
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("iIAFO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c8798067134a9c22$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //
var $c8798067134a9c22$export$2e2bcd8739ae039 = {
    "VzzYJk": "Create",
    "goal-create-success-flag-action": "Go to goal",
    "goal-create-success-flag-title": "Goal has been created",
    "navigation.universal-create.menuItemLoading": "Menu item is loading",
    "platform.navigation-experiences.universal-create.area-label": "Toggle for {text}{heading} options",
    "platform.navigation-experiences.universal-create.integrations.form-loading": "Loading",
    "platform.navigation-experiences.universal-create.integrations.team.create-error-flag-title": "Sorry, something went wrong",
    "platform.navigation-experiences.universal-create.integrations.team.create-success-flag-go-to-team": "View team",
    "platform.navigation-experiences.universal-create.integrations.team.create-success-flag-title": "Team has been created",
    "platform.navigation-experiences.universal-create.menu-group.aria-label": "Create menu",
    "platform.navigation-experiences.universal-create.menu-section.aria-label": "Create menu section",
    "platform.navigation-experiences.universal-create.project.create-error-flag-description": "There was an error while creating your project. Please try again.",
    "platform.navigation-experiences.universal-create.project.create-error-flag-title": "We couldn't create your project",
    "platform.navigation-experiences.universal-create.project.create-success-flag-content": "Go to project",
    "platform.navigation-experiences.universal-create.project.create-success-flag-title": "Project has been created",
    "platform.navigation-experiences.universal-create.secondary-tooltip-text": "More create options",
    "platform.navigation-experiences.universal-create.show-less": "Less",
    "platform.navigation-experiences.universal-create.show-more": "More",
    "platform.navigation-experiences.universal-create.show-more.area-label": "Show {text} {heading} options"
};

});

parcelRegister("h0HD1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $3ef1735a9f06576f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $borK4 = parcelRequire("borK4");
var $3ef1735a9f06576f$export$2e2bcd8739ae039 = (0, $borK4.default);

});
parcelRegister("borK4", function(module, exports) {
$parcel$export(module.exports, "default", () => $8da70760c7209bc2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //
var $8da70760c7209bc2$export$2e2bcd8739ae039 = {
    "act.action.dismissalMessage.common.text": "You won\u2019t see this here as often.",
    "act.action.notInterested.button.text": "Not interested",
    "act.action.notInterestedFlag.flag.text": "Got it, thanks for letting us know",
    "act.action.reasonsModalOkButton.common.text": "OK",
    "act.action.showReasons.common.text": "Why am I seeing this?"
};

});


parcelRegister("FpT2g", function(module, exports) {
$parcel$export(module.exports, "AssistanceServiceBase", () => $28ddb726138ff9e8$export$40a7802808e2fbe3);
$parcel$export(module.exports, "AssistanceServiceImpl", () => $28ddb726138ff9e8$export$a522c5f4ccda1c94);
$parcel$export(module.exports, "AssistanceServiceProvider", () => $28ddb726138ff9e8$export$8fe647eb935c33db);
$parcel$export(module.exports, "useAssistanceService", () => $28ddb726138ff9e8$export$7e31a1844ebbaf85);
$parcel$export(module.exports, "createHookWithAssistanceService", () => $28ddb726138ff9e8$export$5a9ea20fc196ec62);

var $5chsV = parcelRequire("5chsV");


var $fsvuC = parcelRequire("fsvuC");

var $jWJ9H = parcelRequire("jWJ9H");

var $5Y9N2 = parcelRequire("5Y9N2");

var $llCao = parcelRequire("llCao");

var $8IAtM = parcelRequire("8IAtM");

var $jV057 = parcelRequire("jV057");

var $2pSN0 = parcelRequire("2pSN0");


var $fVYJM = parcelRequire("fVYJM");

var $d1B6S = parcelRequire("d1B6S");

var $13Mqn = parcelRequire("13Mqn");

var $8Mbu7 = parcelRequire("8Mbu7");

var $7b2nU = parcelRequire("7b2nU");

var $desEp = parcelRequire("desEp");

var $eBrk9 = parcelRequire("eBrk9");

var $jD7S5 = parcelRequire("jD7S5");

var $6hlp7 = parcelRequire("6hlp7");

var $9TpiC = parcelRequire("9TpiC");

var $k9xDS = parcelRequire("k9xDS");

var $6qfyE = parcelRequire("6qfyE");

var $fH7nM = parcelRequire("fH7nM");

var $6WjoN = parcelRequire("6WjoN");
const $28ddb726138ff9e8$var$addRequestBreadcrumb = ({ durationMs: durationMs, lifecycle: lifecycle, options: options, status: status })=>{
    (0, $2pSN0.addSentryBreadcrumb)({
        category: 'request',
        data: {
            durationMs: durationMs === undefined ? undefined : Math.round(durationMs),
            lifecycle: lifecycle,
            method: (options.options.method ?? 'GET').toUpperCase(),
            operation: options.holdName,
            route: (0, $8Mbu7.normalizeRequestRoute)(options.path),
            status: status
        },
        message: `${options.options.method ?? 'GET'} ${options.holdName ?? (0, $8Mbu7.normalizeRequestRoute)(options.path)} ${lifecycle}`,
        type: 'http'
    });
};
const $28ddb726138ff9e8$var$observeStreamLifecycle = async function*(generator, options) {
    const startedAt = performance.now();
    let firstDataReceived = false;
    let lifecycleEnded = false;
    $28ddb726138ff9e8$var$addRequestBreadcrumb({
        lifecycle: 'started',
        options: options
    });
    try {
        for await (const value of generator){
            if (!firstDataReceived) {
                firstDataReceived = true;
                $28ddb726138ff9e8$var$addRequestBreadcrumb({
                    durationMs: performance.now() - startedAt,
                    lifecycle: 'firstData',
                    options: options
                });
            }
            yield value;
        }
        lifecycleEnded = true;
        $28ddb726138ff9e8$var$addRequestBreadcrumb({
            durationMs: performance.now() - startedAt,
            lifecycle: options.options.signal?.aborted ? 'abort' : 'completed',
            options: options
        });
    } catch (error) {
        lifecycleEnded = true;
        $28ddb726138ff9e8$var$addRequestBreadcrumb({
            durationMs: performance.now() - startedAt,
            lifecycle: error instanceof Error && error.name === 'AbortError' ? 'abort' : error instanceof Error && /timeout/i.test(error.name) ? 'timedOut' : 'error',
            options: options
        });
        throw error;
    } finally{
        if (!lifecycleEnded) $28ddb726138ff9e8$var$addRequestBreadcrumb({
            durationMs: performance.now() - startedAt,
            lifecycle: options.options.signal?.aborted ? 'abort' : 'cancelled',
            options: options
        });
    }
};
const $28ddb726138ff9e8$var$PRODUCT_HEADER = 'x-product';
/** Number of tasks to request per page when using cursor-based pagination. */ const $28ddb726138ff9e8$var$TASKS_PAGE_SIZE = 25;
const $28ddb726138ff9e8$var$LIBRARY_PAGE_SIZE = 25;
const $28ddb726138ff9e8$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
const $28ddb726138ff9e8$var$CHANNEL_ID_HEADER = 'X-Channel-Id';
const $28ddb726138ff9e8$var$CLOUD_ID_HEADER = 'x-cloudid';
const $28ddb726138ff9e8$var$AGENT_SESSION_STATE_VALUES = new Set([
    'WORKING',
    'INPUT_REQUIRED',
    'ARTEFACT_READY',
    'AUTH_REQUIRED',
    'FAILED',
    'REJECTED',
    'COMPLETED',
    'CANCELLED',
    'UNKNOWN'
]);
const $28ddb726138ff9e8$var$isAgentSessionState = (value)=>$28ddb726138ff9e8$var$AGENT_SESSION_STATE_VALUES.has(value);
const $28ddb726138ff9e8$var$hasCloudIdHeader = (headers)=>Object.keys(headers).some((name)=>name.toLowerCase() === $28ddb726138ff9e8$var$CLOUD_ID_HEADER);
const $28ddb726138ff9e8$var$DEFAULT_FILE_VALIDATE_PATH = '/rovo/v1/chat/message/file/validate';
const $28ddb726138ff9e8$var$DEFAULT_FILE_UPLOAD_PATH = '/rovo/v1/chat/message/file';
class $28ddb726138ff9e8$export$40a7802808e2fbe3 {
    constructor(props){
        this.getConfig = ()=>{
            return {
                ...this.config
            };
        };
        const defaultBaseUrl = '/gateway/api/assist';
        const defaultConfig = {
            baseUrl: defaultBaseUrl,
            headers: {}
        };
        this.config = {
            ...props,
            baseUrl: props.baseUrl || defaultConfig.baseUrl,
            credentials: props.credentials,
            headers: {
                ...props.headers || defaultConfig.headers
            }
        };
    }
    createHeaders(init) {
        const configHeaders = this.config.headers || {};
        return new Headers({
            [$28ddb726138ff9e8$var$PRODUCT_HEADER]: this.config.product,
            [$28ddb726138ff9e8$var$EXPERIENCE_ID_HEADER]: this.config.experienceId,
            ...this.config.siteId && (0, $llCao.fg)('rovo_chat_site_switch_reset') && !$28ddb726138ff9e8$var$hasCloudIdHeader(configHeaders) ? {
                [$28ddb726138ff9e8$var$CLOUD_ID_HEADER]: this.config.siteId
            } : {},
            ...configHeaders,
            ...this.config.channelId ? {
                [$28ddb726138ff9e8$var$CHANNEL_ID_HEADER]: this.config.channelId
            } : {},
            ...init
        });
    }
    getChannelId(defaultChannelId) {
        return this.config.channelId || defaultChannelId;
    }
    async fetch({ path: path, options: options, holdName: holdName, baseUrl: requestBaseUrl }) {
        const { baseUrl: configBaseUrl, credentials: configCredentials } = this.config;
        const baseUrl = requestBaseUrl ?? configBaseUrl;
        const requestUrl = (0, $6qfyE.addPath)(baseUrl, path);
        const startTime = performance.now();
        try {
            const response = await window.fetch(requestUrl, {
                credentials: configCredentials,
                ...options
            });
            if (this.config.labelStack) {
                // Please note that the recorded duration of this hold may differ from the time spent actually fetching the data.
                // This is because the browser may schedule network calls and JavaScript execution at its own discrection based
                // on available resources, the main thread being blocked, etc... Still, it is a helpful approximation.
                const endTime = performance.now();
                (0, $8IAtM.addSpanToAll)('fetch', holdName ? `${options.method}-${holdName}` : 'unknown', this.config.labelStack, startTime, endTime);
            }
            const processedResponse = await (0, $6qfyE.processResponse)({
                response: response
            });
            $28ddb726138ff9e8$var$addRequestBreadcrumb({
                durationMs: performance.now() - startTime,
                lifecycle: 'success',
                options: {
                    path: path,
                    options: options,
                    holdName: holdName
                },
                status: response.status
            });
            return processedResponse;
        } catch (error) {
            $28ddb726138ff9e8$var$addRequestBreadcrumb({
                durationMs: performance.now() - startTime,
                lifecycle: error instanceof (0, $d1B6S.ApiError) ? 'httpError' : error instanceof Error && error.name === 'AbortError' ? 'abort' : 'networkError',
                options: {
                    path: path,
                    options: options,
                    holdName: holdName
                },
                status: error instanceof (0, $d1B6S.ApiError) ? error.errorAttributes.statusCode : undefined
            });
            throw error;
        }
    }
    async fetchJson(options) {
        const response = await this.fetch(options);
        const json = await response.json();
        return json;
    }
    async getConversationSharePreview(_payload) {
        throw new (0, $d1B6S.ApiError)('Share preview not found', {
            statusCode: 404
        });
    }
    async getConversationShareMetadata(_payload) {
        throw new (0, $d1B6S.ApiError)('Share metadata not found', {
            statusCode: 404
        });
    }
    async fetchStream(options, config) {
        const response = await this.fetch(options);
        const contentType = response.headers.get('content-type') ?? '';
        const headerSuggestsSSE = config?.useSSE && contentType.includes('text/event-stream');
        return {
            responseData: {
                traceId: (0, $13Mqn.getTraceIdFromResponse)(response)
            },
            generator: headerSuggestsSSE ? $28ddb726138ff9e8$var$observeStreamLifecycle((0, $6hlp7.readSSEStream)(response), options) : $28ddb726138ff9e8$var$observeStreamLifecycle((0, $jD7S5.readJsonStream)(response), options)
        };
    }
}
$28ddb726138ff9e8$export$40a7802808e2fbe3.displayName = "AssistanceServiceBase";
class $28ddb726138ff9e8$export$a522c5f4ccda1c94 extends $28ddb726138ff9e8$export$40a7802808e2fbe3 {
    constructor(props){
        super(props), // Defined as an arrow property so `this` stays bound when the reference is
        // passed directly to data-fetching hooks (e.g. useQuery's queryFn).
        this.getGroupedConversationShares = async ()=>{
            return this.fetchJson({
                path: '/api/v2/shares/grouped',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'api-v2-shares-grouped-get'
            });
        }, this.getAgentActions = async ()=>{
            const response = await this.fetchJson({
                path: '/rovo/v1/agents/configuration/actions',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-actions'
            });
            return response.actions;
        }, this.getAgentKnowledgeConfiguration = (agentCreatorType)=>{
            const queryParams = agentCreatorType ? `?agentCreatorType=${agentCreatorType}` : '';
            return this.fetchJson({
                path: `/rovo/v1/agents/configuration/knowledge${queryParams}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-knowledge'
            });
        }, this.getAgentPermissions = (agentId, payload)=>{
            return this.fetchJson({
                path: `/rovo/v2/permissions/agents/${agentId}`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v2-permissions-agents-[agentId]'
            });
        }, this.getRecommendedAgents = ({ limit: limit, pageUrl: pageUrl })=>{
            const urlParams = new URLSearchParams({
                limit: limit.toString()
            });
            if (pageUrl) urlParams.append('pageUrl', pageUrl);
            const fullPath = `/rovo/v1/agents/recommend/v2?${urlParams.toString()}`;
            return this.fetchJson({
                path: fullPath,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-recommend-v2'
            });
        }, this.getConversationDebugLogs = async (conversationId)=>{
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/debug-logs`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversation-[conversationId]-debug-logs'
            });
            return response.items;
        }, this.validateFiles = async (payload)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            return this.fetchJson({
                path: this.config.fileValidatePath ?? $28ddb726138ff9e8$var$DEFAULT_FILE_VALIDATE_PATH,
                options: {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-message-file-validate'
            });
        }, this.uploadFiles = async (payload)=>{
            const formData = new FormData();
            for (const file of payload.files)formData.append('files', file);
            const response = await this.fetchJson({
                path: this.config.fileUploadPath ?? $28ddb726138ff9e8$var$DEFAULT_FILE_UPLOAD_PATH,
                options: {
                    method: 'POST',
                    headers: this.createHeaders(),
                    body: formData
                },
                holdName: 'rovo-v1-chat-message-file'
            });
            return response;
        }, this.rovoLabsSendMessage = (payload)=>{
            return this.fetchStream({
                path: '/rovo/v1/agent-playground/chat/stream',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-agent-playground-chat-stream'
            });
        }, this.rovoLabsGetConversations = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/chat/conversations',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-chat-conversations'
            });
        }, this.rovoLabsGetTools = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/tools',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-tools'
            });
        }, this.rovoLabsGetLanguageModels = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/language-models',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-language-models'
            });
        }, this.rovoLabsGetPrompts = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/prompts',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-prompts'
            });
        }, this.getGeneratedContent = (payload)=>{
            const queryParams = [];
            if (payload?.actions && payload.actions.length > 0) queryParams.push(`actionKeys=${payload.actions.join(',')}`);
            if (payload?.statuses && payload.statuses.length > 0) queryParams.push(`statuses=${payload.statuses.join(',')}`);
            if (payload?.limit !== undefined) queryParams.push(`limit=${payload.limit}`);
            const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
            return this.fetchJson({
                path: `/rovo/v1/chat/generated-content${queryString}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-generated-content'
            });
        }, this.getRovoUserSettings = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        }, this.updateRovoUserSettings = async (settings)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(settings)
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        }, this.getAgentConciergeAvailability = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/agent-concierge/availability',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'agent-concierge-availability'
            });
        }, this.getAgentConciergeSettings = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/agent-concierge/settings',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'agent-concierge-settings-get'
            });
        }, this.updateAgentConciergeSettings = async (availability)=>{
            await this.fetch({
                path: '/rovo/v1/chat/agent-concierge/settings',
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify({
                        availability: availability
                    })
                },
                holdName: 'agent-concierge-settings-put'
            });
        }, this.getRovoMemories = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories'
            });
        }, this.getRovoMemoryBlurb = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/blurb',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-blurb'
            });
        }, this.answerNow = async (conversationId, messageId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/answer-now`,
                options: options,
                holdName: 'rovo-v1-chat-conversation-message-answer-now'
            });
        }, this.deleteRovoMemory = async (memoryId)=>{
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/memories/${memoryId}`,
                options: options,
                holdName: 'rovo-v1-chat-memories-[memoryId]'
            });
        }, this.getRovoMemoryEdits = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-memory-edits'
            });
        }, this.createMemoryEdit = async (payload)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-memories-memory-edits'
            });
        }, this.createMemory = async (payload)=>{
            await this.fetch({
                path: '/rovo/v1/chat/memories/create',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-memories-create'
            });
        }, this.getRovoMemoryEditsCount = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits/count',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-memory-edits-count'
            });
        }, this.deleteRovoMemoryEdit = async (editId)=>{
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/memories/memory-edits/${editId}`,
                options: options,
                holdName: 'rovo-v1-chat-memories-memory-edits-[editId]'
            });
        }, this.fetchConversationMetadata = async (conversationId)=>{
            const result = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversation-[conversationId]'
            });
            return this.transformSnakeCaseToCamelCase(result);
        }, this.fetchPersonalizedPromptSuggestions = async (config)=>{
            const { offset: offset = 0, limit: limit = 9, contentType: contentType, entryPoint: entryPoint } = config;
            const headers = this.createHeaders({
                'Content-Type': 'application/json'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ai_feature_input: {
                        offset: offset,
                        limit: limit,
                        ...contentType ? {
                            contentType: contentType
                        } : {},
                        ...entryPoint ? {
                            entryPoint: entryPoint
                        } : {}
                    }
                })
            };
            const result = await this.fetchJson({
                path: '/api/ai/v2/ai-feature/confluence-prompt-tiles',
                options: options,
                holdName: 'api-ai-v2-ai-feature-confluence-prompt-tiles'
            });
            return result?.ai_feature_output?.prompt_tiles ?? [];
        }, this.getTasks = async (params)=>{
            const searchParams = new URLSearchParams();
            searchParams.set('limit', String(params?.limit ?? $28ddb726138ff9e8$var$TASKS_PAGE_SIZE));
            if (params?.cursor) searchParams.set('cursor', params.cursor);
            return this.fetchJson({
                path: `/rovo/v1/tasks?${searchParams.toString()}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-tasks'
            });
        }, this.getLibraryEntries = async (params)=>{
            const searchParams = new URLSearchParams();
            searchParams.set('limit', String(params?.limit ?? $28ddb726138ff9e8$var$LIBRARY_PAGE_SIZE));
            if (params?.cursor) searchParams.set('cursor', params.cursor);
            if (params?.query) searchParams.set('query', params.query);
            if (params?.type) searchParams.set('type', params.type);
            if (params?.kind) searchParams.set('kind', params.kind);
            const options = {
                method: 'GET',
                headers: this.createHeaders(),
                signal: params?.controller?.signal
            };
            return this.fetchJson({
                path: `/rovo/v1/library?${searchParams.toString()}`,
                options: options,
                holdName: 'rovo-chat-v1-library'
            });
        }, this.getTasksStream = async (controller)=>{
            return this.fetchStream({
                path: '/rovo/v1/tasks/stream',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        Accept: 'text/event-stream'
                    }),
                    signal: controller?.signal
                },
                holdName: 'rovo-v1-tasks-stream'
            }, {
                useSSE: true
            });
        }, this.cancelTask = async (taskId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/tasks/${taskId}/cancel`,
                options: options,
                holdName: 'rovo-v1-tasks-[taskId]-cancel'
            });
        }, this.deleteTask = async (taskId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/tasks/${taskId}`,
                options: options,
                holdName: 'rovo-v1-tasks-[taskId]-delete'
            });
        }, this.renameTask = async (taskId, title)=>{
            return this.fetchJson({
                path: `/rovo/v1/tasks/${taskId}`,
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify({
                        title: title
                    })
                },
                holdName: 'rovo-v1-tasks-[taskId]'
            });
        }, this.fetchPersonalizedPromptSuggestionsStream = async (config)=>{
            const { offset: offset = 0, limit: limit = 9, contentType: contentType, entryPoint: entryPoint, enable3pPrompt: enable3pPrompt } = config;
            const headers = this.createHeaders({
                'Content-Type': 'application/json'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ai_feature_input: {
                        offset: offset,
                        limit: limit,
                        ...contentType ? {
                            contentType: contentType
                        } : {},
                        ...entryPoint ? {
                            entryPoint: entryPoint
                        } : {},
                        // Only sent for experiment variants A/B; omitted for everyone else so the
                        // request is byte-identical to the pre-3P-feature request.
                        ...enable3pPrompt ? {
                            enable_3p_prompt: true
                        } : {}
                    }
                })
            };
            return this.fetchStream({
                path: '/api/ai/v2/ai-feature/confluence-prompt-tiles/stream',
                options: options,
                holdName: 'api-ai-v2-ai-feature-confluence-prompt-tiles-stream'
            });
        };
    }
    async sendMessageStream({ agentNamedId: agentNamedId, agentId: agentId, message: message, autoActionApprovalMode: autoActionApprovalMode, mimeType: mimeType, conversationId: conversationId, controller: controller, storeMessage: storeMessage = false, citationsEnabled: citationsEnabled = true, aiFeatureContext: aiFeatureContext, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, browserContext: browserContext, additionalContext: additionalContext, writingStyleContext: writingStyleContext, dashboardContext: dashboardContext, dashboardEditorContext: dashboardEditorContext, fileIds: fileIds, webSearchEnabled: webSearchEnabled, sourceMode: sourceMode, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, conciergeEnabled: conciergeEnabled, appFilters: appFilters, selectedCloudIds: selectedCloudIds, useCurrentBrowsingContext: useCurrentBrowsingContext, minionAliasConfig: minionAliasConfig, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, optInAnsNow: optInAnsNow = false, optInNewToolTraces: optInNewToolTraces = false, optInNewTeamworkTraceIcons: optInNewTeamworkTraceIcons = false, browserContextSanitizer: browserContextSanitizer, optInSSEStream: optInSSEStream = false, agentVersion: agentVersion, spaceId: spaceId, capabilities: capabilities, shouldExtractConversationScopes: shouldExtractConversationScopes, browserDisplayContextActive: browserDisplayContextActive, searchArtifact: searchArtifact, artifactContext: artifactContext, parentMessageId: parentMessageId, requestedSkills: requestedSkills, commentMentionContext: commentMentionContext }) {
        const effectiveCapabilities = (0, $k9xDS.buildEffectiveCapabilities)(capabilities);
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            [$28ddb726138ff9e8$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat'),
            // This header is used to opt-in to Deep Research v2 on the BE.
            // This is to ensure that we don't use v2 deep research when we are using the old Rovo Chat UI prior to the refresh..
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            // Opt in to using RESEARCH_STEP, RESEARCH_PLAN, and similar messages for "think deeper".
            // Ensures backward compatibility with legacy clients and allows application targeting within the experiment.
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            },
            ...optInAnsNow && {
                'X-Answer-Now-UI-Opt-In': 'true'
            },
            ...optInNewToolTraces && {
                'X-New-Tool-Traces-Opt-In': 'true'
            },
            ...optInNewTeamworkTraceIcons && {
                'X-New-Teamwork-Trace-Icons-Opt-In': 'true'
            },
            ...effectiveCapabilities && effectiveCapabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(effectiveCapabilities)
            }
        });
        let knowledgeOverride = {};
        // not setting knowledgeEnabled and filters means all org knowledge is applied by default.
        if (appFilters) {
            if (appFilters.length === 0) knowledgeOverride = {
                knowledgeEnabled: false
            };
            else knowledgeOverride = {
                knowledgeEnabled: true,
                filters: {
                    knowledgeSources: appFilters
                }
            };
        }
        const selectedCloudIdsOverride = (0, $llCao.fg)((0, $c0bb806f19dcd148$export$e0744546db5b6189)) && selectedCloudIds && selectedCloudIds.length > 0 ? {
            selectedCloudIds: selectedCloudIds.map((cloudId)=>({
                    cloudId: cloudId
                }))
        } : {};
        const { browserUrl: url, isBrowserContextBlocklisted: isBrowserContextBlocklisted } = (0, $9TpiC.resolveMessageStreamBrowserUrl)({
            browserContext: browserContext,
            browserContextSanitizer: browserContextSanitizer,
            product: this.getConfig().product
        });
        const defaultMimeType = typeof message === 'string' ? 'text/markdown' : 'text/adf';
        const body = {
            content: message,
            context: (0, $desEp.buildMessageStreamRequestContext)({
                browserUrl: url,
                autoActionApprovalMode: autoActionApprovalMode,
                useCurrentBrowsingContext: useCurrentBrowsingContext,
                webSearchEnabled: webSearchEnabled,
                sourceMode: sourceMode,
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                fastModeEnabled: fastModeEnabled,
                planModeEnabled: planModeEnabled,
                editorContext: editorContext,
                whiteboardContext: whiteboardContext,
                slidesContext: slidesContext,
                databaseContext: databaseContext,
                dashboardEditorContext: dashboardEditorContext,
                browserContext: browserContext,
                isBrowserContextBlocklisted: isBrowserContextBlocklisted,
                jiraWorkflowContext: jiraWorkflowContext,
                additionalContext: additionalContext,
                writingStyleContext: writingStyleContext,
                dashboardContext: dashboardContext,
                aiFeatureContext: aiFeatureContext,
                fileIds: fileIds,
                knowledgeOverride: knowledgeOverride,
                selectedCloudIdsOverride: selectedCloudIdsOverride,
                searchArtifact: searchArtifact,
                artifactContext: artifactContext,
                shouldExtractConversationScopes: shouldExtractConversationScopes
            }),
            recipient_agent_named_id: agentNamedId,
            agent_id: agentId,
            // Preserve omitted Concierge state for clients that use default routing; serialize
            // explicit false because the UI toggle is an opt-in control.
            ...conciergeEnabled !== undefined ? {
                concierge_enabled: conciergeEnabled
            } : {},
            mimeType: mimeType && (0, $llCao.fg)('jira_ai_rendering_a2ui') ? mimeType : defaultMimeType,
            ...agentVersion ? {
                agent_version: agentVersion
            } : {},
            // don't allow store message if feature flag is off
            store_message: (0, $llCao.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: citationsEnabled,
            ...minionAliasConfig ?? (this.getConfig().minionAlias ? {
                stratus_config: {
                    minion_alias: this.getConfig().minionAlias
                }
            } : {}),
            ...spaceId ? {
                space_id: spaceId
            } : {},
            ...parentMessageId ? {
                parent_message_id: parentMessageId
            } : {},
            ...requestedSkills?.length ? {
                skills: requestedSkills
            } : {},
            ...commentMentionContext ? {
                comment_mention_context: commentMentionContext
            } : {},
            ...browserDisplayContextActive !== undefined ? {
                browser_display_context_active: browserDisplayContextActive
            } : {}
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async reconnectToMessageStream({ conversationId: conversationId, messageId: messageId, lastEventId: lastEventId, controller: controller }) {
        const headers = this.createHeaders();
        // Add Last-Event-ID header if available
        if (lastEventId) headers.set('Last-Event-ID', lastEventId);
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/stream/sse`,
            options: options
        }, {
            useSSE: true
        });
    }
    // Only takes effect if the stream is a Deep Research stream
    async cancelMessageStream({ conversationId: conversationId, messageId: messageId }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/cancel`,
            options: options
        });
    }
    async sendMessageConfirmedTools({ conversationId: conversationId, agentId: agentId, controller: controller, confirmed_tools: confirmed_tools, optInSSEStream: optInSSEStream = false, storeMessage: storeMessage = false, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, conciergeEnabled: conciergeEnabled, aiFeatureContext: aiFeatureContext, agentVersion: agentVersion, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, optInAnsNow: optInAnsNow = false, optInNewToolTraces: optInNewToolTraces = false, optInNewTeamworkTraceIcons: optInNewTeamworkTraceIcons = false, capabilities: capabilities, searchArtifact: searchArtifact, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, browserContext: browserContext, additionalContext: additionalContext, dashboardContext: dashboardContext, dashboardEditorContext: dashboardEditorContext, useCurrentBrowsingContext: useCurrentBrowsingContext, browserContextSanitizer: browserContextSanitizer }) {
        const effectiveCapabilities = (0, $k9xDS.buildEffectiveCapabilities)(capabilities);
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            [$28ddb726138ff9e8$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat'),
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            },
            ...optInAnsNow && {
                'X-Answer-Now-UI-Opt-In': 'true'
            },
            ...optInNewToolTraces && {
                'X-New-Tool-Traces-Opt-In': 'true'
            },
            ...optInNewTeamworkTraceIcons && {
                'X-New-Teamwork-Trace-Icons-Opt-In': 'true'
            },
            ...effectiveCapabilities && effectiveCapabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(effectiveCapabilities)
            }
        });
        // browser_url is historically the current window location. The blocklist gates the page
        // browser context added when a browserContext is supplied. The NO-URL sentinel under the
        // `jira_free_gen_editor` experiment suppresses the URL (matching sendMessageStream) so that
        // cohort does not leak a URL.
        const browserUrl = browserContext?.context?.browserUrl;
        const isBrowserContextBlocklisted = !!(browserUrl && browserContextSanitizer?.isBlocklisted(browserUrl));
        const isBrowserUrlSuppressed = browserUrl === 'NO-URL' && (0, $5Y9N2.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false);
        const url = isBrowserUrlSuppressed ? '' : window?.location?.href;
        const isBrowserSelectionContextGateEnabled = (0, $llCao.fg)('rovo_chat_browser_selection_context');
        const browserSelection = isBrowserSelectionContextGateEnabled ? browserContext?.context?.selection : undefined;
        const body = {
            conversation_id: conversationId,
            agent_id: agentId,
            ...conciergeEnabled !== undefined ? {
                concierge_enabled: conciergeEnabled
            } : {},
            confirmed_tools: confirmed_tools,
            ...agentVersion ? {
                agent_version: agentVersion
            } : {},
            context: {
                browser_url: url,
                webSearchEnabled: webSearchEnabled,
                ...deepResearchEnabled ? {
                    deepResearchEnabled: deepResearchEnabled
                } : {},
                ...thinkDeeperEnabled ? {
                    extendedThinkingEnabled: thinkDeeperEnabled
                } : {},
                ...alphaExtendedThinkingMode ? {
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode
                } : {},
                ...planModeEnabled ? {
                    planModeEnabled: planModeEnabled,
                    alphaExtendedThinkingMode: 'MARATHON',
                    extendedThinkingEnabled: true
                } : {},
                ...fastModeEnabled ? {
                    fastModeEnabled: fastModeEnabled
                } : {},
                ...aiFeatureContext ? {
                    aiFeatureContext: aiFeatureContext
                } : {},
                ...searchArtifact ? {
                    search_artifact: searchArtifact
                } : {},
                // Full request context — supplied by the store action so the backend receives
                // the same page/whiteboard/creation context as a regular sendMessage. Every
                // field is omitted when undefined, so the slim request above is unaffected.
                ...useCurrentBrowsingContext === undefined ? {} : {
                    useCurrentBrowsingContext: useCurrentBrowsingContext
                },
                // Content-context objects. Inlined to mirror sendMessageStream's serialization
                // exactly; a unit test (the drift guard) asserts the two stay in sync. Each is
                // omitted when undefined, so the slim request above is unaffected.
                ...editorContext ? {
                    editor: editorContext
                } : {},
                ...whiteboardContext ? {
                    whiteboardContext: whiteboardContext
                } : {},
                ...slidesContext ? {
                    slidesContext: slidesContext
                } : {},
                ...databaseContext ? {
                    databaseContext: databaseContext
                } : {},
                ...dashboardEditorContext ? {
                    dashboardEditorContext: dashboardEditorContext
                } : {},
                ...browserContext && !isBrowserContextBlocklisted ? {
                    browser: {
                        htmlBody: browserContext.context?.htmlBody,
                        canvasText: browserContext.context?.canvasText,
                        ...browserSelection ? {
                            selection: browserSelection
                        } : {}
                    }
                } : {},
                jiraWorkflowContext: jiraWorkflowContext,
                ...additionalContext,
                dashboardContext: dashboardContext
            },
            // These values are hardcoded because they are not used in backend, but required in the contract
            content: '',
            mimeType: 'text/markdown',
            // don't allow store message if feature flag is off
            store_message: (0, $llCao.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: false
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async nlCreateAgentStream({ controller: controller, latest_user_message: latest_user_message, draft_agent: draft_agent, conversation_history: conversation_history }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const body = {
            latest_user_message: latest_user_message,
            draft_agent: draft_agent,
            conversation_history: conversation_history
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/agents/nlcreate`,
            options: options
        });
    }
    async getChat(conversationId, capabilities) {
        // Forward the caller-provided chat capabilities (e.g. `inline_lumina_enabled`,
        // which is gated behind `rovo_chat_enable_inline_lumina`) so that fetching a
        // chat from history renders the same rich (Lumina) components as a live stream,
        // rather than downgrading to basic markdown.
        //
        // Forward capabilities as-is: buildEffectiveCapabilities adds send-only
        // capabilities that should not be attached to a history read.
        const headers = this.createHeaders({
            ...capabilities && capabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(capabilities)
            }
        });
        const options = {
            method: 'GET',
            headers: headers
        };
        const path = `/rovo/v1/chat/conversation/${conversationId}/messages`;
        const rawChat = await this.fetchJson({
            path: path,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]-messages'
        });
        const chatArray = rawChat.items;
        return chatArray.map((message)=>(0, $fVYJM.isHumanMessage)(message) ? message : (0, $6WjoN.toStreamResponse)(message));
    }
    async deleteChat(conversationId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}`,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]'
        });
    }
    async getAgents(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
        return response.items;
    }
    async getAgentDetails(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async getAgentDetailsByIdentityAccountId(identityAccountId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/accountid/${identityAccountId}`,
            options: options,
            holdName: 'rovo-v1-agents-accountid-[identityAccountId]'
        });
    }
    async createAgent(payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        return this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
    }
    async updateAgent(id, payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
        return response;
    }
    async deleteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async favouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'POST',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async unfavouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async createConversationChannel(options) {
        const name = options && 'name' in options ? options.name : (0, $fH7nM.generateConversationName)();
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8',
                    [$28ddb726138ff9e8$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat')
                }),
                body: JSON.stringify({
                    name: name,
                    dialogues: options?.dialogues ?? undefined,
                    tags: options?.tags,
                    agent_id: options?.agentId
                })
            },
            holdName: 'rovo-v1-chat-conversation'
        });
    }
    async getConversationChannels(options) {
        const searchParams = new URLSearchParams();
        if (options?.limit !== undefined) searchParams.set('limit', String(options.limit));
        if (options?.cursor !== undefined) searchParams.set('cursor', options.cursor);
        const queryString = searchParams.toString();
        const result = await this.fetchJson({
            path: `/rovo/v1/chat/conversations${queryString ? `?${queryString}` : ''}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'rovo-v1-chat-conversations'
        });
        // Transform snake_case fields to camelCase
        return {
            items: result.items.map((item)=>this.transformSnakeCaseToCamelCase(item)),
            hasNext: result.hasNext ?? false,
            cursor: result.cursor ?? null
        };
    }
    async getPinnedConversationSummary() {
        try {
            const result = await this.fetchJson({
                path: '/rovo/v1/chat/conversations/pinned-summary',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversations-pinned-summary'
            });
            return {
                pinnedCount: result.pinned_count ?? 0,
                maxPinnedConversations: result.max_pinned_conversations ?? 0
            };
        } catch (error) {
            // The endpoint not being deployed yet surfaces as a 404 — ignore that (callers fall back to
            // the local pinned count). Any other failure is genuine, so rethrow rather than swallow it
            // silently, letting the caller report/handle it.
            const statusCode = error instanceof (0, $d1B6S.ApiError) ? error.errorAttributes?.statusCode : undefined;
            if (statusCode === 404) return undefined;
            throw error;
        }
    }
    updateConversationChannel(id, payload) {
        // Transform camelCase field names to snake_case for the REST API
        const apiPayload = this.transformCamelCaseToSnakeCase(payload);
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}`,
            options: {
                method: 'PUT',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify(apiPayload)
            },
            holdName: 'rovo-v1-chat-conversation-[id]'
        }).then((response)=>this.transformSnakeCaseToCamelCase(response));
    }
    transformCamelCaseToSnakeCase(payload) {
        const result = {};
        for (const [key, value] of Object.entries(payload)){
            if (key === 'readStatus') result['read_status'] = value;
            else if (key === 'isPinned') result['is_pinned'] = value;
            else if (key === 'pinnedAt') result['pinned_at'] = value;
            else if (key === 'sourceMode') result['source_mode'] = value;
            else result[key] = value;
        }
        return result;
    }
    transformSnakeCaseToCamelCase(item) {
        if (item == null || typeof item !== 'object') throw new Error(`Expected an object from conversation channel API, got: ${typeof item}`);
        const result = {
            ...item
        };
        if ('read_status' in result) {
            result['readStatus'] = result['read_status'];
            delete result['read_status'];
        }
        if ('is_pinned' in result) {
            result['isPinned'] = result['is_pinned'];
            delete result['is_pinned'];
        }
        if ('pinned_at' in result) {
            result['pinnedAt'] = result['pinned_at'];
            delete result['pinned_at'];
        }
        if ('source_mode' in result) {
            result['sourceMode'] = result['source_mode'];
            delete result['source_mode'];
        }
        const agentSessionState = result['agent_session_state'];
        delete result['agent_session_state'];
        delete result['agentSessionState'];
        if ($28ddb726138ff9e8$var$isAgentSessionState(agentSessionState)) result['agentSessionState'] = agentSessionState;
        else if (agentSessionState != null) (0, $2pSN0.logSentryConsoleWarning)('Unknown agent session state returned by conversation channel API:', agentSessionState);
        return result;
    }
    async resolveConversationAction(id, payload) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}/action`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    ...payload,
                    context: {
                        ...payload.context,
                        browser_url: window.location.href
                    }
                })
            },
            holdName: 'rovo-v1-chat-conversation-[id]-action'
        });
    }
    async bulkResolveConversationUIActions(conversationId, messageId, payload) {
        // The bulk API supports a maximum of 50 items per request.
        // Split into batches and process them sequentially.
        const BATCH_SIZE = 50;
        const allResponses = [];
        for(let batchStart = 0; batchStart < payload.items.length; batchStart += BATCH_SIZE){
            const batchItems = payload.items.slice(batchStart, batchStart + BATCH_SIZE);
            const batchResponses = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/tools/resolution`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify({
                        items: batchItems.map((item)=>({
                                ...item,
                                context: {
                                    ...item.context,
                                    browser_url: window.location.href
                                }
                            }))
                    })
                },
                holdName: 'rovo-v1-chat-conversation-[id]-message-[messageId]-tools-resolution'
            });
            allResponses.push(...batchResponses);
        }
        return allResponses;
    }
    // REST starters, newer API
    async generateAgentStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/agent-starter-suggestion',
            options: options,
            holdName: 'rovo-v1-conversation-starters-agent-starter-suggestion'
        });
    }
    // REST conversation starters, newer API
    async generateContextualStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/page-contextual',
            options: options,
            holdName: 'rovo-v1-conversation-starters-page-contextual'
        });
    }
    // REST dynamic conversation starters (new endpoint)
    async getDynamicConvoStartersNew(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            'x-experience-id': 'convo-starter-for-rovo-button'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/ai/v2/ai-feature/convo-starters',
            options: options,
            holdName: 'api-ai-v2-ai-feature-convo-starters'
        });
    }
    async getWebSearchConfiguration() {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const result = await this.fetchJson({
            path: '/api/v2/configuration/web-search-ai',
            options: options,
            holdName: 'api-v2-configuration-web-search-ai'
        });
        return result;
    }
    async upsertConversationShare(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/share',
            options: options,
            holdName: 'api-v2-share-upsert'
        });
    }
    async ensureConversationShare(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/share',
            options: options,
            holdName: 'api-v2-share-ensure'
        });
    }
    async replaceConversationShare(payload) {
        const { conversationId: conversationId, messageId: messageId, shareType: shareType, allowedUserAris: allowedUserAris } = payload;
        const query = new URLSearchParams({
            conversationId: conversationId,
            messageId: messageId
        });
        const body = {
            conversationId: conversationId,
            messageId: messageId,
            shareType: shareType,
            ...shareType === 'SPECIFIC_USERS' ? {
                allowedUserAris: allowedUserAris ?? []
            } : {}
        };
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(body)
        };
        return this.fetchJson({
            path: `/api/v2/share?${query.toString()}`,
            options: options,
            holdName: 'api-v2-share-replace'
        });
    }
    async getConversationShare(shareToken) {
        return this.fetchJson({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-get'
        });
    }
    async getConversationShareMetadata({ conversationId: conversationId, messageId: messageId }) {
        const query = new URLSearchParams({
            conversationId: conversationId,
            messageId: messageId
        });
        return this.fetchJson({
            path: `/api/v2/share?${query.toString()}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-metadata-get'
        });
    }
    async getConversationSharePreview({ conversationId: conversationId, messageId: messageId }) {
        const query = new URLSearchParams({
            conversationId: conversationId,
            messageId: messageId
        });
        return this.fetchJson({
            path: `/api/v2/share/preview?${query.toString()}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-preview-get'
        });
    }
    async forkSharedConversation(shareToken) {
        return this.fetchJson({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}/fork`,
            options: {
                method: 'POST',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-fork'
        });
    }
    async deleteConversationShare(shareToken) {
        await this.fetch({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}`,
            options: {
                method: 'DELETE',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-delete'
        });
    }
    async deleteAllSharesForConversation(conversationId) {
        await this.fetch({
            path: `/api/v2/shares/conversation/${encodeURIComponent(conversationId)}`,
            options: {
                method: 'DELETE',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-shares-conversation-delete'
        });
    }
    async getPromptHistory(options) {
        return (0, $eBrk9.getPromptHistory)({
            ...options,
            headers: this.createHeaders(),
            fetchJson: (request)=>this.fetchJson(request)
        });
    }
}
$28ddb726138ff9e8$export$a522c5f4ccda1c94.displayName = "AssistanceServiceImpl";
const $28ddb726138ff9e8$var$AssistanceServiceContext = /*#__PURE__*/ (0, $fsvuC.createContext)(new $28ddb726138ff9e8$export$a522c5f4ccda1c94({
    baseUrl: '',
    product: '',
    experienceId: ''
}));
const $28ddb726138ff9e8$export$8fe647eb935c33db = ({ value: value, children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)($28ddb726138ff9e8$var$AssistanceServiceContext.Provider, {
        value: value,
        children: children
    });
$28ddb726138ff9e8$export$8fe647eb935c33db.displayName = "AssistanceServiceProvider";
const $28ddb726138ff9e8$export$7e31a1844ebbaf85 = (props)=>{
    (0, $jWJ9H.di)((0, $fsvuC.useContext), $28ddb726138ff9e8$export$a522c5f4ccda1c94);
    const service = (0, $fsvuC.useContext)($28ddb726138ff9e8$var$AssistanceServiceContext);
    (0, $7b2nU.setRovoChatProduct)(props?.product ?? service.getConfig().product);
    if (!props || !props.experienceId && !props.product && !props.headers && !props.channelId) return service;
    const product = props.product ?? service.getConfig().product;
    const experienceId = props.experienceId ?? service.getConfig().experienceId;
    const headers = props.headers ?? service.getConfig().headers;
    const channelId = props.channelId ?? service.getConfig().channelId;
    return new $28ddb726138ff9e8$export$a522c5f4ccda1c94({
        ...service.getConfig(),
        product: product,
        experienceId: experienceId,
        headers: headers,
        channelId: channelId
    });
};
const $28ddb726138ff9e8$export$5a9ea20fc196ec62 = (originalHook)=>{
    return (props)=>{
        (0, $jWJ9H.di)($28ddb726138ff9e8$export$a522c5f4ccda1c94, (0, $jV057.useAIMateExperienceTracker));
        const { assistanceServiceParams: assistanceServiceParams, ...restProps } = props;
        const experienceTracker = (0, $jV057.useAIMateExperienceTracker)({
            touchpointSource: assistanceServiceParams.touchpointSource
        });
        const headers = (0, $fsvuC.useMemo)(()=>{
            // even though AssistanceServiceInputParam enforces lowercase header keys,
            // it is possible to get a non lowercase key if a prebuilt object was assigned to headers at runtime,
            // so this is an additional safety net, without this duplicate headers keys with different case
            // can get appended during header normalization causing request to fail
            // Relevant thread: https://atlassian.slack.com/archives/C0677M19GU9/p1748531977923069?thread_ts=1747336061.856749&cid=C0677M19GU9
            const inputHeaders = props.assistanceServiceParams.headers ? Object.fromEntries(Object.entries(props.assistanceServiceParams.headers).map(([key, value])=>[
                    key.toLowerCase(),
                    value
                ])) : undefined;
            return {
                'x-cloudid': props.assistanceServiceParams.siteId,
                ...inputHeaders
            };
        }, [
            props.assistanceServiceParams.siteId,
            props.assistanceServiceParams.headers
        ]);
        const assistanceService = (0, $fsvuC.useMemo)(()=>{
            return new $28ddb726138ff9e8$export$a522c5f4ccda1c94({
                product: assistanceServiceParams.product,
                experienceId: assistanceServiceParams.experienceId,
                headers: headers,
                channelId: assistanceServiceParams.channelId,
                baseUrl: assistanceServiceParams.baseUrl,
                minionAlias: assistanceServiceParams.minionAlias,
                fileValidatePath: assistanceServiceParams.fileValidatePath,
                fileUploadPath: assistanceServiceParams.fileUploadPath
            });
        }, [
            assistanceServiceParams.baseUrl,
            assistanceServiceParams.experienceId,
            assistanceServiceParams.product,
            assistanceServiceParams.channelId,
            headers,
            assistanceServiceParams.minionAlias,
            assistanceServiceParams.fileValidatePath,
            assistanceServiceParams.fileUploadPath
        ]);
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing assistance-service baseline: injected hook params are adapted to the generic hook parameter type.
        const result = originalHook({
            ...restProps,
            assistanceServiceInjectedParams: {
                ...assistanceServiceParams,
                headers: headers,
                experienceTracker: experienceTracker,
                assistanceService: assistanceService
            }
        });
        return result;
    };
};

});
parcelRegister("jV057", function(module, exports) {
$parcel$export(module.exports, "ExperienceTrackerHandler", () => $b1c3c05c5ae49ccd$export$5a92a056565f01cc);
$parcel$export(module.exports, "useUFOLabelStackSetter", () => $b1c3c05c5ae49ccd$export$63af6e7bbb4f375d);
$parcel$export(module.exports, "useAIMateExperienceTracker", () => $b1c3c05c5ae49ccd$export$412c53791574f6f0);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $jWJ9H = parcelRequire("jWJ9H");

var $jF8Yw = parcelRequire("jF8Yw");

var $cYhnF = parcelRequire("cYhnF");

var $llCao = parcelRequire("llCao");

var $8IAtM = parcelRequire("8IAtM");

var $bg1fl = parcelRequire("bg1fl");

var $2GxPm = parcelRequire("2GxPm");

var $3Xw0Q = parcelRequire("3Xw0Q");

var $2pSN0 = parcelRequire("2pSN0");

var $jizTQ = parcelRequire("jizTQ");

var $kKZTv = parcelRequire("kKZTv");

var $hvMAG = parcelRequire("hvMAG");

var $3tjvX = parcelRequire("3tjvX");

var $8YfAb = parcelRequire("8YfAb");
const $b1c3c05c5ae49ccd$var$WORK_ITEM_EXPERIENCES = new Set([
    (0, $kKZTv.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_CREATE,
    (0, $kKZTv.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE,
    (0, $kKZTv.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_UPDATE,
    (0, $kKZTv.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_UPDATE
]);
const $b1c3c05c5ae49ccd$var$REMIX_PAGE_EXIT_REASON = 'User either closed or navigated away from the page during a Remix experience.';
const $b1c3c05c5ae49ccd$var$isRovoInstrumentedError = (error)=>error !== null && error !== undefined && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
const $b1c3c05c5ae49ccd$var$isTerminalEvent = (event)=>event.action === 'taskSuccess' || event.action === 'taskFail' || event.action === 'taskAbort';
const $b1c3c05c5ae49ccd$var$isAbortEvent = (event)=>event.action === 'taskAbort';
const $b1c3c05c5ae49ccd$var$isHelloShard = (shard)=>{
    const shardName = shard.split('.')[0];
    return /-hello(?:-\d+)?$/.test(shardName);
};
class $b1c3c05c5ae49ccd$export$5a92a056565f01cc {
    static{
        this.labelStack = [];
    }
    constructor(){
        this.experienceTracker = new (0, $bg1fl.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        this.unbindRemixPageExit = [];
        this.tabVisibilityByExperience = new Map();
        const doc = (0, $jF8Yw.getDocument)();
        if (doc) this.unbindVisibility = (0, $dqdTY.bind)(doc, {
            type: 'visibilitychange',
            listener: ()=>{
                const isHidden = doc.visibilityState === 'hidden';
                this.tabVisibilityByExperience.forEach((tracker)=>{
                    tracker.onVisibilityChange(isHidden);
                });
            }
        });
        if (typeof window !== 'undefined') {
            const abortRemixExperiences = ()=>{
                (0, $3tjvX.REMIX_EXPERIENCES).forEach((name)=>{
                    this.experienceTracker.abort({
                        name: name,
                        reason: $b1c3c05c5ae49ccd$var$REMIX_PAGE_EXIT_REASON,
                        checkForTimeout: false,
                        attributes: {
                            reason: $b1c3c05c5ae49ccd$var$REMIX_PAGE_EXIT_REASON
                        }
                    });
                });
            };
            this.unbindRemixPageExit = [
                // Fire before the analytics pipeline tears down on reload. A cancelled leave
                // confirmation can still abort tracking; pagehide alone loses reload aborts.
                (0, $dqdTY.bind)(window, {
                    type: 'beforeunload',
                    listener: abortRemixExperiences
                }),
                // Retain pagehide as a fallback for browsers that do not dispatch beforeunload.
                (0, $dqdTY.bind)(window, {
                    type: 'pagehide',
                    listener: abortRemixExperiences
                })
            ];
        }
        if (!(0, $cYhnF.expVal)('platform_ai_drop_instrumentation_tracking', 'value', false)) {
            if ((0, $llCao.fg)('rovo_work_item_reliability_shard')) (0, $2GxPm.getCurrentTenantShard)();
            this.unsubscribe = this.experienceTracker.subscribe((event)=>{
                if (event.action === 'taskStart') this.tabVisibilityByExperience.set(event.name, new (0, $8YfAb.TabVisibilityTracker)(doc));
                let filteredErrorAttributes = {};
                let preventSendingLogException = false;
                // When non-null, converts taskFail → taskAbort so the error is excluded from SLO
                // failure counts but still recorded for anomaly detection purposes.
                let sloExclusion = null;
                const isErrorEvent = 'error' in event;
                // Skip SLO exclusion logic for the aiMateFilteredClientError experience itself
                // to avoid re-processing and potential infinite loops.
                const isFilteredClientErrorExperience = event.name === (0, $kKZTv.ExperienceName).FILTERED_CLIENT_ERROR;
                if (isErrorEvent && !isFilteredClientErrorExperience) {
                    // Classify common non-service errors so they can be tracked separately from
                    // real backend failures:
                    //   - client fetch errors (e.g. "Failed to fetch") — request never reached Atlassian
                    //   - product-not-active — HTTP 200 but SSE payload contains an errorCode
                    //   - auth/permission — HTTP 401/403 (session expired, HIPAA, IP allowlist, etc.)
                    if ((0, $3Xw0Q.isClientFetchError)(event.error)) {
                        preventSendingLogException = true;
                        sloExclusion = {
                            reason: (0, $kKZTv.SLOExclusionReason).CLIENT_FETCH_ERROR
                        };
                    } else if ((0, $3Xw0Q.isProductNotActiveError)(event.error)) {
                        preventSendingLogException = true;
                        sloExclusion = {
                            reason: (0, $kKZTv.SLOExclusionReason).PRODUCT_NOT_ACTIVE
                        };
                    } else if ((0, $3Xw0Q.isAuthOrPermissionError)(event.error)) {
                        preventSendingLogException = true;
                        sloExclusion = {
                            reason: (0, $kKZTv.SLOExclusionReason).AUTH_OR_PERMISSION_ERROR
                        };
                    } else if ((0, $3Xw0Q.isRateLimitError)(event.error)) {
                        preventSendingLogException = true;
                        sloExclusion = {
                            reason: (0, $kKZTv.SLOExclusionReason).RATE_LIMIT_ERROR
                        };
                    }
                    if (event.attributes) {
                        const { webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled } = event.attributes;
                        if (webSearchEnabled !== undefined) filteredErrorAttributes = {
                            ...filteredErrorAttributes,
                            webSearchEnabled: webSearchEnabled
                        };
                        if (deepResearchEnabled !== undefined) filteredErrorAttributes = {
                            ...filteredErrorAttributes,
                            deepResearchEnabled: deepResearchEnabled
                        };
                        if (fastModeEnabled !== undefined) filteredErrorAttributes = {
                            ...filteredErrorAttributes,
                            fastModeEnabled: fastModeEnabled
                        };
                        if (thinkDeeperEnabled !== undefined) filteredErrorAttributes = {
                            ...filteredErrorAttributes,
                            thinkDeeperEnabled: thinkDeeperEnabled
                        };
                    }
                    if ($b1c3c05c5ae49ccd$var$isRovoInstrumentedError(event.error)) {
                        const errorAttributes = event.error.errorAttributes;
                        // Remove undefined properties
                        filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([, value])=>value !== undefined));
                    }
                    const teamName = (0, $hvMAG.getOwningTeam)(event.error.message ?? '', event.name);
                    filteredErrorAttributes = {
                        teamName: teamName,
                        ...filteredErrorAttributes
                    };
                    if (!preventSendingLogException) {
                        const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                        const attributes = event.attributes;
                        // this is added by `useExperienceTracker` below
                        const touchpointSource = typeof attributes?.touchpointSource === 'string' ? attributes.touchpointSource : undefined;
                        const teamName = typeof attributes?.teamName === 'string' ? attributes.teamName : undefined;
                        const { traceId: traceIdFromErrorObject, ...filteredErrorAttributesRest } = filteredErrorAttributes;
                        const altTraceId = attributes?.traceId || traceIdFromErrorObject;
                        (0, $2pSN0.logException)({
                            exception: error,
                            name: event.name,
                            // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing experience-tracker baseline: legacy UFO attributes are assembled from mixed attribute sources before being passed to a string map API.
                            tags: {
                                source: 'aiMateExperienceTracker',
                                ...filteredErrorAttributesRest,
                                ...touchpointSource && {
                                    touchpointSource: touchpointSource
                                },
                                ...teamName && {
                                    teamName: teamName
                                },
                                // Rename traceId to atlTraceId if present in attributes to distinguish from Sentry's Trace ID
                                ...altTraceId && {
                                    altTraceId: altTraceId
                                }
                            }
                        });
                    }
                }
                if ($b1c3c05c5ae49ccd$var$isTerminalEvent(event)) // the experience tracker already uses performance.now() to calculate the duration, so we can just piggyback on that,
                // we will loose some precision due to rounding of duration, but it's good enough for our purposes
                (0, $8IAtM.addSpanToAll)('custom', `exp-${event.name}`, $b1c3c05c5ae49ccd$export$5a92a056565f01cc.labelStack, event.startTime, event.startTime + event.duration);
                const tabVisibilityAttributes = $b1c3c05c5ae49ccd$var$isTerminalEvent(event) ? this.tabVisibilityByExperience.get(event.name)?.getAttributes(doc) ?? {} : {};
                // If the error should be excluded from SLO, report it as taskAbort instead of taskFail.
                // taskAbort events are not counted as failures in the SLO but are still recorded
                // so anomaly detectors can track spikes in these error types.
                const effectiveAction = sloExclusion && event.action === 'taskFail' ? 'taskAbort' : event.action;
                const sendEvent = (shard)=>this.sendAnalyticsEvent?.({
                        eventType: 'operational',
                        action: effectiveAction,
                        actionSubject: 'ui',
                        attributes: {
                            task: event.name,
                            taskId: event.id,
                            startTime: event.startTime,
                            ...$b1c3c05c5ae49ccd$var$isTerminalEvent(event) && {
                                duration: event.duration
                            },
                            // Include error info on both taskFail and taskAbort (for excluded errors)
                            // so analytics/anomaly detectors can distinguish error types.
                            ...isErrorEvent && {
                                error: event.error.message,
                                ...filteredErrorAttributes
                            },
                            // Surface why the error was excluded from the SLO so the raw analytics
                            // event can be queried/grouped without joining to the synthetic experience.
                            ...sloExclusion && {
                                sloExclusionReason: sloExclusion.reason
                            },
                            // `abort()` takes its reason as a top-level field rather than inside
                            // `attributes`, so it is otherwise dropped here and aborts land in
                            // analytics with no indication of why they happened. Spread before
                            // `event.attributes` so callers that already nest their own `reason`
                            // keep precedence.
                            ...$b1c3c05c5ae49ccd$var$isAbortEvent(event) && {
                                reason: event.reason
                            },
                            ...event.attributes,
                            ...tabVisibilityAttributes,
                            ...shard && {
                                shard: shard,
                                is_hello: $b1c3c05c5ae49ccd$var$isHelloShard(shard)
                            }
                        }
                    }, {
                        removeDefaultTags: true
                    });
                // Platform cannot reliably read shard information for every host product. Most work-item
                // event traffic comes from Jira and Confluence, so shard enrichment is scoped to these events.
                if ($b1c3c05c5ae49ccd$var$WORK_ITEM_EXPERIENCES.has(event.name) && (0, $llCao.fg)('rovo_work_item_reliability_shard')) (0, $2GxPm.getCurrentTenantShard)().then(sendEvent).catch(()=>{
                // Best-effort analytics must not produce an unhandled rejection.
                });
                else sendEvent();
                // When a client error is excluded from the main SLO (ie. converted to taskAbort),
                // track a separate experience so the volume of these errors can be monitored with its own SLO threshold.
                if (sloExclusion && isErrorEvent) {
                    this.experienceTracker.start({
                        name: (0, $kKZTv.ExperienceName).FILTERED_CLIENT_ERROR,
                        id: (0, $kKZTv.ExperienceName).FILTERED_CLIENT_ERROR,
                        startTime: event.startTime
                    });
                    this.experienceTracker.fail({
                        name: (0, $kKZTv.ExperienceName).FILTERED_CLIENT_ERROR,
                        error: event.error,
                        attributes: {
                            // Preserve the original experience name, error, and exclusion reason for queryability
                            originalTask: event.name,
                            error: event.error.message,
                            sloExclusionReason: sloExclusion.reason,
                            ...filteredErrorAttributes
                        }
                    });
                }
                if ($b1c3c05c5ae49ccd$var$isTerminalEvent(event)) this.tabVisibilityByExperience.delete(event.name);
            });
        }
    }
    destroy() {
        this.experienceTracker.abort({
            reason: 'Experience tracker destroyed'
        });
        this.unsubscribe?.();
        this.unsubscribe = undefined;
        this.unbindVisibility?.();
        this.unbindVisibility = undefined;
        this.unbindRemixPageExit.forEach((unbind)=>unbind());
        this.unbindRemixPageExit = [];
        this.tabVisibilityByExperience.clear();
    }
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$b1c3c05c5ae49ccd$export$5a92a056565f01cc.instance) $b1c3c05c5ae49ccd$export$5a92a056565f01cc.instance = new $b1c3c05c5ae49ccd$export$5a92a056565f01cc();
        // instance is guaranteed to be set after the guard above
        return $b1c3c05c5ae49ccd$export$5a92a056565f01cc.instance;
    }
    /**
	 * @internal For tests only.
	 */ static resetInstance() {
        $b1c3c05c5ae49ccd$export$5a92a056565f01cc.instance?.unbindRemixPageExit.forEach((unbind)=>unbind());
        $b1c3c05c5ae49ccd$export$5a92a056565f01cc.instance = undefined;
    }
    static setLabelStack(labelStack) {
        $b1c3c05c5ae49ccd$export$5a92a056565f01cc.labelStack = labelStack;
    }
}
$b1c3c05c5ae49ccd$export$5a92a056565f01cc.displayName = "ExperienceTrackerHandler";
const $b1c3c05c5ae49ccd$export$63af6e7bbb4f375d = ()=>{
    return (0, $fsvuC.useCallback)((componentLabelStack)=>{
        $b1c3c05c5ae49ccd$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
    }, []);
};
const $b1c3c05c5ae49ccd$export$412c53791574f6f0 = (params, handler = $b1c3c05c5ae49ccd$export$5a92a056565f01cc.getInstance())=>{
    (0, $jWJ9H.di)((0, $jizTQ.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jizTQ.useAnalytics)();
    (0, $fsvuC.useMemo)(()=>{
        // this is not ideal, okay just because `sendAnalyticsEvent` is never change
        // since every hook using the same handler will override its sendAnalyticsEvent
        handler.setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        handler,
        sendAnalyticsEvent
    ]);
    const experienceTrackerProxy = (0, $fsvuC.useMemo)(()=>{
        const proxyHandler = {
            get: (target, prop)=>{
                // Overriding the experienceTracker target methods to add additional attributes
                if (prop === 'fail') return (failParams)=>{
                    target.fail({
                        ...failParams,
                        attributes: {
                            ...failParams.attributes,
                            touchpointSource: params?.touchpointSource,
                            teamName: failParams.teamName
                        }
                    });
                };
                if (prop === 'succeed') return (succeedParams)=>{
                    target.succeed({
                        ...succeedParams,
                        attributes: {
                            ...succeedParams.attributes,
                            touchpointSource: params?.touchpointSource
                        }
                    });
                };
                return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
            }
        };
        return new Proxy(handler.experienceTracker, proxyHandler);
    }, [
        handler,
        params?.touchpointSource
    ]);
    return experienceTrackerProxy;
};

});
parcelRegister("cYhnF", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $516f3330960379c0$export$9db1624a8af791a4);

var $b2kpV = parcelRequire("b2kpV");
function $516f3330960379c0$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $b2kpV.expValInternal)(experimentName, param, defaultValue, true);
}

});
parcelRegister("b2kpV", function(module, exports) {
$parcel$export(module.exports, "expValInternal", () => $f9414f2fe0376a1e$export$48708229abf6ab93);

var $5Y9N2 = parcelRequire("5Y9N2");

var $f9hnP = parcelRequire("f9hnP");

var $04Ulb = parcelRequire("04Ulb");
function $f9414f2fe0376a1e$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $04Ulb.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrideParams = (0, $04Ulb.devOverrides).get(experimentName);
        const overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $f9hnP.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $5Y9N2.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const value = (0, $5Y9N2.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $f9hnP.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}

});
parcelRegister("04Ulb", function(module, exports) {
$parcel$export(module.exports, "devOverrides", () => $5e0ebb46d1f29ff9$export$89f9222be8849d61);
const $5e0ebb46d1f29ff9$export$89f9222be8849d61 = new Map();
let $5e0ebb46d1f29ff9$export$1443858d5f82511f = false;
function $5e0ebb46d1f29ff9$export$6bce865e33a255c3(value) {
    $5e0ebb46d1f29ff9$export$1443858d5f82511f = value;
}

});



parcelRegister("bg1fl", function(module, exports) {
$parcel$export(module.exports, "ExperienceTracker", () => $6543a77383973c93$export$12b6b072930fd68f);

var $hXgX6 = parcelRequire("hXgX6");
class $6543a77383973c93$export$12b6b072930fd68f {
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $hXgX6.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
}

});
parcelRegister("hXgX6", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $525091acf1e96313$export$c90b54e658fc4d7c);

var $2j0Du = parcelRequire("2j0Du");
function $525091acf1e96313$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $525091acf1e96313$export$c90b54e658fc4d7c {
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this._hasStopped = false;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $525091acf1e96313$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $525091acf1e96313$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $2j0Du.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $525091acf1e96313$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
}

});
parcelRegister("2j0Du", function(module, exports) {
$parcel$export(module.exports, "ExperienceTimeoutError", () => $b276a5f1fb13055d$export$d27a2b6293f7631c);
class $b276a5f1fb13055d$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}

});



parcelRegister("2GxPm", function(module, exports) {
$parcel$export(module.exports, "getCurrentTenantShard", () => $a72689fbfa117b27$export$4662865aec5bc074);
let $a72689fbfa117b27$var$cachedShard;
let $a72689fbfa117b27$var$currentLookup;
const $a72689fbfa117b27$var$normalizeShard = (shard)=>typeof shard === 'string' ? shard.trim() || undefined : undefined;
const $a72689fbfa117b27$var$readJiraShard = ()=>$a72689fbfa117b27$var$normalizeShard(window.document.querySelector('meta[name="ajs-shard"]')?.getAttribute('content'));
const $a72689fbfa117b27$var$readSiteInformationShard = async (value)=>{
    let timeout;
    try {
        const data = await Promise.race([
            value,
            new Promise((resolve)=>{
                timeout = setTimeout(()=>resolve(undefined), 5000);
            })
        ]);
        return $a72689fbfa117b27$var$normalizeShard(data?.tenant?.shard ?? data?.shard);
    } catch  {
        // Tenant metadata is best effort and must never break instrumentation.
        return undefined;
    } finally{
        clearTimeout(timeout);
    }
};
const $a72689fbfa117b27$var$readConfluenceShard = async ()=>{
    try {
        const browser = window;
        const siteShard = $a72689fbfa117b27$var$readSiteInformationShard(browser.__SITEINFORMATION__);
        const sessionShard = $a72689fbfa117b27$var$readSiteInformationShard(browser.__SITEINFORMATION_PROMISE__);
        return await siteShard ?? await sessionShard;
    } catch  {
        return undefined;
    }
};
const $a72689fbfa117b27$var$readCurrentTenantShard = async ()=>{
    try {
        if (typeof window === 'undefined') return undefined;
        return $a72689fbfa117b27$var$readJiraShard() ?? $a72689fbfa117b27$var$readConfluenceShard();
    } catch  {
        return undefined;
    }
};
const $a72689fbfa117b27$export$4662865aec5bc074 = ()=>{
    if (typeof window === 'undefined') return Promise.resolve(undefined);
    if ($a72689fbfa117b27$var$cachedShard !== undefined) return Promise.resolve($a72689fbfa117b27$var$cachedShard ?? undefined);
    if ($a72689fbfa117b27$var$currentLookup) return $a72689fbfa117b27$var$currentLookup;
    $a72689fbfa117b27$var$currentLookup = $a72689fbfa117b27$var$readCurrentTenantShard().then((shard)=>{
        $a72689fbfa117b27$var$cachedShard = shard ?? null;
        return shard;
    }).finally(()=>{
        $a72689fbfa117b27$var$currentLookup = undefined;
    });
    return $a72689fbfa117b27$var$currentLookup;
};

});

parcelRegister("3Xw0Q", function(module, exports) {
$parcel$export(module.exports, "isClientFetchError", () => $8a19ad4993e8eddb$export$2e7adc44463c3f4f);
$parcel$export(module.exports, "isAuthOrPermissionError", () => $8a19ad4993e8eddb$export$de229d5c9394f905);
$parcel$export(module.exports, "isRateLimitError", () => $8a19ad4993e8eddb$export$a8908c3867f6f20b);
$parcel$export(module.exports, "isProductNotActiveError", () => $8a19ad4993e8eddb$export$9f0dca42eff14720);

var $3x59x = parcelRequire("3x59x");
// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Issues we are not gonna track in Sentry
const $8a19ad4993e8eddb$var$KNOWN_NETWORK_ERRORS_LIMITED = [
    'server with the specified hostname could not be found',
    'connection failure',
    'Failed to fetch',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted'
];
const $8a19ad4993e8eddb$var$isClientFetchErrorMessage = (message)=>{
    const errorTypes = $8a19ad4993e8eddb$var$KNOWN_NETWORK_ERRORS_LIMITED;
    return Boolean(message) && !!errorTypes.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
};
const $8a19ad4993e8eddb$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $8a19ad4993e8eddb$var$MAX_ERROR_CAUSE_DEPTH = 3;
const $8a19ad4993e8eddb$var$getErrorAndCauseRecords = (error)=>{
    const records = [];
    let currentError = error;
    for(let depth = 0; depth < $8a19ad4993e8eddb$var$MAX_ERROR_CAUSE_DEPTH && (0, $3x59x.isRecord)(currentError); depth++){
        records.push(currentError);
        currentError = currentError.cause;
    }
    return records;
};
const $8a19ad4993e8eddb$var$getErrorStatusCode = (error)=>{
    const errorAttributes = (0, $3x59x.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    const attributes = (0, $3x59x.isRecord)(error.attributes) ? error.attributes : undefined;
    const status = errorAttributes?.statusCode ?? error.status ?? attributes?.status;
    return typeof status === 'number' ? status : undefined;
};
const $8a19ad4993e8eddb$var$getErrorCode = (error)=>{
    const errorAttributes = (0, $3x59x.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    return typeof errorAttributes?.errorCode === 'string' ? errorAttributes.errorCode.toLowerCase() : undefined;
};
const $8a19ad4993e8eddb$export$2e7adc44463c3f4f = (error)=>{
    if (!(0, $3x59x.isRecord)(error)) return false;
    // Check top-level error name and message
    const hasKnownName = typeof error.name === 'string' && $8a19ad4993e8eddb$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name);
    const hasKnownMessage = typeof error.message === 'string' && $8a19ad4993e8eddb$var$isClientFetchErrorMessage(error.message);
    if (hasKnownName || hasKnownMessage) return true;
    // Also check the nested cause (e.g. wrapped fetch errors)
    if (!(0, $3x59x.isRecord)(error.cause)) return false;
    return typeof error.cause.name === 'string' && $8a19ad4993e8eddb$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || typeof error.cause.message === 'string' && $8a19ad4993e8eddb$var$isClientFetchErrorMessage(error.cause.message);
};
const $8a19ad4993e8eddb$export$de229d5c9394f905 = (error)=>{
    return $8a19ad4993e8eddb$var$getErrorAndCauseRecords(error).some((errorRecord)=>{
        const status = $8a19ad4993e8eddb$var$getErrorStatusCode(errorRecord);
        return status === 401 || status === 403;
    });
};
const $8a19ad4993e8eddb$export$a8908c3867f6f20b = (error)=>{
    return $8a19ad4993e8eddb$var$getErrorAndCauseRecords(error).some((errorRecord)=>$8a19ad4993e8eddb$var$getErrorStatusCode(errorRecord) === 429);
};
const $8a19ad4993e8eddb$export$9f0dca42eff14720 = (error)=>{
    return $8a19ad4993e8eddb$var$getErrorAndCauseRecords(error).some((errorRecord)=>{
        const errorCode = $8a19ad4993e8eddb$var$getErrorCode(errorRecord) ?? '';
        return errorCode.includes('product.not.active') || errorCode.includes('product_not_active');
    });
};

});
parcelRegister("3x59x", function(module, exports) {
$parcel$export(module.exports, "isRecord", () => $202ffd3400871e0d$export$6ba840931da50680);
/**
 * Type guard that checks whether a value is a plain record object.
 */ const $202ffd3400871e0d$export$6ba840931da50680 = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);

});


parcelRegister("2pSN0", function(module, exports) {
$parcel$export(module.exports, "setupSentryClient", () => $7235fc7787080803$export$d8bd0edf6c978788);
$parcel$export(module.exports, "logException", () => $7235fc7787080803$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "addSentryBreadcrumb", () => $7235fc7787080803$export$de29810e0b4aa46e);
$parcel$export(module.exports, "logSentryConsoleError", () => $7235fc7787080803$export$2a10cc65cb1c6167);
$parcel$export(module.exports, "logSentryConsoleWarning", () => $7235fc7787080803$export$b9f335638bb5225f);

var $13Mqn = parcelRequire("13Mqn");

var $4RAHi = parcelRequire("4RAHi");

var $8a936 = parcelRequire("8a936");

const $7235fc7787080803$var$importPrivateSentryAsync = async ()=>{
    const sentry = await (parcelRequire("86r9M"));
    return {
        BrowserClient: sentry.BrowserClient,
        eventFromException: sentry.eventFromException
    };
};
const $7235fc7787080803$var$DEFAULT_PACKAGE_NAME = '@atlassian/conversation-assistant';
const $7235fc7787080803$var$DEFAULT_SENTRY_DSN = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
let $7235fc7787080803$var$privateReporter;
let $7235fc7787080803$var$accountIdPromise;
const $7235fc7787080803$var$defaultAccountIdProvider = ()=>new Promise((resolve, reject)=>{
        (0, $13Mqn.performHttpFetch)({
            path: '/gateway/api/me',
            options: {
                method: 'GET'
            }
        }).then((profileData)=>{
            if (profileData?.account_id) resolve(profileData.account_id);
            else reject(new Error('Profile data not loaded'));
        }).catch((error)=>{
            reject(error);
        });
    });
let $7235fc7787080803$var$accountIdProvider = $7235fc7787080803$var$defaultAccountIdProvider;
const $7235fc7787080803$export$59333a3d3d770a30 = (fn)=>{
    $7235fc7787080803$var$accountIdProvider = fn;
    $7235fc7787080803$var$accountIdPromise = undefined;
};
const $7235fc7787080803$export$e941c8ce80d1ac70 = ()=>{
    $7235fc7787080803$var$accountIdProvider = $7235fc7787080803$var$defaultAccountIdProvider;
    $7235fc7787080803$var$accountIdPromise = undefined;
};
const $7235fc7787080803$export$388db6ab9ccbe151 = ()=>{
    $7235fc7787080803$var$privateReporter?.resetForTests();
    $7235fc7787080803$var$privateReporter = undefined;
    $7235fc7787080803$var$accountIdPromise = undefined;
    $7235fc7787080803$var$accountIdProvider = $7235fc7787080803$var$defaultAccountIdProvider;
};
const $7235fc7787080803$var$getEnvironment = ()=>{
    return 'production';
};
const $7235fc7787080803$var$getRelease = ()=>{
    if (typeof window === 'undefined') return;
    return window.SENTRY_RELEASE?.id;
};
const $7235fc7787080803$var$setupPrivateReporter = async ({ accountId: accountId, customSentryDsn: customSentryDsn, ignoreErrors: ignoreErrors, packageName: packageName, packageVersion: packageVersion, product: product })=>{
    const dsn = customSentryDsn || $7235fc7787080803$var$DEFAULT_SENTRY_DSN;
    if ($7235fc7787080803$var$privateReporter) {
        $7235fc7787080803$var$privateReporter.updateContext({
            accountId: accountId,
            packageVersion: packageVersion,
            product: product
        });
        return;
    }
    try {
        const importedSentry = await $7235fc7787080803$var$importPrivateSentryAsync();
        $7235fc7787080803$var$privateReporter = new (0, $8a936.ConversationAssistantPrivateReporter)({
            accountId: accountId,
            dsn: dsn,
            environment: $7235fc7787080803$var$getEnvironment(),
            ignoreErrors: ignoreErrors,
            packageName: packageName,
            packageVersion: packageVersion,
            product: product,
            release: $7235fc7787080803$var$getRelease(),
            sentry: importedSentry
        });
    } catch  {
    // Private reporting is best effort and must not affect Sentry callers.
    }
};
const $7235fc7787080803$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride, ignoreErrors: ignoreErrors, packageVersion: packageVersion } = {})=>{
    let accountId = 'UNKNOWN_AAID';
    const product = productOverride ?? (0, $4RAHi.getRovoChatProduct)();
    const resolvedPackageName = packageName || $7235fc7787080803$var$DEFAULT_PACKAGE_NAME;
    try {
        if (!$7235fc7787080803$var$accountIdPromise) $7235fc7787080803$var$accountIdPromise = $7235fc7787080803$var$accountIdProvider();
        accountId = await $7235fc7787080803$var$accountIdPromise;
    } catch  {
    // do nothing
    }
    await $7235fc7787080803$var$setupPrivateReporter({
        accountId: accountId,
        customSentryDsn: customSentryDsn,
        ignoreErrors: ignoreErrors,
        packageName: resolvedPackageName,
        packageVersion: packageVersion,
        product: product
    });
};
const $7235fc7787080803$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    if (!$7235fc7787080803$var$privateReporter) await $7235fc7787080803$export$d8bd0edf6c978788();
    try {
        await $7235fc7787080803$var$privateReporter?.captureException({
            exception: exception,
            name: name,
            tags: tags
        });
    } catch  {
    // Private reporting is best effort and must not affect Sentry callers.
    }
};
async function $7235fc7787080803$export$de29810e0b4aa46e(crumb) {
    if (!$7235fc7787080803$var$privateReporter) await $7235fc7787080803$export$d8bd0edf6c978788();
    try {
        $7235fc7787080803$var$privateReporter?.addBreadcrumb(crumb);
    } catch  {
    // Breadcrumb collection is best effort and must never affect the caller.
    }
}
const $7235fc7787080803$export$2a10cc65cb1c6167 = (...args)=>{
    console.error(...args); // eslint-disable-line no-console
    if ($7235fc7787080803$var$privateReporter) try {
        $7235fc7787080803$var$privateReporter.addBreadcrumb({
            category: 'console',
            level: 'error',
            message: args.map(String).join(' ')
        });
    } catch  {
    // Mirroring selected console output is best effort.
    }
};
const $7235fc7787080803$export$b9f335638bb5225f = (...args)=>{
    console.warn(...args); // eslint-disable-line no-console
    if ($7235fc7787080803$var$privateReporter) try {
        $7235fc7787080803$var$privateReporter.addBreadcrumb({
            category: 'console',
            level: 'warning',
            message: args.map(String).join(' ')
        });
    } catch  {
    // Mirroring selected console output is best effort.
    }
};

});
parcelRegister("13Mqn", function(module, exports) {
$parcel$export(module.exports, "getTraceIdFromResponse", () => $62b52c86f0f89dca$export$9f229e40eb65abfc);
$parcel$export(module.exports, "FetchError", () => $62b52c86f0f89dca$export$26e841bcf1aeb894);
$parcel$export(module.exports, "performHttpFetch", () => $62b52c86f0f89dca$export$a38d93aa782475f6);

var $8Mbu7 = parcelRequire("8Mbu7");
const $62b52c86f0f89dca$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $62b52c86f0f89dca$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $62b52c86f0f89dca$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $62b52c86f0f89dca$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    const startedAt = (0, $8Mbu7.hasRequestObservationSubscribers)() ? (0, $8Mbu7.requestObservationNow)() : undefined;
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $62b52c86f0f89dca$var$processHttpErrorResponse({
            response: response
        });
        const result = await response.json();
        if (startedAt !== undefined) (0, $8Mbu7.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $8Mbu7.normalizeRequestRoute)(path),
            durationMs: (0, $8Mbu7.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return result;
    } catch (err) {
        const outcome = err instanceof $62b52c86f0f89dca$var$HttpApiError ? 'httpError' : err instanceof Error && err.name === 'AbortError' ? 'abort' : 'networkError';
        const statusCode = err instanceof $62b52c86f0f89dca$var$HttpApiError ? err.errorAttributes.statusCode : undefined;
        if (startedAt !== undefined) (0, $8Mbu7.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $8Mbu7.normalizeRequestRoute)(path),
            durationMs: (0, $8Mbu7.requestObservationDuration)(startedAt),
            outcome: outcome,
            status: statusCode
        });
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        throw new $62b52c86f0f89dca$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $62b52c86f0f89dca$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $62b52c86f0f89dca$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $62b52c86f0f89dca$export$9f229e40eb65abfc(response)
    });
};

});
parcelRegister("8Mbu7", function(module, exports) {
$parcel$export(module.exports, "requestObservationNow", () => $b9da0d09fb88b316$export$eb91308c925b64ce);
$parcel$export(module.exports, "requestObservationDuration", () => $b9da0d09fb88b316$export$327998895df08b85);
$parcel$export(module.exports, "normalizeRequestRoute", () => $b9da0d09fb88b316$export$c805539eac489f93);
$parcel$export(module.exports, "subscribeToRequestObservations", () => $b9da0d09fb88b316$export$d23c16bc33c579b9);
$parcel$export(module.exports, "hasRequestObservationSubscribers", () => $b9da0d09fb88b316$export$1914d1896389da95);
$parcel$export(module.exports, "publishRequestObservation", () => $b9da0d09fb88b316$export$58e155918d09bf5f);
const $b9da0d09fb88b316$var$listeners = new Set();
const $b9da0d09fb88b316$var$UUID_SEGMENT_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $b9da0d09fb88b316$var$NUMERIC_SEGMENT_PATTERN = /\/\d+(?=\/|$)/g;
const $b9da0d09fb88b316$export$eb91308c925b64ce = ()=>{
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') return performance.now();
    return Date.now();
};
const $b9da0d09fb88b316$export$327998895df08b85 = (startedAt)=>Math.max(0, Math.round($b9da0d09fb88b316$export$eb91308c925b64ce() - startedAt));
const $b9da0d09fb88b316$export$c805539eac489f93 = (path)=>{
    try {
        const parsed = new URL(path, 'https://conversation-assistant.invalid');
        return parsed.pathname.replace($b9da0d09fb88b316$var$UUID_SEGMENT_PATTERN, '{id}').replace($b9da0d09fb88b316$var$NUMERIC_SEGMENT_PATTERN, '/{id}');
    } catch  {
        return '/unparseable';
    }
};
const $b9da0d09fb88b316$export$d23c16bc33c579b9 = (listener)=>{
    $b9da0d09fb88b316$var$listeners.add(listener);
    return ()=>{
        $b9da0d09fb88b316$var$listeners.delete(listener);
    };
};
const $b9da0d09fb88b316$export$1914d1896389da95 = ()=>$b9da0d09fb88b316$var$listeners.size > 0;
const $b9da0d09fb88b316$export$58e155918d09bf5f = (observation)=>{
    for (const listener of Array.from($b9da0d09fb88b316$var$listeners))try {
        listener(observation);
    } catch  {
    // Observability must never change the request's result or error behavior.
    }
};
const $b9da0d09fb88b316$export$ef42b2d680ea8d8d = ()=>{
    $b9da0d09fb88b316$var$listeners.clear();
};

});


parcelRegister("4RAHi", function(module, exports) {
$parcel$export(module.exports, "getRovoChatProduct", () => $0501d2d766c00e47$export$d4fdfa93c283ffc);
const $0501d2d766c00e47$export$d4fdfa93c283ffc = ()=>{
    let product = 'UNKNOWN';
    const win = window;
    if (win.__ROVO_CHAT_CONFIG_PRODUCT__) product = win.__ROVO_CHAT_CONFIG_PRODUCT__;
    return product;
};

});

parcelRegister("8a936", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistantPrivateReporter", () => $0df2ecbfb1c8dda6$export$7c63502cdfeff038);

var $8Mbu7 = parcelRequire("8Mbu7");

var $3Xw0Q = parcelRequire("3Xw0Q");

var $eLEhf = parcelRequire("eLEhf");

var $i0OZC = parcelRequire("i0OZC");
const $0df2ecbfb1c8dda6$var$MAX_LINKED_ERRORS = 5;
const $0df2ecbfb1c8dda6$var$MAX_MATCHED_UUID_TAG_LENGTH = 200;
const $0df2ecbfb1c8dda6$var$BLOCKED_LOCATION_PARTS = [
    'localhost',
    'jira-dev.com',
    'stg.atlassian.com',
    'stg.internal.atlassian.com',
    'stg-east.frontend.public.atl-paas.net'
];
const $0df2ecbfb1c8dda6$var$eventId = ()=>crypto.randomUUID().replace(/-/g, '');
const $0df2ecbfb1c8dda6$var$matchesIgnorePattern = (value, patterns)=>patterns?.some((pattern)=>typeof pattern === 'string' ? value.includes(pattern) : (()=>{
            pattern.lastIndex = 0;
            const matches = pattern.test(value);
            pattern.lastIndex = 0;
            return matches;
        })()) ?? false;
const $0df2ecbfb1c8dda6$var$isBlockedLocation = ()=>{
    if (typeof window === 'undefined') return false;
    return $0df2ecbfb1c8dda6$var$BLOCKED_LOCATION_PARTS.some((part)=>window.location.href.includes(part));
};
const $0df2ecbfb1c8dda6$var$requestObservationToBreadcrumb = (observation)=>({
        category: observation.kind === 'graphql' ? 'conversation-assistant.request.graphql' : 'conversation-assistant.request.http',
        data: observation,
        level: observation.outcome === 'success' || observation.outcome === 'abort' ? 'info' : 'warning',
        message: observation.kind === 'graphql' ? `${observation.operation} ${observation.outcome}` : `${observation.method} ${observation.route} ${observation.outcome}`,
        type: 'http'
    });
const $0df2ecbfb1c8dda6$var$toPrivateBreadcrumb = (breadcrumb)=>({
        ...breadcrumb,
        level: breadcrumb.level
    });
const $0df2ecbfb1c8dda6$var$getCause = (error)=>{
    const cause = error.cause;
    return cause instanceof Error ? cause : undefined;
};
class $0df2ecbfb1c8dda6$export$7c63502cdfeff038 {
    constructor({ accountId: accountId, dsn: dsn, environment: environment, ignoreErrors: ignoreErrors, packageName: packageName, packageVersion: packageVersion, product: product, release: release, sentry: sentry }){
        this.breadcrumbGateway = new (0, $eLEhf.ConversationAssistantBreadcrumbGateway)();
        this.accountId = accountId;
        this.enabled = environment === 'production';
        this.ignoreErrors = ignoreErrors;
        this.packageName = packageName;
        this.packageVersion = packageVersion;
        this.product = product;
        this.sentry = sentry;
        this.client = new sentry.BrowserClient({
            attachStacktrace: true,
            autoSessionTracking: false,
            dsn: dsn,
            enabled: this.enabled,
            environment: environment,
            integrations: [],
            maxBreadcrumbs: 100,
            release: release,
            sendClientReports: true
        });
        this.unsubscribeFromRequestObservations = (0, $8Mbu7.subscribeToRequestObservations)((observation)=>{
            this.breadcrumbGateway.add($0df2ecbfb1c8dda6$var$requestObservationToBreadcrumb(observation));
        });
    }
    updateContext({ accountId: accountId, packageVersion: packageVersion, product: product }) {
        this.accountId = accountId;
        if (this.packageVersion === undefined && packageVersion !== undefined) this.packageVersion = packageVersion;
        this.product = product;
    }
    addBreadcrumb(crumb) {
        this.breadcrumbGateway.add(crumb);
    }
    async captureException({ exception: exception, name: name, tags: tags }) {
        if (!this.enabled || (0, $3Xw0Q.isClientFetchError)(exception) || $0df2ecbfb1c8dda6$var$isBlockedLocation()) return;
        const rootMessage = exception instanceof Error ? exception.message : String(exception);
        if ($0df2ecbfb1c8dda6$var$matchesIgnorePattern(rootMessage, this.ignoreErrors)) return;
        const id = $0df2ecbfb1c8dda6$var$eventId();
        const event = await this.sentry.eventFromException(exception, {
            event_id: id
        }, true);
        await this.addLinkedErrors(event, exception);
        const eventTags = {
            experience: tags?.source === 'aiMateExperienceTracker' ? name : undefined,
            name: name,
            packageName: this.packageName,
            packageVersion: this.packageVersion,
            product: this.product,
            sentryOwner: 'conversation-assistant',
            ...tags
        };
        event.tags = {
            ...event.tags,
            ...eventTags
        };
        event.user = {
            id: this.accountId
        };
        event.breadcrumbs = this.breadcrumbGateway.snapshot().map($0df2ecbfb1c8dda6$var$toPrivateBreadcrumb);
        if (typeof window !== 'undefined') event.request = {
            ...event.request,
            url: (0, $i0OZC.normaliseUrl)(window.location.href)
        };
        this.normalizeEventUUIDs(event);
        // Do not pass `originalException`: BaseClient otherwise consults the SDK-wide
        // already-caught registry shared through Sentry's global carrier.
        this.client.captureEvent(event, {
            event_id: id
        });
    }
    resetForTests() {
        this.unsubscribeFromRequestObservations();
        this.breadcrumbGateway.reset();
    }
    async addLinkedErrors(event, exception) {
        if (!(exception instanceof Error) || !event.exception?.values) return;
        const linkedValues = [];
        let current = $0df2ecbfb1c8dda6$var$getCause(exception);
        const seen = new Set([
            exception
        ]);
        while(current && linkedValues.length < $0df2ecbfb1c8dda6$var$MAX_LINKED_ERRORS - 1 && !seen.has(current)){
            seen.add(current);
            const linkedEvent = await this.sentry.eventFromException(current, undefined, true);
            if (linkedEvent.exception?.values?.[0]) linkedValues.unshift(linkedEvent.exception.values[0]);
            current = $0df2ecbfb1c8dda6$var$getCause(current);
        }
        event.exception.values = [
            ...linkedValues,
            ...event.exception.values
        ];
    }
    normalizeEventUUIDs(event) {
        if (!event.exception?.values) return;
        const matchedUUIDs = new Set();
        event.exception.values = event.exception.values.map((exceptionValue)=>{
            const { normalized: normalized, matchedUUIDs: matches } = (0, $i0OZC.normalizeUUID)(exceptionValue.value);
            matches.forEach((match)=>matchedUUIDs.add(match));
            return {
                ...exceptionValue,
                stacktrace: exceptionValue.stacktrace ? {
                    ...exceptionValue.stacktrace,
                    frames: exceptionValue.stacktrace.frames?.map((frame)=>{
                        const normalizedFrame = {
                            ...frame
                        };
                        [
                            'abs_path',
                            'filename',
                            'function',
                            'module'
                        ].forEach((key)=>{
                            if (typeof normalizedFrame[key] !== 'string') return;
                            const normalizedStackValue = (0, $i0OZC.normalizeUUID)(normalizedFrame[key]);
                            normalizedStackValue.matchedUUIDs.forEach((match)=>matchedUUIDs.add(match));
                            normalizedFrame[key] = normalizedStackValue.normalized;
                        });
                        return normalizedFrame;
                    })
                } : undefined,
                value: normalized
            };
        });
        if (matchedUUIDs.size === 0) return;
        const boundedMatches = [];
        for (const match of matchedUUIDs){
            const candidate = [
                ...boundedMatches,
                match
            ];
            if (JSON.stringify(candidate).length > $0df2ecbfb1c8dda6$var$MAX_MATCHED_UUID_TAG_LENGTH) break;
            boundedMatches.push(match);
        }
        event.tags = {
            ...event.tags,
            matchedUUID: JSON.stringify(boundedMatches)
        };
    }
}

});
parcelRegister("eLEhf", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistantBreadcrumbGateway", () => $ad04ac9546494973$export$78d89786cb79630b);

var $i0OZC = parcelRequire("i0OZC");
const $ad04ac9546494973$var$MAX_BREADCRUMBS = 100;
const $ad04ac9546494973$var$MAX_MESSAGE_LENGTH = 500;
const $ad04ac9546494973$var$MAX_DATA_VALUE_LENGTH = 200;
const $ad04ac9546494973$var$COALESCE_WINDOW_MS = 5000;
const $ad04ac9546494973$var$ALLOWED_DATA_KEYS = new Set([
    'action',
    'actionSubject',
    'actionSubjectId',
    'durationMs',
    'experience',
    'kind',
    'lifecycle',
    'method',
    'nextState',
    'operation',
    'outcome',
    'previousState',
    'repeatCount',
    'route',
    'screen',
    'state',
    'status',
    'surface',
    'touchpoint'
]);
const $ad04ac9546494973$var$truncate = (value, maxLength)=>value.length > maxLength ? `${value.slice(0, maxLength - 1)}\u{2026}` : value;
const $ad04ac9546494973$var$sanitizeString = (value, maxLength = $ad04ac9546494973$var$MAX_DATA_VALUE_LENGTH)=>{
    const { normalized: normalized } = (0, $i0OZC.normalizeUUID)(value);
    const withoutQuery = normalized.replace(/([a-z][a-z0-9+.-]*:\/\/[^?\s]+)\?[^\s]*/gi, '$1');
    return $ad04ac9546494973$var$truncate(withoutQuery, maxLength);
};
const $ad04ac9546494973$var$sanitizeData = (data)=>{
    if (!data) return;
    const sanitized = Object.entries(data).reduce((result, [key, value])=>{
        if (!$ad04ac9546494973$var$ALLOWED_DATA_KEYS.has(key) || value !== null && typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean') return result;
        if (typeof value === 'string') {
            const sanitizedValue = $ad04ac9546494973$var$sanitizeString(value);
            result[key] = sanitizedValue;
        } else if (value !== null) result[key] = value;
        return result;
    }, {});
    return Object.keys(sanitized).length > 0 ? sanitized : undefined;
};
const $ad04ac9546494973$var$sanitizeCategory = (category)=>{
    if (!category) return 'conversation-assistant.custom';
    const safeCategory = category.toLowerCase().replace(/[^a-z0-9._-]+/g, '-').slice(0, 80);
    return safeCategory.startsWith('conversation-assistant.') ? safeCategory : `conversation-assistant.${safeCategory}`;
};
const $ad04ac9546494973$var$isCoalescable = (breadcrumb)=>breadcrumb.level === 'warning' || breadcrumb.level === 'error' || breadcrumb.category?.includes('store') === true;
class $ad04ac9546494973$export$78d89786cb79630b {
    add(crumb) {
        const breadcrumb = this.sanitize(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
        if (!$ad04ac9546494973$var$isCoalescable(breadcrumb)) {
            this.push(breadcrumb);
            return;
        }
        const key = JSON.stringify({
            category: breadcrumb.category,
            data: breadcrumb.data,
            level: breadcrumb.level,
            message: breadcrumb.message,
            type: breadcrumb.type
        });
        const pending = this.pendingCoalescedBreadcrumb;
        if (pending?.key === key) {
            pending.repeatCount += 1;
            return;
        }
        this.flushCoalescedSummary();
        this.push(breadcrumb);
        this.pendingCoalescedBreadcrumb = {
            key: key,
            breadcrumb: breadcrumb,
            repeatCount: 1,
            timer: setTimeout(()=>this.flushCoalescedSummary(), $ad04ac9546494973$var$COALESCE_WINDOW_MS)
        };
    }
    snapshot() {
        this.flushCoalescedSummary();
        return this.breadcrumbs.map((breadcrumb)=>({
                ...breadcrumb,
                data: breadcrumb.data ? {
                    ...breadcrumb.data
                } : undefined
            }));
    }
    reset() {
        if (this.pendingCoalescedBreadcrumb) clearTimeout(this.pendingCoalescedBreadcrumb.timer);
        this.pendingCoalescedBreadcrumb = undefined;
        this.breadcrumbs = [];
    }
    sanitize(breadcrumb) {
        const category = $ad04ac9546494973$var$sanitizeCategory(breadcrumb.category);
        const data = $ad04ac9546494973$var$sanitizeData(breadcrumb.data);
        const message = typeof breadcrumb.message === 'string' ? $ad04ac9546494973$var$sanitizeString(breadcrumb.message, $ad04ac9546494973$var$MAX_MESSAGE_LENGTH) : undefined;
        return {
            category: category,
            data: data,
            level: breadcrumb.level,
            message: message,
            timestamp: breadcrumb.timestamp ?? Date.now() / 1000,
            type: breadcrumb.type
        };
    }
    flushCoalescedSummary() {
        const pending = this.pendingCoalescedBreadcrumb;
        if (!pending) return;
        clearTimeout(pending.timer);
        this.pendingCoalescedBreadcrumb = undefined;
        if (pending.repeatCount <= 1) return;
        this.push({
            ...pending.breadcrumb,
            data: {
                ...pending.breadcrumb.data,
                repeatCount: pending.repeatCount
            },
            message: pending.breadcrumb.message ? `${pending.breadcrumb.message} (repeated ${pending.repeatCount} times)` : `Breadcrumb repeated ${pending.repeatCount} times`,
            timestamp: Date.now() / 1000
        });
    }
    push(breadcrumb) {
        this.breadcrumbs.push(breadcrumb);
        if (this.breadcrumbs.length > $ad04ac9546494973$var$MAX_BREADCRUMBS) this.breadcrumbs.splice(0, this.breadcrumbs.length - $ad04ac9546494973$var$MAX_BREADCRUMBS);
    }
    constructor(){
        this.breadcrumbs = [];
    }
}

});
parcelRegister("i0OZC", function(module, exports) {
$parcel$export(module.exports, "normaliseUrl", () => $47b47267b0a8fb56$export$d57ae76c6dc57a5);
$parcel$export(module.exports, "normalizeUUID", () => $47b47267b0a8fb56$export$5efaf8444170fe75);
const $47b47267b0a8fb56$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $47b47267b0a8fb56$var$ATLAS_HOST = 'home.atlassian.com';
const $47b47267b0a8fb56$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $47b47267b0a8fb56$var$UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $47b47267b0a8fb56$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $47b47267b0a8fb56$var$ATLAS_HOST || parsedUrl.host === $47b47267b0a8fb56$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$47b47267b0a8fb56$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};
const $47b47267b0a8fb56$export$5efaf8444170fe75 = (str)=>{
    if (!str) return {
        normalized: '',
        matchedUUIDs: []
    };
    const matchedUUIDs = str.match($47b47267b0a8fb56$var$UUID_REGEX) || [];
    const normalized = str.replace($47b47267b0a8fb56$var$UUID_REGEX, '{uuid}');
    return {
        normalized: normalized,
        matchedUUIDs: matchedUUIDs
    };
};

});



parcelRegister("86r9M", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("juorp").then(()=>parcelRequire('5ABoQ'));

});
parcelRegister("dk4lR", function(module, exports) {
"use strict";

function $9b3084c5dabc3940$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("8b7E8")).resolve(id));
}
module.exports = $9b3084c5dabc3940$var$load;

});
parcelRegister("8b7E8", function(module, exports) {
$parcel$export(module.exports, "register", () => $01896021d7502578$export$6503ec6e8aabbaf, (v) => $01896021d7502578$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $01896021d7502578$export$f7ad0328861e2f03, (v) => $01896021d7502578$export$f7ad0328861e2f03 = v);
var $01896021d7502578$export$6503ec6e8aabbaf;
var $01896021d7502578$export$f7ad0328861e2f03;
"use strict";
var $01896021d7502578$var$mapping = new Map();
function $01896021d7502578$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$01896021d7502578$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $01896021d7502578$var$resolve(id) {
    var resolved = $01896021d7502578$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$01896021d7502578$export$6503ec6e8aabbaf = $01896021d7502578$var$register;
$01896021d7502578$export$f7ad0328861e2f03 = $01896021d7502578$var$resolve;

});




parcelRegister("jizTQ", function(module, exports) {
$parcel$export(module.exports, "isRovoJourneyAllowlistedEvent", () => $c37674eadb1bbfbc$export$f30c856a07c48ee5);
$parcel$export(module.exports, "useAnalytics", () => $c37674eadb1bbfbc$export$e955abb82869dc84);

var $fsvuC = parcelRequire("fsvuC");

var $fg1VY = parcelRequire("fg1VY");

var $mhEfz = parcelRequire("mhEfz");

var $llCao = parcelRequire("llCao");

var $jHM2h = parcelRequire("jHM2h");

var $2pSN0 = parcelRequire("2pSN0");

var $aSkDB = parcelRequire("aSkDB");

var $bSokK = parcelRequire("bSokK");

var $39dkK = parcelRequire("39dkK");

var $iMo3a = parcelRequire("iMo3a");
const $c37674eadb1bbfbc$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host?.includes(host));
const $c37674eadb1bbfbc$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $c37674eadb1bbfbc$export$f30c856a07c48ee5 = ({ action: action, actionSubject: actionSubject, type: type })=>// message sent (client) — sendAnalyticsEvent only, no trackAIMAUEvent equivalent.
    action === 'sent' && actionSubject === 'message' || // aiMateActions displayed (client) — sendAnalyticsEvent only, no trackAIMAUEvent equivalent.
    action === 'displayed' && actionSubject === 'aiMateActions' || // aiInteraction initiated — via sendAnalyticsEvent or trackAIMAUEvent({ type: 'initiated' }).
    action === 'initiated' && actionSubject === 'aiInteraction' || type === 'initiated' || // aiResult viewed — via sendAnalyticsEvent or trackAIMAUEvent({ type: 'viewed' }).
    action === 'viewed' && actionSubject === 'aiResult' || type === 'viewed' || // aiResult actioned (client) — via sendAnalyticsEvent or trackAIMAUEvent({ type: 'actioned' }).
    action === 'actioned' && actionSubject === 'aiResult' || type === 'actioned';
const $c37674eadb1bbfbc$var$getRovoJourneyEventAttributes = ({ eventPayload: eventPayload, attributes: attributes, contextRovoJourneyId: contextRovoJourneyId })=>{
    const { [(0, $bSokK.AI_MATE_ATTRIBUTES).rovoJourneyId]: suppliedRovoJourneyId, ...attributesWithoutRovoJourneyId } = attributes;
    const rovoJourneyId = suppliedRovoJourneyId ?? contextRovoJourneyId;
    return {
        ...attributesWithoutRovoJourneyId,
        ...$c37674eadb1bbfbc$export$f30c856a07c48ee5(eventPayload) && rovoJourneyId ? {
            [(0, $bSokK.AI_MATE_ATTRIBUTES).rovoJourneyId]: rovoJourneyId
        } : {}
    };
};
const $c37674eadb1bbfbc$var$SENTRY_ANALYTICS_ATTRIBUTE_KEYS = [
    'experience',
    'nextState',
    'outcome',
    'previousState',
    'screen',
    'state',
    'surface',
    'touchpoint'
];
const $c37674eadb1bbfbc$var$getSentryAnalyticsBreadcrumb = (event)=>{
    const payload = event.payload;
    const attributes = payload?.attributes ?? {};
    const safeAttributes = $c37674eadb1bbfbc$var$SENTRY_ANALYTICS_ATTRIBUTE_KEYS.reduce((result, key)=>{
        const value = attributes[key];
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') result[key] = value;
        return result;
    }, {});
    return {
        category: 'analytics',
        data: {
            action: payload?.action,
            actionSubject: payload?.actionSubject,
            actionSubjectId: payload?.actionSubjectId,
            ...safeAttributes
        },
        message: [
            payload?.action,
            payload?.actionSubject,
            payload?.actionSubjectId
        ].filter(Boolean).join(' ')
    };
};
const $c37674eadb1bbfbc$export$e955abb82869dc84 = (options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef, mode: mode } = (0, $aSkDB.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $fsvuC.useCallback)((inputPayload)=>{
        const payload = (0, $fg1VY.isUIAnalyticsEvent)(inputPayload) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $c37674eadb1bbfbc$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const tagsForAIAnalytics = [
        ...$c37674eadb1bbfbc$var$DEFAULT_TAGS
    ];
    if ($c37674eadb1bbfbc$var$isTownSquareEvent()) tagsForAIAnalytics.push('townsquare');
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIResultAdopted: trackAIResultAdopted, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $jHM2h.useAIEventsInstrumentation)({
        // Required configruation
        product: propertiesRef.current.product,
        subproduct: propertiesRef.current.product,
        aiFeatureName: 'aiChat',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        tags: tagsForAIAnalytics,
        skipAISessionValidation: options?.skipAISessionValidation,
        customAnalyticsFire: (rawEvent, _createdEvent)=>{
            // Build event and apply context attributes
            const event = createAnalyticsEvent(rawEvent);
            if (!event) // In SSR / no-listener environments, `createAnalyticsEvent` can return `undefined`.
            // Nothing to fire.
            return;
            const aiMateContextAttributes = (0, $iMo3a.getAttributesFromContexts)(event.context);
            // Fire. `event.update(...)` returns `undefined` for stub events (no `<AnalyticsListener>`
            // mounted, e.g. during SSR), so fall back to the original event and guard `.fire` with
            // optional chaining.
            const updatedEvent = event.update({
                attributes: $c37674eadb1bbfbc$var$getRovoJourneyEventAttributes({
                    eventPayload: event.payload ?? rawEvent,
                    attributes: {
                        ...event.payload?.attributes ?? {},
                        ...aiMateContextAttributes
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            }) ?? event;
            updatedEvent?.fire?.((0, $39dkK.ANALYTICS_CHANNEL));
        }
    });
    const getDefaultAttributes = (0, $fsvuC.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, agentIsVerified: agentIsVerified, conversationChannelId: conversationChannelId, chatEntryPoint: chatEntryPoint, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader, inProductExperience: inProductExperience, mode: mode, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias, spaceId: spaceId, isThirdPartyPromptConversation: isThirdPartyPromptConversation, thirdPartyPromptCohort: thirdPartyPromptCohort, thirdPartyConnectCount: thirdPartyConnectCount } = propertiesRef.current;
        return {
            [(0, $bSokK.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).chatEntryPoint]: chatEntryPoint,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).inProductExperience]: inProductExperience,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).agentIsVerified]: agentIsVerified,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).mode]: mode,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).assistanceServiceConfigMinionAlias]: assistanceServiceConfigMinionAlias,
            [(0, $bSokK.AI_MATE_ATTRIBUTES).spaceId]: spaceId,
            // Gated on TRUE, not merely defined: the modal stamps `false` on every submit to clear
            // a previous 3P conversation, so a defined-check would let every later conversation
            // carry these keys with two `undefined`s.
            ...isThirdPartyPromptConversation ? {
                [(0, $bSokK.AI_MATE_ATTRIBUTES).isThirdPartyPromptConversation]: isThirdPartyPromptConversation,
                [(0, $bSokK.AI_MATE_ATTRIBUTES).thirdPartyPromptCohort]: thirdPartyPromptCohort,
                [(0, $bSokK.AI_MATE_ATTRIBUTES).thirdPartyConnectCount]: thirdPartyConnectCount
            } : {}
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $fsvuC.useCallback)((payload)=>{
        // Handle tags
        const tags = [
            ...$c37674eadb1bbfbc$var$DEFAULT_TAGS
        ];
        if ($c37674eadb1bbfbc$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: sourceUnknown, subjectId: subjectIdUnknown, proactive: proactive, userGenerated: userGenerated, doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, connectorInfo: connectorInfo, sourceProducts: sourceProducts, sourceProduct: sourceProduct, pluginsInvoked: pluginsInvoked, tools: tools, skillsInvoked: skillsInvoked, executedStratusSkill: executedStratusSkill, responseSources: responseSources, usesJsm: usesJsm, invokedFrom: invokedFrom, conversationChannelId: conversationChannelId, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias, scenarioId: scenarioId, pageContext: pageContext, viewContext: viewContext, attributes: customAttributes } = payload;
        // source and subjectId are optional in the payload type but trackAI* functions require string.
        // The runtime value (including undefined) is intentionally passed through as-is.
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing analytics baseline: preserves the runtime value while satisfying a string-only downstream API type.
        const source = sourceUnknown;
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing analytics baseline: preserves the runtime value while satisfying a string-only downstream API type.
        const subjectId = subjectIdUnknown;
        const customAttributesRecord = customAttributes ?? {};
        const actionKey = payload.actionKey || customAttributesRecord.actionKey;
        const { [(0, $bSokK.AI_MATE_ATTRIBUTES).rovoJourneyId]: customRovoJourneyId, ...customAttributesWithoutRovoJourneyId } = customAttributesRecord;
        const contextRovoJourneyId = propertiesRef.current.rovoJourneyId;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            citedProductList: citedProductList,
            citedProduct: citedProduct,
            sourceProducts: sourceProducts,
            sourceProduct: sourceProduct,
            ...customAttributesWithoutRovoJourneyId,
            ...$c37674eadb1bbfbc$export$f30c856a07c48ee5(payload) && (customRovoJourneyId || contextRovoJourneyId) ? {
                [(0, $bSokK.AI_MATE_ATTRIBUTES).rovoJourneyId]: customRovoJourneyId ?? contextRovoJourneyId
            } : {},
            aiFeatureName: customAttributesRecord.aiFeatureName || 'aiChat'
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        else if ((payload.type === 'actioned' || payload.type === 'viewed' || payload.type === 'adopted') && typeof actionKey === 'string' && actionKey.length > 0 && (0, $llCao.fg)('cwr_ai_result_analytics_updates')) attributes.messageActions = [
            actionKey
        ];
        if (invokedFrom) attributes.invokedFrom = invokedFrom;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (pluginsInvoked) attributes.pluginsInvoked = pluginsInvoked;
        if (tools) attributes.tools = tools;
        if (skillsInvoked) attributes.skillsInvoked = skillsInvoked;
        if (executedStratusSkill !== undefined) attributes.executedStratusSkill = executedStratusSkill;
        if (responseSources) attributes.responseSources = responseSources;
        if (connectorInfo && (payload.type === 'actioned' ? (0, $llCao.fg)('rovo_chat_connector_info_analytics_on_click') : (0, $llCao.fg)('rovo_chat_connector_info_analytics'))) attributes.connectorInfo = connectorInfo;
        if (usesJsm !== undefined) attributes.usesJsm = usesJsm;
        if (deepResearchEnabled) attributes.deepResearchEnabled = deepResearchEnabled;
        if (fastModeEnabled) attributes.fastModeEnabled = fastModeEnabled;
        if (thinkDeeperEnabled) attributes.thinkDeeperEnabled = thinkDeeperEnabled;
        if (webSearchEnabled) attributes.webSearchEnabled = webSearchEnabled;
        if (conversationChannelId) attributes.conversationChannelId = conversationChannelId;
        if (assistanceServiceConfigMinionAlias) attributes.assistanceServiceConfigMinionAlias = assistanceServiceConfigMinionAlias;
        if (pageContext) attributes.pageContext = pageContext;
        if (scenarioId) attributes.scenarioId = scenarioId;
        if (viewContext) attributes.viewContext = viewContext;
        let libAttributes = {
            ...attributes,
            aiFeatureName: customAttributesRecord.aiFeatureName || 'aiChat',
            proactiveGeneratedAI: proactive ? 1 : 0
        };
        const launchSource = propertiesRef.current.launchSource;
        const launchSourceAttribute = launchSource ? {
            [(0, $bSokK.AI_MATE_ATTRIBUTES).launchSource]: launchSource
        } : {};
        switch(payload.type){
            case 'initiated':
                trackAIInteractionInit({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'viewed':
                trackAIResultView({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId,
                    doesNotMeetMAUCriteria: doesNotMeetMAUCriteria
                });
                break;
            case 'error':
                trackAIResultError({
                    aiErrorMessage: payload.errorMessage
                }, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'dismissed':
                trackAIInteractionDismiss({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'actioned':
                {
                    const actionedPayload = payload;
                    trackAIResultAction(actionedPayload.actionResult, {
                        attributes: {
                            ...libAttributes,
                            ...launchSourceAttribute
                        },
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
            case 'adopted':
                {
                    const adoptedPayload = payload;
                    trackAIResultAdopted(adoptedPayload.actionResult, {
                        attributes: {
                            ...libAttributes,
                            actionKey: adoptedPayload.actionKey,
                            rovoModifiedObjects: adoptedPayload.rovoModifiedObjects,
                            ...launchSourceAttribute
                        },
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
            case 'feedback':
                {
                    const feedbackPayload = payload;
                    trackAIFeedbackSubmit(feedbackPayload.feedbackResult, {
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
        }
    // Handle specific AI MAU events
    }, [
        getDefaultAttributes,
        propertiesRef,
        trackAIInteractionInit,
        trackAIResultView,
        trackAIResultError,
        trackAIInteractionDismiss,
        trackAIResultAction,
        trackAIResultAdopted,
        trackAIFeedbackSubmit
    ]);
    const sendAnalyticsEvent = (0, $fsvuC.useCallback)((payload, options)=>{
        const extraTags = options?.removeDefaultTags ? [] : $c37674eadb1bbfbc$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...'tags' in payload && Array.isArray(payload.tags) ? payload.tags : [],
            ...maybeAtlasOperationalTags(payload)
        ]));
        const defaultAttributes = getDefaultAttributes();
        // `UIAnalyticsEvent | undefined` because in SSR (no `<AnalyticsListener>`),
        // `createAnalyticsEvent` and `event.update(...)` may return `undefined` stubs.
        let eventToBeLoggedWithSentry;
        if ((0, $fg1VY.isUIAnalyticsEvent)(payload)) {
            const aiMateContextAttributes = (0, $iMo3a.getAttributesFromContexts)(payload.context);
            // `payload.update(...)` can return `undefined` for stub events in SSR / no-listener
            // contexts. Fall back to the original event and guard `.fire` with optional chaining.
            const updatedEvent = payload.update({
                ...payload.payload,
                tags: allTags,
                attributes: $c37674eadb1bbfbc$var$getRovoJourneyEventAttributes({
                    eventPayload: payload.payload ?? {},
                    attributes: {
                        ...defaultAttributes,
                        // `payload.payload` is typed as defined on a UIAnalyticsEvent, but during SSR
                        // (and other no-listener contexts) the underlying event can be a stub whose
                        // `payload` is `undefined`. Guard the spread so the subscriber does not throw
                        // `Cannot read properties of undefined (reading 'attributes')`.
                        ...payload.payload?.attributes ?? {},
                        ...aiMateContextAttributes
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            }) ?? payload;
            updatedEvent?.fire?.((0, $39dkK.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent;
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                tags: allTags,
                attributes: $c37674eadb1bbfbc$var$getRovoJourneyEventAttributes({
                    eventPayload: payload,
                    attributes: {
                        ...defaultAttributes,
                        ...payload.attributes
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            });
            if (!event) // In SSR / no-listener environments, `createAnalyticsEvent` can return `undefined`.
            // Nothing to fire or log.
            return;
            const aiMateContextAttributes = (0, $iMo3a.getAttributesFromContexts)(event.context);
            // `event.update(...)` can return `undefined` for stub events in SSR / no-listener
            // contexts (previously crashed with `Cannot read properties of undefined (reading
            // 'fire')`). Fall back to the original event and guard `.fire` with optional chaining.
            const updatedEvent = event.update({
                attributes: $c37674eadb1bbfbc$var$getRovoJourneyEventAttributes({
                    eventPayload: event.payload ?? payload,
                    attributes: {
                        // `event.payload` is normally defined when `createAnalyticsEvent` is wired up
                        // via `<AnalyticsListener>`, but in SSR (where no listener is mounted) the
                        // returned event can be a stub whose `payload` is `undefined`. Spreading
                        // without a guard previously crashed the ExperienceTracker subscriber with
                        // `Cannot read properties of undefined (reading 'attributes')`.
                        ...event.payload?.attributes ?? {},
                        ...aiMateContextAttributes
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            }) ?? event;
            updatedEvent?.fire?.((0, $39dkK.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent;
        }
        if (eventToBeLoggedWithSentry && eventToBeLoggedWithSentry.payload?.eventType !== 'operational') // choosing to log the event with Sentry if it is not an operational event to prevent noise in Sentry and not eat up the Sentry quota
        (0, $2pSN0.addSentryBreadcrumb)($c37674eadb1bbfbc$var$getSentryAnalyticsBreadcrumb(eventToBeLoggedWithSentry));
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes,
        propertiesRef
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        mode: mode
    };
};

});
parcelRegister("jHM2h", function(module, exports) {
$parcel$export(module.exports, "useAIEventsInstrumentation", () => $6f1191d62a5e2642$export$ddf49ad062368ad2);

var $fsvuC = parcelRequire("fsvuC");

var $2iM9p = parcelRequire("2iM9p");

var $9fEYx = parcelRequire("9fEYx");

var $mhEfz = parcelRequire("mhEfz");

var $kcJfc = parcelRequire("kcJfc");

var $9Wu9c = parcelRequire("9Wu9c");

var $gLTbG = parcelRequire("gLTbG");

var $kJXzT = parcelRequire("kJXzT");

var $7KJod = parcelRequire("7KJod");
const $6f1191d62a5e2642$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $fsvuC.useContext)((0, $kcJfc.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $fsvuC.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $9Wu9c.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $7KJod.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, aiFeatureId: aiFeatureId, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $fsvuC.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $2iM9p.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $kJXzT.AISessionState).unset,
            nextState: (0, $2iM9p.P).union((0, $kJXzT.AISessionState).viewed, (0, $kJXzT.AISessionState).error, (0, $kJXzT.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $kJXzT.AISessionState).initiated,
            nextState: (0, $2iM9p.P).union((0, $kJXzT.AISessionState).submitted, (0, $kJXzT.AISessionState).actioned, (0, $kJXzT.AISessionState).adopted, (0, $kJXzT.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $fsvuC.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $9fEYx.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $fsvuC.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                aiFeatureId: aiFeatureId,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $2iM9p.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $gLTbG.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $2iM9p.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $2iM9p.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        aiFeatureId,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $fsvuC.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $kJXzT.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $fsvuC.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $kJXzT.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $fsvuC.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $kJXzT.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $fsvuC.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $kJXzT.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $fsvuC.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $kJXzT.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $fsvuC.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $kJXzT.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $fsvuC.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $kJXzT.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $fsvuC.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $kJXzT.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $fsvuC.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    const baseReturn = {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
    return $6f1191d62a5e2642$var$useStableMethods(baseReturn);
};
/**
 * Returns an object with the same shape as `methods`, but with every method
 * replaced by a stable wrapper that delegates to the latest version. The
 * wrappers are created once on mount; they always read the freshest closure
 * via a ref, so calls observe the same behaviour as calling the unstable
 * methods directly.
 */ function $6f1191d62a5e2642$var$useStableMethods(methods) {
    const ref = (0, $fsvuC.useRef)(methods);
    ref.current = methods;
    return (0, $fsvuC.useMemo)(()=>{
        const out = {};
        for (const key of Object.keys(ref.current))out[key] = (...args)=>ref.current[key](...args);
        return out;
    // Wrappers always read from `ref.current`; no deps needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});
parcelRegister("2iM9p", function(module, exports) {
$parcel$export(module.exports, "P", () => $1ad29cf93cb6abdb$export$56c0d5a1e737357d);
$parcel$export(module.exports, "match", () => $1ad29cf93cb6abdb$export$4659b591c19bdf3d);
const $1ad29cf93cb6abdb$var$t = Symbol.for("@ts-pattern/matcher"), $1ad29cf93cb6abdb$var$e = Symbol.for("@ts-pattern/isVariadic"), $1ad29cf93cb6abdb$var$n = "@ts-pattern/anonymous-select-key", $1ad29cf93cb6abdb$var$r = (t)=>Boolean(t && "object" == typeof t), $1ad29cf93cb6abdb$var$i = (e)=>e && !!e[$1ad29cf93cb6abdb$var$t], $1ad29cf93cb6abdb$var$o = (n, s, c)=>{
    if ($1ad29cf93cb6abdb$var$i(n)) {
        const e = n[$1ad29cf93cb6abdb$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($1ad29cf93cb6abdb$var$r(n)) {
        if (!$1ad29cf93cb6abdb$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $1ad29cf93cb6abdb$var$i(s) && s[$1ad29cf93cb6abdb$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$1ad29cf93cb6abdb$var$o(t, e[n], c)) && r.every((t, e)=>$1ad29cf93cb6abdb$var$o(t, n[e], c)) && (0 === a.length || $1ad29cf93cb6abdb$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$1ad29cf93cb6abdb$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $1ad29cf93cb6abdb$var$i(a = r) && "optional" === a[$1ad29cf93cb6abdb$var$t]().matcherType) && $1ad29cf93cb6abdb$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $1ad29cf93cb6abdb$var$s = (e)=>{
    var n, o, a;
    return $1ad29cf93cb6abdb$var$r(e) ? $1ad29cf93cb6abdb$var$i(e) ? null != (n = null == (o = (a = e[$1ad29cf93cb6abdb$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $1ad29cf93cb6abdb$var$c(e, $1ad29cf93cb6abdb$var$s) : $1ad29cf93cb6abdb$var$c(Object.values(e), $1ad29cf93cb6abdb$var$s) : [];
}, $1ad29cf93cb6abdb$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $1ad29cf93cb6abdb$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$1ad29cf93cb6abdb$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $1ad29cf93cb6abdb$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $1ad29cf93cb6abdb$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$1ad29cf93cb6abdb$var$l(t),
        and: (e)=>$1ad29cf93cb6abdb$var$m(t, e),
        or: (e)=>$1ad29cf93cb6abdb$var$d(t, e),
        select: (e)=>void 0 === e ? $1ad29cf93cb6abdb$var$y(t) : $1ad29cf93cb6abdb$var$y(e, t)
    });
}
function $1ad29cf93cb6abdb$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$1ad29cf93cb6abdb$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$1ad29cf93cb6abdb$var$h($1ad29cf93cb6abdb$var$l(t)),
        select: (e)=>$1ad29cf93cb6abdb$var$h(void 0 === e ? $1ad29cf93cb6abdb$var$y(t) : $1ad29cf93cb6abdb$var$y(e, t))
    });
}
function $1ad29cf93cb6abdb$var$l(e) {
    return $1ad29cf93cb6abdb$var$u({
        [$1ad29cf93cb6abdb$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($1ad29cf93cb6abdb$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $1ad29cf93cb6abdb$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$1ad29cf93cb6abdb$var$s(e),
                matcherType: "optional"
            })
    });
}
const $1ad29cf93cb6abdb$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $1ad29cf93cb6abdb$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $1ad29cf93cb6abdb$var$m(...e) {
    return $1ad29cf93cb6abdb$var$u({
        [$1ad29cf93cb6abdb$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$1ad29cf93cb6abdb$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$1ad29cf93cb6abdb$var$c(e, $1ad29cf93cb6abdb$var$s),
                matcherType: "and"
            })
    });
}
function $1ad29cf93cb6abdb$var$d(...e) {
    return $1ad29cf93cb6abdb$var$u({
        [$1ad29cf93cb6abdb$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $1ad29cf93cb6abdb$var$c(e, $1ad29cf93cb6abdb$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$1ad29cf93cb6abdb$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$1ad29cf93cb6abdb$var$c(e, $1ad29cf93cb6abdb$var$s),
                matcherType: "or"
            })
    });
}
function $1ad29cf93cb6abdb$var$p(e) {
    return {
        [$1ad29cf93cb6abdb$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $1ad29cf93cb6abdb$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $1ad29cf93cb6abdb$var$u({
        [$1ad29cf93cb6abdb$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $1ad29cf93cb6abdb$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $1ad29cf93cb6abdb$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $1ad29cf93cb6abdb$var$n
                    ].concat(void 0 === i ? [] : $1ad29cf93cb6abdb$var$s(i))
            })
    });
}
function $1ad29cf93cb6abdb$var$v(t) {
    return "number" == typeof t;
}
function $1ad29cf93cb6abdb$var$b(t) {
    return "string" == typeof t;
}
function $1ad29cf93cb6abdb$var$w(t) {
    return "bigint" == typeof t;
}
const $1ad29cf93cb6abdb$var$S = $1ad29cf93cb6abdb$var$u($1ad29cf93cb6abdb$var$p(function(t) {
    return !0;
})), $1ad29cf93cb6abdb$var$O = $1ad29cf93cb6abdb$var$S, $1ad29cf93cb6abdb$var$j = (t)=>Object.assign($1ad29cf93cb6abdb$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $1ad29cf93cb6abdb$var$j($1ad29cf93cb6abdb$var$m(t, (n = e, $1ad29cf93cb6abdb$var$p((t)=>$1ad29cf93cb6abdb$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $1ad29cf93cb6abdb$var$j($1ad29cf93cb6abdb$var$m(t, (n = e, $1ad29cf93cb6abdb$var$p((t)=>$1ad29cf93cb6abdb$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$1ad29cf93cb6abdb$var$j($1ad29cf93cb6abdb$var$m(t, ((t)=>$1ad29cf93cb6abdb$var$p((e)=>$1ad29cf93cb6abdb$var$b(e) && e.length >= t))(e))),
        length: (e)=>$1ad29cf93cb6abdb$var$j($1ad29cf93cb6abdb$var$m(t, ((t)=>$1ad29cf93cb6abdb$var$p((e)=>$1ad29cf93cb6abdb$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$1ad29cf93cb6abdb$var$j($1ad29cf93cb6abdb$var$m(t, ((t)=>$1ad29cf93cb6abdb$var$p((e)=>$1ad29cf93cb6abdb$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $1ad29cf93cb6abdb$var$j($1ad29cf93cb6abdb$var$m(t, (n = e, $1ad29cf93cb6abdb$var$p((t)=>$1ad29cf93cb6abdb$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $1ad29cf93cb6abdb$var$j($1ad29cf93cb6abdb$var$m(t, (n = e, $1ad29cf93cb6abdb$var$p((t)=>$1ad29cf93cb6abdb$var$b(t) && Boolean(t.match(n))))));
        }
    }), $1ad29cf93cb6abdb$var$K = $1ad29cf93cb6abdb$var$j($1ad29cf93cb6abdb$var$p($1ad29cf93cb6abdb$var$b)), $1ad29cf93cb6abdb$var$x = (t)=>Object.assign($1ad29cf93cb6abdb$var$u(t), {
        between: (e, n)=>$1ad29cf93cb6abdb$var$x($1ad29cf93cb6abdb$var$m(t, ((t, e)=>$1ad29cf93cb6abdb$var$p((n)=>$1ad29cf93cb6abdb$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$1ad29cf93cb6abdb$var$x($1ad29cf93cb6abdb$var$m(t, ((t)=>$1ad29cf93cb6abdb$var$p((e)=>$1ad29cf93cb6abdb$var$v(e) && e < t))(e))),
        gt: (e)=>$1ad29cf93cb6abdb$var$x($1ad29cf93cb6abdb$var$m(t, ((t)=>$1ad29cf93cb6abdb$var$p((e)=>$1ad29cf93cb6abdb$var$v(e) && e > t))(e))),
        lte: (e)=>$1ad29cf93cb6abdb$var$x($1ad29cf93cb6abdb$var$m(t, ((t)=>$1ad29cf93cb6abdb$var$p((e)=>$1ad29cf93cb6abdb$var$v(e) && e <= t))(e))),
        gte: (e)=>$1ad29cf93cb6abdb$var$x($1ad29cf93cb6abdb$var$m(t, ((t)=>$1ad29cf93cb6abdb$var$p((e)=>$1ad29cf93cb6abdb$var$v(e) && e >= t))(e))),
        int: ()=>$1ad29cf93cb6abdb$var$x($1ad29cf93cb6abdb$var$m(t, $1ad29cf93cb6abdb$var$p((t)=>$1ad29cf93cb6abdb$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$1ad29cf93cb6abdb$var$x($1ad29cf93cb6abdb$var$m(t, $1ad29cf93cb6abdb$var$p((t)=>$1ad29cf93cb6abdb$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$1ad29cf93cb6abdb$var$x($1ad29cf93cb6abdb$var$m(t, $1ad29cf93cb6abdb$var$p((t)=>$1ad29cf93cb6abdb$var$v(t) && t > 0))),
        negative: ()=>$1ad29cf93cb6abdb$var$x($1ad29cf93cb6abdb$var$m(t, $1ad29cf93cb6abdb$var$p((t)=>$1ad29cf93cb6abdb$var$v(t) && t < 0)))
    }), $1ad29cf93cb6abdb$var$E = $1ad29cf93cb6abdb$var$x($1ad29cf93cb6abdb$var$p($1ad29cf93cb6abdb$var$v)), $1ad29cf93cb6abdb$var$A = (t)=>Object.assign($1ad29cf93cb6abdb$var$u(t), {
        between: (e, n)=>$1ad29cf93cb6abdb$var$A($1ad29cf93cb6abdb$var$m(t, ((t, e)=>$1ad29cf93cb6abdb$var$p((n)=>$1ad29cf93cb6abdb$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$1ad29cf93cb6abdb$var$A($1ad29cf93cb6abdb$var$m(t, ((t)=>$1ad29cf93cb6abdb$var$p((e)=>$1ad29cf93cb6abdb$var$w(e) && e < t))(e))),
        gt: (e)=>$1ad29cf93cb6abdb$var$A($1ad29cf93cb6abdb$var$m(t, ((t)=>$1ad29cf93cb6abdb$var$p((e)=>$1ad29cf93cb6abdb$var$w(e) && e > t))(e))),
        lte: (e)=>$1ad29cf93cb6abdb$var$A($1ad29cf93cb6abdb$var$m(t, ((t)=>$1ad29cf93cb6abdb$var$p((e)=>$1ad29cf93cb6abdb$var$w(e) && e <= t))(e))),
        gte: (e)=>$1ad29cf93cb6abdb$var$A($1ad29cf93cb6abdb$var$m(t, ((t)=>$1ad29cf93cb6abdb$var$p((e)=>$1ad29cf93cb6abdb$var$w(e) && e >= t))(e))),
        positive: ()=>$1ad29cf93cb6abdb$var$A($1ad29cf93cb6abdb$var$m(t, $1ad29cf93cb6abdb$var$p((t)=>$1ad29cf93cb6abdb$var$w(t) && t > 0))),
        negative: ()=>$1ad29cf93cb6abdb$var$A($1ad29cf93cb6abdb$var$m(t, $1ad29cf93cb6abdb$var$p((t)=>$1ad29cf93cb6abdb$var$w(t) && t < 0)))
    }), $1ad29cf93cb6abdb$var$P = $1ad29cf93cb6abdb$var$A($1ad29cf93cb6abdb$var$p($1ad29cf93cb6abdb$var$w)), $1ad29cf93cb6abdb$var$T = $1ad29cf93cb6abdb$var$u($1ad29cf93cb6abdb$var$p(function(t) {
    return "boolean" == typeof t;
})), $1ad29cf93cb6abdb$var$B = $1ad29cf93cb6abdb$var$u($1ad29cf93cb6abdb$var$p(function(t) {
    return "symbol" == typeof t;
})), $1ad29cf93cb6abdb$var$_ = $1ad29cf93cb6abdb$var$u($1ad29cf93cb6abdb$var$p(function(t) {
    return null == t;
})), $1ad29cf93cb6abdb$var$k = $1ad29cf93cb6abdb$var$u($1ad29cf93cb6abdb$var$p(function(t) {
    return null != t;
}));
var $1ad29cf93cb6abdb$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $1ad29cf93cb6abdb$var$t,
    optional: $1ad29cf93cb6abdb$var$l,
    array: function(...e) {
        return $1ad29cf93cb6abdb$var$h({
            [$1ad29cf93cb6abdb$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $1ad29cf93cb6abdb$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$1ad29cf93cb6abdb$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $1ad29cf93cb6abdb$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $1ad29cf93cb6abdb$var$u({
            [$1ad29cf93cb6abdb$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $1ad29cf93cb6abdb$var$f(t, (t)=>$1ad29cf93cb6abdb$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $1ad29cf93cb6abdb$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $1ad29cf93cb6abdb$var$u({
            [$1ad29cf93cb6abdb$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $1ad29cf93cb6abdb$var$g(t, (t, e)=>{
                                const n = $1ad29cf93cb6abdb$var$o(s, e, r), i = $1ad29cf93cb6abdb$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$1ad29cf93cb6abdb$var$s(e[0]),
                            ...$1ad29cf93cb6abdb$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $1ad29cf93cb6abdb$var$m,
    union: $1ad29cf93cb6abdb$var$d,
    not: function(e) {
        return $1ad29cf93cb6abdb$var$u({
            [$1ad29cf93cb6abdb$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$1ad29cf93cb6abdb$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $1ad29cf93cb6abdb$var$p,
    select: $1ad29cf93cb6abdb$var$y,
    any: $1ad29cf93cb6abdb$var$S,
    _: $1ad29cf93cb6abdb$var$O,
    string: $1ad29cf93cb6abdb$var$K,
    number: $1ad29cf93cb6abdb$var$E,
    bigint: $1ad29cf93cb6abdb$var$P,
    boolean: $1ad29cf93cb6abdb$var$T,
    symbol: $1ad29cf93cb6abdb$var$B,
    nullish: $1ad29cf93cb6abdb$var$_,
    nonNullable: $1ad29cf93cb6abdb$var$k,
    instanceOf: function(t) {
        return $1ad29cf93cb6abdb$var$u($1ad29cf93cb6abdb$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $1ad29cf93cb6abdb$var$u($1ad29cf93cb6abdb$var$p($1ad29cf93cb6abdb$export$ce1e7a33533a73d9(t)));
    }
};
class $1ad29cf93cb6abdb$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $1ad29cf93cb6abdb$var$$ = {
    matched: !1,
    value: void 0
};
function $1ad29cf93cb6abdb$export$4659b591c19bdf3d(t) {
    return new $1ad29cf93cb6abdb$var$I(t, $1ad29cf93cb6abdb$var$$);
}
class $1ad29cf93cb6abdb$var$I {
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$1ad29cf93cb6abdb$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $1ad29cf93cb6abdb$var$$ : {
            matched: !0,
            value: e(s ? $1ad29cf93cb6abdb$var$n in c ? c[$1ad29cf93cb6abdb$var$n] : c : this.input, this.input)
        };
        return new $1ad29cf93cb6abdb$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $1ad29cf93cb6abdb$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $1ad29cf93cb6abdb$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $1ad29cf93cb6abdb$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
}
function $1ad29cf93cb6abdb$var$L(t) {
    throw new $1ad29cf93cb6abdb$export$6c1467edb54d3773(t);
}

});

parcelRegister("kcJfc", function(module, exports) {
$parcel$export(module.exports, "AIEventsInstrumentationContext", () => $c08cb176e60f22b3$export$4f059feb37b5835e);

var $fsvuC = parcelRequire("fsvuC");
const $c08cb176e60f22b3$export$4f059feb37b5835e = (0, $fsvuC.createContext)(null);

});

parcelRegister("9Wu9c", function(module, exports) {
$parcel$export(module.exports, "defaultAIEventsInstrumentationConfigValues", () => $bbdc1805556426f3$export$5013b36eeed4ec19);

var $kJXzT = parcelRequire("kJXzT");
const $bbdc1805556426f3$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $kJXzT.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};

});
parcelRegister("kJXzT", function(module, exports) {
$parcel$export(module.exports, "AISessionState", () => $c5bc9e283d99ab1e$export$af92e0e920a45719);
$parcel$export(module.exports, "EventDispatcherSources", () => $c5bc9e283d99ab1e$export$7052d5b66e36f60f);
var $c5bc9e283d99ab1e$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $c5bc9e283d99ab1e$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});

});


parcelRegister("gLTbG", function(module, exports) {
$parcel$export(module.exports, "getTagsWithPlatformTag", () => $a521c39d960e794a$export$e053e424fcbfebe9);
const $a521c39d960e794a$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};

});

parcelRegister("7KJod", function(module, exports) {
$parcel$export(module.exports, "useAIInstrumentationSetup", () => $7b29fa7e72b88a5d$export$259576f4e7ac6488);

var $fsvuC = parcelRequire("fsvuC");

var $4PMGJ = parcelRequire("4PMGJ");

var $9ad1m = parcelRequire("9ad1m");

var $kJXzT = parcelRequire("kJXzT");
const $7b29fa7e72b88a5d$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $fsvuC.useRef)(undefined);
    const aiSessionStateRef = (0, $fsvuC.useRef)((0, $kJXzT.AISessionState).unset);
    const setAISessionState = (0, $fsvuC.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $fsvuC.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $fsvuC.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $4PMGJ.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $9ad1m.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $fsvuC.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $9ad1m.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};

});
parcelRegister("4PMGJ", function(module, exports) {
$parcel$export(module.exports, "getNewSingleInstrumentationID", () => $c7e4eb809a4eabe7$export$cee2a1482be61648);

var $2iM9p = parcelRequire("2iM9p");

var $17hIO = parcelRequire("17hIO");
function $c7e4eb809a4eabe7$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $2iM9p.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $2iM9p.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $2iM9p.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, $17hIO.default)());
}

});

parcelRegister("9ad1m", function(module, exports) {
$parcel$export(module.exports, "setSingleInstrumentationIDCookie", () => $46c2e98a8a5926b2$export$9a4eaf99327c19fe);
$parcel$export(module.exports, "readSingleInstrumentationIDCookie", () => $46c2e98a8a5926b2$export$d6fb1caea334c7c7);

var $cJ9lp = parcelRequire("cJ9lp");
var $dQF4W = parcelRequire("dQF4W");
const $46c2e98a8a5926b2$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $46c2e98a8a5926b2$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $46c2e98a8a5926b2$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $dQF4W.setCookie)($46c2e98a8a5926b2$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $46c2e98a8a5926b2$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $cJ9lp.getCookie)($46c2e98a8a5926b2$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $46c2e98a8a5926b2$export$72d8c154d3f75075;

});
parcelRegister("dQF4W", function(module, exports) {
$parcel$export(module.exports, "setCookie", () => $783d458db1965398$export$110700823644f4a6);

var $k3O8N = parcelRequire("k3O8N");

var $llCao = parcelRequire("llCao");

var $4kM1J = parcelRequire("4kM1J");
var $52k2b = parcelRequire("52k2b");

var $5PWEB = parcelRequire("5PWEB");

var $2yNBb = parcelRequire("2yNBb");

var $hw3pG = parcelRequire("hw3pG");
const $783d458db1965398$export$110700823644f4a6 = async (key, value, attributes)=>{
    if ((0, $llCao.fg)('platform_moonjelly_bsc_master_killswitch')) {
        // Set the cookie without checking user preferences when master killswitch is enabled.
        // Emit analytics so we can quantify how often the killswitch path is taken per product
        if ((0, $llCao.fg)('platform_bsc_consent_bypass_analytics')) (0, $52k2b.sendPackageOperationalEvent)({
            action: 'usedSetCookieMasterKillswitch',
            attributes: {
                cookieKey: key,
                product: (0, $4kM1J.getBscGlobalState)().product
            }
        });
        (0, $k3O8N.default).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
        return (0, $hw3pG.Status).SUCCESS;
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    const productName = (0, $4kM1J.getBscGlobalState)().product;
    const wasInitialized = (0, $4kM1J.getBscGlobalState)().hasInitialized;
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    let blockedCookieItemCategory;
    const shouldSetCookie = await (0, $5PWEB.isProcessingAllowedByPreferences)({
        itemKey: key,
        storageType: (0, $hw3pG.CategoryStorageType).Cookies,
        productName: productName,
        blockedCallback: ({ itemCategory: itemCategory })=>{
            blockedCookieItemCategory = itemCategory;
        }
    });
    const eventAttributes = {
        wasRejected: !shouldSetCookie,
        cookieKey: key
    };
    try {
        (0, $52k2b.sendPackageOperationalEvent)({
            action: 'usedSetCookie',
            attributes: eventAttributes
        });
        if (!wasInitialized) (0, $52k2b.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: 'Cookie'
            }
        });
        if (shouldSetCookie) {
            (0, $k3O8N.default).set(key, value, {
                ...attributes,
                'atl-set-cookie': true
            });
            return (0, $hw3pG.Status).SUCCESS;
        } else {
            if (blockedCookieItemCategory === null) (0, $2yNBb.Logger).warn(`setCookie('${key}', ...) was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${key}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
            return (0, $hw3pG.Status).BLOCKED;
        }
    } catch (e) {
        (0, $2yNBb.Logger).errorWithOperationalEvent({
            action: 'usedSetCookieError',
            attributes: eventAttributes,
            message: `Failed to use set cookie. ${e.message || ''}`
        });
        throw e;
    }
};

});
parcelRegister("5PWEB", function(module, exports) {
$parcel$export(module.exports, "getItemCategoryFromPassedCache", () => $6926ebbd7787cbce$export$69d5b68d01f4a366);
$parcel$export(module.exports, "getItemCategory", () => $6926ebbd7787cbce$export$ec8ce5237293e4a4);
$parcel$export(module.exports, "isPromise", () => $6926ebbd7787cbce$export$4369c812aac99591);
$parcel$export(module.exports, "isProcessingAllowedByPreferencesMaybeSync", () => $6926ebbd7787cbce$export$ffbb879d3fefb45c);
$parcel$export(module.exports, "isProcessingAllowedByPreferences", () => $6926ebbd7787cbce$export$e7a3dca206fec6e2);
$parcel$export(module.exports, "isProcessingAllowedByPreferencesWithCategory", () => $6926ebbd7787cbce$export$17e4a7e00d5b99d9);

var $llCao = parcelRequire("llCao");

var $dBSj0 = parcelRequire("dBSj0");

var $hw3pG = parcelRequire("hw3pG");

var $52k2b = parcelRequire("52k2b");

var $4kM1J = parcelRequire("4kM1J");

var $7dgho = parcelRequire("7dgho");

var $2yNBb = parcelRequire("2yNBb");
/**
 * Narrows a payload to the layout it declares, so the matchers below can be type-checked against a
 * concrete pattern shape rather than casting.
 *
 * An absent `patternFormat` means the legacy trie layout — the format the CDN serves while the
 * flat-format gate is off, and what a payload fetched by a consumer that predates COOK-632 will be.
 * TypeScript cannot infer that rule, so this is the one place it is asserted.
 */ const $6926ebbd7787cbce$var$asConcreteCache = (storageControlsData)=>storageControlsData.patternFormat === 'flat' ? storageControlsData : storageControlsData;
/**
 * WeakMap cache for precompiled RegExp objects, keyed by the raw regExp product map.
 * This ensures RegExp strings are compiled at most once per unique cache object.
 */ const $6926ebbd7787cbce$var$compiledRegExpCache = new WeakMap();
const $6926ebbd7787cbce$var$compileRegExpPatterns = (rawPatterns)=>{
    if ($6926ebbd7787cbce$var$compiledRegExpCache.has(rawPatterns)) return $6926ebbd7787cbce$var$compiledRegExpCache.get(rawPatterns);
    const compiled = [];
    for (const [regexString, category] of Object.entries(rawPatterns))try {
        compiled.push({
            regexp: new RegExp(regexString),
            category: category
        });
    } catch (e) {
        (0, $2yNBb.Logger).warn(`BSC: Invalid RegExp pattern "${regexString}" in storage controls cache \u{2014} skipping.`);
    }
    $6926ebbd7787cbce$var$compiledRegExpCache.set(rawPatterns, compiled);
    return compiled;
};
const $6926ebbd7787cbce$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $6926ebbd7787cbce$export$81a82818a800a999 = (itemKey, compiledPatterns)=>{
    for (const { regexp: regexp, category: category } of compiledPatterns){
        if (regexp.test(itemKey)) return category;
    }
    return null;
};
const $6926ebbd7787cbce$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $6926ebbd7787cbce$export$915dea35caff63c = (itemKey, startsWith)=>{
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) return startsWith[prefix];
    }
    return null;
};
const $6926ebbd7787cbce$export$4381be1b9fd38456 = (itemKey, startsWith)=>{
    let best = null;
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) {
            if (best === null || prefix.length > best.length) best = {
                category: startsWith[prefix],
                length: prefix.length
            };
        }
    }
    return best;
};
const $6926ebbd7787cbce$export$495f1917e0bfb98c = (itemKey, endsWith)=>{
    let best = null;
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) {
            if (best === null || suffix.length > best.length) best = {
                category: endsWith[suffix],
                length: suffix.length
            };
        }
    }
    return best;
};
const $6926ebbd7787cbce$export$f6f7882079c4a2cb = (itemKey, endsWith)=>{
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) return endsWith[suffix];
    }
    return null;
};
const $6926ebbd7787cbce$var$hasOwn = (map, key)=>map !== undefined && Object.prototype.hasOwnProperty.call(map, key);
/**
 * Picks the longer of a product and an 'all' pattern match. A tie can only be the same pattern in
 * both maps (two distinct prefixes or suffixes of equal length cannot both match one key), and the
 * product entry wins it — the value a merge of the two maps would have produced.
 */ const $6926ebbd7787cbce$var$pickLongerMatch = (productMatch, allMatch)=>{
    if (productMatch === null) return allMatch;
    if (allMatch === null || productMatch.length >= allMatch.length) return productMatch;
    return allMatch;
};
/**
 * Resolves an item key's category number from a flat payload without merging the 'all' and
 * product maps. Merging allocated four objects per lookup, and the merged regexp object was new
 * every call so `compiledRegExpCache` never hit. Each stage checks the product map before 'all',
 * matching the precedence of the legacy trie path.
 */ const $6926ebbd7787cbce$var$findFlatItemCategoryNumber = (itemKey, cache, product)=>{
    const { keys: keys, patterns: patterns } = cache;
    const productKeys = product ? keys[product] : undefined;
    if ($6926ebbd7787cbce$var$hasOwn(productKeys, itemKey)) return productKeys[itemKey];
    const allKeys = keys['all'];
    if ($6926ebbd7787cbce$var$hasOwn(allKeys, itemKey)) return allKeys[itemKey];
    const productStartsWith = product ? patterns.startsWith[product] : undefined;
    const allStartsWith = patterns.startsWith['all'];
    const productEndsWith = product ? patterns.endsWith[product] : undefined;
    const allEndsWith = patterns.endsWith['all'];
    if ((0, $llCao.fg)('platform_bsc_longest_pattern_match_wins')) {
        const swMatch = $6926ebbd7787cbce$var$pickLongerMatch(productStartsWith ? $6926ebbd7787cbce$export$4381be1b9fd38456(itemKey, productStartsWith) : null, allStartsWith ? $6926ebbd7787cbce$export$4381be1b9fd38456(itemKey, allStartsWith) : null);
        if (swMatch !== null) return swMatch.category;
        const ewMatch = $6926ebbd7787cbce$var$pickLongerMatch(productEndsWith ? $6926ebbd7787cbce$export$495f1917e0bfb98c(itemKey, productEndsWith) : null, allEndsWith ? $6926ebbd7787cbce$export$495f1917e0bfb98c(itemKey, allEndsWith) : null);
        if (ewMatch !== null) return ewMatch.category;
    } else {
        // Compare against null, not truthiness: category 0 (strictly necessary) is a valid match.
        if (productStartsWith) {
            const match = $6926ebbd7787cbce$export$915dea35caff63c(itemKey, productStartsWith);
            if (match !== null) return match;
        }
        if (allStartsWith) {
            const match = $6926ebbd7787cbce$export$915dea35caff63c(itemKey, allStartsWith);
            if (match !== null) return match;
        }
        if (productEndsWith) {
            const match = $6926ebbd7787cbce$export$f6f7882079c4a2cb(itemKey, productEndsWith);
            if (match !== null) return match;
        }
        if (allEndsWith) {
            const match = $6926ebbd7787cbce$export$f6f7882079c4a2cb(itemKey, allEndsWith);
            if (match !== null) return match;
        }
    }
    // The payload's own regexp maps are stable objects, so the WeakMap compile cache hits.
    const productRegExp = product ? patterns.regexp?.[product] : undefined;
    if (productRegExp) {
        const match = $6926ebbd7787cbce$export$81a82818a800a999(itemKey, $6926ebbd7787cbce$var$compileRegExpPatterns(productRegExp));
        if (match !== null) return match;
    }
    const allRegExp = patterns.regexp?.['all'];
    if (allRegExp) return $6926ebbd7787cbce$export$81a82818a800a999(itemKey, $6926ebbd7787cbce$var$compileRegExpPatterns(allRegExp));
    return null;
};
/**
 * A matcher can hand back a value that is not a category number when the payload's shape does
 * not match the matcher in use, so the lookup misses. Coalesce that miss to `null` to honour
 * the declared `PreferenceCategory | null` return type; callers treat `null` as uncategorized.
 */ const $6926ebbd7787cbce$var$toPreferenceCategory = (itemCategoryNumber, categories)=>{
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $hw3pG.PreferenceCategory).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $hw3pG.PreferenceCategory).Functional,
        [categories.ANALYTICS]: (0, $hw3pG.PreferenceCategory).Analytics,
        [categories.MARKETING]: (0, $hw3pG.PreferenceCategory).Marketing,
        [categories.UNKNOWN]: (0, $hw3pG.PreferenceCategory).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] ?? null : null;
};
const $6926ebbd7787cbce$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName?.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    // The payload states its own format, recorded when it was fetched. Re-evaluating the flat-format
    // rollout gate here could disagree with the gate value that chose the file we actually fetched — an
    // unresolved Statsig client, a stale cross-request SSR cache entry, or a gate flip mid-session — and
    // the losing matcher silently returns null for every pattern rather than erroring. The gate stays
    // the sole input to the *fetch* decision.
    const cache = $6926ebbd7787cbce$var$asConcreteCache(storageControlsData);
    if (cache.patternFormat === 'flat' && (0, $llCao.fg)('platform_bsc_flat_lookup_skip_merge')) return $6926ebbd7787cbce$var$toPreferenceCategory($6926ebbd7787cbce$var$findFlatItemCategoryNumber(itemKey, cache, downcasedProduct), categories);
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else if (cache.patternFormat === 'flat') {
        // Flat prefix/suffix maps merge cleanly, because each key is a whole pattern rather than one
        // character of one.
        const productStartsWithPatterns = {
            ...cache.patterns.startsWith['all'],
            ...downcasedProduct ? cache.patterns.startsWith[downcasedProduct] : {}
        };
        const productEndsWithPatterns = {
            ...cache.patterns.endsWith['all'],
            ...downcasedProduct ? cache.patterns.endsWith[downcasedProduct] : {}
        };
        if ((0, $llCao.fg)('platform_bsc_longest_pattern_match_wins')) {
            // Longest-match-wins flat path
            const swMatch = $6926ebbd7787cbce$export$4381be1b9fd38456(itemKey, productStartsWithPatterns);
            if (swMatch !== null) itemCategoryNumber = swMatch.category;
            else {
                const ewMatch = $6926ebbd7787cbce$export$495f1917e0bfb98c(itemKey, productEndsWithPatterns);
                if (ewMatch !== null) itemCategoryNumber = ewMatch.category;
            }
        } else {
            // First-match flat path (COOK-435)
            itemCategoryNumber = $6926ebbd7787cbce$export$915dea35caff63c(itemKey, productStartsWithPatterns);
            if (itemCategoryNumber === null) itemCategoryNumber = $6926ebbd7787cbce$export$f6f7882079c4a2cb(itemKey, productEndsWithPatterns);
        }
    } else {
        // Legacy trie matching path. We search the product trie first and fall back
        // to the 'all' trie; a merged trie is unsafe because a shared first character
        // silently drops the entire 'all' subtree under it (HOT-303432).
        const productStartsWith = downcasedProduct ? cache.patterns.startsWith[downcasedProduct] : undefined;
        const productEndsWith = downcasedProduct ? cache.patterns.endsWith[downcasedProduct] : undefined;
        const allStartsWith = cache.patterns.startsWith['all'];
        const allEndsWith = cache.patterns.endsWith['all'];
        if (productStartsWith) itemCategoryNumber = $6926ebbd7787cbce$export$2c141b1c00f3e482(itemKey, productStartsWith);
        if (itemCategoryNumber === null && allStartsWith) itemCategoryNumber = $6926ebbd7787cbce$export$2c141b1c00f3e482(itemKey, allStartsWith);
        if (itemCategoryNumber === null && productEndsWith) itemCategoryNumber = $6926ebbd7787cbce$export$c4a1dd71bbd8954c(itemKey, productEndsWith);
        if (itemCategoryNumber === null && allEndsWith) itemCategoryNumber = $6926ebbd7787cbce$export$c4a1dd71bbd8954c(itemKey, allEndsWith);
    }
    // RegExp fallback, applied to both the flat and legacy trie pattern paths
    if (itemCategoryNumber === null) {
        const rawRegExpPatterns = {
            ...patterns.regexp?.['all'],
            ...downcasedProduct ? patterns.regexp?.[downcasedProduct] : {}
        };
        const compiledPatterns = $6926ebbd7787cbce$var$compileRegExpPatterns(rawRegExpPatterns);
        itemCategoryNumber = $6926ebbd7787cbce$export$81a82818a800a999(itemKey, compiledPatterns);
    }
    return $6926ebbd7787cbce$var$toPreferenceCategory(itemCategoryNumber, categories);
};
const $6926ebbd7787cbce$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $4kM1J.getBscGlobalState)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $6926ebbd7787cbce$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $6926ebbd7787cbce$export$4369c812aac99591 = (value)=>value != null && typeof value.then === 'function';
const $6926ebbd7787cbce$export$68b935e7ddb93762 = (itemKey, storageType, productName)=>{
    const storageControlsDataOrPromise = (0, $4kM1J.getBscGlobalState)().loadCacheMaybeSync(storageType);
    if ($6926ebbd7787cbce$export$4369c812aac99591(storageControlsDataOrPromise)) return storageControlsDataOrPromise.then((storageControlsData)=>{
        if (!storageControlsData) return null;
        else return $6926ebbd7787cbce$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
    });
    if (!storageControlsDataOrPromise) return null;
    else return $6926ebbd7787cbce$export$69d5b68d01f4a366(itemKey, storageControlsDataOrPromise, productName);
};
function $6926ebbd7787cbce$var$getEffectiveCategory(category) {
    if (category === null) return (0, $hw3pG.PreferenceCategory).Marketing;
    return category;
}
function $6926ebbd7787cbce$var$isProcessingAllowedForCategoryAndPreferenceSync(category, preferences) {
    const effectiveCategory = $6926ebbd7787cbce$var$getEffectiveCategory(category);
    if (!!preferences) {
        if (!!effectiveCategory) return preferences[effectiveCategory];
    }
    return false;
}
/**
 * Given an item category and a promise or object of user preferences, determines whether the item can be set.
 * It avoids only returns a promise if we need the preference data to determine the result, otherwise it returns synchronously.
 *
 * DO NOT CONVERT THIS FUNCTION TO ASYNC - as async functions always return a promise, breaking read-after-write consistency for clients that have already loaded the cache.
 */ function $6926ebbd7787cbce$var$isProcessingAllowedForCategoryMaybeSync(itemCategory, preferencesOrPromise) {
    if (itemCategory === (0, $hw3pG.PreferenceCategory).StrictlyNecessary) return {
        itemCategory: itemCategory,
        shouldProcessItem: true
    };
    if ($6926ebbd7787cbce$export$4369c812aac99591(preferencesOrPromise)) return preferencesOrPromise.then((prefs)=>{
        return {
            itemCategory: itemCategory,
            shouldProcessItem: $6926ebbd7787cbce$var$isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, prefs)
        };
    });
    else return {
        itemCategory: itemCategory,
        shouldProcessItem: $6926ebbd7787cbce$var$isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, preferencesOrPromise)
    };
}
const $6926ebbd7787cbce$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync = ({ itemKey: itemKey, storageType: storageType, productName: productName })=>{
    // start fetching both promises upfront, so they can resolve in parallel if needed
    const itemCategoryOrPromise = $6926ebbd7787cbce$export$68b935e7ddb93762(itemKey, storageType, productName);
    const preferencesOrPromise = (0, $dBSj0.getPreferencesMaybeSync)();
    if ($6926ebbd7787cbce$export$4369c812aac99591(itemCategoryOrPromise)) return itemCategoryOrPromise.then((category)=>$6926ebbd7787cbce$var$isProcessingAllowedForCategoryMaybeSync(category, preferencesOrPromise));
    else return $6926ebbd7787cbce$var$isProcessingAllowedForCategoryMaybeSync(itemCategoryOrPromise, preferencesOrPromise);
};
const $6926ebbd7787cbce$export$ffbb879d3fefb45c = ({ itemKey: itemKey, storageType: storageType, productName: productName, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, extensionSignals: extensionSignals })=>{
    const categoryAndPreferenceOrPromise = $6926ebbd7787cbce$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    const handleDecision = ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory }, wasAsync)=>{
        if (shouldProcessItem) {
            allowedCallback?.({
                wasAsync: wasAsync
            });
            return shouldProcessItem;
        }
        // Check if blocked item is from extension
        const extensionCaller = itemCategory === null ? (0, $7dgho.attributeExtensionCaller)(extensionSignals) : null;
        if (extensionCaller) {
            (0, $52k2b.sendTrackEvent)({
                source: 'package',
                action: 'package',
                actionSubject: 'browserExtensionKeysAllowed',
                attributes: {
                    itemKey: itemKey,
                    storageType: storageType,
                    productName: productName,
                    extensionScheme: extensionCaller.scheme
                }
            });
            allowedCallback?.({
                wasAsync: wasAsync
            });
            return true;
        }
        blockedCallback?.({
            itemHasCategory: itemCategory != null,
            itemCategory: itemCategory,
            wasAsync: wasAsync
        });
        return shouldProcessItem;
    };
    if ($6926ebbd7787cbce$export$4369c812aac99591(categoryAndPreferenceOrPromise)) return categoryAndPreferenceOrPromise.then((categoryAndPreference)=>handleDecision(categoryAndPreference, true));
    else return handleDecision(categoryAndPreferenceOrPromise, false);
};
const $6926ebbd7787cbce$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName, extensionSignals: extensionSignals })=>{
    let shouldProcessItem;
    let itemCategory = null;
    let wasAsync = true;
    let categoryAndPreferenceOrPromise = $6926ebbd7787cbce$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    if ($6926ebbd7787cbce$export$4369c812aac99591(categoryAndPreferenceOrPromise)) // this should be the only await in the function.
    ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = await categoryAndPreferenceOrPromise);
    else {
        wasAsync = false;
        ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = categoryAndPreferenceOrPromise);
    }
    if (shouldProcessItem) allowedCallback?.({
        wasAsync: wasAsync
    });
    else {
        // Check if blocked item is from extension
        const extensionCaller = itemCategory === null ? (0, $7dgho.attributeExtensionCaller)(extensionSignals) : null;
        if (extensionCaller) {
            (0, $52k2b.sendTrackEvent)({
                source: 'package',
                action: 'package',
                actionSubject: 'browserExtensionKeysAllowed',
                attributes: {
                    itemKey: itemKey,
                    storageType: storageType,
                    productName: productName,
                    extensionScheme: extensionCaller.scheme
                }
            });
            allowedCallback?.({
                wasAsync: wasAsync
            });
            return true;
        }
        blockedCallback?.({
            itemHasCategory: itemCategory != null,
            itemCategory: itemCategory,
            wasAsync: wasAsync
        });
    }
    return shouldProcessItem;
};
const $6926ebbd7787cbce$export$17e4a7e00d5b99d9 = async ({ itemKey: itemKey, storageType: storageType, productName: productName, extensionSignals: extensionSignals })=>{
    const categoryAndPreferenceOrPromise = $6926ebbd7787cbce$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    let shouldProcessItem;
    let itemCategory;
    if ($6926ebbd7787cbce$export$4369c812aac99591(categoryAndPreferenceOrPromise)) ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = await categoryAndPreferenceOrPromise);
    else ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = categoryAndPreferenceOrPromise);
    // Check if blocked item is from extension
    if (!shouldProcessItem) {
        const extensionCaller = itemCategory === null ? (0, $7dgho.attributeExtensionCaller)(extensionSignals) : null;
        if (extensionCaller) {
            (0, $52k2b.sendTrackEvent)({
                source: 'package',
                action: 'package',
                actionSubject: 'browserExtensionKeysAllowed',
                attributes: {
                    itemKey: itemKey,
                    storageType: storageType,
                    productName: productName,
                    extensionScheme: extensionCaller.scheme
                }
            });
            return {
                isAllowed: true,
                itemCategory: itemCategory
            };
        }
    }
    return {
        isAllowed: shouldProcessItem,
        itemCategory: itemCategory
    };
};

});
parcelRegister("dBSj0", function(module, exports) {
$parcel$export(module.exports, "getPreferences", () => $04508f0c7f9f94fc$export$1de6a888ae076ff8);
$parcel$export(module.exports, "getPreferencesMaybeSync", () => $04508f0c7f9f94fc$export$39c2cb6e65c1c16b);

var $4kM1J = parcelRequire("4kM1J");
var $5W9qx = parcelRequire("5W9qx");

var $6dLlD = parcelRequire("6dLlD");

var $aHPCS = parcelRequire("aHPCS");

var $cJ9lp = parcelRequire("cJ9lp");

var $fYztB = parcelRequire("fYztB");
async function $04508f0c7f9f94fc$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $4kM1J.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $cJ9lp.getCookie)((0, $6dLlD.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $fYztB.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $cJ9lp.getCookie)((0, $6dLlD.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $aHPCS.getConsentToken)();
            if ((0, $5W9qx.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $fYztB.unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, $fYztB.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}
function $04508f0c7f9f94fc$export$39c2cb6e65c1c16b() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $4kM1J.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $cJ9lp.getCookie)((0, $6dLlD.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $fYztB.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $cJ9lp.getCookie)((0, $6dLlD.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) return (0, $aHPCS.getConsentToken)().then((consentToken)=>{
            if ((0, $5W9qx.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $fYztB.unpackUserPreferencesCookie)(consentToken) : undefined;
        });
        else return (0, $fYztB.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}

});
parcelRegister("6dLlD", function(module, exports) {
$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $9ba140be25382585$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $9ba140be25382585$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $9ba140be25382585$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $9ba140be25382585$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $9ba140be25382585$export$37073d560ecebada);
$parcel$export(module.exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", () => $9ba140be25382585$export$5dc0026db06844f3);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $9ba140be25382585$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $9ba140be25382585$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $9ba140be25382585$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $9ba140be25382585$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $9ba140be25382585$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $9ba140be25382585$export$31deaeaebce525bb);

var $hw3pG = parcelRequire("hw3pG");
const $9ba140be25382585$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $9ba140be25382585$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $9ba140be25382585$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $9ba140be25382585$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $9ba140be25382585$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $9ba140be25382585$export$37073d560ecebada = 'atl-testing-consents';
const $9ba140be25382585$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $9ba140be25382585$export$b28b5d760fe14a21 = {
    [(0, $hw3pG.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $hw3pG.PreferenceCategory).Functional]: true,
    [(0, $hw3pG.PreferenceCategory).Marketing]: true,
    [(0, $hw3pG.PreferenceCategory).Analytics]: true,
    [(0, $hw3pG.PreferenceCategory).Unknown]: true
};
const $9ba140be25382585$export$4a12f9e99971760a = {
    [(0, $hw3pG.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $hw3pG.PreferenceCategory).Functional]: false,
    [(0, $hw3pG.PreferenceCategory).Marketing]: false,
    [(0, $hw3pG.PreferenceCategory).Analytics]: false,
    [(0, $hw3pG.PreferenceCategory).Unknown]: false
};
const $9ba140be25382585$export$f0fd1d13ec1d48f2 = {
    ...$9ba140be25382585$export$4a12f9e99971760a,
    [(0, $hw3pG.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $hw3pG.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $hw3pG.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $9ba140be25382585$export$f95182b7aa141c57 = '001';
const $9ba140be25382585$export$1f25427b34f9c405 = '002';
const $9ba140be25382585$export$31deaeaebce525bb = '003';

});

parcelRegister("aHPCS", function(module, exports) {
$parcel$export(module.exports, "getConsentToken", () => $5d69e96cc2179947$export$f1b8f2ca713fca08);

var $6dLlD = parcelRequire("6dLlD");

var $cJ9lp = parcelRequire("cJ9lp");

var $n7mNs = parcelRequire("n7mNs");

var $4IIcH = parcelRequire("4IIcH");

var $1CFnK = parcelRequire("1CFnK");
/**
 * Module-level cache of the in-flight ConsentHub fetch promise.
 * Cleared as soon as the promise settles (resolved or rejected).
 *
 * Without this, N concurrent callers that all find the consent cookie absent
 * would each independently fire a fetch to ConsentHub, causing a request
 * fan-out on every page load where multiple components call getPreferences()
 * simultaneously.
 */ let $5d69e96cc2179947$var$inFlightConsentToken = null;
const $5d69e96cc2179947$var$_getConsentToken = async ()=>{
    const fallbackConsentToken = (0, $cJ9lp.getCookie)((0, $6dLlD.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $1CFnK.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $n7mNs.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $cJ9lp.getCookie)((0, $6dLlD.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $4IIcH.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $4IIcH.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $4IIcH.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};
const $5d69e96cc2179947$export$f1b8f2ca713fca08 = ()=>{
    // N concurrent callers share a single in-flight promise so only one ConsentHub fetch
    // fires per page load regardless of how many components call getPreferences() simultaneously.
    if ($5d69e96cc2179947$var$inFlightConsentToken) return $5d69e96cc2179947$var$inFlightConsentToken;
    $5d69e96cc2179947$var$inFlightConsentToken = $5d69e96cc2179947$var$_getConsentToken().finally(()=>{
        $5d69e96cc2179947$var$inFlightConsentToken = null;
    });
    return $5d69e96cc2179947$var$inFlightConsentToken;
};

});
parcelRegister("n7mNs", function(module, exports) {
$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $91bacb10715c7b12$export$b5282052fc15e1ae);

var $6dLlD = parcelRequire("6dLlD");

var $cJ9lp = parcelRequire("cJ9lp");
const $91bacb10715c7b12$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $cJ9lp.getCookie)((0, $6dLlD.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("4IIcH", function(module, exports) {
$parcel$export(module.exports, "setConsentTokenCookie", () => $382c702dd90f62ee$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $382c702dd90f62ee$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $382c702dd90f62ee$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $382c702dd90f62ee$export$b3365240280cb3c3);

var $aUpEu = parcelRequire("aUpEu");
var $2yNBb = parcelRequire("2yNBb");

var $6dLlD = parcelRequire("6dLlD");

var $1zSTL = parcelRequire("1zSTL");

var $1vAhy = parcelRequire("1vAhy");
const $382c702dd90f62ee$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 50;
const $382c702dd90f62ee$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 70;
const $382c702dd90f62ee$export$6e0b780517c88191 = ()=>{
    // Random offset is 0-20 minutes inclusive, so the final lifetime spreads across 50-70 minutes.
    const randomizedOffsetMinutes = Math.floor(Math.random() * ($382c702dd90f62ee$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES - $382c702dd90f62ee$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + 1));
    // Spread cookie expiration times to smooth traffic spikes to ConsentHub.
    return $382c702dd90f62ee$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + randomizedOffsetMinutes;
};
// Pick once per module load so both required consent cookies share the same spread-out expiry.
const $382c702dd90f62ee$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = $382c702dd90f62ee$export$6e0b780517c88191();
const $382c702dd90f62ee$var$getRequiredConsentCookieExpiryDate = ()=>{
    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + $382c702dd90f62ee$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES * 60000);
    return expiryDate;
};
const $382c702dd90f62ee$export$8e560d0760f733a2 = (consentToken)=>{
    (0, $1vAhy.setStrictlyNecessaryCookie)((0, $6dLlD.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: $382c702dd90f62ee$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $2yNBb.Logger).debug(`Set Consent Token ${(0, $6dLlD.ATLASSIAN_CONSENT_COOKIE_KEY)} ${consentToken}`);
};
const $382c702dd90f62ee$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $1vAhy.setStrictlyNecessaryCookie)((0, $6dLlD.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $2yNBb.Logger).debug(`set fallback consent token: ${(0, $6dLlD.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)} ${consentToken}`);
};
const $382c702dd90f62ee$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $1zSTL.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $aUpEu.getBitValueFromBool)(!!bannerVisibility);
    (0, $1vAhy.setStrictlyNecessaryCookie)((0, $6dLlD.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: $382c702dd90f62ee$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $2yNBb.Logger).debug(`set shouldShowBannerCookie: ${(0, $6dLlD.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)} ${shouldShowBanner}`);
};
const $382c702dd90f62ee$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $382c702dd90f62ee$export$8e560d0760f733a2(consentToken);
    $382c702dd90f62ee$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("aUpEu", function(module, exports) {
$parcel$export(module.exports, "getBitValueFromBool", () => $7f90c82d60d3e886$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $7f90c82d60d3e886$export$27647458f3cf29d2);
const $7f90c82d60d3e886$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $7f90c82d60d3e886$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("1zSTL", function(module, exports) {
$parcel$export(module.exports, "getBannerVisibility", () => $90e8c32415190bb2$export$bfdb9f82a9194c1e);

var $k3O8N = parcelRequire("k3O8N");

var $5W9qx = parcelRequire("5W9qx");

var $aUpEu = parcelRequire("aUpEu");

var $6dLlD = parcelRequire("6dLlD");

var $kXPoi = parcelRequire("kXPoi");

var $cJ9lp = parcelRequire("cJ9lp");

var $fYztB = parcelRequire("fYztB");
const $90e8c32415190bb2$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $fYztB.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $90e8c32415190bb2$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $90e8c32415190bb2$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $aUpEu.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $kXPoi.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $90e8c32415190bb2$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $kXPoi.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $90e8c32415190bb2$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $kXPoi.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $90e8c32415190bb2$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $90e8c32415190bb2$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $aUpEu.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $kXPoi.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
        They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
        then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)

        UX Problem:
        Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
        But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
        is infrequent (either via Account Privacy Page or once this fallback expires in a year).

        Example:
        While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
        fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
        because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...

        We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
        to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
        persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.

        Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
        consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year

        Result: Show the banner again and hope we officially recapture consents this time around
      */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $90e8c32415190bb2$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $kXPoi.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $90e8c32415190bb2$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $kXPoi.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $90e8c32415190bb2$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents }, ssrOptions)=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    // Detect if js-cookie has been replaced with SSR-safe version (Confluence only)
    const isJsCookieSSRSafe = typeof (0, $k3O8N.default).__SSR_INITIALIZE_COOKIES__ === 'function';
    // Jira passes getCookie explicitly via ssrOptions - it works on both SSR and CSR.
    const ssrFriendlyGetCookie = ssrOptions?.getCookie;
    let fallbackConsentToken;
    if (ssrFriendlyGetCookie) fallbackConsentToken = fallbackConsents || ssrFriendlyGetCookie((0, $6dLlD.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    else fallbackConsentToken = (0, $5W9qx.isSSR)() ? fallbackConsents || (isJsCookieSSRSafe ? (0, $cJ9lp.getCookie)((0, $6dLlD.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)) : undefined) : fallbackConsents || (0, $cJ9lp.getCookie)((0, $6dLlD.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $90e8c32415190bb2$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $aUpEu.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $90e8c32415190bb2$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $90e8c32415190bb2$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});
parcelRegister("kXPoi", function(module, exports) {
$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", () => $6de1a35cf8e6569c$export$42b0ca8aba2631e4);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $6de1a35cf8e6569c$export$497a647f0eb30ef4);
$parcel$export(module.exports, "serializeConsents", () => $6de1a35cf8e6569c$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $6de1a35cf8e6569c$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $6de1a35cf8e6569c$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $6de1a35cf8e6569c$export$3387347b75450ae1);
$parcel$export(module.exports, "hasPrefetchedDataConsents", () => $6de1a35cf8e6569c$export$7133f415a79804e8);
$parcel$export(module.exports, "StatusCodeError", () => $6de1a35cf8e6569c$export$a79c0ea3d7c2444a);

var $aUpEu = parcelRequire("aUpEu");

var $6dLlD = parcelRequire("6dLlD");

var $cJ9lp = parcelRequire("cJ9lp");

var $hw3pG = parcelRequire("hw3pG");

var $8qm4m = parcelRequire("8qm4m");
const $6de1a35cf8e6569c$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $6dLlD.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $6de1a35cf8e6569c$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $6dLlD.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $6de1a35cf8e6569c$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($6de1a35cf8e6569c$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $6de1a35cf8e6569c$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $6de1a35cf8e6569c$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $6de1a35cf8e6569c$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $6de1a35cf8e6569c$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $aUpEu.getBoolFromBitValue)(consentToken[7]);
    return isDefaultTokenV3;
};
const $6de1a35cf8e6569c$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $6dLlD.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $6dLlD.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $hw3pG.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $hw3pG.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $aUpEu.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $hw3pG.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $aUpEu.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $aUpEu.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $6de1a35cf8e6569c$export$42a0b3fb1e53e7b9 = (consents)=>{
    const version = (0, $6dLlD.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $aUpEu.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $8qm4m.ConsentHubKey).Functional)?.granted);
    const analyticsConsent = (0, $aUpEu.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $8qm4m.ConsentHubKey).Analytics)?.granted);
    const marketingConsent = (0, $aUpEu.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $8qm4m.ConsentHubKey).Marketing)?.granted);
    const unknownConsent = (0, $aUpEu.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $8qm4m.ConsentHubKey).Unknown)?.granted);
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $6de1a35cf8e6569c$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $cJ9lp.getCookie)((0, $6dLlD.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $6de1a35cf8e6569c$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $6de1a35cf8e6569c$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $6de1a35cf8e6569c$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $6de1a35cf8e6569c$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $hw3pG.PreferenceCategory).StrictlyNecessary,
        (0, $hw3pG.PreferenceCategory).Functional,
        (0, $hw3pG.PreferenceCategory).Analytics,
        (0, $hw3pG.PreferenceCategory).Marketing,
        (0, $hw3pG.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $hw3pG.PreferenceCategory).StrictlyNecessary]: (0, $8qm4m.ConsentHubKey).StrictlyNecessary,
        [(0, $hw3pG.PreferenceCategory).Functional]: (0, $8qm4m.ConsentHubKey).Functional,
        [(0, $hw3pG.PreferenceCategory).Analytics]: (0, $8qm4m.ConsentHubKey).Analytics,
        [(0, $hw3pG.PreferenceCategory).Marketing]: (0, $8qm4m.ConsentHubKey).Marketing,
        [(0, $hw3pG.PreferenceCategory).Unknown]: (0, $8qm4m.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $6de1a35cf8e6569c$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $6de1a35cf8e6569c$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
const $6de1a35cf8e6569c$export$7133f415a79804e8 = (preferences)=>{
    if (!preferences) return false;
    const prefetchedToken = 'consentToken' in preferences && preferences.consentToken;
    const prefetchedTokenIsDefault = $6de1a35cf8e6569c$export$497a647f0eb30ef4(prefetchedToken || '');
    const hasLegitConsentToken = prefetchedToken && !prefetchedTokenIsDefault;
    const prefetchedConsents = 'consents' in preferences && preferences.consents;
    const hasLegitConsents = prefetchedConsents && Array.isArray(prefetchedConsents) && prefetchedConsents.length > 0;
    return Boolean(hasLegitConsentToken || hasLegitConsents);
};
class $6de1a35cf8e6569c$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, $6de1a35cf8e6569c$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $6de1a35cf8e6569c$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("8qm4m", function(module, exports) {
$parcel$export(module.exports, "ConsentHubKey", () => $f8a2eada7030330b$export$31140359b1e505cf);
var $f8a2eada7030330b$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});


parcelRegister("fYztB", function(module, exports) {
$parcel$export(module.exports, "checkTokenVersionValidity", () => $848fc8bd8284b4d3$export$64b31470e8522819);
$parcel$export(module.exports, "packUserPreferences", () => $848fc8bd8284b4d3$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $848fc8bd8284b4d3$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initializePreferencesData", () => $848fc8bd8284b4d3$export$7962405c3ca274b1);

var $4kM1J = parcelRequire("4kM1J");

var $aUpEu = parcelRequire("aUpEu");

var $6dLlD = parcelRequire("6dLlD");

var $kXPoi = parcelRequire("kXPoi");

var $hw3pG = parcelRequire("hw3pG");
const $848fc8bd8284b4d3$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $6dLlD.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $6dLlD.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $6dLlD.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $6dLlD.V001_SCHEMA_KEY),
        (0, $6dLlD.V002_SCHEMA_KEY),
        (0, $6dLlD.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $848fc8bd8284b4d3$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $6dLlD.V001_SCHEMA_KEY);
    return [
        version,
        (0, $aUpEu.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $aUpEu.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $aUpEu.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $aUpEu.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $848fc8bd8284b4d3$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $hw3pG.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $hw3pG.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $hw3pG.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $hw3pG.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $hw3pG.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $848fc8bd8284b4d3$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $6dLlD.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $hw3pG.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $hw3pG.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $hw3pG.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $hw3pG.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $hw3pG.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $aUpEu.getBitValueFromBool)(userPreferences[(0, $hw3pG.PreferenceCategory).Functional]),
        (0, $aUpEu.getBitValueFromBool)(userPreferences[(0, $hw3pG.PreferenceCategory).Analytics]),
        (0, $aUpEu.getBitValueFromBool)(userPreferences[(0, $hw3pG.PreferenceCategory).Marketing]),
        (0, $aUpEu.getBitValueFromBool)(userPreferences[(0, $hw3pG.PreferenceCategory).Unknown]),
        (0, $aUpEu.getBitValueFromBool)(isDefaultConsentBit),
        (0, $aUpEu.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $aUpEu.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $848fc8bd8284b4d3$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $kXPoi.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$848fc8bd8284b4d3$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $hw3pG.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $hw3pG.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $hw3pG.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $848fc8bd8284b4d3$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $6dLlD.V003_SCHEMA_KEY);
    return [
        version,
        (0, $aUpEu.getBitValueFromBool)(userPreferences[(0, $hw3pG.PreferenceCategory).Functional]),
        (0, $aUpEu.getBitValueFromBool)(userPreferences[(0, $hw3pG.PreferenceCategory).Analytics]),
        (0, $aUpEu.getBitValueFromBool)(userPreferences[(0, $hw3pG.PreferenceCategory).Marketing]),
        (0, $aUpEu.getBitValueFromBool)(userPreferences[(0, $hw3pG.PreferenceCategory).Unknown]),
        (0, $aUpEu.getBitValueFromBool)(userPreferences[(0, $hw3pG.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $aUpEu.getBitValueFromBool)(userPreferences[(0, $hw3pG.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $aUpEu.getBitValueFromBool)(userPreferences[(0, $hw3pG.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $848fc8bd8284b4d3$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $hw3pG.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $hw3pG.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $hw3pG.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $hw3pG.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $hw3pG.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $hw3pG.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $hw3pG.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $hw3pG.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $848fc8bd8284b4d3$var$V002SpecificBitKeys = [
    (0, $hw3pG.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $hw3pG.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $hw3pG.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $hw3pG.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $hw3pG.ConsentPreferenceV2).ConsentedUnderFADP
];
const $848fc8bd8284b4d3$var$V003SpecificBitKeys = [
    (0, $hw3pG.ContextualConsentProperty).ConsentsAreDefault,
    (0, $hw3pG.ContextualConsentProperty).UserIsAuthenticated,
    (0, $hw3pG.ContextualConsentProperty).ConsentDataUnavailable
];
function $848fc8bd8284b4d3$export$3199823fec979bd1(userPreferences) {
    if ((0, $4kM1J.getBscGlobalState)().localConsentMode) return $848fc8bd8284b4d3$var$packPrefsVersion001(userPreferences);
    const isV002 = $848fc8bd8284b4d3$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $848fc8bd8284b4d3$var$packPrefsVersion002(userPreferences);
    const isV003 = $848fc8bd8284b4d3$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $848fc8bd8284b4d3$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $848fc8bd8284b4d3$var$packPrefsVersion001(userPreferences);
}
function $848fc8bd8284b4d3$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $4kM1J.getBscGlobalState)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $6dLlD.V001_SCHEMA_KEY)) return $848fc8bd8284b4d3$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $848fc8bd8284b4d3$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $848fc8bd8284b4d3$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $848fc8bd8284b4d3$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $848fc8bd8284b4d3$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $848fc8bd8284b4d3$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $848fc8bd8284b4d3$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $hw3pG.PrefetchedPreferenceState).INTERNAL) {
        if ($848fc8bd8284b4d3$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $848fc8bd8284b4d3$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $kXPoi.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $848fc8bd8284b4d3$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $hw3pG.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

});



parcelRegister("1CFnK", function(module, exports) {
$parcel$export(module.exports, "getValidConsentData", () => $8e6e446fce580534$export$c515de1cc9cebc71);

var $6dLlD = parcelRequire("6dLlD");

var $cx4QJ = parcelRequire("cx4QJ");

var $fYztB = parcelRequire("fYztB");
const $8e6e446fce580534$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $cx4QJ.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $fYztB.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else {
            const version = (0, $6dLlD.V003_SCHEMA_KEY);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        }
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});
parcelRegister("cx4QJ", function(module, exports) {
$parcel$export(module.exports, "buildConsentPreferences", () => $8fecd4997d7ac154$export$bd9f5bcbf9cd947c);
$parcel$export(module.exports, "fetchConsentPreferences", () => $8fecd4997d7ac154$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $8fecd4997d7ac154$export$f8422650c3dec8b2);

var $llCao = parcelRequire("llCao");

var $2yNBb = parcelRequire("2yNBb");

var $4kM1J = parcelRequire("4kM1J");

var $kXPoi = parcelRequire("kXPoi");
const $8fecd4997d7ac154$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $8fecd4997d7ac154$var$POST_CONSENTS_URL = `${$8fecd4997d7ac154$var$BASE_CONSENTS_URL}/user`;
const $8fecd4997d7ac154$var$GET_CONSENTS_URL = `${$8fecd4997d7ac154$var$POST_CONSENTS_URL}/consents/cookies`;
const $8fecd4997d7ac154$var$getConsentHubHeaders = ()=>({
        'Content-Type': 'application/json',
        'X-Request-Origin': 'bsc',
        'X-Request-Origin-App': $8fecd4997d7ac154$var$getProductForConsentHubHeader()
    });
const $8fecd4997d7ac154$var$getProductForConsentHubHeader = ()=>{
    const product = (0, $4kM1J.getBscGlobalState)().product;
    if (!product || product === 'all') return 'unknown';
    if ((0, $llCao.fg)('platform_bsc_consent_hub_x_origin_app_normalized')) // ConsentHub buckets anything that is not lowercase and hyphen-separated as `unknown`.
    return product.toLowerCase().replace(/\s+/g, '-');
    return product;
};
const $8fecd4997d7ac154$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $kXPoi.serializeConsents)(consentData);
        const consentTimestamp = (0, $kXPoi.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $kXPoi.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $8fecd4997d7ac154$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$8fecd4997d7ac154$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: $8fecd4997d7ac154$var$getConsentHubHeaders()
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $8fecd4997d7ac154$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $2yNBb.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $8fecd4997d7ac154$export$bd9f5bcbf9cd947c();
    }
};
const $8fecd4997d7ac154$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $kXPoi.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $8fecd4997d7ac154$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$8fecd4997d7ac154$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: $8fecd4997d7ac154$var$getConsentHubHeaders(),
            body: $8fecd4997d7ac154$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $kXPoi.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $2yNBb.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

});




parcelRegister("7dgho", function(module, exports) {
$parcel$export(module.exports, "captureCallerSignals", () => $262aaab1ce12f02b$export$9a9299a14dc0c1cb);
$parcel$export(module.exports, "attributeExtensionCaller", () => $262aaab1ce12f02b$export$9674893ac982a3cc);
// Detects storage writes made by browser extensions so consent enforcement doesn't block them.
// Chromium family (Chrome, Chromium Edge, Brave, Opera) all use `chrome-extension://`.
// Firefox uses `moz-extension://`; Safari uses `safari-web-extension://`.
// `ms-browser-extension://` is the legacy EdgeHTML
const $262aaab1ce12f02b$export$99d1f70e3d2681ed = /(chrome-extension|moz-extension|safari-web-extension|ms-browser-extension):\/\/([^/)\s]+)/;
// A frame's script location, minus the `:line:column`. Matches V8's `at fn (url:1:2)` and
// SpiderMonkey/JavaScriptCore's `fn@url:1:2`.
const $262aaab1ce12f02b$var$FRAME_LOCATION = /([a-z][a-z0-9+.-]*:\/\/[^\s)]+?)(?::\d+){0,2}\)?$/i;
// A frame line, not the `Error: ` header V8 prefixes the trace with. V8 starts frames with `at `; the
// other engines use `name@url` and emit no header, so filtering keeps indices comparable.
const $262aaab1ce12f02b$var$FRAME_LINE = /^at\s|@/;
// How many leading frames can hold the code that made the write. BSC sits 2 frames above the caller —
// `captureCallerSignals` and the override closure — and neither can be inlined away: the closure is the
// value installed on `setItem`/the cookie accessor, and a minifier won't inline a function containing
// try/catch. The capture is deliberately one function for that reason.
//
// Bounding the scan is the point of this module. Matching an extension URL anywhere in the stack also
// matches every write made by Atlassian code that an extension merely called into, which turns the
// extension allowance into a blanket consent bypass for our own writes.
const $262aaab1ce12f02b$var$ORIGINATOR_FRAME_WINDOW = 3;
// Nothing past the window is read. V8 defaults to 10 and a product can lower it, so pin it.
const $262aaab1ce12f02b$var$CAPTURED_FRAME_LIMIT = 6;
const $262aaab1ce12f02b$var$parseFrames = (stack)=>stack.split('\n').map((line)=>line.trim()).filter((line)=>$262aaab1ce12f02b$var$FRAME_LINE.test(line));
const $262aaab1ce12f02b$var$asExtensionCaller = (frame)=>{
    const extension = frame?.match($262aaab1ce12f02b$var$FRAME_LOCATION)?.[1]?.match($262aaab1ce12f02b$export$99d1f70e3d2681ed);
    return extension ? {
        scheme: extension[1],
        id: extension[2]
    } : null;
};
const $262aaab1ce12f02b$export$d5f56ab842d0792b = (captured)=>{
    const stack = captured?.stack;
    if (!stack) return null;
    for (const frame of $262aaab1ce12f02b$var$parseFrames(stack).slice(0, $262aaab1ce12f02b$var$ORIGINATOR_FRAME_WINDOW)){
        const caller = $262aaab1ce12f02b$var$asExtensionCaller(frame);
        if (caller) return caller;
    }
    return null;
};
const $262aaab1ce12f02b$export$9a9299a14dc0c1cb = ()=>{
    try {
        const previousLimit = Error.stackTraceLimit;
        Error.stackTraceLimit = $262aaab1ce12f02b$var$CAPTURED_FRAME_LIMIT;
        const stack = new Error();
        Error.stackTraceLimit = previousLimit;
        return {
            stack: stack
        };
    } catch  {
        return {
            stack: new Error()
        };
    }
};
const $262aaab1ce12f02b$export$9674893ac982a3cc = (signals)=>signals ? $262aaab1ce12f02b$export$d5f56ab842d0792b(signals.stack) : null;

});






parcelRegister("aSkDB", function(module, exports) {
$parcel$export(module.exports, "SharedFeaturesInstrumentationIdContext", () => $f983501f00b4155e$export$5ae3634fdb64882c);
$parcel$export(module.exports, "AnalyticsContextWithSourceAndProperties", () => $f983501f00b4155e$export$a00cd3c213413389);
$parcel$export(module.exports, "useAnalyticsPropertiesContext", () => $f983501f00b4155e$export$ab8aa3dfd687f012);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $9sl8X = parcelRequire("9sl8X");
const $f983501f00b4155e$var$initialState = {
    conversationChannelId: '',
    chatEntryPoint: undefined,
    experienceId: '',
    product: '',
    productHeader: '',
    inProductExperience: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    agentIsVerified: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: '',
    mode: undefined
};
const $f983501f00b4155e$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $fsvuC.createContext)({
    propertiesRef: {
        current: {
            ...$f983501f00b4155e$var$initialState
        }
    },
    mode: undefined,
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $f983501f00b4155e$export$5ae3634fdb64882c = /*#__PURE__*/ (0, $fsvuC.createContext)({
    sharedFeaturesInstrumentationId: undefined,
    isInSmartCreateFlow: undefined
});
const $f983501f00b4155e$export$1aefd27d2ed3c1c9 = ({ children: children, mode: mode, launchSource: launchSource, rovoJourneyId: rovoJourneyId })=>{
    const propertiesRef = (0, $fsvuC.useRef)({
        ...$f983501f00b4155e$var$initialState,
        launchSource: launchSource,
        rovoJourneyId: rovoJourneyId
    });
    // Sync the (possibly late/changing) prop into the ref after commit, so concurrent
    // renders that are paused or discarded never leak an uncommitted launch source.
    (0, $fsvuC.useEffect)(()=>{
        propertiesRef.current.launchSource = launchSource;
    }, [
        launchSource
    ]);
    (0, $fsvuC.useEffect)(()=>{
        propertiesRef.current.rovoJourneyId = rovoJourneyId;
    }, [
        rovoJourneyId
    ]);
    const setAnalyticsPropertiesWithoutRerender = (0, $fsvuC.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $fsvuC.useMemo)(()=>({
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender,
        mode
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)($f983501f00b4155e$var$AnalyticsPropertiesContext.Provider, {
        value: value,
        children: children
    });
};
$f983501f00b4155e$export$1aefd27d2ed3c1c9.displayName = "AnalyticsPropertiesContextProvider";
const $f983501f00b4155e$export$a00cd3c213413389 = ({ source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, iframeHostProduct: iframeHostProduct, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow, launchSource: launchSource, rovoJourneyId: rovoJourneyId })=>{
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $fsvuC.useContext)($f983501f00b4155e$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const data = (0, $fsvuC.useMemo)(()=>({
            source: source,
            attributes: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow,
                iframeHostProduct: iframeHostProduct
            }
        }), [
        source,
        sharedFeaturesInstrumentationId,
        parentSharedFeaturesInstrumentationId,
        isInSmartCreateFlow,
        iframeHostProduct
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $9sl8X.default), {
        data: data,
        children: /*#__PURE__*/ (0, $5chsV.jsx)($f983501f00b4155e$export$5ae3634fdb64882c.Provider, {
            value: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            },
            children: /*#__PURE__*/ (0, $5chsV.jsx)($f983501f00b4155e$export$1aefd27d2ed3c1c9, {
                mode: mode,
                launchSource: launchSource,
                rovoJourneyId: rovoJourneyId,
                children: children
            })
        })
    });
};
$f983501f00b4155e$export$a00cd3c213413389.displayName = "AnalyticsContextWithSourceAndProperties";
const $f983501f00b4155e$export$ab8aa3dfd687f012 = ()=>{
    return (0, $fsvuC.useContext)($f983501f00b4155e$var$AnalyticsPropertiesContext);
};

});

parcelRegister("bSokK", function(module, exports) {
$parcel$export(module.exports, "AI_MATE_ATTRIBUTES", () => $9bf1202708c9ff70$export$8cffc8b2c93affd4);
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $9bf1202708c9ff70$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    agentIsVerified: 'agentIsVerified',
    conversationChannelId: 'conversationChannelId',
    chatEntryPoint: 'chatEntryPoint',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    mode: 'mode',
    product: 'product',
    productHeader: 'productHeader',
    inProductExperience: 'inProductExperience',
    singleInstrumentationID: 'singleInstrumentationID',
    sharedFeaturesInstrumentationId: 'sharedFeaturesInstrumentationId',
    assistanceServiceConfigMinionAlias: 'assistanceServiceConfigMinionAlias',
    skillSelectionSource: 'skillSelectionSource',
    // The Rovo Space a chat is scoped to (when any). Set on every event fired
    // while a space-scoped chat is active so "Space MAU" (unique users who
    // initiate a chat in a space) can be measured downstream.
    spaceId: 'spaceId',
    // Source surface that launched the conversation; emitted on result events only.
    // Runtime-validated against the launch-source allowlists at the pubsub boundary, so
    // only closed-vocabulary values ever reach analytics despite FollowUpSource's
    // `| string` fallback.
    launchSource: 'launchSource',
    // Quick Find-to-Chat journey correlation. Emitted only on the five funnel events
    // allowlisted by the analytics controller while the attributed conversation is active.
    rovoJourneyId: 'rovoJourneyId',
    // Set once a conversation is started from a third-party suggested prompt in the
    // Create-with-Rovo modal, so downstream events the 3P experiment does not own
    // (`message/sent`, `adopted/contentFinalized`) can be segmented by cohort.
    isThirdPartyPromptConversation: 'isThirdPartyPromptConversation',
    thirdPartyPromptCohort: 'thirdPartyPromptCohort',
    // Third-party apps connected from the in-thread connect prompt so far in this
    // conversation, so a later message can be read as post-connect without a join.
    thirdPartyConnectCount: 'thirdPartyConnectCount'
};

});

parcelRegister("39dkK", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $a3dd189f7662706c$export$85183a312807388d);
$parcel$export(module.exports, "SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE", () => $a3dd189f7662706c$export$e86f3aae41de8a7);
$parcel$export(module.exports, "REMIX_INTERACTION_SOURCES", () => $a3dd189f7662706c$export$5a1bc70923e441e9);
$parcel$export(module.exports, "isAllowedLaunchSource", () => $a3dd189f7662706c$export$f57fd972b3024068);
$parcel$export(module.exports, "AUTOSUGGEST_SOURCE", () => $a3dd189f7662706c$export$406073150b1a408);
$parcel$export(module.exports, "THIRD_PARTY_CONNECT_PROMPT_SUBJECT", () => $a3dd189f7662706c$export$f3c4b70a2cbe1eb3);

var $9fEYx = parcelRequire("9fEYx");
const $a3dd189f7662706c$export$85183a312807388d = (0, $9fEYx.FabricChannel).aiMate;
const $a3dd189f7662706c$var$REMIX_SOURCES = [
    'remix',
    'inlineRovoFromRemix',
    'remixModalFromToolbar',
    'remixModalFromBlockControls',
    'remixModalFromBlockMenu',
    'remixModalFromFloatingToolbar',
    'remixModalFromViewPageFloatingToolbar',
    'remixModalFromViewPageNudge',
    'remixModalFromNudge',
    'remixModalFromObjectLevelSidebar',
    'remixModalFromPasteMenu',
    'remixStagingArea',
    'remixModalFromMediaInserts'
];
const $a3dd189f7662706c$export$e86f3aae41de8a7 = 'smartLinkRovoButton';
const $a3dd189f7662706c$export$5a1bc70923e441e9 = new Set($a3dd189f7662706c$var$REMIX_SOURCES);
const $a3dd189f7662706c$export$c576fc434c88316f = new Set([
    'agentMentionEditorNudge',
    'automation-discovery-meeting-notes-nudge',
    'automation-discovery-content-reviewer-nudge',
    'jiraAddViewCreateWithRovo',
    'jiraListChildCreateRovo',
    'jiraListEmptyStateCreateRovo',
    'jiraSummaryActivityFeedEmptyState',
    'jiraSummaryRovoCreateRecommendation',
    'jiraSummaryWorkPulseConversationStarter',
    'jiraTimelineChildCreateRovo',
    'jsmSurveyAggregatedInsights',
    'recommendation-card-nudge'
]);
const $a3dd189f7662706c$export$f57fd972b3024068 = (value)=>value !== undefined && $a3dd189f7662706c$export$c576fc434c88316f.has(value);
var $a3dd189f7662706c$export$406073150b1a408 = /*#__PURE__*/ function(AUTOSUGGEST_SOURCE) {
    AUTOSUGGEST_SOURCE["ROVO_CHAT"] = "rovo-chat";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC"] = "confluence-aifc";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_SLIDES"] = "confluence-aifc-slides";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_WHITEBOARD"] = "confluence-aifc-whiteboard";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_DATABASE"] = "confluence-aifc-database";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_LIVE_DOC"] = "confluence-aifc-live-doc";
    return AUTOSUGGEST_SOURCE;
}({});
const $a3dd189f7662706c$export$f3c4b70a2cbe1eb3 = 'thirdPartyConnectPrompt';

});

parcelRegister("iMo3a", function(module, exports) {
$parcel$export(module.exports, "getAttributesFromContexts", () => $a901c20a90057725$export$d97c97ed77ff09e8);

var $fx4XM = parcelRequire("fx4XM");

var $8Kfon = parcelRequire("8Kfon");
const $a901c20a90057725$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return (0, $8Kfon.ALLOWED_AI_MATE_SOURCES).includes(x.source);
};
const $a901c20a90057725$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let contextsThatHaveAttributes = context.filter((x)=>$a901c20a90057725$var$isSourceAndAttributes(x) || x[0, $fx4XM.AI_MATE_CONTEXT]);
    return contextsThatHaveAttributes.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $fx4XM.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};

});
parcelRegister("8Kfon", function(module, exports) {
$parcel$export(module.exports, "ALLOWED_AI_MATE_SOURCES", () => $68882547d11f553f$export$e31e24b63b7085fd);
const $68882547d11f553f$export$e31e24b63b7085fd = [
    'AIMate',
    'smart-create',
    'CSMAI',
    'CSMAIEmbed',
    'rovoServiceAgent',
    'solutionComposer'
];

});



parcelRegister("kKZTv", function(module, exports) {
$parcel$export(module.exports, "ExperienceName", () => $48c51047ab2a5e7a$export$b881bd9f00ed8ed1);
$parcel$export(module.exports, "sendMessageExperienceName", () => $48c51047ab2a5e7a$export$97bfa295b10f6f9e);
$parcel$export(module.exports, "SLOExclusionReason", () => $48c51047ab2a5e7a$export$1b8ade75bafe2a6d);
$parcel$export(module.exports, "PreviewCardRenderStage", () => $48c51047ab2a5e7a$export$315c6d415b08d278);
$parcel$export(module.exports, "PreviewCardRenderDiagnosticAttribute", () => $48c51047ab2a5e7a$export$754812bba125b4c4);
$parcel$export(module.exports, "PreviewCardRenderActionAttribute", () => $48c51047ab2a5e7a$export$51e40ef74b0123bc);
$parcel$export(module.exports, "PreviewContentStage", () => $48c51047ab2a5e7a$export$b49585ccbc2980b5);
$parcel$export(module.exports, "REMIX_GENERATE_PREVIEW_MARKS", () => $48c51047ab2a5e7a$export$ebde7a14f059b67f);
$parcel$export(module.exports, "remixGeneratePreviewExperience", () => $48c51047ab2a5e7a$export$13437d7a030ee3e7);
$parcel$export(module.exports, "REMIX_EDIT_EXISTING_MARKS", () => $48c51047ab2a5e7a$export$bef09d36689d0f74);
$parcel$export(module.exports, "remixEditExistingExperience", () => $48c51047ab2a5e7a$export$a143927e9fe401a2);
$parcel$export(module.exports, "startRemixPasteRenderEmbedExperience", () => $48c51047ab2a5e7a$export$c0c3ed9d934fa9fe);
$parcel$export(module.exports, "succeedRemixPasteRenderEmbedExperience", () => $48c51047ab2a5e7a$export$aa07d60d01b2c5e3);
$parcel$export(module.exports, "failRemixPasteRenderEmbedExperience", () => $48c51047ab2a5e7a$export$2ed37a75e20c9dc7);

var $6JXcl = parcelRequire("6JXcl");

var $iV2VP = parcelRequire("iV2VP");
const $48c51047ab2a5e7a$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_PANEL_COMPOSABLE_EDITOR: 'aiMateLoadPanelComposableEditor',
    LOAD_INLINE_EDITOR: 'aiMateLoadInlineComposableEditor',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    SEARCH_BROWSE_AGENTS: 'aiMateSearchBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    LOAD_AUTO_SUGGEST_SKILLS_UNIFIED: 'aiMateAutoSuggestSkillsUnified',
    LOAD_CHAT_PROMPT_INPUT_SKILLS: 'aiMateChatPromptInputSkillsLoad',
    LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS: 'aiMateInlineChatPromptInputSkillsLoad',
    FETCH_CHAT: 'aiMateFetchChat',
    PREFETCH_CHAT: 'aiMatePrefetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated',
    FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference',
    FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData',
    FETCH_AGENT_DEBUG_MODAL_CONVERSATION_REVIEW: 'aiMateFetchAgentDebugModalDataConversationReview',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    DUPLICATE_AGENT: 'aiMateDuplicateAgent',
    HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData',
    HYDRATE_SKILL_METADATA: 'aiMateHydrateSkillMetadata',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent',
    SEND_DR_MESSAGE: 'aiMateSendDRMessage',
    SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage',
    SEND_TASK_MODE_MESSAGE: 'aiMateSendTaskModeMessage',
    SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage',
    SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE: 'aiMateSendConfirmedToolsTaskModeMessage',
    SEND_A2UI_ACTION: 'aiMateSendA2UIAction',
    RECONNECT_TO_ACTIVE_STREAM: 'aiMateReconnectToActiveStream',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    ANSWER_NOW: 'aiMateAnswerNow',
    HYDRATE_CONVERSATION: 'aiMateHydrateConversation',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad',
    LOAD_MORE_CONVERSATION_CHANNELS: 'aiMateLoadMoreConversationChannels',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    BULK_RESOLVE_CONVERSATION_ACTIONS: 'aiMateBulkResolveConversationActions',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMateFetchKnowledgeSourcesStore',
    PREFETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMatePrefetchKnowledgeSourcesStore',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
    CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
    GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
    AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent',
    PREVIEW_CONTENT: 'aiMatePreviewContent',
    PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender',
    JIRA_PREVIEW_CARD_RENDER: 'aiMateJiraPreviewCardRender',
    JSM_PREVIEW_CARD_RENDER: 'aiMateJsmPreviewCardRender',
    FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions',
    PREFETCH_AGENT_SITE_PERMISSIONS: 'aiMatePrefetchAgentSitePermissions',
    SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
    FILTERED_CLIENT_ERROR: 'aiMateFilteredClientError',
    GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
    PREFETCH_RECOMMENDED_AGENTS: 'aiMatePrefetchRecommendedAgents',
    PREFETCH_RECOMMENDED_SPACES: 'aiMatePrefetchRecommendedSpaces',
    OPEN_RECOMMENDED_SPACES: 'aiMateOpenRecommendedSpaces',
    UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
    VALIDATE_FILES: 'aiMateValidateFiles',
    GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
    AIFC_MESSAGE: 'aiMateAifcMessage',
    AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal',
    AIFC_TWC_ONBOARDING_MODAL_LAUNCH: 'aiMateTwcAifcOnboardingModalLaunch',
    AIFC_LOAD_CHAT_ONLY_CREATION_MODAL: 'aiMateLoadChatOnlyCreationModal',
    AIFC_LOAD_DRAFTS_SECTION: 'aiMateLoadDraftsSection',
    AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent',
    AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat',
    AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived',
    AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled',
    AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent',
    UPDATE_CONTENT_IN_CHAT: 'aiMateUpdateContentInChat',
    AIFC_MODAL_SESSION: 'aiMateAifcModalSession',
    CSM_WIDGET_RENDER: 'csmWidgetRender',
    CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
    CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
    CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
    CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage',
    CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters',
    CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters',
    GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState',
    SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState',
    AGENTS_MODAL_AND_SIDEBAR_LIST: 'aiMateAgentsModalAndSidebarList',
    AGENTS_MODAL_FAVOURITE_AGENTS: 'aiMateAgentsModalFavouriteAgents',
    AGENTS_FULLSCREEN_AGENT_LIST: 'aiMateAgentsFullscreenAgentList',
    STUDIO_TRIGGER_SOLUTION_PLAN: 'aiMateStudioTriggerSolutionPlan',
    MY_PROJECTS_LIST_QUERY: 'aiMateMyProjectsListQuery',
    STUDIO_UPDATE_AGENT: 'aiMateStudioUpdateAgent',
    STUDIO_LOAD_AGENT_CARD: 'aiMateStudioLoadAgentCard',
    STUDIO_LOAD_AGENT_EDITOR: 'aiMateStudioLoadAgentEditor',
    STUDIO_KNOWLEDGE_MODAL_LOAD: 'aiMateStudioKnowledgeModalLoad',
    STUDIO_KNOWLEDGE_CONFIGURATION_VIEW: 'aiMateStudioKnowledgeConfigurationView',
    STUDIO_CREATE_AGENT_TRIGGER: 'aiMateStudioCreateAgentTrigger',
    STUDIO_UPDATE_AGENT_TRIGGER: 'aiMateStudioUpdateAgentTrigger',
    STUDIO_SET_AGENT_TRIGGER_ENABLED: 'aiMateStudioSetAgentTriggerEnabled',
    STUDIO_REMOVE_AGENT_TRIGGER: 'aiMateStudioRemoveAgentTrigger',
    STUDIO_AUTOMATION_CREATE_RULE: 'aiMateStudioAutomationCreateRule',
    THREADS_LIST_QUERY: 'aiMateThreadsListQuery',
    PROACTIVE_ACTION_ITEMS_LOAD: 'aiMateProactiveActionItemsLoad',
    WARM_CONVERSATION_CACHE: 'aiMateWarmConversationCache',
    WARM_CONTEXT_BANNER_LINK: 'aiMateWarmContextBannerLink',
    AIFC_LOAD_PROMPT_SUGGESTIONS: 'aiMateAifcLoadPromptSuggestions',
    REMIX_START: 'aiMateRemixStart',
    REMIX_AIFC_HANDOFF: 'aiMateRemixAifcHandoff',
    FETCH_INSIGHTS_STATUS: 'aiMateFetchInsightsStatus',
    FETCH_INSIGHTS_FEED: 'aiMateFetchInsightsFeed',
    REMIX_RENDERS_IN_MODAL: 'aiMateRemixRendersInModal',
    REMIX_CREATE: 'aiMateRemixCreate',
    REMIX_OPEN_MENU: 'aiMateRemixOpenMenu',
    REMIX_SELECT_OPTION: 'aiMateRemixSelectOption',
    REMIX_SHOW_LOADING: 'aiMateRemixShowLoading',
    // VIEW waits for all embeds' readiness without a timeout.
    // LIMITED requires readiness within each embed's existing deadline.
    REMIX_VIEW: 'aiMateRemixView',
    REMIX_VIEW_LIMITED: 'aiMateRemixViewLimited',
    REMIX_REGENERATE: 'aiMateRemixRegenerate',
    REMIX_INSERT: 'aiMateRemixInsert',
    REMIX_INSERT_LIMITED: 'aiMateRemixInsertLimited',
    REMIX_PASTE: 'aiMateRemixPaste',
    REMIX_COPY_FROM_PREVIEW: 'aiMateRemixCopyFromPreview',
    REMIX_DIAGRAM_PASTE_FINALIZE: 'aiMateRemixDiagramPasteFinalize',
    FETCH_TASKS: 'aiMateFetchTasks',
    FETCH_ARTIFACT_LIBRARY: 'aiMateFetchArtifactLibrary',
    SHARE_ARTIFACT: 'aiMateShareArtifact',
    SHARE_ARTIFACT_ACCESS_CHANGE: 'aiMateShareArtifactAccessChange',
    SHARE_ARTIFACT_SHARE_AUDIENCES: 'aiMateShareArtifactShareAudiences',
    SHARE_ARTIFACT_REVOKE_AUDIENCES: 'aiMateShareArtifactRevokeAudiences',
    DOWNLOAD_ARTIFACT: 'aiMateDownloadArtifact',
    PREVIEW_ARTIFACT_SMART_LINK_RESOLVED: 'aiMatePreviewArtifactSmartLinkResolved',
    LOAD_STICKY_SKILL_LISTENER: 'aiMateLoadStickySkillListener',
    /**
	 * Tracks duplicating a Remix/MAUI app when its link is pasted into another
	 * Confluence page. Started when the editor plugin detects a MAUI link in
	 * the paste, succeeded once the duplicated app's URL has been swapped into
	 * the editor doc, and failed if the duplicate API call (or any JS error in
	 * the duplication flow) fails. When this experience fails, the
	 * REMIX_INSERT experience is also failed so the overall paste-and-insert
	 * flow is reflected in the SLO.
	 */ REMIX_DUPLICATE_APP: 'aiMateRemixDuplicateApp',
    STUDIO_CREATE_AGENT: 'aiMateStudioCreateAgent',
    STUDIO_CREATE_AGENT_ASSIGN: 'aiMateStudioCreateAgentAssign',
    STUDIO_CREATE_AGENT_INVOKE: 'aiMateStudioCreateAgentInvoke',
    STUDIO_CREATE_AGENT_BUILD_AND_CHAT: 'aiMateStudioCreateAgentBuildAndChat',
    STUDIO_CREATE_AGENT_REFINE_IN_STUDIO: 'aiMateStudioCreateAgentRefineInStudio',
    STUDIO_CREATE_AGENT_RENDER: 'aiMateStudioCreateAgentRender',
    JIRA_SAVE_DRAFT_WORK_ITEM: 'aiMateJiraSaveDraftWorkItem',
    JIRA_RESOLVE_DRAFT_WORK_ITEM: 'aiMateJiraResolveDraftWorkItem',
    JIRA_CREATE_WORK_ITEMS_BULK: 'aiMateJiraCreateWorkItemsBulk',
    ROVO_SKILLS_PLAN_WORK_ITEM_CREATE: 'RovoSkillsPlanWorkItemCreate',
    ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE: 'RovoSkillsExecutionWorkItemCreate',
    ROVO_SKILLS_PLAN_WORK_ITEM_UPDATE: 'RovoSkillsPlanWorkItemUpdate',
    ROVO_SKILLS_EXECUTION_WORK_ITEM_UPDATE: 'RovoSkillsExecutionWorkItemUpdate',
    /**
	 * Tracks the sender's end-to-end conversation-sharing funnel as a single
	 * experience. Started when the share modal opens and succeeded only after
	 * an existing or newly created share link is copied to the clipboard.
	 * Unexpected hydration, persistence, share-creation, and clipboard errors
	 * fail the experience. A `404` when loading existing share details is the
	 * expected "not shared yet" state and does not fail the experience. Closing
	 * the modal before any terminal state is recorded aborts the experience so
	 * abandonment is excluded from the SLO.
	 */ SHARE_CONVERSATION_SESSION: 'aiMateShareConversationSession',
    /**
	 * Tracks the first action that reaches a terminal event while the Shared
	 * chats tab in Rovo settings is active. Preview succeeds with `action` set
	 * to `preview`; deleting a share or conversation succeeds or fails with
	 * `action` set to `delete`. Later or overlapping terminal calls are ignored
	 * by the underlying tracker. Closing the tab first aborts the experience.
	 */ MANAGE_CONVERSATION_SHARES: 'aiMateManageConversationShares',
    /**
	 * Tracks loading a shared conversation on the shared conversation preview
	 * page, for both the sender previewing their own share and a recipient
	 * opening a share link. Started when the route mounts and succeeded only
	 * after the conversation has rendered. HTTP 404 responses abort the experience;
	 * other errors retrieving or mapping the share fail it. A link that never
	 * carried the parameters needed to request a share aborts the experience,
	 * as does leaving the page before the conversation renders. Missing shares,
	 * malformed links and abandonment are recorded without counting against the SLO.
	 */ VIEW_CONVERSATION_SHARE: 'aiMateViewConversationShare',
    /**
	 * Tracks rendering the skill detail view of the skills directory, from either
	 * Atlassian Studio or the Rovo Chat skills modal. Started when the detail
	 * segment mounts and succeeded once the skill has rendered. Errors thrown
	 * while loading or rendering the skill fail the experience.
	 */ LOAD_SKILL_DETAIL_IN_SKILL_DIRECTORY: 'aiMateLoadSkillDetailInSkillDirectory',
    /**
	 * Tracks rendering the products filter of the skills directory. Started when
	 * the filter segment mounts and succeeded once the product list has
	 * rendered. Errors loading the product dimension metadata fail the
	 * experience.
	 */ LOAD_SKILLS_DIRECTORY_PRODUCTS_FILTER: 'aiMateLoadSkillsDirectoryProductsFilter',
    AIFC_DEEP_LINK_LAUNCH: 'aiMateAifcDeepLinkLaunch'
};
const $48c51047ab2a5e7a$export$97bfa295b10f6f9e = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, taskModeEnabled: taskModeEnabled, fastModeEnabled: fastModeEnabled, isCustomRovoAgent: isCustomRovoAgent })=>{
    if (isCustomRovoAgent) return $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (deepResearchEnabled) return $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.SEND_DR_MESSAGE;
    if (thinkDeeperEnabled) return $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.SEND_TD_MESSAGE;
    if (taskModeEnabled) return $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.SEND_TASK_MODE_MESSAGE;
    if (fastModeEnabled) // Sending the same experience name for fast mode as it is the same as the default (auto) mode
    return $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.SEND_MESSAGE;
    return $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.SEND_MESSAGE;
};
const $48c51047ab2a5e7a$export$233a4307e330ea30 = [
    $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT,
    $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT_IN_CHAT,
    $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.AIFC_UPDATE_CONTENT,
    $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.AIFC_FINALIZE_CONTENT,
    $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.AIFC_LOAD_STAGING_AREA_MODAL,
    $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.AIFC_MODAL_SESSION,
    $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.REMIX_REGENERATE
];
const $48c51047ab2a5e7a$export$1b8ade75bafe2a6d = {
    /** Browser-level network failure — request never reached Atlassian servers (e.g. VPN, firewall, no connectivity) */ CLIENT_FETCH_ERROR: 'clientFetchError',
    /** Rovo is not enabled for the user's organisation (product-not-active stream error) */ PRODUCT_NOT_ACTIVE: 'productNotActive',
    /** User is not authenticated or lacks permission (HTTP 401/403) */ AUTH_OR_PERMISSION_ERROR: 'authOrPermissionError',
    /** Request was rejected by rate limiting or quota admission control (HTTP 429) */ RATE_LIMIT_ERROR: 'rateLimitError'
};
const $48c51047ab2a5e7a$export$315c6d415b08d278 = {
    /** Experience started (intent detection decided on a creatable/Remix action) */ STARTED_AT: 'previewCardRenderStartedAtMs',
    /** Most recent ACTION_PART received */ ACTION_PART_AT: 'previewCardRenderActionPartAtMs',
    /** ACTION_COMPLETE received */ ACTION_COMPLETE_AT: 'previewCardRenderActionCompleteAtMs',
    /** SmartCreatePreviewCard mounted */ CARD_MOUNTED_AT: 'previewCardRenderCardMountedAtMs',
    /** SmartCreatePreviewCard mounted but used a non-instrumented branch. */ ROUTED_TO_NON_INSTRUMENTED_BRANCH_AT: 'previewCardRenderRoutedToNonInstrumentedBranchAtMs'
};
const $48c51047ab2a5e7a$export$754812bba125b4c4 = {
    /** Why the experience succeeded or aborted. */ TERMINAL_REASON: 'previewCardRenderTerminalReason'
};
const $48c51047ab2a5e7a$export$51e40ef74b0123bc = {
    /** Action status on the ACTION_PREPARE chunk */ ACTION_PREPARE_STATUS: 'previewCardRenderActionPrepareStatus',
    /** Action status on the most recent ACTION_PART chunk */ ACTION_PART_STATUS: 'previewCardRenderActionPartStatus',
    /** Action status on the ACTION_COMPLETE chunk */ ACTION_COMPLETE_STATUS: 'previewCardRenderActionCompleteStatus',
    /** Action key on the ACTION_COMPLETE chunk */ ACTION_COMPLETE_KEY: 'previewCardRenderActionCompleteKey'
};
const $48c51047ab2a5e7a$export$b49585ccbc2980b5 = {
    STARTED_AT: 'previewContentStartedAtMs',
    EMBED_URL_RESOLVED_AT: 'previewContentEmbedUrlResolvedAtMs',
    IFRAME_MOUNTED_AT: 'previewContentIframeMountedAtMs',
    HANDSHAKE_RECEIVED_AT: 'previewContentHandshakeReceivedAtMs',
    IFRAME_LOADED_AT: 'previewContentIframeLoadedAtMs'
};
const $48c51047ab2a5e7a$export$449b821dadec8760 = [
    $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.AIFC_DEEP_LINK_LAUNCH,
    $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.AIFC_INITIAL_DATA_RECEIVED,
    $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.AIFC_ALL_DATA_HANDLED,
    $48c51047ab2a5e7a$export$b881bd9f00ed8ed1.PREVIEW_CONTENT,
    ...$48c51047ab2a5e7a$export$233a4307e330ea30
];
const $48c51047ab2a5e7a$export$ebde7a14f059b67f = {
    SUBMIT: 'submit',
    ACTION_COMPLETE_RECEIVED: 'action_complete_received',
    PREVIEW_VISIBLE: 'preview_visible'
};
const $48c51047ab2a5e7a$export$35724980a513a99d = [
    {
        key: 'backend_latency',
        startMark: $48c51047ab2a5e7a$export$ebde7a14f059b67f.SUBMIT,
        endMark: $48c51047ab2a5e7a$export$ebde7a14f059b67f.ACTION_COMPLETE_RECEIVED
    },
    {
        key: 'render_latency',
        startMark: $48c51047ab2a5e7a$export$ebde7a14f059b67f.ACTION_COMPLETE_RECEIVED,
        endMark: $48c51047ab2a5e7a$export$ebde7a14f059b67f.PREVIEW_VISIBLE
    }
];
const $48c51047ab2a5e7a$export$13437d7a030ee3e7 = new (0, $6JXcl.UFOExperience)('remix-generate-preview', {
    type: (0, $iV2VP.ExperienceTypes).Experience,
    performanceType: (0, $iV2VP.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$48c51047ab2a5e7a$export$35724980a513a99d
    ]
});
const $48c51047ab2a5e7a$export$bef09d36689d0f74 = {
    SUBMIT: 'submit',
    ACTION_COMPLETE_RECEIVED: 'action_complete_received',
    NODE_INSERTED: 'node_inserted'
};
const $48c51047ab2a5e7a$export$222a56424ec38dc0 = [
    {
        key: 'backend_latency',
        startMark: $48c51047ab2a5e7a$export$bef09d36689d0f74.SUBMIT,
        endMark: $48c51047ab2a5e7a$export$bef09d36689d0f74.ACTION_COMPLETE_RECEIVED
    },
    {
        key: 'insertion_latency',
        startMark: $48c51047ab2a5e7a$export$bef09d36689d0f74.ACTION_COMPLETE_RECEIVED,
        endMark: $48c51047ab2a5e7a$export$bef09d36689d0f74.NODE_INSERTED
    }
];
const $48c51047ab2a5e7a$export$a143927e9fe401a2 = new (0, $6JXcl.UFOExperience)('remix-edit-existing', {
    type: (0, $iV2VP.ExperienceTypes).Experience,
    performanceType: (0, $iV2VP.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$48c51047ab2a5e7a$export$222a56424ec38dc0
    ]
});
const $48c51047ab2a5e7a$export$5806cfefce9dc0ad = {
    PASTE_DETECTED: 'paste_detected',
    EMBED_LOADED: 'embed_loaded'
};
const $48c51047ab2a5e7a$export$c39e7538132ae645 = [
    {
        key: 'render_latency',
        startMark: $48c51047ab2a5e7a$export$5806cfefce9dc0ad.PASTE_DETECTED,
        endMark: $48c51047ab2a5e7a$export$5806cfefce9dc0ad.EMBED_LOADED
    }
];
const $48c51047ab2a5e7a$export$cf4d370f87e7f73d = new (0, $6JXcl.UFOExperience)('remix-paste-render-embed', {
    type: (0, $iV2VP.ExperienceTypes).Experience,
    performanceType: (0, $iV2VP.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$48c51047ab2a5e7a$export$c39e7538132ae645
    ]
});
let $48c51047ab2a5e7a$var$isRemixPasteRenderEmbedExperienceActive = false;
const $48c51047ab2a5e7a$export$c0c3ed9d934fa9fe = (metadata)=>{
    if ($48c51047ab2a5e7a$var$isRemixPasteRenderEmbedExperienceActive) return;
    $48c51047ab2a5e7a$var$isRemixPasteRenderEmbedExperienceActive = true;
    $48c51047ab2a5e7a$export$cf4d370f87e7f73d.start();
    $48c51047ab2a5e7a$export$cf4d370f87e7f73d.mark($48c51047ab2a5e7a$export$5806cfefce9dc0ad.PASTE_DETECTED);
    if (metadata) $48c51047ab2a5e7a$export$cf4d370f87e7f73d.addMetadata(metadata);
};
const $48c51047ab2a5e7a$export$aa07d60d01b2c5e3 = (metadata)=>{
    if (!$48c51047ab2a5e7a$var$isRemixPasteRenderEmbedExperienceActive) return;
    $48c51047ab2a5e7a$export$cf4d370f87e7f73d.mark($48c51047ab2a5e7a$export$5806cfefce9dc0ad.EMBED_LOADED);
    if (metadata) $48c51047ab2a5e7a$export$cf4d370f87e7f73d.addMetadata(metadata);
    $48c51047ab2a5e7a$export$cf4d370f87e7f73d.success();
    $48c51047ab2a5e7a$var$isRemixPasteRenderEmbedExperienceActive = false;
};
const $48c51047ab2a5e7a$export$2ed37a75e20c9dc7 = (error, metadata)=>{
    if (!$48c51047ab2a5e7a$var$isRemixPasteRenderEmbedExperienceActive) return;
    if (metadata) $48c51047ab2a5e7a$export$cf4d370f87e7f73d.addMetadata(metadata);
    $48c51047ab2a5e7a$export$cf4d370f87e7f73d.failure({
        metadata: {
            reason: error.message
        }
    });
    $48c51047ab2a5e7a$var$isRemixPasteRenderEmbedExperienceActive = false;
};

});
parcelRegister("6JXcl", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $bb83d0fa08b81b58$export$c00d22927c60484a);

var $65YTY = parcelRequire("65YTY");
class $bb83d0fa08b81b58$export$c00d22927c60484a extends (0, $65YTY.UFOAbstractExperience) {
}

});
parcelRegister("65YTY", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $6de9c42a5866f7ac$export$d31c89db257648c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $17hIO = parcelRequire("17hIO");


var $3taQr = parcelRequire("3taQr");

var $iKGfn = parcelRequire("iKGfn");

var $4xdfL = parcelRequire("4xdfL");

var $9Xe8y = parcelRequire("9Xe8y");

var $OCIAE = parcelRequire("OCIAE");

var $dy9vV = parcelRequire("dy9vV");

var $2zZTf = parcelRequire("2zZTf");

var $lkCky = parcelRequire("lkCky");

var $lAIjw = parcelRequire("lAIjw");

var $9IZtV = parcelRequire("9IZtV");

var $4twIG = parcelRequire("4twIG");

var $iV2VP = parcelRequire("iV2VP");

var $5jXJe = parcelRequire("5jXJe");
const $6de9c42a5866f7ac$var$getPageVisibleState = ()=>{
    return !(0, $lAIjw.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $lkCky.PageVisibleState).VISIBLE : (0, $lkCky.PageVisibleState).HIDDEN;
};
class $6de9c42a5866f7ac$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $9IZtV.UFOExperienceState).NOT_STARTED;
        this.instanceId = null; // for concurrent
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $lkCky.PageVisibleState).MIXED;
            (0, $2zZTf.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $6de9c42a5866f7ac$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $iV2VP.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $iV2VP.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $OCIAE.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $4twIG.canTransition)(this.state, newState)) {
            (0, $OCIAE.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $9IZtV.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = (0, $5jXJe.perfNowOrTimestamp)(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $17hIO.default)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = (0, $5jXJe.perfNowOrTimestamp)(timestamp);
                if (!this._isManualStateEnabled()) (0, $iKGfn.getGlobalEventStream)().push((0, $9Xe8y.unsubscribeEvent)((0, $lkCky.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $OCIAE.ufolog)('this.parent', this.parent);
                (0, $iKGfn.getGlobalEventStream)().push((0, $3taQr.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $OCIAE.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $dy9vV.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $9IZtV.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $6de9c42a5866f7ac$var$getPageVisibleState();
            (0, $2zZTf.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $OCIAE.ufolog)('subscribed', this.id);
                (0, $iKGfn.getGlobalEventStream)().push((0, $4xdfL.subscribeEvent)((0, $lkCky.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $lkCky.FMP_MARK) && name !== (0, $lkCky.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $dy9vV.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: (0, $5jXJe.perfNowOrTimestamp)(timestamp)
        });
        this.transition((0, $9IZtV.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $lkCky.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $lkCky.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $dy9vV.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $2zZTf.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $9IZtV.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $9IZtV.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $9IZtV.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $OCIAE.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $ddd67f40feddf208$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $ddd67f40feddf208$export$2295b861f318254a = '0.1.5';

parcelRegister("3taQr", function(module, exports) {
$parcel$export(module.exports, "experiencePayloadEvent", () => $ced1d8020f37020e$export$7c957416596ca127);

var $lkCky = parcelRequire("lkCky");
const $ced1d8020f37020e$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $lkCky.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("lkCky", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $56aad3df452b198d$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $56aad3df452b198d$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $56aad3df452b198d$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $56aad3df452b198d$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $56aad3df452b198d$export$837e0f79a8056912);
var $56aad3df452b198d$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $56aad3df452b198d$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $56aad3df452b198d$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $56aad3df452b198d$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $56aad3df452b198d$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $56aad3df452b198d$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $56aad3df452b198d$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $56aad3df452b198d$export$9f2bf58999404c75 = 'fmp';
const $56aad3df452b198d$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("iKGfn", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $52c74e5d22d43ae1$export$6123a44dc2384540);

const $52c74e5d22d43ae1$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < (0, $161c8cfa8193bed5$export$d8b468db8a225bc9)) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};

});
const $161c8cfa8193bed5$export$d8b468db8a225bc9 = 250;


parcelRegister("4xdfL", function(module, exports) {
$parcel$export(module.exports, "subscribeEvent", () => $602666bcc7a174a3$export$37863216db4b714d);

var $lkCky = parcelRequire("lkCky");
const $602666bcc7a174a3$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $lkCky.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("9Xe8y", function(module, exports) {
$parcel$export(module.exports, "unsubscribeEvent", () => $b430211b26a0446f$export$ee1a7bd1fc9ea85e);

var $lkCky = parcelRequire("lkCky");
const $b430211b26a0446f$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $lkCky.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("OCIAE", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $54f6e906639b1566$export$b4958caff08a0960);

var $52xGr = parcelRequire("52xGr");
const $54f6e906639b1566$export$b4958caff08a0960 = (...args)=>{
    (0, $52xGr.ufologger).log(...args);
};

});
parcelRegister("52xGr", function(module, exports) {
$parcel$export(module.exports, "ufologger", () => $7fe61f0bbad71ccd$export$4ab84f6f04f6566d);
class $7fe61f0bbad71ccd$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($7fe61f0bbad71ccd$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($7fe61f0bbad71ccd$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $7fe61f0bbad71ccd$export$4ab84f6f04f6566d = new $7fe61f0bbad71ccd$var$UFOLogger();

});


parcelRegister("dy9vV", function(module, exports) {
$parcel$export(module.exports, "ufowarn", () => $c3ae6aabd4573e14$export$d53d07b6034c4560);

var $52xGr = parcelRequire("52xGr");
const $c3ae6aabd4573e14$export$d53d07b6034c4560 = (...args)=>{
    (0, $52xGr.ufologger).warn(...args);
};

});

parcelRegister("2zZTf", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $83e8064df39210f6$export$13e680397ec8f3eb);

var $lAIjw = parcelRequire("lAIjw");
class $83e8064df39210f6$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $lAIjw.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $83e8064df39210f6$export$13e680397ec8f3eb = new $83e8064df39210f6$var$VisibilityChangeObserver();

});
parcelRegister("lAIjw", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $afb7d62fa5199a0e$export$15e172712955e18f);
const $afb7d62fa5199a0e$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("9IZtV", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $ee674a812fad36a5$export$81b70111112841a0);
const $ee674a812fad36a5$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("4twIG", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $b5add66ec4bed40c$export$178881f329fdb81f);

var $9IZtV = parcelRequire("9IZtV");
const $b5add66ec4bed40c$var$UFOStateAvailableTransitions = {
    [(0, $9IZtV.UFOExperienceState).NOT_STARTED.id]: [
        (0, $9IZtV.UFOExperienceState).STARTED.id
    ],
    [(0, $9IZtV.UFOExperienceState).STARTED.id]: [
        (0, $9IZtV.UFOExperienceState).IN_PROGRESS.id,
        (0, $9IZtV.UFOExperienceState).BLOCKED.id,
        (0, $9IZtV.UFOExperienceState).SUCCEEDED.id,
        (0, $9IZtV.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $9IZtV.UFOExperienceState).FAILED.id,
        (0, $9IZtV.UFOExperienceState).ABORTED.id
    ],
    [(0, $9IZtV.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $9IZtV.UFOExperienceState).BLOCKED.id,
        (0, $9IZtV.UFOExperienceState).SUCCEEDED.id,
        (0, $9IZtV.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $9IZtV.UFOExperienceState).FAILED.id,
        (0, $9IZtV.UFOExperienceState).ABORTED.id
    ],
    [(0, $9IZtV.UFOExperienceState).BLOCKED.id]: [
        (0, $9IZtV.UFOExperienceState).RECOVERED.id,
        (0, $9IZtV.UFOExperienceState).ABORTED.id
    ],
    [(0, $9IZtV.UFOExperienceState).RECOVERED.id]: [
        (0, $9IZtV.UFOExperienceState).STARTED.id,
        (0, $9IZtV.UFOExperienceState).SUCCEEDED.id,
        (0, $9IZtV.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $9IZtV.UFOExperienceState).FAILED.id,
        (0, $9IZtV.UFOExperienceState).ABORTED.id
    ],
    [(0, $9IZtV.UFOExperienceState).SUCCEEDED.id]: [
        (0, $9IZtV.UFOExperienceState).STARTED.id
    ],
    [(0, $9IZtV.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $9IZtV.UFOExperienceState).SUCCEEDED.id,
        (0, $9IZtV.UFOExperienceState).FAILED.id,
        (0, $9IZtV.UFOExperienceState).ABORTED.id
    ],
    [(0, $9IZtV.UFOExperienceState).FAILED.id]: [
        (0, $9IZtV.UFOExperienceState).STARTED.id
    ],
    [(0, $9IZtV.UFOExperienceState).ABORTED.id]: [
        (0, $9IZtV.UFOExperienceState).STARTED.id
    ]
};
const $b5add66ec4bed40c$export$178881f329fdb81f = (state1, state2)=>{
    return $b5add66ec4bed40c$var$UFOStateAvailableTransitions[state1.id] && $b5add66ec4bed40c$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("iV2VP", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $3af2d4248a3fc512$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $3af2d4248a3fc512$export$cc26007c03242fff);
var $3af2d4248a3fc512$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $3af2d4248a3fc512$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("5jXJe", function(module, exports) {
$parcel$export(module.exports, "perfNowOrTimestamp", () => $c36d53027ae56110$export$c753e8669d30c8ad);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $f0JNj = parcelRequire("f0JNj");
const $c36d53027ae56110$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $f0JNj.roundPerfNow)();
};

});
parcelRegister("f0JNj", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $7f744a3d310bdc9b$export$5f490af6b2b115cf);
const $7f744a3d310bdc9b$export$5f490af6b2b115cf = ()=>~~performance.now();

});





parcelRegister("hvMAG", function(module, exports) {
$parcel$export(module.exports, "getOwningTeam", () => $1f22bbd94ebc2ee9$export$d6e429d0895093);
/**
 * Determines the owning team for a failure event based on the experience task name,
 * error message, and optional attributes (e.g. actionKey).
 *
 * The rules are derived from the AIFC Top Baseline Errors report and use regex matching
 * to handle error messages that contain dynamic values (UUIDs, IDs, hashes, etc).
 *
 * @see https://hello.atlassian.net/wiki/spaces/ac8/pages/6822974693/Apr+13-14+2026+-+AIFC+Top+Baseline+Errors
 */ 
var $kKZTv = parcelRequire("kKZTv");
var $1f22bbd94ebc2ee9$export$e196c5257e9c94dd = /*#__PURE__*/ function(OwningTeam) {
    OwningTeam["AifcFoundations"] = "AIFC Foundations";
    OwningTeam["EditorAi"] = "Editor AI";
    OwningTeam["RovoChat"] = "Rovo Chat";
    OwningTeam["Whiteboards"] = "Whiteboards";
    OwningTeam["Databases"] = "Databases";
    OwningTeam["JiraAifc"] = "Jira AIFC";
    OwningTeam["Pulsar"] = "Pulsar";
    return OwningTeam;
}({});
/**
 * Step 1 — Experience-specific error rules.
 * These are checked first and only when the experience name matches.
 */ const $1f22bbd94ebc2ee9$var$RULES_FOR_SPECIFIC_EXPERIENCES = [
    {
        pattern: /Something went wrong on Rovo's end. Please try sending your message again./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $kKZTv.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*whiteboard/i,
        team: "Whiteboards",
        experiences: [
            (0, $kKZTv.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*database/i,
        team: "Databases",
        experiences: [
            (0, $kKZTv.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*page/i,
        team: "AIFC Foundations",
        experiences: [
            (0, $kKZTv.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The orchestrator reached its depth limit and the ConfluenceCreationTool was not invoked./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $kKZTv.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /Could not create content of type \w+ in the Confluence staging area./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $kKZTv.ExperienceName).AIFC_GENERATE_CONTENT,
            (0, $kKZTv.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
        ]
    },
    {
        pattern: /Message action error: [Code 400] convoai.rest.bad.request - Failed to update page: missing pageId and ADF content for actionKey:.*/i,
        team: "AIFC Foundations",
        experiences: [
            (0, $kKZTv.ExperienceName).AIFC_UPDATE_CONTENT
        ]
    },
    {
        pattern: /Message action error: [Code 400] convoai.rest.bad.request - Failed to update page: missing pageId and ADF content for actionKey:.*/i,
        team: "Editor AI",
        experiences: [
            (0, $kKZTv.ExperienceName).UPDATE_CONTENT_IN_CHAT
        ]
    },
    {
        pattern: /AIFC stream received edit tags but no elements were affected/i,
        team: "Whiteboards",
        experiences: [
            (0, $kKZTv.ExperienceName).AIFC_UPDATE_CONTENT
        ]
    }
];
/**
 * Step 2 — Global error rules that apply across all experiences.
 */ const $1f22bbd94ebc2ee9$var$GLOBAL_ERROR_MESSAGE_RULES = [
    {
        pattern: /network error/i,
        team: "Rovo Chat"
    },
    {
        pattern: /An error occurred. Please try again later./i,
        team: "Rovo Chat"
    },
    {
        pattern: /Failed to fetch/i,
        team: "Rovo Chat"
    },
    {
        pattern: /An unknown error occurred/i,
        team: "Rovo Chat"
    },
    {
        pattern: /\[Code 403\] {"code":403,"message":"You're unable to access content because your IP address is not listed in the IP allowlist. Contact your admin for help."}/i,
        team: "Rovo Chat"
    },
    {
        pattern: /AIFC stream received only preamble but no <todo_list>, SVG or whiteboards XML.*/i,
        team: "Whiteboards"
    },
    {
        pattern: /No sizing converter defined for element type 'mindmap'/i,
        team: "Whiteboards"
    },
    {
        pattern: /AIFC stream received edit tags but no elements were affected/i,
        team: "Whiteboards"
    },
    {
        pattern: /Could not find database:/i,
        team: "Databases"
    }
];
/**
 * Step 3 — Default team ownership per experience.
 * Used as a fallback when no error-pattern rule matches.
 */ const $1f22bbd94ebc2ee9$var$DEFAULT_TEAM_FOR_EXPERIENCE = new Map([
    [
        (0, $kKZTv.ExperienceName).AIFC_FINALIZE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $kKZTv.ExperienceName).AIFC_ALL_DATA_HANDLED,
        "AIFC Foundations"
    ],
    [
        (0, $kKZTv.ExperienceName).AIFC_GENERATE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $kKZTv.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT,
        "AIFC Foundations"
    ],
    [
        (0, $kKZTv.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        "AIFC Foundations"
    ],
    [
        (0, $kKZTv.ExperienceName).AIFC_MODAL_SESSION,
        "AIFC Foundations"
    ],
    [
        (0, $kKZTv.ExperienceName).AIFC_UPDATE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $kKZTv.ExperienceName).UPDATE_CONTENT_IN_CHAT,
        "Editor AI"
    ],
    [
        (0, $kKZTv.ExperienceName).PREVIEW_CARD_RENDER,
        "AIFC Foundations"
    ],
    [
        (0, $kKZTv.ExperienceName).PREVIEW_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $kKZTv.ExperienceName).SEND_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $kKZTv.ExperienceName).SEND_TASK_MODE_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $kKZTv.ExperienceName).SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $kKZTv.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_UNIFIED,
        "Rovo Chat"
    ],
    [
        (0, $kKZTv.ExperienceName).LOAD_CHAT_PROMPT_INPUT_SKILLS,
        "Rovo Chat"
    ],
    [
        (0, $kKZTv.ExperienceName).LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS,
        "Rovo Chat"
    ],
    [
        (0, $kKZTv.ExperienceName).JIRA_SAVE_DRAFT_WORK_ITEM,
        "Jira AIFC"
    ],
    [
        (0, $kKZTv.ExperienceName).JIRA_CREATE_WORK_ITEMS_BULK,
        "Jira AIFC"
    ],
    [
        (0, $kKZTv.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_CREATE,
        "Jira AIFC"
    ],
    [
        (0, $kKZTv.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE,
        "Jira AIFC"
    ],
    [
        (0, $kKZTv.ExperienceName).SHARE_ARTIFACT_ACCESS_CHANGE,
        "Rovo Chat"
    ],
    [
        (0, $kKZTv.ExperienceName).SHARE_ARTIFACT_SHARE_AUDIENCES,
        "Rovo Chat"
    ],
    [
        (0, $kKZTv.ExperienceName).SHARE_ARTIFACT_REVOKE_AUDIENCES,
        "Rovo Chat"
    ],
    [
        (0, $kKZTv.ExperienceName).DOWNLOAD_ARTIFACT,
        "Rovo Chat"
    ],
    [
        (0, $kKZTv.ExperienceName).PREVIEW_ARTIFACT_SMART_LINK_RESOLVED,
        "Rovo Chat"
    ],
    [
        (0, $kKZTv.ExperienceName).SHARE_CONVERSATION_SESSION,
        "Rovo Chat"
    ],
    [
        (0, $kKZTv.ExperienceName).MANAGE_CONVERSATION_SHARES,
        "Rovo Chat"
    ],
    [
        (0, $kKZTv.ExperienceName).VIEW_CONVERSATION_SHARE,
        "Rovo Chat"
    ],
    [
        (0, $kKZTv.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_UPDATE,
        "Pulsar"
    ],
    [
        (0, $kKZTv.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_UPDATE,
        "Pulsar"
    ]
]);
const $1f22bbd94ebc2ee9$export$d6e429d0895093 = (errorMessage, experienceName)=>{
    if (!errorMessage) return $1f22bbd94ebc2ee9$var$DEFAULT_TEAM_FOR_EXPERIENCE.get(experienceName);
    // Step 1: Experience-specific error-pattern rules
    if (experienceName) for (const rule of $1f22bbd94ebc2ee9$var$RULES_FOR_SPECIFIC_EXPERIENCES){
        if (rule.experiences.includes(experienceName) && rule.pattern.test(errorMessage)) return rule.team;
    }
    // Step 2: Global error-pattern rules
    for (const rule of $1f22bbd94ebc2ee9$var$GLOBAL_ERROR_MESSAGE_RULES){
        if (rule.pattern.test(errorMessage)) return rule.team;
    }
    // Step 3: Default team for this experience
    if (experienceName) return $1f22bbd94ebc2ee9$var$DEFAULT_TEAM_FOR_EXPERIENCE.get(experienceName);
    return undefined;
};

});

parcelRegister("3tjvX", function(module, exports) {
$parcel$export(module.exports, "REMIX_EXPERIENCES", () => $95d1567dce7c2249$export$2c3914d94a6bf2e3);

var $kKZTv = parcelRequire("kKZTv");
const $95d1567dce7c2249$export$2c3914d94a6bf2e3 = [
    (0, $kKZTv.ExperienceName).REMIX_START,
    (0, $kKZTv.ExperienceName).REMIX_AIFC_HANDOFF,
    (0, $kKZTv.ExperienceName).REMIX_RENDERS_IN_MODAL,
    (0, $kKZTv.ExperienceName).REMIX_CREATE,
    (0, $kKZTv.ExperienceName).REMIX_OPEN_MENU,
    (0, $kKZTv.ExperienceName).REMIX_REGENERATE,
    (0, $kKZTv.ExperienceName).REMIX_INSERT,
    (0, $kKZTv.ExperienceName).REMIX_PASTE,
    (0, $kKZTv.ExperienceName).REMIX_COPY_FROM_PREVIEW,
    (0, $kKZTv.ExperienceName).REMIX_DIAGRAM_PASTE_FINALIZE,
    (0, $kKZTv.ExperienceName).REMIX_DUPLICATE_APP
];

});

parcelRegister("8YfAb", function(module, exports) {
$parcel$export(module.exports, "TabVisibilityTracker", () => $e0e72c6cadde48b9$export$79c3dc6f15d36f18);
class $e0e72c6cadde48b9$export$79c3dc6f15d36f18 {
    constructor(doc){
        this.totalHiddenMs = 0;
        this.startTime = performance.now();
        const isHidden = doc?.visibilityState === 'hidden';
        this.lastHiddenAt = isHidden ? this.startTime : null;
        this.firstHiddenOffsetMs = isHidden ? 0 : null;
    }
    onVisibilityChange(isHidden) {
        const now = performance.now();
        if (isHidden) {
            if (this.lastHiddenAt === null) this.lastHiddenAt = now;
            if (this.firstHiddenOffsetMs === null) this.firstHiddenOffsetMs = now - this.startTime;
        } else if (this.lastHiddenAt !== null) {
            this.totalHiddenMs += now - this.lastHiddenAt;
            this.lastHiddenAt = null;
        }
    }
    getAttributes(doc) {
        const now = performance.now();
        const elapsed = now - this.startTime;
        let totalHiddenMs = this.totalHiddenMs;
        if (this.lastHiddenAt !== null) totalHiddenMs += now - this.lastHiddenAt;
        const tabHiddenProportion = elapsed > 0 ? totalHiddenMs / elapsed : 0;
        return {
            isActiveTab: doc ? doc.visibilityState === 'visible' : true,
            tabHiddenProportion: tabHiddenProportion,
            tabFirstHiddenOffsetMs: this.firstHiddenOffsetMs
        };
    }
}

});


const $c0bb806f19dcd148$export$e0744546db5b6189 = 'rovo_chat_sites_source_filter';

parcelRegister("fVYJM", function(module, exports) {
$parcel$export(module.exports, "isSSEMessage", () => $4afb5ab9f678249f$export$f78edfe5a93b58af);
$parcel$export(module.exports, "ACCEPTABLE_USE_VIOLATIONS_ERROR", () => $4afb5ab9f678249f$export$c424fe9570a5f2d9);
$parcel$export(module.exports, "RESPONSE_TONES", () => $4afb5ab9f678249f$export$c162f3e7456e473f);
$parcel$export(module.exports, "RESPONSE_LENGTHS", () => $4afb5ab9f678249f$export$a461d78149e66005);
$parcel$export(module.exports, "RESPONSE_STRUCTURES", () => $4afb5ab9f678249f$export$42a434f431015fce);
$parcel$export(module.exports, "RESPONSE_EMOJIS", () => $4afb5ab9f678249f$export$312f4aeec9b65640);
$parcel$export(module.exports, "RESPONSE_TLDR_OPTIONS", () => $4afb5ab9f678249f$export$f3430750c3a3992d);
$parcel$export(module.exports, "THIRD_PARTY_PROMPT_SOURCE_CONTENT_TYPE", () => $4afb5ab9f678249f$export$7fe06c6ae176663);
$parcel$export(module.exports, "normalizeEntityAnnotationsMessage", () => $4afb5ab9f678249f$export$d6de2556d50e53b4);
$parcel$export(module.exports, "isHumanMessage", () => $4afb5ab9f678249f$export$a69fab2afb88c2eb);
$parcel$export(module.exports, "isAssistantMessage", () => $4afb5ab9f678249f$export$6f965deda7f0960c);
$parcel$export(module.exports, "isStreamResponse", () => $4afb5ab9f678249f$export$b4631726cbc1440a);
$parcel$export(module.exports, "isSharedSnapshotMessage", () => $4afb5ab9f678249f$export$1af37a4715539580);
$parcel$export(module.exports, "isAgentResponse", () => $4afb5ab9f678249f$export$a6e5100ca2770191);
$parcel$export(module.exports, "isStreamMessageWithMessage", () => $4afb5ab9f678249f$export$2403e128f2e81f8f);
$parcel$export(module.exports, "isInProgressStreamResponse", () => $4afb5ab9f678249f$export$5c1c15675df13ae5);
$parcel$export(module.exports, "isStreamInteractionConclusion", () => $4afb5ab9f678249f$export$2d3cb9d520902824);
$parcel$export(module.exports, "isStreamError", () => $4afb5ab9f678249f$export$d422a2733a3b5def);
$parcel$export(module.exports, "isStreamAUPError", () => $4afb5ab9f678249f$export$1e1cf807ece63df4);
$parcel$export(module.exports, "isStreamAnswerPart", () => $4afb5ab9f678249f$export$e45102edbc73b240);
$parcel$export(module.exports, "isStreamAnswerUiPart", () => $4afb5ab9f678249f$export$a29b8eb13b54e91f);
$parcel$export(module.exports, "isStreamAnswerUiContent", () => $4afb5ab9f678249f$export$eee53d3475c29169);
$parcel$export(module.exports, "isStreamEntityAnnotations", () => $4afb5ab9f678249f$export$6fb760a9d35f0551);
$parcel$export(module.exports, "isStreamReasoningPart", () => $4afb5ab9f678249f$export$51a109436d382715);
$parcel$export(module.exports, "isStreamActionPart", () => $4afb5ab9f678249f$export$dbf4211c9117b9bc);
$parcel$export(module.exports, "isStreamActionClassification", () => $4afb5ab9f678249f$export$3d7b0b359441d5a6);
$parcel$export(module.exports, "isStreamActionPrepare", () => $4afb5ab9f678249f$export$584e11c2903f4ed6);
$parcel$export(module.exports, "isStreamActionComplete", () => $4afb5ab9f678249f$export$7d94ce53d589f586);
$parcel$export(module.exports, "isStreamAutoActionApproval", () => $4afb5ab9f678249f$export$9082a8e48d820016);
$parcel$export(module.exports, "isStreamResearchStart", () => $4afb5ab9f678249f$export$abec64f24e2ec3e7);
$parcel$export(module.exports, "isStreamResearchBeginningTrace", () => $4afb5ab9f678249f$export$9c1f93971e9e3fbe);
$parcel$export(module.exports, "isStreamResearchStepContent", () => $4afb5ab9f678249f$export$79a0ed7d987faa8f);
$parcel$export(module.exports, "isStreamResearchStepTitle", () => $4afb5ab9f678249f$export$7b1c8227569f1a92);
$parcel$export(module.exports, "isStreamResearchPlan", () => $4afb5ab9f678249f$export$cde91b49af35d559);
$parcel$export(module.exports, "isStreamTodoSnapshot", () => $4afb5ab9f678249f$export$4a6a601f69cf3c74);
$parcel$export(module.exports, "isStreamTaskStatus", () => $4afb5ab9f678249f$export$6b0058543411cb3a);
$parcel$export(module.exports, "isStreamConciergeAgentSelected", () => $4afb5ab9f678249f$export$5cfcb66b0fc392d6);
$parcel$export(module.exports, "isStreamResearchStepTitleShort", () => $4afb5ab9f678249f$export$ac74da022f74040a);
$parcel$export(module.exports, "isStreamSkillStart", () => $4afb5ab9f678249f$export$7898cc38956b9052);
$parcel$export(module.exports, "isStreamSkillEnd", () => $4afb5ab9f678249f$export$bb608d13a1268633);
$parcel$export(module.exports, "isStreamFastModeResponseAvailable", () => $4afb5ab9f678249f$export$b65c73c7e2d8d96f);
$parcel$export(module.exports, "isStreamFastModeEnabled", () => $4afb5ab9f678249f$export$40cf419186312161);
$parcel$export(module.exports, "isStreamRemoveAnswerNow", () => $4afb5ab9f678249f$export$a83708fc4401682d);
$parcel$export(module.exports, "isStreamResearchStepSource", () => $4afb5ab9f678249f$export$68192da24ac8c141);
$parcel$export(module.exports, "isStreamResearchStepCompleted", () => $4afb5ab9f678249f$export$cfccfd17b68ccb0);
$parcel$export(module.exports, "isStreamResearchStepIcons", () => $4afb5ab9f678249f$export$1fd230d6956c2575);
$parcel$export(module.exports, "isStreamResearchStepDocument", () => $4afb5ab9f678249f$export$3bc697eeff31bdf6);
$parcel$export(module.exports, "isStreamReconnectSupportPart", () => $4afb5ab9f678249f$export$c679ee34f7312895);
$parcel$export(module.exports, "isStreamResearchPayload", () => $4afb5ab9f678249f$export$46e0fb5e4b019a49);
$parcel$export(module.exports, "isStreamSkill", () => $4afb5ab9f678249f$export$6f74311d40862a9f);
$parcel$export(module.exports, "isStreamMemoryUpdate", () => $4afb5ab9f678249f$export$d95e474df0d530df);
$parcel$export(module.exports, "isStreamTrace", () => $4afb5ab9f678249f$export$fd5a05be03f147a0);
$parcel$export(module.exports, "isStreamThinkDeeperTriggered", () => $4afb5ab9f678249f$export$682514f3a8131b98);
$parcel$export(module.exports, "isFollowUpMessage", () => $4afb5ab9f678249f$export$aeae5b4fda357302);
$parcel$export(module.exports, "isStreamAgenticUi", () => $4afb5ab9f678249f$export$6275ff996073145e);
$parcel$export(module.exports, "isStreamHeartbeat", () => $4afb5ab9f678249f$export$b46beea5c82aa1b9);
$parcel$export(module.exports, "isActionExecutedSuccessfully", () => $4afb5ab9f678249f$export$b8391261162989d9);
$parcel$export(module.exports, "isActionResolutionCancelled", () => $4afb5ab9f678249f$export$1060c4fa97e34fa7);
$parcel$export(module.exports, "isChannelNotFoundError", () => $4afb5ab9f678249f$export$6ce1ccc24e75456f);
$parcel$export(module.exports, "isStreamActionError", () => $4afb5ab9f678249f$export$c3c933dad2745d3f);
$parcel$export(module.exports, "isRateLimitedError", () => $4afb5ab9f678249f$export$bc96a6a479480590);
$parcel$export(module.exports, "isHipaaError", () => $4afb5ab9f678249f$export$f8b1b75846492611);
$parcel$export(module.exports, "isAUPViolationError", () => $4afb5ab9f678249f$export$d263dc5d64f36d48);
$parcel$export(module.exports, "isConversationChannelDataMessage", () => $4afb5ab9f678249f$export$b454081350f4a578);
$parcel$export(module.exports, "isScopeDeterminedMessage", () => $4afb5ab9f678249f$export$145ab74998a54a20);
$parcel$export(module.exports, "isSpaceSourceRecommendationsMessage", () => $4afb5ab9f678249f$export$75ceabc5bb9500e4);
$parcel$export(module.exports, "isStreamPromptRedaction", () => $4afb5ab9f678249f$export$f4111656f23d9b9b);
$parcel$export(module.exports, "isStreamPromptBlock", () => $4afb5ab9f678249f$export$c43cf9ba6a2176ef);
$parcel$export(module.exports, "isStreamResponseRedaction", () => $4afb5ab9f678249f$export$f16ff8eb19967a97);
$parcel$export(module.exports, "isStreamResponseBlock", () => $4afb5ab9f678249f$export$55f7bd80eacbc51b);
$parcel$export(module.exports, "isStreamAttachmentBlock", () => $4afb5ab9f678249f$export$a1be74470d3c1fe9);
$parcel$export(module.exports, "isConfirmAction", () => $4afb5ab9f678249f$export$4af48296a8d61cec);

var $3ioMM = parcelRequire("3ioMM");

var $d1B6S = parcelRequire("d1B6S");
const $4afb5ab9f678249f$export$f78edfe5a93b58af = (message)=>{
    return message !== null && typeof message === 'object' && '__isSSEWrapper' in message && message.__isSSEWrapper === true;
};
const $4afb5ab9f678249f$export$5945515082cc2cbf = 'convoai.rest.not.found';
const $4afb5ab9f678249f$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
const $4afb5ab9f678249f$export$c162f3e7456e473f = [
    'rovo_default',
    'professional',
    'creative',
    'empathetic'
];
const $4afb5ab9f678249f$export$a461d78149e66005 = [
    'shorter',
    'neutral',
    'longer'
];
const $4afb5ab9f678249f$export$42a434f431015fce = [
    'less_structured',
    'neutral',
    'more_structured'
];
const $4afb5ab9f678249f$export$312f4aeec9b65640 = [
    'none',
    'neutral',
    'more'
];
const $4afb5ab9f678249f$export$f3430750c3a3992d = [
    'enabled',
    'disabled'
];
var $4afb5ab9f678249f$export$2e28f9aa1dcf9823 = /*#__PURE__*/ function(PromptCategory) {
    PromptCategory["ANALYZE"] = "Analyze";
    PromptCategory["BRAINSTORM"] = "Brainstorm";
    PromptCategory["REVIEW"] = "Review";
    PromptCategory["SUMMARIZE"] = "Summarize";
    PromptCategory["CREATE"] = "Create";
    PromptCategory["EXECUTE"] = "Execute";
    PromptCategory["FIND"] = "Find";
    PromptCategory["LEARN"] = "Learn";
    return PromptCategory;
}({});
var $4afb5ab9f678249f$export$bd1535eb0caf2683 = /*#__PURE__*/ function(PromptRole) {
    PromptRole["GENERAL"] = "General";
    PromptRole["ENGINEERING"] = "Engineering";
    PromptRole["PRODUCT"] = "Product";
    PromptRole["PROGRAM_MANAGEMENT"] = "Program Management";
    PromptRole["DESIGN"] = "Design";
    PromptRole["MARKETING"] = "Marketing";
    PromptRole["IT_OPS"] = "IT Ops";
    PromptRole["SALES"] = "Sales";
    PromptRole["CUSTOMER_SUPPORT"] = "Customer Support";
    PromptRole["HELPDESK_SUPPORT"] = "Helpdesk Support";
    PromptRole["SECURITY"] = "Security";
    return PromptRole;
}({});
const $4afb5ab9f678249f$export$77c9504201bdfdea = 'PROMPT_TILE';
const $4afb5ab9f678249f$export$7fe06c6ae176663 = 'third-party';
const $4afb5ab9f678249f$export$31883fad14b55ba5 = 'FINAL_RESPONSE';
const $4afb5ab9f678249f$var$entityTypeMap = {
    person: 'Person',
    Person: 'Person',
    inferred_project: 'InferredProject',
    InferredProject: 'InferredProject'
};
const $4afb5ab9f678249f$export$d6de2556d50e53b4 = (message)=>({
        sentence: message.sentence,
        entities: message.entities.map((entity)=>({
                type: $4afb5ab9f678249f$var$entityTypeMap[entity.type],
                mention: entity.mention,
                start: entity.start,
                end: entity.end,
                ari: entity.ari,
                canonicalName: entity.canonical_name,
                confidenceScore: entity.confidence_score
            }))
    });
const $4afb5ab9f678249f$export$fb661125ffb29bd6 = (message)=>{
    return $4afb5ab9f678249f$export$a69fab2afb88c2eb(message) || $4afb5ab9f678249f$export$6f965deda7f0960c(message) || $4afb5ab9f678249f$export$b4631726cbc1440a(message);
};
const $4afb5ab9f678249f$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $4afb5ab9f678249f$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $4afb5ab9f678249f$export$1af37a4715539580 = (message)=>Boolean(message.message_metadata?.sharedFromMessageId);
const $4afb5ab9f678249f$export$a6e5100ca2770191 = (message)=>message instanceof Object && $4afb5ab9f678249f$export$6f965deda7f0960c(message.message);
const $4afb5ab9f678249f$export$2403e128f2e81f8f = (message)=>message instanceof Object && message.message instanceof Object;
const $4afb5ab9f678249f$export$5c1c15675df13ae5 = (message)=>$4afb5ab9f678249f$export$b4631726cbc1440a(message) && message.message?.message?.async_status === 'IN_PROGRESS';
const $4afb5ab9f678249f$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $4afb5ab9f678249f$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $4afb5ab9f678249f$var$isOptionalNullableString = (value)=>value === undefined || value === null || typeof value === 'string';
const $4afb5ab9f678249f$export$2d3cb9d520902824 = (message)=>{
    if (!$4afb5ab9f678249f$var$isRecord(message) || message.type !== 'INTERACTION_CONCLUSION' || !$4afb5ab9f678249f$var$isRecord(message.message) || message.message.outcome !== 'SUCCEEDED' && message.message.outcome !== 'FAILED') return false;
    if (message.millisOffset !== undefined && typeof message.millisOffset !== 'number') return false;
    if (message.metadata != null && (!$4afb5ab9f678249f$var$isRecord(message.metadata) || !$4afb5ab9f678249f$var$isOptionalNullableString(message.metadata.request_id) || !$4afb5ab9f678249f$var$isOptionalNullableString(message.metadata.message_id))) return false;
    return true;
};
const $4afb5ab9f678249f$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $4afb5ab9f678249f$export$1e1cf807ece63df4 = (message)=>$4afb5ab9f678249f$export$d422a2733a3b5def(message) && message.message?.message_template === $4afb5ab9f678249f$export$c424fe9570a5f2d9;
const $4afb5ab9f678249f$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $4afb5ab9f678249f$var$isNonEmptyString = (value)=>typeof value === 'string' && value.length > 0;
const $4afb5ab9f678249f$export$a29b8eb13b54e91f = (message)=>$4afb5ab9f678249f$var$isRecord(message) && message.type === 'ANSWER_UI_PART' && $4afb5ab9f678249f$var$isNonEmptyString(message.part_id);
const $4afb5ab9f678249f$export$eee53d3475c29169 = (message)=>{
    if (!$4afb5ab9f678249f$var$isRecord(message) || message.type !== 'ANSWER_UI_CONTENT' || !$4afb5ab9f678249f$var$isNonEmptyString(message.part_id)) return false;
    if (message.state === 'failed') return true;
    return message.state === 'ready' && $4afb5ab9f678249f$var$isRecord(message.message) && message.message.format === 'lumina_v1' && $4afb5ab9f678249f$var$isNonEmptyString(message.message.content);
};
const $4afb5ab9f678249f$var$isRawEntityAnnotation = (value)=>$4afb5ab9f678249f$var$isRecord(value) && (value.type === 'person' || value.type === 'Person' || value.type === 'inferred_project' || value.type === 'InferredProject') && typeof value.mention === 'string' && typeof value.start === 'number' && Number.isFinite(value.start) && typeof value.end === 'number' && Number.isFinite(value.end) && typeof value.ari === 'string' && typeof value.canonical_name === 'string' && typeof value.confidence_score === 'number' && Number.isFinite(value.confidence_score);
const $4afb5ab9f678249f$export$6fb760a9d35f0551 = (message)=>$4afb5ab9f678249f$var$isRecord(message) && message.type === 'ENTITY_ANNOTATIONS' && $4afb5ab9f678249f$var$isRecord(message.message) && typeof message.message.sentence === 'string' && Array.isArray(message.message.entities) && message.message.entities.every($4afb5ab9f678249f$var$isRawEntityAnnotation);
const $4afb5ab9f678249f$export$51a109436d382715 = (message)=>message instanceof Object && message.type === 'REASONING_PART';
const $4afb5ab9f678249f$export$dbf4211c9117b9bc = (message)=>message instanceof Object && message.type === 'ACTION_PART';
const $4afb5ab9f678249f$export$3d7b0b359441d5a6 = (message)=>message instanceof Object && message.type === 'ACTION_CLASSIFICATION';
const $4afb5ab9f678249f$export$584e11c2903f4ed6 = (message)=>message instanceof Object && message.type === 'ACTION_PREPARE';
const $4afb5ab9f678249f$export$7d94ce53d589f586 = (message)=>message instanceof Object && message.type === 'ACTION_COMPLETE';
const $4afb5ab9f678249f$var$AUTO_ACTION_APPROVAL_STATUSES = new Set([
    'REVIEWING',
    'AUTO_APPROVED',
    'AUTO_APPROVED_REQUIRES_HUMAN',
    'REQUIRES_HUMAN'
]);
const $4afb5ab9f678249f$var$isNullableString = (value)=>value === null || typeof value === 'string';
const $4afb5ab9f678249f$export$9082a8e48d820016 = (message)=>{
    if (!$4afb5ab9f678249f$var$isRecord(message) || message.type !== 'AUTO_ACTION_APPROVAL' || !$4afb5ab9f678249f$var$isRecord(message.message)) return false;
    const payload = message.message;
    const metadataIsValid = message.metadata === undefined || message.metadata === null || $4afb5ab9f678249f$var$isRecord(message.metadata) && (message.metadata.request_id === undefined || $4afb5ab9f678249f$var$isNullableString(message.metadata.request_id));
    const sequenceIdIsValid = message.sequence_id === undefined || typeof message.sequence_id === 'string';
    return typeof message.millisOffset === 'number' && Number.isFinite(message.millisOffset) && typeof payload.content === 'string' && typeof payload.status === 'string' && $4afb5ab9f678249f$var$AUTO_ACTION_APPROVAL_STATUSES.has(payload.status) && typeof payload.action_display_name === 'string' && typeof payload.tool_name === 'string' && $4afb5ab9f678249f$var$isNullableString(payload.action_key) && $4afb5ab9f678249f$var$isNullableString(payload.reason) && typeof payload.source === 'string' && typeof payload.risk_category === 'string' && typeof payload.policy_version === 'string' && $4afb5ab9f678249f$var$isNullableString(payload.model_id) && metadataIsValid && sequenceIdIsValid;
};
const $4afb5ab9f678249f$export$abec64f24e2ec3e7 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_START';
const $4afb5ab9f678249f$export$9c1f93971e9e3fbe = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $4afb5ab9f678249f$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $4afb5ab9f678249f$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $4afb5ab9f678249f$export$cde91b49af35d559 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_PLAN';
const $4afb5ab9f678249f$export$4a6a601f69cf3c74 = (message)=>message instanceof Object && message.type === 'TODO_SNAPSHOT';
const $4afb5ab9f678249f$export$6b0058543411cb3a = (message)=>message instanceof Object && message.type === 'TASK_STATUS';
const $4afb5ab9f678249f$export$5cfcb66b0fc392d6 = (message)=>typeof message === 'object' && message !== null && 'type' in message && message.type === 'CONCIERGE_AGENT_SELECTED';
const $4afb5ab9f678249f$export$ac74da022f74040a = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT';
const $4afb5ab9f678249f$export$7898cc38956b9052 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_START';
const $4afb5ab9f678249f$export$bb608d13a1268633 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_END';
const $4afb5ab9f678249f$export$b65c73c7e2d8d96f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_RESPONSE_AVAILABLE';
const $4afb5ab9f678249f$export$40cf419186312161 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_ENABLED';
const $4afb5ab9f678249f$export$a83708fc4401682d = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'REMOVE_ANSWER_NOW';
const $4afb5ab9f678249f$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $4afb5ab9f678249f$export$cfccfd17b68ccb0 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $4afb5ab9f678249f$export$1fd230d6956c2575 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_ICONS';
const $4afb5ab9f678249f$export$3bc697eeff31bdf6 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_DOCUMENT';
const $4afb5ab9f678249f$export$c679ee34f7312895 = (message)=>message instanceof Object && message.type === 'RECONNECT_SUPPORTED';
const $4afb5ab9f678249f$export$46e0fb5e4b019a49 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE' || message.message.message_template === 'RESEARCH_STEP_ICONS' || message.message.message_template === 'RESEARCH_STEP_DOCUMENT');
const $4afb5ab9f678249f$export$6f74311d40862a9f = (message)=>message instanceof Object && message.type === 'TRACE' && ($4afb5ab9f678249f$export$7898cc38956b9052(message) || $4afb5ab9f678249f$export$bb608d13a1268633(message));
const $4afb5ab9f678249f$export$d95e474df0d530df = (message)=>message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'MEMORY_UPDATE';
const $4afb5ab9f678249f$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($4afb5ab9f678249f$export$46e0fb5e4b019a49(message)) return false;
    if ($4afb5ab9f678249f$export$cde91b49af35d559(message)) return false;
    if ($4afb5ab9f678249f$export$6f74311d40862a9f(message)) return false;
    if ($4afb5ab9f678249f$export$b65c73c7e2d8d96f(message)) return false;
    if ($4afb5ab9f678249f$export$682514f3a8131b98(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $4afb5ab9f678249f$export$682514f3a8131b98 = (message)=>{
    return message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'THINK_DEEPER_TRIGGERED';
};
const $4afb5ab9f678249f$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $4afb5ab9f678249f$export$6275ff996073145e = (message)=>{
    if (!$4afb5ab9f678249f$export$f78edfe5a93b58af(message) || message.eventType !== 'AGENTIC_UI') return false;
    if (message.data === null || typeof message.data !== 'object') return false;
    const data = message.data;
    return Array.isArray(data.message?.content);
};
const $4afb5ab9f678249f$export$b46beea5c82aa1b9 = (message)=>message instanceof Object && message.type === 'HEART_BEAT';
const $4afb5ab9f678249f$export$b8391261162989d9 = (message)=>$4afb5ab9f678249f$export$6f965deda7f0960c(message) && (message?.message_metadata?.is_action_execution ?? false) && message?.message_metadata?.action_execution_result === 'SUCCESS';
const $4afb5ab9f678249f$export$1060c4fa97e34fa7 = (payloadContext)=>{
    return payloadContext?.resolution?.type === 'cancel';
};
const $4afb5ab9f678249f$export$6ce1ccc24e75456f = (error)=>(0, $d1B6S.isApiError)(error) && error.errorAttributes?.errorCode === $4afb5ab9f678249f$export$5945515082cc2cbf;
const $4afb5ab9f678249f$export$c3c933dad2745d3f = (msg)=>msg && msg.type === 'ACTION_ERROR' && msg.message && msg.message.status === 'ERRORED';
const $4afb5ab9f678249f$export$bc96a6a479480590 = (error)=>(0, $d1B6S.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $4afb5ab9f678249f$export$f8b1b75846492611 = (error)=>(0, $d1B6S.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $3ioMM.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $4afb5ab9f678249f$export$d263dc5d64f36d48 = (error)=>error instanceof Object && error?.detail?.type === 'ERROR' && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === $4afb5ab9f678249f$export$c424fe9570a5f2d9;
const $4afb5ab9f678249f$export$b454081350f4a578 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
const $4afb5ab9f678249f$export$145ab74998a54a20 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'SCOPE_DETERMINED';
const $4afb5ab9f678249f$export$75ceabc5bb9500e4 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'SPACE_SOURCE_RECOMMENDATIONS' && message.message instanceof Object;
const $4afb5ab9f678249f$export$f4111656f23d9b9b = (message)=>message instanceof Object && (message.type === 'PROMPT_REDACTION' || message.type === 'PROMPT_REDACTED');
const $4afb5ab9f678249f$export$c43cf9ba6a2176ef = (message)=>message instanceof Object && (message.type === 'PROMPT_BLOCKED' || message.type === 'PROMPT_BLOCK');
const $4afb5ab9f678249f$export$f16ff8eb19967a97 = (message)=>message instanceof Object && message.type === 'RESPONSE_REDACTION';
const $4afb5ab9f678249f$export$55f7bd80eacbc51b = (message)=>message instanceof Object && message.type === 'RESPONSE_BLOCKED';
const $4afb5ab9f678249f$export$a1be74470d3c1fe9 = (message)=>message instanceof Object && message.type === 'ATTACHMENT_BLOCKED';
function $4afb5ab9f678249f$export$4af48296a8d61cec(payloadContext) {
    return payloadContext?.resolution?.type === 'confirm';
}

});
parcelRegister("3ioMM", function(module, exports) {
$parcel$export(module.exports, "AI_MATE_EXPERIENCE_ID", () => $e747fa6857beed64$export$e8114853eca81277);
$parcel$export(module.exports, "ASSISTANCE_SERVICE_ERROR_CODES", () => $e747fa6857beed64$export$1106bf31edf2a9b8);
$parcel$export(module.exports, "STATUS_CODES", () => $e747fa6857beed64$export$333e4f57333eadfa);
const $e747fa6857beed64$export$e8114853eca81277 = 'ai-mate';
const $e747fa6857beed64$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    AGENT_FORBIDDEN: 'convoai.rest.agent-forbidden',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $e747fa6857beed64$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415,
    FILE_RAI_POLICY_VIOLATION: 406
};

});

parcelRegister("d1B6S", function(module, exports) {
$parcel$export(module.exports, "ApiError", () => $e700666f15a610ba$export$f2e832acab1bdd79);
$parcel$export(module.exports, "isApiError", () => $e700666f15a610ba$export$89d83cc97c52a37);
$parcel$export(module.exports, "getPinnedConversationLimitErrorData", () => $e700666f15a610ba$export$45f7ada0fbd007df);
$parcel$export(module.exports, "mapErrorToApiError", () => $e700666f15a610ba$export$3c02d1a328d4d808);
const $e700666f15a610ba$export$8de5b7b1f5c5cfb7 = 'convoai.rest.pinned.conversation.limit.exceeded';
class $e700666f15a610ba$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes, data){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
        this.data = data;
    }
}
const $e700666f15a610ba$export$89d83cc97c52a37 = (error)=>error instanceof $e700666f15a610ba$export$f2e832acab1bdd79;
const $e700666f15a610ba$var$getRecord = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value) ? value : undefined;
const $e700666f15a610ba$var$getApiErrorAttributes = (error)=>{
    if ($e700666f15a610ba$export$89d83cc97c52a37(error)) return error.errorAttributes;
    return $e700666f15a610ba$var$getRecord($e700666f15a610ba$var$getRecord(error)?.errorAttributes);
};
const $e700666f15a610ba$var$getStructuredErrorData = (error)=>{
    const errorRecord = $e700666f15a610ba$var$getRecord(error);
    return $e700666f15a610ba$var$getRecord(errorRecord?.data) ?? $e700666f15a610ba$var$getRecord($e700666f15a610ba$var$getRecord(errorRecord?.errorAttributes)?.data);
};
const $e700666f15a610ba$var$getValidCount = (value, minimum)=>typeof value === 'number' && Number.isInteger(value) && value >= minimum ? value : undefined;
const $e700666f15a610ba$export$45f7ada0fbd007df = (error)=>{
    const errorAttributes = $e700666f15a610ba$var$getApiErrorAttributes(error);
    if (errorAttributes?.errorCode !== $e700666f15a610ba$export$8de5b7b1f5c5cfb7) return undefined;
    const data = $e700666f15a610ba$var$getStructuredErrorData(error);
    if (!data) return {};
    const maxPinnedConversations = $e700666f15a610ba$var$getValidCount(data.maxPinnedConversations, 1);
    const pinnedCount = $e700666f15a610ba$var$getValidCount(data.pinnedCount, 0);
    return {
        ...maxPinnedConversations !== undefined && {
            maxPinnedConversations: maxPinnedConversations
        },
        ...pinnedCount !== undefined && {
            pinnedCount: pinnedCount
        }
    };
};
const $e700666f15a610ba$export$3c02d1a328d4d808 = (error)=>{
    if ($e700666f15a610ba$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $e700666f15a610ba$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};

});


parcelRegister("7b2nU", function(module, exports) {
$parcel$export(module.exports, "setRovoChatProduct", () => $be3ebb429a2b2c08$export$caa27b16709bc2df);

const $be3ebb429a2b2c08$export$caa27b16709bc2df = (product)=>{
    if (window) window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
};

});

parcelRegister("desEp", function(module, exports) {
$parcel$export(module.exports, "buildMessageStreamRequestContext", () => $1c76ead175839365$export$693ae5fbaa444eeb);

var $llCao = parcelRequire("llCao");
function $1c76ead175839365$export$693ae5fbaa444eeb(params) {
    const { browserUrl: browserUrl, autoActionApprovalMode: autoActionApprovalMode, useCurrentBrowsingContext: useCurrentBrowsingContext, webSearchEnabled: webSearchEnabled, sourceMode: sourceMode, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, dashboardEditorContext: dashboardEditorContext, browserContext: browserContext, isBrowserContextBlocklisted: isBrowserContextBlocklisted = false, jiraWorkflowContext: jiraWorkflowContext, additionalContext: additionalContext, writingStyleContext: writingStyleContext, dashboardContext: dashboardContext, aiFeatureContext: aiFeatureContext, fileIds: fileIds, knowledgeOverride: knowledgeOverride, selectedCloudIdsOverride: selectedCloudIdsOverride, searchArtifact: searchArtifact, artifactContext: artifactContext, shouldExtractConversationScopes: shouldExtractConversationScopes } = params;
    const isBrowserSelectionContextGateEnabled = (0, $llCao.fg)('rovo_chat_browser_selection_context');
    const browserSelection = isBrowserSelectionContextGateEnabled ? browserContext?.context?.selection : undefined;
    return {
        // without useCurrentBrowsingContext browser_url is not always used by the Rovo,
        // instead it depends on prompt intent to use it,
        // with useCurrentBrowsingContext we can ensure it is always used
        browser_url: browserUrl,
        ...autoActionApprovalMode ? {
            auto_action_approval_mode: autoActionApprovalMode
        } : {},
        ...useCurrentBrowsingContext === undefined ? {} : {
            useCurrentBrowsingContext: useCurrentBrowsingContext
        },
        webSearchEnabled: webSearchEnabled,
        ...sourceMode ? {
            sourceMode: sourceMode
        } : {},
        deepResearchEnabled: deepResearchEnabled,
        ...thinkDeeperEnabled ? {
            extendedThinkingEnabled: thinkDeeperEnabled
        } : {},
        ...alphaExtendedThinkingMode ? {
            alphaExtendedThinkingMode: alphaExtendedThinkingMode
        } : {},
        ...fastModeEnabled ? {
            fastModeEnabled: fastModeEnabled
        } : {},
        ...planModeEnabled ? {
            planModeEnabled: planModeEnabled,
            alphaExtendedThinkingMode: 'MARATHON',
            extendedThinkingEnabled: true
        } : {},
        ...editorContext ? {
            editor: editorContext
        } : {},
        ...whiteboardContext ? {
            whiteboardContext: whiteboardContext
        } : {},
        ...slidesContext ? {
            slidesContext: slidesContext
        } : {},
        ...databaseContext ? {
            databaseContext: databaseContext
        } : {},
        ...dashboardEditorContext ? {
            dashboardEditorContext: dashboardEditorContext
        } : {},
        // If browserUrl is inaccessible, fallback to htmlBody or canvasText if they exist
        // Do not send htmlBody or canvasText if the URL is blocklisted to ensure the site is truly not sent to the backend
        ...browserContext && !isBrowserContextBlocklisted ? {
            browser: {
                htmlBody: browserContext.context?.htmlBody,
                canvasText: browserContext.context?.canvasText,
                ...browserSelection ? {
                    selection: browserSelection
                } : {}
            }
        } : {},
        jiraWorkflowContext: jiraWorkflowContext,
        ...additionalContext,
        ...writingStyleContext ? {
            writingStyleContext: writingStyleContext
        } : {},
        dashboardContext: dashboardContext,
        aiFeatureContext: aiFeatureContext,
        fileIds: fileIds,
        ...knowledgeOverride,
        ...selectedCloudIdsOverride,
        ...searchArtifact ? {
            search_artifact: searchArtifact
        } : {},
        ...artifactContext ? {
            artifact_context: artifactContext
        } : {},
        ...shouldExtractConversationScopes !== undefined ? {
            shouldExtractConversationScopes: shouldExtractConversationScopes
        } : {}
    };
}

});

parcelRegister("eBrk9", function(module, exports) {
$parcel$export(module.exports, "getPromptHistory", () => $ed9facde01bc1b05$export$42d9632e135ee324);
async function $ed9facde01bc1b05$export$42d9632e135ee324({ limit: limit, signal: signal, headers: headers, fetchJson: fetchJson }) {
    const searchParams = new URLSearchParams();
    searchParams.set('limit', String(limit));
    const result = await fetchJson({
        baseUrl: '/gateway/api/acps',
        path: `/rovo/v1/session/prompt-history?${searchParams.toString()}`,
        options: {
            method: 'GET',
            headers: headers,
            signal: signal
        },
        holdName: 'rovo-v1-session-prompt-history'
    });
    return {
        items: result.items.map((item)=>({
                messageId: item.message_id,
                sessionId: item.session_id,
                displayText: item.display_text,
                truncated: item.truncated,
                createdAt: item.created_at,
                isOpeningPrompt: item.is_opening_prompt === true
            })),
        cursor: result.cursor ?? null,
        hasNext: result.hasNext
    };
}

});

parcelRegister("jD7S5", function(module, exports) {
$parcel$export(module.exports, "readJsonStream", () => $b016303819c7091c$export$1f24b2b263bcfa75);

var $llCao = parcelRequire("llCao");

var $fUV6f = parcelRequire("fUV6f");
async function* $b016303819c7091c$export$1f24b2b263bcfa75(response) {
    const reader = (0, $fUV6f.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                const json = chunk.startsWith('data: ') && (0, $llCao.fg)('rovo-guard-ui-redaction-and-blocking') ? chunk.slice(6) : chunk;
                yield JSON.parse(json);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}

});
parcelRegister("fUV6f", function(module, exports) {
$parcel$export(module.exports, "getBufferReader", () => $bd3fc68416bff1ef$export$f6383c3ea1307da9);
const $bd3fc68416bff1ef$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};

});


parcelRegister("6hlp7", function(module, exports) {
$parcel$export(module.exports, "readSSEStream", () => $203c67eaa69e49da$export$6dab2f647580dc69);

var $llCao = parcelRequire("llCao");

var $fUV6f = parcelRequire("fUV6f");
const $203c67eaa69e49da$var$parseSSEMessage = (message)=>{
    const parsed = {};
    const dataLines = [];
    for (const line of message.split('\n')){
        const trimmedLine = line.trim();
        const colonIndex = trimmedLine.indexOf(':');
        if (trimmedLine && colonIndex !== -1) {
            const field = trimmedLine.substring(0, colonIndex);
            const value = trimmedLine.substring(colonIndex + 1).trimStart();
            switch(field){
                case 'event':
                    parsed.eventType = value;
                    break;
                case 'data':
                    dataLines.push(value);
                    break;
                case 'id':
                    parsed.id = value;
                    break;
                default:
                    break;
            }
        }
    }
    if (dataLines.length) parsed.data = dataLines.join('\n');
    return parsed;
};
async function* $203c67eaa69e49da$export$6dab2f647580dc69(response) {
    const reader = (0, $fUV6f.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    const reliableContracts = (0, $llCao.fg)('rovo_ai_mate_reliability_contracts');
    let pendingCarriageReturn = false;
    try {
        do try {
            const { value: value, done: done } = await reader.read();
            doneStreaming = done;
            let text = value ?? '';
            if (reliableContracts) {
                // Preserve a trailing CR until the next read so a split CRLF is one
                // newline, not an accidental event boundary. Lone CR is also valid SSE.
                text = `${pendingCarriageReturn ? '\r' : ''}${text}`;
                pendingCarriageReturn = !done && text.endsWith('\r');
                if (pendingCarriageReturn) text = text.slice(0, -1);
                text = text.replace(/\r\n?/g, '\n');
            }
            if (text) {
                const combined = `${remainder}${text}`;
                const parts = combined.split('\n\n'); // SSE messages are separated by double newlines
                // the last part may be incomplete — keep it for the next read
                remainder = parts.pop() ?? '';
                for (const chunk of parts)try {
                    const parsed = $203c67eaa69e49da$var$parseSSEMessage(chunk);
                    if (parsed.data) {
                        const parsedData = JSON.parse(parsed.data);
                        yield {
                            __isSSEWrapper: true,
                            data: parsedData,
                            id: parsed.id,
                            eventType: parsed.eventType
                        };
                    }
                } catch  {
                // ignore malformed JSON; keep streaming future valid messages
                }
            }
            // If the stream just ended and we still have a remainder, try to parse it once.
            if (doneStreaming && remainder) try {
                const parsed = $203c67eaa69e49da$var$parseSSEMessage(remainder);
                if (parsed.data) {
                    const parsedData = JSON.parse(parsed.data);
                    yield {
                        __isSSEWrapper: true,
                        data: parsedData,
                        id: parsed.id,
                        eventType: parsed.eventType
                    };
                }
            } catch  {
            // ignore malformed tail
            } finally{
                remainder = '';
            }
        } catch (e) {
            // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
            if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
            else throw e;
        }
        while (!doneStreaming);
    } finally{
        if (reliableContracts) try {
            if (!doneStreaming) await reader.cancel();
        } catch  {
        // Cleanup must not replace the original read error or consumer outcome.
        } finally{
            reader.releaseLock();
        }
    }
}

});

parcelRegister("9TpiC", function(module, exports) {
$parcel$export(module.exports, "resolveMessageStreamBrowserUrl", () => $21803c58b558c070$export$d272e1989c4ab4bf);

var $dJhjg = parcelRequire("dJhjg");
const $21803c58b558c070$var$getMessageStreamHref = (product)=>{
    const backendOriginHost = window?.__backendOriginHost;
    if (product === 'confluence' && window.location.hostname === 'localhost' && typeof backendOriginHost === 'string') {
        const urlWithLocalhost = new URL(window.location.href);
        urlWithLocalhost.hostname = backendOriginHost;
        urlWithLocalhost.port = '';
        urlWithLocalhost.protocol = 'https:';
        return urlWithLocalhost.toString();
    }
    return window?.location?.href;
};
const $21803c58b558c070$export$d272e1989c4ab4bf = ({ browserContext: browserContext, browserContextSanitizer: browserContextSanitizer, product: product })=>{
    const browserContextUrl = browserContext?.context?.browserUrl;
    const isBrowserContextBlocklisted = Boolean(browserContextUrl && browserContextSanitizer?.isBlocklisted(browserContextUrl));
    const isBrowserUrlSuppressed = browserContextUrl === 'NO-URL' && (0, $dJhjg.isExperimentEnabled)('jira_free_gen_editor');
    if (isBrowserContextBlocklisted || isBrowserUrlSuppressed) return {
        browserUrl: '',
        isBrowserContextBlocklisted: isBrowserContextBlocklisted
    };
    return {
        browserUrl: browserContextUrl || $21803c58b558c070$var$getMessageStreamHref(product) || '',
        isBrowserContextBlocklisted: isBrowserContextBlocklisted
    };
};

});
parcelRegister("dJhjg", function(module, exports) {
$parcel$export(module.exports, "isExperimentEnabled", () => $a3d5659b9b4c4036$export$336b018592dc9972);

var $cYhnF = parcelRequire("cYhnF");
function $a3d5659b9b4c4036$export$336b018592dc9972(experimentName) {
    return (0, $cYhnF.expVal)(experimentName, 'isEnabled', false) === true;
}

});


parcelRegister("k9xDS", function(module, exports) {
$parcel$export(module.exports, "buildEffectiveCapabilities", () => $de75d33b503fd880$export$6656e8be041b8747);

var $llCao = parcelRequire("llCao");
const $de75d33b503fd880$export$3b20549d55cda4db = 'store-message-from-user-settings';
const $de75d33b503fd880$export$bd10ff38e53e4101 = 'actionable-follow-ups';
const $de75d33b503fd880$export$f447b2e2b8f0d61e = 'actionable-follow-ups-stacked';
/**
 * Maps each gated capability to the gate that enables it. Add new
 * capability/gate pairs here rather than introducing nested ternaries at the
 * call sites.
 */ const $de75d33b503fd880$var$GATED_CAPABILITIES = [
    {
        capability: $de75d33b503fd880$export$3b20549d55cda4db,
        isEnabled: ()=>(0, $llCao.fg)('ai_mate_store_messages_be_driven')
    }
];
const $de75d33b503fd880$export$6656e8be041b8747 = (capabilities)=>{
    const enabledCapabilities = $de75d33b503fd880$var$GATED_CAPABILITIES.filter(({ isEnabled: isEnabled })=>isEnabled()).map(({ capability: capability })=>capability);
    // Preserve older UIs' inline opt-in, but never request both formats.
    const callerCapabilities = capabilities?.includes($de75d33b503fd880$export$f447b2e2b8f0d61e) ? capabilities.filter((capability)=>capability !== $de75d33b503fd880$export$bd10ff38e53e4101) : capabilities;
    if (callerCapabilities === undefined && enabledCapabilities.length === 0) return undefined;
    return Array.from(new Set([
        ...callerCapabilities ?? [],
        ...enabledCapabilities
    ]));
};

});

parcelRegister("6qfyE", function(module, exports) {
$parcel$export(module.exports, "addPath", () => $5de43cae52dd2a33$export$4c25481b843feb0b);
$parcel$export(module.exports, "processResponse", () => $5de43cae52dd2a33$export$21fcb6cfd5628534);

var $d1B6S = parcelRequire("d1B6S");

var $13Mqn = parcelRequire("13Mqn");
const $5de43cae52dd2a33$export$4c25481b843feb0b = (baseUrl, path)=>{
    if (path === '') // return base url without trailing slash
    return baseUrl;
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
const $5de43cae52dd2a33$var$removeTimestampFromErrorMessage = (errorBodyJson)=>{
    const { timestamp: _timestamp, ...rest } = errorBodyJson;
    return JSON.stringify(rest);
};
const $5de43cae52dd2a33$var$processErrorResponse = async ({ response: response })=>{
    let errorCode;
    let outputErrorMessage;
    const responseText = await response.text();
    let rawErrorMessage;
    let data;
    try {
        const errorBodyJson = JSON.parse(responseText);
        const { data: responseData, error_code: error_code, error_message: error_message, message_template: message_template, errors: errors, errorMessage: errorMessage, timestamp: timestamp } = errorBodyJson;
        data = typeof responseData === 'object' && responseData !== null && !Array.isArray(responseData) ? responseData : undefined;
        rawErrorMessage = errorMessage ?? error_message;
        if (errors?.length) // Use a single error code for now
        errorCode = errors[0];
        else if (error_code) errorCode = error_code;
        else errorCode = message_template;
        if (!errorCode || !rawErrorMessage) outputErrorMessage = timestamp ? $5de43cae52dd2a33$var$removeTimestampFromErrorMessage(errorBodyJson) : responseText;
        else outputErrorMessage = `${errorCode} - ${rawErrorMessage}`;
    } catch  {
        outputErrorMessage = responseText;
    }
    const errorMessage = `[Code ${response.status}] ${outputErrorMessage}`;
    const errorAttributes = {
        errorCode: errorCode,
        statusCode: response.status,
        rawErrorMessage: rawErrorMessage,
        traceId: (0, $13Mqn.getTraceIdFromResponse)(response)
    };
    throw new (0, $d1B6S.ApiError)(errorMessage, errorAttributes, data);
};
const $5de43cae52dd2a33$export$21fcb6cfd5628534 = async ({ response: response })=>{
    if (!response.ok || response.status >= 400) await $5de43cae52dd2a33$var$processErrorResponse({
        response: response
    });
    return response;
};

});

parcelRegister("fH7nM", function(module, exports) {
$parcel$export(module.exports, "generateConversationName", () => $bdc7993b49bb3c73$export$11cc4786742ed7c2);
const $bdc7993b49bb3c73$export$11cc4786742ed7c2 = ()=>{
    const date = new Date();
    const formattedDate = date.toLocaleDateString(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const name = `${formattedDate} ${formattedTime}`;
    return name;
};

});

parcelRegister("6WjoN", function(module, exports) {
$parcel$export(module.exports, "getId", () => $0cc25277fa623fb3$export$218c8c3169c024d2);
$parcel$export(module.exports, "addAnswerPart", () => $0cc25277fa623fb3$export$6e5609c05ab74cc7);
$parcel$export(module.exports, "addActionPart", () => $0cc25277fa623fb3$export$13b6a4e4e3704011);
$parcel$export(module.exports, "removeSensitiveData", () => $0cc25277fa623fb3$export$efd4f6b5d168b654);
$parcel$export(module.exports, "NO_PARENT_MESSAGE_ID", () => $0cc25277fa623fb3$export$4c47ae95c311c518);
$parcel$export(module.exports, "createHumanMessage", () => $0cc25277fa623fb3$export$4010f996e89e886a);
$parcel$export(module.exports, "toStreamResponse", () => $0cc25277fa623fb3$export$3220a4ff7b3a96df);

var $fVYJM = parcelRequire("fVYJM");

var $3x59x = parcelRequire("3x59x");
const $0cc25277fa623fb3$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
const $0cc25277fa623fb3$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
    const content = `${response.content}${answerPart.message.content}`;
    // Remove source indexes, e.g [^1^] from the content
    const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
    return {
        ...response,
        content: cleanedContent
    };
};
const $0cc25277fa623fb3$var$addAnswerPartAgentResponse = (response, answerPart)=>({
        ...response,
        message: $0cc25277fa623fb3$var$addAnswerPartAssistantMessage(response.message, answerPart)
    });
// ****************************************************************************
// Action streaming accumulation configuration
// ****************************************************************************
const $0cc25277fa623fb3$var$toPathArr = (path)=>Array.isArray(path) ? path : path.split('.').filter(Boolean);
const $0cc25277fa623fb3$var$getAtPath = (obj, path)=>{
    let cur = obj;
    for (const key of path){
        if (!(0, $3x59x.isRecord)(cur)) return undefined;
        cur = cur[key];
    }
    return cur;
};
const $0cc25277fa623fb3$var$setAtPath = (obj, path, value)=>{
    if (path.length === 0) return value;
    const [head, ...rest] = path;
    const base = (0, $3x59x.isRecord)(obj) ? obj : {};
    return {
        ...base,
        [head]: $0cc25277fa623fb3$var$setAtPath(base[head], rest, value)
    };
};
// Defines which sub-field(s) of a message action's data should be accumulated by string appending.
// Keyed by action key. Values can be a dot path or an array path, or an array of multiple paths.
// E.g.:
// {
//   'create-document-action': 'content',
//   'update-document-action': ['content', 'meta.subtitle']
// }
let $0cc25277fa623fb3$var$actionDataAccumulationConfig = {
    ['aifc-confluence-page-create']: 'adf'
};
const $0cc25277fa623fb3$export$a1715e22f3105088 = (prev, next)=>{
    const key = next.key;
    const rulePaths = $0cc25277fa623fb3$var$actionDataAccumulationConfig[key];
    const prevData = prev?.data;
    const newData = next?.data;
    if (rulePaths && typeof prevData === 'object' && prevData !== null && typeof newData === 'object' && newData !== null) {
        const paths = Array.isArray(rulePaths) ? rulePaths : [
            rulePaths
        ];
        let base = {
            ...newData
        };
        for (const p of paths){
            const pathArr = $0cc25277fa623fb3$var$toPathArr(p);
            const prevVal = $0cc25277fa623fb3$var$getAtPath(prevData, pathArr);
            const nextVal = $0cc25277fa623fb3$var$getAtPath(newData, pathArr);
            const accumulated = String(prevVal ?? '') + String(nextVal ?? '');
            const updated = $0cc25277fa623fb3$var$setAtPath(base, pathArr, accumulated);
            // `setAtPath` only returns the raw `value` when the path is empty; here
            // `pathArr` is always non-empty (derived from a configured rule path), so
            // the result is always the spread record branch.
            if ((0, $3x59x.isRecord)(updated)) base = updated;
        }
        return {
            ...prev,
            data: base,
            status: next.status
        };
    }
    // Default: replace only data from next, keep other fields from prev
    return {
        ...prev,
        data: next.data,
        status: next.status
    };
};
const $0cc25277fa623fb3$export$6554ad578994a75f = (actions, actionPart, actionUpdaterOverride)=>{
    const { key: key, invocationId: invocationId } = actionPart.message;
    // Accumulate by `invocationId` when the part has one, so multiple same-`key` actions (e.g. several
    // page creates in a single message) stream independently; fall back to `key` for parts without an
    // invocationId. For single-action messages both resolve to the same action, so no experiment gate
    // is needed here.
    const existingActionIndex = invocationId ? actions.findIndex((action)=>action.invocationId === invocationId) : actions.findIndex((action)=>action.key === key);
    if (existingActionIndex === -1) return [
        ...actions || [],
        actionPart.message
    ];
    const updatedActions = [
        ...actions
    ];
    const prevAction = updatedActions[existingActionIndex];
    const nextAction = actionPart.message;
    updatedActions[existingActionIndex] = actionUpdaterOverride ? actionUpdaterOverride(prevAction, nextAction) : $0cc25277fa623fb3$export$a1715e22f3105088(prevAction, nextAction);
    return updatedActions;
};
const $0cc25277fa623fb3$export$6e5609c05ab74cc7 = (response, answerPart)=>({
        ...response,
        message: $0cc25277fa623fb3$var$addAnswerPartAgentResponse(response.message, answerPart)
    });
const $0cc25277fa623fb3$export$13b6a4e4e3704011 = (response, actionPart, actionUpdaterOverride)=>{
    const { message: message } = response.message;
    const { actions: actions } = message;
    const isActionsArrayPresent = actions && actions.length > 0;
    return {
        ...response,
        message: {
            ...response.message,
            message: {
                ...message,
                actions: !isActionsArrayPresent ? [
                    actionPart.message
                ] : $0cc25277fa623fb3$export$6554ad578994a75f(actions, actionPart, actionUpdaterOverride)
            }
        }
    };
};
const $0cc25277fa623fb3$var$removeSensitiveDataAssistantMessage = (message)=>{
    const { plugin_invocations: plugin_invocations, ...rest } = message;
    return {
        ...rest,
        plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                ...pluginInvocation,
                plugin_output: '--PRIVATE--'
            }))
    };
};
const $0cc25277fa623fb3$var$removeSensitiveDataAgentResponse = (message)=>({
        ...message,
        message: $0cc25277fa623fb3$var$removeSensitiveDataAssistantMessage(message.message)
    });
const $0cc25277fa623fb3$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        message: $0cc25277fa623fb3$var$removeSensitiveDataAgentResponse(message.message)
    });
const $0cc25277fa623fb3$export$4c47ae95c311c518 = '00000000-0000-0000-0000-000000000000';
const $0cc25277fa623fb3$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId, fileUploads, displayContext)=>{
    return {
        role: 'HUMAN',
        id: id,
        content: content,
        time_created: new Date().toISOString(),
        user_ari: 'unknown',
        plugin_invocations: [],
        isFromSeededConversation: isFromSeededConversation,
        requestId: requestId,
        file_uploads: fileUploads,
        ...displayContext ? {
            display_context: displayContext
        } : {}
    };
};
const $0cc25277fa623fb3$export$3220a4ff7b3a96df = (message)=>{
    if ((0, $fVYJM.isAgentResponse)(message)) return {
        type: 'FINAL_RESPONSE',
        message: message
    };
    return {
        type: 'FINAL_RESPONSE',
        message: {
            message: message
        }
    };
};

});


parcelRegister("7keNf", function(module, exports) {
$parcel$export(module.exports, "AtlBrowserStorageLocal", () => $5318ecd369c41511$export$c8cc3ffd3f2c1d2f);
$parcel$export(module.exports, "AtlBrowserStorageSession", () => $5318ecd369c41511$export$edbae459bdf957a5);
$parcel$export(module.exports, "findStorageTarget", () => $5318ecd369c41511$export$14921bfc334334c0);
$parcel$export(module.exports, "WebStorageType", () => (parcelRequire("2VwFl")).WebStorageType);

var $llCao = parcelRequire("llCao");

var $4kM1J = parcelRequire("4kM1J");
var $5W9qx = parcelRequire("5W9qx");
var $52k2b = parcelRequire("52k2b");

var $2yNBb = parcelRequire("2yNBb");

var $hw3pG = parcelRequire("hw3pG");

var $2VwFl = parcelRequire("2VwFl");

var $eUjXx = parcelRequire("eUjXx");
var $2pRv1 = parcelRequire("2pRv1");
var $Nva0P = parcelRequire("Nva0P");
class $5318ecd369c41511$export$8e4a3cf07a10930b {
    constructor(storage, storageType){
        this.isAvailable = false;
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStorageEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $4kM1J.getBscGlobalState)().webStorageEnabled) return true;
        (0, $2yNBb.Logger).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $2yNBb.Logger).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $eUjXx.getStorageItem)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            // BSC controls are disabled (pre-init, caller opted out, or killswitch active).
            // Write proceeds unconditionally — emit analytics so we can quantify bypass volume
            // (gated by platform_bsc_consent_bypass_analytics for safe rollout).
            if ((0, $llCao.fg)('platform_bsc_consent_bypass_analytics')) {
                const globalState = (0, $4kM1J.getBscGlobalState)();
                (0, $52k2b.sendPackageOperationalEvent)({
                    action: 'usedAtlBrowserStorageSetItemBscDisabled',
                    attributes: {
                        storageType: this.storageType,
                        product: globalState.product,
                        hasInitialized: globalState.hasInitialized ?? false
                    }
                });
            }
            this.storage.setItem(key, value);
            return {
                status: (0, $hw3pG.Status).SUCCESS
            };
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $2yNBb.Logger).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return {
                status: (0, $hw3pG.Status).ERROR,
                error: new Error(`${this.storageType} is unavailable. Failed to set item ${key}`)
            };
        }
        const globalStateProduct = (0, $4kM1J.getBscGlobalState)().product;
        const wasInitialized = (0, $4kM1J.getBscGlobalState)().hasInitialized;
        // IMPORTANT: do not await above this line - if you do it will cause reading after writing to not return the new value until the microtask queue is drained, instead of just those that need to wait for remote fetch.
        const itemSetResult = await (0, $2pRv1.setStorageItem)(key, value, this.storageType, globalStateProduct, this.storage);
        if (!wasInitialized) (0, $52k2b.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        if (itemSetResult.status === (0, $hw3pG.Status).SUCCESS) (0, $2yNBb.Logger).debug(`Successfully set item ${key} with value ${value}`);
        else if (itemSetResult.status === (0, $hw3pG.Status).BLOCKED) {
            // Only an actual block is described as "blocked" — errors are surfaced (and logged)
            // upstream in setStorageItem's catch blocks via Logger.errorWithOperationalEvent.
            (0, $2yNBb.Logger).debug(`Blocked setting item ${key}`);
            const productSuffix = globalStateProduct ? ` for product "${globalStateProduct}"` : '';
            if (itemSetResult.blockedItemCategory === null) // Async path with confirmed cause: key is not registered.
            (0, $2yNBb.Logger).warn(`${this.storageType}.setItem('${key}', ...) was blocked${productSuffix}` + `: '${key}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
            else if (itemSetResult.blockedItemCategory === undefined) // MaybeSync path: cause not available. State only what we know.
            (0, $2yNBb.Logger).warn(`${this.storageType}.setItem('${key}', ...) was blocked${productSuffix}.`);
        }
        return itemSetResult;
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $2yNBb.Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $Nva0P.setStrictlyNecessaryStorageItem)(key, value, this.storageType, this.storage);
        if (!(0, $4kM1J.getBscGlobalState)().hasInitialized) (0, $52k2b.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        (0, $2yNBb.Logger).debug(`${itemSetStatus === (0, $hw3pG.Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $2yNBb.Logger).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $5W9qx.isSSR)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
}
const $5318ecd369c41511$export$c8cc3ffd3f2c1d2f = new $5318ecd369c41511$export$8e4a3cf07a10930b(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
globalThis.localStorage, (0, $2VwFl.WebStorageType).LocalStorage);
const $5318ecd369c41511$export$edbae459bdf957a5 = new $5318ecd369c41511$export$8e4a3cf07a10930b(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
globalThis.sessionStorage, (0, $2VwFl.WebStorageType).SessionStorage);
const $5318ecd369c41511$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $2VwFl.WebStorageType).LocalStorage]: $5318ecd369c41511$export$c8cc3ffd3f2c1d2f,
        [(0, $2VwFl.WebStorageType).SessionStorage]: $5318ecd369c41511$export$edbae459bdf957a5
    })[type];
};

});
parcelRegister("2VwFl", function(module, exports) {
$parcel$export(module.exports, "WebStorageType", () => $e1c3e2a58b2ab456$export$259e3a861f28589b);
var $e1c3e2a58b2ab456$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});

});

parcelRegister("eUjXx", function(module, exports) {
$parcel$export(module.exports, "getStorageItem", () => $5ad63a018c830828$export$e612bb1301d659de);

var $52k2b = parcelRequire("52k2b");

var $2yNBb = parcelRequire("2yNBb");
const $5ad63a018c830828$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $52k2b.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $2yNBb.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};

});

parcelRegister("2pRv1", function(module, exports) {
$parcel$export(module.exports, "setStorageItem", () => $e4f000c165e1d327$export$5ee8760f703d9d62);

var $4kM1J = parcelRequire("4kM1J");
var $52k2b = parcelRequire("52k2b");

var $5PWEB = parcelRequire("5PWEB");

var $hw3pG = parcelRequire("hw3pG");

var $kQqrj = parcelRequire("kQqrj");

var $2VwFl = parcelRequire("2VwFl");

var $3GAaF = parcelRequire("3GAaF");
const $e4f000c165e1d327$var$isPromise = (value)=>value != null && typeof value.then === 'function';
const $e4f000c165e1d327$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    const categoryStorageType = storageType === (0, $2VwFl.WebStorageType).LocalStorage ? (0, $hw3pG.CategoryStorageType).LocalStorage : (0, $hw3pG.CategoryStorageType).SessionStorage;
    const disableWebStorageConsentChecks = (0, $4kM1J.getBscGlobalState)().disableWebStorageConsentChecks ?? false;
    if (disableWebStorageConsentChecks) {
        const eventAttributes = {
            itemKey: itemKey,
            storageType: storageType,
            consentChecksDisabled: true
        };
        try {
            // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
            // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
            (0, $kQqrj.ItemKeyCache).markSetByPackage(categoryStorageType, itemKey);
            browserStorage.setItem(itemKey, value);
        } catch (e) {
            (0, $3GAaF.reportSetItemError)({
                message: `${storageType} failed to setItem with consent checks disabled. ${e.message || ''}`,
                attributes: eventAttributes,
                error: e
            });
            return {
                status: (0, $hw3pG.Status).ERROR,
                error: e
            };
        }
        let wasAsync = true;
        try {
            let shouldSetItem;
            const shouldSetItemOrPromise = (0, $5PWEB.isProcessingAllowedByPreferencesMaybeSync)({
                itemKey: itemKey,
                storageType: categoryStorageType,
                productName: productName
            });
            if ($e4f000c165e1d327$var$isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
            else {
                wasAsync = false;
                shouldSetItem = shouldSetItemOrPromise;
            }
            (0, $52k2b.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    ...eventAttributes,
                    wasRejected: !shouldSetItem,
                    wasAsync: wasAsync
                }
            });
        } catch (e) {
            (0, $3GAaF.reportSetItemError)({
                attributes: {
                    ...eventAttributes,
                    wasAsync: wasAsync
                },
                message: `Failed to emit analytics for setStorageItem with consent checks disabled. ${e.message || ''}`,
                error: e
            });
        }
        return {
            status: (0, $hw3pG.Status).SUCCESS
        };
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    let shouldSetItem;
    let wasAsync = true;
    const shouldSetItemOrPromise = (0, $5PWEB.isProcessingAllowedByPreferencesMaybeSync)({
        itemKey: itemKey,
        storageType: categoryStorageType,
        productName: productName
    });
    if ($e4f000c165e1d327$var$isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
    else {
        wasAsync = false;
        shouldSetItem = shouldSetItemOrPromise;
    }
    // The synchronous preference check surfaces no block reason:
    // `isProcessingAllowedByPreferencesMaybeSync` takes no blockedCallback, so we cannot tell
    // "key not registered in the allow-list" from "blocked by user consent" here. The BLOCKED
    // result therefore carries `blockedItemCategory: undefined` ("reason unknown"), which the
    // caller reads as such and answers with a terse "was blocked" warning.
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType,
        consentChecksDisabled: false,
        wasAsync: wasAsync
    };
    try {
        (0, $52k2b.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
            // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
            (0, $kQqrj.ItemKeyCache).markSetByPackage(categoryStorageType, itemKey);
            browserStorage.setItem(itemKey, value);
            return {
                status: (0, $hw3pG.Status).SUCCESS
            };
        } else return {
            status: (0, $hw3pG.Status).BLOCKED,
            blockedItemCategory: undefined
        };
    } catch (e) {
        (0, $3GAaF.reportSetItemError)({
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`,
            error: e
        });
        return {
            status: (0, $hw3pG.Status).ERROR,
            error: e
        };
    }
};

});
parcelRegister("kQqrj", function(module, exports) {
$parcel$export(module.exports, "ItemKeyCache", () => $db8622e6ec9ada4e$export$ff3c91e80f54f26c);

var $hw3pG = parcelRequire("hw3pG");
class $db8622e6ec9ada4e$var$ItemKeyCacheService {
    constructor(){
        this.cache = Object.fromEntries(Object.keys((0, $hw3pG.CategoryStorageType)).map((storageType)=>{
            return [
                storageType,
                new Set()
            ];
        }));
    }
    markSetByPackage(storageType, itemKey) {
        this.cache[storageType].add(itemKey);
    }
    wasSetByPackage(storageType, itemKey) {
        return this.cache[storageType].has(itemKey);
    }
}
const $db8622e6ec9ada4e$export$ff3c91e80f54f26c = new $db8622e6ec9ada4e$var$ItemKeyCacheService();

});

parcelRegister("3GAaF", function(module, exports) {
$parcel$export(module.exports, "reportSetItemError", () => $451ecc33880dbefa$export$ba6a684424c69e54);

var $2yNBb = parcelRequire("2yNBb");
/**
 * Identifies browser "quota exceeded" storage failures across the cross-browser variants (per MDN's
 * `Storage.setItem` exceptions): modern browsers throw a `DOMException` named `QuotaExceededError`;
 * legacy WebKit/Blink expose the numeric `code === 22` (`QUOTA_EXCEEDED_ERR`); Firefox historically
 * throws `NS_ERROR_DOM_QUOTA_REACHED` with `code === 1014`.
 */ const $451ecc33880dbefa$var$isQuotaExceededError = (error)=>{
    if (!error || typeof error !== 'object') return false;
    const { name: name, code: code } = error;
    return name === 'QuotaExceededError' || name === 'NS_ERROR_DOM_QUOTA_REACHED' || code === 22 || code === 1014;
};
const $451ecc33880dbefa$export$ba6a684424c69e54 = ({ message: message, attributes: attributes, error: error })=>{
    if ($451ecc33880dbefa$var$isQuotaExceededError(error)) {
        (0, $2yNBb.Logger).error(message);
        return;
    }
    (0, $2yNBb.Logger).errorWithOperationalEvent({
        action: 'usedAtlBrowserStorageSetItemError',
        message: message,
        attributes: attributes
    });
};

});


parcelRegister("Nva0P", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryStorageItem", () => $fd6cf88c40a2fa9b$export$f1b0c189562aa9fd);

var $52k2b = parcelRequire("52k2b");

var $2yNBb = parcelRequire("2yNBb");

var $hw3pG = parcelRequire("hw3pG");

var $kQqrj = parcelRequire("kQqrj");

var $2VwFl = parcelRequire("2VwFl");
const $fd6cf88c40a2fa9b$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $52k2b.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
        // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
        (0, $kQqrj.ItemKeyCache).markSetByPackage(storageType === (0, $2VwFl.WebStorageType).LocalStorage ? (0, $hw3pG.CategoryStorageType).LocalStorage : (0, $hw3pG.CategoryStorageType).SessionStorage, itemKey);
        browserStorage.setItem(itemKey, value);
        return (0, $hw3pG.Status).SUCCESS;
    } catch (e) {
        (0, $2yNBb.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $hw3pG.Status).FAILED;
    }
};

});


parcelRegister("l5S7M", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $437f52a393cbb28c$export$b0c5c2fac8144e54);

var $2voWR = parcelRequire("2voWR");

var $7QGOY = parcelRequire("7QGOY");

var $5lOdF = parcelRequire("5lOdF");

var $3CeZj = parcelRequire("3CeZj");

var $eWwS1 = parcelRequire("eWwS1");
const $437f52a393cbb28c$export$b0c5c2fac8144e54 = {
    pageLoad: $3CeZj.pageLoad,
    pageSegmentLoad: $eWwS1.pageSegmentLoad,
    interaction: $5lOdF.interaction,
    custom: $7QGOY.custom,
    concurrent: $2voWR.concurrent
};

});
parcelRegister("2voWR", function(module, exports) {
$parcel$export(module.exports, "concurrent", () => $c0be20e3ae35c494$export$370df09ecc3de059);

var $3eqwL = parcelRequire("3eqwL");

var $7QGOY = parcelRequire("7QGOY");

var $5lOdF = parcelRequire("5lOdF");
const $c0be20e3ae35c494$var$concurrentMetrics = {};
const $c0be20e3ae35c494$var$getKey = (config, type)=>`${type}--${config.key}`;
const $c0be20e3ae35c494$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $c0be20e3ae35c494$var$ensurePath = (config, type)=>{
    const key = $c0be20e3ae35c494$var$getKey(config, type);
    if (!(key in $c0be20e3ae35c494$var$concurrentMetrics)) $c0be20e3ae35c494$var$concurrentMetrics[key] = {};
};
const $c0be20e3ae35c494$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $c0be20e3ae35c494$var$getKey(config, type);
    if (concurrentKey in $c0be20e3ae35c494$var$concurrentMetrics && $c0be20e3ae35c494$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $c0be20e3ae35c494$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $c0be20e3ae35c494$var$concurrentMetrics)) $c0be20e3ae35c494$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $c0be20e3ae35c494$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $c0be20e3ae35c494$var$validateConfig(config);
    $c0be20e3ae35c494$var$ensurePath(config, type);
    const metricFromCache = $c0be20e3ae35c494$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $3eqwL.BMEventsType).INLINE_RESULT ? (0, $5lOdF.interaction) : (0, $7QGOY.custom);
    const metric = metricFactory(config);
    $c0be20e3ae35c494$var$concurrentMetrics[$c0be20e3ae35c494$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $c0be20e3ae35c494$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$c0be20e3ae35c494$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $3eqwL.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$c0be20e3ae35c494$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $3eqwL.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$c0be20e3ae35c494$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $3eqwL.BMEventsType).CUSTOM)
};

});
parcelRegister("7QGOY", function(module, exports) {
$parcel$export(module.exports, "custom", () => $d0cbd7063c140a3a$export$4c00f665f0d4b443);

var $hw9oH = parcelRequire("hw9oH");

var $3eqwL = parcelRequire("3eqwL");
const $d0cbd7063c140a3a$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $hw9oH.Metric)({
        ...config,
        type: (0, $3eqwL.BMEventsType).CUSTOM
    });
};

});
parcelRegister("hw9oH", function(module, exports) {
$parcel$export(module.exports, "Metric", () => $55d1efdfcaaf3eac$export$efdd3e096bc27746);

var $e4IhG = parcelRequire("e4IhG");

var $f3izM = parcelRequire("f3izM");

var $5xYV9 = parcelRequire("5xYV9");
class $55d1efdfcaaf3eac$export$efdd3e096bc27746 extends (0, $5xYV9.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $e4IhG.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $f3izM.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}

});


parcelRegister("5lOdF", function(module, exports) {
$parcel$export(module.exports, "interaction", () => $af3b7e46cba2bdd9$export$92473e6020ad89b4);

var $hw9oH = parcelRequire("hw9oH");

var $3eqwL = parcelRequire("3eqwL");
const $af3b7e46cba2bdd9$export$92473e6020ad89b4 = (config)=>{
    return new (0, $hw9oH.Metric)({
        ...config,
        type: (0, $3eqwL.BMEventsType).INLINE_RESULT
    });
};

});


parcelRegister("3CeZj", function(module, exports) {
$parcel$export(module.exports, "pageLoad", () => $0832ee7e412a2f6c$export$791d520f7e8058a5);

var $e2EPn = parcelRequire("e2EPn");

var $3eqwL = parcelRequire("3eqwL");
const $0832ee7e412a2f6c$export$791d520f7e8058a5 = (config)=>{
    return new (0, $e2EPn.PageLoadMetric)({
        ...config,
        type: (0, $3eqwL.BMEventsType).PAGE_LOAD
    });
};

});
parcelRegister("e2EPn", function(module, exports) {
$parcel$export(module.exports, "PageLoadMetric", () => $5ed96ca0c9fc3849$export$3c51073271a9eac3);

var $23R3w = parcelRequire("23R3w");

var $fKyz0 = parcelRequire("fKyz0");

var $e4IhG = parcelRequire("e4IhG");

var $f3izM = parcelRequire("f3izM");

var $3eqwL = parcelRequire("3eqwL");

var $97FbR = parcelRequire("97FbR");

var $es0Kq = parcelRequire("es0Kq");

var $iBC9C = parcelRequire("iBC9C");
class $5ed96ca0c9fc3849$export$3c51073271a9eac3 extends (0, $97FbR.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $es0Kq.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $es0Kq.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $es0Kq.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $97FbR.BasePageLoadMetric).FMP]) {
                const mark = (0, $23R3w.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $es0Kq.pageLoadMetaMetric).markFMP(mark);
            } else (0, $es0Kq.pageLoadMetaMetric).markFMP(this.marks[(0, $97FbR.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $e4IhG.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $f3izM.submitter).queue(data);
        (0, $fKyz0.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $es0Kq.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $es0Kq.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $es0Kq.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $f3izM.submitter).config.configChunk;
        if (!configChunk?.[(0, $3eqwL.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $iBC9C.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $f3izM.submitter).queue(webVitalMetric.getData());
        (0, $fKyz0.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}

});
parcelRegister("iBC9C", function(module, exports) {
$parcel$export(module.exports, "WebVitalsMetric", () => $f5418d8ee4fdfc2b$export$dc0d85d4d6503cd7);

var $3eqwL = parcelRequire("3eqwL");

var $5xYV9 = parcelRequire("5xYV9");
class $f5418d8ee4fdfc2b$export$dc0d85d4d6503cd7 extends (0, $5xYV9.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $3eqwL.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $5xYV9.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}

});



parcelRegister("eWwS1", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $de2f08c19bdd953c$export$94114666844d5f66);

var $gvP0M = parcelRequire("gvP0M");

var $3eqwL = parcelRequire("3eqwL");
const $de2f08c19bdd953c$export$94114666844d5f66 = (config)=>{
    return new (0, $gvP0M.PageSegmentLoadMetric)({
        ...config,
        type: (0, $3eqwL.BMEventsType).PAGE_SEGMENT_LOAD
    });
};

});
parcelRegister("gvP0M", function(module, exports) {
$parcel$export(module.exports, "PageSegmentLoadMetric", () => $fe7896f4de7701d2$export$24c8bfcd77494cc1);

var $23R3w = parcelRequire("23R3w");

var $3eqwL = parcelRequire("3eqwL");

var $5xYV9 = parcelRequire("5xYV9");

var $hw9oH = parcelRequire("hw9oH");

var $es0Kq = parcelRequire("es0Kq");
class $fe7896f4de7701d2$export$24c8bfcd77494cc1 extends (0, $hw9oH.Metric) {
    static{
        this.FMP = 'fmp';
    }
    constructor(config){
        super(config), this.isInitial = true;
        this.config = config;
    }
    startFromPageLoad() {
        const pageLoadMetaData = (0, $es0Kq.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $fe7896f4de7701d2$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($fe7896f4de7701d2$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $es0Kq.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$fe7896f4de7701d2$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $23R3w.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $3eqwL.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $5xYV9.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $5xYV9.MetricState).STARTED) (0, $es0Kq.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
}

});



parcelRegister("8YRrB", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $1ebe1204273a0715$export$c00d22927c60484a);

var $a3zw2 = parcelRequire("a3zw2");
class $1ebe1204273a0715$export$c00d22927c60484a extends (0, $a3zw2.UFOAbstractExperience) {
}

});
parcelRegister("a3zw2", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $17691ff469627e27$export$d31c89db257648c);

var $17hIO = parcelRequire("17hIO");

var $llCao = parcelRequire("llCao");

var $4IreF = parcelRequire("4IreF");

var $iznU1 = parcelRequire("iznU1");

var $iCGBp = parcelRequire("iCGBp");

var $2k4bX = parcelRequire("2k4bX");

var $aWuej = parcelRequire("aWuej");


var $iTVCC = parcelRequire("iTVCC");

var $h7rnK = parcelRequire("h7rnK");

var $8Vyrj = parcelRequire("8Vyrj");

var $4Jz7t = parcelRequire("4Jz7t");

var $aAN0e = parcelRequire("aAN0e");

var $d55U0 = parcelRequire("d55U0");

var $bJHRc = parcelRequire("bJHRc");

var $8TSjH = parcelRequire("8TSjH");

var $4xOWz = parcelRequire("4xOWz");

var $lYE2V = parcelRequire("lYE2V");

var $2EgEu = parcelRequire("2EgEu");

var $8nBFK = parcelRequire("8nBFK");

var $6EW77 = parcelRequire("6EW77");
const $17691ff469627e27$var$getPageVisibleState = ()=>{
    return !(0, $iTVCC.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $4xOWz.PageVisibleState).VISIBLE : (0, $4xOWz.PageVisibleState).HIDDEN;
};
class $17691ff469627e27$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $lYE2V.UFOExperienceState).NOT_STARTED;
        this.instanceId = null; // for concurrent
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.traceContext = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $4xOWz.PageVisibleState).MIXED;
            (0, $8TSjH.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $17691ff469627e27$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $8nBFK.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $8nBFK.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $d55U0.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $2EgEu.canTransition)(this.state, newState)) {
            (0, $d55U0.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $lYE2V.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = (0, $6EW77.perfNowOrTimestamp)(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $17hIO.default)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = (0, $6EW77.perfNowOrTimestamp)(timestamp);
                if (!this._isManualStateEnabled()) (0, $8Vyrj.getGlobalEventStream)().push((0, $aAN0e.unsubscribeEvent)((0, $4xOWz.SUBSCRIBE_ALL), this.handleDoneBind));
                this.stopTrace();
                const data = await this.exportData();
                (0, $d55U0.ufolog)('this.parent', this.parent);
                (0, $8Vyrj.getGlobalEventStream)().push((0, $h7rnK.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $d55U0.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $bJHRc.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $lYE2V.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $17691ff469627e27$var$getPageVisibleState();
            (0, $8TSjH.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $d55U0.ufolog)('subscribed', this.id);
                (0, $8Vyrj.getGlobalEventStream)().push((0, $4Jz7t.subscribeEvent)((0, $4xOWz.SUBSCRIBE_ALL), this.handleDoneBind));
            }
            this.startTrace(this.id);
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $4xOWz.FMP_MARK) && name !== (0, $4xOWz.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $bJHRc.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: (0, $6EW77.perfNowOrTimestamp)(timestamp)
        });
        this.transition((0, $lYE2V.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $4xOWz.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $4xOWz.INLINE_RESPONSE_MARK), timestamp);
    }
    startTrace(experienceId) {
        if ((0, $llCao.fg)('ufo_v1_tracing')) {
            let traceContext = (0, $2k4bX.getActiveTrace)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, $iCGBp.generateTraceId)(),
                    spanId: (0, $iznU1.generateSpanId)()
                };
                (0, $aWuej.setActiveTrace)(traceContext.traceId, traceContext.spanId, 'ufo_v1.' + experienceId);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, $llCao.fg)('ufo_v1_tracing')) (0, $4IreF.clearActiveTrace)();
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $bJHRc.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $8TSjH.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $lYE2V.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $lYE2V.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $lYE2V.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $d55U0.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $6b756b851d60bfdf$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig,
            ...(0, $llCao.fg)('ufo_v1_tracing') ? {
                traceContext: this.traceContext
            } : {}
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.traceContext = null;
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $6b756b851d60bfdf$export$2295b861f318254a = '0.1.5';

parcelRegister("h7rnK", function(module, exports) {
$parcel$export(module.exports, "experiencePayloadEvent", () => $a9b8b2d844e4de2b$export$7c957416596ca127);

var $4xOWz = parcelRequire("4xOWz");
const $a9b8b2d844e4de2b$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $4xOWz.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});

parcelRegister("4Jz7t", function(module, exports) {
$parcel$export(module.exports, "subscribeEvent", () => $01c695b70a752847$export$37863216db4b714d);

var $4xOWz = parcelRequire("4xOWz");
const $01c695b70a752847$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $4xOWz.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("aAN0e", function(module, exports) {
$parcel$export(module.exports, "unsubscribeEvent", () => $fce2a72ac410a8a9$export$ee1a7bd1fc9ea85e);

var $4xOWz = parcelRequire("4xOWz");
const $fce2a72ac410a8a9$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $4xOWz.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("lYE2V", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $0c2161f2644f1db5$export$81b70111112841a0);
const $0c2161f2644f1db5$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("2EgEu", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $0e68e47b7e727bf2$export$178881f329fdb81f);

var $lYE2V = parcelRequire("lYE2V");
const $0e68e47b7e727bf2$var$UFOStateAvailableTransitions = {
    [(0, $lYE2V.UFOExperienceState).NOT_STARTED.id]: [
        (0, $lYE2V.UFOExperienceState).STARTED.id
    ],
    [(0, $lYE2V.UFOExperienceState).STARTED.id]: [
        (0, $lYE2V.UFOExperienceState).IN_PROGRESS.id,
        (0, $lYE2V.UFOExperienceState).BLOCKED.id,
        (0, $lYE2V.UFOExperienceState).SUCCEEDED.id,
        (0, $lYE2V.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $lYE2V.UFOExperienceState).FAILED.id,
        (0, $lYE2V.UFOExperienceState).ABORTED.id
    ],
    [(0, $lYE2V.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $lYE2V.UFOExperienceState).BLOCKED.id,
        (0, $lYE2V.UFOExperienceState).SUCCEEDED.id,
        (0, $lYE2V.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $lYE2V.UFOExperienceState).FAILED.id,
        (0, $lYE2V.UFOExperienceState).ABORTED.id
    ],
    [(0, $lYE2V.UFOExperienceState).BLOCKED.id]: [
        (0, $lYE2V.UFOExperienceState).RECOVERED.id,
        (0, $lYE2V.UFOExperienceState).ABORTED.id
    ],
    [(0, $lYE2V.UFOExperienceState).RECOVERED.id]: [
        (0, $lYE2V.UFOExperienceState).STARTED.id,
        (0, $lYE2V.UFOExperienceState).SUCCEEDED.id,
        (0, $lYE2V.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $lYE2V.UFOExperienceState).FAILED.id,
        (0, $lYE2V.UFOExperienceState).ABORTED.id
    ],
    [(0, $lYE2V.UFOExperienceState).SUCCEEDED.id]: [
        (0, $lYE2V.UFOExperienceState).STARTED.id
    ],
    [(0, $lYE2V.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $lYE2V.UFOExperienceState).SUCCEEDED.id,
        (0, $lYE2V.UFOExperienceState).FAILED.id,
        (0, $lYE2V.UFOExperienceState).ABORTED.id
    ],
    [(0, $lYE2V.UFOExperienceState).FAILED.id]: [
        (0, $lYE2V.UFOExperienceState).STARTED.id
    ],
    [(0, $lYE2V.UFOExperienceState).ABORTED.id]: [
        (0, $lYE2V.UFOExperienceState).STARTED.id
    ]
};
const $0e68e47b7e727bf2$export$178881f329fdb81f = (state1, state2)=>{
    return $0e68e47b7e727bf2$var$UFOStateAvailableTransitions[state1.id] && $0e68e47b7e727bf2$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("6EW77", function(module, exports) {
$parcel$export(module.exports, "perfNowOrTimestamp", () => $f1509cd7246a7570$export$c753e8669d30c8ad);

var $icbWk = parcelRequire("icbWk");
const $f1509cd7246a7570$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $icbWk.roundPerfNow)();
};

});
parcelRegister("icbWk", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $276aac341955f1ce$export$5f490af6b2b115cf);
const $276aac341955f1ce$export$5f490af6b2b115cf = ()=>~~performance.now();

});




parcelRegister("82aOh", function(module, exports) {
$parcel$export(module.exports, "isAtlassianRelayEnvironment", () => $23802bbf003c14f2$export$56db1ec1ca8ef90c);
$parcel$export(module.exports, "createRelayEnvironment", () => $23802bbf003c14f2$export$7afaa9c867644497);

var $7LcWi = parcelRequire("7LcWi");

var $kwVED = parcelRequire("kwVED");

var $llCao = parcelRequire("llCao");

var $du32W = parcelRequire("du32W");

var $9Ygjv = parcelRequire("9Ygjv");

var $dJYfW = parcelRequire("dJYfW");

var $kX6ri = parcelRequire("kX6ri");

var $j3JfP = parcelRequire("j3JfP");

var $lIryO = parcelRequire("lIryO");

var $43nuC = parcelRequire("43nuC");

var $eqQe8 = parcelRequire("eqQe8");
// Enable Relay Resolvers globally for this module
(0, $7LcWi.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
function $23802bbf003c14f2$var$createNetwork(networkOptions, getEnableUfoHolds) {
    const fetchOperation = (request, variables, cacheConfig)=>(0, $dJYfW.fetch)(request, variables, cacheConfig, networkOptions);
    const fetchOperationWithMiddleware = (0, $eqQe8.ufoDataFetchHoldMiddleware)(fetchOperation, {
        getIsEnabled: getEnableUfoHolds
    });
    return (0, $7LcWi.Network).create(fetchOperationWithMiddleware, networkOptions.isServer === false ? (0, $lIryO.createSubscribeFn)(networkOptions) : undefined);
}
/**
 * Brand attached to every environment produced by {@link createRelayEnvironment}.
 *
 * We use `Symbol.for` (the global symbol registry) rather than a module-local `Symbol()` so the
 * brand stays stable even if this module ends up duplicated across bundles/realms — the guard in a
 * consumer will still recognise an environment created by another copy of this package.
 */ const $23802bbf003c14f2$var$ATLASSIAN_RELAY_ENVIRONMENT_BRAND = Symbol.for('@atlassian/relay-environment.AtlassianRelayEnvironment');
function $23802bbf003c14f2$var$brandEnvironment(environment) {
    Object.defineProperty(environment, $23802bbf003c14f2$var$ATLASSIAN_RELAY_ENVIRONMENT_BRAND, {
        value: true,
        enumerable: false,
        configurable: false,
        writable: false
    });
    return environment;
}
function $23802bbf003c14f2$export$56db1ec1ca8ef90c(environment) {
    return environment != null && (typeof environment === 'object' || typeof environment === 'function') && environment[$23802bbf003c14f2$var$ATLASSIAN_RELAY_ENVIRONMENT_BRAND] === true;
}
/**
 * Relay calls `environment.UNSTABLE_getDefaultRenderPolicy()` on every `QueryResource.prepare`, so
 * this allows overriding it dynamically (and not during module scope evaluation).
 */ class $23802bbf003c14f2$var$DynamicRenderPolicyEnvironment extends (0, $7LcWi.Environment) {
    constructor(config, getRenderPolicy){
        super(config);
        this.getRenderPolicy = getRenderPolicy;
    }
    /**
	 * Note: currently missing from @types/relay-runtime (version 20.1.1) but DOES exist at runtime.
	 */ UNSTABLE_getDefaultRenderPolicy() {
        return this.getRenderPolicy();
    }
}
const $23802bbf003c14f2$var$createStore = (source, options)=>new (0, (/*@__PURE__*/$parcel$interopDefault($kwVED)))(source, options);
function $23802bbf003c14f2$export$7afaa9c867644497({ log: log, requiredFieldLogger: requiredFieldLogger, networkOptions: networkOptions, getDataID: getDataID, getDefaultRenderPolicy: getDefaultRenderPolicy, getEnableUfoHolds: getEnableUfoHolds, wsClientOptions: wsClientOptions }) {
    if ((0, $llCao.fg)('platform_relay_enable_activity_compatibility_flag') || (0, $llCao.fg)('platform_relay_activity_compatibility_townsquare')) (0, $7LcWi.RelayFeatureFlags).ENABLE_ACTIVITY_COMPATIBILITY = true;
    if (wsClientOptions) (0, $du32W.configureWebSocketClient)(wsClientOptions);
    const source = new (0, $7LcWi.RecordSource)();
    const config = {
        configName: 'Atlassian Shared Graphql Gateway',
        network: $23802bbf003c14f2$var$createNetwork(networkOptions || {
            isServer: false
        }, getEnableUfoHolds),
        store: $23802bbf003c14f2$var$createStore(source, {
            log: log ?? undefined,
            getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $9Ygjv.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $9Ygjv.default),
        scheduler: (0, $j3JfP.default),
        missingFieldHandlers: (0, $kX6ri.default),
        handlerProvider: (0, $43nuC.createRelayHandlerProvider)(source)
    };
    const environment = getDefaultRenderPolicy ? new $23802bbf003c14f2$var$DynamicRenderPolicyEnvironment(config, getDefaultRenderPolicy) : new (0, $7LcWi.Environment)(config);
    return $23802bbf003c14f2$var$brandEnvironment(environment);
}

});
parcelRegister("kwVED", function(module, exports) {
'use strict';

var $9f4gV = parcelRequire("9f4gV");
module.exports = $9f4gV;

});

parcelRegister("du32W", function(module, exports) {
$parcel$export(module.exports, "configureWebSocketClient", () => $b9a26479fb2aeec8$export$155768b0e0a38663);
$parcel$export(module.exports, "getClient", () => $b9a26479fb2aeec8$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "attachConnectionRecovery", () => $b9a26479fb2aeec8$export$b4412e664c6cc09b);
$parcel$export(module.exports, "getSocketConnectionState", () => $b9a26479fb2aeec8$export$83dc7d6f7d0a4fad);
$parcel$export(module.exports, "acquireSubscriptionClient", () => $b9a26479fb2aeec8$export$2f4a9d3832f4a2d9);

var $k4jja = parcelRequire("k4jja");

var $llCao = parcelRequire("llCao");

var $2WJ9z = parcelRequire("2WJ9z");


var $7fM5s = parcelRequire("7fM5s");

var $lEiH8 = parcelRequire("lEiH8");

var $kxMWA = parcelRequire("kxMWA");

var $fWSBp = parcelRequire("fWSBp");
const $b9a26479fb2aeec8$var$defaultClientState = (0, $lEiH8.createClientState)();
let $b9a26479fb2aeec8$var$configuredOptions;
let $b9a26479fb2aeec8$var$recoveryCount = 0;
let $b9a26479fb2aeec8$var$detachRecovery;
const $b9a26479fb2aeec8$export$155768b0e0a38663 = (options)=>{
    if ($b9a26479fb2aeec8$var$defaultClientState.client) {
        // eslint-disable-next-line no-console
        console.warn('configureWebSocketClient was called after the subscription client was already created, so these options have been ignored. Configure it while creating the relay environment, before any subscription starts.');
        return;
    }
    $b9a26479fb2aeec8$var$configuredOptions = options;
};
const $b9a26479fb2aeec8$var$getClientForState = (state, url)=>{
    if ((0, $7fM5s.isSSR)()) return null;
    if (!state.client) {
        const onConnectionEvent = $b9a26479fb2aeec8$var$configuredOptions?.getConnectionEventReporter?.();
        const terminate = ()=>state.client?.terminate();
        const { listeners: listeners, isConnected: isConnected } = (0, $fWSBp.createSocketListeners)({
            onConnectionEvent: onConnectionEvent,
            pongWaitTimeout: (0, $llCao.fg)('platform_relay_subscription_reliability') ? (0, $e15c9062f5fd0542$export$6fe3216720bb7a79) : 0,
            terminate: terminate
        });
        state.isSocketConnected = isConnected;
        const rateLimitedRetryWait = (0, $llCao.fg)('platform_relay_subscription_reliability') && (0, $llCao.fg)('platform_relay_subscription_rate_limit_backoff') ? (0, $kxMWA.createRateLimitedRetryWait)((0, $e15c9062f5fd0542$export$bcf3b302e1a0ba63)) : undefined;
        const retryWait = (0, $llCao.fg)('platform_relay_subscription_reliability') ? rateLimitedRetryWait ?? (0, $kxMWA.createRetryWait)((0, $e15c9062f5fd0542$export$bcf3b302e1a0ba63)) : undefined;
        state.abortPendingRetryWait = retryWait?.abort ?? (()=>false);
        state.observesSocketState = (0, $llCao.fg)('platform_relay_subscription_reliability-additional') && Boolean(onConnectionEvent || (0, $llCao.fg)('platform_relay_subscription_reliability'));
        const options = {
            url: url ?? (0, $7fM5s.getAggSubscriptionEndpoint)(),
            lazy: true,
            keepAlive: (0, $llCao.fg)('platform_relay_subscription_reliability') ? (0, $e15c9062f5fd0542$export$68a6a6cccbaf5f06) : (0, $e15c9062f5fd0542$export$8b012b965402e06a),
            retryAttempts: (0, $llCao.fg)('platform_relay_subscription_reliability') ? (0, $e15c9062f5fd0542$export$6a0c27ebdbd1f0ed) : (0, $e15c9062f5fd0542$export$bf6cd96e19b2987f),
            retryWait: retryWait?.wait,
            shouldRetry: (0, $llCao.fg)('platform_relay_subscription_reliability') ? (0, $kxMWA.shouldRetryTransportFailure) : undefined,
            // 0 = wait forever (graphql-ws default).
            connectionAckWaitTimeout: (0, $llCao.fg)('platform_relay_subscription_reliability') ? (0, $e15c9062f5fd0542$export$e5f3cb8ab5223cd4) : 0,
            lazyCloseTimeout: (0, $llCao.fg)('platform_relay_subscription_connection_reuse') ? (0, $e15c9062f5fd0542$export$3f57674185473b5d) : 0,
            on: onConnectionEvent || (0, $llCao.fg)('platform_relay_subscription_reliability') ? listeners : undefined,
            connectionParams: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'X-ExperimentalApi': (0, $2WJ9z.getRelayExperimentalApis)().join(',')
            }
        };
        state.client = (0, $k4jja.createClient)(options);
        state.lazyCloseTimeout = options.lazyCloseTimeout;
        if (rateLimitedRetryWait) state.client.on('closed', rateLimitedRetryWait.recordClose);
    }
    return state.client;
};
const $b9a26479fb2aeec8$export$6bb76d6eba7e258c = ()=>$b9a26479fb2aeec8$var$getClientForState($b9a26479fb2aeec8$var$defaultClientState);
const $b9a26479fb2aeec8$export$b4412e664c6cc09b = ()=>{
    if (!(0, $llCao.fg)('platform_relay_subscription_reliability')) return ()=>{};
    $b9a26479fb2aeec8$var$recoveryCount += 1;
    if ($b9a26479fb2aeec8$var$recoveryCount === 1) (0, $lEiH8.setEndpointRecoveryEnabled)(true);
    $b9a26479fb2aeec8$var$detachRecovery ??= (0, $kxMWA.addRecoveryListeners)({
        terminate: ()=>$b9a26479fb2aeec8$var$defaultClientState.client?.terminate(),
        isConnected: ()=>$b9a26479fb2aeec8$var$defaultClientState.isSocketConnected(),
        abortRetryWait: ()=>$b9a26479fb2aeec8$var$defaultClientState.abortPendingRetryWait()
    });
    let released = false;
    return ()=>{
        if (released) return;
        released = true;
        $b9a26479fb2aeec8$var$recoveryCount -= 1;
        if ($b9a26479fb2aeec8$var$recoveryCount === 0) {
            (0, $lEiH8.setEndpointRecoveryEnabled)(false);
            $b9a26479fb2aeec8$var$detachRecovery?.();
            $b9a26479fb2aeec8$var$detachRecovery = undefined;
        }
    };
};
const $b9a26479fb2aeec8$export$2f0afd443356d36f = ()=>{
    $b9a26479fb2aeec8$var$defaultClientState.client = null;
    $b9a26479fb2aeec8$var$configuredOptions = undefined;
    $b9a26479fb2aeec8$var$defaultClientState.isSocketConnected = ()=>false;
    $b9a26479fb2aeec8$var$defaultClientState.abortPendingRetryWait = ()=>false;
    $b9a26479fb2aeec8$var$defaultClientState.observesSocketState = false;
    $b9a26479fb2aeec8$var$defaultClientState.lazyCloseTimeout = 0;
};
/** Unknown when the product has not enabled socket lifecycle reporting or reliability. */ const $b9a26479fb2aeec8$var$getConnectionState = (state)=>(0, $llCao.fg)('platform_relay_subscription_reliability-additional') && state.observesSocketState ? state.isSocketConnected() ? 'connected' : 'disconnected' : 'unknown';
const $b9a26479fb2aeec8$export$83dc7d6f7d0a4fad = ()=>$b9a26479fb2aeec8$var$getConnectionState($b9a26479fb2aeec8$var$defaultClientState);
const $b9a26479fb2aeec8$export$2f4a9d3832f4a2d9 = (url)=>(0, $7fM5s.isSSR)() ? null : (0, $lEiH8.acquireClient)(typeof url === 'function' ? url() : url, $b9a26479fb2aeec8$var$getClientForState, $b9a26479fb2aeec8$var$getConnectionState);

});
parcelRegister("k4jja", function(module, exports) {
$parcel$export(module.exports, "createClient", () => $e9c3289431fae5b2$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ 
var $5hQHW = parcelRequire("5hQHW");

var $10Se1 = parcelRequire("10Se1");
var $e9c3289431fae5b2$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $e9c3289431fae5b2$var$__await ? (this.v = v, this) : new $e9c3289431fae5b2$var$__await(v);
};
var $e9c3289431fae5b2$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e9c3289431fae5b2$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $e9c3289431fae5b2$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $e9c3289431fae5b2$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$e9c3289431fae5b2$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting', retrying);
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $5hQHW.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $5hQHW.stringifyMessage)({
                                    type: (0, $5hQHW.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if (errOrEvent instanceof $e9c3289431fae5b2$export$f5b1bfead8e118a7) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $5hQHW.stringifyMessage)(payload ? {
                            type: (0, $5hQHW.MessageType).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $5hQHW.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $5hQHW.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $5hQHW.CloseCode).InternalClientError, (0, $10Se1.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $5hQHW.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $5hQHW.stringifyMessage)(message.payload ? {
                                    type: (0, $5hQHW.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $5hQHW.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $5hQHW.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload, retrying); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $5hQHW.CloseCode).BadResponse, (0, $10Se1.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($e9c3289431fae5b2$var$isLikeCloseEvent(errOrCloseEvent) && ($e9c3289431fae5b2$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $5hQHW.CloseCode).InternalServerError,
            (0, $5hQHW.CloseCode).InternalClientError,
            (0, $5hQHW.CloseCode).BadRequest,
            (0, $5hQHW.CloseCode).BadResponse,
            (0, $5hQHW.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $5hQHW.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $5hQHW.CloseCode).SubscriberAlreadyExists,
            (0, $5hQHW.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($e9c3289431fae5b2$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    function subscribe(payload, sink) {
        const id = generateID(payload);
        let done = false, errored = false, releaser = ()=>{
            // for handling completions before connect
            locks--;
            done = true;
        };
        (async ()=>{
            locks++;
            for(;;)try {
                const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                // if done while waiting for connect, release the connection lock right away
                if (done) return release();
                const unlisten = emitter.onMessage(id, (message)=>{
                    switch(message.type){
                        case (0, $5hQHW.MessageType).Next:
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                            sink.next(message.payload);
                            return;
                        case (0, $5hQHW.MessageType).Error:
                            errored = true, done = true;
                            sink.error(message.payload);
                            releaser();
                            return;
                        case (0, $5hQHW.MessageType).Complete:
                            done = true;
                            releaser(); // release completes the sink
                            return;
                    }
                });
                socket.send((0, $5hQHW.stringifyMessage)({
                    id: id,
                    type: (0, $5hQHW.MessageType).Subscribe,
                    payload: payload
                }, replacer));
                releaser = ()=>{
                    if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                    socket.send((0, $5hQHW.stringifyMessage)({
                        id: id,
                        type: (0, $5hQHW.MessageType).Complete
                    }, replacer));
                    locks--;
                    done = true;
                    release();
                };
                // either the releaser will be called, connection completed and
                // the promise resolved or the socket closed and the promise rejected.
                // whatever happens though, we want to stop listening for messages
                await waitForReleaseOrThrowOnClose.finally(unlisten);
                return; // completed, shouldnt try again
            } catch (errOrCloseEvent) {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            }
        })().then(()=>{
            // delivering either an error or a complete terminates the sequence
            if (!errored) sink.complete();
        }) // resolves on release or normal closure
        .catch((err)=>{
            sink.error(err);
        }); // rejects on close events and errors
        return ()=>{
            // dispose only of active subscriptions
            if (!done) releaser();
        };
    }
    return {
        on: emitter.on,
        subscribe: subscribe,
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = subscribe(request, {
                next (val) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $e9c3289431fae5b2$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $e9c3289431fae5b2$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $e9c3289431fae5b2$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $e9c3289431fae5b2$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', new $e9c3289431fae5b2$export$f5b1bfead8e118a7());
        }
    };
}
class $e9c3289431fae5b2$export$f5b1bfead8e118a7 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'TerminatedCloseEvent';
        this.message = '4499: Terminated';
        this.code = 4499;
        this.reason = 'Terminated';
        this.wasClean = false;
    }
}
function $e9c3289431fae5b2$var$isLikeCloseEvent(val) {
    return (0, $10Se1.isObject)(val) && 'code' in val && 'reason' in val;
}
function $e9c3289431fae5b2$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $e9c3289431fae5b2$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});
parcelRegister("5hQHW", function(module, exports) {
$parcel$export(module.exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", () => $3d976cf3527ab04b$export$5c0a4edfedc7c457);
$parcel$export(module.exports, "CloseCode", () => $3d976cf3527ab04b$export$777128f41f6616ec);
$parcel$export(module.exports, "MessageType", () => $3d976cf3527ab04b$export$80edbf15fa61a4db);
$parcel$export(module.exports, "parseMessage", () => $3d976cf3527ab04b$export$f2f615077a189f21);
$parcel$export(module.exports, "stringifyMessage", () => $3d976cf3527ab04b$export$77896e5b47bfd50b);
/**
 *
 * common
 *
 */ 
var $10Se1 = parcelRequire("10Se1");
const $3d976cf3527ab04b$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $3d976cf3527ab04b$export$ec743af8bb66f3be = 'graphql-ws';
var $3d976cf3527ab04b$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($3d976cf3527ab04b$export$777128f41f6616ec || ($3d976cf3527ab04b$export$777128f41f6616ec = {}));
var $3d976cf3527ab04b$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($3d976cf3527ab04b$export$80edbf15fa61a4db || ($3d976cf3527ab04b$export$80edbf15fa61a4db = {}));
function $3d976cf3527ab04b$export$c17861b159b1b673(val) {
    if (!(0, $10Se1.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $10Se1.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $10Se1.extendedTypeof)(val.type)}`);
    switch(val.type){
        case $3d976cf3527ab04b$export$80edbf15fa61a4db.ConnectionInit:
        case $3d976cf3527ab04b$export$80edbf15fa61a4db.ConnectionAck:
        case $3d976cf3527ab04b$export$80edbf15fa61a4db.Ping:
        case $3d976cf3527ab04b$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $10Se1.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $3d976cf3527ab04b$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $10Se1.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $10Se1.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $10Se1.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $10Se1.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $10Se1.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $10Se1.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $10Se1.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $10Se1.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $10Se1.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $10Se1.extendedTypeof)(val.payload.extensions)}`);
            break;
        case $3d976cf3527ab04b$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $10Se1.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $10Se1.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $10Se1.extendedTypeof)(val.payload)}`);
            break;
        case $3d976cf3527ab04b$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $10Se1.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $10Se1.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $3d976cf3527ab04b$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $10Se1.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $3d976cf3527ab04b$export$9e0e49e75fa7d548(val) {
    try {
        $3d976cf3527ab04b$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $3d976cf3527ab04b$export$f2f615077a189f21(data, reviver) {
    return $3d976cf3527ab04b$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $3d976cf3527ab04b$export$77896e5b47bfd50b(msg, replacer) {
    $3d976cf3527ab04b$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}

});
parcelRegister("10Se1", function(module, exports) {
$parcel$export(module.exports, "extendedTypeof", () => $0bcfda8190a3d94c$export$573326049e1b1c6b);
$parcel$export(module.exports, "isObject", () => $0bcfda8190a3d94c$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "areGraphQLErrors", () => $0bcfda8190a3d94c$export$e6262fbc2e92290);
$parcel$export(module.exports, "limitCloseReason", () => $0bcfda8190a3d94c$export$2937fa0c8dddae54);
/** @private */ function $0bcfda8190a3d94c$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $0bcfda8190a3d94c$export$a6cdc56e425d0d0a(val) {
    return $0bcfda8190a3d94c$export$573326049e1b1c6b(val) === 'object';
}
function $0bcfda8190a3d94c$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $0bcfda8190a3d94c$export$92bd080471bc30f1(val) {
    return $0bcfda8190a3d94c$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $0bcfda8190a3d94c$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $0bcfda8190a3d94c$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

});



parcelRegister("2WJ9z", function(module, exports) {
$parcel$export(module.exports, "getRelayExperimentalApis", () => $ffa236ba1a3ed36c$export$2cb71284f72ca45b);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
const $ffa236ba1a3ed36c$export$ebe3a775ce3053a5 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs',
    'help-object-store-agg-beta',
    'HelpCenterReorderTopics',
    'polaris-v0'
];
const $ffa236ba1a3ed36c$export$2cb71284f72ca45b = ()=>$ffa236ba1a3ed36c$export$ebe3a775ce3053a5;

});

// Gate off keepAlive. UCT refresh window:
// https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $e15c9062f5fd0542$export$8b012b965402e06a = 580000;
const $e15c9062f5fd0542$export$68a6a6cccbaf5f06 = 30000;
const $e15c9062f5fd0542$export$6fe3216720bb7a79 = 15000;
const $e15c9062f5fd0542$export$e5f3cb8ab5223cd4 = 15000;
const $e15c9062f5fd0542$export$bf6cd96e19b2987f = 100;
const $e15c9062f5fd0542$export$bcf3b302e1a0ba63 = 30000;
const $e15c9062f5fd0542$export$74f911c394187993 = 4430;
const $e15c9062f5fd0542$export$5d72de7e544ab20f = 300000;
const $e15c9062f5fd0542$export$a5991d6597d2d0f8 = 15000;
const $e15c9062f5fd0542$export$6a0c27ebdbd1f0ed = 240;
const $e15c9062f5fd0542$export$3f57674185473b5d = 5000;
const $e15c9062f5fd0542$export$1ad8434180c5936c = 300000;

parcelRegister("7fM5s", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $c564fd9e2e84ab2f$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $c564fd9e2e84ab2f$export$29a72e89601dfc59);
const $c564fd9e2e84ab2f$export$48d7c418edadb60c = ()=>globalThis.false ?? false;
const $c564fd9e2e84ab2f$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});

parcelRegister("lEiH8", function(module, exports) {
$parcel$export(module.exports, "createClientState", () => $044daf149c047213$export$cc843780465d747);
$parcel$export(module.exports, "setEndpointRecoveryEnabled", () => $044daf149c047213$export$9a35d4fa6f37aac7);
$parcel$export(module.exports, "acquireClient", () => $044daf149c047213$export$8ecce7f262269062);

var $kxMWA = parcelRequire("kxMWA");
const $044daf149c047213$export$cc843780465d747 = ()=>({
        client: null,
        isSocketConnected: ()=>false,
        abortPendingRetryWait: ()=>false,
        observesSocketState: false,
        lazyCloseTimeout: 0
    });
const $044daf149c047213$var$clients = new Map();
let $044daf149c047213$var$recoveryEnabled = false;
function $044daf149c047213$var$attachRecovery(entry) {
    if ($044daf149c047213$var$recoveryEnabled && entry.references > 0 && !entry.detachRecovery) entry.detachRecovery = (0, $kxMWA.addRecoveryListeners)({
        terminate: ()=>entry.client.terminate(),
        isConnected: entry.state.isSocketConnected,
        abortRetryWait: entry.state.abortPendingRetryWait
    });
}
function $044daf149c047213$export$9a35d4fa6f37aac7(enabled) {
    $044daf149c047213$var$recoveryEnabled = enabled;
    for (const entry of $044daf149c047213$var$clients.values())if (enabled) $044daf149c047213$var$attachRecovery(entry);
    else {
        entry.detachRecovery?.();
        entry.detachRecovery = undefined;
    }
}
function $044daf149c047213$export$8ecce7f262269062(url, initialize, getConnectionState) {
    let entry = $044daf149c047213$var$clients.get(url);
    if (!entry) {
        const state = $044daf149c047213$export$cc843780465d747();
        const client = initialize(state, url);
        if (!client) return null;
        entry = {
            state: state,
            client: client,
            references: 0
        };
        $044daf149c047213$var$clients.set(url, entry);
    }
    const acquired = entry;
    clearTimeout(acquired.evictionTimer);
    acquired.evictionTimer = undefined;
    acquired.references += 1;
    $044daf149c047213$var$attachRecovery(acquired);
    let released = false;
    return {
        client: acquired.client,
        getSocketConnectionState: ()=>getConnectionState(acquired.state),
        release: ()=>{
            if (released) return;
            released = true;
            if (--acquired.references !== 0) return;
            acquired.detachRecovery?.();
            acquired.detachRecovery = undefined;
            const evict = ()=>{
                // A rapid resubscription can retain the entry during the lazy-close window.
                if (acquired.references !== 0 || $044daf149c047213$var$clients.get(url) !== acquired) return;
                $044daf149c047213$var$clients.delete(url);
                try {
                    Promise.resolve(acquired.client.dispose()).catch(()=>{
                    /* disposal errors must not break observer teardown */ });
                } catch  {
                /* disposal errors must not break observer teardown */ }
            };
            if (acquired.state.lazyCloseTimeout > 0) acquired.evictionTimer = setTimeout(evict, acquired.state.lazyCloseTimeout);
            else evict();
        }
    };
}

});
parcelRegister("kxMWA", function(module, exports) {
$parcel$export(module.exports, "createRetryWait", () => $2fad48b94d4ff451$export$ea2f6b7dff89727b);
$parcel$export(module.exports, "shouldRetryTransportFailure", () => $2fad48b94d4ff451$export$f7ed0a50263b7ba7);
$parcel$export(module.exports, "createRateLimitedRetryWait", () => $2fad48b94d4ff451$export$7543ed35130ad0de);
$parcel$export(module.exports, "addRecoveryListeners", () => $2fad48b94d4ff451$export$693cd641fa681cb1);

var $jF8Yw = parcelRequire("jF8Yw");

const $2fad48b94d4ff451$export$ea2f6b7dff89727b = (maxRetryWait)=>{
    let abortCurrent;
    return {
        abort: ()=>{
            if (!abortCurrent) return false;
            abortCurrent();
            abortCurrent = undefined;
            return true;
        },
        wait: async (retries)=>{
            const jitter = Math.floor(Math.random() * 2700 + 300);
            const delay = Math.min(1000 * 2 ** retries + jitter, maxRetryWait);
            await new Promise((resolve)=>{
                const timer = setTimeout(()=>{
                    abortCurrent = undefined;
                    resolve();
                }, delay);
                abortCurrent = ()=>{
                    clearTimeout(timer);
                    resolve();
                };
            });
        }
    };
};
// The library's own default `shouldRetry`. From 5.16, `Client.terminate()` emits a close-like
// `Error`, so the close shape must be checked before the type.
const $2fad48b94d4ff451$var$isLikeCloseEvent = (value)=>typeof value === 'object' && value !== null && 'code' in value && 'reason' in value;
const $2fad48b94d4ff451$export$f7ed0a50263b7ba7 = (errOrCloseEvent)=>$2fad48b94d4ff451$var$isLikeCloseEvent(errOrCloseEvent) || !(errOrCloseEvent instanceof Error);
/** Retry-after in ms of a rate-limit close, or undefined for any other close. */ const $2fad48b94d4ff451$var$getRateLimitRetryAfter = (event)=>{
    if (!$2fad48b94d4ff451$var$isLikeCloseEvent(event) || event.code !== (0, $e15c9062f5fd0542$export$74f911c394187993) || typeof event.reason !== 'string' || !/^\d+$/.test(event.reason)) return undefined;
    return Math.min(Math.max(Number(event.reason), 1) * 1000, (0, $e15c9062f5fd0542$export$5d72de7e544ab20f));
};
const $2fad48b94d4ff451$export$7543ed35130ad0de = (maxRetryWait)=>{
    let notBefore = 0;
    let abortCurrent;
    return {
        recordClose: (event)=>{
            const retryAfter = $2fad48b94d4ff451$var$getRateLimitRetryAfter(event);
            if (retryAfter !== undefined) notBefore = Date.now() + retryAfter + Math.floor(Math.random() * (0, $e15c9062f5fd0542$export$a5991d6597d2d0f8));
        },
        abort: ()=>{
            if (!abortCurrent) return false;
            abortCurrent();
            return true;
        },
        wait: async (retries)=>{
            const jitter = Math.floor(Math.random() * 2700 + 300);
            // Jitter after the cap, so clients that reached it do not retry in lockstep.
            const backoff = Math.min(1000 * 2 ** retries, maxRetryWait) + jitter;
            await new Promise((resolve)=>{
                let timer;
                const finish = ()=>{
                    clearTimeout(timer);
                    abortCurrent = undefined;
                    resolve();
                };
                const finishAfter = (delay)=>{
                    clearTimeout(timer);
                    timer = setTimeout(finish, delay);
                };
                finishAfter(Math.max(backoff, notBefore - Date.now()));
                abortCurrent = ()=>{
                    const untilDeadline = notBefore - Date.now();
                    if (untilDeadline > 0) finishAfter(untilDeadline);
                    else finish();
                };
            });
        }
    };
};
const $2fad48b94d4ff451$export$693cd641fa681cb1 = ({ terminate: terminate, isConnected: isConnected, abortRetryWait: abortRetryWait })=>{
    const doc = (0, $jF8Yw.getDocument)();
    const reconnect = ()=>{
        if (abortRetryWait()) return;
        terminate();
    };
    const wakeIfDisconnected = ()=>{
        if (!isConnected()) reconnect();
    };
    const onVisibilityChange = ()=>{
        if (doc?.visibilityState === 'visible') wakeIfDisconnected();
    };
    const onPageShow = (event)=>{
        // pageshow also fires on ordinary loads; only `persisted` is bfcache.
        if (event.persisted) reconnect();
    };
    const onResume = ()=>{
        reconnect();
    };
    window.addEventListener('online', wakeIfDisconnected);
    window.addEventListener('pageshow', onPageShow);
    doc?.addEventListener('visibilitychange', onVisibilityChange);
    // Chrome tab freeze; no pageshow.
    doc?.addEventListener('resume', onResume);
    return ()=>{
        window.removeEventListener('online', wakeIfDisconnected);
        window.removeEventListener('pageshow', onPageShow);
        doc?.removeEventListener('visibilitychange', onVisibilityChange);
        doc?.removeEventListener('resume', onResume);
    };
};

});


parcelRegister("fWSBp", function(module, exports) {
$parcel$export(module.exports, "createSocketListeners", () => $01e8139057be223c$export$e9b0d6f3238eb01d);

var $npRTf = parcelRequire("npRTf");
// Browser close is a CloseEvent; Client.terminate() emits a close-like object, which from
// graphql-ws 5.16 is an Error.
const $01e8139057be223c$var$readCloseInfo = (event)=>{
    if (typeof event !== 'object' || event === null) return {
        closeCode: null,
        reason: null,
        wasClean: null
    };
    const code = 'code' in event ? event.code : undefined;
    const reason = 'reason' in event ? event.reason : undefined;
    const wasClean = 'wasClean' in event ? event.wasClean : undefined;
    return {
        closeCode: typeof code === 'number' ? code : null,
        reason: typeof reason === 'string' ? reason : null,
        wasClean: typeof wasClean === 'boolean' ? wasClean : null
    };
};
const $01e8139057be223c$export$e9b0d6f3238eb01d = ({ onConnectionEvent: onConnectionEvent, pongWaitTimeout: pongWaitTimeout, terminate: terminate })=>{
    let attempt = 0;
    let connectionCount = 0;
    let connectedAt = null;
    let pongDeadline;
    const report = (event)=>{
        if (!onConnectionEvent) return;
        try {
            onConnectionEvent(event);
        } catch  {
        // Avoid breaking the transport if reporting throws.
        }
    };
    const clearPongDeadline = ()=>{
        clearTimeout(pongDeadline);
        pongDeadline = undefined;
    };
    return {
        isConnected: ()=>connectedAt !== null,
        listeners: {
            connecting: ()=>{
                attempt += 1;
                report({
                    type: 'connecting',
                    attempt: attempt
                });
            },
            opened: ()=>{
                report({
                    type: 'opened',
                    attempt: attempt
                });
            },
            connected: ()=>{
                connectionCount += 1;
                connectedAt = Date.now();
                report({
                    type: 'connected',
                    attempt: attempt,
                    connectionCount: connectionCount
                });
                attempt = 0;
            },
            closed: (event)=>{
                // Drop the deadline so it cannot kill a reconnecting socket.
                clearPongDeadline();
                report({
                    type: 'closed',
                    ...$01e8139057be223c$var$readCloseInfo(event),
                    connectedForMs: connectedAt === null ? null : Date.now() - connectedAt
                });
                connectedAt = null;
            },
            // Only our outbound ping arms the deadline; only an inbound pong clears it.
            ping: (received)=>{
                if (received || pongWaitTimeout <= 0) return;
                clearPongDeadline();
                pongDeadline = setTimeout(terminate, pongWaitTimeout);
            },
            pong: (received)=>{
                if (received) clearPongDeadline();
            },
            error: (error)=>{
                report({
                    type: 'error',
                    message: error instanceof Error ? error.message : null,
                    kind: (0, $npRTf.getSinkError)(error).kind
                });
            }
        }
    };
};

});
parcelRegister("npRTf", function(module, exports) {
$parcel$export(module.exports, "getSinkError", () => $11822b6c5cedb02e$export$ece4736473c28965);

var $llCao = parcelRequire("llCao");
/** `Array.isArray` alone narrows a `readonly` array to `any[]`, losing the element type. */ const $11822b6c5cedb02e$var$isGraphQLErrorArray = (error)=>Array.isArray(error);
/**
 * Events are duck-typed rather than matched with `instanceof`: `Event`, `CloseEvent` and
 * `ErrorEvent` are not globals in every environment the client runs in, and `instanceof`
 * throws outright when its right-hand side is undefined.
 */ const $11822b6c5cedb02e$var$isEventLike = (error)=>typeof error === 'object' && error !== null && 'type' in error && typeof error.type === 'string';
const $11822b6c5cedb02e$var$isCloseEvent = (error)=>$11822b6c5cedb02e$var$isEventLike(error) && error.type === 'close';
const $11822b6c5cedb02e$var$isErrorEvent = (error)=>$11822b6c5cedb02e$var$isEventLike(error) && error.type === 'error';
// The numeric `code` keeps out Node-style errors, whose `code` is a string such as `ECONNRESET`.
const $11822b6c5cedb02e$var$isCloseLike = (error)=>typeof error === 'object' && error !== null && 'code' in error && typeof error.code === 'number' && 'reason' in error && typeof error.reason === 'string';
/** Non-enumerable details on a shared Error instance (same object goes to every sink). */ const $11822b6c5cedb02e$var$withDetails = (error, details)=>{
    for (const [key, value] of Object.entries(details))Object.defineProperty(error, key, {
        value: value,
        enumerable: false,
        configurable: true,
        writable: true
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return error;
};
/** Pre-gate sink shaping. */ const $11822b6c5cedb02e$var$getLegacySinkError = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const closeEvent = error;
        errorInfo = new Error(`CloseEvent: ${closeEvent.reason}`);
        errorInfo.closeCode = closeEvent.code;
        errorInfo.wasClean = closeEvent.wasClean;
    } else if (typeof error === 'object' && 'type' in error && error.type === 'error') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const errorEvent = error;
        errorInfo = new Error(`ErrorEvent: "${errorEvent.error}"`);
    } else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};
const $11822b6c5cedb02e$var$getStructuredSinkError = (error)=>{
    if ($11822b6c5cedb02e$var$isGraphQLErrorArray(error)) {
        const [firstError] = error;
        // A real Error, not the raw payload element typed as one, so it carries a stack. AGG
        // sends these as JSON, so the element is a plain object however it is typed.
        const errorInfo = Object.assign(new Error(firstError?.message), {
            kind: 'graphql-errors',
            graphQLErrors: error
        });
        if (firstError?.stack) errorInfo.stack = firstError.stack;
        return errorInfo;
    }
    if (error instanceof Error) // Its own `wasClean`, where it has one, is left as it is rather than redefined.
    return $11822b6c5cedb02e$var$withDetails(error, $11822b6c5cedb02e$var$isCloseLike(error) ? {
        kind: 'close-event',
        closeCode: error.code
    } : {
        kind: 'error'
    });
    if ($11822b6c5cedb02e$var$isCloseEvent(error)) return Object.assign(new Error(`CloseEvent: ${error.reason}`), {
        kind: 'close-event',
        closeCode: error.code,
        wasClean: error.wasClean
    });
    if ($11822b6c5cedb02e$var$isErrorEvent(error)) return Object.assign(new Error(`ErrorEvent: "${error.error}"`), {
        kind: 'error-event'
    });
    if ($11822b6c5cedb02e$var$isEventLike(error)) return Object.assign(new Error(`Event: ${error.type}`), {
        kind: 'event'
    });
    // `String` rather than interpolation, which throws for a symbol.
    const message = `Unknown sink error: ${String(error)}`;
    // A close with no `type`, such as "All Subscriptions Gone". The message stays as it was,
    // because consumers match on it.
    if ($11822b6c5cedb02e$var$isCloseLike(error)) return Object.assign(new Error(message), {
        kind: 'close-event',
        closeCode: error.code,
        ...'wasClean' in error && typeof error.wasClean === 'boolean' ? {
            wasClean: error.wasClean
        } : {}
    });
    return Object.assign(new Error(message), {
        kind: 'unknown'
    });
};
const $11822b6c5cedb02e$export$ece4736473c28965 = (error)=>{
    if ((0, $llCao.fg)('platform_relay_subscription_sink_error')) return $11822b6c5cedb02e$var$getStructuredSinkError(error);
    // Gate off: legacy shape (no `kind`).
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $11822b6c5cedb02e$var$getLegacySinkError(error);
};

});



parcelRegister("9Ygjv", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3936abeb2b4084c$export$2e2bcd8739ae039);
function $f3936abeb2b4084c$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    return `${String(id)}:::::${typeName}`;
}

});

parcelRegister("dJYfW", function(module, exports) {
$parcel$export(module.exports, "fetch", () => $8d15e8059af9d50b$export$e7aa7bc5c1b3cfb3);

var $gmwAy = parcelRequire("gmwAy");

var $7LcWi = parcelRequire("7LcWi");

var $llCao = parcelRequire("llCao");

var $3Lx6t = parcelRequire("3Lx6t");

var $ag5I6 = parcelRequire("ag5I6");

var $1eIfd = parcelRequire("1eIfd");

var $8ryVV = parcelRequire("8ryVV");

var $c2vQm = parcelRequire("c2vQm");

var $kcAhT = parcelRequire("kcAhT");

var $edb2K = parcelRequire("edb2K");

var $jEWVr = parcelRequire("jEWVr");

var $37TPL = parcelRequire("37TPL");

var $717i4 = parcelRequire("717i4");

var $2uD1g = parcelRequire("2uD1g");

var $bGlyK = parcelRequire("bGlyK");
const $8d15e8059af9d50b$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $8d15e8059af9d50b$var$moduleID = 'relay-fetch';
const $8d15e8059af9d50b$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig, dependencies)=>{
    if (dependencies?.didPreflightAuthenticationCheckTriggerRedirect?.(request, variables, cacheConfig) === true) // Jira's preflight check starts login navigation as a side effect. Keep Relay pending
    // while the redirect takes over instead of starting a fetch with a stale auth state.
    return (0, $7LcWi.Observable).from(new Promise(()=>{}));
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = dependencies?.getLoggingAndMetricsHelper?.(loggingMetadata);
    // Per-query opt-in (cacheConfig.metadata.captureErrors) to forward this operation's response to
    // the product's capture callback, if one is provided. Whether to actually capture (feature gates,
    // etc.) is a product concern owned by the callback itself, not by this platform code.
    const shouldCaptureErrors = cacheConfig?.metadata?.captureErrors === true && !dependencies?.isServer;
    let responseHeaders;
    function augmentResponse(response) {
        const traceIdFromHeader = // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        (0, $llCao.fg)('platform_relay_fetch_traceid_header_fallback') && responseHeaders ? responseHeaders.get('atl-traceid') ?? undefined : undefined;
        (0, $8ryVV.addTraceId)(queryName, (0, $bGlyK.getTraceIdFromExtensions)(response) ?? traceIdFromHeader);
        (0, $3Lx6t.putExtensions)(queryName, response.extensions);
    }
    // TODO: This needs to be changed by removing each Product, and only if all keys are empty final output is null
    function enforceNonNullability(response) {
        if (response.data && // DO NOT ADD TO THIS CONDITION.
        // Doing so can make service timeouts in non-critical dependencies result in a complete breakage of experiences.
        // If requesting a namespaced field, flatten it - e.g. "query { foo { bar {" should become "query { foo_bar {".
        // See https://atlassian.slack.com/archives/C01E2MPPLE4/p1780367270438419.
        (response.data.jira === null || response.data.customerService === null || response.data.graphStore === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    return (0, $7LcWi.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$8d15e8059af9d50b$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // handles getting multipart response
            const getData = ()=>{
                const endpoint = (0, $ag5I6.getAggEndpoint)(request, cacheConfig);
                const body = (0, $ag5I6.getRequestBody)(request, variables);
                let options = {
                    body: body
                };
                if (dependencies?.getHeaders) {
                    const headers = dependencies.getHeaders({
                        endpoint: endpoint,
                        options: options,
                        request: request,
                        variables: variables
                    });
                    options = {
                        ...options,
                        headers: {
                            ...options.headers,
                            ...headers
                        }
                    };
                }
                if (dependencies?.getAbortSignal) options.signal = dependencies?.getAbortSignal();
                const fetchOverNetwork = (0, $edb2K.buildGraphqlSmartFetch)({
                    url: dependencies?.setEndpoint ? dependencies?.setEndpoint(endpoint) : endpoint,
                    options: options,
                    variables: variables,
                    request: request,
                    isServer: dependencies?.isServer || false,
                    cacheConfig: cacheConfig
                });
                const earlyScriptPromise = dependencies?.earlyScriptPromise?.(request, variables);
                let fetchFn = fetchOverNetwork;
                let initialSource = fetchFn;
                if (dependencies?.withErrorHandling) {
                    const withErrorHandling = dependencies.withErrorHandling;
                    initialSource = ()=>!dependencies?.isServer && earlyScriptPromise ? withErrorHandling(earlyScriptPromise) : withErrorHandling(fetchFn());
                }
                const responses = (0, $jEWVr.processMultipartPromise)(()=>(0, $717i4.retryOnError)(initialSource, {
                        retryFunc: fetchFn,
                        retryPredicate: (0, $2uD1g.shouldRetry),
                        retryAttempts: (0, $37TPL.getRetryAttemptsForQuery)(request),
                        onRetry: loggingAndMetrics?.logErrorRetry
                    }), dependencies?.onFetchError, (headers)=>{
                    responseHeaders = headers;
                });
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (dependencies?.isServer) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = $8d15e8059af9d50b$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, $1eIfd.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, $1eIfd.QueryPromisesMap).set(requestID, firstResponse);
                            (0, $1eIfd.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: (r)=>{
                        let payload = r;
                        let response = payload || {};
                        if (dependencies?.isServer && $8d15e8059af9d50b$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, $kcAhT.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if (shouldCaptureErrors && typeof dependencies?.captureResponseErrors === 'function') dependencies.captureResponseErrors(request, singularResponse);
                            if (dependencies?.validateResponse && !dependencies.validateResponse(request, singularResponse)) {
                                dependencies?.onInvalidResponse?.(request, singularResponse);
                                responseShouldHang = true;
                                return;
                            }
                            enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if (dependencies?.isServer && requestID != null && typeof dependencies?.queryResponseCache !== 'undefined') {
                                if ('appendWithMetadata' in dependencies.queryResponseCache) dependencies.queryResponseCache.appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                                else dependencies.queryResponseCache.setWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                            }
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if (dependencies?.isServer && $8d15e8059af9d50b$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        loggingAndMetrics?.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!dependencies?.isServer && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = dependencies?.queryResponseCache?.get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($gmwAy)))(ssrCache)) {
                    // The cached payload is seeded into Relay below without passing through
                    // validateResponse, so capture its errors here instead.
                    if (shouldCaptureErrors && !Array.isArray(ssrCache) && typeof dependencies?.captureResponseErrors === 'function') dependencies.captureResponseErrors(request, ssrCache);
                    dependencies?.queryResponseCache?.delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($8d15e8059af9d50b$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $c2vQm.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $c2vQm.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                dependencies?.handleAbort?.(request, reason);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics?.logError(error);
            sink.error(error);
        }
    });
};

});
parcelRegister("3Lx6t", function(module, exports) {
$parcel$export(module.exports, "startCapturingExtensions", () => $a59d54c13dd1788b$export$8656ba3981c6f6c1);
$parcel$export(module.exports, "stopCapturingExtensions", () => $a59d54c13dd1788b$export$f16fa6040161f056);
$parcel$export(module.exports, "putExtensions", () => $a59d54c13dd1788b$export$17dc47fdf278de21);
$parcel$export(module.exports, "getExtensions", () => $a59d54c13dd1788b$export$7c6ea4184129ef74);
const $a59d54c13dd1788b$var$OperationExtensionsMap = {};
const $a59d54c13dd1788b$export$8656ba3981c6f6c1 = (operationName)=>{
    $a59d54c13dd1788b$var$OperationExtensionsMap[operationName] = $a59d54c13dd1788b$var$OperationExtensionsMap[operationName] || [];
};
const $a59d54c13dd1788b$export$f16fa6040161f056 = (operationName)=>{
    $a59d54c13dd1788b$var$OperationExtensionsMap[operationName] = undefined;
};
const $a59d54c13dd1788b$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $a59d54c13dd1788b$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $a59d54c13dd1788b$export$7c6ea4184129ef74 = (operationName)=>$a59d54c13dd1788b$var$OperationExtensionsMap[operationName] || [];

});

parcelRegister("ag5I6", function(module, exports) {
$parcel$export(module.exports, "getAggEndpoint", () => $a96c44b973c5ba19$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $a96c44b973c5ba19$export$55bce18df99af758);

var $hoalA = parcelRequire("hoalA");
const $a96c44b973c5ba19$var$branchSlug = typeof $hoalA !== 'undefined' && $hoalA.env ? undefined : undefined;
// Pre-encoded value passed through verbatim as the `serviceOverride` query param.
const $a96c44b973c5ba19$var$serviceOverrides = typeof $hoalA !== 'undefined' && $hoalA.env ? undefined : undefined;
const $a96c44b973c5ba19$export$8f8c52ac77845a86 = `/gateway/api/graphql${$a96c44b973c5ba19$var$branchSlug ? `/${$a96c44b973c5ba19$var$branchSlug}/graphql` : ''}`;
const $a96c44b973c5ba19$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    let endpoint = $a96c44b973c5ba19$export$8f8c52ac77845a86;
    if (cacheConfig.metadata?.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    let url = `${endpoint}?operation=${request.name}`;
    if ($a96c44b973c5ba19$var$serviceOverrides) url = `${url}&serviceOverride=${$a96c44b973c5ba19$var$serviceOverrides}`;
    return url;
};
const $a96c44b973c5ba19$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});

parcelRegister("1eIfd", function(module, exports) {
$parcel$export(module.exports, "QueryPromisesMap", () => $ae2ce4fdb0006700$export$607b80f5bc6e396d);
$parcel$export(module.exports, "CompletedQueryPromisesMap", () => $ae2ce4fdb0006700$export$cdadce6ed6361a2c);
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $ae2ce4fdb0006700$export$607b80f5bc6e396d = new Map();
const $ae2ce4fdb0006700$export$cdadce6ed6361a2c = new Map();

});

parcelRegister("8ryVV", function(module, exports) {
$parcel$export(module.exports, "startCapturingTraceIds", () => $2ede587a8967f766$export$a2bcb2fac360646c);
$parcel$export(module.exports, "stopCapturingTraceIds", () => $2ede587a8967f766$export$559128bdc4352001);
$parcel$export(module.exports, "addTraceId", () => $2ede587a8967f766$export$fcaa732775f12226);
$parcel$export(module.exports, "getTraceIds", () => $2ede587a8967f766$export$5113e470f5c95670);
const $2ede587a8967f766$var$OperationTraceIdMap = {};
const $2ede587a8967f766$export$a2bcb2fac360646c = (operationName)=>{
    $2ede587a8967f766$var$OperationTraceIdMap[operationName] = $2ede587a8967f766$var$OperationTraceIdMap[operationName] || [];
};
const $2ede587a8967f766$export$559128bdc4352001 = (operationName)=>{
    $2ede587a8967f766$var$OperationTraceIdMap[operationName] = undefined;
};
const $2ede587a8967f766$export$fcaa732775f12226 = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = $2ede587a8967f766$var$OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const $2ede587a8967f766$export$5113e470f5c95670 = (operationName)=>$2ede587a8967f766$var$OperationTraceIdMap[operationName] || [];

});

parcelRegister("edb2K", function(module, exports) {
$parcel$export(module.exports, "buildGraphqlSmartFetch", () => $591fcdf062f28c1a$export$33c9c992c7855d86);

var $jo5KC = parcelRequire("jo5KC");

var $2WJ9z = parcelRequire("2WJ9z");

var $ajJyl = parcelRequire("ajJyl");

var $iC37n = parcelRequire("iC37n");
const $591fcdf062f28c1a$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
function $591fcdf062f28c1a$export$33c9c992c7855d86({ url: url, options: options, variables: variables, request: request, isServer: isServer, cacheConfig: cacheConfig }) {
    const headers = {
        'atl-client-name': 'atlassian-frontend-monorepo',
        Accept: $591fcdf062f28c1a$var$relayDeferAcceptableFormats.join(', '),
        'X-ExperimentalApi': (0, $2WJ9z.getRelayExperimentalApis)().join(','),
        ...cacheConfig?.metadata?.headers || {}
    };
    const requestOptions = (0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(options, {
        credentials: 'same-origin',
        headers: headers
    });
    requestOptions.headers['Content-Type'] = 'application/json';
    // Default `atl-attribution` header value for AGG requests
    // https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
    if (!requestOptions.headers['atl-attribution']) requestOptions.headers['atl-attribution'] = JSON.stringify({
        service: 'afm-frontend'
    });
    const { isGetRequest: isGetRequest, reason: reason } = (0, $iC37n.shouldUseGetMethod)({
        url: url,
        variables: variables,
        request: request,
        headers: requestOptions.headers,
        isServer: isServer
    });
    // Nav4ProjectsContentQuery is forced to go POST route to avoid the stale cache issues when transition between issues in Issue-view
    // that's not a permanent fix, but rather an attampt to unblock the team
    // Context: #jiv-navigation-issue channel
    if (isGetRequest && request.name !== 'Nav4ProjectsContentQuery') {
        requestOptions.method = 'GET';
        url = (0, $ajJyl.buildGetUrl)(url, variables);
        delete requestOptions.body; // Not needed for GET
    } else {
        requestOptions.method = 'POST';
        if (reason) requestOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
    }
    return ()=>fetch(url, requestOptions);
}

});
parcelRegister("ajJyl", function(module, exports) {
$parcel$export(module.exports, "buildGetUrl", () => $6fe7cbbcecc37733$export$28ae0033b80c6303);
function $6fe7cbbcecc37733$export$28ae0033b80c6303(baseUrl, variables) {
    const params = new URLSearchParams();
    params.append('variables', JSON.stringify(variables));
    return baseUrl + `${baseUrl.includes('?') ? '&' : '?'}${params.toString()}`;
}

});

parcelRegister("iC37n", function(module, exports) {
$parcel$export(module.exports, "shouldUseGetMethod", () => $6232d6623753f921$export$5ad31d96a9271d42);

var $2s20S = parcelRequire("2s20S");

var $ajJyl = parcelRequire("ajJyl");

var $3EVY7 = parcelRequire("3EVY7");
const $6232d6623753f921$var$MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
const $6232d6623753f921$var$MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
function $6232d6623753f921$export$5ad31d96a9271d42({ url: baseUrl, variables: variables, request: request, headers: headers, isServer: isServer }) {
    if (isServer) return {
        isGetRequest: false,
        reason: 'SSR'
    };
    if ((0, $2s20S.killswitch)('relay-get-queries')) return {
        isGetRequest: false,
        reason: 'Killswitch is on'
    };
    if (request.operationKind !== 'query') return {
        isGetRequest: false,
        reason: request.operationKind
    };
    const queryLength = (0, $ajJyl.buildGetUrl)(baseUrl, variables).length;
    const headersSize = (0, $3EVY7.calculateHeadersSize)(headers || {});
    return queryLength <= $6232d6623753f921$var$MAX_QUERY_LENGTH && headersSize <= $6232d6623753f921$var$MAX_HEADERS_SIZE ? {
        isGetRequest: true
    } : {
        isGetRequest: false,
        reason: 'URL length or headers size too large'
    };
}

});
parcelRegister("2s20S", function(module, exports) {
$parcel$export(module.exports, "killswitch", () => $0f1913b01a8ea003$export$fcfcaa5d2f57d3a7);

var $5Y9N2 = parcelRequire("5Y9N2");
let $0f1913b01a8ea003$var$cachedNames;
const $0f1913b01a8ea003$var$isStringArray = (value)=>Array.isArray(value) && value.every((name)=>typeof name === 'string');
function $0f1913b01a8ea003$export$fcfcaa5d2f57d3a7(name) {
    if (!$0f1913b01a8ea003$var$cachedNames) {
        // Do not permanently cache the default before the host initializes the SDK.
        if (!(0, $5Y9N2.default).initializeCompleted()) return false;
        // Killswitches are operational controls and must not fire experiment exposures.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- shared dynamic config killswitch helper
        const config = (0, $5Y9N2.default).getExperimentValue('killswitch', 'value', [], {
            fireExperimentExposure: false,
            typeGuard: $0f1913b01a8ea003$var$isStringArray
        });
        // SDK mocks and config overrides can bypass the SDK's type guard.
        $0f1913b01a8ea003$var$cachedNames = new Set($0f1913b01a8ea003$var$isStringArray(config) ? config.map((entry)=>entry.toLowerCase()) : []);
    }
    return $0f1913b01a8ea003$var$cachedNames.has(name.toLowerCase());
}

});

parcelRegister("3EVY7", function(module, exports) {
$parcel$export(module.exports, "calculateHeadersSize", () => $688972b728da8b76$export$dd754c3ef60c6999);
// Calculate the size of the headers
function $688972b728da8b76$export$dd754c3ef60c6999(headers) {
    let totalBytes = 0;
    const textEncoder = new TextEncoder();
    // Iterate over each header entry (name and value)
    for (const [name, value] of Object.entries(headers)){
        const headerSize = textEncoder.encode(`${name}: ${value}\r\n`).length; // Include CRLF
        totalBytes += headerSize;
    }
    return totalBytes;
}

});



parcelRegister("jEWVr", function(module, exports) {
$parcel$export(module.exports, "processMultipartPromise", () => $e6200643f3915ef4$export$f76505a7f2969e4e);

var $7LcWi = parcelRequire("7LcWi");

var $llCao = parcelRequire("llCao");

var $dHUmU = parcelRequire("dHUmU");
const $e6200643f3915ef4$var$NO_CONTENT = 204;
function $e6200643f3915ef4$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
/**
 * Forward `error` to `observer.error`, giving the product-provided
 * `onFetchError` (if any) a chance to transform it first.
 */ function $e6200643f3915ef4$var$emitError(observer, error, response, onFetchError) {
    const transformed = onFetchError ? onFetchError(error, response) : error;
    // `Sink.error` accepts `Error` per its type, but in practice relay
    // forwards whatever it receives to consumers. Cast to keep the existing
    // signature while allowing products to return any error-like value.
    observer.error(transformed);
}
function $e6200643f3915ef4$var$handleMultipartResponse(response, observer, onFetchError) {
    const contentType = response.headers.get('content-type');
    const boundary = $e6200643f3915ef4$var$getBoundary(contentType || '');
    if (!boundary) {
        $e6200643f3915ef4$var$emitError(observer, new Error('Invalid multipart boundary'), response, onFetchError);
        return;
    }
    const decoder = new TextDecoder('utf-8');
    async function* streamReader() {
        // @ts-expect-error a Response object in Node is streamable
        for await (const chunk of response.body){
            const newText = decoder.decode(chunk, {
                stream: true
            });
            yield newText;
        }
    }
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        (0, $dHUmU.processStream)(streamReader(), boundary, observer).catch((error)=>$e6200643f3915ef4$var$emitError(observer, error, response, onFetchError));
    } catch (e) {
        const error = new Error('Failed to read from response body');
        // @ts-ignore: cause property may not be available in all environments
        error.cause = e;
        $e6200643f3915ef4$var$emitError(observer, error, response, onFetchError);
    }
}
function $e6200643f3915ef4$var$handleJsonResponse(response, observer, onFetchError) {
    response.json().then((data)=>{
        return observer.next(data);
    }).catch((error)=>$e6200643f3915ef4$var$emitError(observer, error, response, onFetchError)).finally(()=>observer.complete());
}
function $e6200643f3915ef4$var$handleTextResponse(response, observer, onFetchError) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((responseError)=>{
        let traceId = '';
        if ((0, $llCao.fg)('platform_relay_use_shared_relay_env_help_center')) traceId = `(trace-id: ${response.headers.get('atl-traceid')}) `;
        const error = new Error(`Error while parsing text response ${traceId}(Content-Type: ${response?.headers?.get('content-type')}): ${responseError instanceof Error ? responseError.message : String(responseError)}`);
        $e6200643f3915ef4$var$emitError(observer, error, response, onFetchError);
    });
}
function $e6200643f3915ef4$export$f76505a7f2969e4e(source, onFetchError, onResponseHeaders) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $7LcWi.Observable).create((observer)=>{
        result.then((response)=>{
            // Expose the response headers via a side-channel so the consumer can
            // read values such as `atl-traceid` without changing the payload emission shape.
            if ((0, $llCao.fg)('platform_relay_fetch_traceid_header_fallback')) onResponseHeaders?.(response.headers);
            if (response.status === $e6200643f3915ef4$var$NO_CONTENT) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $e6200643f3915ef4$var$handleJsonResponse(response, observer, onFetchError);
            else if (contentType.includes('text/plain')) $e6200643f3915ef4$var$handleTextResponse(response, observer, onFetchError);
            else if (contentType.includes('multipart/mixed')) $e6200643f3915ef4$var$handleMultipartResponse(response, observer, onFetchError);
            else $e6200643f3915ef4$var$handleTextResponse(response, observer, onFetchError);
        })// Pre-response failure (network error, AbortController, etc.) — no
        // Response object is in scope, so pass `undefined`.
        .catch((error)=>$e6200643f3915ef4$var$emitError(observer, error, undefined, onFetchError));
    });
}

});
parcelRegister("dHUmU", function(module, exports) {
$parcel$export(module.exports, "processStream", () => $f3b88ffb1eda8e95$export$efb69f1fe7577739);

var $9aIqU = parcelRequire("9aIqU");
async function $f3b88ffb1eda8e95$export$efb69f1fe7577739(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = (0, $9aIqU.processChunk)(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) (0, $9aIqU.processChunk)(incompleteChunk, boundaryString, observer);
    observer.complete();
}

});
parcelRegister("9aIqU", function(module, exports) {
$parcel$export(module.exports, "processChunk", () => $b81169675440c33a$export$701544522b0c6c99);

var $llCao = parcelRequire("llCao");
function $b81169675440c33a$var$escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
// The boundary is fixed for the lifetime of a response while processChunk runs once per network chunk,
// so the compiled delimiter pattern is kept for the last boundary seen instead of rebuilt per chunk.
let $b81169675440c33a$var$cachedDelimiter;
function $b81169675440c33a$var$getDelimiterPattern(boundaryString) {
    if ($b81169675440c33a$var$cachedDelimiter?.boundaryString !== boundaryString) $b81169675440c33a$var$cachedDelimiter = {
        boundaryString: boundaryString,
        pattern: new RegExp(`(?:^|\\r\\n)${$b81169675440c33a$var$escapeRegExp(boundaryString)}`)
    };
    return $b81169675440c33a$var$cachedDelimiter.pattern;
}
function $b81169675440c33a$var$getBody(part) {
    // A part with a header block is "headers\r\n\r\nbody", so the split yields [headers, body] and the
    // payload is part2. A part without a header block yields a single element, part2 is undefined and
    // the whole part (part1) is the payload.
    const [part1, part2] = part.split(/\r?\n\r?\n/);
    return part2 ?? part1;
}
function $b81169675440c33a$var$processChunkCrlfAnchored(chunk, boundaryString, observer) {
    // RFC 2046 5.1.1: a delimiter is CRLF followed by "--" and the boundary (the CRLF is optional only
    // for the first delimiter, at the very start of the body). Matching the bare "--boundary" would
    // also match the same characters inside a JSON payload (e.g. "---" in a document body), which
    // splits and corrupts the payload. JSON strings carry escaped newlines, so a CRLF-anchored
    // delimiter does not occur inside a payload.
    const parts = chunk.split($b81169675440c33a$var$getDelimiterPattern(boundaryString));
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            const body = $b81169675440c33a$var$getBody(part);
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch  {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    const lastPart = parts[parts.length - 1];
    // The trailing segment is only known to be complete once the next delimiter arrives, but a part
    // whose body already parses as JSON is complete: emit it now instead of holding it back until the
    // next part (or the end of the stream). Keep the trailing CRLF so the delimiter that follows is
    // still recognised.
    const trailingPart = lastPart.trim();
    if (trailingPart && !trailingPart.startsWith('--')) {
        const body = $b81169675440c33a$var$getBody(trailingPart);
        if (body) try {
            observer.next(JSON.parse(incompleteChunk + body));
            return lastPart.match(/\s*$/)?.[0] ?? '';
        } catch  {
        // Body is still incomplete; keep it until more data arrives.
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + lastPart;
}
/**
 * The previous implementation, used while `ai_3p_defer_multipart_response_fix` is off.
 *
 * It splits on the bare boundary string, so a payload containing it is cut apart, and a part is only
 * emitted once the next delimiter has arrived.
 */ function $b81169675440c33a$var$processChunkLegacy(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [part1, part2] = part.split(/\r?\n\r?\n/);
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            const body = part2 ?? part1;
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch  {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}
function $b81169675440c33a$export$701544522b0c6c99(chunk, boundaryString, observer) {
    if ((0, $llCao.fg)('ai_3p_defer_multipart_response_fix')) return $b81169675440c33a$var$processChunkCrlfAnchored(chunk, boundaryString, observer);
    return $b81169675440c33a$var$processChunkLegacy(chunk, boundaryString, observer);
}

});



parcelRegister("37TPL", function(module, exports) {
$parcel$export(module.exports, "getRetryAttemptsForQuery", () => $ae1f7888ba27385c$export$9dec0f42cc67f6ab);

const $ae1f7888ba27385c$export$9dec0f42cc67f6ab = (request)=>{
    if (request.operationKind === 'query') return 0, $35a4dea637e0d056$export$81189edc9b923717;
    return 0;
};

});
const $35a4dea637e0d056$export$81189edc9b923717 = 1;


parcelRegister("717i4", function(module, exports) {
$parcel$export(module.exports, "retryOnError", () => $58d17e5c1e796c95$export$f859c88bfac2cf2c);

const $58d17e5c1e796c95$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = (0, $35a4dea637e0d056$export$81189edc9b923717), onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > (0, $35a4dea637e0d056$export$81189edc9b923717) ? (0, $35a4dea637e0d056$export$81189edc9b923717) : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};

});

parcelRegister("2uD1g", function(module, exports) {
$parcel$export(module.exports, "shouldRetry", () => $2cb76b061efebd2b$export$7bfea3c3d460ecd8);
const $2cb76b061efebd2b$export$7bfea3c3d460ecd8 = (error)=>{
    if ('statusCode' in error && typeof error.statusCode === 'number') return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};

});

parcelRegister("bGlyK", function(module, exports) {
$parcel$export(module.exports, "getTraceIdFromExtensions", () => $99a166d420ad778d$export$eefb7f54c3b07211);

var $llCao = parcelRequire("llCao");
const $99a166d420ad778d$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions == null || extensions.gateway == null) return undefined;
    if ((0, $llCao.fg)('platform_relay_fetch_use_tid_property')) {
        if (typeof extensions.gateway.tId === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.tId;
    } else {
        if (typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.trace_id;
    }
    return undefined;
};

});


parcelRegister("kX6ri", function(module, exports) {
$parcel$export(module.exports, "default", () => $2042bec0cb53a809$export$2e2bcd8739ae039);

var $bVJFv = parcelRequire("bVJFv");

var $9Ygjv = parcelRequire("9Ygjv");
const $2042bec0cb53a809$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $2042bec0cb53a809$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $2042bec0cb53a809$export$77232ec02db7a24a = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $bVJFv.JiraFilterAri).parse(id).filterId;
            if ($2042bec0cb53a809$var$isCustomFilter(filterId)) return (0, $9Ygjv.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($2042bec0cb53a809$var$isSystemFilter(filterId)) return (0, $9Ygjv.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $2042bec0cb53a809$var$MissingFieldHandlers = [
    $2042bec0cb53a809$export$77232ec02db7a24a
];
var $2042bec0cb53a809$export$2e2bcd8739ae039 = $2042bec0cb53a809$var$MissingFieldHandlers;

});
parcelRegister("bVJFv", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAri", () => $8af87165e4cd0214$export$3cfb6cc809e835bd);

var $498ox = parcelRequire("498ox");

var $llRkr = parcelRequire("llRkr");

var $jEYBS = parcelRequire("jEYBS");
// src/jira/filter/manifest.ts
var $8af87165e4cd0214$var$jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $498ox.JiraFilterAriResourceOwner),
    resourceType: (0, $498ox.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/filter/index.ts
var $8af87165e4cd0214$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, $llRkr.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $8af87165e4cd0214$var$jiraFilterAriStaticOpts.qualifier,
            platformQualifier: $8af87165e4cd0214$var$jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $8af87165e4cd0214$var$jiraFilterAriStaticOpts.resourceOwner,
            resourceType: $8af87165e4cd0214$var$jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, $jEYBS.AriParser).fromOpts(derivedOpts, $8af87165e4cd0214$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $jEYBS.AriParser).fromString(maybeAri, $8af87165e4cd0214$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
};

});
parcelRegister("498ox", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAriResourceOwner", () => $304e83bcf6f6775c$export$e6199848f52f1119);
$parcel$export(module.exports, "JiraFilterAriResourceType", () => $304e83bcf6f6775c$export$3c64de4ae038e3ae);
// src/jira/filter/types.ts
var $304e83bcf6f6775c$export$e6199848f52f1119 = "jira", $304e83bcf6f6775c$export$3c64de4ae038e3ae = "filter";

});

parcelRegister("llRkr", function(module, exports) {
$parcel$export(module.exports, "RegisteredAri", () => $0402eb0cbfe393c1$export$579ee78b1dcf0a11);

var $97UhQ = parcelRequire("97UhQ");
// src/core/registered-ari.ts
var $0402eb0cbfe393c1$export$579ee78b1dcf0a11 = class extends (0, $97UhQ.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $97UhQ.AnyAri).parse(this.toString());
    }
};

});
parcelRegister("97UhQ", function(module, exports) {
$parcel$export(module.exports, "Ari", () => $6a506de7feb7e971$export$3a4885701291260b);
$parcel$export(module.exports, "AnyAri", () => $6a506de7feb7e971$export$44a7af7122933d6b);

var $jEYBS = parcelRequire("jEYBS");
// src/core/ari.ts
var $6a506de7feb7e971$export$3a4885701291260b = class {
    constructor(opts){
        this._ati = (0, $jEYBS.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
};
// src/any-ari.ts
var $6a506de7feb7e971$export$44a7af7122933d6b = class _AnyAri extends $6a506de7feb7e971$export$3a4885701291260b {
    constructor(opts){
        super(opts);
    }
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $jEYBS.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $jEYBS.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
};

});
parcelRegister("jEYBS", function(module, exports) {
$parcel$export(module.exports, "AriParser", () => $e500c4983382f5e5$export$4c3a8cde7a55740b);
$parcel$export(module.exports, "Ati", () => $e500c4983382f5e5$export$ab4b293d0121b8ee);

var $deMd8 = parcelRequire("deMd8");

var $igQF2 = parcelRequire("igQF2");
// src/core/rules/cloud-id.ts
function $e500c4983382f5e5$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, $igQF2.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $e500c4983382f5e5$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:;{}=]+(/[!a-zA-Z0-9\\-_.~@:;{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $igQF2.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $e500c4983382f5e5$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $e500c4983382f5e5$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $e500c4983382f5e5$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $igQF2.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $e500c4983382f5e5$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $igQF2.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $e500c4983382f5e5$var$NUMBER_OF_ARI_SEGMENTS = 5, $e500c4983382f5e5$export$4c3a8cde7a55740b = class extends (0, $deMd8.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $e500c4983382f5e5$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), ariProperties.resourceIdSegmentFormats) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $deMd8.validateAriQualifier)(qualifier), (0, $deMd8.validatePlatformQualifier)(platformQualifier), $e500c4983382f5e5$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $e500c4983382f5e5$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $e500c4983382f5e5$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $e500c4983382f5e5$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, segmentFormats) {
        var _a;
        let expectedKeys = Object.keys(segmentFormats), slugVariables = (_a = slug.match(/\{(.*?)\}/g)) != null ? _a : [], finalVariable = slugVariables[slugVariables.length - 1], finalVariableKey = finalVariable == null ? void 0 : finalVariable.slice(1, -1), slugWithFinalSegmentFormat = slug.replace(/\{(.*?)\}/g, (_placeholder, key)=>{
            var _a2;
            let finalSegmentFormat = key === finalVariableKey ? segmentFormats[key] : void 0;
            return `(?<${key}>${(_a2 = finalSegmentFormat == null ? void 0 : finalSegmentFormat.source) != null ? _a2 : ".*?"})`;
        }), regexpResult = new RegExp(`^${slugWithFinalSegmentFormat}$`).exec(incomingSegments);
        if (!regexpResult) throw new (0, $igQF2.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a2;
            if (!((_a2 = regexpResult.groups) != null && _a2[expectedKey])) throw new (0, $igQF2.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $e500c4983382f5e5$var$NUMBER_OF_ATI_SEGMENTS = 4, $e500c4983382f5e5$var$AtiParser = class extends (0, $deMd8.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $e500c4983382f5e5$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $deMd8.validateAtiQualifier)(qualifier), (0, $deMd8.validatePlatformQualifier)(platformQualifier), $e500c4983382f5e5$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $e500c4983382f5e5$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $deMd8.validateAtiQualifier)(qualifier), (0, $deMd8.validatePlatformQualifier)(platformQualifier), $e500c4983382f5e5$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $e500c4983382f5e5$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $e500c4983382f5e5$export$ab4b293d0121b8ee = class _Ati {
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $e500c4983382f5e5$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
};

});
parcelRegister("deMd8", function(module, exports) {
$parcel$export(module.exports, "validatePlatformQualifier", () => $9a31fad753ce7a98$export$4f6e8fa90a16fdc4);
$parcel$export(module.exports, "validateAtiQualifier", () => $9a31fad753ce7a98$export$da331df28ad1f3d9);
$parcel$export(module.exports, "validateAriQualifier", () => $9a31fad753ce7a98$export$822bcd2b6f6774a1);
$parcel$export(module.exports, "BaseParser", () => $9a31fad753ce7a98$export$3d09a5c28ff3e040);

var $igQF2 = parcelRequire("igQF2");
// src/core/rules/platform-qualifier.ts
function $9a31fad753ce7a98$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $igQF2.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $9a31fad753ce7a98$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $igQF2.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $9a31fad753ce7a98$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $igQF2.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $9a31fad753ce7a98$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $igQF2.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $9a31fad753ce7a98$var$NUMBER_OF_BASE_SEGMENTS = 5, $9a31fad753ce7a98$var$SEGMENT_SEPARATOR = ":", $9a31fad753ce7a98$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($9a31fad753ce7a98$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $igQF2.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $9a31fad753ce7a98$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($9a31fad753ce7a98$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($9a31fad753ce7a98$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

});
parcelRegister("igQF2", function(module, exports) {
$parcel$export(module.exports, "ValidationError", () => $d4d291fd5b559825$export$2191b9da168c6cf0);
// src/errors.ts
var $d4d291fd5b559825$export$2191b9da168c6cf0 = class extends Error {
};

});







parcelRegister("j3JfP", function(module, exports) {
$parcel$export(module.exports, "default", () => $596ed4c22ca90e38$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");

var $80czl = parcelRequire("80czl");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$596ed4c22ca90e38$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, (/*@__PURE__*/$parcel$interopDefault($80czl))).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, $80czl.version) === 'undefined' || (0, $80czl.version).startsWith('16'))) (0, (/*@__PURE__*/$parcel$interopDefault($80czl))).unstable_batchedUpdates(()=>{
            fn();
        });
        else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).startTransition === 'function') (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).startTransition(()=>{
            fn();
        });
        else fn();
        return '';
    }
};

});

parcelRegister("lIryO", function(module, exports) {
$parcel$export(module.exports, "createSubscribeFn", () => $ef42501646fb0829$export$10f5a0700f263f11);

var $7LcWi = parcelRequire("7LcWi");

var $llCao = parcelRequire("llCao");

var $69loc = parcelRequire("69loc");

var $du32W = parcelRequire("du32W");

var $npRTf = parcelRequire("npRTf");
const $ef42501646fb0829$var$channels = new Map();
const $ef42501646fb0829$var$channelsByClient = new WeakMap();
/** Select connection state; all observers then run the same subscription implementation. */ function $ef42501646fb0829$var$createSubscriptionObservable(cacheConfig, subscribe) {
    return (0, $7LcWi.Observable).create((sink)=>{
        const context = cacheConfig?.metadata?.subscriptionShardingContext;
        if (context === undefined || !(0, $llCao.fg)('platform_relay_subscription_sharding')) return subscribe(sink, (0, $du32W.getClient)(), $ef42501646fb0829$var$channels, (0, $du32W.getSocketConnectionState));
        const lease = (0, $du32W.acquireSubscriptionClient)(()=>(0, $69loc.getSubscriptionUrl)(context));
        if (!lease) return subscribe(sink, null, $ef42501646fb0829$var$channels, (0, $du32W.getSocketConnectionState));
        try {
            let clientChannels = $ef42501646fb0829$var$channelsByClient.get(lease.client);
            if (!clientChannels) {
                clientChannels = new Map();
                $ef42501646fb0829$var$channelsByClient.set(lease.client, clientChannels);
            }
            const cleanup = subscribe(sink, lease.client, clientChannels, lease.getSocketConnectionState);
            return ()=>{
                try {
                    cleanup?.();
                } finally{
                    lease.release();
                }
            };
        } catch (error) {
            lease.release();
            throw error;
        }
    });
}
function $ef42501646fb0829$var$stableStringify(value) {
    if (value === null || typeof value !== 'object') return JSON.stringify(value) ?? 'null';
    if (Array.isArray(value)) return `[${value.map($ef42501646fb0829$var$stableStringify).join(',')}]`;
    const obj = value;
    const keys = Object.keys(obj).sort();
    return `{${keys.map((k)=>`${JSON.stringify(k)}:${$ef42501646fb0829$var$stableStringify(obj[k])}`).join(',')}}`;
}
function $ef42501646fb0829$var$channelKey(payload) {
    return $ef42501646fb0829$var$stableStringify({
        pq: payload.extensions?.pq ?? null,
        operationName: payload.operationName ?? null,
        variables: payload.variables ?? null,
        extensions: payload.extensions ?? null
    });
}
let $ef42501646fb0829$var$cachedDefaultSubscribe;
function $ef42501646fb0829$export$10f5a0700f263f11(subscribeOptions) {
    if (typeof subscribeOptions === 'undefined' && typeof $ef42501646fb0829$var$cachedDefaultSubscribe !== 'undefined') return $ef42501646fb0829$var$cachedDefaultSubscribe;
    const fn = ({ id: id, name: operationName }, variables, cacheConfig)=>$ef42501646fb0829$var$createSubscriptionObservable(cacheConfig, (sink, client, channels, getConnectionState)=>{
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const replayConfig = cacheConfig?.metadata?.replay || undefined;
            const replayCommand = replayConfig !== null && typeof replayConfig === 'object' && 'command' in replayConfig ? replayConfig.command : undefined;
            const replayExtensions = replayCommand ? {
                command: replayCommand
            } : replayConfig ? {
                replay: replayConfig
            } : {};
            const payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: {
                    pq: id,
                    ...subscribeOptions?.subscribeExtensions || {},
                    ...replayExtensions
                }
            };
            subscribeOptions?.onSubscribeTrigger?.(payload);
            const key = $ef42501646fb0829$var$channelKey(payload);
            // Keep one cleanup policy for the entire observer lifetime.
            const guardChannelOwnership = !(0, $llCao.fg)('relay_subscription_cleanup_killswitch');
            const existingChannel = channels.get(key);
            let joinedChannel = existingChannel;
            // Capture before failure; the channel may reopen first.
            const isNewChannel = !existingChannel;
            const observerCount = (existingChannel?.sinks.size ?? 0) + 1;
            // Reuse the product-level subscription reporter instead of a per-call metadata callback.
            const diagnosticsEnabled = (0, $llCao.fg)('platform_relay_subscription_reliability-additional');
            const diagnostics = diagnosticsEnabled && typeof subscribeOptions?.onSubscriptionDiagnostic === 'function' ? subscribeOptions.onSubscriptionDiagnostic : undefined;
            const report = (event)=>{
                try {
                    diagnostics?.({
                        operationName: payload.operationName,
                        variables: payload.variables,
                        ...event
                    });
                } catch  {
                // Diagnostics must not interrupt subscriptions.
                }
            };
            if (diagnostics) report({
                type: 'attached',
                isNewChannel: isNewChannel,
                observerCount: observerCount,
                channelHasReceivedResponse: existingChannel?.hasReceivedResponse ?? false,
                socketState: getConnectionState()
            });
            const removeConnected = diagnostics ? client.on('connected', ()=>report({
                    type: 'connected'
                })) : undefined;
            const removeClosed = diagnostics ? client.on('closed', ()=>report({
                    type: 'closed'
                })) : undefined;
            const detachDiagnostics = ()=>{
                removeConnected?.();
                removeClosed?.();
            };
            const localSink = {
                next: (value)=>{
                    if (diagnostics) {
                        const extensions = value?.extensions;
                        const requestId = extensions?.gateway?.request_id;
                        const traceId = extensions?.gateway?.tId ?? extensions?.gateway?.trace_id;
                        const channel = extensions?.agg?.channel;
                        report({
                            type: 'response',
                            requestId: typeof requestId === 'string' ? requestId : null,
                            traceId: typeof traceId === 'string' ? traceId : null,
                            channel: typeof channel === 'string' ? channel : null
                        });
                    }
                    // @ts-expect-error incompatible types between two libraries
                    sink.next(value);
                },
                error: (err, requestId)=>{
                    report({
                        type: 'error',
                        requestId: requestId
                    });
                    detachDiagnostics();
                    sink.error(err);
                    subscribeOptions?.onSubscribeError?.({
                        ...payload,
                        requestId: requestId,
                        isNewChannel: isNewChannel,
                        observerCount: observerCount
                    });
                },
                complete: ()=>{
                    report({
                        type: 'completed'
                    });
                    detachDiagnostics();
                    sink.complete?.();
                }
            };
            if (!existingChannel) {
                const newChannel = {
                    sinks: new Set([
                        localSink
                    ]),
                    dispose: ()=>{},
                    lastRequestId: null,
                    hasReceivedResponse: false
                };
                joinedChannel = newChannel;
                let terminated = false;
                newChannel.dispose = client.subscribe(payload, {
                    next: (value)=>{
                        if (diagnosticsEnabled) newChannel.hasReceivedResponse = true;
                        // @ts-expect-error agg prop is missing on generic "extensions" type
                        const aggRequestId = value?.extensions?.gateway?.request_id;
                        if (aggRequestId) newChannel.lastRequestId = aggRequestId;
                        for (const s of Array.from(newChannel.sinks))try {
                            s.next(value);
                        } catch  {
                        /* isolate sinks */ }
                    },
                    error: (sinkError)=>{
                        terminated = true;
                        const errorInfo = (0, $npRTf.getSinkError)(sinkError);
                        const sinks = Array.from(newChannel.sinks);
                        const { lastRequestId: lastRequestId } = newChannel;
                        if (!guardChannelOwnership || channels.get(key) === newChannel) channels.delete(key);
                        newChannel.sinks.clear();
                        for (const s of sinks)try {
                            s.error(errorInfo, lastRequestId);
                        } catch  {
                        /* isolate sinks */ }
                    },
                    complete: ()=>{
                        terminated = true;
                        const sinks = Array.from(newChannel.sinks);
                        if (!guardChannelOwnership || channels.get(key) === newChannel) channels.delete(key);
                        newChannel.sinks.clear();
                        for (const s of sinks)try {
                            s.complete?.();
                        } catch  {
                        /* isolate sinks */ }
                    }
                });
                // A synchronous terminal callback may already have opened a replacement.
                // Register only a live channel, once its real disposer is available.
                if (!guardChannelOwnership || !terminated) channels.set(key, newChannel);
            } else existingChannel.sinks.add(localSink);
            return ()=>{
                report({
                    type: 'disposed'
                });
                detachDiagnostics();
                const c = guardChannelOwnership ? joinedChannel : channels.get(key);
                if (!c) return;
                const removed = c.sinks.delete(localSink);
                if (guardChannelOwnership && !removed) return;
                if (c.sinks.size === 0) {
                    if (!guardChannelOwnership || channels.get(key) === c) channels.delete(key);
                    try {
                        c.dispose();
                    } catch  {
                    /* upstream dispose errors must not break Relay teardown */ }
                }
            };
        });
    if (typeof subscribeOptions === 'undefined') $ef42501646fb0829$var$cachedDefaultSubscribe = fn;
    return fn;
}
const $ef42501646fb0829$export$ec068583843480e7 = $ef42501646fb0829$export$10f5a0700f263f11();

});
parcelRegister("69loc", function(module, exports) {
$parcel$export(module.exports, "getSubscriptionUrl", () => $b739a8a351aaada3$export$192ea60656b1a47f);

var $7fM5s = parcelRequire("7fM5s");
function $b739a8a351aaada3$export$192ea60656b1a47f(context) {
    if (typeof context !== 'object' || context === null || !('type' in context) || context.type !== 'workspace' || !('product' in context) || typeof context.product !== 'string' || !('workspaceId' in context) || typeof context.workspaceId !== 'string') throw new Error('Invalid subscription sharding context');
    return `${(0, $7fM5s.getAggSubscriptionEndpoint)()}/${$b739a8a351aaada3$var$encodeContextSegment(context.product)}/workspace/${$b739a8a351aaada3$var$encodeContextSegment(context.workspaceId)}`;
}
function $b739a8a351aaada3$var$encodeContextSegment(value) {
    if (!value || value === '.' || value === '..') throw new Error('Invalid subscription sharding context segment');
    return encodeURIComponent(value);
}

});


parcelRegister("43nuC", function(module, exports) {
$parcel$export(module.exports, "createRelayHandlerProvider", () => $ff746bcb1324692f$export$a40b5c8b00dd9369);

var $7LcWi = parcelRequire("7LcWi");

var $llCao = parcelRequire("llCao");

var $aY1jT = parcelRequire("aY1jT");

var $7D8tg = parcelRequire("7D8tg");
function $ff746bcb1324692f$export$a40b5c8b00dd9369(source) {
    const DeleteRecordHandler = (0, $llCao.fg)('platform_relay_delete_record_handler') ? (0, $7D8tg.createDeleteRecordHandler)(source) : (0, $7LcWi.DefaultHandlerProvider)('deleteRecord');
    return (handle)=>{
        switch(handle){
            case 'deleteEdge':
                return 0, $aY1jT.DeleteEdgeHandler;
            case 'deleteRecord':
                return DeleteRecordHandler;
            default:
                return (0, $7LcWi.DefaultHandlerProvider)(handle);
        }
    };
}

});
parcelRegister("aY1jT", function(module, exports) {
$parcel$export(module.exports, "DeleteEdgeHandler", () => $e696d360cc98b1dc$export$a2264b8f69028704);

var $7LcWi = parcelRequire("7LcWi");

var $l9kus = parcelRequire("l9kus");

var $4xrs9 = parcelRequire("4xrs9");
// Copied from ConnectionHandler.deleteNode implementation with a single change in behaviour:
// nodeID is compared to the `id` field of the node, rather than node.getDataID().
// This is a sane thing to do within the scope of a single connection even in the light of
// id collisions present in AGG for the entities of different types.
// Such change makes @deleteEdge directive usable again.
function $e696d360cc98b1dc$var$deleteNode(record, nodeID) {
    const { EDGES: EDGES, NODE: NODE } = (0, $7LcWi.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    let nextEdges;
    for(let ii = 0; ii < edges.length; ii++){
        const edge = edges[ii];
        const node = edge && edge.getLinkedRecord(NODE);
        // N.B. node.getValue('id') instead of node.getDataID()
        if (node != null && node.getValue('id') === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
const $e696d360cc98b1dc$export$a2264b8f69028704 = {
    update: (store, payload)=>{
        const record = store.get(payload.dataID);
        if (record == null) return;
        // @types/relay-runtime is broken, handleArgs is present in the original Flow types.
        const { connections: connections } = payload.handleArgs;
        (0, $l9kus.default)(connections != null, 'MutationHandlers: Expected connection IDs to be specified.');
        const idOrIds = record.getValue(payload.fieldKey);
        const idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach((id)=>{
            if (typeof id === 'string') for (const connectionID of connections){
                const connection = store.get(connectionID);
                if (connection == null) {
                    (0, $4xrs9.default)(false, `[Relay] The connection with id ${connectionID} doesn't exist.`);
                    continue;
                }
                $e696d360cc98b1dc$var$deleteNode(connection, id);
            }
        });
    }
};

});
parcelRegister("4xrs9", function(module, exports) {
$parcel$export(module.exports, "default", () => $34df8a135c96ea64$export$2e2bcd8739ae039);
var $34df8a135c96ea64$var$isProduction = true;
function $34df8a135c96ea64$var$warning(condition, message) {
    if (!$34df8a135c96ea64$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $34df8a135c96ea64$export$2e2bcd8739ae039 = $34df8a135c96ea64$var$warning;

});


parcelRegister("7D8tg", function(module, exports) {
$parcel$export(module.exports, "createDeleteRecordHandler", () => $9fed2a43c54c435e$export$a61ecd985ed07422);
const $9fed2a43c54c435e$var$RELAY_DATA_ID_SEPARATOR = ':::::';
const $9fed2a43c54c435e$export$a61ecd985ed07422 = (source)=>({
        update: (store, payload)=>{
            const record = store.get(payload.dataID);
            if (record == null) return;
            const idOrIds = record.getValue(payload.fieldKey);
            const aris = Array.isArray(idOrIds) ? idOrIds : [
                idOrIds
            ];
            const idsInStore = source.getRecordIDs();
            const arisToDelete = aris.flatMap((id)=>{
                if (typeof id !== 'string') return [];
                const typeQualifiedPrefix = `${id}${$9fed2a43c54c435e$var$RELAY_DATA_ID_SEPARATOR}`;
                const matchingStoreIDs = idsInStore.filter((dataID)=>dataID.startsWith(typeQualifiedPrefix));
                return matchingStoreIDs;
            });
            arisToDelete.forEach((dataID)=>store.delete(dataID));
        }
    });

});


parcelRegister("eqQe8", function(module, exports) {
$parcel$export(module.exports, "ufoDataFetchHoldMiddleware", () => $48dcacb9eda69e80$export$3e78a79ab7bcbcc3);

var $7LcWi = parcelRequire("7LcWi");

var $boDYW = parcelRequire("boDYW");
const $48dcacb9eda69e80$var$HELD_INTERACTION_TYPES = [
    'press',
    'typing'
];
const $48dcacb9eda69e80$export$3e78a79ab7bcbcc3 = (next, options)=>(request, variables, cacheConfig, uploadables)=>{
        if (options?.getIsEnabled?.() !== true) return next(request, variables, cacheConfig, uploadables);
        const source = next(request, variables, cacheConfig, uploadables);
        if ('subscribe' in source) return (0, $7LcWi.Observable).create((sink)=>{
            const releaseHold = (0, $boDYW.startDataFetchHold)({
                label: `relay-${request.operationKind}`,
                name: request.name,
                interactionTypes: $48dcacb9eda69e80$var$HELD_INTERACTION_TYPES
            });
            const subscription = source.subscribe(sink);
            return ()=>{
                try {
                    subscription.unsubscribe();
                } finally{
                    releaseHold?.();
                }
            };
        });
        return source;
    };

});
parcelRegister("boDYW", function(module, exports) {
$parcel$export(module.exports, "startDataFetchHold", () => $8f632a9279750999$export$fbd04cc8165928ea);

var $8IAtM = parcelRequire("8IAtM");

var $4EiT4 = parcelRequire("4EiT4");
function $8f632a9279750999$export$fbd04cc8165928ea({ label: label, name: name, interactionTypes: interactionTypes }) {
    const interaction = (0, $8IAtM.getActiveInteraction)();
    if (!interaction || interaction.end !== 0) return;
    if (interactionTypes && !interactionTypes.includes(interaction.type)) return;
    const releaseHold = (0, $8IAtM.addHold)(interaction.id, [
        {
            name: label
        }
    ], name, false);
    let released = false;
    return ()=>{
        if (released) return;
        released = true;
        (0, $4EiT4.default)(()=>{
            releaseHold();
            (0, $8IAtM.tryComplete)(interaction.id);
        });
    };
}

});
parcelRegister("4EiT4", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a040f7e1ad29ae4$export$2e2bcd8739ae039);

var $hoalA = parcelRequire("hoalA");
function $0a040f7e1ad29ae4$var$scheduleOnPaint(callback) {
    const isSSR = typeof window === 'undefined' || Boolean(globalThis?.false) || typeof $hoalA !== 'undefined' && Boolean($hoalA?.env?.REACT_SSR);
    if (isSSR) {
        // In SSR, execute callback immediately (no paint event exists)
        callback();
        return;
    }
    if (globalThis.document?.visibilityState !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
}
var $0a040f7e1ad29ae4$export$2e2bcd8739ae039 = $0a040f7e1ad29ae4$var$scheduleOnPaint;

});




parcelRegister("39O37", function(module, exports) {

var $f4aDX = parcelRequire("f4aDX");

var $9ounl = parcelRequire("9ounl");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $24c909171fabe8aa$var$capitalize(string) {
    return $9ounl($f4aDX(string).toLowerCase());
}
module.exports = $24c909171fabe8aa$var$capitalize;

});
parcelRegister("9ounl", function(module, exports) {

var $2wTe1 = parcelRequire("2wTe1");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $6d6deae26af145dc$var$upperFirst = $2wTe1('toUpperCase');
module.exports = $6d6deae26af145dc$var$upperFirst;

});
parcelRegister("2wTe1", function(module, exports) {

var $jhK4K = parcelRequire("jhK4K");

var $l9fHB = parcelRequire("l9fHB");

var $1s04a = parcelRequire("1s04a");

var $f4aDX = parcelRequire("f4aDX");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $1d79687fcef7f6ab$var$createCaseFirst(methodName) {
    return function(string) {
        string = $f4aDX(string);
        var strSymbols = $l9fHB(string) ? $1s04a(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $jhK4K(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $1d79687fcef7f6ab$var$createCaseFirst;

});
parcelRegister("jhK4K", function(module, exports) {

var $37knY = parcelRequire("37knY");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $e0a35886719149fe$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $37knY(array, start, end);
}
module.exports = $e0a35886719149fe$var$castSlice;

});
parcelRegister("37knY", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $2451d6b83a1bf50b$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $2451d6b83a1bf50b$var$baseSlice;

});


parcelRegister("l9fHB", function(module, exports) {
/** Used to compose unicode character classes. */ var $f6569e6149dfe05b$var$rsAstralRange = '\\ud800-\\udfff', $f6569e6149dfe05b$var$rsComboMarksRange = '\\u0300-\\u036f', $f6569e6149dfe05b$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $f6569e6149dfe05b$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $f6569e6149dfe05b$var$rsComboRange = $f6569e6149dfe05b$var$rsComboMarksRange + $f6569e6149dfe05b$var$reComboHalfMarksRange + $f6569e6149dfe05b$var$rsComboSymbolsRange, $f6569e6149dfe05b$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $f6569e6149dfe05b$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $f6569e6149dfe05b$var$reHasUnicode = RegExp('[' + $f6569e6149dfe05b$var$rsZWJ + $f6569e6149dfe05b$var$rsAstralRange + $f6569e6149dfe05b$var$rsComboRange + $f6569e6149dfe05b$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $f6569e6149dfe05b$var$hasUnicode(string) {
    return $f6569e6149dfe05b$var$reHasUnicode.test(string);
}
module.exports = $f6569e6149dfe05b$var$hasUnicode;

});

parcelRegister("1s04a", function(module, exports) {

var $1an8C = parcelRequire("1an8C");

var $l9fHB = parcelRequire("l9fHB");

var $1GrvZ = parcelRequire("1GrvZ");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $10e8751e1383958e$var$stringToArray(string) {
    return $l9fHB(string) ? $1GrvZ(string) : $1an8C(string);
}
module.exports = $10e8751e1383958e$var$stringToArray;

});
parcelRegister("1an8C", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $0d98ac5b2a223378$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $0d98ac5b2a223378$var$asciiToArray;

});

parcelRegister("1GrvZ", function(module, exports) {
/** Used to compose unicode character classes. */ var $139f0e9767d50511$var$rsAstralRange = '\\ud800-\\udfff', $139f0e9767d50511$var$rsComboMarksRange = '\\u0300-\\u036f', $139f0e9767d50511$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $139f0e9767d50511$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $139f0e9767d50511$var$rsComboRange = $139f0e9767d50511$var$rsComboMarksRange + $139f0e9767d50511$var$reComboHalfMarksRange + $139f0e9767d50511$var$rsComboSymbolsRange, $139f0e9767d50511$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $139f0e9767d50511$var$rsAstral = '[' + $139f0e9767d50511$var$rsAstralRange + ']', $139f0e9767d50511$var$rsCombo = '[' + $139f0e9767d50511$var$rsComboRange + ']', $139f0e9767d50511$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $139f0e9767d50511$var$rsModifier = '(?:' + $139f0e9767d50511$var$rsCombo + '|' + $139f0e9767d50511$var$rsFitz + ')', $139f0e9767d50511$var$rsNonAstral = '[^' + $139f0e9767d50511$var$rsAstralRange + ']', $139f0e9767d50511$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $139f0e9767d50511$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $139f0e9767d50511$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $139f0e9767d50511$var$reOptMod = $139f0e9767d50511$var$rsModifier + '?', $139f0e9767d50511$var$rsOptVar = '[' + $139f0e9767d50511$var$rsVarRange + ']?', $139f0e9767d50511$var$rsOptJoin = '(?:' + $139f0e9767d50511$var$rsZWJ + '(?:' + [
    $139f0e9767d50511$var$rsNonAstral,
    $139f0e9767d50511$var$rsRegional,
    $139f0e9767d50511$var$rsSurrPair
].join('|') + ')' + $139f0e9767d50511$var$rsOptVar + $139f0e9767d50511$var$reOptMod + ')*', $139f0e9767d50511$var$rsSeq = $139f0e9767d50511$var$rsOptVar + $139f0e9767d50511$var$reOptMod + $139f0e9767d50511$var$rsOptJoin, $139f0e9767d50511$var$rsSymbol = '(?:' + [
    $139f0e9767d50511$var$rsNonAstral + $139f0e9767d50511$var$rsCombo + '?',
    $139f0e9767d50511$var$rsCombo,
    $139f0e9767d50511$var$rsRegional,
    $139f0e9767d50511$var$rsSurrPair,
    $139f0e9767d50511$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $139f0e9767d50511$var$reUnicode = RegExp($139f0e9767d50511$var$rsFitz + '(?=' + $139f0e9767d50511$var$rsFitz + ')|' + $139f0e9767d50511$var$rsSymbol + $139f0e9767d50511$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $139f0e9767d50511$var$unicodeToArray(string) {
    return string.match($139f0e9767d50511$var$reUnicode) || [];
}
module.exports = $139f0e9767d50511$var$unicodeToArray;

});





parcelRegister("kVJwA", function(module, exports) {
$parcel$export(module.exports, "getATLContextDomain", () => $bf41a4e522d075a0$export$b5ce351acdc48c2a);


var $3jn4g = parcelRequire("3jn4g");

var $jxu5d = parcelRequire("jxu5d");

var $gy7Y5 = parcelRequire("gy7Y5");

var $ePlaA = parcelRequire("ePlaA");

var $g7Y9k = parcelRequire("g7Y9k");
function $bf41a4e522d075a0$var$isValidDomainKey(domainKey) {
    if (!(0, $ePlaA.AllowedDomains).includes(domainKey)) return false;
    return true;
}
function $bf41a4e522d075a0$export$b5ce351acdc48c2a(domain, environment) {
    // Validate this is a valid domain
    if (!$bf41a4e522d075a0$var$isValidDomainKey(domain)) throw new Error(`Domain ${domain} is not supported.
      Supported domains: ${(0, $ePlaA.AllowedDomains).join(', ')}`);
    // First priority, always return the global context if the product has onboarded
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    const data = globalThis.ATL_CONTEXT_DOMAIN;
    if (data) return data[domain];
    const [env, perimeter] = environment ?? (0, $g7Y9k._getEnvironmentFromDomain)();
    // Second priority, return if there is a full domain override
    const override = (0, $jxu5d.fullDomainOverride)[domain];
    if (override) return(// Exact match preferred
    override[perimeter]?.[env] ?? override[0, $5b20f9eca5080b27$export$f005e2e9f707cb5f][0, $5b20f9eca5080b27$export$42dd0cdd351a4a9] // Fallback to mandatory commercial production
    );
    // Third priority, join the subdomain
    const tld = (0, $3jn4g.domainMap)[perimeter]?.[env] ?? (0, $3jn4g.domainMap)[0, $5b20f9eca5080b27$export$f005e2e9f707cb5f][0, $5b20f9eca5080b27$export$42dd0cdd351a4a9];
    const subdomain = (0, $gy7Y5.subdomainOverride)[domain] ?? domain;
    return `${subdomain}.${tld}`;
}

});
const $5b20f9eca5080b27$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $5b20f9eca5080b27$export$f005e2e9f707cb5f = 'commercial';
const $5b20f9eca5080b27$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $5b20f9eca5080b27$export$a739cd5aac835909 = 'stg';
const $5b20f9eca5080b27$export$42dd0cdd351a4a9 = 'prod';
const $5b20f9eca5080b27$export$404582bc18fe4d9e = 'dev';

parcelRegister("3jn4g", function(module, exports) {
$parcel$export(module.exports, "domainMap", () => $0b3a81f5d8d4d8c1$export$6836b090dbaa813a);

const $0b3a81f5d8d4d8c1$export$6836b090dbaa813a = {
    [(0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)]: {
        [(0, $5b20f9eca5080b27$export$a739cd5aac835909)]: 'stg.atlassian.com',
        [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'atlassian.com'
    },
    [(0, $5b20f9eca5080b27$export$bd6b5a7802d76127)]: {
        [(0, $5b20f9eca5080b27$export$a739cd5aac835909)]: 'atlassian-fex.com'
    },
    [(0, $5b20f9eca5080b27$export$ce553301d55c2fd8)]: {
        [(0, $5b20f9eca5080b27$export$a739cd5aac835909)]: 'stg.atlassian-us-gov-mod.com',
        [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'atlassian-us-gov-mod.com'
    }
};

});

parcelRegister("jxu5d", function(module, exports) {
$parcel$export(module.exports, "fullDomainOverride", () => $6e0974627c4dfa7b$export$4723232b625f823e);

const $6e0974627c4dfa7b$export$4723232b625f823e = {
    analytics: {
        [(0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'analytics.atlassian.com'
        }
    },
    // Marketing site
    confluence: {
        [(0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'confluence.atlassian.com'
        }
    },
    // Atlassian design system documentation
    design: {
        [(0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'design.atlassian.com'
        }
    },
    // Old staff intranet (now hello.atlassian.net)
    extranet: {
        [(0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'extranet.atlassian.com'
        }
    },
    // Go links
    go: {
        [(0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'go.atlassian.com'
        }
    },
    my: {
        [(0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'my.atlassian.com'
        }
    },
    schema: {
        [(0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'schema.atlassian.com'
        }
    },
    start: {
        [(0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'start.atlassian.com',
            [(0, $5b20f9eca5080b27$export$a739cd5aac835909)]: 'start.stg.atlassian.com'
        },
        [(0, $5b20f9eca5080b27$export$ce553301d55c2fd8)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'start.atlassian-us-gov-mod.com',
            [(0, $5b20f9eca5080b27$export$a739cd5aac835909)]: 'start.stg.atlassian-us-gov-mod.com'
        }
    },
    surveys: {
        [(0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'surveys.atlassian.com'
        }
    },
    'wac-cdn': {
        [(0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'wac-cdn.atlassian.com'
        }
    },
    integrations: {
        [(0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'integrations.atlassian.com'
        }
    },
    permalink: {
        [(0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'permalink.atlassian.com'
        }
    },
    id: {
        [(0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'id.atlassian.com',
            [(0, $5b20f9eca5080b27$export$a739cd5aac835909)]: 'id.stg.internal.atlassian.com',
            [(0, $5b20f9eca5080b27$export$404582bc18fe4d9e)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $5b20f9eca5080b27$export$ce553301d55c2fd8)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'id.atlassian-us-gov-mod.com',
            [(0, $5b20f9eca5080b27$export$a739cd5aac835909)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    },
    support: {
        [(0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)]: {
            [(0, $5b20f9eca5080b27$export$42dd0cdd351a4a9)]: 'support.atlassian.com'
        }
    }
};

});

parcelRegister("gy7Y5", function(module, exports) {
$parcel$export(module.exports, "subdomainOverride", () => $5eb52a2c7c282e43$export$c6ab20d0ac4d06b2);
const $5eb52a2c7c282e43$export$c6ab20d0ac4d06b2 = {};

});

parcelRegister("ePlaA", function(module, exports) {
$parcel$export(module.exports, "AllowedDomains", () => $ebd34d26c7164d36$export$b450288891b9771b);
/* *NOTE*: please ensure any changes made to Perimeter and DomainKey type is copied in typings/atl-context.globals.d.ts */ const $ebd34d26c7164d36$export$b450288891b9771b = [
    'admin',
    'analytics',
    'api',
    'api.media',
    'api-private',
    'as',
    'atl-global',
    'atlaskit',
    'auth',
    'automation',
    'cassi.internal',
    'cc-import-sources.services',
    'confluence',
    'confluence-chats-integr.services',
    'confluence-cloud-bamboo.internal',
    'confluence-questions.services',
    'data-portal.internal',
    'design',
    'developer',
    'extranet',
    'go',
    'id',
    'id-mail-assets',
    'integrations',
    'ja',
    'jira',
    'jsd-widget',
    'jsd-widget-staging',
    'marketplace',
    'my',
    'my-reminders.services',
    'partners',
    'permalink',
    'permalink.stg',
    'schema',
    'start',
    'support',
    'surveys',
    'team',
    'wac-cdn',
    'xxid',
    'home'
];

});

parcelRegister("g7Y9k", function(module, exports) {
$parcel$export(module.exports, "_getEnvironmentFromDomain", () => $5eab3498228a70ef$export$509d18a5fd824839);

function $5eab3498228a70ef$export$509d18a5fd824839() {
    const hostname = globalThis.location?.hostname;
    if (!hostname) // default if no location available
    return [
        (0, $5b20f9eca5080b27$export$42dd0cdd351a4a9),
        (0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)
    ];
    // *.atlassian-fex.com
    if (hostname.match(/atlassian-fex\.com/)) return [
        (0, $5b20f9eca5080b27$export$a739cd5aac835909),
        (0, $5b20f9eca5080b27$export$bd6b5a7802d76127)
    ];
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $5b20f9eca5080b27$export$a739cd5aac835909),
        (0, $5b20f9eca5080b27$export$ce553301d55c2fd8)
    ];
    // *.atlassian-stg-fedm.net
    if (hostname.match(/atlassian-stg-fedm\.net/)) return [
        (0, $5b20f9eca5080b27$export$a739cd5aac835909),
        (0, $5b20f9eca5080b27$export$ce553301d55c2fd8)
    ];
    // *.atlassian-us-gov-mod.com OR *.atlassian-us-gov-mod.net
    if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $5b20f9eca5080b27$export$42dd0cdd351a4a9),
        (0, $5b20f9eca5080b27$export$ce553301d55c2fd8)
    ];
    // *.stg.atlassian.com OR *.stg.internal.atlassian.com
    if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
        (0, $5b20f9eca5080b27$export$a739cd5aac835909),
        (0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)
    ];
    // *.jira-dev.com
    if (hostname.match(/jira-dev\.com/)) return [
        (0, $5b20f9eca5080b27$export$a739cd5aac835909),
        (0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)
    ];
    // default fallthrough
    return [
        (0, $5b20f9eca5080b27$export$42dd0cdd351a4a9),
        (0, $5b20f9eca5080b27$export$f005e2e9f707cb5f)
    ];
}

});


parcelRegister("26kmM", function(module, exports) {
$parcel$export(module.exports, "getInstance", () => $d3280d99362d4165$export$8bedcca5bbd73999);

var $kVJwA = parcelRequire("kVJwA");

var $5Y9N2 = parcelRequire("5Y9N2");

var $l7VAg = parcelRequire("l7VAg");

var $kkM4a = parcelRequire("kkM4a");

var $eVOdG = parcelRequire("eVOdG");
const $d3280d99362d4165$var$redirect = ()=>{
    const identity = (0, $kVJwA.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
    window.location.assign(redirectUrl);
};
const $d3280d99362d4165$var$timeIsBeforeNow = (dateTime)=>{
    return !!(dateTime && dateTime.getTime() <= Date.now());
};
const $d3280d99362d4165$var$HeartbeatService = (onBadRequest)=>{
    let timer;
    let heartBeatInterval;
    let nextCallTimestamp;
    let sessionExpiryTimestamp;
    let cachedEndpoint;
    let initialized = false;
    let authenticated = false;
    let userActive = true;
    let tabActive = true;
    const isAuthenticated = ()=>{
        return authenticated;
    };
    const isInitialized = ()=>{
        return initialized;
    };
    const init = ()=>{
        // Initial heartbeat
        beat();
        heartBeatInterval = setupHeartbeatInterval();
        timer = setupBrowserInteractionTime();
    };
    const cleanup = ()=>{
        clearHeartbeatInterval();
        clearBrowserInteractionTime();
    };
    const beat = async ()=>{
        try {
            if (cachedEndpoint === undefined && (0, $5Y9N2.default).initializeCompleted()) cachedEndpoint = (0, $l7VAg.getDefaultHeartbeatEndpoint)();
            const response = await (0, $eVOdG.postHeartbeat)(cachedEndpoint ?? (0, $l7VAg.HEARTBEAT_V1_ENDPOINT), $d3280d99362d4165$var$redirect, onBadRequest);
            if (!initialized) initialized = true;
            if (response) {
                const { nextCallTimestamp: nextCallT, sessionExpiryTime: sessionExpiryT } = response;
                nextCallTimestamp = new Date(nextCallT);
                sessionExpiryTimestamp = sessionExpiryT ? new Date(sessionExpiryT) : undefined;
                authenticated = true;
            }
        } catch (error) {
            // Silent degradation - heartbeat service should not interfere with application
            authenticated = false;
            clearHeartbeatInterval();
        }
    };
    const setupHeartbeatInterval = ()=>setInterval(()=>{
            if ($d3280d99362d4165$var$timeIsBeforeNow(sessionExpiryTimestamp) || userActive && tabActive && $d3280d99362d4165$var$timeIsBeforeNow(nextCallTimestamp)) beat();
        }, (0, $l7VAg.INTERVAL_TIME));
    const clearHeartbeatInterval = ()=>{
        clearInterval(heartBeatInterval);
        heartBeatInterval = undefined;
    };
    const setupBrowserInteractionTime = ()=>{
        const timer = new (0, $kkM4a.default)({
            idleTimeoutMs: (0, $l7VAg.DEFAULT_IDLE_TIME),
            stopTimerOnTabchange: false,
            browserTabActiveCallbacks: [
                ()=>tabActive = true
            ],
            browserTabInactiveCallbacks: [
                ()=>tabActive = false
            ],
            idleCallbacks: [
                ()=>{
                    // Beat once when the user goes idle and the tab is active
                    if (tabActive) beat();
                    userActive = false;
                }
            ],
            activeCallbacks: [
                ()=>userActive = true
            ]
        });
        timer.startTimer();
        return timer;
    };
    const clearBrowserInteractionTime = ()=>{
        timer && timer.destroy();
        timer = undefined;
    };
    return {
        isAuthenticated: isAuthenticated,
        isInitialized: isInitialized,
        init: init,
        cleanup: cleanup
    };
};
let $d3280d99362d4165$var$instance = null;
const $d3280d99362d4165$export$8bedcca5bbd73999 = (onBadRequest)=>{
    if (!$d3280d99362d4165$var$instance) {
        $d3280d99362d4165$var$instance = $d3280d99362d4165$var$HeartbeatService(onBadRequest);
        $d3280d99362d4165$var$instance.init();
    }
    return $d3280d99362d4165$var$instance;
};

});
parcelRegister("l7VAg", function(module, exports) {
$parcel$export(module.exports, "HEARTBEAT_V1_ENDPOINT", () => $86bd52119f3a51b9$export$172ec9c0e085fafc);
$parcel$export(module.exports, "getDefaultHeartbeatEndpoint", () => $86bd52119f3a51b9$export$43672c9b21c3a625);
$parcel$export(module.exports, "DEFAULT_IDLE_TIME", () => $86bd52119f3a51b9$export$af2ff676951003fe);
$parcel$export(module.exports, "INTERVAL_TIME", () => $86bd52119f3a51b9$export$f2b2f5ef0b498d26);

var $dJhjg = parcelRequire("dJhjg");
const $86bd52119f3a51b9$export$172ec9c0e085fafc = '/gateway/api/session/heartbeat';
const $86bd52119f3a51b9$export$6249a60627b1cb70 = '/gateway/api/v2/session/heartbeat';
const $86bd52119f3a51b9$export$43672c9b21c3a625 = ()=>(0, $dJhjg.isExperimentEnabled)('id-kirby-heartbeat-v2-endpoint') ? $86bd52119f3a51b9$export$6249a60627b1cb70 : $86bd52119f3a51b9$export$172ec9c0e085fafc;
const $86bd52119f3a51b9$export$af2ff676951003fe = 60000; // 60 seconds
const $86bd52119f3a51b9$export$f2b2f5ef0b498d26 = 10000; // 10 seconds

});

parcelRegister("kkM4a", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f55c0bbb697d07e$export$2e2bcd8739ae039);

var $aSEUQ = parcelRequire("aSEUQ");
const $1f55c0bbb697d07e$var$windowIdleEvents = [
    'scroll',
    'resize'
];
const $1f55c0bbb697d07e$var$documentIdleEvents = [
    'wheel',
    'keydown',
    'keyup',
    'mousedown',
    'mousemove',
    'touchstart',
    'touchmove',
    'click',
    'contextmenu'
];
class $1f55c0bbb697d07e$export$2e2bcd8739ae039 {
    constructor({ timeIntervalEllapsedCallbacks: timeIntervalEllapsedCallbacks = [], absoluteTimeEllapsedCallbacks: absoluteTimeEllapsedCallbacks = [], checkCallbacksIntervalMs: checkCallbacksIntervalMs = 100, browserTabInactiveCallbacks: browserTabInactiveCallbacks = [], idleCallbacks: idleCallbacks = [], stopTimerOnTabchange: stopTimerOnTabchange = true, activeCallbacks: activeCallbacks = [], browserTabActiveCallbacks: browserTabActiveCallbacks = [], idleTimeoutMs: idleTimeoutMs = 3000 }){
        this.onBrowserTabInactive = ()=>{
            // if running pause timer
            if (this.isRunning() && this.stopTimerOnTabchange) this.stopTimer();
            this.browserTabInactiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
        };
        this.onBrowserTabActive = ()=>{
            // if not running start timer
            if (!this.isRunning()) this.startTimer();
            this.browserTabActiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
        };
        this.onBrowserActiveChange = ()=>{
            if (document.visibilityState === 'visible') this.onBrowserTabActive();
            else this.onBrowserTabInactive();
        };
        this.onTimePassed = ()=>{
            // check all callbacks time and if passed execute callback
            this.absoluteTimeEllapsedCallbacks.forEach(({ callback: callback, pending: pending, timeInMilliseconds: timeInMilliseconds }, index)=>{
                if (pending && timeInMilliseconds <= this.getTimeInMilliseconds()) {
                    callback(this.getTimeInMilliseconds());
                    this.absoluteTimeEllapsedCallbacks[index].pending = false;
                }
            });
            this.timeIntervalEllapsedCallbacks.forEach(({ callback: callback, timeInMilliseconds: timeInMilliseconds, multiplier: multiplier }, index)=>{
                if (timeInMilliseconds <= this.getTimeInMilliseconds()) {
                    callback(this.getTimeInMilliseconds());
                    this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                }
            });
            if (this.currentIdleTimeMs >= this.idleTimeoutMs && this.isRunning()) {
                this.idle = true;
                this.stopTimer();
                this.idleCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            } else this.currentIdleTimeMs += this.checkCallbacksIntervalMs;
        };
        this.resetIdleTime = ()=>{
            if (this.idle) this.startTimer();
            this.activeCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            this.idle = false;
            this.currentIdleTimeMs = 0;
        };
        this.registerEventListeners = ()=>{
            const documentListenerOptions = {
                passive: true
            };
            const windowListenerOptions = {
                ...documentListenerOptions,
                capture: true
            };
            document.addEventListener('visibilitychange', this.onBrowserActiveChange);
            const throttleResetIdleTime = (0, (/*@__PURE__*/$parcel$interopDefault($aSEUQ)))(this.resetIdleTime, 2000, {
                leading: true,
                trailing: false
            });
            $1f55c0bbb697d07e$var$windowIdleEvents.forEach((event)=>{
                window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
            });
            $1f55c0bbb697d07e$var$documentIdleEvents.forEach((event)=>document.addEventListener(event, throttleResetIdleTime, documentListenerOptions));
        };
        this.unregisterEventListeners = ()=>{
            document.removeEventListener('visibilitychange', this.onBrowserActiveChange);
            $1f55c0bbb697d07e$var$windowIdleEvents.forEach((event)=>window.removeEventListener(event, this.resetIdleTime));
            $1f55c0bbb697d07e$var$documentIdleEvents.forEach((event)=>document.removeEventListener(event, this.resetIdleTime));
        };
        this.checkCallbacksOnInterval = ()=>{
            this.checkCallbackIntervalId = window.setInterval(()=>{
                this.onTimePassed();
            }, this.checkCallbacksIntervalMs);
        };
        this.startTimer = ()=>{
            if (!this.checkCallbackIntervalId) this.checkCallbacksOnInterval();
            const last = this.times[this.times.length - 1];
            if (last && last.stop === null) return;
            this.times.push({
                start: performance.now(),
                stop: null
            });
            this.running = true;
        };
        this.stopTimer = ()=>{
            if (!this.times.length) return;
            this.times[this.times.length - 1].stop = performance.now();
            this.running = false;
        };
        this.addTimeIntervalEllapsedCallback = (timeIntervalEllapsedCallback)=>{
            this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
        };
        this.addAbsoluteTimeEllapsedCallback = (absoluteTimeEllapsedCallback)=>{
            this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
        };
        this.addBrowserTabInactiveCallback = (browserTabInactiveCallback)=>{
            this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
        };
        this.addBrowserTabActiveCallback = (browserTabActiveCallback)=>{
            this.browserTabActiveCallbacks.push(browserTabActiveCallback);
        };
        this.addIdleCallback = (inactiveCallback)=>{
            this.idleCallbacks.push(inactiveCallback);
        };
        this.addActiveCallback = (activeCallback)=>{
            this.activeCallbacks.push(activeCallback);
        };
        this.getTimeInMilliseconds = ()=>{
            return this.times.reduce((acc, current)=>{
                if (current.stop) acc = acc + (current.stop - current.start);
                else acc = acc + (performance.now() - current.start);
                return acc;
            }, 0);
        };
        this.isRunning = ()=>{
            return this.running;
        };
        this.isIdle = ()=>{
            return this.idle;
        };
        this.reset = ()=>{
            this.times = [];
        };
        this.destroy = ()=>{
            this.unregisterEventListeners();
            if (this.checkCallbackIntervalId) window.clearInterval(this.checkCallbackIntervalId);
        };
        this.running = false;
        this.times = [];
        this.idle = false;
        this.currentIdleTimeMs = 0;
        this.marks = {};
        this.measures = {};
        this.stopTimerOnTabchange = stopTimerOnTabchange;
        this.browserTabActiveCallbacks = browserTabActiveCallbacks;
        this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
        this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
        this.idleTimeoutMs = idleTimeoutMs;
        this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
        this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
        this.idleCallbacks = idleCallbacks;
        this.activeCallbacks = activeCallbacks;
        this.registerEventListeners();
    }
    mark(key) {
        if (!this.marks[key]) this.marks[key] = [];
        this.marks[key].push({
            time: this.getTimeInMilliseconds()
        });
    }
    getMarks(name) {
        if (this.marks[name].length < 1) return;
        return this.marks[name];
    }
    measure(name, startMarkName, endMarkName) {
        const startMarks = this.marks[startMarkName];
        const startMark = startMarks[startMarks.length - 1];
        const endMarks = this.marks[endMarkName];
        const endMark = endMarks[endMarks.length - 1];
        if (!this.measures[name]) this.measures[name] = [];
        this.measures[name].push({
            name: name,
            startTime: startMark.time,
            duration: endMark.time - startMark.time
        });
    }
    getMeasures(name) {
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        if (!this.measures[name] && this.measures[name].length < 1) return;
        return this.measures[name];
    }
}

});
parcelRegister("aSEUQ", function(module, exports) {

var $8TKkC = parcelRequire("8TKkC");

var $2vblS = parcelRequire("2vblS");
/** Error message constants. */ var $7ebeaf94f943508f$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $7ebeaf94f943508f$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($7ebeaf94f943508f$var$FUNC_ERROR_TEXT);
    if ($2vblS(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $8TKkC(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $7ebeaf94f943508f$var$throttle;

});


parcelRegister("eVOdG", function(module, exports) {
$parcel$export(module.exports, "postHeartbeat", () => $9bcb9f560a3d995e$export$931f43089f67754c);

var $l7VAg = parcelRequire("l7VAg");
const $9bcb9f560a3d995e$var$RETRY_HTTP_CODES = [
    408,
    500,
    502,
    503,
    504,
    522,
    524
];
function $9bcb9f560a3d995e$var$timeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
async function $9bcb9f560a3d995e$var$fetchRetry(url, options = {}, retries = 5, backoff = 300) {
    const response = await fetch(url, options);
    if (response.ok || response.status === 401) return response;
    if (retries > 0 && $9bcb9f560a3d995e$var$RETRY_HTTP_CODES.includes(response.status)) {
        await $9bcb9f560a3d995e$var$timeout(backoff);
        return await $9bcb9f560a3d995e$var$fetchRetry(url, options, retries - 1, backoff * 2);
    } else return Promise.reject(response);
}
const $9bcb9f560a3d995e$export$931f43089f67754c = async (endpoint = (0, $l7VAg.getDefaultHeartbeatEndpoint)(), onAuthenticationFailed, onBadRequest)=>{
    try {
        const response = await $9bcb9f560a3d995e$var$fetchRetry(endpoint, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response && response.ok) return response.json();
        if (response && response.status === 401 && onAuthenticationFailed) {
            onAuthenticationFailed();
            return;
        }
    } catch (e) {
        const errorResponse = e;
        if (errorResponse.status === 400) {
            onBadRequest?.();
            return Promise.reject(errorResponse);
        }
        $9bcb9f560a3d995e$var$RETRY_HTTP_CODES.includes(errorResponse.status);
    }
};

});


parcelRegister("8Bxyp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.batchActions = $643bce87c385c560$var$batchActions;
module.exports.enableBatching = $643bce87c385c560$var$enableBatching;
module.exports.batchDispatchMiddleware = $643bce87c385c560$var$batchDispatchMiddleware;
var $643bce87c385c560$var$BATCH = module.exports.BATCH = 'BATCHING_REDUCER.BATCH';
function $643bce87c385c560$var$batchActions(actions) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $643bce87c385c560$var$BATCH;
    return {
        type: type,
        meta: {
            batch: true
        },
        payload: actions
    };
}
function $643bce87c385c560$var$enableBatching(reduce) {
    return function batchingReducer(state, action) {
        if (action && action.meta && action.meta.batch) return action.payload.reduce(batchingReducer, state);
        return reduce(state, action);
    };
}
function $643bce87c385c560$var$batchDispatchMiddleware(store) {
    function dispatchChildActions(store, action) {
        if (action.meta && action.meta.batch) action.payload.forEach(function(childAction) {
            dispatchChildActions(store, childAction);
        });
        else store.dispatch(action);
    }
    return function(next) {
        return function(action) {
            if (action && action.meta && action.meta.batch) dispatchChildActions(store, action);
            return next(action);
        };
    };
}

});

parcelRegister("3Vyd8", function(module, exports) {
!function(e, t) {
    t(module.exports);
}(module.exports, function(e) {
    "use strict";
    function t(e, t) {
        e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        });
    }
    function r(e, t) {
        Object.defineProperty(this, "kind", {
            value: e,
            enumerable: !0
        }), t && t.length && Object.defineProperty(this, "path", {
            value: t,
            enumerable: !0
        });
    }
    function n(e, t, r) {
        n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "rhs", {
            value: r,
            enumerable: !0
        });
    }
    function o(e, t) {
        o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
            value: t,
            enumerable: !0
        });
    }
    function i(e, t) {
        i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        });
    }
    function a(e, t, r) {
        a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "item", {
            value: r,
            enumerable: !0
        });
    }
    function f(e, t, r) {
        var n = e.slice((r || t) + 1 || e.length);
        return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
    }
    function u(e) {
        var t = "undefined" == typeof e ? "undefined" : N(e);
        return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
    }
    function l(e, t, r, c, s, d, p) {
        s = s || [], p = p || [];
        var g = s.slice(0);
        if ("undefined" != typeof d) {
            if (c) {
                if ("function" == typeof c && c(g, d)) return;
                if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
                    if (c.prefilter && c.prefilter(g, d)) return;
                    if (c.normalize) {
                        var h = c.normalize(g, d, e, t);
                        h && (e = h[0], t = h[1]);
                    }
                }
            }
            g.push(d);
        }
        "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
        var y = "undefined" == typeof e ? "undefined" : N(e), v = "undefined" == typeof t ? "undefined" : N(t), b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d), m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
        if (!b && m) r(new o(g, t));
        else if (!m && b) r(new i(g, e));
        else if (u(e) !== u(t)) r(new n(g, e, t));
        else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));
        else if ("object" === y && null !== e && null !== t) {
            if (p.filter(function(t) {
                return t.lhs === e;
            }).length) e !== t && r(new n(g, e, t));
            else {
                if (p.push({
                    lhs: e,
                    rhs: t
                }), Array.isArray(e)) {
                    var w;
                    e.length;
                    for(w = 0; w < e.length; w++)w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
                    for(; w < t.length;)r(new a(g, w, new o(void 0, t[w++])));
                } else {
                    var x = Object.keys(e), S = Object.keys(t);
                    x.forEach(function(n, o) {
                        var i = S.indexOf(n);
                        i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
                    }), S.forEach(function(e) {
                        l(void 0, t[e], r, c, g, e, p);
                    });
                }
                p.length = p.length - 1;
            }
        } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
    }
    function c(e, t, r, n) {
        return n = n || [], l(e, t, function(e) {
            e && n.push(e);
        }, r), n.length ? n : void 0;
    }
    function s(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    s(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    delete o[r.path[n]];
                    break;
                case "E":
                case "N":
                    o[r.path[n]] = r.rhs;
            }
        } else switch(r.kind){
            case "A":
                s(e[t], r.index, r.item);
                break;
            case "D":
                e = f(e, t);
                break;
            case "E":
            case "N":
                e[t] = r.rhs;
        }
        return e;
    }
    function d(e, t, r) {
        if (e && t && r && r.kind) {
            for(var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;)"undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
            switch(r.kind){
                case "A":
                    s(r.path ? n[r.path[o]] : n, r.index, r.item);
                    break;
                case "D":
                    delete n[r.path[o]];
                    break;
                case "E":
                case "N":
                    n[r.path[o]] = r.rhs;
            }
        }
    }
    function p(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    p(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    o[r.path[n]] = r.lhs;
                    break;
                case "E":
                    o[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete o[r.path[n]];
            }
        } else switch(r.kind){
            case "A":
                p(e[t], r.index, r.item);
                break;
            case "D":
                e[t] = r.lhs;
                break;
            case "E":
                e[t] = r.lhs;
                break;
            case "N":
                e = f(e, t);
        }
        return e;
    }
    function g(e, t, r) {
        if (e && t && r && r.kind) {
            var n, o, i = e;
            for(o = r.path.length - 1, n = 0; n < o; n++)"undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
            switch(r.kind){
                case "A":
                    p(i[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    i[r.path[n]] = r.lhs;
                    break;
                case "E":
                    i[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete i[r.path[n]];
            }
        }
    }
    function h(e, t, r) {
        if (e && t) {
            var n = function(n) {
                r && !r(e, t, n) || d(e, t, n);
            };
            l(e, t, n);
        }
    }
    function y(e) {
        return "color: " + F[e].color + "; font-weight: bold";
    }
    function v(e) {
        var t = e.kind, r = e.path, n = e.lhs, o = e.rhs, i = e.index, a = e.item;
        switch(t){
            case "E":
                return [
                    r.join("."),
                    n,
                    "\u2192",
                    o
                ];
            case "N":
                return [
                    r.join("."),
                    o
                ];
            case "D":
                return [
                    r.join(".")
                ];
            case "A":
                return [
                    r.join(".") + "[" + i + "]",
                    a
                ];
            default:
                return [];
        }
    }
    function b(e, t, r, n) {
        var o = c(e, t);
        try {
            n ? r.groupCollapsed("diff") : r.group("diff");
        } catch (e) {
            r.log("diff");
        }
        o ? o.forEach(function(e) {
            var t = e.kind, n = v(e);
            r.log.apply(r, [
                "%c " + F[t].text,
                y(t)
            ].concat(P(n)));
        }) : r.log("\u2014\u2014 no diff \u2014\u2014");
        try {
            r.groupEnd();
        } catch (e) {
            r.log("\u2014\u2014 diff end \u2014\u2014 ");
        }
    }
    function m(e, t, r, n) {
        switch("undefined" == typeof e ? "undefined" : N(e)){
            case "object":
                return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];
            case "function":
                return e(t);
            default:
                return e;
        }
    }
    function w(e) {
        var t = e.timestamp, r = e.duration;
        return function(e, n, o) {
            var i = [
                "action"
            ];
            return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
        };
    }
    function x(e, t) {
        var r = t.logger, n = t.actionTransformer, o = t.titleFormatter, i = void 0 === o ? w(t) : o, a = t.collapsed, f = t.colors, u = t.level, l = t.diff, c = "undefined" == typeof t.titleFormatter;
        e.forEach(function(o, s) {
            var d = o.started, p = o.startedTime, g = o.action, h = o.prevState, y = o.error, v = o.took, w = o.nextState, x = e[s + 1];
            x && (w = x.prevState, v = x.started - d);
            var S = n(g), k = "function" == typeof a ? a(function() {
                return w;
            }, g, o) : a, j = D(p), E = f.title ? "color: " + f.title(S) + ";" : "", A = [
                "color: gray; font-weight: lighter;"
            ];
            A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
            var O = i(S, j, v);
            try {
                k ? f.title && c ? r.groupCollapsed.apply(r, [
                    "%c " + O
                ].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, [
                    "%c " + O
                ].concat(A)) : r.group(O);
            } catch (e) {
                r.log(O);
            }
            var N = m(u, S, [
                h
            ], "prevState"), P = m(u, S, [
                S
            ], "action"), C = m(u, S, [
                y,
                h
            ], "error"), F = m(u, S, [
                w
            ], "nextState");
            if (N) {
                if (f.prevState) {
                    var L = "color: " + f.prevState(h) + "; font-weight: bold";
                    r[N]("%c prev state", L, h);
                } else r[N]("prev state", h);
            }
            if (P) {
                if (f.action) {
                    var T = "color: " + f.action(S) + "; font-weight: bold";
                    r[P]("%c action    ", T, S);
                } else r[P]("action    ", S);
            }
            if (y && C) {
                if (f.error) {
                    var M = "color: " + f.error(y, h) + "; font-weight: bold;";
                    r[C]("%c error     ", M, y);
                } else r[C]("error     ", y);
            }
            if (F) {
                if (f.nextState) {
                    var _ = "color: " + f.nextState(w) + "; font-weight: bold";
                    r[F]("%c next state", _, w);
                } else r[F]("next state", w);
            }
            l && b(h, w, r, k);
            try {
                r.groupEnd();
            } catch (e) {
                r.log("\u2014\u2014 log end \u2014\u2014");
            }
        });
    }
    function S() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Object.assign({}, L, e), r = t.logger, n = t.stateTransformer, o = t.errorTransformer, i = t.predicate, a = t.logErrors, f = t.diffPredicate;
        if ("undefined" == typeof r) return function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        var u = [];
        return function(e) {
            var r = e.getState;
            return function(e) {
                return function(l) {
                    if ("function" == typeof i && !i(r, l)) return e(l);
                    var c = {};
                    u.push(c), c.started = O.now(), c.startedTime = new Date, c.prevState = n(r()), c.action = l;
                    var s = void 0;
                    if (a) try {
                        s = e(l);
                    } catch (e) {
                        c.error = o(e);
                    }
                    else s = e(l);
                    c.took = O.now() - c.started, c.nextState = n(r());
                    var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
                    if (x(u, Object.assign({}, t, {
                        diff: d
                    })), u.length = 0, c.error) throw c.error;
                    return s;
                };
            };
        };
    }
    var k, j, E = function(e, t) {
        return new Array(t + 1).join(e);
    }, A = function(e, t) {
        return E("0", t - e.toString().length) + e;
    }, D = function(e) {
        return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
    }, O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date, N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, P = function(e) {
        if (Array.isArray(e)) {
            for(var t = 0, r = Array(e.length); t < e.length; t++)r[t] = e[t];
            return r;
        }
        return Array.from(e);
    }, C = [];
    k = "object" === ("undefined" == typeof $parcel$global ? "undefined" : N($parcel$global)) && $parcel$global ? $parcel$global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function() {
        "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
    }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
        diff: {
            value: c,
            enumerable: !0
        },
        observableDiff: {
            value: l,
            enumerable: !0
        },
        applyDiff: {
            value: h,
            enumerable: !0
        },
        applyChange: {
            value: d,
            enumerable: !0
        },
        revertChange: {
            value: g,
            enumerable: !0
        },
        isConflict: {
            value: function() {
                return "undefined" != typeof j;
            },
            enumerable: !0
        },
        noConflict: {
            value: function() {
                return C && (C.forEach(function(e) {
                    e();
                }), C = null), c;
            },
            enumerable: !0
        }
    });
    var F = {
        E: {
            color: "#2196F3",
            text: "CHANGED:"
        },
        N: {
            color: "#4CAF50",
            text: "ADDED:"
        },
        D: {
            color: "#F44336",
            text: "DELETED:"
        },
        A: {
            color: "#2196F3",
            text: "ARRAY:"
        }
    }, L = {
        level: "log",
        logger: console,
        logErrors: !0,
        collapsed: void 0,
        predicate: void 0,
        duration: !1,
        timestamp: !0,
        stateTransformer: function(e) {
            return e;
        },
        actionTransformer: function(e) {
            return e;
        },
        errorTransformer: function(e) {
            return e;
        },
        colors: {
            title: function() {
                return "inherit";
            },
            prevState: function() {
                return "#9E9E9E";
            },
            action: function() {
                return "#03A9F4";
            },
            nextState: function() {
                return "#4CAF50";
            },
            error: function() {
                return "#F20404";
            }
        },
        diff: !1,
        diffPredicate: void 0,
        transformer: void 0
    }, T = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.dispatch, r = e.getState;
        return "function" == typeof t || "function" == typeof r ? S()({
            dispatch: t,
            getState: r
        }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
    };
    e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});

parcelRegister("1Lexu", function(module, exports) {

var $erAOt = parcelRequire("erAOt");
/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var $14857566347da68a$var$partition = $erAOt(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
module.exports = $14857566347da68a$var$partition;

});
parcelRegister("erAOt", function(module, exports) {

var $dLFlf = parcelRequire("dLFlf");

var $hNsW0 = parcelRequire("hNsW0");

var $6i1yA = parcelRequire("6i1yA");

var $11H9d = parcelRequire("11H9d");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $a84024a3a2ab13c3$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $11H9d(collection) ? $dLFlf : $hNsW0, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $6i1yA(iteratee, 2), accumulator);
    };
}
module.exports = $a84024a3a2ab13c3$var$createAggregator;

});
parcelRegister("dLFlf", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $a05fbbc02a78a9da$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $a05fbbc02a78a9da$var$arrayAggregator;

});

parcelRegister("hNsW0", function(module, exports) {

var $7ufod = parcelRequire("7ufod");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $cf4d7512d605d90f$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $7ufod(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $cf4d7512d605d90f$var$baseAggregator;

});
parcelRegister("7ufod", function(module, exports) {

var $7VRSw = parcelRequire("7VRSw");

var $gjHTW = parcelRequire("gjHTW");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $573745cadf58cb5a$var$baseEach = $gjHTW($7VRSw);
module.exports = $573745cadf58cb5a$var$baseEach;

});
parcelRegister("7VRSw", function(module, exports) {

var $byyCj = parcelRequire("byyCj");

var $fyIDO = parcelRequire("fyIDO");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $5c67a6619038a5c1$var$baseForOwn(object, iteratee) {
    return object && $byyCj(object, iteratee, $fyIDO);
}
module.exports = $5c67a6619038a5c1$var$baseForOwn;

});

parcelRegister("gjHTW", function(module, exports) {

var $iEpZU = parcelRequire("iEpZU");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $be107997fa992292$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$iEpZU(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $be107997fa992292$var$createBaseEach;

});





parcelRegister("3XDPx", function(module, exports) {
/**
 * This allows you to work with object hierarchies that have been frozen
 * with Object.freeze().  "get" operations can use the normal JS syntax,
 * but operations that modify the data will have to return partial copies of
 * the structure. The portions of the structure that did not change will
 * === their previous values.
 *
 * Inspired by clojure/mori and Immutable.js
 */ 'use strict';
const $2e25c74075a2a6a9$var$i = module.exports;
const $2e25c74075a2a6a9$var$identity = (coll)=>coll;
// we only care about objects or arrays for now
const $2e25c74075a2a6a9$var$weCareAbout = (val)=>val !== null && (Array.isArray(val) || // This will skip objects created with `new Foo()`
    // and objects created with `Object.create(proto)`
    // The benefit is ignoring DOM elements and event emitters,
    // which are often circular.
    $2e25c74075a2a6a9$var$isObjectLike(val));
const $2e25c74075a2a6a9$var$isObjectLike = (val)=>typeof val === 'object' && (val.constructor === Object || val.constructor == null) && (Object.getPrototypeOf(val) === Object.prototype || Object.getPrototypeOf(val) === null);
const $2e25c74075a2a6a9$var$forKeys = (obj, iter)=>{
    let idx, keys;
    if (Array.isArray(obj)) {
        idx = obj.length;
        while(idx--)iter(idx);
        return;
    }
    keys = Object.keys(obj);
    idx = keys.length;
    while(idx--)iter(keys[idx]);
};
const $2e25c74075a2a6a9$var$cloneObj = (obj)=>{
    const newObj = obj.constructor == null ? Object.create(null) : {};
    const keys = Object.keys(obj);
    let idx = keys.length;
    let key;
    while(idx--){
        key = keys[idx];
        newObj[key] = obj[key];
    }
    return newObj;
};
const $2e25c74075a2a6a9$var$clone = (coll)=>{
    if (Array.isArray(coll)) return coll.slice();
    else return $2e25c74075a2a6a9$var$cloneObj(coll);
};
const $2e25c74075a2a6a9$var$freezeIfNeeded = $2e25c74075a2a6a9$var$identity;
const $2e25c74075a2a6a9$var$_freeze = $2e25c74075a2a6a9$var$identity;
const $2e25c74075a2a6a9$var$prevNodes = [];
const $2e25c74075a2a6a9$var$baseFreeze = (coll)=>{
    if ($2e25c74075a2a6a9$var$prevNodes.some((val)=>val === coll)) throw new Error('object has a reference cycle');
    $2e25c74075a2a6a9$var$prevNodes.push(coll);
    $2e25c74075a2a6a9$var$forKeys(coll, (key)=>{
        const prop = coll[key];
        if ($2e25c74075a2a6a9$var$weCareAbout(prop)) $2e25c74075a2a6a9$var$baseFreeze(prop);
    });
    $2e25c74075a2a6a9$var$prevNodes.pop();
    Object.freeze(coll);
    return coll;
};
/**
 * recrursively freeze an object and all its child objects
 * @param  {Object|Array} coll
 * @return {Object|Array}
 */ module.exports.freeze = $2e25c74075a2a6a9$var$identity;
/**
 * recursively un-freeze an object, by cloning frozen collections
 * @param  {[type]} coll [description]
 * @return {[type]}      [description]
 */ module.exports.thaw = function thaw(coll) {
    if (!$2e25c74075a2a6a9$var$weCareAbout(coll) || !Object.isFrozen(coll)) return coll;
    const newColl = Array.isArray(coll) ? new Array(coll.length) : {};
    $2e25c74075a2a6a9$var$forKeys(coll, (key)=>{
        newColl[key] = thaw(coll[key]);
    });
    return newColl;
};
/**
 * set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key   Key or index
 * @param  {Object}        value
 * @return {Object|Array}        new object hierarchy with modifications
 */ module.exports.assoc = function assoc(coll, key, value) {
    if (coll[key] === value) return $2e25c74075a2a6a9$var$_freeze(coll);
    const newObj = $2e25c74075a2a6a9$var$clone(coll);
    newObj[key] = $2e25c74075a2a6a9$var$freezeIfNeeded(value);
    return $2e25c74075a2a6a9$var$_freeze(newObj);
};
module.exports.set = module.exports.assoc;
/**
 * un-set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key  Key or Index
 * @return {Object|Array}       New object or array
 */ module.exports.dissoc = function dissoc(coll, key) {
    const newObj = $2e25c74075a2a6a9$var$clone(coll);
    delete newObj[key];
    return $2e25c74075a2a6a9$var$_freeze(newObj);
};
module.exports.unset = module.exports.dissoc;
/**
 * set a value deep in a hierarchical structure
 * @param  {Object|Array} coll
 * @param  {Array}        path    A list of keys to traverse
 * @param  {Object}       value
 * @return {Object|Array}       new object hierarchy with modifications
 */ module.exports.assocIn = function assocIn(coll, path, value) {
    const key0 = path[0];
    if (path.length === 1) // simplest case is a 1-element array.  Just a simple assoc.
    return $2e25c74075a2a6a9$var$i.assoc(coll, key0, value);
    else // break the problem down.  Assoc this object with the first key
    // and the result of assocIn with the rest of the keys
    return $2e25c74075a2a6a9$var$i.assoc(coll, key0, assocIn(coll[key0] || {}, path.slice(1), value));
};
module.exports.setIn = module.exports.assocIn;
/**
 * un-set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {Array} path  A list of keys to traverse
 * @return {Object|Array}       New object or array
 */ module.exports.dissocIn = function dissocIn(coll, path) {
    const key0 = path[0];
    if (!coll.hasOwnProperty(key0)) return coll;
    if (path.length === 1) // simplest case is a 1-element array.  Just a simple dissoc.
    return $2e25c74075a2a6a9$var$i.dissoc(coll, key0);
    else // break the problem down.  Assoc this object with the first key
    // and the result of dissocIn with the rest of the keys
    return $2e25c74075a2a6a9$var$i.assoc(coll, key0, dissocIn(coll[key0], path.slice(1)));
};
module.exports.unsetIn = module.exports.dissocIn;
/**
 * get an object from a hierachy based on an array of keys
 * @param  {Object|Array} coll
 * @param  {Array}        path    list of keys
 * @return {Object}       value, or undefined
 */ function $2e25c74075a2a6a9$var$baseGet(coll, path) {
    return (path || []).reduce((curr, key)=>{
        if (!curr) return;
        return curr[key];
    }, coll);
}
module.exports.getIn = $2e25c74075a2a6a9$var$baseGet;
/**
 * Update a value in a hierarchy
 * @param  {Object|Array}   coll
 * @param  {Array}          path     list of keys
 * @param  {Function} callback The existing value with be passed to this.
 *                             Return the new value to set
 * @return {Object|Array}      new object hierarchy with modifications
 */ module.exports.updateIn = function updateIn(coll, path, callback) {
    const existingVal = $2e25c74075a2a6a9$var$baseGet(coll, path);
    return $2e25c74075a2a6a9$var$i.assocIn(coll, path, callback(existingVal));
};
// generate wrappers for the mutative array methods
[
    'push',
    'unshift',
    'pop',
    'shift',
    'reverse',
    'sort'
].forEach((methodName)=>{
    module.exports[methodName] = function(arr, val) {
        const newArr = [
            ...arr
        ];
        newArr[methodName]($2e25c74075a2a6a9$var$freezeIfNeeded(val));
        return $2e25c74075a2a6a9$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = 'icepick.' + methodName;
});
// splice is special because it is variadic
module.exports.splice = function splice(arr, ..._args) {
    const newArr = [
        ...arr
    ];
    const args = _args.map($2e25c74075a2a6a9$var$freezeIfNeeded);
    newArr.splice.apply(newArr, args);
    return $2e25c74075a2a6a9$var$_freeze(newArr);
};
// slice is non-mutative
module.exports.slice = function slice(arr, arg1, arg2) {
    const newArr = arr.slice(arg1, arg2);
    return $2e25c74075a2a6a9$var$_freeze(newArr);
};
[
    'map',
    'filter'
].forEach((methodName)=>{
    module.exports[methodName] = function(fn, arr) {
        const newArr = arr[methodName](fn);
        return $2e25c74075a2a6a9$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = 'icepick.' + methodName;
});
module.exports.extend = module.exports.assign = function assign(obj, ...objs) {
    const newObj = objs.reduce($2e25c74075a2a6a9$var$singleAssign, obj);
    return $2e25c74075a2a6a9$var$_freeze(newObj);
};
function $2e25c74075a2a6a9$var$singleAssign(obj1, obj2) {
    return Object.keys(obj2).reduce((obj, key)=>{
        return $2e25c74075a2a6a9$var$i.assoc(obj, key, obj2[key]);
    }, obj1);
}
module.exports.merge = $2e25c74075a2a6a9$var$merge;
function $2e25c74075a2a6a9$var$merge(target, source, resolver) {
    if (target == null || source == null) return target;
    return Object.keys(source).reduce((obj, key)=>{
        const sourceVal = source[key];
        const targetVal = obj[key];
        const resolvedSourceVal = resolver ? resolver(targetVal, sourceVal, key) : sourceVal;
        if ($2e25c74075a2a6a9$var$weCareAbout(sourceVal) && $2e25c74075a2a6a9$var$weCareAbout(targetVal)) {
            // if they are both frozen and reference equal, assume they are deep equal
            if (resolvedSourceVal === targetVal && true) return obj;
            if (Array.isArray(sourceVal)) return $2e25c74075a2a6a9$var$i.assoc(obj, key, resolvedSourceVal);
            // recursively merge pairs of objects
            return $2e25c74075a2a6a9$var$assocIfDifferent(obj, key, $2e25c74075a2a6a9$var$merge(targetVal, resolvedSourceVal, resolver));
        }
        // primitive values, stuff with prototypes
        return $2e25c74075a2a6a9$var$assocIfDifferent(obj, key, resolvedSourceVal);
    }, target);
}
function $2e25c74075a2a6a9$var$assocIfDifferent(target, key, value) {
    if (target[key] === value) return target;
    return $2e25c74075a2a6a9$var$i.assoc(target, key, value);
}
const $2e25c74075a2a6a9$var$chainProto = {
    value: function value() {
        return this.val;
    },
    thru: function thru(fn) {
        this.val = $2e25c74075a2a6a9$var$freezeIfNeeded(fn(this.val));
        return this;
    }
};
Object.keys(module.exports).forEach((methodName)=>{
    if (methodName.match(/^(map|filter)$/)) {
        $2e25c74075a2a6a9$var$chainProto[methodName] = function(fn) {
            this.val = module.exports[methodName](fn, this.val);
            return this;
        };
        return;
    }
    $2e25c74075a2a6a9$var$chainProto[methodName] = function(...args) {
        this.val = module.exports[methodName](this.val, ...args);
        return this;
    };
});
module.exports.chain = function chain(val) {
    const wrapped = Object.create($2e25c74075a2a6a9$var$chainProto);
    wrapped.val = val;
    return wrapped;
};

});

parcelRegister("icbxG", function(module, exports) {
$parcel$export(module.exports, "ExperienceTrackerContext", () => $4ecb93a07668210f$export$a7b0697657ed8bd0);

var $fsvuC = parcelRequire("fsvuC");
const $4ecb93a07668210f$export$a7b0697657ed8bd0 = (0, $fsvuC.createContext)({
    abort () {},
    fail () {},
    start () {},
    succeed () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    },
    updateAttributes () {}
});

});

parcelRegister("iuoEq", function(module, exports) {
$parcel$export(module.exports, "default", () => $f60baa1d57d0fc73$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.

var $17hIO = parcelRequire("17hIO");

var $bN1y6 = parcelRequire("bN1y6");

var $6J97j = parcelRequire("6J97j");

var $aXWJz = parcelRequire("aXWJz");

var $9LG40 = parcelRequire("9LG40");

var $8IAtM = parcelRequire("8IAtM");

var $kAAlR = parcelRequire("kAAlR");

var $6RBZX = parcelRequire("6RBZX");
function $f60baa1d57d0fc73$var$traceUFOTransition(ufoName, routeName = ufoName, preloadKey) {
    if (!(0, $6J97j.isUFOEnabled)()) return;
    const pressInteractionsList = (0, $6J97j.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $8IAtM.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $8IAtM.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $kAAlR.default).current = ufoName;
        const rate = (0, $6J97j.getInteractionRate)(ufoName, 'transition');
        if ((0, $bN1y6.default)(rate)) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const newId = (0, $17hIO.default)();
            (0, $6RBZX.setInteractionActiveTrace)(newId);
            (0, $9LG40.default).current = newId;
            (0, $8IAtM.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $aXWJz.getActiveTrace)(), preloadKey);
        }
    }
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f60baa1d57d0fc73$export$2e2bcd8739ae039 = $f60baa1d57d0fc73$var$traceUFOTransition;

});
parcelRegister("6RBZX", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $498bf6d5789b7b0a$export$f2e521e495a88544);

var $7n0IO = parcelRequire("7n0IO");

var $62SDP = parcelRequire("62SDP");
function $498bf6d5789b7b0a$export$f2e521e495a88544(newId) {
    (0, $7n0IO.setActiveTrace)(newId.replace(/-/g, ''), (0, $62SDP.generateSpanId)(), 'transition');
}

});
parcelRegister("7n0IO", function(module, exports) {
$parcel$export(module.exports, "setActiveTrace", () => $937b7f35b48f3ed7$export$a1002be327997103);

var $CYTlF = parcelRequire("CYTlF");

var $llCao = parcelRequire("llCao");

var $9iPXD = parcelRequire("9iPXD");

var $TjJC1 = parcelRequire("TjJC1");

var $ayZ4S = parcelRequire("ayZ4S");

var $4jk1s = parcelRequire("4jk1s");

var $k2hYx = parcelRequire("k2hYx");
function $937b7f35b48f3ed7$export$a1002be327997103(traceId, spanId, type) {
    if ((0, $llCao.fg)('platform_ufo_enable_otel_context_manager')) {
        const activeTraceContext = (0, $CYTlF.ROOT_CONTEXT).setValue((0, $k2hYx.traceIdKey), traceId).setValue((0, $ayZ4S.spanIdKey), spanId).setValue((0, $TjJC1.experienceTypeKey), type);
        // Now we need to get the global Context Manager and set the active context
        // Using type assertion because we've "extended" the ContextManager type
        if ((0, $9iPXD.getContextManager)() instanceof (0, $9iPXD.UFOContextManager)) {
            let contextManager = (0, $9iPXD.getContextManager)();
            contextManager.setActive(activeTraceContext);
        }
    } else (0, $4jk1s.state).context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}

});

parcelRegister("62SDP", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $f5a2ba0e28cd6892$export$295213bc4d0c54ad);
function $f5a2ba0e28cd6892$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});



parcelRegister("lV5p4", function(module, exports) {
$parcel$export(module.exports, "GlobalPageLoadExperience", () => $4f347da1395df251$export$bf7c1e56255f1467);

var $3PC4H = parcelRequire("3PC4H");

var $8nBFK = parcelRequire("8nBFK");

var $gQXsQ = parcelRequire("gQXsQ");

var $6EW77 = parcelRequire("6EW77");

var $a3zw2 = parcelRequire("a3zw2");
class $4f347da1395df251$var$UFOGlobalPageLoadExperience extends (0, $a3zw2.UFOAbstractExperience) {
    startPageLoad(id, initial = false, startTime) {
        const result = super.start(initial ? 0 : (0, $6EW77.perfNowOrTimestamp)(startTime));
        this.setPageLoadId(id);
        this.initial = initial;
        return result;
    }
    updateConfig(config) {
        Object.assign(this.config, config);
    }
    setPageLoadId(id) {
        this.loadingPageLoadId = id;
    }
    async getId() {
        return this.loadingPageLoadId;
    }
    async exportData() {
        const data = await super.exportData();
        return {
            ...data,
            initial: this.initial
        };
    }
    constructor(...args){
        super(...args), this.loadingPageLoadId = 'UNKNOWN', this.type = (0, $8nBFK.ExperienceTypes).Load, this.performanceType = (0, $8nBFK.ExperiencePerformanceTypes).PageLoad, this.initial = true;
    }
}
const $4f347da1395df251$export$bf7c1e56255f1467 = new $4f347da1395df251$var$UFOGlobalPageLoadExperience('UFO_GLOBAL_PAGE_LOAD', {
    type: (0, $8nBFK.ExperienceTypes).Load,
    performanceType: (0, $8nBFK.ExperiencePerformanceTypes).PageLoad,
    // this should come from global config
    until: (0, $3PC4H.untilAll)([
        {
            category: (0, $gQXsQ.PageSegmentExperienceTypes).PRODUCT
        }
    ])
});

});
parcelRegister("3PC4H", function(module, exports) {
$parcel$export(module.exports, "untilAll", () => $619b51f3405c7bbe$export$44695628831598be);

var $d55U0 = parcelRequire("d55U0");

var $lYE2V = parcelRequire("lYE2V");
const $619b51f3405c7bbe$var$isUntilExperience = (until)=>{
    return until.experience !== undefined;
};
const $619b51f3405c7bbe$var$isUntilCategory = (until)=>{
    return until.category !== undefined;
};
const $619b51f3405c7bbe$export$44695628831598be = (deps)=>()=>{
        const notMet = [
            ...deps
        ];
        return (data)=>{
            if (notMet.length > 0) {
                const doneIndexes = notMet.reduce((acc, dep, i)=>{
                    // validation logic
                    if ($619b51f3405c7bbe$var$isUntilExperience(dep) && dep.experience.uuid === data.uuid) acc.push(i);
                    else if ($619b51f3405c7bbe$var$isUntilCategory(dep) && dep.category === data.category) acc.push(i);
                    return acc;
                }, []);
                const priorityStateFound = data.state === (0, $lYE2V.UFOExperienceState).ABORTED || data.state === (0, $lYE2V.UFOExperienceState).FAILED;
                if (priorityStateFound && doneIndexes.length > 0) {
                    notMet.length = 0;
                    return {
                        done: true,
                        state: data.state
                    };
                }
                doneIndexes.reverse().forEach((i)=>{
                    notMet.splice(i, 1);
                });
                (0, $d55U0.ufolog)('untilAll deps left:', notMet.length, notMet);
                if (notMet.length === 0) return {
                    done: true,
                    state: (0, $lYE2V.UFOExperienceState).SUCCEEDED
                };
            }
            return {
                done: false
            };
        };
    };

});

parcelRegister("gQXsQ", function(module, exports) {
$parcel$export(module.exports, "PageSegmentExperienceTypes", () => $4102d7b5cd247c86$export$17d97452062ccf73);
const $4102d7b5cd247c86$export$17d97452062ccf73 = {
    NAVIGATION: 'NAVIGATION',
    PRODUCT: 'PRODUCT',
    COMPONENT: 'COMPONENT'
};

});


parcelRegister("2iMml", function(module, exports) {
$parcel$export(module.exports, "choreographerFactory", () => $4db461c06b32142c$export$55d2aeb17c4cfbe);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $8F5dv = parcelRequire("8F5dv");

var $a5MkA = parcelRequire("a5MkA");

var $5iH7k = parcelRequire("5iH7k");

var $4yeKx = parcelRequire("4yeKx");
var $3A3Vn = parcelRequire("3A3Vn");
var $df8z1 = parcelRequire("df8z1");
var $6ajK0 = parcelRequire("6ajK0");
var $dDqWB = parcelRequire("dDqWB");
var $8NC9k = parcelRequire("8NC9k");
var $hKuUX = parcelRequire("hKuUX");
var $5Tm0m = parcelRequire("5Tm0m");
var $4vB8u = parcelRequire("4vB8u");
var $iHWy5 = parcelRequire("iHWy5");
var $csHaM = parcelRequire("csHaM");
var $20YcX = parcelRequire("20YcX");
/**
 * If no callback is provided, the component claims the slot.
 * This matches callers who don't provide a shouldClaim function.
 * If the callback throws, the component declines the slot so the next message can be offered.
 */ function $4db461c06b32142c$var$evaluateShouldClaim(shouldClaim) {
    if (!shouldClaim) return true;
    try {
        return shouldClaim();
    } catch  {
        return false;
    }
}
function $4db461c06b32142c$export$55d2aeb17c4cfbe(productId, env, metaMetricsData = {}, choreographerOptions = {
    enableChoreographer: true
}) {
    // Instantiate our plugin instance, passing the productId through for segmenting any messageId's from any other plugins
    const plugin = new (0, $5iH7k.ProductChoreographerPlugin)(productId, env, metaMetricsData);
    // Capture plugin-wide TTL from options
    const pluginTtl = choreographerOptions.messageTtl;
    /**
	 * React hook that provides startMessage and stopMessage functions that call through the plugin API with the provided messageId, for easy assignment to React event handlers.
	 *
	 * @param messageId The messageId to be provided to the choreographer API whenever the startMessage and stopMessage callbacks are invoked.
	 * @param callbacks An object containing start and stop callbacks.
	 * @param messageTtl Optional TTL for messages started via the returned startMessage function. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use plugin-wide TTL or global default (5 minutes). Message-level TTL takes priority over plugin-wide TTL.
	 * @returns An object with startMessage and stopMessage callbacks, which contain references to the messageId to be passed to the choreographer API, so that the consumer no longer needs to specify that at call time.
	 */ const useChoreographer = (messageId, { [(0, $a5MkA.MessageEventType).START]: startCallback, [(0, $a5MkA.MessageEventType).STOP]: stopCallback } = {}, messageTtl)=>{
        const isMessageStarted = (0, $fsvuC.useRef)(false);
        const startRef = (0, $fsvuC.useRef)(startCallback);
        const stopRef = (0, $fsvuC.useRef)(stopCallback);
        // Callback that uses a ref to track any changes in the received startCallback parameter, so the caller doesn't have to worry about memoization
        const startMessageCallback = (0, $fsvuC.useCallback)(async (...args)=>{
            const didMessageStart = await startRef.current?.(...args) ?? true;
            isMessageStarted.current = didMessageStart;
            return didMessageStart;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's startMessage function, for use in components.
        // Use message-level TTL if provided, otherwise fall back to plugin-wide TTL
        const startMessage = (0, $fsvuC.useCallback)((...args)=>{
            plugin.onStart(messageId, ()=>startMessageCallback(...args));
            // Message-level TTL takes priority over plugin-wide TTL, if provided
            return plugin.startMessage(messageId, {}, messageTtl !== undefined ? messageTtl : pluginTtl);
        }, [
            messageId,
            startMessageCallback,
            messageTtl
        ]);
        // Callback that uses a ref to track any changes in the received stopCallback parameter, so the caller doesn't have to worry about memoization
        const stopMessageCallback = (0, $fsvuC.useCallback)(async (...args)=>{
            const didMessageStop = await stopRef.current?.(...args) ?? true;
            isMessageStarted.current = !didMessageStop;
            return didMessageStop;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's stopMessage function, for use in components.
        const stopMessage = (0, $fsvuC.useCallback)((...args)=>{
            if (isMessageStarted.current) {
                plugin.onStop(messageId, ()=>stopMessageCallback(...args));
                return plugin.stopMessage(messageId);
            }
            return Promise.resolve((0, $a5MkA.MessageDeliveryStatus).STOPPED);
        }, [
            isMessageStarted,
            messageId,
            stopMessageCallback
        ]);
        // Stable function reference that invokes whichever start or stop handler is appropriate for the message's current display state.
        // Tracking this state with a ref allows us to know the current display state in real-time, so that potentially subsequent calls
        // can be made to toggle its state, without requiring tracking a useState value and requiring rerenders to update the callback
        // with the latest display state, and without generating false blocked messages from cached/outdated toggleMessage references.
        const toggleMessage = (0, $fsvuC.useCallback)(()=>{
            return isMessageStarted.current ? stopMessage() : startMessage();
        }, [
            isMessageStarted,
            startMessage,
            stopMessage
        ]);
        // Syncs any incoming startCallback and stopCallback functions as the latest version to be invoked when a startMessage or stopMessage call is issued through the choreographer API
        (0, $fsvuC.useLayoutEffect)(()=>{
            startRef.current = startCallback;
            stopRef.current = stopCallback;
        }, [
            startCallback,
            stopCallback
        ]);
        /**
		 * At component mount, we want to default a start and stop function, which invokes these functions with no additional parameters,
		 * just to supply some sane defaults. If startMessage or stopMessage are called explicitly, they can optionally supply some extra
		 * parameters, at which point, a just-in-time registration of a new callback version will be supplied to the choreographer, which
		 * will proxy those parameter through to the target state-setter functions. But if they are not called explicitly, such as in the
		 * case where a message is started and never stopped, and is timed out from the Choreographer, we want to have a default version
		 * available to execute against.
		 *
		 * At component unmount, stop the current message, if it's displayed, and unsubscribe the stop callback for this messageId within
		 * the plugin.
		 */ (0, $fsvuC.useLayoutEffect)(()=>{
            plugin.on(messageId, {
                start: async ()=>{
                    return await startMessage() === (0, $a5MkA.MessageDeliveryStatus).STARTED;
                },
                stop: async ()=>{
                    return await stopMessage() === (0, $a5MkA.MessageDeliveryStatus).STOPPED;
                }
            });
            return ()=>{
                // If unsubscribing, fire the stopMessageCallback one last time to ensure the component can clear the local state responsible for displaying its message
                stopMessage(messageId);
                plugin.off(messageId);
            };
        }, [
            messageId,
            startMessage,
            stopMessage
        ]);
        // Return the wrapped startMessage and stopMessage functions to the consumer, which will route their requests through the choreographer API with the messageId proxied straight through on behalf of the caller
        return (0, $fsvuC.useMemo)(()=>({
                startMessage: startMessage,
                stopMessage: stopMessage,
                toggleMessage: toggleMessage
            }), [
            startMessage,
            stopMessage,
            toggleMessage
        ]);
    };
    const shouldBeChoreographed = (props, toggleableProp)=>{
        return plugin.shouldBeChoreographed(props, choreographerOptions, toggleableProp);
    };
    const useChoreographedRender = ({ messageId: messageId, onMessageDisposition: onMessageDisposition, messageTtl: messageTtl, shouldClaim: shouldClaim })=>{
        const [shouldRender, setShouldRender] = (0, $fsvuC.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
            start: ()=>{
                if (!$4db461c06b32142c$var$evaluateShouldClaim(shouldClaim)) return false;
                setShouldRender(true);
                return true;
            },
            stop: ()=>setShouldRender(false)
        }, messageTtl);
        (0, $fsvuC.useLayoutEffect)(()=>{
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            const stopMessageAsync = async ()=>{
                const disposition = await stopMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>void stopMessageAsync();
        }, [
            messageId,
            onMessageDisposition,
            startMessage,
            stopMessage,
            messageTtl
        ]);
        return shouldRender;
    };
    const withChoreographedRender = (Component)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, messageTtl: messageTtl, shouldClaim: shouldClaim, ...props }) {
            const shouldRender = useChoreographedRender({
                messageId: messageId,
                onMessageDisposition: onMessageDisposition,
                messageTtl: messageTtl,
                shouldClaim: shouldClaim
            });
            if (shouldRender) // Need to cast "props" as unknown to avoid TS error because it can't infer that
            // the remaining props are the same as T
            return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
                ...props
            });
            return null;
        }
        ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
        function MaybeChoreographedByAncestor(props) {
            const isChoreographedByAncestor = (0, $8F5dv.useIsChoreographedByAncestor)();
            // When an ancestor (e.g. the Post Office message wrapper) is already
            // choreographing this subtree, defer to it and render directly — a nested
            // second choreographer collides with the ancestor and can stop the message
            // from rendering at all.
            if (isChoreographedByAncestor) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { messageId: messageId, onMessageDisposition: onMessageDisposition, messageTtl: messageTtl, shouldClaim: shouldClaim, ...rest } = props;
                return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
                    ...rest
                });
            }
            return /*#__PURE__*/ (0, $5chsV.jsx)(ChoreographedComponent, {
                ...props
            });
        }
        MaybeChoreographedByAncestor.displayName = `MaybeChoreographedByAncestor(${Component.displayName ?? 'Component'})`;
        return MaybeChoreographedByAncestor;
    };
    const withChoreographedToggle = (Component, toggleableProp)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, messageTtl: messageTtl, shouldClaim: shouldClaim, ...rest }) {
            // Need to cast "rest" as unknown to avoid TS error because it can't infer that
            // the remaining props are the same as T
            const props = rest;
            const toggleablePropValue = props[toggleableProp];
            const [shouldRender, setShouldRender] = (0, $fsvuC.useState)(false);
            const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
                start: ()=>{
                    if (!$4db461c06b32142c$var$evaluateShouldClaim(shouldClaim)) return false;
                    setShouldRender(true);
                    return true;
                },
                stop: ()=>setShouldRender(false)
            }, messageTtl);
            (0, $fsvuC.useLayoutEffect)(()=>{
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                const stopMessageAsync = async ()=>{
                    const disposition = await stopMessage();
                    onMessageDisposition?.(disposition);
                };
                if (toggleablePropValue && !shouldRender) startMessageAsync();
                else if (!toggleablePropValue && shouldRender) stopMessageAsync();
                return ()=>{
                    if (!toggleablePropValue && shouldRender) stopMessageAsync();
                };
            }, [
                messageId,
                onMessageDisposition,
                shouldRender,
                startMessage,
                stopMessage,
                toggleablePropValue,
                messageTtl
            ]);
            return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
                ...props,
                [toggleableProp]: shouldRender
            });
        }
        ChoreographedComponent.displayName = `ChoreographedToggle${Component.displayName ?? 'Component'}`;
        function MaybeChoreographedByAncestor(props) {
            const isChoreographedByAncestor = (0, $8F5dv.useIsChoreographedByAncestor)();
            // Defer to an ancestor choreographer (e.g. the Post Office message wrapper)
            // instead of applying a second, colliding choreographer over the same subtree.
            if (isChoreographedByAncestor) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { messageId: messageId, onMessageDisposition: onMessageDisposition, messageTtl: messageTtl, shouldClaim: shouldClaim, ...rest } = props;
                return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
                    ...rest
                });
            }
            return /*#__PURE__*/ (0, $5chsV.jsx)(ChoreographedComponent, {
                ...props
            });
        }
        MaybeChoreographedByAncestor.displayName = `MaybeChoreographedByAncestorToggle(${Component.displayName ?? 'Component'})`;
        return MaybeChoreographedByAncestor;
    };
    function wrapWithFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $5chsV.jsx)(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedRender: withChoreographedRender
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    function wrapWithToggleFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $5chsV.jsx)(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    const AutoDismissFlag = wrapWithFactoryFunctions((0, $4yeKx.AutoDismissFlag));
    const Banner = wrapWithFactoryFunctions((0, $3A3Vn.Banner));
    const ChoreographedComponent = wrapWithFactoryFunctions((0, $df8z1.ChoreographedComponent));
    const Flag = wrapWithFactoryFunctions((0, $6ajK0.Flag));
    const Modal = wrapWithFactoryFunctions((0, $8NC9k.Modal));
    const Popper = wrapWithFactoryFunctions((0, $5Tm0m.Popper));
    const Spotlight = wrapWithFactoryFunctions((0, $iHWy5.Spotlight));
    const SpotlightCard = wrapWithFactoryFunctions((0, $csHaM.SpotlightCard));
    const InlineDialog = wrapWithToggleFactoryFunctions((0, $dDqWB.InlineDialog));
    // Similar to Popup, PopoverContent uses a union type and so must be wrapped manually.
    const PopoverContent = function() {
        function WrappedPopoverContent(props) {
            return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hKuUX.PopoverContent), {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        WrappedPopoverContent.displayName = `ChoreographerFactory(${(0, $hKuUX.PopoverContent).displayName})`;
        return WrappedPopoverContent;
    }();
    // Would ideally like to use wrapWithToggleFactoryFunctions here, but the Popup component's props is a union
    // type, and that for some reason causes ToggleableChoreographerUtilities to be passed through to the
    // consumer-exposed Popup component's prop type, which is not what we want, so we'll just wrap it manually here
    const Popup = function() {
        function WrappedPopup(props) {
            return /*#__PURE__*/ (0, $5chsV.jsx)((0, $4vB8u.Popup), {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        WrappedPopup.displayName = `ChoreographerFactory(${(0, $4vB8u.Popup).displayName})`;
        return WrappedPopup;
    }();
    // Return these items from the factory function for use within React products
    return {
        plugin: plugin,
        useChoreographer: useChoreographer,
        shouldBeChoreographed: shouldBeChoreographed,
        useChoreographedRender: useChoreographedRender,
        withChoreographedRender: withChoreographedRender,
        withChoreographedToggle: withChoreographedToggle,
        AutoDismissFlag: AutoDismissFlag,
        Banner: Banner,
        ChoreographedComponent: ChoreographedComponent,
        Flag: Flag,
        InlineDialog: InlineDialog,
        Modal: Modal,
        Popper: Popper,
        Popup: Popup,
        Spotlight: Spotlight,
        SpotlightCard: SpotlightCard,
        SpotlightTarget: $20YcX.SpotlightTarget,
        PopoverContent: PopoverContent
    };
}

});
parcelRegister("8F5dv", function(module, exports) {
$parcel$export(module.exports, "AncestorChoreographerProvider", () => $15aed84384dfca9b$export$6bbbd27ff914855a);
$parcel$export(module.exports, "useIsChoreographedByAncestor", () => $15aed84384dfca9b$export$1995d416b134f323);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
/**
 * Tracks whether an ancestor is already choreographing this subtree.
 *
 * The Post Office message wrapper (and any other outer choreographer) applies
 * choreography once, at the top of a message. A choreographer-wrapped component
 * rendered further down — e.g. a product spotlight such as `JiraSpotlight`, or a
 * Confluence component built on `@confluence/choreographer-services` — would
 * otherwise start a *second*, independent choreographer over the same subtree.
 * Two choreographers gating the same DOM collide and the message can silently
 * fail to render.
 *
 * When this context is `true`, choreographer-wrapped components skip their own
 * choreography and render their children directly, deferring to the ancestor.
 */ const $15aed84384dfca9b$var$IsChoreographedByAncestorContext = /*#__PURE__*/ (0, $fsvuC.createContext)(false);
const $15aed84384dfca9b$export$6bbbd27ff914855a = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)($15aed84384dfca9b$var$IsChoreographedByAncestorContext.Provider, {
        value: true,
        children: children
    });
$15aed84384dfca9b$export$6bbbd27ff914855a.displayName = "AncestorChoreographerProvider";
const $15aed84384dfca9b$export$1995d416b134f323 = ()=>(0, $fsvuC.useContext)($15aed84384dfca9b$var$IsChoreographedByAncestorContext);

});

parcelRegister("5iH7k", function(module, exports) {
$parcel$export(module.exports, "ProductChoreographerPlugin", () => $55b6a3e83b6da6e5$export$44bee9c9373d59fb);

var $jhuwq = parcelRequire("jhuwq");
class $55b6a3e83b6da6e5$export$44bee9c9373d59fb extends (0, $jhuwq.ChoreographerPlugin) {
    constructor(product, env, metaMetricsData = {}){
        super(product, env, metaMetricsData);
    }
}

});

parcelRegister("4yeKx", function(module, exports) {
$parcel$export(module.exports, "AutoDismissFlag", () => $7cd9d0f9b762468b$export$9879a8e0db317538);

var $3muTT = parcelRequire("3muTT");

var $dtMAb = parcelRequire("dtMAb");
const $7cd9d0f9b762468b$export$9879a8e0db317538 = (0, $dtMAb.wrapComponentForChoreographer)((0, $3muTT.default));

});

parcelRegister("3A3Vn", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $d2edc47e62bb99d0$export$3b4e64e77073e307);

var $dhkoW = parcelRequire("dhkoW");

var $dtMAb = parcelRequire("dtMAb");
const $d2edc47e62bb99d0$export$3b4e64e77073e307 = (0, $dtMAb.wrapComponentForChoreographer)((0, $dhkoW.default));

});

parcelRegister("df8z1", function(module, exports) {
$parcel$export(module.exports, "ChoreographedComponent", () => $9109e9426d314adc$export$2d56cb44b2c5f8dc);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
const $9109e9426d314adc$var$ChildrenWrapper = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: children
    });
$9109e9426d314adc$var$ChildrenWrapper.displayName = "ChildrenWrapper";
const $9109e9426d314adc$export$2d56cb44b2c5f8dc = ({ messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, shouldBeChoreographed: shouldBeChoreographed, withChoreographedRender: withChoreographedRender, children: children })=>{
    const ChoreographedChildrenWrapper = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useMemo(()=>withChoreographedRender($9109e9426d314adc$var$ChildrenWrapper), [
        withChoreographedRender
    ]);
    if (!shouldBeChoreographed({
        messageId: messageId,
        messageType: messageType,
        onMessageDisposition: onMessageDisposition
    })) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)(ChoreographedChildrenWrapper, {
        messageId: messageId,
        onMessageDisposition: onMessageDisposition,
        children: children
    });
};
$9109e9426d314adc$export$2d56cb44b2c5f8dc.displayName = "ChoreographedComponent";

});

parcelRegister("6ajK0", function(module, exports) {
$parcel$export(module.exports, "Flag", () => $0ad4d31fd03966c9$export$48ea269755562084);

var $intO7 = parcelRequire("intO7");

var $dtMAb = parcelRequire("dtMAb");
const $0ad4d31fd03966c9$export$48ea269755562084 = (0, $dtMAb.wrapComponentForChoreographer)((0, $intO7.default));

});

parcelRegister("dDqWB", function(module, exports) {
$parcel$export(module.exports, "InlineDialog", () => $dbee76bcd5a2bd4f$export$c7313f750e9cbc9d);

var $l1T84 = parcelRequire("l1T84");

var $dtMAb = parcelRequire("dtMAb");
const $dbee76bcd5a2bd4f$export$c7313f750e9cbc9d = (0, $dtMAb.wrapToggleableComponentForChoreographer)((0, $l1T84.default), 'isOpen');

});

parcelRegister("8NC9k", function(module, exports) {
$parcel$export(module.exports, "Modal", () => $b9cc144905536bed$export$2b77a92f1a5ad772);

var $8OcK0 = parcelRequire("8OcK0");

var $dtMAb = parcelRequire("dtMAb");
const $b9cc144905536bed$export$2b77a92f1a5ad772 = (0, $dtMAb.wrapComponentForChoreographer)((0, $8OcK0.default));

});

parcelRegister("hKuUX", function(module, exports) {
$parcel$export(module.exports, "PopoverContent", () => $69d5974b723f43bf$export$d7e1f420b25549ff);

var $8xjQm = parcelRequire("8xjQm");

var $dtMAb = parcelRequire("dtMAb");
const $69d5974b723f43bf$export$d7e1f420b25549ff = (0, $dtMAb.wrapToggleableComponentForChoreographer)((0, $8xjQm.PopoverContent), 'isVisible');

});

parcelRegister("5Tm0m", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $c1b03a31b23337b2$export$badac9ada3a0bdf9);

var $f3WQU = parcelRequire("f3WQU");

var $dtMAb = parcelRequire("dtMAb");
const $c1b03a31b23337b2$export$badac9ada3a0bdf9 = (0, $dtMAb.wrapComponentForChoreographer)((0, $f3WQU.Popper));

});

parcelRegister("4vB8u", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $cc38f432dcdb3d5e$export$129a32eedafa97c5);

var $RG5NG = parcelRequire("RG5NG");

var $dtMAb = parcelRequire("dtMAb");
const $cc38f432dcdb3d5e$export$129a32eedafa97c5 = (0, $dtMAb.wrapToggleableComponentForChoreographer)((0, $RG5NG.Popup), 'isOpen');

});

parcelRegister("iHWy5", function(module, exports) {
$parcel$export(module.exports, "Spotlight", () => $99f99ca7a8bcbc07$export$1033c28b5e1c2deb);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $72dzD = parcelRequire("72dzD");

var $llCao = parcelRequire("llCao");

var $dtMAb = parcelRequire("dtMAb");

var $ek2y4 = parcelRequire("ek2y4");

var $20YcX = parcelRequire("20YcX");
const $99f99ca7a8bcbc07$var$DeprecatedSpotlight = (0, $dtMAb.wrapComponentForChoreographer)((0, $72dzD.default));
const $99f99ca7a8bcbc07$export$1033c28b5e1c2deb = (props)=>{
    const { isMigrated: isMigrated } = props;
    if (isMigrated && (0, $llCao.fg)('post-office_enable_ads_spotlight_migration')) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $ek2y4.MigratedSpotlight), {
        ...props
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)($99f99ca7a8bcbc07$var$DeprecatedSpotlight, {
        ...props
    });
};
$99f99ca7a8bcbc07$export$1033c28b5e1c2deb.displayName = "Spotlight";
$99f99ca7a8bcbc07$export$1033c28b5e1c2deb.displayName = 'ChoreographerSpotlight';

});
parcelRegister("ek2y4", function(module, exports) {
$parcel$export(module.exports, "MigratedSpotlight", () => $b09f252c94c6d36d$export$13e08e0bdd266b1b);
/* MigratedSpotlight.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $gOANe = parcelRequire("gOANe");

var $daZXj = parcelRequire("daZXj");

var $eygIb = parcelRequire("eygIb");

var $3Ru3M = parcelRequire("3Ru3M");

var $9Cyj3 = parcelRequire("9Cyj3");

var $3NMdW = parcelRequire("3NMdW");

var $e9bDS = parcelRequire("e9bDS");

var $6k44y = parcelRequire("6k44y");

var $jZ2NQ = parcelRequire("jZ2NQ");

var $4iMK3 = parcelRequire("4iMK3");

var $kpS32 = parcelRequire("kpS32");

var $8xjQm = parcelRequire("8xjQm");

var $TLRFC = parcelRequire("TLRFC");

var $35rMO = parcelRequire("35rMO");

var $sAY9X = parcelRequire("sAY9X");

var $1rHDk = parcelRequire("1rHDk");

var $5SxcE = parcelRequire("5SxcE");

var $df8z1 = parcelRequire("df8z1");

var $aFiY0 = parcelRequire("aFiY0");

var $4FalA = parcelRequire("4FalA");

var $17w4v = parcelRequire("17w4v");

var $15bBM = parcelRequire("15bBM");

var $3taQQ = parcelRequire("3taQQ");

var $6MNwg = parcelRequire("6MNwg");
const $b09f252c94c6d36d$var$styles = {
    imageWrapper: "_39xV02N91d"
};
const $b09f252c94c6d36d$var$translations = {
    actions: (0, $aFiY0.actions),
    heading: (0, $15bBM.heading),
    children: (0, $4FalA.children),
    dialogPlacement: (0, $17w4v.dialogPlacement),
    target: (0, $3taQQ.target)
};
const $b09f252c94c6d36d$export$13e08e0bdd266b1b = (props)=>{
    const { messageId: messageId, messageType: messageType, onMessageDisposition: onMessageDisposition, shouldBeChoreographed: shouldBeChoreographed, withChoreographedRender: withChoreographedRender, ...rest } = props;
    const placement = $b09f252c94c6d36d$var$translations.dialogPlacement(rest.dialogPlacement);
    const actions = $b09f252c94c6d36d$var$translations.actions(rest.actions);
    const heading = $b09f252c94c6d36d$var$translations.heading(rest.heading);
    const body = $b09f252c94c6d36d$var$translations.children(rest.children);
    const id = $b09f252c94c6d36d$var$translations.target(rest.target);
    const [isVisible, setIsVisible] = (0, $fsvuC.useState)(true);
    const dismiss = (0, $fsvuC.useCallback)(()=>{
        setIsVisible(false);
    }, []);
    const renderInline = (0, $6MNwg.useMountToHtmlElement)({
        selectors: id ? `#${id}` : undefined,
        as: 'inline',
        position: 'inside'
    });
    return renderInline(/*#__PURE__*/ (0, $5chsV.jsx)((0, $df8z1.ChoreographedComponent), {
        messageId: messageId,
        messageType: messageType,
        onMessageDisposition: onMessageDisposition,
        shouldBeChoreographed: shouldBeChoreographed,
        withChoreographedRender: withChoreographedRender,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $TLRFC.PopoverProvider), {
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $35rMO.PopoverTarget), {
                    children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {})
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $8xjQm.PopoverContent), {
                    offset: rest.offset,
                    dismiss: dismiss,
                    placement: placement,
                    isVisible: isVisible,
                    children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $9Cyj3.SpotlightCard), {
                        children: [
                            /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jZ2NQ.SpotlightHeader), {
                                children: [
                                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $4iMK3.SpotlightHeadline), {
                                        children: heading
                                    }),
                                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $3NMdW.SpotlightControls), {
                                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $e9bDS.SpotlightDismissControl), {
                                            onClick: dismiss
                                        })
                                    })
                                ]
                            }),
                            rest.image && /*#__PURE__*/ (0, $5chsV.jsx)((0, $kpS32.SpotlightMedia), {
                                children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                                    className: (0, $gJ6nT.default)([
                                        $b09f252c94c6d36d$var$styles.imageWrapper
                                    ]),
                                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $gOANe.default), {
                                        src: rest.image,
                                        alt: ""
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $5chsV.jsx)((0, $3Ru3M.SpotlightBody), {
                                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $daZXj.Text), {
                                    children: body
                                })
                            }),
                            /*#__PURE__*/ (0, $5chsV.jsxs)((0, $6k44y.SpotlightFooter), {
                                children: [
                                    rest.actionsBeforeElement && /*#__PURE__*/ (0, $5chsV.jsx)((0, $5SxcE.SpotlightStepCount), {
                                        children: rest.actionsBeforeElement
                                    }),
                                    /*#__PURE__*/ (0, $5chsV.jsxs)((0, $eygIb.SpotlightActions), {
                                        children: [
                                            actions.secondary && /*#__PURE__*/ (0, $5chsV.jsx)((0, $1rHDk.SpotlightSecondaryAction), {
                                                onClick: actions.secondary.onClick,
                                                children: actions.secondary.text
                                            }),
                                            actions.primary && /*#__PURE__*/ (0, $5chsV.jsx)((0, $sAY9X.SpotlightPrimaryAction), {
                                                onClick: actions.primary.onClick,
                                                children: actions.primary.text
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
$b09f252c94c6d36d$export$13e08e0bdd266b1b.displayName = "MigratedSpotlight";

});
parcelRegister("aFiY0", function(module, exports) {
$parcel$export(module.exports, "actions", () => $5a85d5c7e1c5aa86$export$e324594224ef24da);
const $5a85d5c7e1c5aa86$export$e324594224ef24da = (value)=>{
    if (!value || value.length === 0) return {};
    if (value.length === 1) {
        const [primary] = value;
        return {
            primary: primary
        };
    }
    const primary = value.find((action)=>action.ctaType === 'primary');
    const secondary = value.find((action)=>action.ctaType === 'secondary');
    if (primary && secondary) return {
        primary: primary,
        secondary: secondary
    };
    if (primary) {
        // Only primary found, assign the other as secondary
        const other = value.find((action)=>action !== primary);
        return {
            primary: primary,
            secondary: other
        };
    }
    if (secondary) {
        // Only secondary found, assign the other as primary
        const other = value.find((action)=>action !== secondary);
        return {
            primary: other,
            secondary: secondary
        };
    }
    // Neither ctaType is set, assume second is primary, first is secondary
    const [secondaryFallback, primaryFallback] = value;
    return {
        primary: primaryFallback,
        secondary: secondaryFallback
    };
};

});

parcelRegister("4FalA", function(module, exports) {
$parcel$export(module.exports, "children", () => $dc3c94532e9ea124$export$bacb5cc5a11aef16);
const $dc3c94532e9ea124$export$bacb5cc5a11aef16 = (value)=>{
    return value;
};

});

parcelRegister("17w4v", function(module, exports) {
$parcel$export(module.exports, "dialogPlacement", () => $b83fb387dc2fd3fa$export$608d2c28a2f3926e);
const $b83fb387dc2fd3fa$var$placementMap = {
    'top right': 'top-start',
    'top center': 'top-center',
    'top left': 'top-end',
    'right bottom': 'right-start',
    'right middle': 'right-start',
    'right top': 'right-end',
    'bottom left': 'bottom-end',
    'bottom center': 'bottom-center',
    'bottom right': 'bottom-start',
    'left top': 'left-end',
    'left middle': 'left-start',
    'left bottom': 'left-start'
};
const $b83fb387dc2fd3fa$export$608d2c28a2f3926e = (value)=>{
    // `bottom left` is the default placement when `undefined` is passed.
    return $b83fb387dc2fd3fa$var$placementMap[value || 'bottom left'];
};

});

parcelRegister("15bBM", function(module, exports) {
$parcel$export(module.exports, "heading", () => $570494fbe119ce70$export$46e4a324ac90507f);
const $570494fbe119ce70$export$46e4a324ac90507f = (value)=>{
    return value;
};

});

parcelRegister("3taQQ", function(module, exports) {
$parcel$export(module.exports, "target", () => $0ceb371ef3099a67$export$44271b4f0c6a3563);
const $0ceb371ef3099a67$export$44271b4f0c6a3563 = (value)=>{
    if (!value || value.length === 0) return '';
    /**
	 * All of the following are actually invalid in CSS selectors.
	 * It's unlikely that a lot of these are actually used as `Spotlight` `name` prop values.
	 * If it turns out other characters are used, add them as needed.
	 *
	 * (space) — descendant combinator
	 * > — child combinator
	 * + — adjacent sibling combinator
	 * ~ — general sibling combinator
	 * . — class selector
	 * # — ID selector
	 * : — pseudo-class/element
	 * [ ] — attribute selectors
	 * ( ) — functional notation
	 * , — selector list separator
	 * * — universal selector
	 * | — namespace separator
	 * " ' — string delimiters
	 * \ — escape character
	 * Characters not allowed in unescaped identifiers:
	 * Digits 0-9 cannot be the first character
	 * !, @, $, %, ^, &, =, {, }, ;, /, and most other punctuation
	 */ return value.replace(/ /g, '-').replace(/\//g, '-');
};

});

parcelRegister("6MNwg", function(module, exports) {
$parcel$export(module.exports, "useMountToHtmlElement", () => $ccc1ba8df8f28c1b$export$81e9e5f51d0d0a61);

var $fsvuC = parcelRequire("fsvuC");

var $80czl = parcelRequire("80czl");

var $jF8Yw = parcelRequire("jF8Yw");
function $ccc1ba8df8f28c1b$export$81e9e5f51d0d0a61(params) {
    const { as: as = 'portal', selectors: selectors, position: position = 'after', observeRoot: observeRoot, rootDocument: rootDocument } = params ?? {};
    const targetElement = $ccc1ba8df8f28c1b$var$useElement({
        selectors: selectors,
        observeRoot: observeRoot,
        rootDocument: rootDocument
    });
    const renderPortal = $ccc1ba8df8f28c1b$var$usePortalNearElement({
        targetElement: targetElement,
        position: position
    });
    const renderInline = $ccc1ba8df8f28c1b$var$useInlineNearElement({
        targetElement: targetElement,
        position: position
    });
    if (as === 'inline') return renderInline;
    return renderPortal;
}
function $ccc1ba8df8f28c1b$var$useElement({ selectors: selectors, observeRoot: observeRoot, rootDocument: rootDocument }) {
    const knownEls = (0, $fsvuC.useRef)({});
    const [el, setEl] = (0, $fsvuC.useState)();
    (0, $fsvuC.useEffect)(()=>{
        const doc = rootDocument ?? (0, $jF8Yw.getDocument)();
        if (!doc || !selectors) {
            setEl(undefined);
            return;
        }
        if (knownEls.current[selectors] !== undefined) {
            setEl(knownEls.current[selectors]);
            return;
        }
        const element = doc.querySelector(selectors) ?? undefined;
        knownEls.current[selectors] = element;
        setEl(element);
        if (observeRoot) {
            const observer = new MutationObserver(()=>{
                const foundElement = doc.querySelector(selectors);
                if (foundElement) {
                    setEl(foundElement);
                    observer.disconnect();
                }
            });
            observer.observe(observeRoot, {
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        selectors,
        observeRoot,
        rootDocument
    ]);
    return el;
}
function $ccc1ba8df8f28c1b$var$usePortalNearElement({ targetElement: targetElement, position: position }) {
    const [portalContainer, setPortalContainer] = (0, $fsvuC.useState)(null);
    (0, $fsvuC.useEffect)(()=>{
        if (!(0, $jF8Yw.getDocument)() || !targetElement) {
            setPortalContainer(null);
            return;
        }
        const container = targetElement.ownerDocument.createElement('div');
        container.style.position = 'absolute';
        if (position === 'after') targetElement.parentNode?.insertBefore(container, targetElement.nextSibling);
        else if (position === 'before') targetElement.parentNode?.insertBefore(container, targetElement);
        else targetElement.appendChild(container);
        setPortalContainer(container);
        return ()=>container.remove();
    }, [
        targetElement,
        position
    ]);
    return (children)=>portalContainer ? (0, $80czl.createPortal)(children, portalContainer) : null;
}
function $ccc1ba8df8f28c1b$var$useInlineNearElement({ targetElement: targetElement, position: position }) {
    const [inlineContainer, setInlineContainer] = (0, $fsvuC.useState)(null);
    (0, $fsvuC.useEffect)(()=>{
        if (!(0, $jF8Yw.getDocument)() || !targetElement) {
            setInlineContainer(null);
            return;
        }
        const container = targetElement.ownerDocument.createElement('div');
        if (position === 'after') targetElement.parentNode?.insertBefore(container, targetElement.nextSibling);
        else if (position === 'before') targetElement.parentNode?.insertBefore(container, targetElement);
        else targetElement.appendChild(container);
        setInlineContainer(container);
        return ()=>container.remove();
    }, [
        targetElement,
        position
    ]);
    return (children)=>inlineContainer ? (0, $80czl.createPortal)(children, inlineContainer) : null;
}

});


parcelRegister("20YcX", function(module, exports) {
$parcel$export(module.exports, "SpotlightTarget", () => $fcdff86e6ed12845$export$e29577842f211e22);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $a5Zx6 = parcelRequire("a5Zx6");

var $llCao = parcelRequire("llCao");

var $3taQQ = parcelRequire("3taQQ");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $fcdff86e6ed12845$export$e29577842f211e22 = ({ children: children, name: name })=>{
    const id = (0, $3taQQ.target)(name);
    if ((0, $llCao.fg)('post-office_enable_ads_spotlight_migration')) return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        id: id,
        children: children
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $a5Zx6.default), {
        name: name,
        children: children
    });
};
$fcdff86e6ed12845$export$e29577842f211e22.displayName = "SpotlightTarget";
$fcdff86e6ed12845$export$e29577842f211e22.displayName = 'SpotlightTarget';

});


parcelRegister("csHaM", function(module, exports) {
$parcel$export(module.exports, "SpotlightCard", () => $fb9f1cfb9eb944f5$export$14710e13fc01d383);
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package

var $d3HMC = parcelRequire("d3HMC");

var $dtMAb = parcelRequire("dtMAb");
const $fb9f1cfb9eb944f5$export$14710e13fc01d383 = (0, $dtMAb.wrapComponentForChoreographer)((0, $d3HMC.default));

});


parcelRegister("kyAKM", function(module, exports) {
$parcel$export(module.exports, "useFocusScope", () => (parcelRequire("iGacE")).useFocusScope);
$parcel$export(module.exports, "default", () => $ef737e15e0aa2ae9$export$2e2bcd8739ae039);

var $dbm6y = parcelRequire("dbm6y");
parcelRequire("iGacE");
var $ef737e15e0aa2ae9$export$2e2bcd8739ae039 = (0, $dbm6y.default);

});
parcelRegister("dbm6y", function(module, exports) {
$parcel$export(module.exports, "default", () => $998d72fb3ec805a8$export$2e2bcd8739ae039);

var $5j9Yb = parcelRequire("5j9Yb");

var $9wuDe = parcelRequire("9wuDe");

var $fsvuC = parcelRequire("fsvuC");

var $858iz = parcelRequire("858iz");

var $4yO8R = parcelRequire("4yO8R");
var $998d72fb3ec805a8$var$FocusLockCombination = /*#__PURE__*/ $fsvuC.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $fsvuC.createElement((0, $858iz.default), (0, $9wuDe.default)({
        sideCar: (0, $4yO8R.default),
        ref: ref
    }, props));
});
var $998d72fb3ec805a8$var$_ref = (0, $858iz.default).propTypes || {}, $998d72fb3ec805a8$var$sideCar = $998d72fb3ec805a8$var$_ref.sideCar, $998d72fb3ec805a8$var$propTypes = (0, $5j9Yb.default)($998d72fb3ec805a8$var$_ref, [
    "sideCar"
]);
$998d72fb3ec805a8$var$FocusLockCombination.propTypes = {};
var $998d72fb3ec805a8$export$2e2bcd8739ae039 = $998d72fb3ec805a8$var$FocusLockCombination;

});
parcelRegister("858iz", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e253a45a30a3046$export$2e2bcd8739ae039);

var $9wuDe = parcelRequire("9wuDe");

var $fsvuC = parcelRequire("fsvuC");


var $fRUrj = parcelRequire("fRUrj");

var $8V6dQ = parcelRequire("8V6dQ");

var $c1i1L = parcelRequire("c1i1L");

var $eCSaH = parcelRequire("eCSaH");

var $5G5xt = parcelRequire("5G5xt");
var $5e253a45a30a3046$var$emptyArray = [];
var $5e253a45a30a3046$var$FocusLock = /*#__PURE__*/ $fsvuC.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $fsvuC.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $fsvuC.useRef();
    var isActive = $fsvuC.useRef(false);
    var originalFocusedElement = $fsvuC.useRef(null);
    var _React$useState2 = $fsvuC.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $5e253a45a30a3046$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $fsvuC.useState({}), id = _React$useState3[0];
    var onActivation = $fsvuC.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $fsvuC.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $fsvuC.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $fsvuC.useCallback(function(event) {
        if (isActive.current) (0, $eCSaH.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $eCSaH.mediumBlur).useMedium;
    var setObserveNode = $fsvuC.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $9wuDe.default)((_extends2 = {}, _extends2[$fRUrj.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$fRUrj.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $8V6dQ.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $fsvuC.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $fsvuC.createElement($fsvuC.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $fsvuC.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $c1i1L.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $fsvuC.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $c1i1L.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $fsvuC.createElement(SideCar, {
        id: id,
        sideCar: (0, $eCSaH.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $fsvuC.createElement(Container, (0, $9wuDe.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $fsvuC.createElement((0, $5G5xt.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $fsvuC.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $c1i1L.hiddenGuard)
    }));
});
$5e253a45a30a3046$var$FocusLock.propTypes = {};
var $5e253a45a30a3046$export$2e2bcd8739ae039 = $5e253a45a30a3046$var$FocusLock;

});
parcelRegister("fRUrj", function(module, exports) {
$parcel$export(module.exports, "FOCUS_GROUP", () => $b8d795fb0aead817$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $b8d795fb0aead817$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $b8d795fb0aead817$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $b8d795fb0aead817$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $b8d795fb0aead817$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $b8d795fb0aead817$export$4f9a06cb7441a087 = 'data-focus-lock';
var $b8d795fb0aead817$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $b8d795fb0aead817$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $b8d795fb0aead817$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $b8d795fb0aead817$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("8V6dQ", function(module, exports) {
$parcel$export(module.exports, "useMergeRefs", () => $67e87933b2539865$export$74665b213cb5c4cf);

var $fsvuC = parcelRequire("fsvuC");

var $hPdF1 = parcelRequire("hPdF1");

var $jz55c = parcelRequire("jz55c");
var $67e87933b2539865$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $fsvuC.useLayoutEffect : $fsvuC.useEffect;
var $67e87933b2539865$var$currentValues = new WeakMap();
function $67e87933b2539865$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $jz55c.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $hPdF1.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $67e87933b2539865$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $67e87933b2539865$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $hPdF1.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $hPdF1.assignRef)(ref, current_1);
            });
        }
        $67e87933b2539865$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("hPdF1", function(module, exports) {
$parcel$export(module.exports, "assignRef", () => $cfa1cbcc6821c0cb$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $cfa1cbcc6821c0cb$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("jz55c", function(module, exports) {
$parcel$export(module.exports, "useCallbackRef", () => $03acfcd0cf080145$export$25bec8c6f54ee79a);

var $fsvuC = parcelRequire("fsvuC");
function $03acfcd0cf080145$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $fsvuC.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("c1i1L", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", () => $8c038fec706a7c82$export$b8c7b07253306600);

var $fsvuC = parcelRequire("fsvuC");

var $8c038fec706a7c82$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $8c038fec706a7c82$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $fsvuC.createElement($fsvuC.Fragment, null, /*#__PURE__*/ $fsvuC.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $8c038fec706a7c82$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $fsvuC.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $8c038fec706a7c82$export$b8c7b07253306600
    }));
};
$8c038fec706a7c82$var$InFocusGuard.propTypes = {};
var $8c038fec706a7c82$export$2e2bcd8739ae039 = $8c038fec706a7c82$var$InFocusGuard;

});

parcelRegister("eCSaH", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", () => $aa5ea2ab4d29c5ed$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $aa5ea2ab4d29c5ed$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $aa5ea2ab4d29c5ed$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $aa5ea2ab4d29c5ed$export$892cbf28e5518020);

var $Dam4U = parcelRequire("Dam4U");
var $aa5ea2ab4d29c5ed$export$5733e022b1d538cb = (0, $Dam4U.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $aa5ea2ab4d29c5ed$export$b3e9a9312f73723c = (0, $Dam4U.createMedium)();
var $aa5ea2ab4d29c5ed$export$3a1d52767cbc07b8 = (0, $Dam4U.createMedium)();
var $aa5ea2ab4d29c5ed$export$892cbf28e5518020 = (0, $Dam4U.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("Dam4U", function(module, exports) {
$parcel$export(module.exports, "createMedium", () => $075bacf0a32aefd2$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $075bacf0a32aefd2$export$e13ec7dd7a14088d);

var $d5gve = parcelRequire("d5gve");
function $075bacf0a32aefd2$var$ItoI(a) {
    return a;
}
function $075bacf0a32aefd2$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $075bacf0a32aefd2$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $075bacf0a32aefd2$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $075bacf0a32aefd2$var$ItoI;
    return $075bacf0a32aefd2$var$innerCreateMedium(defaults, middleware);
}
function $075bacf0a32aefd2$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $075bacf0a32aefd2$var$innerCreateMedium(null);
    medium.options = (0, $d5gve.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});


parcelRegister("5G5xt", function(module, exports) {
$parcel$export(module.exports, "focusScope", () => $42252be1b1df4410$export$f5272e9b1168239c);

var $fsvuC = parcelRequire("fsvuC");
var $42252be1b1df4410$export$f5272e9b1168239c = /*#__PURE__*/ (0, $fsvuC.createContext)(undefined);

});


parcelRegister("4yO8R", function(module, exports) {
$parcel$export(module.exports, "default", () => $35213b881232b066$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");


var $fQmx1 = parcelRequire("fQmx1");

var $baqh9 = parcelRequire("baqh9");
var $kgzKu = parcelRequire("kgzKu");
var $4cdUI = parcelRequire("4cdUI");
var $6mu3f = parcelRequire("6mu3f");
var $eUyeu = parcelRequire("eUyeu");parcelRequire("aQUtT");
var $d6PJl = parcelRequire("d6PJl");

var $g2UV8 = parcelRequire("g2UV8");

var $eCSaH = parcelRequire("eCSaH");
var $35213b881232b066$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $35213b881232b066$var$isFreeFocus = function isFreeFocus() {
    return $35213b881232b066$var$focusOnBody() || (0, $eUyeu.focusIsHidden)();
};
var $35213b881232b066$var$lastActiveTrap = null;
var $35213b881232b066$var$lastActiveFocus = null;
var $35213b881232b066$var$lastPortaledElement = null;
var $35213b881232b066$var$focusWasOutsideWindow = false;
var $35213b881232b066$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $35213b881232b066$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($35213b881232b066$var$lastActiveTrap.whiteList || $35213b881232b066$var$defaultWhitelist)(activeElement);
};
var $35213b881232b066$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $35213b881232b066$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $35213b881232b066$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $35213b881232b066$var$lastPortaledElement && $35213b881232b066$var$lastPortaledElement.portaledElement === element;
};
function $35213b881232b066$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $35213b881232b066$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($35213b881232b066$var$focusWasOutsideWindow);
    return $35213b881232b066$var$focusWasOutsideWindow === 'meanwhile';
};
var $35213b881232b066$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $35213b881232b066$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $35213b881232b066$var$checkInHost(activeElement, area, area);
    });
};
var $35213b881232b066$var$activateTrap = function activateTrap() {
    var result = false;
    if ($35213b881232b066$var$lastActiveTrap) {
        var _lastActiveTrap = $35213b881232b066$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $35213b881232b066$var$lastPortaledElement && $35213b881232b066$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $g2UV8.extractRef)).filter(Boolean));
            if (!activeElement || $35213b881232b066$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $35213b881232b066$var$focusWasOutside(crossFrame) || !$35213b881232b066$var$isFreeFocus() || !$35213b881232b066$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $6mu3f.focusInside)(workingArea) || activeElement && $35213b881232b066$var$withinHost(activeElement, workingArea) || $35213b881232b066$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$35213b881232b066$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $d6PJl.moveFocusInside)(workingArea, $35213b881232b066$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $35213b881232b066$var$lastPortaledElement = {};
                        }
                    }
                    $35213b881232b066$var$focusWasOutsideWindow = false;
                    $35213b881232b066$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $kgzKu.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $35213b881232b066$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $35213b881232b066$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $35213b881232b066$var$onTrap = function onTrap(event) {
    if ($35213b881232b066$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $35213b881232b066$var$onBlur = function onBlur() {
    return (0, $g2UV8.deferAction)($35213b881232b066$var$activateTrap);
};
var $35213b881232b066$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $35213b881232b066$var$recordPortal(currentNode, source);
};
var $35213b881232b066$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $35213b881232b066$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $fsvuC.createElement("div", {
        onBlur: $35213b881232b066$var$onBlur,
        onFocus: $35213b881232b066$var$onFocus
    }, children);
};
$35213b881232b066$var$FocusTrap.propTypes = {};
var $35213b881232b066$var$onWindowBlur = function onWindowBlur() {
    $35213b881232b066$var$focusWasOutsideWindow = 'just';
    (0, $g2UV8.deferAction)(function() {
        $35213b881232b066$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $35213b881232b066$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $35213b881232b066$var$onTrap);
    document.addEventListener('focusout', $35213b881232b066$var$onBlur);
    window.addEventListener('blur', $35213b881232b066$var$onWindowBlur);
};
var $35213b881232b066$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $35213b881232b066$var$onTrap);
    document.removeEventListener('focusout', $35213b881232b066$var$onBlur);
    window.removeEventListener('blur', $35213b881232b066$var$onWindowBlur);
};
function $35213b881232b066$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $35213b881232b066$var$focusLockAPI = {
    moveFocusInside: (0, $d6PJl.moveFocusInside),
    focusInside: (0, $6mu3f.focusInside),
    focusNextElement: (0, $4cdUI.focusNextElement),
    focusPrevElement: (0, $4cdUI.focusPrevElement),
    focusFirstElement: (0, $4cdUI.focusFirstElement),
    focusLastElement: (0, $4cdUI.focusLastElement),
    captureFocusRestore: (0, $baqh9.captureFocusRestore)
};
function $35213b881232b066$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$35213b881232b066$var$lastActiveTrap) $35213b881232b066$var$attachHandler();
    var lastTrap = $35213b881232b066$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $35213b881232b066$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $35213b881232b066$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($35213b881232b066$var$focusLockAPI);
        $35213b881232b066$var$activateTrap(true);
        (0, $g2UV8.deferAction)($35213b881232b066$var$activateTrap);
    } else {
        $35213b881232b066$var$detachHandler();
        $35213b881232b066$var$lastActiveFocus = null;
    }
}
(0, $eCSaH.mediumFocus).assignSyncMedium($35213b881232b066$var$onFocus);
(0, $eCSaH.mediumBlur).assignMedium($35213b881232b066$var$onBlur);
(0, $eCSaH.mediumEffect).assignMedium(function(cb) {
    return cb($35213b881232b066$var$focusLockAPI);
});
var $35213b881232b066$export$2e2bcd8739ae039 = (0, $fQmx1.default)($35213b881232b066$var$reducePropsToState, $35213b881232b066$var$handleStateChangeOnClient)($35213b881232b066$var$FocusWatcher);

});
parcelRegister("fQmx1", function(module, exports) {
$parcel$export(module.exports, "default", () => $b88d30aa87af3d9f$export$2e2bcd8739ae039);

var $12oQk = parcelRequire("12oQk");

var $6K52q = parcelRequire("6K52q");

var $fsvuC = parcelRequire("fsvuC");
function $b88d30aa87af3d9f$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $12oQk.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $fsvuC.PureComponent));
        (0, $6K52q.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $b88d30aa87af3d9f$export$2e2bcd8739ae039 = $b88d30aa87af3d9f$var$withSideEffect;

});

parcelRegister("baqh9", function(module, exports) {
$parcel$export(module.exports, "captureFocusRestore", () => $821502aa0d3c27e7$export$d357db6e554ff59a);

var $6EA7L = parcelRequire("6EA7L");
function $821502aa0d3c27e7$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $821502aa0d3c27e7$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $821502aa0d3c27e7$var$weakRef(currentElement),
            parent: $821502aa0d3c27e7$var$weakRef(currentElement.parentElement),
            left: $821502aa0d3c27e7$var$weakRef(currentElement.previousElementSibling),
            right: $821502aa0d3c27e7$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $821502aa0d3c27e7$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $821502aa0d3c27e7$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $6EA7L.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $821502aa0d3c27e7$export$d357db6e554ff59a = function(targetElement) {
    var location = $821502aa0d3c27e7$export$5061a7725be48ff9(targetElement);
    return function() {
        return $821502aa0d3c27e7$var$restoreFocusTo(location);
    };
};

});
parcelRegister("6EA7L", function(module, exports) {
$parcel$export(module.exports, "filterAutoFocusable", () => $4d828008c3906873$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $4d828008c3906873$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $4d828008c3906873$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $4d828008c3906873$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $4d828008c3906873$export$2344b14b097df817);

var $bk9In = parcelRequire("bk9In");

var $fJLi8 = parcelRequire("fJLi8");

var $8AvOR = parcelRequire("8AvOR");

var $k74LZ = parcelRequire("k74LZ");
var $4d828008c3906873$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $bk9In.toArray)(nodes).filter(function(node) {
        return (0, $fJLi8.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $fJLi8.notHiddenInput)(node);
    });
};
var $4d828008c3906873$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $bk9In.toArray)(nodes).filter(function(node) {
        return (0, $fJLi8.isAutoFocusAllowedCached)(cache, node);
    });
};
var $4d828008c3906873$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $8AvOR.orderByTabIndex)($4d828008c3906873$export$6266a5cd5915dc33((0, $k74LZ.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $4d828008c3906873$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $8AvOR.orderByTabIndex)($4d828008c3906873$export$6266a5cd5915dc33((0, $k74LZ.getFocusables)(topNodes), visibilityCache), false);
};
var $4d828008c3906873$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $4d828008c3906873$export$6266a5cd5915dc33((0, $k74LZ.getParentAutofocusables)(topNode), visibilityCache);
};
var $4d828008c3906873$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $4d828008c3906873$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $bk9In.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $4d828008c3906873$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $4d828008c3906873$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("bk9In", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $83e9191c53589506$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $83e9191c53589506$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $83e9191c53589506$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $83e9191c53589506$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $83e9191c53589506$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $83e9191c53589506$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("fJLi8", function(module, exports) {
$parcel$export(module.exports, "isVisibleCached", () => $b74fbe1ad547b6a5$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $b74fbe1ad547b6a5$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $b74fbe1ad547b6a5$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $b74fbe1ad547b6a5$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $b74fbe1ad547b6a5$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $b74fbe1ad547b6a5$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $b74fbe1ad547b6a5$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $b74fbe1ad547b6a5$export$4e62c701997796c1);

var $fRUrj = parcelRequire("fRUrj");
var $b74fbe1ad547b6a5$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $b74fbe1ad547b6a5$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $b74fbe1ad547b6a5$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $b74fbe1ad547b6a5$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $b74fbe1ad547b6a5$var$isVisibleUncached = function(node, checkParent) {
    return !node || $b74fbe1ad547b6a5$var$isTopNode(node) || !$b74fbe1ad547b6a5$var$isElementHidden(node) && !$b74fbe1ad547b6a5$var$isInert(node) && checkParent($b74fbe1ad547b6a5$var$getParentNode(node));
};
var $b74fbe1ad547b6a5$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $b74fbe1ad547b6a5$var$isVisibleUncached(node, $b74fbe1ad547b6a5$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $b74fbe1ad547b6a5$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$b74fbe1ad547b6a5$var$isTopNode(node) ? $b74fbe1ad547b6a5$export$b8550e27de209d85(node) ? checkParent($b74fbe1ad547b6a5$var$getParentNode(node)) : false : true;
};
var $b74fbe1ad547b6a5$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $b74fbe1ad547b6a5$var$isAutoFocusAllowedUncached(node, $b74fbe1ad547b6a5$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $b74fbe1ad547b6a5$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $b74fbe1ad547b6a5$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $b74fbe1ad547b6a5$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $b74fbe1ad547b6a5$export$9d74f6fbc6f469d0 = function(node) {
    return $b74fbe1ad547b6a5$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $b74fbe1ad547b6a5$export$8197b0ea56b3b055 = function(node) {
    return !(($b74fbe1ad547b6a5$export$88a6ceeed5737ba3(node) || $b74fbe1ad547b6a5$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $b74fbe1ad547b6a5$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $fRUrj.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $b74fbe1ad547b6a5$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $b74fbe1ad547b6a5$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $b74fbe1ad547b6a5$export$602e5a0d338d7750 = function(node) {
    return !$b74fbe1ad547b6a5$export$d94b8b58ec2f30eb(node);
};
var $b74fbe1ad547b6a5$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("8AvOR", function(module, exports) {
$parcel$export(module.exports, "orderByTabIndex", () => $640a5e2aa3b72757$export$cb40ee071f0d5226);

var $bk9In = parcelRequire("bk9In");
var $640a5e2aa3b72757$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $640a5e2aa3b72757$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $640a5e2aa3b72757$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $bk9In.toArray)(nodes).map(function(node, index) {
        var tabIndex = $640a5e2aa3b72757$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($640a5e2aa3b72757$export$350ee6c095d98996);
};

});

parcelRegister("k74LZ", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $ea4829e7e7ceebfd$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $ea4829e7e7ceebfd$export$853fa94d922e78b9);

var $fRUrj = parcelRequire("fRUrj");

var $bk9In = parcelRequire("bk9In");

var $h1XZ5 = parcelRequire("h1XZ5");
var $ea4829e7e7ceebfd$var$queryTabbables = (0, $h1XZ5.tabbables).join(',');
var $ea4829e7e7ceebfd$var$queryGuardTabbables = "".concat($ea4829e7e7ceebfd$var$queryTabbables, ", [data-focus-guard]");
var $ea4829e7e7ceebfd$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $bk9In.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $ea4829e7e7ceebfd$var$queryGuardTabbables : $ea4829e7e7ceebfd$var$queryTabbables) ? [
            child
        ] : [], $ea4829e7e7ceebfd$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $ea4829e7e7ceebfd$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $ea4829e7e7ceebfd$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $ea4829e7e7ceebfd$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $ea4829e7e7ceebfd$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $ea4829e7e7ceebfd$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $bk9In.toArray)(parent.parentNode.querySelectorAll($ea4829e7e7ceebfd$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $ea4829e7e7ceebfd$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $fRUrj.FOCUS_AUTO), "]"));
    return (0, $bk9In.toArray)(parentFocus).map(function(node) {
        return $ea4829e7e7ceebfd$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("h1XZ5", function(module, exports) {
$parcel$export(module.exports, "tabbables", () => $c6610f459a6d32a6$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $c6610f459a6d32a6$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("kgzKu", function(module, exports) {
$parcel$export(module.exports, "expandFocusableNodes", () => $ec110840f6d29952$export$f89ac71e91767111);

var $7PWlA = parcelRequire("7PWlA");

var $fJLi8 = parcelRequire("fJLi8");

var $2s2Ff = parcelRequire("2s2Ff");

var $8AvOR = parcelRequire("8AvOR");

var $k74LZ = parcelRequire("k74LZ");
var $ec110840f6d29952$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $7PWlA.getAllAffectedNodes)(topNode).filter((0, $fJLi8.isNotAGuard));
    var commonParent = (0, $2s2Ff.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $8AvOR.orderByTabIndex)((0, $k74LZ.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $k74LZ.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $fJLi8.isGuard)(node)
        };
    });
};

});
parcelRegister("7PWlA", function(module, exports) {
$parcel$export(module.exports, "getAllAffectedNodes", () => $5b4a8e5a80752f42$export$7e87c4720b9b279b);

var $fRUrj = parcelRequire("fRUrj");

var $bk9In = parcelRequire("bk9In");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $5b4a8e5a80752f42$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $5b4a8e5a80752f42$var$getTopParent = function(node) {
    return node.parentNode ? $5b4a8e5a80752f42$var$getTopParent(node.parentNode) : node;
};
var $5b4a8e5a80752f42$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $bk9In.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $fRUrj.FOCUS_GROUP));
        acc.push.apply(acc, group ? $5b4a8e5a80752f42$var$filterNested((0, $bk9In.toArray)($5b4a8e5a80752f42$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $fRUrj.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $fRUrj.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("2s2Ff", function(module, exports) {
$parcel$export(module.exports, "getTopCommonParent", () => $1c90435fb357bf1d$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $1c90435fb357bf1d$export$8f99714c70a37db1);

var $6EA7L = parcelRequire("6EA7L");

var $bk9In = parcelRequire("bk9In");
var $1c90435fb357bf1d$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $1c90435fb357bf1d$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $1c90435fb357bf1d$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $1c90435fb357bf1d$var$getParents(nodeA);
    var parentsB = $1c90435fb357bf1d$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $1c90435fb357bf1d$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $bk9In.asArray)(baseActiveElement);
    var leftEntries = (0, $bk9In.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $1c90435fb357bf1d$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $1c90435fb357bf1d$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $6EA7L.contains)(common, topCommon)) topCommon = common;
                else topCommon = $1c90435fb357bf1d$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $1c90435fb357bf1d$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $6EA7L.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("4cdUI", function(module, exports) {
$parcel$export(module.exports, "focusNextElement", () => $30e313693ceabd4e$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $30e313693ceabd4e$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $30e313693ceabd4e$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $30e313693ceabd4e$export$6a79073ddabfd6c3);

var $dm6dG = parcelRequire("dm6dG");

var $6EA7L = parcelRequire("6EA7L");

var $bk9In = parcelRequire("bk9In");
var $30e313693ceabd4e$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $bk9In.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $6EA7L.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $6EA7L.getTabbableNodes)(shards, new Map()) : (0, $6EA7L.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $30e313693ceabd4e$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $6EA7L.getTabbableNodes)((0, $bk9In.asArray)(shards), new Map()) : (0, $6EA7L.getFocusableNodes)((0, $bk9In.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $30e313693ceabd4e$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $30e313693ceabd4e$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $30e313693ceabd4e$var$defaultOptions(options);
    var solution = $30e313693ceabd4e$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $dm6dG.focusOn)(target.node, newOptions.focusOptions);
};
var $30e313693ceabd4e$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $30e313693ceabd4e$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $30e313693ceabd4e$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $30e313693ceabd4e$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $30e313693ceabd4e$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $30e313693ceabd4e$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $dm6dG.focusOn)(node.node, options.focusOptions);
};
var $30e313693ceabd4e$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $30e313693ceabd4e$var$pickBoundary(scope, options, 'first');
};
var $30e313693ceabd4e$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $30e313693ceabd4e$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("dm6dG", function(module, exports) {
$parcel$export(module.exports, "focusOn", () => $9b92278f4cc3493b$export$c12b3da842c43a8);
var $9b92278f4cc3493b$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("6mu3f", function(module, exports) {
$parcel$export(module.exports, "focusInside", () => $4a1c1bb687b58df6$export$20115f8da7baa6fa);

var $6EA7L = parcelRequire("6EA7L");

var $7PWlA = parcelRequire("7PWlA");

var $bk9In = parcelRequire("bk9In");

var $852YM = parcelRequire("852YM");
var $4a1c1bb687b58df6$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $4a1c1bb687b58df6$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $bk9In.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $4a1c1bb687b58df6$var$focusInFrame(node, activeElement);
    }));
};
var $4a1c1bb687b58df6$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $852YM.getActiveElement)((0, $bk9In.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $7PWlA.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $6EA7L.contains)(node, activeElement) || $4a1c1bb687b58df6$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("852YM", function(module, exports) {
$parcel$export(module.exports, "getActiveElement", () => $5e2119fc91fa5f6d$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $hSd34 = parcelRequire("hSd34");
var $5e2119fc91fa5f6d$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $5e2119fc91fa5f6d$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $hSd34.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $5e2119fc91fa5f6d$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("hSd34", function(module, exports) {
$parcel$export(module.exports, "safeProbe", () => $d03199fe9220d144$export$78d20aae35adef88);
var $d03199fe9220d144$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("eUyeu", function(module, exports) {
$parcel$export(module.exports, "focusIsHidden", () => $adb0d9908bda4c98$export$be6b21806d3fd485);

var $fRUrj = parcelRequire("fRUrj");

var $6EA7L = parcelRequire("6EA7L");

var $bk9In = parcelRequire("bk9In");

var $852YM = parcelRequire("852YM");
var $adb0d9908bda4c98$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $852YM.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $bk9In.toArray)(inDocument.querySelectorAll("[".concat((0, $fRUrj.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $6EA7L.contains)(node, activeElement);
    });
};

});

parcelRegister("aQUtT", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("d6PJl")).moveFocusInside);

var $fRUrj = parcelRequire("fRUrj");

var $6mu3f = parcelRequire("6mu3f");

var $eUyeu = parcelRequire("eUyeu");


var $kgzKu = parcelRequire("kgzKu");

var $d6PJl = parcelRequire("d6PJl");

var $baqh9 = parcelRequire("baqh9");

var $4cdUI = parcelRequire("4cdUI");

var $6EA7L = parcelRequire("6EA7L");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $7e6a92b20bac994c$export$1a988e7317c65621 = $fRUrj;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $7e6a92b20bac994c$var$deprecated_default_moveFocusInside = (0, $d6PJl.moveFocusInside);
var $7e6a92b20bac994c$export$2e2bcd8739ae039 //
 = $7e6a92b20bac994c$var$deprecated_default_moveFocusInside;

});
parcelRegister("d6PJl", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => $027683f9bfec1dae$export$cd599851e879a025);

var $dm6dG = parcelRequire("dm6dG");

var $2mbSD = parcelRequire("2mbSD");
var $027683f9bfec1dae$var$guardCount = 0;
var $027683f9bfec1dae$var$lockDisabled = false;
var $027683f9bfec1dae$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $2mbSD.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($027683f9bfec1dae$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($027683f9bfec1dae$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $027683f9bfec1dae$var$lockDisabled = true;
            setTimeout(function() {
                $027683f9bfec1dae$var$lockDisabled = false;
            }, 1);
            return;
        }
        $027683f9bfec1dae$var$guardCount++;
        (0, $dm6dG.focusOn)(focusable.node, options.focusOptions);
        $027683f9bfec1dae$var$guardCount--;
    }
};

});
parcelRegister("2mbSD", function(module, exports) {
$parcel$export(module.exports, "focusSolver", () => $1b76da01ebb86c67$export$305758c744b57f6f);

var $14kXx = parcelRequire("14kXx");

var $6EA7L = parcelRequire("6EA7L");

var $7PWlA = parcelRequire("7PWlA");

var $bk9In = parcelRequire("bk9In");

var $ho3RN = parcelRequire("ho3RN");

var $852YM = parcelRequire("852YM");

var $fJLi8 = parcelRequire("fJLi8");

var $2s2Ff = parcelRequire("2s2Ff");
var $1b76da01ebb86c67$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $fJLi8.isDefined));
};
var $1b76da01ebb86c67$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $852YM.getActiveElement)((0, $bk9In.asArray)(topNode).length > 0 ? document : (0, $bk9In.getFirst)(topNode).ownerDocument);
    var entries = (0, $7PWlA.getAllAffectedNodes)(topNode).filter((0, $fJLi8.isNotAGuard));
    var commonParent = (0, $2s2Ff.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $6EA7L.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $fJLi8.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $6EA7L.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $1b76da01ebb86c67$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $14kXx.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $14kXx.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $ho3RN.pickAutofocus)(anyFocusable, innerTabbable, (0, $2s2Ff.allParentAutofocusables)(entries, visibilityCache)) || (0, $ho3RN.pickAutofocus)(anyFocusable, innerFocusables, (0, $2s2Ff.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("14kXx", function(module, exports) {
$parcel$export(module.exports, "NEW_FOCUS", () => $0c766c43ce81e209$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $0c766c43ce81e209$export$65842178e9bb4205);

var $aBlqk = parcelRequire("aBlqk");

var $cEFLi = parcelRequire("cEFLi");

var $fJLi8 = parcelRequire("fJLi8");
var $0c766c43ce81e209$export$85710b12cf912438 = 'NEW_FOCUS';
var $0c766c43ce81e209$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $fJLi8.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $0c766c43ce81e209$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $0c766c43ce81e209$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $aBlqk.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $cEFLi.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $cEFLi.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("aBlqk", function(module, exports) {
$parcel$export(module.exports, "correctNode", () => $7b7dfa64d2dcc768$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $7b7dfa64d2dcc768$export$4a5a72a7124e45f9);

var $fJLi8 = parcelRequire("fJLi8");
var $7b7dfa64d2dcc768$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $fJLi8.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $7b7dfa64d2dcc768$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $fJLi8.isRadioElement)(node) && node.name) return $7b7dfa64d2dcc768$var$findSelectedRadio(node, nodes);
    return node;
};
var $7b7dfa64d2dcc768$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($7b7dfa64d2dcc768$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("cEFLi", function(module, exports) {
$parcel$export(module.exports, "pickFirstFocus", () => $93699d7c0ea0c1fa$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $93699d7c0ea0c1fa$export$e06728ee87c96122);

var $aBlqk = parcelRequire("aBlqk");
var $93699d7c0ea0c1fa$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $aBlqk.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $93699d7c0ea0c1fa$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $aBlqk.correctNode)(node, nodes));
};

});


parcelRegister("ho3RN", function(module, exports) {
$parcel$export(module.exports, "pickAutofocus", () => $ca87ad616224c4b0$export$cfb742983e257555);

var $6EA7L = parcelRequire("6EA7L");

var $cEFLi = parcelRequire("cEFLi");

var $fJLi8 = parcelRequire("fJLi8");
var $ca87ad616224c4b0$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $fJLi8.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $ca87ad616224c4b0$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $6EA7L.filterAutoFocusable)(nodes.filter($ca87ad616224c4b0$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $cEFLi.pickFirstFocus)(autoFocusable);
    return (0, $cEFLi.pickFirstFocus)((0, $6EA7L.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("g2UV8", function(module, exports) {
$parcel$export(module.exports, "deferAction", () => $bae8fc7e55b0d513$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $bae8fc7e55b0d513$export$c613fed06e332533);
function $bae8fc7e55b0d513$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $bae8fc7e55b0d513$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $bae8fc7e55b0d513$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});



parcelRegister("iGacE", function(module, exports) {
$parcel$export(module.exports, "useFocusScope", () => $d994105a737471bc$export$88b601623c920b1e);

var $9wuDe = parcelRequire("9wuDe");

var $fsvuC = parcelRequire("fsvuC");

var $5G5xt = parcelRequire("5G5xt");

var $eCSaH = parcelRequire("eCSaH");

var $g2UV8 = parcelRequire("g2UV8");
var $d994105a737471bc$var$collapseRefs = function collapseRefs(shards) {
    return shards.map((0, $g2UV8.extractRef)).filter(Boolean);
};
var $d994105a737471bc$var$withMedium = function withMedium(fn) {
    return new Promise(function(resolve) {
        return (0, $eCSaH.mediumEffect).useMedium(function() {
            resolve(fn.apply(void 0, arguments));
        });
    });
};
var $d994105a737471bc$export$66a1a75609d08840 = function useFocusController() {
    for(var _len = arguments.length, shards = new Array(_len), _key = 0; _key < _len; _key++)shards[_key] = arguments[_key];
    if (!shards.length) throw new Error('useFocusController requires at least one target element');
    var ref = (0, $fsvuC.useRef)(shards);
    ref.current = shards;
    return (0, $fsvuC.useMemo)(function() {
        return {
            autoFocus: function autoFocus(focusOptions) {
                if (focusOptions === void 0) focusOptions = {};
                return $d994105a737471bc$var$withMedium(function(car) {
                    return car.moveFocusInside($d994105a737471bc$var$collapseRefs(ref.current), null, focusOptions);
                });
            },
            focusNext: function focusNext(options) {
                return $d994105a737471bc$var$withMedium(function(car) {
                    car.moveFocusInside($d994105a737471bc$var$collapseRefs(ref.current), null);
                    car.focusNextElement(document.activeElement, (0, $9wuDe.default)({
                        scope: $d994105a737471bc$var$collapseRefs(ref.current)
                    }, options));
                });
            },
            focusPrev: function focusPrev(options) {
                return $d994105a737471bc$var$withMedium(function(car) {
                    car.moveFocusInside($d994105a737471bc$var$collapseRefs(ref.current), null);
                    car.focusPrevElement(document.activeElement, (0, $9wuDe.default)({
                        scope: $d994105a737471bc$var$collapseRefs(ref.current)
                    }, options));
                });
            },
            focusFirst: function focusFirst(options) {
                return $d994105a737471bc$var$withMedium(function(car) {
                    car.focusFirstElement($d994105a737471bc$var$collapseRefs(ref.current), options);
                });
            },
            focusLast: function focusLast(options) {
                return $d994105a737471bc$var$withMedium(function(car) {
                    car.focusLastElement($d994105a737471bc$var$collapseRefs(ref.current), options);
                });
            }
        };
    }, []);
};
var $d994105a737471bc$export$88b601623c920b1e = function useFocusScope() {
    var scope = (0, $fsvuC.useContext)((0, $5G5xt.focusScope));
    if (!scope) throw new Error('FocusLock is required to operate with FocusScope');
    return $d994105a737471bc$export$66a1a75609d08840.apply(void 0, [
        scope.observed
    ].concat(scope.shards));
};

});


parcelRegister("121xR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bcPpD = parcelRequire("bcPpD");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $0c072d2a9f1f4f8a$var$_interopRequireDefault($bcPpD).default;
    }
});

var $7GTIk = parcelRequire("7GTIk");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $7GTIk.TouchScrollable;
    }
});
function $0c072d2a9f1f4f8a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("bcPpD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8288b222abd143f4$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $fsvuC = parcelRequire("fsvuC");
var $8288b222abd143f4$var$_react2 = $8288b222abd143f4$var$_interopRequireDefault($fsvuC);

var $lpPPJ = parcelRequire("lpPPJ");

var $7GTIk = parcelRequire("7GTIk");

var $LYdIW = parcelRequire("LYdIW");
var $8288b222abd143f4$var$_withLockSheet2 = $8288b222abd143f4$var$_interopRequireDefault($LYdIW);

var $iHGfi = parcelRequire("iHGfi");
var $8288b222abd143f4$var$_withTouchListeners2 = $8288b222abd143f4$var$_interopRequireDefault($iHGfi);

var $1KxAE = parcelRequire("1KxAE");
function $8288b222abd143f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8288b222abd143f4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8288b222abd143f4$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8288b222abd143f4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $8288b222abd143f4$var$ScrollLock = function(_PureComponent) {
    $8288b222abd143f4$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $8288b222abd143f4$var$_classCallCheck(this, ScrollLock);
        return $8288b222abd143f4$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $8288b222abd143f4$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$lpPPJ.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $8288b222abd143f4$var$_react2.default.createElement($7GTIk.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($fsvuC.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $8288b222abd143f4$var$compose = (0, $1KxAE.pipe)($8288b222abd143f4$var$_withTouchListeners2.default, $8288b222abd143f4$var$_withLockSheet2.default);
var $8288b222abd143f4$var$SheetLock = $8288b222abd143f4$var$compose($8288b222abd143f4$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $8288b222abd143f4$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $8288b222abd143f4$var$_react2.default.createElement($8288b222abd143f4$var$SheetLock, props) : props.children;
};
$8288b222abd143f4$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $8288b222abd143f4$var$LockToggle;

});
parcelRegister("lpPPJ", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("7GTIk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $5997ac4cb4be52df$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5997ac4cb4be52df$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $fsvuC = parcelRequire("fsvuC");

var $lpPPJ = parcelRequire("lpPPJ");

var $1KxAE = parcelRequire("1KxAE");
function $5997ac4cb4be52df$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $5997ac4cb4be52df$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5997ac4cb4be52df$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5997ac4cb4be52df$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5997ac4cb4be52df$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $5997ac4cb4be52df$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $5997ac4cb4be52df$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $5997ac4cb4be52df$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $5997ac4cb4be52df$var$_possibleConstructorReturn(_this, _ret);
    }
    $5997ac4cb4be52df$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$lpPPJ.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $1KxAE.preventInertiaScroll, $1KxAE.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $1KxAE.allowTouchMove, $1KxAE.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$lpPPJ.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $1KxAE.preventInertiaScroll, $1KxAE.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $1KxAE.allowTouchMove, $1KxAE.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $5997ac4cb4be52df$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $fsvuC.cloneElement)(children, $5997ac4cb4be52df$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($fsvuC.PureComponent);

});
parcelRegister("1KxAE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $1464249e9da01fba$var$preventTouchMove;
module.exports.allowTouchMove = $1464249e9da01fba$var$allowTouchMove;
module.exports.preventInertiaScroll = $1464249e9da01fba$var$preventInertiaScroll;
module.exports.isTouchDevice = $1464249e9da01fba$var$isTouchDevice;
module.exports.camelToKebab = $1464249e9da01fba$var$camelToKebab;
module.exports.parse = $1464249e9da01fba$var$parse;
module.exports.getPadding = $1464249e9da01fba$var$getPadding;
module.exports.getWindowHeight = $1464249e9da01fba$var$getWindowHeight;
module.exports.getDocumentHeight = $1464249e9da01fba$var$getDocumentHeight;
module.exports.makeStyleTag = $1464249e9da01fba$var$makeStyleTag;
module.exports.injectStyles = $1464249e9da01fba$var$injectStyles;
module.exports.insertStyleTag = $1464249e9da01fba$var$insertStyleTag;

var $lpPPJ = parcelRequire("lpPPJ");
var $1464249e9da01fba$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $1464249e9da01fba$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $1464249e9da01fba$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $1464249e9da01fba$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $1464249e9da01fba$var$isTouchDevice() {
    if (!$lpPPJ.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $1464249e9da01fba$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $1464249e9da01fba$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $1464249e9da01fba$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $1464249e9da01fba$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($1464249e9da01fba$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $1464249e9da01fba$var$getPadding() {
    if (!$lpPPJ.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $1464249e9da01fba$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($lpPPJ.canUseDOM) return window.innerHeight * multiplier;
}
function $1464249e9da01fba$var$getDocumentHeight() {
    if ($lpPPJ.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $1464249e9da01fba$var$makeStyleTag() {
    if (!$lpPPJ.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $1464249e9da01fba$var$injectStyles(tag, css) {
    if (!$lpPPJ.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $1464249e9da01fba$var$insertStyleTag(tag) {
    if (!$lpPPJ.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("LYdIW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $09031a68a98bcbfb$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $09031a68a98bcbfb$var$withLockSheet;

var $fsvuC = parcelRequire("fsvuC");
var $09031a68a98bcbfb$var$_react2 = $09031a68a98bcbfb$var$_interopRequireDefault($fsvuC);

var $1KxAE = parcelRequire("1KxAE");
function $09031a68a98bcbfb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $09031a68a98bcbfb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $09031a68a98bcbfb$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $09031a68a98bcbfb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $09031a68a98bcbfb$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $09031a68a98bcbfb$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $09031a68a98bcbfb$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $09031a68a98bcbfb$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $1KxAE.makeStyleTag)();
                if (!sheet) return;
                (0, $1KxAE.injectStyles)(sheet, styles);
                (0, $1KxAE.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $1KxAE.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $1KxAE.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $09031a68a98bcbfb$var$_possibleConstructorReturn(_this, _ret);
        }
        $09031a68a98bcbfb$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet || !this.sheet.parentNode || typeof this.sheet.parentNode.removeChild !== 'function') return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $09031a68a98bcbfb$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($fsvuC.PureComponent);
}

});

parcelRegister("iHGfi", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d9dd033e1c16fea5$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $d9dd033e1c16fea5$var$withTouchListeners;

var $fsvuC = parcelRequire("fsvuC");
var $d9dd033e1c16fea5$var$_react2 = $d9dd033e1c16fea5$var$_interopRequireDefault($fsvuC);

var $lpPPJ = parcelRequire("lpPPJ");

var $1KxAE = parcelRequire("1KxAE");
function $d9dd033e1c16fea5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d9dd033e1c16fea5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d9dd033e1c16fea5$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d9dd033e1c16fea5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $d9dd033e1c16fea5$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $d9dd033e1c16fea5$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $d9dd033e1c16fea5$var$_classCallCheck(this, TouchProvider);
            return $d9dd033e1c16fea5$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $d9dd033e1c16fea5$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$lpPPJ.canUseDOM || !(0, $1KxAE.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $1KxAE.preventTouchMove, $1KxAE.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$lpPPJ.canUseDOM || !(0, $1KxAE.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $1KxAE.preventTouchMove, $1KxAE.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $d9dd033e1c16fea5$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($fsvuC.PureComponent);
}

});



parcelRegister("8wYaX", function(module, exports) {
$parcel$export(module.exports, "combine", () => $150cf2ec65181ba7$export$1be1fc439b849fdf);
function $150cf2ec65181ba7$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});

parcelRegister("iNmwK", function(module, exports) {
$parcel$export(module.exports, "dropTargetForElements", () => $a75672abcd89616b$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $a75672abcd89616b$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $a75672abcd89616b$export$c746a5152d4ba26c);

var $dqdTY = parcelRequire("dqdTY");

var $qhzN7 = parcelRequire("qhzN7");

var $2wdyh = parcelRequire("2wdyh");

var $fX42K = parcelRequire("fX42K");

var $8wYaX = parcelRequire("8wYaX");

var $h1oBm = parcelRequire("h1oBm");

var $gtl0b = parcelRequire("gtl0b");

var $2NcSy = parcelRequire("2NcSy");

var $4ares = parcelRequire("4ares");



const $a75672abcd89616b$var$draggableRegistry = new WeakMap();
function $a75672abcd89616b$var$addToRegistry(args) {
    $a75672abcd89616b$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $a75672abcd89616b$var$draggableRegistry.delete(args.element);
    };
}
const $a75672abcd89616b$var$honeyPotFix = (0, $2wdyh.makeHoneyPotFix)();
const $a75672abcd89616b$var$adapter = (0, $fX42K.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
		 * this adapter always gets preference over the text adapter.
		 * `document` is the first `EventTarget` under `window`
		 * https://twitter.com/alexandereardon/status/1604658588311465985
		 */ return (0, $8wYaX.combine)($a75672abcd89616b$var$honeyPotFix.bindEvents(), (0, $dqdTY.bind)(document, {
            type: 'dragstart',
            listener (event) {
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                const entry = $a75672abcd89616b$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
					 * A text selection drag _can_ have the `draggable` element be
					 * the `event.target` if the user is dragging the text selection
					 * from the `draggable`.
					 *
					 * To know if the `draggable` is being dragged, we look at whether any
					 * `"text/plain"` data is being dragged. If it is, then a text selection
					 * drag is occurring.
					 *
					 * This behaviour has been validated on:
					 *
					 * - Chrome@128 on Android@14
					 * - Chrome@128 on iOS@17.6.1
					 * - Chrome@128 on Windows@11
					 * - Chrome@128 on MacOS@14.6.1
					 * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
					 * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
					 *
					 * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
					 * but unfortunately ProseMirror is always setting `""` as the dragged text
					 *
					 * Note: Unfortunately editor is (heavily) leaning on the current functionality today
					 * and unwinding it will be a decent amount of effort. So for now, a text selection
					 * where the `event.target` is a `draggable` element will still trigger the
					 * element adapter.
					 *
					 * // Future state:
					 * if(event.dataTransfer.getData(textMediaType)) {
					 * 	return;
					 * }
					 *
					 */ const input = (0, $4ares.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $qhzN7.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
					 *  **Goal**
					 *  Pass information to other applications
					 *
					 * **Approach**
					 *  Put data into the native data store
					 *
					 *  **What about the native adapter?**
					 *  When the element adapter puts native data into the native data store
					 *  the native adapter is not triggered in the current window,
					 *  but a native adapter in an external window _can_ be triggered
					 *
					 *  **Why bake this into core?**
					 *  This functionality could be pulled out and exposed inside of
					 *  `onGenerateDragPreview`. But decided to make it a part of the
					 *  base API as it felt like a common enough use case and ended
					 *  up being a similar amount of code to include this function as
					 *  it was to expose the hook for it
					 */ const nativeData = entry.getInitialDataForExternal?.(feedback) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
					 *  📱 For Android devices, a drag operation will not start unless
					 * "text/plain" or "text/uri-list" data exists in the native data store
					 * https://twitter.com/alexandereardon/status/1732189803754713424
					 *
					 * Tested on:
					 * Device: Google Pixel 5
					 * Android version: 14 (November 5, 2023)
					 * Chrome version: 120.0
					 */ if ((0, $2NcSy.isAndroid)() && !event.dataTransfer.types.includes((0, $58ff2e19b0510997$export$fd3d00026297c0ad)) && !event.dataTransfer.types.includes((0, $0ff3806a414665e6$export$4c44a460f123106))) event.dataTransfer.setData((0, $58ff2e19b0510997$export$fd3d00026297c0ad), (0, $2NcSy.androidFallbackText));
                /**
					 * 1. Must set any media type for `iOS15` to work
					 * 2. We are also doing adding data so that the native adapter
					 * can know that the element adapter has handled this drag
					 *
					 * We used to wrap this `setData()` in a `try/catch` for Firefox,
					 * but it looks like that was not needed.
					 *
					 * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
					 *
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
					 * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
					 *
					 * // just checking a few more combinations to be super safe
					 *
					 * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
					 * - ✅ Chrome@78 (Oct 2019) on Windows 10
					 * - ✅ Safari@14.1 on macOS Big Sur
					 */ event.dataTransfer.setData((0, $2e2e8445b88fdb4c$export$c9c4cc54e73b125d), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: entry.getInitialData?.(feedback) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        $a75672abcd89616b$var$draggableRegistry.get(payload.source.element)?.[eventName]?.(// I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $a75672abcd89616b$var$honeyPotFix.getOnPostDispatch()
});
const $a75672abcd89616b$export$e7140b68045b5036 = $a75672abcd89616b$var$adapter.dropTarget;
const $a75672abcd89616b$export$59a074bac4c54f54 = $a75672abcd89616b$var$adapter.monitor;
function $a75672abcd89616b$export$c746a5152d4ba26c(args) {
    const cleanup = (0, $8wYaX.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $a75672abcd89616b$var$adapter.registerUsage(), $a75672abcd89616b$var$addToRegistry(args), (0, $gtl0b.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $h1oBm.once)(cleanup);
}

});
parcelRegister("qhzN7", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $afa0b83d101cc6b5$export$81d0353f25f5dd);

var $3N4E6 = parcelRequire("3N4E6");
function $afa0b83d101cc6b5$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $3N4E6.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("3N4E6", function(module, exports) {
$parcel$export(module.exports, "isHoneyPotElement", () => $8f27b7c60dc4e803$export$821bdcd739a2706b);

function $8f27b7c60dc4e803$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $2beb1c5a9011e8fc$export$6eafea55f7947469));
}

});
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $2beb1c5a9011e8fc$export$6eafea55f7947469 = 'data-pdnd-honey-pot';



parcelRegister("2wdyh", function(module, exports) {
$parcel$export(module.exports, "makeHoneyPotFix", () => $311f331b23b30056$export$8ecad27c959e89e0);

var $dqdTY = parcelRequire("dqdTY");


var $665Vc = parcelRequire("665Vc");

var $97jg3 = parcelRequire("97jg3");

const $311f331b23b30056$var$honeyPotSize = 2;
const $311f331b23b30056$var$halfHoneyPotSize = $311f331b23b30056$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $311f331b23b30056$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $311f331b23b30056$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $311f331b23b30056$var$halfHoneyPotSize,
        y: point.y - $311f331b23b30056$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $311f331b23b30056$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $311f331b23b30056$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $311f331b23b30056$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $311f331b23b30056$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $311f331b23b30056$var$getHoneyPotRectFor({ client: client }) {
    const point = $311f331b23b30056$var$preventGoingForwardsOffScreen($311f331b23b30056$var$preventGoingBackwardsOffScreen($311f331b23b30056$var$pullBackByHalfHoneyPotSize($311f331b23b30056$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $311f331b23b30056$var$honeyPotSize,
        height: $311f331b23b30056$var$honeyPotSize
    });
}
function $311f331b23b30056$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $311f331b23b30056$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $311f331b23b30056$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $2beb1c5a9011e8fc$export$6eafea55f7947469), 'true');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the honey pot is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    if ((0, $97jg3.supportsPopover)()) element.setAttribute('popover', 'manual');
    // can shift during the drag thanks to Firefox
    let clientRect = $311f331b23b30056$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        position: 'fixed',
        ...(0, $97jg3.supportsPopover)() ? // needs to be overridden by our top / left values
        (0, $665Vc.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $f924aeb8b4d03d56$export$7d0a15ee70427305)
        },
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        ...$311f331b23b30056$var$getRectStyles({
            clientRect: clientRect
        })
    });
    document.body.appendChild(element);
    if ((0, $97jg3.supportsPopover)()) element.showPopover();
    /**
	 *  🦊 In firefox we can get `"pointermove"` events after the drag
	 * has started, which is a spec violation.
	 * The final `"pointermove"` will reveal where the "depressed" position
	 * is for our honey pot fix.
	 */ const unbindPointerMove = (0, $dqdTY.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $311f331b23b30056$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $311f331b23b30056$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($311f331b23b30056$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $dqdTY.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $311f331b23b30056$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $dqdTY.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $311f331b23b30056$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                const { input: input } = payload.location.current;
                finish?.({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $f924aeb8b4d03d56$export$7d0a15ee70427305 = 2147483647;

parcelRegister("665Vc", function(module, exports) {
$parcel$export(module.exports, "popoverResetUserAgentStyles", () => $84fc71413d6a8117$export$74004cb910cdc478);
const $84fc71413d6a8117$export$74004cb910cdc478 = {
    inset: 'unset',
    border: 'none',
    padding: 0,
    margin: 0,
    overflow: 'visible',
    color: 'inherit',
    background: 'transparent',
    width: 'auto',
    height: 'auto'
};

});

parcelRegister("97jg3", function(module, exports) {
$parcel$export(module.exports, "supportsPopover", () => $aa828e0b41cdf922$export$1150b66d0ff92823);

var $h1oBm = parcelRequire("h1oBm");
const $aa828e0b41cdf922$export$1150b66d0ff92823 = (0, $h1oBm.once)(function supportsPopover() {
    return typeof HTMLElement !== 'undefined' && typeof HTMLElement.prototype.showPopover === 'function';
});

});
parcelRegister("h1oBm", function(module, exports) {
$parcel$export(module.exports, "once", () => $5662b4a639ad674e$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $5662b4a639ad674e$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});



parcelRegister("fX42K", function(module, exports) {
$parcel$export(module.exports, "makeAdapter", () => $70bbdd2e9318c589$export$2aa3a33160990d96);

var $641PA = parcelRequire("641PA");

var $9X9Ac = parcelRequire("9X9Ac");

var $aUpg2 = parcelRequire("aUpg2");

var $ktojy = parcelRequire("ktojy");
function $70bbdd2e9318c589$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $ktojy.makeMonitor)();
    const dropTargetAPI = (0, $aUpg2.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource?.(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch?.(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $641PA.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $641PA.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $9X9Ac.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("641PA", function(module, exports) {
$parcel$export(module.exports, "lifecycle", () => $304f07de7b6da683$export$3efdceeb8ca25c51);

var $dqdTY = parcelRequire("dqdTY");

var $qhzN7 = parcelRequire("qhzN7");

var $3N4E6 = parcelRequire("3N4E6");

var $kzLxN = parcelRequire("kzLxN");

var $lCmze = parcelRequire("lCmze");

var $4ares = parcelRequire("4ares");

var $j8wAr = parcelRequire("j8wAr");
const $304f07de7b6da683$var$globalState = {
    isActive: false
};
function $304f07de7b6da683$var$canStart() {
    return !$304f07de7b6da683$var$globalState.isActive;
}
function $304f07de7b6da683$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $304f07de7b6da683$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $304f07de7b6da683$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$304f07de7b6da683$var$canStart()) return;
    const initial = $304f07de7b6da683$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $304f07de7b6da683$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $304f07de7b6da683$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $j8wAr.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $304f07de7b6da683$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $4ares.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $3N4E6.isHoneyPotElement)(event.target) ? (0, $qhzN7.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $304f07de7b6da683$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $304f07de7b6da683$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $dqdTY.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $kzLxN.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
					 * At this point we don't know if a drag is being cancelled,
					 * or if a drag is leaving the `window`.
					 *
					 * Both have:
					 *   1. "dragleave" (with `relatedTarget: null`)
					 *   2. "dragend" (a "dragend" can occur when outside the `window`)
					 *
					 * **Clearing drop targets**
					 *
					 * For either case we are clearing the the drop targets
					 *
					 * - cancelling: we clear drop targets in `"dragend"` anyway
					 * - leaving the `window`: we clear the drop targets (to clear stickiness)
					 *
					 * **Leaving the window and finishing the drag**
					 *
					 * _internal drags_
					 *
					 * - The drag continues when the user is outside the `window`
					 *   and can resume if the user drags back over the `window`,
					 *   or end when the user drops in an external `window`.
					 * - We will get a `"dragend"`, or we can listen for other
					 *   events to determine the drag is finished when the user re-enters the `window`).
					 *
					 * _external drags_
					 *
					 * - We conclude the drag operation.
					 * - We have no idea if the user will drag back over the `window`,
					 *   or if the drag ends elsewhere.
					 * - We will create a new drag if the user re-enters the `window`.
					 *
					 * **Not updating `input`**
					 *
					 * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
					 * Workaround: intentionally not updating `input` in "dragleave"
					 * rather than the users current input values
					 * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
					 * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
					 **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $4ares.getInput)(event)
                };
                /** If there are no drop targets, then we will get
					 * a "drop" event if:
					 * - `preventUnhandled()` is being used
					 * - there is an unmanaged drop target (eg another library)
					 * In these cases, it's up to the consumer
					 * to handle the drop if it's not over one of our drop targets
					 * - `preventUnhandled()` will cancel the "drop"
					 * - unmanaged drop targets can handle the "drop" how they want to
					 * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $304f07de7b6da683$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $4ares.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $lCmze.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $304f07de7b6da683$var$getNativeSetDragImage(event)
    });
}
function $304f07de7b6da683$var$setDropEffectOnEvent({ event: event, current: current }) {
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = current[0]?.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $304f07de7b6da683$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $4ares.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $304f07de7b6da683$export$3efdceeb8ca25c51 = {
    canStart: $304f07de7b6da683$var$canStart,
    start: $304f07de7b6da683$var$start
};

});
parcelRegister("kzLxN", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindow", () => $450f216ff3c6fd6a$export$57d220c74e84a273);

var $btCj5 = parcelRequire("btCj5");

var $ah9Nt = parcelRequire("ah9Nt");

var $gFXy4 = parcelRequire("gFXy4");

var $bQHto = parcelRequire("bQHto");
function $450f216ff3c6fd6a$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $ah9Nt.isSafari)()) return (0, $bQHto.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 * (foreign element)
	 */ if ((0, $btCj5.isFirefox)()) return (0, $gFXy4.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is `null` *(standard check)*
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("btCj5", function(module, exports) {
$parcel$export(module.exports, "isFirefox", () => $5374b78be2968fbb$export$b7d78993b74f766d);

var $h1oBm = parcelRequire("h1oBm");
const $5374b78be2968fbb$export$b7d78993b74f766d = (0, $h1oBm.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});

parcelRegister("ah9Nt", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $c0eb20ba4249fd50$export$95df08bae54cb4df);

var $h1oBm = parcelRequire("h1oBm");
const $c0eb20ba4249fd50$export$95df08bae54cb4df = (0, $h1oBm.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("gFXy4", function(module, exports) {
$parcel$export(module.exports, "isFromAnotherWindow", () => $80c3798f829396b1$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $80c3798f829396b1$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $80c3798f829396b1$export$e46810fef53b5b0e(eventTarget) {
    return $80c3798f829396b1$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});

parcelRegister("bQHto", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $0ff2dd253ea993fa$export$f21837c338005454);

var $ah9Nt = parcelRequire("ah9Nt");

var $lhlAT = parcelRequire("lhlAT");
function $0ff2dd253ea993fa$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $ah9Nt.isSafari)()) return false;
    return dragLeave.hasOwnProperty((0, $lhlAT.symbols).isLeavingWindow);
}

});
parcelRegister("lhlAT", function(module, exports) {
$parcel$export(module.exports, "symbols", () => $d4194ac8668b5aa3$export$47616e9f7f5fe113);

var $dqdTY = parcelRequire("dqdTY");

var $ah9Nt = parcelRequire("ah9Nt");
const $d4194ac8668b5aa3$export$47616e9f7f5fe113 = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $ah9Nt.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $dqdTY.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$d4194ac8668b5aa3$export$47616e9f7f5fe113.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$d4194ac8668b5aa3$export$47616e9f7f5fe113.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});



parcelRegister("lCmze", function(module, exports) {
$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $c85f33e07aef07a7$export$ac5e5b0daf997b2);
function $c85f33e07aef07a7$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("4ares", function(module, exports) {
$parcel$export(module.exports, "getInput", () => $af39c5c2b2ff6fd8$export$7c112ceec8941e67);
function $af39c5c2b2ff6fd8$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("j8wAr", function(module, exports) {
$parcel$export(module.exports, "makeDispatch", () => $db3b265657c47c29$export$9f13ecc44e83d682);

var $hMOFt = parcelRequire("hMOFt");
const $db3b265657c47c29$var$scheduleOnDrag = (0, $hMOFt.default)((fn)=>fn());
const $db3b265657c47c29$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $db3b265657c47c29$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $db3b265657c47c29$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $db3b265657c47c29$var$dragStart.flush();
            $db3b265657c47c29$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $db3b265657c47c29$var$scheduleOnDrag(()=>{
                $db3b265657c47c29$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $db3b265657c47c29$var$dragStart.flush();
            $db3b265657c47c29$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});


parcelRegister("9X9Ac", function(module, exports) {
$parcel$export(module.exports, "register", () => $f6f9aaadabb559cb$export$6503ec6e8aabbaf);
const $f6f9aaadabb559cb$var$ledger = new Map();
function $f6f9aaadabb559cb$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $f6f9aaadabb559cb$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $f6f9aaadabb559cb$var$ledger.set(typeKey, initial);
    return initial;
}
function $f6f9aaadabb559cb$export$6503ec6e8aabbaf(args) {
    const entry = $f6f9aaadabb559cb$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $f6f9aaadabb559cb$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("aUpg2", function(module, exports) {
$parcel$export(module.exports, "makeDropTarget", () => $e66e6e4dbc8d60b7$export$47d10e7bd9c81890);

var $8wYaX = parcelRequire("8wYaX");

var $h1oBm = parcelRequire("h1oBm");

var $gtl0b = parcelRequire("gtl0b");
function $e66e6e4dbc8d60b7$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $e66e6e4dbc8d60b7$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        const cleanup = (0, $8wYaX.combine)((0, $gtl0b.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $h1oBm.once)(cleanup);
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = args.getData?.(feedback) ?? {};
        const dropEffect = args.getDropEffect?.(feedback) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry?.[eventName]?.(// I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry?.onDropTargetChange?.(args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) entry?.onDragLeave?.(args);
            }
            for (const record of payload.location.current.dropTargets){
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry?.onDropTargetChange?.(args);
                entry?.onDragEnter?.(args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $e66e6e4dbc8d60b7$var$copyReverse(current);
        const actualCaptureOrdered = $e66e6e4dbc8d60b7$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if (parent?.element !== lastParent?.element) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!argsForLast.getIsSticky?.(feedback)) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $e66e6e4dbc8d60b7$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("gtl0b", function(module, exports) {
$parcel$export(module.exports, "addAttribute", () => $6fe3018a2ad119e7$export$5dcb5c23b6ba980a);
function $6fe3018a2ad119e7$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("ktojy", function(module, exports) {
$parcel$export(module.exports, "makeMonitor", () => $063a027dfd8b99a4$export$5dd4ed888d5b12ca);

var $h1oBm = parcelRequire("h1oBm");
function $063a027dfd8b99a4$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $h1oBm.once)(cleanup);
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) // @ts-expect-error: I cannot get this type working!
        monitor[eventName]?.(payload);
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("2NcSy", function(module, exports) {
$parcel$export(module.exports, "isAndroid", () => $d5ead0b7c2e0c8cc$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $d5ead0b7c2e0c8cc$export$aceb3ed8b7f7bd2c);

var $h1oBm = parcelRequire("h1oBm");
const $d5ead0b7c2e0c8cc$export$a11b0059900ceec8 = (0, $h1oBm.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $d5ead0b7c2e0c8cc$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $58ff2e19b0510997$export$fd3d00026297c0ad = 'text/plain';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $0ff3806a414665e6$export$4c44a460f123106 = 'text/uri-list';

/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $2e2e8445b88fdb4c$export$c9c4cc54e73b125d = 'application/vnd.pdnd';


parcelRegister("3c6LS", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", () => $b8301f03b046d552$export$bb1740f3194979c1);

var $65JuC = parcelRequire("65JuC");
function $b8301f03b046d552$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return (0, $65JuC.adapter).monitor(args);
}

});
parcelRegister("65JuC", function(module, exports) {
$parcel$export(module.exports, "adapter", () => $996f3461f97c5124$export$e00c9c6684b0ace);

var $dqdTY = parcelRequire("dqdTY");

var $fX42K = parcelRequire("fX42K");

var $lHVxK = parcelRequire("lHVxK");

var $lCmze = parcelRequire("lCmze");

var $kOYsS = parcelRequire("kOYsS");

var $j8BxR = parcelRequire("j8BxR");

var $bV6I7 = parcelRequire("bV6I7");
let $996f3461f97c5124$var$didDragStartLocally = false;
const $996f3461f97c5124$export$e00c9c6684b0ace = (0, $fX42K.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $dqdTY.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($996f3461f97c5124$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $lHVxK.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = (0, $j8BxR.getAvailableTypes)(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types: types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = (0, $kOYsS.getAvailableItems)(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!(0, $bV6I7.isAnAvailableType)({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $996f3461f97c5124$export$e00c9c6684b0ace.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $996f3461f97c5124$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $dqdTY.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, $lCmze.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $dqdTY.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $996f3461f97c5124$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

});
parcelRegister("lHVxK", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindow", () => $59f3ebba5c038ec5$export$d1c6f249e893cdf4);

var $btCj5 = parcelRequire("btCj5");

var $ah9Nt = parcelRequire("ah9Nt");

var $1VAva = parcelRequire("1VAva");

var $gFXy4 = parcelRequire("gFXy4");
function $59f3ebba5c038ec5$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
    const { type: type, relatedTarget: relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, $ah9Nt.isSafari)()) return (0, $1VAva.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is an element inside the child `iframe`
	 * (foreign element)
	 */ if ((0, $btCj5.isFirefox)()) return (0, $gFXy4.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is `null` *(standard check)*
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("1VAva", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindowInSafari", () => $3a561e80070f82ff$export$de68634bd94ed596);

var $ah9Nt = parcelRequire("ah9Nt");

var $lhlAT = parcelRequire("lhlAT");
function $3a561e80070f82ff$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $ah9Nt.isSafari)()) return false;
    return dragEnter.hasOwnProperty((0, $lhlAT.symbols).isEnteringWindow);
}

});


parcelRegister("kOYsS", function(module, exports) {
$parcel$export(module.exports, "getAvailableItems", () => $e39af12212f48d3e$export$8d28cfecded8dcab);

var $bV6I7 = parcelRequire("bV6I7");
function $e39af12212f48d3e$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || (0, $bV6I7.isAnAvailableType)({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}

});
parcelRegister("bV6I7", function(module, exports) {
$parcel$export(module.exports, "isAnAvailableType", () => $a849b5fc71399e6f$export$a8e56a860d7957c7);

var $2NcSy = parcelRequire("2NcSy");


function $a849b5fc71399e6f$export$a8e56a860d7957c7({ type: type, value: value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $2e2e8445b88fdb4c$export$c9c4cc54e73b125d)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $58ff2e19b0510997$export$fd3d00026297c0ad) && value === (0, $2NcSy.androidFallbackText)) return false;
    return true;
}

});


parcelRegister("j8BxR", function(module, exports) {
$parcel$export(module.exports, "getAvailableTypes", () => $a4f5cc6b682c9d3c$export$8c257a3856120a77);

var $bV6I7 = parcelRequire("bV6I7");
function $a4f5cc6b682c9d3c$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter((type)=>(0, $bV6I7.isAnAvailableType)({
            type: type,
            value: transfer.getData(type)
        }));
}

});



parcelRegister("kwIhN", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => $51672a205338edc0$export$2e178e3647f5e6e9);

var $kLsGG = parcelRequire("kLsGG");
function $51672a205338edc0$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return (0, $kLsGG.adapter).monitor(args);
}

});
parcelRegister("kLsGG", function(module, exports) {
$parcel$export(module.exports, "adapter", () => $2261b7477ac7bba4$export$e00c9c6684b0ace);

var $dqdTY = parcelRequire("dqdTY");

var $fX42K = parcelRequire("fX42K");

var $8wYaX = parcelRequire("8wYaX");




var $lw9CL = parcelRequire("lw9CL");

var $7KkIo = parcelRequire("7KkIo");
const $2261b7477ac7bba4$export$e00c9c6684b0ace = (0, $fX42K.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $8wYaX.combine)((0, $7KkIo.honeyPotFix).bindEvents(), (0, $dqdTY.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $2e2e8445b88fdb4c$export$c9c4cc54e73b125d))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $58ff2e19b0510997$export$fd3d00026297c0ad))) return;
                const target = (0, $lw9CL.findTextNode)(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    target: // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, $58ff2e19b0510997$export$fd3d00026297c0ad)),
                    HTML: event.dataTransfer.getData((0, $69c4eea1f1404581$export$338a9f6c7a1f02b0))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: (0, $7KkIo.honeyPotFix).getOnPostDispatch()
});
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $2261b7477ac7bba4$export$e00c9c6684b0ace.registerUsage();
})();

});
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $69c4eea1f1404581$export$338a9f6c7a1f02b0 = 'text/html';

parcelRegister("lw9CL", function(module, exports) {
$parcel$export(module.exports, "findTextNode", () => $44c6b0b123c5ca23$export$c15c0fde2d293bb4);

var $ah9Nt = parcelRequire("ah9Nt");

function $44c6b0b123c5ca23$export$c15c0fde2d293bb4(event) {
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $ah9Nt.isSafari)()) return null;
    /**
	 * According to the spec, `event.target` should be the `Text` node that
	 * the drag started from when dragging a text selection.
	 *
	 * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
	 *
	 * However, in Safari the closest `HTMLElement` is returned.
	 * So we need to figure out if text is dragging ourselves.
	 *
	 * → https://bugs.webkit.org/show_bug.cgi?id=268959
	 */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!event.dataTransfer?.getData((0, $58ff2e19b0510997$export$fd3d00026297c0ad))) return null;
    /**
	 * Grab the first Text node and use that.
	 * Only doing a single level search as that is all we need for this bug.
	 */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text ?? null;
}

});

parcelRegister("7KkIo", function(module, exports) {
$parcel$export(module.exports, "honeyPotFix", () => $033ce1e96379373e$export$f17744ed5439c0ab);

var $2wdyh = parcelRequire("2wdyh");
const $033ce1e96379373e$export$f17744ed5439c0ab = (0, $2wdyh.makeHoneyPotFix)();

});



parcelRegister("1mzzO", function(module, exports) {

var $98sQP = parcelRequire("98sQP");
var $0fe3714d5eee7ea6$var$listeningFocusTrap = null;
function $0fe3714d5eee7ea6$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $0fe3714d5eee7ea6$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($0fe3714d5eee7ea6$var$listeningFocusTrap) $0fe3714d5eee7ea6$var$listeningFocusTrap.pause();
        $0fe3714d5eee7ea6$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $0fe3714d5eee7ea6$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $0fe3714d5eee7ea6$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $0fe3714d5eee7ea6$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $0fe3714d5eee7ea6$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $0fe3714d5eee7ea6$var$tryFocus(lastTabbableNode);
            return $0fe3714d5eee7ea6$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $0fe3714d5eee7ea6$var$tryFocus(firstTabbableNode);
        $0fe3714d5eee7ea6$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $98sQP(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $0fe3714d5eee7ea6$var$tryFocus(lastTabbableNode);
        $0fe3714d5eee7ea6$var$tryFocus(firstTabbableNode);
    }
}
function $0fe3714d5eee7ea6$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $0fe3714d5eee7ea6$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $0fe3714d5eee7ea6$var$focusTrap;

});
parcelRegister("98sQP", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $6a6b3d9e545d892f$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $6a6b3d9e545d892f$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});


parcelRegister("cv14p", function(module, exports) {
$parcel$export(module.exports, "default", () => $919935d0823a99e4$export$2e2bcd8739ae039);

var $kfssI = parcelRequire("kfssI");
function $919935d0823a99e4$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $919935d0823a99e4$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $919935d0823a99e4$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($919935d0823a99e4$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $919935d0823a99e4$var$scrollIntoView(target, options) {
    var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
    if ($919935d0823a99e4$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(isTargetAttached ? (0, $kfssI.default)(target, options) : []);
    if (!isTargetAttached) return;
    var computeOptions = $919935d0823a99e4$var$getOptions(options);
    return $919935d0823a99e4$var$defaultBehavior((0, $kfssI.default)(target, computeOptions), computeOptions.behavior);
}
var $919935d0823a99e4$export$2e2bcd8739ae039 = $919935d0823a99e4$var$scrollIntoView;

});
parcelRegister("kfssI", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebdb49550a455625$export$2e2bcd8739ae039);
function $ebdb49550a455625$var$t(t) {
    return "object" == typeof t && null != t && 1 === t.nodeType;
}
function $ebdb49550a455625$var$e(t, e) {
    return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function $ebdb49550a455625$var$n(t, n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return $ebdb49550a455625$var$e(r.overflowY, n) || $ebdb49550a455625$var$e(r.overflowX, n) || function(t) {
            var e = function(t) {
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            }(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
    }
    return !1;
}
function $ebdb49550a455625$var$r(t, e, n, r, i, o, l, d) {
    return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
var $ebdb49550a455625$export$2e2bcd8739ae039 = function(e, i) {
    var o = window, l = i.scrollMode, d = i.block, f = i.inline, h = i.boundary, u = i.skipOverflowHiddenElements, s = "function" == typeof h ? h : function(t) {
        return t !== h;
    };
    if (!$ebdb49550a455625$var$t(e)) throw new TypeError("Invalid target");
    for(var a, c, g = document.scrollingElement || document.documentElement, p = [], m = e; $ebdb49550a455625$var$t(m) && s(m);){
        if ((m = null == (c = (a = m).parentElement) ? a.getRootNode().host || null : c) === g) {
            p.push(m);
            break;
        }
        null != m && m === document.body && $ebdb49550a455625$var$n(m) && !$ebdb49550a455625$var$n(document.documentElement) || null != m && $ebdb49550a455625$var$n(m, u) && p.push(m);
    }
    for(var w = o.visualViewport ? o.visualViewport.width : innerWidth, v = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, E = b.width, M = b.top, V = b.right, x = b.bottom, I = b.left, C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2, R = "center" === f ? I + E / 2 : "end" === f ? V : I, T = [], k = 0; k < p.length; k++){
        var B = p[k], D = B.getBoundingClientRect(), O = D.height, X = D.width, Y = D.top, L = D.right, S = D.bottom, j = D.left;
        if ("if-needed" === l && M >= 0 && I >= 0 && x <= v && V <= w && M >= Y && x <= S && I >= j && V <= L) return T;
        var N = getComputedStyle(B), q = parseInt(N.borderLeftWidth, 10), z = parseInt(N.borderTopWidth, 10), A = parseInt(N.borderRightWidth, 10), F = parseInt(N.borderBottomWidth, 10), G = 0, J = 0, K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0, P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0, Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0, U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
        if (g === B) G = "start" === d ? C : "end" === d ? C - v : "nearest" === d ? $ebdb49550a455625$var$r(H, H + v, v, z, F, H + C, H + C + y, y) : C - v / 2, J = "start" === f ? R : "center" === f ? R - w / 2 : "end" === f ? R - w : $ebdb49550a455625$var$r(W, W + w, w, q, A, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);
        else {
            G = "start" === d ? C - Y - z : "end" === d ? C - S + F + P : "nearest" === d ? $ebdb49550a455625$var$r(Y, S, O, z, F + P, C, C + y, y) : C - (Y + O / 2) + P / 2, J = "start" === f ? R - j - q : "center" === f ? R - (j + X / 2) + K / 2 : "end" === f ? R - L + A + K : $ebdb49550a455625$var$r(j, L, X, q, A + K, R, R + E, E);
            var Z = B.scrollLeft, $ = B.scrollTop;
            C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
        }
        T.push({
            el: B,
            top: G,
            left: J
        });
    }
    return T;
};

});


parcelRegister("knrfi", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iFgyQ = parcelRequire("iFgyQ");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $ed5b1714c97640e2$var$_interopRequireDefault($iFgyQ).default;
    }
});
function $ed5b1714c97640e2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("iFgyQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d968e6fc662e90f3$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $fsvuC = parcelRequire("fsvuC");

var $80czl = parcelRequire("80czl");
function $d968e6fc662e90f3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d968e6fc662e90f3$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d968e6fc662e90f3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d968e6fc662e90f3$var$NodeResolver = function(_Component) {
    $d968e6fc662e90f3$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $d968e6fc662e90f3$var$_classCallCheck(this, NodeResolver);
        return $d968e6fc662e90f3$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $d968e6fc662e90f3$var$_createClass(NodeResolver, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.innerRef((0, $80czl.findDOMNode)(this));
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($fsvuC.Component);
module.exports.default = $d968e6fc662e90f3$var$NodeResolver;

});


parcelRegister("etCKv", function(module, exports) {
$parcel$export(module.exports, "PendoChoreographerPlugin", () => $3f1f28b442a64920$export$3390a677f4025523);

var $a5MkA = parcelRequire("a5MkA");

var $jhuwq = parcelRequire("jhuwq");
class $3f1f28b442a64920$export$3390a677f4025523 extends (0, $jhuwq.ChoreographerPlugin) {
    constructor(envType, metaMetricsData = {}){
        super((0, $a5MkA.ProductIds).PENDO, envType, metaMetricsData), this.currentMessageId = '', this.getPendoConfig = (pendoConfig)=>{
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const pendoPlugin = this;
            return {
                ...pendoConfig,
                guides: {
                    ...pendoConfig.guides ?? {},
                    globalScripts: [
                        ...pendoConfig.guides?.globalScripts ?? [],
                        {
                            beforeMount (evnt) {
                                if (pendoPlugin.state.isDisabled) evnt.cancel = true;
                                else {
                                    pendoPlugin.currentMessageId = evnt.step.id;
                                    pendoPlugin.on(pendoPlugin.currentMessageId, {});
                                    pendoPlugin.startMessage(pendoPlugin.currentMessageId);
                                }
                            },
                            unmounted () {
                                pendoPlugin.stopMessage(pendoPlugin.currentMessageId);
                            }
                        }
                    ]
                }
            };
        };
    }
    isDisplayingMessage() {
        return Boolean(window.pendo?.getActiveGuide?.());
    }
}

});

parcelRegister("5FBJa", function(module, exports) {
$parcel$export(module.exports, "default", () => $420e0bfa14b3943b$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $420e0bfa14b3943b$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("aHiqu", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== 'undefined' ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var RushaCore = __webpack_require__(5);
            var _require = __webpack_require__(1), toHex = _require.toHex, ceilHeapSize = _require.ceilHeapSize;
            var conv = __webpack_require__(6);
            // Calculate the length of buffer that the sha1 routine uses
            // including the padding.
            var padlen = function(len) {
                for(len += 9; len % 64 > 0; len += 1);
                return len;
            };
            var padZeroes = function(bin, len) {
                var h8 = new Uint8Array(bin.buffer);
                var om = len % 4, align = len - om;
                switch(om){
                    case 0:
                        h8[align + 3] = 0;
                    case 1:
                        h8[align + 2] = 0;
                    case 2:
                        h8[align + 1] = 0;
                    case 3:
                        h8[align + 0] = 0;
                }
                for(var i = (len >> 2) + 1; i < bin.length; i++)bin[i] = 0;
            };
            var padData = function(bin, chunkLen, msgLen) {
                bin[chunkLen >> 2] |= 0x80 << 24 - (chunkLen % 4 << 3);
                // To support msgLen >= 2 GiB, use a float division when computing the
                // high 32-bits of the big-endian message length in bits.
                bin[((chunkLen >> 2) + 2 & -16) + 14] = msgLen / 536870912 | 0;
                bin[((chunkLen >> 2) + 2 & -16) + 15] = msgLen << 3;
            };
            var getRawDigest = function(heap, padMaxChunkLen) {
                var io = new Int32Array(heap, padMaxChunkLen + 320, 5);
                var out = new Int32Array(5);
                var arr = new DataView(out.buffer);
                arr.setInt32(0, io[0], false);
                arr.setInt32(4, io[1], false);
                arr.setInt32(8, io[2], false);
                arr.setInt32(12, io[3], false);
                arr.setInt32(16, io[4], false);
                return out;
            };
            var Rusha = function() {
                function Rusha(chunkSize) {
                    _classCallCheck(this, Rusha);
                    chunkSize = chunkSize || 65536;
                    if (chunkSize % 64 > 0) throw new Error('Chunk size must be a multiple of 128 bit');
                    this._offset = 0;
                    this._maxChunkLen = chunkSize;
                    this._padMaxChunkLen = padlen(chunkSize);
                    // The size of the heap is the sum of:
                    // 1. The padded input message size
                    // 2. The extended space the algorithm needs (320 byte)
                    // 3. The 160 bit state the algoritm uses
                    this._heap = new ArrayBuffer(ceilHeapSize(this._padMaxChunkLen + 320 + 20));
                    this._h32 = new Int32Array(this._heap);
                    this._h8 = new Int8Array(this._heap);
                    this._core = new RushaCore({
                        Int32Array: Int32Array
                    }, {}, this._heap);
                }
                Rusha.prototype._initState = function _initState(heap, padMsgLen) {
                    this._offset = 0;
                    var io = new Int32Array(heap, padMsgLen + 320, 5);
                    io[0] = 1732584193;
                    io[1] = -271733879;
                    io[2] = -1732584194;
                    io[3] = 271733878;
                    io[4] = -1009589776;
                };
                Rusha.prototype._padChunk = function _padChunk(chunkLen, msgLen) {
                    var padChunkLen = padlen(chunkLen);
                    var view = new Int32Array(this._heap, 0, padChunkLen >> 2);
                    padZeroes(view, chunkLen);
                    padData(view, chunkLen, msgLen);
                    return padChunkLen;
                };
                Rusha.prototype._write = function _write(data, chunkOffset, chunkLen, off) {
                    conv(data, this._h8, this._h32, chunkOffset, chunkLen, off || 0);
                };
                Rusha.prototype._coreCall = function _coreCall(data, chunkOffset, chunkLen, msgLen, finalize) {
                    var padChunkLen = chunkLen;
                    this._write(data, chunkOffset, chunkLen);
                    if (finalize) padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                };
                Rusha.prototype.rawDigest = function rawDigest(str) {
                    var msgLen = str.byteLength || str.length || str.size || 0;
                    this._initState(this._heap, this._padMaxChunkLen);
                    var chunkOffset = 0, chunkLen = this._maxChunkLen;
                    for(chunkOffset = 0; msgLen > chunkOffset + chunkLen; chunkOffset += chunkLen)this._coreCall(str, chunkOffset, chunkLen, msgLen, false);
                    this._coreCall(str, chunkOffset, msgLen - chunkOffset, msgLen, true);
                    return getRawDigest(this._heap, this._padMaxChunkLen);
                };
                Rusha.prototype.digest = function digest(str) {
                    return toHex(this.rawDigest(str).buffer);
                };
                Rusha.prototype.digestFromString = function digestFromString(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromBuffer = function digestFromBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromArrayBuffer = function digestFromArrayBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.resetState = function resetState() {
                    this._initState(this._heap, this._padMaxChunkLen);
                    return this;
                };
                Rusha.prototype.append = function append(chunk) {
                    var chunkOffset = 0;
                    var chunkLen = chunk.byteLength || chunk.length || chunk.size || 0;
                    var turnOffset = this._offset % this._maxChunkLen;
                    var inputLen = void 0;
                    this._offset += chunkLen;
                    while(chunkOffset < chunkLen){
                        inputLen = Math.min(chunkLen - chunkOffset, this._maxChunkLen - turnOffset);
                        this._write(chunk, chunkOffset, inputLen, turnOffset);
                        turnOffset += inputLen;
                        chunkOffset += inputLen;
                        if (turnOffset === this._maxChunkLen) {
                            this._core.hash(this._maxChunkLen, this._padMaxChunkLen);
                            turnOffset = 0;
                        }
                    }
                    return this;
                };
                Rusha.prototype.getState = function getState() {
                    var turnOffset = this._offset % this._maxChunkLen;
                    var heap = void 0;
                    if (!turnOffset) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        heap = io.buffer.slice(io.byteOffset, io.byteOffset + io.byteLength);
                    } else heap = this._heap.slice(0);
                    return {
                        offset: this._offset,
                        heap: heap
                    };
                };
                Rusha.prototype.setState = function setState(state) {
                    this._offset = state.offset;
                    if (state.heap.byteLength === 20) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        io.set(new Int32Array(state.heap));
                    } else this._h32.set(new Int32Array(state.heap));
                    return this;
                };
                Rusha.prototype.rawEnd = function rawEnd() {
                    var msgLen = this._offset;
                    var chunkLen = msgLen % this._maxChunkLen;
                    var padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                    var result = getRawDigest(this._heap, this._padMaxChunkLen);
                    this._initState(this._heap, this._padMaxChunkLen);
                    return result;
                };
                Rusha.prototype.end = function end() {
                    return toHex(this.rawEnd().buffer);
                };
                return Rusha;
            }();
            module1.exports = Rusha;
            module1.exports._core = RushaCore;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /* eslint-env commonjs, browser */ //
            // toHex
            //
            var precomputedHex = new Array(256);
            for(var i = 0; i < 256; i++)precomputedHex[i] = (i < 0x10 ? '0' : '') + i.toString(16);
            module1.exports.toHex = function(arrayBuffer) {
                var binarray = new Uint8Array(arrayBuffer);
                var res = new Array(arrayBuffer.byteLength);
                for(var _i = 0; _i < res.length; _i++)res[_i] = precomputedHex[binarray[_i]];
                return res.join('');
            };
            //
            // ceilHeapSize
            //
            module1.exports.ceilHeapSize = function(v) {
                // The asm.js spec says:
                // The heap object's byteLength must be either
                // 2^n for n in [12, 24) or 2^24 * n for n ≥ 1.
                // Also, byteLengths smaller than 2^16 are deprecated.
                var p = 0;
                // If v is smaller than 2^16, the smallest possible solution
                // is 2^16.
                if (v <= 65536) return 65536;
                // If v < 2^24, we round up to 2^n,
                // otherwise we round up to 2^24 * n.
                if (v < 16777216) {
                    for(p = 1; p < v; p = p << 1);
                } else {
                    for(p = 16777216; p < v; p += 16777216);
                }
                return p;
            };
            //
            // isDedicatedWorkerScope
            //
            module1.exports.isDedicatedWorkerScope = function(self1) {
                var isRunningInWorker = 'WorkerGlobalScope' in self1 && self1 instanceof self1.WorkerGlobalScope;
                var isRunningInSharedWorker = 'SharedWorkerGlobalScope' in self1 && self1 instanceof self1.SharedWorkerGlobalScope;
                var isRunningInServiceWorker = 'ServiceWorkerGlobalScope' in self1 && self1 instanceof self1.ServiceWorkerGlobalScope;
                // Detects whether we run inside a dedicated worker or not.
                //
                // We can't just check for `DedicatedWorkerGlobalScope`, since IE11
                // has a bug where it only supports `WorkerGlobalScope`.
                //
                // Therefore, we consider us as running inside a dedicated worker
                // when we are running inside a worker, but not in a shared or service worker.
                //
                // When new types of workers are introduced, we will need to adjust this code.
                return isRunningInWorker && !isRunningInSharedWorker && !isRunningInServiceWorker;
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, worker */ module1.exports = function() {
                var Rusha = __webpack_require__(0);
                var hashData = function(hasher, data, cb) {
                    try {
                        return cb(null, hasher.digest(data));
                    } catch (e) {
                        return cb(e);
                    }
                };
                var hashFile = function(hasher, readTotal, blockSize, file, cb) {
                    var reader = new self.FileReader();
                    reader.onloadend = function onloadend() {
                        if (reader.error) return cb(reader.error);
                        var buffer = reader.result;
                        readTotal += reader.result.byteLength;
                        try {
                            hasher.append(buffer);
                        } catch (e) {
                            cb(e);
                            return;
                        }
                        if (readTotal < file.size) hashFile(hasher, readTotal, blockSize, file, cb);
                        else cb(null, hasher.end());
                    };
                    reader.readAsArrayBuffer(file.slice(readTotal, readTotal + blockSize));
                };
                var workerBehaviourEnabled = true;
                self.onmessage = function(event) {
                    if (!workerBehaviourEnabled) return;
                    var data = event.data.data, file = event.data.file, id = event.data.id;
                    if (typeof id === 'undefined') return;
                    if (!file && !data) return;
                    var blockSize = event.data.blockSize || 4194304;
                    var hasher = new Rusha(blockSize);
                    hasher.resetState();
                    var done = function(err, hash) {
                        if (!err) self.postMessage({
                            id: id,
                            hash: hash
                        });
                        else self.postMessage({
                            id: id,
                            error: err.name
                        });
                    };
                    if (data) hashData(hasher, data, done);
                    if (file) hashFile(hasher, 0, blockSize, file, done);
                };
                return function() {
                    workerBehaviourEnabled = false;
                };
            };
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, browser */ var work = __webpack_require__(4);
            var Rusha = __webpack_require__(0);
            var createHash = __webpack_require__(7);
            var runWorker = __webpack_require__(2);
            var _require = __webpack_require__(1), isDedicatedWorkerScope = _require.isDedicatedWorkerScope;
            var isRunningInDedicatedWorker = typeof self !== 'undefined' && isDedicatedWorkerScope(self);
            Rusha.disableWorkerBehaviour = isRunningInDedicatedWorker ? runWorker() : function() {};
            Rusha.createWorker = function() {
                var worker = work(/*require.resolve*/ 2);
                var terminate = worker.terminate;
                worker.terminate = function() {
                    URL.revokeObjectURL(worker.objectURL);
                    terminate.call(worker);
                };
                return worker;
            };
            Rusha.createHash = createHash;
            module1.exports = Rusha;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            function webpackBootstrapFunc(modules) {
                /******/ // The module cache
                /******/ var installedModules = {};
                /******/ // The require function
                /******/ function __webpack_require__(moduleId) {
                    /******/ // Check if module is in cache
                    /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                    /******/ // Create a new module (and put it into the cache)
                    /******/ var module1 = installedModules[moduleId] = {
                        /******/ i: moduleId,
                        /******/ l: false,
                        /******/ exports: {}
                    };
                    /******/ // Execute the module function
                    /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                    /******/ // Flag the module as loaded
                    /******/ module1.l = true;
                    /******/ // Return the exports of the module
                    /******/ return module1.exports;
                /******/ }
                /******/ // expose the modules object (__webpack_modules__)
                /******/ __webpack_require__.m = modules;
                /******/ // expose the module cache
                /******/ __webpack_require__.c = installedModules;
                /******/ // identity function for calling harmony imports with the correct context
                /******/ __webpack_require__.i = function(value) {
                    return value;
                };
                /******/ // define getter function for harmony exports
                /******/ __webpack_require__.d = function(exports, name, getter) {
                    /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                        /******/ configurable: false,
                        /******/ enumerable: true,
                        /******/ get: getter
                    });
                /******/ };
                /******/ // define __esModule on exports
                /******/ __webpack_require__.r = function(exports) {
                    /******/ Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                /******/ };
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/ __webpack_require__.n = function(module1) {
                    /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                        return module1['default'];
                    } : /******/ function getModuleExports() {
                        return module1;
                    };
                    /******/ __webpack_require__.d(getter, 'a', getter);
                    /******/ return getter;
                /******/ };
                /******/ // Object.prototype.hasOwnProperty.call
                /******/ __webpack_require__.o = function(object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/ // __webpack_public_path__
                /******/ __webpack_require__.p = "/";
                /******/ // on error function for async loading
                /******/ __webpack_require__.oe = function(err) {
                    console.error(err);
                    throw err;
                };
                var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
                return f.default || f // try to call default if defined to also support babel esmodule exports
                ;
            }
            var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
            var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true
            ;
            // http://stackoverflow.com/a/2593661/130442
            function quoteRegExp(str) {
                return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
            }
            function getModuleDependencies(sources, module1, queueName) {
                var retval = {};
                retval[queueName] = [];
                var fnString = module1.toString();
                var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!wrapperSignature) return retval;
                var webpackRequireName = wrapperSignature[1];
                // main bundle deps
                var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
                var match;
                while(match = re.exec(fnString)){
                    if (match[3] === 'dll-reference') continue;
                    retval[queueName].push(match[3]);
                }
                // dll deps
                re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
                while(match = re.exec(fnString)){
                    if (!sources[match[2]]) {
                        retval[queueName].push(match[1]);
                        sources[match[2]] = __webpack_require__(match[1]).m;
                    }
                    retval[match[2]] = retval[match[2]] || [];
                    retval[match[2]].push(match[4]);
                }
                return retval;
            }
            function hasValuesInQueues(queues) {
                var keys = Object.keys(queues);
                return keys.reduce(function(hasValues, key) {
                    return hasValues || queues[key].length > 0;
                }, false);
            }
            function getRequiredModules(sources, moduleId) {
                var modulesQueue = {
                    main: [
                        moduleId
                    ]
                };
                var requiredModules = {
                    main: []
                };
                var seenModules = {
                    main: {}
                };
                while(hasValuesInQueues(modulesQueue)){
                    var queues = Object.keys(modulesQueue);
                    for(var i = 0; i < queues.length; i++){
                        var queueName = queues[i];
                        var queue = modulesQueue[queueName];
                        var moduleToCheck = queue.pop();
                        seenModules[queueName] = seenModules[queueName] || {};
                        if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue;
                        seenModules[queueName][moduleToCheck] = true;
                        requiredModules[queueName] = requiredModules[queueName] || [];
                        requiredModules[queueName].push(moduleToCheck);
                        var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
                        var newModulesKeys = Object.keys(newModules);
                        for(var j = 0; j < newModulesKeys.length; j++){
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
                        }
                    }
                }
                return requiredModules;
            }
            module1.exports = function(moduleId, options) {
                options = options || {};
                var sources = {
                    main: __webpack_require__.m
                };
                var requiredModules = options.all ? {
                    main: Object.keys(sources)
                } : getRequiredModules(sources, moduleId);
                var src = '';
                Object.keys(requiredModules).filter(function(m) {
                    return m !== 'main';
                }).forEach(function(module1) {
                    var entryModule = 0;
                    while(requiredModules[module1][entryModule])entryModule++;
                    requiredModules[module1].push(entryModule);
                    sources[module1][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
                    src = src + 'var ' + module1 + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module1].map(function(id) {
                        return '' + JSON.stringify(id) + ': ' + sources[module1][id].toString();
                    }).join(',') + '});\n';
                });
                src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function(id) {
                    return '' + JSON.stringify(id) + ': ' + sources.main[id].toString();
                }).join(',') + '})(self);';
                var blob = new window.Blob([
                    src
                ], {
                    type: 'text/javascript'
                });
                if (options.bare) return blob;
                var URL1 = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var workerUrl = URL1.createObjectURL(blob);
                var worker = new window.Worker(workerUrl);
                worker.objectURL = workerUrl;
                return worker;
            };
        /***/ },
        /* 5 */ /***/ function(module1, exports) {
            // The low-level RushCore module provides the heart of Rusha,
            // a high-speed sha1 implementation working on an Int32Array heap.
            // At first glance, the implementation seems complicated, however
            // with the SHA1 spec at hand, it is obvious this almost a textbook
            // implementation that has a few functions hand-inlined and a few loops
            // hand-unrolled.
            module1.exports = function RushaCore(stdlib$840, foreign$841, heap$842) {
                'use asm';
                var H$843 = new stdlib$840.Int32Array(heap$842);
                function hash$844(k$845, x$846) {
                    // k in bytes
                    k$845 = k$845 | 0;
                    x$846 = x$846 | 0;
                    var i$847 = 0, j$848 = 0, y0$849 = 0, z0$850 = 0, y1$851 = 0, z1$852 = 0, y2$853 = 0, z2$854 = 0, y3$855 = 0, z3$856 = 0, y4$857 = 0, z4$858 = 0, t0$859 = 0, t1$860 = 0;
                    y0$849 = H$843[x$846 + 320 >> 2] | 0;
                    y1$851 = H$843[x$846 + 324 >> 2] | 0;
                    y2$853 = H$843[x$846 + 328 >> 2] | 0;
                    y3$855 = H$843[x$846 + 332 >> 2] | 0;
                    y4$857 = H$843[x$846 + 336 >> 2] | 0;
                    for(i$847 = 0; (i$847 | 0) < (k$845 | 0); i$847 = i$847 + 64 | 0){
                        z0$850 = y0$849;
                        z1$852 = y1$851;
                        z2$854 = y2$853;
                        z3$856 = y3$855;
                        z4$858 = y4$857;
                        for(j$848 = 0; (j$848 | 0) < 64; j$848 = j$848 + 4 | 0){
                            t1$860 = H$843[i$847 + j$848 >> 2] | 0;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 & y2$853 | ~y1$851 & y3$855) | 0) + ((t1$860 + y4$857 | 0) + 1518500249 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[k$845 + j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 64 | 0; (j$848 | 0) < (k$845 + 80 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 & y2$853 | ~y1$851 & y3$855) | 0) + ((t1$860 + y4$857 | 0) + 1518500249 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 80 | 0; (j$848 | 0) < (k$845 + 160 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 ^ y2$853 ^ y3$855) | 0) + ((t1$860 + y4$857 | 0) + 1859775393 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 160 | 0; (j$848 | 0) < (k$845 + 240 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 & y2$853 | y1$851 & y3$855 | y2$853 & y3$855) | 0) + ((t1$860 + y4$857 | 0) - 1894007588 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 240 | 0; (j$848 | 0) < (k$845 + 320 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 ^ y2$853 ^ y3$855) | 0) + ((t1$860 + y4$857 | 0) - 899497514 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        y0$849 = y0$849 + z0$850 | 0;
                        y1$851 = y1$851 + z1$852 | 0;
                        y2$853 = y2$853 + z2$854 | 0;
                        y3$855 = y3$855 + z3$856 | 0;
                        y4$857 = y4$857 + z4$858 | 0;
                    }
                    H$843[x$846 + 320 >> 2] = y0$849;
                    H$843[x$846 + 324 >> 2] = y1$851;
                    H$843[x$846 + 328 >> 2] = y2$853;
                    H$843[x$846 + 332 >> 2] = y3$855;
                    H$843[x$846 + 336 >> 2] = y4$857;
                }
                return {
                    hash: hash$844
                };
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports) {
            var _this = this;
            /* eslint-env commonjs, browser */ var reader = void 0;
            if (typeof self !== 'undefined' && typeof self.FileReaderSync !== 'undefined') reader = new self.FileReaderSync();
            // Convert a binary string and write it to the heap.
            // A binary string is expected to only contain char codes < 256.
            var convStr = function(str, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = str.charCodeAt(start + 3);
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = str.charCodeAt(start + 2);
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = str.charCodeAt(start + 1);
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = str.charCodeAt(start);
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2] = str.charCodeAt(start + i) << 24 | str.charCodeAt(start + i + 1) << 16 | str.charCodeAt(start + i + 2) << 8 | str.charCodeAt(start + i + 3);
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = str.charCodeAt(start + j + 2);
                    case 2:
                        H8[off + j + 2 | 0] = str.charCodeAt(start + j + 1);
                    case 1:
                        H8[off + j + 3 | 0] = str.charCodeAt(start + j);
                }
            };
            // Convert a buffer or array and write it to the heap.
            // The buffer or array is expected to only contain elements < 256.
            var convBuf = function(buf, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = buf[start + 3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[start + 2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[start + 1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[start];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[start + i] << 24 | buf[start + i + 1] << 16 | buf[start + i + 2] << 8 | buf[start + i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[start + j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[start + j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[start + j];
                }
            };
            var convBlob = function(blob, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                var buf = new Uint8Array(reader.readAsArrayBuffer(blob.slice(start, start + len)));
                switch(om){
                    case 0:
                        H8[off] = buf[3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[0];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[i] << 24 | buf[i + 1] << 16 | buf[i + 2] << 8 | buf[i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[j];
                }
            };
            module1.exports = function(data, H8, H32, start, len, off) {
                if (typeof data === 'string') return convStr(data, H8, H32, start, len, off);
                if (data instanceof Array) return convBuf(data, H8, H32, start, len, off);
                // Safely doing a Buffer check using "this" to avoid Buffer polyfill to be included in the dist
                if (_this && _this.Buffer && _this.Buffer.isBuffer(data)) return convBuf(data, H8, H32, start, len, off);
                if (data instanceof ArrayBuffer) return convBuf(new Uint8Array(data), H8, H32, start, len, off);
                if (data.buffer instanceof ArrayBuffer) return convBuf(new Uint8Array(data.buffer, data.byteOffset, data.byteLength), H8, H32, start, len, off);
                if (data instanceof Blob) return convBlob(data, H8, H32, start, len, off);
                throw new Error('Unsupported data type.');
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var Rusha = __webpack_require__(0);
            var _require = __webpack_require__(1), toHex = _require.toHex;
            var Hash = function() {
                function Hash() {
                    _classCallCheck(this, Hash);
                    this._rusha = new Rusha();
                    this._rusha.resetState();
                }
                Hash.prototype.update = function update(data) {
                    this._rusha.append(data);
                    return this;
                };
                Hash.prototype.digest = function digest(encoding) {
                    var digest = this._rusha.rawEnd().buffer;
                    if (!encoding) return digest;
                    if (encoding === 'hex') return toHex(digest);
                    throw new Error('unsupported digest encoding');
                };
                _createClass(Hash, [
                    {
                        key: 'state',
                        get: function() {
                            return this._rusha.getState();
                        },
                        set: function(state) {
                            this._rusha.setState(state);
                        }
                    }
                ]);
                return Hash;
            }();
            module1.exports = function() {
                return new Hash();
            };
        /***/ }
    ]);
});

});

parcelRegister("lt9IW", function(module, exports) {
"use strict";
var $fa13d95d273b688f$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $fa13d95d273b688f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fa13d95d273b688f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $fa13d95d273b688f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $fsvuC = parcelRequire("fsvuC");

var $jf0Un = parcelRequire("jf0Un");
var $fa13d95d273b688f$var$ALL_INITIALIZERS = [];
var $fa13d95d273b688f$var$READY_INITIALIZERS = [];
function $fa13d95d273b688f$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $fa13d95d273b688f$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $fa13d95d273b688f$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $fa13d95d273b688f$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $fa13d95d273b688f$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $fa13d95d273b688f$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $fa13d95d273b688f$var$render(loaded, props) {
    return $fsvuC.createElement($fa13d95d273b688f$var$resolve(loaded), props);
}
function $fa13d95d273b688f$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $fa13d95d273b688f$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $fa13d95d273b688f$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $fa13d95d273b688f$var$READY_INITIALIZERS.push(function() {
        if ($fa13d95d273b688f$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $fa13d95d273b688f$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $fa13d95d273b688f$var$_classCallCheck(this, LoadableComponent);
            var _this = $fa13d95d273b688f$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        // renamed from componentWillMount See https://fb.me/react-unsafe-component-lifecycles
        LoadableComponent.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $fsvuC.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($fsvuC.Component), _class.contextTypes = {
        loadable: $jf0Un.shape({
            report: $jf0Un.func.isRequired
        })
    }, _temp;
}
function $fa13d95d273b688f$var$Loadable(opts) {
    return $fa13d95d273b688f$var$createLoadableComponent($fa13d95d273b688f$var$load, opts);
}
function $fa13d95d273b688f$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $fa13d95d273b688f$var$createLoadableComponent($fa13d95d273b688f$var$loadMap, opts);
}
$fa13d95d273b688f$var$Loadable.Map = $fa13d95d273b688f$var$LoadableMap;
var $fa13d95d273b688f$var$Capture = function(_React$Component2) {
    $fa13d95d273b688f$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $fa13d95d273b688f$var$_classCallCheck(this, Capture);
        return $fa13d95d273b688f$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $fsvuC.Children.only(this.props.children);
    };
    return Capture;
}($fsvuC.Component);
$fa13d95d273b688f$var$Capture.propTypes = {
    report: $jf0Un.func.isRequired
};
$fa13d95d273b688f$var$Capture.childContextTypes = {
    loadable: $jf0Un.shape({
        report: $jf0Un.func.isRequired
    }).isRequired
};
$fa13d95d273b688f$var$Loadable.Capture = $fa13d95d273b688f$var$Capture;
function $fa13d95d273b688f$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $fa13d95d273b688f$var$flushInitializers(initializers);
    });
}
$fa13d95d273b688f$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $fa13d95d273b688f$var$flushInitializers($fa13d95d273b688f$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$fa13d95d273b688f$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $fa13d95d273b688f$var$flushInitializers($fa13d95d273b688f$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $fa13d95d273b688f$var$Loadable;

});

parcelRegister("3Fp8y", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $b19637fe3a7cf6d0$export$6e8ea24b15199873);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
function $b19637fe3a7cf6d0$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $5chsV.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $5chsV.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("fgXcj", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_expValNoExposure", () => $45b152c07bfd2720$export$da472ee01c19d92e);

var $b2kpV = parcelRequire("b2kpV");
function $45b152c07bfd2720$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    return (0, $b2kpV.expValInternal)(experimentName, param, defaultValue, false);
}

});

parcelRegister("jY9mG", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $e89ae2983d258337$export$e926676385687eaf);
$parcel$export(module.exports, "withErrorBoundary", () => $e89ae2983d258337$export$f0c7a449e0cfaec7);

var $fsvuC = parcelRequire("fsvuC");
'use client';
const $e89ae2983d258337$export$b16d9fb1a22de840 = (0, $fsvuC.createContext)(null);
const $e89ae2983d258337$var$initialState = {
    didCatch: false,
    error: null
};
class $e89ae2983d258337$export$e926676385687eaf extends (0, $fsvuC.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $e89ae2983d258337$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($e89ae2983d258337$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $e89ae2983d258337$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($e89ae2983d258337$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $fsvuC.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $fsvuC.createElement)($e89ae2983d258337$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $e89ae2983d258337$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $e89ae2983d258337$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $e89ae2983d258337$export$c052f6604b7d51fe() {
    const context = (0, $fsvuC.useContext)($e89ae2983d258337$export$b16d9fb1a22de840);
    $e89ae2983d258337$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $fsvuC.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $fsvuC.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $e89ae2983d258337$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $fsvuC.forwardRef)((props, ref)=>(0, $fsvuC.createElement)($e89ae2983d258337$export$e926676385687eaf, errorBoundaryProps, (0, $fsvuC.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});

parcelRegister("hzhxT", function(module, exports) {
$parcel$export(module.exports, "ROVO_POST_MESSAGE_EVENT_TYPE", () => $102d5db4df13f743$export$cabfb6cc8c48b099);
$parcel$export(module.exports, "RovoPostMessagePubsubListener", () => $102d5db4df13f743$export$e5e1a9c59c299631);
$parcel$export(module.exports, "useRovoPostMessageToPubsub", () => $102d5db4df13f743$export$5340cc94dd0ecbea);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $6dtVG = parcelRequire("6dtVG");
const $102d5db4df13f743$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $102d5db4df13f743$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $102d5db4df13f743$var$allowedSubdomains = [
    '.jira-dev.com',
    '.jira.atlassian.cloud',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $102d5db4df13f743$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $102d5db4df13f743$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($102d5db4df13f743$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $102d5db4df13f743$var$allowedOrigins.includes(hostname));
};
const $102d5db4df13f743$export$e5e1a9c59c299631 = ()=>{
    const publish = (0, $6dtVG.usePublish)('ai-mate');
    (0, $fsvuC.useEffect)(()=>{
        const handlerUnbind = (0, $dqdTY.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$102d5db4df13f743$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $102d5db4df13f743$export$cabfb6cc8c48b099) {
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $102d5db4df13f743$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    event.source?.postMessage(ackPayload, {
                        targetOrigin: '*'
                    });
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
$102d5db4df13f743$export$e5e1a9c59c299631.displayName = "RovoPostMessagePubsubListener";
const $102d5db4df13f743$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $102d5db4df13f743$export$5340cc94dd0ecbea = ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $fsvuC.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $fsvuC.useState)(false);
    (0, $fsvuC.useEffect)(()=>{
        const handlerUnbind = (0, $dqdTY.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$102d5db4df13f743$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $102d5db4df13f743$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $fsvuC.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $102d5db4df13f743$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $102d5db4df13f743$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};

});
parcelRegister("6dtVG", function(module, exports) {
$parcel$export(module.exports, "useSubscribe", () => $f31a23bda9e06539$export$d3d523392640272);
$parcel$export(module.exports, "useSubscribeAll", () => $f31a23bda9e06539$export$2570c8aa24b6d327);
$parcel$export(module.exports, "usePublish", () => $f31a23bda9e06539$export$d55c81786220731c);
$parcel$export(module.exports, "Subscriber", () => $f31a23bda9e06539$export$60959659b2c22881);
/* eslint-disable @atlaskit/platform/one-value-export-per-file -- command callers cannot use hooks */ 
var $fsvuC = parcelRequire("fsvuC");
const $f31a23bda9e06539$var$MAX_CONSUMED_EVENT_KEYS = 5000;
const $f31a23bda9e06539$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed',
    'agent-editor-open-tools',
    // Internal signals that must never overwrite the publish queue — they would
    // cause `triggerLatest` subscribers (e.g. PubSubListener) to replay them
    // instead of the real action event (e.g. open-browse-agent-modal) that
    // originally opened the chat.
    'smartlinks-subscription-changed',
    'smartlinks-context-payload',
    'set-message-context',
    'jira-create-context-payload',
    'submit-rovo-remix',
    'rovo-remix-handoff-failed',
    'sync-prompt-input-draft'
]);
const $f31a23bda9e06539$var$isIgnoredForTriggerLatest = (type)=>$f31a23bda9e06539$var$ignoredTriggerLatestEvents.has(type);
const $f31a23bda9e06539$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let consumedEventKeys = new Set();
    let consumedEventKeyQueue = [];
    let subIdCounter = 0;
    let eventIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const createEvent = (payload)=>{
        eventIdCounter += 1;
        return {
            id: eventIdCounter.toString(),
            payload: payload
        };
    };
    const rememberConsumedEventKey = (claimKey)=>{
        consumedEventKeys.add(claimKey);
        consumedEventKeyQueue = [
            ...consumedEventKeyQueue,
            claimKey
        ];
        if (consumedEventKeyQueue.length > $f31a23bda9e06539$var$MAX_CONSUMED_EVENT_KEYS) {
            const [oldestClaimKey, ...remainingClaimKeys] = consumedEventKeyQueue;
            consumedEventKeyQueue = remainingClaimKeys;
            if (oldestClaimKey) consumedEventKeys.delete(oldestClaimKey);
        }
    };
    const claimConsumeOnceEvent = ({ event: event, consumeOnceKey: consumeOnceKey })=>{
        if (!event.payload.consumeOnce || !consumeOnceKey) return true;
        const claimKey = `${consumeOnceKey}:${event.id}`;
        if (consumedEventKeys.has(claimKey)) return false;
        rememberConsumedEventKey(claimKey);
        return true;
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest, consumeOnceKey: consumeOnceKey }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        const callbackWithConsumption = (event)=>{
            if (!claimConsumeOnceEvent({
                event: event,
                consumeOnceKey: consumeOnceKey
            })) return;
            callback(event.payload);
        };
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callbackWithConsumption,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const event = publishQueue[topic];
                callbackWithConsumption(event);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        const event = createEvent(payload);
        /**
		 * Log that this Topic received a published event, regardless of whether it has subscribers or not.
		 * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
		 */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$f31a23bda9e06539$var$isIgnoredForTriggerLatest(payload.type)) publishQueue[topic] = event;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(event.payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(event));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    const clearLatest = (topic)=>{
        delete publishQueue[topic];
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue,
        clearLatest: clearLatest
    };
};
const $f31a23bda9e06539$var$pubSub = $f31a23bda9e06539$var$createPubSub();
const $f31a23bda9e06539$export$89b472e03be495df = (topic, payload)=>{
    $f31a23bda9e06539$var$pubSub.publish(topic, payload);
};
const $f31a23bda9e06539$var$usePubSub = ()=>{
    return $f31a23bda9e06539$var$pubSub;
};
const $f31a23bda9e06539$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest, clearLatestOnUnmount: clearLatestOnUnmount, consumeOnceKey: consumeOnceKey }, callback)=>{
    const { subscribe: subscribe, clearLatest: clearLatest } = $f31a23bda9e06539$var$usePubSub();
    const callbackRef = (0, $fsvuC.useRef)(callback);
    callbackRef.current = callback;
    (0, $fsvuC.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest,
            consumeOnceKey: consumeOnceKey
        }, (...args)=>callbackRef.current(...args));
        return ()=>{
            unsubscribe();
            if (clearLatestOnUnmount) clearLatest(topic);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic,
        clearLatestOnUnmount,
        consumeOnceKey
    ]);
};
const $f31a23bda9e06539$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $f31a23bda9e06539$var$usePubSub();
    const callbackRef = (0, $fsvuC.useRef)(callback);
    callbackRef.current = callback;
    (0, $fsvuC.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $f31a23bda9e06539$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $f31a23bda9e06539$var$usePubSub();
    (0, $fsvuC.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $f31a23bda9e06539$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $f31a23bda9e06539$var$usePubSub();
    const publishFn = (0, $fsvuC.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $f31a23bda9e06539$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount, consumeOnceKey: consumeOnceKey })=>{
    $f31a23bda9e06539$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest,
        consumeOnceKey: consumeOnceKey
    }, onEvent);
    $f31a23bda9e06539$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};
$f31a23bda9e06539$export$60959659b2c22881.displayName = "Subscriber";

});


parcelRegister("T5sq6", function(module, exports) {
$parcel$export(module.exports, "StorageClient", () => $9f19b81d6bc39b61$export$6c85f5032e75eff9);

var $f6inj = parcelRequire("f6inj");

class $9f19b81d6bc39b61$export$6c85f5032e75eff9 {
    constructor(clientKey, options){
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || (0, $98fd96abde9f3719$export$3364800d9d60baf9);
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $f6inj.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
}

});
parcelRegister("f6inj", function(module, exports) {
$parcel$export(module.exports, "mockWindowStorage", () => $1a3f1ed38b6b4432$export$efebfe7859cae3c7);
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $1a3f1ed38b6b4432$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $1a3f1ed38b6b4432$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$1a3f1ed38b6b4432$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};

});

const $98fd96abde9f3719$export$3364800d9d60baf9 = 'localStorage';


parcelRegister("bGnNF", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b44857508271e26$export$2e2bcd8739ae039);

var $k5uvD = parcelRequire("k5uvD");
var $4b44857508271e26$export$2e2bcd8739ae039 = (0, $k5uvD.default);

});
parcelRegister("k5uvD", function(module, exports) {
$parcel$export(module.exports, "default", () => $446992eae529e249$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $6J97j = parcelRequire("6J97j");

var $9G3Hh = parcelRequire("9G3Hh");

var $22i4U = parcelRequire("22i4U");

var $7yHJR = parcelRequire("7yHJR");
const $446992eae529e249$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $fsvuC.useEffect) : (0, $fsvuC.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $446992eae529e249$var$useInteractionIdValue() {
    const interactionId = (0, $fsvuC.useContext)((0, $22i4U.default));
    const [currentId, setCurrentId] = (0, $fsvuC.useState)(interactionId?.current || null);
    $446992eae529e249$var$useLayoutEffectSAFE(()=>{
        setCurrentId(interactionId?.current || null);
        const unsubscribe = (0, $7yHJR.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $446992eae529e249$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true }) {
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $6J97j.isUFOEnabled)();
    const currentInteractionId = $446992eae529e249$var$useInteractionIdValue();
    // react-18: useId instead
    const context = (0, $fsvuC.useContext)((0, $9G3Hh.default));
    $446992eae529e249$var$useLayoutEffectSAFE(()=>{
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) return context.hold(name);
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: children
    }) : null;
}
$446992eae529e249$export$2e2bcd8739ae039.displayName = "UFOLoadHold";

});


parcelRegister("5PUly", function(module, exports) {
$parcel$export(module.exports, "componentWithFG", () => $fc8a379070988673$export$cf56d0f54cfcce4);

var $llCao = parcelRequire("llCao");

var $3Fp8y = parcelRequire("3Fp8y");
const $fc8a379070988673$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $3Fp8y.componentWithCondition)(()=>(0, $llCao.fg)(featureFlagName), ComponentTrue, ComponentFalse);

});

parcelRegister("eWXlB", function(module, exports) {
$parcel$export(module.exports, "default", () => $693f2764546d1cfc$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $hMTg4 = parcelRequire("hMTg4");

var $AlpUr = parcelRequire("AlpUr");

var $j6C1z = parcelRequire("j6C1z");
function $693f2764546d1cfc$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $j6C1z.useSafeIntl)();
    const messages = (0, $AlpUr.useMessages)(intl.locale, loaderFn);
    /**
	 * IntlProvider does not inherit from upstream IntlProviders,
	 * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
	 * This prevents the missing messages error.
	 */ const mergedMessages = (0, $fsvuC.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hMTg4.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}
$693f2764546d1cfc$export$2e2bcd8739ae039.displayName = "IntlMessagesProvider";

});
parcelRegister("AlpUr", function(module, exports) {
$parcel$export(module.exports, "useMessages", () => $8a4b3e6665607f92$export$4d17e2d9c5348842);

var $fsvuC = parcelRequire("fsvuC");

var $hPqet = parcelRequire("hPqet");
function $8a4b3e6665607f92$export$4d17e2d9c5348842(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $fsvuC.useState)((0, $hPqet.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $fsvuC.useRef)(localeState.locale);
    (0, $fsvuC.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}

});
parcelRegister("hPqet", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $df39ee88e46daff7$export$79618bef82c02d4c);
const $df39ee88e46daff7$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};

});


parcelRegister("j6C1z", function(module, exports) {
$parcel$export(module.exports, "useSafeIntl", () => $e300e91180a87faf$export$f752ac21ea3960a5);

var $fsvuC = parcelRequire("fsvuC");

var $iuaPl = parcelRequire("iuaPl");
var $cQb9u = parcelRequire("cQb9u");
var $hh8m9 = parcelRequire("hh8m9");

var $hPqet = parcelRequire("hPqet");
// Prevents memory leaks
const $e300e91180a87faf$var$cache = (0, $cQb9u.createIntlCache)();
const $e300e91180a87faf$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $fsvuC.useContext)((0, $hh8m9.Context));
    if (!context) return (0, $iuaPl.createIntl)((0, $hPqet.DEFAULT_LOCALE_STATE), $e300e91180a87faf$var$cache);
    return context;
};

});


parcelRegister("0NS3s", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => $2357248da82f55d2$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $2357248da82f55d2$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $2357248da82f55d2$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $2357248da82f55d2$var$tinyTransparentImage) nativeSetDragImage($2357248da82f55d2$var$tinyTransparentImage, 0, 0);
}

});

parcelRegister("8cDkT", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => $d063a77354875d12$export$453c0582481cc59d);

var $dqdTY = parcelRequire("dqdTY");

var $lCmze = parcelRequire("lCmze");
function $d063a77354875d12$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $d063a77354875d12$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $d063a77354875d12$var$start() {
    $d063a77354875d12$var$cleanup();
    $d063a77354875d12$var$unbindEvents = (0, $dqdTY.bindAll)(window, [
        {
            type: 'dragover',
            listener: $d063a77354875d12$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $d063a77354875d12$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $d063a77354875d12$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $d063a77354875d12$var$cleanup
        },
        ...(0, $lCmze.getBindingsForBrokenDrags)({
            onDragEnd: $d063a77354875d12$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $d063a77354875d12$var$cleanup() {
    $d063a77354875d12$var$unbindEvents?.();
    $d063a77354875d12$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $d063a77354875d12$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $d063a77354875d12$var$cleanup();
}
const $d063a77354875d12$export$453c0582481cc59d = {
    start: $d063a77354875d12$var$start,
    stop: $d063a77354875d12$var$stop
};

});

parcelRegister("dElcB", function(module, exports) {
$parcel$export(module.exports, "default", () => $9eff75181209f67c$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
function $9eff75181209f67c$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $fsvuC.useRef)(null);
    var maxWaitArgs = (0, $fsvuC.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $fsvuC.useRef)(false);
    var functionTimeoutHandler = (0, $fsvuC.useRef)(null);
    var isComponentUnmounted = (0, $fsvuC.useRef)(false);
    var debouncedFunction = (0, $fsvuC.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $fsvuC.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $fsvuC.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $fsvuC.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $fsvuC.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("99aEm", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $6a8d373313950d5f$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $6a8d373313950d5f$var$basePropertyOf;

});

parcelRegister("2CNTZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e95d6dd977c6ef1$export$2e2bcd8739ae039);

var $9wuDe = parcelRequire("9wuDe");

var $h2YWL = parcelRequire("h2YWL");

var $lVtiv = parcelRequire("lVtiv");

var $2jjr3 = parcelRequire("2jjr3");

var $ctJkm = parcelRequire("ctJkm");

var $fsvuC = parcelRequire("fsvuC");

var $armuk = parcelRequire("armuk");
var $1e95d6dd977c6ef1$var$isDevelopment = false;
var $1e95d6dd977c6ef1$var$testOmitPropsOnStringTag = (0, $armuk.default);
var $1e95d6dd977c6ef1$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $1e95d6dd977c6ef1$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $1e95d6dd977c6ef1$var$testOmitPropsOnStringTag : $1e95d6dd977c6ef1$var$testOmitPropsOnComponent;
};
var $1e95d6dd977c6ef1$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $1e95d6dd977c6ef1$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $ctJkm.registerStyles)(cache, serialized, isStringTag);
    (0, $2jjr3.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $ctJkm.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $1e95d6dd977c6ef1$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $1e95d6dd977c6ef1$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $1e95d6dd977c6ef1$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $h2YWL.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $fsvuC.useContext((0, $h2YWL.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $ctJkm.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $lVtiv.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $1e95d6dd977c6ef1$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $fsvuC.createElement($fsvuC.Fragment, null, /*#__PURE__*/ $fsvuC.createElement($1e95d6dd977c6ef1$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $fsvuC.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $1e95d6dd977c6ef1$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $9wuDe.default)({}, options, nextOptions, {
                shouldForwardProp: $1e95d6dd977c6ef1$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("armuk", function(module, exports) {
$parcel$export(module.exports, "default", () => $799ddeb4e8672467$export$2e2bcd8739ae039);

var $bPxW7 = parcelRequire("bPxW7");
// eslint-disable-next-line no-undef
var $799ddeb4e8672467$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $799ddeb4e8672467$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $bPxW7.default)(function(prop) {
    return $799ddeb4e8672467$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});


parcelRegister("fk1Yl", function(module, exports) {

var $3EaKU = parcelRequire("3EaKU");

var $f4aDX = parcelRequire("f4aDX");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $b27a40f216940e56$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $b27a40f216940e56$var$rsComboMarksRange = '\\u0300-\\u036f', $b27a40f216940e56$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $b27a40f216940e56$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $b27a40f216940e56$var$rsComboRange = $b27a40f216940e56$var$rsComboMarksRange + $b27a40f216940e56$var$reComboHalfMarksRange + $b27a40f216940e56$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $b27a40f216940e56$var$rsCombo = '[' + $b27a40f216940e56$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $b27a40f216940e56$var$reComboMark = RegExp($b27a40f216940e56$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $b27a40f216940e56$var$deburr(string) {
    string = $f4aDX(string);
    return string && string.replace($b27a40f216940e56$var$reLatin, $3EaKU).replace($b27a40f216940e56$var$reComboMark, '');
}
module.exports = $b27a40f216940e56$var$deburr;

});
parcelRegister("3EaKU", function(module, exports) {

var $99aEm = parcelRequire("99aEm");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $2a7d7363317e3bcc$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $2a7d7363317e3bcc$var$deburrLetter = $99aEm($2a7d7363317e3bcc$var$deburredLetters);
module.exports = $2a7d7363317e3bcc$var$deburrLetter;

});


parcelRegister("jbwXy", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3b2f97b6e6e078f$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $45KC3 = parcelRequire("45KC3");

var $17hIO = parcelRequire("17hIO");

var $llCao = parcelRequire("llCao");

var $bN1y6 = parcelRequire("bN1y6");

var $6J97j = parcelRequire("6J97j");

var $8Y1tf = parcelRequire("8Y1tf");

var $aXWJz = parcelRequire("aXWJz");

var $ktNMP = parcelRequire("ktNMP");

var $9G3Hh = parcelRequire("9G3Hh");

var $22i4U = parcelRequire("22i4U");

var $8IAtM = parcelRequire("8IAtM");

var $kAAlR = parcelRequire("kAAlR");

var $jkCOZ = parcelRequire("jkCOZ");

var $8DZGr = parcelRequire("8DZGr");

var $4EiT4 = parcelRequire("4EiT4");

var $ezPPc = parcelRequire("ezPPc");
let $e3b2f97b6e6e078f$var$tryCompleteHandle;
/** A portion of the page we apply measurement to */ const $e3b2f97b6e6e078f$var$UFOSegment = ({ name: segmentName, children: children, mode: mode = 'single', type: type = 'first-party', excludeFromMetrics: excludeFromMetrics = false })=>{
    // If UFO is disabled, render children without any tracking overhead
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $6J97j.isUFOEnabled)();
    const parentContext = (0, $fsvuC.useContext)((0, $9G3Hh.default));
    const segmentIdMap = (0, $fsvuC.useMemo)(()=>{
        if (!parentContext?.segmentIdMap) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    const segmentId = (0, $fsvuC.useMemo)(()=>{
        if (mode === 'single') return (0, $jkCOZ.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        const newSegmentId = (0, $jkCOZ.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    const labelStack = (0, $fsvuC.useMemo)(()=>{
        // Only stamp `excludeFromMetrics` alongside a third-party type.
        // So it can never remove first-party work from metrics.
        const label = {
            name: segmentName,
            segmentId: segmentId,
            ...type !== 'first-party' ? {
                type: type
            } : {},
            ...excludeFromMetrics && type === 'third-party' ? {
                excludeFromMetrics: true
            } : {}
        };
        return parentContext?.labelStack ? [
            ...parentContext.labelStack,
            label
        ] : [
            label
        ];
    }, [
        parentContext,
        segmentName,
        segmentId,
        type,
        excludeFromMetrics
    ]);
    const interactionId = (0, $fsvuC.useContext)((0, $22i4U.default));
    const interactionContext = (0, $fsvuC.useMemo)(()=>{
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($e3b2f97b6e6e078f$var$tryCompleteHandle) cancelAnimationFrame?.($e3b2f97b6e6e078f$var$tryCompleteHandle);
                    const onComplete = ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            const isPageVisible = globalThis?.document?.visibilityState === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $e3b2f97b6e6e078f$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $e3b2f97b6e6e078f$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $8IAtM.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $8IAtM.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    if ((0, $llCao.fg)('platform_ufo_native_task_scheduling')) (0, $8DZGr.default)(onComplete);
                    else (0, $45KC3.unstable_scheduleCallback)((0, $45KC3.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $8IAtM.addHold)(interactionId.current, labelStack, name, false);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $8IAtM.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $8IAtM.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                const minorInteractions = [
                    ...(0, $6J97j.getDoNotAbortActivePressInteraction)() ?? [],
                    ...(0, $6J97j.getMinorInteractions)() ?? []
                ];
                if (minorInteractions.includes(name)) {
                    const activeInteraction = (0, $8IAtM.getActiveInteraction)();
                    activeInteraction?.minorInteractions?.push({
                        name: name,
                        startTime: timestamp ?? performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, $8IAtM.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $6J97j.getInteractionRate)(name, 'press');
                if ((0, $bN1y6.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    const newId = (0, $17hIO.default)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $ktNMP.setInteractionActiveTrace)(newId, 'press');
                    (0, $8IAtM.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $kAAlR.default).current, (0, $aXWJz.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $8IAtM.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $8IAtM.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $8IAtM.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $8IAtM.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $8IAtM.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $8IAtM.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $8IAtM.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $8IAtM.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $4EiT4.default)(()=>{
                        const paintedTime = performance.now();
                        this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    const hasMounted = (0, $fsvuC.useRef)(false);
    const onRender = (0, $fsvuC.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((0, $6J97j.getConfig)()?.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $fsvuC.useEffect)(()=>{
        (0, $8IAtM.addSegment)(labelStack);
        return ()=>{
            (0, $8IAtM.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $fsvuC.useMemo)(()=>labelStack.map((l)=>(0, $8Y1tf.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    // If UFO is disabled, just render children without tracking overhead
    if (!ufoEnabled) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: children
    });
    const ufoSegment = /*#__PURE__*/ (0, $5chsV.jsx)((0, $9G3Hh.default).Provider, {
        value: interactionContext,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Profiler), {
            id: reactProfilerId,
            onRender: onRender,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $ezPPc.default), {
        labelStack: labelStack,
        onRender: (...args)=>interactionContext.onRender.apply(interactionContext, args),
        children: ufoSegment
    });
};
$e3b2f97b6e6e078f$var$UFOSegment.displayName = "UFOSegment";
$e3b2f97b6e6e078f$var$UFOSegment.displayName = 'UFOSegment';
var $e3b2f97b6e6e078f$export$2e2bcd8739ae039 = $e3b2f97b6e6e078f$var$UFOSegment;

});
parcelRegister("ktNMP", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $0a3a071f69095a9a$export$f2e521e495a88544);

var $1zIQ8 = parcelRequire("1zIQ8");

var $7n0IO = parcelRequire("7n0IO");
function $0a3a071f69095a9a$export$f2e521e495a88544(interactionId, experienceType) {
    (0, $7n0IO.setActiveTrace)(interactionId.replace(/-/g, ''), (0, $1zIQ8.generateSpanId)(), experienceType);
}

});
parcelRegister("1zIQ8", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $d7ad05bf5af92527$export$295213bc4d0c54ad);
// DO NOT CALL THIS FUNCTION DIRECTLY!!!!
// It is only to be called by React UFO libraries for the automatic handling of trace context for experiences.
// Calling this may cause trace context to be broken
function $d7ad05bf5af92527$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});


parcelRegister("jkCOZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0662f24ef14a1bb$export$2e2bcd8739ae039);
function $e0662f24ef14a1bb$var$generateId(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $e0662f24ef14a1bb$export$2e2bcd8739ae039 = $e0662f24ef14a1bb$var$generateId;

});

parcelRegister("8DZGr", function(module, exports) {
$parcel$export(module.exports, "default", () => $8fe5d1b020504f34$export$2e2bcd8739ae039);
const $8fe5d1b020504f34$var$getNativeScheduler = ()=>{
    const nativeScheduler = globalThis.scheduler;
    return typeof nativeScheduler?.postTask === 'function' ? nativeScheduler : undefined;
};
/**
 * Schedules `callback` as a normal-priority macrotask using native browser APIs.
 *
 * Native replacement for `unstable_scheduleCallback(unstable_NormalPriority, callback)` from the
 * `scheduler` npm package, which is being removed for React 19 compatibility.
 *
 * - Prefers the Prioritized Task Scheduling API (`scheduler.postTask`) with `user-visible`
 *   priority, the native equivalent of React's `NormalPriority`.
 *   https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
 * - Falls back to `setTimeout(callback, 0)` where `postTask` is unavailable (e.g. Safari, SSR).
 *
 * Note: unlike the `scheduler` package, this does not share React's internal task queue, so the
 * callback is not guaranteed to run after already-queued React work of the same priority.
 */ function $8fe5d1b020504f34$var$scheduleNormalPriorityTask(callback) {
    const nativeScheduler = $8fe5d1b020504f34$var$getNativeScheduler();
    if (nativeScheduler) {
        nativeScheduler.postTask(callback, {
            priority: 'user-visible'
        });
        return;
    }
    setTimeout(callback, 0);
}
var $8fe5d1b020504f34$export$2e2bcd8739ae039 = $8fe5d1b020504f34$var$scheduleNormalPriorityTask;

});

parcelRegister("ezPPc", function(module, exports) {
$parcel$export(module.exports, "default", () => $78768e36cde99641$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $fcnWW = parcelRequire("fcnWW");

var $loOYz = parcelRequire("loOYz");

var $hoalA = parcelRequire("hoalA");
const $78768e36cde99641$var$isInSSR = typeof false !== 'undefined' && false || typeof $hoalA !== 'undefined' && Boolean($hoalA?.env?.REACT_SSR || false);
const $78768e36cde99641$var$SsrRenderProfiler = (props)=>{
    if ($78768e36cde99641$var$isInSSR) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $loOYz.SsrRenderProfilerInner), {
        ...props
    });
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5chsV.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $fcnWW.ProfilerMarker), {}),
            props.children
        ]
    });
};
$78768e36cde99641$var$SsrRenderProfiler.displayName = "SsrRenderProfiler";
var $78768e36cde99641$export$2e2bcd8739ae039 = $78768e36cde99641$var$SsrRenderProfiler;

});
parcelRegister("fcnWW", function(module, exports) {
$parcel$export(module.exports, "ProfilerMarker", () => $480e0290a592a87d$export$18d523e2a9aac2d9);
const $480e0290a592a87d$export$18d523e2a9aac2d9 = ({ onRender: onRender })=>{
    onRender?.();
    return null;
};

});

parcelRegister("loOYz", function(module, exports) {
$parcel$export(module.exports, "SsrRenderProfilerInner", () => $bbc3b6d98475abdd$export$b8bd105b650b1c1e);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $6J97j = parcelRequire("6J97j");

var $8Y1tf = parcelRequire("8Y1tf");

var $8IAtM = parcelRequire("8IAtM");

var $1jo3W = parcelRequire("1jo3W");

var $fcnWW = parcelRequire("fcnWW");

var $fwsrq = parcelRequire("fwsrq");
function $bbc3b6d98475abdd$var$checkActiveInteractionAndResetStartMarksIfSet() {
    const activeInteractionId = (0, $8IAtM.getActiveInteraction)()?.id;
    if (!!(0, $fwsrq.default).lastActiveInteraction && (0, $fwsrq.default).lastActiveInteraction !== activeInteractionId) (0, $1jo3W.clearState)();
    (0, $fwsrq.default).lastActiveInteraction = activeInteractionId;
}
const $bbc3b6d98475abdd$var$getIsNativeTracingEnabled = ()=>(0, $6J97j.getConfig)()?.ssr?.enableNativeTracing ?? false;
const $bbc3b6d98475abdd$var$onStartRender = (id, currentSegmentName, parentContext)=>{
    if (!(0, $fwsrq.default).startTimes.has(id)) (0, $fwsrq.default).startTimes.set(id, []);
    (0, $fwsrq.default).startTimes.get(id)?.push(performance.now());
    if (!$bbc3b6d98475abdd$var$getIsNativeTracingEnabled()) return null;
    const startSpan = globalThis.__vm_internals__?.telemetry?.startSpan;
    let spanState = (0, $fwsrq.default).spanStates.get(id) ?? null;
    if (!spanState && startSpan) {
        const span = startSpan(currentSegmentName, {
            parentSpanId: parentContext?.spanId
        });
        spanState = {
            span: span
        };
        (0, $fwsrq.default).spanStates.set(id, spanState);
    }
    return spanState;
};
const $bbc3b6d98475abdd$var$ParentSpanContext = /*#__PURE__*/ (0, $fsvuC.createContext)(null);
const $bbc3b6d98475abdd$export$b8bd105b650b1c1e = ({ children: children, labelStack: labelStack, onRender: onRender })=>{
    const reactProfilerId = (0, $fsvuC.useMemo)(()=>labelStack.map((l)=>(0, $8Y1tf.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    $bbc3b6d98475abdd$var$checkActiveInteractionAndResetStartMarksIfSet();
    const parentSpan = (0, $fsvuC.useContext)($bbc3b6d98475abdd$var$ParentSpanContext);
    const currentSpanState = $bbc3b6d98475abdd$var$onStartRender(reactProfilerId, (0, $8Y1tf.sanitizeLabelStackName)(labelStack[labelStack.length - 1].name), parentSpan);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: /*#__PURE__*/ (0, $5chsV.jsxs)($bbc3b6d98475abdd$var$ParentSpanContext.Provider, {
            value: currentSpanState?.span.getSpanContext() ?? null,
            children: [
                children,
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $fcnWW.ProfilerMarker), {
                    onRender: ()=>{
                        const startTimesForId = (0, $fwsrq.default).startTimes.get(reactProfilerId);
                        if (startTimesForId?.length) {
                            const endTime = performance.now();
                            const firstStartTime = startTimesForId[0];
                            const lastStartTime = startTimesForId[startTimesForId.length - 1];
                            const baseDuration = endTime - lastStartTime;
                            const actualDuration = endTime - firstStartTime;
                            onRender('mount', actualDuration, baseDuration, firstStartTime, endTime);
                        }
                        const spanState = (0, $fwsrq.default).spanStates.get(reactProfilerId);
                        if (spanState) spanState.latestEndTime = performance.now();
                    }
                })
            ]
        })
    });
};
$bbc3b6d98475abdd$export$b8bd105b650b1c1e.displayName = "SsrRenderProfilerInner";

});
parcelRegister("1jo3W", function(module, exports) {
$parcel$export(module.exports, "clearState", () => $9bd9a9d2a74332dd$export$cf4e4023c0a34c8d);

var $fwsrq = parcelRequire("fwsrq");
const $9bd9a9d2a74332dd$export$cf4e4023c0a34c8d = ()=>{
    (0, $fwsrq.default).startTimes.clear();
    (0, $fwsrq.default).spanStates.clear();
};

});




parcelRegister("b4Gqj", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab788649cd97f3b7$export$2e2bcd8739ae039);

var $eoOW8 = parcelRequire("eoOW8");
var $ab788649cd97f3b7$export$2e2bcd8739ae039 = (0, $eoOW8.default);

});
parcelRegister("eoOW8", function(module, exports) {
$parcel$export(module.exports, "default", () => $61c70a2349b23816$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $9G3Hh = parcelRequire("9G3Hh");

var $dOQFV = parcelRequire("dOQFV");
/**
 * Annotate part of the react tree with a product name
 * ```
 * <UFOLabel name="card">
 *   <Card card={data} />
 * </UFOLabel>
 * ```
 */ const $61c70a2349b23816$var$UFOLabel = ({ name: name, children: children })=>{
    const context = (0, $dOQFV.useInteractionContext)();
    const newContext = (0, $fsvuC.useMemo)(()=>{
        if (context) return {
            ...context,
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [
                ...context.labelStack,
                {
                    name: name
                }
            ]
        };
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $9G3Hh.default).Provider, {
        value: newContext,
        children: children
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: children
    });
};
$61c70a2349b23816$var$UFOLabel.displayName = "UFOLabel";
$61c70a2349b23816$var$UFOLabel.displayName = 'UFOLabel';
var $61c70a2349b23816$export$2e2bcd8739ae039 = $61c70a2349b23816$var$UFOLabel;

});


parcelRegister("623DQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3cda71a20071bdb$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");

var $9G3Hh = parcelRequire("9G3Hh");
function $c3cda71a20071bdb$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $fsvuC.useContext)((0, $9G3Hh.default));
    (0, $fsvuC.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof globalThis?.structuredClone === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}

});

parcelRegister("RaKlO", function(module, exports) {
$parcel$export(module.exports, "getUrlForDomainInContext", () => $fc93a7bb949ff54c$export$c162de1e7fecc908);

var $1rs8z = parcelRequire("1rs8z");
function $fc93a7bb949ff54c$export$c162de1e7fecc908(subdomain, envType) {
    const domain = (0, $1rs8z.getDomainInContext)(subdomain, envType);
    if (!domain) {
        console.warn(`Domain could not be determined for requested subdomain: ${subdomain}`);
        return undefined;
    }
    return `${globalThis.location?.protocol ?? 'https:'}//${domain}`;
}

});
parcelRegister("1rs8z", function(module, exports) {
$parcel$export(module.exports, "getDomainInContext", () => $dde851cec6793aca$export$3f82b86ecb947bf0);


var $1Mfou = parcelRequire("1Mfou");

var $5Z1ks = parcelRequire("5Z1ks");

var $ljPPo = parcelRequire("ljPPo");

var $dJiMy = parcelRequire("dJiMy");

var $aANsA = parcelRequire("aANsA");
function $dde851cec6793aca$var$getDomainForIsolatedCloud(subdomain, perimeter, isolatedCloudDomain) {
    const domainMappings = (0, $aANsA.isolatedCloudFunctions)[perimeter];
    if ((0, $aANsA.ReservedNameMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudReservedNameDomain(subdomain, isolatedCloudDomain);
    if ((0, $aANsA.AtlDomainMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudAtlDomain(subdomain, isolatedCloudDomain);
    return domainMappings.isolatedCloudVanityDomain(subdomain, isolatedCloudDomain);
}
function $dde851cec6793aca$var$getDomainForNonIsolatedCloud(subdomain, perimeter, envType) {
    // First, check if the subdomain is associated with a global domain
    if ((0, $5Z1ks.globalDomains)[subdomain]) return (0, $5Z1ks.globalDomains)[subdomain];
    // Second, check if the subdomain is associated with a full domain override (ex. a domain that uses a different pattern in other perimeters/environments)
    const override = (0, $1Mfou.fullDomainOverride)[subdomain]?.[perimeter]?.[envType];
    if (override) return override;
    // Use default domain ending for the given perimeter
    const domainMappings = (0, $aANsA.nonIsolatedCloudFunctions)[perimeter];
    return domainMappings.defaultDomainEnding(subdomain, envType);
}
function $dde851cec6793aca$export$3f82b86ecb947bf0(subdomain, envType) {
    const currentCloudEnvironment = (0, $ljPPo.cloudEnvironment)();
    if (currentCloudEnvironment === undefined) return undefined;
    if (currentCloudEnvironment.type === 'isolated-cloud') {
        const domain = (0, $dJiMy.isolatedCloudDomain)();
        if (domain === undefined) return undefined;
        return $dde851cec6793aca$var$getDomainForIsolatedCloud(subdomain, (0, $9924ccd0a7eb3f48$export$f005e2e9f707cb5f), domain);
    }
    return $dde851cec6793aca$var$getDomainForNonIsolatedCloud(subdomain, currentCloudEnvironment.perimeter, envType);
}

});
const $9924ccd0a7eb3f48$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $9924ccd0a7eb3f48$export$f005e2e9f707cb5f = 'commercial';
const $9924ccd0a7eb3f48$export$17b81a3d6c98013c = 'isolated-cloud';
const $9924ccd0a7eb3f48$export$a739cd5aac835909 = 'staging';
const $9924ccd0a7eb3f48$export$42dd0cdd351a4a9 = 'prod';
const $9924ccd0a7eb3f48$export$404582bc18fe4d9e = 'dev';
const $9924ccd0a7eb3f48$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $9924ccd0a7eb3f48$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $9924ccd0a7eb3f48$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $9924ccd0a7eb3f48$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $9924ccd0a7eb3f48$export$b61e047ddcc35726 = 'GCP';
const $9924ccd0a7eb3f48$export$1baf17f3e645a2b2 = 'AWS';

parcelRegister("1Mfou", function(module, exports) {
$parcel$export(module.exports, "fullDomainOverride", () => $23e851071e279d57$export$4723232b625f823e);

const $23e851071e279d57$export$4723232b625f823e = {
    id: {
        [(0, $9924ccd0a7eb3f48$export$f005e2e9f707cb5f)]: {
            [(0, $9924ccd0a7eb3f48$export$42dd0cdd351a4a9)]: 'id.atlassian.com',
            [(0, $9924ccd0a7eb3f48$export$a739cd5aac835909)]: 'id.stg.internal.atlassian.com',
            [(0, $9924ccd0a7eb3f48$export$404582bc18fe4d9e)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $9924ccd0a7eb3f48$export$ce553301d55c2fd8)]: {
            [(0, $9924ccd0a7eb3f48$export$42dd0cdd351a4a9)]: 'id.atlassian-us-gov-mod.com',
            [(0, $9924ccd0a7eb3f48$export$a739cd5aac835909)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    }
};

});

parcelRegister("5Z1ks", function(module, exports) {
$parcel$export(module.exports, "globalDomains", () => $841ae6d7868998ce$export$cfd430a73d68f4bc);
const $841ae6d7868998ce$export$cfd430a73d68f4bc = {
    confluence: 'confluence.atlassian.com',
    design: 'design.atlassian.com',
    extranet: 'extranet.atlassian.com',
    go: 'go.atlassian.com',
    my: 'my.atlassian.com',
    surveys: 'surveys.atlassian.com',
    'wac-cdn': 'wac-cdn.atlassian.com',
    integrations: 'integrations.atlassian.com',
    permalink: 'permalink.atlassian.com',
    support: 'support.atlassian.com'
};

});

parcelRegister("ljPPo", function(module, exports) {
$parcel$export(module.exports, "cloudEnvironment", () => $b83eb8a2391b37ef$export$9e04105551ffc5c4);


var $avVuU = parcelRequire("avVuU");

var $27c9v = parcelRequire("27c9v");
function $b83eb8a2391b37ef$var$cloudEnvironmentSsrLookup() {
    // @ts-ignore
    if (globalThis.ssrContext?.isInIC === true) return {
        type: 'isolated-cloud',
        perimeter: (0, $9924ccd0a7eb3f48$export$f005e2e9f707cb5f)
    };
    // @ts-ignore
    if (globalThis.ssrContext?.isInFedramp === true) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $9924ccd0a7eb3f48$export$ce553301d55c2fd8)
    };
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $9924ccd0a7eb3f48$export$f005e2e9f707cb5f)
    };
}
function $b83eb8a2391b37ef$var$cloudEnvironmentCookieLookup() {
    // Avoid calling isFedrampModerate() and isIsolatedCloud() here to avoid repeated cookie parsing
    const atlCtxCookieValues = (0, $27c9v.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $9924ccd0a7eb3f48$export$f005e2e9f707cb5f)
    };
    const isIc = (0, $avVuU.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
    if (isIc) return {
        type: 'isolated-cloud',
        perimeter: (0, $9924ccd0a7eb3f48$export$f005e2e9f707cb5f)
    };
    if (atlCtxCookieValues.perimeter === (0, $9924ccd0a7eb3f48$export$ce553301d55c2fd8)) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $9924ccd0a7eb3f48$export$ce553301d55c2fd8)
    };
    // If a new cloud environment has been created but not added to this library, return undefined
    return undefined;
}
function $b83eb8a2391b37ef$export$9e04105551ffc5c4() {
    if (typeof document === 'undefined') return $b83eb8a2391b37ef$var$cloudEnvironmentSsrLookup();
    return $b83eb8a2391b37ef$var$cloudEnvironmentCookieLookup();
}

});

parcelRegister("dJiMy", function(module, exports) {
$parcel$export(module.exports, "isolatedCloudDomain", () => $39ba88c25b2bca34$export$80638ee198476daf);

var $27c9v = parcelRequire("27c9v");
function $39ba88c25b2bca34$export$80638ee198476daf() {
    if (typeof document === 'undefined') return globalThis.location?.hostname;
    const atlCtxCookieValues = (0, $27c9v.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icDomain;
}

});

parcelRegister("aANsA", function(module, exports) {
$parcel$export(module.exports, "ReservedNameMapping", () => $72ab7111150f3afe$export$5860df3acd1ee020);
$parcel$export(module.exports, "AtlDomainMapping", () => $72ab7111150f3afe$export$c6366754aee43afa);
$parcel$export(module.exports, "isolatedCloudFunctions", () => $72ab7111150f3afe$export$ad1f7afdb45ad83);
$parcel$export(module.exports, "nonIsolatedCloudFunctions", () => $72ab7111150f3afe$export$c3b4bc58a05128d6);

const $72ab7111150f3afe$export$5860df3acd1ee020 = {
    [(0, $9924ccd0a7eb3f48$export$f005e2e9f707cb5f)]: [
        'home',
        'team',
        'start',
        'id',
        'api',
        'admin',
        'auth',
        'bitbucket'
    ]
};
const $72ab7111150f3afe$export$c6366754aee43afa = {
    [(0, $9924ccd0a7eb3f48$export$f005e2e9f707cb5f)]: [
        'packages'
    ]
};
const $72ab7111150f3afe$export$ad1f7afdb45ad83 = {
    [(0, $9924ccd0a7eb3f48$export$f005e2e9f707cb5f)]: {
        isolatedCloudReservedNameDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.${isolatedCloudDomain}`,
        isolatedCloudAtlDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.atl.${isolatedCloudDomain}`,
        isolatedCloudVanityDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.services.${isolatedCloudDomain}`
    }
};
const $72ab7111150f3afe$export$c3b4bc58a05128d6 = {
    [(0, $9924ccd0a7eb3f48$export$f005e2e9f707cb5f)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $9924ccd0a7eb3f48$export$42dd0cdd351a4a9:
                    return `${subdomain}.atlassian.com`;
                case 0, $9924ccd0a7eb3f48$export$a739cd5aac835909:
                    return `${subdomain}.stg.atlassian.com`;
                case 0, $9924ccd0a7eb3f48$export$404582bc18fe4d9e:
                    return `${subdomain}.dev.atlassian.com`;
                default:
                    console.warn(`Cannot get non-isolated commercial domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    },
    [(0, $9924ccd0a7eb3f48$export$ce553301d55c2fd8)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $9924ccd0a7eb3f48$export$42dd0cdd351a4a9:
                    return `${subdomain}.atlassian-us-gov-mod.com`;
                case 0, $9924ccd0a7eb3f48$export$a739cd5aac835909:
                    return `${subdomain}.stg.atlassian-us-gov-mod.com`;
                default:
                    console.warn(`Cannot get fedramp-moderate domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    }
};

});



parcelRegister("gJX1v", function(module, exports) {

var $39O37 = parcelRequire("39O37");

var $i2PXL = parcelRequire("i2PXL");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $c2fea214d489945d$var$camelCase = $i2PXL(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $39O37(word) : word);
});
module.exports = $c2fea214d489945d$var$camelCase;

});
parcelRegister("i2PXL", function(module, exports) {

var $k1UhI = parcelRequire("k1UhI");

var $fk1Yl = parcelRequire("fk1Yl");

var $1hllW = parcelRequire("1hllW");
/** Used to compose unicode capture groups. */ var $d230b8a799bb77ad$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $d230b8a799bb77ad$var$reApos = RegExp($d230b8a799bb77ad$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $d230b8a799bb77ad$var$createCompounder(callback) {
    return function(string) {
        return $k1UhI($1hllW($fk1Yl(string).replace($d230b8a799bb77ad$var$reApos, '')), callback, '');
    };
}
module.exports = $d230b8a799bb77ad$var$createCompounder;

});
parcelRegister("k1UhI", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $e94f8fa3b6aabad3$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $e94f8fa3b6aabad3$var$arrayReduce;

});

parcelRegister("1hllW", function(module, exports) {

var $7S3kD = parcelRequire("7S3kD");

var $9g9J4 = parcelRequire("9g9J4");

var $f4aDX = parcelRequire("f4aDX");

var $ayX5U = parcelRequire("ayX5U");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $0ee7f139939284c4$var$words(string, pattern, guard) {
    string = $f4aDX(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $9g9J4(string) ? $ayX5U(string) : $7S3kD(string);
    return string.match(pattern) || [];
}
module.exports = $0ee7f139939284c4$var$words;

});
parcelRegister("7S3kD", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $5bb02930bb391392$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $5bb02930bb391392$var$asciiWords(string) {
    return string.match($5bb02930bb391392$var$reAsciiWord) || [];
}
module.exports = $5bb02930bb391392$var$asciiWords;

});

parcelRegister("9g9J4", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $6bdd270f37ac775e$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $6bdd270f37ac775e$var$hasUnicodeWord(string) {
    return $6bdd270f37ac775e$var$reHasUnicodeWord.test(string);
}
module.exports = $6bdd270f37ac775e$var$hasUnicodeWord;

});

parcelRegister("ayX5U", function(module, exports) {
/** Used to compose unicode character classes. */ var $7b0aeb4060f1f239$var$rsAstralRange = '\\ud800-\\udfff', $7b0aeb4060f1f239$var$rsComboMarksRange = '\\u0300-\\u036f', $7b0aeb4060f1f239$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $7b0aeb4060f1f239$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $7b0aeb4060f1f239$var$rsComboRange = $7b0aeb4060f1f239$var$rsComboMarksRange + $7b0aeb4060f1f239$var$reComboHalfMarksRange + $7b0aeb4060f1f239$var$rsComboSymbolsRange, $7b0aeb4060f1f239$var$rsDingbatRange = '\\u2700-\\u27bf', $7b0aeb4060f1f239$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $7b0aeb4060f1f239$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $7b0aeb4060f1f239$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $7b0aeb4060f1f239$var$rsPunctuationRange = '\\u2000-\\u206f', $7b0aeb4060f1f239$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $7b0aeb4060f1f239$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $7b0aeb4060f1f239$var$rsVarRange = '\\ufe0e\\ufe0f', $7b0aeb4060f1f239$var$rsBreakRange = $7b0aeb4060f1f239$var$rsMathOpRange + $7b0aeb4060f1f239$var$rsNonCharRange + $7b0aeb4060f1f239$var$rsPunctuationRange + $7b0aeb4060f1f239$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $7b0aeb4060f1f239$var$rsApos = "['\u2019]", $7b0aeb4060f1f239$var$rsBreak = '[' + $7b0aeb4060f1f239$var$rsBreakRange + ']', $7b0aeb4060f1f239$var$rsCombo = '[' + $7b0aeb4060f1f239$var$rsComboRange + ']', $7b0aeb4060f1f239$var$rsDigits = '\\d+', $7b0aeb4060f1f239$var$rsDingbat = '[' + $7b0aeb4060f1f239$var$rsDingbatRange + ']', $7b0aeb4060f1f239$var$rsLower = '[' + $7b0aeb4060f1f239$var$rsLowerRange + ']', $7b0aeb4060f1f239$var$rsMisc = '[^' + $7b0aeb4060f1f239$var$rsAstralRange + $7b0aeb4060f1f239$var$rsBreakRange + $7b0aeb4060f1f239$var$rsDigits + $7b0aeb4060f1f239$var$rsDingbatRange + $7b0aeb4060f1f239$var$rsLowerRange + $7b0aeb4060f1f239$var$rsUpperRange + ']', $7b0aeb4060f1f239$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $7b0aeb4060f1f239$var$rsModifier = '(?:' + $7b0aeb4060f1f239$var$rsCombo + '|' + $7b0aeb4060f1f239$var$rsFitz + ')', $7b0aeb4060f1f239$var$rsNonAstral = '[^' + $7b0aeb4060f1f239$var$rsAstralRange + ']', $7b0aeb4060f1f239$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $7b0aeb4060f1f239$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $7b0aeb4060f1f239$var$rsUpper = '[' + $7b0aeb4060f1f239$var$rsUpperRange + ']', $7b0aeb4060f1f239$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $7b0aeb4060f1f239$var$rsMiscLower = '(?:' + $7b0aeb4060f1f239$var$rsLower + '|' + $7b0aeb4060f1f239$var$rsMisc + ')', $7b0aeb4060f1f239$var$rsMiscUpper = '(?:' + $7b0aeb4060f1f239$var$rsUpper + '|' + $7b0aeb4060f1f239$var$rsMisc + ')', $7b0aeb4060f1f239$var$rsOptContrLower = '(?:' + $7b0aeb4060f1f239$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $7b0aeb4060f1f239$var$rsOptContrUpper = '(?:' + $7b0aeb4060f1f239$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $7b0aeb4060f1f239$var$reOptMod = $7b0aeb4060f1f239$var$rsModifier + '?', $7b0aeb4060f1f239$var$rsOptVar = '[' + $7b0aeb4060f1f239$var$rsVarRange + ']?', $7b0aeb4060f1f239$var$rsOptJoin = '(?:' + $7b0aeb4060f1f239$var$rsZWJ + '(?:' + [
    $7b0aeb4060f1f239$var$rsNonAstral,
    $7b0aeb4060f1f239$var$rsRegional,
    $7b0aeb4060f1f239$var$rsSurrPair
].join('|') + ')' + $7b0aeb4060f1f239$var$rsOptVar + $7b0aeb4060f1f239$var$reOptMod + ')*', $7b0aeb4060f1f239$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $7b0aeb4060f1f239$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $7b0aeb4060f1f239$var$rsSeq = $7b0aeb4060f1f239$var$rsOptVar + $7b0aeb4060f1f239$var$reOptMod + $7b0aeb4060f1f239$var$rsOptJoin, $7b0aeb4060f1f239$var$rsEmoji = '(?:' + [
    $7b0aeb4060f1f239$var$rsDingbat,
    $7b0aeb4060f1f239$var$rsRegional,
    $7b0aeb4060f1f239$var$rsSurrPair
].join('|') + ')' + $7b0aeb4060f1f239$var$rsSeq;
/** Used to match complex or compound words. */ var $7b0aeb4060f1f239$var$reUnicodeWord = RegExp([
    $7b0aeb4060f1f239$var$rsUpper + '?' + $7b0aeb4060f1f239$var$rsLower + '+' + $7b0aeb4060f1f239$var$rsOptContrLower + '(?=' + [
        $7b0aeb4060f1f239$var$rsBreak,
        $7b0aeb4060f1f239$var$rsUpper,
        '$'
    ].join('|') + ')',
    $7b0aeb4060f1f239$var$rsMiscUpper + '+' + $7b0aeb4060f1f239$var$rsOptContrUpper + '(?=' + [
        $7b0aeb4060f1f239$var$rsBreak,
        $7b0aeb4060f1f239$var$rsUpper + $7b0aeb4060f1f239$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $7b0aeb4060f1f239$var$rsUpper + '?' + $7b0aeb4060f1f239$var$rsMiscLower + '+' + $7b0aeb4060f1f239$var$rsOptContrLower,
    $7b0aeb4060f1f239$var$rsUpper + '+' + $7b0aeb4060f1f239$var$rsOptContrUpper,
    $7b0aeb4060f1f239$var$rsOrdUpper,
    $7b0aeb4060f1f239$var$rsOrdLower,
    $7b0aeb4060f1f239$var$rsDigits,
    $7b0aeb4060f1f239$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $7b0aeb4060f1f239$var$unicodeWords(string) {
    return string.match($7b0aeb4060f1f239$var$reUnicodeWord) || [];
}
module.exports = $7b0aeb4060f1f239$var$unicodeWords;

});




parcelRegister("ctgTR", function(module, exports) {

var $i2PXL = parcelRequire("i2PXL");
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $91454d718f6f197c$var$kebabCase = $i2PXL(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $91454d718f6f197c$var$kebabCase;

});

parcelRegister("czlIv", function(module, exports) {
$parcel$export(module.exports, "z", () => (parcelRequire("g3khG")));

var $g3khG = parcelRequire("g3khG");

var $9269996eed87807b$export$2e2bcd8739ae039 = $g3khG;

});
parcelRegister("g3khG", function(module, exports) {

var $gpYaW = parcelRequire("gpYaW");

var $6oKOk = parcelRequire("6oKOk");

var $j2kaC = parcelRequire("j2kaC");

var $ggoEV = parcelRequire("ggoEV");

var $a3jia = parcelRequire("a3jia");

var $9MMus = parcelRequire("9MMus");
$parcel$exportWildcard(module.exports, $gpYaW);
$parcel$exportWildcard(module.exports, $6oKOk);
$parcel$exportWildcard(module.exports, $j2kaC);
$parcel$exportWildcard(module.exports, $ggoEV);
$parcel$exportWildcard(module.exports, $a3jia);
$parcel$exportWildcard(module.exports, $9MMus);

});
parcelRegister("gpYaW", function(module, exports) {
$parcel$export(module.exports, "setErrorMap", () => $bf3da8bf49e1158f$export$1097a8289cfd22d7);
$parcel$export(module.exports, "getErrorMap", () => $bf3da8bf49e1158f$export$32f27c719778d4c4);
$parcel$export(module.exports, "defaultErrorMap", () => (parcelRequire("jsANS")).default);

var $jsANS = parcelRequire("jsANS");
let $bf3da8bf49e1158f$var$overrideErrorMap = (0, $jsANS.default);
function $bf3da8bf49e1158f$export$1097a8289cfd22d7(map) {
    $bf3da8bf49e1158f$var$overrideErrorMap = map;
}
function $bf3da8bf49e1158f$export$32f27c719778d4c4() {
    return $bf3da8bf49e1158f$var$overrideErrorMap;
}

});
parcelRegister("jsANS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2ad2e3ed7ec998d$export$2e2bcd8739ae039);

var $9MMus = parcelRequire("9MMus");

var $ggoEV = parcelRequire("ggoEV");
const $e2ad2e3ed7ec998d$var$errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case (0, $9MMus.ZodIssueCode).invalid_type:
            if (issue.received === (0, $ggoEV.ZodParsedType).undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case (0, $9MMus.ZodIssueCode).invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, (0, $ggoEV.util).jsonStringifyReplacer)}`;
            break;
        case (0, $9MMus.ZodIssueCode).unrecognized_keys:
            message = `Unrecognized key(s) in object: ${(0, $ggoEV.util).joinValues(issue.keys, ", ")}`;
            break;
        case (0, $9MMus.ZodIssueCode).invalid_union:
            message = `Invalid input`;
            break;
        case (0, $9MMus.ZodIssueCode).invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${(0, $ggoEV.util).joinValues(issue.options)}`;
            break;
        case (0, $9MMus.ZodIssueCode).invalid_enum_value:
            message = `Invalid enum value. Expected ${(0, $ggoEV.util).joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case (0, $9MMus.ZodIssueCode).invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case (0, $9MMus.ZodIssueCode).invalid_return_type:
            message = `Invalid function return type`;
            break;
        case (0, $9MMus.ZodIssueCode).invalid_date:
            message = `Invalid date`;
            break;
        case (0, $9MMus.ZodIssueCode).invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else (0, $ggoEV.util).assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case (0, $9MMus.ZodIssueCode).too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "bigint") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case (0, $9MMus.ZodIssueCode).too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case (0, $9MMus.ZodIssueCode).custom:
            message = `Invalid input`;
            break;
        case (0, $9MMus.ZodIssueCode).invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case (0, $9MMus.ZodIssueCode).not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case (0, $9MMus.ZodIssueCode).not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            (0, $ggoEV.util).assertNever(issue);
    }
    return {
        message: message
    };
};
var $e2ad2e3ed7ec998d$export$2e2bcd8739ae039 = $e2ad2e3ed7ec998d$var$errorMap;

});
parcelRegister("9MMus", function(module, exports) {
$parcel$export(module.exports, "ZodIssueCode", () => $71fe35e8920ec06a$export$5ba560653e4a1035);
$parcel$export(module.exports, "quotelessJson", () => $71fe35e8920ec06a$export$913eddeaf297cfea);
$parcel$export(module.exports, "ZodError", () => $71fe35e8920ec06a$export$f98dac4b251ab333);

var $ggoEV = parcelRequire("ggoEV");
const $71fe35e8920ec06a$export$5ba560653e4a1035 = (0, $ggoEV.util).arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $71fe35e8920ec06a$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $71fe35e8920ec06a$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $71fe35e8920ec06a$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, (0, $ggoEV.util).jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            const firstEl = sub.path[0];
            fieldErrors[firstEl] = fieldErrors[firstEl] || [];
            fieldErrors[firstEl].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$71fe35e8920ec06a$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $71fe35e8920ec06a$export$f98dac4b251ab333(issues);
    return error;
};

});
parcelRegister("ggoEV", function(module, exports) {
$parcel$export(module.exports, "util", () => $bd7144c3f5f4dc52$export$7debb50ef11d5e0b);
$parcel$export(module.exports, "objectUtil", () => $bd7144c3f5f4dc52$export$4aa2142c225fd5c7);
$parcel$export(module.exports, "ZodParsedType", () => $bd7144c3f5f4dc52$export$5716da67bfaa244d);
$parcel$export(module.exports, "getParsedType", () => $bd7144c3f5f4dc52$export$3e9057828ebd5c7a);
var $bd7144c3f5f4dc52$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($bd7144c3f5f4dc52$export$7debb50ef11d5e0b || ($bd7144c3f5f4dc52$export$7debb50ef11d5e0b = {}));
var $bd7144c3f5f4dc52$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($bd7144c3f5f4dc52$export$4aa2142c225fd5c7 || ($bd7144c3f5f4dc52$export$4aa2142c225fd5c7 = {}));
const $bd7144c3f5f4dc52$export$5716da67bfaa244d = $bd7144c3f5f4dc52$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $bd7144c3f5f4dc52$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $bd7144c3f5f4dc52$export$5716da67bfaa244d.undefined;
        case "string":
            return $bd7144c3f5f4dc52$export$5716da67bfaa244d.string;
        case "number":
            return Number.isNaN(data) ? $bd7144c3f5f4dc52$export$5716da67bfaa244d.nan : $bd7144c3f5f4dc52$export$5716da67bfaa244d.number;
        case "boolean":
            return $bd7144c3f5f4dc52$export$5716da67bfaa244d.boolean;
        case "function":
            return $bd7144c3f5f4dc52$export$5716da67bfaa244d.function;
        case "bigint":
            return $bd7144c3f5f4dc52$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $bd7144c3f5f4dc52$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $bd7144c3f5f4dc52$export$5716da67bfaa244d.array;
            if (data === null) return $bd7144c3f5f4dc52$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $bd7144c3f5f4dc52$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $bd7144c3f5f4dc52$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $bd7144c3f5f4dc52$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $bd7144c3f5f4dc52$export$5716da67bfaa244d.date;
            return $bd7144c3f5f4dc52$export$5716da67bfaa244d.object;
        default:
            return $bd7144c3f5f4dc52$export$5716da67bfaa244d.unknown;
    }
};

});




parcelRegister("6oKOk", function(module, exports) {
$parcel$export(module.exports, "makeIssue", () => $4a894b9cfe90102c$export$244a85fde9c419ed);
$parcel$export(module.exports, "EMPTY_PATH", () => $4a894b9cfe90102c$export$1526d2e05f74572);
$parcel$export(module.exports, "addIssueToContext", () => $4a894b9cfe90102c$export$db7caee60e5d514d);
$parcel$export(module.exports, "ParseStatus", () => $4a894b9cfe90102c$export$5b20a5c3d05c1f6f);
$parcel$export(module.exports, "INVALID", () => $4a894b9cfe90102c$export$9a105a556e65c2c0);
$parcel$export(module.exports, "DIRTY", () => $4a894b9cfe90102c$export$325a211da9693fcf);
$parcel$export(module.exports, "OK", () => $4a894b9cfe90102c$export$c6813a8d51f77eaf);
$parcel$export(module.exports, "isAborted", () => $4a894b9cfe90102c$export$afa861e3c5730743);
$parcel$export(module.exports, "isDirty", () => $4a894b9cfe90102c$export$910b6cdd390341b3);
$parcel$export(module.exports, "isValid", () => $4a894b9cfe90102c$export$1ea939691cdc45b8);
$parcel$export(module.exports, "isAsync", () => $4a894b9cfe90102c$export$aefee5ebe1dcfd9e);

var $gpYaW = parcelRequire("gpYaW");

var $jsANS = parcelRequire("jsANS");
const $4a894b9cfe90102c$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $4a894b9cfe90102c$export$1526d2e05f74572 = [];
function $4a894b9cfe90102c$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = (0, $gpYaW.getErrorMap)();
    const issue = $4a894b9cfe90102c$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === (0, $jsANS.default) ? undefined : (0, $jsANS.default)
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $4a894b9cfe90102c$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $4a894b9cfe90102c$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $4a894b9cfe90102c$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $4a894b9cfe90102c$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $4a894b9cfe90102c$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $4a894b9cfe90102c$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $4a894b9cfe90102c$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $4a894b9cfe90102c$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $4a894b9cfe90102c$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $4a894b9cfe90102c$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $4a894b9cfe90102c$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $4a894b9cfe90102c$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;

});

parcelRegister("j2kaC", function(module, exports) {

});

parcelRegister("a3jia", function(module, exports) {
$parcel$export(module.exports, "ZodType", () => $751926319bc7e827$export$2afb8ab49d4b92c0);
$parcel$export(module.exports, "ZodEffects", () => $751926319bc7e827$export$a60af00cc0ce2582);
$parcel$export(module.exports, "ZodFirstPartyTypeKind", () => $751926319bc7e827$export$558106ce543bd011);
$parcel$export(module.exports, "ZodOptional", () => $751926319bc7e827$export$aa56fec1e9d629b8);
$parcel$export(module.exports, "ZodNullable", () => $751926319bc7e827$export$aaac0b8b429cef5);
$parcel$export(module.exports, "ZodArray", () => $751926319bc7e827$export$7acfc3e64785411);
$parcel$export(module.exports, "ZodPromise", () => $751926319bc7e827$export$3f196b0127d6e50a);
$parcel$export(module.exports, "ZodUnion", () => $751926319bc7e827$export$a8b236cb5070a311);
$parcel$export(module.exports, "ZodIntersection", () => $751926319bc7e827$export$c02deaf0bb5203d4);
$parcel$export(module.exports, "ZodDefault", () => $751926319bc7e827$export$bb19b37874861e7e);
$parcel$export(module.exports, "ZodBranded", () => $751926319bc7e827$export$66b0c798a395271f);
$parcel$export(module.exports, "ZodCatch", () => $751926319bc7e827$export$75a44ec6249ac76b);
$parcel$export(module.exports, "ZodPipeline", () => $751926319bc7e827$export$a3c3ef8a0e95c6da);
$parcel$export(module.exports, "ZodReadonly", () => $751926319bc7e827$export$5d1f7ef05c4e493a);
$parcel$export(module.exports, "datetimeRegex", () => $751926319bc7e827$export$a4b563879add27a);
$parcel$export(module.exports, "ZodString", () => $751926319bc7e827$export$1230eb29b8d3b502);
$parcel$export(module.exports, "ZodNumber", () => $751926319bc7e827$export$5b070a55c0c43e09);
$parcel$export(module.exports, "ZodBigInt", () => $751926319bc7e827$export$67d741fd70ff98f4);
$parcel$export(module.exports, "ZodBoolean", () => $751926319bc7e827$export$723d146f80596191);
$parcel$export(module.exports, "ZodDate", () => $751926319bc7e827$export$e974be33bdc55521);
$parcel$export(module.exports, "ZodSymbol", () => $751926319bc7e827$export$bcc3b40f6b638044);
$parcel$export(module.exports, "ZodUndefined", () => $751926319bc7e827$export$4e780e961c30340d);
$parcel$export(module.exports, "ZodNull", () => $751926319bc7e827$export$a96281f914484f2d);
$parcel$export(module.exports, "ZodAny", () => $751926319bc7e827$export$b9d1edb536b4e4eb);
$parcel$export(module.exports, "ZodUnknown", () => $751926319bc7e827$export$ef3b1bb1630977ae);
$parcel$export(module.exports, "ZodNever", () => $751926319bc7e827$export$1e576a20c3ce9fb5);
$parcel$export(module.exports, "ZodVoid", () => $751926319bc7e827$export$7d39f5df85f21031);
$parcel$export(module.exports, "ZodObject", () => $751926319bc7e827$export$736315c5b55efbad);
$parcel$export(module.exports, "ZodTuple", () => $751926319bc7e827$export$e2a18bb771d8e6a3);
$parcel$export(module.exports, "ZodLazy", () => $751926319bc7e827$export$378d0cfce37406e6);
$parcel$export(module.exports, "ZodLiteral", () => $751926319bc7e827$export$7e44096782a165d3);
$parcel$export(module.exports, "ZodEnum", () => $751926319bc7e827$export$d325d1f0e1c20179);
$parcel$export(module.exports, "ZodNativeEnum", () => $751926319bc7e827$export$370b2e8d6d6f5c56);
$parcel$export(module.exports, "ZodDiscriminatedUnion", () => $751926319bc7e827$export$5ef2424805ac76a3);
$parcel$export(module.exports, "ZodRecord", () => $751926319bc7e827$export$a2acc09968cb4b7f);
$parcel$export(module.exports, "ZodMap", () => $751926319bc7e827$export$163b6a2b712d9542);
$parcel$export(module.exports, "ZodSet", () => $751926319bc7e827$export$977057706f816712);
$parcel$export(module.exports, "ZodFunction", () => $751926319bc7e827$export$d4602ba55673f53c);
$parcel$export(module.exports, "ZodTransformer", () => $751926319bc7e827$export$a60af00cc0ce2582);
$parcel$export(module.exports, "ZodNaN", () => $751926319bc7e827$export$26ccfa0145e8511f);
$parcel$export(module.exports, "BRAND", () => $751926319bc7e827$export$cf2deea74cde46b4);
$parcel$export(module.exports, "custom", () => $751926319bc7e827$export$4c00f665f0d4b443);
$parcel$export(module.exports, "Schema", () => $751926319bc7e827$export$2afb8ab49d4b92c0);
$parcel$export(module.exports, "ZodSchema", () => $751926319bc7e827$export$2afb8ab49d4b92c0);
$parcel$export(module.exports, "late", () => $751926319bc7e827$export$1ee8ee30835eab8b);
$parcel$export(module.exports, "instanceof", () => $751926319bc7e827$export$3d916e7c22dbd8b5);
$parcel$export(module.exports, "string", () => $751926319bc7e827$export$22b082955e083ec3);
$parcel$export(module.exports, "number", () => $751926319bc7e827$export$98e628dec113755e);
$parcel$export(module.exports, "nan", () => $751926319bc7e827$export$9e06de0973666692);
$parcel$export(module.exports, "bigint", () => $751926319bc7e827$export$a0f65b52274bcc00);
$parcel$export(module.exports, "boolean", () => $751926319bc7e827$export$4a21f16c33752377);
$parcel$export(module.exports, "date", () => $751926319bc7e827$export$324d90190a8b822a);
$parcel$export(module.exports, "symbol", () => $751926319bc7e827$export$8f701197936bc2a6);
$parcel$export(module.exports, "undefined", () => $751926319bc7e827$export$1db45310990710a5);
$parcel$export(module.exports, "null", () => $751926319bc7e827$export$7b1b591b262c240);
$parcel$export(module.exports, "any", () => $751926319bc7e827$export$4154a199d7d90455);
$parcel$export(module.exports, "unknown", () => $751926319bc7e827$export$19282c40b967aec6);
$parcel$export(module.exports, "never", () => $751926319bc7e827$export$b3e22bcfd64c1022);
$parcel$export(module.exports, "void", () => $751926319bc7e827$export$490e536ee7389aeb);
$parcel$export(module.exports, "array", () => $751926319bc7e827$export$2f23118c22fb2630);
$parcel$export(module.exports, "object", () => $751926319bc7e827$export$be5493f9613cbbe);
$parcel$export(module.exports, "strictObject", () => $751926319bc7e827$export$8fb0df5f40d0b477);
$parcel$export(module.exports, "union", () => $751926319bc7e827$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "discriminatedUnion", () => $751926319bc7e827$export$4b888e40c4ee26dd);
$parcel$export(module.exports, "intersection", () => $751926319bc7e827$export$bc86dfbf7795668c);
$parcel$export(module.exports, "tuple", () => $751926319bc7e827$export$65e3907585753458);
$parcel$export(module.exports, "record", () => $751926319bc7e827$export$e5185e241753e543);
$parcel$export(module.exports, "map", () => $751926319bc7e827$export$871de8747c9eaa88);
$parcel$export(module.exports, "set", () => $751926319bc7e827$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "function", () => $751926319bc7e827$export$44e51c8aac7c2deb);
$parcel$export(module.exports, "lazy", () => $751926319bc7e827$export$488013bae63b21da);
$parcel$export(module.exports, "literal", () => $751926319bc7e827$export$c8ec6e1ec9fefcb0);
$parcel$export(module.exports, "enum", () => $751926319bc7e827$export$78a99c8d44d72635);
$parcel$export(module.exports, "nativeEnum", () => $751926319bc7e827$export$6fe7eca19ebe5199);
$parcel$export(module.exports, "promise", () => $751926319bc7e827$export$c957ef27a0ebfd4);
$parcel$export(module.exports, "effect", () => $751926319bc7e827$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "optional", () => $751926319bc7e827$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "nullable", () => $751926319bc7e827$export$133fc36489ac9add);
$parcel$export(module.exports, "preprocess", () => $751926319bc7e827$export$fc37fe19dfda43ee);
$parcel$export(module.exports, "pipeline", () => $751926319bc7e827$export$43f28b24e1eb8181);
$parcel$export(module.exports, "ostring", () => $751926319bc7e827$export$3b3d07727c5b702c);
$parcel$export(module.exports, "onumber", () => $751926319bc7e827$export$eb150471a61fced6);
$parcel$export(module.exports, "oboolean", () => $751926319bc7e827$export$269251733cdcbbf1);
$parcel$export(module.exports, "coerce", () => $751926319bc7e827$export$8c14e57e778d3873);
$parcel$export(module.exports, "transformer", () => $751926319bc7e827$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "NEVER", () => $751926319bc7e827$export$96c94437c95d7862);

var $9MMus = parcelRequire("9MMus");
parcelRequire("gpYaW");
var $jsANS = parcelRequire("jsANS");
var $gpYaW = parcelRequire("gpYaW");

var $hCp99 = parcelRequire("hCp99");

var $6oKOk = parcelRequire("6oKOk");

var $ggoEV = parcelRequire("ggoEV");
class $751926319bc7e827$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $751926319bc7e827$var$handleResult = (ctx, result)=>{
    if ((0, $6oKOk.isValid)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new (0, $9MMus.ZodError)(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $751926319bc7e827$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $751926319bc7e827$export$2afb8ab49d4b92c0 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, $ggoEV.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, $ggoEV.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new (0, $6oKOk.ParseStatus)(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, $ggoEV.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, $6oKOk.isAsync)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $ggoEV.getParsedType)(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $751926319bc7e827$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $ggoEV.getParsedType)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return (0, $6oKOk.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>(0, $6oKOk.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $ggoEV.getParsedType)(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, $6oKOk.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $751926319bc7e827$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: (0, $9MMus.ZodIssueCode).custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $751926319bc7e827$export$a60af00cc0ce2582({
            schema: this,
            typeName: $751926319bc7e827$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return $751926319bc7e827$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $751926319bc7e827$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $751926319bc7e827$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $751926319bc7e827$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $751926319bc7e827$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $751926319bc7e827$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $751926319bc7e827$export$a60af00cc0ce2582({
            ...$751926319bc7e827$var$processCreateParams(this._def),
            schema: this,
            typeName: $751926319bc7e827$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $751926319bc7e827$export$bb19b37874861e7e({
            ...$751926319bc7e827$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $751926319bc7e827$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $751926319bc7e827$export$66b0c798a395271f({
            typeName: $751926319bc7e827$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$751926319bc7e827$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $751926319bc7e827$export$75a44ec6249ac76b({
            ...$751926319bc7e827$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $751926319bc7e827$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $751926319bc7e827$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $751926319bc7e827$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $751926319bc7e827$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $751926319bc7e827$var$cuid2Regex = /^[0-9a-z]+$/;
const $751926319bc7e827$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $751926319bc7e827$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $751926319bc7e827$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $751926319bc7e827$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $751926319bc7e827$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $751926319bc7e827$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $751926319bc7e827$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $751926319bc7e827$var$emojiRegex;
// faster, simpler, safer
const $751926319bc7e827$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $751926319bc7e827$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $751926319bc7e827$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $751926319bc7e827$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $751926319bc7e827$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $751926319bc7e827$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $751926319bc7e827$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $751926319bc7e827$var$dateRegex = new RegExp(`^${$751926319bc7e827$var$dateRegexSource}$`);
function $751926319bc7e827$var$timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function $751926319bc7e827$var$timeRegex(args) {
    return new RegExp(`^${$751926319bc7e827$var$timeRegexSource(args)}$`);
}
function $751926319bc7e827$export$a4b563879add27a(args) {
    let regex = `${$751926319bc7e827$var$dateRegexSource}T${$751926319bc7e827$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $751926319bc7e827$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $751926319bc7e827$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $751926319bc7e827$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $751926319bc7e827$var$isValidJWT(jwt, alg) {
    if (!$751926319bc7e827$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        if (!header) return false;
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function $751926319bc7e827$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $751926319bc7e827$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $751926319bc7e827$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $751926319bc7e827$export$1230eb29b8d3b502 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $ggoEV.ZodParsedType).string) {
            const ctx = this._getOrReturnCtx(input);
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).string,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        const status = new (0, $6oKOk.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$751926319bc7e827$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        validation: "email",
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$751926319bc7e827$var$emojiRegex) $751926319bc7e827$var$emojiRegex = new RegExp($751926319bc7e827$var$_emojiRegex, "u");
                if (!$751926319bc7e827$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$751926319bc7e827$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$751926319bc7e827$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        validation: "nanoid",
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$751926319bc7e827$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$751926319bc7e827$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$751926319bc7e827$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, $6oKOk.addIssueToContext)(ctx, {
                    validation: "url",
                    code: (0, $9MMus.ZodIssueCode).invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $751926319bc7e827$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $751926319bc7e827$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $751926319bc7e827$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$751926319bc7e827$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        validation: "duration",
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$751926319bc7e827$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$751926319bc7e827$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        validation: "jwt",
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$751926319bc7e827$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        validation: "cidr",
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$751926319bc7e827$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        validation: "base64",
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$751926319bc7e827$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        validation: "base64url",
                        code: (0, $9MMus.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $ggoEV.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: (0, $9MMus.ZodIssueCode).invalid_string,
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    _addCheck(check) {
        return new $751926319bc7e827$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...(0, $hCp99.errorUtil).errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...(0, $hCp99.errorUtil).errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...(0, $hCp99.errorUtil).errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...(0, $hCp99.errorUtil).errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...(0, $hCp99.errorUtil).errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...(0, $hCp99.errorUtil).errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...(0, $hCp99.errorUtil).errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, (0, $hCp99.errorUtil).errToObj(message));
    }
    trim() {
        return new $751926319bc7e827$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $751926319bc7e827$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $751926319bc7e827$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$751926319bc7e827$export$1230eb29b8d3b502.create = (params)=>{
    return new $751926319bc7e827$export$1230eb29b8d3b502({
        checks: [],
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodString,
        coerce: params?.coerce ?? false,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $751926319bc7e827$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class $751926319bc7e827$export$5b070a55c0c43e09 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $ggoEV.ZodParsedType).number) {
            const ctx = this._getOrReturnCtx(input);
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).number,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        let ctx = undefined;
        const status = new (0, $6oKOk.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!(0, $ggoEV.util).isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($751926319bc7e827$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $ggoEV.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $hCp99.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $hCp99.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $hCp99.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $hCp99.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $751926319bc7e827$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $hCp99.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $751926319bc7e827$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: (0, $hCp99.errorUtil).toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: (0, $hCp99.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: (0, $hCp99.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: (0, $hCp99.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: (0, $hCp99.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $hCp99.errorUtil).toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: (0, $hCp99.errorUtil).toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: (0, $hCp99.errorUtil).toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: (0, $hCp99.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && (0, $ggoEV.util).isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$751926319bc7e827$export$5b070a55c0c43e09.create = (params)=>{
    return new $751926319bc7e827$export$5b070a55c0c43e09({
        checks: [],
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodNumber,
        coerce: params?.coerce || false,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$67d741fd70ff98f4 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== (0, $ggoEV.ZodParsedType).bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new (0, $6oKOk.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $ggoEV.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $6oKOk.addIssueToContext)(ctx, {
            code: (0, $9MMus.ZodIssueCode).invalid_type,
            expected: (0, $ggoEV.ZodParsedType).bigint,
            received: ctx.parsedType
        });
        return 0, $6oKOk.INVALID;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $hCp99.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $hCp99.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $hCp99.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $hCp99.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $751926319bc7e827$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $hCp99.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $751926319bc7e827$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: (0, $hCp99.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: (0, $hCp99.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: (0, $hCp99.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: (0, $hCp99.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $hCp99.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$751926319bc7e827$export$67d741fd70ff98f4.create = (params)=>{
    return new $751926319bc7e827$export$67d741fd70ff98f4({
        checks: [],
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$723d146f80596191 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $ggoEV.ZodParsedType).boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).boolean,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        return (0, $6oKOk.OK)(input.data);
    }
}
$751926319bc7e827$export$723d146f80596191.create = (params)=>{
    return new $751926319bc7e827$export$723d146f80596191({
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodBoolean,
        coerce: params?.coerce || false,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$e974be33bdc55521 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $ggoEV.ZodParsedType).date) {
            const ctx = this._getOrReturnCtx(input);
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).date,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_date
            });
            return 0, $6oKOk.INVALID;
        }
        const status = new (0, $6oKOk.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else (0, $ggoEV.util).assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $751926319bc7e827$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: (0, $hCp99.errorUtil).toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: (0, $hCp99.errorUtil).toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$751926319bc7e827$export$e974be33bdc55521.create = (params)=>{
    return new $751926319bc7e827$export$e974be33bdc55521({
        checks: [],
        coerce: params?.coerce || false,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodDate,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$bcc3b40f6b638044 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $ggoEV.ZodParsedType).symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).symbol,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        return (0, $6oKOk.OK)(input.data);
    }
}
$751926319bc7e827$export$bcc3b40f6b638044.create = (params)=>{
    return new $751926319bc7e827$export$bcc3b40f6b638044({
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodSymbol,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$4e780e961c30340d extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $ggoEV.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).undefined,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        return (0, $6oKOk.OK)(input.data);
    }
}
$751926319bc7e827$export$4e780e961c30340d.create = (params)=>{
    return new $751926319bc7e827$export$4e780e961c30340d({
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodUndefined,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$a96281f914484f2d extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $ggoEV.ZodParsedType).null) {
            const ctx = this._getOrReturnCtx(input);
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).null,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        return (0, $6oKOk.OK)(input.data);
    }
}
$751926319bc7e827$export$a96281f914484f2d.create = (params)=>{
    return new $751926319bc7e827$export$a96281f914484f2d({
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodNull,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$b9d1edb536b4e4eb extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, $6oKOk.OK)(input.data);
    }
}
$751926319bc7e827$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $751926319bc7e827$export$b9d1edb536b4e4eb({
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodAny,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$ef3b1bb1630977ae extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, $6oKOk.OK)(input.data);
    }
}
$751926319bc7e827$export$ef3b1bb1630977ae.create = (params)=>{
    return new $751926319bc7e827$export$ef3b1bb1630977ae({
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodUnknown,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$1e576a20c3ce9fb5 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $6oKOk.addIssueToContext)(ctx, {
            code: (0, $9MMus.ZodIssueCode).invalid_type,
            expected: (0, $ggoEV.ZodParsedType).never,
            received: ctx.parsedType
        });
        return 0, $6oKOk.INVALID;
    }
}
$751926319bc7e827$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $751926319bc7e827$export$1e576a20c3ce9fb5({
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodNever,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$7d39f5df85f21031 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $ggoEV.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).void,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        return (0, $6oKOk.OK)(input.data);
    }
}
$751926319bc7e827$export$7d39f5df85f21031.create = (params)=>{
    return new $751926319bc7e827$export$7d39f5df85f21031({
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodVoid,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$7acfc3e64785411 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== (0, $ggoEV.ZodParsedType).array) {
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, $6oKOk.addIssueToContext)(ctx, {
                    code: tooBig ? (0, $9MMus.ZodIssueCode).too_big : (0, $9MMus.ZodIssueCode).too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, $6oKOk.addIssueToContext)(ctx, {
                    code: (0, $9MMus.ZodIssueCode).too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, $6oKOk.addIssueToContext)(ctx, {
                    code: (0, $9MMus.ZodIssueCode).too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $751926319bc7e827$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return (0, $6oKOk.ParseStatus).mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $751926319bc7e827$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return (0, $6oKOk.ParseStatus).mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $751926319bc7e827$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: (0, $hCp99.errorUtil).toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $751926319bc7e827$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: (0, $hCp99.errorUtil).toString(message)
            }
        });
    }
    length(len, message) {
        return new $751926319bc7e827$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: (0, $hCp99.errorUtil).toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$751926319bc7e827$export$7acfc3e64785411.create = (schema, params)=>{
    return new $751926319bc7e827$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodArray,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
function $751926319bc7e827$var$deepPartialify(schema) {
    if (schema instanceof $751926319bc7e827$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $751926319bc7e827$export$aa56fec1e9d629b8.create($751926319bc7e827$var$deepPartialify(fieldSchema));
        }
        return new $751926319bc7e827$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $751926319bc7e827$export$7acfc3e64785411) return new $751926319bc7e827$export$7acfc3e64785411({
        ...schema._def,
        type: $751926319bc7e827$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $751926319bc7e827$export$aa56fec1e9d629b8) return $751926319bc7e827$export$aa56fec1e9d629b8.create($751926319bc7e827$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $751926319bc7e827$export$aaac0b8b429cef5) return $751926319bc7e827$export$aaac0b8b429cef5.create($751926319bc7e827$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $751926319bc7e827$export$e2a18bb771d8e6a3) return $751926319bc7e827$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$751926319bc7e827$var$deepPartialify(item)));
    else return schema;
}
class $751926319bc7e827$export$736315c5b55efbad extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = (0, $ggoEV.util).objectKeys(shape);
        this._cached = {
            shape: shape,
            keys: keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $ggoEV.ZodParsedType).object) {
            const ctx = this._getOrReturnCtx(input);
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $751926319bc7e827$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $751926319bc7e827$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $751926319bc7e827$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, $6oKOk.addIssueToContext)(ctx, {
                        code: (0, $9MMus.ZodIssueCode).unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $751926319bc7e827$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return (0, $6oKOk.ParseStatus).mergeObjectSync(status, syncPairs);
        });
        else return (0, $6oKOk.ParseStatus).mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        (0, $hCp99.errorUtil).errToObj;
        return new $751926319bc7e827$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (0, $hCp99.errorUtil).errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $751926319bc7e827$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $751926319bc7e827$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $751926319bc7e827$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $751926319bc7e827$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $751926319bc7e827$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $751926319bc7e827$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of (0, $ggoEV.util).objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new $751926319bc7e827$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of (0, $ggoEV.util).objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new $751926319bc7e827$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $751926319bc7e827$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of (0, $ggoEV.util).objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new $751926319bc7e827$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of (0, $ggoEV.util).objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof $751926319bc7e827$export$aa56fec1e9d629b8)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new $751926319bc7e827$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $751926319bc7e827$var$createZodEnum((0, $ggoEV.util).objectKeys(this.shape));
    }
}
$751926319bc7e827$export$736315c5b55efbad.create = (shape, params)=>{
    return new $751926319bc7e827$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $751926319bc7e827$export$1e576a20c3ce9fb5.create(),
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodObject,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
$751926319bc7e827$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $751926319bc7e827$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $751926319bc7e827$export$1e576a20c3ce9fb5.create(),
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodObject,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
$751926319bc7e827$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $751926319bc7e827$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $751926319bc7e827$export$1e576a20c3ce9fb5.create(),
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodObject,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$a8b236cb5070a311 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new (0, $9MMus.ZodError)(result.ctx.common.issues));
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $6oKOk.INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new (0, $9MMus.ZodError)(issues));
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $6oKOk.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
$751926319bc7e827$export$a8b236cb5070a311.create = (types, params)=>{
    return new $751926319bc7e827$export$a8b236cb5070a311({
        options: types,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodUnion,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $751926319bc7e827$var$getDiscriminator = (type)=>{
    if (type instanceof $751926319bc7e827$export$378d0cfce37406e6) return $751926319bc7e827$var$getDiscriminator(type.schema);
    else if (type instanceof $751926319bc7e827$export$a60af00cc0ce2582) return $751926319bc7e827$var$getDiscriminator(type.innerType());
    else if (type instanceof $751926319bc7e827$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $751926319bc7e827$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $751926319bc7e827$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return (0, $ggoEV.util).objectValues(type.enum);
    else if (type instanceof $751926319bc7e827$export$bb19b37874861e7e) return $751926319bc7e827$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $751926319bc7e827$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $751926319bc7e827$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $751926319bc7e827$export$aa56fec1e9d629b8) return [
        undefined,
        ...$751926319bc7e827$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $751926319bc7e827$export$aaac0b8b429cef5) return [
        null,
        ...$751926319bc7e827$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $751926319bc7e827$export$66b0c798a395271f) return $751926319bc7e827$var$getDiscriminator(type.unwrap());
    else if (type instanceof $751926319bc7e827$export$5d1f7ef05c4e493a) return $751926319bc7e827$var$getDiscriminator(type.unwrap());
    else if (type instanceof $751926319bc7e827$export$75a44ec6249ac76b) return $751926319bc7e827$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $751926319bc7e827$export$5ef2424805ac76a3 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $ggoEV.ZodParsedType).object) {
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return 0, $6oKOk.INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $751926319bc7e827$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $751926319bc7e827$export$5ef2424805ac76a3({
            typeName: $751926319bc7e827$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$751926319bc7e827$var$processCreateParams(params)
        });
    }
}
function $751926319bc7e827$var$mergeValues(a, b) {
    const aType = (0, $ggoEV.getParsedType)(a);
    const bType = (0, $ggoEV.getParsedType)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === (0, $ggoEV.ZodParsedType).object && bType === (0, $ggoEV.ZodParsedType).object) {
        const bKeys = (0, $ggoEV.util).objectKeys(b);
        const sharedKeys = (0, $ggoEV.util).objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $751926319bc7e827$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === (0, $ggoEV.ZodParsedType).array && bType === (0, $ggoEV.ZodParsedType).array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $751926319bc7e827$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === (0, $ggoEV.ZodParsedType).date && bType === (0, $ggoEV.ZodParsedType).date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $751926319bc7e827$export$c02deaf0bb5203d4 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, $6oKOk.isAborted)(parsedLeft) || (0, $6oKOk.isAborted)(parsedRight)) return 0, $6oKOk.INVALID;
            const merged = $751926319bc7e827$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, $6oKOk.addIssueToContext)(ctx, {
                    code: (0, $9MMus.ZodIssueCode).invalid_intersection_types
                });
                return 0, $6oKOk.INVALID;
            }
            if ((0, $6oKOk.isDirty)(parsedLeft) || (0, $6oKOk.isDirty)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$751926319bc7e827$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $751926319bc7e827$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodIntersection,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$e2a18bb771d8e6a3 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $ggoEV.ZodParsedType).array) {
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return 0, $6oKOk.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $751926319bc7e827$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return (0, $6oKOk.ParseStatus).mergeArray(status, results);
        });
        else return (0, $6oKOk.ParseStatus).mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $751926319bc7e827$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$751926319bc7e827$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $751926319bc7e827$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$a2acc09968cb4b7f extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $ggoEV.ZodParsedType).object) {
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $751926319bc7e827$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $751926319bc7e827$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return (0, $6oKOk.ParseStatus).mergeObjectAsync(status, pairs);
        else return (0, $6oKOk.ParseStatus).mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $751926319bc7e827$export$2afb8ab49d4b92c0) return new $751926319bc7e827$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $751926319bc7e827$export$558106ce543bd011.ZodRecord,
            ...$751926319bc7e827$var$processCreateParams(third)
        });
        return new $751926319bc7e827$export$a2acc09968cb4b7f({
            keyType: $751926319bc7e827$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $751926319bc7e827$export$558106ce543bd011.ZodRecord,
            ...$751926319bc7e827$var$processCreateParams(second)
        });
    }
}
class $751926319bc7e827$export$163b6a2b712d9542 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $ggoEV.ZodParsedType).map) {
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).map,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $751926319bc7e827$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $751926319bc7e827$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return 0, $6oKOk.INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return 0, $6oKOk.INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$751926319bc7e827$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $751926319bc7e827$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodMap,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$977057706f816712 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $ggoEV.ZodParsedType).set) {
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).set,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, $6oKOk.addIssueToContext)(ctx, {
                    code: (0, $9MMus.ZodIssueCode).too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, $6oKOk.addIssueToContext)(ctx, {
                    code: (0, $9MMus.ZodIssueCode).too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return 0, $6oKOk.INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $751926319bc7e827$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $751926319bc7e827$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: (0, $hCp99.errorUtil).toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $751926319bc7e827$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: (0, $hCp99.errorUtil).toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$751926319bc7e827$export$977057706f816712.create = (valueType, params)=>{
    return new $751926319bc7e827$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodSet,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$d4602ba55673f53c extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $ggoEV.ZodParsedType).function) {
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).function,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, $6oKOk.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $gpYaW.getErrorMap)(),
                    (0, $jsANS.default)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $9MMus.ZodIssueCode).invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, $6oKOk.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $gpYaW.getErrorMap)(),
                    (0, $jsANS.default)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $9MMus.ZodIssueCode).invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $751926319bc7e827$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $6oKOk.OK)(async function(...args) {
                const error = new (0, $9MMus.ZodError)([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $6oKOk.OK)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new (0, $9MMus.ZodError)([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new (0, $9MMus.ZodError)([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $751926319bc7e827$export$d4602ba55673f53c({
            ...this._def,
            args: $751926319bc7e827$export$e2a18bb771d8e6a3.create(items).rest($751926319bc7e827$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $751926319bc7e827$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $751926319bc7e827$export$d4602ba55673f53c({
            args: args ? args : $751926319bc7e827$export$e2a18bb771d8e6a3.create([]).rest($751926319bc7e827$export$ef3b1bb1630977ae.create()),
            returns: returns || $751926319bc7e827$export$ef3b1bb1630977ae.create(),
            typeName: $751926319bc7e827$export$558106ce543bd011.ZodFunction,
            ...$751926319bc7e827$var$processCreateParams(params)
        });
    }
}
class $751926319bc7e827$export$378d0cfce37406e6 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$751926319bc7e827$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $751926319bc7e827$export$378d0cfce37406e6({
        getter: getter,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodLazy,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$7e44096782a165d3 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, $6oKOk.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $9MMus.ZodIssueCode).invalid_literal,
                expected: this._def.value
            });
            return 0, $6oKOk.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$751926319bc7e827$export$7e44096782a165d3.create = (value, params)=>{
    return new $751926319bc7e827$export$7e44096782a165d3({
        value: value,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodLiteral,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
function $751926319bc7e827$var$createZodEnum(values, params) {
    return new $751926319bc7e827$export$d325d1f0e1c20179({
        values: values,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodEnum,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
}
class $751926319bc7e827$export$d325d1f0e1c20179 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $6oKOk.addIssueToContext)(ctx, {
                expected: (0, $ggoEV.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $9MMus.ZodIssueCode).invalid_type
            });
            return 0, $6oKOk.INVALID;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $6oKOk.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $9MMus.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, $6oKOk.INVALID;
        }
        return (0, $6oKOk.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $751926319bc7e827$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $751926319bc7e827$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$751926319bc7e827$export$d325d1f0e1c20179.create = $751926319bc7e827$var$createZodEnum;
class $751926319bc7e827$export$370b2e8d6d6f5c56 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const nativeEnumValues = (0, $ggoEV.util).getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== (0, $ggoEV.ZodParsedType).string && ctx.parsedType !== (0, $ggoEV.ZodParsedType).number) {
            const expectedValues = (0, $ggoEV.util).objectValues(nativeEnumValues);
            (0, $6oKOk.addIssueToContext)(ctx, {
                expected: (0, $ggoEV.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $9MMus.ZodIssueCode).invalid_type
            });
            return 0, $6oKOk.INVALID;
        }
        if (!this._cache) this._cache = new Set((0, $ggoEV.util).getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = (0, $ggoEV.util).objectValues(nativeEnumValues);
            (0, $6oKOk.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $9MMus.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, $6oKOk.INVALID;
        }
        return (0, $6oKOk.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$751926319bc7e827$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $751926319bc7e827$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodNativeEnum,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$3f196b0127d6e50a extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $ggoEV.ZodParsedType).promise && ctx.common.async === false) {
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).promise,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        const promisified = ctx.parsedType === (0, $ggoEV.ZodParsedType).promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, $6oKOk.OK)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$751926319bc7e827$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $751926319bc7e827$export$3f196b0127d6e50a({
        type: schema,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodPromise,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$a60af00cc0ce2582 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $751926319bc7e827$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, $6oKOk.addIssueToContext)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return 0, $6oKOk.INVALID;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $6oKOk.INVALID;
                if (result.status === "dirty") return (0, $6oKOk.DIRTY)(result.value);
                if (status.value === "dirty") return (0, $6oKOk.DIRTY)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return 0, $6oKOk.INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $6oKOk.INVALID;
                if (result.status === "dirty") return (0, $6oKOk.DIRTY)(result.value);
                if (status.value === "dirty") return (0, $6oKOk.DIRTY)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return 0, $6oKOk.INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return 0, $6oKOk.INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, $6oKOk.isValid)(base)) return 0, $6oKOk.INVALID;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, $6oKOk.isValid)(base)) return 0, $6oKOk.INVALID;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        (0, $ggoEV.util).assertNever(effect);
    }
}
$751926319bc7e827$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $751926319bc7e827$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
$751926319bc7e827$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $751926319bc7e827$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodEffects,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$aa56fec1e9d629b8 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $ggoEV.ZodParsedType).undefined) return (0, $6oKOk.OK)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$751926319bc7e827$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $751926319bc7e827$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodOptional,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$aaac0b8b429cef5 extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $ggoEV.ZodParsedType).null) return (0, $6oKOk.OK)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$751926319bc7e827$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $751926319bc7e827$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodNullable,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$bb19b37874861e7e extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === (0, $ggoEV.ZodParsedType).undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$751926319bc7e827$export$bb19b37874861e7e.create = (type, params)=>{
    return new $751926319bc7e827$export$bb19b37874861e7e({
        innerType: type,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$75a44ec6249ac76b extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, $6oKOk.isAsync)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new (0, $9MMus.ZodError)(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new (0, $9MMus.ZodError)(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$751926319bc7e827$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $751926319bc7e827$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
class $751926319bc7e827$export$26ccfa0145e8511f extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $ggoEV.ZodParsedType).nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, $6oKOk.addIssueToContext)(ctx, {
                code: (0, $9MMus.ZodIssueCode).invalid_type,
                expected: (0, $ggoEV.ZodParsedType).nan,
                received: ctx.parsedType
            });
            return 0, $6oKOk.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$751926319bc7e827$export$26ccfa0145e8511f.create = (params)=>{
    return new $751926319bc7e827$export$26ccfa0145e8511f({
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodNaN,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
const $751926319bc7e827$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $751926319bc7e827$export$66b0c798a395271f extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $751926319bc7e827$export$a3c3ef8a0e95c6da extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return 0, $6oKOk.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, $6oKOk.DIRTY)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return 0, $6oKOk.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $751926319bc7e827$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $751926319bc7e827$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $751926319bc7e827$export$5d1f7ef05c4e493a extends $751926319bc7e827$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, $6oKOk.isValid)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, $6oKOk.isAsync)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$751926319bc7e827$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $751926319bc7e827$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $751926319bc7e827$export$558106ce543bd011.ZodReadonly,
        ...$751926319bc7e827$var$processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $751926319bc7e827$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $751926319bc7e827$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $751926319bc7e827$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = $751926319bc7e827$var$cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = $751926319bc7e827$var$cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return $751926319bc7e827$export$b9d1edb536b4e4eb.create();
}
const $751926319bc7e827$export$1ee8ee30835eab8b = {
    object: $751926319bc7e827$export$736315c5b55efbad.lazycreate
};
var $751926319bc7e827$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($751926319bc7e827$export$558106ce543bd011 || ($751926319bc7e827$export$558106ce543bd011 = {}));
// requires TS 4.4+
class $751926319bc7e827$var$Class {
    constructor(..._){}
}
const $751926319bc7e827$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$751926319bc7e827$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $751926319bc7e827$export$22b082955e083ec3 = $751926319bc7e827$export$1230eb29b8d3b502.create;
const $751926319bc7e827$export$98e628dec113755e = $751926319bc7e827$export$5b070a55c0c43e09.create;
const $751926319bc7e827$export$9e06de0973666692 = $751926319bc7e827$export$26ccfa0145e8511f.create;
const $751926319bc7e827$export$a0f65b52274bcc00 = $751926319bc7e827$export$67d741fd70ff98f4.create;
const $751926319bc7e827$export$4a21f16c33752377 = $751926319bc7e827$export$723d146f80596191.create;
const $751926319bc7e827$export$324d90190a8b822a = $751926319bc7e827$export$e974be33bdc55521.create;
const $751926319bc7e827$export$8f701197936bc2a6 = $751926319bc7e827$export$bcc3b40f6b638044.create;
const $751926319bc7e827$export$1db45310990710a5 = $751926319bc7e827$export$4e780e961c30340d.create;
const $751926319bc7e827$export$7b1b591b262c240 = $751926319bc7e827$export$a96281f914484f2d.create;
const $751926319bc7e827$export$4154a199d7d90455 = $751926319bc7e827$export$b9d1edb536b4e4eb.create;
const $751926319bc7e827$export$19282c40b967aec6 = $751926319bc7e827$export$ef3b1bb1630977ae.create;
const $751926319bc7e827$export$b3e22bcfd64c1022 = $751926319bc7e827$export$1e576a20c3ce9fb5.create;
const $751926319bc7e827$export$490e536ee7389aeb = $751926319bc7e827$export$7d39f5df85f21031.create;
const $751926319bc7e827$export$2f23118c22fb2630 = $751926319bc7e827$export$7acfc3e64785411.create;
const $751926319bc7e827$export$be5493f9613cbbe = $751926319bc7e827$export$736315c5b55efbad.create;
const $751926319bc7e827$export$8fb0df5f40d0b477 = $751926319bc7e827$export$736315c5b55efbad.strictCreate;
const $751926319bc7e827$export$971dd5b0dfd021b6 = $751926319bc7e827$export$a8b236cb5070a311.create;
const $751926319bc7e827$export$4b888e40c4ee26dd = $751926319bc7e827$export$5ef2424805ac76a3.create;
const $751926319bc7e827$export$bc86dfbf7795668c = $751926319bc7e827$export$c02deaf0bb5203d4.create;
const $751926319bc7e827$export$65e3907585753458 = $751926319bc7e827$export$e2a18bb771d8e6a3.create;
const $751926319bc7e827$export$e5185e241753e543 = $751926319bc7e827$export$a2acc09968cb4b7f.create;
const $751926319bc7e827$export$871de8747c9eaa88 = $751926319bc7e827$export$163b6a2b712d9542.create;
const $751926319bc7e827$export$adaa4cf7ef1b65be = $751926319bc7e827$export$977057706f816712.create;
const $751926319bc7e827$export$44e51c8aac7c2deb = $751926319bc7e827$export$d4602ba55673f53c.create;
const $751926319bc7e827$export$488013bae63b21da = $751926319bc7e827$export$378d0cfce37406e6.create;
const $751926319bc7e827$export$c8ec6e1ec9fefcb0 = $751926319bc7e827$export$7e44096782a165d3.create;
const $751926319bc7e827$export$78a99c8d44d72635 = $751926319bc7e827$export$d325d1f0e1c20179.create;
const $751926319bc7e827$export$6fe7eca19ebe5199 = $751926319bc7e827$export$370b2e8d6d6f5c56.create;
const $751926319bc7e827$export$c957ef27a0ebfd4 = $751926319bc7e827$export$3f196b0127d6e50a.create;
const $751926319bc7e827$export$dc573d8a6576cdb3 = $751926319bc7e827$export$a60af00cc0ce2582.create;
const $751926319bc7e827$export$516e28dec6a4b6d4 = $751926319bc7e827$export$aa56fec1e9d629b8.create;
const $751926319bc7e827$export$133fc36489ac9add = $751926319bc7e827$export$aaac0b8b429cef5.create;
const $751926319bc7e827$export$fc37fe19dfda43ee = $751926319bc7e827$export$a60af00cc0ce2582.createWithPreprocess;
const $751926319bc7e827$export$43f28b24e1eb8181 = $751926319bc7e827$export$a3c3ef8a0e95c6da.create;
const $751926319bc7e827$export$3b3d07727c5b702c = ()=>$751926319bc7e827$export$22b082955e083ec3().optional();
const $751926319bc7e827$export$eb150471a61fced6 = ()=>$751926319bc7e827$export$98e628dec113755e().optional();
const $751926319bc7e827$export$269251733cdcbbf1 = ()=>$751926319bc7e827$export$4a21f16c33752377().optional();
const $751926319bc7e827$export$8c14e57e778d3873 = {
    string: (arg)=>$751926319bc7e827$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$751926319bc7e827$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$751926319bc7e827$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$751926319bc7e827$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$751926319bc7e827$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $751926319bc7e827$export$96c94437c95d7862 = (0, $6oKOk.INVALID);

});
parcelRegister("hCp99", function(module, exports) {
$parcel$export(module.exports, "errorUtil", () => $cd397dd9f27d064b$export$b9faa7f0c32cb80d);
var $cd397dd9f27d064b$export$b9faa7f0c32cb80d;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    // biome-ignore lint:
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})($cd397dd9f27d064b$export$b9faa7f0c32cb80d || ($cd397dd9f27d064b$export$b9faa7f0c32cb80d = {}));

});




parcelRegister("Wd0FJ", function(module, exports) {
$parcel$export(module.exports, "AtlassianRelayEnvironmentProvider", () => $089c2ff7fadace63$export$6c22afad970ad5ac);
$parcel$export(module.exports, "RelayEnvironmentProvider", () => $089c2ff7fadace63$export$43b1f3e917d65526);
$parcel$export(module.exports, "ConditionalRelayEnvironmentProvider", () => $089c2ff7fadace63$export$2f6292af3d34630d);
$parcel$export(module.exports, "useRelayEnvironmentProvider", () => $089c2ff7fadace63$export$e237a628f59c9f4e);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $iNT4o = parcelRequire("iNT4o");

var $llCao = parcelRequire("llCao");

var $82aOh = parcelRequire("82aOh");

var $4YxHf = parcelRequire("4YxHf");
function $089c2ff7fadace63$export$6c22afad970ad5ac({ children: children }) {
    const existingRelayContext = (0, $fsvuC.useContext)((0, $iNT4o.ReactRelayContext));
    // If a compatible relay environment (one created via `createRelayEnvironment`) is already present
    // in the tree, reuse it instead of shadowing it with our own internal environment.
    if (existingRelayContext != null && (0, $82aOh.isAtlassianRelayEnvironment)(existingRelayContext.environment) && (0, $llCao.fg)('relay_environment_-_reuse_product_env_when_exist')) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: children
    });
    // Otherwise, fall back to providing the default internal relay environment.
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $iNT4o.RelayEnvironmentProvider), {
        environment: (0, $4YxHf.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__),
        children: children
    });
}
$089c2ff7fadace63$export$6c22afad970ad5ac.displayName = "AtlassianRelayEnvironmentProvider";
const $089c2ff7fadace63$export$43b1f3e917d65526 = $089c2ff7fadace63$export$6c22afad970ad5ac;
const $089c2ff7fadace63$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $fsvuC.useContext)((0, $iNT4o.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, $5chsV.jsx)($089c2ff7fadace63$export$6c22afad970ad5ac, {
        children: children
    });
};
$089c2ff7fadace63$export$2f6292af3d34630d.displayName = "ConditionalRelayEnvironmentProvider";
function $089c2ff7fadace63$export$e237a628f59c9f4e() {
    const environment = (0, $iNT4o.useRelayEnvironment)();
    return (0, $fsvuC.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("4YxHf", function(module, exports) {
$parcel$export(module.exports, "__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__", () => $b2b20644430b91e5$export$df54517d175e6d6b);

var $llCao = parcelRequire("llCao");

var $82aOh = parcelRequire("82aOh");

var $5E2Os = parcelRequire("5E2Os");

var $dwL8z = parcelRequire("dwL8z");
const $b2b20644430b91e5$var$getLoggingAndMetricsHelper = ()=>{
    return {
        logNonBreakingErrors: ()=>{},
        logError: ()=>{},
        logErrorRetry: ()=>{},
        logQueryFallbackToPost: ()=>{}
    };
};
const $b2b20644430b91e5$export$4a639ebead870a0c = new (0, $dwL8z.SSRQueryResponseCache)({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $b2b20644430b91e5$export$df54517d175e6d6b = (0, $82aOh.createRelayEnvironment)({
    networkOptions: {
        getLoggingAndMetricsHelper: $b2b20644430b91e5$var$getLoggingAndMetricsHelper,
        withErrorHandling: (source)=>source,
        validateResponse: (request, response)=>{
            const errors = 'errors' in response ? response.errors : undefined;
            if (errors != null) {
                const requestId = response?.extensions?.gateway?.request_id;
                (0, $5E2Os.captureErrors)(errors, {
                    operationName: request.name,
                    requestId: requestId
                });
                if ((0, $llCao.fg)('platform_relay_redirect_on_step_up_auth_studio')) {
                    const { hasStepUpAuthError: hasStepUpAuthError, stepUpUrl: stepUpUrl } = (0, $5E2Os.isStepUpAuthError)(errors);
                    // Guard against SSR: window is not defined in server-side rendering environments.
                    // RelayEnvironmentProvider is used by platform components (e.g. GlobalSideNavigation)
                    // during SSR — validateResponse may be called during renderToString where window
                    // does not exist. Without this guard, a step-up auth error would throw
                    // ReferenceError and crash the entire SSR render.
                    if (hasStepUpAuthError && stepUpUrl && typeof window !== 'undefined') window.location.href = stepUpUrl;
                }
            }
            return true;
        },
        onInvalidResponse: ()=>{},
        queryResponseCache: $b2b20644430b91e5$export$4a639ebead870a0c,
        // Use typeof window === 'undefined' for SSR detection rather than globalThis.false.
        // false is set in tests but not in Bifrost's actual SSR environment (it's set in
        // init() which runs after module evaluation). typeof window === 'undefined' is the
        // standard pattern and correctly identifies both Bifrost SSR and test environments.
        isServer: typeof window === 'undefined'
    }
});

});
parcelRegister("5E2Os", function(module, exports) {
$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $df686260cb47953b$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $df686260cb47953b$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $df686260cb47953b$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isUnauthenticated", () => $df686260cb47953b$export$1724ecfee73c4768);
$parcel$export(module.exports, "isStepUpAuthError", () => $df686260cb47953b$export$60fba4117567a49b);

var $17hIO = parcelRequire("17hIO");
const $df686260cb47953b$var$errorCollector = new Map();
const $df686260cb47953b$export$da396ad2a542b095 = 120000; // 2min
const $df686260cb47953b$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $df686260cb47953b$var$errorCollector.delete(key);
    }, $df686260cb47953b$export$da396ad2a542b095);
};
const $df686260cb47953b$export$c211170518c6d0f6 = (key = (0, $17hIO.default)())=>{
    $df686260cb47953b$var$errorCollector.set(key, []);
    $df686260cb47953b$var$scheduleCleanup(key);
    return key;
};
const $df686260cb47953b$export$e0491a0d974dadfa = (key)=>{
    const errors = $df686260cb47953b$var$errorCollector.get(key);
    $df686260cb47953b$var$errorCollector.delete(key);
    return errors || [];
};
const $df686260cb47953b$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $df686260cb47953b$var$errorCollector.forEach((value, key)=>{
        $df686260cb47953b$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $df686260cb47953b$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};
const $df686260cb47953b$export$60fba4117567a49b = (errors)=>{
    const stepUpError = errors.find((error)=>error.message.startsWith('Step-up authentication is required.') && error.extensions?.statusCode === 303 && error.extensions?.stepUpUrl);
    return {
        hasStepUpAuthError: !!stepUpError,
        stepUpUrl: stepUpError?.extensions?.stepUpUrl ?? undefined
    };
};

});

parcelRegister("dwL8z", function(module, exports) {
$parcel$export(module.exports, "SSRQueryResponseCache", () => $34860a397e66365f$export$be21c283b097d175);

var $7LcWi = parcelRequire("7LcWi");
function $34860a397e66365f$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $7LcWi.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $34860a397e66365f$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $34860a397e66365f$export$be21c283b097d175 extends (0, $7LcWi.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl, timeoutCallback: timeoutCallback }){
        super({
            size: size,
            ttl: ttl
        });
        const isServer = typeof window === 'undefined';
        const cachedData = isServer ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || window?.__PLATFORM_SSR_AGG_CACHE__?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(()=>{
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback?.(this._responses, this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    /**
	 * @deprecated only sets a single response; does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Stores a GraphQLRepsonse along with metadata about the call.
	 * If called multiple times (such as when incremental payloads are received),
	 * will update the stored response to be an array of GraphQLSingularResponse objects,
	 * which Relay is happy to handle.
	 * @deprecated works, but does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $34860a397e66365f$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}

});



parcelRegister("jA2dA", function(module, exports) {
$parcel$export(module.exports, "UFOThirdPartySegment", () => $129c56e202e96027$export$5f6fe75c46d0124e);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $9G3Hh = parcelRequire("9G3Hh");

var $22i4U = parcelRequire("22i4U");

var $8IAtM = parcelRequire("8IAtM");

var $k5uvD = parcelRequire("k5uvD");

var $5hgll = parcelRequire("5hgll");

var $7QiLB = parcelRequire("7QiLB");

var $bXfN8 = parcelRequire("bXfN8");

var $jbwXy = parcelRequire("jbwXy");

var $deB58 = parcelRequire("deB58");

var $6lt4T = parcelRequire("6lt4T");

var $lJ0Z9 = parcelRequire("lJ0Z9");

var $2qFML = parcelRequire("2qFML");
const $129c56e202e96027$var$FORGE_TTAI_EVENT_PREFIX = 'ufo-forge';
// Early-signal event emitted by the iframe bridge as soon as it wires up its
// UFO observers. Receiving this within ABORT_TIMEOUT_INITIAL_MS tells us the
// iframe is on the new rollout cohort and will send data events.
const $129c56e202e96027$var$FORGE_INIT_EVENT = 'ufo-forge-init';
// Grace period (ms) after the navigation hold releases before finalising.
const $129c56e202e96027$var$GRACE_PERIOD_MS = 2000;
// Initial abort timeout (ms from mount). If no recognised iframe event arrives within
// this window, the hold is force-released and an abort marker is logged. This protects
// metric quality during progressive rollouts where old-cohort iframes never emit events.
const $129c56e202e96027$var$ABORT_TIMEOUT_INITIAL_MS = 6000;
// Per-segment cap on the number of `resized` entries forwarded to addIframeSegmentData.
// useResizeAnalytics already limits emissions to a 10s tracking window, but a chatty
// app could still produce dozens of resizes; combined with many Forge apps on one
// page this could push segment3pData toward the 60 KB soft limit. The cap provides
// defence-in-depth without affecting realistic apps (typical <20 resizes per segment).
const $129c56e202e96027$var$MAX_RESIZED_ENTRIES_PER_SEGMENT = 50;
// Extended abort timeout (ms from mount). Once any recognised iframe event is received
// we know the iframe is on the new rollout cohort and actively sending data, so we extend
// the window to accommodate legitimately slow-loading Forge apps.
const $129c56e202e96027$var$ABORT_TIMEOUT_EXTENDED_MS = 30000;
// Events logged via addIframeSegmentData as they arrive.
const $129c56e202e96027$var$IFRAME_SEGMENT_DATA_SUFFIXES = [
    'resource-timing',
    'paint-timing',
    'largest-contentful-paint',
    'layout-shift',
    'dom-mutations',
    'navigation-timing'
];
// Events that extend the forge-ui-requests corrected end-time during grace.
const $129c56e202e96027$var$NAV_HOLD_GRACE_SUFFIXES = new Set([
    'navigation-timing',
    'resource-timing'
]);
/** Reads segmentId from UFOInteractionContext and stores it in a ref. */ function $129c56e202e96027$var$IframeSegmentIdReader({ segmentIdRef: segmentIdRef }) {
    const context = (0, $fsvuC.useContext)((0, $9G3Hh.default));
    const labelStack = context?.labelStack;
    const segmentId = labelStack && labelStack.length > 0 ? labelStack[labelStack.length - 1].segmentId : undefined;
    if (segmentId && segmentIdRef.current !== segmentId) segmentIdRef.current = segmentId;
    return null;
}
$129c56e202e96027$var$IframeSegmentIdReader.displayName = "IframeSegmentIdReader";
/** Subscribes to iframe performance events and records them as segment3pTimings. */ function $129c56e202e96027$var$IframeSegment({ onRegisterIframeEventListener: onRegisterIframeEventListener, appType: appType }) {
    const interactionId = (0, $fsvuC.useContext)((0, $22i4U.default));
    const interactionContext = (0, $fsvuC.useContext)((0, $9G3Hh.default));
    const segmentIdRef = (0, $fsvuC.useRef)(undefined);
    // Per-segment counter for `resized` entries (defence-in-depth payload cap).
    // Tracks both the count AND the segmentId it was last incremented under, so
    // SPA navigations that swap segmentId reset the budget for the new segment.
    const resizedCountRef = (0, $fsvuC.useRef)(0);
    const resizedCounterSegmentIdRef = (0, $fsvuC.useRef)(undefined);
    const isUiKit = appType === 'UIKit';
    // Released on the first navigation-timing event from the iframe.
    const [navigationHold, setNavigationHold] = (0, $fsvuC.useState)('holding');
    // UIKit: wrap onRender to account for React Profiler timings
    // Accumulates profiler timing bounds so we emit one aggregated entry at cleanup.
    const profilerAccRef = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useLayoutEffect)(()=>{
        if (!isUiKit || !interactionContext || !interactionContext.onRender) return;
        const originalOnRender = interactionContext.onRender.bind(interactionContext);
        interactionContext.onRender = function(phase, actualDuration, baseDuration, startTime, commitTime) {
            originalOnRender(phase, actualDuration, baseDuration, startTime, commitTime);
            // Accumulate timing bounds into a single entry.
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            if (profilerAccRef.current === null) profilerAccRef.current = {
                startTime: start,
                endTime: end
            };
            else {
                if (start < profilerAccRef.current.startTime) profilerAccRef.current.startTime = start;
                if (end > profilerAccRef.current.endTime) profilerAccRef.current.endTime = end;
            }
        };
        return ()=>{
            interactionContext.onRender = originalOnRender;
        };
    }, [
        isUiKit,
        interactionContext,
        interactionId
    ]);
    (0, $fsvuC.useEffect)(()=>{
        let navigationHoldReleased = false;
        let lastNavEventTime = null;
        let gracePeriodTimer = null;
        // Tracks whether any recognised iframe event has been received, which tells us
        // the iframe is on the new rollout cohort and actively sending data.
        let iframeEventsReceived = false;
        let abortTimer;
        const mountTime = performance.now();
        const fireAbort = (abortAfterMs)=>{
            // Cancel any pending grace period so it doesn't also fire.
            if (gracePeriodTimer !== null) {
                clearTimeout(gracePeriodTimer);
                gracePeriodTimer = null;
            }
            // Force-release the hold if still active at abort time.
            if (!navigationHoldReleased) {
                navigationHoldReleased = true;
                setNavigationHold('released');
            }
            // Record the abort marker so downstream analytics can detect it.
            if (interactionId.current && segmentIdRef.current) (0, $8IAtM.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                label: 'segment-timing-abort',
                data: {
                    reason: 'timeout',
                    abortAfterMs: abortAfterMs
                }
            });
        };
        // Start with the short initial timeout. If no ufo-forge-init signal arrives
        // within this window, the iframe is likely an old-cohort app that will never
        // send events — abort early to avoid blocking the interaction indefinitely.
        abortTimer = setTimeout(()=>{
            if (!iframeEventsReceived) fireAbort($129c56e202e96027$var$ABORT_TIMEOUT_INITIAL_MS);
        }, $129c56e202e96027$var$ABORT_TIMEOUT_INITIAL_MS);
        const finaliseHolds = ()=>{
            const iid = interactionId.current;
            const lStack = interactionContext?.labelStack;
            if (iid && lStack) {
                if (lastNavEventTime !== null) (0, $8IAtM.addCompletedHold)(iid, lStack, 'forge-ui-requests', mountTime, lastNavEventTime);
            }
        };
        const scheduleGracePeriodExpiry = ()=>{
            // Reset the 2s countdown each time a new event arrives during the grace period.
            if (gracePeriodTimer !== null) clearTimeout(gracePeriodTimer);
            gracePeriodTimer = setTimeout(()=>{
                clearTimeout(abortTimer);
                finaliseHolds();
            }, $129c56e202e96027$var$GRACE_PERIOD_MS);
        };
        const maybeStartGracePeriod = ()=>{
            if (navigationHoldReleased && gracePeriodTimer === null) scheduleGracePeriodExpiry();
        };
        const handleEvent = (event)=>{
            // Host-side `resized` events come from useResizeAnalytics (forge-ui).
            // They are emitted whenever the iframe container height changes during
            // the 10s tracking window after mount. We forward only the reliable
            // fields (height, elapsed). The `measuredHeight` and `viewportHeight`
            // fields are intentionally excluded because they require a vendor
            // config that is rarely populated in practice (almost always null).
            if (event.type === 'resized') {
                // Guard against malformed payloads (height is required and must be
                // a non-negative number; useResizeAnalytics emits Math.trunc'd ints).
                // `IframeSegmentEvent` already declares `[key: string]: unknown`, so
                // no `as` cast is needed — the typeof guards handle runtime safety.
                const { height: height, elapsed: elapsed } = event;
                // Reset the per-segment counter when the active segmentId changes
                // (SPA navigations swap segments; each gets a fresh budget).
                if (segmentIdRef.current && segmentIdRef.current !== resizedCounterSegmentIdRef.current) {
                    resizedCountRef.current = 0;
                    resizedCounterSegmentIdRef.current = segmentIdRef.current;
                }
                if (typeof height === 'number' && Number.isFinite(height) && height >= 0 && typeof elapsed === 'number' && Number.isFinite(elapsed) && elapsed >= 0 && resizedCountRef.current < $129c56e202e96027$var$MAX_RESIZED_ENTRIES_PER_SEGMENT && interactionId.current && segmentIdRef.current) {
                    resizedCountRef.current += 1;
                    (0, $8IAtM.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                        label: 'resized',
                        data: {
                            height: height,
                            elapsed: elapsed
                        }
                    });
                }
                // NOTE: we deliberately do NOT set iframeEventsReceived = true here.
                // The 6s abort timer exists to detect old-cohort iframes that won't
                // emit bridge events. `resized` is a host-side signal (forge-ui's
                // ResizeObserver) and fires regardless of which bridge version the
                // iframe is serving, so it cannot confirm new-cohort membership.
                // Only bridge-emitted `ufo-forge-*` events (esp. `ufo-forge-init`)
                // are valid proof, and they extend the abort timeout below.
                return;
            }
            if (event.type !== 'ufo-event' || typeof event.name !== 'string' || !event.name.startsWith($129c56e202e96027$var$FORGE_TTAI_EVENT_PREFIX)) return;
            const eventName = event.name;
            const suffix = $129c56e202e96027$var$IFRAME_SEGMENT_DATA_SUFFIXES.find((s)=>eventName.endsWith(`-${s}`));
            if (suffix && interactionId.current && segmentIdRef.current) {
                const { type: type, ...rest } = event;
                const restData = rest;
                let data;
                if (suffix === 'resource-timing') data = (0, $7QiLB.shapeResourceTimingData)(restData);
                else if (suffix === 'navigation-timing') data = (0, $5hgll.shapeNavigationTimingData)(restData);
                else if (suffix === 'paint-timing') data = (0, $2qFML.shapePaintTimingData)(restData);
                else if (suffix === 'largest-contentful-paint') data = (0, $6lt4T.shapeLargestContentfulPaintData)(restData);
                else if (suffix === 'layout-shift') data = (0, $lJ0Z9.shapeLayoutShiftData)(restData);
                else if (suffix === 'dom-mutations') {
                    // Skip intermediate batches — only record the final summary batch.
                    if (!(0, $bXfN8.isDomMutationsFinalBatch)(restData)) return;
                    data = (0, $deB58.shapeDomMutationsData)(restData);
                } else data = restData;
                if (data !== undefined) (0, $8IAtM.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                    label: suffix,
                    data: data
                });
            }
            // ufo-forge-init confirms the iframe is on the new rollout cohort — extend the abort window.
            if (eventName === $129c56e202e96027$var$FORGE_INIT_EVENT && !iframeEventsReceived) {
                iframeEventsReceived = true;
                clearTimeout(abortTimer);
                const remainingMs = Math.max($129c56e202e96027$var$ABORT_TIMEOUT_EXTENDED_MS - (performance.now() - mountTime), 0);
                abortTimer = setTimeout(()=>{
                    fireAbort($129c56e202e96027$var$ABORT_TIMEOUT_EXTENDED_MS);
                }, remainingMs);
            }
            if (eventName.endsWith('-navigation-timing') && !navigationHoldReleased) {
                navigationHoldReleased = true;
                setNavigationHold('released');
                maybeStartGracePeriod();
            }
            if (navigationHoldReleased) {
                const now = performance.now();
                if (suffix && $129c56e202e96027$var$NAV_HOLD_GRACE_SUFFIXES.has(suffix)) {
                    lastNavEventTime = now;
                    scheduleGracePeriodExpiry();
                }
            }
        };
        const unregister = onRegisterIframeEventListener(handleEvent);
        // Emit react-profiler-timing for UI kit
        const activeInteraction = (0, $8IAtM.getActiveInteraction)();
        let isUnmounted = false;
        if (activeInteraction) activeInteraction.cleanupCallbacks.push(()=>{
            if (isUnmounted) return;
            const iid = interactionId.current;
            const sid = segmentIdRef.current;
            if (iid && sid && profilerAccRef.current !== null) {
                (0, $8IAtM.addIframeSegmentData)(iid, sid, {
                    label: 'react-profiler-timing',
                    data: {
                        ...profilerAccRef.current
                    }
                });
                profilerAccRef.current = null;
            }
        });
        return ()=>{
            isUnmounted = true;
            unregister();
            clearTimeout(abortTimer);
            if (gracePeriodTimer !== null) clearTimeout(gracePeriodTimer);
        };
    }, [
        onRegisterIframeEventListener,
        interactionId,
        interactionContext
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5chsV.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $k5uvD.default), {
                name: "forge-ui-requests",
                hold: navigationHold === 'holding'
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)($129c56e202e96027$var$IframeSegmentIdReader, {
                segmentIdRef: segmentIdRef
            })
        ]
    });
}
$129c56e202e96027$var$IframeSegment.displayName = "IframeSegment";
/** Writes per-segment extraData via addSegmentExtraData. */ function $129c56e202e96027$var$SegmentExtraDataWriter({ extraData: extraData }) {
    const interactionContext = (0, $fsvuC.useContext)((0, $9G3Hh.default));
    const interactionId = (0, $fsvuC.useContext)((0, $22i4U.default));
    const labelStack = interactionContext?.labelStack;
    const segmentId = labelStack && labelStack.length > 0 ? labelStack[labelStack.length - 1].segmentId : undefined;
    (0, $fsvuC.useEffect)(()=>{
        const currentInteractionId = interactionId.current;
        if (segmentId && currentInteractionId) (0, $8IAtM.addSegmentExtraData)(currentInteractionId, segmentId, extraData);
    }, [
        extraData,
        segmentId,
        interactionId
    ]);
    return null;
}
$129c56e202e96027$var$SegmentExtraDataWriter.displayName = "SegmentExtraDataWriter";
/** Writes the per-segment excluded breadcrumb via addExcluded3pSegment (keyed by segmentId). */ function $129c56e202e96027$var$Excluded3pSegmentDataWriter({ data: data }) {
    const interactionContext = (0, $fsvuC.useContext)((0, $9G3Hh.default));
    const interactionId = (0, $fsvuC.useContext)((0, $22i4U.default));
    const labelStack = interactionContext?.labelStack;
    const segmentId = labelStack && labelStack.length > 0 ? labelStack[labelStack.length - 1].segmentId : undefined;
    (0, $fsvuC.useEffect)(()=>{
        const currentInteractionId = interactionId.current;
        if (segmentId && currentInteractionId) (0, $8IAtM.addExcluded3pSegment)(currentInteractionId, segmentId, data);
    }, [
        data,
        segmentId,
        interactionId
    ]);
    return null;
}
$129c56e202e96027$var$Excluded3pSegmentDataWriter.displayName = "Excluded3pSegmentDataWriter";
const $129c56e202e96027$export$5f6fe75c46d0124e = (props)=>{
    const { children: children, onRegisterIframeEventListener: onRegisterIframeEventListener, extraData: extraData, excludeFromMetrics: excludeFromMetrics, excludedData: excludedData, ...otherProps } = props;
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jbwXy.default), {
        type: "third-party",
        excludeFromMetrics: excludeFromMetrics,
        ...otherProps,
        children: [
            onRegisterIframeEventListener && extraData && /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5chsV.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $5chsV.jsx)($129c56e202e96027$var$IframeSegment, {
                        onRegisterIframeEventListener: onRegisterIframeEventListener,
                        appType: extraData.appType
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)($129c56e202e96027$var$SegmentExtraDataWriter, {
                        extraData: extraData
                    })
                ]
            }),
            excludedData && /*#__PURE__*/ (0, $5chsV.jsx)($129c56e202e96027$var$Excluded3pSegmentDataWriter, {
                data: excludedData
            }),
            children
        ]
    });
};
$129c56e202e96027$export$5f6fe75c46d0124e.displayName = "UFOThirdPartySegment";
$129c56e202e96027$export$5f6fe75c46d0124e.displayName = 'UFOThirdPartySegment';

});
parcelRegister("5hgll", function(module, exports) {
$parcel$export(module.exports, "shapeNavigationTimingData", () => $226039ffbda57b03$export$545c2c69328f5019);

var $ftwuK = parcelRequire("ftwuK");
function $226039ffbda57b03$export$545c2c69328f5019(data) {
    const payload = data?.payload || {};
    // payload.timing.* to payload.* directly. Support both shapes during rollout.
    const timing = payload?.timing || payload;
    // Trim long URLs to just the last path segment to keep payload size manageable.
    const rawName = typeof payload.name === 'string' ? payload.name : '';
    const label = rawName.includes('/') ? rawName.split('/').filter(Boolean).pop() ?? rawName : rawName;
    return {
        label: label,
        // From Resource Timing spec
        redirectStart: (0, $ftwuK.num)(timing.redirectStart),
        redirectEnd: (0, $ftwuK.num)(timing.redirectEnd),
        fetchStart: (0, $ftwuK.num)(timing.fetchStart),
        domainLookupStart: (0, $ftwuK.num)(timing.domainLookupStart),
        domainLookupEnd: (0, $ftwuK.num)(timing.domainLookupEnd),
        connectStart: (0, $ftwuK.num)(timing.connectStart),
        connectEnd: (0, $ftwuK.num)(timing.connectEnd),
        secureConnectionStart: (0, $ftwuK.num)(timing.secureConnectionStart),
        requestStart: (0, $ftwuK.num)(timing.requestStart),
        responseStart: (0, $ftwuK.num)(timing.responseStart),
        responseEnd: (0, $ftwuK.num)(timing.responseEnd),
        // Added in PR #769 — present in new flat shape, absent in old nested shape (defaults to 0)
        encodedBodySize: (0, $ftwuK.num)(timing.encodedBodySize),
        decodedBodySize: (0, $ftwuK.num)(timing.decodedBodySize),
        transferSize: (0, $ftwuK.num)(timing.transferSize),
        // From Navigation Timing 2 spec
        redirectCount: (0, $ftwuK.num)(payload.redirectCount),
        type: typeof payload.type === 'string' ? payload.type : undefined,
        unloadEventStart: (0, $ftwuK.num)(timing.unloadEventStart),
        unloadEventEnd: (0, $ftwuK.num)(timing.unloadEventEnd),
        workerStart: (0, $ftwuK.num)(timing.workerStart),
        nextHopProtocol: typeof timing.nextHopProtocol === 'string' ? timing.nextHopProtocol : undefined
    };
}

});
parcelRegister("ftwuK", function(module, exports) {
$parcel$export(module.exports, "num", () => $13d7778e3fe12e15$export$61cc6a0be4938a2a);
$parcel$export(module.exports, "OTHER_JS_RESOURCE_TYPE", () => $13d7778e3fe12e15$export$824874a276cb07ee);
$parcel$export(module.exports, "IMAGE_RESOURCE_LABEL", () => $13d7778e3fe12e15$export$32cd9cb473b29795);
$parcel$export(module.exports, "FILE_RESOURCE_LABEL", () => $13d7778e3fe12e15$export$df2b7600eb5084d1);
$parcel$export(module.exports, "AVATAR_RESOURCE_LABEL", () => $13d7778e3fe12e15$export$f46f09415f80b308);
const $13d7778e3fe12e15$export$61cc6a0be4938a2a = (v)=>typeof v === 'number' ? Math.round(v) : 0;
const $13d7778e3fe12e15$export$824874a276cb07ee = 'other';
const $13d7778e3fe12e15$export$32cd9cb473b29795 = '<image-resource>';
const $13d7778e3fe12e15$export$df2b7600eb5084d1 = '<file-resource>';
const $13d7778e3fe12e15$export$f46f09415f80b308 = '<avatar-resource>';

});


parcelRegister("7QiLB", function(module, exports) {
$parcel$export(module.exports, "shapeResourceTimingData", () => $79111d947cc1ba23$export$58bcddf582fad063);

var $iUv1y = parcelRequire("iUv1y");

var $6sT1Z = parcelRequire("6sT1Z");

var $iDDej = parcelRequire("iDDej");

var $ftwuK = parcelRequire("ftwuK");
// Accepted source values from forge-cdn bridge:
//   - 'forge-framework' (PR #775+) — Forge runtime assets (bridge.js, iframeResizer*, etc.)
//   - 'forge-app'       (PR #775+) — app-author assets on installation-scoped subdomain
//   - 'external'        (both schemes) — anything outside Atlassian-controlled domains
//   - 'internal'        (PR #769 only, LEGACY) — bridges still emit this until PR #775
//                       rolls out everywhere; safe to remove from this allowlist after
//                       the rollout has been stable for a release cycle. Do NOT remove
//                       'external' during that cleanup — it's a first-class value in
//                       both the old and new schemes.
const $79111d947cc1ba23$var$ACCEPTED_SOURCES = [
    'forge-framework',
    'forge-app',
    'external',
    'internal'
];
const $79111d947cc1ba23$var$ASSET_RESOURCE_TYPES = new Set([
    'script',
    'link',
    'css'
]);
const $79111d947cc1ba23$var$SCRIPT_EXTENSIONS = [
    '.js',
    '.mjs',
    '.cjs'
];
const $79111d947cc1ba23$var$STYLESHEET_EXTENSIONS = [
    '.css'
];
const $79111d947cc1ba23$var$ASSET_EXTENSIONS = [
    ...$79111d947cc1ba23$var$SCRIPT_EXTENSIONS,
    ...$79111d947cc1ba23$var$STYLESHEET_EXTENSIONS
];
const $79111d947cc1ba23$var$FILE_OR_MEDIA_EXTENSIONS = [
    '.pdf',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.ppt',
    '.pptx',
    '.csv',
    '.zip',
    '.heic',
    '.mov',
    '.mp4',
    '.mp3',
    '.wav',
    '.woff',
    '.woff2',
    '.ttf',
    '.otf'
];
const $79111d947cc1ba23$var$IMAGE_EXTENSIONS = [
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.webp',
    '.svg',
    '.ico'
];
const $79111d947cc1ba23$var$ATTACHMENT_OR_DOWNLOAD_PATH_PATTERNS = [
    /(?:^|\/)secure\/attachment(?:\/|$)/,
    /(?:^|\/)download\/attachments(?:\/|$)/,
    /(?:^|\/)wiki\/download(?:\/|$)/,
    /(?:^|\/)child\/attachment(?:\/|$)/,
    /(?:^|\/)attachment(?:\/|$)/
];
function $79111d947cc1ba23$var$stripQueryAndHash(value) {
    return value.split(/[?#]/, 1)[0] ?? '';
}
function $79111d947cc1ba23$var$getSanitizedLastPathSegment(value) {
    const trimmedValue = $79111d947cc1ba23$var$stripQueryAndHash(value).replace(/\/+$/, '');
    if (!trimmedValue.includes('/')) return trimmedValue;
    return trimmedValue.split('/').filter(Boolean).pop() ?? trimmedValue;
}
function $79111d947cc1ba23$var$hasExtension(value, extensions) {
    const path = $79111d947cc1ba23$var$stripQueryAndHash(value).toLowerCase();
    return extensions.some((extension)=>path.endsWith(extension));
}
function $79111d947cc1ba23$var$hasAttachmentOrDownloadPath(value) {
    return $79111d947cc1ba23$var$ATTACHMENT_OR_DOWNLOAD_PATH_PATTERNS.some((pattern)=>pattern.test(value));
}
function $79111d947cc1ba23$var$isAvatarResource(value) {
    return value.includes('avatar-management') || value.includes('/initials/') || value.includes('%2finitials%2f') || value.includes('viewavatar');
}
function $79111d947cc1ba23$var$getSanitizedBackendResourceLabel(rawName) {
    const querylessName = $79111d947cc1ba23$var$stripQueryAndHash(rawName);
    const normalizedRawName = rawName.toLowerCase();
    const normalizedQuerylessName = querylessName.toLowerCase();
    if ($79111d947cc1ba23$var$isAvatarResource(normalizedRawName)) return 0, $ftwuK.AVATAR_RESOURCE_LABEL;
    if ($79111d947cc1ba23$var$hasExtension(normalizedQuerylessName, $79111d947cc1ba23$var$IMAGE_EXTENSIONS)) return 0, $ftwuK.IMAGE_RESOURCE_LABEL;
    if ($79111d947cc1ba23$var$hasAttachmentOrDownloadPath(normalizedQuerylessName) || $79111d947cc1ba23$var$hasExtension(normalizedQuerylessName, $79111d947cc1ba23$var$FILE_OR_MEDIA_EXTENSIONS)) return 0, $ftwuK.FILE_RESOURCE_LABEL;
    return querylessName;
}
function $79111d947cc1ba23$var$isBackendResourceTiming(initiatorType) {
    return (0, $iDDej.BACKEND_RESOURCE_TIMING_INITIATOR_TYPES).has(initiatorType);
}
function $79111d947cc1ba23$var$isScriptOrStylesheetResource(rawName, initiatorType) {
    if (initiatorType === (0, $ftwuK.OTHER_JS_RESOURCE_TYPE)) return $79111d947cc1ba23$var$hasExtension(rawName, $79111d947cc1ba23$var$ASSET_EXTENSIONS);
    if (!$79111d947cc1ba23$var$ASSET_RESOURCE_TYPES.has(initiatorType)) return false;
    return $79111d947cc1ba23$var$hasExtension(rawName, $79111d947cc1ba23$var$ASSET_EXTENSIONS);
}
function $79111d947cc1ba23$export$58bcddf582fad063(data) {
    const payload = data?.payload || {};
    // payload.timing.* to payload.* directly. Support both shapes during rollout.
    const timing = payload?.timing || payload;
    const rawName = typeof payload.name === 'string' ? payload.name : '';
    const initiatorType = typeof payload.initiatorType === 'string' ? payload.initiatorType : 'other';
    const isBackendTiming = $79111d947cc1ba23$var$isBackendResourceTiming(initiatorType);
    if (!isBackendTiming && !$79111d947cc1ba23$var$isScriptOrStylesheetResource(rawName, initiatorType)) return undefined;
    const name = isBackendTiming ? $79111d947cc1ba23$var$getSanitizedBackendResourceLabel(rawName) : $79111d947cc1ba23$var$getSanitizedLastPathSegment(rawName);
    const startTime = (0, $ftwuK.num)(payload.startTime);
    const duration = (0, $ftwuK.num)(payload.duration);
    const fetchStart = (0, $ftwuK.num)(timing.fetchStart);
    const workerStart = (0, $ftwuK.num)(timing.workerStart);
    const responseStart = (0, $ftwuK.num)(timing.responseStart);
    const requestStart = (0, $ftwuK.num)(timing.requestStart);
    const transferSize = typeof payload.transferSize === 'number' ? payload.transferSize : undefined;
    const encodedSize = typeof payload.encodedBodySize === 'number' ? payload.encodedBodySize : undefined;
    const decodedSize = typeof payload.decodedBodySize === 'number' ? payload.decodedBodySize : undefined;
    // serverTime / networkTime are not in the current iframe payload but kept for forward-compat
    const serverTime = typeof payload.serverTime === 'number' ? payload.serverTime : undefined;
    const networkTime = typeof payload.networkTime === 'number' ? payload.networkTime : undefined;
    const source = $79111d947cc1ba23$var$ACCEPTED_SOURCES.includes(payload.source) ? payload.source : undefined;
    // Base fields — always present (times are relative to interaction start from the iframe)
    const shaped = {
        label: name,
        startTime: startTime,
        duration: duration,
        workerStart: Math.max(workerStart, 0),
        fetchStart: Math.max(fetchStart, 0),
        type: initiatorType,
        ...source !== undefined ? {
            source: source
        } : {}
    };
    const cacheable = (0, $6sT1Z.isCacheableType)(rawName, initiatorType);
    shaped.ttfb = responseStart;
    if (serverTime !== undefined) shaped.serverTime = serverTime;
    if (networkTime !== undefined) shaped.networkTime = networkTime;
    if (transferSize !== undefined) shaped.size = transferSize;
    // Flag entries where timing-allow-origin headers are missing:
    // duration > 0 but all size fields are 0 means the browser withheld size data.
    if (duration > 0 && transferSize === 0 && encodedSize === 0) shaped.noTA = true;
    if (cacheable) {
        // CacheableResourceTiming — calculateTransferType is only meaningful for cacheable resources
        const transferType = (0, $iUv1y.calculateTransferType)(rawName, initiatorType, duration, transferSize);
        if (transferType !== null) shaped.transferType = transferType;
        if (encodedSize !== undefined) shaped.encodedSize = encodedSize;
        if (decodedSize !== undefined) shaped.decodedSize = decodedSize;
    } else // NonCacheableResourceTiming (fetch, xmlhttprequest, etc.)
    shaped.requestStart = requestStart;
    return shaped;
}

});
parcelRegister("iUv1y", function(module, exports) {
$parcel$export(module.exports, "calculateTransferType", () => $e5201e152039a6ed$export$82deef6698791e4e);

var $6sT1Z = parcelRequire("6sT1Z");

function $e5201e152039a6ed$export$82deef6698791e4e(name, type, duration, size) {
    if (!(0, $6sT1Z.isCacheableType)(name, type)) return 0, $402a0cf753e25867$export$790b3707cd7b148f;
    if ((size === undefined || size === 0) && duration === 0) return 0, $402a0cf753e25867$export$31e3351e7cd6ef5;
    if (size === 0 && duration > 0) return 0, $402a0cf753e25867$export$1f09aaaa930516f;
    if (size === undefined) return null;
    return 0, $402a0cf753e25867$export$790b3707cd7b148f;
}

});
parcelRegister("6sT1Z", function(module, exports) {
$parcel$export(module.exports, "isCacheableType", () => $23c04f8669361bf3$export$86a03f39f85a653c);
const $23c04f8669361bf3$var$alwaysCacheableTypes = [
    'script',
    'link'
];
function $23c04f8669361bf3$export$86a03f39f85a653c(url, type) {
    if ($23c04f8669361bf3$var$alwaysCacheableTypes.includes(type)) return true;
    if (type === 'other' && url.includes('.js')) return true;
    return false;
}

});

const $402a0cf753e25867$export$790b3707cd7b148f = 'network';
const $402a0cf753e25867$export$31e3351e7cd6ef5 = 'memory';
const $402a0cf753e25867$export$1f09aaaa930516f = 'disk';



parcelRegister("bXfN8", function(module, exports) {
$parcel$export(module.exports, "isDomMutationsFinalBatch", () => $496146f848029085$export$e8c5a8531f7dfa04);

var $7OCor = parcelRequire("7OCor");
function $496146f848029085$export$e8c5a8531f7dfa04(data) {
    const payload = (0, $7OCor.extractPayload)(data);
    return payload.isFinalBatch === true;
}

});
parcelRegister("7OCor", function(module, exports) {
$parcel$export(module.exports, "extractPayload", () => $5e0e4339e29d009d$export$4f39ed69b4aab39d);
function $5e0e4339e29d009d$export$4f39ed69b4aab39d(data) {
    return data.payload !== null && typeof data.payload === 'object' ? data.payload : {};
}

});


parcelRegister("deB58", function(module, exports) {
$parcel$export(module.exports, "shapeDomMutationsData", () => $f599445474fa654b$export$6954fd19623912a2);

var $7OCor = parcelRequire("7OCor");

var $6r691 = parcelRequire("6r691");
function $f599445474fa654b$export$6954fd19623912a2(data) {
    const payload = (0, $7OCor.extractPayload)(data);
    return {
        totalMutations: typeof payload.totalMutations === 'number' ? payload.totalMutations : 0,
        observationDurationMs: (0, $6r691.num)(payload.observationDurationMs),
        stopReason: typeof payload.stopReason === 'string' ? payload.stopReason : null
    };
}

});
parcelRegister("6r691", function(module, exports) {
$parcel$export(module.exports, "num", () => $d0865e1689b024d8$export$61cc6a0be4938a2a);
/**
 * Iframe event shaping helpers
 *
 * These functions normalise raw Forge bridge event data into compact, consistent
 * shapes before storing in segment3pTimings, reducing payload size and aligning
 * with the equivalent host-page metrics where applicable.
 *
 * Each function receives the full raw event object (minus `type`) and returns
 * only the fields worth retaining in the analytics payload.
 */ const $d0865e1689b024d8$export$61cc6a0be4938a2a = (v)=>typeof v === 'number' ? Math.round(v) : 0;

});


parcelRegister("6lt4T", function(module, exports) {
$parcel$export(module.exports, "shapeLargestContentfulPaintData", () => $121d46899265e56a$export$249cfe420379ce6a);

var $7OCor = parcelRequire("7OCor");

var $6r691 = parcelRequire("6r691");
function $121d46899265e56a$export$249cfe420379ce6a(data) {
    const payload = (0, $7OCor.extractPayload)(data);
    return {
        startTime: (0, $6r691.num)(payload.startTime),
        size: (0, $6r691.num)(payload.size)
    };
}

});

parcelRegister("lJ0Z9", function(module, exports) {
$parcel$export(module.exports, "shapeLayoutShiftData", () => $9df0109ec9a52de0$export$13eca0f9ce301e95);

var $7OCor = parcelRequire("7OCor");

var $6r691 = parcelRequire("6r691");
function $9df0109ec9a52de0$export$13eca0f9ce301e95(data) {
    const payload = (0, $7OCor.extractPayload)(data);
    const rawSources = Array.isArray(payload.sources) ? payload.sources : [];
    const sources = rawSources.map((source)=>{
        const s = source !== null && typeof source === 'object' ? source : {};
        return {
            node: typeof s.node === 'string' ? s.node : 'unknown'
        };
    });
    return {
        value: typeof payload.value === 'number' ? payload.value : 0,
        startTime: (0, $6r691.num)(payload.startTime),
        cumulativeScore: typeof payload.cumulativeScore === 'number' ? payload.cumulativeScore : 0,
        sessionValue: typeof payload.sessionValue === 'number' ? payload.sessionValue : 0,
        sources: sources
    };
}

});

parcelRegister("2qFML", function(module, exports) {
$parcel$export(module.exports, "shapePaintTimingData", () => $8110b140a35066db$export$eb873803b57f13dd);

var $7OCor = parcelRequire("7OCor");

var $6r691 = parcelRequire("6r691");
function $8110b140a35066db$export$eb873803b57f13dd(data) {
    const payload = (0, $7OCor.extractPayload)(data);
    return {
        name: typeof payload.name === 'string' ? payload.name : '',
        startTime: (0, $6r691.num)(payload.startTime)
    };
}

});


parcelRegister("4HFTd", function(module, exports) {
$parcel$export(module.exports, "convertToError", () => $107427706557d208$export$70fb45ead8febbe5);
const $107427706557d208$export$70fb45ead8febbe5 = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};

});

parcelRegister("479gE", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fef01371a388bdf$export$2e2bcd8739ae039);
function $2fef01371a388bdf$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $2fef01371a388bdf$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $2fef01371a388bdf$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $2fef01371a388bdf$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $2fef01371a388bdf$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $2fef01371a388bdf$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $2fef01371a388bdf$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $2fef01371a388bdf$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $2fef01371a388bdf$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $2fef01371a388bdf$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $2fef01371a388bdf$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $2fef01371a388bdf$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $2fef01371a388bdf$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $2fef01371a388bdf$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $2fef01371a388bdf$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $2fef01371a388bdf$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $2fef01371a388bdf$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $2fef01371a388bdf$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $2fef01371a388bdf$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $2fef01371a388bdf$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $2fef01371a388bdf$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $2fef01371a388bdf$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $2fef01371a388bdf$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $2fef01371a388bdf$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $2fef01371a388bdf$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $2fef01371a388bdf$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $2fef01371a388bdf$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $2fef01371a388bdf$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $2fef01371a388bdf$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $2fef01371a388bdf$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $2fef01371a388bdf$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $2fef01371a388bdf$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $2fef01371a388bdf$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $2fef01371a388bdf$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $2fef01371a388bdf$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $2fef01371a388bdf$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $2fef01371a388bdf$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $2fef01371a388bdf$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $2fef01371a388bdf$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $2fef01371a388bdf$var$fromHex_1 = $2fef01371a388bdf$var$fromHex, $2fef01371a388bdf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $2fef01371a388bdf$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $2fef01371a388bdf$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $2fef01371a388bdf$var$fromRgb_1 = $2fef01371a388bdf$var$fromRgb, $2fef01371a388bdf$var$fromCssRgb_1 = $2fef01371a388bdf$var$fromCssRgb, $2fef01371a388bdf$var$fromHsl_1 = $2fef01371a388bdf$var$fromHsl, $2fef01371a388bdf$var$fromCssHsl_1 = $2fef01371a388bdf$var$fromCssHsl, $2fef01371a388bdf$var$fromHsv_1 = $2fef01371a388bdf$var$fromHsv, $2fef01371a388bdf$var$fromCmyk_1 = $2fef01371a388bdf$var$fromCmyk, $2fef01371a388bdf$var$fromYiq_1 = $2fef01371a388bdf$var$fromYiq, $2fef01371a388bdf$var$fromXYZ_1 = $2fef01371a388bdf$var$fromXYZ, $2fef01371a388bdf$var$fromxyY_1 = $2fef01371a388bdf$var$fromxyY, $2fef01371a388bdf$var$fromLms_1 = $2fef01371a388bdf$var$fromLms, $2fef01371a388bdf$var$fromCieLab_1 = $2fef01371a388bdf$var$fromCieLab, $2fef01371a388bdf$var$fromCieLuv_1 = $2fef01371a388bdf$var$fromCieLuv, $2fef01371a388bdf$var$fromCieLch_1 = $2fef01371a388bdf$var$fromCieLch, $2fef01371a388bdf$var$fromHsluv = $2fef01371a388bdf$var$fromCieLch$1, $2fef01371a388bdf$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $2fef01371a388bdf$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $2fef01371a388bdf$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $2fef01371a388bdf$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $2fef01371a388bdf$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $2fef01371a388bdf$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $2fef01371a388bdf$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $2fef01371a388bdf$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $2fef01371a388bdf$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $2fef01371a388bdf$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $2fef01371a388bdf$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $2fef01371a388bdf$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $2fef01371a388bdf$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $2fef01371a388bdf$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $2fef01371a388bdf$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $2fef01371a388bdf$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $2fef01371a388bdf$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $2fef01371a388bdf$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $2fef01371a388bdf$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $2fef01371a388bdf$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $2fef01371a388bdf$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $2fef01371a388bdf$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $2fef01371a388bdf$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $2fef01371a388bdf$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $2fef01371a388bdf$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $2fef01371a388bdf$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $2fef01371a388bdf$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $2fef01371a388bdf$var$fromHsluv
    }
}, $2fef01371a388bdf$var$adapt_1 = $2fef01371a388bdf$var$adapt, $2fef01371a388bdf$var$adjacent_1 = $2fef01371a388bdf$var$adjacent, $2fef01371a388bdf$var$brightness_1 = $2fef01371a388bdf$var$brightness, $2fef01371a388bdf$var$complementary_1 = $2fef01371a388bdf$var$complementary, $2fef01371a388bdf$var$contrast_1 = $2fef01371a388bdf$var$contrast, $2fef01371a388bdf$var$contrastRatio_1 = $2fef01371a388bdf$var$contrastRatio, $2fef01371a388bdf$var$convert_1 = $2fef01371a388bdf$var$convert, $2fef01371a388bdf$var$difference_1 = $2fef01371a388bdf$var$difference, $2fef01371a388bdf$var$fade_1 = $2fef01371a388bdf$var$fade, $2fef01371a388bdf$var$greyscale_1 = $2fef01371a388bdf$var$greyscale, $2fef01371a388bdf$var$hue_1 = $2fef01371a388bdf$var$hue, $2fef01371a388bdf$var$invert_1 = $2fef01371a388bdf$var$invert, $2fef01371a388bdf$var$invertLightness_1 = $2fef01371a388bdf$var$invertLightness, $2fef01371a388bdf$var$mid_1 = $2fef01371a388bdf$var$mid, $2fef01371a388bdf$var$multiply_1 = $2fef01371a388bdf$var$multiply, $2fef01371a388bdf$var$saturation_1 = $2fef01371a388bdf$var$saturation, $2fef01371a388bdf$var$sepia_1 = $2fef01371a388bdf$var$sepia, $2fef01371a388bdf$var$shade_1 = $2fef01371a388bdf$var$shade, $2fef01371a388bdf$var$temperature_1 = $2fef01371a388bdf$var$temperature, $2fef01371a388bdf$var$tetrad_1 = $2fef01371a388bdf$var$tetrad, $2fef01371a388bdf$var$triad_1 = $2fef01371a388bdf$var$triad, $2fef01371a388bdf$var$index$2 = {
    adapt: $2fef01371a388bdf$var$adapt_1,
    adjacent: $2fef01371a388bdf$var$adjacent_1,
    brightness: $2fef01371a388bdf$var$brightness_1,
    complementary: $2fef01371a388bdf$var$complementary_1,
    contrast: $2fef01371a388bdf$var$contrast_1,
    contrastRatio: $2fef01371a388bdf$var$contrastRatio_1,
    convert: $2fef01371a388bdf$var$convert_1,
    difference: $2fef01371a388bdf$var$difference_1,
    fade: $2fef01371a388bdf$var$fade_1,
    greyscale: $2fef01371a388bdf$var$greyscale_1,
    hue: $2fef01371a388bdf$var$hue_1,
    invert: $2fef01371a388bdf$var$invert_1,
    invertLightness: $2fef01371a388bdf$var$invertLightness_1,
    mid: $2fef01371a388bdf$var$mid_1,
    multiply: $2fef01371a388bdf$var$multiply_1,
    saturation: $2fef01371a388bdf$var$saturation_1,
    sepia: $2fef01371a388bdf$var$sepia_1,
    shade: $2fef01371a388bdf$var$shade_1,
    temperature: $2fef01371a388bdf$var$temperature_1,
    tetrad: $2fef01371a388bdf$var$tetrad_1,
    triad: $2fef01371a388bdf$var$triad_1
}, $2fef01371a388bdf$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $2fef01371a388bdf$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $2fef01371a388bdf$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($2fef01371a388bdf$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $2fef01371a388bdf$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($2fef01371a388bdf$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $2fef01371a388bdf$var$api_1 = $2fef01371a388bdf$var$api, $2fef01371a388bdf$var$helpers = {
    getIlluminant: function(r) {
        return $2fef01371a388bdf$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $2fef01371a388bdf$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $2fef01371a388bdf$var$index)if ($2fef01371a388bdf$var$index.hasOwnProperty(e) && $2fef01371a388bdf$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $2fef01371a388bdf$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $2fef01371a388bdf$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $2fef01371a388bdf$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $2fef01371a388bdf$var$constants, s));
            default:
                return null;
        }
    }
}, $2fef01371a388bdf$var$helpers_1 = $2fef01371a388bdf$var$helpers, $2fef01371a388bdf$var$dependencies = {
    conversions: $2fef01371a388bdf$var$index,
    operations: $2fef01371a388bdf$var$index$2,
    helpers: $2fef01371a388bdf$var$helpers_1
}, $2fef01371a388bdf$var$entry = $2fef01371a388bdf$var$api_1($2fef01371a388bdf$var$dependencies, $2fef01371a388bdf$var$constants);
var $2fef01371a388bdf$export$2e2bcd8739ae039 = $2fef01371a388bdf$var$entry;

});

parcelRegister("l67wx", function(module, exports) {

var $h6Xza = parcelRequire("h6Xza");

var $7ufod = parcelRequire("7ufod");

var $eh3wF = parcelRequire("eh3wF");

var $11H9d = parcelRequire("11H9d");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $f5bffe91d2927262$var$forEach(collection, iteratee) {
    var func = $11H9d(collection) ? $h6Xza : $7ufod;
    return func(collection, $eh3wF(iteratee));
}
module.exports = $f5bffe91d2927262$var$forEach;

});
parcelRegister("eh3wF", function(module, exports) {

var $leX1P = parcelRequire("leX1P");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $a64563680bb55374$var$castFunction(value) {
    return typeof value == 'function' ? value : $leX1P;
}
module.exports = $a64563680bb55374$var$castFunction;

});


parcelRegister("3ls7k", function(module, exports) {
$parcel$export(module.exports, "PlatformSiteAri", () => $26f924bc66742f72$export$62388e9e87e2e1c9);

var $4hjtB = parcelRequire("4hjtB");

var $llRkr = parcelRequire("llRkr");

var $jEYBS = parcelRequire("jEYBS");
// src/platform/site/manifest.ts
var $26f924bc66742f72$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $4hjtB.PlatformSiteAriResourceOwner),
    resourceType: (0, $4hjtB.PlatformSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $26f924bc66742f72$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $llRkr.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $26f924bc66742f72$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $26f924bc66742f72$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $26f924bc66742f72$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $26f924bc66742f72$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $jEYBS.AriParser).fromOpts(derivedOpts, $26f924bc66742f72$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $jEYBS.AriParser).fromString(maybeAri, $26f924bc66742f72$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};

});
parcelRegister("4hjtB", function(module, exports) {
$parcel$export(module.exports, "PlatformSiteAriResourceOwner", () => $31d7db95bd45aba8$export$2866935ccba4694c);
$parcel$export(module.exports, "PlatformSiteAriResourceType", () => $31d7db95bd45aba8$export$c9ae8b227ea4b550);
// src/platform/site/types.ts
var $31d7db95bd45aba8$export$2866935ccba4694c = "platform", $31d7db95bd45aba8$export$c9ae8b227ea4b550 = "site";

});


parcelRegister("6H1py", function(module, exports) {

var $i2PXL = parcelRequire("i2PXL");

var $9ounl = parcelRequire("9ounl");
/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */ var $4df7da7691f76369$var$startCase = $i2PXL(function(result, word, index) {
    return result + (index ? ' ' : '') + $9ounl(word);
});
module.exports = $4df7da7691f76369$var$startCase;

});

parcelRegister("hMQGr", function(module, exports) {

var $3I8Od = parcelRequire("3I8Od");

var $kxesc = parcelRequire("kxesc");

var $cwDmY = parcelRequire("cwDmY");

var $ikiqP = parcelRequire("ikiqP");

var $cFg8N = parcelRequire("cFg8N");

var $hX6xj = parcelRequire("hX6xj");

var $7Neex = parcelRequire("7Neex");

var $94agL = parcelRequire("94agL");
/** Used to compose bitmasks for cloning. */ var $cf2fc93d797feeac$var$CLONE_DEEP_FLAG = 1, $cf2fc93d797feeac$var$CLONE_FLAT_FLAG = 2, $cf2fc93d797feeac$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $cf2fc93d797feeac$var$omit = $7Neex(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $3I8Od(paths, function(path) {
        path = $ikiqP(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $cFg8N(object, $94agL(object), result);
    if (isDeep) result = $kxesc(result, $cf2fc93d797feeac$var$CLONE_DEEP_FLAG | $cf2fc93d797feeac$var$CLONE_FLAT_FLAG | $cf2fc93d797feeac$var$CLONE_SYMBOLS_FLAG, $hX6xj);
    var length = paths.length;
    while(length--)$cwDmY(result, paths[length]);
    return result;
});
module.exports = $cf2fc93d797feeac$var$omit;

});
parcelRegister("cwDmY", function(module, exports) {

var $ikiqP = parcelRequire("ikiqP");

var $52ohX = parcelRequire("52ohX");

var $lSQJO = parcelRequire("lSQJO");

var $8iXBM = parcelRequire("8iXBM");
/** Used for built-in method references. */ var $91e7032e4395e385$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $91e7032e4395e385$var$hasOwnProperty = $91e7032e4395e385$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $91e7032e4395e385$var$baseUnset(object, path) {
    path = $ikiqP(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $8iXBM(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$91e7032e4395e385$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $lSQJO(object, path);
    return obj == null || delete obj[$8iXBM($52ohX(path))];
}
module.exports = $91e7032e4395e385$var$baseUnset;

});
parcelRegister("lSQJO", function(module, exports) {

var $8RMkV = parcelRequire("8RMkV");

var $37knY = parcelRequire("37knY");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $fee78cc267d13daf$var$parent(object, path) {
    return path.length < 2 ? object : $8RMkV(object, $37knY(path, 0, -1));
}
module.exports = $fee78cc267d13daf$var$parent;

});


parcelRegister("hX6xj", function(module, exports) {

var $dCF5X = parcelRequire("dCF5X");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $d11d044ee2a27bc4$var$customOmitClone(value) {
    return $dCF5X(value) ? undefined : value;
}
module.exports = $d11d044ee2a27bc4$var$customOmitClone;

});


parcelRegister("kN0DI", function(module, exports) {

var $kLvEk = parcelRequire("kLvEk");

var $11H9d = parcelRequire("11H9d");

var $gST7B = parcelRequire("gST7B");
/** `Object#toString` result references. */ var $f228e14790acaaba$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $f228e14790acaaba$var$isString(value) {
    return typeof value == 'string' || !$11H9d(value) && $gST7B(value) && $kLvEk(value) == $f228e14790acaaba$var$stringTag;
}
module.exports = $f228e14790acaaba$var$isString;

});

parcelRegister("1BvTi", function(module, exports) {
$parcel$export(module.exports, "default", () => $c46e80e1ab0e0f84$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $7uMuM = parcelRequire("7uMuM");
var $c46e80e1ab0e0f84$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $fsvuC.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, $5chsV.jsx)(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args), this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $7uMuM.default)()(EngagementEventsWrapper);
};

});

parcelRegister("aa42x", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d7a64258c1f2e45$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $jf0Un = parcelRequire("jf0Un");
var $6d7a64258c1f2e45$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $fsvuC.Component) {
        static{
            this.contextTypes = {
                subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($jf0Un))).func,
                setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($jf0Un))).func
            };
        }
        render() {
            return /*#__PURE__*/ (0, $5chsV.jsx)(StoreWrapperInner, {
                ...this.props,
                context: this.context
            });
        }
    }
    const StoreWrapperInner = (allProps)=>{
        const { context: context, ...props } = allProps;
        const { children: children, engagementId: engagementId, messageType: messageType, onMessageDisposition: onMessageDisposition } = props;
        const [message, setMessage] = (0, $fsvuC.useState)(null);
        const unsubscribeRef = (0, $fsvuC.useRef)(null);
        const removeConfigRef = (0, $fsvuC.useRef)(null);
        const canSubscribe = (0, $fsvuC.useCallback)(()=>{
            return context && !!context?.subscribeEngagementState;
        }, [
            context
        ]);
        const canSetConfig = (0, $fsvuC.useCallback)(()=>{
            return context && !!context?.setComponentConfig;
        }, [
            context
        ]);
        const onStoreChange = (0, $fsvuC.useCallback)((state)=>{
            setMessage(computeNewState(state).message);
        }, []);
        const subscribeToStore = (0, $fsvuC.useCallback)(()=>{
            return context?.subscribeEngagementState?.(onStoreChange);
        }, [
            context,
            onStoreChange
        ]);
        const setChoreographerConfig = (0, $fsvuC.useCallback)((propsToUse = props)=>{
            return context?.setComponentConfig?.(getComponentType(), {
                messageType: propsToUse.messageType,
                onMessageDisposition: propsToUse.onMessageDisposition
            }, propsToUse.engagementId);
        }, [
            context,
            props
        ]);
        // Handle initial mount (equivalent to UNSAFE_componentWillMount)
        (0, $fsvuC.useEffect)(()=>{
            if (canSubscribe()) unsubscribeRef.current = subscribeToStore() || null;
            if (canSetConfig()) removeConfigRef.current = setChoreographerConfig() || null;
            return ()=>{
                if (unsubscribeRef.current) unsubscribeRef.current();
                if (removeConfigRef.current) removeConfigRef.current();
            };
        }, [
            canSubscribe,
            canSetConfig,
            subscribeToStore,
            setChoreographerConfig
        ]);
        // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
        const previousEngagementId = (0, $fsvuC.useRef)(engagementId);
        const previousMessageType = (0, $fsvuC.useRef)(messageType);
        const previousOnMessageDisposition = (0, $fsvuC.useRef)(onMessageDisposition);
        (0, $fsvuC.useEffect)(()=>{
            if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
                removeConfigRef.current();
                removeConfigRef.current = setChoreographerConfig(props) || null;
            } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) setChoreographerConfig(props);
            previousEngagementId.current = engagementId;
            previousMessageType.current = messageType;
            previousOnMessageDisposition.current = onMessageDisposition;
        }, [
            props,
            setChoreographerConfig,
            canSetConfig,
            engagementId,
            messageType,
            onMessageDisposition
        ]);
        if (!message) {
            if (componentType === 'inlineDialog') return children || null;
            return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
        const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/ (0, $5chsV.jsx)(InnerComponent, {
            ...props,
            ...message
        }, messageKey);
    };
    return StoreWrapper;
};

});

parcelRegister("7LnGU", function(module, exports) {
$parcel$export(module.exports, "buttonActionTypes", () => $2545b757d020f3a8$export$e7d79186651244da);
const $2545b757d020f3a8$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};

});

parcelRegister("aiQwF", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c870591d87b80b3$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
class $3c870591d87b80b3$export$2e2bcd8739ae039 extends (0, $fsvuC.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}
$3c870591d87b80b3$export$2e2bcd8739ae039.displayName = "HtmlContent";

});

parcelRegister("4oxeW", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @lightSyntaxTransform
 * @noflow
 * @nolint
 * @preventMunge
 * @preserve-invariant-messages
 */ "use no memo";
"use strict";
var $33333014fecdc10c$var$__create = Object.create;
var $33333014fecdc10c$var$__defProp = Object.defineProperty;
var $33333014fecdc10c$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $33333014fecdc10c$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $33333014fecdc10c$var$__getProtoOf = Object.getPrototypeOf;
var $33333014fecdc10c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $33333014fecdc10c$var$__export = (target, all)=>{
    for(var name in all)$33333014fecdc10c$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $33333014fecdc10c$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $33333014fecdc10c$var$__getOwnPropNames(from))if (!$33333014fecdc10c$var$__hasOwnProp.call(to, key) && key !== except) $33333014fecdc10c$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $33333014fecdc10c$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $33333014fecdc10c$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $33333014fecdc10c$var$__create($33333014fecdc10c$var$__getProtoOf(mod)) : {}, $33333014fecdc10c$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $33333014fecdc10c$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $33333014fecdc10c$var$__toCommonJS = (mod)=>$33333014fecdc10c$var$__copyProps($33333014fecdc10c$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/index.ts
var $33333014fecdc10c$var$index_exports = {};
$33333014fecdc10c$var$__export($33333014fecdc10c$var$index_exports, {
    $dispatcherGuard: ()=>$33333014fecdc10c$var$$dispatcherGuard,
    $makeReadOnly: ()=>$33333014fecdc10c$var$$makeReadOnly,
    $reset: ()=>$33333014fecdc10c$var$$reset,
    $structuralCheck: ()=>$33333014fecdc10c$var$$structuralCheck,
    c: ()=>$33333014fecdc10c$var$c,
    clearRenderCounterRegistry: ()=>$33333014fecdc10c$var$clearRenderCounterRegistry,
    renderCounterRegistry: ()=>$33333014fecdc10c$var$renderCounterRegistry,
    useRenderCounter: ()=>$33333014fecdc10c$var$useRenderCounter
});
module.exports = $33333014fecdc10c$var$__toCommonJS($33333014fecdc10c$var$index_exports);

var $33333014fecdc10c$var$React = $33333014fecdc10c$var$__toESM((parcelRequire("fsvuC")));
var { useRef: $33333014fecdc10c$var$useRef, useEffect: $33333014fecdc10c$var$useEffect, isValidElement: $33333014fecdc10c$var$isValidElement } = $33333014fecdc10c$var$React;
var $33333014fecdc10c$var$_a;
var $33333014fecdc10c$var$ReactSecretInternals = //@ts-ignore
($33333014fecdc10c$var$_a = $33333014fecdc10c$var$React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE) != null ? $33333014fecdc10c$var$_a : $33333014fecdc10c$var$React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
var $33333014fecdc10c$var$$empty = Symbol.for("react.memo_cache_sentinel");
var $33333014fecdc10c$var$_a2;
var $33333014fecdc10c$var$c = // @ts-expect-error
typeof (($33333014fecdc10c$var$_a2 = $33333014fecdc10c$var$React.__COMPILER_RUNTIME) == null ? void 0 : $33333014fecdc10c$var$_a2.c) === "function" ? // @ts-expect-error
$33333014fecdc10c$var$React.__COMPILER_RUNTIME.c : function c2(size) {
    return $33333014fecdc10c$var$React.useMemo(()=>{
        const $ = new Array(size);
        for(let ii = 0; ii < size; ii++)$[ii] = $33333014fecdc10c$var$$empty;
        $[$33333014fecdc10c$var$$empty] = true;
        return $;
    }, []);
};
var $33333014fecdc10c$var$LazyGuardDispatcher = {};
[
    "readContext",
    "useCallback",
    "useContext",
    "useEffect",
    "useImperativeHandle",
    "useInsertionEffect",
    "useLayoutEffect",
    "useMemo",
    "useReducer",
    "useRef",
    "useState",
    "useDebugValue",
    "useDeferredValue",
    "useTransition",
    "useMutableSource",
    "useSyncExternalStore",
    "useId",
    "unstable_isNewReconciler",
    "getCacheSignal",
    "getCacheForType",
    "useCacheRefresh"
].forEach((name)=>{
    $33333014fecdc10c$var$LazyGuardDispatcher[name] = ()=>{
        throw new Error(`[React] Unexpected React hook call (${name}) from a React compiled function. Check that all hooks are called directly and named according to convention ('use[A-Z]') `);
    };
});
var $33333014fecdc10c$var$originalDispatcher = null;
$33333014fecdc10c$var$LazyGuardDispatcher["useMemoCache"] = (count)=>{
    if ($33333014fecdc10c$var$originalDispatcher == null) throw new Error("React Compiler internal invariant violation: unexpected null dispatcher");
    else return $33333014fecdc10c$var$originalDispatcher.useMemoCache(count);
};
function $33333014fecdc10c$var$setCurrent(newDispatcher) {
    $33333014fecdc10c$var$ReactSecretInternals.ReactCurrentDispatcher.current = newDispatcher;
    return $33333014fecdc10c$var$ReactSecretInternals.ReactCurrentDispatcher.current;
}
var $33333014fecdc10c$var$guardFrames = [];
function $33333014fecdc10c$var$$dispatcherGuard(kind) {
    const curr = $33333014fecdc10c$var$ReactSecretInternals.ReactCurrentDispatcher.current;
    if (kind === 0 /* PushGuardContext */ ) {
        $33333014fecdc10c$var$guardFrames.push(curr);
        if ($33333014fecdc10c$var$guardFrames.length === 1) $33333014fecdc10c$var$originalDispatcher = curr;
        if (curr === $33333014fecdc10c$var$LazyGuardDispatcher) throw new Error(`[React] Unexpected call to custom hook or component from a React compiled function. Check that (1) all hooks are called directly and named according to convention ('use[A-Z]') and (2) components are returned as JSX instead of being directly invoked.`);
        $33333014fecdc10c$var$setCurrent($33333014fecdc10c$var$LazyGuardDispatcher);
    } else if (kind === 1 /* PopGuardContext */ ) {
        const lastFrame = $33333014fecdc10c$var$guardFrames.pop();
        if (lastFrame == null) throw new Error("React Compiler internal error: unexpected null in guard stack");
        if ($33333014fecdc10c$var$guardFrames.length === 0) $33333014fecdc10c$var$originalDispatcher = null;
        $33333014fecdc10c$var$setCurrent(lastFrame);
    } else if (kind === 2 /* PushExpectHook */ ) {
        $33333014fecdc10c$var$guardFrames.push(curr);
        $33333014fecdc10c$var$setCurrent($33333014fecdc10c$var$originalDispatcher);
    } else if (kind === 3 /* PopExpectHook */ ) {
        const lastFrame = $33333014fecdc10c$var$guardFrames.pop();
        if (lastFrame == null) throw new Error("React Compiler internal error: unexpected null in guard stack");
        $33333014fecdc10c$var$setCurrent(lastFrame);
    } else throw new Error("React Compiler internal error: unreachable block" + kind);
}
function $33333014fecdc10c$var$$reset($) {
    for(let ii = 0; ii < $.length; ii++)$[ii] = $33333014fecdc10c$var$$empty;
}
function $33333014fecdc10c$var$$makeReadOnly() {
    throw new Error("TODO: implement $makeReadOnly in react-compiler-runtime");
}
var $33333014fecdc10c$var$renderCounterRegistry = /* @__PURE__ */ new Map();
function $33333014fecdc10c$var$clearRenderCounterRegistry() {
    for (const counters of $33333014fecdc10c$var$renderCounterRegistry.values())counters.forEach((counter)=>{
        counter.count = 0;
    });
}
function $33333014fecdc10c$var$registerRenderCounter(name, val) {
    let counters = $33333014fecdc10c$var$renderCounterRegistry.get(name);
    if (counters == null) {
        counters = /* @__PURE__ */ new Set();
        $33333014fecdc10c$var$renderCounterRegistry.set(name, counters);
    }
    counters.add(val);
}
function $33333014fecdc10c$var$removeRenderCounter(name, val) {
    const counters = $33333014fecdc10c$var$renderCounterRegistry.get(name);
    if (counters == null) return;
    counters.delete(val);
}
function $33333014fecdc10c$var$useRenderCounter(name) {
    const val = $33333014fecdc10c$var$useRef(null);
    if (val.current != null) val.current.count += 1;
    $33333014fecdc10c$var$useEffect(()=>{
        if (val.current == null) {
            const counter = {
                count: 0
            };
            $33333014fecdc10c$var$registerRenderCounter(name, counter);
            val.current = counter;
        }
        return ()=>{
            if (val.current !== null) $33333014fecdc10c$var$removeRenderCounter(name, val.current);
        };
    });
}
var $33333014fecdc10c$var$seenErrors = /* @__PURE__ */ new Set();
function $33333014fecdc10c$var$$structuralCheck(oldValue, newValue, variableName, fnName, kind, loc) {
    function error(l, r, path, depth) {
        const str = `${fnName}:${loc} [${kind}] ${variableName}${path} changed from ${l} to ${r} at depth ${depth}`;
        if ($33333014fecdc10c$var$seenErrors.has(str)) return;
        $33333014fecdc10c$var$seenErrors.add(str);
        console.error(str);
    }
    const depthLimit = 2;
    function recur(oldValue2, newValue2, path, depth) {
        if (depth > depthLimit) return;
        else if (oldValue2 === newValue2) return;
        else if (typeof oldValue2 !== typeof newValue2) error(`type ${typeof oldValue2}`, `type ${typeof newValue2}`, path, depth);
        else if (typeof oldValue2 === "object") {
            const oldArray = Array.isArray(oldValue2);
            const newArray = Array.isArray(newValue2);
            if (oldValue2 === null && newValue2 !== null) error("null", `type ${typeof newValue2}`, path, depth);
            else if (newValue2 === null) error(`type ${typeof oldValue2}`, "null", path, depth);
            else if (oldValue2 instanceof Map) {
                if (!(newValue2 instanceof Map)) error(`Map instance`, `other value`, path, depth);
                else if (oldValue2.size !== newValue2.size) error(`Map instance with size ${oldValue2.size}`, `Map instance with size ${newValue2.size}`, path, depth);
                else {
                    for (const [k, v] of oldValue2)if (!newValue2.has(k)) error(`Map instance with key ${k}`, `Map instance without key ${k}`, path, depth);
                    else recur(v, newValue2.get(k), `${path}.get(${k})`, depth + 1);
                }
            } else if (newValue2 instanceof Map) error("other value", `Map instance`, path, depth);
            else if (oldValue2 instanceof Set) {
                if (!(newValue2 instanceof Set)) error(`Set instance`, `other value`, path, depth);
                else if (oldValue2.size !== newValue2.size) error(`Set instance with size ${oldValue2.size}`, `Set instance with size ${newValue2.size}`, path, depth);
                else {
                    for (const v of newValue2)if (!oldValue2.has(v)) error(`Set instance without element ${v}`, `Set instance with element ${v}`, path, depth);
                }
            } else if (newValue2 instanceof Set) error("other value", `Set instance`, path, depth);
            else if (oldArray || newArray) {
                if (oldArray !== newArray) error(`type ${oldArray ? "array" : "object"}`, `type ${newArray ? "array" : "object"}`, path, depth);
                else if (oldValue2.length !== newValue2.length) error(`array with length ${oldValue2.length}`, `array with length ${newValue2.length}`, path, depth);
                else for(let ii = 0; ii < oldValue2.length; ii++)recur(oldValue2[ii], newValue2[ii], `${path}[${ii}]`, depth + 1);
            } else if ($33333014fecdc10c$var$isValidElement(oldValue2) || $33333014fecdc10c$var$isValidElement(newValue2)) {
                if ($33333014fecdc10c$var$isValidElement(oldValue2) !== $33333014fecdc10c$var$isValidElement(newValue2)) error(`type ${$33333014fecdc10c$var$isValidElement(oldValue2) ? "React element" : "object"}`, `type ${$33333014fecdc10c$var$isValidElement(newValue2) ? "React element" : "object"}`, path, depth);
                else if (oldValue2.type !== newValue2.type) error(`React element of type ${oldValue2.type}`, `React element of type ${newValue2.type}`, path, depth);
                else recur(oldValue2.props, newValue2.props, `[props of ${path}]`, depth + 1);
            } else {
                for(const key in newValue2)if (!(key in oldValue2)) error(`object without key ${key}`, `object with key ${key}`, path, depth);
                for(const key in oldValue2)if (!(key in newValue2)) error(`object with key ${key}`, `object without key ${key}`, path, depth);
                else recur(oldValue2[key], newValue2[key], `${path}.${key}`, depth + 1);
            }
        } else if (typeof oldValue2 === "function") return;
        else if (isNaN(oldValue2) || isNaN(newValue2)) {
            if (isNaN(oldValue2) !== isNaN(newValue2)) error(`${isNaN(oldValue2) ? "NaN" : "non-NaN value"}`, `${isNaN(newValue2) ? "NaN" : "non-NaN value"}`, path, depth);
        } else if (oldValue2 !== newValue2) error(oldValue2, newValue2, path, depth);
    }
    recur(oldValue, newValue, "", 0);
}

});

parcelRegister("5CGS4", function(module, exports) {
$parcel$export(module.exports, "JiraWorkspaceAri", () => $4181c1abf99f4a76$export$d4d0794234e3fd53);

var $70Pn5 = parcelRequire("70Pn5");

var $llRkr = parcelRequire("llRkr");

var $jEYBS = parcelRequire("jEYBS");
// src/jira/workspace/manifest.ts
var $4181c1abf99f4a76$var$jiraWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $70Pn5.JiraWorkspaceAriResourceOwner),
    resourceType: (0, $70Pn5.JiraWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/jira/workspace/index.ts
var $4181c1abf99f4a76$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, $llRkr.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4181c1abf99f4a76$var$jiraWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $4181c1abf99f4a76$var$jiraWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4181c1abf99f4a76$var$jiraWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $4181c1abf99f4a76$var$jiraWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $jEYBS.AriParser).fromOpts(derivedOpts, $4181c1abf99f4a76$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $jEYBS.AriParser).fromString(maybeAri, $4181c1abf99f4a76$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
};

});
parcelRegister("70Pn5", function(module, exports) {
$parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", () => $51b061c2bc83e6b3$export$e52ccdf6abac8896);
$parcel$export(module.exports, "JiraWorkspaceAriResourceType", () => $51b061c2bc83e6b3$export$669cd5f7b3746bb);
// src/jira/workspace/types.ts
var $51b061c2bc83e6b3$export$e52ccdf6abac8896 = "jira", $51b061c2bc83e6b3$export$669cd5f7b3746bb = "workspace";

});


parcelRegister("e5O57", function(module, exports) {
$parcel$export(module.exports, "createCache", () => $85c5f583d75a5709$export$cf6fa0bbcc94b912);
function $85c5f583d75a5709$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}

});

parcelRegister("v4B04", function(module, exports) {
$parcel$export(module.exports, "PreloadableJSResource", () => $512cfc8249382aa6$export$4fe5fba5bb1d3c09);

var $eAY4o = parcelRequire("eAY4o");
function $512cfc8249382aa6$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $eAY4o.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}

});
parcelRegister("eAY4o", function(module, exports) {
$parcel$export(module.exports, "JSResource", () => $d525dd8b3c891735$export$148e45a6d4b4d65);

var $6xqHR = parcelRequire("6xqHR");

var $8PBMI = parcelRequire("8PBMI");

var $8dMDe = parcelRequire("8dMDe");
function $d525dd8b3c891735$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $8PBMI.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $8PBMI.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $6xqHR.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $8PBMI.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $8dMDe.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}

});
parcelRegister("6xqHR", function(module, exports) {
$parcel$export(module.exports, "generateId", () => $40501d6042c3862d$export$567fc7097e064344);
let $40501d6042c3862d$var$id = 100000;
function $40501d6042c3862d$export$567fc7097e064344() {
    $40501d6042c3862d$var$id += 1;
    return $40501d6042c3862d$var$id.toString();
}

});

parcelRegister("8PBMI", function(module, exports) {
$parcel$export(module.exports, "eventEmitter", () => $08e1da5fcc0fb3b9$export$10dc3edfc20c8ff);
function $08e1da5fcc0fb3b9$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $08e1da5fcc0fb3b9$export$10dc3edfc20c8ff = $08e1da5fcc0fb3b9$var$createEventEmitter();

});

parcelRegister("8dMDe", function(module, exports) {
$parcel$export(module.exports, "isJSModuleWithDefaultExport", () => $9f1217e801da96ea$export$3b514faac3ba993c);
function $9f1217e801da96ea$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}

});



parcelRegister("fSwMi", function(module, exports) {
$parcel$export(module.exports, "blockDraggingToIFrames", () => $16d67281d879a33d$export$6ae1d8fab001518c);

var $iNmwK = parcelRequire("iNmwK");

var $8wYaX = parcelRequire("8wYaX");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $16d67281d879a33d$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $16d67281d879a33d$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $16d67281d879a33d$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($16d67281d879a33d$var$isActive) return;
    $16d67281d879a33d$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$16d67281d879a33d$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $8wYaX.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $iNmwK.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $16d67281d879a33d$var$isActive = false;
    });
}
function $16d67281d879a33d$export$6ae1d8fab001518c({ element: element }) {
    return (0, $iNmwK.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $16d67281d879a33d$var$tryStart();
        }
    });
}

});

parcelRegister("dJE72", function(module, exports) {
$parcel$export(module.exports, "getIsInJiraHoldoutData", () => $e28bcf3d6f2fe984$export$169025fa80347e5);
$parcel$export(module.exports, "JiraHoldoutCustomData", () => $e28bcf3d6f2fe984$export$fdfd98dbe16cdb4a);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $5Y9N2 = parcelRequire("5Y9N2");

var $623DQ = parcelRequire("623DQ");
const $e28bcf3d6f2fe984$export$169025fa80347e5 = ()=>{
    const featureGateWithinHoldout = 'product-jira-holdout-org_id-observability-gate';
    // This explicitly does not fire exposure, in order to prevent a Holdout exposure, which can dilute the Holdout measurement.
    const isInJiraHoldout = (0, $5Y9N2.default).initializeCompleted() && !(0, $5Y9N2.default).checkGate(featureGateWithinHoldout, {
        fireGateExposure: false
    });
    return {
        holdout: isInJiraHoldout ? 'jira-holdout' : ''
    };
};
const $e28bcf3d6f2fe984$export$fdfd98dbe16cdb4a = ()=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $623DQ.default), {
        data: $e28bcf3d6f2fe984$export$169025fa80347e5()
    });
};
$e28bcf3d6f2fe984$export$fdfd98dbe16cdb4a.displayName = "JiraHoldoutCustomData";

});

parcelRegister("398Pa", function(module, exports) {
$parcel$export(module.exports, "UFOGenAISegment", () => $b6ec16539d76e1b2$export$208d0ee3b8b8e438);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $jbwXy = parcelRequire("jbwXy");
const $b6ec16539d76e1b2$export$208d0ee3b8b8e438 = (props)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jbwXy.default), {
        type: "gen-ai",
        ...props
    });
};
$b6ec16539d76e1b2$export$208d0ee3b8b8e438.displayName = "UFOGenAISegment";
$b6ec16539d76e1b2$export$208d0ee3b8b8e438.displayName = 'UFOGenAISegment';

});

parcelRegister("WcIZd", function(module, exports) {
$parcel$export(module.exports, "UniversalCreateButton", () => $51a9c9fc6e3f6644$export$5c89068caaa33f77);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $6Zt46 = parcelRequire("6Zt46");

var $3eMph = parcelRequire("3eMph");
function $51a9c9fc6e3f6644$export$5c89068caaa33f77(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6Zt46.GenericErrorBoundary), {
        name: "universal-create-button-lazy",
        app: props.product,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $3eMph.UniversalCreateButtonLazy), {
            ...props
        })
    });
}
$51a9c9fc6e3f6644$export$5c89068caaa33f77.displayName = "UniversalCreateButton";

});
parcelRegister("6Zt46", function(module, exports) {
$parcel$export(module.exports, "GenericErrorBoundary", () => $ac356b67d0b751f5$export$9e9b5b3f9c08ce57);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $jY9mG = parcelRequire("jY9mG");

var $j2RAC = parcelRequire("j2RAC");

var $hEGZD = parcelRequire("hEGZD");

var $230VD = parcelRequire("230VD");
function $ac356b67d0b751f5$export$9e9b5b3f9c08ce57({ children: children, name: name, interactionId: interactionId, fallback: fallback = null, onError: onError, app: app }) {
    const { product: product, subProduct: subProduct } = (0, $230VD.useMenuStateContext)();
    const { product: productV1, subProduct: subProductV1 } = (0, $230VD.useUniversalCreateState)();
    const tags = {
        component: (0, $hEGZD.PACKAGE_PREFIX),
        subProduct: subProduct || subProductV1
    };
    const { handleError: handleError } = (0, $j2RAC.useNavBoundaryContext)({
        location: name,
        disableSentry: false,
        disableAnalytics: true,
        onError: onError,
        sentryConfig: {
            product: app || product || productV1
        },
        interactionId: interactionId,
        tags: tags
    });
    const handleOnError = (0, $fsvuC.useCallback)(async (error)=>{
        handleError(error);
    }, [
        handleError
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jY9mG.ErrorBoundary), {
        fallback: fallback,
        onError: handleOnError,
        children: children
    });
}
$ac356b67d0b751f5$export$9e9b5b3f9c08ce57.displayName = "GenericErrorBoundary";

});
parcelRegister("j2RAC", function(module, exports) {
$parcel$export(module.exports, "useNavBoundaryContext", () => $afdfc86ff5917d4a$export$335b0c12ccf77339);

var $fsvuC = parcelRequire("fsvuC");

var $jyuiz = parcelRequire("jyuiz");

var $iM8tV = parcelRequire("iM8tV");

var $6IJ5i = parcelRequire("6IJ5i");
function $afdfc86ff5917d4a$export$335b0c12ccf77339({ location: location = 'unknown', disableSentry: disableSentry = false, disableAnalytics: disableAnalytics = false, onError: onError, sentryConfig: sentryConfig, tags: tags } = {}) {
    const { fireEvent: fireEvent } = (0, $jyuiz.useAnalyticsEvents)();
    if (!disableSentry) try {
        (0, $iM8tV.setupSentryClient)({
            sentryConfig: sentryConfig
        });
    } catch (error) {
        // Log failure to initialize Sentry
        fireEvent('operational.initSentry.failed', {
            location: location,
            reason: error instanceof Error ? error.message : 'unknown'
        });
    }
    const tagsToLog = (0, $fsvuC.useMemo)(()=>{
        return {
            ...tags,
            location: location,
            teamName: (0, $6IJ5i.SENTRY_TEAM_NAME),
            product: sentryConfig?.product ?? (0, $6IJ5i.SENTRY_PRODUCT),
            productBuild: $afdfc86ff5917d4a$var$getProductBuild()
        };
    }, [
        tags,
        location,
        sentryConfig?.product
    ]);
    const handleError = (0, $fsvuC.useCallback)((error)=>{
        // Send events to sentry
        if (!disableSentry) try {
            (0, $iM8tV.logException)(error, tagsToLog);
        } catch (err) {
            // Log failure to send to Sentry
            fireEvent('operational.logToSentry.failed', {
                location: location,
                reason: err instanceof Error ? err.message : 'unknown'
            });
        }
        // Fire Analytics event
        if (!disableAnalytics) fireEvent('operational.errorBoundary.unhandledErrorCaught', {
            location: location,
            errorMessage: error.message,
            errorStack: error.stack || 'no stack trace'
        });
        // Invoke external onError
        onError?.(error);
    }, [
        disableSentry,
        disableAnalytics,
        onError,
        location,
        tagsToLog,
        fireEvent
    ]);
    return {
        handleError: handleError
    };
}
function $afdfc86ff5917d4a$var$getProductBuild() {
    // Ensure we don't invoke window object in SSR
    if (typeof window === 'undefined') return 'unknown';
    switch(true){
        // Jira - window.BUILD_KEY
        case 'BUILD_KEY' in window:
            return window.BUILD_KEY || 'unknown';
        // Confluence - window.__buildInfo
        case '__buildInfo' in window:
            return window.__buildInfo?.FRONTEND_VERSION || 'unknown';
        default:
            return 'unknown';
    }
}

});
parcelRegister("jyuiz", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $373a799d1aabbf1f$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::9b651e704a805fcfd97874cf37f36513>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen navigation-error-boundary
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $mhEfz = parcelRequire("mhEfz");


var $flRBu = parcelRequire("flRBu");
const $373a799d1aabbf1f$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    const fireEvent = (0, $fsvuC.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $flRBu.default)(...params));
        event.fire((0, $ef5fca219fe79279$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $ef5fca219fe79279$export$3f072f06b90c3985 = 'navigation';

parcelRegister("flRBu", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6c8a213eaa5b607$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::dc0a1bceb2402ac8e42ce6b49bcb524d>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen navigation-error-boundary
 */ const $c6c8a213eaa5b607$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $c6c8a213eaa5b607$export$2e2bcd8739ae039 = $c6c8a213eaa5b607$var$createEventPayload;

});


parcelRegister("iM8tV", function(module, exports) {
$parcel$export(module.exports, "logException", () => $4c4e477ded2058a9$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "setupSentryClient", () => $4c4e477ded2058a9$export$d8bd0edf6c978788);

var $k5Njc = parcelRequire("k5Njc");
var $goCYZ = parcelRequire("goCYZ");
var $8B7hC = parcelRequire("8B7hC");
var $hcHAe = parcelRequire("hcHAe");
var $3wWMf = parcelRequire("3wWMf");

var $bcirB = parcelRequire("bcirB");

var $ibNQH = parcelRequire("ibNQH");

var $6IJ5i = parcelRequire("6IJ5i");
let $4c4e477ded2058a9$var$sentryClient;
let $4c4e477ded2058a9$var$activeSuppressBackendErrors;
let $4c4e477ded2058a9$var$scope = new (0, $3wWMf.Scope)();
/** Reads `name` / `message` off an Error or a normalised plain-object error, if present. */ function $4c4e477ded2058a9$var$toErrorLike(value) {
    if (typeof value !== 'object' || value === null) return {};
    const { name: name, message: message } = value;
    return {
        name: typeof name === 'string' ? name : undefined,
        message: typeof message === 'string' ? message : undefined
    };
}
function $4c4e477ded2058a9$var$isBFFErrorName(name) {
    return name === (0, $bcirB.BFFErrorEnum).BFF_ERROR || name === (0, $bcirB.BFFErrorEnum).BFF_NETWORK_ERROR;
}
/** Parses a BFF `status` extra into an HTTP status code. Non-status values (e.g. "error") are ignored. */ function $4c4e477ded2058a9$var$parseHttpStatus(status) {
    if (typeof status === 'number') return Number.isInteger(status) ? status : undefined;
    if (typeof status === 'string' && /^\d{3}$/.test(status.trim())) return Number(status);
    return undefined;
}
/** Joins `type` and `value` the same way Sentry's `ignoreErrors` filter does. */ function $4c4e477ded2058a9$var$withType(type, value) {
    return type && value ? `${type}: ${value}` : undefined;
}
function $4c4e477ded2058a9$export$ad536eaf3aa9a746(event) {
    const extras = event.extra ?? {};
    // Sentry chains causes as multiple `values`. Older events have a single value, newer linked
    // errors can have several — classify as suppress if any of them is a known transport failure.
    const exceptions = event.exception?.values ?? [];
    const original = $4c4e477ded2058a9$var$toErrorLike(extras.originalError);
    const candidates = [
        event.message,
        ...exceptions.flatMap((e)=>[
                e.value,
                $4c4e477ded2058a9$var$withType(e.type, e.value)
            ]),
        original.message,
        $4c4e477ded2058a9$var$withType(original.name, original.message)
    ].filter((candidate)=>Boolean(candidate));
    if ((0, $6IJ5i.SUPPRESSED_BACKEND_ERROR_PATTERNS).some((re)=>candidates.some((c)=>re.test(c)))) return 'suppress';
    // Prefer the explicit status on BFF wrappers; fall back to the `fetchJSON` message format on
    // the wrapped original error. The outer exception value and `event.message` are usually
    // derived from the same `fetchJSON` message for status-bearing errors, so these last two
    // parses are defensive fallbacks for non-wrapped errors or future error shapes.
    const httpStatus = ($4c4e477ded2058a9$var$isBFFErrorName(extras.name) ? $4c4e477ded2058a9$var$parseHttpStatus(extras.status) : undefined) ?? (0, $6IJ5i.extractHttpStatusFromMessage)(original.message) ?? (0, $6IJ5i.extractHttpStatusFromMessage)(exceptions[exceptions.length - 1]?.value) ?? (0, $6IJ5i.extractHttpStatusFromMessage)(event.message);
    return (0, $6IJ5i.classifyHttpStatus)(httpStatus);
}
function $4c4e477ded2058a9$export$ef31311040ebdb46(event) {
    return $4c4e477ded2058a9$export$ad536eaf3aa9a746(event) === 'suppress';
}
function $4c4e477ded2058a9$export$8b38ee55852dc5a(event, random = Math.random) {
    switch($4c4e477ded2058a9$export$ad536eaf3aa9a746(event)){
        case 'suppress':
            return null;
        case 'sample':
            if (random() >= (0, $6IJ5i.RATE_LIMITED_SAMPLE_RATE)) return null;
            return {
                ...event,
                tags: {
                    ...event.tags,
                    suppressionSampleRate: String((0, $6IJ5i.RATE_LIMITED_SAMPLE_RATE))
                }
            };
        default:
            return event;
    }
}
function $4c4e477ded2058a9$export$f86b2a1a2ce291b3(exception, tags) {
    $4c4e477ded2058a9$var$scope.setTags(tags);
    if (exception instanceof (0, $bcirB.BFFError)) {
        const error = exception;
        $4c4e477ded2058a9$var$scope.setExtras({
            name: error.name,
            context: error.context,
            status: error.status,
            timestamp: error.timestamp,
            originalError: error.originalError,
            ...error instanceof (0, $bcirB.BFFNetworkError) && {
                url: error.url
            }
        });
    }
    $4c4e477ded2058a9$var$sentryClient?.captureException(exception, undefined, $4c4e477ded2058a9$var$scope);
    // Unset tags to prevent an instance of the error boundary from logging with a specific tag,
    // and then another instance from wrongly passing it despite not having the tag.
    for (const [key, _] of Object.entries(tags))$4c4e477ded2058a9$var$scope.setTag(key, undefined);
    // Unset any extras to prevent them from persisting
    $4c4e477ded2058a9$var$scope.setExtras({});
}
function $4c4e477ded2058a9$export$d8bd0edf6c978788({ sentryConfig: sentryConfig }) {
    const { dsn: dsn = (0, $6IJ5i.SENTRY_DSN), env: env, suppressBackendErrors: suppressBackendErrors = true } = sentryConfig || {};
    if ($4c4e477ded2058a9$var$sentryClient) {
        // Singleton: later callers can't change the suppression behaviour, so warn once if they
        // try. Products should coordinate on this setting at the boundary that initialises first.
        if ($4c4e477ded2058a9$var$activeSuppressBackendErrors !== undefined && $4c4e477ded2058a9$var$activeSuppressBackendErrors !== suppressBackendErrors) // eslint-disable-next-line no-console
        console.warn(`[navigation-error-boundary] setupSentryClient was already initialised with suppressBackendErrors=${$4c4e477ded2058a9$var$activeSuppressBackendErrors}; later value ${suppressBackendErrors} is ignored.`);
        return true;
    }
    // SSR-safe check. If we are in SSR, we don't need a sentryClient
    if (typeof window === 'undefined') return false;
    $4c4e477ded2058a9$var$activeSuppressBackendErrors = suppressBackendErrors;
    const environment = (0, $ibNQH.getEnvironment)(env);
    // filter integrations that use the global variable
    const integrations = (0, $8B7hC.getDefaultIntegrations)({}).filter((defaultIntegration)=>{
        return ![
            'BrowserApiErrors',
            'Breadcrumbs',
            'GlobalHandlers'
        ].includes(defaultIntegration.name);
    });
    $4c4e477ded2058a9$var$sentryClient = new (0, $k5Njc.BrowserClient)({
        ...(0, $6IJ5i.DEFAULT_SENTRY_CONFIG),
        ignoreErrors: suppressBackendErrors ? [
            ...(0, $6IJ5i.DEFAULT_SENTRY_CONFIG).ignoreErrors,
            ...(0, $6IJ5i.SUPPRESSED_BACKEND_ERROR_PATTERNS)
        ] : (0, $6IJ5i.DEFAULT_SENTRY_CONFIG).ignoreErrors,
        dsn: dsn,
        environment: environment,
        beforeSend: (event)=>{
            // Only events captured via logException (which sets teamName)
            if (event.tags?.teamName === undefined) return null;
            return suppressBackendErrors ? $4c4e477ded2058a9$export$8b38ee55852dc5a(event) : event;
        },
        attachStacktrace: true,
        transport: (0, $hcHAe.makeFetchTransport),
        stackParser: (0, $goCYZ.defaultStackParser),
        integrations: integrations
    });
    $4c4e477ded2058a9$var$scope.setClient($4c4e477ded2058a9$var$sentryClient);
    $4c4e477ded2058a9$var$sentryClient.init();
    return true;
}
function $4c4e477ded2058a9$export$64db7b418e82aaf6() {
    $4c4e477ded2058a9$var$sentryClient = undefined;
    $4c4e477ded2058a9$var$activeSuppressBackendErrors = undefined;
    $4c4e477ded2058a9$var$scope = new (0, $3wWMf.Scope)();
}

});
parcelRegister("k5Njc", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $ea0a85f0b3da425d$export$1df9218a526d318d);

var $6pdqM = parcelRequire("6pdqM");
var $eXyoe = parcelRequire("eXyoe");

var $fiizB = parcelRequire("fiizB");
var $ei29P = parcelRequire("ei29P");
var $1fZLn = parcelRequire("1fZLn");
var $koMb7 = parcelRequire("koMb7");

var $eWeX3 = parcelRequire("eWeX3");

var $1Vo9Y = parcelRequire("1Vo9Y");

var $2bJYr = parcelRequire("2bJYr");

var $51QTT = parcelRequire("51QTT");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $ea0a85f0b3da425d$export$1df9218a526d318d extends (0, $eXyoe.BaseClient) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $2bJYr.WINDOW).SENTRY_SDK_SOURCE || (0, $1fZLn.getSDKSource)();
        (0, $6pdqM.applySdkMetadata)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $2bJYr.WINDOW).document) (0, $2bJYr.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $2bJYr.WINDOW).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $1Vo9Y.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $1Vo9Y.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $eWeX3.DEBUG_BUILD) && (0, $koMb7.logger).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $51QTT.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $eWeX3.DEBUG_BUILD) && (0, $koMb7.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $eWeX3.DEBUG_BUILD) && (0, $koMb7.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $eWeX3.DEBUG_BUILD) && (0, $koMb7.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $fiizB.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $ei29P.dsnToString)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}

});
parcelRegister("eWeX3", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $ae02148649ff60d9$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $ae02148649ff60d9$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("1Vo9Y", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $166ddaf1972d107f$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $166ddaf1972d107f$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $166ddaf1972d107f$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $166ddaf1972d107f$export$5425b53185d13d6c);

var $5xS6z = parcelRequire("5xS6z");

var $e0v2o = parcelRequire("e0v2o");
var $lfeDQ = parcelRequire("lfeDQ");
var $97v7b = parcelRequire("97v7b");
var $ag8Pq = parcelRequire("ag8Pq");
var $iMEJN = parcelRequire("iMEJN");
/**
 * This function creates an exception from a JavaScript Error
 */ function $166ddaf1972d107f$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $166ddaf1972d107f$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $166ddaf1972d107f$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $166ddaf1972d107f$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $5xS6z.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $97v7b.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $166ddaf1972d107f$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $ag8Pq.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $166ddaf1972d107f$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $166ddaf1972d107f$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $166ddaf1972d107f$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $166ddaf1972d107f$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $166ddaf1972d107f$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $166ddaf1972d107f$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $166ddaf1972d107f$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($166ddaf1972d107f$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $166ddaf1972d107f$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $166ddaf1972d107f$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $166ddaf1972d107f$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $e0v2o.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $iMEJN.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $166ddaf1972d107f$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $166ddaf1972d107f$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $iMEJN.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $166ddaf1972d107f$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $97v7b.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $166ddaf1972d107f$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $97v7b.isDOMError)(exception) || (0, $97v7b.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $166ddaf1972d107f$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $97v7b.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $166ddaf1972d107f$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $e0v2o.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $97v7b.isError)(exception)) // we have a real Error object, do nothing
    return $166ddaf1972d107f$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $97v7b.isPlainObject)(exception) || (0, $97v7b.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $166ddaf1972d107f$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $e0v2o.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $166ddaf1972d107f$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $e0v2o.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $e0v2o.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $166ddaf1972d107f$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $166ddaf1972d107f$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $97v7b.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $166ddaf1972d107f$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $lfeDQ.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $97v7b.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $97v7b.isEvent)(exception)) {
        const className = $166ddaf1972d107f$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $166ddaf1972d107f$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}

});

parcelRegister("2bJYr", function(module, exports) {
$parcel$export(module.exports, "WINDOW", () => $19804547790e8054$export$56d8a8a25bd48b81);
$parcel$export(module.exports, "shouldIgnoreOnError", () => $19804547790e8054$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $19804547790e8054$export$4997ffc0176396a6);


var $5xS6z = parcelRequire("5xS6z");

var $e0v2o = parcelRequire("e0v2o");
var $lfeDQ = parcelRequire("lfeDQ");
var $6QqBw = parcelRequire("6QqBw");
const $19804547790e8054$export$56d8a8a25bd48b81 = (0, $6QqBw.GLOBAL_OBJ);
let $19804547790e8054$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $19804547790e8054$export$b79738ab10c590b2() {
    return $19804547790e8054$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $19804547790e8054$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $19804547790e8054$var$ignoreOnError++;
    setTimeout(()=>{
        $19804547790e8054$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $19804547790e8054$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $lfeDQ.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$19804547790e8054$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $19804547790e8054$export$1265a142ff5ba165();
            (0, $5xS6z.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $e0v2o.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $e0v2o.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $5xS6z.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $lfeDQ.markFunctionWrapped)(sentryWrapped, fn);
    (0, $lfeDQ.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

});

parcelRegister("51QTT", function(module, exports) {
$parcel$export(module.exports, "createUserFeedbackEnvelope", () => $3a9614a900f64a68$export$24a4dfcb686ee5bf);

var $8xY6D = parcelRequire("8xY6D");
var $ei29P = parcelRequire("ei29P");
/**
 * Creates an envelope from a user feedback.
 */ function $3a9614a900f64a68$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $ei29P.dsnToString)(dsn)
        }
    };
    const item = $3a9614a900f64a68$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $8xY6D.createEnvelope)(headers, [
        item
    ]);
}
function $3a9614a900f64a68$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

});


parcelRegister("goCYZ", function(module, exports) {
$parcel$export(module.exports, "defaultStackParser", () => $befd20660ecf614d$export$2b2b997d81bf3907);

var $gyMDG = parcelRequire("gyMDG");
// global reference to slice
const $befd20660ecf614d$var$UNKNOWN_FUNCTION = '?';
const $befd20660ecf614d$var$OPERA10_PRIORITY = 10;
const $befd20660ecf614d$var$OPERA11_PRIORITY = 20;
const $befd20660ecf614d$var$CHROME_PRIORITY = 30;
const $befd20660ecf614d$var$WINJS_PRIORITY = 40;
const $befd20660ecf614d$var$GECKO_PRIORITY = 50;
function $befd20660ecf614d$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $befd20660ecf614d$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $befd20660ecf614d$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $befd20660ecf614d$var$chromeStackParserFn = (line)=>{
    const parts = $befd20660ecf614d$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $befd20660ecf614d$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $befd20660ecf614d$var$extractSafariExtensionDetails(parts[1] || $befd20660ecf614d$var$UNKNOWN_FUNCTION, parts[2]);
        return $befd20660ecf614d$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $befd20660ecf614d$export$263a749fff749872 = [
    $befd20660ecf614d$var$CHROME_PRIORITY,
    $befd20660ecf614d$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $befd20660ecf614d$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $befd20660ecf614d$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $befd20660ecf614d$var$gecko = (line)=>{
    const parts = $befd20660ecf614d$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $befd20660ecf614d$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $befd20660ecf614d$var$UNKNOWN_FUNCTION;
        [func, filename] = $befd20660ecf614d$var$extractSafariExtensionDetails(func, filename);
        return $befd20660ecf614d$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $befd20660ecf614d$export$cdba47a5dd2804d = [
    $befd20660ecf614d$var$GECKO_PRIORITY,
    $befd20660ecf614d$var$gecko
];
const $befd20660ecf614d$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $befd20660ecf614d$var$winjs = (line)=>{
    const parts = $befd20660ecf614d$var$winjsRegex.exec(line);
    return parts ? $befd20660ecf614d$var$createFrame(parts[2], parts[1] || $befd20660ecf614d$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $befd20660ecf614d$export$179460296da408e8 = [
    $befd20660ecf614d$var$WINJS_PRIORITY,
    $befd20660ecf614d$var$winjs
];
const $befd20660ecf614d$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $befd20660ecf614d$var$opera10 = (line)=>{
    const parts = $befd20660ecf614d$var$opera10Regex.exec(line);
    return parts ? $befd20660ecf614d$var$createFrame(parts[2], parts[3] || $befd20660ecf614d$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $befd20660ecf614d$export$f892b52c880ffc7a = [
    $befd20660ecf614d$var$OPERA10_PRIORITY,
    $befd20660ecf614d$var$opera10
];
const $befd20660ecf614d$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $befd20660ecf614d$var$opera11 = (line)=>{
    const parts = $befd20660ecf614d$var$opera11Regex.exec(line);
    return parts ? $befd20660ecf614d$var$createFrame(parts[5], parts[3] || parts[4] || $befd20660ecf614d$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $befd20660ecf614d$export$af11af13f09fb0dc = [
    $befd20660ecf614d$var$OPERA11_PRIORITY,
    $befd20660ecf614d$var$opera11
];
const $befd20660ecf614d$export$7197c0fe6554c079 = [
    $befd20660ecf614d$export$263a749fff749872,
    $befd20660ecf614d$export$cdba47a5dd2804d,
    $befd20660ecf614d$export$179460296da408e8
];
const $befd20660ecf614d$export$2b2b997d81bf3907 = (0, $gyMDG.createStackParser)(...$befd20660ecf614d$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $befd20660ecf614d$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $befd20660ecf614d$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("8B7hC", function(module, exports) {
$parcel$export(module.exports, "getDefaultIntegrations", () => $64276db75a974acc$export$5783b2920b1d62b9);

var $5xS6z = parcelRequire("5xS6z");
var $22vpF = parcelRequire("22vpF");
var $9IpGu = parcelRequire("9IpGu");
var $bcmjf = parcelRequire("bcmjf");
var $8EcGG = parcelRequire("8EcGG");
var $7KhuL = parcelRequire("7KhuL");
var $fGTgs = parcelRequire("fGTgs");

var $cb9KV = parcelRequire("cb9KV");
var $koMb7 = parcelRequire("koMb7");
var $gyMDG = parcelRequire("gyMDG");
var $dnYJu = parcelRequire("dnYJu");

var $k5Njc = parcelRequire("k5Njc");

var $eWeX3 = parcelRequire("eWeX3");

var $2bJYr = parcelRequire("2bJYr");

var $3lU56 = parcelRequire("3lU56");

var $eMZeB = parcelRequire("eMZeB");

var $9FeUM = parcelRequire("9FeUM");

var $3COXJ = parcelRequire("3COXJ");

var $c01qe = parcelRequire("c01qe");

var $cVdRh = parcelRequire("cVdRh");

var $goCYZ = parcelRequire("goCYZ");

var $hcHAe = parcelRequire("hcHAe");

var $dckIV = parcelRequire("dckIV");
/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $64276db75a974acc$export$5ef831fccfce35e5 = [
    (0, $7KhuL.inboundFiltersIntegration)(),
    (0, $22vpF.functionToStringIntegration)(),
    (0, $cVdRh.browserApiErrorsIntegration)(),
    (0, $3lU56.breadcrumbsIntegration)(),
    (0, $9FeUM.globalHandlersIntegration)(),
    (0, $c01qe.linkedErrorsIntegration)(),
    (0, $eMZeB.dedupeIntegration)(),
    (0, $3COXJ.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function $64276db75a974acc$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$64276db75a974acc$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $64276db75a974acc$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $64276db75a974acc$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $2bJYr.WINDOW).SENTRY_RELEASE && (0, $2bJYr.WINDOW).SENTRY_RELEASE.id) options.release = (0, $2bJYr.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $gyMDG.stackParserFromStackParserOptions)(options.stackParser || (0, $goCYZ.defaultStackParser)),
        integrations: (0, $bcmjf.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $dnYJu.supportsFetch)() ? (0, $hcHAe.makeFetchTransport) : (0, $dckIV.makeXHRTransport))
    };
    (0, $fGTgs.initAndBind)((0, $k5Njc.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $64276db75a974acc$var$startSessionTracking();
}
const $64276db75a974acc$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $9IpGu.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $2bJYr.WINDOW).document) {
        (0, $eWeX3.DEBUG_BUILD) && (0, $koMb7.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $eWeX3.DEBUG_BUILD) && (0, $koMb7.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $2bJYr.WINDOW).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $8EcGG.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $2bJYr.WINDOW).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $2bJYr.WINDOW).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $2bJYr.WINDOW).document.head || (0, $2bJYr.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $eWeX3.DEBUG_BUILD) && (0, $koMb7.logger).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $64276db75a974acc$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $64276db75a974acc$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $64276db75a974acc$export$4997ffc0176396a6(fn) {
    return (0, $2bJYr.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $64276db75a974acc$var$startSessionTracking() {
    if (typeof (0, $2bJYr.WINDOW).document === 'undefined') {
        (0, $eWeX3.DEBUG_BUILD) && (0, $koMb7.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $5xS6z.startSession)({
        ignoreDuration: true
    });
    (0, $5xS6z.captureSession)();
    // We want to create a session for every navigation as well
    (0, $cb9KV.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $5xS6z.startSession)({
                ignoreDuration: true
            });
            (0, $5xS6z.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $64276db75a974acc$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $5xS6z.getClient)();
    if (client) client.captureUserFeedback(feedback);
}

});
parcelRegister("3lU56", function(module, exports) {
$parcel$export(module.exports, "breadcrumbsIntegration", () => $270ed5d87d09fbe4$export$c079d904b326663a);

var $5xS6z = parcelRequire("5xS6z");
var $bcmjf = parcelRequire("bcmjf");

var $1ZO6A = parcelRequire("1ZO6A");
var $bi1Kh = parcelRequire("bi1Kh");
var $1WiA4 = parcelRequire("1WiA4");
var $cb9KV = parcelRequire("cb9KV");
var $dmKg1 = parcelRequire("dmKg1");
var $jOhtQ = parcelRequire("jOhtQ");
var $e0v2o = parcelRequire("e0v2o");
var $koMb7 = parcelRequire("koMb7");
var $3ZJVQ = parcelRequire("3ZJVQ");
var $h6sgJ = parcelRequire("h6sgJ");
var $78f95 = parcelRequire("78f95");

var $eWeX3 = parcelRequire("eWeX3");

var $2bJYr = parcelRequire("2bJYr");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $270ed5d87d09fbe4$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $270ed5d87d09fbe4$var$INTEGRATION_NAME = 'Breadcrumbs';
const $270ed5d87d09fbe4$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $270ed5d87d09fbe4$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $bi1Kh.addConsoleInstrumentationHandler)($270ed5d87d09fbe4$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $1ZO6A.addClickKeypressInstrumentationHandler)($270ed5d87d09fbe4$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $dmKg1.addXhrInstrumentationHandler)($270ed5d87d09fbe4$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $1WiA4.addFetchInstrumentationHandler)($270ed5d87d09fbe4$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $cb9KV.addHistoryInstrumentationHandler)($270ed5d87d09fbe4$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $270ed5d87d09fbe4$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $270ed5d87d09fbe4$export$c079d904b326663a = (0, $bcmjf.defineIntegration)($270ed5d87d09fbe4$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $270ed5d87d09fbe4$export$2dc68d50d56fbbd = (0, $bcmjf.convertIntegrationFnToClass)($270ed5d87d09fbe4$var$INTEGRATION_NAME, $270ed5d87d09fbe4$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $270ed5d87d09fbe4$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $5xS6z.getClient)() !== client) return;
        (0, $5xS6z.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $e0v2o.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $270ed5d87d09fbe4$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $5xS6z.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $270ed5d87d09fbe4$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $eWeX3.DEBUG_BUILD) && (0, $koMb7.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$270ed5d87d09fbe4$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$270ed5d87d09fbe4$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $270ed5d87d09fbe4$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $270ed5d87d09fbe4$var$_isEvent(event) ? event.target : event;
            target = (0, $jOhtQ.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $jOhtQ.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $5xS6z.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $270ed5d87d09fbe4$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $5xS6z.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $78f95.severityLevelFromString)(handlerData.level),
            message: (0, $h6sgJ.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $h6sgJ.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $5xS6z.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $270ed5d87d09fbe4$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $5xS6z.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $dmKg1.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $5xS6z.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $270ed5d87d09fbe4$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $5xS6z.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $5xS6z.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $5xS6z.addBreadcrumb)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $270ed5d87d09fbe4$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $5xS6z.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $3ZJVQ.parseUrl)((0, $2bJYr.WINDOW).location.href);
        let parsedFrom = from ? (0, $3ZJVQ.parseUrl)(from) : undefined;
        const parsedTo = (0, $3ZJVQ.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $5xS6z.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $270ed5d87d09fbe4$var$_isEvent(event) {
    return !!event && !!event.target;
}

});

parcelRegister("eMZeB", function(module, exports) {
$parcel$export(module.exports, "dedupeIntegration", () => $ac450c43a5693408$export$6d39aa44cd0c7567);

var $bcmjf = parcelRequire("bcmjf");

var $koMb7 = parcelRequire("koMb7");

var $eWeX3 = parcelRequire("eWeX3");
const $ac450c43a5693408$var$INTEGRATION_NAME = 'Dedupe';
const $ac450c43a5693408$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $ac450c43a5693408$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($ac450c43a5693408$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $eWeX3.DEBUG_BUILD) && (0, $koMb7.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $ac450c43a5693408$export$6d39aa44cd0c7567 = (0, $bcmjf.defineIntegration)($ac450c43a5693408$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ac450c43a5693408$export$688d98c249d31ad3 = (0, $bcmjf.convertIntegrationFnToClass)($ac450c43a5693408$var$INTEGRATION_NAME, $ac450c43a5693408$export$6d39aa44cd0c7567);
function $ac450c43a5693408$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($ac450c43a5693408$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($ac450c43a5693408$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $ac450c43a5693408$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$ac450c43a5693408$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$ac450c43a5693408$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $ac450c43a5693408$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $ac450c43a5693408$var$_getExceptionFromEvent(previousEvent);
    const currentException = $ac450c43a5693408$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$ac450c43a5693408$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$ac450c43a5693408$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $ac450c43a5693408$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $ac450c43a5693408$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $ac450c43a5693408$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $ac450c43a5693408$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $ac450c43a5693408$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $ac450c43a5693408$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});

parcelRegister("9FeUM", function(module, exports) {
$parcel$export(module.exports, "globalHandlersIntegration", () => $7093832ff4e6fed0$export$66acc70e8cf2b71a);

var $5xS6z = parcelRequire("5xS6z");
var $bcmjf = parcelRequire("bcmjf");

var $jxo1y = parcelRequire("jxo1y");
var $eupZN = parcelRequire("eupZN");
var $jOhtQ = parcelRequire("jOhtQ");
var $97v7b = parcelRequire("97v7b");
var $koMb7 = parcelRequire("koMb7");

var $eWeX3 = parcelRequire("eWeX3");

var $1Vo9Y = parcelRequire("1Vo9Y");

var $2bJYr = parcelRequire("2bJYr");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $7093832ff4e6fed0$var$INTEGRATION_NAME = 'GlobalHandlers';
const $7093832ff4e6fed0$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $7093832ff4e6fed0$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $7093832ff4e6fed0$var$_installGlobalOnErrorHandler(client);
                $7093832ff4e6fed0$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $7093832ff4e6fed0$var$_installGlobalOnUnhandledRejectionHandler(client);
                $7093832ff4e6fed0$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $7093832ff4e6fed0$export$66acc70e8cf2b71a = (0, $bcmjf.defineIntegration)($7093832ff4e6fed0$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $7093832ff4e6fed0$export$204155decbc90e5a = (0, $bcmjf.convertIntegrationFnToClass)($7093832ff4e6fed0$var$INTEGRATION_NAME, $7093832ff4e6fed0$export$66acc70e8cf2b71a);
function $7093832ff4e6fed0$var$_installGlobalOnErrorHandler(client) {
    (0, $jxo1y.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $7093832ff4e6fed0$var$getOptions();
        if ((0, $5xS6z.getClient)() !== client || (0, $2bJYr.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $97v7b.isString)(msg) ? $7093832ff4e6fed0$var$_eventFromIncompleteOnError(msg, url, line, column) : $7093832ff4e6fed0$var$_enhanceEventWithInitialFrame((0, $1Vo9Y.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $5xS6z.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $7093832ff4e6fed0$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $eupZN.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $7093832ff4e6fed0$var$getOptions();
        if ((0, $5xS6z.getClient)() !== client || (0, $2bJYr.shouldIgnoreOnError)()) return;
        const error = $7093832ff4e6fed0$var$_getUnhandledRejectionError(e);
        const event = (0, $97v7b.isPrimitive)(error) ? $7093832ff4e6fed0$var$_eventFromRejectionWithPrimitive(error) : (0, $1Vo9Y.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $5xS6z.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $7093832ff4e6fed0$var$_getUnhandledRejectionError(error) {
    if ((0, $97v7b.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $7093832ff4e6fed0$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7093832ff4e6fed0$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $97v7b.isErrorEvent)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $7093832ff4e6fed0$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7093832ff4e6fed0$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $97v7b.isString)(url) && url.length > 0 ? url : (0, $jOhtQ.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $7093832ff4e6fed0$var$globalHandlerLog(type) {
    (0, $eWeX3.DEBUG_BUILD) && (0, $koMb7.logger).log(`Global Handler attached: ${type}`);
}
function $7093832ff4e6fed0$var$getOptions() {
    const client = (0, $5xS6z.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});

parcelRegister("3COXJ", function(module, exports) {
$parcel$export(module.exports, "httpContextIntegration", () => $2a3c73c673779982$export$1378794447170364);

var $bcmjf = parcelRequire("bcmjf");

var $2bJYr = parcelRequire("2bJYr");
const $2a3c73c673779982$var$INTEGRATION_NAME = 'HttpContext';
const $2a3c73c673779982$var$_httpContextIntegration = ()=>{
    return {
        name: $2a3c73c673779982$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $2bJYr.WINDOW).navigator && !(0, $2bJYr.WINDOW).location && !(0, $2bJYr.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $2bJYr.WINDOW).location && (0, $2bJYr.WINDOW).location.href;
            const { referrer: referrer } = (0, $2bJYr.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $2bJYr.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $2a3c73c673779982$export$1378794447170364 = (0, $bcmjf.defineIntegration)($2a3c73c673779982$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $2a3c73c673779982$export$5d2ee9a544b09a94 = (0, $bcmjf.convertIntegrationFnToClass)($2a3c73c673779982$var$INTEGRATION_NAME, $2a3c73c673779982$export$1378794447170364);

});

parcelRegister("c01qe", function(module, exports) {
$parcel$export(module.exports, "linkedErrorsIntegration", () => $8bc696872cbf878d$export$ebabb00eb7f3a395);

var $bcmjf = parcelRequire("bcmjf");

var $5qzhP = parcelRequire("5qzhP");

var $1Vo9Y = parcelRequire("1Vo9Y");
const $8bc696872cbf878d$var$DEFAULT_KEY = 'cause';
const $8bc696872cbf878d$var$DEFAULT_LIMIT = 5;
const $8bc696872cbf878d$var$INTEGRATION_NAME = 'LinkedErrors';
const $8bc696872cbf878d$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $8bc696872cbf878d$var$DEFAULT_LIMIT;
    const key = options.key || $8bc696872cbf878d$var$DEFAULT_KEY;
    return {
        name: $8bc696872cbf878d$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $5qzhP.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $1Vo9Y.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $8bc696872cbf878d$export$ebabb00eb7f3a395 = (0, $bcmjf.defineIntegration)($8bc696872cbf878d$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $8bc696872cbf878d$export$8d1e60aaf616fb4f = (0, $bcmjf.convertIntegrationFnToClass)($8bc696872cbf878d$var$INTEGRATION_NAME, $8bc696872cbf878d$export$ebabb00eb7f3a395);

});

parcelRegister("cVdRh", function(module, exports) {
$parcel$export(module.exports, "browserApiErrorsIntegration", () => $96858ee27ae822ec$export$59bfe9f1c76150e);

var $bcmjf = parcelRequire("bcmjf");

var $lfeDQ = parcelRequire("lfeDQ");
var $gyMDG = parcelRequire("gyMDG");

var $2bJYr = parcelRequire("2bJYr");
const $96858ee27ae822ec$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $96858ee27ae822ec$var$INTEGRATION_NAME = 'TryCatch';
const $96858ee27ae822ec$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $96858ee27ae822ec$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $lfeDQ.fill)((0, $2bJYr.WINDOW), 'setTimeout', $96858ee27ae822ec$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $lfeDQ.fill)((0, $2bJYr.WINDOW), 'setInterval', $96858ee27ae822ec$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $lfeDQ.fill)((0, $2bJYr.WINDOW), 'requestAnimationFrame', $96858ee27ae822ec$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $2bJYr.WINDOW)) (0, $lfeDQ.fill)(XMLHttpRequest.prototype, 'send', $96858ee27ae822ec$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $96858ee27ae822ec$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($96858ee27ae822ec$var$_wrapEventTarget);
            }
        }
    };
};
const $96858ee27ae822ec$export$59bfe9f1c76150e = (0, $bcmjf.defineIntegration)($96858ee27ae822ec$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $96858ee27ae822ec$export$f1a018517668e6d3 = (0, $bcmjf.convertIntegrationFnToClass)($96858ee27ae822ec$var$INTEGRATION_NAME, $96858ee27ae822ec$export$59bfe9f1c76150e);
function $96858ee27ae822ec$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $2bJYr.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $gyMDG.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $96858ee27ae822ec$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $2bJYr.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $gyMDG.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $96858ee27ae822ec$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $lfeDQ.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $gyMDG.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $lfeDQ.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $gyMDG.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $2bJYr.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $96858ee27ae822ec$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $2bJYr.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $lfeDQ.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $2bJYr.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $gyMDG.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $2bJYr.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $gyMDG.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $lfeDQ.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("hcHAe", function(module, exports) {
$parcel$export(module.exports, "makeFetchTransport", () => $c8655d6f48e4a3f7$export$b2311068c46d7cc8);

var $cpOgG = parcelRequire("cpOgG");

var $iMEJN = parcelRequire("iMEJN");

var $iSMgL = parcelRequire("iSMgL");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $c8655d6f48e4a3f7$export$b2311068c46d7cc8(options, nativeFetch = (0, $iSMgL.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $iSMgL.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $iMEJN.rejectedSyncPromise)(e);
        }
    }
    return (0, $cpOgG.createTransport)(options, makeRequest);
}

});
parcelRegister("iSMgL", function(module, exports) {
$parcel$export(module.exports, "getNativeFetchImplementation", () => $dbf2b672578a265a$export$8be2119ce08e3379);
$parcel$export(module.exports, "clearCachedFetchImplementation", () => $dbf2b672578a265a$export$d499686d2dd738c6);

var $dnYJu = parcelRequire("dnYJu");
var $koMb7 = parcelRequire("koMb7");

var $eWeX3 = parcelRequire("eWeX3");

var $2bJYr = parcelRequire("2bJYr");
let $dbf2b672578a265a$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $dbf2b672578a265a$export$8be2119ce08e3379() {
    if ($dbf2b672578a265a$var$cachedFetchImpl) return $dbf2b672578a265a$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $dnYJu.isNativeFetch)((0, $2bJYr.WINDOW).fetch)) return $dbf2b672578a265a$var$cachedFetchImpl = (0, $2bJYr.WINDOW).fetch.bind((0, $2bJYr.WINDOW));
    const document = (0, $2bJYr.WINDOW).document;
    let fetchImpl = (0, $2bJYr.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $eWeX3.DEBUG_BUILD) && (0, $koMb7.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $dbf2b672578a265a$var$cachedFetchImpl = fetchImpl.bind((0, $2bJYr.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $dbf2b672578a265a$export$d499686d2dd738c6() {
    $dbf2b672578a265a$var$cachedFetchImpl = undefined;
}

});


parcelRegister("dckIV", function(module, exports) {
$parcel$export(module.exports, "makeXHRTransport", () => $99bc78a3d1dab005$export$5e1441cee30d5a39);

var $cpOgG = parcelRequire("cpOgG");

var $iMEJN = parcelRequire("iMEJN");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $99bc78a3d1dab005$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $99bc78a3d1dab005$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $iMEJN.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $99bc78a3d1dab005$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $cpOgG.createTransport)(options, makeRequest);
}

});


parcelRegister("bcirB", function(module, exports) {
$parcel$export(module.exports, "BFFErrorEnum", () => $47d16f3283b16854$export$7d83cc20f4070394);
$parcel$export(module.exports, "BFFError", () => $47d16f3283b16854$export$c6a4f8515f74c5c8);
$parcel$export(module.exports, "BFFNetworkError", () => $47d16f3283b16854$export$f4de77e3e154579c);
/**
 * ------------------------------------------------------------------
 * BFF Error Classes
 * Shared error handling for BFF operations / observability
 * ------------------------------------------------------------------
 */ var $47d16f3283b16854$export$7d83cc20f4070394 = /*#__PURE__*/ function(BFFErrorEnum) {
    BFFErrorEnum["BFF_ERROR"] = "BFF_ERROR";
    BFFErrorEnum["BFF_NETWORK_ERROR"] = "BFF_NETWORK_ERROR";
    return BFFErrorEnum;
}({});
class $47d16f3283b16854$export$c6a4f8515f74c5c8 extends Error {
    constructor(message, context){
        super(message);
        this.name = "BFF_ERROR";
        this.context = context.additionalContext;
        this.originalError = context.originalError;
        this.status = context.status;
        this.timestamp = new Date().toISOString();
    }
}
class $47d16f3283b16854$export$f4de77e3e154579c extends $47d16f3283b16854$export$c6a4f8515f74c5c8 {
    constructor(message, context){
        super(message, context);
        this.name = "BFF_NETWORK_ERROR";
        this.url = context.url;
    }
}

});

parcelRegister("ibNQH", function(module, exports) {
$parcel$export(module.exports, "getEnvironment", () => $109fb9d65e96a34a$export$57570b1603cf6adb);

var $kAcWU = parcelRequire("kAcWU");

var $f0aIa = parcelRequire("f0aIa");
function $109fb9d65e96a34a$export$57570b1603cf6adb(env) {
    if (env) return env;
    if (typeof window === 'undefined' || !window.location) return (0, $f0aIa.Environment).Unknown;
    const host = window.location.hostname.toLowerCase();
    // Fast path: exact hostname matches
    const exactMatch = (0, $kAcWU.EXACT_HOST_MAP)[host];
    if (exactMatch) return exactMatch;
    // Extract TLD for efficient branching (find last dot position)
    const lastDot = host.lastIndexOf('.');
    if (lastDot === -1) return (0, $f0aIa.Environment).Unknown;
    const tld = host.slice(lastDot + 1); // 'com', 'net', etc.
    // Branch by TLD to reduce checks
    switch(tld){
        case 'com':
            return $109fb9d65e96a34a$var$classifyComDomain(host);
        case 'net':
            return $109fb9d65e96a34a$var$classifyNetDomain(host);
        default:
            return (0, $f0aIa.Environment).Unknown;
    }
}
/**
 * Classify .com domains
 */ function $109fb9d65e96a34a$var$classifyComDomain(host) {
    // jira-dev.com (staging)
    if (host.endsWith('.jira-dev.com')) return (0, $f0aIa.Environment).Staging;
    // atlassian-us-gov-mod.com (FedRAMP)
    if (host.endsWith('.atlassian-us-gov-mod.com')) {
        // FedRAMP Bifrost CDN: check most specific first
        if (host.endsWith('.frontend.cdn.atlassian-us-gov-mod.com')) return host.includes('.stg.') ? (0, $f0aIa.Environment).Staging : (0, $f0aIa.Environment).Prod;
        if (host.endsWith('.stg.atlassian-us-gov-mod.com')) return (0, $f0aIa.Environment).Staging;
        return (0, $f0aIa.Environment).Prod;
    }
    // atlassian.com domains
    if (host.endsWith('.atlassian.com')) {
        // services.atlassian.com vanity domains (check most specific first)
        if (host.endsWith('.dev.services.atlassian.com')) return (0, $f0aIa.Environment).Development;
        if (host.endsWith('.staging.services.atlassian.com')) return (0, $f0aIa.Environment).Staging;
        if (host.endsWith('.services.atlassian.com')) return (0, $f0aIa.Environment).Prod;
        // Environment-specific subdomains
        if (host.endsWith('.dev.atlassian.com')) return (0, $f0aIa.Environment).Development;
        if (host.endsWith('.stg.atlassian.com')) return (0, $f0aIa.Environment).Staging;
        return (0, $f0aIa.Environment).Prod;
    }
    return (0, $f0aIa.Environment).Unknown;
}
/**
 * Classify .net domains
 */ function $109fb9d65e96a34a$var$classifyNetDomain(host) {
    // atlassian.net (prod tenants)
    if (host.endsWith('.atlassian.net')) return (0, $f0aIa.Environment).Prod;
    // atl-paas-us-gov-mod.net (FedRAMP Micros)
    if (host.endsWith('.atl-paas-us-gov-mod.net')) {
        if (host.includes('.staging.')) return (0, $f0aIa.Environment).Staging;
        if (host.includes('.prod.')) return (0, $f0aIa.Environment).Prod;
        return (0, $f0aIa.Environment).Unknown;
    }
    // atl-paas.net (commercial Micros and Bifrost)
    if (host.endsWith('.atl-paas.net')) {
        // Bifrost commercial: check most specific first
        if (host.endsWith('.frontend.public.atl-paas.net')) {
            if (host.includes('.ddev.') || host.includes('.dev-west2.')) return (0, $f0aIa.Environment).Development;
            if (host.includes('.stg-east.')) return (0, $f0aIa.Environment).Staging;
            if (host.includes('.prod-east.')) return (0, $f0aIa.Environment).Prod;
            return (0, $f0aIa.Environment).Development;
        }
        // Micros commercial
        if (host.includes('.dev.') || host.includes('.platdev.')) return (0, $f0aIa.Environment).Development;
        if (host.includes('.staging.')) return (0, $f0aIa.Environment).Staging;
        if (host.includes('.prod.')) return (0, $f0aIa.Environment).Prod;
    }
    return (0, $f0aIa.Environment).Unknown;
}

});
parcelRegister("kAcWU", function(module, exports) {
$parcel$export(module.exports, "EXACT_HOST_MAP", () => $ac81b1c417481894$export$636c0c57a2ce36e9);

var $f0aIa = parcelRequire("f0aIa");
const $ac81b1c417481894$export$636c0c57a2ce36e9 = {
    localhost: (0, $f0aIa.Environment).Development,
    '127.0.0.1': (0, $f0aIa.Environment).Development,
    'id.atlassian.com': (0, $f0aIa.Environment).Prod,
    'admin.atlassian.com': (0, $f0aIa.Environment).Prod,
    'id.stg.internal.atlassian.com': (0, $f0aIa.Environment).Staging,
    'admin.stg.atlassian.com': (0, $f0aIa.Environment).Staging
};

});
parcelRegister("f0aIa", function(module, exports) {
$parcel$export(module.exports, "Environment", () => $29f95c526799920e$export$7dc6752a22ab011a);
var $29f95c526799920e$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
    Environment["Unknown"] = "unknown";
    return Environment;
}({});

});



parcelRegister("6IJ5i", function(module, exports) {
$parcel$export(module.exports, "SENTRY_DSN", () => $a86d89e43563d14f$export$6faa4a850bc4d0ce);
$parcel$export(module.exports, "SENTRY_TEAM_NAME", () => $a86d89e43563d14f$export$eafddbd5a5d6fa6a);
$parcel$export(module.exports, "SUPPRESSED_BACKEND_ERROR_PATTERNS", () => $a86d89e43563d14f$export$3a6a639b0dcb30fa);
$parcel$export(module.exports, "extractHttpStatusFromMessage", () => $a86d89e43563d14f$export$4cbc5d5dee209a6d);
$parcel$export(module.exports, "RATE_LIMITED_SAMPLE_RATE", () => $a86d89e43563d14f$export$d467879341ff009d);
$parcel$export(module.exports, "classifyHttpStatus", () => $a86d89e43563d14f$export$223e1d981f020f65);
$parcel$export(module.exports, "DEFAULT_SENTRY_CONFIG", () => $a86d89e43563d14f$export$52d764e0fd2a1dc5);
$parcel$export(module.exports, "SENTRY_PRODUCT", () => $a86d89e43563d14f$export$9f448e5ee63d7699);
// Navigation-experience Sentry DSN
const $a86d89e43563d14f$export$6faa4a850bc4d0ce = 'https://b8c4ebbdd822beb92561fea2a46d2146@o55978.ingest.us.sentry.io/4510463033081856';
const $a86d89e43563d14f$export$eafddbd5a5d6fa6a = 'afe-navigation-experience';
const $a86d89e43563d14f$export$3a6a639b0dcb30fa = [
    // Browser-level network failures. Newer browsers append the request host, e.g.
    // `Failed to fetch (rovo-extension-web.atlassian.com)`, so allow an optional `(host)` suffix
    // while staying anchored (so e.g. "Failed to fetch universal create menu items" won't match).
    /Failed to fetch(?: \([^)]*\))?$/i,
    /NetworkError when attempting to fetch/i,
    /Load failed(?: \([^)]*\))?$/i,
    // Aborted requests. Anchored to the error type (`AbortError: ...`) so FE errors that merely
    // mention "AbortError" in their message are still reported.
    /^AbortError\b/i,
    /The user aborted a request/i,
    // `fetchJSON` failures without a status code (e.g. `fetch() returned no response`).
    /^Failed to fetch data:(?!\s*\d{3}\b)/i,
    /^RelayNetwork: No data returned for operation/i,
    /^FetchError:/i,
    /^Error getting available products by site/i
];
function $a86d89e43563d14f$export$4cbc5d5dee209a6d(message) {
    if (!message) return undefined;
    const match = /^Failed to fetch data:\s*(\d{3})\b/i.exec(message);
    return match ? Number(match[1]) : undefined;
}
const $a86d89e43563d14f$export$d467879341ff009d = 0.01;
function $a86d89e43563d14f$export$223e1d981f020f65(status) {
    if (status === undefined) return 'report';
    if (status === 429) return 'sample';
    if (status === 401 || status === 403 || status >= 500 && status <= 599) return 'suppress';
    return 'report';
}
const $a86d89e43563d14f$export$52d764e0fd2a1dc5 = {
    whitelistUrls: [
        /atl-paas.net/,
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/
    ],
    ignoreUrls: [
        /extensions\//i,
        /^chrome:\/\//i
    ],
    attachStacktrace: true
};
const $a86d89e43563d14f$export$9f448e5ee63d7699 = 'navigation';

});



parcelRegister("hEGZD", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_PREFIX", () => $99b779aeb1ef82b5$export$373682275c03fc63);
$parcel$export(module.exports, "TRIGGER_BUTTON_TEST_ID", () => $99b779aeb1ef82b5$export$3f4cc858c0cb6e84);
$parcel$export(module.exports, "MAX_ALLOWED_SECTIONS", () => $99b779aeb1ef82b5$export$4e49778ae689b92a);
$parcel$export(module.exports, "SOURCE_LOCATION", () => $99b779aeb1ef82b5$export$c2ae99333adf8094);
$parcel$export(module.exports, "REQUIRED_USER_ITEMS", () => $99b779aeb1ef82b5$export$4c7df19e787d8989);
$parcel$export(module.exports, "MAX_MENU_HEIGHT", () => $99b779aeb1ef82b5$export$441df76988f6d01);
$parcel$export(module.exports, "RESPONSIVE_BREAKPOINT", () => $99b779aeb1ef82b5$export$d268f31a83479f83);
$parcel$export(module.exports, "MOBILE_WIDTH_BREAKPOINT", () => $99b779aeb1ef82b5$export$bc385bb37fb17e9c);
$parcel$export(module.exports, "RESIZING_DEBOUNCED", () => $99b779aeb1ef82b5$export$f8e186cd2da1abff);
$parcel$export(module.exports, "PRIMARY_ACTION_ITEM_INDEX", () => $99b779aeb1ef82b5$export$aca7035f4c6a6c0b);
const $99b779aeb1ef82b5$export$373682275c03fc63 = 'universal-create';
const $99b779aeb1ef82b5$export$3f4cc858c0cb6e84 = `${$99b779aeb1ef82b5$export$373682275c03fc63}-trigger-button`;
const $99b779aeb1ef82b5$export$85183a312807388d = 'navigation';
const $99b779aeb1ef82b5$export$4e49778ae689b92a = 3;
const $99b779aeb1ef82b5$export$c2ae99333adf8094 = 'universal-create';
const $99b779aeb1ef82b5$export$4c7df19e787d8989 = [
    'ati:cloud:townsquare:team',
    'ati:cloud:townsquare:goal'
];
const $99b779aeb1ef82b5$export$441df76988f6d01 = 430;
const $99b779aeb1ef82b5$export$d268f31a83479f83 = 'sm';
const $99b779aeb1ef82b5$export$bc385bb37fb17e9c = 767;
const $99b779aeb1ef82b5$export$f8e186cd2da1abff = 100;
const $99b779aeb1ef82b5$export$aca7035f4c6a6c0b = -1;

});

parcelRegister("230VD", function(module, exports) {
$parcel$export(module.exports, "SectionExpansionContext", () => $b7e0091f7c727ad4$export$fc9ae5c4169099cb);
$parcel$export(module.exports, "useSectionExpansionContext", () => $b7e0091f7c727ad4$export$b316af36f410c3ff);
$parcel$export(module.exports, "MenuControlContext", () => $b7e0091f7c727ad4$export$39aa3c8950714d79);
$parcel$export(module.exports, "MenuStateContext", () => $b7e0091f7c727ad4$export$24aad8519b95b41b);
$parcel$export(module.exports, "useMenuStateContext", () => $b7e0091f7c727ad4$export$efa3856fc0e85e7f);
$parcel$export(module.exports, "useUniversalCreateState", () => $b7e0091f7c727ad4$export$c7381b2490bb4d36);
$parcel$export(module.exports, "useUniversalCreateControl", () => $b7e0091f7c727ad4$export$2cd627eaf555af8f);

var $fsvuC = parcelRequire("fsvuC");
const $b7e0091f7c727ad4$var$defaultSectionExpansionContext = {
    sectionExpansionState: {},
    setSectionExpansionState: function() {}
};
const $b7e0091f7c727ad4$export$fc9ae5c4169099cb = (0, $fsvuC.createContext)($b7e0091f7c727ad4$var$defaultSectionExpansionContext);
function $b7e0091f7c727ad4$export$b316af36f410c3ff() {
    return (0, $fsvuC.useContext)($b7e0091f7c727ad4$export$fc9ae5c4169099cb);
}
const $b7e0091f7c727ad4$var$defaultFormControls = {
    load: function() {},
    reset: function() {},
    close: function() {}
};
const $b7e0091f7c727ad4$export$39aa3c8950714d79 = (0, $fsvuC.createContext)($b7e0091f7c727ad4$var$defaultFormControls);
function $b7e0091f7c727ad4$export$56d95dc846453c64() {
    return (0, $fsvuC.useContext)($b7e0091f7c727ad4$export$39aa3c8950714d79);
}
const $b7e0091f7c727ad4$export$24aad8519b95b41b = (0, $fsvuC.createContext)({
    items: [],
    product: 'unknown',
    subProduct: undefined,
    growthRecommendationsSessionId: undefined,
    setGrowthRecommendationsSessionId: undefined,
    crossAppCreationConfig: {
        enabled: false
    },
    sections: [],
    suggestionConfig: {
        enabled: false
    },
    isNav4Enabled: true,
    preventClose: undefined
});
function $b7e0091f7c727ad4$export$efa3856fc0e85e7f() {
    return (0, $fsvuC.useContext)($b7e0091f7c727ad4$export$24aad8519b95b41b);
}
function $b7e0091f7c727ad4$export$c7381b2490bb4d36() {
    return (0, $fsvuC.useContext)($b7e0091f7c727ad4$export$24aad8519b95b41b);
}
function $b7e0091f7c727ad4$export$2cd627eaf555af8f() {
    return (0, $fsvuC.useContext)($b7e0091f7c727ad4$export$39aa3c8950714d79);
}

});


parcelRegister("3eMph", function(module, exports) {
$parcel$export(module.exports, "UniversalCreateButtonLazy", () => $260a67579167ea94$export$3739611c05de95f9);
/* LazyTrigger.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $e7IxC = parcelRequire("e7IxC");

var $j1DKB = parcelRequire("j1DKB");

var $cl0SH = parcelRequire("cl0SH");

var $960kA = parcelRequire("960kA");

var $cQUxy = parcelRequire("cQUxy");

var $3q03G = parcelRequire("3q03G");

var $Wd0FJ = parcelRequire("Wd0FJ");

var $230VD = parcelRequire("230VD");

var $aLgA9 = parcelRequire("aLgA9");

var $5AnMP = parcelRequire("5AnMP");

var $7wMvV = parcelRequire("7wMvV");

var $9U8bL = parcelRequire("9U8bL");

var $9WMk3 = parcelRequire("9WMk3");

var $1M7xj = parcelRequire("1M7xj");

var $fK8qN = parcelRequire("fK8qN");
function $260a67579167ea94$var$UniversalCreateButtonLazyInner(props) {
    const { children: children, testId: testId, onClick: onClick, onClose: onClose, isOpen: isOpen, enableTriggerPulse: enableTriggerPulse = false, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, isNav4Enabled: isNav4Enabled = true, shouldAnimateCreateIcon: shouldAnimateCreateIcon = false, buttonTheme: buttonTheme, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, shouldRenderToParent: shouldRenderToParent, buttonOnly: buttonOnly = false } = props;
    const isButtonOnly = buttonOnly;
    const primaryActionItem = 'primaryActionItem' in props ? props.primaryActionItem : undefined;
    const isResponsive = (0, $aLgA9.useIsResponsiveView)();
    // Track JS chunk load time - must be called before the lazy chunk loads
    (0, $1M7xj.useJsChunkLoadTrack)();
    const [isLocalOpen, setLocalIsOpen] = (0, $e7IxC.default)(isOpen, ()=>false);
    const handleTriggerButtonClick = (0, $fsvuC.useCallback)(()=>{
        setLocalIsOpen(!isLocalOpen);
        // Notify parent
        onClick?.();
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onClick
    ]);
    const handleClose = (0, $fsvuC.useCallback)(()=>{
        setLocalIsOpen(false);
        onClose?.();
    }, [
        setLocalIsOpen,
        onClose
    ]);
    const handleMouseEnter = (0, $fsvuC.useCallback)((event)=>{
        onMouseEnter?.(event);
    }, [
        onMouseEnter
    ]);
    const [growthRecommendationsSessionId, setGrowthRecommendationsSessionId] = (0, $fsvuC.useState)(undefined);
    const menuStateContextValue = (0, $fsvuC.useMemo)(()=>{
        const sections = 'sections' in props && props.sections ? props.sections : [];
        const crossAppCreationConfig = 'crossAppCreationConfig' in props ? props.crossAppCreationConfig ?? {
            enabled: false
        } : {
            enabled: false
        };
        const selectedItem = 'selectedItem' in props ? props.selectedItem : undefined;
        return {
            items: [],
            // to be removed
            product: props.product ?? 'unknown',
            subProduct: props.subProduct,
            isNav4Enabled: isNav4Enabled,
            sections: sections,
            crossAppCreationConfig: crossAppCreationConfig,
            suggestionConfig: {
                enabled: false
            },
            selectedItem: // to be removed
            selectedItem,
            preventClose: props.preventClose,
            primaryActionItem: primaryActionItem,
            growthRecommendationsSessionId: growthRecommendationsSessionId,
            setGrowthRecommendationsSessionId: setGrowthRecommendationsSessionId
        };
    }, [
        props,
        isNav4Enabled,
        primaryActionItem,
        growthRecommendationsSessionId
    ]);
    const sharedTriggerButtonProps = (0, $fsvuC.useMemo)(()=>({
            testId: testId,
            triggerButtonSpotlightTarget: triggerButtonSpotlightTarget,
            enableTriggerPulse: enableTriggerPulse,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: handleTriggerButtonClick,
            isNav4Enabled: isNav4Enabled,
            shouldAnimateCreateIcon: shouldAnimateCreateIcon,
            buttonTheme: buttonTheme
        }), [
        testId,
        triggerButtonSpotlightTarget,
        enableTriggerPulse,
        handleMouseEnter,
        onMouseLeave,
        handleTriggerButtonClick,
        isNav4Enabled,
        shouldAnimateCreateIcon,
        buttonTheme
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $230VD.MenuStateContext).Provider, {
        value: menuStateContextValue,
        children: isButtonOnly ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $9WMk3.TriggerButton), {
            ...sharedTriggerButtonProps,
            buttonOnly: true,
            children: children
        }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $7wMvV.EntryPointPopup), {
            isOpen: isLocalOpen,
            placement: isResponsive && isNav4Enabled || primaryActionItem ? 'bottom-end' : 'bottom-start',
            // eslint-disable-next-line @atlaskit/design-system/use-should-render-to-parent
            shouldRenderToParent: shouldRenderToParent,
            onClose: handleClose,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $9WMk3.TriggerButton), {
                    ...sharedTriggerButtonProps,
                    buttonOnly: undefined,
                    isEntryPointEnabled: true,
                    triggerProps: triggerProps,
                    isOpen: triggerProps['aria-expanded'],
                    primaryActionItem: primaryActionItem,
                    children: children
                }),
            entryPoint: (0, $fK8qN.popupContentEntryPoint),
            entryPointProps: props,
            fallback: /*#__PURE__*/ (0, $5chsV.jsx)((0, $9U8bL.LoadingMenu), {
                padded: true
            })
        })
    });
}
$260a67579167ea94$var$UniversalCreateButtonLazyInner.displayName = "UniversalCreateButtonLazyInner";
function $260a67579167ea94$export$3739611c05de95f9(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3q03G.NavigationUFOSegment), {
        id: "universalCreateComponentLoad",
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $Wd0FJ.ConditionalRelayEnvironmentProvider), {
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $960kA.BFFProvider), {
                consumer: (0, $cl0SH.BFFConsumerEnum).UNIVERSAL_CREATE,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $cQUxy.UniversalCreateBFFProvider), {
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5AnMP.AnalyticsWrapper), {
                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $j1DKB.FlagsProvider), {
                            children: /*#__PURE__*/ (0, $5chsV.jsx)($260a67579167ea94$var$UniversalCreateButtonLazyInner, {
                                ...props
                            })
                        })
                    })
                })
            })
        })
    });
}
$260a67579167ea94$export$3739611c05de95f9.displayName = "UniversalCreateButtonLazy";

});
parcelRegister("cl0SH", function(module, exports) {
$parcel$export(module.exports, "BFFConsumerEnum", () => $f1e440b0f401bea2$export$9a146e025690327e);
$parcel$export(module.exports, "ASSETS_APP_KEY", () => $f1e440b0f401bea2$export$45e63649edff1e2a);
$parcel$export(module.exports, "RETRY_INTERVAL_DEFAULT", () => $f1e440b0f401bea2$export$7b4183e5f0de390a);
$parcel$export(module.exports, "MAX_ATTEMPTS_NEW_DEFAULT", () => $f1e440b0f401bea2$export$2edbfcb69dc77e78);
$parcel$export(module.exports, "RequestStatus", () => $f1e440b0f401bea2$export$600e7c1f9e0414e1);
$parcel$export(module.exports, "BFF_REQUEST_STATUS_KEY", () => $f1e440b0f401bea2$export$c889532d47d74e9c);
$parcel$export(module.exports, "FLIGHTDECK_REQUEST_STATUS_KEY", () => $f1e440b0f401bea2$export$123b1b8742c0ac6a);
$parcel$export(module.exports, "UC_MENU_ITEMS_REQUEST_STATUS_KEY", () => $f1e440b0f401bea2$export$1631e8a201b50246);
var $f1e440b0f401bea2$export$9a146e025690327e = /*#__PURE__*/ function(BFFConsumerEnum) {
    BFFConsumerEnum["ATLASSIAN_SWITCHER"] = "ATLASSIAN_SWITCHER";
    BFFConsumerEnum["GLOBAL_SHORTCUTS"] = "GLOBAL_SHORTCUTS";
    BFFConsumerEnum["GLOBAL_SIDE_NAVIGATION"] = "GLOBAL_SIDE_NAVIGATION";
    BFFConsumerEnum["UNIVERSAL_CREATE"] = "UNIVERSAL_CREATE";
    return BFFConsumerEnum;
}({});
const $f1e440b0f401bea2$export$45e63649edff1e2a = 'ASSETS';
const $f1e440b0f401bea2$export$45c80c6b98d65f36 = 3;
const $f1e440b0f401bea2$export$7b4183e5f0de390a = 1000;
const $f1e440b0f401bea2$export$2edbfcb69dc77e78 = 1;
const $f1e440b0f401bea2$export$891dc7068a3d5e65 = 14;
const $f1e440b0f401bea2$export$6e594fe130dbe3b = 14;
var $f1e440b0f401bea2$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["INIT"] = "initializing";
    RequestStatus["LOADING"] = "loading";
    RequestStatus["COMPLETE"] = "complete";
    RequestStatus["ERROR"] = "error";
    return RequestStatus;
}({});
const $f1e440b0f401bea2$export$c889532d47d74e9c = 'bff';
const $f1e440b0f401bea2$export$123b1b8742c0ac6a = 'flightdeck';
const $f1e440b0f401bea2$export$1631e8a201b50246 = 'uc-menu-items';

});

parcelRegister("960kA", function(module, exports) {
$parcel$export(module.exports, "BFFContext", () => $fe98743768aa744a$export$873dcaf380a86d6b);
$parcel$export(module.exports, "useBFFContext", () => $fe98743768aa744a$export$63342c357ecccda2);
$parcel$export(module.exports, "BFFProvider", () => $fe98743768aa744a$export$71a938590b6955cc);
$parcel$export(module.exports, "useUserContext", () => $fe98743768aa744a$export$87c54b525b914dab);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $cl0SH = parcelRequire("cl0SH");
const $fe98743768aa744a$export$b2445cd6f2d7fd5 = {
    cache: {},
    cacheKey: '',
    status: null,
    consumer: null
};
const $fe98743768aa744a$export$873dcaf380a86d6b = /*#__PURE__*/ (0, $fsvuC.createContext)({
    value: $fe98743768aa744a$export$b2445cd6f2d7fd5,
    currentLoadingRequests: [],
    setValue: ()=>{},
    updateCurrentLoadingRequests: ()=>{}
});
function $fe98743768aa744a$export$63342c357ecccda2() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useContext($fe98743768aa744a$export$873dcaf380a86d6b);
}
function $fe98743768aa744a$export$71a938590b6955cc({ consumer: consumer, children: children }) {
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useState({
        cache: {},
        cacheKey: consumer,
        consumer: consumer,
        status: (0, $cl0SH.RequestStatus).INIT
    });
    const [currentLoadingRequests, setCurrentLoadingRequests] = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useState([]);
    const updateCurrentLoadingRequests = (0, $fsvuC.useCallback)((name, status)=>{
        switch(status){
            case (0, $cl0SH.RequestStatus).LOADING:
                setCurrentLoadingRequests((prev)=>[
                        ...prev,
                        name
                    ]);
                break;
            case (0, $cl0SH.RequestStatus).COMPLETE:
                setCurrentLoadingRequests((prev)=>prev.filter((request)=>request !== name));
                break;
            case (0, $cl0SH.RequestStatus).ERROR:
                setCurrentLoadingRequests([]);
                break;
        }
    }, [
        setCurrentLoadingRequests
    ]);
    const stableContextValue = (0, $fsvuC.useMemo)(()=>({
            value: value,
            setValue: setValue,
            currentLoadingRequests: currentLoadingRequests,
            updateCurrentLoadingRequests: updateCurrentLoadingRequests
        }), [
        currentLoadingRequests,
        updateCurrentLoadingRequests,
        value
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)($fe98743768aa744a$export$873dcaf380a86d6b.Provider, {
        value: stableContextValue,
        children: children
    });
}
$fe98743768aa744a$export$71a938590b6955cc.displayName = "BFFProvider";
const $fe98743768aa744a$var$defaultUserControls = {
    user: undefined
};
const $fe98743768aa744a$export$38ee920e59704589 = /*#__PURE__*/ (0, $fsvuC.createContext)($fe98743768aa744a$var$defaultUserControls);
function $fe98743768aa744a$export$87c54b525b914dab() {
    return (0, $fsvuC.useContext)($fe98743768aa744a$export$38ee920e59704589);
}

});

parcelRegister("cQUxy", function(module, exports) {
$parcel$export(module.exports, "useUniversalCreateBFFContext", () => $280a96c8b9d5a14d$export$1bb2b4064846aef2);
$parcel$export(module.exports, "UniversalCreateBFFProvider", () => $280a96c8b9d5a14d$export$afffe3cb36bf5e6e);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
const $280a96c8b9d5a14d$export$c037b66df971b916 = /*#__PURE__*/ (0, $fsvuC.createContext)({
    inFlightRequests: new Map(),
    setInFlightRequests: ()=>{}
});
function $280a96c8b9d5a14d$export$1bb2b4064846aef2() {
    return (0, $fsvuC.useContext)($280a96c8b9d5a14d$export$c037b66df971b916);
}
function $280a96c8b9d5a14d$export$afffe3cb36bf5e6e({ children: children }) {
    const inFlightRequestsRef = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useRef(new Map());
    const setInFlightRequests = (0, $fsvuC.useCallback)((requestKey, value)=>{
        inFlightRequestsRef.current.set(requestKey, value);
    }, []);
    const contextValue = (0, $fsvuC.useMemo)(()=>({
            inFlightRequests: inFlightRequestsRef.current,
            setInFlightRequests: setInFlightRequests
        }), [
        setInFlightRequests
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)($280a96c8b9d5a14d$export$c037b66df971b916.Provider, {
        value: contextValue,
        children: children
    });
}
$280a96c8b9d5a14d$export$afffe3cb36bf5e6e.displayName = "UniversalCreateBFFProvider";

});

parcelRegister("3q03G", function(module, exports) {
$parcel$export(module.exports, "NavigationUFOSegment", () => $cb5ce0e43453d21b$export$a546442f39c56898);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $jbwXy = parcelRequire("jbwXy");

var $4lK3D = parcelRequire("4lK3D");
function $cb5ce0e43453d21b$export$a546442f39c56898({ id: id, children: children }) {
    const experienceObj = (0, $4lK3D.NavigationExperienceId)[id];
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jbwXy.default), {
        name: experienceObj.experienceId,
        children: children
    });
}
$cb5ce0e43453d21b$export$a546442f39c56898.displayName = "NavigationUFOSegment";

});
parcelRegister("4lK3D", function(module, exports) {
$parcel$export(module.exports, "NavigationExperienceId", () => $10153a0fa918e65c$export$fe188b07687f765a);

var $8nBFK = parcelRequire("8nBFK");
const $10153a0fa918e65c$export$fe188b07687f765a = {
    goalCreate: {
        experienceId: 'uc-goal-create',
        config: {
            type: (0, $8nBFK.ExperienceTypes).Experience,
            performanceType: (0, $8nBFK.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    teamCreate: {
        experienceId: 'uc-team-create',
        config: {
            type: (0, $8nBFK.ExperienceTypes).Experience,
            performanceType: (0, $8nBFK.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    projectCreate: {
        experienceId: 'uc-project-create',
        config: {
            type: (0, $8nBFK.ExperienceTypes).Experience,
            performanceType: (0, $8nBFK.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    universalCreateComponentLoad: {
        experienceId: 'uc-component-load',
        config: {
            type: (0, $8nBFK.ExperienceTypes).Load,
            performanceType: (0, $8nBFK.ExperiencePerformanceTypes).PageSegmentLoad
        },
        instanceId: undefined
    },
    universalCreatePrefetch: {
        experienceId: 'uc-backend-prefetch',
        config: {
            type: (0, $8nBFK.ExperienceTypes).Operation,
            performanceType: (0, $8nBFK.ExperiencePerformanceTypes).Custom
        },
        instanceId: undefined
    },
    globalSideNavigationLoad: {
        experienceId: 'global-side-navigation-load',
        config: {
            type: (0, $8nBFK.ExperienceTypes).Load,
            performanceType: (0, $8nBFK.ExperiencePerformanceTypes).PageSegmentLoad
        },
        instanceId: undefined
    },
    customizationModalLoad: {
        experienceId: 'customization-modal-load',
        config: {
            type: (0, $8nBFK.ExperienceTypes).Load,
            performanceType: (0, $8nBFK.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    customizationModalUpdate: {
        experienceId: 'customization-modal-update',
        config: {
            type: (0, $8nBFK.ExperienceTypes).Experience,
            performanceType: (0, $8nBFK.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    globalMoreMenuLoad: {
        experienceId: 'global-more-menu-load',
        config: {
            type: (0, $8nBFK.ExperienceTypes).Load,
            performanceType: (0, $8nBFK.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    globalRootAppChromeLoad: {
        experienceId: 'global-root-app-chrome-load',
        config: {
            type: (0, $8nBFK.ExperienceTypes).Load,
            performanceType: (0, $8nBFK.ExperiencePerformanceTypes).PageSegmentLoad
        },
        instanceId: undefined
    }
};

});


parcelRegister("aLgA9", function(module, exports) {
$parcel$export(module.exports, "findSelectedItem", () => $f3b14750b112c072$export$5a8ab32aeea5694f);
$parcel$export(module.exports, "useIsResponsiveView", () => $f3b14750b112c072$export$2a50c0408cf3ddb8);
$parcel$export(module.exports, "omitSafely", () => $f3b14750b112c072$export$d6eadbd047ebd460);
$parcel$export(module.exports, "getCloudId", () => $f3b14750b112c072$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "getOrgId", () => $f3b14750b112c072$export$5a762450d50ca901);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $hMQGr = parcelRequire("hMQGr");

var $dElcB = parcelRequire("dElcB");

var $hEGZD = parcelRequire("hEGZD");
function $f3b14750b112c072$export$5a8ab32aeea5694f(sections, selectedItem) {
    for (const section of sections)// Only app-defined sections have items at definition time
    if (section.type === 'appDefinedSection') {
        for (const menuItem of section.items)// Check if item has ati property (both NativeMenuItem and CrossAppMenuItem have it)
        if ('ati' in menuItem && menuItem.ati.toString() === selectedItem.toString()) {
            // For cross-app items, we need to return null as they don't have onClick/loadCreateContent
            // Only native items can be "selected" in the traditional sense
            if ('onClick' in menuItem || 'loadCreateContent' in menuItem) return menuItem;
        }
    }
    return null;
}
function $f3b14750b112c072$export$911e33c48adcec1b(mixedItems) {
    return mixedItems.flatMap((namedItem)=>namedItem.items).map((menuItem)=>menuItem.ati.toString());
}
function $f3b14750b112c072$export$2a50c0408cf3ddb8() {
    const [isResponsiveMode, setIsResponsiveMode] = (0, $fsvuC.useState)(typeof window !== 'undefined' && window.innerWidth <= (0, $hEGZD.MOBILE_WIDTH_BREAKPOINT));
    const [handleResizeDebounced] = (0, $dElcB.default)(()=>{
        const isCurrentlyMobile = window.innerWidth <= (0, $hEGZD.MOBILE_WIDTH_BREAKPOINT);
        setIsResponsiveMode((prev)=>prev !== isCurrentlyMobile ? isCurrentlyMobile : prev);
    }, (0, $hEGZD.RESIZING_DEBOUNCED));
    (0, $fsvuC.useEffect)(()=>{
        const unbind = (0, $dqdTY.bindAll)(window, [
            {
                type: 'resize',
                listener: handleResizeDebounced
            }
        ]);
        return unbind;
    }, [
        handleResizeDebounced
    ]);
    return isResponsiveMode;
}
const $f3b14750b112c072$export$d6eadbd047ebd460 = (item, ...properties)=>(0, (/*@__PURE__*/$parcel$interopDefault($hMQGr)))(item, ...properties);
const $f3b14750b112c072$export$fdd2c0ba94025c3c = (contextConfig)=>contextConfig.enabled ? contextConfig.cloudId : '';
const $f3b14750b112c072$export$5a762450d50ca901 = (contextConfig)=>contextConfig.enabled ? contextConfig.orgId : undefined;

});

parcelRegister("5AnMP", function(module, exports) {
$parcel$export(module.exports, "AnalyticsWrapper", () => $e9e27d5121f26e95$export$63b55d605f8a2340);
/* AnalyticsWrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $c5gj6 = parcelRequire("c5gj6");
function $e9e27d5121f26e95$export$63b55d605f8a2340({ children: children }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $c5gj6.NavigationAnalyticsContext), {
        data: {
            source: 'topNav'
        },
        children: children
    });
}
$e9e27d5121f26e95$export$63b55d605f8a2340.displayName = "AnalyticsWrapper";

});

parcelRegister("7wMvV", function(module, exports) {
$parcel$export(module.exports, "EntryPointPopup", () => $c45cd96b3df3d912$export$8f8a5b7d7394d1f8);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $iNT4o = parcelRequire("iNT4o");

var $3NfiF = parcelRequire("3NfiF");

var $RG5NG = parcelRequire("RG5NG");

var $9lAcD = parcelRequire("9lAcD");

var $gWXcM = parcelRequire("gWXcM");

var $Wd0FJ = parcelRequire("Wd0FJ");

var $230VD = parcelRequire("230VD");

var $7Q0y6 = parcelRequire("7Q0y6");

var $6Zt46 = parcelRequire("6Zt46");

var $bdUph = parcelRequire("bdUph");

var $70oEW = parcelRequire("70oEW");
const $c45cd96b3df3d912$var$emptyEntryPointParams = {};
const $c45cd96b3df3d912$var$noop = ()=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {});
function $c45cd96b3df3d912$var$EntryPointPopupInner({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, isOpen: isOpen, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $Wd0FJ.useRelayEnvironmentProvider)();
    const { preventClose: preventClose, product: product, crossAppCreationConfig: crossAppCreationConfig } = (0, $230VD.useMenuStateContext)();
    const isPrefetchEnabled = crossAppCreationConfig.enabled && Boolean(crossAppCreationConfig.prefetch);
    const { triggerPrefetch: triggerPrefetch } = (0, $70oEW.usePrefetch)();
    const id = (0, $fsvuC.useMemo)(()=>entryPoint.root.getModuleName() || 'unknown', [
        entryPoint
    ]);
    const [content, setContent] = (0, $fsvuC.useState)(()=>$c45cd96b3df3d912$var$noop);
    const contentLoadedRef = (0, $fsvuC.useRef)(false);
    const handleClose = (0, $fsvuC.useCallback)((event, currentLevel)=>{
        if (product === 'confluence' && preventClose) return;
        onClose?.(event, currentLevel);
        setContent(()=>$c45cd96b3df3d912$var$noop);
        contentLoadedRef.current = false;
    }, [
        preventClose,
        product,
        onClose
    ]);
    // Compute effective isOpen state based on feature gate
    const isPopupOpen = isOpen ?? false;
    const triggerCloseRef = (0, $bdUph.useClickToCloseRef)({
        isOpen: isPopupOpen,
        handleClose: handleClose
    });
    const prevIsOpenRef = (0, $fsvuC.useRef)(isPopupOpen);
    const entryPointLoadTriggeredRef = (0, $fsvuC.useRef)(false);
    const { fireMenuStateChanged: fireMenuStateChanged, fireEntryPointLoadTriggered: fireEntryPointLoadTriggered } = (0, $7Q0y6.useUniversalCreateAnalytics)();
    (0, $fsvuC.useEffect)(function fireMenuStateChangedEffect() {
        const prevIsOpen = prevIsOpenRef.current;
        // Only fire analytics on actual state transitions (use displayed state)
        if (isPopupOpen !== prevIsOpen) fireMenuStateChanged({
            itemState: isPopupOpen ? 'expanded' : 'collapsed',
            version: 'v2'
        });
        prevIsOpenRef.current = isPopupOpen;
    }, [
        isPopupOpen,
        fireMenuStateChanged,
        prevIsOpenRef
    ]);
    const version = 'v2';
    // on hover callback
    const load = (0, $fsvuC.useCallback)((trigger = 'hover')=>{
        if (!entryPointLoadTriggeredRef.current) {
            entryPointLoadTriggeredRef.current = true;
            fireEntryPointLoadTriggered({
                trigger: trigger,
                version: version
            });
        }
        if (isPrefetchEnabled) triggerPrefetch();
        return (0, $iNT4o.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $c45cd96b3df3d912$var$emptyEntryPointParams);
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        fireEntryPointLoadTriggered,
        isPrefetchEnabled,
        triggerPrefetch,
        version
    ]);
    // on menu loaded callback
    const onLoad = (0, $fsvuC.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when already loaded
        if (contentLoadedRef.current) return;
        contentLoadedRef.current = true;
        setContent(()=>(contentProps)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $gWXcM.InternalEntryPointContainer), {
                    id: id,
                    entryPointReference: entryPointReference,
                    fallback: fallback || null,
                    errorFallback: errorFallback,
                    runtimeProps: {
                        entryPointProps: entryPointProps,
                        onClose: handleClose,
                        contentProps: contentProps
                    },
                    onError: onError,
                    forcedError: forcedReportErrorUFO
                }));
    }, [
        setContent,
        id,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        onError,
        handleClose
    ]);
    const triggerRef = (0, $9lAcD.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    // Primary button onLoad - preload but don't open popup
    const onLoadPrimary = (0, $fsvuC.useCallback)(()=>{
    // Primary button should only preload, NOT open the popup
    // The preloaded reference will be disposed automatically by usePressablePreloadRef
    // The actual click behavior is handled by primaryActionItem.onClick
    }, []);
    // Separate ref for the primary button with ONLY preload functionality (no popup opening)
    const primaryButtonRef = (0, $9lAcD.usePressablePreloadRef)({
        load: load,
        onLoad: onLoadPrimary
    });
    const popupTrigger = (0, $fsvuC.useCallback)((triggerProps)=>{
        const mergedRef = (0, $3NfiF.mergeRefs)([
            triggerRef,
            triggerProps.ref,
            triggerCloseRef
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef,
            splitButtonPrimaryRef: primaryButtonRef
        });
    }, [
        trigger,
        triggerRef,
        triggerCloseRef,
        primaryButtonRef
    ]);
    const popupContent = (0, $fsvuC.useCallback)((contentProps)=>content(contentProps), [
        content
    ]);
    // Track previous values to detect prop changes
    // Initialize as undefined to detect initial render with isOpen={true}
    const prevIsOpenPropRef = (0, $fsvuC.useRef)(undefined);
    (0, $fsvuC.useEffect)(function preloadWithControlledOpenState() {
        const isOpenPropChanged = isOpen !== prevIsOpenPropRef.current;
        prevIsOpenPropRef.current = isOpen;
        if (isOpen && isOpenPropChanged && !contentLoadedRef.current) {
            const triggerLoading = ()=>{
                const preloadedRef = load('controlled');
                if (preloadedRef) onLoad({
                    reference: preloadedRef
                });
            };
            const timeoutId = setTimeout(triggerLoading, 0);
            return ()=>clearTimeout(timeoutId);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $RG5NG.Popup), {
        ...popupProps,
        isOpen: isPopupOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}
$c45cd96b3df3d912$var$EntryPointPopupInner.displayName = "EntryPointPopupInner";
function $c45cd96b3df3d912$export$8f8a5b7d7394d1f8(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6Zt46.GenericErrorBoundary), {
        name: "entry-point-popup",
        children: /*#__PURE__*/ (0, $5chsV.jsx)($c45cd96b3df3d912$var$EntryPointPopupInner, {
            ...props
        })
    });
}
$c45cd96b3df3d912$export$8f8a5b7d7394d1f8.displayName = "EntryPointPopup";

});
parcelRegister("3NfiF", function(module, exports) {
$parcel$export(module.exports, "mergeRefs", () => $2c31d0f6c1edf0a0$export$c9058316764c140e);

var $hPdF1 = parcelRequire("hPdF1");

var $la77W = parcelRequire("la77W");
function $2c31d0f6c1edf0a0$export$c9058316764c140e(refs) {
    return (0, $la77W.createCallbackRef)(function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $hPdF1.assignRef)(ref, newValue);
        });
    });
}

});
parcelRegister("la77W", function(module, exports) {
$parcel$export(module.exports, "createCallbackRef", () => $f6800f6957dbae4f$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $f6800f6957dbae4f$export$35a19128eb4acba4(callback) {
    var current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            var last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});


parcelRegister("9lAcD", function(module, exports) {
$parcel$export(module.exports, "usePressablePreloadRef", () => $8f7267c279c0fc8d$export$1ff47f24e06a5d2d);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $llCao = parcelRequire("llCao");

var $kjqBn = parcelRequire("kjqBn");
const $8f7267c279c0fc8d$var$disabledTriggerSelector = ':disabled, [disabled], [aria-disabled="true"]';
function $8f7267c279c0fc8d$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad, loadOnFocus: loadOnFocus = false, preloadOnFocus: preloadOnFocus = false }) {
    const nodeRef = (0, $fsvuC.useRef)(null);
    const eventListeners = (0, $fsvuC.useRef)([]);
    const { preloadReference: preloadReference, cancelPreload: cancelPreload, eagerLoad: eagerLoad } = (0, $kjqBn.useEntryPointPreload)(load);
    const clickListener = (0, $fsvuC.useMemo)(()=>{
        return ()=>{
            if (nodeRef.current?.matches($8f7267c279c0fc8d$var$disabledTriggerSelector)) {
                cancelPreload();
                return;
            }
            if (onBeforeLoad) onBeforeLoad();
            onLoad(eagerLoad());
        };
    }, [
        cancelPreload,
        onBeforeLoad,
        onLoad,
        eagerLoad
    ]);
    const mouseDownListener = (0, $fsvuC.useMemo)(()=>{
        return ()=>{
            if (nodeRef.current?.matches($8f7267c279c0fc8d$var$disabledTriggerSelector)) {
                cancelPreload();
                return;
            }
            eagerLoad();
        };
    }, [
        cancelPreload,
        eagerLoad
    ]);
    const mouseEnterListener = (0, $fsvuC.useMemo)(()=>{
        return ()=>{
            if (nodeRef.current?.matches($8f7267c279c0fc8d$var$disabledTriggerSelector)) {
                cancelPreload();
                return;
            }
            preloadReference();
        };
    }, [
        cancelPreload,
        preloadReference
    ]);
    const focusListener = (0, $fsvuC.useCallback)(()=>{
        // focus() can emit trusted events when a popup or modal restores focus on close.
        // Only keyboard traversal expresses fresh focus-preload intent in that case.
        if ((0, $llCao.fg)('platform_dst-popup-trigger-dispose-on-close')) return;
        mouseEnterListener();
    }, [
        mouseEnterListener
    ]);
    const cleanUpEventListeners = (0, $fsvuC.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $fsvuC.useCallback)((element, type, callback)=>{
        const unbind = (0, $dqdTY.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $fsvuC.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'click', clickListener);
                addEventListener(element, 'mousedown', mouseDownListener);
                addEventListener(element, 'mouseenter', mouseEnterListener);
                addEventListener(element, 'mouseleave', cancelPreload);
                if (loadOnFocus) addEventListener(element, 'focusin', clickListener);
                else if (preloadOnFocus) {
                    addEventListener(element, 'focusin', focusListener);
                    addEventListener(element, 'focusout', cancelPreload);
                }
            }
            // Update the ref with the new element
            nodeRef.current = element;
        }
    }, [
        clickListener,
        mouseDownListener,
        mouseEnterListener,
        focusListener,
        cancelPreload,
        loadOnFocus,
        addEventListener,
        cleanUpEventListeners,
        preloadOnFocus
    ]);
    (0, $fsvuC.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}

});
parcelRegister("kjqBn", function(module, exports) {
$parcel$export(module.exports, "useEntryPointPreload", () => $d7f2b9f68f402e96$export$57effc2a5e3611f);

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");
const $d7f2b9f68f402e96$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $d7f2b9f68f402e96$var$TIME_TO_INTENT = 200;
function $d7f2b9f68f402e96$export$57effc2a5e3611f(load) {
    const actions = (0, $fsvuC.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $llCao.fg)('platform_relay_preload_ensure_max_age_disposal') === false) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
        };
        const cleanupPreload = ()=>{
            request.preload?.dispose();
            // Only remove the max age timeout when the component is cleaned up.
            if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $llCao.fg)('platform_relay_preload_ensure_max_age_disposal')) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const eagerLoad = ()=>{
            clearPreloadTimeouts();
            return loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $d7f2b9f68f402e96$var$PRELOAD_MAX_AGE);
            }, $d7f2b9f68f402e96$var$TIME_TO_INTENT);
        };
        return {
            preloadReference: preloadReference,
            cancelPreload: cancelPreload,
            cleanupPreload: cleanupPreload,
            eagerLoad: eagerLoad
        };
    }, [
        load
    ]);
    // Dispose preload and clear timeouts when component unmounts
    // or when `load` identity changes (new actions object created).
    (0, $fsvuC.useEffect)(()=>{
        return ()=>{
            actions.cleanupPreload();
        };
    }, [
        actions
    ]);
    return actions;
}

});


parcelRegister("gWXcM", function(module, exports) {
$parcel$export(module.exports, "InternalEntryPointContainer", () => $9c9b36213296d75b$export$5d4dc37edd8a3adb);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $jY9mG = parcelRequire("jY9mG");

var $iNT4o = parcelRequire("iNT4o");

var $9fczp = parcelRequire("9fczp");

var $1gXPF = parcelRequire("1gXPF");

var $4LXGz = parcelRequire("4LXGz");
function $9c9b36213296d75b$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $4LXGz.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $9fczp.useUFOReportError)();
    const onError = (0, $fsvuC.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $1gXPF.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: error?.message ?? 'Unknown error',
            errorStack: error?.stack ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $fsvuC.useCallback)(({ error: error })=>{
        const onClose = runtimeProps?.onClose ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jY9mG.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError,
        children: /*#__PURE__*/ (0, $5chsV.jsx)(PlaceholderComponent, {
            name: placeholderName ?? 'internal-internal-entry-point-container',
            fallback: fallback,
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $iNT4o.EntryPointContainer), {
                entryPointReference: entryPointReference,
                props: runtimeProps
            })
        })
    });
}
$9c9b36213296d75b$var$InternalEntryPointContainerInner.displayName = "InternalEntryPointContainerInner";
function $9c9b36213296d75b$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $4LXGz.useEntryPointConfig)();
    return /*#__PURE__*/ (0, $5chsV.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $5chsV.jsx)($9c9b36213296d75b$var$InternalEntryPointContainerInner, {
            ...props
        })
    });
}
$9c9b36213296d75b$export$5d4dc37edd8a3adb.displayName = "InternalEntryPointContainer";

});
parcelRegister("9fczp", function(module, exports) {
$parcel$export(module.exports, "useUFOReportError", () => $d003b54b2c95ef4f$export$75d40f522062f923);

var $dOQFV = parcelRequire("dOQFV");

var $8IAtM = parcelRequire("8IAtM");
function $d003b54b2c95ef4f$export$75d40f522062f923() {
    const ufoContext = (0, $dOQFV.useInteractionContext)();
    const reportError = (error)=>{
        const interaction = (0, $8IAtM.getActiveInteraction)();
        if (interaction?.id) (0, $8IAtM.addError)(interaction.id, error.name, ufoContext?.labelStack || null, error.name, error.errorMessage, error.errorStack, error.forcedError);
        else (0, $8IAtM.addErrorToAll)(error.name, ufoContext?.labelStack || null, error.name, error.errorMessage, error.errorStack);
    };
    return reportError;
}

});

parcelRegister("4LXGz", function(module, exports) {
$parcel$export(module.exports, "useEntryPointConfig", () => $f45e362899072a13$export$dfa96f26176fa91f);

var $iJhgW = parcelRequire("iJhgW");
function $f45e362899072a13$export$dfa96f26176fa91f() {
    return 0, $iJhgW.entryPointConfig;
}

});
parcelRegister("iJhgW", function(module, exports) {
$parcel$export(module.exports, "entryPointConfig", () => $843db1be0a260c48$export$ec2e992e3170c3c4);

var $rzbnb = parcelRequire("rzbnb");
const $843db1be0a260c48$export$ec2e992e3170c3c4 = (0, $rzbnb.defaultEntryPointConfig);

});
parcelRegister("rzbnb", function(module, exports) {
$parcel$export(module.exports, "defaultEntryPointConfig", () => $d9619ab926645f04$export$7ca620c75cbaadf0);

var $fsvuC = parcelRequire("fsvuC");

var $7Dmr2 = parcelRequire("7Dmr2");

var $jbwXy = parcelRequire("jbwXy");
const $d9619ab926645f04$var$GlobalModalErrorFallback = ({ closeModal: closeModal, fallback: fallback })=>{
    const hasFallback = fallback != null;
    (0, $fsvuC.useEffect)(()=>{
        if (!hasFallback) closeModal();
    }, [
        closeModal,
        hasFallback
    ]);
    return fallback ?? null;
};
const $d9619ab926645f04$export$7ca620c75cbaadf0 = {
    PlaceholderComponent: (0, $7Dmr2.default),
    UFOSegmentComponent: (0, $jbwXy.default),
    GlobalModalErrorFallback: $d9619ab926645f04$var$GlobalModalErrorFallback
};

});
parcelRegister("7Dmr2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a0cf7e64c10023c$export$2e2bcd8739ae039);

var $4cPcM = parcelRequire("4cPcM");
var $5a0cf7e64c10023c$export$2e2bcd8739ae039 = (0, $4cPcM.default);

});
parcelRegister("4cPcM", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d26286c227e1e73$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $bGnNF = parcelRequire("bGnNF");

var $8cTOu = parcelRequire("8cTOu");

var $96c2C = parcelRequire("96c2C");
function $5d26286c227e1e73$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback = null }) {
    const waitContext = (0, $fsvuC.useContext)((0, $96c2C.WaitContext));
    const shouldHold = !waitContext || !!waitContext.currentValue();
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $8cTOu.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5chsV.Fragment), {
            children: [
                fallback,
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $bGnNF.default), {
                    name: name,
                    hold: shouldHold
                })
            ]
        }),
        name: name,
        children: children
    });
}
$5d26286c227e1e73$export$2e2bcd8739ae039.displayName = "Placeholder";

});
parcelRegister("8cTOu", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $40077ac70a41e4db$export$256c542058532d6f);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
const $40077ac70a41e4db$var$isNodeEnvironment = ()=>{
    return typeof window === 'undefined' || window.name === 'nodejs';
};
const $40077ac70a41e4db$var$LazySuspenseContext = /*#__PURE__*/ (0, $fsvuC.createContext)({
    fallback: /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Fragment), {}),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    },
    name: ''
});
const $40077ac70a41e4db$var$DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useContext($40077ac70a41e4db$var$LazySuspenseContext);
    (0, $fsvuC.useLayoutEffect)(()=>{
        return ()=>{
            if (!outsideSuspense) setFallback(null);
        };
    }, [
        outsideSuspense,
        setFallback
    ]);
    return children(outsideSuspense ? null : fallback);
};
$40077ac70a41e4db$var$DynamicFallback.displayName = "DynamicFallback";
$40077ac70a41e4db$var$DynamicFallback.displayName = 'DynamicFallback';
const $40077ac70a41e4db$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
    const [hydrationFallback, setHydrationFallback] = (0, $fsvuC.useState)(null);
    const mountedRef = (0, $fsvuC.useRef)(false);
    (0, $fsvuC.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const contextValue = (0, $fsvuC.useMemo)(()=>({
            fallback: fallback,
            setFallback: (newFallback)=>{
                if (hydrationFallback === newFallback) return;
                setHydrationFallback(newFallback);
            },
            name: name
        }), [
        fallback,
        hydrationFallback,
        name
    ]);
    const renderFallback = (outsideSuspense)=>/*#__PURE__*/ (0, $5chsV.jsx)($40077ac70a41e4db$var$DynamicFallback, {
            outsideSuspense: outsideSuspense,
            children: (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback
        });
    return /*#__PURE__*/ (0, $5chsV.jsx)($40077ac70a41e4db$var$LazySuspenseContext.Provider, {
        value: contextValue,
        children: $40077ac70a41e4db$var$isNodeEnvironment() ? children : /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5chsV.Fragment), {
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Suspense), {
                    fallback: renderFallback(false),
                    children: children
                }),
                (!mountedRef.current || hydrationFallback) && renderFallback(true)
            ]
        })
    });
};
$40077ac70a41e4db$export$256c542058532d6f.displayName = "LazySuspense";
$40077ac70a41e4db$export$256c542058532d6f.displayName = 'LazySuspense';

});

parcelRegister("96c2C", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $cddd015c64cabc56$export$9ba3fe09d15de47b);

var $fsvuC = parcelRequire("fsvuC");
const $cddd015c64cabc56$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $fsvuC.createContext)({
    subscribe: ()=>()=>{},
    currentValue: ()=>1
});

});







parcelRegister("7Q0y6", function(module, exports) {
$parcel$export(module.exports, "useUniversalCreateAnalytics", () => $db39fbede95ea17e$export$eebe354ebe67c94c);

var $fsvuC = parcelRequire("fsvuC");

var $mhEfz = parcelRequire("mhEfz");

var $llCao = parcelRequire("llCao");

var $5uwXq = parcelRequire("5uwXq");

var $230VD = parcelRequire("230VD");
function $db39fbede95ea17e$export$eebe354ebe67c94c() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    const { growthRecommendationsSessionId: growthRecommendationsSessionId, product: product, subProduct: subProduct } = (0, $230VD.useUniversalCreateState)();
    // Provide fallback for product if undefined
    const safeProduct = product || 'unknown';
    const includeGrowthSessionInAnalytics = (0, $llCao.fg)('navx-3810-re-instrument-growth-session-id');
    const baseAttributes = (0, $fsvuC.useMemo)(()=>({
            navLayer: (0, $5uwXq.NAV_LAYER),
            navContainer: (0, $5uwXq.NAV_CONTAINER),
            navVersion: (0, $5uwXq.NAV_VERSION),
            product: safeProduct,
            subProduct: subProduct,
            ...includeGrowthSessionInAnalytics && growthRecommendationsSessionId !== undefined && {
                recommendationSessionId: growthRecommendationsSessionId
            }
        }), [
        growthRecommendationsSessionId,
        includeGrowthSessionInAnalytics,
        safeProduct,
        subProduct
    ]);
    const topLevelAttributes = (0, $fsvuC.useMemo)(()=>({
            actionSubject: 'universalCreate',
            eventType: 'ui',
            source: (0, $5uwXq.ANALYTICS_SOURCE),
            tags: [
                (0, $5uwXq.ANALYTICS_TAG)
            ]
        }), []);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88038
    const fireCreateButtonClicked = (0, $fsvuC.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireCreateButtonViewed = (0, $fsvuC.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireCreateButtonHovered = (0, $fsvuC.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'hovered',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireEntryPointLoadTriggered = (0, $fsvuC.useCallback)((attributes)=>{
        createAnalyticsEvent({
            actionSubject: 'universalCreateEntryPointLoad',
            action: 'triggered',
            eventType: 'track',
            source: (0, $5uwXq.ANALYTICS_SOURCE),
            tags: [
                (0, $5uwXq.ANALYTICS_TAG)
            ],
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88332
    const fireNativeMenuItemClicked = (0, $fsvuC.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateNativeMenuItem',
            attributes: {
                group: 'native',
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88486
    const fireSuggestionsMenuItemClicked = (0, $fsvuC.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateSuggestionsMenuItem',
            attributes: {
                group: 'suggestions',
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88295
    const fireMenuItemClicked = (0, $fsvuC.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateMenuItem',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88599
    const fireNativeMenuViewed = (0, $fsvuC.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateNativeMenu',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88724
    const fireSuggestionsMenuViewed = (0, $fsvuC.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateSuggestionsMenu',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92169
    const fireMenuItemsViewed = (0, $fsvuC.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateMenuSection',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/100116
    const fireMenuContentClosed = (0, $fsvuC.useCallback)(()=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'closed',
            actionSubjectId: 'universalCreateMenuContent',
            attributes: {
                ...baseAttributes
            }
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/89698
    const fireMenuStateChanged = (0, $fsvuC.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'changed',
            actionSubjectId: 'universalCreateMenuState',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        baseAttributes
    ]);
    // createModal viewed Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90539
    // createModalBackButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90540
    // createModalCancelButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90541
    // createModalCreateButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90542
    const fireFormControlAttributes = (0, $fsvuC.useCallback)(({ actionSubjectId: actionSubjectId, action: action = 'clicked', ...attributes })=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            actionSubject: 'universalCreate',
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92730
    const fireShowMoreButtonClicked = (0, $fsvuC.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateShowMoreButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/96626
    const fireJSChunkLoadTime = (0, $fsvuC.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'loaded',
            actionSubject: 'universalCreateJSChunkLoad',
            actionSubjectId: 'universalCreateJSChunkLoad',
            eventType: 'operational',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    return {
        fireCreateButtonClicked: fireCreateButtonClicked,
        fireCreateButtonHovered: fireCreateButtonHovered,
        fireCreateButtonViewed: fireCreateButtonViewed,
        fireEntryPointLoadTriggered: fireEntryPointLoadTriggered,
        fireNativeMenuItemClicked: fireNativeMenuItemClicked,
        fireSuggestionsMenuItemClicked: fireSuggestionsMenuItemClicked,
        fireMenuItemClicked: fireMenuItemClicked,
        fireNativeMenuViewed: fireNativeMenuViewed,
        fireSuggestionsMenuViewed: fireSuggestionsMenuViewed,
        fireMenuItemsViewed: fireMenuItemsViewed,
        fireMenuContentClosed: fireMenuContentClosed,
        fireMenuStateChanged: fireMenuStateChanged,
        fireFormControlAttributes: fireFormControlAttributes,
        fireShowMoreButtonClicked: fireShowMoreButtonClicked,
        fireJSChunkLoadTime: fireJSChunkLoadTime
    };
}

});
parcelRegister("5uwXq", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $d1d1dc729c490d5a$export$85183a312807388d);
$parcel$export(module.exports, "ANALYTICS_TAG", () => $d1d1dc729c490d5a$export$1f0ede2864ffece6);
$parcel$export(module.exports, "NAV_LAYER", () => $d1d1dc729c490d5a$export$40fae459cb78b698);
$parcel$export(module.exports, "NAV_CONTAINER", () => $d1d1dc729c490d5a$export$2ee98aa1b18a8f41);
$parcel$export(module.exports, "NAV_VERSION", () => $d1d1dc729c490d5a$export$b4ed8a331b8fd4cc);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $d1d1dc729c490d5a$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "ATI_PRESETS", () => $d1d1dc729c490d5a$export$c091fab9d8f83000);
const $d1d1dc729c490d5a$export$85183a312807388d = 'navigation';
const $d1d1dc729c490d5a$export$1f0ede2864ffece6 = 'navigationExperiences';
const $d1d1dc729c490d5a$export$40fae459cb78b698 = 'global';
const $d1d1dc729c490d5a$export$2ee98aa1b18a8f41 = 'top';
const $d1d1dc729c490d5a$export$b4ed8a331b8fd4cc = 4;
const $d1d1dc729c490d5a$export$f7109619a5e9e0d6 = 'topNav';
const $d1d1dc729c490d5a$export$c091fab9d8f83000 = {
    PAGE: 'ati:cloud:confluence:page',
    WHITEBOARD: 'ati:cloud:confluence:whiteboard',
    GOAL: 'ati:cloud:townsquare:goal',
    WORK_ITEM: 'ati:cloud:jira:issue',
    LOOM: 'ati:cloud:loom:video',
    PROJECT: 'ati:cloud:townsquare:project',
    TEAM: 'ati:cloud:townsquare:team',
    TRELLO_BOARD: 'ati:cloud:trello:board'
};
const $d1d1dc729c490d5a$export$9449803ae25a1ccd = $d1d1dc729c490d5a$export$c091fab9d8f83000.LOOM;

});


parcelRegister("bdUph", function(module, exports) {
$parcel$export(module.exports, "useClickToCloseRef", () => $7f7447847aa6d41c$export$46ec6629f411921d);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");
function $7f7447847aa6d41c$export$46ec6629f411921d({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const unbind = (0, $dqdTY.bind)(el, {
            type: 'click',
            listener: (e)=>{
                if (isOpen) {
                    e.stopPropagation();
                    handleClose(e);
                }
            }
        });
        return unbind;
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
}

});

parcelRegister("70oEW", function(module, exports) {
$parcel$export(module.exports, "usePrefetch", () => $739d24276a214125$export$4dcd17e50290e364);

var $fsvuC = parcelRequire("fsvuC");

var $oAzkD = parcelRequire("oAzkD");

var $fChM0 = parcelRequire("fChM0");

var $230VD = parcelRequire("230VD");

var $6KuCP = parcelRequire("6KuCP");

var $8rkif = parcelRequire("8rkif");

var $5Z4Gr = parcelRequire("5Z4Gr");
function $739d24276a214125$export$4dcd17e50290e364() {
    const { sections: sections, product: product, subProduct: subProduct, crossAppCreationConfig: crossAppCreationConfig } = (0, $230VD.useMenuStateContext)();
    const { locale: locale } = (0, $oAzkD.default)();
    const shouldSkip = !crossAppCreationConfig.enabled;
    const shouldFetchData = !shouldSkip && crossAppCreationConfig.enabled && crossAppCreationConfig.prefetch === true;
    const { triggerPrefetch: triggerPrefetchLoom } = (0, $5Z4Gr.usePrefetchLoom)();
    const appMenuConfig = (0, $fsvuC.useMemo)(()=>(0, $6KuCP.sectionsToAppMenuConfig)(sections), [
        sections
    ]);
    const { fetchUserIfNeeded: fetchUserIfNeeded } = (0, $8rkif.useFetchUser)();
    /**
	 * Fetching menu items
	 */ const { data: data, fetchUCMenuItems: fetchUCMenuItems } = (0, $fChM0.useUCMenuItems)({
        cloudId: crossAppCreationConfig.enabled ? crossAppCreationConfig.cloudId : '',
        orgId: crossAppCreationConfig.enabled ? crossAppCreationConfig.orgId : '',
        userId: crossAppCreationConfig.enabled ? crossAppCreationConfig.accountId : '',
        product: product,
        locale: locale,
        subProduct: subProduct,
        appMenuConfig: appMenuConfig,
        skipInitialization: !shouldFetchData
    });
    const prefetchTriggered = (0, $fsvuC.useRef)(false);
    const userFetchTriggered = (0, $fsvuC.useRef)(false);
    const triggerPrefetch = (0, $fsvuC.useCallback)(()=>{
        if (prefetchTriggered.current || !shouldFetchData) return;
        prefetchTriggered.current = true;
        triggerPrefetchLoom();
        fetchUCMenuItems();
    }, [
        shouldFetchData,
        fetchUCMenuItems,
        triggerPrefetchLoom
    ]);
    // Reactively fetch user data when sections become available
    (0, $fsvuC.useEffect)(function fetchUserWhenDataReady() {
        if (!shouldFetchData || !data?.sections || userFetchTriggered.current) return;
        userFetchTriggered.current = true;
        fetchUserIfNeeded({
            sections: data.sections
        });
    }, [
        shouldFetchData,
        data?.sections,
        fetchUserIfNeeded
    ]);
    return {
        triggerPrefetch: triggerPrefetch
    };
}

});
parcelRegister("fChM0", function(module, exports) {
$parcel$export(module.exports, "useUCMenuItems", () => $e834e9fbde0ef41a$export$23f37315094bc4d3);
// ===============================
// UC Menu Items V2 API Communication
// ===============================

var $fsvuC = parcelRequire("fsvuC");

var $bcirB = parcelRequire("bcirB");

var $j2RAC = parcelRequire("j2RAC");

var $66O7R = parcelRequire("66O7R");

var $2VRdp = parcelRequire("2VRdp");

var $cl0SH = parcelRequire("cl0SH");

var $960kA = parcelRequire("960kA");

var $cQUxy = parcelRequire("cQUxy");

var $6osoX = parcelRequire("6osoX");

var $aJIsV = parcelRequire("aJIsV");

var $9rBrz = parcelRequire("9rBrz");

var $jWQIc = parcelRequire("jWQIc");
function $e834e9fbde0ef41a$export$23f37315094bc4d3({ cloudId: cloudId, orgId: orgId, product: product, userId: userId, locale: locale, subProduct: subProduct, appMenuConfig: appMenuConfig, skipInitialization: skipInitialization = false }) {
    const { value: value, currentLoadingRequests: currentLoadingRequests } = (0, $960kA.useBFFContext)();
    const boundaryConfig = (0, $fsvuC.useMemo)(()=>({
            location: 'useUCMenuItems',
            disableSentry: false,
            disableAnalytics: true,
            sentryConfig: {
                product: product
            },
            interactionId: 'universalCreatePrefetch',
            tags: {
                component: 'universal-create',
                subProduct: subProduct
            }
        }), [
        product,
        subProduct
    ]);
    const { handleError: handleError } = (0, $j2RAC.useNavBoundaryContext)(boundaryConfig);
    const { inFlightRequests: inFlightRequests, setInFlightRequests: setInFlightRequests } = (0, $cQUxy.useUniversalCreateBFFContext)();
    const { setStatus: setStatus } = (0, $9rBrz.useStatus)();
    const [data, setData] = (0, $fsvuC.useState)(undefined);
    const [hasError, setHasError] = (0, $fsvuC.useState)(false);
    const { buildUCMenuItemsURL: buildUCMenuItemsURL } = (0, $jWQIc.useURLBuilder)({
        cloudId: cloudId
    });
    const requestIdRef = (0, $fsvuC.useRef)(0);
    /**
	 * Helper functions for feature gated inflight request tracking
	 */ const isRequestInflight = (0, $fsvuC.useCallback)((requestKey)=>{
        return inFlightRequests.has(requestKey);
    }, [
        inFlightRequests
    ]);
    const setRequestInFlight = (0, $fsvuC.useCallback)((requestKey, value)=>{
        return setInFlightRequests(requestKey, value);
    }, [
        setInFlightRequests
    ]);
    const clearInFlightRequest = (0, $fsvuC.useCallback)((requestKey)=>{
        return inFlightRequests.delete(requestKey);
    }, [
        inFlightRequests
    ]);
    // Encode the config to get binary parameters
    const encodedConfig = (0, $fsvuC.useMemo)(()=>{
        if (skipInitialization) return null;
        try {
            return (0, $2VRdp.encodeConfig)(appMenuConfig);
        } catch  {
            // If encoding fails, we'll handle it in the fetch
            return null;
        }
    }, [
        appMenuConfig,
        skipInitialization
    ]);
    // Generate cache key based on encoded config and metadata
    const { cachedObject: cachedObject, setCachedObject: setCachedObject } = (0, $aJIsV.useGenericCache)({
        cloudId: cloudId,
        productType: product,
        orgId: orgId,
        accountId: userId,
        subProduct: subProduct,
        locale: locale,
        // Include encoded config in cache key to ensure different configs get different cache entries
        ...encodedConfig && {
            encodedConfigD: encodedConfig.d
        }
    });
    // Set data from cache on mount if available
    if (cachedObject && !data) {
        setData(cachedObject);
        setHasError(false);
    }
    const fetchUCMenuItems = (0, $fsvuC.useCallback)(async ()=>{
        // Early exit: filter out invalid param requests when required identifiers are missing or skip initialization if requested
        if (!cloudId || !orgId || skipInitialization) return;
        // Early exit: if encoding failed
        if (!encodedConfig) {
            setHasError(true);
            setStatus((0, $cl0SH.RequestStatus).ERROR, (0, $cl0SH.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            return;
        }
        // Return cached data if available (already locale-scoped via cache key)
        if (cachedObject) {
            setStatus((0, $cl0SH.RequestStatus).COMPLETE, (0, $cl0SH.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            return cachedObject;
        }
        // Generate request key to prevent duplicate concurrent requests
        const requestKey = `${product}|${orgId}|${userId}|${locale}|${subProduct}|${encodedConfig.d}`;
        // Skip if an identical request is already in flight
        if (isRequestInflight(requestKey)) return;
        // Increment request id for race protection
        requestIdRef.current += 1;
        const scopedId = requestIdRef.current;
        // Create and start experience tracker only when actually making request
        const experience = (0, $66O7R.createExperienceTracker)('universalCreatePrefetch');
        experience?.start();
        try {
            const url = buildUCMenuItemsURL({
                product: product,
                orgId: orgId,
                userId: userId,
                locale: locale,
                subProduct: subProduct,
                d: encodedConfig.d,
                ro: encodedConfig.ro,
                rt: encodedConfig.rt,
                ap: encodedConfig.ap
            });
            setStatus((0, $cl0SH.RequestStatus).LOADING, (0, $cl0SH.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            // Mark request key as in-flight before fetch fires to prevent race conditions
            setRequestInFlight(requestKey, true);
            const response = await (0, $6osoX.fetchJSON)(url, {});
            // Ignore if this response is for a stale request
            if (scopedId !== requestIdRef.current) {
                // Clear in-flight key if this was the request that set it
                if (isRequestInflight(requestKey)) clearInFlightRequest(requestKey);
                return;
            }
            if (response.status === (0, $cl0SH.RequestStatus).ERROR) {
                experience?.failure();
                setHasError(true);
                setData(undefined);
                setStatus((0, $cl0SH.RequestStatus).ERROR, (0, $cl0SH.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
                // Clear in-flight key on error
                clearInFlightRequest(requestKey);
                handleError(new (0, $bcirB.BFFNetworkError)('Failed to fetch universal create menu items', {
                    url: url,
                    // forward the real HTTP status (e.g. "401", "500") so Sentry
                    // noise suppression and dashboards can classify the BE failure. Falls back
                    // to RequestStatus.ERROR for network-level failures with no response.
                    status: typeof response.httpStatus === 'number' ? String(response.httpStatus) : response.status,
                    originalError: response.error,
                    additionalContext: {
                        requestKey: requestKey
                    }
                }));
                return;
            }
            if (response.status === (0, $cl0SH.RequestStatus).COMPLETE && response.data) {
                experience?.success();
                setData(response.data);
                setHasError(false);
                // Only cache if the data is not partial
                if (!response.data.isPartial) setCachedObject(response.data);
                setStatus((0, $cl0SH.RequestStatus).COMPLETE, (0, $cl0SH.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
                // Clear in-flight key on success
                clearInFlightRequest(requestKey);
                return response.data;
            }
        } catch (error) {
            experience?.failure();
            if (scopedId === requestIdRef.current) {
                setHasError(true);
                setData(undefined);
                setStatus((0, $cl0SH.RequestStatus).ERROR, (0, $cl0SH.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            }
            // Clear in-flight key on exception
            clearInFlightRequest(requestKey);
            handleError(new (0, $bcirB.BFFError)('Error occurred during fetchUCMenuItems', {
                status: (0, $cl0SH.RequestStatus).ERROR,
                originalError: error,
                additionalContext: {
                    requestKey: requestKey
                }
            }));
        }
        return;
    }, [
        cloudId,
        orgId,
        skipInitialization,
        encodedConfig,
        cachedObject,
        product,
        userId,
        locale,
        subProduct,
        isRequestInflight,
        setStatus,
        buildUCMenuItemsURL,
        setRequestInFlight,
        clearInFlightRequest,
        handleError,
        setCachedObject
    ]);
    const isLoading = (0, $fsvuC.useMemo)(()=>{
        if (skipInitialization) return false;
        // We check if the current loading requests include UC menu items rather than the BFF status directly
        // to ensure that it only returns true for UC menu items and not other BFF requests.
        const isBffLoadingOurStuff = currentLoadingRequests?.includes((0, $cl0SH.UC_MENU_ITEMS_REQUEST_STATUS_KEY)) ?? false;
        // That said, if the BFF is in loading state but data has been returned, we want to wait for things to complete
        // before running things like onResultChange, so that we don't do those things an unnecessary extra time
        // during the brief moment when data is present but loading is still true, or an error has occurred and loading is still true.
        const hasMenuItemDataBeenReturned = data !== undefined || hasError;
        return isBffLoadingOurStuff && !hasMenuItemDataBeenReturned;
    }, [
        currentLoadingRequests,
        data,
        hasError,
        skipInitialization
    ]);
    return {
        data: data,
        isLoading: isLoading,
        hasError: hasError,
        status: value.status,
        fetchUCMenuItems: fetchUCMenuItems
    };
}

});
parcelRegister("66O7R", function(module, exports) {
$parcel$export(module.exports, "useExperienceTracker", () => $f13f5d84208067fb$export$cdefb2a8b53f879f);
$parcel$export(module.exports, "createExperienceTracker", () => $f13f5d84208067fb$export$15f9dc99109fec75);

var $fsvuC = parcelRequire("fsvuC");

var $8YRrB = parcelRequire("8YRrB");

var $humA9 = parcelRequire("humA9");

var $4lK3D = parcelRequire("4lK3D");
function $f13f5d84208067fb$var$useUFOExperience(id, config, instanceId) {
    return (0, $fsvuC.useMemo)(()=>new (0, $8YRrB.UFOExperience)(id, config, instanceId), [
        id,
        config,
        instanceId
    ]);
}
function $f13f5d84208067fb$export$cdefb2a8b53f879f(key) {
    const experienceObj = (0, $4lK3D.NavigationExperienceId)[key];
    const experience = $f13f5d84208067fb$var$useUFOExperience(experienceObj.experienceId, experienceObj.config, experienceObj.instanceId);
    (0, $humA9.useUFOComponentExperience)(experience); // this hook starts the experience and aborts it when the component is unmounted
    return experience;
}
function $f13f5d84208067fb$export$15f9dc99109fec75(key) {
    const experienceObj = (0, $4lK3D.NavigationExperienceId)[key];
    return new (0, $8YRrB.UFOExperience)(experienceObj.experienceId, experienceObj.config, experienceObj.instanceId);
}

});
parcelRegister("humA9", function(module, exports) {
$parcel$export(module.exports, "useUFOComponentExperience", () => $d194ccdb13668fa2$export$30ab340faaed55d4);

var $fsvuC = parcelRequire("fsvuC");
const $d194ccdb13668fa2$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $fsvuC.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $d194ccdb13668fa2$export$30ab340faaed55d4 = (experience)=>{
    (0, $fsvuC.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $d194ccdb13668fa2$var$useConstructor(()=>experience.start());
    return null;
};

});


parcelRegister("2VRdp", function(module, exports) {
$parcel$export(module.exports, "encodeConfig", () => $d031ac9202c8e26f$export$1282978798683232);
/**
 * Encode configuration to binary format with query parameters
 */ 
var $31gea = parcelRequire("31gea");

var $3f0uf = parcelRequire("3f0uf");

var $dIxag = parcelRequire("dIxag");
// =============================================================================
// Configuration Validation
// =============================================================================
const $d031ac9202c8e26f$var$MAX_SECTIONS = 15;
function $d031ac9202c8e26f$var$validateConfig(config) {
    if (!config || typeof config !== 'object') throw new Error('Config must be an object');
    if (!Array.isArray(config.appMenuConfig)) throw new Error('Config sections must be an array');
    if (config.appMenuConfig.length === 0) throw new Error('Cannot encode empty sections array');
    if (config.appMenuConfig.length > $d031ac9202c8e26f$var$MAX_SECTIONS) throw new Error(`Too many sections (max ${$d031ac9202c8e26f$var$MAX_SECTIONS})`);
}
// =============================================================================
// ATI Encoding
// =============================================================================
/**
 * Encode a single ATI string to 3-byte binary format, then Base64URL
 *
 * @param ati - ATI string to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Base64URL-encoded ATI (4 characters)
 */ function $d031ac9202c8e26f$var$encodeATIToBase64(ati, unknowns) {
    const encoded = (0, $31gea.ariStr2Bin)(ati, unknowns);
    const buffer = new Uint8Array(3);
    (0, $31gea.writeEncodedATI)({
        encoded: encoded,
        buffer: buffer,
        offset: 0
    });
    return (0, $3f0uf.encodeBase64Url)(buffer);
}
/**
 * Encode a list of ATI strings to comma-separated Base64URL format
 *
 * @param atiList - Array of ATI strings (optional)
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Comma-separated Base64URL-encoded ATIs, or empty string if no ATIs
 */ function $d031ac9202c8e26f$var$encodeATIList(atiList, unknowns) {
    if (!atiList || atiList.length === 0) return '';
    return atiList.map((ati)=>$d031ac9202c8e26f$var$encodeATIToBase64(ati, unknowns)).join(',');
}
// =============================================================================
// Encoding Utilities
// =============================================================================
/**
 * Join array parts with hierarchical delimiter, truncating trailing empty/undefined values
 *
 * This utility implements a common pattern across encoding functions:
 * 1. Construct an array with known data
 * 2. Truncate array at last non-empty item
 * 3. Join array as string with delimiter at specified hierarchy level
 *
 * @param parts - Array of values to join (string | number | undefined)
 * @param delimiterLevel - Hierarchy level of delimiter to use (0=~, 1=|, 2=,, 3=:)
 * @returns Joined string with trailing empties removed
 *
 * @example
 * joinWithTruncation(['a', 'b', ''], 3) // 'a:b' (level 3 = ':')
 * joinWithTruncation(['a', '', ''], 2) // 'a' (level 2 = ',')
 * joinWithTruncation([1, 2, undefined], 1) // '1|2' (level 1 = '|')
 */ function $d031ac9202c8e26f$var$joinWithTruncation(parts, delimiterLevel) {
    // When delimiter level is out of bounds, default to '~'
    const delimiter = (0, $dIxag.DELIMITERS)[delimiterLevel] ?? '~';
    // Find last index where value is not empty string or undefined
    let lastIndex = parts.length - 1;
    while(lastIndex >= 0 && (parts[lastIndex] === '' || parts[lastIndex] === undefined))lastIndex--;
    // Slice to last non-empty index + 1, convert all to string, and join
    return parts.slice(0, lastIndex + 1).map(String).join(delimiter);
}
// =============================================================================
// Menu Item Encoding
// =============================================================================
const $d031ac9202c8e26f$var$PROMOTED_FLAG = '1';
/**
 * Encode a single menu item
 *
 * Format: atiBase64:itemType[:promoted]
 * - The promoted flag is only included when true
 *
 * @param item - Menu item to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded menu item string
 * @throws Error if item type is unknown
 */ function $d031ac9202c8e26f$var$encodeMenuItem(item, unknowns) {
    // Note: order of fields is important, do not change it without updating the decode function
    const typeCode = item.type !== undefined ? $d031ac9202c8e26f$var$getCodeByType(item) : undefined;
    const atiBase64 = $d031ac9202c8e26f$var$encodeATIToBase64(item.ati, unknowns);
    const isPromoted = item.promoted === true;
    const promotedFlag = isPromoted ? $d031ac9202c8e26f$var$PROMOTED_FLAG : undefined;
    return $d031ac9202c8e26f$var$joinWithTruncation([
        atiBase64,
        typeCode,
        promotedFlag
    ], 3); // Level 3: ':' (item properties)
}
/**
 * Get the numeric type code for a menu item
 *
 * @param item - Menu item
 * @returns Numeric type code
 * @throws Error if item type is unknown or undefined
 */ function $d031ac9202c8e26f$var$getCodeByType(item) {
    // If go down the path of getting code, type should not be undefined
    if (item.type === undefined) throw new Error('Item type is undefined');
    const typeCode = (0, $dIxag.MENU_ITEM_TYPE_MAP)[item.type];
    if (typeCode === undefined) throw new Error(`Unknown item type: ${item.type}`);
    return typeCode;
}
/**
 * Get the numeric code for a menu section
 *
 * @param sectionType - Section type MenuSection['type']
 * @returns String type code number
 */ function $d031ac9202c8e26f$var$sectionTypeToCode(sectionType) {
    const typeCode = (0, $dIxag.SECTION_TYPE_MAP)[sectionType];
    if (typeCode === undefined) throw new Error(`Unknown section type: ${String(sectionType)}`);
    return typeCode;
}
// =============================================================================
// Section Encoding
// =============================================================================
/**
 * Get the numeric code for a personalize mode
 *
 * @param mode - Personalize mode
 * @returns Numeric code for the mode
 * @throws Error if mode is unknown
 */ function $d031ac9202c8e26f$var$personalizeCodeByMode(mode) {
    const code = (0, $dIxag.PERSONALIZE_MODE_MAP)[mode];
    if (code === undefined) throw new Error(`Unknown personalize mode: ${mode}`);
    return code;
}
/**
 * Encode an overflow threshold
 *
 * @param overflowThreshold - Overflow threshold
 * @returns Encoded overflow threshold string
 */ function $d031ac9202c8e26f$var$encodeOverflowThreshold(overflowThreshold) {
    if (overflowThreshold < 0) throw new Error('Overflow threshold must be positive');
    return overflowThreshold.toString();
}
/**
 * Encode an app-defined section
 *
 * Format: 0|item1,item2,...|personalizeCode
 * - Trailing default values are truncated (personalize='0' / 'off' can be omitted)
 * - personalizeCode: 0=off, 1=full, 2=overflow
 *
 * @private
 * @param section - App-defined section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 */ function $d031ac9202c8e26f$var$encodeAppDefinedSection(section, unknowns) {
    // Note: order of fields is important, do not change it without updating the decode function
    const sectionType = $d031ac9202c8e26f$var$sectionTypeToCode('appDefinedSection');
    const encodedItems = section.items.map((item)=>$d031ac9202c8e26f$var$encodeMenuItem(item, unknowns)).join(',');
    const personalizeCode = section.personalize && section.personalize !== 'off' ? $d031ac9202c8e26f$var$personalizeCodeByMode(section.personalize) : undefined;
    const overflowThreshold = personalizeCode !== undefined && section.personalize === 'overflow' && section.overflowThreshold !== undefined ? $d031ac9202c8e26f$var$encodeOverflowThreshold(section.overflowThreshold) : undefined;
    return $d031ac9202c8e26f$var$joinWithTruncation([
        sectionType,
        encodedItems,
        personalizeCode,
        overflowThreshold
    ], 1); // Level 1: '|' (section fields)
}
/**
 * Encode a suggestion section
 *
 * Format: 1|limit|excludeAti1,excludeAti2,...|preferredAti1,preferredAti2,...
 * - Trailing empty values are truncated (empty excludeAtis/preferredAtis can be omitted)
 * - Default limit (5) is included explicitly for clarity
 *
 * @private
 * @param section - Suggestion section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 */ function $d031ac9202c8e26f$var$encodeSuggestionSection(section, unknowns) {
    // Note: order of fields is important, do not change it without updating the decode function
    const sectionType = $d031ac9202c8e26f$var$sectionTypeToCode('suggestionSection');
    const limit = section.limit;
    const excludeAtis = $d031ac9202c8e26f$var$encodeATIList(section.excludeAtis, unknowns);
    const preferredAtis = $d031ac9202c8e26f$var$encodeATIList(section.preferredAtis, unknowns);
    return $d031ac9202c8e26f$var$joinWithTruncation([
        sectionType,
        limit,
        excludeAtis,
        preferredAtis
    ], 1); // Level 1: '|' (section fields)
}
/**
 * Encode a single menu section based on its type
 *
 * @param section - Menu section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 * @throws Error if section type is unknown
 */ function $d031ac9202c8e26f$var$encodeSection(section, unknowns) {
    switch(section.type){
        case 'appDefinedSection':
            return $d031ac9202c8e26f$var$encodeAppDefinedSection(section, unknowns);
        case 'suggestionSection':
            return $d031ac9202c8e26f$var$encodeSuggestionSection(section, unknowns);
        default:
            // TypeScript exhaustiveness check - this should never happen
            throw new Error(`Unknown section type: ${String(section)}`);
    }
}
// =============================================================================
// Final Assembly
// =============================================================================
/**
 * Build the raw configuration string from encoded sections
 *
 * Format: v{SCHEMA_VERSION}~section1~section2~...
 *
 * @private
 * @param encodedSections - Array of encoded section strings
 * @returns Raw configuration string with version prefix
 */ function $d031ac9202c8e26f$var$buildRawConfigString(encodedSections) {
    return `v${0, $dIxag.SCHEMA_VERSION}~${encodedSections.join('~')}`;
}
/**
 * Attach unknown component query parameters to the encoded result
 *
 * @private
 * @param encodedData - Base64URL-encoded configuration data
 * @param unknowns - Unknown ATI components collected during encoding
 * @returns Encoded configuration with query parameters
 */ function $d031ac9202c8e26f$var$attachQueryParameters(encodedData, unknowns) {
    const result = {
        d: encodedData
    };
    if (unknowns.owners.length > 0) result.ro = unknowns.owners.join(',');
    if (unknowns.types.length > 0) result.rt = unknowns.types.join(',');
    if (unknowns.prefixes.length > 0) result.ap = unknowns.prefixes.join(',');
    return result;
}
function $d031ac9202c8e26f$export$1282978798683232(config) {
    $d031ac9202c8e26f$var$validateConfig(config);
    const unknowns = {
        owners: [],
        types: [],
        prefixes: []
    };
    const encodedSections = config.appMenuConfig.map((section)=>$d031ac9202c8e26f$var$encodeSection(section, unknowns));
    const rawConfigString = $d031ac9202c8e26f$var$buildRawConfigString(encodedSections);
    // Encode UTF-8 string to bytes, then to base64url
    const utf8Bytes = new TextEncoder().encode(rawConfigString);
    const encodedData = (0, $3f0uf.encodeBase64Url)(utf8Bytes);
    return $d031ac9202c8e26f$var$attachQueryParameters(encodedData, unknowns);
}

});
parcelRegister("31gea", function(module, exports) {
$parcel$export(module.exports, "ariStr2Bin", () => $0a003121b1622397$export$4b052fcb66ebb451);
$parcel$export(module.exports, "writeEncodedATI", () => $0a003121b1622397$export$9fa514be131db9ec);
/**
 * Encode ATI string to binary representation
 */ 
var $kW7yd = parcelRequire("kW7yd");

var $dIxag = parcelRequire("dIxag");
/**
 * Get configuration for a specific component kind
 */ function $0a003121b1622397$var$getComponentConfig(unknowns, kind) {
    switch(kind){
        case 'prefix':
            return {
                array: unknowns.prefixes,
                maxLimit: (0, $dIxag.MAX_UNKNOWN_PREFIXES),
                errorMessage: `Too many unknown ATI prefixes (max ${0, $dIxag.MAX_UNKNOWN_PREFIXES})`
            };
        case 'owner':
            return {
                array: unknowns.owners,
                maxLimit: (0, $dIxag.MAX_UNKNOWN_OWNERS),
                errorMessage: `Too many unknown resource owners (max ${0, $dIxag.MAX_UNKNOWN_OWNERS})`
            };
        case 'type':
            return {
                array: unknowns.types,
                maxLimit: (0, $dIxag.MAX_UNKNOWN_TYPES),
                errorMessage: `Too many unknown resource types (max ${0, $dIxag.MAX_UNKNOWN_TYPES})`
            };
    }
}
/**
 * Ensure capacity for a component kind
 * @throws Error if capacity limit is exceeded
 */ function $0a003121b1622397$var$ensureCapacity(unknowns, kind) {
    const config = $0a003121b1622397$var$getComponentConfig(unknowns, kind);
    if (config.array.length >= config.maxLimit) throw new Error(config.errorMessage);
}
/**
 * Track unknown component value and return its index
 * Reuses existing index if value already tracked
 */ function $0a003121b1622397$var$trackUnknown({ unknowns: unknowns, kind: kind, value: value }) {
    const config = $0a003121b1622397$var$getComponentConfig(unknowns, kind);
    const existing = config.array.indexOf(value);
    if (existing !== -1) return existing;
    $0a003121b1622397$var$ensureCapacity(unknowns, kind);
    config.array.push(value);
    return config.array.length - 1;
}
/**
 * Encode a component (prefix/owner/type) to its code
 * Returns code and unknown flag
 */ function $0a003121b1622397$var$encodeComponent({ unknowns: unknowns, kind: kind, value: value, knownMap: knownMap }) {
    const knownCode = knownMap[value];
    const isUnknown = knownCode === undefined;
    const code = isUnknown ? $0a003121b1622397$var$trackUnknown({
        unknowns: unknowns,
        kind: kind,
        value: value
    }) : knownCode;
    return {
        code: code,
        isUnknown: isUnknown
    };
}
function $0a003121b1622397$export$4b052fcb66ebb451(ati, unknowns) {
    const { prefix: prefix, owner: owner, type: type } = (0, $kW7yd.parseATI)(ati);
    const { code: prefixCode, isUnknown: prefixIsUnknown } = $0a003121b1622397$var$encodeComponent({
        unknowns: unknowns,
        kind: 'prefix',
        value: prefix,
        knownMap: (0, $dIxag.ATI_PREFIX_MAP)
    });
    const { code: ownerCode, isUnknown: ownerIsUnknown } = $0a003121b1622397$var$encodeComponent({
        unknowns: unknowns,
        kind: 'owner',
        value: owner,
        knownMap: (0, $dIxag.RESOURCE_OWNER_MAP)
    });
    const { code: typeCode, isUnknown: typeIsUnknown } = $0a003121b1622397$var$encodeComponent({
        unknowns: unknowns,
        kind: 'type',
        value: type,
        knownMap: (0, $dIxag.RESOURCE_TYPE_MAP)
    });
    return {
        prefixCode: prefixCode,
        prefixIsUnknown: prefixIsUnknown,
        ownerCode: ownerCode,
        ownerIsUnknown: ownerIsUnknown,
        typeCode: typeCode,
        typeIsUnknown: typeIsUnknown
    };
}
function $0a003121b1622397$export$9fa514be131db9ec({ encoded: encoded, buffer: buffer, offset: offset }) {
    const { prefixCode: prefixCode, prefixIsUnknown: prefixIsUnknown, ownerIsUnknown: ownerIsUnknown, typeIsUnknown: typeIsUnknown, ownerCode: ownerCode, typeCode: typeCode } = encoded;
    // Byte 0: [P|O|T|P|OOOO]
    const ownerUpper = ownerCode >> (0, $dIxag.BIT_SHIFTS).OWNER_UPPER_BITS & 0x0f;
    const byte0 = (prefixIsUnknown ? 1 : 0) << (0, $dIxag.BIT_SHIFTS).PREFIX_FLAG_SHIFT | (ownerIsUnknown ? 1 : 0) << (0, $dIxag.BIT_SHIFTS).OWNER_FLAG_SHIFT | (typeIsUnknown ? 1 : 0) << (0, $dIxag.BIT_SHIFTS).TYPE_FLAG_SHIFT | (prefixCode & 0x01) << (0, $dIxag.BIT_SHIFTS).PREFIX_VALUE_SHIFT | ownerUpper;
    // Byte 1: [OOOO|TTTT]
    const ownerLower = ownerCode & 0x0f;
    const typeUpper = typeCode >> 8 & 0x0f;
    const byte1 = ownerLower << (0, $dIxag.BIT_SHIFTS).OWNER_LOWER_SHIFT | typeUpper;
    // Byte 2: [TTTTTTTT]
    const byte2 = typeCode & 0xff;
    // Write bytes directly (inline writeUInt8)
    buffer[offset] = byte0 & 0xff;
    buffer[offset + 1] = byte1 & 0xff;
    buffer[offset + 2] = byte2 & 0xff;
}

});
parcelRegister("kW7yd", function(module, exports) {
$parcel$export(module.exports, "parseATI", () => $b2f373f25b6dbc82$export$5597e67f4dded1e6);
$parcel$export(module.exports, "createIndexMap", () => $b2f373f25b6dbc82$export$912bb685303c4ec7);
/**
 * Utility functions for parsing and constructing ATI strings
 * Uses @atlassian/ari package for ATI parsing
 */ 
var $jEYBS = parcelRequire("jEYBS");
function $b2f373f25b6dbc82$export$5597e67f4dded1e6(ati) {
    try {
        const parsed = (0, $jEYBS.Ati).parse(ati);
        return {
            prefix: parsed.platformQualifier,
            owner: parsed.resourceOwner,
            type: parsed.resourceType
        };
    } catch  {
        throw new Error(`Invalid ATI format: expected "ati:<prefix>:<owner>:<type>", got "${ati}"`);
    }
}
function $b2f373f25b6dbc82$export$9acdaf42ad16ae47({ prefix: prefix, owner: owner, type: type }) {
    if (!prefix || !owner || !type) throw new Error('All ATI components (prefix, owner, type) must be non-empty');
    try {
        const ati = (0, $jEYBS.Ati).create({
            platformQualifier: prefix,
            resourceOwner: owner,
            resourceType: type
        });
        return ati.toString();
    } catch  {
        throw new Error('Failed to construct ATI from components');
    }
}
function $b2f373f25b6dbc82$export$9039e3b1770c6b8(ati) {
    if (typeof ati !== 'string') return false;
    try {
        (0, $jEYBS.Ati).parse(ati);
        return true;
    } catch  {
        return false;
    }
}
function $b2f373f25b6dbc82$export$912bb685303c4ec7(items) {
    return Object.fromEntries(items.map((item, index)=>[
            item,
            index
        ]));
}

});

parcelRegister("dIxag", function(module, exports) {
$parcel$export(module.exports, "SCHEMA_VERSION", () => $9ec96e1b5281932b$export$3167453beff01750);
$parcel$export(module.exports, "ATI_PREFIX_MAP", () => $9ec96e1b5281932b$export$61beacecbf214ae6);
$parcel$export(module.exports, "RESOURCE_OWNER_MAP", () => $9ec96e1b5281932b$export$83dfff18be6bef06);
$parcel$export(module.exports, "RESOURCE_TYPE_MAP", () => $9ec96e1b5281932b$export$38830b2321100ef2);
$parcel$export(module.exports, "BIT_SHIFTS", () => $9ec96e1b5281932b$export$4c68bfc8c9124205);
$parcel$export(module.exports, "MAX_UNKNOWN_OWNERS", () => $9ec96e1b5281932b$export$3010378ceda42048);
$parcel$export(module.exports, "MAX_UNKNOWN_TYPES", () => $9ec96e1b5281932b$export$6048538928ea261a);
$parcel$export(module.exports, "MAX_UNKNOWN_PREFIXES", () => $9ec96e1b5281932b$export$fd3a5bd85e4c7caa);
$parcel$export(module.exports, "MENU_ITEM_TYPE_MAP", () => $9ec96e1b5281932b$export$3dcfc8418d714114);
$parcel$export(module.exports, "PERSONALIZE_MODE_MAP", () => $9ec96e1b5281932b$export$6cabc9b146da4ac8);
$parcel$export(module.exports, "SECTION_TYPE_MAP", () => $9ec96e1b5281932b$export$1e5c4f2c7d35f342);
$parcel$export(module.exports, "DELIMITERS", () => $9ec96e1b5281932b$export$dab292c7293b69ae);
/**
 * Binary Encoding Constants for Universal Create Menu (V2 API)
 *
 * This module defines the constants used for encoding/decoding ATI configurations
 * into a compact binary format for URL transmission.
 *
 * These constants are shared across frontend and backend for binary encoding/decoding operations.
 */ 
var $kW7yd = parcelRequire("kW7yd");
const $9ec96e1b5281932b$export$3167453beff01750 = 2;
const $9ec96e1b5281932b$export$b2144c689c2ff042 = [
    'cloud',
    'third-party'
];
const $9ec96e1b5281932b$export$61beacecbf214ae6 = (0, $kW7yd.createIndexMap)($9ec96e1b5281932b$export$b2144c689c2ff042);
const $9ec96e1b5281932b$export$89e1a37ecee09500 = [
    // ALL NEW RESOURCE OWNERS MUST BE ADDED AT THE END OF THIS LIST
    'jira',
    'confluence',
    'loom',
    'townsquare',
    'trello',
    'bitbucket',
    'opsgenie',
    'compass',
    'statuspage',
    'atlas'
];
const $9ec96e1b5281932b$export$83dfff18be6bef06 = (0, $kW7yd.createIndexMap)($9ec96e1b5281932b$export$89e1a37ecee09500);
const $9ec96e1b5281932b$export$9dd62a2b56d5462d = [
    // ALL NEW RESOURCE TYPES MUST BE ADDED AT THE END OF THIS LIST
    'issue',
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'space',
    'video',
    'goal',
    'project',
    'team',
    'post',
    'board',
    'repository',
    'workspace',
    'component',
    'embed',
    'livedoc',
    'chat',
    'agent'
];
const $9ec96e1b5281932b$export$38830b2321100ef2 = (0, $kW7yd.createIndexMap)($9ec96e1b5281932b$export$9dd62a2b56d5462d);
const $9ec96e1b5281932b$export$b1e8f8dc54861a99 = 3;
const $9ec96e1b5281932b$export$21d9e5eeb6ffaecd = 1;
const $9ec96e1b5281932b$export$19409b356a31bc6d = {
    // Byte 0 masks
    PREFIX_FLAG_MASK: 128,
    OWNER_FLAG_MASK: 64,
    TYPE_FLAG_MASK: 32,
    PREFIX_VALUE_MASK: 16,
    OWNER_UPPER_MASK: 15,
    // Byte 1 masks
    OWNER_LOWER_MASK: 240,
    TYPE_UPPER_MASK: 15,
    // Byte 2 masks
    TYPE_LOWER_MASK: 255
};
const $9ec96e1b5281932b$export$4c68bfc8c9124205 = {
    PREFIX_FLAG_SHIFT: 7,
    OWNER_FLAG_SHIFT: 6,
    TYPE_FLAG_SHIFT: 5,
    PREFIX_VALUE_SHIFT: 4,
    OWNER_LOWER_SHIFT: 4,
    OWNER_UPPER_BITS: 4,
    TYPE_UPPER_SHIFT: 4,
    TYPE_UPPER_BITS: 8
};
const $9ec96e1b5281932b$export$597234ac346c7ad8 = 256;
const $9ec96e1b5281932b$export$8c22d9b338278eca = 4096;
const $9ec96e1b5281932b$export$3010378ceda42048 = 256;
const $9ec96e1b5281932b$export$6048538928ea261a = 4096;
const $9ec96e1b5281932b$export$fd3a5bd85e4c7caa = 2;
const $9ec96e1b5281932b$export$4030221cfc1fb63c = 5;
const $9ec96e1b5281932b$export$ece7c64a85a33d85 = 255;
const $9ec96e1b5281932b$export$6747badc61b8e57b = 512;
const $9ec96e1b5281932b$export$48ffef5fac2e11a = 10;
const $9ec96e1b5281932b$export$c38e76af505e38a1 = [
    'native',
    'link',
    'platform'
];
const $9ec96e1b5281932b$export$3dcfc8418d714114 = (0, $kW7yd.createIndexMap)($9ec96e1b5281932b$export$c38e76af505e38a1);
const $9ec96e1b5281932b$export$c89f8194e7716284 = [
    'off',
    'full',
    'overflow',
    'growthRecommendations'
];
const $9ec96e1b5281932b$export$6cabc9b146da4ac8 = (0, $kW7yd.createIndexMap)($9ec96e1b5281932b$export$c89f8194e7716284);
const $9ec96e1b5281932b$export$9c3e0a77c247e0c = [
    'appDefinedSection',
    'suggestionSection'
];
const $9ec96e1b5281932b$export$1e5c4f2c7d35f342 = (0, $kW7yd.createIndexMap)($9ec96e1b5281932b$export$9c3e0a77c247e0c);
const $9ec96e1b5281932b$export$dab292c7293b69ae = [
    '~',
    '|',
    ',',
    ':'
];

});


parcelRegister("3f0uf", function(module, exports) {
$parcel$export(module.exports, "encodeBase64Url", () => $9123a1d2471e794b$export$b0ffcdf8b133e63c);
/**
 * Platform-agnostic buffer utilities for binary encoding/decoding
 * Works in both browser and Node.js environments
 */ /**
 * Encode Uint8Array to base64url string (without padding)
 *
 * @param bytes - Uint8Array to encode
 * @returns Base64URL-encoded string
 */ 
var $fxj4L = parcelRequire("fxj4L");
var $9123a1d2471e794b$require$Buffer = $fxj4L.Buffer;
function $9123a1d2471e794b$export$b0ffcdf8b133e63c(bytes) {
    if (bytes.length === 0) return '';
    if (btoa === undefined) return $9123a1d2471e794b$require$Buffer.from(bytes).toString('base64url');
    else {
        // Browser: convert to binary string using Array.from (safe for large arrays and null bytes)
        const binaryString = Array.from(bytes, (byte)=>String.fromCharCode(byte)).join('');
        return btoa(binaryString).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    }
}

});


parcelRegister("6osoX", function(module, exports) {
$parcel$export(module.exports, "fetchJSON", () => $baec1641c072b83f$export$81bec6e38e8b706b);

var $cl0SH = parcelRequire("cl0SH");

var $jWQIc = parcelRequire("jWQIc");

var $j1u1e = parcelRequire("j1u1e");
class $baec1641c072b83f$export$65bd6083489bd8bb extends Error {
    constructor(httpStatus, statusText){
        super(`Failed to fetch data: ${httpStatus} ${statusText}`);
        this.httpStatus = httpStatus;
    }
}
function $baec1641c072b83f$export$f931afb2c5ecf7c7() {
    const host = window.location.host;
    return host.includes('localhost') && host.includes(':');
}
async function $baec1641c072b83f$export$81bec6e38e8b706b(url, init) {
    try {
        const response = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: {
                'Atl-BFF-Payload-Version': (0, $j1u1e.default).packageVersion,
                ...init?.headers
            }
        });
        // Defensive: misbehaving SWs / fetch wrappers can violate the Promise<Response>
        // contract and resolve to undefined
        if (!response) throw new Error('Failed to fetch data: fetch() returned no response');
        // Validate response status and throw an error for non-OK responses, except for specific cases handled by feature flags.
        if (!response.ok) {
            const isAvailableProductsEndpoint = URL.parse(url)?.pathname.includes((0, $jWQIc.BFFEndpointsEnum).AVAILABLE_PRODUCTS);
            // The Available Products endpoint returns a 403 status code exclusively from blockBotsMiddleware.
            if (response.status === 403 && isAvailableProductsEndpoint) // Return an empty list of sites to prevent pollinator from treating this as a failed request.
            return {
                status: (0, $cl0SH.RequestStatus).COMPLETE,
                data: {
                    sites: []
                }
            };
            throw new $baec1641c072b83f$export$65bd6083489bd8bb(response.status, response.statusText);
        }
        const jsonResponse = await response.json();
        return {
            status: (0, $cl0SH.RequestStatus).COMPLETE,
            data: jsonResponse
        };
    } catch (e) {
        return {
            status: (0, $cl0SH.RequestStatus).ERROR,
            error: e,
            ...e instanceof $baec1641c072b83f$export$65bd6083489bd8bb && {
                httpStatus: e.httpStatus
            },
            data: null
        };
    }
}

});
parcelRegister("jWQIc", function(module, exports) {
$parcel$export(module.exports, "BFFEndpointsEnum", () => $4bc2e36203f6e8b4$export$92af951f33a9009c);
$parcel$export(module.exports, "useURLBuilder", () => $4bc2e36203f6e8b4$export$3748aab334e7d372);

var $fsvuC = parcelRequire("fsvuC");

var $cl0SH = parcelRequire("cl0SH");

var $5LA8y = parcelRequire("5LA8y");

var $7CTtp = parcelRequire("7CTtp");

var $eJcNi = parcelRequire("eJcNi");
var $4bc2e36203f6e8b4$export$92af951f33a9009c = /*#__PURE__*/ function(BFFEndpointsEnum) {
    BFFEndpointsEnum["AVAILABLE_PRODUCTS"] = "/gateway/api/app-switcher/api/available-products";
    BFFEndpointsEnum["MENU_ITEMS_V2"] = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
    return BFFEndpointsEnum;
}({});
const $4bc2e36203f6e8b4$var$getOriginUrl = ({ originUrl: originUrl } = {})=>originUrl || new URL(window.location.href).origin;
function $4bc2e36203f6e8b4$export$3748aab334e7d372({ cloudId: cloudId, userId: userId, product: product }) {
    const { consumer: consumer } = (0, $7CTtp.useConsumer)();
    const { items: cachedItems } = (0, $5LA8y.useCache)();
    const originUrl = (0, $eJcNi.default)();
    const buildUCMenuItemsURL = (0, $fsvuC.useCallback)((props)=>{
        const { product: productParam, orgId: orgId, userId: userIdParam, locale: locale, subProduct: subProduct, d: d, ro: ro, rt: rt, ap: ap } = props;
        const baseUrl = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
        let url;
        try {
            url = new URL(`${$4bc2e36203f6e8b4$var$getOriginUrl({
                originUrl: originUrl
            })}${baseUrl}`);
        } catch (e) {
            return '';
        }
        const searchParams = new URLSearchParams();
        // Maintain specific order: tenantid, product, orgid, userid, source, then other params
        const queryParams = [
            [
                'tenantid',
                cloudId
            ],
            [
                'product',
                productParam || product
            ],
            [
                'orgid',
                orgId
            ],
            [
                'userid',
                userIdParam || userId
            ],
            [
                'source',
                consumer
            ],
            [
                'locale',
                locale
            ],
            [
                'subproduct',
                subProduct
            ],
            [
                'd',
                d
            ],
            [
                'ro',
                ro
            ],
            [
                'rt',
                rt
            ],
            [
                'ap',
                ap
            ]
        ];
        queryParams.forEach(([key, value])=>{
            if (value) searchParams.append(key, value);
        });
        // Append search params to URL
        url.search = searchParams.toString();
        return url.toString();
    }, [
        cloudId,
        product,
        userId,
        consumer,
        originUrl
    ]);
    const buildProductShortcutURL = (0, $fsvuC.useCallback)(({ baseUrl: baseUrl })=>{
        const finalBaseUrl = baseUrl ?? "/gateway/api/app-switcher/api/available-products";
        // No point in building a URL if there are no items to fetch and the cache is already populated
        if (cachedItems.length > 0) return '';
        const queryValues = '';
        return `${$4bc2e36203f6e8b4$var$getOriginUrl({
            originUrl: originUrl
        })}${finalBaseUrl}?${queryValues}`;
    }, [
        cachedItems,
        originUrl
    ]);
    const buildURL = (0, $fsvuC.useCallback)(({ baseUrl: baseUrl })=>{
        let url = '';
        if (baseUrl) url = `${$4bc2e36203f6e8b4$var$getOriginUrl({
            originUrl: originUrl
        })}${baseUrl}`;
        // Consumer specific URL building implementations happen here
        switch(consumer){
            case (0, $cl0SH.BFFConsumerEnum).GLOBAL_SHORTCUTS:
                url = buildProductShortcutURL({});
                break;
            case (0, $cl0SH.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION:
                url = buildProductShortcutURL({});
                break;
        }
        if (!url) return url;
        // Append the consumer to the URL
        let formattedUrl;
        try {
            formattedUrl = new URL(url);
        } catch (e) {
            return url;
        }
        const updatedParams = new URLSearchParams(formattedUrl.search);
        if (consumer) updatedParams.append('source', consumer);
        if (cloudId) updatedParams.append('tenantid', cloudId);
        if (userId) updatedParams.append('userid', userId);
        if (product) updatedParams.append('product', product);
        return `${formattedUrl.origin}${formattedUrl.pathname}?${updatedParams}`;
    }, [
        buildProductShortcutURL,
        consumer,
        cloudId,
        userId,
        product,
        originUrl
    ]);
    return {
        buildURL: buildURL,
        buildProductShortcutURL: buildProductShortcutURL,
        buildUCMenuItemsURL: buildUCMenuItemsURL
    };
}

});
parcelRegister("5LA8y", function(module, exports) {
$parcel$export(module.exports, "useCache", () => $2f16a474662a5c32$export$c6e89b6bb9436bc0);

var $fsvuC = parcelRequire("fsvuC");

var $960kA = parcelRequire("960kA");
function $2f16a474662a5c32$export$c6e89b6bb9436bc0() {
    const { value: { consumer: consumer, cache: cache, cacheKey: cacheKey }, setValue: setValue } = (0, $fsvuC.useContext)((0, $960kA.BFFContext));
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    const items = (0, $fsvuC.useMemo)(()=>{
        return cache[cacheKey] ?? [];
    }, [
        cache,
        cacheKey
    ]);
    const updateCacheKey = (0, $fsvuC.useCallback)((updatedCacheKey)=>{
        setValue((prev)=>({
                ...prev,
                cacheKey: `${consumer}-${updatedCacheKey}`
            }));
    }, [
        setValue,
        consumer
    ]);
    const addItemsToCache = (0, $fsvuC.useCallback)((items, compareKey = 'cloudId')=>{
        setValue((prev)=>{
            const itemData = prev.cache[cacheKey] ?? [];
            // Overwrite values with matched key if a new value is present
            // This shouldn't be necessary, but it helps act as a safeguard
            // for duplication.
            for (let item of items){
                const replacedItemIndex = itemData.findIndex((i)=>i[compareKey] === item[compareKey]);
                if (replacedItemIndex !== -1) itemData[replacedItemIndex] = item;
                else itemData.push(item);
            }
            return {
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: itemData
                }
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const clearCache = (0, $fsvuC.useCallback)(()=>{
        setValue((prev)=>({
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: []
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    return {
        addItemsToCache: addItemsToCache,
        cacheKey: cacheKey,
        clearCache: clearCache,
        items: items,
        updateCacheKey: updateCacheKey
    };
}

});

parcelRegister("7CTtp", function(module, exports) {
$parcel$export(module.exports, "useConsumer", () => $278b754770a3747d$export$33062d550933de6f);

var $fsvuC = parcelRequire("fsvuC");

var $960kA = parcelRequire("960kA");
function $278b754770a3747d$export$33062d550933de6f() {
    const { value: { consumer: consumer } } = (0, $fsvuC.useContext)((0, $960kA.BFFContext));
    return {
        consumer: consumer
    };
}

});

parcelRegister("eJcNi", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f3340a773602089$export$2e2bcd8739ae039);

var $fmRdZ = parcelRequire("fmRdZ");
/**
 * Hook that returns the context of a forced origin url (used for supporting global shortcuts locally)
 */ const $2f3340a773602089$var$useOriginUrl = ()=>{
    const context = (0, $fmRdZ.useBFFOriginUrlContext)();
    return context;
};
var $2f3340a773602089$export$2e2bcd8739ae039 = $2f3340a773602089$var$useOriginUrl;

});
parcelRegister("fmRdZ", function(module, exports) {
$parcel$export(module.exports, "useBFFOriginUrlContext", () => $1ddcbc7c6f7a5541$export$13a55721f6e3a9e);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
const $1ddcbc7c6f7a5541$var$BFFOriginUrlContext = /*#__PURE__*/ (0, $fsvuC.createContext)(undefined);
const $1ddcbc7c6f7a5541$export$405f92d0950d3d4f = ({ children: children, url: url })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)($1ddcbc7c6f7a5541$var$BFFOriginUrlContext.Provider, {
        value: url,
        children: children
    });
};
$1ddcbc7c6f7a5541$export$405f92d0950d3d4f.displayName = "BFFOriginUrlProvider";
const $1ddcbc7c6f7a5541$export$13a55721f6e3a9e = ()=>{
    return (0, $fsvuC.useContext)($1ddcbc7c6f7a5541$var$BFFOriginUrlContext);
};

});



parcelRegister("j1u1e", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2e0c8649cae5afc$export$2e2bcd8739ae039);
const $d2e0c8649cae5afc$var$packageName = "platform-pkg";
const $d2e0c8649cae5afc$var$packageVersion = "0.0.0-use.local";
const $d2e0c8649cae5afc$var$_default_1 = {
    packageName: $d2e0c8649cae5afc$var$packageName,
    packageVersion: $d2e0c8649cae5afc$var$packageVersion
};
var $d2e0c8649cae5afc$export$2e2bcd8739ae039 = $d2e0c8649cae5afc$var$_default_1;

});


parcelRegister("aJIsV", function(module, exports) {
$parcel$export(module.exports, "useGenericCache", () => $df325ed995a3b23f$export$53a1e737d45016e2);

var $fsvuC = parcelRequire("fsvuC");

var $960kA = parcelRequire("960kA");
/**
 * Helper function to create a deterministic cache key from an object
 * by sorting keys and stringifying the result
 */ function $df325ed995a3b23f$var$createSortedCacheKey(unordered) {
    return JSON.stringify(Object.keys(unordered).sort().reduce((obj, key)=>{
        obj[key] = unordered[key];
        return obj;
    }, {}));
}
function $df325ed995a3b23f$export$53a1e737d45016e2(props) {
    const { value: { consumer: consumer, cache: cache }, setValue: setValue } = (0, $960kA.useBFFContext)();
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    // Compute cache key using useMemo with sorted JSON stringification
    const cacheKey = (0, $fsvuC.useMemo)(()=>{
        const sortedJsonString = $df325ed995a3b23f$var$createSortedCacheKey(props);
        return `gc-${consumer}-${sortedJsonString}`;
    }, [
        consumer,
        props
    ]);
    const cachedObject = cache[cacheKey];
    const setCachedObject = (0, $fsvuC.useCallback)((objectToCache)=>{
        setValue((prev)=>({
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: objectToCache
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    const removeCachedObject = (0, $fsvuC.useCallback)(()=>{
        setValue((prev)=>{
            const { [cacheKey]: removed, ...remainingCache } = prev.cache;
            return {
                ...prev,
                cache: remainingCache
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const getCachedObject = (targetCacheKey)=>cache[targetCacheKey];
    const hasCachedObject = (targetCacheKey)=>cache[targetCacheKey] !== undefined;
    return {
        cachedObject: cachedObject,
        cacheKey: cacheKey,
        getCachedObject: getCachedObject,
        hasCachedObject: hasCachedObject,
        removeCachedObject: removeCachedObject,
        setCachedObject: setCachedObject
    };
}

});

parcelRegister("9rBrz", function(module, exports) {
$parcel$export(module.exports, "useStatus", () => $b561af286cc266cc$export$53cc6abb6942ce72);

var $fsvuC = parcelRequire("fsvuC");

var $cl0SH = parcelRequire("cl0SH");

var $960kA = parcelRequire("960kA");
function $b561af286cc266cc$export$53cc6abb6942ce72() {
    const { setValue: setValue, value: { status: status, error: error }, currentLoadingRequests: currentLoadingRequests, updateCurrentLoadingRequests: updateCurrentLoadingRequests } = (0, $960kA.useBFFContext)();
    const isInitializing = (0, $fsvuC.useMemo)(()=>status === (0, $cl0SH.RequestStatus).INIT, [
        status
    ]);
    const isComplete = (0, $fsvuC.useMemo)(()=>status === (0, $cl0SH.RequestStatus).COMPLETE, [
        status
    ]);
    const isError = (0, $fsvuC.useMemo)(()=>status === (0, $cl0SH.RequestStatus).ERROR, [
        status
    ]);
    const isLoading = (0, $fsvuC.useMemo)(()=>status === (0, $cl0SH.RequestStatus).LOADING, [
        status
    ]);
    const isLoaded = (0, $fsvuC.useMemo)(()=>status !== (0, $cl0SH.RequestStatus).LOADING, [
        status
    ]);
    // Globally update the status based on the request queue for the BFF
    (0, $fsvuC.useEffect)(()=>{
        if (!currentLoadingRequests.length && status === (0, $cl0SH.RequestStatus).LOADING) // Ensure that the error state remains if it was previously set
        setValue((prev)=>{
            if (prev.status === (0, $cl0SH.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: (0, $cl0SH.RequestStatus).COMPLETE
            };
        });
    }, [
        currentLoadingRequests,
        setValue,
        status
    ]);
    // Globally manage the request queue of any calls to the BFF
    const setStatus = (0, $fsvuC.useCallback)((newStatus, integratingComponent, error)=>{
        if (newStatus === (0, $cl0SH.RequestStatus).LOADING && integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $cl0SH.RequestStatus).LOADING);
        if (newStatus === (0, $cl0SH.RequestStatus).COMPLETE) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $cl0SH.RequestStatus).COMPLETE);
        }
        if (newStatus === (0, $cl0SH.RequestStatus).ERROR) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $cl0SH.RequestStatus).ERROR);
        }
        setValue((prev)=>{
            const isErrorStatus = newStatus === (0, $cl0SH.RequestStatus).ERROR;
            return {
                ...prev,
                status: isErrorStatus ? (0, $cl0SH.RequestStatus).ERROR : (0, $cl0SH.RequestStatus).LOADING,
                error: isErrorStatus ? error : undefined
            };
        });
    }, [
        updateCurrentLoadingRequests,
        setValue
    ]);
    return {
        error: error,
        isComplete: isComplete,
        isError: isError,
        isInitializing: isInitializing,
        isLoaded: isLoaded,
        isLoading: isLoading,
        setStatus: setStatus,
        status: status
    };
}

});


parcelRegister("6KuCP", function(module, exports) {
$parcel$export(module.exports, "sectionsToAppMenuConfig", () => $20f4b67ebb1d5469$export$c9ba238fd04e08d2);


var $grXAL = parcelRequire("grXAL");
const $20f4b67ebb1d5469$export$20ae29efbf02e075 = (item)=>({
        type: (0, $grXAL.isNativeMenuItem)(item) ? 'native' : item.type,
        ati: item.ati.toString(),
        promoted: item?.promoted
    });
const $20f4b67ebb1d5469$export$95539883fd80ce6 = (section)=>{
    if (section.type === 'suggestionSection') return {
        type: 'suggestionSection',
        limit: section.limit ?? 5,
        ...section.excludeAtis && {
            excludeAtis: section.excludeAtis.map((ati)=>ati.toString())
        },
        ...section.preferredAtis && {
            preferredAtis: section.preferredAtis.map((ati)=>ati.toString())
        }
    };
    if (section.type === 'appDefinedSection') {
        const overflowThreshold = Boolean(section.foldable) ? typeof section.foldable === 'number' ? section.foldable : (0, $7b7d6f3fbc64b228$export$e5a5b1df38d9e289) : undefined;
        return {
            type: 'appDefinedSection',
            items: section.items.map($20f4b67ebb1d5469$export$20ae29efbf02e075),
            personalize: section.personalize,
            ...overflowThreshold && {
                overflowThreshold: overflowThreshold
            }
        };
    }
    // Assert that we have handled all possible section types
    const exhaustive = section;
    return exhaustive;
};
const $20f4b67ebb1d5469$export$c9ba238fd04e08d2 = (sections)=>({
        appMenuConfig: sections.map($20f4b67ebb1d5469$export$95539883fd80ce6)
    });

});
const $7b7d6f3fbc64b228$export$e5a5b1df38d9e289 = 4;

parcelRegister("grXAL", function(module, exports) {
$parcel$export(module.exports, "isNativeMenuItem", () => $075e3d387f2f3010$export$68f958d92a17ef71);
const $075e3d387f2f3010$export$68f958d92a17ef71 = (item)=>{
    return 'children' in item && !('type' in item);
};

});


parcelRegister("8rkif", function(module, exports) {
$parcel$export(module.exports, "useFetchUser", () => $5174c71318e82875$export$61de563e38fe014d);

var $960kA = parcelRequire("960kA");

var $bsCZb = parcelRequire("bsCZb");

var $hEGZD = parcelRequire("hEGZD");
function $5174c71318e82875$export$61de563e38fe014d() {
    const { user: currentUser } = (0, $960kA.useUserContext)();
    const { fetchUser: fetchUser } = (0, $bsCZb.useFetchUser)();
    /**
	 * Conditionally fetches user data if menu items require it.
	 * Supports both V1 (flat items array) and V2 (sections with items) data structures.
	 *
	 * @param params - Object containing either items array or sections array
	 */ const fetchUserIfNeeded = ({ items: items, sections: sections })=>{
        // Skip if user already available
        if (currentUser) return;
        // Check V1 format (flat items array)
        if (items) {
            const willNeedUser = items.some((item)=>{
                return item.ati && (0, $hEGZD.REQUIRED_USER_ITEMS).includes(item.ati);
            });
            if (willNeedUser) fetchUser();
        }
        // Check V2 format (sections with items)
        if (sections && Array.isArray(sections)) {
            const willNeedUser = sections.some((section)=>Array.isArray(section.items) && section.items.some((item)=>item && item.ati && (0, $hEGZD.REQUIRED_USER_ITEMS).includes(item.ati)));
            if (willNeedUser) fetchUser();
        }
    };
    return {
        fetchUserIfNeeded: fetchUserIfNeeded
    };
}

});
parcelRegister("bsCZb", function(module, exports) {
$parcel$export(module.exports, "useFetchUser", () => $21f801524feb0d88$export$61de563e38fe014d);

var $fsvuC = parcelRequire("fsvuC");
function $21f801524feb0d88$export$61de563e38fe014d() {
    const fetchUser = (0, $fsvuC.useCallback)(async ()=>{
        try {
            const response = await fetch('/gateway/api/me', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) return undefined;
            const userData = await response.json();
            return userData;
        } catch (err) {
            return undefined;
        }
    }, []);
    return {
        fetchUser: fetchUser
    };
}

});


parcelRegister("5Z4Gr", function(module, exports) {
$parcel$export(module.exports, "usePrefetchLoom", () => $5c901deef0bd5df0$export$c1b17113cb5b0556);

var $fsvuC = parcelRequire("fsvuC");

var $icbxG = parcelRequire("icbxG");

var $hEGZD = parcelRequire("hEGZD");

var $230VD = parcelRequire("230VD");


function $5c901deef0bd5df0$export$c1b17113cb5b0556() {
    const loadPromiseRef = (0, $fsvuC.useRef)(null);
    const experienceTracker = (0, $fsvuC.useContext)((0, $icbxG.ExperienceTrackerContext));
    const { product: product, suggestionConfig: suggestionConfig, crossAppCreationConfig: crossAppCreationConfig } = (0, $230VD.useMenuStateContext)();
    const triggerPrefetch = (0, $fsvuC.useCallback)(()=>{
        if (loadPromiseRef.current) return;
        // Only load if either suggestion config or cross-app creation is enabled
        if (!suggestionConfig.enabled && !crossAppCreationConfig?.enabled) return;
        const { cloudId: cloudId, environment: environment } = crossAppCreationConfig?.enabled ? crossAppCreationConfig : suggestionConfig.enabled ? suggestionConfig : {};
        const finalEnvironment = environment || 'prod';
        const loadingPromise = (async ()=>{
            try {
                if (cloudId) {
                    const [{ initLoomSDK: initLoomSDK }, { convertSourceProductToProductType: convertSourceProductToProductType }] = await Promise.all([
                        (parcelRequire("g4JMS")),
                        (parcelRequire("fQe3b"))
                    ]);
                    await initLoomSDK({
                        environment: finalEnvironment,
                        cloudId: cloudId,
                        productName: convertSourceProductToProductType(product),
                        experienceTracker: experienceTracker,
                        entryPointLocation: (0, $hEGZD.SOURCE_LOCATION)
                    });
                }
            } catch  {
            // ignore
            }
        })();
        loadPromiseRef.current = loadingPromise;
    }, [
        experienceTracker,
        product,
        suggestionConfig,
        crossAppCreationConfig
    ]);
    return {
        triggerPrefetch: triggerPrefetch
    };
}

});
parcelRegister("g4JMS", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("cTdBv").then(()=>parcelRequire('kbizH'));

});

parcelRegister("fQe3b", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("6xZ5v").then(()=>parcelRequire('btNYQ'));

});




parcelRegister("9U8bL", function(module, exports) {
$parcel$export(module.exports, "LoadingMenu", () => $ff135387d3057ea1$export$dab1248df0cdf0ab);
/* LoadingMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $mhEfz = parcelRequire("mhEfz");

var $jRYjy = parcelRequire("jRYjy");

var $5uwXq = parcelRequire("5uwXq");

var $f5uqR = parcelRequire("f5uqR");
const $ff135387d3057ea1$var$styles = {
    wrapper: "_4ouGXIyCDO",
    wrapperWithPadding: "_4ouGXIyCDO _0Of8r22ADO _1Znuxb5zaO _1wydGW2ADO _2Zuz6Q5zaO"
};
function $ff135387d3057ea1$export$dab1248df0cdf0ab({ padded: padded = false }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    (0, $fsvuC.useEffect)(()=>{
        // Intentional inline this analytics events due to
        // loading menu component can be used outside of context
        createAnalyticsEvent({
            actionSubject: 'universalCreate',
            eventType: 'ui',
            source: (0, $5uwXq.ANALYTICS_SOURCE),
            tags: [
                (0, $5uwXq.ANALYTICS_TAG)
            ],
            action: 'viewed',
            actionSubjectId: 'universalCreateLoadingMenu',
            attributes: {}
        }).fire((0, $5uwXq.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
        testId: "global-create-content-loading-menu",
        xcss: padded ? $ff135387d3057ea1$var$styles.wrapperWithPadding : $ff135387d3057ea1$var$styles.wrapper,
        children: Array.from({
            length: 6
        }, (_, index)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $f5uqR.SkeletonItem), {
                contentHeight: 8
            }, `loading-skeleton-item-${index}`))
    });
}
$ff135387d3057ea1$export$dab1248df0cdf0ab.displayName = "LoadingMenu";

});
parcelRegister("f5uqR", function(module, exports) {
$parcel$export(module.exports, "SkeletonItem", () => $d5949bf99597315f$export$fbc0ea7debdb77e);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gTOBM = parcelRequire("gTOBM");
const $d5949bf99597315f$export$fbc0ea7debdb77e = (props)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $gTOBM.MenuSkeletonItem), {
        ...props
    });
};
$d5949bf99597315f$export$fbc0ea7debdb77e.displayName = "SkeletonItem";

});
parcelRegister("gTOBM", function(module, exports) {
$parcel$export(module.exports, "MenuSkeletonItem", () => $18dc5a853fb96c6c$export$cde35cc9e1359709);
/* MenuSkeletonItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $oAzkD = parcelRequire("oAzkD");

var $jR7Rq = parcelRequire("jR7Rq");

var $d0SZF = parcelRequire("d0SZF");

var $3uRAY = parcelRequire("3uRAY");

var $8e1dR = parcelRequire("8e1dR");

var $0D76W = parcelRequire("0D76W");
const $18dc5a853fb96c6c$var$DEFAULT_CONTENT_HEIGHT = 8;
const $18dc5a853fb96c6c$var$menuSkeletonStyles = {
    wrapper: "_0jFU0VUofl _39xV02N91d _2Zuz6Q1Y8M _1Znuxb1Y8M"
};
const $18dc5a853fb96c6c$export$cde35cc9e1359709 = ({ testId: testId, contentHeight: contentHeight = $18dc5a853fb96c6c$var$DEFAULT_CONTENT_HEIGHT })=>{
    const { formatMessage: formatMessage } = (0, $oAzkD.default)();
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $d0SZF.Stack), {
        xcss: $18dc5a853fb96c6c$var$menuSkeletonStyles.wrapper,
        alignBlock: "center",
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $jR7Rq.Flex), {
                alignItems: "center",
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $3uRAY.default), {
                    testId: "skeleton-item-v2",
                    width: "100%",
                    height: contentHeight,
                    isShimmering: true
                })
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $8e1dR.default), {
                children: formatMessage((0, $0D76W.default).menuItemLoading)
            })
        ]
    });
};
$18dc5a853fb96c6c$export$cde35cc9e1359709.displayName = "MenuSkeletonItem";

});
parcelRegister("0D76W", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d48b9ec4eadd552$export$2e2bcd8739ae039);

var $54F37 = parcelRequire("54F37");
const $5d48b9ec4eadd552$var$messages = (0, $54F37.defineMessages)({
    menuItemLoading: {
        id: 'navigation.universal-create.menuItemLoading',
        defaultMessage: 'Menu item is loading',
        description: 'The message that screen reader announces when a menu item is loading'
    }
});
var $5d48b9ec4eadd552$export$2e2bcd8739ae039 = $5d48b9ec4eadd552$var$messages;

});




parcelRegister("9WMk3", function(module, exports) {
$parcel$export(module.exports, "TriggerButton", () => $904dcc644e4e6738$export$4129321aecd13375);
/* TriggerButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $54F37 = parcelRequire("54F37");
var $oAzkD = parcelRequire("oAzkD");

var $3KROw = parcelRequire("3KROw");

var $lLT4i = parcelRequire("lLT4i");

var $hdkV2 = parcelRequire("hdkV2");

var $9cVKi = parcelRequire("9cVKi");

var $irYrv = parcelRequire("irYrv");

var $cIdnd = parcelRequire("cIdnd");
var $cBAtE = parcelRequire("cBAtE");

var $a5Zx6 = parcelRequire("a5Zx6");

var $fPBr2 = parcelRequire("fPBr2");

var $llCao = parcelRequire("llCao");

var $jkJ1C = parcelRequire("jkJ1C");

var $k4sC6 = parcelRequire("k4sC6");

var $he2MH = parcelRequire("he2MH");

var $3Kmf8 = parcelRequire("3Kmf8");

var $hEGZD = parcelRequire("hEGZD");

var $230VD = parcelRequire("230VD");

var $7Q0y6 = parcelRequire("7Q0y6");

var $8ApsA = parcelRequire("8ApsA");
const $904dcc644e4e6738$var$triggerButton = null;
/**
 * Clean up nav3 button once Confluence has cleaned up nav3
 * https://jplat.atlassian.net/browse/BLU-7401
 */ const $904dcc644e4e6738$var$nav3ButtonTextStyles = null;
const $904dcc644e4e6738$var$animatedCreateIconStyles = null;
const $904dcc644e4e6738$var$animatedCreateIconOpenStyles = null;
/**
 * Rotates the add icon into a cross while the menu is open. Defined at module level so its
 * component type stays stable across renders, letting the rotation transition play.
 */ const $904dcc644e4e6738$var$AnimatedCreateIcon = ({ isOpen: isOpen, ...iconProps })=>/*#__PURE__*/ (0, $5chsV.jsx)("span", {
        className: (0, $gJ6nT.default)([
            "_3iDTPbccYA _1kOSYtC67X _3Z9K0wqvoi _0qk6IKxt7V _1SdfoHYbGa",
            isOpen && "_1VJPcaEFNz"
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hdkV2))), {
            ...iconProps
        })
    });
$904dcc644e4e6738$var$AnimatedCreateIcon.displayName = "AnimatedCreateIcon";
const $904dcc644e4e6738$var$messages = (0, $54F37.defineMessages)({
    secondaryButtonTooltipText: {
        id: 'platform.navigation-experiences.universal-create.secondary-tooltip-text',
        defaultMessage: 'More create options',
        description: 'Tooltip text shown when hovering over the secondary button in the split create button that opens additional create options'
    }
});
function $904dcc644e4e6738$var$TooltipWrapper({ children: children, text: text, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = true }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3Kmf8.default), {
        content: text,
        tag: "span",
        isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled,
        position: "bottom",
        ignoreTooltipPointerEvents: true,
        children: children
    });
}
$904dcc644e4e6738$var$TooltipWrapper.displayName = "TooltipWrapper";
function $904dcc644e4e6738$var$TriggerButtonInner({ triggerProps: triggerProps, testId: testId, onClick: onClick, children: children, isOpen: isOpen = false, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, enableTriggerPulse: enableTriggerPulse, isNav4Enabled: isNav4Enabled = true, shouldAnimateCreateIcon: shouldAnimateCreateIcon = false, buttonTheme: buttonTheme, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, primaryActionItem: primaryActionItem, isEntryPointEnabled: isEntryPointEnabled = false, buttonOnly: buttonOnly = false }) {
    const isButtonOnly = buttonOnly;
    const { product: product, sections: sections } = (0, $230VD.useUniversalCreateState)();
    const { fireCreateButtonClicked: fireCreateButtonClicked, fireCreateButtonHovered: fireCreateButtonHovered, fireCreateButtonViewed: fireCreateButtonViewed } = (0, $7Q0y6.useUniversalCreateAnalytics)();
    const { formatMessage: formatMessage } = (0, $oAzkD.default)();
    const isDesktop = (0, $he2MH.UNSAFE_useMediaQuery)('above.sm')?.matches ?? false;
    const version = sections?.length ? 'v2' : 'v1';
    const hasHoveredRef = (0, $fsvuC.useRef)(false);
    const isSplitButton = Boolean(primaryActionItem);
    const buttonVariant = isSplitButton ? 'split' : 'standard';
    const hasFiredViewEvent = (0, $fsvuC.useRef)(false);
    (0, $fsvuC.useEffect)(function fireButtonViewEvent() {
        if (hasFiredViewEvent.current) return;
        hasFiredViewEvent.current = true;
        fireCreateButtonViewed({
            buttonVariant: buttonVariant,
            version: version,
            isButtonOnly: isButtonOnly
        });
    }, [
        fireCreateButtonViewed,
        buttonVariant,
        version,
        isButtonOnly
    ]);
    // Extract splitPrimaryRef from triggerProps for split button variant
    const { splitButtonPrimaryRef: splitButtonPrimaryRef, ...restTriggerProps } = triggerProps ?? {};
    const onButtonClick = (0, $fsvuC.useCallback)(()=>{
        /// For entrypoint path (isEntryPointEnabled is true), set to expanded when isOpen is true
        // For non-entrypoint path (isEntryPointEnabled is false), set to expanded when isOpen is false (current state), as in the legacy mode, the event is fired before menu opens.
        const itemState = isButtonOnly ? 'button-only' : isEntryPointEnabled === isOpen ? 'expanded' : 'collapsed';
        const clickedButtonPart = isSplitButton ? 'dropdown' : 'full';
        const clickedButtonVariant = isSplitButton ? 'split' : 'standard';
        fireCreateButtonClicked({
            itemState: itemState,
            buttonPart: clickedButtonPart,
            buttonVariant: clickedButtonVariant
        });
        onClick();
    }, [
        fireCreateButtonClicked,
        isOpen,
        onClick,
        isEntryPointEnabled,
        isButtonOnly,
        isSplitButton
    ]);
    const primaryItemOnClick = primaryActionItem?.onClick;
    const onPrimaryButtonClick = (0, $fsvuC.useCallback)((event)=>{
        const itemState = isEntryPointEnabled === isOpen ? 'expanded' : 'collapsed';
        fireCreateButtonClicked({
            itemState: itemState,
            buttonPart: 'primary',
            buttonVariant: 'split'
        });
        primaryItemOnClick?.(event);
    }, [
        fireCreateButtonClicked,
        isEntryPointEnabled,
        isOpen,
        primaryItemOnClick
    ]);
    const CreateIcon = isButtonOnly ? (0, (/*@__PURE__*/$parcel$interopDefault($hdkV2))) : shouldAnimateCreateIcon ? (iconProps)=>/*#__PURE__*/ (0, $5chsV.jsx)($904dcc644e4e6738$var$AnimatedCreateIcon, {
            ...iconProps,
            isOpen: isOpen
        }) : isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($irYrv))) : (0, (/*@__PURE__*/$parcel$interopDefault($hdkV2)));
    const createEnterEvent = (0, $fsvuC.useCallback)(({ buttonPart: buttonPart, shouldTriggerMouseEnterProp: shouldTriggerMouseEnterProp = true })=>(event)=>{
            if (!hasHoveredRef.current) {
                hasHoveredRef.current = true;
                const itemState = isButtonOnly ? 'button-only' : isEntryPointEnabled === isOpen ? 'expanded' : 'collapsed';
                fireCreateButtonHovered({
                    buttonPart: buttonPart,
                    buttonVariant: buttonVariant,
                    itemState: itemState,
                    version: version
                });
            }
            if (shouldTriggerMouseEnterProp) onMouseEnter?.(event);
        }, [
        onMouseEnter,
        fireCreateButtonHovered,
        isOpen,
        isEntryPointEnabled,
        version,
        buttonVariant,
        isButtonOnly
    ]);
    const enterEvent = createEnterEvent({
        buttonPart: 'full'
    });
    const enterEventPrimary = createEnterEvent({
        buttonPart: 'primary'
    });
    const enterEventDropdown = createEnterEvent({
        buttonPart: 'dropdown'
    });
    const leaveEvent = (0, $fsvuC.useCallback)((event)=>{
        onMouseLeave?.(event);
    }, [
        onMouseLeave
    ]);
    const nav3Button = !isNav4Enabled ? /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            "_2zn3kOvLZJ _20TGBK2ADO _4cVK8J2ADO _2KveArdnbC _0TG72ZdnbC"
        ]),
        children: product === 'confluence' ? /*#__PURE__*/ (0, $5chsV.jsx)("div", {
            className: (0, $gJ6nT.default)([
                "_2b6yPu2ADO _326PPJ2ADO _4zJbgkdnbC _1GtPpldnbC _1vxi63YbGa"
            ]),
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $3KROw.default), {
                ...restTriggerProps,
                appearance: "primary",
                // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @atlaskit/design-system/no-unsafe-style-overrides
                theme: buttonTheme,
                onMouseEnter: enterEvent,
                onMouseLeave: leaveEvent,
                onClick: onButtonClick,
                // Legacy path; all products within AFM use nav4. Unlike the TopNav buttons, which call
                // a CreateIcon render function directly, this Button takes an element, so the animated
                // CreateIcon would be mounted as a new component each render and skip the rotation.
                // Render AnimatedCreateIcon directly instead, duplicating the CreateIcon logic.
                iconBefore: shouldAnimateCreateIcon && !isButtonOnly ? /*#__PURE__*/ (0, $5chsV.jsx)($904dcc644e4e6738$var$AnimatedCreateIcon, {
                    label: "",
                    isOpen: isOpen,
                    "data-vc": "global-content-create-button"
                }) : /*#__PURE__*/ (0, $5chsV.jsx)(CreateIcon, {
                    label: "",
                    "data-vc": "global-content-create-button"
                }),
                testId: testId || (0, $hEGZD.TRIGGER_BUTTON_TEST_ID),
                "aria-label": children,
                isSelected: isOpen,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $k4sC6.Show), {
                    above: "sm",
                    as: "span",
                    children: children
                })
            })
        }) : /*#__PURE__*/ (0, $5chsV.jsx)($904dcc644e4e6738$var$TooltipWrapper, {
            text: children,
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $cIdnd.Button), {
                ...restTriggerProps,
                appearance: "primary",
                onClick: onButtonClick,
                onMouseEnter: enterEvent,
                onMouseLeave: leaveEvent,
                isSelected: isOpen,
                iconBefore: CreateIcon,
                testId: testId || (0, $hEGZD.TRIGGER_BUTTON_TEST_ID),
                "aria-label": children,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $k4sC6.Show), {
                    above: "sm",
                    as: "span",
                    children: children
                })
            })
        })
    }) : null;
    const responsiveSafeButton = isNav4Enabled ? /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $k4sC6.Show), {
                above: (0, $hEGZD.RESPONSIVE_BREAKPOINT),
                as: "span",
                children: /*#__PURE__*/ (0, $5chsV.jsx)($904dcc644e4e6738$var$TooltipWrapper, {
                    text: children,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $cIdnd.Button), {
                        ...isDesktop ? restTriggerProps : {},
                        appearance: "primary",
                        onClick: onButtonClick,
                        onMouseEnter: enterEvent,
                        onMouseLeave: leaveEvent,
                        isSelected: isOpen,
                        iconBefore: CreateIcon,
                        testId: testId || (0, $hEGZD.TRIGGER_BUTTON_TEST_ID),
                        "aria-label": children,
                        "data-responsive-variant": "desktop",
                        children: children
                    })
                })
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $jkJ1C.Hide), {
                above: (0, $hEGZD.RESPONSIVE_BREAKPOINT),
                as: "span",
                children: /*#__PURE__*/ (0, $5chsV.jsx)($904dcc644e4e6738$var$TooltipWrapper, {
                    text: children,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $cBAtE.IconButton), {
                        ...!isDesktop ? restTriggerProps : {},
                        appearance: "primary",
                        onClick: onButtonClick,
                        onMouseEnter: enterEvent,
                        onMouseLeave: leaveEvent,
                        isSelected: isOpen,
                        icon: CreateIcon,
                        testId: `${testId || (0, $hEGZD.TRIGGER_BUTTON_TEST_ID)}-mobile`,
                        label: children,
                        "data-responsive-variant": "mobile"
                    })
                })
            })
        ]
    }) : null;
    const splitButtonVariant = primaryActionItem ? /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $k4sC6.Show), {
                above: (0, $hEGZD.RESPONSIVE_BREAKPOINT),
                children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $lLT4i.SplitButton), {
                    appearance: "primary",
                    children: [
                        /*#__PURE__*/ (0, $5chsV.jsx)($904dcc644e4e6738$var$TooltipWrapper, {
                            text: children,
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $cIdnd.Button), {
                                ref: splitButtonPrimaryRef,
                                appearance: "primary",
                                onClick: onPrimaryButtonClick,
                                onMouseEnter: enterEventPrimary,
                                "aria-label": children,
                                testId: "uc-trigger-button-primary",
                                children: children
                            })
                        }),
                        /*#__PURE__*/ (0, $5chsV.jsx)($904dcc644e4e6738$var$TooltipWrapper, {
                            text: formatMessage($904dcc644e4e6738$var$messages.secondaryButtonTooltipText),
                            isScreenReaderAnnouncementDisabled: false,
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $cBAtE.IconButton), {
                                ...isDesktop ? restTriggerProps : {},
                                appearance: "primary",
                                onClick: onButtonClick,
                                isSelected: isOpen,
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9cVKi))),
                                "data-responsive-variant": "desktop",
                                label: children,
                                testId: `${testId || (0, $hEGZD.TRIGGER_BUTTON_TEST_ID)}-split`,
                                onMouseEnter: enterEventDropdown,
                                onMouseLeave: leaveEvent
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $jkJ1C.Hide), {
                above: "sm",
                children: /*#__PURE__*/ (0, $5chsV.jsx)($904dcc644e4e6738$var$TooltipWrapper, {
                    text: children,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $cBAtE.IconButton), {
                        ...!isDesktop ? restTriggerProps : {},
                        appearance: "primary",
                        onClick: onButtonClick,
                        onMouseEnter: enterEvent,
                        onMouseLeave: leaveEvent,
                        isSelected: isOpen,
                        icon: CreateIcon,
                        testId: `${testId || (0, $hEGZD.TRIGGER_BUTTON_TEST_ID)}-mobile`,
                        label: children,
                        "data-responsive-variant": "mobile"
                    })
                })
            })
        ]
    }) : null;
    const buttonToRender = primaryActionItem ? splitButtonVariant : isNav4Enabled ? responsiveSafeButton : nav3Button;
    if (!(0, $llCao.fg)('navx_uc_spotlight_upgrade') && triggerButtonSpotlightTarget) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $a5Zx6.default), {
        name: triggerButtonSpotlightTarget,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $fPBr2.Pulse), {
            radius: 3,
            pulse: enableTriggerPulse,
            children: buttonToRender
        })
    });
    return buttonToRender;
}
$904dcc644e4e6738$var$TriggerButtonInner.displayName = "TriggerButtonInner";
const $904dcc644e4e6738$export$4129321aecd13375 = (0, $8ApsA.withIntlProvider)($904dcc644e4e6738$var$TriggerButtonInner);

});
parcelRegister("8ApsA", function(module, exports) {
$parcel$export(module.exports, "withIntlProvider", () => $a1f15af40cb8558e$export$a5d940130f33be3f);
/* intlProvider.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $mhEfz = parcelRequire("mhEfz");

var $eWXlB = parcelRequire("eWXlB");

var $iIAFO = parcelRequire("iIAFO");
function $a1f15af40cb8558e$export$bca6b946a784e234(locale) {
    if ([
        'en-GB',
        'en-ZZ',
        'pt-PT',
        'zh-TW'
    ].includes(locale)) return locale;
    else if (locale === 'zh-HK') return 'zh-TW';
    return locale.split('-')[0];
}

























function $a1f15af40cb8558e$var$fetchLanguageFile(code) {
    switch(code){
        case 'cs':
            return (parcelRequire("3f0ib"));
        case 'da':
            return (parcelRequire("fPhRT"));
        case 'de':
            return (parcelRequire("l3CYP"));
        case 'en-GB':
            return (parcelRequire("8lw0T"));
        case 'en-ZZ':
            return (parcelRequire("35jDq"));
        case 'en':
            return Promise.resolve((parcelRequire("iIAFO")));
        case 'es':
            return (parcelRequire("lJ075"));
        case 'fi':
            return (parcelRequire("j5UK6"));
        case 'fr':
            return (parcelRequire("a22Vs"));
        case 'hu':
            return (parcelRequire("h476g"));
        case 'it':
            return (parcelRequire("2RWSw"));
        case 'ja':
            return (parcelRequire("2ygQB"));
        case 'ko':
            return (parcelRequire("64xG1"));
        case 'nb':
            return (parcelRequire("31xeP"));
        case 'nl':
            return (parcelRequire("b3CVo"));
        case 'pl':
            return (parcelRequire("WiUtz"));
        case 'pt':
            return (parcelRequire("hiqbu"));
        case 'ru':
            return (parcelRequire("g4ZeT"));
        case 'sv':
            return (parcelRequire("foBjK"));
        case 'th':
            return (parcelRequire("14TMe"));
        case 'tr':
            return (parcelRequire("hACtB"));
        case 'uk':
            return (parcelRequire("ad02O"));
        case 'vi':
            return (parcelRequire("jXCdl"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("faqaW"));
        case 'zh':
            return (parcelRequire("gMVTT"));
        default:
            throw new Error(`Unable to find translation for locale ${code}`);
    }
}
const $a1f15af40cb8558e$export$12346a674644c156 = 'operational';
const $a1f15af40cb8558e$export$515664faa1398f37 = 'navigation';
function $a1f15af40cb8558e$var$Provider({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    const loaderFn = async (locale)=>{
        const intlLocale = new Intl.Locale(locale.replace('_', '-'));
        try {
            const module = await $a1f15af40cb8558e$var$fetchLanguageFile($a1f15af40cb8558e$export$bca6b946a784e234(intlLocale.toString()));
            return module.default;
        } catch (e) {
            createAnalyticsEvent({
                eventType: $a1f15af40cb8558e$export$12346a674644c156,
                action: 'not_loaded',
                actionSubject: 'uc_i18n',
                attributes: {
                    locale: locale
                }
            }).fire($a1f15af40cb8558e$export$515664faa1398f37);
        }
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $eWXlB.default), {
        loaderFn: loaderFn,
        defaultMessages: (0, $iIAFO.default),
        children: children
    });
}
$a1f15af40cb8558e$var$Provider.displayName = "Provider";
const $a1f15af40cb8558e$export$a5d940130f33be3f = (WrappedComponent)=>(props)=>/*#__PURE__*/ (0, $5chsV.jsx)($a1f15af40cb8558e$var$Provider, {
            children: /*#__PURE__*/ (0, $5chsV.jsx)(WrappedComponent, {
                ...props
            })
        });

});
parcelRegister("3f0ib", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("1dTV0").then(()=>parcelRequire('8brXG'));

});

parcelRegister("fPhRT", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("6ujAL").then(()=>parcelRequire('FxCNw'));

});

parcelRegister("l3CYP", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("lQ7tG").then(()=>parcelRequire('7qTk8'));

});

parcelRegister("8lw0T", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("1TWcz").then(()=>parcelRequire('a9UY7'));

});

parcelRegister("35jDq", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("hadjF").then(()=>parcelRequire('4W2ey'));

});

parcelRegister("lJ075", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("eTMM3").then(()=>parcelRequire('3f4am'));

});

parcelRegister("j5UK6", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("7NyDp").then(()=>parcelRequire('cbPTS'));

});

parcelRegister("a22Vs", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("92TLm").then(()=>parcelRequire('aS41p'));

});

parcelRegister("h476g", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("ku3hs").then(()=>parcelRequire('7NBF8'));

});

parcelRegister("2RWSw", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("2vTr8").then(()=>parcelRequire('3sZbe'));

});

parcelRegister("2ygQB", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("3RKiO").then(()=>parcelRequire('7o301'));

});

parcelRegister("64xG1", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("kEizW").then(()=>parcelRequire('a4BBp'));

});

parcelRegister("31xeP", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("4lGTJ").then(()=>parcelRequire('8FtQJ'));

});

parcelRegister("b3CVo", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("2DWME").then(()=>parcelRequire('3ynpG'));

});

parcelRegister("WiUtz", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("egX4Q").then(()=>parcelRequire('rq0Eo'));

});

parcelRegister("hiqbu", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("di7G9").then(()=>parcelRequire('5KMTB'));

});

parcelRegister("g4ZeT", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("9AWmD").then(()=>parcelRequire('b8NYW'));

});

parcelRegister("foBjK", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("jlG7d").then(()=>parcelRequire('jjkY3'));

});

parcelRegister("14TMe", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("9HVV5").then(()=>parcelRequire('80Jj5'));

});

parcelRegister("hACtB", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("fcYhR").then(()=>parcelRequire('BAapE'));

});

parcelRegister("ad02O", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("4qeOw").then(()=>parcelRequire('4iyEe'));

});

parcelRegister("jXCdl", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("6KG1B").then(()=>parcelRequire('1gNWN'));

});

parcelRegister("faqaW", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("vV2T8").then(()=>parcelRequire('emTcI'));

});

parcelRegister("gMVTT", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("8Ab7I").then(()=>parcelRequire('8nUVU'));

});



parcelRegister("1M7xj", function(module, exports) {
$parcel$export(module.exports, "useJsChunkLoadTrack", () => $7af7343be4df1f38$export$1fd7afacc69597bb);

var $fsvuC = parcelRequire("fsvuC");

var $6kSlG = parcelRequire("6kSlG");

var $7Q0y6 = parcelRequire("7Q0y6");
const $7af7343be4df1f38$var$MODULE_ID = 'universal-create-popup-content';
function $7af7343be4df1f38$export$1fd7afacc69597bb() {
    const { fireJSChunkLoadTime: fireJSChunkLoadTime } = (0, $7Q0y6.useUniversalCreateAnalytics)();
    const hasFiredRef = (0, $fsvuC.useRef)(false);
    const loadStartTimesRef = (0, $fsvuC.useRef)(new Map());
    const handleLoadStart = (0, $fsvuC.useCallback)((event)=>{
        if (event.moduleId === $7af7343be4df1f38$var$MODULE_ID && !hasFiredRef.current) loadStartTimesRef.current.set(event.transactionId, performance.now());
    }, []);
    const handleLoadCompleteOrError = (0, $fsvuC.useCallback)((event)=>{
        const startTime = loadStartTimesRef.current.get(event.transactionId);
        if (startTime !== undefined) loadStartTimesRef.current.delete(event.transactionId);
        if (event.moduleId === $7af7343be4df1f38$var$MODULE_ID && startTime !== undefined && !hasFiredRef.current) {
            const loadTime = performance.now() - startTime;
            hasFiredRef.current = true;
            fireJSChunkLoadTime({
                durationInMs: loadTime,
                hasError: Boolean(event.error)
            });
        }
    }, [
        fireJSChunkLoadTime
    ]);
    (0, $6kSlG.useEventListener)('jsresource.load.start', handleLoadStart);
    (0, $6kSlG.useEventListener)('jsresource.load.complete', handleLoadCompleteOrError);
    (0, $6kSlG.useEventListener)('jsresource.load.error', handleLoadCompleteOrError);
}

});
parcelRegister("6kSlG", function(module, exports) {
$parcel$export(module.exports, "useEventListener", () => $dae90737f94710b3$export$7080b3e976bc91ab);

var $fsvuC = parcelRequire("fsvuC");

var $8PBMI = parcelRequire("8PBMI");
function $dae90737f94710b3$export$7080b3e976bc91ab(eventName, subscriber) {
    (0, $fsvuC.useEffect)(()=>{
        return (0, $8PBMI.eventEmitter).on(eventName, subscriber);
    }, [
        eventName,
        subscriber
    ]);
}

});


parcelRegister("fK8qN", function(module, exports) {
$parcel$export(module.exports, "popupContentEntryPoint", () => $df858c14c96e9a76$export$8970f497f10bcb6);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

const $df858c14c96e9a76$export$8970f497f10bcb6 = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("aqnPs")), {
        moduleId: "e062cabf",
        moduleName: "PopupContent",
        priority: "interaction",
        moduleId: 'universal-create-popup-content'
    }),
    getPreloadProps: (_params)=>({
            queries: {},
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("1214c", function(module, exports) {
$parcel$export(module.exports, "JSResourceForInteraction", () => $21791d47c1c52261$export$e83743682263315a);

var $e5O57 = parcelRequire("e5O57");

var $v4B04 = parcelRequire("v4B04");

var $7FXYZ = parcelRequire("7FXYZ");
const $21791d47c1c52261$var$cache = (0, $e5O57.createCache)(new Map());
/** Message when a string path reaches runtime (expected: build rewrites it to a loader). */ const $21791d47c1c52261$var$RUNTIME_STRING_ERROR = "JSResourceForInteraction was called with a string path at runtime. Ensure @atlassian/react-async-transformer is applied to transform this to a dynamic import.";
function $21791d47c1c52261$export$e83743682263315a(loaderOrPath, opts) {
    if (typeof loaderOrPath === 'string') throw new Error(`${$21791d47c1c52261$var$RUNTIME_STRING_ERROR} String path: ${JSON.stringify(loaderOrPath)}`);
    const { chain: chain } = opts ?? {};
    return $21791d47c1c52261$var$cache.get(opts.moduleId, ()=>(0, $v4B04.PreloadableJSResource)(()=>(0, $7FXYZ.postTask)(chain ? ()=>chain(Promise.resolve(loaderOrPath())) : loaderOrPath, {
                priority: 'user-visible'
            }), opts));
}

});

parcelRegister("l9vc0", function(module, exports) {
$parcel$export(module.exports, "createEntryPoint", () => $3454c9d47b985654$export$fa00dd5c1a75592f);
/* eslint-disable @typescript-eslint/no-empty-object-type */ function $3454c9d47b985654$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}

});

parcelRegister("aqnPs", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("iMqVv").then(()=>parcelRequire('iyPk0'));

});




parcelRegister("7Ztz8", function(module, exports) {
$parcel$export(module.exports, "default", () => $e95380f479b02f97$export$2e2bcd8739ae039);

var $kiWGn = parcelRequire("kiWGn");
function $e95380f479b02f97$var$traceUFOPress(name, timestamp) {
    return (0, $kiWGn.default)(name, 'press', timestamp);
}
var $e95380f479b02f97$export$2e2bcd8739ae039 = $e95380f479b02f97$var$traceUFOPress;

});
parcelRegister("kiWGn", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ca6ed5083c8e5ef$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.

var $17hIO = parcelRequire("17hIO");

var $bN1y6 = parcelRequire("bN1y6");

var $6J97j = parcelRequire("6J97j");

var $aXWJz = parcelRequire("aXWJz");

var $ktNMP = parcelRequire("ktNMP");

var $9LG40 = parcelRequire("9LG40");

var $8IAtM = parcelRequire("8IAtM");

var $kAAlR = parcelRequire("kAAlR");
function $9ca6ed5083c8e5ef$var$traceUFOInteraction(name, interactionType, startTime) {
    if (!(0, $6J97j.isUFOEnabled)()) return;
    const rate = (0, $6J97j.getInteractionRate)(name, interactionType);
    const pressInteractionsList = (0, $6J97j.getDoNotAbortActivePressInteraction)();
    const minorInteractions = (pressInteractionsList ?? []).concat((0, $6J97j.getMinorInteractions)() ?? []);
    if (minorInteractions.includes(name)) {
        const activeInteraction = (0, $8IAtM.getActiveInteraction)();
        activeInteraction?.minorInteractions?.push({
            name: name,
            startTime: startTime ?? performance.now()
        });
        return;
    } else (0, $8IAtM.abortAll)('new_interaction', name);
    if ((0, $bN1y6.default)(rate)) {
        const startTimestamp = startTime ?? performance.now();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $17hIO.default)();
        (0, $9LG40.default).current = newId;
        // covered experiences with tracing instrumentation:
        // inline-result.inline-card-create-submit
        (0, $ktNMP.setInteractionActiveTrace)(newId, interactionType);
        (0, $8IAtM.addNewInteraction)(newId, name, interactionType === 'hover' ? 'press' : interactionType, startTimestamp, rate, [], (0, $kAAlR.default).current, (0, $aXWJz.getActiveTrace)());
    }
}
var $9ca6ed5083c8e5ef$export$2e2bcd8739ae039 = $9ca6ed5083c8e5ef$var$traceUFOInteraction;

});


parcelRegister("6eJAW", function(module, exports) {
$parcel$export(module.exports, "setInteractionError", () => $b27fd3617e45bcdf$export$5b689ca7b019e89f);

var $8IAtM = parcelRequire("8IAtM");
function $b27fd3617e45bcdf$export$5b689ca7b019e89f(interactionName, error) {
    const interaction = (0, $8IAtM.getActiveInteraction)();
    if (!interaction) return;
    if (interaction.ufoName !== interactionName) return;
    (0, $8IAtM.addError)(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
}

});

parcelRegister("1TBsX", function(module, exports) {
$parcel$export(module.exports, "default", () => $1617fd7bf9f5fd3c$export$2e2bcd8739ae039);

var $6K52q = parcelRequire("6K52q");

var $2d6mV = parcelRequire("2d6mV");
parcelRequire("4vcfT");
var $T5sq6 = parcelRequire("T5sq6");

var $bLbrK = parcelRequire("bLbrK");
var $kFD4l = parcelRequire("kFD4l");

var $e4PpU = parcelRequire("e4PpU");

var $jHWTs = parcelRequire("jHWTs");

var $do7Gh = parcelRequire("do7Gh");
function $1617fd7bf9f5fd3c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1617fd7bf9f5fd3c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1617fd7bf9f5fd3c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6K52q.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1617fd7bf9f5fd3c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $1617fd7bf9f5fd3c$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $1617fd7bf9f5fd3c$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $1617fd7bf9f5fd3c$export$2e2bcd8739ae039 {
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $6K52q.default)(this, "fallbackArtifactMap", new Map());
        (0, $6K52q.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $T5sq6.StorageClient)($1617fd7bf9f5fd3c$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $jHWTs.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $2d6mV.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $bLbrK.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $e4PpU.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$1617fd7bf9f5fd3c$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = Math.random() < 0.001 ? (0, $do7Gh.flightDeckClientExperience)() : new (0, $kFD4l.MockExperience)();
        experience.start();
        try {
            const artifactWithKey = $1617fd7bf9f5fd3c$var$_objectSpread($1617fd7bf9f5fd3c$var$_objectSpread({}, artifact), {}, {
                key: (0, $jHWTs.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $do7Gh.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
}

});
parcelRegister("2d6mV", function(module, exports) {
$parcel$export(module.exports, "retryOnException", () => $c31374bd499c5878$export$1d94629c94e7a17f);

var $4HFTd = parcelRequire("4HFTd");

var $fCoBL = parcelRequire("fCoBL");

var $9RNfo = parcelRequire("9RNfo");

var $lXet4 = parcelRequire("lXet4");
const $c31374bd499c5878$var$NO_CALLS_ERROR = 'No calls made';
const $c31374bd499c5878$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $fCoBL.NO_RETRIES), retryOn: retryOn = [
    (0, $9RNfo.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($c31374bd499c5878$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await (0, $lXet4.wait)(nextMSInterval);
        if (onRetry && error.message !== $c31374bd499c5878$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $4HFTd.convertToError)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};

});
parcelRegister("fCoBL", function(module, exports) {
$parcel$export(module.exports, "NO_RETRIES", () => $2d595bc3be8ba0fd$export$a0a1c8f90becc136);
const $2d595bc3be8ba0fd$export$a0a1c8f90becc136 = [];
const $2d595bc3be8ba0fd$export$972171517b12aa4 = [
    0,
    0
];
const $2d595bc3be8ba0fd$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $2d595bc3be8ba0fd$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("9RNfo", function(module, exports) {
$parcel$export(module.exports, "FailedFetchError", () => $640d0972cc08316d$export$558a29265b4c0def);
$parcel$export(module.exports, "default", () => $640d0972cc08316d$export$2e2bcd8739ae039);
class $640d0972cc08316d$export$558a29265b4c0def extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}
var $640d0972cc08316d$export$2e2bcd8739ae039 = $640d0972cc08316d$export$558a29265b4c0def;

});

parcelRegister("lXet4", function(module, exports) {
$parcel$export(module.exports, "wait", () => $558f47abe293c7c6$export$5c069c93d2b7493f);
const $558f47abe293c7c6$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });

});


parcelRegister("4vcfT", function(module, exports) {
$parcel$export(module.exports, "StorageClient", () => (parcelRequire("T5sq6")).StorageClient);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $T5sq6 = parcelRequire("T5sq6");

var $7a38343cd0911cb1$export$2e2bcd8739ae039 = (0, $T5sq6.StorageClient);

});

parcelRegister("bLbrK", function(module, exports) {
$parcel$export(module.exports, "fetchFlightDeckConfiguration", () => $88fcf68d33c7a5ac$export$6026918e023c9101);

var $chi7W = parcelRequire("chi7W");

var $5GzG2 = parcelRequire("5GzG2");

var $dVRUr = parcelRequire("dVRUr");

var $ehkT8 = parcelRequire("ehkT8");

var $h7D7v = parcelRequire("h7D7v");

var $kFD4l = parcelRequire("kFD4l");

var $cLbEm = parcelRequire("cLbEm");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $88fcf68d33c7a5ac$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $88fcf68d33c7a5ac$var$defaultPerimeter = "commercial";
async function $88fcf68d33c7a5ac$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter, _dim$impactLevel;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $88fcf68d33c7a5ac$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $88fcf68d33c7a5ac$var$defaultPerimeter;
    // Needed for backwards compatibility with Flight Deck core, reference perimeter
    const impactLevel = (_dim$impactLevel = dim.impactLevel) !== null && _dim$impactLevel !== void 0 ? _dim$impactLevel : perimeter;
    const environment = $88fcf68d33c7a5ac$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $chi7W.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        impactLevel: impactLevel,
        environment: environment,
        locale: locale
    };
    const client = await $88fcf68d33c7a5ac$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $88fcf68d33c7a5ac$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $88fcf68d33c7a5ac$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $88fcf68d33c7a5ac$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $88fcf68d33c7a5ac$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $88fcf68d33c7a5ac$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $kFD4l.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $kFD4l.getVersionMetadataFetchExperience)();
    return new (0, $h7D7v.ConfigClient)(new (0, $dVRUr.BifrostDataSource)(new (0, $ehkT8.BifrostHttpClientImpl)(env, perimeter), (0, $5GzG2.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $88fcf68d33c7a5ac$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("chi7W", function(module, exports) {
$parcel$export(module.exports, "default", () => $524a853eaa1c474b$export$2e2bcd8739ae039);
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $524a853eaa1c474b$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $524a853eaa1c474b$export$2e2bcd8739ae039 = $524a853eaa1c474b$export$852ff24d0930c62f;

});

parcelRegister("5GzG2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $hUZOC = parcelRequire("hUZOC");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $hUZOC.Either;
    }
});

var $4KJVU = parcelRequire("4KJVU");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $4KJVU.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $4KJVU.tryGetArtifactData;
    }
});

var $9MKfH = parcelRequire("9MKfH");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $9MKfH.parseArtifactManifest;
    }
});

var $5pwkU = parcelRequire("5pwkU");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $5pwkU.parseVersionMetadata;
    }
});

var $dWHto = parcelRequire("dWHto");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $dWHto.checkManifest;
    }
});

var $16agm = parcelRequire("16agm");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $16agm.ConfigRegistryDataSource;
    }
});

var $co5Ko = parcelRequire("co5Ko");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $co5Ko.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $co5Ko.Versions;
    }
});

});
parcelRegister("hUZOC", function(module, exports) {
"use strict";
var $d0b79de837acc0d6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $d0b79de837acc0d6$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $d0b79de837acc0d6$var$Right(value);
    };
    Either.left = function(error) {
        return new $d0b79de837acc0d6$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $d0b79de837acc0d6$var$Either;
var $d0b79de837acc0d6$var$Right = /** @class */ function(_super) {
    $d0b79de837acc0d6$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $d0b79de837acc0d6$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $d0b79de837acc0d6$var$Either.right(this.right);
    };
    return Right;
}($d0b79de837acc0d6$var$Either);
var $d0b79de837acc0d6$var$Left = /** @class */ function(_super) {
    $d0b79de837acc0d6$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $d0b79de837acc0d6$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $d0b79de837acc0d6$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $d0b79de837acc0d6$var$Either.left(f(this.left));
    };
    return Left;
}($d0b79de837acc0d6$var$Either);

});

parcelRegister("4KJVU", function(module, exports) {
"use strict";
var $375f16a0e29345ab$var$__assign = module.exports && module.exports.__assign || function() {
    $375f16a0e29345ab$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $375f16a0e29345ab$var$__assign.apply(this, arguments);
};
var $375f16a0e29345ab$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $375f16a0e29345ab$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $375f16a0e29345ab$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $375f16a0e29345ab$var$tryGetArtifactData;

var $c73hE = parcelRequire("c73hE");

var $5GzG2 = parcelRequire("5GzG2");

var $4FDsM = parcelRequire("4FDsM");

var $9QQSk = parcelRequire("9QQSk");

var $5DQNN = parcelRequire("5DQNN");
function $375f16a0e29345ab$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $375f16a0e29345ab$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $375f16a0e29345ab$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $375f16a0e29345ab$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $375f16a0e29345ab$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $5GzG2.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $4FDsM.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $375f16a0e29345ab$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $9QQSk.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $375f16a0e29345ab$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $375f16a0e29345ab$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $375f16a0e29345ab$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $c73hE.interpolateTagScheme)(manifest.tagScheme, $375f16a0e29345ab$var$__assign($375f16a0e29345ab$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $375f16a0e29345ab$var$__awaiter(_this, void 0, void 0, function() {
                                return $375f16a0e29345ab$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $375f16a0e29345ab$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $5DQNN.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $5DQNN.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $9QQSk.assertUnreachable)(artifact);
    }
}

});
parcelRegister("c73hE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $8d18af92ad3924bd$var$interpolateTagScheme;
module.exports.generateTagScheme = $8d18af92ad3924bd$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $8d18af92ad3924bd$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $8d18af92ad3924bd$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $8d18af92ad3924bd$var$getVersionMetadataTag;
const $8d18af92ad3924bd$var$TAG_SCHEME_VERSION = 2;
function $8d18af92ad3924bd$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($8d18af92ad3924bd$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $8d18af92ad3924bd$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $8d18af92ad3924bd$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $8d18af92ad3924bd$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $8d18af92ad3924bd$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $8d18af92ad3924bd$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $8d18af92ad3924bd$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $8d18af92ad3924bd$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("4FDsM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $36699a54ec4a9f52$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $36699a54ec4a9f52$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("9QQSk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $72c1fc4c6c1204a9$var$assertUnreachable;
function $72c1fc4c6c1204a9$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("5DQNN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $41b98dad4e0a386e$var$toJson;
module.exports.toPrettyJson = $41b98dad4e0a386e$var$toPrettyJson;
function $41b98dad4e0a386e$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $41b98dad4e0a386e$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});


parcelRegister("9MKfH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $71fc7974e02ab542$var$parseArtifactManifest;

var $8ZlRh = parcelRequire("8ZlRh");
function $71fc7974e02ab542$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $8ZlRh.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $8ZlRh.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $71fc7974e02ab542$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $8ZlRh.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $71fc7974e02ab542$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $71fc7974e02ab542$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $8ZlRh.parseUnknownObject)(dimensions);
    var supported = (0, $8ZlRh.parseArray)(unparsedDimensions.supported).map($8ZlRh.parseString);
    var fallback = (0, $8ZlRh.parseUndefinedOr)($8ZlRh.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $71fc7974e02ab542$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $8ZlRh.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $71fc7974e02ab542$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $71fc7974e02ab542$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $8ZlRh.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $8ZlRh.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $8ZlRh.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $8ZlRh.parseUndefinedOr)($8ZlRh.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $71fc7974e02ab542$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $71fc7974e02ab542$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});
parcelRegister("8ZlRh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $68b4f9d5b04dbd2f$var$parseString;
module.exports.parseArray = $68b4f9d5b04dbd2f$var$parseArray;
module.exports.parseBoolean = $68b4f9d5b04dbd2f$var$parseBoolean;
module.exports.parseUnknownObject = $68b4f9d5b04dbd2f$var$parseUnknownObject;
module.exports.parseUndefinedOr = $68b4f9d5b04dbd2f$var$parseUndefinedOr;
function $68b4f9d5b04dbd2f$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $68b4f9d5b04dbd2f$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $68b4f9d5b04dbd2f$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $68b4f9d5b04dbd2f$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $68b4f9d5b04dbd2f$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});


parcelRegister("5pwkU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $3f085ed46d87c0c0$var$parseVersionMetadata;

var $8ZlRh = parcelRequire("8ZlRh");
function $3f085ed46d87c0c0$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $8ZlRh.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $8ZlRh.parseString)(unknownObject.version);
    var publishTime = new Date((0, $8ZlRh.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $8ZlRh.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("dWHto", function(module, exports) {
"use strict";
var $a27269faec5f74fb$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $a27269faec5f74fb$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $a27269faec5f74fb$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $a27269faec5f74fb$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("16agm", function(module, exports) {
"use strict";
var $0cce4ff5de5ce396$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0cce4ff5de5ce396$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $c73hE = parcelRequire("c73hE");

var $hUZOC = parcelRequire("hUZOC");

var $9MKfH = parcelRequire("9MKfH");

var $5pwkU = parcelRequire("5pwkU");
var $0cce4ff5de5ce396$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $0cce4ff5de5ce396$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $0cce4ff5de5ce396$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $c73hE.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($9MKfH.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $hUZOC.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $0cce4ff5de5ce396$var$__awaiter(this, void 0, void 0, function() {
            return $0cce4ff5de5ce396$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $0cce4ff5de5ce396$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $0cce4ff5de5ce396$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $c73hE.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $5pwkU.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $0cce4ff5de5ce396$var$ConfigRegistryDataSource;

});

parcelRegister("co5Ko", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $904c2f377c86432a$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $904c2f377c86432a$var$BaseUrls;
var $904c2f377c86432a$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $904c2f377c86432a$var$Versions;

});


parcelRegister("dVRUr", function(module, exports) {
$parcel$export(module.exports, "BifrostDataSource", () => $a24a6a804ac1c85a$export$2cb8d79200775058);

var $5GzG2 = parcelRequire("5GzG2");

var $c73hE = parcelRequire("c73hE");
class $a24a6a804ac1c85a$export$2cb8d79200775058 {
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
    async getLatestVersionMetadata() {
        const tag = (0, $c73hE.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $5GzG2.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $5GzG2.parseVersionMetadata)(response);
                return (0, $5GzG2.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $5GzG2.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $c73hE.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $5GzG2.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $5GzG2.parseArtifactManifest)(response);
                return (0, $5GzG2.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $5GzG2.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
}

});

parcelRegister("ehkT8", function(module, exports) {
$parcel$export(module.exports, "BifrostHttpClientImpl", () => $a652db32dfa2c3e4$export$45c6d12ca9c14f83);

var $5GzG2 = parcelRequire("5GzG2");
function $a652db32dfa2c3e4$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $a652db32dfa2c3e4$export$45c6d12ca9c14f83 {
    constructor(env, perimeter){
        this.baseUrl = $a652db32dfa2c3e4$export$f654b28f82155665(env, perimeter);
    }
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $5GzG2.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $5GzG2.Either).right(json)));
            }).catch((error)=>resolve((0, $5GzG2.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
}

});

parcelRegister("h7D7v", function(module, exports) {
$parcel$export(module.exports, "ConfigClient", () => $c7716f8fb604305a$export$8489e2f039bfcc4c);

var $6K52q = parcelRequire("6K52q");

var $5GzG2 = parcelRequire("5GzG2");

var $1dcXN = parcelRequire("1dcXN");
function $c7716f8fb604305a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c7716f8fb604305a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c7716f8fb604305a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6K52q.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c7716f8fb604305a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $c7716f8fb604305a$export$8489e2f039bfcc4c {
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $1dcXN.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $c7716f8fb604305a$var$_objectSpread($c7716f8fb604305a$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $5GzG2.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $5GzG2.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
}

});
parcelRegister("1dcXN", function(module, exports) {
$parcel$export(module.exports, "ExperienceDataSourceWrapper", () => $0e210f9b58865422$export$1cc944571619e6e8);
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $0e210f9b58865422$export$1cc944571619e6e8 {
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
}

});


parcelRegister("kFD4l", function(module, exports) {
$parcel$export(module.exports, "MockExperience", () => $f0c5f14e82578118$export$5e7536cf7bc56fee);
$parcel$export(module.exports, "getFlightDeckFetchExperience", () => $f0c5f14e82578118$export$a3006f8f221c0a3b);
$parcel$export(module.exports, "getVersionMetadataFetchExperience", () => $f0c5f14e82578118$export$c3ac7702bfd47c1b);
const $f0c5f14e82578118$var$SAMPLING_RATE = 10;
class $f0c5f14e82578118$var$UFOExperienceWrapper {
    constructor(experience){
        this.experience = experience;
    }
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
}
class $f0c5f14e82578118$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $f0c5f14e82578118$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $f0c5f14e82578118$var$SAMPLING_RATE) return new $f0c5f14e82578118$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("8TpeQ"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $f0c5f14e82578118$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $f0c5f14e82578118$export$5e7536cf7bc56fee();
    }
}
const $f0c5f14e82578118$export$a3006f8f221c0a3b = ()=>$f0c5f14e82578118$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $f0c5f14e82578118$export$c3ac7702bfd47c1b = ()=>$f0c5f14e82578118$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("8TpeQ", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("3XqmV").then(()=>parcelRequire('hDbXa'));

});


parcelRegister("cLbEm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $uCcdp = parcelRequire("uCcdp");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $uCcdp.parseConfigWithTargeting;
    }
});

var $3Sdy6 = parcelRequire("3Sdy6");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $3Sdy6.TargetedConfig;
    }
});

});
parcelRegister("uCcdp", function(module, exports) {
"use strict";
var $05c06e641c32d46e$var$__assign = module.exports && module.exports.__assign || function() {
    $05c06e641c32d46e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $05c06e641c32d46e$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $05c06e641c32d46e$var$parseConfigWithTargeting;

var $3Sdy6 = parcelRequire("3Sdy6");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $05c06e641c32d46e$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $05c06e641c32d46e$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $3Sdy6.TargetedConfig({
                defaultConfig: $05c06e641c32d46e$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $05c06e641c32d46e$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $3Sdy6.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $05c06e641c32d46e$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $05c06e641c32d46e$var$__assign($05c06e641c32d46e$var$__assign({}, accObject), (_a = {}, _a[key] = $05c06e641c32d46e$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $05c06e641c32d46e$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $05c06e641c32d46e$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $05c06e641c32d46e$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $05c06e641c32d46e$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $05c06e641c32d46e$var$parseIdentifierList(target.orgIds),
            siteIds: $05c06e641c32d46e$var$parseIdentifierList(target.siteIds),
            userIds: $05c06e641c32d46e$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $05c06e641c32d46e$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("3Sdy6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $2d20ecd02cfc27d2$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $2d20ecd02cfc27d2$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $2d20ecd02cfc27d2$var$TargetedConfig;
function $2d20ecd02cfc27d2$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("e4PpU", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3f952c1407bb045$export$2e2bcd8739ae039);
class $a3f952c1407bb045$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
        this.perimeter = dimensions === null || dimensions === void 0 ? void 0 : dimensions.perimeter;
    }
}
const $a3f952c1407bb045$export$1d76d155060824c9 = (e)=>e instanceof $a3f952c1407bb045$export$2e2bcd8739ae039;

});

parcelRegister("jHWTs", function(module, exports) {
$parcel$export(module.exports, "artifactKey", () => $e58fb77cdd53dc39$export$e3553dc63541d477);
const $e58fb77cdd53dc39$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("do7Gh", function(module, exports) {
$parcel$export(module.exports, "flightDeckClientExperience", () => $9bf379858ac33972$export$1e3a41a51f6457c5);
$parcel$export(module.exports, "exceptionToMetadata", () => $9bf379858ac33972$export$f33622abb5224195);

var $6K52q = parcelRequire("6K52q");

var $8nBFK = parcelRequire("8nBFK");
var $8YRrB = parcelRequire("8YRrB");
function $9bf379858ac33972$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9bf379858ac33972$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9bf379858ac33972$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6K52q.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9bf379858ac33972$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $9bf379858ac33972$export$1e3a41a51f6457c5 = ()=>new (0, $8YRrB.UFOExperience)("retrieve-artifact", {
        type: (0, $8nBFK.ExperienceTypes).Operation,
        performanceType: (0, $8nBFK.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $9bf379858ac33972$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $9bf379858ac33972$var$_objectSpread($9bf379858ac33972$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});


parcelRegister("l74la", function(module, exports) {
$parcel$export(module.exports, "MenuListItem", () => $bc0b04a482452ce9$export$6c2f3257abc4825b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1ofmy = parcelRequire("1ofmy");
const $bc0b04a482452ce9$export$6c2f3257abc4825b = (0, $1ofmy.ListItem);

});
parcelRegister("1ofmy", function(module, exports) {
$parcel$export(module.exports, "ListItem", () => $b66cdabf14f7060b$export$a7b06bfba60a8a78);
/* list-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
function $b66cdabf14f7060b$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId,
        children: children
    });
}
const $b66cdabf14f7060b$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $fsvuC.forwardRef)($b66cdabf14f7060b$var$_ListItem);

});


parcelRegister("fZhOI", function(module, exports) {
$parcel$export(module.exports, "defaultMemoize", () => $ba3a5f9a7bddba2c$export$281bff7f05488aa2, (v) => $ba3a5f9a7bddba2c$export$281bff7f05488aa2 = v);
$parcel$export(module.exports, "createSelectorCreator", () => $ba3a5f9a7bddba2c$export$5943f4447f6ef248, (v) => $ba3a5f9a7bddba2c$export$5943f4447f6ef248 = v);
$parcel$export(module.exports, "createStructuredSelector", () => $ba3a5f9a7bddba2c$export$75979cfcd91bf38f, (v) => $ba3a5f9a7bddba2c$export$75979cfcd91bf38f = v);
$parcel$export(module.exports, "createSelector", () => $ba3a5f9a7bddba2c$export$595d22ed68ca2841, (v) => $ba3a5f9a7bddba2c$export$595d22ed68ca2841 = v);
var $ba3a5f9a7bddba2c$export$1e511d4a378977f5;
var $ba3a5f9a7bddba2c$export$281bff7f05488aa2;
var $ba3a5f9a7bddba2c$export$5943f4447f6ef248;
var $ba3a5f9a7bddba2c$export$75979cfcd91bf38f;
var $ba3a5f9a7bddba2c$export$595d22ed68ca2841;
'use strict';
$ba3a5f9a7bddba2c$export$1e511d4a378977f5 = true;
$ba3a5f9a7bddba2c$export$281bff7f05488aa2 = $ba3a5f9a7bddba2c$var$defaultMemoize;
$ba3a5f9a7bddba2c$export$5943f4447f6ef248 = $ba3a5f9a7bddba2c$var$createSelectorCreator;
$ba3a5f9a7bddba2c$export$75979cfcd91bf38f = $ba3a5f9a7bddba2c$var$createStructuredSelector;
function $ba3a5f9a7bddba2c$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $ba3a5f9a7bddba2c$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function $ba3a5f9a7bddba2c$var$defaultMemoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ba3a5f9a7bddba2c$var$defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!$ba3a5f9a7bddba2c$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function $ba3a5f9a7bddba2c$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function $ba3a5f9a7bddba2c$var$createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $ba3a5f9a7bddba2c$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = $ba3a5f9a7bddba2c$var$defaultMemoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var $ba3a5f9a7bddba2c$var$createSelector = $ba3a5f9a7bddba2c$export$595d22ed68ca2841 = $ba3a5f9a7bddba2c$var$createSelectorCreator($ba3a5f9a7bddba2c$var$defaultMemoize);
function $ba3a5f9a7bddba2c$var$createStructuredSelector(selectors) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ba3a5f9a7bddba2c$var$createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}

});

parcelRegister("hGaNX", function(module, exports) {
$parcel$export(module.exports, "EditionAwareness", () => $cfa4de2fef3d71a4$export$a55b02efe3d62583);

var $5chsV = parcelRequire("5chsV");

var $kjN90 = parcelRequire("kjN90");

var $fsvuC = parcelRequire("fsvuC");

var $iNT4o = parcelRequire("iNT4o");

var $5Y9N2 = parcelRequire("5Y9N2");

var $bGnNF = parcelRequire("bGnNF");

var $jbwXy = parcelRequire("jbwXy");

var $cDOGs = parcelRequire("cDOGs");

var $gtiPr = parcelRequire("gtiPr");

var $eOaYv = parcelRequire("eOaYv");

var $j88QB = parcelRequire("j88QB");

var $g7JRw = parcelRequire("g7JRw");

var $cYQj7 = parcelRequire("cYQj7");

var $e1Gsk = parcelRequire("e1Gsk");

var $7zHly = parcelRequire("7zHly");

var $lTNnt = parcelRequire("lTNnt");

var $84vV3 = parcelRequire("84vV3");

var $gvKck = parcelRequire("gvKck");

var $ccEDk = parcelRequire("ccEDk");

var $9anV8 = parcelRequire("9anV8");

var $5Cvkg = parcelRequire("5Cvkg");
const $cfa4de2fef3d71a4$var$PREDUNNING_LENGTH = 14;
const $cfa4de2fef3d71a4$var$MILLISECONDS_PER_DAY = 86400000;
/**
 * Edition awareness is used to communicate to customers about the current edition they have and if they should
 * - Add payment details
 * - Upgrade their edition
 *
 * This component deals with creating the context which is then used throughout the package to:
 * - Track analytics
 * - Know which product/edition/cloud id is being used
 * - Know when to show/hide the button
 */ function $cfa4de2fef3d71a4$var$EditionAwarenessImpl(props) {
    const { cloudId: cloudId, product: product, edition: edition, orgId: orgId, userId: userId, userDisplayName: userDisplayName, userEmail: userEmail, userRoles: userRolesFromProduct, environment: environment, entitlementId: entitlementIdFromProduct, siteTraits: siteTraits = [], canRender: canRender, currentRoute: currentRoute, premiumFeatureHighlightToggle: premiumFeatureHighlightToggle, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen, PremiumWrapper: PremiumWrapper, getAction: getAction, showFlag: showFlag, hideFlag: hideFlag, hasDismissedButton: hasDismissedButton, onDismissButton: onDismissButton } = props;
    const queryConfig = (0, $7zHly.getQueryConfig)(product, edition, cloudId, userRolesFromProduct, entitlementIdFromProduct);
    const data = (0, $iNT4o.useLazyLoadQuery)((0, $kjN90.default), queryConfig);
    const entitlementInfo = data?.tenantContexts?.[0]?.entitlementInfo;
    const entitlement = entitlementInfo?.entitlement;
    const entitlementId = entitlementInfo?.entitlementId ?? entitlementIdFromProduct;
    const transactionAccounts = data?.tenantContexts?.[0]?.transactionAccounts;
    const canBundleCollection = !!transactionAccounts && transactionAccounts.length > 0 && transactionAccounts.every((txa)=>txa?.isCurrentUserBillingAdmin === true);
    const siteTraitsForContext = (0, $fsvuC.useMemo)(()=>(0, $lTNnt.getSiteTraitValues)(siteTraits), [
        siteTraits
    ]);
    const standardToPremiumTraitKey = (0, $gvKck.STANDARD_TO_PREMIUM_TRAIT_ELIGIBILITY)[product];
    // This entitlement was filter because was not on trial or predunning, but use the traits to validate is indeed a paid site
    const isEligibleForStandardToPremium = Boolean(edition === 'standard' && !entitlement && standardToPremiumTraitKey && siteTraitsForContext[standardToPremiumTraitKey]);
    const invoiceGroupInvoiceable = entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable;
    const invoiceableStatus = isEligibleForStandardToPremium || invoiceGroupInvoiceable === true ? 'INVOICEABLE' : invoiceGroupInvoiceable === false ? 'NOT_INVOICEABLE' : 'UNKNOWN';
    const invoiceGroupPaymentConfig = entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities?.configurePaymentV2;
    const canAddInvoiceGroupPayment = invoiceGroupPaymentConfig ? Boolean(invoiceGroupPaymentConfig.isAvailableToUser && invoiceGroupPaymentConfig.experienceUrl) : null;
    const transactionAccountPaymentConfig = entitlement?.transactionAccount?.experienceCapabilities?.addPaymentMethodV2;
    const canAddTxaPayment = transactionAccountPaymentConfig ? Boolean(transactionAccountPaymentConfig.isAvailableToUser && transactionAccountPaymentConfig.experienceUrl) : null;
    // Use invoice group configurePaymentV2 to determine can add payment and experience url by default
    // If invoice group does not exist (for example free edition skip trial scenario), fall back to txa addPaymentMethodV2 if possible
    const canAddPaymentDetails = canAddInvoiceGroupPayment ?? canAddTxaPayment;
    const addPaymentDetailsExperienceUrl = invoiceGroupPaymentConfig ? invoiceGroupPaymentConfig.experienceUrl : edition === 'free' ? transactionAccountPaymentConfig?.experienceUrl : null;
    const hasPaymentDetailsEntered = isEligibleForStandardToPremium ? true : Boolean(invoiceGroupInvoiceable ?? entitlement?.transactionAccount?.isBillToPresent);
    const trialTimeLeft = entitlement?.subscription?.trial?.timeLeft ?? undefined;
    const trialDaysLeft = (0, $cDOGs.getTrialDaysLeft)(trialTimeLeft);
    const trialStartTimestamp = entitlement?.subscription?.trial?.startTimestamp;
    const trialStartDate = (0, $fsvuC.useMemo)(()=>trialStartTimestamp ? new Date(trialStartTimestamp) : undefined, [
        trialStartTimestamp
    ]);
    const trialEndTimestamp = entitlement?.subscription?.trial?.endTimestamp;
    const trialEndDate = (0, $fsvuC.useMemo)(()=>trialEndTimestamp ? new Date(trialEndTimestamp) : undefined, [
        trialEndTimestamp
    ]);
    const trialLengthDays = entitlement?.offering?.trial?.lengthDays ?? undefined;
    const isInTrial = Boolean(trialDaysLeft && trialDaysLeft > 0);
    const isEntitlementPredunningStatus = entitlement?.preDunning?.status;
    const isCollectionEntitlementPredunningStatus = entitlement?.relatesFromEntitlementsWithCollectionType?.[0]?.entitlement?.preDunning?.status;
    const isInPredunning = (isEntitlementPredunningStatus === 'IN_PRE_DUNNING' || isCollectionEntitlementPredunningStatus === 'IN_PRE_DUNNING') && invoiceableStatus === 'NOT_INVOICEABLE';
    const { isInCollection: isInCollection, collectionEntitlementId: collectionEntitlementId } = (0, $fsvuC.useMemo)(()=>{
        // The COLLECTION-filtered alias is the single source of truth for collection membership.
        // The query filters it on `relationshipTypes: "COLLECTION"`, so every entry it returns is
        // already a collection relationship and there is no need to match on `relationshipType`.
        const collectionRelationships = entitlement?.relatesFromEntitlementsWithCollectionType;
        const collectionEntitlement = collectionRelationships?.[0];
        return {
            isInCollection: !entitlement || !collectionRelationships ? 'UNKNOWN' : // `entitlementId` is nullable in the schema, and consumers of
            // `collectionEntitlementId` build an entitlement ARI out of it (see
            // `collection-change-plan-popup`). Requiring it here keeps that id usable
            // whenever we report IN_COLLECTION.
            collectionEntitlement?.entitlementId ? 'IN_COLLECTION' : 'NOT_IN_COLLECTION',
            collectionEntitlementId: collectionEntitlement?.entitlementId
        };
    }, [
        entitlement
    ]);
    const isChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
    const changeOfferingToStandardExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
    const isDirectBuyChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2WithSkipTrial?.isAvailableToUser;
    const directBuyChangeOfferingToStandardExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2WithSkipTrial?.experienceUrl;
    const canUpgrade = // Site admin check is not added to the eligibility check, as all the other fields are site-level properties, while this one is at user-site level
    isEligibleForStandardToPremium && userRolesFromProduct?.includes('SITE_ADMIN') || Boolean(isChangeOfferingAvailable && changeOfferingToStandardExperienceUrl);
    const canDirectBuyUpgrade = Boolean(isDirectBuyChangeOfferingAvailable && directBuyChangeOfferingToStandardExperienceUrl);
    const transactionAccountId = entitlement?.transactionAccount?.key;
    const isEnterpriseCustomer = (0, $fsvuC.useMemo)(()=>{
        // The alias is already server-filtered to ENTERPRISE, so the `relationshipType`
        // check is redundant for real data. It is kept because Relay's MockPayloadGenerator
        // auto-fills unmocked alias fields with a bogus 1-element array (random
        // `relationshipType`, truthy `entitlementId`). Matching on `relationshipType` makes
        // those auto-filled entries fall through to non-enterprise instead of producing a
        // false-positive in tests that do not explicitly mock this alias.
        const enterpriseEntitlement = entitlement?.relatesFromEntitlementsWithEnterpriseType?.find((item)=>item?.relationshipType === 'ENTERPRISE');
        return !!enterpriseEntitlement?.entitlementId;
    }, [
        entitlement?.relatesFromEntitlementsWithEnterpriseType
    ]);
    const productCollection = (0, $e1Gsk.getProductCollection)(product);
    const collectionType = isInCollection === 'IN_COLLECTION' && productCollection?.isEnabled && productCollection?.collectionType || null;
    const userRoles = (0, $fsvuC.useMemo)(()=>{
        const roles = [
            ...userRolesFromProduct || []
        ];
        if (data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.transactionAccount?.isCurrentUserBillingAdmin) roles.push('BILLING_ADMIN');
        return roles;
    }, [
        data?.tenantContexts,
        userRolesFromProduct
    ]);
    // We need to use the `latestUsageForChargeElement` to get the licensed user count for both free and trialing customers
    const licensedUsersRaw = entitlement?.latestUsageForChargeElement;
    // Assumes that there are always at least one assigned user to cover scenarios
    const licensedUsers = Math.max(licensedUsersRaw || 0, 1);
    const isStorageLimitsExperimentEnabled = (0, $5Y9N2.default).getExperimentValue('jsmgrowth-267_enforce_storage_limits_servco_free', 'isEnabled', false);
    const isServiceCollectionFree = edition === 'free' && (product === 'jira-service-management' || product === 'jira-customer-service') && isStorageLimitsExperimentEnabled;
    // TODO: After fg cleanup for jsmgrowth-267_enforce_storage_limits_servco_free, we can
    // destructure criticalStorage directly and remove the manual
    // bytesToGigabytes fallbacks in storageUsageInGB / storageLimitInGB below.
    const criticalStorage = (0, $fsvuC.useMemo)(()=>{
        if (!isStorageLimitsExperimentEnabled) return undefined;
        if (isServiceCollectionFree) return (0, $cYQj7.getMostCriticalStorage)([
            data.jsm_storage && {
                ...data.jsm_storage,
                product: 'jira-service-management'
            },
            data.csm_storage && {
                ...data.csm_storage,
                product: 'jira-customer-service'
            }
        ]);
        if ((0, $84vV3.isProductOneOf)(product, [
            'jira',
            'jira-product-discovery'
        ]) && data.jira) return (0, $cYQj7.getMostCriticalStorage)([
            {
                ...data.jira,
                product: product
            }
        ]);
        return undefined;
    }, [
        data.csm_storage,
        data.jira,
        data.jsm_storage,
        isServiceCollectionFree,
        isStorageLimitsExperimentEnabled,
        product
    ]);
    const storageUsageInGB = (0, $fsvuC.useMemo)(()=>{
        if (criticalStorage && isStorageLimitsExperimentEnabled) return criticalStorage.storageUsageInGB;
        const JIRA_STORAGE_PRODUCTS = isStorageLimitsExperimentEnabled ? [
            'jira',
            'jira-product-discovery'
        ] : [
            'jira',
            'jira-service-management',
            'jira-product-discovery'
        ];
        if (data.jira?.attachmentStorageUsed && (0, $84vV3.isProductOneOf)(product, JIRA_STORAGE_PRODUCTS)) return (0, $gtiPr.bytesToGigabytes)(data.jira.attachmentStorageUsed);
        return undefined;
    }, [
        criticalStorage,
        data.jira?.attachmentStorageUsed,
        isStorageLimitsExperimentEnabled,
        product
    ]);
    const storageLimitInGB = (0, $fsvuC.useMemo)(()=>{
        if (criticalStorage && isStorageLimitsExperimentEnabled) return criticalStorage.storageLimitInGB;
        if (typeof data.jira?.attachmentStorageAllowed === 'number') return (0, $gtiPr.bytesToGigabytes)(data.jira.attachmentStorageAllowed);
        return undefined;
    }, [
        criticalStorage,
        data.jira?.attachmentStorageAllowed,
        isStorageLimitsExperimentEnabled
    ]);
    const storageIsUnlimited = (0, $fsvuC.useMemo)(()=>{
        if (criticalStorage && isStorageLimitsExperimentEnabled) return criticalStorage.storageIsUnlimited;
        if (typeof data.jira?.attachmentStorageIsUnlimited === 'boolean') return data.jira.attachmentStorageIsUnlimited;
        return undefined;
    }, [
        criticalStorage,
        data.jira?.attachmentStorageIsUnlimited,
        isStorageLimitsExperimentEnabled
    ]);
    const offeringKey = entitlement?.offering?.key;
    const automationFreeLimitStatus = (0, $fsvuC.useMemo)(()=>(0, $g7JRw.getAutomationFreeLimitStatus)({
            product: product,
            edition: edition,
            ...siteTraitsForContext
        }), [
        product,
        edition,
        siteTraitsForContext
    ]);
    const lastKnownTrial = (0, $fsvuC.useMemo)(()=>{
        const entitlementProfile = isInCollection === 'IN_COLLECTION' ? entitlement?.relatesFromEntitlementsWithCollectionType?.[0]?.entitlement?.entitlementProfile : entitlement?.entitlementProfile;
        // We purposely don't discard the results of the trial if the customer is not on a trial, the reason for this
        // is to enable experiences where the customer has just started a trial, but that change is not yet reflected
        // on the page that has loaded for them.
        const trialEndTimeStamp = entitlementProfile?.lastKnownTrial?.trialEndTimeStamp;
        if (!trialEndTimeStamp) return undefined;
        if (isInTrial && trialEndTimeStamp <= Date.now() || isInPredunning && trialEndTimeStamp + $cfa4de2fef3d71a4$var$PREDUNNING_LENGTH * $cfa4de2fef3d71a4$var$MILLISECONDS_PER_DAY <= Date.now()) return undefined;
        return {
            trialEndTimeStamp: entitlementProfile?.lastKnownTrial?.trialEndTimeStamp,
            trialType: entitlementProfile?.lastKnownTrial?.trialType,
            trialTrigger: entitlementProfile?.lastKnownTrial?.trialTrigger,
            createdAt: entitlementProfile?.lastKnownTrial?.createdAt,
            offeringId: entitlementProfile?.lastKnownTrial?.offeringId
        };
    }, [
        entitlement?.entitlementProfile,
        isInPredunning,
        isInTrial,
        isInCollection,
        entitlement?.relatesFromEntitlementsWithCollectionType
    ]);
    const isInReverseTrial = (isInTrial || isInPredunning) && lastKnownTrial?.trialType === 'REVERSE_TRIAL';
    const availableCollectionSegments = data?.growthUnifiedProfile_getEntitlementProfile?.availableCollectionSegments;
    const isSinglePaidApp = (0, $fsvuC.useMemo)(()=>{
        const targetOfferingId = (0, $ccEDk.getTwcOfferingIdForEdition)(edition);
        const collectionSegment = availableCollectionSegments?.find((segment)=>segment.collectionOfferingId === targetOfferingId);
        const isSingleAppPaidSegment = collectionSegment?.cannibalisationRiskSegment === 'single_app_paid';
        const otherApps = collectionSegment?.existingStandaloneApps?.filter((app)=>app.entitlementId !== entitlementId) ?? [];
        const otherAppsAutoProvisionedUnactive = otherApps.every((app)=>app.isAutoProvisionedUnactivated === true);
        return isSingleAppPaidSegment && otherAppsAutoProvisionedUnactive;
    }, [
        edition,
        entitlementId,
        availableCollectionSegments
    ]);
    const context = (0, $fsvuC.useMemo)(()=>{
        return {
            cloudId: cloudId,
            orgId: orgId,
            product: product,
            edition: edition,
            entitlementId: entitlementId,
            invoiceableStatus: invoiceableStatus,
            canAddPaymentDetails: canAddPaymentDetails,
            hasPaymentDetailsEntered: hasPaymentDetailsEntered,
            addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl,
            offeringKey: offeringKey,
            trialDaysLeft: trialDaysLeft,
            trialLengthDays: trialLengthDays,
            trialStartDate: trialStartDate,
            trialEndDate: trialEndDate,
            isInTrial: isInTrial,
            isInPredunning: isInPredunning,
            isInReverseTrial: isInReverseTrial,
            canUpgrade: canUpgrade,
            canDirectBuyUpgrade: canDirectBuyUpgrade,
            changeOfferingToStandardExperienceUrl: changeOfferingToStandardExperienceUrl,
            directBuyChangeOfferingToStandardExperienceUrl: directBuyChangeOfferingToStandardExperienceUrl,
            transactionAccountId: transactionAccountId,
            isInCollection: isInCollection,
            isEnterpriseCustomer: isEnterpriseCustomer,
            collectionEntitlementId: collectionEntitlementId,
            collectionType: collectionType,
            isSinglePaidApp: isSinglePaidApp,
            canBundleCollection: canBundleCollection,
            userId: userId,
            userDisplayName: userDisplayName,
            userEmail: userEmail,
            userRoles: userRoles,
            environment: environment,
            licensedUsers: licensedUsers,
            storageUsageInGB: storageUsageInGB,
            storageLimitInGB: storageLimitInGB,
            storageIsUnlimited: storageIsUnlimited,
            ...siteTraitsForContext,
            automationFreeLimitStatus: automationFreeLimitStatus,
            premiumFeatureHighlightToggle: premiumFeatureHighlightToggle,
            shouldAutoOpen: shouldAutoOpen,
            onAutoOpen: onAutoOpen,
            PremiumWrapper: PremiumWrapper,
            lastKnownTrial: lastKnownTrial,
            getAction: getAction,
            showFlag: showFlag,
            hideFlag: hideFlag,
            currentRoute: currentRoute,
            hasDismissedButton: hasDismissedButton,
            onDismissButton: onDismissButton
        };
    }, [
        cloudId,
        orgId,
        product,
        edition,
        entitlementId,
        invoiceableStatus,
        canAddPaymentDetails,
        hasPaymentDetailsEntered,
        addPaymentDetailsExperienceUrl,
        offeringKey,
        trialDaysLeft,
        trialLengthDays,
        trialStartDate,
        trialEndDate,
        isInTrial,
        isInPredunning,
        isInReverseTrial,
        canUpgrade,
        canDirectBuyUpgrade,
        changeOfferingToStandardExperienceUrl,
        directBuyChangeOfferingToStandardExperienceUrl,
        transactionAccountId,
        isInCollection,
        isEnterpriseCustomer,
        collectionEntitlementId,
        collectionType,
        isSinglePaidApp,
        canBundleCollection,
        userId,
        userDisplayName,
        userEmail,
        userRoles,
        environment,
        licensedUsers,
        storageUsageInGB,
        storageLimitInGB,
        storageIsUnlimited,
        siteTraitsForContext,
        automationFreeLimitStatus,
        premiumFeatureHighlightToggle,
        shouldAutoOpen,
        onAutoOpen,
        PremiumWrapper,
        lastKnownTrial,
        getAction,
        showFlag,
        hideFlag,
        currentRoute,
        hasDismissedButton,
        onDismissButton
    ]);
    const experimentContextValue = (0, $fsvuC.useMemo)(()=>new (0, $j88QB.ExperimentContextClass)(), []);
    if (!canRender) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bGnNF.default), {
        name: "edition-awareness-waiting-on-product"
    });
    if (isEnterpriseCustomer) return null;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $j88QB.ExperimentContext).Provider, {
        value: experimentContextValue,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $eOaYv.EditionAwarenessContext).Provider, {
            value: context,
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5Cvkg.ErrorBoundary), {
                product: product,
                edition: edition,
                id: "audience-and-timing",
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $9anV8.ActionsAndContent), {})
            })
        })
    });
}
$cfa4de2fef3d71a4$var$EditionAwarenessImpl.displayName = "EditionAwarenessImpl";
function $cfa4de2fef3d71a4$export$a55b02efe3d62583(props) {
    const { product: product, edition: edition } = props;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jbwXy.default), {
        name: "edition-awareness-platform",
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5Cvkg.ErrorBoundary), {
            product: product,
            edition: edition,
            id: "edition-awareness",
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $5chsV.jsx)($cfa4de2fef3d71a4$var$EditionAwarenessImpl, {
                    ...props
                })
            })
        })
    });
}
$cfa4de2fef3d71a4$export$a55b02efe3d62583.displayName = "EditionAwareness";

});
parcelRegister("kjN90", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d417aefa36069b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d2a4dbd80bd7450d72447fd639ecc7be>>
 * @relayHash e6152dd1a5925a058ab1711a5b94403e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0bfeeba63f63db376535a28ced3af92a825359d3d072e4fb908f85b1c68f9c20
const $3d417aefa36069b2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "applicationKey"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entitlementFilter"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entitlementId"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isServiceCollectionFree"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldCheckCanBundleCollection"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForAddPaymentDetails"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForChargeQuantities"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForDirectBuyChangeOffering"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForPaymentDetails"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldCheckForSinglePaidApp"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForStorageLimit"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForStorageUsageJira"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForSubscription"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForTrial"
    }, v17 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v18 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "applicationKey"
        },
        v17 /*: any*/ 
    ], v19 = {
        "condition": "shouldCheckForStorageUsageJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "shouldCheckForStorageLimit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": v18 /*: any*/ ,
                                "kind": "ScalarField",
                                "name": "attachmentStorageAllowed"
                            },
                            {
                                "args": v18 /*: any*/ ,
                                "kind": "ScalarField",
                                "name": "attachmentStorageIsUnlimited"
                            }
                        ]
                    },
                    {
                        "args": v18 /*: any*/ ,
                        "kind": "ScalarField",
                        "name": "attachmentStorageUsed"
                    }
                ]
            }
        ]
    }, v20 = [
        {
            "kind": "Literal",
            "name": "applicationKey",
            "value": "JIRA_SERVICE_DESK"
        },
        v17 /*: any*/ 
    ], v21 = [
        {
            "kind": "Literal",
            "name": "applicationKey",
            "value": "JIRA_CUSTOMER_SERVICE"
        },
        v17 /*: any*/ 
    ], v22 = {
        "condition": "isServiceCollectionFree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "jsm_storage",
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": v20 /*: any*/ ,
                        "kind": "ScalarField",
                        "name": "attachmentStorageAllowed"
                    },
                    {
                        "args": v20 /*: any*/ ,
                        "kind": "ScalarField",
                        "name": "attachmentStorageUsed"
                    },
                    {
                        "args": v20 /*: any*/ ,
                        "kind": "ScalarField",
                        "name": "attachmentStorageIsUnlimited"
                    }
                ]
            },
            {
                "alias": "csm_storage",
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": v21 /*: any*/ ,
                        "kind": "ScalarField",
                        "name": "attachmentStorageAllowed"
                    },
                    {
                        "args": v21 /*: any*/ ,
                        "kind": "ScalarField",
                        "name": "attachmentStorageUsed"
                    },
                    {
                        "args": v21 /*: any*/ ,
                        "kind": "ScalarField",
                        "name": "attachmentStorageIsUnlimited"
                    }
                ]
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v24 = {
        "condition": "shouldCheckForSinglePaidApp",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "entitlementId",
                        "variableName": "entitlementId"
                    }
                ],
                "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
                "kind": "LinkedField",
                "name": "growthUnifiedProfile_getEntitlementProfile",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GrowthUnifiedProfileAvailableCollectionSegmentResult",
                        "kind": "LinkedField",
                        "name": "availableCollectionSegments",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "collectionOfferingId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "cannibalisationRiskSegment"
                            },
                            {
                                "concreteType": "GrowthUnifiedProfileCollectionSegmentStandaloneAppResult",
                                "kind": "LinkedField",
                                "name": "existingStandaloneApps",
                                "plural": true,
                                "selections": [
                                    v23 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "isAutoProvisionedUnactivated"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v25 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v26 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v27 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v28 = [
        {
            "kind": "Variable",
            "name": "where",
            "variableName": "entitlementFilter"
        }
    ], v29 = {
        "kind": "Literal",
        "name": "offeringName",
        "value": "Standard"
    }, v30 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v31 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v32 = [
        v30 /*: any*/ ,
        v31 /*: any*/ 
    ], v33 = {
        "concreteType": "CcpEntitlementExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "args": [
                    v29 /*: any*/ 
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": v32 /*: any*/ ,
                "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
            },
            {
                "condition": "shouldCheckForDirectBuyChangeOffering",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "changeOfferingV2WithSkipTrial",
                        "args": [
                            v29 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "skipTrial",
                                "value": true
                            }
                        ],
                        "concreteType": "CcpChangeOfferingExperienceCapability",
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": v32 /*: any*/ ,
                        "storageKey": "changeOfferingV2(offeringName:\"Standard\",skipTrial:true)"
                    }
                ]
            }
        ]
    }, v34 = {
        "condition": "shouldCheckForChargeQuantities",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "chargeElement",
                        "variableName": "chargeElement"
                    }
                ],
                "kind": "ScalarField",
                "name": "latestUsageForChargeElement"
            }
        ]
    }, v35 = {
        "concreteType": "CcpEntitlementPreDunning",
        "kind": "LinkedField",
        "name": "preDunning",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    }, v36 = {
        "concreteType": "CcpOfferingTrial",
        "kind": "LinkedField",
        "name": "trial",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lengthDays"
            }
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "key"
    }, v38 = {
        "condition": "shouldCheckForTrial",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "CcpTrial",
                "kind": "LinkedField",
                "name": "trial",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "timeLeft"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "startTimestamp"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "endTimestamp"
                    }
                ]
            }
        ]
    }, v39 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v40 = {
        "condition": "shouldCheckForTrial",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "CcpInvoiceGroupExperienceCapabilities",
                "kind": "LinkedField",
                "name": "experienceCapabilities",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "CcpConfigurePaymentMethodExperienceCapability",
                        "kind": "LinkedField",
                        "name": "configurePaymentV2",
                        "plural": false,
                        "selections": [
                            v31 /*: any*/ ,
                            v30 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v41 = {
        "condition": "shouldCheckForPaymentDetails",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "CcpTransactionAccount",
                "kind": "LinkedField",
                "name": "transactionAccount",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isBillToPresent"
                    }
                ]
            }
        ]
    }, v42 = {
        "condition": "shouldCheckForAddPaymentDetails",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "CcpTransactionAccount",
                "kind": "LinkedField",
                "name": "transactionAccount",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "CcpTransactionAccountExperienceCapabilities",
                        "kind": "LinkedField",
                        "name": "experienceCapabilities",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "CcpAddPaymentMethodExperienceCapability",
                                "kind": "LinkedField",
                                "name": "addPaymentMethodV2",
                                "plural": false,
                                "selections": v32 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ]
    }, v43 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v44 = {
        "alias": "relatesFromEntitlementsWithEnterpriseType",
        "args": [
            {
                "kind": "Literal",
                "name": "relationshipTypes",
                "value": "ENTERPRISE"
            }
        ],
        "concreteType": "CcpEntitlementRelationship",
        "kind": "LinkedField",
        "name": "relatesFromEntitlements",
        "plural": true,
        "selections": [
            v43 /*: any*/ ,
            v23 /*: any*/ 
        ],
        "storageKey": "relatesFromEntitlements(relationshipTypes:\"ENTERPRISE\")"
    }, v45 = [
        {
            "kind": "Literal",
            "name": "relationshipTypes",
            "value": "COLLECTION"
        }
    ], v46 = {
        "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
        "kind": "LinkedField",
        "name": "entitlementProfile",
        "plural": false,
        "selections": [
            {
                "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
                "kind": "LinkedField",
                "name": "lastKnownTrial",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "trialType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "trialTrigger"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "trialEndTimeStamp"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "createdAt"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "offeringId"
                    }
                ]
            }
        ]
    }, v47 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v48 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editionAwarenessQuery",
            "selections": [
                v19 /*: any*/ ,
                v22 /*: any*/ ,
                v24 /*: any*/ ,
                {
                    "args": v25 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "condition": "shouldCheckCanBundleCollection",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "transactionAccounts",
                                    "plural": true,
                                    "selections": [
                                        v26 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v27 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v23 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v28 /*: any*/ ,
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v33 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForTrial",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v35 /*: any*/ ,
                                                        {
                                                            "concreteType": "CcpOffering",
                                                            "kind": "LinkedField",
                                                            "name": "offering",
                                                            "plural": false,
                                                            "selections": [
                                                                v36 /*: any*/ ,
                                                                v37 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckForSubscription",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CcpSubscription",
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CcpAccountDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "accountDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CcpInvoiceGroup",
                                                                            "kind": "LinkedField",
                                                                            "name": "invoiceGroup",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v39 /*: any*/ ,
                                                                                v40 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "CcpTransactionAccount",
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        v26 /*: any*/ 
                                                    ]
                                                },
                                                v41 /*: any*/ ,
                                                v42 /*: any*/ ,
                                                v44 /*: any*/ ,
                                                {
                                                    "alias": "relatesFromEntitlementsWithCollectionType",
                                                    "args": v45 /*: any*/ ,
                                                    "concreteType": "CcpEntitlementRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        v43 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        {
                                                            "concreteType": "CcpEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlement",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                v46 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                                                },
                                                v46 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v6 /*: any*/ ,
                v10 /*: any*/ ,
                v16 /*: any*/ ,
                v15 /*: any*/ ,
                v9 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v14 /*: any*/ ,
                v0 /*: any*/ ,
                v13 /*: any*/ ,
                v11 /*: any*/ ,
                v8 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v12 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editionAwarenessQuery",
            "selections": [
                {
                    "args": v25 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v27 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v47 /*: any*/ ,
                                v23 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v28 /*: any*/ ,
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v33 /*: any*/ ,
                                                {
                                                    "concreteType": "CcpTransactionAccount",
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v48 /*: any*/ 
                                                    ]
                                                },
                                                v44 /*: any*/ ,
                                                {
                                                    "alias": "relatesFromEntitlementsWithCollectionType",
                                                    "args": v45 /*: any*/ ,
                                                    "concreteType": "CcpEntitlementRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        v43 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        {
                                                            "concreteType": "CcpEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlement",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                v48 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                                                },
                                                v46 /*: any*/ ,
                                                v48 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForTrial",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v35 /*: any*/ ,
                                                        {
                                                            "concreteType": "CcpOffering",
                                                            "kind": "LinkedField",
                                                            "name": "offering",
                                                            "plural": false,
                                                            "selections": [
                                                                v36 /*: any*/ ,
                                                                v37 /*: any*/ ,
                                                                v48 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckForSubscription",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CcpSubscription",
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CcpAccountDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "accountDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CcpInvoiceGroup",
                                                                            "kind": "LinkedField",
                                                                            "name": "invoiceGroup",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v39 /*: any*/ ,
                                                                                v40 /*: any*/ ,
                                                                                v48 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v48 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v41 /*: any*/ ,
                                                v42 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        },
                        {
                            "condition": "shouldCheckCanBundleCollection",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "transactionAccounts",
                                    "plural": true,
                                    "selections": [
                                        v47 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v48 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v19 /*: any*/ ,
                v22 /*: any*/ ,
                v24 /*: any*/ 
            ]
        },
        "params": {
            "id": "0bfeeba63f63db376535a28ced3af92a825359d3d072e4fb908f85b1c68f9c20",
            "metadata": {},
            "name": "editionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3d417aefa36069b2$var$node.hash = "5143991d893c12f7e70fee2876123aa9";
var $3d417aefa36069b2$export$2e2bcd8739ae039 = $3d417aefa36069b2$var$node;

});

parcelRegister("cDOGs", function(module, exports) {
$parcel$export(module.exports, "getTrialDaysLeft", () => $e9d26dad4bfda64a$export$954628993bf3188e);
$parcel$export(module.exports, "getTrialDaysLeftFromTrialEndTime", () => $e9d26dad4bfda64a$export$165abb069513be0e);
$parcel$export(module.exports, "useMemoizedTrialDaysLeftFromTrialEndTime", () => $e9d26dad4bfda64a$export$bc3e0c760835aa1e);

var $fsvuC = parcelRequire("fsvuC");

function $e9d26dad4bfda64a$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $f9196309764c88eb$export$98a7370239de6730));
}
function $e9d26dad4bfda64a$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $e9d26dad4bfda64a$export$954628993bf3188e(trialEndTime - Date.now());
}
function $e9d26dad4bfda64a$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $fsvuC.useMemo)(()=>$e9d26dad4bfda64a$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $e9d26dad4bfda64a$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $e9d26dad4bfda64a$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $e9d26dad4bfda64a$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $fsvuC.useMemo)(()=>$e9d26dad4bfda64a$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}

});
const $f9196309764c88eb$export$98a7370239de6730 = 86400000;


parcelRegister("gtiPr", function(module, exports) {
$parcel$export(module.exports, "bytesToGigabytes", () => $f7e07fd92744dde4$export$6f25243957146989);
/**
 * Most storage measurements are in gigabytes
 */ function $f7e07fd92744dde4$export$6f25243957146989(bytes) {
    return bytes / 1000000000;
}

});

parcelRegister("eOaYv", function(module, exports) {
$parcel$export(module.exports, "EditionAwarenessContext", () => $efb8917f67a39f25$export$ac3ca8c46f19a73f);
$parcel$export(module.exports, "useEditionAwareness", () => $efb8917f67a39f25$export$5a5baedfe8151ce);

var $fsvuC = parcelRequire("fsvuC");
const $efb8917f67a39f25$export$ac3ca8c46f19a73f = /*#__PURE__*/ (0, $fsvuC.createContext)(null);
function $efb8917f67a39f25$export$5a5baedfe8151ce() {
    const context = (0, $fsvuC.useContext)($efb8917f67a39f25$export$ac3ca8c46f19a73f);
    if (!context) throw new Error('Missing context, please ensure this is used within EditionAwarenessContext');
    return context;
}

});

parcelRegister("j88QB", function(module, exports) {
$parcel$export(module.exports, "ExperimentContextClass", () => $931c2b997f6c88ec$export$cab0526cd5428d4e);
$parcel$export(module.exports, "ExperimentContext", () => $931c2b997f6c88ec$export$fcdf652c4fd8e4c7);
$parcel$export(module.exports, "useExperimentContext", () => $931c2b997f6c88ec$export$471c3c65727643de);
$parcel$export(module.exports, "useGetExperimentValue", () => $931c2b997f6c88ec$export$59dd27b2c85d98d8);

var $fsvuC = parcelRequire("fsvuC");

var $5Y9N2 = parcelRequire("5Y9N2");
class $931c2b997f6c88ec$export$cab0526cd5428d4e {
    constructor(context){
        this.experimentDictionary = {};
        this.experimentDictionary = context ?? {};
    }
    experimentExposed(experimentName, experimentVariant, extraAttributes) {
        // If the experiment is already in the dictionary (i.e. been exposed before),
        // we don't want to overwrite the timestamp of first exposure.
        if (Object.keys(this.experimentDictionary).includes(experimentName)) return;
        this.experimentDictionary[experimentName] = {
            cohort: experimentVariant,
            timestamp: Date.now(),
            ...extraAttributes
        };
    }
    experiments() {
        return this.experimentDictionary;
    }
}
$931c2b997f6c88ec$export$cab0526cd5428d4e.displayName = "ExperimentContextClass";
const $931c2b997f6c88ec$export$fcdf652c4fd8e4c7 = /*#__PURE__*/ (0, $fsvuC.createContext)(null);
function $931c2b997f6c88ec$export$471c3c65727643de() {
    const context = (0, $fsvuC.useContext)($931c2b997f6c88ec$export$fcdf652c4fd8e4c7);
    if (!context) throw new Error('Missing context, please ensure this is used within ExperimentContext');
    return context;
}
const $931c2b997f6c88ec$export$59dd27b2c85d98d8 = ()=>{
    const experimentContext = $931c2b997f6c88ec$export$471c3c65727643de();
    const getExperimentValue = (0, $fsvuC.useCallback)(({ statsigParams: { experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options }, experimentContextAttributes: experimentContextAttributes = {} })=>{
        const cohort = options ? (0, $5Y9N2.default).getExperimentValue(experimentName, parameterName, defaultValue, options) : (0, $5Y9N2.default).getExperimentValue(experimentName, parameterName, defaultValue);
        // By default, fireExperimentExposure is true but we need to explicitly
        // check for that to ensure we fire our context update correctly.
        if (options?.fireExperimentExposure !== false) experimentContext.experimentExposed(experimentName, cohort, experimentContextAttributes);
        return cohort;
    }, [
        experimentContext
    ]);
    const getExperimentCohort = (0, $fsvuC.useCallback)((experimentName, fireExposure = true)=>getExperimentValue({
            statsigParams: {
                experimentName: experimentName,
                parameterName: 'cohort',
                defaultValue: 'not-enrolled',
                options: fireExposure ? undefined : {
                    fireExperimentExposure: false
                }
            }
        }), [
        getExperimentValue
    ]);
    return {
        getExperimentValue: getExperimentValue,
        getExperimentCohort: getExperimentCohort
    };
};

});

parcelRegister("g7JRw", function(module, exports) {
$parcel$export(module.exports, "AUTOMATION_USAGE_FREE_LIMIT", () => $66ac9e30bb66e6d2$export$7296becdbc8d7810);
$parcel$export(module.exports, "AUTOMATION_USAGE_STANDARD_LIMIT", () => $66ac9e30bb66e6d2$export$5a0f9f37fb711f37);
$parcel$export(module.exports, "getAutomationFreeLimitStatus", () => $66ac9e30bb66e6d2$export$5f347675b43b787f);

var $i0cCM = parcelRequire("i0cCM");

var $gDdDZ = parcelRequire("gDdDZ");
const $66ac9e30bb66e6d2$export$7296becdbc8d7810 = 100;
const $66ac9e30bb66e6d2$export$5a0f9f37fb711f37 = 1700;
const $66ac9e30bb66e6d2$export$b3d11e30afa46646 = 0.8 * $66ac9e30bb66e6d2$export$7296becdbc8d7810;
const $66ac9e30bb66e6d2$export$5f347675b43b787f = ({ edition: edition, product: product, automationUsage: automationUsage, lastAutomationFreeLimitBreachDate: lastAutomationFreeLimitBreachDate = null })=>{
    if (edition === 'free' && product === 'jira') {
        if ($66ac9e30bb66e6d2$export$5ff23a30e22aeec2(automationUsage, lastAutomationFreeLimitBreachDate)) return 'BREACHED';
        if ($66ac9e30bb66e6d2$var$isAutomationProjectedToBreach(automationUsage, edition)) return 'PROJECTED_TO_BREACH';
    }
    return null;
};
const $66ac9e30bb66e6d2$export$5c4f4d557a0ee678 = (automationUsage)=>{
    const today = new Date();
    const dayOfMonth = today.getDate();
    return automationUsage / dayOfMonth * (0, $i0cCM.default)(today);
};
const $66ac9e30bb66e6d2$var$isAutomationProjectedToBreach = (automationUsage, edition)=>{
    // Already breached the limit, no need to project
    if (automationUsage >= $66ac9e30bb66e6d2$export$7296becdbc8d7810) return false;
    const projectedUsage = $66ac9e30bb66e6d2$export$5c4f4d557a0ee678(automationUsage);
    if (edition === 'free') return projectedUsage >= $66ac9e30bb66e6d2$export$7296becdbc8d7810 && automationUsage >= $66ac9e30bb66e6d2$export$b3d11e30afa46646;
    return projectedUsage >= $66ac9e30bb66e6d2$export$7296becdbc8d7810;
};
const $66ac9e30bb66e6d2$export$5ff23a30e22aeec2 = (automationUsage, lastAutomationFreeLimitBreachDate)=>{
    return lastAutomationFreeLimitBreachDate && automationUsage >= $66ac9e30bb66e6d2$export$7296becdbc8d7810 && (0, $gDdDZ.default)(new Date(), lastAutomationFreeLimitBreachDate);
};

});

parcelRegister("cYQj7", function(module, exports) {
$parcel$export(module.exports, "getMostCriticalStorage", () => $9756b631909229d7$export$81797a82b2cbeccb);

var $gtiPr = parcelRequire("gtiPr");
function $9756b631909229d7$export$81797a82b2cbeccb(storageDataArray) {
    const allUnlimited = storageDataArray.length > 0 && storageDataArray.every((data)=>data?.attachmentStorageIsUnlimited ?? false);
    if (allUnlimited) return {
        storageIsUnlimited: true
    };
    let winner = null;
    let winnerRatio = -Infinity;
    for (const data of storageDataArray){
        const isUnlimited = data?.attachmentStorageIsUnlimited ?? false;
        if (isUnlimited) continue;
        const used = data?.attachmentStorageUsed ?? 0;
        const allowed = data?.attachmentStorageAllowed ?? Infinity;
        const ratio = allowed > 0 ? used / allowed : used > 0 ? Infinity : 0;
        if (ratio > winnerRatio) {
            winnerRatio = ratio;
            winner = data;
        }
    }
    if (!winner) return {};
    return {
        product: winner.product,
        storageUsageInGB: typeof winner.attachmentStorageUsed === 'number' ? (0, $gtiPr.bytesToGigabytes)(winner.attachmentStorageUsed) : undefined,
        storageLimitInGB: typeof winner.attachmentStorageAllowed === 'number' ? (0, $gtiPr.bytesToGigabytes)(winner.attachmentStorageAllowed) : undefined,
        storageIsUnlimited: winner.attachmentStorageIsUnlimited ?? undefined
    };
}

});

parcelRegister("e1Gsk", function(module, exports) {
$parcel$export(module.exports, "getProductCollection", () => $93439691d2377f8f$export$6cf5f13af3dcd5bf);
const $93439691d2377f8f$export$6cf5f13af3dcd5bf = (product)=>{
    switch(product){
        case 'jira-service-management':
        case 'jira-customer-service':
            return {
                collectionType: 'Service Collection',
                isEnabled: true
            };
        case 'jira':
        case 'confluence':
            return {
                collectionType: 'Teamwork Collection',
                isEnabled: true
            };
        default:
            return undefined;
    }
};

});

parcelRegister("7zHly", function(module, exports) {
$parcel$export(module.exports, "getQueryConfig", () => $1130a948c743fefd$export$bac5bb66ae1b635d);

var $5Y9N2 = parcelRequire("5Y9N2");

var $llCao = parcelRequire("llCao");

var $lJkk5 = parcelRequire("lJkk5");

var $lFWLU = parcelRequire("lFWLU");

var $84vV3 = parcelRequire("84vV3");

var $lUy4V = parcelRequire("lUy4V");
function $1130a948c743fefd$export$bac5bb66ae1b635d(product, edition, cloudId, userRolesFromProduct, entitlementId) {
    const isProductJiraFree = product === 'jira' && edition === 'free';
    // JSSHL (TAIYO-388): also fetch the Jira storage fields for Standard sites behind the kill switch,
    // so the Standard storage hard limit pill and dialog can be evaluated. Relies on
    // `jira-standard-storage-hard-limits-issue-query-fg` to check enrolment (TAIYO-582).
    const isProductJiraStandardAndEnrolled = product === 'jira' && edition === 'standard' && (0, $llCao.fg)('jira-standard-storage-hard-limits-kill-switch') && (0, $llCao.fg)('jira-standard-storage-hard-limits-issue-query-fg');
    const isStorageLimitsExperimentEnabled = edition === 'free' && (product === 'jira-service-management' || product === 'jira-customer-service') && (0, $5Y9N2.default).getExperimentValue('jsmgrowth-267_enforce_storage_limits_servco_free', 'isEnabled', false);
    const shouldCheckForPaymentDetails = edition === 'free' && (0, $84vV3.isProductOneOf)(product, [
        'jira',
        'confluence',
        'jira-product-discovery',
        'jira-service-management'
    ]);
    const shouldCheckForTrial = edition === 'premium' || edition === 'standard';
    const shouldCheckForSubscription = shouldCheckForTrial || shouldCheckForPaymentDetails;
    const isSiteAdmin = userRolesFromProduct?.includes('SITE_ADMIN') ?? false;
    // Entitlement filter controls which entitlements are fetched from the API.
    // The filter is based on the trial end timestamp in TCS - if a customer downgrades to free while
    // on a trial, they still show up when inTrialOrPreDunning is true as the filter assumes they're still on trial.
    //
    //   - Site admin + non-free edition:
    //       Returns entitlements that are (in trial/predunning) OR (in a collection)
    //
    //   - Non-site admin + non-free edition:
    //       Returns entitlements that are (in trial/predunning)
    //
    //   - Free edition (any user):
    //       Returns all entitlements (no filter)
    //
    const getEntitlementFilter = ()=>{
        if (isSiteAdmin && edition !== 'free') // Preserve the COLLECTION filter: standard-to-premium needs collection membership to
        // exclude paid collection sites, even when they are not in trial or predunning.
        return {
            OR: [
                {
                    inTrialOrPreDunning: true
                },
                {
                    hasRelationshipFromWithType: 'COLLECTION'
                }
            ]
        };
        else return edition !== 'free' ? {
            inTrialOrPreDunning: true
        } : null;
    };
    const entitlementFilter = getEntitlementFilter();
    const resolvedEntitlementId = entitlementId ?? '';
    return {
        shouldCheckForDirectBuyChangeOffering: isProductJiraFree,
        shouldCheckForTrial: shouldCheckForTrial,
        shouldCheckForSubscription: shouldCheckForSubscription,
        cloudId: cloudId,
        productKey: (0, $lUy4V.getHamsKey)(product),
        shouldCheckForChargeQuantities: edition === 'free',
        entitlementFilter: entitlementFilter,
        entitlementId: resolvedEntitlementId,
        chargeElement: (0, $lJkk5.getChargeElementKey)(product),
        shouldCheckForStorageUsageJira: isProductJiraFree || isProductJiraStandardAndEnrolled,
        applicationKey: (0, $lFWLU.getJiraApplicationKey)(product) ?? 'JIRA_SOFTWARE',
        shouldCheckForStorageLimit: isProductJiraFree || isProductJiraStandardAndEnrolled,
        isServiceCollectionFree: isStorageLimitsExperimentEnabled,
        shouldCheckForPaymentDetails: shouldCheckForPaymentDetails,
        shouldCheckForSinglePaidApp: edition === 'premium' && isSiteAdmin && (0, $84vV3.isProductOneOf)(product, [
            'jira',
            'confluence'
        ]) && Boolean(resolvedEntitlementId),
        shouldCheckForAddPaymentDetails: edition === 'free',
        shouldCheckCanBundleCollection: edition === 'premium' && isSiteAdmin && (0, $84vV3.isProductOneOf)(product, [
            'jira',
            'confluence'
        ]) && (0, $llCao.fg)('check_bundle_twc_permission')
    };
}

});
parcelRegister("lJkk5", function(module, exports) {
$parcel$export(module.exports, "getChargeElementKey", () => $1ec28e68a4377419$export$58e4e89574623b4);
const $1ec28e68a4377419$var$PRODUCT_TO_CHARGE_ELEMENT = {
    ['confluence']: 'user',
    ['jira']: 'user',
    ['jira-product-discovery']: 'user',
    ['jira-service-management']: 'agent',
    ['jira-customer-service']: 'agent'
};
const $1ec28e68a4377419$export$58e4e89574623b4 = (product)=>{
    return $1ec28e68a4377419$var$PRODUCT_TO_CHARGE_ELEMENT[product];
};

});

parcelRegister("lFWLU", function(module, exports) {
$parcel$export(module.exports, "getJiraApplicationKey", () => $b84be6f757c674f2$export$2fd6994252e4887f);
// We're explicitly excluding 'confluence' from this mapping as it's handled separately
const $b84be6f757c674f2$var$PRODUCT_TO_JIRA_APPLICATION_KEY = {
    ['jira']: 'JIRA_SOFTWARE',
    ['jira-product-discovery']: 'JIRA_PRODUCT_DISCOVERY',
    ['jira-service-management']: 'JIRA_SERVICE_DESK',
    ['jira-customer-service']: 'JIRA_CUSTOMER_SERVICE'
};
const $b84be6f757c674f2$export$2fd6994252e4887f = (product)=>{
    return $b84be6f757c674f2$var$PRODUCT_TO_JIRA_APPLICATION_KEY[product];
};

});

parcelRegister("84vV3", function(module, exports) {
$parcel$export(module.exports, "isProductOneOf", () => $0f700ab5caad6b79$export$fda637a5d76f2dc6);
function $0f700ab5caad6b79$export$fda637a5d76f2dc6(product, possibleMatches) {
    return possibleMatches.includes(product);
}

});

parcelRegister("lUy4V", function(module, exports) {
$parcel$export(module.exports, "getHamsKey", () => $ced0eea38af22fdc$export$291d012eb0744b34);
const $ced0eea38af22fdc$var$ProductKeyToHAMSMap = {
    ['confluence']: 'confluence',
    ['jira']: 'jira-software',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['jira-service-management']: 'jira-servicedesk',
    ['jira-customer-service']: 'jira-customer-service'
};
const $ced0eea38af22fdc$export$291d012eb0744b34 = (product)=>{
    return $ced0eea38af22fdc$var$ProductKeyToHAMSMap[product];
};

});


parcelRegister("lTNnt", function(module, exports) {
$parcel$export(module.exports, "getSiteTraitValues", () => $d8add23755926d8f$export$2a16c85f3c5d2302);

var $llCao = parcelRequire("llCao");
const $d8add23755926d8f$var$parseBooleanTrait = (trait)=>{
    if (!trait) return false;
    if (typeof trait.value === 'boolean') return trait.value;
    if (typeof trait.value === 'string') return trait.value === 'true';
    return false;
};
const $d8add23755926d8f$export$2a16c85f3c5d2302 = (traits)=>{
    if (traits.length === 0) return {
        automationUsage: 0,
        lastAutomationFreeLimitBreachDate: null,
        isSiteEligibleToServcoUplift: false,
        isEligibleForJsmStandardToPremium: false,
        isEligibleForJswStandardToPremium: false,
        isEligibleForJpdStandardToPremium: false,
        isEligibleForConfluenceStandardToPremium: false,
        isEligibleForJsmStandardToPremiumV2: false,
        isEligibleForJswStandardToPremiumV2: false,
        isEligibleForJpdStandardToPremiumV2: false,
        isEligibleForConfluenceStandardToPremiumV2: false,
        isEligibleForJswPremiumToTwc: false,
        isEligibleForConfluencePremiumToTwc: false
    };
    const automationUsageTrait = traits.find((trait)=>trait.name === 'growth_automation_limits_current_usage');
    const lastAutomationFreeLimitBreachDateTrait = traits.find((trait)=>trait.name === 'growth_automation_limits_usage_latest_breach_date');
    const servcoUpliftTrait = traits.find((trait)=>trait.name === 'is_site_eligible_to_servco_uplift');
    const jsmUpsellTrait = traits.find((trait)=>trait.name === 'ea_jsm_is_eligible_for_standard_to_premium');
    const jswUpsellTrait = traits.find((trait)=>trait.name === 'ea_jsw_is_eligible_for_standard_to_premium');
    const jpdUpsellTrait = traits.find((trait)=>trait.name === 'ea_jpd_is_eligible_for_standard_to_premium');
    const confluenceUpsellTrait = traits.find((trait)=>trait.name === 'ea_confluence_is_eligible_for_standard_to_premium');
    const jsmUpsellTraitV2 = traits.find((trait)=>trait.name === 'ea_jsm_is_eligible_for_standard_to_premium_v2');
    const jswUpsellTraitV2 = traits.find((trait)=>trait.name === 'ea_jsw_is_eligible_for_standard_to_premium_v2');
    const jpdUpsellTraitV2 = traits.find((trait)=>trait.name === 'ea_jpd_is_eligible_for_standard_to_premium_v2');
    const confluenceUpsellTraitV2 = traits.find((trait)=>trait.name === 'ea_confluence_is_eligible_for_standard_to_premium_v2');
    const jswPremiumToTwcTrait = traits.find((trait)=>trait.name === 'ea_jsw_is_eligible_for_premium_to_twc');
    const confluencePremiumToTwcTrait = traits.find((trait)=>trait.name === 'ea_confluence_is_eligible_for_premium_to_twc');
    const automationUsage = automationUsageTrait && automationUsageTrait.value !== undefined && !isNaN(Number(automationUsageTrait.value)) ? Number(automationUsageTrait.value) : 0;
    const lastAutomationFreeLimitBreachDate = lastAutomationFreeLimitBreachDateTrait && typeof lastAutomationFreeLimitBreachDateTrait.value === 'string' && !isNaN(Date.parse(lastAutomationFreeLimitBreachDateTrait.value)) ? new Date(lastAutomationFreeLimitBreachDateTrait.value) : null;
    const isSiteEligibleToServcoUplift = Boolean(servcoUpliftTrait && typeof servcoUpliftTrait.value === 'boolean' && servcoUpliftTrait.value);
    const useNewUpsellTraits = (0, $llCao.fg)('ea_upsell_new_traits');
    return {
        automationUsage: automationUsage,
        lastAutomationFreeLimitBreachDate: lastAutomationFreeLimitBreachDate,
        isSiteEligibleToServcoUplift: isSiteEligibleToServcoUplift,
        isEligibleForJsmStandardToPremium: $d8add23755926d8f$var$parseBooleanTrait(useNewUpsellTraits ? jsmUpsellTraitV2 : jsmUpsellTrait),
        isEligibleForJswStandardToPremium: $d8add23755926d8f$var$parseBooleanTrait(useNewUpsellTraits ? jswUpsellTraitV2 : jswUpsellTrait),
        isEligibleForJpdStandardToPremium: $d8add23755926d8f$var$parseBooleanTrait(useNewUpsellTraits ? jpdUpsellTraitV2 : jpdUpsellTrait),
        isEligibleForConfluenceStandardToPremium: $d8add23755926d8f$var$parseBooleanTrait(useNewUpsellTraits ? confluenceUpsellTraitV2 : confluenceUpsellTrait),
        isEligibleForJsmStandardToPremiumV2: $d8add23755926d8f$var$parseBooleanTrait(jsmUpsellTraitV2),
        isEligibleForJswStandardToPremiumV2: $d8add23755926d8f$var$parseBooleanTrait(jswUpsellTraitV2),
        isEligibleForJpdStandardToPremiumV2: $d8add23755926d8f$var$parseBooleanTrait(jpdUpsellTraitV2),
        isEligibleForConfluenceStandardToPremiumV2: $d8add23755926d8f$var$parseBooleanTrait(confluenceUpsellTraitV2),
        isEligibleForJswPremiumToTwc: $d8add23755926d8f$var$parseBooleanTrait(jswPremiumToTwcTrait),
        isEligibleForConfluencePremiumToTwc: $d8add23755926d8f$var$parseBooleanTrait(confluencePremiumToTwcTrait)
    };
};

});

parcelRegister("gvKck", function(module, exports) {
$parcel$export(module.exports, "STANDARD_TO_PREMIUM_TRAIT_ELIGIBILITY", () => $72c1af2dbff4b17d$export$f7861a1e18ff1895);
const $72c1af2dbff4b17d$export$f7861a1e18ff1895 = {
    jira: 'isEligibleForJswStandardToPremium',
    'jira-service-management': 'isEligibleForJsmStandardToPremium',
    'jira-product-discovery': 'isEligibleForJpdStandardToPremium',
    confluence: 'isEligibleForConfluenceStandardToPremium'
};

});

parcelRegister("ccEDk", function(module, exports) {
$parcel$export(module.exports, "getTwcOfferingIdForEdition", () => $39174e5e6b9b42a0$export$bd921605150273f9);
const $39174e5e6b9b42a0$export$58096a83ecfc939c = '7e16cb96-ade2-4220-9010-c71ef9a70cf2';
const $39174e5e6b9b42a0$export$eee98e893bc98ccd = 'b296663a-50d7-4e51-bc53-be058da00dad';
function $39174e5e6b9b42a0$export$bd921605150273f9(edition) {
    switch(edition){
        case 'standard':
            return $39174e5e6b9b42a0$export$58096a83ecfc939c;
        case 'premium':
            return $39174e5e6b9b42a0$export$eee98e893bc98ccd;
        default:
            return undefined;
    }
}

});

parcelRegister("9anV8", function(module, exports) {
$parcel$export(module.exports, "ActionsAndContent", () => $7290c920b270344a$export$3bec899b1babe0fe);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $bGnNF = parcelRequire("bGnNF");

var $6dj2G = parcelRequire("6dj2G");

var $eOaYv = parcelRequire("eOaYv");

var $j88QB = parcelRequire("j88QB");

var $hvUnP = parcelRequire("hvUnP");

var $aE3ln = parcelRequire("aE3ln");

var $3nAzh = parcelRequire("3nAzh");

var $byEur = parcelRequire("byEur");

var $gmtpF = parcelRequire("gmtpF");

var $MOTjl = parcelRequire("MOTjl");

var $eMWWi = parcelRequire("eMWWi");

var $dGhAe = parcelRequire("dGhAe");

var $hGnef = parcelRequire("hGnef");

var $2Cds1 = parcelRequire("2Cds1");

var $caWwh = parcelRequire("caWwh");

var $31xHR = parcelRequire("31xHR");

var $hGecc = parcelRequire("hGecc");

var $hnVBT = parcelRequire("hnVBT");

var $iCbte = parcelRequire("iCbte");

var $1r0W6 = parcelRequire("1r0W6");

var $h6HlO = parcelRequire("h6HlO");

var $92lDb = parcelRequire("92lDb");

var $fqXcR = parcelRequire("fqXcR");

var $7Hn1d = parcelRequire("7Hn1d");

var $i56hz = parcelRequire("i56hz");

var $2OzPO = parcelRequire("2OzPO");

var $dPgpR = parcelRequire("dPgpR");

var $aADqg = parcelRequire("aADqg");

var $1ZV8K = parcelRequire("1ZV8K");

var $9Z7AB = parcelRequire("9Z7AB");

var $8Nx3j = parcelRequire("8Nx3j");

var $1yMee = parcelRequire("1yMee");

var $e2lbi = parcelRequire("e2lbi");

var $nd4Sn = parcelRequire("nd4Sn");

var $cTE2C = parcelRequire("cTE2C");

var $5FGz7 = parcelRequire("5FGz7");

var $lrnRV = parcelRequire("lrnRV");

var $2qx5E = parcelRequire("2qx5E");

var $9cCkE = parcelRequire("9cCkE");

var $04eA3 = parcelRequire("04eA3");

var $gNndG = parcelRequire("gNndG");

var $aVuvl = parcelRequire("aVuvl");

var $4q39A = parcelRequire("4q39A");

var $48j9G = parcelRequire("48j9G");

var $fLXfP = parcelRequire("fLXfP");

var $6DAUJ = parcelRequire("6DAUJ");

var $3pPxF = parcelRequire("3pPxF");

var $i1i2R = parcelRequire("i1i2R");

var $d4Ntt = parcelRequire("d4Ntt");

var $b3tXy = parcelRequire("b3tXy");

var $bfeRu = parcelRequire("bfeRu");

var $hhEZh = parcelRequire("hhEZh");

var $iy8CK = parcelRequire("iy8CK");

var $hBN2X = parcelRequire("hBN2X");

var $hM1Vl = parcelRequire("hM1Vl");

var $ckNWz = parcelRequire("ckNWz");

var $8Ajct = parcelRequire("8Ajct");

var $cl6c5 = parcelRequire("cl6c5");

var $7KnVX = parcelRequire("7KnVX");

var $juPTO = parcelRequire("juPTO");
function $7290c920b270344a$var$FreeEdition() {
    const context = (0, $eOaYv.useEditionAwareness)();
    const { getExperimentCohort: getExperimentCohort } = (0, $j88QB.useGetExperimentValue)();
    if ((0, $nd4Sn.isEligibleForTWCPlanSelectionPage)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $d4Ntt.PlanSelectionPageModal), {
        type: "twc"
    });
    if ((0, $hvUnP.isEligibleForAutomationFreeLimitModal)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $gNndG.AutomationFreeLimitModal), {});
    if ((0, $8Nx3j.isEligibleForStorageHardLimit)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $8Ajct.StorageHardLimitModal), {});
    // Claim eligible variation traffic before the overlapping PDE upgrade-link route.
    if ((0, $5FGz7.isEligibleForUserLimitDirectBuy)(context)) {
        const cohort = getExperimentCohort((0, $04eA3.USER_LIMIT_DIRECT_BUY_EXPERIMENT), false);
        if (cohort === 'variation') return /*#__PURE__*/ (0, $5chsV.jsx)((0, $cl6c5.UserLimitDirectBuyModal), {});
    }
    if ((0, $gmtpF.isEligibleForEAtoOSBFreeWithPDE)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $juPTO.UpgradeStandardFlowLink), {});
    if ((0, $1r0W6.isEligibleForJsmStorageOverLimit)(context) || (0, $iCbte.isEligibleForJsmStorageNearLimit)(context) || (0, $caWwh.isEligibleForFreeToStandardModal)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6DAUJ.FreeToStandardModal), {});
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6dj2G.IneligibleAnalytics), {});
}
$7290c920b270344a$var$FreeEdition.displayName = "FreeEdition";
function $7290c920b270344a$var$StandardEdition() {
    const context = (0, $eOaYv.useEditionAwareness)();
    const { product: product, currentRoute: currentRoute } = context;
    const { getExperimentCohort: getExperimentCohort } = (0, $j88QB.useGetExperimentValue)();
    if ((0, $cTE2C.isEligibleForTWCTrialNoPDE)(context)) // Teamwork Collection with no PDE in trial
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $d4Ntt.PlanSelectionPageModal), {
        type: "twc"
    });
    if ((0, $e2lbi.isEligibleForTWCChangePlan)(context)) {
        if ((0, $llCao.fg)('twc-pde-trial-ea-modal-update-gate')) {
            const cohort = getExperimentCohort('twc-pde-trial-ea-modal-update-experiment', false);
            if (cohort === 'variation') return /*#__PURE__*/ (0, $5chsV.jsx)((0, $48j9G.CollectionTrialModal), {});
        }
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $4q39A.CollectionChangePlanPopup), {});
    }
    if ((0, $1yMee.isEligibleForTWCAddPaymentDetails)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aVuvl.CollectionAddPaymentDetailsPopup), {});
    if ((0, $i56hz.isEligibleForReverseTrialPlanSelection)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $d4Ntt.PlanSelectionPageModal), {
        type: "reverse-trial"
    });
    // Storage-limit auto-upgrade path is independent of the STAR experiment / its
    // killswitch / cohort. Render the modal whenever the dedicated storage-limit
    // killswitch is on and the entitlement trial trigger is AUTO_UPGRADE_STORAGE_LIMIT.
    if ((0, $dGhAe.isEligibleForExploreEditionBenefitsModalStorageLimit)(context) || (0, $eMWWi.isEligibleForExploreEditionBenefitsModalReverseTrial)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fLXfP.ExploreEditionBenefitsModal), {});
    if ((0, $hGnef.isEligibleForExploreEditionBenefitsModalWithPDE)(context)) {
        if (getExperimentCohort('jsmgrowth466_star') === 'variation') return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fLXfP.ExploreEditionBenefitsModal), {});
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6dj2G.IneligibleAnalytics), {});
    }
    if ((0, $2Cds1.isEligibleForExploreEditionBenefitsModalWithoutPDE)(context)) {
        if (getExperimentCohort('jsmgrowth466_star') === 'variation') return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fLXfP.ExploreEditionBenefitsModal), {});
    // jira-service-management intentionally falls through to the downstream isEligibleForStandardAddPaymentModal handler
    }
    // Catch-all: block CSM and ops routes that fell through (e.g. killswitch OFF, not in trial, or non-variation cohort)
    if (product === 'jira-customer-service' || currentRoute === 'ops') return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6dj2G.IneligibleAnalytics), {});
    if ((0, $aADqg.isEligibleForStandardPaymentFlowLink)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $7KnVX.PaymentFlowLink), {});
    if ((0, $2OzPO.isEligibleForStandardAddPaymentModal)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $iy8CK.StandardAddPaymentModal), {});
    // Jira Standard - Site admins get routed to JSTO, others to payment popup
    if ((0, $dPgpR.isEligibleForStandardPaymentDetailsPopup)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $i1i2R.PaymentDetailsPopup), {});
    if ((0, $byEur.isEligibleForConfluenceStandardAddPaymentModal)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $iy8CK.StandardAddPaymentModal), {});
    if ((0, $hGecc.isEligibleForJiraStandardPredunning)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $7KnVX.PaymentFlowLink), {});
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6dj2G.IneligibleAnalytics), {});
}
$7290c920b270344a$var$StandardEdition.displayName = "StandardEdition";
function $7290c920b270344a$var$PaidStandardUpsells() {
    const context = (0, $eOaYv.useEditionAwareness)();
    const { getExperimentCohort: getExperimentCohort } = (0, $j88QB.useGetExperimentValue)();
    if ((0, $9Z7AB.isEligibleForStandardToPremiumIncentiveOffer)(context)) {
        // The button is unchanged; defer exposure until the selected modal renders.
        const cohort = getExperimentCohort('standard_to_premium_incentive_offer_experiment', false);
        if (cohort === 'variation') return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hM1Vl.StandardToPremiumIncentiveOfferModal), {});
    }
    if ((0, $1ZV8K.isEligibleForStandardToPremium)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $ckNWz.StandardToPremiumModal), {});
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6dj2G.IneligibleAnalytics), {});
}
$7290c920b270344a$var$PaidStandardUpsells.displayName = "PaidStandardUpsells";
function $7290c920b270344a$var$JiraStandardStorageHardLimit() {
    const context = (0, $eOaYv.useEditionAwareness)();
    // requires fetching the collection membership async from root query to avoid calling TCS on ineligible Standard sites
    const { getExperimentCohort: getExperimentCohort } = (0, $j88QB.useGetExperimentValue)();
    const { data: data, loading: loading, error: error } = (0, $9cCkE.useGetStandardStorageHardLimitData)();
    const isAvailableToUser = data?.isAvailableToUser;
    const experienceUrl = data?.experienceUrl;
    const isInCollection = data?.isInCollection;
    const canUpgradeToPremium = isAvailableToUser === true && Boolean(experienceUrl);
    const contextWithCollection = (0, $fsvuC.useMemo)(()=>({
            ...context,
            canUpgradeToPremium: canUpgradeToPremium,
            ...isInCollection && {
                isInCollection: isInCollection
            }
        }), [
        context,
        canUpgradeToPremium,
        isInCollection
    ]);
    if (loading) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bGnNF.default), {
        name: "jira-standard-storage-hard-limit-edition-awareness"
    });
    if (error) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {});
    // Within 1 GB of the allowance only users who can upgrade to Premium are exposed; at or over
    // it everyone not in a collection is. The pill in `getStandardContent` applies the same guard.
    const isNearLimit = (0, $hnVBT.isJiraStandardStorageNearLimit)(context);
    // if near limit = true, must have canUpgradeToPremium = true as near limit is only shown to users who can upgrade to Premium
    if (isInCollection === 'NOT_IN_COLLECTION' && (!isNearLimit || canUpgradeToPremium === true)) {
        // Exposure fires here, having already met all other eligibility criteria
        const cohort = getExperimentCohort('jira-standard-storage-hard-limits', true);
        if (cohort === 'variation') return /*#__PURE__*/ (0, $5chsV.jsx)((0, $eOaYv.EditionAwarenessContext).Provider, {
            value: contextWithCollection,
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $hBN2X.StandardStorageHardLimitModal), {})
        });
    }
    return /*#__PURE__*/ (0, $5chsV.jsx)($7290c920b270344a$var$PaidStandardUpsells, {});
}
$7290c920b270344a$var$JiraStandardStorageHardLimit.displayName = "JiraStandardStorageHardLimit";
function $7290c920b270344a$var$PaidStandard() {
    const context = (0, $eOaYv.useEditionAwareness)();
    if ((0, $hnVBT.isEligibleForJiraStandardStorageHardLimit)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)($7290c920b270344a$var$JiraStandardStorageHardLimit, {});
    return /*#__PURE__*/ (0, $5chsV.jsx)($7290c920b270344a$var$PaidStandardUpsells, {});
}
$7290c920b270344a$var$PaidStandard.displayName = "PaidStandard";
function $7290c920b270344a$var$PaidPremium() {
    const context = (0, $eOaYv.useEditionAwareness)();
    const { getExperimentCohort: getExperimentCohort } = (0, $j88QB.useGetExperimentValue)();
    if ((0, $fqXcR.isEligibleForPremiumToTwc)(context)) {
        getExperimentCohort('premium-to-twc-upsell-aa', true);
        const cohort = getExperimentCohort('premium-to-twc-upsell-ab');
        if (cohort === 'variation') return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3pPxF.PaidToTwcModal), {});
    }
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6dj2G.IneligibleAnalytics), {});
}
$7290c920b270344a$var$PaidPremium.displayName = "PaidPremium";
function $7290c920b270344a$var$PremiumEdition() {
    const context = (0, $eOaYv.useEditionAwareness)();
    const { getExperimentCohort: getExperimentCohort } = (0, $j88QB.useGetExperimentValue)();
    // make sure twc is always shown first before jira reverse trial
    // otherwise, jira reverse trial will be shown with collection
    // additional check on invoiceableStatus and canAddPaymentDetails
    // to block any EA to be shown if the customer is in a collection
    // * confluence premium is showing EA regardless which needs to be blocked from collection
    if ((0, $cTE2C.isEligibleForTWCTrialNoPDE)(context)) // Teamwork Collection with no PDE in trial
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $d4Ntt.PlanSelectionPageModal), {
        type: "twc"
    });
    if ((0, $e2lbi.isEligibleForTWCChangePlan)(context)) {
        if ((0, $llCao.fg)('twc-pde-trial-ea-modal-update-gate')) {
            const cohort = getExperimentCohort('twc-pde-trial-ea-modal-update-experiment', false);
            if (cohort === 'variation') return /*#__PURE__*/ (0, $5chsV.jsx)((0, $48j9G.CollectionTrialModal), {});
        }
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $4q39A.CollectionChangePlanPopup), {});
    }
    if ((0, $1yMee.isEligibleForTWCAddPaymentDetails)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aVuvl.CollectionAddPaymentDetailsPopup), {});
    if ((0, $MOTjl.isEligibleForEAtoOSBNonRTPremiumAndRTPredunning)(context)) {
        const cohort = getExperimentCohort('ea-to-osb-nonrt-premium-rt-predunning-ab', false);
        if (cohort === 'variation') return /*#__PURE__*/ (0, $5chsV.jsx)((0, $7KnVX.PaymentFlowLink), {});
    }
    if ((0, $i56hz.isEligibleForReverseTrialPlanSelection)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $d4Ntt.PlanSelectionPageModal), {
        type: "reverse-trial"
    });
    if ((0, $7Hn1d.isEligibleForReverseTrial)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hhEZh.ReverseTrialPopupDialog), {});
    if ((0, $92lDb.isEligibleForPremiumPaymentDetailsPopup)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $i1i2R.PaymentDetailsPopup), {});
    if ((0, $31xHR.isEligibleForJiraPremiumPredunning)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $7KnVX.PaymentFlowLink), {});
    if ((0, $aE3ln.isEligibleForConfluenceBuyReverseTrial)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $d4Ntt.PlanSelectionPageModal), {
        type: "reverse-trial"
    });
    if ((0, $3nAzh.isEligibleForConfluencePremiumPopup)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bfeRu.PremiumPopup), {});
    if ((0, $h6HlO.isEligibleForPremiumAddPaymentModal)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $b3tXy.PremiumAddPaymentModal), {});
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6dj2G.IneligibleAnalytics), {});
}
$7290c920b270344a$var$PremiumEdition.displayName = "PremiumEdition";
function $7290c920b270344a$export$3bec899b1babe0fe() {
    const context = (0, $eOaYv.useEditionAwareness)();
    const { edition: edition } = context;
    if (edition === 'free') return /*#__PURE__*/ (0, $5chsV.jsx)($7290c920b270344a$var$FreeEdition, {});
    if ((0, $2qx5E.isPaidStandard)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)($7290c920b270344a$var$PaidStandard, {});
    if (edition === 'standard') return /*#__PURE__*/ (0, $5chsV.jsx)($7290c920b270344a$var$StandardEdition, {});
    if ((0, $lrnRV.isPaidPremium)(context)) return /*#__PURE__*/ (0, $5chsV.jsx)($7290c920b270344a$var$PaidPremium, {});
    if (edition === 'premium') return /*#__PURE__*/ (0, $5chsV.jsx)($7290c920b270344a$var$PremiumEdition, {});
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6dj2G.IneligibleAnalytics), {});
}
$7290c920b270344a$export$3bec899b1babe0fe.displayName = "ActionsAndContent";

});
parcelRegister("6dj2G", function(module, exports) {
$parcel$export(module.exports, "IneligibleAnalytics", () => $ea125b488c2ad0c3$export$132e847a0a2f0eca);

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $eOaYv = parcelRequire("eOaYv");

var $3dBeg = parcelRequire("3dBeg");
/**
 * One off event which tracks when a customer is eligible/ineligible for edition awareness.
 */ function $ea125b488c2ad0c3$var$useTrackAudienceAndTiming({ isEligible: isEligible, shouldTrack: shouldTrack }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $3dBeg.useAnalytics)();
    const hasSent = (0, $fsvuC.useRef)(false);
    (0, $fsvuC.useEffect)(()=>{
        if (!shouldTrack || hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'operational',
            actionSubject: 'audienceAndTiming',
            actionSubjectId: 'editionAwareness',
            action: 'checked',
            attributes: {
                isEligible: isEligible
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        isEligible,
        shouldTrack
    ]);
}
function $ea125b488c2ad0c3$export$132e847a0a2f0eca() {
    const { edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, userRoles: userRoles } = (0, $eOaYv.useEditionAwareness)();
    const isPremiumSiteAdminNotInTrialOrPredunning = Boolean((0, $llCao.fg)('analytic_for_premium_site_admin') && edition === 'premium' && userRoles?.includes('SITE_ADMIN') && !isInTrial && !isInPredunning);
    const shouldTrack = Boolean(edition === 'free' || isInTrial || isInPredunning || isPremiumSiteAdminNotInTrialOrPredunning);
    $ea125b488c2ad0c3$var$useTrackAudienceAndTiming({
        isEligible: false,
        shouldTrack: shouldTrack
    });
    return null;
}

});
parcelRegister("3dBeg", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3e2b5e066787a523$export$85183a312807388d);
$parcel$export(module.exports, "getAttributesFromContexts", () => $3e2b5e066787a523$export$d97c97ed77ff09e8);
$parcel$export(module.exports, "defaultAttributes", () => $3e2b5e066787a523$export$38cd8db2db178f58);
$parcel$export(module.exports, "useAnalytics", () => $3e2b5e066787a523$export$e955abb82869dc84);

var $fsvuC = parcelRequire("fsvuC");

var $9fEYx = parcelRequire("9fEYx");

var $5jOIJ = parcelRequire("5jOIJ");

var $mhEfz = parcelRequire("mhEfz");

var $5Y9N2 = parcelRequire("5Y9N2");

var $eOaYv = parcelRequire("eOaYv");

var $j88QB = parcelRequire("j88QB");
const $3e2b5e066787a523$export$85183a312807388d = (0, $9fEYx.FabricChannel).growth;
function $3e2b5e066787a523$var$getAnalyticsBoolean({ value: value, whenTrue: whenTrue, whenFalse: whenFalse }) {
    if (value === whenTrue) return true;
    if (value === whenFalse) return false;
    return null;
}
const $3e2b5e066787a523$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        if (x.attributes) return {
            ...acc,
            ...x.attributes
        };
        return {
            ...acc,
            ...x ?? {}
        };
    }, {});
};
const $3e2b5e066787a523$export$38cd8db2db178f58 = {
    packageName: '@atlassian/edition-awareness',
    source: 'editionAwareness',
    featureId: 'edition-awareness',
    growthPillar: 'BUY'
};
function $3e2b5e066787a523$export$e955abb82869dc84() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    const editionAwarenessContext = (0, $eOaYv.useEditionAwareness)();
    const experimentContext = (0, $j88QB.useExperimentContext)();
    const sendAnalyticsEvent = (0, $fsvuC.useCallback)((payload)=>{
        const editionAwarenessContextAttributes = {
            // Required properties
            cloudId: editionAwarenessContext.cloudId,
            product: editionAwarenessContext.product,
            currentProductEdition: editionAwarenessContext.edition,
            // Payment properties
            isInvoiceable: $3e2b5e066787a523$var$getAnalyticsBoolean({
                value: editionAwarenessContext.invoiceableStatus,
                whenTrue: 'INVOICEABLE',
                whenFalse: 'NOT_INVOICEABLE'
            }),
            hasPaymentDetailsEntered: editionAwarenessContext.hasPaymentDetailsEntered,
            canAddPaymentDetails: editionAwarenessContext.canAddPaymentDetails,
            addPaymentDetailsExperienceUrl: editionAwarenessContext.addPaymentDetailsExperienceUrl,
            // Trial properties
            trialDaysLeft: editionAwarenessContext.trialDaysLeft,
            trialLengthDays: editionAwarenessContext.trialLengthDays,
            trialEndDate: editionAwarenessContext.trialEndDate,
            isInTrial: editionAwarenessContext.isInTrial,
            isInPredunning: editionAwarenessContext.isInPredunning,
            isInReverseTrial: editionAwarenessContext.isInReverseTrial,
            lastKnownTrial: editionAwarenessContext?.lastKnownTrial,
            offeringKey: editionAwarenessContext?.offeringKey,
            // Upgrade properties
            canUpgrade: editionAwarenessContext.canUpgrade,
            canDirectBuyUpgrade: editionAwarenessContext.canDirectBuyUpgrade,
            changeOfferingToStandardExperienceUrl: editionAwarenessContext.changeOfferingToStandardExperienceUrl,
            directBuyChangeOfferingToStandardExperienceUrl: editionAwarenessContext.directBuyChangeOfferingToStandardExperienceUrl,
            // Entitlement properties
            entitlementId: editionAwarenessContext.entitlementId,
            isInCollection: $3e2b5e066787a523$var$getAnalyticsBoolean({
                value: editionAwarenessContext.isInCollection,
                whenTrue: 'IN_COLLECTION',
                whenFalse: 'NOT_IN_COLLECTION'
            }),
            collectionType: editionAwarenessContext.collectionType,
            isSinglePaidApp: editionAwarenessContext.isSinglePaidApp,
            canBundleCollection: editionAwarenessContext.canBundleCollection,
            // User permissions properties
            userRoles: editionAwarenessContext.userRoles,
            // Site properties
            licensedUsers: editionAwarenessContext.licensedUsers,
            storageUsageInGB: editionAwarenessContext.storageUsageInGB,
            storageLimitInGB: editionAwarenessContext.storageLimitInGB,
            storageIsUnlimited: editionAwarenessContext.storageIsUnlimited,
            isEnterpriseCustomer: editionAwarenessContext.isEnterpriseCustomer,
            // Site traits
            automationUsage: editionAwarenessContext.automationUsage,
            lastAutomationFreeLimitBreachDate: editionAwarenessContext.lastAutomationFreeLimitBreachDate,
            automationFreeLimitStatus: editionAwarenessContext.automationFreeLimitStatus,
            isEligibleForJsmStandardToPremium: editionAwarenessContext.isEligibleForJsmStandardToPremium,
            isEligibleForJswStandardToPremium: editionAwarenessContext.isEligibleForJswStandardToPremium,
            isEligibleForJpdStandardToPremium: editionAwarenessContext.isEligibleForJpdStandardToPremium,
            isEligibleForConfluenceStandardToPremium: editionAwarenessContext.isEligibleForConfluenceStandardToPremium,
            isEligibleForJsmStandardToPremiumV2: editionAwarenessContext.isEligibleForJsmStandardToPremiumV2,
            isEligibleForJswStandardToPremiumV2: editionAwarenessContext.isEligibleForJswStandardToPremiumV2,
            isEligibleForJpdStandardToPremiumV2: editionAwarenessContext.isEligibleForJpdStandardToPremiumV2,
            isEligibleForConfluenceStandardToPremiumV2: editionAwarenessContext.isEligibleForConfluenceStandardToPremiumV2,
            isEligibleForJswPremiumToTwc: editionAwarenessContext.isEligibleForJswPremiumToTwc,
            isEligibleForConfluencePremiumToTwc: editionAwarenessContext.isEligibleForConfluencePremiumToTwc,
            // Capabilities
            shouldAutoOpen: editionAwarenessContext.shouldAutoOpen,
            isEnforceStorageLimitsEnabled: editionAwarenessContext.edition === 'free' && (editionAwarenessContext.product === 'jira-service-management' || editionAwarenessContext.product === 'jira-customer-service') && (0, $5Y9N2.default).getExperimentValue('jsmgrowth-267_enforce_storage_limits_servco_free', 'isEnabled', false)
        };
        if (payload instanceof (0, $5jOIJ.default)) {
            const contextAttributes = $3e2b5e066787a523$export$d97c97ed77ff09e8(payload.context);
            payload.update({
                ...payload.payload,
                attributes: {
                    ...contextAttributes,
                    ...$3e2b5e066787a523$export$38cd8db2db178f58,
                    ...payload.payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experiments: experimentContext.experiments()
                }
            }).fire($3e2b5e066787a523$export$85183a312807388d);
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                attributes: {
                    ...$3e2b5e066787a523$export$38cd8db2db178f58,
                    ...payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experiments: experimentContext.experiments()
                }
            });
            const contextAttributes = $3e2b5e066787a523$export$d97c97ed77ff09e8(event.context);
            event.update({
                attributes: {
                    ...contextAttributes,
                    ...event.payload.attributes
                }
            }).fire($3e2b5e066787a523$export$85183a312807388d);
        }
    }, [
        createAnalyticsEvent,
        editionAwarenessContext,
        experimentContext
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent
    };
}
function $3e2b5e066787a523$export$b901544a79a3bbad({ name: name, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = $3e2b5e066787a523$export$e955abb82869dc84();
    const hasSent = (0, $fsvuC.useRef)(false);
    (0, $fsvuC.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'screen',
            name: name,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        name,
        attributes
    ]);
    return null;
}
$3e2b5e066787a523$export$b901544a79a3bbad.displayName = "ScreenEvent";

});


parcelRegister("hvUnP", function(module, exports) {
$parcel$export(module.exports, "isEligibleForAutomationFreeLimitModal", () => $3c3e934ccf98925f$export$f8cd4dfe6dfcae9f);

var $fo0Wu = parcelRequire("fo0Wu");

var $84vV3 = parcelRequire("84vV3");
function $3c3e934ccf98925f$export$f8cd4dfe6dfcae9f(context) {
    const { isInCollection: isInCollection, edition: edition, automationFreeLimitStatus: automationFreeLimitStatus, product: product, canUpgrade: canUpgrade } = context;
    return Boolean(isInCollection === 'NOT_IN_COLLECTION' && (0, $fo0Wu.isEditionOneOf)(edition, [
        'free'
    ]) && (0, $84vV3.isProductOneOf)(product, [
        'jira'
    ]) && canUpgrade && automationFreeLimitStatus);
}

});
parcelRegister("fo0Wu", function(module, exports) {
$parcel$export(module.exports, "isEditionOneOf", () => $7bb553fe30dfcfb7$export$33790e51c030646b);
function $7bb553fe30dfcfb7$export$33790e51c030646b(edition, possibleMatches) {
    return possibleMatches.includes(edition);
}

});


parcelRegister("aE3ln", function(module, exports) {
$parcel$export(module.exports, "isEligibleForConfluenceBuyReverseTrial", () => $f2d0fcf0a892e756$export$e0ad20fde7eb6dc6);
function $f2d0fcf0a892e756$export$e0ad20fde7eb6dc6(context) {
    const { product: product, edition: edition, invoiceableStatus: invoiceableStatus, isInReverseTrial: isInReverseTrial, isInTrial: isInTrial, isInPredunning: isInPredunning, isInCollection: isInCollection, userRoles: userRoles, canAddPaymentDetails: canAddPaymentDetails, canUpgrade: canUpgrade } = context;
    return Boolean(isInCollection === 'NOT_IN_COLLECTION' && product === 'confluence' && edition === 'premium' && (isInTrial || isInPredunning) && isInReverseTrial && invoiceableStatus === 'NOT_INVOICEABLE' && userRoles?.includes('BILLING_ADMIN') && canAddPaymentDetails && canUpgrade);
}

});

parcelRegister("3nAzh", function(module, exports) {
$parcel$export(module.exports, "isEligibleForConfluencePremiumPopup", () => $a8761c6a5f2f9aa1$export$9416586c22ff4b30);

var $fo0Wu = parcelRequire("fo0Wu");
function $a8761c6a5f2f9aa1$export$9416586c22ff4b30(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, isInCollection: isInCollection } = context;
    return Boolean(isInCollection === 'NOT_IN_COLLECTION' && (0, $fo0Wu.isEditionOneOf)(edition, [
        'premium'
    ]) && product === 'confluence' && (isInTrial || isInPredunning));
}

});

parcelRegister("byEur", function(module, exports) {
$parcel$export(module.exports, "isEligibleForConfluenceStandardAddPaymentModal", () => $34b524c8bb134744$export$e836acfd81d43d40);

var $fo0Wu = parcelRequire("fo0Wu");
function $34b524c8bb134744$export$e836acfd81d43d40(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, isInCollection: isInCollection } = context;
    return Boolean(isInCollection === 'NOT_IN_COLLECTION' && (0, $fo0Wu.isEditionOneOf)(edition, [
        'standard'
    ]) && product === 'confluence' && (isInTrial || isInPredunning) && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails);
}

});

parcelRegister("gmtpF", function(module, exports) {
$parcel$export(module.exports, "isEligibleForEAtoOSBFreeWithPDE", () => $780ef48d82db77bc$export$2fc8b3290463c59f);

var $fo0Wu = parcelRequire("fo0Wu");

var $84vV3 = parcelRequire("84vV3");
function $780ef48d82db77bc$export$2fc8b3290463c59f(context) {
    const { product: product, edition: edition, canUpgrade: canUpgrade, changeOfferingToStandardExperienceUrl: changeOfferingToStandardExperienceUrl, isInCollection: isInCollection, hasPaymentDetailsEntered: hasPaymentDetailsEntered } = context;
    const isEligibleNonCollectionProduct = isInCollection === 'NOT_IN_COLLECTION' && (0, $84vV3.isProductOneOf)(product, [
        'jira',
        'jira-product-discovery',
        'confluence'
    ]);
    const isEligibleCollectionAgnosticProduct = (0, $84vV3.isProductOneOf)(product, [
        'jira-service-management'
    ]);
    return Boolean((0, $fo0Wu.isEditionOneOf)(edition, [
        'free'
    ]) && canUpgrade && hasPaymentDetailsEntered && changeOfferingToStandardExperienceUrl && (isEligibleNonCollectionProduct || isEligibleCollectionAgnosticProduct));
}

});

parcelRegister("MOTjl", function(module, exports) {
$parcel$export(module.exports, "isEligibleForEAtoOSBNonRTPremiumAndRTPredunning", () => $39fccb0307f9651a$export$5fbb167b086fdea2);

var $llCao = parcelRequire("llCao");
function $39fccb0307f9651a$export$5fbb167b086fdea2(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, isInReverseTrial: isInReverseTrial, isInCollection: isInCollection, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl } = context;
    const isRTPredunningAudience = isInReverseTrial && isInPredunning && (product === 'jira' || product === 'confluence');
    const isNonRTTrialAudience = !isInReverseTrial && (product === 'jira' && isInTrial || product === 'confluence' && (isInTrial || isInPredunning));
    return Boolean(isInCollection === 'NOT_IN_COLLECTION' && edition === 'premium' && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails && !!addPaymentDetailsExperienceUrl && (isRTPredunningAudience || isNonRTTrialAudience) && (0, $llCao.fg)('ea-to-osb-nonrt-premium-rt-predunning-kill-switch'));
}

});

parcelRegister("eMWWi", function(module, exports) {
$parcel$export(module.exports, "isEligibleForExploreEditionBenefitsModalReverseTrial", () => $67913bcbfd5d2480$export$7ae4df6a74f7f1f0);

var $llCao = parcelRequire("llCao");

var $84vV3 = parcelRequire("84vV3");
function $67913bcbfd5d2480$export$7ae4df6a74f7f1f0({ product: product, edition: edition, isInReverseTrial: isInReverseTrial, lastKnownTrial: lastKnownTrial }) {
    return Boolean(edition === 'standard' && isInReverseTrial && (0, $84vV3.isProductOneOf)(product, [
        'jira-service-management',
        'jira-customer-service'
    ]) && lastKnownTrial?.trialTrigger === 'CROSSFLOW_REVERSE_TRIAL' && (0, $llCao.fg)('jsmgrowth-369-reverse-trials-ea-kill-switch'));
}

});

parcelRegister("dGhAe", function(module, exports) {
$parcel$export(module.exports, "isEligibleForExploreEditionBenefitsModalStorageLimit", () => $80db5658e0553f78$export$e9fa57939363ea21);

var $84vV3 = parcelRequire("84vV3");
function $80db5658e0553f78$export$e9fa57939363ea21({ product: product, edition: edition, isInTrial: isInTrial, lastKnownTrial: lastKnownTrial }) {
    if (edition === 'standard' && isInTrial && (0, $84vV3.isProductOneOf)(product, [
        'jira-service-management',
        'jira-customer-service'
    ]) && lastKnownTrial?.trialTrigger === 'AUTO_UPGRADE_MEDIA_STORAGE_LIMIT') return true;
    return false;
}

});

parcelRegister("hGnef", function(module, exports) {
$parcel$export(module.exports, "isEligibleForExploreEditionBenefitsModalWithPDE", () => $b508288d313a02da$export$9c6d1794c9e6b0da);

var $84vV3 = parcelRequire("84vV3");
function $b508288d313a02da$export$9c6d1794c9e6b0da({ product: product, edition: edition, isInTrial: isInTrial, invoiceableStatus: invoiceableStatus, hasPaymentDetailsEntered: hasPaymentDetailsEntered }) {
    if (edition === 'standard' && isInTrial && (0, $84vV3.isProductOneOf)(product, [
        'jira-service-management',
        'jira-customer-service'
    ]) && (hasPaymentDetailsEntered || invoiceableStatus === 'INVOICEABLE')) return true;
    return false;
}

});

parcelRegister("2Cds1", function(module, exports) {
$parcel$export(module.exports, "isEligibleForExploreEditionBenefitsModalWithoutPDE", () => $edec691feb4b12ee$export$e4ac5dd74ecc884f);

var $84vV3 = parcelRequire("84vV3");
function $edec691feb4b12ee$export$e4ac5dd74ecc884f({ product: product, edition: edition, isInTrial: isInTrial, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails }) {
    if (edition === 'standard' && isInTrial && (0, $84vV3.isProductOneOf)(product, [
        'jira-service-management',
        'jira-customer-service'
    ]) && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails) return true;
    return false;
}

});

parcelRegister("caWwh", function(module, exports) {
$parcel$export(module.exports, "isEligibleForFreeToStandardModal", () => $d1f6cb2fc367cc03$export$4a67e7452b9d2774);

var $fo0Wu = parcelRequire("fo0Wu");

var $84vV3 = parcelRequire("84vV3");
function $d1f6cb2fc367cc03$export$4a67e7452b9d2774(context) {
    const { edition: edition, canUpgrade: canUpgrade, canDirectBuyUpgrade: canDirectBuyUpgrade, isInCollection: isInCollection, product: product, currentRoute: currentRoute } = context;
    return Boolean((0, $fo0Wu.isEditionOneOf)(edition, [
        'free'
    ]) && (canUpgrade || canDirectBuyUpgrade) && ((0, $84vV3.isProductOneOf)(product, [
        'jira-service-management'
    ]) && currentRoute !== 'ops' || // All the other products are eligible for non-collection sites
    isInCollection === 'NOT_IN_COLLECTION' && (0, $84vV3.isProductOneOf)(product, [
        'jira',
        'confluence',
        'jira-product-discovery'
    ])));
}

});

parcelRegister("31xHR", function(module, exports) {
$parcel$export(module.exports, "isEligibleForJiraPremiumPredunning", () => $0bd70c90f2630c5f$export$f46acfd104f09e48);

var $fo0Wu = parcelRequire("fo0Wu");

var $84vV3 = parcelRequire("84vV3");
function $0bd70c90f2630c5f$export$f46acfd104f09e48(context) {
    const { product: product, edition: edition, isInPredunning: isInPredunning, canAddPaymentDetails: canAddPaymentDetails, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, isInCollection: isInCollection, invoiceableStatus: invoiceableStatus } = context;
    return Boolean(isInCollection === 'NOT_IN_COLLECTION' && (0, $fo0Wu.isEditionOneOf)(edition, [
        'premium'
    ]) && isInPredunning && (0, $84vV3.isProductOneOf)(product, [
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ]) && canAddPaymentDetails && addPaymentDetailsExperienceUrl && invoiceableStatus === 'NOT_INVOICEABLE');
}

});

parcelRegister("hGecc", function(module, exports) {
$parcel$export(module.exports, "isEligibleForJiraStandardPredunning", () => $feb574b7757eb03d$export$99a24d1a09f0bdfd);

var $fo0Wu = parcelRequire("fo0Wu");

var $84vV3 = parcelRequire("84vV3");
function $feb574b7757eb03d$export$99a24d1a09f0bdfd(context) {
    const { product: product, edition: edition, isInPredunning: isInPredunning, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, isInCollection: isInCollection } = context;
    return Boolean(isInCollection === 'NOT_IN_COLLECTION' && (0, $fo0Wu.isEditionOneOf)(edition, [
        'standard'
    ]) && addPaymentDetailsExperienceUrl && isInPredunning && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails && (0, $84vV3.isProductOneOf)(product, [
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ]));
}

});

parcelRegister("hnVBT", function(module, exports) {
$parcel$export(module.exports, "JIRA_STANDARD_STORAGE_NEAR_LIMIT_GB_THRESHOLD", () => $070d7a5effaace51$export$a6a6312155517c3b);
$parcel$export(module.exports, "isEligibleForJiraStandardStorageHardLimit", () => $070d7a5effaace51$export$eed18760df24a6fd);
$parcel$export(module.exports, "isJiraStandardStorageNearLimit", () => $070d7a5effaace51$export$ac3ddca7b2f8a1c6);

var $llCao = parcelRequire("llCao");

var $fo0Wu = parcelRequire("fo0Wu");
const $070d7a5effaace51$export$a6a6312155517c3b = 1;
function $070d7a5effaace51$export$eed18760df24a6fd(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, storageUsageInGB: storageUsageInGB, storageLimitInGB: storageLimitInGB, storageIsUnlimited: storageIsUnlimited } = context;
    if (!storageUsageInGB || !storageLimitInGB) return false;
    return Boolean(product === 'jira' && (0, $fo0Wu.isEditionOneOf)(edition, [
        'standard'
    ]) && !isInTrial && !isInPredunning && !storageIsUnlimited && // Includes the near-limit band from `limit - 1 GB`. Who sees that band is not decided here:
    // the dispatch and the pill gate it on `canUpgradeToPremium`.
    storageUsageInGB >= storageLimitInGB - $070d7a5effaace51$export$a6a6312155517c3b && (0, $llCao.fg)('jira-standard-storage-hard-limits-kill-switch'));
}
function $070d7a5effaace51$export$ac3ddca7b2f8a1c6(context) {
    const { storageUsageInGB: storageUsageInGB, storageLimitInGB: storageLimitInGB } = context;
    if (!storageUsageInGB || !storageLimitInGB) return false;
    return storageUsageInGB >= storageLimitInGB - $070d7a5effaace51$export$a6a6312155517c3b && storageUsageInGB < storageLimitInGB;
}

});

parcelRegister("iCbte", function(module, exports) {
$parcel$export(module.exports, "isEligibleForJsmStorageNearLimit", () => $3e858486a11037ca$export$9be156eca6370e22);

var $5Y9N2 = parcelRequire("5Y9N2");
const $3e858486a11037ca$export$e651dfbe221a2c4 = 0.9;
// Hard-limit and near-limit are mutually exclusive at the threshold of
// storageUsageInGB === storageLimitInGB. The hard-limit predicate uses
// `>=` so we must use a strict `<` here AND defensively guard against
// floating-point drift around the boundary (e.g. usage 0.999_999 of a
// 1.0 limit). Without this, a fractional gigabyte of drift would route
// the user to "Storage almost full" while AdminHub shows "full".
//
// We treat anything within 1e-9 of the limit as already at the hard
// limit. JSM storage usage is reported in GB with at most 6 decimal
// places of precision upstream, so 1e-9 is well below any real-world
// drift while still keeping the boundary deterministic.
const $3e858486a11037ca$var$FLOAT_DRIFT_TOLERANCE = 1e-9;
function $3e858486a11037ca$export$9be156eca6370e22(context) {
    const { storageUsageInGB: storageUsageInGB, storageLimitInGB: storageLimitInGB, storageIsUnlimited: storageIsUnlimited, product: product, edition: edition, canUpgrade: canUpgrade, canDirectBuyUpgrade: canDirectBuyUpgrade, userRoles: userRoles } = context;
    if (!storageUsageInGB || !storageLimitInGB) return false;
    const userIsJiraAdmin = userRoles?.includes('JIRA_ADMIN') ?? false;
    const usageRatio = storageUsageInGB / storageLimitInGB;
    const isStrictlyBelowHardLimit = usageRatio < 1 - $3e858486a11037ca$var$FLOAT_DRIFT_TOLERANCE;
    const isStorageLimitsExperimentEnabled = edition === 'free' && (product === 'jira-service-management' || product === 'jira-customer-service') && (0, $5Y9N2.default).getExperimentValue('jsmgrowth-267_enforce_storage_limits_servco_free', 'isEnabled', false);
    return product === 'jira-service-management' && userIsJiraAdmin && edition === 'free' && !!(canUpgrade || canDirectBuyUpgrade) && !storageIsUnlimited && usageRatio >= $3e858486a11037ca$export$e651dfbe221a2c4 && isStrictlyBelowHardLimit && isStorageLimitsExperimentEnabled;
}

});

parcelRegister("1r0W6", function(module, exports) {
$parcel$export(module.exports, "isEligibleForJsmStorageOverLimit", () => $5752026dcaba4064$export$7748cf7f08a86647);

var $5Y9N2 = parcelRequire("5Y9N2");
function $5752026dcaba4064$export$7748cf7f08a86647(context) {
    const { storageUsageInGB: storageUsageInGB, storageLimitInGB: storageLimitInGB, storageIsUnlimited: storageIsUnlimited, product: product, edition: edition, canUpgrade: canUpgrade, canDirectBuyUpgrade: canDirectBuyUpgrade, userRoles: userRoles } = context;
    if (!storageUsageInGB || !storageLimitInGB) return false;
    const userIsJiraAdmin = userRoles?.includes('JIRA_ADMIN') ?? false;
    const isStorageLimitsExperimentEnabled = edition === 'free' && (product === 'jira-service-management' || product === 'jira-customer-service') && (0, $5Y9N2.default).getExperimentValue('jsmgrowth-267_enforce_storage_limits_servco_free', 'isEnabled', false);
    return product === 'jira-service-management' && userIsJiraAdmin && edition === 'free' && !!(canUpgrade || canDirectBuyUpgrade) && !storageIsUnlimited && storageUsageInGB >= storageLimitInGB && isStorageLimitsExperimentEnabled;
}

});

parcelRegister("h6HlO", function(module, exports) {
$parcel$export(module.exports, "isEligibleForPremiumAddPaymentModal", () => $de967f62b61eaf21$export$8ca336c4787758f5);

var $fo0Wu = parcelRequire("fo0Wu");

var $84vV3 = parcelRequire("84vV3");
function $de967f62b61eaf21$export$8ca336c4787758f5(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails } = context;
    return Boolean((0, $fo0Wu.isEditionOneOf)(edition, [
        'premium'
    ]) && isInTrial && (0, $84vV3.isProductOneOf)(product, [
        'jira-service-management',
        'jira-product-discovery'
    ]) && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails);
}

});

parcelRegister("92lDb", function(module, exports) {
$parcel$export(module.exports, "isEligibleForPremiumPaymentDetailsPopup", () => $6ca3c47489031e17$export$20fafa3abc2da179);

var $fo0Wu = parcelRequire("fo0Wu");
function $6ca3c47489031e17$export$20fafa3abc2da179(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInReverseTrial: isInReverseTrial, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, isInCollection: isInCollection, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails } = context;
    return Boolean(isInCollection === 'NOT_IN_COLLECTION' && (0, $fo0Wu.isEditionOneOf)(edition, [
        'premium'
    ]) && product === 'jira' && isInTrial && !isInReverseTrial && addPaymentDetailsExperienceUrl && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails);
}

});

parcelRegister("fqXcR", function(module, exports) {
$parcel$export(module.exports, "isEligibleForPremiumToTwc", () => $f0525ce62e73830d$export$cba3da60a47f96);

var $llCao = parcelRequire("llCao");

var $fo0Wu = parcelRequire("fo0Wu");

var $84vV3 = parcelRequire("84vV3");
const $f0525ce62e73830d$var$PRODUCT_TRAIT_ELIGIBILITY = {
    jira: 'isEligibleForJswPremiumToTwc',
    confluence: 'isEligibleForConfluencePremiumToTwc'
};
function $f0525ce62e73830d$var$getProductTraitEligibility(context) {
    const traitKey = $f0525ce62e73830d$var$PRODUCT_TRAIT_ELIGIBILITY[context.product];
    return traitKey ? Boolean(context[traitKey]) : false;
}
function $f0525ce62e73830d$export$cba3da60a47f96(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, isSinglePaidApp: isSinglePaidApp, canBundleCollection: canBundleCollection, userRoles: userRoles, hasDismissedButton: hasDismissedButton, onDismissButton: onDismissButton } = context;
    return Boolean((0, $84vV3.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && (0, $fo0Wu.isEditionOneOf)(edition, [
        'premium'
    ]) && $f0525ce62e73830d$var$getProductTraitEligibility(context) && !isInTrial && !isInPredunning && isSinglePaidApp && userRoles?.includes('SITE_ADMIN') && canBundleCollection && hasDismissedButton === false && typeof onDismissButton === 'function' && (0, $llCao.fg)('premium-to-twc-upsell'));
}

});

parcelRegister("7Hn1d", function(module, exports) {
$parcel$export(module.exports, "isEligibleForReverseTrial", () => $4aafb56e6bc2b812$export$a40237193d8c237b);

var $fo0Wu = parcelRequire("fo0Wu");
function $4aafb56e6bc2b812$export$a40237193d8c237b(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInReverseTrial: isInReverseTrial, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, isInCollection: isInCollection, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails } = context;
    return Boolean(isInCollection === 'NOT_IN_COLLECTION' && (0, $fo0Wu.isEditionOneOf)(edition, [
        'premium'
    ]) && product === 'jira' && isInTrial && isInReverseTrial && addPaymentDetailsExperienceUrl && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails);
}

});

parcelRegister("i56hz", function(module, exports) {
$parcel$export(module.exports, "isEligibleForReverseTrialPlanSelection", () => $7507fdb3f7fec211$export$e939a07b6b49e3d2);

var $llCao = parcelRequire("llCao");

var $fo0Wu = parcelRequire("fo0Wu");
function $7507fdb3f7fec211$export$e939a07b6b49e3d2(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, isInReverseTrial: isInReverseTrial, userRoles: userRoles, isInCollection: isInCollection, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, canUpgrade: canUpgrade } = context;
    return Boolean(isInCollection === 'NOT_IN_COLLECTION' && product === 'jira' && (isInTrial || isInPredunning) && isInReverseTrial && userRoles?.includes('BILLING_ADMIN') && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails && canUpgrade && (0, $fo0Wu.isEditionOneOf)(edition, (0, $llCao.fg)('reverse_trial_on_standard_ea_kill_switch') ? [
        'premium',
        'standard'
    ] : [
        'premium'
    ]));
}

});

parcelRegister("2OzPO", function(module, exports) {
$parcel$export(module.exports, "isEligibleForStandardAddPaymentModal", () => $4f3c397625f59b56$export$3895b7d1f33e279e);

var $fo0Wu = parcelRequire("fo0Wu");

var $84vV3 = parcelRequire("84vV3");
function $4f3c397625f59b56$export$3895b7d1f33e279e(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails } = context;
    return Boolean((0, $fo0Wu.isEditionOneOf)(edition, [
        'standard'
    ]) && isInTrial && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails && (0, $84vV3.isProductOneOf)(product, [
        'jira-service-management',
        'jira-product-discovery'
    ]));
}

});

parcelRegister("dPgpR", function(module, exports) {
$parcel$export(module.exports, "isEligibleForStandardPaymentDetailsPopup", () => $9892cf7cd6ba9908$export$b02d2c2f86fa7487);

var $fo0Wu = parcelRequire("fo0Wu");
function $9892cf7cd6ba9908$export$b02d2c2f86fa7487(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, isInCollection: isInCollection } = context;
    return Boolean(isInCollection === 'NOT_IN_COLLECTION' && (0, $fo0Wu.isEditionOneOf)(edition, [
        'standard'
    ]) && product === 'jira' && isInTrial && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails);
}

});

parcelRegister("aADqg", function(module, exports) {
$parcel$export(module.exports, "isEligibleForStandardPaymentFlowLink", () => $7d039f5246299b24$export$1906afb287ebb7aa);

var $fo0Wu = parcelRequire("fo0Wu");

var $84vV3 = parcelRequire("84vV3");
function $7d039f5246299b24$export$1906afb287ebb7aa(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, isInCollection: isInCollection } = context;
    return Boolean(isInCollection === 'NOT_IN_COLLECTION' && (0, $fo0Wu.isEditionOneOf)(edition, [
        'standard'
    ]) && (isInTrial || isInPredunning) && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails && (0, $84vV3.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && addPaymentDetailsExperienceUrl);
}

});

parcelRegister("1ZV8K", function(module, exports) {
$parcel$export(module.exports, "isEligibleForStandardToPremium", () => $0c25aca510bcc596$export$d58c0da339bf36d9);

var $llCao = parcelRequire("llCao");

var $fo0Wu = parcelRequire("fo0Wu");

var $gvKck = parcelRequire("gvKck");
function $0c25aca510bcc596$var$getProductTraitEligibility(context) {
    const traitKey = (0, $gvKck.STANDARD_TO_PREMIUM_TRAIT_ELIGIBILITY)[context.product];
    return traitKey ? Boolean(context[traitKey]) : false;
}
function $0c25aca510bcc596$export$d58c0da339bf36d9(context) {
    const { edition: edition, isInCollection: isInCollection, isInTrial: isInTrial, isInPredunning: isInPredunning, userRoles: userRoles, hasDismissedButton: hasDismissedButton, onDismissButton: onDismissButton } = context;
    return Boolean((0, $fo0Wu.isEditionOneOf)(edition, [
        'standard'
    ]) && // This trait will also check the supported products
    $0c25aca510bcc596$var$getProductTraitEligibility(context) && userRoles?.includes('SITE_ADMIN') && !isInTrial && !isInPredunning && hasDismissedButton === false && typeof onDismissButton === 'function' && // Paid sites outside a collection may have no entitlement returned by the query filter,
    // leaving collection status UNKNOWN. Requiring NOT_IN_COLLECTION would exclude those sites.
    ((0, $llCao.fg)('ea_remove_twc_standard_to_premium') ? isInCollection !== 'IN_COLLECTION' : true));
}

});

parcelRegister("9Z7AB", function(module, exports) {
$parcel$export(module.exports, "isEligibleForStandardToPremiumIncentiveOffer", () => $6bcf45e4b5546317$export$9ce364ffd394a924);

var $llCao = parcelRequire("llCao");

var $1ZV8K = parcelRequire("1ZV8K");

var $84vV3 = parcelRequire("84vV3");
function $6bcf45e4b5546317$export$9ce364ffd394a924(context) {
    const { product: product, isInCollection: isInCollection } = context;
    return (0, $1ZV8K.isEligibleForStandardToPremium)(context) && (0, $84vV3.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && // On paid standard, we know the site is standalone if this is not IN_COLLECTION
    isInCollection !== 'IN_COLLECTION' && (0, $llCao.fg)('standard_to_premium_incentive_offer_ea_kill_switch');
}

});

parcelRegister("8Nx3j", function(module, exports) {
$parcel$export(module.exports, "isEligibleForStorageHardLimit", () => $706db04dc6290302$export$8057dcbab6360925);
function $706db04dc6290302$export$8057dcbab6360925(context) {
    const { storageUsageInGB: storageUsageInGB, storageLimitInGB: storageLimitInGB, storageIsUnlimited: storageIsUnlimited, product: product, edition: edition, isInCollection: isInCollection, canUpgrade: canUpgrade, canDirectBuyUpgrade: canDirectBuyUpgrade } = context;
    if (!storageUsageInGB || !storageLimitInGB) return false;
    return Boolean(isInCollection === 'NOT_IN_COLLECTION' && product === 'jira' && edition === 'free' && (canUpgrade || canDirectBuyUpgrade) && !storageIsUnlimited && storageUsageInGB >= storageLimitInGB);
}

});

parcelRegister("1yMee", function(module, exports) {
$parcel$export(module.exports, "isEligibleForTWCAddPaymentDetails", () => $e13d64eefffe2f43$export$92559b6c170c03d7);

var $fo0Wu = parcelRequire("fo0Wu");

var $84vV3 = parcelRequire("84vV3");
function $e13d64eefffe2f43$export$92559b6c170c03d7(context) {
    const { product: product, edition: edition, isInCollection: isInCollection, isInPredunning: isInPredunning, userRoles: userRoles } = context;
    return Boolean((0, $fo0Wu.isEditionOneOf)(edition, [
        'standard',
        'premium'
    ]) && isInCollection === 'IN_COLLECTION' && (0, $84vV3.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && userRoles?.includes('BILLING_ADMIN') && isInPredunning);
}

});

parcelRegister("e2lbi", function(module, exports) {
$parcel$export(module.exports, "isEligibleForTWCChangePlan", () => $251b221edb6cc2ed$export$81d798ee41a14e1f);

var $fo0Wu = parcelRequire("fo0Wu");

var $84vV3 = parcelRequire("84vV3");
function $251b221edb6cc2ed$export$81d798ee41a14e1f(context) {
    const { product: product, edition: edition, isInCollection: isInCollection, isInTrial: isInTrial, userRoles: userRoles, invoiceableStatus: invoiceableStatus } = context;
    return Boolean((0, $fo0Wu.isEditionOneOf)(edition, [
        'standard',
        'premium'
    ]) && isInCollection === 'IN_COLLECTION' && (0, $84vV3.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && userRoles?.includes('BILLING_ADMIN') && isInTrial && invoiceableStatus !== 'NOT_INVOICEABLE');
}

});

parcelRegister("nd4Sn", function(module, exports) {
$parcel$export(module.exports, "isEligibleForTWCPlanSelectionPage", () => $557675a6250785f7$export$1110acfc7a546604);

var $fo0Wu = parcelRequire("fo0Wu");

var $84vV3 = parcelRequire("84vV3");
function $557675a6250785f7$export$1110acfc7a546604(context) {
    const { product: product, edition: edition, isInCollection: isInCollection, userRoles: userRoles } = context;
    return Boolean((0, $fo0Wu.isEditionOneOf)(edition, [
        'free'
    ]) && isInCollection === 'IN_COLLECTION' && (0, $84vV3.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && userRoles?.includes('BILLING_ADMIN'));
}

});

parcelRegister("cTE2C", function(module, exports) {
$parcel$export(module.exports, "isEligibleForTWCTrialNoPDE", () => $08673bbba20c28c4$export$f7ff9356fa50dbb8);

var $fo0Wu = parcelRequire("fo0Wu");

var $84vV3 = parcelRequire("84vV3");
function $08673bbba20c28c4$export$f7ff9356fa50dbb8(context) {
    const { product: product, edition: edition, isInCollection: isInCollection, isInTrial: isInTrial, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, userRoles: userRoles } = context;
    return Boolean((0, $fo0Wu.isEditionOneOf)(edition, [
        'standard',
        'premium'
    ]) && isInCollection === 'IN_COLLECTION' && (0, $84vV3.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && userRoles?.includes('BILLING_ADMIN') && isInTrial && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails);
}

});

parcelRegister("5FGz7", function(module, exports) {
$parcel$export(module.exports, "isEligibleForUserLimitDirectBuy", () => $6665bb96f6fe6bd3$export$ee4d476587a8361b);

var $llCao = parcelRequire("llCao");

var $fo0Wu = parcelRequire("fo0Wu");

var $84vV3 = parcelRequire("84vV3");

var $coImd = parcelRequire("coImd");
function $6665bb96f6fe6bd3$export$ee4d476587a8361b(context) {
    const { product: product, edition: edition, isInCollection: isInCollection, licensedUsers: licensedUsers, canUpgrade: canUpgrade, canDirectBuyUpgrade: canDirectBuyUpgrade } = context;
    const { warningUserLimit: warningUserLimit, licensedUserLimit: licensedUserLimit } = (0, $coImd.PRODUCT_LIMITS_MAP).jira;
    return Boolean(isInCollection === 'NOT_IN_COLLECTION' && (0, $fo0Wu.isEditionOneOf)(edition, [
        'free'
    ]) && (0, $84vV3.isProductOneOf)(product, [
        'jira'
    ]) && licensedUsers >= warningUserLimit && licensedUsers <= licensedUserLimit && // Include existing EA upgrade viewers, even when they cannot direct buy.
    (canUpgrade || canDirectBuyUpgrade) && (0, $llCao.fg)('twcg-2318_ea_user_limit_direct_buy_kill_switch'));
}

});
parcelRegister("coImd", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_LIMITS_MAP", () => $207d5ed2f552de85$export$4e1b24dd66f07b40);
const $207d5ed2f552de85$export$4e1b24dd66f07b40 = {
    'jira-product-discovery': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    },
    jira: {
        licensedUserLimit: 10,
        warningUserLimit: 7
    },
    confluence: {
        licensedUserLimit: 10,
        warningUserLimit: 3
    },
    'jira-service-management': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    },
    'jira-customer-service': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    }
};

});


parcelRegister("lrnRV", function(module, exports) {
$parcel$export(module.exports, "isPaidPremium", () => $d0369ba3b972a0f2$export$fa864051bd534508);
function $d0369ba3b972a0f2$export$fa864051bd534508({ edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning }) {
    return edition === 'premium' && !isInTrial && !isInPredunning;
}

});

parcelRegister("2qx5E", function(module, exports) {
$parcel$export(module.exports, "isPaidStandard", () => $e74a3d524555352e$export$f72be74abc9ed8ec);
function $e74a3d524555352e$export$f72be74abc9ed8ec({ edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning }) {
    return edition === 'standard' && !isInTrial && !isInPredunning;
}

});

parcelRegister("9cCkE", function(module, exports) {
$parcel$export(module.exports, "useGetStandardStorageHardLimitData", () => $a839a2c3e37edbfa$export$809848670d06510b);

var $ejTBG = parcelRequire("ejTBG");

var $fsvuC = parcelRequire("fsvuC");

var $iNT4o = parcelRequire("iNT4o");

var $6hOVZ = parcelRequire("6hOVZ");

var $eOaYv = parcelRequire("eOaYv");

var $lUy4V = parcelRequire("lUy4V");
function $a839a2c3e37edbfa$export$809848670d06510b() {
    const { cloudId: cloudId, product: product, edition: edition } = (0, $eOaYv.useEditionAwareness)();
    const environment = (0, $iNT4o.useRelayEnvironment)();
    const reportError = (0, $6hOVZ.useErrorAnalytics)({
        product: product,
        edition: edition,
        id: 'use-get-standard-storage-hard-limit-data'
    });
    const [returnData, setReturnData] = (0, $fsvuC.useState)({
        data: null,
        loading: true,
        error: null
    });
    (0, $fsvuC.useEffect)(()=>{
        (0, $iNT4o.fetchQuery)(environment, (0, $ejTBG.default), {
            cloudId: cloudId,
            productKey: (0, $lUy4V.getHamsKey)(product)
        }).toPromise().then((data)=>{
            const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
            // Resolved before the relationships check so a returned capability survives null relationships
            const changeOfferingToPremium = entitlement?.experienceCapabilities?.changeOfferingV2ToPremium;
            const experienceUrl = changeOfferingToPremium?.experienceUrl;
            const isAvailableToUser = changeOfferingToPremium?.isAvailableToUser;
            const relationships = entitlement?.relatesFromEntitlements;
            if (!relationships) return setReturnData({
                data: {
                    experienceUrl: experienceUrl,
                    isAvailableToUser: isAvailableToUser,
                    isInCollection: 'UNKNOWN'
                },
                loading: false,
                error: null
            });
            const isInCollection = relationships.some((relationship)=>relationship?.relationshipType === 'COLLECTION' && relationship.entitlementId) ? 'IN_COLLECTION' : 'NOT_IN_COLLECTION';
            return setReturnData({
                data: {
                    experienceUrl: experienceUrl,
                    isAvailableToUser: isAvailableToUser,
                    isInCollection: isInCollection
                },
                loading: false,
                error: null
            });
        }).catch((e)=>{
            const error = e instanceof Error ? e : new Error(String(e));
            reportError(error);
            setReturnData({
                data: null,
                loading: false,
                error: error
            });
        });
    }, [
        cloudId,
        environment,
        product,
        reportError
    ]);
    return returnData;
}

});
parcelRegister("ejTBG", function(module, exports) {
$parcel$export(module.exports, "default", () => $08f7ac3a5bb6c624$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a095ffa0df04ec4d228271fbefaf526a>>
 * @relayHash 8f93f6ba1a918a7cc8225f7aac606f0f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2d836981a058f6aa308263aa0ec0f93cc601ef2e57d352711e156824636b6e80
const $08f7ac3a5bb6c624$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "productKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v3 = {
        "args": [
            {
                "kind": "Literal",
                "name": "relationshipTypes",
                "value": "COLLECTION"
            }
        ],
        "concreteType": "CcpEntitlementRelationship",
        "kind": "LinkedField",
        "name": "relatesFromEntitlements",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "relationshipType"
            },
            {
                "kind": "ScalarField",
                "name": "entitlementId"
            }
        ],
        "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
    }, v4 = {
        "concreteType": "CcpEntitlementExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "alias": "changeOfferingV2ToPremium",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "offeringName",
                        "value": "Premium"
                    }
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isAvailableToUser"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "experienceUrl"
                    }
                ],
                "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useGetStandardStorageHardLimitDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useGetStandardStorageHardLimitDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2d836981a058f6aa308263aa0ec0f93cc601ef2e57d352711e156824636b6e80",
            "metadata": {},
            "name": "useGetStandardStorageHardLimitDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$08f7ac3a5bb6c624$var$node.hash = "23e955f3f4e1848d0b211453ad2ad373";
var $08f7ac3a5bb6c624$export$2e2bcd8739ae039 = $08f7ac3a5bb6c624$var$node;

});

parcelRegister("6hOVZ", function(module, exports) {
$parcel$export(module.exports, "isSLOError", () => $eb4db5ac38035655$export$3588d828587fb858);
$parcel$export(module.exports, "useErrorAnalytics", () => $eb4db5ac38035655$export$e2d4523bbccd2343);

var $fsvuC = parcelRequire("fsvuC");

var $l8KEn = parcelRequire("l8KEn");
/**
 * This hook is designed to be used before contexts are initialized to avoid circular dependencies.
 */ function $eb4db5ac38035655$var$useOperationalFailureAnalytics({ product: product, edition: edition }) {
    const sendOperationalEvent = (0, $l8KEn.useOperationalAnalytics)({
        product: product,
        edition: edition
    });
    return (0, $fsvuC.useCallback)((attributes)=>{
        sendOperationalEvent({
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: attributes
        });
    }, [
        sendOperationalEvent
    ]);
}
/**
 * These are errors which we ignore from SLO reporting to ensure we reporting on errors we can action
 */ const $eb4db5ac38035655$var$nonSLOErrors = [
    /**
	 * These occur when the fetch request fails (usually this is because the users network is offline)
	 *
	 * This is usually thrown from inside of the products fetch handler
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws this error to every fetch request
	 */ /failed to fetch/i,
    /**
	 * These occur when the fetch request fails due to a server response (e.g. 401 due to the user needing to reauthenticate their session)
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws server errors after parsing the response headers
	 */ /Error server response:/i
];
function $eb4db5ac38035655$export$3588d828587fb858(error) {
    // Just checks that none of our non slo errors match the error
    return !$eb4db5ac38035655$var$nonSLOErrors.some((msg)=>msg.test(error.message));
}
function $eb4db5ac38035655$export$e2d4523bbccd2343({ product: product, edition: edition, id: id }) {
    const sendOperationalFailure = $eb4db5ac38035655$var$useOperationalFailureAnalytics({
        product: product,
        edition: edition
    });
    return (0, $fsvuC.useCallback)((error)=>{
        sendOperationalFailure({
            error: error.message,
            errorStack: error.stack,
            errorName: error.name,
            id: id ?? 'unknownErrorId',
            isSLOError: $eb4db5ac38035655$export$3588d828587fb858(error)
        });
    }, [
        sendOperationalFailure,
        id
    ]);
}
function $eb4db5ac38035655$export$45aafd752da9ba22({ product: product, edition: edition }) {
    const sendOperationalFailure = $eb4db5ac38035655$var$useOperationalFailureAnalytics({
        product: product,
        edition: edition
    });
    return (0, $fsvuC.useCallback)((dataValidationError)=>{
        sendOperationalFailure({
            dataValidationError: dataValidationError,
            id: 'dataValidationError'
        });
    }, [
        sendOperationalFailure
    ]);
}

});
parcelRegister("l8KEn", function(module, exports) {
$parcel$export(module.exports, "useOperationalAnalytics", () => $e42e45100f0406c2$export$18e9461e904f638a);

var $fsvuC = parcelRequire("fsvuC");

var $mhEfz = parcelRequire("mhEfz");

var $3dBeg = parcelRequire("3dBeg");
function $e42e45100f0406c2$export$18e9461e904f638a({ product: product, edition: edition }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    return (0, $fsvuC.useCallback)(({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
        const event = createAnalyticsEvent({
            eventType: 'operational',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...(0, $3dBeg.defaultAttributes),
                product: product,
                currentProductEdition: edition,
                ...attributes
            }
        });
        const contextAttributes = (0, $3dBeg.getAttributesFromContexts)(event.context);
        event.update({
            attributes: {
                ...contextAttributes,
                ...event.payload.attributes
            }
        }).fire((0, $3dBeg.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        product,
        edition
    ]);
}

});



parcelRegister("04eA3", function(module, exports) {
$parcel$export(module.exports, "USER_LIMIT_DIRECT_BUY_EXPERIMENT", () => $3d8efc2282477088$export$63d6a69f5a656a93);
$parcel$export(module.exports, "useUserLimitDirectBuyExperiment", () => $3d8efc2282477088$export$639ce90b3966b8f3);

var $fsvuC = parcelRequire("fsvuC");

var $eOaYv = parcelRequire("eOaYv");

var $j88QB = parcelRequire("j88QB");

var $5FGz7 = parcelRequire("5FGz7");
const $3d8efc2282477088$export$63d6a69f5a656a93 = 'twcg-2318_ea_user_limit_direct_buy_experiment';
function $3d8efc2282477088$export$639ce90b3966b8f3() {
    const context = (0, $eOaYv.useEditionAwareness)();
    const { getExperimentCohort: getExperimentCohort } = (0, $j88QB.useGetExperimentValue)();
    const expose = (0, $fsvuC.useCallback)(()=>{
        if (!(0, $5FGz7.isEligibleForUserLimitDirectBuy)(context)) return;
        getExperimentCohort($3d8efc2282477088$export$63d6a69f5a656a93);
    }, [
        context,
        getExperimentCohort
    ]);
    return {
        expose: expose
    };
}

});

parcelRegister("gNndG", function(module, exports) {
$parcel$export(module.exports, "AutomationFreeLimitModal", () => $48d32aa72bdd1e46$export$b124b7369c64df7c);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $eOaYv = parcelRequire("eOaYv");

var $aJ73T = parcelRequire("aJ73T");

var $2njtZ = parcelRequire("2njtZ");

var $auT0T = parcelRequire("auT0T");
function $48d32aa72bdd1e46$export$b124b7369c64df7c() {
    const { edition: edition } = (0, $eOaYv.useEditionAwareness)();
    const DIALOG_CONFIG = (0, $fsvuC.useMemo)(()=>{
        if (edition === 'free') return 0, $auT0T.FREE_DIALOG_CONFIG;
        throw new Error(`Unsupported edition: ${edition}`);
    }, [
        edition
    ]);
    const modalProps = (0, $fsvuC.useMemo)(()=>({
            width: 968,
            height: 516
        }), []);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aJ73T.ModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $2njtZ.default),
        dialogConfig: DIALOG_CONFIG
    });
}
$48d32aa72bdd1e46$export$b124b7369c64df7c.displayName = "AutomationFreeLimitModal";

});
parcelRegister("aJ73T", function(module, exports) {
$parcel$export(module.exports, "ModalEntryPoint", () => $a1bb579510efed80$export$50a5ec7edfae079b);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $9sl8X = parcelRequire("9sl8X");

var $aa5ZN = parcelRequire("aa5ZN");

var $kPtWX = parcelRequire("kPtWX");

var $fwygm = parcelRequire("fwygm");

var $ezp5D = parcelRequire("ezp5D");

var $8iLmE = parcelRequire("8iLmE");

var $hD4W1 = parcelRequire("hD4W1");

var $fqMum = parcelRequire("fqMum");
function $a1bb579510efed80$export$50a5ec7edfae079b(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fwygm.DialogContext).Provider, {
        value: dialogConfig,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $9sl8X.default), {
            data: dialogConfig,
            children: /*#__PURE__*/ (0, $5chsV.jsx)($a1bb579510efed80$var$ModalEntryPointInner, {
                ...rest
            })
        })
    });
}
$a1bb579510efed80$export$50a5ec7edfae079b.displayName = "ModalEntryPoint";
function $a1bb579510efed80$var$ModalEntryPointInner(props) {
    const { shouldAutoOpen: shouldAutoOpen, entryPointProps: entryPointProps, onError: onError, ...rest } = props;
    const onEntrypointError = (0, $ezp5D.useEntrypointErrorAnalytics)();
    const onErrorCallback = (0, $fsvuC.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        onEntrypointError({
            error: error,
            errorInfo: errorInfo
        });
        onError?.({
            error: error,
            errorInfo: errorInfo
        });
    }, [
        onEntrypointError,
        onError
    ]);
    const onCloseDialog = (0, $8iLmE.useOnCloseDialog)();
    const onClose = (0, $fsvuC.useCallback)((extraInformation)=>{
        let attributes;
        if (extraInformation && typeof extraInformation === 'object' && 'triggeredBy' in extraInformation) attributes = {
            triggeredBy: extraInformation.triggeredBy
        };
        onCloseDialog(attributes);
        entryPointProps?.onClose?.();
    }, [
        entryPointProps,
        onCloseDialog
    ]);
    const finalEntryPointProps = (0, $fsvuC.useMemo)(()=>({
            ...entryPointProps,
            onClose: onClose
        }), [
        entryPointProps,
        onClose
    ]);
    // If we're auto opening, we can handle this setting here
    const Trigger = shouldAutoOpen ? (0, $fqMum.AutoOpenModalTrigger) : (0, $kPtWX.ModalTrigger);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aa5ZN.ModalContextProvider), {
        children: /*#__PURE__*/ (0, $5chsV.jsx)(Trigger, {
            ...rest,
            entryPointProps: finalEntryPointProps,
            onError: onErrorCallback,
            shouldAutoOpen: shouldAutoOpen,
            preloadOnFocus: true,
            children: ({ ref: ref })=>{
                return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hD4W1.EditionAwarenessButton), {
                    ref: ref
                });
            }
        })
    });
}
$a1bb579510efed80$var$ModalEntryPointInner.displayName = "ModalEntryPointInner";

});
parcelRegister("fwygm", function(module, exports) {
$parcel$export(module.exports, "DialogContext", () => $3f13118f2c73c1e6$export$8b93a07348a7730c);
$parcel$export(module.exports, "useDialogContext", () => $3f13118f2c73c1e6$export$898e461c0669e62d);

var $fsvuC = parcelRequire("fsvuC");
const $3f13118f2c73c1e6$export$8b93a07348a7730c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createContext(null);
function $3f13118f2c73c1e6$export$898e461c0669e62d() {
    return (0, $fsvuC.useContext)($3f13118f2c73c1e6$export$8b93a07348a7730c);
}

});

parcelRegister("ezp5D", function(module, exports) {
$parcel$export(module.exports, "useEntrypointErrorAnalytics", () => $aee1f2b06ec33e92$export$f2e26e89f653216c);

var $fsvuC = parcelRequire("fsvuC");

var $3dBeg = parcelRequire("3dBeg");

var $6hOVZ = parcelRequire("6hOVZ");
function $aee1f2b06ec33e92$export$f2e26e89f653216c() {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $3dBeg.useAnalytics)();
    const handleOnError = (0, $fsvuC.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: {
                error: error.message,
                errorStack: error.stack,
                errorName: error.name,
                errorComponentStack: errorInfo.componentStack,
                id: 'entrypointError',
                isSLOError: (0, $6hOVZ.isSLOError)(error)
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    return handleOnError;
}

});

parcelRegister("8iLmE", function(module, exports) {
$parcel$export(module.exports, "useOnCloseDialog", () => $8275386e6757005e$export$bdf52d4393ceb609);

var $fsvuC = parcelRequire("fsvuC");

var $dElcB = parcelRequire("dElcB");

var $3dBeg = parcelRequire("3dBeg");
const $8275386e6757005e$export$bdf52d4393ceb609 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $3dBeg.useAnalytics)();
    const onClose = (0, $fsvuC.useCallback)((attributes)=>{
        sendAnalyticsEvent({
            action: 'closed',
            actionSubject: 'dialog',
            actionSubjectId: 'editionAwarenessDialog',
            attributes: attributes
        });
    }, [
        sendAnalyticsEvent
    ]);
    const [onCloseDebounced] = (0, $dElcB.default)(onClose, 300, {
        leading: true,
        trailing: false
    });
    return onCloseDebounced;
};

});

parcelRegister("hD4W1", function(module, exports) {
$parcel$export(module.exports, "EditionAwarenessButton", () => $9cdb6054db61a8a6$export$57ddd9301662f8e4);
$parcel$export(module.exports, "EditionAwarenessLink", () => $9cdb6054db61a8a6$export$1bf8122badfd728c);
/* edition-awareness-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $ECZQy = parcelRequire("ECZQy");
var $oAzkD = parcelRequire("oAzkD");

var $dwUnm = parcelRequire("dwUnm");

var $iguLq = parcelRequire("iguLq");

var $cklu4 = parcelRequire("cklu4");

var $fE6ce = parcelRequire("fE6ce");

var $gD3tC = parcelRequire("gD3tC");

var $buAwh = parcelRequire("buAwh");

var $cIdnd = parcelRequire("cIdnd");
var $cBAtE = parcelRequire("cBAtE");
var $kCitG = parcelRequire("kCitG");

var $dKvIi = parcelRequire("dKvIi");

var $llCao = parcelRequire("llCao");

var $cGW6W = parcelRequire("cGW6W");

var $jRYjy = parcelRequire("jRYjy");

var $jR7Rq = parcelRequire("jR7Rq");

var $3OsKS = parcelRequire("3OsKS");

var $d0SZF = parcelRequire("d0SZF");

var $9NkD7 = parcelRequire("9NkD7");

var $g3jqz = parcelRequire("g3jqz");

var $2vFQ8 = parcelRequire("2vFQ8");

var $g9Qw8 = parcelRequire("g9Qw8");

var $ir53u = parcelRequire("ir53u");

var $3dBeg = parcelRequire("3dBeg");

var $8Eye0 = parcelRequire("8Eye0");

var $eOaYv = parcelRequire("eOaYv");

var $j88QB = parcelRequire("j88QB");

var $MOTjl = parcelRequire("MOTjl");

var $e2lbi = parcelRequire("e2lbi");

var $3OEoy = parcelRequire("3OEoy");

var $gDVPz = parcelRequire("gDVPz");

var $04eA3 = parcelRequire("04eA3");
const $9cdb6054db61a8a6$var$styles = {
    button: "_2sNsIgmnOE _0bjKvDKTcp _2mHwu82ADO _00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _2V7sgONvrM _3hxITi6wH8 _2Y7lL48HPE _4c065U1Y8M _1kk5Tkf7mX _0KLXrulfZc _4kiQYAUofl _1UtDYzy7kJ _1kOSYtDpdQ _3Z9K0w2HTN _3iDTPbQ4SZ _0hPCNLDIqT _32C2rkyL8i _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5y7kJ _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _1eOmH6o126 _0clgaMy7kJ _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8 _3gzVzLN4oS",
    default: "_3vBAKHceTh _1UtDYzJejw _10n1R5Jejw _1eOmH6eJK9 _0clgaMJejw _3gzVzLhT4j",
    warning: "_3vBAKHv0qQ",
    danger: "_3vBAKHnod9",
    icon: "_3iDTPbQ4SZ _2O5VijdnbC _3YEZNOdnbC _4xdlr0DIqT _20VacPYbGa",
    dismissible: "_1Lz9lodnbC _3XDz3BdnbC",
    dismissMenu: "_2sNsIgmnOE _0bjKvDKTcp _2mHwu82ADO _00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _2V7sgONvrM _3hxITi6wH8 _2Y7lL42ADO _4c065UPgdg _3vBAKHceTh _1kk5Tkf7mX _0KLXrulfZc _4kiQYAUofl _1UtDYzy7kJ _1kOSYtDpdQ _3Z9K0w2HTN _3iDTPbQ4SZ _0hPCNLDIqT _1Vs123dnbC _2C2kUQdnbC _1v9SsVdnbC _1eOmH6eJK9 _3gzVzLhT4j",
    reasonsUl: "_313842dnbC _2XsHFM5zaO _2Zuz6Q2ADO"
};
function $9cdb6054db61a8a6$var$Icon({ appearance: appearance, icon: icon, color: color }) {
    if (icon === 'warning') {
        const defaultColor = appearance === 'danger' ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon-warning, #E06C00)";
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gD3tC))), {
            label: "",
            color: color ?? defaultColor,
            size: "small"
        });
    }
    if (icon === 'credit-card') return /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cklu4))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #AF59E1)"
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iguLq))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #AF59E1)"
    });
}
$9cdb6054db61a8a6$var$Icon.displayName = "Icon";
const $9cdb6054db61a8a6$export$57ddd9301662f8e4 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ onClick: onClick, ...rest }, ref)=>{
    const buttonContent = (0, $3OEoy.useButtonContent)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default', isDismissible: isDismissible } = buttonContent;
    const hasCustomTheme = (0, $dKvIi.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $3dBeg.useAnalytics)();
    const context = (0, $eOaYv.useEditionAwareness)();
    const { getExperimentCohort: getExperimentCohort } = (0, $j88QB.useGetExperimentValue)();
    const { expose: expose } = (0, $04eA3.useUserLimitDirectBuyExperiment)();
    const analyticsAttributes = (0, $fsvuC.useMemo)(()=>({
            type: 'button',
            icon: icon,
            appearance: appearance,
            isDismissible: isDismissible
        }), [
        icon,
        appearance,
        isDismissible
    ]);
    const handleOnClick = (0, $fsvuC.useCallback)((e, analyticsEvent)=>{
        expose();
        onClick?.(e, analyticsEvent);
        // Both control and variation exposures are fired here to keep the cohorts balanced
        if ((0, $llCao.fg)('twc-pde-trial-ea-modal-update-gate') && (0, $e2lbi.isEligibleForTWCChangePlan)(context)) getExperimentCohort('twc-pde-trial-ea-modal-update-experiment');
        // Fire exposure here so control users, whose routing does not render PaymentFlowLink,
        // are still enrolled. Variation additionally fires in PaymentFlowLink.
        if ((0, $MOTjl.isEligibleForEAtoOSBNonRTPremiumAndRTPredunning)(context)) getExperimentCohort('ea-to-osb-nonrt-premium-rt-predunning-ab');
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        expose,
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes,
        getExperimentCohort,
        context
    ]);
    const handleOnMouseEnter = (0, $fsvuC.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'hovered',
            actionSubject: 'button',
            actionSubjectId: 'editionAwareness',
            attributes: analyticsAttributes
        });
    }, [
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    const Button = hasCustomTheme ? // When there's a custom theme applied we just return a button which gets styled by the theme
    /*#__PURE__*/ (0, $5chsV.jsxs)((0, $cIdnd.Button), {
        ...rest,
        ref: ref,
        onClick: handleOnClick,
        onMouseEnter: handleOnMouseEnter,
        iconBefore: ()=>/*#__PURE__*/ (0, $5chsV.jsx)($9cdb6054db61a8a6$var$Icon, {
                appearance: appearance,
                icon: icon,
                color: "currentColor"
            }),
        children: [
            text,
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $ir53u.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    }) : /*#__PURE__*/ (0, $5chsV.jsxs)((0, $3OsKS.Pressable), {
        ...rest,
        ref: ref,
        xcss: (0, $dwUnm.cx)($9cdb6054db61a8a6$var$styles.button, appearance === 'default' && $9cdb6054db61a8a6$var$styles.default, appearance === 'warning' && $9cdb6054db61a8a6$var$styles.warning, appearance === 'danger' && $9cdb6054db61a8a6$var$styles.danger, isDismissible && $9cdb6054db61a8a6$var$styles.dismissible),
        onClick: handleOnClick,
        onMouseEnter: handleOnMouseEnter,
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                xcss: $9cdb6054db61a8a6$var$styles.icon,
                children: /*#__PURE__*/ (0, $5chsV.jsx)($9cdb6054db61a8a6$var$Icon, {
                    appearance: appearance,
                    icon: icon
                })
            }),
            text,
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $ir53u.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
    if (isDismissible) return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jR7Rq.Flex), {
        alignItems: "center",
        children: [
            Button,
            /*#__PURE__*/ (0, $5chsV.jsx)($9cdb6054db61a8a6$var$DismissMenu, {})
        ]
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        id: "edition-awareness-button",
        children: Button
    });
});
const $9cdb6054db61a8a6$export$1bf8122badfd728c = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ onClick: onClick, href: href, touchpointIntent: touchpointIntent, linkId: linkId, ...rest }, ref)=>{
    const buttonContent = (0, $3OEoy.useButtonContent)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default' } = buttonContent;
    const hasCustomTheme = (0, $dKvIi.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $3dBeg.useAnalytics)();
    const { origin: origin, url: tracedUrl } = (0, $gDVPz.useTracedUrl)(href);
    if (!tracedUrl) throw new Error('The link url is undefined, please check the context');
    const analyticsAttributes = (0, $fsvuC.useMemo)(()=>({
            type: 'link',
            icon: icon,
            appearance: appearance,
            touchpointIntent: touchpointIntent,
            linkId: linkId
        }), [
        icon,
        appearance,
        touchpointIntent,
        linkId
    ]);
    const handleOnClick = (0, $fsvuC.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent, tracedUrl);
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: {
                    ...analyticsAttributes,
                    ...origin.toAnalyticsAttributes()
                }
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes,
        origin,
        tracedUrl
    ]);
    const handleOnMouseEnter = (0, $fsvuC.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'hovered',
            actionSubject: 'button',
            actionSubjectId: 'editionAwareness',
            attributes: analyticsAttributes
        });
    }, [
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    if (hasCustomTheme) {
        // When there's a custom theme applied we just return a button which gets styled by the theme
        const topNavLinkButton = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $kCitG.LinkButton), {
            ...rest,
            href: tracedUrl,
            ref: ref,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            iconBefore: ()=>/*#__PURE__*/ (0, $5chsV.jsx)($9cdb6054db61a8a6$var$Icon, {
                    appearance: appearance,
                    icon: icon,
                    color: "currentColor"
                }),
            children: [
                text,
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $ir53u.UiViewedEvent), {
                    actionSubjectId: "editionAwareness",
                    actionSubject: "button",
                    attributes: analyticsAttributes
                })
            ]
        });
        return topNavLinkButton;
    }
    const anchor = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $cGW6W.Anchor), {
        ...rest,
        href: tracedUrl,
        ref: ref,
        xcss: (0, $dwUnm.cx)($9cdb6054db61a8a6$var$styles.button, appearance === 'default' && $9cdb6054db61a8a6$var$styles.default, appearance === 'warning' && $9cdb6054db61a8a6$var$styles.warning, appearance === 'danger' && $9cdb6054db61a8a6$var$styles.danger),
        onClick: handleOnClick,
        onMouseEnter: handleOnMouseEnter,
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                xcss: $9cdb6054db61a8a6$var$styles.icon,
                children: /*#__PURE__*/ (0, $5chsV.jsx)($9cdb6054db61a8a6$var$Icon, {
                    appearance: appearance,
                    icon: icon
                })
            }),
            text,
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $ir53u.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
    return anchor;
});
function $9cdb6054db61a8a6$var$DismissMenu() {
    const { formatMessage: formatMessage } = (0, $oAzkD.default)();
    const fireDismissMenuEvent = (0, $8Eye0.useOnClickDismissMenu)();
    const { onDismissButton: onDismissButton } = (0, $eOaYv.useEditionAwareness)();
    const hasCustomTheme = (0, $dKvIi.useHasCustomTheme)();
    const handleOnEvents = (0, $fsvuC.useCallback)((e)=>{
        if (e.type === 'DISMISS_SUCCEEDED' && onDismissButton) {
            onDismissButton();
            fireDismissMenuEvent('dismiss');
        }
        if (e.type === 'AD_CONTROL_DROP_DOWN_MENU_OPENED') fireDismissMenuEvent('openMenu');
        if (e.type === 'REASONS_BUTTON_CLICKED') fireDismissMenuEvent('learnMore');
    }, [
        onDismissButton,
        fireDismissMenuEvent
    ]);
    const dismissMenuAriaLabel = formatMessage({
        id: '@atlassian/edition-awareness.edition-awareness-dismiss-button.menu-aria',
        defaultMessage: 'More',
        description: 'The aria label for the dismiss menu, indicating to the user that there are further actions available.'
    });
    const getAdControlsTrigger = (0, $fsvuC.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ triggerRef: triggerRef, ...props })=>hasCustomTheme ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $cBAtE.IconButton), {
            ...props,
            ref: triggerRef,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fE6ce))),
            "aria-label": dismissMenuAriaLabel
        }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $3OsKS.Pressable), {
            ...props,
            ref: triggerRef,
            xcss: (0, $dwUnm.cx)($9cdb6054db61a8a6$var$styles.dismissMenu),
            "aria-label": dismissMenuAriaLabel,
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fE6ce))), {
                label: "",
                spacing: "none",
                color: "var(--ds-icon-subtlest, #6B6E76)"
            })
        }), [
        hasCustomTheme,
        dismissMenuAriaLabel
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $g3jqz.default), {
        onEvents: (e)=>handleOnEvents(e),
        shouldShowDismissFlag: false,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $9NkD7.default), {
            itemId: "default-item",
            trigger: getAdControlsTrigger,
            children: (props)=>/*#__PURE__*/ (0, $5chsV.jsxs)((0, $5chsV.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $2vFQ8.default), {
                            ...props,
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ECZQy.default), {
                                id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.dismiss",
                                defaultMessage: "Dismiss",
                                description: "An action for the user to permanently dismiss this button to prevent it from appearing again"
                            })
                        }),
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $g9Qw8.default), {
                            ...props,
                            modalProps: {
                                body: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $d0SZF.Stack), {
                                    space: "space.150",
                                    children: [
                                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ECZQy.default), {
                                                id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.why-am-i-seeing-this-v4",
                                                defaultMessage: "We think changing your plan will improve your team's productivity. This recommendation is only shown to site admins.",
                                                description: "A message that informs the user why they are seeing the current plan recommendation for their current product"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $buAwh.default), {
                                                appearance: "default",
                                                href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                                target: "_blank",
                                                onClick: ()=>fireDismissMenuEvent('clickLink'),
                                                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ECZQy.default), {
                                                    id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.data-privacy.link",
                                                    defaultMessage: "Learn more about your data privacy with Atlassian",
                                                    description: "Link to Atlassian data privacy page"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }
                        })
                    ]
                })
        })
    });
}
$9cdb6054db61a8a6$var$DismissMenu.displayName = "DismissMenu";

});
parcelRegister("9NkD7", function(module, exports) {
$parcel$export(module.exports, "default", () => $03e6be06c0223239$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $8XDhJ = parcelRequire("8XDhJ");

var $aCtVx = parcelRequire("aCtVx");


var $kUk4q = parcelRequire("kUk4q");

var $emgdV = parcelRequire("emgdV");
const $03e6be06c0223239$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsDropdown'
};
const $03e6be06c0223239$var$AdControlDropdownMenu = ({ children: children, itemId: itemId, onOpenChange: onOpenChange = ()=>{}, ...rest })=>{
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kUk4q.default)();
    const { createEventDispatcher: createEventDispatcher } = (0, $emgdV.useAdControlProvider)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $8XDhJ.default), {
        ...rest,
        onOpenChange: (onOpenChangeArgs)=>{
            eventDispatcher.dispatch(onOpenChangeArgs.isOpen ? (0, $ccaff9c1e22335c3$export$17ff257e1f6e39f5) : (0, $ccaff9c1e22335c3$export$7fc09cf740f33ed4), createInteractedUIEvent($03e6be06c0223239$var$interactedUIEventAction));
            onOpenChange(onOpenChangeArgs);
        },
        shouldFitContainer: false,
        shouldRenderToParent: true,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $aCtVx.default), {
            children: typeof children === 'function' ? children({
                itemId: itemId
            }) : children
        })
    });
};
$03e6be06c0223239$var$AdControlDropdownMenu.displayName = "AdControlDropdownMenu";
var $03e6be06c0223239$export$2e2bcd8739ae039 = $03e6be06c0223239$var$AdControlDropdownMenu;

});
// ACT Event types
// AdControlDropdownMenu
const $ccaff9c1e22335c3$export$17ff257e1f6e39f5 = 'AD_CONTROL_DROP_DOWN_MENU_OPENED';
const $ccaff9c1e22335c3$export$7fc09cf740f33ed4 = 'AD_CONTROL_DROP_DOWN_MENU_CLOSED';
const $ccaff9c1e22335c3$export$e33200507ac1d20a = 'DISMISS_STARTED';
const $ccaff9c1e22335c3$export$103f41d1f3bf374e = 'DISMISS_SUCCEEDED';
const $ccaff9c1e22335c3$export$6d3088110036f124 = 'DISMISS_FAILED';
const $ccaff9c1e22335c3$export$5595c6967e83d351 = 'REASONS_BUTTON_CLICKED';
const $ccaff9c1e22335c3$export$ff50ad60f08a4bc0 = 'REASONS_MODAL_SHOWN';
const $ccaff9c1e22335c3$export$6bd2d8eacca15ce1 = 'REASONS_MODAL_DISMISSED';
const $ccaff9c1e22335c3$export$5c5fc6956b7600ea = 'FLAG_DISMISSED';

parcelRegister("kUk4q", function(module, exports) {
$parcel$export(module.exports, "default", () => $29b850ffccefd702$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");


var $mhEfz = parcelRequire("mhEfz");
function $29b850ffccefd702$export$2e2bcd8739ae039() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    const createInteractedUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useCallback((action)=>createAnalyticsEvent({
            eventType: (0, $ddd31af8f515fa50$export$a1562d08625f5d7e),
            ...action
        }), [
        createAnalyticsEvent
    ]);
    const createScreenUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useCallback((name)=>createAnalyticsEvent({
            eventType: (0, $ddd31af8f515fa50$export$f1d537d508d2945a),
            name: name
        }), [
        createAnalyticsEvent
    ]);
    return {
        createInteractedUIEvent: createInteractedUIEvent,
        createScreenUIEvent: createScreenUIEvent
    };
}

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $ddd31af8f515fa50$export$a1562d08625f5d7e = 'ui';
const $ddd31af8f515fa50$export$947dac6c72b26f81 = 'track';
const $ddd31af8f515fa50$export$f1d537d508d2945a = 'screen';
const $ddd31af8f515fa50$export$12346a674644c156 = 'operational';
const $ddd31af8f515fa50$export$b055de0e665cb20c = 'unknown';


parcelRegister("emgdV", function(module, exports) {
$parcel$export(module.exports, "useAdControlProvider", () => $6dd181e631b6e098$export$450072b04d50916);

var $fsvuC = parcelRequire("fsvuC");


var $3YcFy = parcelRequire("3YcFy");

var $696yM = parcelRequire("696yM");
function $6dd181e631b6e098$export$450072b04d50916() {
    const { state: state, modalPropsRef: modalPropsRef, dispatch: dispatch, onEvents: onEvents, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $696yM.useAdControlContext)();
    /**
	 * Add a flag with flagProps to state for the item was dismissed
	 * {@link https://atlassian.design/components/flag/examples}
	 */ const addFlag = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useCallback((itemId, flagProps)=>{
        dispatch({
            type: 'ADD_FLAG',
            payload: {
                itemId: itemId,
                flagProps: flagProps
            }
        });
    }, [
        dispatch
    ]);
    /**
	 * Open a modal and set the modal props reference
	 */ const openModal = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useCallback((modalProps, modalItemId)=>{
        modalPropsRef.current = modalProps;
        dispatch({
            type: 'OPEN_MODAL',
            payload: modalItemId
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * Close a modal and clear the modal props reference
	 */ const closeModal = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useCallback(()=>{
        modalPropsRef.current = undefined;
        dispatch({
            type: 'CLOSE_MODAL'
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * The internal event handler that is used by the ACTEventDispatcher
	 */ const handleOnEvents = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useCallback((event)=>{
        // Handle the events that have side effects on the state.
        switch(event.type){
            case 0, $ccaff9c1e22335c3$export$5c5fc6956b7600ea:
                dispatch({
                    type: 'REMOVE_FLAG',
                    payload: event.itemId
                });
                break;
        }
        // Call the onEvents handler that is passed from the consumer.
        onEvents(event);
    }, [
        dispatch,
        onEvents
    ]);
    /**
	 * Create an event dispatcher for the given item id
	 */ const createEventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useCallback((itemId)=>{
        return new (0, $3YcFy.default)(itemId, handleOnEvents);
    }, [
        handleOnEvents
    ]);
    return {
        state: state,
        openModal: openModal,
        closeModal: closeModal,
        createEventDispatcher: createEventDispatcher,
        addFlag: addFlag,
        shouldShowDismissFlag: shouldShowDismissFlag
    };
}

});
parcelRegister("3YcFy", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3b41a8d1bda662a$export$2e2bcd8739ae039);
class $c3b41a8d1bda662a$export$2e2bcd8739ae039 {
    constructor(itemId, handler){
        this.itemId = itemId;
        this.handler = handler;
    }
    dispatch(type, analyticsEvent) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            analyticsEvent: analyticsEvent
        });
    }
    dispatchError(type, error) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            error: error
        });
    }
    _dispatch(event) {
        if (this.handler) this.handler(event);
    }
}

});

parcelRegister("696yM", function(module, exports) {
$parcel$export(module.exports, "useAdControlContext", () => $389363a17d8879b3$export$4e82dc865a56141b);

var $fsvuC = parcelRequire("fsvuC");

var $1X7od = parcelRequire("1X7od");
function $389363a17d8879b3$export$4e82dc865a56141b() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useContext((0, $1X7od.AdControlContext));
}

});
parcelRegister("1X7od", function(module, exports) {
$parcel$export(module.exports, "AdControlContext", () => $8c9b066662fb3060$export$554b2f9bd0a293df);

var $fsvuC = parcelRequire("fsvuC");

var $39Q8t = parcelRequire("39Q8t");
const $8c9b066662fb3060$export$554b2f9bd0a293df = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createContext({
    state: {
        ...(0, $39Q8t.initialAdControlProviderState)
    },
    modalPropsRef: undefined,
    dispatch: ()=>{},
    onEvents: ()=>{},
    shouldShowDismissFlag: true
});

});
parcelRegister("39Q8t", function(module, exports) {
$parcel$export(module.exports, "initialAdControlProviderState", () => $64d5cdde11530776$export$22776e7a42f7089d);
$parcel$export(module.exports, "adControlProviderReducer", () => $64d5cdde11530776$export$5f3557676ca801eb);
const $64d5cdde11530776$export$22776e7a42f7089d = {
    flags: new Map()
};
const $64d5cdde11530776$export$5f3557676ca801eb = (state, action)=>{
    switch(action.type){
        case 'ADD_FLAG':
            return {
                ...state,
                flags: new Map(state.flags).set(action.payload.itemId, action.payload.flagProps)
            };
        case 'REMOVE_FLAG':
            {
                // Clone the flags map and delete the flag
                const flags = new Map(state.flags);
                flags.delete(action.payload);
                return {
                    ...state,
                    flags: flags
                };
            }
        case 'OPEN_MODAL':
            return {
                ...state,
                modalItemId: action.payload
            };
        case 'CLOSE_MODAL':
            return {
                ...state,
                modalItemId: undefined
            };
        default:
            return state;
    }
};

});





parcelRegister("g3jqz", function(module, exports) {
$parcel$export(module.exports, "default", () => $a915e997b6fe7bc4$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $1X7od = parcelRequire("1X7od");

var $39Q8t = parcelRequire("39Q8t");

var $aJvhd = parcelRequire("aJvhd");

var $g5RT2 = parcelRequire("g5RT2");

var $9PJOF = parcelRequire("9PJOF");
const $a915e997b6fe7bc4$var$AdControlProvider = ({ children: children, onEvents: onEvents = ()=>{}, shouldShowDismissFlag: shouldShowDismissFlag = true })=>{
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useReducer((0, $39Q8t.adControlProviderReducer), (0, $39Q8t.initialAdControlProviderState));
    const modalPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useRef();
    const modalProps = modalPropsRef.current ?? {
        body: '',
        title: '',
        hasCloseButton: true
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aJvhd.default), {
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $1X7od.AdControlContext).Provider, {
            value: {
                state: state,
                modalPropsRef: modalPropsRef,
                dispatch: dispatch,
                onEvents: onEvents,
                shouldShowDismissFlag: shouldShowDismissFlag
            },
            children: [
                children,
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $9PJOF.default), {
                    itemId: state.modalItemId,
                    ...modalProps
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $g5RT2.default), {})
            ]
        })
    });
};
$a915e997b6fe7bc4$var$AdControlProvider.displayName = "AdControlProvider";
var $a915e997b6fe7bc4$export$2e2bcd8739ae039 = $a915e997b6fe7bc4$var$AdControlProvider;

});
parcelRegister("aJvhd", function(module, exports) {
$parcel$export(module.exports, "default", () => $03fabb36481c82e1$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $eWXlB = parcelRequire("eWXlB");

var $8KWPd = parcelRequire("8KWPd");

var $h0HD1 = parcelRequire("h0HD1");
const $03fabb36481c82e1$var$ActIntlProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $eWXlB.default), {
        defaultMessages: (0, $h0HD1.default),
        loaderFn: (0, $8KWPd.fetchMessagesForLocale),
        children: children
    });
};
$03fabb36481c82e1$var$ActIntlProvider.displayName = "ActIntlProvider";
var $03fabb36481c82e1$export$2e2bcd8739ae039 = $03fabb36481c82e1$var$ActIntlProvider;

});
parcelRegister("8KWPd", function(module, exports) {
$parcel$export(module.exports, "fetchMessagesForLocale", () => $f71e7abbe8c2a8b2$export$2b153a2030b0feb2);

var $jInJw = parcelRequire("jInJw");

var $h0HD1 = parcelRequire("h0HD1");
const $f71e7abbe8c2a8b2$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $f71e7abbe8c2a8b2$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const targetLocale = ($f71e7abbe8c2a8b2$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $jInJw.locales)) {
            const messages = await (0, $jInJw.locales)[targetLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $jInJw.locales)) {
            const messages = await (0, $jInJw.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
	 * English bundled by default as this is the majority of users
	 */ return 0, $h0HD1.default;
};

});
parcelRegister("jInJw", function(module, exports) {
$parcel$export(module.exports, "locales", () => $35b62c6804532af6$export$df1c34db1371eeed);


























const $35b62c6804532af6$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("k0oC6")),
    da: ()=>(parcelRequire("ff88x")),
    de: ()=>(parcelRequire("gNfi7")),
    en_GB: ()=>(parcelRequire("kow1h")),
    en_ZZ: ()=>(parcelRequire("6jbq4")),
    en: ()=>Promise.resolve((parcelRequire("h0HD1"))),
    es: ()=>(parcelRequire("bNm2r")),
    fi: ()=>(parcelRequire("lB5VR")),
    fr: ()=>(parcelRequire("9KFM8")),
    hu: ()=>(parcelRequire("5hHlY")),
    it: ()=>(parcelRequire("fq7mF")),
    ja: ()=>(parcelRequire("eDUrS")),
    ko: ()=>(parcelRequire("2bqES")),
    nb: ()=>(parcelRequire("KEjiO")),
    nl: ()=>(parcelRequire("elT3H")),
    pl: ()=>(parcelRequire("6JX5p")),
    pt_BR: ()=>(parcelRequire("kYVEt")),
    ru: ()=>(parcelRequire("3wbpL")),
    sv: ()=>(parcelRequire("1kMpY")),
    th: ()=>(parcelRequire("dWI6P")),
    tr: ()=>(parcelRequire("7zvki")),
    uk: ()=>(parcelRequire("asVmO")),
    vi: ()=>(parcelRequire("2gBFF")),
    zh_TW: ()=>(parcelRequire("8JddV")),
    zh: ()=>(parcelRequire("6gFb8"))
};

});
parcelRegister("k0oC6", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("5UIPu").then(()=>parcelRequire('WTcqN'));

});

parcelRegister("ff88x", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("1inAC").then(()=>parcelRequire('hnW0R'));

});

parcelRegister("gNfi7", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("aZPz6").then(()=>parcelRequire('jyom4'));

});

parcelRegister("kow1h", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("j2DnE").then(()=>parcelRequire('DvnX8'));

});

parcelRegister("6jbq4", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("4x05b").then(()=>parcelRequire('5T17R'));

});

parcelRegister("bNm2r", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("6AreQ").then(()=>parcelRequire('k2KEo'));

});

parcelRegister("lB5VR", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("8c8qD").then(()=>parcelRequire('caasR'));

});

parcelRegister("9KFM8", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("d3Efr").then(()=>parcelRequire('6VaQl'));

});

parcelRegister("5hHlY", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("bctDC").then(()=>parcelRequire('epSjS'));

});

parcelRegister("fq7mF", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("9paeh").then(()=>parcelRequire('5hqV8'));

});

parcelRegister("eDUrS", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("kv9Q4").then(()=>parcelRequire('cgPQZ'));

});

parcelRegister("2bqES", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("iRaTd").then(()=>parcelRequire('gKCjW'));

});

parcelRegister("KEjiO", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("RimTP").then(()=>parcelRequire('1rA9o'));

});

parcelRegister("elT3H", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("iwqae").then(()=>parcelRequire('dFUaA'));

});

parcelRegister("6JX5p", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("ayb3k").then(()=>parcelRequire('hfcVM'));

});

parcelRegister("kYVEt", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("2xzxo").then(()=>parcelRequire('fSliP'));

});

parcelRegister("3wbpL", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("goTLh").then(()=>parcelRequire('dlAhj'));

});

parcelRegister("1kMpY", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("doGWb").then(()=>parcelRequire('7qEEz'));

});

parcelRegister("dWI6P", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("bBWMm").then(()=>parcelRequire('1yEyd'));

});

parcelRegister("7zvki", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("2iRuA").then(()=>parcelRequire('34Q9f'));

});

parcelRegister("asVmO", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("eRYHo").then(()=>parcelRequire('4wNuJ'));

});

parcelRegister("2gBFF", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("dchLW").then(()=>parcelRequire('bpjQ2'));

});

parcelRegister("8JddV", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("b3wr9").then(()=>parcelRequire('fj6Rn'));

});

parcelRegister("6gFb8", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("jrXv3").then(()=>parcelRequire('dbHLm'));

});




parcelRegister("g5RT2", function(module, exports) {
$parcel$export(module.exports, "default", () => $d625461aabf29a07$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $ECZQy = parcelRequire("ECZQy");

var $3muTT = parcelRequire("3muTT");

var $bnLBB = parcelRequire("bnLBB");

var $6UDJ1 = parcelRequire("6UDJ1");

var $jRYjy = parcelRequire("jRYjy");


var $kUk4q = parcelRequire("kUk4q");

var $emgdV = parcelRequire("emgdV");

var $clzmc = parcelRequire("clzmc");

var $c4wT7 = parcelRequire("c4wT7");
const $d625461aabf29a07$var$ACT_FLAG_WRAPPER = 'act-flag-wrapper';
const $d625461aabf29a07$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsFlagClose'
};
const $d625461aabf29a07$var$DismissalFlagGroup = ()=>{
    (0, $c4wT7.overridePortalIndex)($d625461aabf29a07$var$ACT_FLAG_WRAPPER);
    const { state: { flags: flags }, createEventDispatcher: createEventDispatcher } = (0, $emgdV.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kUk4q.default)();
    const handleOnDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useCallback((id)=>{
        createEventDispatcher(id).dispatch((0, $ccaff9c1e22335c3$export$5c5fc6956b7600ea), createInteractedUIEvent($d625461aabf29a07$var$interactedUIEventAction));
    }, [
        createEventDispatcher,
        createInteractedUIEvent
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bnLBB.default), {
        onDismissed: handleOnDismissed,
        children: Array.from(flags.entries()).map(([itemId, { actions: actions = [], ...flagProps } = {
            actions: []
        }], i)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                id: $d625461aabf29a07$var$ACT_FLAG_WRAPPER,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $3muTT.default), {
                    id: itemId,
                    testId: `act-flag-${itemId}`,
                    icon: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6UDJ1))), {
                        label: "Success",
                        spacing: "spacious",
                        color: "var(--ds-icon-success, #6A9A23)"
                    }),
                    title: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ECZQy.default), {
                        ...(0, $clzmc.messages).notInterestedFlag
                    }),
                    description: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ECZQy.default), {
                        ...(0, $clzmc.messages).dismissalMessage
                    }),
                    ...flagProps,
                    actions: actions.map((action)=>({
                            ...action,
                            onClick: (e)=>{
                                action.onClick?.(e, ()=>handleOnDismissed(itemId));
                            }
                        }))
                })
            }, i))
    });
};
$d625461aabf29a07$var$DismissalFlagGroup.displayName = "DismissalFlagGroup";
var $d625461aabf29a07$export$2e2bcd8739ae039 = $d625461aabf29a07$var$DismissalFlagGroup;

});
parcelRegister("clzmc", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3b4d648dacb3bc2b$export$defe85febe8b728c);

var $54F37 = parcelRequire("54F37");
const $3b4d648dacb3bc2b$export$defe85febe8b728c = (0, $54F37.defineMessages)({
    notInterested: {
        id: 'act.action.notInterested.button.text',
        defaultMessage: 'Not interested',
        description: 'The text of a button to indicate the users can dismiss the current component'
    },
    notInterestedFlag: {
        id: 'act.action.notInterestedFlag.flag.text',
        defaultMessage: 'Got it, thanks for letting us know',
        description: 'A message that informs the users the dismissal action is taken'
    },
    showReasons: {
        id: 'act.action.showReasons.common.text',
        defaultMessage: 'Why am I seeing this?',
        description: "The text of a button to indicate the users can click and see the reasons for a component's appearance"
    },
    dismissalMessage: {
        id: 'act.action.dismissalMessage.common.text',
        defaultMessage: "You won\u2019t see this here as often.",
        description: 'A message that informs the users the dismissal action is taken'
    },
    reasonsModalOkButton: {
        id: 'act.action.reasonsModalOkButton.common.text',
        defaultMessage: 'OK',
        description: 'The text of a button to indicate the users can dismiss the current modal'
    }
});

});

parcelRegister("c4wT7", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PORTAL_OVERRIDE_INDEX", () => $ddcbf31ee1e4ee24$export$335243096683aa37);
$parcel$export(module.exports, "overridePortalIndex", () => $ddcbf31ee1e4ee24$export$61df98316049b30);
const $ddcbf31ee1e4ee24$export$335243096683aa37 = 900;
function $ddcbf31ee1e4ee24$export$61df98316049b30(elementId, index = $ddcbf31ee1e4ee24$export$335243096683aa37) {
    setTimeout(()=>{
        if (typeof document !== 'undefined') {
            const parentPortal = $ddcbf31ee1e4ee24$export$148feac3be949786(document.getElementById(elementId), '.atlaskit-portal');
            if (parentPortal) parentPortal.setAttribute('style', `z-index:${index};`);
        }
    }, 0);
}
function $ddcbf31ee1e4ee24$var$collectionHas(all, curr) {
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
}
function $ddcbf31ee1e4ee24$export$148feac3be949786(elm, selector) {
    let all = document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$ddcbf31ee1e4ee24$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
}

});


parcelRegister("9PJOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $530fbbeb95b5ecce$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $ECZQy = parcelRequire("ECZQy");

var $BP2AV = parcelRequire("BP2AV");

var $kJ3Vl = parcelRequire("kJ3Vl");

var $8OcK0 = parcelRequire("8OcK0");

var $djI0m = parcelRequire("djI0m");

var $79e8h = parcelRequire("79e8h");

var $fTkoK = parcelRequire("fTkoK");

var $g9Smr = parcelRequire("g9Smr");

var $jRYjy = parcelRequire("jRYjy");


var $kUk4q = parcelRequire("kUk4q");

var $emgdV = parcelRequire("emgdV");

var $clzmc = parcelRequire("clzmc");

var $c4wT7 = parcelRequire("c4wT7");
const $530fbbeb95b5ecce$var$adControlScreenName = 'adControlsReasonsModal';
const $530fbbeb95b5ecce$var$ACT_MODAL_CONTENT = 'ACT_MODAL_CONTENT';
const $530fbbeb95b5ecce$var$ReasonsModal = ({ body: body, itemId: itemId, title: title, zIndexOverride: zIndexOverride = (0, $c4wT7.DEFAULT_PORTAL_OVERRIDE_INDEX), hasCloseButton: hasCloseButton = true, ...props })=>{
    const { closeModal: closeModal, createEventDispatcher: createEventDispatcher } = (0, $emgdV.useAdControlProvider)();
    const { createScreenUIEvent: createScreenUIEvent } = (0, $kUk4q.default)();
    const isMounted = (0, $fsvuC.useRef)(false);
    const eventDispatcherRef = (0, $fsvuC.useRef)();
    eventDispatcherRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useMemo(()=>itemId !== undefined ? createEventDispatcher(itemId) : eventDispatcherRef.current, [
        createEventDispatcher,
        itemId
    ]);
    const isOpen = itemId !== undefined;
    (0, $fsvuC.useEffect)(()=>{
        const eventDispatcher = eventDispatcherRef.current;
        if (!eventDispatcher) return;
        if (isOpen) eventDispatcher.dispatch((0, $ccaff9c1e22335c3$export$ff50ad60f08a4bc0), createScreenUIEvent($530fbbeb95b5ecce$var$adControlScreenName));
        else if (isMounted.current && !isOpen) eventDispatcher.dispatch((0, $ccaff9c1e22335c3$export$6bd2d8eacca15ce1), createScreenUIEvent($530fbbeb95b5ecce$var$adControlScreenName));
    }, [
        createScreenUIEvent,
        isOpen
    ]);
    (0, $fsvuC.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    if (isOpen && zIndexOverride) (0, $c4wT7.overridePortalIndex)($530fbbeb95b5ecce$var$ACT_MODAL_CONTENT, zIndexOverride);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $g9Smr.default), {
        children: isOpen && /*#__PURE__*/ (0, $5chsV.jsx)((0, $8OcK0.default), {
            shouldCloseOnEscapePress: true,
            onClose: closeModal,
            ...props,
            children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jRYjy.Box), {
                id: $530fbbeb95b5ecce$var$ACT_MODAL_CONTENT,
                children: [
                    title !== null && /*#__PURE__*/ (0, $5chsV.jsx)((0, $79e8h.default), {
                        hasCloseButton: hasCloseButton,
                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $fTkoK.default), {
                            children: title ?? /*#__PURE__*/ (0, $5chsV.jsx)((0, $ECZQy.default), {
                                ...(0, $clzmc.messages).showReasons
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $kJ3Vl.default), {
                        children: body
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $djI0m.default), {
                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $BP2AV.default), {
                            appearance: "primary",
                            onClick: closeModal,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ECZQy.default), {
                                ...(0, $clzmc.messages).reasonsModalOkButton
                            })
                        })
                    })
                ]
            })
        })
    });
};
$530fbbeb95b5ecce$var$ReasonsModal.displayName = "ReasonsModal";
var $530fbbeb95b5ecce$export$2e2bcd8739ae039 = $530fbbeb95b5ecce$var$ReasonsModal;

});


parcelRegister("2vFQ8", function(module, exports) {
$parcel$export(module.exports, "default", () => $6851ec7d4ea0ff1e$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $ECZQy = parcelRequire("ECZQy");

var $hTGok = parcelRequire("hTGok");


var $kUk4q = parcelRequire("kUk4q");

var $emgdV = parcelRequire("emgdV");

var $clzmc = parcelRequire("clzmc");
const $6851ec7d4ea0ff1e$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'notInterested'
};
const $6851ec7d4ea0ff1e$var$DismissalButton = ({ itemId: itemId, onClick: onClick, children: children, flagProps: flagProps, ...props })=>{
    const { addFlag: addFlag, createEventDispatcher: createEventDispatcher, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $emgdV.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kUk4q.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useCallback(async (e)=>{
        eventDispatcher.dispatch((0, $ccaff9c1e22335c3$export$e33200507ac1d20a), createInteractedUIEvent($6851ec7d4ea0ff1e$var$interactedUIEventAction));
        shouldShowDismissFlag && addFlag(itemId, flagProps);
        try {
            await onClick?.(e, itemId);
            eventDispatcher.dispatch((0, $ccaff9c1e22335c3$export$103f41d1f3bf374e));
        } catch (e) {
            eventDispatcher.dispatchError((0, $ccaff9c1e22335c3$export$6d3088110036f124), e);
        }
    }, [
        addFlag,
        createInteractedUIEvent,
        eventDispatcher,
        flagProps,
        itemId,
        onClick,
        shouldShowDismissFlag
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hTGok.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $5chsV.jsx)((0, $ECZQy.default), {
            ...(0, $clzmc.messages).notInterested
        })
    });
};
$6851ec7d4ea0ff1e$var$DismissalButton.displayName = "DismissalButton";
var $6851ec7d4ea0ff1e$export$2e2bcd8739ae039 = $6851ec7d4ea0ff1e$var$DismissalButton;

});

parcelRegister("g9Qw8", function(module, exports) {
$parcel$export(module.exports, "default", () => $058ae6e2f5a9e96a$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $ECZQy = parcelRequire("ECZQy");

var $hTGok = parcelRequire("hTGok");


var $kUk4q = parcelRequire("kUk4q");

var $emgdV = parcelRequire("emgdV");

var $clzmc = parcelRequire("clzmc");
const $058ae6e2f5a9e96a$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsReasons'
};
const $058ae6e2f5a9e96a$var$ReasonsButton = ({ children: children, itemId: itemId, modalProps: modalProps, onClick: onClick, ...props })=>{
    const { createEventDispatcher: createEventDispatcher, openModal: openModal } = (0, $emgdV.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kUk4q.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useCallback((e)=>{
        eventDispatcher.dispatch((0, $ccaff9c1e22335c3$export$5595c6967e83d351), createInteractedUIEvent($058ae6e2f5a9e96a$var$interactedUIEventAction));
        openModal(modalProps, itemId);
        onClick?.(e, itemId);
    }, [
        createInteractedUIEvent,
        eventDispatcher,
        itemId,
        modalProps,
        onClick,
        openModal
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hTGok.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $5chsV.jsx)((0, $ECZQy.default), {
            ...(0, $clzmc.messages).showReasons
        })
    });
};
$058ae6e2f5a9e96a$var$ReasonsButton.displayName = "ReasonsButton";
var $058ae6e2f5a9e96a$export$2e2bcd8739ae039 = $058ae6e2f5a9e96a$var$ReasonsButton;

});

parcelRegister("ir53u", function(module, exports) {
$parcel$export(module.exports, "UiViewedEvent", () => $69b21d27f94f8c2b$export$d0a9edec5c713764);

var $fsvuC = parcelRequire("fsvuC");

var $3dBeg = parcelRequire("3dBeg");
function $69b21d27f94f8c2b$export$d0a9edec5c713764({ actionSubjectId: actionSubjectId, actionSubject: actionSubject, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $3dBeg.useAnalytics)();
    const hasSent = (0, $fsvuC.useRef)(false);
    (0, $fsvuC.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        actionSubject,
        actionSubjectId,
        attributes
    ]);
    return null;
}
$69b21d27f94f8c2b$export$d0a9edec5c713764.displayName = "UiViewedEvent";

});

parcelRegister("8Eye0", function(module, exports) {
$parcel$export(module.exports, "useOnClickDismissMenu", () => $4c935e1f16349e08$export$d840cf3018e72a62);

var $fsvuC = parcelRequire("fsvuC");

var $3dBeg = parcelRequire("3dBeg");
const $4c935e1f16349e08$export$d840cf3018e72a62 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $3dBeg.useAnalytics)();
    return (0, $fsvuC.useCallback)((dismissMenuIntent)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'editionAwarenessDismissMenu',
            attributes: {
                dismissMenuIntent: dismissMenuIntent
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
};

});

parcelRegister("3OEoy", function(module, exports) {
$parcel$export(module.exports, "useButtonContent", () => $a2f542751e5f5ab5$export$c810aba6284fa97d);

var $54F37 = parcelRequire("54F37");
var $oAzkD = parcelRequire("oAzkD");

var $7Z4U9 = parcelRequire("7Z4U9");

var $8Nx3j = parcelRequire("8Nx3j");

var $eOaYv = parcelRequire("eOaYv");

var $j88QB = parcelRequire("j88QB");

var $hvUnP = parcelRequire("hvUnP");

var $aE3ln = parcelRequire("aE3ln");

var $hnVBT = parcelRequire("hnVBT");

var $iCbte = parcelRequire("iCbte");

var $1r0W6 = parcelRequire("1r0W6");

var $fqXcR = parcelRequire("fqXcR");

var $i56hz = parcelRequire("i56hz");

var $1ZV8K = parcelRequire("1ZV8K");

var $84vV3 = parcelRequire("84vV3");

var $coImd = parcelRequire("coImd");
const $a2f542751e5f5ab5$var$buttonMessages = (0, $54F37.defineMessages)({
    upgradeText: {
        id: '@atlassian/edition-awareness.button.upgrade',
        defaultMessage: 'Upgrade',
        description: 'Informs the user that they can upgrade their product'
    },
    premiumTrial: {
        id: '@atlassian/edition-awareness.button.premium-trial',
        defaultMessage: 'Premium trial',
        description: 'Informs the user that they are on a Premium trial'
    },
    standardTrial: {
        id: '@atlassian/edition-awareness.button.standard-trial',
        defaultMessage: 'Standard trial',
        description: 'Informs the user that they are on a Standard trial'
    },
    storageNearLimit: {
        id: '@atlassian/edition-awareness.button.storage-near-limit',
        defaultMessage: 'Near limit',
        description: 'Shown on the edition awareness pill when storage usage is approaching the limit (near-limit threshold): Service Collection Free at 90% of the allowance, Jira Standard within 1 GB of it.'
    }
});
function $a2f542751e5f5ab5$var$getFreeContent({ context: context, formatMessage: formatMessage }) {
    const { licensedUsers: licensedUsers, product: product, automationFreeLimitStatus: automationFreeLimitStatus } = context;
    const limits = (0, $coImd.PRODUCT_LIMITS_MAP)[product];
    const upgradeText = formatMessage($a2f542751e5f5ab5$var$buttonMessages.upgradeText);
    const isAutomationFreeLimitModalEligible = (0, $hvUnP.isEligibleForAutomationFreeLimitModal)(context);
    if (isAutomationFreeLimitModalEligible && automationFreeLimitStatus === 'BREACHED') return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.automation-limits-breached',
            defaultMessage: 'Limit reached',
            description: 'Informs the user that they have breached their automation limits'
        }),
        appearance: 'danger',
        icon: 'warning'
    };
    if (isAutomationFreeLimitModalEligible && automationFreeLimitStatus === 'PROJECTED_TO_BREACH') return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.automation-near-limit',
            defaultMessage: 'Near limit',
            description: 'Informs the user that they are about to breach their automation limits'
        }),
        appearance: 'warning',
        icon: 'warning'
    };
    if ((0, $8Nx3j.isEligibleForStorageHardLimit)(context) || (0, $1r0W6.isEligibleForJsmStorageOverLimit)(context)) return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.storage-hard-limit',
            defaultMessage: 'Storage full',
            description: 'Shown on the edition awareness pill when storage usage is at or over the limit.'
        }),
        appearance: 'warning',
        icon: 'warning'
    };
    if ((0, $84vV3.isProductOneOf)(product, [
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ])) {
        if (licensedUsers >= limits.licensedUserLimit) return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.no-users-left',
                defaultMessage: 'No {product, select, jpd {creators} jsm {agents} jcs {agents} jira {users} confluence {users} other {users}} left',
                description: 'Informs the user that there are no licensed users left and they may need to upgrade their product'
            }, {
                product: (0, $7Z4U9.getProductForTranslation)(product)
            }),
            appearance: product !== 'confluence' ? 'danger' : 'warning',
            icon: 'warning'
        };
        if (licensedUsers >= limits.warningUserLimit) return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.limited-users-left',
                defaultMessage: 'Limited {product, select, jpd {creators} jsm {agents} jcs {agents} jira {users} confluence {users} other {users}} left',
                description: 'Informs the user that there are limited licensed users left before they need to upgrade their product'
            }, {
                product: (0, $7Z4U9.getProductForTranslation)(product)
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    if ((0, $iCbte.isEligibleForJsmStorageNearLimit)(context)) return {
        text: formatMessage($a2f542751e5f5ab5$var$buttonMessages.storageNearLimit),
        appearance: 'warning',
        icon: 'warning'
    };
    if (product === 'confluence' && licensedUsers >= limits.warningUserLimit) return {
        text: upgradeText,
        appearance: 'warning',
        icon: 'warning'
    };
    return {
        text: upgradeText,
        appearance: 'default',
        icon: 'gem'
    };
}
function $a2f542751e5f5ab5$var$getStandardContent({ context: context, formatMessage: formatMessage, getExperimentCohort: getExperimentCohort }) {
    // JSSHL (TAIYO-388, TAIYO-553): must stay in step with JiraStandardStorageHardLimit in
    // actions-and-content.tsx, which provides the resolved collection membership and
    // canUpgradeToPremium and only claims the variation cohort; everyone else falls through to the
    // pills below. Within 1 GB of limit users are only eligible if they
    // can upgrade to Premium, so the pill and the dispatch expose the same users.
    const isNearLimit = (0, $hnVBT.isJiraStandardStorageNearLimit)(context);
    if (context.isInCollection === 'NOT_IN_COLLECTION' && (0, $hnVBT.isEligibleForJiraStandardStorageHardLimit)(context) && // if near limit = true, must have canUpgradeToPremium = true
    (!isNearLimit || context.canUpgradeToPremium === true) && getExperimentCohort('jira-standard-storage-hard-limits', true) === 'variation') {
        if (isNearLimit) return {
            text: formatMessage($a2f542751e5f5ab5$var$buttonMessages.storageNearLimit),
            appearance: 'warning',
            icon: 'warning'
        };
        return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.storage-hard-limit-storage-full',
                defaultMessage: 'Storage full',
                description: 'Shown on the edition awareness pill when storage usage is at or over the limit.'
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    if ((0, $1ZV8K.isEligibleForStandardToPremium)(context)) return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.upgrade.standard-to-premium',
            defaultMessage: 'Upgrade',
            description: 'Informs the user that they can upgrade their product'
        }),
        appearance: 'default',
        icon: 'gem',
        isDismissible: true
    };
    return null;
}
function $a2f542751e5f5ab5$var$getTrialContent({ context: context, formatMessage: formatMessage }) {
    const { product: product, edition: edition, trialDaysLeft: trialDaysLeft, trialLengthDays: trialLengthDays } = context;
    const isInFirstHalfOfTrial = Boolean(trialDaysLeft && trialLengthDays && trialDaysLeft > Math.ceil(trialLengthDays / 2));
    const premiumTrialText = formatMessage($a2f542751e5f5ab5$var$buttonMessages.premiumTrial);
    const standardTrialText = formatMessage($a2f542751e5f5ab5$var$buttonMessages.standardTrial);
    let appearance = 'default';
    let icon = 'gem';
    const daysLeftText = formatMessage({
        id: '@atlassian/edition-awareness.button.daysLeft',
        defaultMessage: '{trialDaysLeft, plural, one {# day} other {# days}} left',
        description: 'Informs the user how many days they have left in trial'
    }, {
        trialDaysLeft: trialDaysLeft
    });
    if ((0, $i56hz.isEligibleForReverseTrialPlanSelection)(context)) {
        if (isInFirstHalfOfTrial) return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.see-plans',
                defaultMessage: 'See plans',
                description: 'Informs the user that they are able to see plans'
            }),
            appearance: appearance,
            icon: icon
        };
        if (trialDaysLeft && trialDaysLeft <= 3) {
            appearance = 'warning';
            icon = 'warning';
        }
        return {
            text: daysLeftText,
            appearance: appearance,
            icon: icon
        };
    }
    if ((0, $84vV3.isProductOneOf)(product, [
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ])) {
        // If trial is still in its first half, show trial message instead of trial days left
        if (isInFirstHalfOfTrial) {
            if (edition === 'premium') return {
                text: premiumTrialText,
                appearance: appearance,
                icon: icon
            };
            if (edition === 'standard') return {
                text: standardTrialText,
                appearance: appearance,
                icon: icon
            };
        }
        // If trial has 3 days or less remaining, swap the button to the warning state
        if (trialDaysLeft && trialDaysLeft <= 3) {
            appearance = 'warning';
            icon = 'warning';
        }
        return {
            text: daysLeftText,
            appearance: appearance,
            icon: icon
        };
    }
    if ((0, $aE3ln.isEligibleForConfluenceBuyReverseTrial)(context)) {
        appearance = 'default';
        icon = 'gem';
        if (trialDaysLeft && trialDaysLeft > 15) return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.see-plans.cbrt',
                defaultMessage: 'See plans',
                description: 'Informs the user that they are able to see plans'
            }),
            appearance: appearance,
            icon: icon
        };
        if (trialDaysLeft && trialDaysLeft <= 3) {
            appearance = 'warning';
            icon = 'warning';
        }
        return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.see-plans.cbrt.final',
                // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
                defaultMessage: '{trialDaysLeft, plural, =1 {# day} other {# days}} left',
                description: 'Indicates to the user how many days they have left in trial'
            }, {
                trialDaysLeft: trialDaysLeft
            }),
            appearance: appearance,
            icon: icon
        };
    }
    return {
        text: daysLeftText,
        appearance: appearance,
        icon: icon
    };
}
function $a2f542751e5f5ab5$var$getPredunningContent({ context: context, formatMessage: formatMessage }) {
    let appearance = 'default';
    let icon = 'credit-card';
    if ((0, $i56hz.isEligibleForReverseTrialPlanSelection)(context)) return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.choose-plans',
            defaultMessage: 'Choose a plan',
            description: 'Informs the user that they are able to choose a plan'
        }),
        appearance: 'warning',
        icon: 'warning'
    };
    if ((0, $aE3ln.isEligibleForConfluenceBuyReverseTrial)(context)) return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.see-plans.final',
            defaultMessage: 'Choose a plan',
            description: 'Informs the user that they are able to choose a plan'
        }),
        appearance: 'warning',
        icon: 'warning'
    };
    return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.addPaymentDetails',
            defaultMessage: 'Add payment details',
            description: 'Informs the user how many days they have left in trial'
        }),
        appearance: appearance,
        icon: icon
    };
}
function $a2f542751e5f5ab5$var$getCollectionContent({ context: context, formatMessage: formatMessage }) {
    /* ==============================
	// Collection
	// Collection handles its own logic for the button content
	// This is to avoid the button content from being overridden by other products' logic
	// ============================== */ const { isInTrial: isInTrial, trialDaysLeft: trialDaysLeft, isInPredunning: isInPredunning, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails } = context;
    const upgradeText = formatMessage($a2f542751e5f5ab5$var$buttonMessages.upgradeText);
    if (isInTrial) {
        let appearance = 'default';
        let icon = 'gem';
        const daysLeftText = formatMessage({
            id: '@atlassian/edition-awareness.button.collection.daysLeft',
            defaultMessage: '{trialDaysLeft, plural, one {# day} other {# days}} left',
            description: 'Informs the user how many days they have left in trial'
        }, {
            trialDaysLeft: trialDaysLeft
        });
        if (trialDaysLeft && trialDaysLeft <= 3) {
            if (invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails) {
                appearance = 'warning';
                icon = 'warning';
            }
        }
        return {
            text: daysLeftText,
            appearance: appearance,
            icon: icon
        };
    }
    if (isInPredunning) {
        if (canAddPaymentDetails && invoiceableStatus === 'NOT_INVOICEABLE') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.collection.addPaymentDetails',
                defaultMessage: 'Add payment details'
            }),
            appearance: 'default',
            icon: 'gem'
        };
    }
    return {
        text: upgradeText,
        appearance: 'default',
        icon: 'gem'
    };
}
function $a2f542751e5f5ab5$var$getPremiumContent({ context: context, formatMessage: formatMessage, getExperimentCohort: getExperimentCohort }) {
    if ((0, $fqXcR.isEligibleForPremiumToTwc)(context)) {
        getExperimentCohort('premium-to-twc-upsell-aa', true);
        const cohort = getExperimentCohort('premium-to-twc-upsell-ab');
        if (cohort === 'variation') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.upgrade.premium-to-twc',
                defaultMessage: 'Upgrade',
                description: 'Informs the user that they can upgrade their product'
            }),
            appearance: 'default',
            icon: 'gem',
            isDismissible: true
        };
    }
    return null;
}
function $a2f542751e5f5ab5$export$c810aba6284fa97d() {
    const { formatMessage: formatMessage } = (0, $oAzkD.default)();
    const context = (0, $eOaYv.useEditionAwareness)();
    const { getExperimentCohort: getExperimentCohort } = (0, $j88QB.useGetExperimentValue)();
    const { edition: edition, isInPredunning: isInPredunning, isInTrial: isInTrial, isInCollection: isInCollection, product: product } = context;
    /*
	 * Keep this before the other checks to avoid showing the collection content in the other cases
	 */ if (isInCollection === 'IN_COLLECTION' && (0, $84vV3.isProductOneOf)(product, [
        'jira',
        'confluence'
    ])) return $a2f542751e5f5ab5$var$getCollectionContent({
        context: context,
        formatMessage: formatMessage
    });
    if (edition === 'free') return $a2f542751e5f5ab5$var$getFreeContent({
        context: context,
        formatMessage: formatMessage
    });
    if (isInTrial) return $a2f542751e5f5ab5$var$getTrialContent({
        context: context,
        formatMessage: formatMessage
    });
    if (isInPredunning) return $a2f542751e5f5ab5$var$getPredunningContent({
        context: context,
        formatMessage: formatMessage
    });
    if (edition === 'standard') return $a2f542751e5f5ab5$var$getStandardContent({
        context: context,
        formatMessage: formatMessage,
        getExperimentCohort: getExperimentCohort
    });
    if (edition === 'premium') return $a2f542751e5f5ab5$var$getPremiumContent({
        context: context,
        formatMessage: formatMessage,
        getExperimentCohort: getExperimentCohort
    });
    return null;
}

});
parcelRegister("7Z4U9", function(module, exports) {
$parcel$export(module.exports, "getProductForTranslation", () => $a9804edd7b0f9adf$export$fd45d905638d9909);
const $a9804edd7b0f9adf$var$PRODUCT_TO_TRANSLATION_KEY = {
    jira: 'jira',
    'jira-service-management': 'jsm',
    'jira-product-discovery': 'jpd',
    'jira-customer-service': 'jcs',
    confluence: 'confluence'
};
function $a9804edd7b0f9adf$export$fd45d905638d9909(product) {
    return $a9804edd7b0f9adf$var$PRODUCT_TO_TRANSLATION_KEY[product];
}

});


parcelRegister("gDVPz", function(module, exports) {
$parcel$export(module.exports, "useTracedUrl", () => $f9fb8a4d7cb3b02e$export$5eea7bde9861e87b);

var $fsvuC = parcelRequire("fsvuC");

var $iBNbX = parcelRequire("iBNbX");

var $eOaYv = parcelRequire("eOaYv");
const $f9fb8a4d7cb3b02e$export$5a01ec5e3068630c = {
    ['confluence']: 'confluence',
    ['jira']: 'jira',
    ['jira-product-discovery']: 'jira',
    ['jira-service-management']: 'jira',
    ['jira-customer-service']: 'jira'
};
function $f9fb8a4d7cb3b02e$export$5eea7bde9861e87b(untracedUrl) {
    const { product: product } = (0, $eOaYv.useEditionAwareness)();
    const origin = (0, $fsvuC.useMemo)(()=>new (0, $iBNbX.default)({
            product: $f9fb8a4d7cb3b02e$export$5a01ec5e3068630c[product]
        }), [
        product
    ]);
    const url = (0, $fsvuC.useMemo)(()=>untracedUrl ? origin.addToUrl(untracedUrl) : undefined, [
        untracedUrl,
        origin
    ]);
    return {
        url: url,
        origin: origin
    };
}

});


parcelRegister("fqMum", function(module, exports) {
$parcel$export(module.exports, "AutoOpenModalTrigger", () => $1dabf632677be8c3$export$beb58c00994cbd66);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $iNT4o = parcelRequire("iNT4o");

var $8V6dQ = parcelRequire("8V6dQ");

var $1oQSL = parcelRequire("1oQSL");

var $kJ3Vl = parcelRequire("kJ3Vl");

var $8OcK0 = parcelRequire("8OcK0");

var $djI0m = parcelRequire("djI0m");

var $79e8h = parcelRequire("79e8h");

var $fTkoK = parcelRequire("fTkoK");

var $d0SZF = parcelRequire("d0SZF");

var $4LXGz = parcelRequire("4LXGz");

var $9lAcD = parcelRequire("9lAcD");

var $bfLoj = parcelRequire("bfLoj");

var $gWXcM = parcelRequire("gWXcM");

var $Wd0FJ = parcelRequire("Wd0FJ");
const $1dabf632677be8c3$var$emptyEntryPointParams = {};
const $1dabf632677be8c3$var$emptyEntryPointProps = {};
function $1dabf632677be8c3$export$beb58c00994cbd66({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, shouldAutoOpen: shouldAutoOpen, preloadOnFocus: preloadOnFocus = false }) {
    const { openModal: openModal } = (0, $fsvuC.useContext)((0, $bfLoj.ModalContext));
    const environmentProvider = (0, $Wd0FJ.useRelayEnvironmentProvider)();
    const { GlobalModalErrorFallback: GlobalModalErrorFallback } = (0, $4LXGz.useEntryPointConfig)();
    const metricName = (0, $fsvuC.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $fsvuC.useCallback)(()=>(0, $iNT4o.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $1dabf632677be8c3$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $fsvuC.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const defaultFallback = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5chsV.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $79e8h.default), {
                        hasCloseButton: true,
                        children: title ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $fTkoK.default), {
                            children: title
                        }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $d0SZF.Stack), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $1oQSL.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsxs)((0, $kJ3Vl.default), {
                        children: [
                            /*#__PURE__*/ (0, $5chsV.jsx)((0, $1oQSL.default), {}),
                            /*#__PURE__*/ (0, $5chsV.jsx)((0, $1oQSL.default), {}),
                            /*#__PURE__*/ (0, $5chsV.jsx)((0, $1oQSL.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $djI0m.default), {})
                ]
            });
            const container = /*#__PURE__*/ (0, $5chsV.jsx)((0, $gWXcM.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, $5chsV.jsx)(GlobalModalErrorFallback, {
                        error: error,
                        closeModal: closeModal
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                },
                fallback: Fallback ? /*#__PURE__*/ (0, $5chsV.jsx)(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $1dabf632677be8c3$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return /*#__PURE__*/ (0, $5chsV.jsx)((0, $8OcK0.default), {
                ...modalProps,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress,
                children: container
            });
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        GlobalModalErrorFallback,
        onError
    ]);
    const triggerRef = (0, $9lAcD.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $8V6dQ.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    // -- UNIQUE CODE FOR AUTO LOADING
    const hasRun = (0, $fsvuC.useRef)(false);
    (0, $fsvuC.useEffect)(()=>{
        if (!hasRun.current && shouldAutoOpen) {
            hasRun.current = true;
            const reference = load();
            onLoad({
                reference: reference,
                dispose: reference.dispose
            });
        }
    }, [
        shouldAutoOpen,
        load,
        onLoad
    ]);
    // -- UNIQUE CODE FOR AUTO LOADING
    return children({
        ref: mergedRef
    });
}
$1dabf632677be8c3$export$beb58c00994cbd66.displayName = "AutoOpenModalTrigger";

});


parcelRegister("2njtZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c529abfa70f4a13$export$2e2bcd8739ae039);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

const $1c529abfa70f4a13$var$AutomationLimitsEntryPoint = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("96OSd")), {
        moduleId: "fda1ad3d",
        priority: "interaction",
        moduleId: 'edition-awareness-automation-free-limit-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});
var $1c529abfa70f4a13$export$2e2bcd8739ae039 = $1c529abfa70f4a13$var$AutomationLimitsEntryPoint;

});
parcelRegister("96OSd", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("26UR6").then(()=>parcelRequire('7YPbX'));

});


parcelRegister("auT0T", function(module, exports) {
$parcel$export(module.exports, "FREE_DIALOG_CONFIG", () => $bf2f82a0707c8ad5$export$212eac90358facd0);

var $1iBop = parcelRequire("1iBop");
const $bf2f82a0707c8ad5$export$212eac90358facd0 = {
    touchpointIntent: 'directBuy',
    dialogId: 'automation-free-limit-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1iBop.Edition).STANDARD_EDITION
};

});
parcelRegister("1iBop", function(module, exports) {
$parcel$export(module.exports, "GrowthPillar", () => $42f334eca9fc5f0e$export$9874ba4d5a9c06c8);
$parcel$export(module.exports, "Edition", () => $42f334eca9fc5f0e$export$6f4a0f769e61929);
var $42f334eca9fc5f0e$export$9874ba4d5a9c06c8 = /*#__PURE__*/ function(GrowthPillar) {
    GrowthPillar["FIND"] = "FIND";
    GrowthPillar["BUY"] = "BUY";
    GrowthPillar["USE"] = "USE";
    GrowthPillar["PLATFORM"] = "PLATFORM";
    return GrowthPillar;
}({});
var $42f334eca9fc5f0e$export$6f4a0f769e61929 = /*#__PURE__*/ function(Edition) {
    Edition["FREE_EDITION"] = "free";
    Edition["STANDARD_EDITION"] = "standard";
    Edition["PREMIUM_EDITION"] = "premium";
    Edition["SELECTION"] = "selection";
    return Edition;
}({});

});



parcelRegister("aVuvl", function(module, exports) {
$parcel$export(module.exports, "CollectionAddPaymentDetailsPopup", () => $ddb7fd8d2dcf57fc$export$7c1c66d41188536);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $7rioG = parcelRequire("7rioG");

var $eLkUl = parcelRequire("eLkUl");

var $l18VF = parcelRequire("l18VF");
const $ddb7fd8d2dcf57fc$export$7c1c66d41188536 = ()=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $7rioG.PopupEntryPoint), {
        entryPoint: (0, $eLkUl.entryPoint),
        entryPointProps: {},
        placement: 'bottom-end',
        dialogConfig: (0, $l18VF.DIALOG_CONFIG)
    });
};
$ddb7fd8d2dcf57fc$export$7c1c66d41188536.displayName = "CollectionAddPaymentDetailsPopup";

});
parcelRegister("7rioG", function(module, exports) {
$parcel$export(module.exports, "PopupEntryPoint", () => $f9d0ab38d254f975$export$e14c42e99b209c4d);
/* popup-entry-point.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $9sl8X = parcelRequire("9sl8X");

var $jRYjy = parcelRequire("jRYjy");

var $9cT91 = parcelRequire("9cT91");

var $5I8al = parcelRequire("5I8al");

var $fwygm = parcelRequire("fwygm");

var $ezp5D = parcelRequire("ezp5D");

var $8iLmE = parcelRequire("8iLmE");

var $hD4W1 = parcelRequire("hD4W1");
const $f9d0ab38d254f975$var$styles = {
    fallbackBox: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
};
function $f9d0ab38d254f975$export$e14c42e99b209c4d(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fwygm.DialogContext).Provider, {
        value: dialogConfig,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $9sl8X.default), {
            data: dialogConfig,
            children: /*#__PURE__*/ (0, $5chsV.jsx)($f9d0ab38d254f975$export$dece147acb9eddff, {
                ...rest
            })
        })
    });
}
$f9d0ab38d254f975$export$e14c42e99b209c4d.displayName = "PopupEntryPoint";
function $f9d0ab38d254f975$export$dece147acb9eddff(props) {
    const { onClose: onClose, ...rest } = props;
    const onError = (0, $ezp5D.useEntrypointErrorAnalytics)();
    const onCloseDialog = (0, $8iLmE.useOnCloseDialog)();
    const onClosePopup = (0, $fsvuC.useCallback)((event, currentLevel)=>{
        onClose?.(event, currentLevel);
        onCloseDialog();
    }, [
        onClose,
        onCloseDialog
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5I8al.PopupTrigger), {
        ...rest,
        shouldFitContainer: false,
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $hD4W1.EditionAwarenessButton), {
                ref: ref
            }),
        fallback: /*#__PURE__*/ (0, $5chsV.jsx)($f9d0ab38d254f975$var$PopupFallback, {}),
        onError: onError,
        onClose: onClosePopup,
        preloadOnFocus: true
    });
}
$f9d0ab38d254f975$export$dece147acb9eddff.displayName = "PopupEntryPointInner";
const $f9d0ab38d254f975$var$PopupFallback = ()=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
        xcss: $f9d0ab38d254f975$var$styles.fallbackBox,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $9cT91.default), {})
    });
$f9d0ab38d254f975$var$PopupFallback.displayName = "PopupFallback";

});

parcelRegister("eLkUl", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $fc8a146b73105343$export$6333901e831d7af0);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

const $fc8a146b73105343$export$6333901e831d7af0 = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("hnMJn")), {
        moduleId: "732c33d7",
        priority: "interaction",
        moduleId: 'edition-awareness-collection-add-payment-details-popup'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});

});
parcelRegister("hnMJn", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("c4gjF").then(()=>parcelRequire('1s6u5'));

});


parcelRegister("l18VF", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $3f536d5e66244719$export$3b6761b6086f6dfd);
const $3f536d5e66244719$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'collection-add-payment-details-popup',
    dialogType: 'pop-up'
};

});


parcelRegister("4q39A", function(module, exports) {
$parcel$export(module.exports, "CollectionChangePlanPopup", () => $82f2a987df21b556$export$a32dee959fd7bd6e);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $eOaYv = parcelRequire("eOaYv");

var $7rioG = parcelRequire("7rioG");

var $ehCzw = parcelRequire("ehCzw");

var $iRZSk = parcelRequire("iRZSk");
const $82f2a987df21b556$export$a32dee959fd7bd6e = ()=>{
    const { collectionEntitlementId: collectionEntitlementId } = (0, $eOaYv.useEditionAwareness)();
    const entryPointParams = (0, $fsvuC.useMemo)(()=>({
            collectionEntitlementId: `ari:cloud:commerce::entitlement/${collectionEntitlementId}`
        }), [
        collectionEntitlementId
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $7rioG.PopupEntryPoint), {
        entryPoint: (0, $ehCzw.entryPoint),
        entryPointParams: entryPointParams,
        placement: 'bottom-end',
        dialogConfig: (0, $iRZSk.DIALOG_CONFIG)
    });
};
$82f2a987df21b556$export$a32dee959fd7bd6e.displayName = "CollectionChangePlanPopup";

});
parcelRegister("ehCzw", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $049bfd7dbca83c8f$export$6333901e831d7af0);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

var $4qDvg = parcelRequire("4qDvg");

const $049bfd7dbca83c8f$export$6333901e831d7af0 = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("bECH1")), {
        moduleId: "47830478",
        priority: "interaction",
        moduleId: 'edition-awareness-collection-change-plan-popup'
    }),
    getPreloadProps: ({ collectionEntitlementId: collectionEntitlementId })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                collectionChangePlanPopupQuery: {
                    parameters: $4qDvg.default,
                    variables: {
                        collectionEntitlementId: collectionEntitlementId
                    }
                }
            }
        })
});

});
parcelRegister("4qDvg", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fe8e00597601a48$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9bde5f91778d86c0c2aa7edb3623b43a>>
 * @relayHash 78d13f0d1fdc6880857606f82d2074ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 242a677a397113cedf06a1f4ffb86a7bef4bcd0e5d406fa845d786f9871940f0

var $7LcWi = parcelRequire("7LcWi");
const $9fe8e00597601a48$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "collectionEntitlementId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "collectionEntitlementId"
        }
    ], v2 = {
        "concreteType": "CcpEntitlementExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpManageEntitlementExperienceCapability",
                "kind": "LinkedField",
                "name": "manageEntitlement",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "experienceUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isAvailableToUser"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "collectionChangePlanPopupQuery",
            "selections": [
                {
                    "concreteType": "CcpQueryApi",
                    "kind": "LinkedField",
                    "name": "ccp",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlementV2",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "collectionChangePlanPopupQuery",
            "selections": [
                {
                    "concreteType": "CcpQueryApi",
                    "kind": "LinkedField",
                    "name": "ccp",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlementV2",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "242a677a397113cedf06a1f4ffb86a7bef4bcd0e5d406fa845d786f9871940f0",
            "metadata": {},
            "name": "collectionChangePlanPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9fe8e00597601a48$var$node.hash = "9b656bb88394dc31aa1596f9938d5c9a";
(0, $7LcWi.PreloadableQueryRegistry).set($9fe8e00597601a48$var$node.params.id, $9fe8e00597601a48$var$node);
var $9fe8e00597601a48$export$2e2bcd8739ae039 = $9fe8e00597601a48$var$node;

});

parcelRegister("bECH1", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("iLROm").then(()=>parcelRequire('ilhu5'));

});


parcelRegister("iRZSk", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $9a9a34cca162df46$export$3b6761b6086f6dfd);

var $1iBop = parcelRequire("1iBop");
const $9a9a34cca162df46$export$3b6761b6086f6dfd = {
    touchpointIntent: 'changePlan',
    dialogId: 'collection-change-plan-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $1iBop.Edition).SELECTION
};

});


parcelRegister("48j9G", function(module, exports) {
$parcel$export(module.exports, "CollectionTrialModal", () => $f515c354d38b7445$export$f0b1f164a2951c7b);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $eOaYv = parcelRequire("eOaYv");

var $aJ73T = parcelRequire("aJ73T");

var $kADOw = parcelRequire("kADOw");

var $dZnEl = parcelRequire("dZnEl");
const $f515c354d38b7445$var$modalProps = {
    width: 'medium'
};
const $f515c354d38b7445$export$f0b1f164a2951c7b = ()=>{
    const { collectionEntitlementId: collectionEntitlementId } = (0, $eOaYv.useEditionAwareness)();
    const entryPointParams = (0, $fsvuC.useMemo)(()=>({
            collectionEntitlementId: `ari:cloud:commerce::entitlement/${collectionEntitlementId}`
        }), [
        collectionEntitlementId
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aJ73T.ModalEntryPoint), {
        entryPoint: (0, $kADOw.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: $f515c354d38b7445$var$modalProps,
        dialogConfig: (0, $dZnEl.DIALOG_CONFIG)
    });
};
$f515c354d38b7445$export$f0b1f164a2951c7b.displayName = "CollectionTrialModal";

});
parcelRegister("kADOw", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $35c1306a79e85539$export$6333901e831d7af0);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

var $8t5Jj = parcelRequire("8t5Jj");

const $35c1306a79e85539$export$6333901e831d7af0 = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("6y10I")), {
        moduleId: "8f7dbe3d",
        priority: "interaction",
        moduleId: 'edition-awareness-collection-trial-modal'
    }),
    getPreloadProps: ({ collectionEntitlementId: collectionEntitlementId })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                collectionTrialModalQuery: {
                    parameters: $8t5Jj.default,
                    variables: {
                        collectionEntitlementId: collectionEntitlementId
                    }
                }
            }
        })
});

});
parcelRegister("8t5Jj", function(module, exports) {
$parcel$export(module.exports, "default", () => $42b9761119fd53ec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c09d0091f169378048d9817d4dd25c84>>
 * @relayHash 31080e5e62511dde6e8d333bb5ca57b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 86bd60ec9265df62e6ca865576da70af9f998a694aceb05853fefdf610859337

var $7LcWi = parcelRequire("7LcWi");
const $42b9761119fd53ec$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "collectionEntitlementId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "collectionEntitlementId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "collectionTrialModalQuery",
            "selections": [
                {
                    "concreteType": "CcpQueryApi",
                    "kind": "LinkedField",
                    "name": "ccp",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlementV2",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "teamworkCollectionTrialModalFragment"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "collectionTrialModalQuery",
            "selections": [
                {
                    "concreteType": "CcpQueryApi",
                    "kind": "LinkedField",
                    "name": "ccp",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlementV2",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CcpOffering",
                                    "kind": "LinkedField",
                                    "name": "offering",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "CcpEntitlementExperienceCapabilities",
                                    "kind": "LinkedField",
                                    "name": "experienceCapabilities",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "CcpManageEntitlementExperienceCapability",
                                            "kind": "LinkedField",
                                            "name": "manageEntitlement",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "experienceUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isAvailableToUser"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "licensedUsers",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "chargeElement",
                                            "value": "user"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "latestUsageForChargeElement",
                                    "storageKey": "latestUsageForChargeElement(chargeElement:\"user\")"
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "relationshipTypes",
                                            "value": [
                                                "COLLECTION"
                                            ]
                                        }
                                    ],
                                    "concreteType": "CcpEntitlementRelationship",
                                    "kind": "LinkedField",
                                    "name": "relatesToEntitlements",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "relationshipType"
                                        },
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CcpOffering",
                                                    "kind": "LinkedField",
                                                    "name": "offering",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "productKey"
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                },
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "relatesToEntitlements(relationshipTypes:[\"COLLECTION\"])"
                                },
                                {
                                    "concreteType": "CcpEntitlementTemplate",
                                    "kind": "LinkedField",
                                    "name": "entitlementTemplate",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlementTemplateUserUsageInclusions",
                                            "kind": "LinkedField",
                                            "name": "userUsageInclusions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "references"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "data"
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "86bd60ec9265df62e6ca865576da70af9f998a694aceb05853fefdf610859337",
            "metadata": {},
            "name": "collectionTrialModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$42b9761119fd53ec$var$node.hash = "099e27776796344223da9c18362c93ad";
(0, $7LcWi.PreloadableQueryRegistry).set($42b9761119fd53ec$var$node.params.id, $42b9761119fd53ec$var$node);
var $42b9761119fd53ec$export$2e2bcd8739ae039 = $42b9761119fd53ec$var$node;

});

parcelRegister("6y10I", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("gZTKg").then(()=>parcelRequire('hbjFW'));

});


parcelRegister("dZnEl", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $06d2b3d2cbaba508$export$3b6761b6086f6dfd);
const $06d2b3d2cbaba508$export$3b6761b6086f6dfd = {
    touchpointIntent: 'onboarding',
    dialogId: 'collection-trial-modal',
    dialogType: 'modal'
};

});


parcelRegister("fLXfP", function(module, exports) {
$parcel$export(module.exports, "ExploreEditionBenefitsModal", () => $21d30c80ebbe8d26$export$6d6f5b93e7fec4b2);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $hIr30 = parcelRequire("hIr30");

var $rV8Gn = parcelRequire("rV8Gn");

var $k31PG = parcelRequire("k31PG");

var $eOaYv = parcelRequire("eOaYv");

var $aJ73T = parcelRequire("aJ73T");

var $hbqb2 = parcelRequire("hbqb2");

var $e81i8 = parcelRequire("e81i8");
function $21d30c80ebbe8d26$export$6d6f5b93e7fec4b2() {
    const { product: product, cloudId: cloudId, edition: edition, currentRoute: currentRoute, userEmail: userEmail, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen, lastKnownTrial: lastKnownTrial } = (0, $eOaYv.useEditionAwareness)();
    const isStorageLimitBreached = lastKnownTrial?.trialTrigger === 'AUTO_UPGRADE_MEDIA_STORAGE_LIMIT';
    const variantId = (0, $e81i8.useVariantId)({
        product: product,
        currentRoute: currentRoute,
        isStorageLimitBreached: isStorageLimitBreached
    });
    const initialOpenModal = (0, $fsvuC.useRef)(shouldAutoOpen);
    const entryPointParams = (0, $fsvuC.useMemo)(()=>({
            cloudId: cloudId,
            product: product
        }), [
        cloudId,
        product
    ]);
    const entryPointProps = (0, $fsvuC.useMemo)(()=>({
            variantId: variantId,
            touchpointId: 'edition-awareness-explore-modal',
            edition: edition,
            email: userEmail ?? undefined
        }), [
        edition,
        variantId,
        userEmail
    ]);
    const { fireTrigger: firePopupTrigger } = (0, $k31PG.useFirePostOfficeTrigger)({
        triggerId: 'jsm-edition-awareness-button-popup'
    });
    const { fireTrigger: fireModalTrigger } = (0, $k31PG.useFirePostOfficeTrigger)({
        triggerId: 'edition-benefits-modal'
    });
    // Clear the query param once we've consumed it, so re-mounts don't re-open
    (0, $fsvuC.useEffect)(()=>{
        if (shouldAutoOpen) onAutoOpen?.();
    }, [
        shouldAutoOpen,
        onAutoOpen
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (initialOpenModal.current) fireModalTrigger({
            isActive: true
        });
        else firePopupTrigger({
            isActive: true
        });
        return ()=>{
            firePopupTrigger({
                isActive: false
            });
            fireModalTrigger({
                isActive: false
            });
        };
    }, [
        firePopupTrigger,
        fireModalTrigger
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aJ73T.ModalEntryPoint), {
        entryPoint: (0, $rV8Gn.editionBenefitsModalEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        dialogConfig: (0, $hbqb2.DIALOG_CONFIG),
        modalProps: (0, $hIr30.MODAL_CONFIG)
    });
}
$21d30c80ebbe8d26$export$6d6f5b93e7fec4b2.displayName = "ExploreEditionBenefitsModal";

});
parcelRegister("hIr30", function(module, exports) {
$parcel$export(module.exports, "MODAL_CONFIG", () => $5ae6c5a8151003ad$export$310af821ace1b0a4);
$parcel$export(module.exports, "SERVICE_COLLECTION_PRICING_PAGE_URL", () => $5ae6c5a8151003ad$export$73d1ac3f0d282717);
$parcel$export(module.exports, "ADMIN_BILLING_PATH", () => $5ae6c5a8151003ad$export$fe159292463016ac);
$parcel$export(module.exports, "JSM_STORAGE_MANAGEMENT_PATH", () => $5ae6c5a8151003ad$export$2ef4407f4b54d009);
$parcel$export(module.exports, "CSM_STORAGE_MANAGEMENT_PATH", () => $5ae6c5a8151003ad$export$1f6e874869664558);
$parcel$export(module.exports, "CANCEL_SUBSCRIPTION_SAC_URL", () => $5ae6c5a8151003ad$export$5911f793141d3670);
$parcel$export(module.exports, "JSM_PRICING_PAGE_URL", () => $5ae6c5a8151003ad$export$f3616073c30968f9);
$parcel$export(module.exports, "INCIDENTS_SLACK_INTEGRATION_VIDEO_URL", () => $5ae6c5a8151003ad$export$6a49267b3da8f732);
const $5ae6c5a8151003ad$export$310af821ace1b0a4 = {
    width: 'x-large',
    shouldScrollInViewport: true
};
const $5ae6c5a8151003ad$export$e2be65a9b817a3d8 = {
    ...$5ae6c5a8151003ad$export$310af821ace1b0a4,
    width: 960
};
const $5ae6c5a8151003ad$export$73d1ac3f0d282717 = 'https://www.atlassian.com/collections/service/pricing';
const $5ae6c5a8151003ad$export$fe159292463016ac = '/admin/billing';
const $5ae6c5a8151003ad$export$2ef4407f4b54d009 = '/jira/settings/products/jira-service-management-storage-management';
const $5ae6c5a8151003ad$export$1f6e874869664558 = '/jira/settings/products/customerservice/storage-management';
const $5ae6c5a8151003ad$export$5911f793141d3670 = 'https://support.atlassian.com/subscriptions-and-billing/docs/cancel-a-subscription/';
const $5ae6c5a8151003ad$export$f3616073c30968f9 = 'http://www.atlassian.com/software/jira/service-management/product-pricing';
const $5ae6c5a8151003ad$export$6a49267b3da8f732 = `https://www.youtube.com/embed/cljyGRFV2fo?rel=0&modestbranding=1`;

});

parcelRegister("rV8Gn", function(module, exports) {
$parcel$export(module.exports, "editionBenefitsModalEntryPoint", () => $f23c3d1289767d75$export$4708c4eaa8d901cd);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

var $7MTKD = parcelRequire("7MTKD");

var $4WPhN = parcelRequire("4WPhN");

var $7gw7Y = parcelRequire("7gw7Y");

const $f23c3d1289767d75$export$4708c4eaa8d901cd = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("lWp4C")), {
        moduleId: "f335c645",
        priority: "interaction",
        moduleId: 'edition-benefits-modal-relay'
    }),
    getPreloadProps: ({ cloudId: cloudId, product: product })=>({
            queries: {
                editionBenefitsModalRelayQuery: {
                    parameters: (0, $7gw7Y.default),
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: (0, $7MTKD.getHamsKey)(product),
                        projectType: (0, $4WPhN.getProjectType)(product)
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                product: product
            }
        })
});

});
parcelRegister("7MTKD", function(module, exports) {
$parcel$export(module.exports, "getHamsKey", () => $447951485b22890b$export$291d012eb0744b34);
$parcel$export(module.exports, "getProductFromHamsKey", () => $447951485b22890b$export$3658e62040c7be00);
const $447951485b22890b$var$ProductKeyToHAMSMap = {
    ['jira']: 'jira-software',
    ['jira-service-management']: 'jira-servicedesk',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['confluence']: 'confluence',
    ['jira-customer-service']: 'jira-customer-service'
};
// Pre-built reverse lookup for `getProductFromHamsKey`, so the map is not rebuilt on every call.
const $447951485b22890b$var$HAMSToProductKeyMap = Object.fromEntries(Object.entries($447951485b22890b$var$ProductKeyToHAMSMap).map(([product, hamsKey])=>[
        hamsKey,
        product
    ]));
const $447951485b22890b$export$291d012eb0744b34 = (product)=>{
    return $447951485b22890b$var$ProductKeyToHAMSMap[product];
};
const $447951485b22890b$export$3658e62040c7be00 = (hamsProductKey)=>{
    return $447951485b22890b$var$HAMSToProductKeyMap[hamsProductKey] ?? 'jira-service-management';
};

});

parcelRegister("4WPhN", function(module, exports) {
$parcel$export(module.exports, "getProjectType", () => $ce1a8ae0d77397c9$export$3dd0da95519c1a33);
const $ce1a8ae0d77397c9$export$3dd0da95519c1a33 = (product)=>{
    switch(product){
        case 'jira-service-management':
            return 'SERVICE_DESK';
        case 'jira-customer-service':
            return 'CUSTOMER_SERVICE';
        case 'jira':
            return 'SOFTWARE';
        case 'jira-product-discovery':
            return 'PRODUCT_DISCOVERY';
        case 'confluence':
            throw new Error('Confluence is not supported');
        default:
            throw new Error('Product not supported');
    }
};

});

parcelRegister("7gw7Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $31e1b907653065ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74a53ad6421f1c8d7280d9877d928236>>
 * @relayHash ef1111bd15d10eaaab0f3bd5698ebf18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12af83d9dec697d2b286a6fc415281377a8f74d26d8aff5a0c9d7d5938b7d228

var $7LcWi = parcelRequire("7LcWi");
const $31e1b907653065ac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectType"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "cloudUrl"
    }, v3 = {
        "args": [
            {
                "kind": "Literal",
                "name": "product",
                "value": "jira"
            }
        ],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "active"
            }
        ],
        "storageKey": "activationIdByProduct(product:\"jira\")"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "concreteType": "CcpEntitlementExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "offeringName",
                        "value": "Premium"
                    }
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": [
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isAvailableToUser"
                    }
                ],
                "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
            },
            {
                "alias": "changeToStandard",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "offeringName",
                        "value": "Standard"
                    }
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": v7 /*: any*/ ,
                "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
            }
        ]
    }, v9 = [
        {
            "kind": "Literal",
            "name": "relationshipTypes",
            "value": "COLLECTION"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v11 = {
        "concreteType": "CcpBillingPeriodDetails",
        "kind": "LinkedField",
        "name": "billingPeriodDetails",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "nextBillingTimestamp"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v13 = {
        "concreteType": "CcpInvoiceGroupExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpConfigurePaymentMethodExperienceCapability",
                "kind": "LinkedField",
                "name": "configurePaymentV2",
                "plural": false,
                "selections": v7 /*: any*/ 
            }
        ]
    }, v14 = {
        "concreteType": "CcpSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "concreteType": "CcpAccountDetails",
                "kind": "LinkedField",
                "name": "accountDetails",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "CcpInvoiceGroup",
                        "kind": "LinkedField",
                        "name": "invoiceGroup",
                        "plural": false,
                        "selections": [
                            v12 /*: any*/ ,
                            v13 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v16 = {
        "concreteType": "CcpTransactionAccountExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpAddPaymentMethodExperienceCapability",
                "kind": "LinkedField",
                "name": "addPaymentMethodV2",
                "plural": false,
                "selections": v7 /*: any*/ 
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "key"
    }, v18 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v19 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "name"
    }, v23 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v25 = {
        "concreteType": "CcpSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "concreteType": "CcpAccountDetails",
                "kind": "LinkedField",
                "name": "accountDetails",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "CcpInvoiceGroup",
                        "kind": "LinkedField",
                        "name": "invoiceGroup",
                        "plural": false,
                        "selections": [
                            v12 /*: any*/ ,
                            v13 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ]
            },
            v20 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "editionBenefitsModalRelayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "CcpEntitlementRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "CcpEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlement",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CcpTransactionAccount",
                                                                    "kind": "LinkedField",
                                                                    "name": "transactionAccount",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                                                },
                                                v14 /*: any*/ ,
                                                {
                                                    "concreteType": "CcpTransactionAccount",
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v19 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "editionBenefitsModalRelayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v24 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "CcpEntitlementRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "CcpEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlement",
                                                            "plural": false,
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CcpTransactionAccount",
                                                                    "kind": "LinkedField",
                                                                    "name": "transactionAccount",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                                                },
                                                v25 /*: any*/ ,
                                                {
                                                    "concreteType": "CcpTransactionAccount",
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                },
                                                v20 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v19 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "12af83d9dec697d2b286a6fc415281377a8f74d26d8aff5a0c9d7d5938b7d228",
            "metadata": {},
            "name": "editionBenefitsModalRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$31e1b907653065ac$var$node.hash = "4adcf3c0d1fd080dc809373daae7326c";
(0, $7LcWi.PreloadableQueryRegistry).set($31e1b907653065ac$var$node.params.id, $31e1b907653065ac$var$node);
var $31e1b907653065ac$export$2e2bcd8739ae039 = $31e1b907653065ac$var$node;

});

parcelRegister("lWp4C", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("dUxcz").then(()=>parcelRequire('aapxy'));

});


parcelRegister("k31PG", function(module, exports) {
$parcel$export(module.exports, "TriggerContextProvider", () => $7c247b21e0d1cafc$export$e80a5720bb4c8fe3);
$parcel$export(module.exports, "useTrigger", () => $7c247b21e0d1cafc$export$3b196fe93a948c18);
$parcel$export(module.exports, "useFirePostOfficeTrigger", () => $7c247b21e0d1cafc$export$83b33e5fe4cce64);
$parcel$export(module.exports, "usePostOfficeExernalMessageProxy", () => $7c247b21e0d1cafc$export$e45375ff75169f);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
const $7c247b21e0d1cafc$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $7c247b21e0d1cafc$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $7c247b21e0d1cafc$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createContext($7c247b21e0d1cafc$var$initialActiveTriggerState);
const $7c247b21e0d1cafc$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createContext($7c247b21e0d1cafc$var$initialTriggerDispatchState);
const $7c247b21e0d1cafc$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $fsvuC.useState)({});
    const setTriggerState = (0, $fsvuC.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $fsvuC.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $fsvuC.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)($7c247b21e0d1cafc$var$TriggerContext.Provider, {
        value: triggerContextValue,
        children: /*#__PURE__*/ (0, $5chsV.jsx)($7c247b21e0d1cafc$var$TriggerDispatchContext.Provider, {
            value: triggerContexDispatchValue,
            children: children
        })
    });
};
$7c247b21e0d1cafc$export$e80a5720bb4c8fe3.displayName = "TriggerContextProvider";
const $7c247b21e0d1cafc$export$454c1d7c35958f5e = ()=>(0, $fsvuC.useContext)($7c247b21e0d1cafc$var$TriggerContext);
const $7c247b21e0d1cafc$export$23cbf084e08bdb93 = ()=>(0, $fsvuC.useContext)($7c247b21e0d1cafc$var$TriggerDispatchContext);
const $7c247b21e0d1cafc$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $7c247b21e0d1cafc$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $7c247b21e0d1cafc$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $7c247b21e0d1cafc$export$23cbf084e08bdb93();
    const fireTrigger = (0, $fsvuC.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $7c247b21e0d1cafc$export$e45375ff75169f = (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $7c247b21e0d1cafc$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $7c247b21e0d1cafc$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $7c247b21e0d1cafc$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $7c247b21e0d1cafc$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $fsvuC.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $fsvuC.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $fsvuC.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};

});

parcelRegister("hbqb2", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $a0dffbb1f33a66c4$export$3b6761b6086f6dfd);

var $1iBop = parcelRequire("1iBop");
const $a0dffbb1f33a66c4$export$3b6761b6086f6dfd = {
    touchpointIntent: 'onboarding',
    dialogId: 'explore-edition-benefits-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1iBop.Edition).STANDARD_EDITION
};

});

parcelRegister("e81i8", function(module, exports) {
$parcel$export(module.exports, "useVariantId", () => $ecdd7b6ce117ec98$export$1916128b8004cf87);
const $ecdd7b6ce117ec98$export$1916128b8004cf87 = ({ product: product, currentRoute: currentRoute, isStorageLimitBreached: isStorageLimitBreached })=>{
    if (currentRoute === 'ops') return 'standard-rovo-service-agents-ops-team';
    // When storage limit is breached, show storage-specific variants
    if (isStorageLimitBreached) switch(product){
        case 'jira-customer-service':
            return 'standard-storage-limits-csm-teams';
        case 'jira-service-management':
            return 'standard-storage-limits-jsm-teams';
        default:
            return 'standard-storage-limits-jsm-teams';
    }
    switch(product){
        case 'jira-customer-service':
            return 'standard-rovo-service-agents-csm-teams';
        case 'jira-service-management':
            return 'standard-rovo-service-agents-service-teams';
        default:
            return 'standard-rovo-service-agents-service-teams';
    }
};

});


parcelRegister("6DAUJ", function(module, exports) {
$parcel$export(module.exports, "FreeToStandardModal", () => $4c86f1a9f7687f81$export$61689b501c3b79e6);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $5Y9N2 = parcelRequire("5Y9N2");

var $eOaYv = parcelRequire("eOaYv");

var $lFWLU = parcelRequire("lFWLU");

var $eSLCP = parcelRequire("eSLCP");

var $aJ73T = parcelRequire("aJ73T");

var $9adCI = parcelRequire("9adCI");

var $4D30e = parcelRequire("4D30e");
function $4c86f1a9f7687f81$export$61689b501c3b79e6() {
    const { product: product, cloudId: cloudId } = (0, $eOaYv.useEditionAwareness)();
    const isStorageLimitsExperimentEnabled = (product === 'jira-service-management' || product === 'jira-customer-service') && (0, $5Y9N2.default).getExperimentValue('jsmgrowth-267_enforce_storage_limits_servco_free', 'isEnabled', false);
    const jiraApplicationKey = (0, $lFWLU.getJiraApplicationKey)(product);
    const projectType = (0, $eSLCP.getJiraProjectTypeKey)(product);
    const isJira = isStorageLimitsExperimentEnabled ? product === 'jira' || product === 'jira-product-discovery' : product === 'jira' || product === 'jira-product-discovery' || product === 'jira-service-management';
    const entryPointParams = (0, $fsvuC.useMemo)(()=>({
            cloudId: cloudId,
            // Fallback to any valid value since this means that we're not using jira
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            // Fallback to any valid value since this means that we're not using jira
            projectType: projectType ?? 'SOFTWARE',
            isJira: isJira,
            isConfluence: product === 'confluence',
            isServiceCollectionFree: product === 'jira-service-management' && isStorageLimitsExperimentEnabled
        }), [
        cloudId,
        product,
        projectType,
        jiraApplicationKey,
        isJira,
        isStorageLimitsExperimentEnabled
    ]);
    const modalProps = (0, $fsvuC.useMemo)(()=>({
            width: 'x-large'
        }), []);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aJ73T.ModalEntryPoint), {
        entryPoint: (0, $4D30e.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $9adCI.DIALOG_CONFIG)
    });
}
$4c86f1a9f7687f81$export$61689b501c3b79e6.displayName = "FreeToStandardModal";

});
parcelRegister("eSLCP", function(module, exports) {
$parcel$export(module.exports, "getJiraProjectTypeKey", () => $2dc7e214c4c3b7cd$export$600268f282087736);
// We're explicitly excluding 'confluence' from this mapping as it's handled separately
const $2dc7e214c4c3b7cd$var$PRODUCT_TO_JIRA_PROJECT_TYPE_KEY = {
    ['jira']: 'SOFTWARE',
    ['jira-product-discovery']: 'PRODUCT_DISCOVERY',
    ['jira-service-management']: 'SERVICE_DESK'
};
const $2dc7e214c4c3b7cd$export$600268f282087736 = (product)=>{
    return $2dc7e214c4c3b7cd$var$PRODUCT_TO_JIRA_PROJECT_TYPE_KEY[product];
};

});

parcelRegister("9adCI", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $9800d7992eff2980$export$3b6761b6086f6dfd);

var $1iBop = parcelRequire("1iBop");
const $9800d7992eff2980$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'free-to-standard-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1iBop.Edition).STANDARD_EDITION
};

});

parcelRegister("4D30e", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $bc8bb9735d5887b5$export$6333901e831d7af0);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

var $4Jyap = parcelRequire("4Jyap");

const $bc8bb9735d5887b5$export$6333901e831d7af0 = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("gdJeO")), {
        moduleId: "afc4323d",
        priority: "interaction",
        moduleId: 'edition-awareness-free-to-standard-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, projectType: projectType, jiraApplicationKey: jiraApplicationKey, isJira: isJira, isConfluence: isConfluence, isServiceCollectionFree: isServiceCollectionFree = false })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                freeToStandardModalQuery: {
                    parameters: $4Jyap.default,
                    variables: {
                        cloudId: cloudId,
                        jiraApplicationKey: jiraApplicationKey,
                        projectType: projectType,
                        isJira: isJira,
                        isConfluence: isConfluence,
                        isServiceCollectionFree: isServiceCollectionFree
                    }
                }
            }
        })
});

});
parcelRegister("4Jyap", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5d2093368d3a282$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<60c13a810b1406f7419bf891488c9a9a>>
 * @relayHash ee2c6a18d841d37fb30880ac310078ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dbbbd84f1e38e47200ac4addeca6edb56946e326bc82cb145b26a2204085a797

var $7LcWi = parcelRequire("7LcWi");
const $a5d2093368d3a282$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfluence"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJira"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isServiceCollectionFree"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraApplicationKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "condition": "isConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v6 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "cql",
                        "value": "type=user"
                    },
                    {
                        "kind": "Literal",
                        "name": "excludeServiceAppUsers",
                        "value": true
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "confluence_searchUser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponse",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluencePerson",
                                "kind": "LinkedField",
                                "name": "confluencePerson",
                                "plural": false,
                                "selections": [
                                    v7 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    {
                                        "concreteType": "Icon",
                                        "kind": "LinkedField",
                                        "name": "profilePicture",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "path"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isUnlimited"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesLimit"
                    }
                ]
            }
        ]
    }, v9 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v6 /*: any*/ 
    ], v10 = {
        "args": v9 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageAllowed"
    }, v11 = {
        "args": v9 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageUsed"
    }, v12 = {
        "args": v9 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageIsUnlimited"
    }, v13 = [
        v6 /*: any*/ ,
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v14 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "args": v13 /*: any*/ ,
        "concreteType": "JiraProjectConnection",
        "kind": "LinkedField",
        "name": "allJiraProjects",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "args": v14 /*: any*/ ,
                                "concreteType": "JiraAssignableUsersConnection",
                                "kind": "LinkedField",
                                "name": "assignableUsers",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraAssignableUsersEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v7 /*: any*/ ,
                                                    v15 /*: any*/ ,
                                                    v16 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "assignableUsers(first:10)"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v18 = [
        {
            "kind": "Literal",
            "name": "applicationKey",
            "value": "JIRA_SERVICE_DESK"
        },
        v6 /*: any*/ 
    ], v19 = {
        "args": v18 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageAllowed"
    }, v20 = {
        "args": v18 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageUsed"
    }, v21 = {
        "args": v18 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageIsUnlimited"
    }, v22 = [
        {
            "kind": "Literal",
            "name": "applicationKey",
            "value": "JIRA_CUSTOMER_SERVICE"
        },
        v6 /*: any*/ 
    ], v23 = {
        "alias": "csm_storage",
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": v22 /*: any*/ ,
                "kind": "ScalarField",
                "name": "attachmentStorageAllowed"
            },
            {
                "args": v22 /*: any*/ ,
                "kind": "ScalarField",
                "name": "attachmentStorageUsed"
            },
            {
                "args": v22 /*: any*/ ,
                "kind": "ScalarField",
                "name": "attachmentStorageIsUnlimited"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "id"
    }, v25 = {
        "args": v13 /*: any*/ ,
        "concreteType": "JiraProjectConnection",
        "kind": "LinkedField",
        "name": "allJiraProjects",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "args": v14 /*: any*/ ,
                                "concreteType": "JiraAssignableUsersConnection",
                                "kind": "LinkedField",
                                "name": "assignableUsers",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraAssignableUsersEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v7 /*: any*/ ,
                                                    v15 /*: any*/ ,
                                                    v16 /*: any*/ ,
                                                    v24 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "assignableUsers(first:10)"
                            },
                            v24 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "freeToStandardModalQuery",
            "selections": [
                v8 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isServiceCollectionFree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "jsm_storage",
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        v23 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "freeToStandardModalQuery",
            "selections": [
                v8 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isServiceCollectionFree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "jsm_storage",
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        },
                        v23 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "dbbbd84f1e38e47200ac4addeca6edb56946e326bc82cb145b26a2204085a797",
            "metadata": {},
            "name": "freeToStandardModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a5d2093368d3a282$var$node.hash = "786e3468aaf86e6cd22477f3aba584d3";
(0, $7LcWi.PreloadableQueryRegistry).set($a5d2093368d3a282$var$node.params.id, $a5d2093368d3a282$var$node);
var $a5d2093368d3a282$export$2e2bcd8739ae039 = $a5d2093368d3a282$var$node;

});

parcelRegister("gdJeO", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("gX5ut").then(()=>parcelRequire('fRad5'));

});



parcelRegister("3pPxF", function(module, exports) {
$parcel$export(module.exports, "PaidToTwcModal", () => $4661806ce36e62b2$export$34ac5fd024a301b8);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $oAzkD = parcelRequire("oAzkD");

var $eOaYv = parcelRequire("eOaYv");

var $aJ73T = parcelRequire("aJ73T");

var $5TEkX = parcelRequire("5TEkX");

var $aZnMm = parcelRequire("aZnMm");
function $4661806ce36e62b2$export$34ac5fd024a301b8() {
    const { formatMessage: formatMessage } = (0, $oAzkD.default)();
    const { cloudId: cloudId, entitlementId: entitlementId } = (0, $eOaYv.useEditionAwareness)();
    const entryPointParams = (0, $fsvuC.useMemo)(()=>({
            context: entitlementId ? {
                tenantId: cloudId,
                useCase: 'bundleableEntitlements',
                custom: {
                    entitlementIds: [
                        entitlementId
                    ]
                }
            } : null
        }), [
        cloudId,
        entitlementId
    ]);
    const modalProps = (0, $fsvuC.useMemo)(()=>({
            width: 968,
            height: '640px',
            shouldScrollInViewport: false,
            label: formatMessage({
                id: '@atlassian/edition-awareness.dialog.paid-to-twc.label',
                defaultMessage: 'Teamwork Collection plan comparison',
                description: 'Accessible name for the Teamwork Collection comparison dialog.'
            })
        }), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aJ73T.ModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $aZnMm.entryPoint),
        entryPointParams: entryPointParams,
        dialogConfig: (0, $5TEkX.DIALOG_CONFIG)
    });
}
$4661806ce36e62b2$export$34ac5fd024a301b8.displayName = "PaidToTwcModal";

});
parcelRegister("5TEkX", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $dbbb1a4bf173c7e9$export$3b6761b6086f6dfd);

var $1iBop = parcelRequire("1iBop");
const $dbbb1a4bf173c7e9$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'paid-to-twc-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1iBop.Edition).PREMIUM_EDITION
};

});

parcelRegister("aZnMm", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $9f9309c864a4e832$export$6333901e831d7af0);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

var $4RlOn = parcelRequire("4RlOn");

const $9f9309c864a4e832$export$6333901e831d7af0 = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("dvDV8")), {
        moduleId: "e6cb99b6",
        priority: "interaction",
        moduleId: 'edition-awareness-paid-to-twc-modal'
    }),
    getPreloadProps: ({ context: context })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                paidToTwcModalQuery: {
                    parameters: $4RlOn.default,
                    variables: {
                        context: context
                    }
                }
            }
        })
});

});
parcelRegister("4RlOn", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b434bbee5ae2ea7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4061c69c7fa1962d677d23e51835fd86>>
 * @relayHash 132ddd044de3c8e2223f3e2a9cdd814f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c213d4a4d7bf0a4f5ef630bb5f660cde7d71d3e828f5299807f911a299d8b4dc

var $7LcWi = parcelRequire("7LcWi");
const $6b434bbee5ae2ea7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "context",
            "variableName": "context"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "entityId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "paidToTwcModalQuery",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "paidToTwcModalQuery",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c213d4a4d7bf0a4f5ef630bb5f660cde7d71d3e828f5299807f911a299d8b4dc",
            "metadata": {},
            "name": "paidToTwcModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6b434bbee5ae2ea7$var$node.hash = "9ece934d5f0bc1ddbe2c2c9fa97ee3dd";
(0, $7LcWi.PreloadableQueryRegistry).set($6b434bbee5ae2ea7$var$node.params.id, $6b434bbee5ae2ea7$var$node);
var $6b434bbee5ae2ea7$export$2e2bcd8739ae039 = $6b434bbee5ae2ea7$var$node;

});

parcelRegister("dvDV8", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("gFCmZ").then(()=>parcelRequire('aNg3n'));

});



parcelRegister("i1i2R", function(module, exports) {
$parcel$export(module.exports, "PaymentDetailsPopup", () => $ce45dc3098d5953b$export$7d88b723086482e8);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $eOaYv = parcelRequire("eOaYv");

var $7rioG = parcelRequire("7rioG");

var $l1VOA = parcelRequire("l1VOA");

var $cb3RZ = parcelRequire("cb3RZ");
function $ce45dc3098d5953b$export$7d88b723086482e8() {
    const { edition: edition } = (0, $eOaYv.useEditionAwareness)();
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $7rioG.PopupEntryPoint), {
        entryPoint: (0, $cb3RZ.entryPoint),
        placement: 'bottom-end',
        dialogConfig: edition === 'standard' ? (0, $l1VOA.STANDARD_DIALOG_CONFIG) : (0, $l1VOA.PREMIUM_DIALOG_CONFIG)
    });
}
$ce45dc3098d5953b$export$7d88b723086482e8.displayName = "PaymentDetailsPopup";

});
parcelRegister("l1VOA", function(module, exports) {
$parcel$export(module.exports, "PREMIUM_DIALOG_CONFIG", () => $f18d0c5341225984$export$1a0ae553b5d69abc);
$parcel$export(module.exports, "STANDARD_DIALOG_CONFIG", () => $f18d0c5341225984$export$e42f11d536a45036);

var $1iBop = parcelRequire("1iBop");
const $f18d0c5341225984$export$1a0ae553b5d69abc = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'payment-details-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $1iBop.Edition).PREMIUM_EDITION
};
const $f18d0c5341225984$export$e42f11d536a45036 = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'payment-details-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $1iBop.Edition).STANDARD_EDITION
};

});

parcelRegister("cb3RZ", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $d5bb488ede07e658$export$6333901e831d7af0);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

const $d5bb488ede07e658$export$6333901e831d7af0 = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("5T69O")), {
        moduleId: "43cb1037",
        priority: "interaction",
        moduleId: 'edition-awareness-payment-details-popup'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});

});
parcelRegister("5T69O", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("k7dsr").then(()=>parcelRequire('6APKD'));

});



parcelRegister("d4Ntt", function(module, exports) {
$parcel$export(module.exports, "PlanSelectionPageModal", () => $d85f627e3451c452$export$d906ffa5ff65562d);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $oAzkD = parcelRequire("oAzkD");

var $llCao = parcelRequire("llCao");

var $eOaYv = parcelRequire("eOaYv");

var $lUy4V = parcelRequire("lUy4V");

var $aJ73T = parcelRequire("aJ73T");

var $4YqTf = parcelRequire("4YqTf");

var $6MeqM = parcelRequire("6MeqM");
const $d85f627e3451c452$var$TWC_MODAL_CONFIG_DEFAULT = {
    width: '1116px',
    height: '733px'
};
const $d85f627e3451c452$var$REVERSE_TRIAL_MODAL_CONFIG = {
    width: '968px',
    height: '740px'
};
const $d85f627e3451c452$export$bffe4b53a0bc4bce = {
    width: '968px',
    height: '784px'
};
const $d85f627e3451c452$var$getModalConfig = (type, isShowingContactSalesMessage)=>{
    if (type === 'reverse-trial') return isShowingContactSalesMessage ? $d85f627e3451c452$export$bffe4b53a0bc4bce : $d85f627e3451c452$var$REVERSE_TRIAL_MODAL_CONFIG;
    return $d85f627e3451c452$var$TWC_MODAL_CONFIG_DEFAULT;
};
function $d85f627e3451c452$export$d906ffa5ff65562d({ type: type }) {
    const { cloudId: cloudId, product: product, userId: userId } = (0, $eOaYv.useEditionAwareness)();
    const { formatMessage: formatMessage } = (0, $oAzkD.default)();
    const shouldCheckContactSalesEligibility = type === 'reverse-trial' && Boolean(userId) && (0, $llCao.fg)('twcg-1533-pls-contact-path-disco-gate');
    // The cohort that decides whether the contact sales footer renders is only known
    // inside the dialog, so it reports back up here. The ref holds the latched value for
    // the `modalProps` getters below; the state exists purely to re-render the open
    // dialog so those getters are read again.
    const isShowingContactSalesMessageRef = (0, $fsvuC.useRef)(false);
    const [, setIsShowingContactSalesMessage] = (0, $fsvuC.useState)(false);
    const onContactSalesMessageVisibilityChange = (0, $fsvuC.useCallback)((isVisible)=>{
        isShowingContactSalesMessageRef.current = isVisible;
        setIsShowingContactSalesMessage(isVisible);
    }, []);
    // Reopening the dialog should start at the base height, until the cohort resolves again
    const onClose = (0, $fsvuC.useCallback)(()=>onContactSalesMessageVisibilityChange(false), [
        onContactSalesMessageVisibilityChange
    ]);
    const entryPointParams = (0, $fsvuC.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $lUy4V.getHamsKey)(product),
            shouldCheckContactSalesEligibility: shouldCheckContactSalesEligibility,
            userId: userId
        }), [
        cloudId,
        product,
        shouldCheckContactSalesEligibility,
        userId
    ]);
    const entryPointProps = (0, $fsvuC.useMemo)(()=>({
            onClose: onClose,
            onContactSalesMessageVisibilityChange: onContactSalesMessageVisibilityChange,
            type: type
        }), [
        onClose,
        onContactSalesMessageVisibilityChange,
        type
    ]);
    // `ModalTrigger` captures this object when the dialog opens, so it has to stay stable
    // while the contact sales cohort resolves. The latched visibility is read back through
    // getters instead.
    const modalProps = (0, $fsvuC.useMemo)(()=>{
        const label = formatMessage({
            id: '@atlassian/edition-awareness.dialog.plan-selection-page.title',
            defaultMessage: 'Plan selection',
            description: 'Accessible name for the plan selection dialog, announced to assistive technology users.'
        });
        const config = ()=>$d85f627e3451c452$var$getModalConfig(type, shouldCheckContactSalesEligibility && isShowingContactSalesMessageRef.current);
        return {
            get width () {
                return config().width;
            },
            get height () {
                return config().height;
            },
            shouldScrollInViewport: false,
            shouldCloseOnEscape: true,
            label: label
        };
    }, [
        type,
        shouldCheckContactSalesEligibility,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aJ73T.ModalEntryPoint), {
        entryPointProps: entryPointProps,
        entryPoint: (0, $6MeqM.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $4YqTf.DIALOG_CONFIG)
    });
}
$d85f627e3451c452$export$d906ffa5ff65562d.displayName = "PlanSelectionPageModal";

});
parcelRegister("4YqTf", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $6414af3f08ffe74f$export$3b6761b6086f6dfd);

var $1iBop = parcelRequire("1iBop");
const $6414af3f08ffe74f$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'plan-selection-page-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1iBop.Edition).SELECTION
};

});

parcelRegister("6MeqM", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $02e30362bb9d302a$export$6333901e831d7af0);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

var $41Yjy = parcelRequire("41Yjy");

const $02e30362bb9d302a$export$6333901e831d7af0 = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("4jRDS")), {
        moduleId: "d069ac51",
        priority: "interaction",
        moduleId: 'edition-awareness-plan-selection-page-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey, shouldCheckContactSalesEligibility: shouldCheckContactSalesEligibility = false, userId: userId })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                planSelectionPageModalQuery: {
                    parameters: $41Yjy.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey,
                        shouldCheckContactSalesEligibility: shouldCheckContactSalesEligibility,
                        // The GUPS fields are skipped when eligibility isn't being checked, so the
                        // required $userId variable is satisfied with a placeholder
                        userId: userId ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("41Yjy", function(module, exports) {
$parcel$export(module.exports, "default", () => $742ec27cd393e925$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<23e3824d7380525e4bf2de8f990b0609>>
 * @relayHash 5d45817bea569e257955f7f1726793ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e8a101025c04e12a0cba019e488aa09185a5765af05c3b63427effb6b4a793d4

var $7LcWi = parcelRequire("7LcWi");
const $742ec27cd393e925$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckContactSalesEligibility"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    }, v4 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v8 = {
        "condition": "shouldCheckContactSalesEligibility",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "accountId",
                        "variableName": "userId"
                    }
                ],
                "concreteType": "GrowthUnifiedProfileAccountProfileResult",
                "kind": "LinkedField",
                "name": "growthUnifiedProfile_getAccountProfile",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GrowthUnifiedProfileAccountCompanyRecord",
                        "kind": "LinkedField",
                        "name": "companyProfile",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "accountSegment"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "domainType"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "planSelectionPageModalQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v8 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "planSelectionPageModalQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v8 /*: any*/ 
            ]
        },
        "params": {
            "id": "e8a101025c04e12a0cba019e488aa09185a5765af05c3b63427effb6b4a793d4",
            "metadata": {},
            "name": "planSelectionPageModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$742ec27cd393e925$var$node.hash = "69a5c01479dc12c3d1726239102a04fd";
(0, $7LcWi.PreloadableQueryRegistry).set($742ec27cd393e925$var$node.params.id, $742ec27cd393e925$var$node);
var $742ec27cd393e925$export$2e2bcd8739ae039 = $742ec27cd393e925$var$node;

});

parcelRegister("4jRDS", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("gg3z4").then(()=>parcelRequire('84S3B'));

});



parcelRegister("b3tXy", function(module, exports) {
$parcel$export(module.exports, "PremiumAddPaymentModal", () => $2ffd73a0c32ff650$export$45cd24e1ba5c2588);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $aJ73T = parcelRequire("aJ73T");

var $9mcRc = parcelRequire("9mcRc");

var $1XqQu = parcelRequire("1XqQu");
function $2ffd73a0c32ff650$export$45cd24e1ba5c2588() {
    const modalProps = (0, $fsvuC.useMemo)(()=>({
            width: 968,
            height: 576
        }), []);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aJ73T.ModalEntryPoint), {
        entryPoint: (0, $1XqQu.entryPoint),
        modalProps: modalProps,
        dialogConfig: (0, $9mcRc.DIALOG_CONFIG)
    });
}
$2ffd73a0c32ff650$export$45cd24e1ba5c2588.displayName = "PremiumAddPaymentModal";

});
parcelRegister("9mcRc", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $25d37f2bd0732094$export$3b6761b6086f6dfd);

var $1iBop = parcelRequire("1iBop");
const $25d37f2bd0732094$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'premium-add-payment-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1iBop.Edition).PREMIUM_EDITION
};

});

parcelRegister("1XqQu", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $7e25ec31f839190a$export$6333901e831d7af0);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

const $7e25ec31f839190a$export$6333901e831d7af0 = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("feBGS")), {
        moduleId: "f32031a2",
        priority: "interaction",
        moduleId: 'edition-awareness-premium-add-payment-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});

});
parcelRegister("feBGS", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("ezXC3").then(()=>parcelRequire('56a0M'));

});



parcelRegister("bfeRu", function(module, exports) {
$parcel$export(module.exports, "PremiumPopup", () => $abf83b2e9c571938$export$831a974b36144ba6);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $eOaYv = parcelRequire("eOaYv");

var $lUy4V = parcelRequire("lUy4V");

var $7rioG = parcelRequire("7rioG");

var $ap9Tq = parcelRequire("ap9Tq");

var $kgnPE = parcelRequire("kgnPE");

var $8SpUv = parcelRequire("8SpUv");
const $abf83b2e9c571938$export$831a974b36144ba6 = ()=>{
    const { cloudId: cloudId, product: product, PremiumWrapper: PremiumWrapper, trialDaysLeft: trialDaysLeft, userRoles: userRoles, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen, isInTrial: isInTrial, isInReverseTrial: isInReverseTrial } = (0, $eOaYv.useEditionAwareness)();
    const [isPremiumModalOpen, setIsPremiumModalOpen] = (0, $fsvuC.useState)(false);
    const handleClosePremiumModal = (0, $fsvuC.useCallback)(()=>setIsPremiumModalOpen(false), []);
    const handleOpenPremiumModal = (0, $fsvuC.useCallback)(()=>setIsPremiumModalOpen(true), []);
    const entryPointParams = (0, $fsvuC.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $lUy4V.getHamsKey)(product)
        }), [
        product,
        cloudId
    ]);
    const entryPointProps = (0, $fsvuC.useMemo)(()=>({
            handleOpenPremiumModal: handleOpenPremiumModal,
            onClose: handleClosePremiumModal
        }), [
        handleOpenPremiumModal,
        handleClosePremiumModal
    ]);
    const onClose = (0, $fsvuC.useCallback)(()=>{
        // This will reset the auto open state from product
        onAutoOpen?.();
    }, [
        onAutoOpen
    ]);
    if (!PremiumWrapper) // Shouldn't happen, but if it does then we can at least still show the customer a dialog
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: shouldAutoOpen ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $ap9Tq.AutoOpenPopupTrigger), {
            entryPoint: (0, $8SpUv.entryPoint),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            placement: 'bottom-end',
            onClose: onClose,
            dialogConfig: (0, $kgnPE.DIALOG_CONFIG)
        }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $7rioG.PopupEntryPoint), {
            entryPoint: (0, $8SpUv.entryPoint),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            placement: 'bottom-end',
            onClose: onClose,
            dialogConfig: (0, $kgnPE.DIALOG_CONFIG)
        })
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: /*#__PURE__*/ (0, $5chsV.jsx)(PremiumWrapper, {
            isInTrial: Boolean(isInTrial),
            isInReverseTrial: Boolean(isInReverseTrial),
            trialDaysLeft: trialDaysLeft,
            isSiteAdmin: !!userRoles?.includes('SITE_ADMIN'),
            isPremiumModalOpen: isPremiumModalOpen,
            onClosePremiumModal: handleClosePremiumModal,
            children: shouldAutoOpen ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $ap9Tq.AutoOpenPopupTrigger), {
                entryPoint: (0, $8SpUv.entryPoint),
                entryPointParams: entryPointParams,
                entryPointProps: entryPointProps,
                placement: 'bottom-end',
                onClose: onClose,
                dialogConfig: (0, $kgnPE.DIALOG_CONFIG)
            }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $7rioG.PopupEntryPoint), {
                entryPoint: (0, $8SpUv.entryPoint),
                entryPointParams: entryPointParams,
                entryPointProps: entryPointProps,
                placement: 'bottom-end',
                onClose: onClose,
                dialogConfig: (0, $kgnPE.DIALOG_CONFIG)
            })
        })
    });
};
$abf83b2e9c571938$export$831a974b36144ba6.displayName = "PremiumPopup";

});
parcelRegister("ap9Tq", function(module, exports) {
$parcel$export(module.exports, "AutoOpenPopupTrigger", () => $e076ce81b09bd07a$export$6189e5bf9171fa04);
/* AutoOpenPopupTrigger.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $iNT4o = parcelRequire("iNT4o");

var $9sl8X = parcelRequire("9sl8X");

var $RG5NG = parcelRequire("RG5NG");

var $jRYjy = parcelRequire("jRYjy");

var $9cT91 = parcelRequire("9cT91");

var $gWXcM = parcelRequire("gWXcM");

var $Wd0FJ = parcelRequire("Wd0FJ");

var $ezp5D = parcelRequire("ezp5D");

var $8iLmE = parcelRequire("8iLmE");

var $hD4W1 = parcelRequire("hD4W1");
const $e076ce81b09bd07a$var$styles = {
    fallbackBox: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
};
const $e076ce81b09bd07a$var$emptyEntryPointParams = {};
const $e076ce81b09bd07a$var$emptyEntryPointProps = {};
function $e076ce81b09bd07a$export$6189e5bf9171fa04(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $9sl8X.default), {
        data: dialogConfig,
        children: /*#__PURE__*/ (0, $5chsV.jsx)($e076ce81b09bd07a$var$AutoOpenPopupTriggerInner, {
            ...rest
        })
    });
}
$e076ce81b09bd07a$export$6189e5bf9171fa04.displayName = "AutoOpenPopupTrigger";
/**
 * THIS IS A TEMPORARY IMPLEMENTATION, WILL BE REMOVED IN THE FUTURE
 * NOT RECOMMENDED FOR USE ANYWHERE ELSE
 * Supports the auto-open functionality for the Confluence Premium Popup
 */ function $e076ce81b09bd07a$var$AutoOpenPopupTriggerInner({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorFallback: errorFallback, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $Wd0FJ.useRelayEnvironmentProvider)();
    const onError = (0, $ezp5D.useEntrypointErrorAnalytics)();
    const onDismiss = (0, $8iLmE.useOnCloseDialog)();
    const id = (0, $fsvuC.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $fsvuC.useState)(false);
    const [content, setContent] = (0, $fsvuC.useState)(null);
    const handleOpen = (0, $fsvuC.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0, $fsvuC.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event, currentLevel);
        onDismiss();
    }, [
        onClose,
        onDismiss
    ]);
    const load = (0, $fsvuC.useCallback)(()=>(0, $iNT4o.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $e076ce81b09bd07a$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $fsvuC.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        handleOpen();
        setContent(/*#__PURE__*/ (0, $5chsV.jsx)((0, $gWXcM.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: /*#__PURE__*/ (0, $5chsV.jsx)($e076ce81b09bd07a$var$PopupFallback, {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $e076ce81b09bd07a$var$emptyEntryPointProps,
            onError: onError
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        errorFallback,
        handleOpen,
        onError
    ]);
    const handleToggleAndLoad = (0, $fsvuC.useCallback)(()=>{
        if (isOpen) {
            handleClose(null);
            return;
        }
        handleOpen();
        onLoad({
            reference: load()
        });
    }, [
        isOpen,
        handleOpen,
        onLoad,
        load,
        handleClose
    ]);
    const popupTrigger = (0, $fsvuC.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hD4W1.EditionAwarenessButton), {
            ...triggerProps,
            ref: triggerProps.ref,
            onClick: handleToggleAndLoad
        });
    }, [
        handleToggleAndLoad
    ]);
    const popupContent = (0, $fsvuC.useCallback)(()=>{
        return content;
    }, [
        content
    ]);
    const hasRun = (0, $fsvuC.useRef)(false);
    // Auto-open on load
    (0, $fsvuC.useEffect)(()=>{
        if (!hasRun.current) {
            handleToggleAndLoad?.();
            hasRun.current = true;
        }
    }, [
        handleToggleAndLoad
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $RG5NG.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent,
        shouldFitContainer: false
    });
}
$e076ce81b09bd07a$var$AutoOpenPopupTriggerInner.displayName = "AutoOpenPopupTriggerInner";
const $e076ce81b09bd07a$var$PopupFallback = ()=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
        xcss: $e076ce81b09bd07a$var$styles.fallbackBox,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $9cT91.default), {})
    });
$e076ce81b09bd07a$var$PopupFallback.displayName = "PopupFallback";

});

parcelRegister("kgnPE", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $f9e1b7c34c5d9ac9$export$3b6761b6086f6dfd);

var $1iBop = parcelRequire("1iBop");
const $f9e1b7c34c5d9ac9$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'premium-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $1iBop.Edition).PREMIUM_EDITION
};

});

parcelRegister("8SpUv", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $d3fa3a6c716dc79c$export$6333901e831d7af0);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

var $juKnv = parcelRequire("juKnv");

const $d3fa3a6c716dc79c$export$6333901e831d7af0 = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("jMHrj")), {
        moduleId: "d68a8af6",
        priority: "interaction",
        moduleId: 'edition-awareness-premium-popup'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                confluencePremiumPopupQuery: {
                    parameters: $juKnv.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("juKnv", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a452d63647ecd71$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e8351006f5eb2eddc21a94e6eaea4bad>>
 * @relayHash f5958739e09e5411147f112f6550ea59
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 477817a92613a7818d8c6b7b9c49bbc1517b2ca7a3bc41a318aaf8920c59e4c7

var $7LcWi = parcelRequire("7LcWi");
const $7a452d63647ecd71$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "confluencePremiumPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "confluencePremiumPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "477817a92613a7818d8c6b7b9c49bbc1517b2ca7a3bc41a318aaf8920c59e4c7",
            "metadata": {},
            "name": "confluencePremiumPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7a452d63647ecd71$var$node.hash = "42c226cd7fc904c05729c90bcaaed23e";
(0, $7LcWi.PreloadableQueryRegistry).set($7a452d63647ecd71$var$node.params.id, $7a452d63647ecd71$var$node);
var $7a452d63647ecd71$export$2e2bcd8739ae039 = $7a452d63647ecd71$var$node;

});

parcelRegister("jMHrj", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("fENEW").then(()=>parcelRequire('6N0rV'));

});



parcelRegister("hhEZh", function(module, exports) {
$parcel$export(module.exports, "ReverseTrialPopupDialog", () => $c97a2b2e70522726$export$436172fa0e71e289);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $eOaYv = parcelRequire("eOaYv");

var $lUy4V = parcelRequire("lUy4V");

var $7rioG = parcelRequire("7rioG");

var $dic6P = parcelRequire("dic6P");

var $kAFYs = parcelRequire("kAFYs");
function $c97a2b2e70522726$export$436172fa0e71e289() {
    const { product: product, cloudId: cloudId } = (0, $eOaYv.useEditionAwareness)();
    const entryPointParams = (0, $fsvuC.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $lUy4V.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $7rioG.PopupEntryPoint), {
        entryPoint: (0, $kAFYs.entryPoint),
        entryPointParams: entryPointParams,
        placement: 'bottom-end',
        dialogConfig: (0, $dic6P.DIALOG_CONFIG)
    });
}
$c97a2b2e70522726$export$436172fa0e71e289.displayName = "ReverseTrialPopupDialog";

});
parcelRegister("dic6P", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $ddfa9ad8d8d9ee9c$export$3b6761b6086f6dfd);

var $1iBop = parcelRequire("1iBop");
const $ddfa9ad8d8d9ee9c$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'reverse-trial-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $1iBop.Edition).PREMIUM_EDITION
};

});

parcelRegister("kAFYs", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $e452d040dfd96f07$export$6333901e831d7af0);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

var $a7Ns9 = parcelRequire("a7Ns9");

const $e452d040dfd96f07$export$6333901e831d7af0 = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("b5g01")), {
        moduleId: "38aee5f9",
        priority: "interaction",
        moduleId: 'edition-awareness-reverse-trial-popup'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                reverseTrialPopupQuery: {
                    parameters: $a7Ns9.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("a7Ns9", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3eaef45cd8b9eee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<282e84a59ad31677adfafd111cd33ab9>>
 * @relayHash fb387ee4c17d62b6ce4867baf6061884
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe23b73929c26e3fa0b23fad14fc6c713c94abcd8a87983ce3d62e052dbade3b

var $7LcWi = parcelRequire("7LcWi");
const $d3eaef45cd8b9eee$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Free"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "reverseTrialPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Free\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "reverseTrialPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Free\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fe23b73929c26e3fa0b23fad14fc6c713c94abcd8a87983ce3d62e052dbade3b",
            "metadata": {},
            "name": "reverseTrialPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d3eaef45cd8b9eee$var$node.hash = "7149df0cbb7841476e95591ab561c360";
(0, $7LcWi.PreloadableQueryRegistry).set($d3eaef45cd8b9eee$var$node.params.id, $d3eaef45cd8b9eee$var$node);
var $d3eaef45cd8b9eee$export$2e2bcd8739ae039 = $d3eaef45cd8b9eee$var$node;

});

parcelRegister("b5g01", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("j86xC").then(()=>parcelRequire('jENzF'));

});



parcelRegister("iy8CK", function(module, exports) {
$parcel$export(module.exports, "StandardAddPaymentModal", () => $3d896f954dc7ef79$export$e7d982549be9547c);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $eOaYv = parcelRequire("eOaYv");

var $lJkk5 = parcelRequire("lJkk5");

var $lFWLU = parcelRequire("lFWLU");

var $eSLCP = parcelRequire("eSLCP");

var $lUy4V = parcelRequire("lUy4V");

var $aJ73T = parcelRequire("aJ73T");

var $foLtK = parcelRequire("foLtK");

var $k0q7j = parcelRequire("k0q7j");
function $3d896f954dc7ef79$export$e7d982549be9547c() {
    const { product: product, cloudId: cloudId } = (0, $eOaYv.useEditionAwareness)();
    const projectType = (0, $eSLCP.getJiraProjectTypeKey)(product);
    const jiraApplicationKey = (0, $lFWLU.getJiraApplicationKey)(product);
    const entryPointParams = (0, $fsvuC.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $lUy4V.getHamsKey)(product),
            chargeElement: (0, $lJkk5.getChargeElementKey)(product),
            // Fallback to any valid value since this means that we're not using jira
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            // Fallback to any valid value since this means that we're not using jira
            projectType: projectType ?? 'SOFTWARE',
            isJira: product === 'jira' || product === 'jira-product-discovery' || product === 'jira-service-management',
            isConfluence: product === 'confluence'
        }), [
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const modalProps = (0, $fsvuC.useMemo)(()=>{
        if (product === 'confluence') return {
            width: 1000,
            height: 600
        };
        return {
            width: 968,
            height: 576
        };
    }, [
        product
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aJ73T.ModalEntryPoint), {
        entryPoint: (0, $k0q7j.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $foLtK.DIALOG_CONFIG)
    });
}
$3d896f954dc7ef79$export$e7d982549be9547c.displayName = "StandardAddPaymentModal";

});
parcelRegister("foLtK", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $0c2428306326354d$export$3b6761b6086f6dfd);

var $1iBop = parcelRequire("1iBop");
const $0c2428306326354d$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'standard-add-payment-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1iBop.Edition).STANDARD_EDITION
};

});

parcelRegister("k0q7j", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $164a148121bca2b6$export$6333901e831d7af0);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

var $aC7j2 = parcelRequire("aC7j2");

const $164a148121bca2b6$export$6333901e831d7af0 = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("2hv2H")), {
        moduleId: "8a2449b3",
        priority: "interaction",
        moduleId: 'edition-awareness-standard-add-payment-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey, projectType: projectType, chargeElement: chargeElement, jiraApplicationKey: jiraApplicationKey, isJira: isJira, isConfluence: isConfluence })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                standardAddPaymentModalQuery: {
                    parameters: $aC7j2.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey,
                        chargeElement: chargeElement,
                        projectType: projectType,
                        jiraApplicationKey: jiraApplicationKey,
                        isJira: isJira,
                        isConfluence: isConfluence
                    }
                }
            }
        })
});

});
parcelRegister("aC7j2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e6196492b9d4279$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d282a5123f245865e33224a46f1392ca>>
 * @relayHash 081ae02dbc9e7d3009e7fbdca4492722
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7e0de08a75b889e79cd9fefc7277283b171871d0347b99f590cc073558ab0ab9

var $7LcWi = parcelRequire("7LcWi");
const $5e6196492b9d4279$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfluence"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJira"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraApplicationKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v7 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v9 = {
        "args": [
            {
                "kind": "Variable",
                "name": "chargeElement",
                "variableName": "chargeElement"
            }
        ],
        "kind": "ScalarField",
        "name": "latestUsageForChargeElement"
    }, v10 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "condition": "isConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v10 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "cql",
                        "value": "type=user"
                    },
                    {
                        "kind": "Literal",
                        "name": "excludeServiceAppUsers",
                        "value": true
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "confluence_searchUser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponse",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluencePerson",
                                "kind": "LinkedField",
                                "name": "confluencePerson",
                                "plural": false,
                                "selections": [
                                    v11 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    {
                                        "concreteType": "Icon",
                                        "kind": "LinkedField",
                                        "name": "profilePicture",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "path"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isUnlimited"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesLimit"
                    }
                ]
            }
        ]
    }, v13 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v10 /*: any*/ 
    ], v14 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageAllowed"
    }, v15 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageUsed"
    }, v16 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageIsUnlimited"
    }, v17 = [
        v10 /*: any*/ ,
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v18 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v22 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "standardAddPaymentModalQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v18 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "standardAddPaymentModalQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v18 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v22 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7e0de08a75b889e79cd9fefc7277283b171871d0347b99f590cc073558ab0ab9",
            "metadata": {},
            "name": "standardAddPaymentModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5e6196492b9d4279$var$node.hash = "1a2deb9f2ae9b251077ad9a1cce4e589";
(0, $7LcWi.PreloadableQueryRegistry).set($5e6196492b9d4279$var$node.params.id, $5e6196492b9d4279$var$node);
var $5e6196492b9d4279$export$2e2bcd8739ae039 = $5e6196492b9d4279$var$node;

});

parcelRegister("2hv2H", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("ie3RL").then(()=>parcelRequire('ko6nL'));

});



parcelRegister("hBN2X", function(module, exports) {
$parcel$export(module.exports, "StandardStorageHardLimitModal", () => $682120ad10377ed7$export$9f8df4ccbd43f791);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $eOaYv = parcelRequire("eOaYv");

var $lUy4V = parcelRequire("lUy4V");

var $aJ73T = parcelRequire("aJ73T");

var $2BSQN = parcelRequire("2BSQN");

var $28Raf = parcelRequire("28Raf");
function $682120ad10377ed7$export$9f8df4ccbd43f791() {
    const { cloudId: cloudId, product: product } = (0, $eOaYv.useEditionAwareness)();
    const entryPointParams = (0, $fsvuC.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $lUy4V.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const modalProps = (0, $fsvuC.useMemo)(()=>({
            width: 968,
            height: 560
        }), []);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aJ73T.ModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $28Raf.default),
        entryPointParams: entryPointParams,
        dialogConfig: (0, $2BSQN.DIALOG_CONFIG)
    });
}
$682120ad10377ed7$export$9f8df4ccbd43f791.displayName = "StandardStorageHardLimitModal";

});
parcelRegister("2BSQN", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $f735b2893110d279$export$3b6761b6086f6dfd);

var $1iBop = parcelRequire("1iBop");
const $f735b2893110d279$export$3b6761b6086f6dfd = {
    // The primary CTA starts a Premium trial, which also makes useOnClickPrimaryCta close the dialog
    touchpointIntent: 'startTrial',
    dialogId: 'standard-storage-hard-limit-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1iBop.Edition).PREMIUM_EDITION
};

});

parcelRegister("28Raf", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbcc60a0c0d35ee4$export$2e2bcd8739ae039);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

var $3Fou1 = parcelRequire("3Fou1");

const $dbcc60a0c0d35ee4$var$standardStorageHardLimitEntryPoint = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("ghdDN")), {
        moduleId: "f5370f8b",
        priority: "interaction",
        moduleId: 'edition-awareness-standard-storage-hard-limit-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                standardStorageHardLimitModalQuery: {
                    parameters: $3Fou1.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});
var $dbcc60a0c0d35ee4$export$2e2bcd8739ae039 = $dbcc60a0c0d35ee4$var$standardStorageHardLimitEntryPoint;

});
parcelRegister("3Fou1", function(module, exports) {
$parcel$export(module.exports, "default", () => $726e675a0de85e31$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2f66d99c957d42a98f3c67163506a839>>
 * @relayHash 9f7ff8f4a3c79a02cc7cc5b69bbcafb1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b1e397e03055cd7074d0373480676b9b55f9aa9177f9abfa52ae525c9fa46c3b

var $7LcWi = parcelRequire("7LcWi");
const $726e675a0de85e31$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jiraStorageUpgradeAdminRequestLastRequestedAt"
                    }
                ]
            }
        ]
    }, v2 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "standardStorageHardLimitModalQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "changeOfferingV2ToPremium",
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "standardStorageHardLimitModalQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "alias": "changeOfferingV2ToPremium",
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b1e397e03055cd7074d0373480676b9b55f9aa9177f9abfa52ae525c9fa46c3b",
            "metadata": {},
            "name": "standardStorageHardLimitModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$726e675a0de85e31$var$node.hash = "d10346218ebbf1d7887259e54132bff9";
(0, $7LcWi.PreloadableQueryRegistry).set($726e675a0de85e31$var$node.params.id, $726e675a0de85e31$var$node);
var $726e675a0de85e31$export$2e2bcd8739ae039 = $726e675a0de85e31$var$node;

});

parcelRegister("ghdDN", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("h1pag").then(()=>parcelRequire('7HLeE'));

});



parcelRegister("hM1Vl", function(module, exports) {
$parcel$export(module.exports, "StandardToPremiumIncentiveOfferModal", () => $caddfb868327047f$export$a6caa33e3f6accbe);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $eOaYv = parcelRequire("eOaYv");

var $lUy4V = parcelRequire("lUy4V");

var $aJ73T = parcelRequire("aJ73T");

var $jBckE = parcelRequire("jBckE");

var $ai5ud = parcelRequire("ai5ud");
function $caddfb868327047f$export$a6caa33e3f6accbe() {
    const { cloudId: cloudId, product: product } = (0, $eOaYv.useEditionAwareness)();
    const entryPointParams = (0, $fsvuC.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $lUy4V.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const modalProps = (0, $fsvuC.useMemo)(()=>({
            width: 968
        }), []);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aJ73T.ModalEntryPoint), {
        entryPoint: (0, $ai5ud.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $jBckE.DIALOG_CONFIG)
    });
}
$caddfb868327047f$export$a6caa33e3f6accbe.displayName = "StandardToPremiumIncentiveOfferModal";

});
parcelRegister("jBckE", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $052b3c74235715d0$export$3b6761b6086f6dfd);

var $1iBop = parcelRequire("1iBop");
const $052b3c74235715d0$export$3b6761b6086f6dfd = {
    touchpointIntent: 'changePlan',
    dialogId: 'standard-to-premium-incentive-offer-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1iBop.Edition).PREMIUM_EDITION
};

});

parcelRegister("ai5ud", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $14eb2e3da8baa9cd$export$6333901e831d7af0);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

var $kSRcz = parcelRequire("kSRcz");

const $14eb2e3da8baa9cd$export$6333901e831d7af0 = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("2omAF")), {
        moduleId: "ed0ed43f",
        priority: "interaction",
        moduleId: 'edition-awareness-standard-to-premium-incentive-offer-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                standardToPremiumIncentiveOfferModalQuery: {
                    parameters: $kSRcz.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("kSRcz", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd7dd1131d6ba0ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39b382984f2d4352df9ba02cd71d9a49>>
 * @relayHash 5e6fa2170de372f4d9efbff91d33100f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b13b6702ea7d67f0d6a4d52e2462f2ced7974990d382fb13b56347cb9a201d7f

var $7LcWi = parcelRequire("7LcWi");
const $cd7dd1131d6ba0ab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "key"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "standardToPremiumIncentiveOfferModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CcpTransactionAccount",
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "standardToPremiumIncentiveOfferModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CcpTransactionAccount",
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b13b6702ea7d67f0d6a4d52e2462f2ced7974990d382fb13b56347cb9a201d7f",
            "metadata": {},
            "name": "standardToPremiumIncentiveOfferModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cd7dd1131d6ba0ab$var$node.hash = "059b4a5e58671e759c1e566b0a6fe8f1";
(0, $7LcWi.PreloadableQueryRegistry).set($cd7dd1131d6ba0ab$var$node.params.id, $cd7dd1131d6ba0ab$var$node);
var $cd7dd1131d6ba0ab$export$2e2bcd8739ae039 = $cd7dd1131d6ba0ab$var$node;

});

parcelRegister("2omAF", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("01szM").then(()=>parcelRequire('gavBe'));

});



parcelRegister("ckNWz", function(module, exports) {
$parcel$export(module.exports, "StandardToPremiumModal", () => $505025060ce77aaa$export$a74acc125b20e3e5);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $eOaYv = parcelRequire("eOaYv");

var $lUy4V = parcelRequire("lUy4V");

var $aJ73T = parcelRequire("aJ73T");

var $3ulpW = parcelRequire("3ulpW");

var $aBDww = parcelRequire("aBDww");
function $505025060ce77aaa$export$a74acc125b20e3e5() {
    const { product: product, cloudId: cloudId } = (0, $eOaYv.useEditionAwareness)();
    const entryPointParams = (0, $fsvuC.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $lUy4V.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const modalProps = (0, $fsvuC.useMemo)(()=>({
            width: 968
        }), []);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aJ73T.ModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $aBDww.entryPoint),
        entryPointParams: entryPointParams,
        dialogConfig: (0, $3ulpW.DIALOG_CONFIG)
    });
}
$505025060ce77aaa$export$a74acc125b20e3e5.displayName = "StandardToPremiumModal";

});
parcelRegister("3ulpW", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $7a4c3cf290fd9393$export$3b6761b6086f6dfd);

var $1iBop = parcelRequire("1iBop");
const $7a4c3cf290fd9393$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'standard-to-premium-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1iBop.Edition).PREMIUM_EDITION
};

});

parcelRegister("aBDww", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $576bbc21ce689cb9$export$6333901e831d7af0);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

var $j2RvA = parcelRequire("j2RvA");

const $576bbc21ce689cb9$export$6333901e831d7af0 = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("52QKv")), {
        moduleId: "9dc17d8c",
        priority: "interaction",
        moduleId: 'edition-awareness-standard-to-premium-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                standardToPremiumModalQuery: {
                    parameters: $j2RvA.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("j2RvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b56b6058ad66a928$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a6c771fee38300541a757cfb707782a9>>
 * @relayHash 14295077f5d16de593a74a9bdeabaee5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d56c908b8e278ee6e857c36b91b873af24d7196aed0e8a685abe732a6aeb20c

var $7LcWi = parcelRequire("7LcWi");
const $b56b6058ad66a928$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        v3 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isAvailableToUser"
        },
        {
            "kind": "ScalarField",
            "name": "experienceUrl"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "standardToPremiumModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "standardToPremiumModalExperienceCapabilitiesFragment"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "standardToPremiumModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isCommerceEntitlementExperienceCapabilities"
                                                },
                                                {
                                                    "alias": "changeOfferingV2ToPremium",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "offeringName",
                                                            "value": "Premium"
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": v4 /*: any*/ ,
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                },
                                                {
                                                    "alias": "changeOfferingV2PlanSelectionPage",
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": v4 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5d56c908b8e278ee6e857c36b91b873af24d7196aed0e8a685abe732a6aeb20c",
            "metadata": {},
            "name": "standardToPremiumModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b56b6058ad66a928$var$node.hash = "c281b5a28fccec23292230fbed9949f2";
(0, $7LcWi.PreloadableQueryRegistry).set($b56b6058ad66a928$var$node.params.id, $b56b6058ad66a928$var$node);
var $b56b6058ad66a928$export$2e2bcd8739ae039 = $b56b6058ad66a928$var$node;

});

parcelRegister("52QKv", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("ko795").then(()=>parcelRequire('IVoIE'));

});



parcelRegister("8Ajct", function(module, exports) {
$parcel$export(module.exports, "StorageHardLimitModal", () => $4882085973ef80d9$export$d58ea28307440812);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $eOaYv = parcelRequire("eOaYv");

var $aJ73T = parcelRequire("aJ73T");

var $gGUV8 = parcelRequire("gGUV8");

var $24nW4 = parcelRequire("24nW4");
function $4882085973ef80d9$export$d58ea28307440812() {
    const { userId: userId } = (0, $eOaYv.useEditionAwareness)();
    const shouldCheckContactSalesEligibility = Boolean(userId) && (0, $llCao.fg)('twcg-1533-pls-contact-path-disco-gate');
    const entryPointParams = (0, $fsvuC.useMemo)(()=>({
            userId: userId,
            shouldCheckContactSalesEligibility: shouldCheckContactSalesEligibility
        }), [
        userId,
        shouldCheckContactSalesEligibility
    ]);
    const modalProps = (0, $fsvuC.useMemo)(()=>({
            width: 968,
            height: 520
        }), []);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aJ73T.ModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $24nW4.default),
        entryPointParams: entryPointParams,
        dialogConfig: (0, $gGUV8.DIALOG_CONFIG)
    });
}
$4882085973ef80d9$export$d58ea28307440812.displayName = "StorageHardLimitModal";

});
parcelRegister("gGUV8", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $33dfdd9ba18f5006$export$3b6761b6086f6dfd);

var $1iBop = parcelRequire("1iBop");
const $33dfdd9ba18f5006$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'storage-hard-limit-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1iBop.Edition).STANDARD_EDITION
};

});

parcelRegister("24nW4", function(module, exports) {
$parcel$export(module.exports, "default", () => $e992672aeed952a4$export$2e2bcd8739ae039);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

var $dsh43 = parcelRequire("dsh43");

const $e992672aeed952a4$var$storageHardLimitEntryPoint = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("8srmc")), {
        moduleId: "c613c169",
        priority: "interaction",
        moduleId: 'edition-awareness-storage-hard-limit-modal'
    }),
    getPreloadProps: ({ shouldCheckContactSalesEligibility: shouldCheckContactSalesEligibility = false, userId: userId })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                storageHardLimitModalQuery: {
                    parameters: $dsh43.default,
                    variables: {
                        shouldCheckContactSalesEligibility: shouldCheckContactSalesEligibility,
                        // The GUPS fields are skipped when eligibility isn't being checked, so the
                        // required $userId variable is satisfied with a placeholder
                        userId: userId ?? ''
                    }
                }
            }
        })
});
var $e992672aeed952a4$export$2e2bcd8739ae039 = $e992672aeed952a4$var$storageHardLimitEntryPoint;

});
parcelRegister("dsh43", function(module, exports) {
$parcel$export(module.exports, "default", () => $edcb36f2f13ec18f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2017533a94faaa3c86deb6bf60e73cf5>>
 * @relayHash c383562df6596a19a82df44992ef8ffc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bcb3ca553fad0779e2802de26960a7c8a85fa7e426acb9860c8bd5d5fca4994f

var $7LcWi = parcelRequire("7LcWi");
const $edcb36f2f13ec18f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckContactSalesEligibility"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    }, v2 = [
        {
            "condition": "shouldCheckContactSalesEligibility",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "accountId",
                            "variableName": "userId"
                        }
                    ],
                    "concreteType": "GrowthUnifiedProfileAccountProfileResult",
                    "kind": "LinkedField",
                    "name": "growthUnifiedProfile_getAccountProfile",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GrowthUnifiedProfileAccountCompanyRecord",
                            "kind": "LinkedField",
                            "name": "companyProfile",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountSegment"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "domainType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "storageHardLimitModalQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "storageHardLimitModalQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "bcb3ca553fad0779e2802de26960a7c8a85fa7e426acb9860c8bd5d5fca4994f",
            "metadata": {},
            "name": "storageHardLimitModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$edcb36f2f13ec18f$var$node.hash = "8cb34fd69c20cc328efa3bf57bc9a17d";
(0, $7LcWi.PreloadableQueryRegistry).set($edcb36f2f13ec18f$var$node.params.id, $edcb36f2f13ec18f$var$node);
var $edcb36f2f13ec18f$export$2e2bcd8739ae039 = $edcb36f2f13ec18f$var$node;

});

parcelRegister("8srmc", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("lpcNy").then(()=>parcelRequire('3c3nn'));

});



parcelRegister("cl6c5", function(module, exports) {
$parcel$export(module.exports, "UserLimitDirectBuyModal", () => $6ef94f54d8f5dc3b$export$c1c14068af2cd433);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $eOaYv = parcelRequire("eOaYv");

var $aJ73T = parcelRequire("aJ73T");

var $8bjak = parcelRequire("8bjak");

var $8C5iK = parcelRequire("8C5iK");
const $6ef94f54d8f5dc3b$var$modalProps = {
    width: 968,
    height: 560
};
function $6ef94f54d8f5dc3b$export$c1c14068af2cd433() {
    const { cloudId: cloudId } = (0, $eOaYv.useEditionAwareness)();
    const entryPointParams = (0, $fsvuC.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aJ73T.ModalEntryPoint), {
        entryPoint: (0, $8C5iK.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: $6ef94f54d8f5dc3b$var$modalProps,
        dialogConfig: (0, $8bjak.DIALOG_CONFIG)
    });
}
$6ef94f54d8f5dc3b$export$c1c14068af2cd433.displayName = "UserLimitDirectBuyModal";

});
parcelRegister("8bjak", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $350c1f4d1441c9b1$export$3b6761b6086f6dfd);

var $1iBop = parcelRequire("1iBop");
const $350c1f4d1441c9b1$export$3b6761b6086f6dfd = {
    dialogId: 'user-limit-direct-buy-modal',
    dialogType: 'modal',
    touchpointIntent: 'changePlan',
    targetProductEdition: (0, $1iBop.Edition).STANDARD_EDITION
};

});

parcelRegister("8C5iK", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $deec90af93ff40c0$export$6333901e831d7af0);

var $1214c = parcelRequire("1214c");

var $l9vc0 = parcelRequire("l9vc0");

var $gT6Dc = parcelRequire("gT6Dc");

const $deec90af93ff40c0$export$6333901e831d7af0 = (0, $l9vc0.createEntryPoint)({
    root: (0, $1214c.JSResourceForInteraction)(()=>(parcelRequire("7eigt")), {
        moduleId: "5e5e537a",
        priority: "interaction",
        moduleId: 'edition-awareness-user-limit-direct-buy-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                userLimitDirectBuyModalContentQuery: {
                    parameters: $gT6Dc.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("gT6Dc", function(module, exports) {
$parcel$export(module.exports, "default", () => $9300c48a4e3494a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<718d5d3e9a96f826e4b78ebb4c258eab>>
 * @relayHash 28f3f43ba5e93ca88b9bd0282f5ab143
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID edac6e8eb239d9c647cf67d881f2caefdd5b0eea820d7bc975b64b0de17e7def
const $9300c48a4e3494a9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "types": [
                    "SOFTWARE"
                ]
            }
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "userLimitDirectBuyModalContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v2 /*: any*/ ,
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "assignableUsers(first:10)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "userLimitDirectBuyModalContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v2 /*: any*/ ,
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "assignableUsers(first:10)"
                                                },
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "edac6e8eb239d9c647cf67d881f2caefdd5b0eea820d7bc975b64b0de17e7def",
            "metadata": {},
            "name": "userLimitDirectBuyModalContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9300c48a4e3494a9$var$node.hash = "ef5a18f27c3e046b8a2b1f9a763c1fd9";
var $9300c48a4e3494a9$export$2e2bcd8739ae039 = $9300c48a4e3494a9$var$node;

});

parcelRegister("7eigt", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("fIA63").then(()=>parcelRequire('axODH'));

});



parcelRegister("7KnVX", function(module, exports) {
$parcel$export(module.exports, "PaymentFlowLink", () => $216ff68723e13159$export$aa8ff608e1ef425);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $9sl8X = parcelRequire("9sl8X");

var $eOaYv = parcelRequire("eOaYv");

var $j88QB = parcelRequire("j88QB");

var $MOTjl = parcelRequire("MOTjl");

var $hD4W1 = parcelRequire("hD4W1");
const $216ff68723e13159$export$d546020ad1fe9957 = {
    linkId: 'payment-flow',
    touchpointIntent: 'addPaymentDetails'
};
const $216ff68723e13159$var$PaymentFlowLinkContent = ({ href: href })=>{
    const context = (0, $eOaYv.useEditionAwareness)();
    const { getExperimentCohort: getExperimentCohort } = (0, $j88QB.useGetExperimentValue)();
    const handlePaymentFlowClick = (0, $fsvuC.useCallback)(()=>{
        if ((0, $MOTjl.isEligibleForEAtoOSBNonRTPremiumAndRTPredunning)(context)) getExperimentCohort('ea-to-osb-nonrt-premium-rt-predunning-ab');
    }, [
        context,
        getExperimentCohort
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hD4W1.EditionAwarenessLink), {
        href: href,
        target: "_blank",
        onClick: handlePaymentFlowClick,
        ...$216ff68723e13159$export$d546020ad1fe9957
    });
};
$216ff68723e13159$var$PaymentFlowLinkContent.displayName = "PaymentFlowLinkContent";
const $216ff68723e13159$export$aa8ff608e1ef425 = ()=>{
    const { addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl } = (0, $eOaYv.useEditionAwareness)();
    if (addPaymentDetailsExperienceUrl) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $9sl8X.default), {
        data: $216ff68723e13159$export$d546020ad1fe9957,
        children: /*#__PURE__*/ (0, $5chsV.jsx)($216ff68723e13159$var$PaymentFlowLinkContent, {
            href: addPaymentDetailsExperienceUrl
        })
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {});
};
$216ff68723e13159$export$aa8ff608e1ef425.displayName = "PaymentFlowLink";

});

parcelRegister("juPTO", function(module, exports) {
$parcel$export(module.exports, "UpgradeStandardFlowLink", () => $f5940b25d1dac30e$export$a8729b26aa8f56b8);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $9sl8X = parcelRequire("9sl8X");

var $1iBop = parcelRequire("1iBop");

var $eOaYv = parcelRequire("eOaYv");

var $04eA3 = parcelRequire("04eA3");

var $hD4W1 = parcelRequire("hD4W1");
const $f5940b25d1dac30e$export$d546020ad1fe9957 = {
    linkId: 'upgrade-flow',
    touchpointIntent: 'changePlan',
    targetProductEdition: (0, $1iBop.Edition).STANDARD_EDITION
};
const $f5940b25d1dac30e$var$UpgradeStandardFlowLinkContent = ()=>{
    const { changeOfferingToStandardExperienceUrl: changeOfferingToStandardExperienceUrl, product: product } = (0, $eOaYv.useEditionAwareness)();
    const { expose: expose } = (0, $04eA3.useUserLimitDirectBuyExperiment)();
    const handleUpgradeFlowClick = (0, $fsvuC.useCallback)((e, _analyticsEvent, tracedUrl)=>{
        expose();
        if (product === 'jira' && tracedUrl) try {
            e.preventDefault();
            const url = new URL(tracedUrl);
            // Read window.location.href at click time so it reflects any client-side
            // navigation that occurred since the component was rendered, regardless of
            // which router (Jira or Confluence) is in use.
            url.searchParams.set('returnUrl', window.location.href);
            window.open(url.toString(), '_blank');
        } catch  {
        // URL construction failed — let the <a> tag navigate naturally
        }
    }, [
        product,
        expose
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hD4W1.EditionAwarenessLink), {
        href: changeOfferingToStandardExperienceUrl,
        target: "_blank",
        onClick: handleUpgradeFlowClick,
        ...$f5940b25d1dac30e$export$d546020ad1fe9957
    });
};
$f5940b25d1dac30e$var$UpgradeStandardFlowLinkContent.displayName = "UpgradeStandardFlowLinkContent";
const $f5940b25d1dac30e$export$a8729b26aa8f56b8 = ()=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $9sl8X.default), {
        data: $f5940b25d1dac30e$export$d546020ad1fe9957,
        children: /*#__PURE__*/ (0, $5chsV.jsx)($f5940b25d1dac30e$var$UpgradeStandardFlowLinkContent, {})
    });
};
$f5940b25d1dac30e$export$a8729b26aa8f56b8.displayName = "UpgradeStandardFlowLink";

});


parcelRegister("5Cvkg", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $f8a84e5c344cf3a4$export$e926676385687eaf);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $jY9mG = parcelRequire("jY9mG");

var $8IAtM = parcelRequire("8IAtM");

var $dOQFV = parcelRequire("dOQFV");

var $6hOVZ = parcelRequire("6hOVZ");
const $f8a84e5c344cf3a4$export$e926676385687eaf = ({ children: children, product: product, edition: edition, id: id })=>{
    const handleOnError = (0, $6hOVZ.useErrorAnalytics)({
        product: product,
        edition: edition,
        id: id
    });
    const ufoContext = (0, $dOQFV.useInteractionContext)();
    const onError = (0, $fsvuC.useCallback)((error)=>{
        const interaction = (0, $8IAtM.getActiveInteraction)();
        handleOnError(error);
        if (interaction && ufoContext) (0, $8IAtM.addError)(interaction?.id, error.name, ufoContext?.labelStack, error.name, error.message, error.stack);
        else (0, $8IAtM.addErrorToAll)(`ErrorBoundary:${id}`, ufoContext?.labelStack || null, error.name, error.message);
    }, [
        handleOnError,
        id,
        ufoContext
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jY9mG.ErrorBoundary), {
        onError: onError,
        fallback: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {}),
        children: children
    });
};
$f8a84e5c344cf3a4$export$e926676385687eaf.displayName = "ErrorBoundary";

});


parcelRegister("hTfO1", function(module, exports) {
$parcel$export(module.exports, "appSwitcherBffAvailableProductsFetch", () => $33fcb9777f5f2fff$export$1096efb00c5f8afc);
$parcel$export(module.exports, "createAppSwitcherBffAvailableProductsProvider", () => $33fcb9777f5f2fff$export$7fd9c7ae7afb494c);

var $j3C8w = parcelRequire("j3C8w");

var $74Uz3 = parcelRequire("74Uz3");

var $2nV9c = parcelRequire("2nV9c");
const $33fcb9777f5f2fff$export$f36bb44a614923a8 = '/gateway/api/app-switcher/api/available-products';
const $33fcb9777f5f2fff$export$1096efb00c5f8afc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $74Uz3.fetchJsonWithNetworkRetries)(`${$33fcb9777f5f2fff$export$f36bb44a614923a8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $33fcb9777f5f2fff$export$7fd9c7ae7afb494c = ()=>{
    return (0, $2nV9c.createProviderWithCustomFetchData)('appSwitcherBffAvailableProducts', (0, $j3C8w.ExperienceMark).API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, $33fcb9777f5f2fff$export$1096efb00c5f8afc);
};

});
parcelRegister("j3C8w", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $4552505b2e69855e$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "EXPERIENCE_CONFIGS", () => $4552505b2e69855e$export$d54d7a2744fdf647);
$parcel$export(module.exports, "ExperienceMark", () => $4552505b2e69855e$export$cbf1e672c3e37474);
$parcel$export(module.exports, "EXPERIENCES_TO_MARKS", () => $4552505b2e69855e$export$755e75afbd377bc4);
$parcel$export(module.exports, "MARKS_TO_EXPERIENCES", () => $4552505b2e69855e$export$805ed806e0769ee4);
$parcel$export(module.exports, "ExperienceMarkPhase", () => $4552505b2e69855e$export$ec8391a70bbdbe59);
$parcel$export(module.exports, "AbortReason", () => $4552505b2e69855e$export$279d6315a97b520d);
$parcel$export(module.exports, "SWITCHER_RENDER_START_PERFORMANCE_MARK", () => $4552505b2e69855e$export$86919b84f9a64054);

var $8nBFK = parcelRequire("8nBFK");

var $d9NXm = parcelRequire("d9NXm");
var $4552505b2e69855e$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    Experience["RENDER_THIRD_PARTY_SECTION"] = "render-third-party-section";
    return Experience;
}({});
const $4552505b2e69855e$export$d54d7a2744fdf647 = {
    ["render-custom-links-section"]: {
        type: (0, $8nBFK.ExperienceTypes).Load,
        performanceType: (0, $8nBFK.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switch-to-section"]: {
        type: (0, $8nBFK.ExperienceTypes).Load,
        performanceType: (0, $8nBFK.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switcher-empty-state"]: {
        type: (0, $8nBFK.ExperienceTypes).Load,
        performanceType: (0, $8nBFK.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-third-party-section"]: {
        type: (0, $8nBFK.ExperienceTypes).Load,
        performanceType: (0, $8nBFK.ExperiencePerformanceTypes).PageSegmentLoad
    }
};
var $4552505b2e69855e$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_APP_SWITCHER_BFF_GLOBAL_APPS"] = "api-app-switcher-bff-global-apps";
    ExperienceMark["API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS"] = "api-app-switcher-bff-third-party-products";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
const $4552505b2e69855e$var$allNonTestExperienceMarks = Object.values($4552505b2e69855e$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
const $4552505b2e69855e$export$755e75afbd377bc4 = {
    ["render-custom-links-section"]: $4552505b2e69855e$var$allNonTestExperienceMarks,
    ["render-switch-to-section"]: $4552505b2e69855e$var$allNonTestExperienceMarks,
    ["render-switcher-empty-state"]: $4552505b2e69855e$var$allNonTestExperienceMarks,
    ["render-third-party-section"]: $4552505b2e69855e$var$allNonTestExperienceMarks
};
const $4552505b2e69855e$export$805ed806e0769ee4 = (0, $d9NXm.invertRecordOfArrays)($4552505b2e69855e$export$755e75afbd377bc4);
var $4552505b2e69855e$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $4552505b2e69855e$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
const $4552505b2e69855e$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';

});
parcelRegister("d9NXm", function(module, exports) {
$parcel$export(module.exports, "invertRecordOfArrays", () => $c1808f10fbea886e$export$c371a74fe5222b3);
function $c1808f10fbea886e$export$c371a74fe5222b3(record) {
    const invertedRecord = {};
    Object.entries(record).forEach(([key, values])=>{
        values.forEach((value)=>{
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}

});


parcelRegister("74Uz3", function(module, exports) {
$parcel$export(module.exports, "fetchJson", () => $c04837cbcad4c170$export$6d71b655afe1638d);
$parcel$export(module.exports, "fetchJsonWithNetworkRetries", () => $c04837cbcad4c170$export$16566b750080153d);
$parcel$export(module.exports, "postJson", () => $c04837cbcad4c170$export$c776284ef4b1209a);

var $do7hl = parcelRequire("do7hl");

var $bLPvC = parcelRequire("bLPvC");

var $33YiJ = parcelRequire("33YiJ");
const $c04837cbcad4c170$var$extraJsonFromResponse = (response)=>{
    if (response.ok) return response.json();
    throw new (0, $bLPvC.FetchError)(`Unable to fetch ${response.url} ${response.status} ${response.statusText}`, response.status);
};
const $c04837cbcad4c170$export$6d71b655afe1638d = (url, init, emptyResponse)=>fetch(url, {
        credentials: 'include',
        ...init,
        headers: {
            'Atl-App-Switcher-Version': (0, $do7hl.default).packageVersion,
            ...init?.headers
        }
    }).then(!emptyResponse ? $c04837cbcad4c170$var$extraJsonFromResponse : ()=>{});
const $c04837cbcad4c170$export$16566b750080153d = (url, retryConfig, init)=>{
    return (0, $33YiJ.retryOnException)(()=>fetch(url, {
            credentials: 'include',
            ...init,
            headers: {
                'Atl-App-Switcher-Version': (0, $do7hl.default).packageVersion,
                ...init?.headers
            }
        }), retryConfig).then($c04837cbcad4c170$var$extraJsonFromResponse);
};
const $c04837cbcad4c170$export$c776284ef4b1209a = (url, data, emptyResponse)=>$c04837cbcad4c170$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }, emptyResponse);

});
parcelRegister("do7hl", function(module, exports) {
$parcel$export(module.exports, "default", () => $29e06a77c797cc63$export$2e2bcd8739ae039);
const $29e06a77c797cc63$var$packageName = "platform-pkg";
const $29e06a77c797cc63$var$packageVersion = "0.0.0-use.local";
const $29e06a77c797cc63$var$_default_1 = {
    packageName: $29e06a77c797cc63$var$packageName,
    packageVersion: $29e06a77c797cc63$var$packageVersion
};
var $29e06a77c797cc63$export$2e2bcd8739ae039 = $29e06a77c797cc63$var$_default_1;

});

parcelRegister("bLPvC", function(module, exports) {
$parcel$export(module.exports, "FETCH_ERROR_NAME", () => $54f4208d5dabe9d1$export$83179404a61b001a);
$parcel$export(module.exports, "FetchError", () => $54f4208d5dabe9d1$export$26e841bcf1aeb894);
const $54f4208d5dabe9d1$export$83179404a61b001a = 'FetchError';
class $54f4208d5dabe9d1$export$26e841bcf1aeb894 extends Error {
    constructor(message, status){
        super(message), this.name = $54f4208d5dabe9d1$export$83179404a61b001a;
        this.status = status;
    }
    static isFetchError(value) {
        return value instanceof $54f4208d5dabe9d1$export$26e841bcf1aeb894;
    }
}

});

parcelRegister("33YiJ", function(module, exports) {
$parcel$export(module.exports, "retryOnException", () => $0748967de5db4bd5$export$1d94629c94e7a17f);
const $0748967de5db4bd5$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $0748967de5db4bd5$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
    let nextMSInterval = 0;
    let error = new Error('No calls made');
    const retries = config.intervalsMS.length;
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) {
            await $0748967de5db4bd5$export$5c069c93d2b7493f(nextMSInterval);
            if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
        }
        return await invokeOperation();
    } catch (e) {
        error = e;
        if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
        nextMSInterval = config.intervalsMS.shift();
    }
    throw error;
};

});


parcelRegister("2nV9c", function(module, exports) {
$parcel$export(module.exports, "createProviderWithCustomFetchData", () => $002dd8045a9a3a9f$export$310e48be95687c2f);

var $74Uz3 = parcelRequire("74Uz3");

var $j2XWl = parcelRequire("j2XWl");

var $42oko = parcelRequire("42oko");
const $002dd8045a9a3a9f$export$500fbc0cd14cdbaa = (name, experienceMark, url)=>{
    const fetchMethod = (0, $j2XWl.withCached)((param)=>(0, $74Uz3.fetchJson)(url));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $42oko.default)(name, experienceMark, fetchMethod, fetchMethod.cached, // fetch will only throw on a network exception,
        // so we can safely retry on all exceptions
        {
            shouldRetryOnException: ()=>true,
            intervalsMS: [
                50,
                200,
                1000
            ]
        })
    };
};
const $002dd8045a9a3a9f$export$310e48be95687c2f = (name, experienceMark, fetchData, retryConfig, shouldUpdate)=>{
    const fetchMethod = (0, $j2XWl.withCached)((param)=>fetchData(param));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $42oko.default)(name, experienceMark, fetchMethod, fetchMethod.cached, retryConfig, shouldUpdate)
    };
};

});
parcelRegister("j2XWl", function(module, exports) {
$parcel$export(module.exports, "withCached", () => $76b808e7d173ff42$export$7f51828d6b6af163);
const $76b808e7d173ff42$export$d4d4b402ab64e2f4 = 5000;
const $76b808e7d173ff42$var$isPromise = (p)=>{
    return typeof p.then === 'function' && typeof p.catch === 'function';
};
const $76b808e7d173ff42$export$7f51828d6b6af163 = (fn)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        promiseCache.set(cacheKey, maybePromise);
        if ($76b808e7d173ff42$var$isPromise(maybePromise)) maybePromise.then((result)=>{
            resultCache.set(cacheKey, result);
            setTimeout(()=>promiseCache.delete(cacheKey), $76b808e7d173ff42$export$d4d4b402ab64e2f4);
        }).catch(()=>{
            promiseCache.delete(cacheKey);
        });
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});

parcelRegister("42oko", function(module, exports) {
$parcel$export(module.exports, "Status", () => $67caf29049df83ec$export$96e9906d6d93a972);
$parcel$export(module.exports, "isComplete", () => $67caf29049df83ec$export$9569565a7ac14e8e);
$parcel$export(module.exports, "isError", () => $67caf29049df83ec$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isLoading", () => $67caf29049df83ec$export$20bb0d907fbbe433);
$parcel$export(module.exports, "hasLoaded", () => $67caf29049df83ec$export$5fce62f50756dbf);
$parcel$export(module.exports, "default", () => $67caf29049df83ec$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $7uMuM = parcelRequire("7uMuM");

var $6QsiP = parcelRequire("6QsiP");

var $4K03o = parcelRequire("4K03o");

var $9gm5E = parcelRequire("9gm5E");

var $33YiJ = parcelRequire("33YiJ");
const $67caf29049df83ec$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
var $67caf29049df83ec$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
const $67caf29049df83ec$export$947ceca65da0e7a6 = (data)=>({
        status: "complete",
        data: data
    });
const $67caf29049df83ec$export$9569565a7ac14e8e = (result)=>result.status === "complete";
const $67caf29049df83ec$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
const $67caf29049df83ec$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
const $67caf29049df83ec$export$5fce62f50756dbf = (result)=>result.status !== "loading";
function $67caf29049df83ec$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    const getInitialState = (props)=>{
        if (mapPropsToInitialValue) {
            const initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: "complete",
                data: initialValue
            };
        }
        return {
            status: "loading",
            data: null
        };
    };
    class DataProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
        static{
            this.displayName = `DataProvider(${name})`;
        }
        componentWillUnmount() {
            /**
			 * Promise resolved after component is unmounted to be ignored
			 */ this.acceptResults = false;
        }
        componentDidMount() {
            this.props.experienceTracker.markStart(experienceMark);
            this.fetchData();
        }
        componentDidUpdate(prevProps) {
            if (shouldUpdate?.(prevProps.params, this.props.params)) this.fetchData();
        }
        fetchData() {
            (0, $33YiJ.retryOnException)(()=>mapPropsToPromise(this.props.params), {
                intervalsMS: retryConfig?.intervalsMS || [],
                shouldRetryOnException: retryConfig?.shouldRetryOnException,
                onRetry: (previousException, retryCount)=>{
                    this.onRetry(previousException, retryCount);
                }
            }).then((result)=>{
                this.onResult(result);
            }).catch((error)=>{
                this.onError(error);
            });
        }
        onResult(value) {
            if (this.acceptResults) this.setState({
                data: value,
                status: "complete"
            });
            this.props.experienceTracker.markEnd(experienceMark);
            this.fireOperationalEvent({
                action: 'receivedResult',
                actionSubjectId: name,
                attributes: {
                    provider: name
                }
            });
        }
        onRetry(error, retryCount) {
            this.fireOperationalEvent({
                action: 'retried',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: retryConfig?.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $4K03o.errorToReason)(error),
                    retryCount: retryCount
                }
            });
        }
        onError(error) {
            /**
			 * Do not transition from "complete" state to "error"
			 */ if (this.acceptResults && !$67caf29049df83ec$export$9569565a7ac14e8e(this.state)) this.setState({
                error: error,
                status: "error",
                data: null
            });
            this.fireOperationalEvent({
                action: 'failed',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: (0, $4K03o.errorToReason)(error)
                }
            });
        }
        render() {
            return this.props.children(this.state);
        }
        constructor(...args){
            super(...args), this.acceptResults = true, this.state = getInitialState(this.props.params), this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $ddd31af8f515fa50$export$12346a674644c156),
                    actionSubject: $67caf29049df83ec$var$DATA_PROVIDER_SUBJECT,
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        outdated: !this.acceptResults
                    }
                }).fire((0, $6QsiP.NAVIGATION_CHANNEL));
            };
        }
    }
    // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    const InnerComponent = (0, $7uMuM.default)()((0, $9gm5E.withExperienceTracker)(DataProvider));
    const OuterComponent = ({ children: children, ...params })=>{
        return /*#__PURE__*/ (0, $5chsV.jsx)(InnerComponent, {
            params: params,
            children: children
        });
    };
    return OuterComponent;
}

});
parcelRegister("6QsiP", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $438949f9609d2f23$export$515664faa1398f37);
$parcel$export(module.exports, "SWITCHER_SUBJECT", () => $438949f9609d2f23$export$17ff9c46e41eb585);
$parcel$export(module.exports, "SWITCHER_ITEM_LOZENGES_SUBJECT", () => $438949f9609d2f23$export$c3c93e13b09d3ad9);
$parcel$export(module.exports, "SWITCHER_COMPONENT", () => $438949f9609d2f23$export$2b570fc112cbca);
$parcel$export(module.exports, "SWITCHER_SOURCE", () => $438949f9609d2f23$export$5ed36c4d23de5568);
$parcel$export(module.exports, "TRIGGER_COMPONENT", () => $438949f9609d2f23$export$8d2f933bbd9e4f09);
$parcel$export(module.exports, "TRIGGER_SUBJECT", () => $438949f9609d2f23$export$d7029a5dc66b0736);
$parcel$export(module.exports, "SWITCHER_PARTIAL_RESULTS", () => $438949f9609d2f23$export$4649adbfda1b6a66);
$parcel$export(module.exports, "SWITCHER_JOINABLE_SITES", () => $438949f9609d2f23$export$5724539c9b1a3a5d);
$parcel$export(module.exports, "SWITCHER_AVAILABLE_PRODUCTS", () => $438949f9609d2f23$export$22f5f827d9934254);
$parcel$export(module.exports, "analyticsAttributes", () => $438949f9609d2f23$export$a305f130b289b818);
$parcel$export(module.exports, "withAnalyticsContextData", () => $438949f9609d2f23$export$97ebdd8e7274f18a);
$parcel$export(module.exports, "RenderTracker", () => $438949f9609d2f23$export$e09ad93c2b74b853);
$parcel$export(module.exports, "NotRenderedTracker", () => $438949f9609d2f23$export$95b1f1a72cad0dcb);
$parcel$export(module.exports, "ViewedTracker", () => $438949f9609d2f23$export$b3fd6624b6a6d057);
$parcel$export(module.exports, "getCustomLinksRenderTracker", () => $438949f9609d2f23$export$d75a4f56d85f67ea);
$parcel$export(module.exports, "getItemAnalyticsContext", () => $438949f9609d2f23$export$6489efba2ca85102);
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("7uMuM")).default);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("c5gj6")).NavigationAnalyticsContext);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $ddd31af8f515fa50$export$12346a674644c156);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $ddd31af8f515fa50$export$a1562d08625f5d7e);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");


var $c5gj6 = parcelRequire("c5gj6");

var $h4B8Q = parcelRequire("h4B8Q");

var $7uMuM = parcelRequire("7uMuM");

var $42oko = parcelRequire("42oko");

var $2UW91 = parcelRequire("2UW91");

var $2qWdG = parcelRequire("2qWdG");
const $438949f9609d2f23$export$515664faa1398f37 = 'navigation';
const $438949f9609d2f23$export$17ff9c46e41eb585 = 'atlassianSwitcher';
const $438949f9609d2f23$export$7598b001981cfda5 = 'atlassianSwitcherItem';
const $438949f9609d2f23$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
const $438949f9609d2f23$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
const $438949f9609d2f23$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
const $438949f9609d2f23$export$2b570fc112cbca = 'atlassianSwitcher';
const $438949f9609d2f23$export$5ed36c4d23de5568 = 'atlassianSwitcher';
const $438949f9609d2f23$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
const $438949f9609d2f23$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
const $438949f9609d2f23$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
const $438949f9609d2f23$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
const $438949f9609d2f23$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
const $438949f9609d2f23$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
const $438949f9609d2f23$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
const $438949f9609d2f23$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
const $438949f9609d2f23$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
const $438949f9609d2f23$var$RENDERED_ACTION = 'rendered';
const $438949f9609d2f23$var$NOT_RENDERED_ACTION = 'not_rendered';
const $438949f9609d2f23$var$VIEWED_ACTION = 'viewed';
const $438949f9609d2f23$export$884b1a4c7ac9dd14 = (0, $h4B8Q.default)($438949f9609d2f23$export$515664faa1398f37);
const $438949f9609d2f23$export$a305f130b289b818 = (attributes)=>({
        attributes: attributes
    });
const $438949f9609d2f23$export$97ebdd8e7274f18a = function(mapPropsToContext) {
    return function(WrappedComponent) {
        return (props)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $c5gj6.NavigationAnalyticsContext), {
                data: mapPropsToContext(props),
                children: /*#__PURE__*/ (0, $5chsV.jsx)(WrappedComponent, {
                    ...props
                })
            });
    };
};
const $438949f9609d2f23$var$isValidDuration = (duration)=>{
    return duration !== null && duration !== undefined && duration >= 0;
};
const $438949f9609d2f23$export$e09ad93c2b74b853 = (0, $7uMuM.default)({
    onRender: (createAnalyticsEvent, props)=>{
        const duration = props.data?.duration;
        return createAnalyticsEvent({
            eventType: (0, $ddd31af8f515fa50$export$12346a674644c156),
            action: $438949f9609d2f23$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: {
                ...props.data,
                ...$438949f9609d2f23$var$isValidDuration(duration) && {
                    bucket: (0, $2qWdG.getMetricBucket)(duration, (0, $2qWdG.RenderTrackerBuckets))
                }
            }
        }).fire($438949f9609d2f23$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $438949f9609d2f23$export$95b1f1a72cad0dcb = (0, $7uMuM.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $ddd31af8f515fa50$export$12346a674644c156),
            action: $438949f9609d2f23$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($438949f9609d2f23$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $438949f9609d2f23$export$b3fd6624b6a6d057 = (0, $7uMuM.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $ddd31af8f515fa50$export$a1562d08625f5d7e),
            action: $438949f9609d2f23$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($438949f9609d2f23$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $438949f9609d2f23$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
    if (notRenderedReason) return /*#__PURE__*/ (0, $5chsV.jsx)($438949f9609d2f23$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            notRenderedReason: notRenderedReason
        }
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)($438949f9609d2f23$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $438949f9609d2f23$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, $5chsV.jsx)($438949f9609d2f23$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            providerFailed: providerFailed
        }
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)($438949f9609d2f23$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $438949f9609d2f23$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
    if (!(0, $42oko.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $438949f9609d2f23$var$renderTracker({
        subject: $438949f9609d2f23$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
const $438949f9609d2f23$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    const emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if (customLinksProviderResult?.status === (0, $42oko.Status).ERROR) return 'custom_links_api_error';
        const error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $2UW91.UserSiteDataError)) return error.reason;
        else return 'usd_unknown';
    }
    const notRenderedReason = getNotRenderedReason();
    return $438949f9609d2f23$var$renderTrackerWithReason({
        subject: $438949f9609d2f23$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
const $438949f9609d2f23$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
        ...$438949f9609d2f23$export$a305f130b289b818({
            groupIndex: groupIndex,
            itemId: id,
            itemType: type,
            productType: productType,
            ...extraAttributes
        })
    });

});
parcelRegister("2UW91", function(module, exports) {
$parcel$export(module.exports, "UserSiteDataErrorReason", () => $c887588379b25604$export$b08600051ba52198);
$parcel$export(module.exports, "UserSiteDataError", () => $c887588379b25604$export$c460344055e97b1);
var $c887588379b25604$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
class $c887588379b25604$export$c460344055e97b1 extends Error {
    constructor(reason, message){
        super(message);
        this.name = 'UserSiteDataError';
        this.reason = reason;
    }
}

});

parcelRegister("2qWdG", function(module, exports) {
$parcel$export(module.exports, "RenderTrackerBuckets", () => $3896e888a2146624$export$e59c24bc0768d568);
$parcel$export(module.exports, "getMetricBucket", () => $3896e888a2146624$export$b59492d26971ae92);
const $3896e888a2146624$var$INFINITY = '+Inf';
const $3896e888a2146624$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
const $3896e888a2146624$export$b59492d26971ae92 = (metricValue, buckets)=>{
    return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $3896e888a2146624$var$INFINITY) : null;
};

});


parcelRegister("4K03o", function(module, exports) {
$parcel$export(module.exports, "errorToReason", () => $fc0bec899658c890$export$a3e288208721751b);
function $fc0bec899658c890$export$a3e288208721751b(error) {
    const { name: name = 'Unknown', status: status } = error || {};
    return {
        name: name,
        status: status
    };
}

});

parcelRegister("9gm5E", function(module, exports) {
$parcel$export(module.exports, "SwitcherExperienceTrackerContext", () => $abe156d44bb9075f$export$3f3eebb4b8116461);
$parcel$export(module.exports, "useExperienceTracker", () => $abe156d44bb9075f$export$cdefb2a8b53f879f);
$parcel$export(module.exports, "withExperienceTracker", () => $abe156d44bb9075f$export$f88dde183f4d31cb);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
const $abe156d44bb9075f$var$noop = ()=>{};
const $abe156d44bb9075f$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $fsvuC.createContext)({
    start: $abe156d44bb9075f$var$noop,
    success: $abe156d44bb9075f$var$noop,
    failure: $abe156d44bb9075f$var$noop,
    failureAll: $abe156d44bb9075f$var$noop,
    abort: $abe156d44bb9075f$var$noop,
    abortAll: $abe156d44bb9075f$var$noop,
    markStart: $abe156d44bb9075f$var$noop,
    markEnd: $abe156d44bb9075f$var$noop
});
const $abe156d44bb9075f$export$cdefb2a8b53f879f = ()=>(0, $fsvuC.useContext)($abe156d44bb9075f$export$3f3eebb4b8116461);
const $abe156d44bb9075f$export$f88dde183f4d31cb = (Component)=>{
    const WithExperienceTracker = (props)=>{
        const experienceTracker = $abe156d44bb9075f$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
    WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
    return WithExperienceTracker;
};

});




parcelRegister("fmHPh", function(module, exports) {
$parcel$export(module.exports, "default", () => $ece10a9b31bb83c8$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $aSEUQ = parcelRequire("aSEUQ");

var $6QsiP = parcelRequire("6QsiP");
var $c5gj6 = parcelRequire("c5gj6");
var $7uMuM = parcelRequire("7uMuM");

var $do7hl = parcelRequire("do7hl");

var $gUKAl = parcelRequire("gUKAl");

var $38uUX = parcelRequire("38uUX");
const $ece10a9b31bb83c8$var$THROTTLE_EXPIRES = 60000; // 60 seconds
const $ece10a9b31bb83c8$var$THROTTLE_OPTIONS = {
    leading: true,
    trailing: false
};
const $ece10a9b31bb83c8$var$TRIGGER_CONTEXT = {
    componentName: (0, $6QsiP.TRIGGER_COMPONENT),
    ...(0, $do7hl.default)
};
class $ece10a9b31bb83c8$var$PrefetchTrigger extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
    render() {
        const { children: children, Container: Container = 'div' } = this.props;
        return /*#__PURE__*/ (0, $5chsV.jsx)(Container, {
            onFocus: this.handleMouseEnter,
            onMouseEnter: this.handleMouseEnter,
            onClick: this.handleMouseClick,
            children: children
        });
    }
    constructor(...args){
        super(...args), this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $ddd31af8f515fa50$export$12346a674644c156),
                actionSubject: (0, $6QsiP.TRIGGER_SUBJECT),
                ...payload
            }).fire((0, $6QsiP.NAVIGATION_CHANNEL));
        }, this.triggerPrefetch = (0, (/*@__PURE__*/$parcel$interopDefault($aSEUQ)))(()=>{
            (0, $38uUX.prefetchAll)(this.props);
            this.fireOperationalEvent({
                action: 'triggered'
            });
        }, $ece10a9b31bb83c8$var$THROTTLE_EXPIRES, $ece10a9b31bb83c8$var$THROTTLE_OPTIONS), this.handleMouseEnter = ()=>{
            this.triggerPrefetch();
            this.lastEnteredAt = (0, $gUKAl.performanceNow)();
        }, this.handleMouseClick = ()=>{
            if (this.lastEnteredAt) {
                const hoverToClick = Math.round((0, $gUKAl.performanceNow)() - this.lastEnteredAt);
                this.fireOperationalEvent({
                    action: 'clicked',
                    attributes: {
                        hoverToClick: hoverToClick
                    }
                });
            }
        };
    }
}
$ece10a9b31bb83c8$var$PrefetchTrigger.displayName = "PrefetchTrigger";
const $ece10a9b31bb83c8$var$PrefetchTriggerWithEvents = (0, $7uMuM.default)()($ece10a9b31bb83c8$var$PrefetchTrigger);
var $ece10a9b31bb83c8$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $c5gj6.NavigationAnalyticsContext), {
        data: $ece10a9b31bb83c8$var$TRIGGER_CONTEXT,
        children: /*#__PURE__*/ (0, $5chsV.jsx)($ece10a9b31bb83c8$var$PrefetchTriggerWithEvents, {
            ...props
        })
    });

});
parcelRegister("gUKAl", function(module, exports) {
$parcel$export(module.exports, "performanceNow", () => $72e50b3ad3b0defb$export$fb4230f160368c88);
const $72e50b3ad3b0defb$export$fb4230f160368c88 = typeof window !== 'undefined' && window.performance && window.performance.now.bind(performance) || Date.now;

});

parcelRegister("38uUX", function(module, exports) {
$parcel$export(module.exports, "prefetchAll", () => $80039ee95d5ae76c$export$aba5d6cf034db22e);

var $jhsew = parcelRequire("jhsew");

var $3OKZq = parcelRequire("3OKZq");

var $djlG7 = parcelRequire("djlG7");

var $frdQR = parcelRequire("frdQR");

var $d7rku = parcelRequire("d7rku");
const $80039ee95d5ae76c$export$aba5d6cf034db22e = (props)=>{
    const { cloudId: cloudId, product: product } = props;
    (0, $frdQR.default)();
    (0, $jhsew.prefetchFlightDeck)({});
    (0, $3OKZq.prefetchAvailableProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $djlG7.prefetchThirdPartyProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $d7rku.prefetchJoinableSites)(props.joinableSitesDataProvider);
};

});
parcelRegister("jhsew", function(module, exports) {
$parcel$export(module.exports, "FlightDeckProvider", () => $ba9dfd75f6ce76d0$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "prefetchFlightDeck", () => $ba9dfd75f6ce76d0$export$7d2a567d3e50224);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $1TBsX = parcelRequire("1TBsX");

var $bgxUe = parcelRequire("bgxUe");


var $j3C8w = parcelRequire("j3C8w");

var $jKvDA = parcelRequire("jKvDA");

var $2nV9c = parcelRequire("2nV9c");

var $8oxXB = parcelRequire("8oxXB");
const $ba9dfd75f6ce76d0$var$client = new (0, $1TBsX.default)('atlassian-switcher', {
    handlers: {},
    // Switch the FD default storage from localStorage to sessionStorage to avoid issues related to GDPR policy.
    // The storageEngine option isn't exposed directly by the FD SDK, but you can still pass it in
    // https://hello.jira.atlassian.cloud/browse/NAVX-658
    //@ts-ignore
    storageEngine: 'sessionStorage'
});
const { fetchMethod: $ba9dfd75f6ce76d0$var$fetchFlightDeck, ProviderComponent: $ba9dfd75f6ce76d0$var$DefaultFlightDeckProviderComponent } = (0, $2nV9c.createProviderWithCustomFetchData)('flightDeck', (0, $j3C8w.ExperienceMark).API_FLIGHT_DECK, async ()=>{
    const artifact = await $ba9dfd75f6ce76d0$var$client.fetchConfigFromFlightDeck({
        name: 'app-switcher-fe',
        dimensions: {
            environmentType: 'prod',
            perimeter: (0, $bgxUe.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
        }
    });
    return $ba9dfd75f6ce76d0$var$transformFlightDeckArtifactToProductConfiguration(artifact);
});
const $ba9dfd75f6ce76d0$var$transformFlightDeckArtifactToProductConfiguration = (artifact)=>{
    const artifactMap = new Map();
    for (const product of artifact.products){
        const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey } = product;
        artifactMap.set(apsKey, {
            key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
            href: siteUrlSuffix,
            ordinal: ordinal,
            label: (0, $8oxXB.formatLabel)(displayName),
            description: (0, $8oxXB.formatDescription)(subtitle),
            iconKey: iconKey
        });
        // TODO: remove this once Asset app becomes standalone app
        if (apsKey === 'JIRA_SERVICE_DESK' && !artifactMap.has((0, $a911def61a058b00$export$45e63649edff1e2a))) artifactMap.set((0, $a911def61a058b00$export$45e63649edff1e2a), {
            key: (0, $a911def61a058b00$export$45e63649edff1e2a),
            href: '/jira/assets',
            ordinal: ordinal + 0.1,
            label: (0, $8oxXB.formatLabel)((0, $jKvDA.default).assets),
            iconKey: 'assets'
        });
    }
    return {
        products: Object.fromEntries(artifactMap),
        links: Object.fromEntries(artifact.links.map(({ apsKey: apsKey, ...link })=>[
                apsKey,
                {
                    ...link,
                    key: apsKey.toLowerCase(),
                    href: link.url,
                    label: (0, $8oxXB.formatLabel)(link.displayName),
                    description: (0, $8oxXB.formatDescription)(link.subtitle),
                    iconKey: 'admin'
                }
            ]))
    };
};
const $ba9dfd75f6ce76d0$export$56da85ac9d40dbcd = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)($ba9dfd75f6ce76d0$var$DefaultFlightDeckProviderComponent, {
        children: children
    });
$ba9dfd75f6ce76d0$export$56da85ac9d40dbcd.displayName = "FlightDeckProvider";
const $ba9dfd75f6ce76d0$export$7d2a567d3e50224 = $ba9dfd75f6ce76d0$var$fetchFlightDeck;

});
const $a911def61a058b00$export$45e63649edff1e2a = 'ASSETS';
const $a911def61a058b00$export$eb7589a4ee50c678 = 'tenantless';

parcelRegister("jKvDA", function(module, exports) {
$parcel$export(module.exports, "default", () => $78e8b2c733039933$export$2e2bcd8739ae039);

var $54F37 = parcelRequire("54F37");
const $78e8b2c733039933$var$messages = (0, $54F37.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.title',
        defaultMessage: 'Get started with cloud',
        description: 'The title text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsBody: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body',
        defaultMessage: 'Try a product to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLink: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link',
        defaultMessage: 'Explore products',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    home: {
        id: 'fabric.atlassianSwitcher.atlassianHome',
        defaultMessage: 'Home',
        description: 'The text of a link redirecting the user to the Home site'
    },
    rovo: {
        id: 'fabric.atlassianSwitcher.rovo-home',
        defaultMessage: 'Rovo Home',
        description: 'The text of a link redirecting the user to the rovo home site'
    },
    administration: {
        id: 'fabric.atlassianSwitcher.administration',
        defaultMessage: 'Administration',
        description: 'The text of a link redirecting the user to Administration'
    },
    atlassianStart: {
        id: 'fabric.atlassianSwitcher.start',
        defaultMessage: 'Atlassian Start',
        description: 'The text of a link redirecting the user to the Start site'
    },
    assets: {
        id: 'fabric.atlassianSwitcher.assets',
        defaultMessage: 'Assets',
        description: 'The text of a link redirecting the user to the Assets'
    },
    artifacts: {
        id: 'fabric.atlassianSwitcher.artifacts',
        defaultMessage: 'Artifacts',
        description: 'The text of a link redirecting the user to Artifacts'
    },
    analytics: {
        id: 'fabric.atlassianSwitcher.analytics',
        defaultMessage: 'Analytics',
        description: 'The text of a link redirecting the user to the Analytics'
    },
    insights: {
        id: 'fabric.atlassianSwitcher.insights',
        defaultMessage: 'Insights',
        description: 'The text of a link redirecting the user to Insights'
    },
    companyHub: {
        id: 'fabric.atlassianSwitcher.companyHub',
        defaultMessage: 'Company Hub',
        description: 'The text of a link redirecting the user to the Company Hub'
    },
    goals: {
        id: 'fabric.atlassianSwitcher.goals',
        defaultMessage: 'Goals',
        description: 'The text of a link redirecting the user to the Goals'
    },
    projects: {
        id: 'fabric.atlassianSwitcher.projects',
        defaultMessage: 'Projects',
        description: 'The text of a link redirecting the user to the Projects'
    },
    teams: {
        id: 'fabric.atlassianSwitcher.teams',
        defaultMessage: 'Teams',
        description: 'The text of a link redirecting the user to the Teams'
    },
    search: {
        id: 'fabric.atlassianSwitcher.search',
        defaultMessage: 'Search',
        description: 'The text of a link redirecting the user to the Search'
    },
    chat: {
        id: 'fabric.atlassianSwitcher.chat',
        defaultMessage: 'Chat',
        description: 'The text of a link redirecting the user to the Chat'
    },
    studio: {
        id: 'fabric.atlassianSwitcher.studio',
        defaultMessage: 'Studio',
        description: 'The text of a link redirecting the user to the Studio'
    },
    rovoSearch: {
        id: 'fabric.atlassianSwitcher.rovo-search',
        defaultMessage: 'Rovo Search',
        description: 'The text of a link redirecting the user to Rovo Search app'
    },
    rovoChat: {
        id: 'fabric.atlassianSwitcher.rovo-chat',
        defaultMessage: 'Rovo Chat',
        description: 'The text of a link redirecting the user to the Rovo Chat app'
    },
    rovoStudio: {
        id: 'fabric.atlassianSwitcher.rovo-studio',
        defaultMessage: 'Rovo Studio',
        description: 'The text of a link redirecting the user to Rovo Studio app'
    },
    manageList: {
        id: 'fabric.atlassianSwitcher.manageList',
        defaultMessage: 'Manage list',
        description: 'This text is for the action for a user to manage the values present in an editable list of links.'
    },
    errorEmptyPartialResults: {
        id: 'fabric.atlassianSwitcher.errorEmptyPartialResults',
        defaultMessage: "We can't display your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and no sites'
    },
    errorHeading: {
        id: 'fabric.atlassianSwitcher.errorHeading',
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorText: {
        id: 'fabric.atlassianSwitcher.errorText',
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the Atlassian Switcher.'
    },
    errorImageAltText: {
        id: 'fabric.atlassianSwitcher.errorImageAltText',
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the Atlassian Switcher'
    },
    errorTextNetwork: {
        id: 'fabric.atlassianSwitcher.errorTextNetwork',
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again.",
        description: 'Text that is displayed when we detect a network issue.'
    },
    errorHeadingLoggedOut: {
        id: 'fabric.atlassianSwitcher.errorHeadingLoggedOut',
        defaultMessage: 'Your Atlassian account is logged out',
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorHeadingUnverified: {
        id: 'fabric.atlassianSwitcher.errorHeadingUnverified',
        defaultMessage: 'Your account is unverified',
        description: 'Heading that is displayed when we detect user account is unverified.'
    },
    errorPartialResults: {
        id: 'fabric.atlassianSwitcher.errorPartialResults',
        defaultMessage: "We can't display some of your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and 1 or more sites'
    },
    errorPartialResultsRefresh: {
        id: 'fabric.atlassianSwitcher.errorPartialResultsRefresh',
        defaultMessage: 'Refresh the page, or try again later.',
        description: 'Subtitle of the error message when available products returns a partial result'
    },
    errorTextUnverified: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified',
        defaultMessage: 'Please confirm your email address to view a list of available products.',
        description: 'Text that is displayed when we detect user account is unverified.'
    },
    productDescriptionConfluence: {
        id: 'fabric.atlassianSwitcher.product.description.confluence',
        defaultMessage: 'Document collaboration',
        description: 'Text displayed under the Confluence product recommendation.'
    },
    productDescriptionJiraServiceManagement: {
        id: 'fabric.atlassianSwitcher.product.description.jsm',
        defaultMessage: 'Collaborative IT service management',
        description: 'Text displayed under the Jira Service Management product recommendation.'
    },
    productDescriptionJiraSoftware: {
        id: 'fabric.atlassianSwitcher.product.description.jsw',
        defaultMessage: 'Project and issue tracking',
        description: 'Text displayed under the Jira Software product recommendation.'
    },
    productDescriptionOpsgenie: {
        id: 'fabric.atlassianSwitcher.product.description.opsgenie',
        defaultMessage: 'Modern incident management',
        description: 'Text displayed under the Opsgenie product recommendation.'
    },
    productDescriptionCompass: {
        id: 'fabric.atlassianSwitcher.product.description.compass',
        defaultMessage: 'Component manager',
        description: 'Text displayed under the Compass product recommendation.'
    },
    join: {
        id: 'fabric.atlassianSwitcher.join',
        defaultMessage: 'Join',
        description: 'Section Header in Atlassian Switcher. To set the expectation of what items would be shown in following section. Shown when an user has at least one joinable site via Domain Enabled Sign up with common collaborators.'
    },
    expandProductList: {
        id: 'fabric.atlassianSwitcher.expandProductList',
        defaultMessage: '{numItems} more',
        description: 'Text for the button that expands the product list in the Atlassian Switcher.'
    },
    collapseProductList: {
        id: 'fabric.atlassianSwitcher.contractProductList',
        defaultMessage: 'Less',
        description: 'Text for the button that collapses the product list in the Atlassian Switcher.'
    },
    emptyStateExploreProductsBodyAppify: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body-appify',
        defaultMessage: 'Try an app to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLinkAppify: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link-appify',
        defaultMessage: 'Explore apps',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    errorTextUnverifiedAppify: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified-appify',
        defaultMessage: 'Please confirm your email address to view a list of available apps.',
        description: 'Text that is displayed when we detect user account is unverified.'
    },
    customLinksSectionTitle: {
        id: 'fabric.atlassianSwitcher.customLinksSectionTitle',
        defaultMessage: 'Custom links',
        description: 'Title of the collapsible custom links section in the App Switcher, shown on the section header.'
    },
    thirdPartySectionTitle: {
        id: 'fabric.atlassianSwitcher.thirdPartySectionTitle',
        defaultMessage: 'Integrations',
        description: 'Title of the collapsible third-party apps section in the App Switcher, shown on the section header.'
    },
    sitesSectionLabel: {
        id: 'fabric.atlassianSwitcher.sitesSectionLabel',
        defaultMessage: 'Sites',
        description: 'Label shown above the list of connected sites for a product in the App Switcher, when the product is available on more than one site.'
    }
});
var $78e8b2c733039933$export$2e2bcd8739ae039 = $78e8b2c733039933$var$messages;

});

parcelRegister("8oxXB", function(module, exports) {
$parcel$export(module.exports, "formatLabel", () => $fe60e2c1731bed1b$export$957d7daebd899f12);
$parcel$export(module.exports, "formatDescription", () => $fe60e2c1731bed1b$export$f731e929548061dc);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $ECZQy = parcelRequire("ECZQy");
const $fe60e2c1731bed1b$export$957d7daebd899f12 = (label)=>{
    return typeof label === 'string' ? label : /*#__PURE__*/ (0, $5chsV.jsx)((0, $ECZQy.default), {
        ...label
    });
};
const $fe60e2c1731bed1b$export$f731e929548061dc = (description)=>{
    return typeof description === 'string' ? description : description ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $ECZQy.default), {
        ...description
    }) : null;
};

});


parcelRegister("3OKZq", function(module, exports) {
$parcel$export(module.exports, "AvailableProductsProvider", () => $7926e8af47f8e4e7$export$4c169257ef988618);
$parcel$export(module.exports, "prefetchAvailableProducts", () => $7926e8af47f8e4e7$export$1c5684a3ba697d80);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $hTfO1 = parcelRequire("hTfO1");
const { fetchMethod: $7926e8af47f8e4e7$var$fetchAppSwitcherBffAvailableProducts, ProviderComponent: $7926e8af47f8e4e7$var$DefaultBffDataProviderComponent } = (0, $hTfO1.createAppSwitcherBffAvailableProductsProvider)();
const $7926e8af47f8e4e7$export$4c169257ef988618 = ({ cloudId: cloudId, product: product, children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)($7926e8af47f8e4e7$var$DefaultBffDataProviderComponent, {
        cloudId: cloudId,
        product: product,
        children: children
    });
$7926e8af47f8e4e7$export$4c169257ef988618.displayName = "AvailableProductsProvider";
const $7926e8af47f8e4e7$export$1c5684a3ba697d80 = $7926e8af47f8e4e7$var$fetchAppSwitcherBffAvailableProducts;
const $7926e8af47f8e4e7$export$cd9fc41c59711bdd = ()=>$7926e8af47f8e4e7$var$fetchAppSwitcherBffAvailableProducts.reset();

});

parcelRegister("djlG7", function(module, exports) {
$parcel$export(module.exports, "ThirdPartyProductsProvider", () => $9bc2e6e20c9ff119$export$a7ffda257898c103);
$parcel$export(module.exports, "prefetchThirdPartyProducts", () => $9bc2e6e20c9ff119$export$ba83558707df5bbe);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $kImU5 = parcelRequire("kImU5");
const { fetchMethod: $9bc2e6e20c9ff119$var$fetchAppSwitcherBffThirdPartyProducts, ProviderComponent: $9bc2e6e20c9ff119$var$DefaultBffThirdPartyProductsDataProvider } = (0, $kImU5.createAppSwitcherBffThirdPartyProductsProvider)();
const $9bc2e6e20c9ff119$export$a7ffda257898c103 = ({ cloudId: cloudId, children: children, product: product })=>/*#__PURE__*/ (0, $5chsV.jsx)($9bc2e6e20c9ff119$var$DefaultBffThirdPartyProductsDataProvider, {
        cloudId: cloudId,
        product: product,
        children: children
    });
$9bc2e6e20c9ff119$export$a7ffda257898c103.displayName = "ThirdPartyProductsProvider";
const $9bc2e6e20c9ff119$export$ba83558707df5bbe = $9bc2e6e20c9ff119$var$fetchAppSwitcherBffThirdPartyProducts;
const $9bc2e6e20c9ff119$export$fdb5fe543e39bc7a = ()=>$9bc2e6e20c9ff119$var$fetchAppSwitcherBffThirdPartyProducts.reset();

});
parcelRegister("kImU5", function(module, exports) {
$parcel$export(module.exports, "createAppSwitcherBffThirdPartyProductsProvider", () => $fae417460730a9d2$export$1a41882ddb3a9c38);

var $j3C8w = parcelRequire("j3C8w");

var $74Uz3 = parcelRequire("74Uz3");

var $2nV9c = parcelRequire("2nV9c");
const $fae417460730a9d2$export$7cf62b3dbe96f5e8 = '/gateway/api/app-switcher/api/app-switcher/v1/third-party-products';
const $fae417460730a9d2$export$c39ca0fbc2221bcc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $74Uz3.fetchJsonWithNetworkRetries)(`${$fae417460730a9d2$export$7cf62b3dbe96f5e8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $fae417460730a9d2$export$1a41882ddb3a9c38 = ()=>{
    return (0, $2nV9c.createProviderWithCustomFetchData)('appSwitcherBffThirdPartyProducts', (0, $j3C8w.ExperienceMark).API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS, $fae417460730a9d2$export$c39ca0fbc2221bcc);
};

});


parcelRegister("frdQR", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a7b19df34accacd$export$2e2bcd8739ae039);

var $9HBjC = parcelRequire("9HBjC");
var $8a7b19df34accacd$export$2e2bcd8739ae039 = ()=>{
    (0, $9HBjC.loadAtlassianSwitcher)();
    return (0, $9HBjC.loadGenericSwitcher)();
};

});
parcelRegister("9HBjC", function(module, exports) {
$parcel$export(module.exports, "loadAtlassianSwitcher", () => $f1663701acef09b7$export$6c6894dd831bfacb);
$parcel$export(module.exports, "loadGenericSwitcher", () => $f1663701acef09b7$export$64191a36345a6b2b);
$parcel$export(module.exports, "AtlassianSwitcherLoader", () => $f1663701acef09b7$export$25f16f9fee84a840);
$parcel$export(module.exports, "GenericSwitcherLoader", () => $f1663701acef09b7$export$8c21d1a0c59fc17e);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $lt9IW = parcelRequire("lt9IW");

var $llCao = parcelRequire("llCao");

var $fE39v = parcelRequire("fE39v");

const $f1663701acef09b7$export$6c6894dd831bfacb = ()=>(parcelRequire("7BTHI")).then((module)=>module.default);

const $f1663701acef09b7$export$64191a36345a6b2b = ()=>(parcelRequire("6mmwG")).then((module)=>module.default);

const $f1663701acef09b7$var$AtlassianSwitcherLoaderLazyComponent = /*#__PURE__*/ (0, $fsvuC.lazy)(()=>(parcelRequire("7BTHI")));
Object.assign($f1663701acef09b7$var$AtlassianSwitcherLoaderLazyComponent, {
    displayName: 'lazy(AtlassianSwitcherLoader)'
});
const $f1663701acef09b7$var$AtlassianSwitcherLoaderLoadableComponent = (0, (/*@__PURE__*/$parcel$interopDefault($lt9IW)))({
    loader: $f1663701acef09b7$export$6c6894dd831bfacb,
    loading: ()=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $fE39v.default), {})
});
function $f1663701acef09b7$var$AtlassianSwitcherLoaderWithSuspense(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Suspense), {
        fallback: /*#__PURE__*/ (0, $5chsV.jsx)((0, $fE39v.default), {}),
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($f1663701acef09b7$var$AtlassianSwitcherLoaderLazyComponent, props)
    });
}
$f1663701acef09b7$var$AtlassianSwitcherLoaderWithSuspense.displayName = "AtlassianSwitcherLoaderWithSuspense";
const $f1663701acef09b7$export$25f16f9fee84a840 = (props)=>(0, $llCao.fg)('nike_r19_react_loadable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($f1663701acef09b7$var$AtlassianSwitcherLoaderWithSuspense, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($f1663701acef09b7$var$AtlassianSwitcherLoaderLoadableComponent, props);

const $f1663701acef09b7$var$GenericSwitcherLoaderLazyComponent = /*#__PURE__*/ (0, $fsvuC.lazy)(()=>(parcelRequire("6mmwG")));
Object.assign($f1663701acef09b7$var$GenericSwitcherLoaderLazyComponent, {
    displayName: 'lazy(GenericSwitcherLoader)'
});
const $f1663701acef09b7$var$GenericSwitcherLoaderLoadableComponent = (0, (/*@__PURE__*/$parcel$interopDefault($lt9IW)))({
    loader: $f1663701acef09b7$export$64191a36345a6b2b,
    loading: ()=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $fE39v.default), {})
});
function $f1663701acef09b7$var$GenericSwitcherLoaderWithSuspense(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Suspense), {
        fallback: /*#__PURE__*/ (0, $5chsV.jsx)((0, $fE39v.default), {}),
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($f1663701acef09b7$var$GenericSwitcherLoaderLazyComponent, props)
    });
}
$f1663701acef09b7$var$GenericSwitcherLoaderWithSuspense.displayName = "GenericSwitcherLoaderWithSuspense";
const $f1663701acef09b7$export$8c21d1a0c59fc17e = (props)=>(0, $llCao.fg)('nike_r19_react_loadable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($f1663701acef09b7$var$GenericSwitcherLoaderWithSuspense, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($f1663701acef09b7$var$GenericSwitcherLoaderLoadableComponent, props);

});
parcelRegister("fE39v", function(module, exports) {
$parcel$export(module.exports, "default", () => $416f77366dbd377c$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $oAzkD = parcelRequire("oAzkD");

var $jRYjy = parcelRequire("jRYjy");

var $j3C8w = parcelRequire("j3C8w");
var $cJRdr = parcelRequire("cJRdr");

var $jpESA = parcelRequire("jpESA");
/*
  In the Remote App Switcher, the Skeleton component shows up first as a fallback while the full Remote App Switcher is still loading.
  Since the styles (compiled CSS) are lazy-loaded with the full App Switcher, they are not be ready when the Skeleton appears.
  This causes visual issues where the Skeleton looks broken

  To avoid this, we use inline styles instead. This guarantees that all required styles are applied immediately with the component.
  https://hello.jira.atlassian.cloud/browse/NAVX-676
*/ const $416f77366dbd377c$var$iconSkeleton = /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
    style: {
        display: 'inline-block',
        width: 32,
        height: 32,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-large, 8px)",
        marginRight: "var(--ds-space-100, 8px)"
    }
});
const $416f77366dbd377c$var$lineSkeleton = /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
    style: {
        display: 'inline-block',
        width: 260,
        height: 10,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-small, 4px)"
    }
});
var $416f77366dbd377c$export$2e2bcd8739ae039 = ()=>{
    (0, $cJRdr.useExperienceRenderAndMountMark)((0, $j3C8w.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    const { formatMessage: formatMessage } = (0, $oAzkD.default)();
    const items = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jRYjy.Box), {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            paddingInline: "var(--ds-space-200, 16px)",
            paddingBlock: "var(--ds-space-100, 8px)",
            alignItems: 'center'
        },
        children: [
            $416f77366dbd377c$var$iconSkeleton,
            $416f77366dbd377c$var$lineSkeleton
        ]
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jRYjy.Box), {
        as: "section",
        style: {
            width: '343px',
            height: '80vh'
        },
        role: "alert",
        "aria-label": formatMessage((0, $jpESA.default).skeletonLoaderAriaLabel),
        testId: "skeleton",
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                "aria-hidden": "true",
                style: {
                    paddingInline: "var(--ds-space-200, 16px)",
                    paddingTop: "var(--ds-space-300, 24px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                },
                children: $416f77366dbd377c$var$lineSkeleton
            }),
            items,
            items,
            items
        ]
    });
};

});
parcelRegister("cJRdr", function(module, exports) {
$parcel$export(module.exports, "useExperienceSuccess", () => $8e8bf67ed5c20223$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceRenderAndMountMark", () => $8e8bf67ed5c20223$export$fb30551804b67d63);
/* eslint-disable no-console */ 
var $fsvuC = parcelRequire("fsvuC");

var $a96nq = parcelRequire("a96nq");

var $9gm5E = parcelRequire("9gm5E");
function $8e8bf67ed5c20223$export$675e0d25df38d426(experienceName, customStartTime) {
    const experienceTracker = (0, $9gm5E.useExperienceTracker)();
    (0, $a96nq.useOnceImmediately)(()=>experienceTracker.start(experienceName, customStartTime));
}
function $8e8bf67ed5c20223$export$e94f0da4fc0603c6(experience, attributes) {
    const experienceTracker = (0, $9gm5E.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $fsvuC.useLayoutEffect)(()=>experienceTracker.success(experience, attributes), []);
}
function $8e8bf67ed5c20223$export$fb30551804b67d63(mark) {
    const experienceTracker = (0, $9gm5E.useExperienceTracker)();
    (0, $a96nq.useOnceImmediately)(()=>experienceTracker.markStart(mark));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $fsvuC.useLayoutEffect)(()=>experienceTracker.markEnd(mark), []);
}

});
parcelRegister("a96nq", function(module, exports) {
$parcel$export(module.exports, "useSingleton", () => $2b23cb1ed4df3b70$export$abf4268d2dd55708);
$parcel$export(module.exports, "useOnceImmediately", () => $2b23cb1ed4df3b70$export$ad4f8d0eee7a0e24);

var $fsvuC = parcelRequire("fsvuC");
function $2b23cb1ed4df3b70$export$abf4268d2dd55708(builder) {
    const ref = (0, $fsvuC.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $2b23cb1ed4df3b70$export$ad4f8d0eee7a0e24(callback) {
    const wasCalledRef = (0, $fsvuC.useRef)(false);
    const result = (0, $fsvuC.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}

});


parcelRegister("jpESA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b23ed86912f84cf0$export$2e2bcd8739ae039);

var $54F37 = parcelRequire("54F37");
const $b23ed86912f84cf0$var$messages = (0, $54F37.defineMessages)({
    newLozenge: {
        id: 'fabric.atlassianSwitcher.newLozenge',
        defaultMessage: 'New',
        description: 'The lozenge text for a lozenge indicating a new switcher item'
    },
    tryLozenge: {
        id: 'fabric.atlassianSwitcher.tryLozenge',
        defaultMessage: 'Try',
        description: 'Alternative lozenge text for a lozenge indicating a new switcher item'
    },
    sites: {
        id: 'fabric.atlassianSwitcher.sites',
        defaultMessage: '{productName} {numSites, plural, one {site} other {sites}}',
        description: 'The text of a toggle showing or hiding more site options'
    },
    skeletonLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeletonLoaderAriaLabel',
        defaultMessage: 'The App Switcher is loading',
        description: 'The aria-label for the app switcher skeleton loader primitive'
    },
    skeleton3pLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeleton3pLoaderAriaLabel',
        defaultMessage: 'The App Switcher third party section is loading',
        description: 'The aria-label for the app switcher third party skeleton loader primitive'
    },
    reorderItemDropdown: {
        id: 'fabric.atlassianSwitcher.reorderItemDropdown',
        defaultMessage: 'Reorder menu item',
        description: 'The text of a button to reorder an item in the switcher'
    },
    moveItemUp: {
        id: 'fabric.atlassianSwitcher.moveItemUp',
        defaultMessage: 'Move up',
        description: 'The text of a button to move an item up in the switcher'
    },
    moveItemDown: {
        id: 'fabric.atlassianSwitcher.moveItemDown',
        defaultMessage: 'Move down',
        description: 'The text of a button to move an item down in the switcher'
    },
    moveItemToTop: {
        id: 'fabric.atlassianSwitcher.moveItemToTop',
        defaultMessage: 'Move to top',
        description: 'The text of a button to move an item to the top in the switcher'
    },
    moveItemToBottom: {
        id: 'fabric.atlassianSwitcher.moveItemToBottom',
        defaultMessage: 'Move to bottom',
        description: 'The text of a button to move an item to the bottom in the switcher'
    },
    showMoreSites: {
        id: 'fabric.atlassianSwitcher.showMoreSites',
        defaultMessage: 'Show more',
        description: 'The text of a button that reveals the remaining sites in an expanded switcher item site list'
    },
    showLessSites: {
        id: 'fabric.atlassianSwitcher.showLessSites',
        defaultMessage: 'Show less',
        description: 'The text of a button that collapses the expanded list of sites back to the first few in a switcher item'
    },
    unitDescriptionInfoButton: {
        id: 'fabric.atlassianSwitcher.unitDescriptionInfoButton',
        defaultMessage: 'About {unitName}',
        description: 'The accessible label of an info icon button that reveals a short administrator-written description of the named organisation unit'
    },
    pinOrgOrUnit: {
        id: 'fabric.atlassianSwitcher.pinOrgOrUnit',
        defaultMessage: 'Pin {name}',
        description: 'Accessible label and tooltip for the button that pins an organisation or unit to the top of the app switcher org list. {name} is the organisation or unit name.'
    },
    unpinOrgOrUnit: {
        id: 'fabric.atlassianSwitcher.unpinOrgOrUnit',
        defaultMessage: 'Unpin {name}',
        description: 'Accessible label and tooltip for the button that removes an organisation or unit from the pinned list in the app switcher. {name} is the organisation or unit name.'
    }
});
var $b23ed86912f84cf0$export$2e2bcd8739ae039 = $b23ed86912f84cf0$var$messages;

});


parcelRegister("7BTHI", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("b4uHm").then(()=>parcelRequire('e2SKC'));

});

parcelRegister("6mmwG", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("gNSeR").then(()=>parcelRequire('5ucMR'));

});



parcelRegister("d7rku", function(module, exports) {
$parcel$export(module.exports, "JoinableSitesProvider", () => $f092832241462c95$export$70da68d3b04f82d0);
$parcel$export(module.exports, "prefetchJoinableSites", () => $f092832241462c95$export$2aed3ef1595b4d9);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $fyO9L = parcelRequire("fyO9L");
const { fetchMethod: $f092832241462c95$var$fetchJoinableSites, ProviderComponent: $f092832241462c95$var$DefaultDataProviderComponent } = (0, $fyO9L.createJoinableSitesProvider)();
const $f092832241462c95$export$70da68d3b04f82d0 = ({ children: children, joinableSitesDataProvider: joinableSitesDataProvider, cloudId: cloudId })=>{
    const CustomDataProviderComponent = joinableSitesDataProvider && joinableSitesDataProvider.ProviderComponent;
    const DataProviderComponent = CustomDataProviderComponent || $f092832241462c95$var$DefaultDataProviderComponent;
    return /*#__PURE__*/ (0, $5chsV.jsx)(DataProviderComponent, {
        cloudId: cloudId,
        children: children
    });
};
$f092832241462c95$export$70da68d3b04f82d0.displayName = "JoinableSitesProvider";
const $f092832241462c95$export$2aed3ef1595b4d9 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod({});
        return;
    }
    $f092832241462c95$var$fetchJoinableSites({});
};
const $f092832241462c95$export$4ba2a997caa6db74 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod.reset();
        return;
    }
    $f092832241462c95$var$fetchJoinableSites.reset();
};

});
parcelRegister("fyO9L", function(module, exports) {
$parcel$export(module.exports, "createJoinableSitesProvider", () => $cb1a5913f83b1de2$export$c3b6af53f1ca17d8);

var $2nV9c = parcelRequire("2nV9c");

var $j3C8w = parcelRequire("j3C8w");
const $cb1a5913f83b1de2$export$62986affcccd56a5 = ()=>Promise.resolve({
        sites: undefined
    });
const $cb1a5913f83b1de2$export$c3b6af53f1ca17d8 = (fetchData = $cb1a5913f83b1de2$export$62986affcccd56a5, retryConfig)=>{
    return (0, $2nV9c.createProviderWithCustomFetchData)('joinableSites', (0, $j3C8w.ExperienceMark).API_JOINABLE_SITES, fetchData, retryConfig);
};

});




parcelRegister("kutJa", function(module, exports) {
$parcel$export(module.exports, "experienceTimingsOf", () => $0db13f0fe0c74881$export$3ac4e94b194cd647);
$parcel$export(module.exports, "generateUFOMarkName", () => $0db13f0fe0c74881$export$504463c8409cf4d7);
$parcel$export(module.exports, "setSwitcherRenderStartMark", () => $0db13f0fe0c74881$export$16539b434cec5cfb);
$parcel$export(module.exports, "getSwitcherRenderStartMark", () => $0db13f0fe0c74881$export$436b7aeb93937572);

var $j3C8w = parcelRequire("j3C8w");
function $0db13f0fe0c74881$export$3ac4e94b194cd647(experience) {
    return (0, $j3C8w.EXPERIENCES_TO_MARKS)[experience].map($0db13f0fe0c74881$var$generateUFOTiming);
}
function $0db13f0fe0c74881$var$generateUFOTiming(mark) {
    return {
        key: mark,
        startMark: $0db13f0fe0c74881$export$504463c8409cf4d7(mark, (0, $j3C8w.ExperienceMarkPhase).START),
        endMark: $0db13f0fe0c74881$export$504463c8409cf4d7(mark, (0, $j3C8w.ExperienceMarkPhase).END)
    };
}
const $0db13f0fe0c74881$export$504463c8409cf4d7 = (mark, phase)=>`${mark}_${phase}`;
const $0db13f0fe0c74881$export$16539b434cec5cfb = ()=>{
    performance.mark((0, $j3C8w.SWITCHER_RENDER_START_PERFORMANCE_MARK));
};
const $0db13f0fe0c74881$export$436b7aeb93937572 = ()=>{
    const renderStartPerformanceMarks = performance.getEntriesByName ? performance.getEntriesByName((0, $j3C8w.SWITCHER_RENDER_START_PERFORMANCE_MARK)) : [];
    return renderStartPerformanceMarks[renderStartPerformanceMarks.length - 1]?.startTime;
};

});

parcelRegister("4F56e", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b528675bed98b69$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $hMTg4 = parcelRequire("hMTg4");
var $oAzkD = parcelRequire("oAzkD");


var $mhEfz = parcelRequire("mhEfz");

var $6QsiP = parcelRequire("6QsiP");

var $fE39v = parcelRequire("fE39v");






























function $6b528675bed98b69$var$fetchLanguageFile(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("eTNjt"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("jiq0i"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("hNFkd"));
        case 'en-GB':
            return (parcelRequire("c1i43"));
        case 'en-ZZ':
            return (parcelRequire("5oVLu"));
        case 'en-US':
        case 'en':
            return (parcelRequire("hruop"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("cloCS"));
        case 'et':
            return (parcelRequire("dtDxJ"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("fbpLb"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("4znHV"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("aHdGg"));
        case 'is':
            return (parcelRequire("7jtVX"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("7aZUu"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("lVFeD"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("aSDW5"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("6qr6Y"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("lnzcB"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("gsy8L"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("28ObF"));
        case 'pt-PT':
            return (parcelRequire("hmQGC"));
        case 'ro':
            return (parcelRequire("2qW0i"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("kzux8"));
        case 'sk':
            return (parcelRequire("8qPnD"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("1SCtr"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("2AmdB"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("1Ct4D"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("8CtUW"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("Y5q5R"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("c7O65"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("9WpNs"));
    }
    throw Error(`Unable to find translation for locale ${locale}`);
}
const $6b528675bed98b69$var$SwitcherIntlProvider = ({ children: children })=>{
    const { locale: locale } = (0, $oAzkD.default)();
    // Intl.Locale doesn't like underscores
    const [isLocaleLoaded, setIsLocaleLoaded] = (0, $fsvuC.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    const [localeMessages, setLocaleMessages] = (0, $fsvuC.useState)({});
    (0, $fsvuC.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const intlLocale = new Intl.Locale(locale.replace('_', '-'));
            try {
                const module = await $6b528675bed98b69$var$fetchLanguageFile(intlLocale.toString());
                const newMessages = module.default || module;
                setLocaleMessages(newMessages);
                setIsLocaleLoaded(true);
            } catch  {
                // fail to download message and do nothing because UI will use default language (English) to render
                setIsLocaleLoaded(true);
                createAnalyticsEvent({
                    eventType: (0, $ddd31af8f515fa50$export$12346a674644c156),
                    action: 'not_loaded',
                    actionSubject: 'i18n',
                    attributes: {
                        country: intlLocale.region,
                        language: intlLocale.language
                    }
                }).fire((0, $6QsiP.NAVIGATION_CHANNEL));
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale,
        createAnalyticsEvent
    ]);
    // delay loading until we have attempted to load the locale data otherwise we can flicker from English to the user's language
    if (!isLocaleLoaded) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fE39v.default), {});
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hMTg4.default), {
        locale: locale,
        messages: localeMessages,
        children: children
    }, locale);
};
$6b528675bed98b69$var$SwitcherIntlProvider.displayName = "SwitcherIntlProvider";
var $6b528675bed98b69$export$2e2bcd8739ae039 = $6b528675bed98b69$var$SwitcherIntlProvider;

});
parcelRegister("eTNjt", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("eVoZN").then(()=>parcelRequire('3Aax9'));

});

parcelRegister("jiq0i", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("6qB0D").then(()=>parcelRequire('1z69x'));

});

parcelRegister("hNFkd", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("7hOwM").then(()=>parcelRequire('9OiGE'));

});

parcelRegister("c1i43", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("j4Uqr").then(()=>parcelRequire('bttXA'));

});

parcelRegister("5oVLu", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("1U4J3").then(()=>parcelRequire('4gqZH'));

});

parcelRegister("hruop", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("kDAfU").then(()=>parcelRequire('20SV5'));

});

parcelRegister("cloCS", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("8OeIv").then(()=>parcelRequire('iB40J'));

});

parcelRegister("dtDxJ", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("3Hp2a").then(()=>parcelRequire('c9kdo'));

});

parcelRegister("fbpLb", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("4pT7Q").then(()=>parcelRequire('9AZ7v'));

});

parcelRegister("4znHV", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("4VwQ2").then(()=>parcelRequire('l5G5w'));

});

parcelRegister("aHdGg", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("aLInO").then(()=>parcelRequire('4dlPM'));

});

parcelRegister("7jtVX", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("9Qd2e").then(()=>parcelRequire('h6Gbc'));

});

parcelRegister("7aZUu", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("68TP3").then(()=>parcelRequire('9pXzy'));

});

parcelRegister("lVFeD", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("kPmuz").then(()=>parcelRequire('6moKP'));

});

parcelRegister("aSDW5", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("eC9Fl").then(()=>parcelRequire('a2wZT'));

});

parcelRegister("6qr6Y", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("3pfXR").then(()=>parcelRequire('elBr9'));

});

parcelRegister("lnzcB", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("6c0wZ").then(()=>parcelRequire('5eToo'));

});

parcelRegister("gsy8L", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("k0k34").then(()=>parcelRequire('ezGq2'));

});

parcelRegister("28ObF", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("iKmrJ").then(()=>parcelRequire('fTLGO'));

});

parcelRegister("hmQGC", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("8lTDh").then(()=>parcelRequire('7vlV3'));

});

parcelRegister("2qW0i", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("kO9v1").then(()=>parcelRequire('gefu6'));

});

parcelRegister("kzux8", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("3tTgH").then(()=>parcelRequire('8zjCO'));

});

parcelRegister("8qPnD", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("41xPS").then(()=>parcelRequire('htEGD'));

});

parcelRegister("1SCtr", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("fE2fI").then(()=>parcelRequire('b76kU'));

});

parcelRegister("2AmdB", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("fmo8K").then(()=>parcelRequire('f98wp'));

});

parcelRegister("1Ct4D", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("3uquC").then(()=>parcelRequire('gEngH'));

});

parcelRegister("8CtUW", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("8EtyK").then(()=>parcelRequire('cHFIv'));

});

parcelRegister("Y5q5R", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("3Ps23").then(()=>parcelRequire('h57N0'));

});

parcelRegister("c7O65", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("kubaY").then(()=>parcelRequire('cg4dB'));

});

parcelRegister("9WpNs", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("dc4kb").then(()=>parcelRequire('aafxU'));

});


parcelRegister("5TWOC", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5faa928411f6ae6$export$2e2bcd8739ae039);

var $54F37 = parcelRequire("54F37");
const $e5faa928411f6ae6$var$messages = (0, $54F37.defineMessages)({
    switchToTitle: {
        id: 'fabric.atlassianSwitcher.switchToTitle',
        defaultMessage: 'Apps',
        description: 'The title of the apps section in the App Switcher.'
    },
    switchSitesOrAppsTooltip: {
        id: 'fabric.atlassianSwitcher.switchSitesOrAppsTooltip',
        defaultMessage: 'Switch sites or apps',
        description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
    },
    tenantlessTopOrgSwitcherText: {
        id: 'fabric.atlassianSwitcher.tenantlessTopOrgSwitcherText',
        defaultMessage: 'Select organisation',
        description: 'The text of the organisation switcher item when no organisation is selected'
    },
    switcherModalLabel: {
        id: 'fabric.atlassianSwitcher.modalLabel',
        defaultMessage: 'Atlassian App Switcher',
        description: 'The label of the switcher modal'
    },
    joinStatusText: {
        id: 'fabric.atlassianSwitcher.joinStatusText',
        defaultMessage: 'Join',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    instantAccessStatusText: {
        id: 'fabric.atlassianSwitcher.instantAccessStatusText',
        defaultMessage: 'Instant access',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    joinTeamStatusText: {
        id: 'fabric.atlassianSwitcher.joinTeamStatusText',
        defaultMessage: 'Join team',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    jpdDescriptionText: {
        id: 'fabric.atlassianSwitcher.jpdDescriptionText',
        defaultMessage: 'Prioritize and plan new ideas',
        description: 'The description displayed for Jira Product Discovery.'
    },
    confluenceDescriptionText: {
        id: 'fabric.atlassianSwitcher.confluenceDescriptionText',
        defaultMessage: 'Document and collaborate',
        description: 'The description displayed for Confluence.'
    },
    jiraDescriptionText: {
        id: 'fabric.atlassianSwitcher.jiraDescriptionText',
        defaultMessage: 'Plan and track project delivery',
        description: 'The description displayed for Jira.'
    },
    jsmDescriptionText: {
        id: 'fabric.atlassianSwitcher.jsmDescriptionText',
        defaultMessage: 'Automate and deliver IT support',
        description: 'The description displayed for Jira Service Management.'
    },
    requestSentStatusText: {
        id: 'fabric.atlassianSwitcher.requestSentStatusText',
        defaultMessage: 'Request sent',
        description: 'The text displayed alongside a product to indicate the user has requested access to the product.'
    },
    requestAccessPendingRequestFlagTitle: {
        id: 'fabric.atlassianSwitcher.successFlag.title',
        defaultMessage: 'Access request sent to Admin',
        description: 'Title shown when user has requested access to a product but the request is pending.'
    },
    requestAccessPendingRequestFlagDescription: {
        id: 'fabric.atlassianSwitcher.successFlag.description',
        defaultMessage: "You'll get an email once it's approved",
        description: 'Description shown when user has requested access to a product but the request is pending'
    },
    requestAccessPendingRequestFlagErrorTitle: {
        id: 'fabric.atlassianSwitcher.errorFlag.title',
        defaultMessage: `We couldn't add you to {product}`,
        description: 'Title shown when user has requested access to a product but the request has failed.'
    },
    requestAccessPendingRequestFlagErrorDescription: {
        id: 'fabric.atlassianSwitcher.errorFlag.description',
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, <a>contact support</a>.",
        description: 'Description shown when user has requested access to a product but the request is pending'
    },
    reorderItemErrorFlagTitle: {
        id: 'fabric.atlassianSwitcher.reorderItemErrorFlagTitle',
        defaultMessage: 'Something went wrong',
        description: 'The title of the error flag for reordering items in the switcher'
    },
    reorderItemErrorFlagDescription: {
        id: 'fabric.atlassianSwitcher.reorderItemErrorFlagDescription',
        defaultMessage: 'Please refresh the page or try again later.',
        description: 'The description of the error flag for reordering items in the switcher'
    },
    reorderItemErrorFlagAction: {
        id: 'fabric.atlassianSwitcher.reorderItemErrorFlagAction',
        defaultMessage: 'Got it',
        description: 'The action of the error flag for reordering items in the switcher'
    },
    jiraDescriptionTextGalaxia: {
        id: 'fabric.atlassianSwitcher.jiraDescriptionText-galaxia',
        defaultMessage: 'Plan and track project delivery',
        description: 'The description displayed for Jira.'
    },
    otherSectionOfOrgSwitcher: {
        id: 'fabric.atlassianSwitcher.otherSectionOfOrgSwitcher',
        defaultMessage: 'Other',
        description: 'Text displayed as the title of the other section of the org switcher.'
    },
    orgUnitSelectorMenuLabel: {
        id: 'fabric.atlassianSwitcher.orgUnitSelectorMenuLabel',
        defaultMessage: 'Organisations and units',
        description: 'Accessible label for the inline-expanded org/unit selector panel, read by assistive technology when it opens below the trigger.'
    },
    expandOrgUnitList: {
        id: 'fabric.atlassianSwitcher.expandOrgUnitList',
        defaultMessage: '{numItems, plural, one {# more} other {# more}}',
        description: 'Text for the button that reveals the organisations and units hidden by the pinned-only view of the app switcher org list. {numItems} is how many are hidden.'
    },
    collapseOrgUnitList: {
        id: 'fabric.atlassianSwitcher.collapseOrgUnitList',
        defaultMessage: 'Show less',
        description: 'Text for the button that collapses the full organisation and unit list back to only the pinned ones in the app switcher.'
    }
});
var $e5faa928411f6ae6$export$2e2bcd8739ae039 = $e5faa928411f6ae6$var$messages;

});

parcelRegister("8IsnD", function(module, exports) {
$parcel$export(module.exports, "UnitTile", () => $41fb41a9d4f245ce$export$288d51ea26b988c2);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $eBgj8 = parcelRequire("eBgj8");

var $dwUnm = parcelRequire("dwUnm");

var $jRYjy = parcelRequire("jRYjy");

var $9FNmU = parcelRequire("9FNmU");

var $lptwE = parcelRequire("lptwE");
// ─── Shared ──────────────────────────────────────────────────────────────────
const $41fb41a9d4f245ce$var$boxStyles = {
    xsmall: "_0bjKvD042k _2sNsIg7NXe _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _39xV02SPN1 _0jFU0VSPN1 _1kk5Tkf7mX",
    small: "_0bjKvDy67O _2sNsIg7NXe _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg _1kk5Tkf7mX",
    medium: "_0bjKvDBSbZ _2sNsIgmnOE _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _39xV02Uofl _0jFU0VUofl _1kk5Tkf7mX",
    large: "_0bjKvDX7GY _2sNsIgxzFw _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _39xV02pJKa _0jFU0VpJKa _1kk5Tkf7mX"
};
const $41fb41a9d4f245ce$var$FALLBACK_TESTID = 'unit-tile';
const $41fb41a9d4f245ce$var$sandboxUnitStyles = {
    grayscale: "_2V7sgONvrM _3hxITi6wH8 _3vBAKHtT36 _1llTr6MFyn _24h04i2Njc"
};
// ─── UnitTileImage ────────────────────────────────────────────────────────────
const $41fb41a9d4f245ce$var$imageHighlightedStyles = {
    overlay: "_1mT5xdRAKS _0EnhYgdnbC _2Gfj6iOLYo _0GBAIrogpp _2WYcYGWVPG _3wEj0XKcZT"
};
const $41fb41a9d4f245ce$var$imageLoadingStyles = {
    container: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS",
    overlay: "_49OCfRdnbC _1mT5xdWVPG"
};
function $41fb41a9d4f245ce$var$UnitTileLoadingSkeleton({ size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
        xcss: (0, $dwUnm.cx)($41fb41a9d4f245ce$var$boxStyles[size], $41fb41a9d4f245ce$var$imageLoadingStyles.container),
        testId: `${testId}-loading-skeleton`,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $eBgj8.default), {
            appearance: "square",
            size: size
        })
    });
}
$41fb41a9d4f245ce$var$UnitTileLoadingSkeleton.displayName = "UnitTileLoadingSkeleton";
function $41fb41a9d4f245ce$var$UnitTileImage({ unitName: unitName, size: size, iconUrl: iconUrl, isDecorative: isDecorative, isHighlighted: isHighlighted, isSandboxUnit: isSandboxUnit, sizes: sizes, srcSet: srcSet, testId: testId, onError: onError, onLoad: onLoad, showLoadingState: showLoadingState }) {
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jRYjy.Box), {
        xcss: (0, $dwUnm.cx)($41fb41a9d4f245ce$var$boxStyles[size], $41fb41a9d4f245ce$var$imageLoadingStyles.container, isHighlighted ? $41fb41a9d4f245ce$var$imageHighlightedStyles.overlay : undefined, isSandboxUnit ? $41fb41a9d4f245ce$var$sandboxUnitStyles.grayscale : undefined),
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)("img", {
                src: iconUrl,
                srcSet: srcSet,
                sizes: sizes,
                alt: unitName,
                "aria-hidden": isDecorative ? true : undefined,
                onError: onError,
                onLoad: onLoad,
                /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- borderRadius: inherit requires inline style; cannot use cssMap for inherited values */ style: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: 'inherit',
                    opacity: showLoadingState ? 0 : 1
                }
            }),
            showLoadingState && /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                xcss: $41fb41a9d4f245ce$var$imageLoadingStyles.overlay,
                testId: `${testId}-loading-skeleton`,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $eBgj8.default), {
                    appearance: "square",
                    size: size
                })
            })
        ]
    });
}
$41fb41a9d4f245ce$var$UnitTileImage.displayName = "UnitTileImage";
// ─── UnitTileAbbreviation ─────────────────────────────────────────────────────
const $41fb41a9d4f245ce$var$backgroundColorStyles = {
    purple: "_0KLXruB8KG",
    blue: "_0KLXruVva3",
    lime: "_0KLXruXL80",
    yellow: "_0KLXru56u3"
};
const $41fb41a9d4f245ce$var$highlightedBackgroundColorStyles = {
    purple: "_0KLXrueJK9",
    blue: "_0KLXruotmK",
    lime: "_0KLXruL7r8",
    yellow: "_0KLXruBwZU"
};
const $41fb41a9d4f245ce$var$textColorStyles = {
    purple: "_1UtDYzXCFT",
    blue: "_1UtDYz802h",
    lime: "_1UtDYzfXoY",
    yellow: "_1UtDYzD7aB"
};
function $41fb41a9d4f245ce$var$UnitTileAbbreviation({ unitName: unitName, size: size, isHighlighted: isHighlighted, isSandboxUnit: isSandboxUnit, testId: testId }) {
    const variant = (0, $lptwE.getVariant)(unitName);
    const displayInitials = (0, $lptwE.getAbbreviation)(unitName);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
        xcss: (0, $dwUnm.cx)($41fb41a9d4f245ce$var$boxStyles[size], $41fb41a9d4f245ce$var$backgroundColorStyles[variant], isHighlighted ? $41fb41a9d4f245ce$var$highlightedBackgroundColorStyles[variant] : undefined, isSandboxUnit ? $41fb41a9d4f245ce$var$sandboxUnitStyles.grayscale : undefined),
        testId: testId,
        "data-variant": variant,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
            as: "span",
            "aria-hidden": "true",
            xcss: $41fb41a9d4f245ce$var$textColorStyles[variant],
            children: displayInitials
        })
    });
}
$41fb41a9d4f245ce$var$UnitTileAbbreviation.displayName = "UnitTileAbbreviation";
function $41fb41a9d4f245ce$export$288d51ea26b988c2({ unitName: unitName, size: size, iconUrl: iconUrl, icons: icons, isDecorative: isDecorative, isHighlighted: isHighlighted, isSandboxUnit: isSandboxUnit, testId: testId, isIconLoading: isIconLoading }) {
    const resolvedTestId = testId ?? $41fb41a9d4f245ce$var$FALLBACK_TESTID;
    // Signed icon URLs can expire after rendering; fall back to initials for a failed URL, while allowing a new URL to retry.
    const [failedIconUrl, setFailedIconUrl] = (0, $fsvuC.useState)();
    // Tracks native image loading
    const [loadedIconUrl, setLoadedIconUrl] = (0, $fsvuC.useState)();
    // Renditions win when usable, since only they can be matched to the rendered size.
    // Falling through to `iconUrl` keeps callers that have no renditions unchanged.
    const iconSources = (0, $9FNmU.resolveIconSources)(icons, size);
    const resolvedIconUrl = iconSources.src ?? iconUrl;
    // Keyed off the URL actually rendered, so an expired rendition falls back to
    // initials just as an expired `iconUrl` does.
    const hasFailedImage = failedIconUrl === resolvedIconUrl;
    const displayedIconUrl = hasFailedImage ? undefined : resolvedIconUrl;
    const isImageLoading = Boolean(displayedIconUrl) && loadedIconUrl !== displayedIconUrl;
    const showSkeleton = isIconLoading || isImageLoading;
    if (!displayedIconUrl) {
        if (showSkeleton) return /*#__PURE__*/ (0, $5chsV.jsx)($41fb41a9d4f245ce$var$UnitTileLoadingSkeleton, {
            size: size,
            testId: resolvedTestId
        });
        return /*#__PURE__*/ (0, $5chsV.jsx)($41fb41a9d4f245ce$var$UnitTileAbbreviation, {
            unitName: unitName,
            size: size,
            isHighlighted: isHighlighted,
            isSandboxUnit: isSandboxUnit,
            testId: resolvedTestId
        });
    }
    return /*#__PURE__*/ (0, $5chsV.jsx)($41fb41a9d4f245ce$var$UnitTileImage, {
        unitName: unitName,
        size: size,
        iconUrl: displayedIconUrl,
        srcSet: iconSources.srcSet,
        sizes: iconSources.sizes,
        // Treat a failed image as no icon so the existing initials tile is rendered.
        onError: ()=>setFailedIconUrl(displayedIconUrl),
        onLoad: ()=>setLoadedIconUrl(displayedIconUrl),
        showLoadingState: showSkeleton,
        isDecorative: isDecorative,
        isHighlighted: isHighlighted,
        isSandboxUnit: isSandboxUnit,
        testId: resolvedTestId
    });
}
$41fb41a9d4f245ce$export$288d51ea26b988c2.displayName = "UnitTile";

});
parcelRegister("9FNmU", function(module, exports) {
$parcel$export(module.exports, "resolveIconSources", () => $2a4651bfb8aed977$export$56f7c7688e1ed157);

var $aYHjR = parcelRequire("aYHjR");
function $2a4651bfb8aed977$export$56f7c7688e1ed157(icons, size) {
    // Width descriptors are meaningless without a positive width, and renditions are
    // typically server-supplied, so normalise before trusting the payload. Keying by
    // width also drops duplicates, which the browser would ignore anyway.
    const byWidth = new Map();
    for (const icon of icons ?? []){
        const isUsable = Boolean(icon?.url) && Number.isFinite(icon?.width) && icon.width > 0;
        if (isUsable && !byWidth.has(icon.width)) byWidth.set(icon.width, icon.url);
    }
    if (byWidth.size === 0) return {};
    const candidates = [
        ...byWidth.entries()
    ].sort(([a], [b])=>a - b);
    const renderedPx = (0, $aYHjR.UNIT_TILE_SIZE_PX)[size];
    // `src` is just the fallback for anything that ignores `srcSet`, but it also
    // drives the tile's load/error handling, so point it at the smallest rendition
    // that still covers the tile. If every rendition is smaller, the largest is the
    // closest available.
    const [, fallbackUrl] = candidates.find(([width])=>width >= renderedPx) ?? candidates[candidates.length - 1];
    return {
        src: fallbackUrl,
        srcSet: candidates.map(([width, url])=>`${url} ${width}w`).join(', '),
        sizes: `${renderedPx}px`
    };
}

});
parcelRegister("aYHjR", function(module, exports) {
$parcel$export(module.exports, "UNIT_TILE_SIZE_PX", () => $89cbe3b6eb33aede$export$61ee162ef692854e);
const $89cbe3b6eb33aede$export$61ee162ef692854e = {
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 48
};

});


parcelRegister("lptwE", function(module, exports) {
$parcel$export(module.exports, "getAbbreviation", () => $c0fff13ab110c1af$export$6907d3f19a659b76);
$parcel$export(module.exports, "getVariant", () => $c0fff13ab110c1af$export$2d101db3c1e74fd1);
const $c0fff13ab110c1af$var$VARIANTS = [
    'purple',
    'blue',
    'lime',
    'yellow'
];
function $c0fff13ab110c1af$export$6907d3f19a659b76(unitName) {
    const initials = unitName.toLowerCase().split(/[\s-]+/) // Split by spaces and hyphens
    .filter((w)=>/^[a-z0-9]/.test(w)) // Filter out non-alphanumeric words (e.g. &, +)
    .map((w)=>w[0]) // Keep only the first letter of each word
    .join('').slice(0, 2); // Cap at 2 characters
    return initials.charAt(0).toUpperCase() + initials.slice(1); // Capitalise first letter
}
function $c0fff13ab110c1af$export$2d101db3c1e74fd1(unitName) {
    const charCodes = unitName.split('').reduce((a, b)=>a + b.charCodeAt(0), 0);
    return $c0fff13ab110c1af$var$VARIANTS[charCodes % $c0fff13ab110c1af$var$VARIANTS.length];
}

});


parcelRegister("bbxsm", function(module, exports) {
$parcel$export(module.exports, "createUnitTileAppSwitcherIcon", () => $eba9982d1cf205ef$export$c3993ea44ff06ff1);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $8IsnD = parcelRequire("8IsnD");
function $eba9982d1cf205ef$export$c3993ea44ff06ff1(unitProfile) {
    return function UnitTileAppSwitcherIcon({ testId: testId }) {
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $8IsnD.UnitTile), {
            unitName: unitProfile.unitName,
            iconUrl: unitProfile.unitIconUrl ?? undefined,
            size: "small",
            testId: testId
        });
    };
}

});

parcelRegister("3cQdo", function(module, exports) {
$parcel$export(module.exports, "SwitchToTooltipText", () => $1e3f814bf78c9485$export$c5ef4d14b7e18cbd);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $ECZQy = parcelRequire("ECZQy");

var $4F56e = parcelRequire("4F56e");

var $5TWOC = parcelRequire("5TWOC");
const $1e3f814bf78c9485$export$c5ef4d14b7e18cbd = /*#__PURE__*/ (0, $5chsV.jsx)((0, $4F56e.default), {
    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ECZQy.default), {
        ...(0, $5TWOC.default).switchSitesOrAppsTooltip
    })
});

});

parcelRegister("jiRQy", function(module, exports) {
$parcel$export(module.exports, "RovoSettingsModal", () => $22292163b64e8f50$export$f2c3f3e62df426ba);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $jY9mG = parcelRequire("jY9mG");

var $oAzkD = parcelRequire("oAzkD");

var $fm5Zq = parcelRequire("fm5Zq");

var $jRYjy = parcelRequire("jRYjy");

var $jR7Rq = parcelRequire("jR7Rq");

var $3OsKS = parcelRequire("3OsKS");

var $9jkYU = parcelRequire("9jkYU");
const $22292163b64e8f50$var$triggerStyles = {
    button: "_23rrnHyKLB _3hxITiYbGa _0Of8r22ADO _1wydGW2ADO _2Zuz6Q5zaO _1Znuxb5zaO _0KLXruyL8i _0wOv4Q7zJH _39xV02N91d _1eOmH6o126",
    text: "_2sNsIg7NXe _1UtDYzKGUX"
};
const $22292163b64e8f50$var$DefaultTrigger = ({ open: open })=>{
    const { formatMessage: formatMessage } = (0, $oAzkD.default)();
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3OsKS.Pressable), {
        xcss: $22292163b64e8f50$var$triggerStyles.button,
        onClick: ()=>open(),
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jR7Rq.Flex), {
            alignItems: "center",
            gap: "space.075",
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fm5Zq))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)"
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                    xcss: $22292163b64e8f50$var$triggerStyles.text,
                    children: formatMessage((0, $9jkYU.messages).defaultTriggerLabel)
                })
            ]
        })
    });
};
$22292163b64e8f50$var$DefaultTrigger.displayName = "DefaultTrigger";

const $22292163b64e8f50$var$LazyRovoSettingsModalProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).lazy(()=>(parcelRequire("biVSC")).then((mod)=>({
            default: mod.RovoSettingsModalLazy
        })));
const $22292163b64e8f50$export$f2c3f3e62df426ba = ({ children: renderTrigger, ...providerProps })=>{
    const [isActivated, setIsActivated] = (0, $fsvuC.useState)(false);
    const pendingOpenOptions = (0, $fsvuC.useRef)(undefined);
    const openModalRef = (0, $fsvuC.useRef)(null);
    const open = (0, $fsvuC.useCallback)((options)=>{
        if (openModalRef.current) // Provider already mounted — open directly
        openModalRef.current(options);
        else {
            // First click — store options and mount the provider
            pendingOpenOptions.current = options;
            setIsActivated(true);
        }
    }, []);
    // Calling the render function directly (rather than mounting it as a
    // component) makes React diff the returned JSX in-place against the previous
    // render, so the trigger element survives parent re-renders even if the
    // render function's identity changes (e.g. inline arrows).
    const triggerNode = renderTrigger ? renderTrigger({
        open: open
    }) : /*#__PURE__*/ (0, $5chsV.jsx)($22292163b64e8f50$var$DefaultTrigger, {
        open: open
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jY9mG.ErrorBoundary), {
        fallbackRender: ()=>null,
        children: [
            triggerNode,
            isActivated && /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $5chsV.jsx)($22292163b64e8f50$var$LazyRovoSettingsModalProvider, {
                    ...providerProps,
                    pendingOpenOptions: pendingOpenOptions,
                    openModalRef: openModalRef
                })
            })
        ]
    });
};
$22292163b64e8f50$export$f2c3f3e62df426ba.displayName = "RovoSettingsModal";

});
parcelRegister("9jkYU", function(module, exports) {
$parcel$export(module.exports, "messages", () => $6c68fa4be81a67f9$export$defe85febe8b728c);

var $54F37 = parcelRequire("54F37");
const $6c68fa4be81a67f9$export$defe85febe8b728c = (0, $54F37.defineMessages)({
    modalTitle: {
        id: 'ai-mate.rovo-settings-modal.portable-rovo-settings.modal-title.non-final',
        defaultMessage: 'Sources & apps',
        description: 'Title of the Rovo Settings modal dialog'
    },
    searchPlaceholder: {
        id: 'ai-mate.rovo-settings-modal.portable-rovo-settings.search-placeholder.non-final',
        defaultMessage: 'Search settings',
        description: 'Placeholder for the search box in the Rovo Settings modal side nav'
    },
    defaultTriggerLabel: {
        id: 'ai-mate.rovo-settings-modal.portable-rovo-settings.default-trigger-label.non-final',
        defaultMessage: 'Explore all apps',
        description: 'Label for the default button that opens the Rovo Settings modal'
    }
});

});

parcelRegister("biVSC", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = Promise.all([
    $dk4lR("a1CVM"),
    $dk4lR("5h6rP"),
    $dk4lR("35prZ")
]).then(()=>parcelRequire('joRlf'));

});


parcelRegister("ktnDV", function(module, exports) {
$parcel$export(module.exports, "RovoSettingsModalSurface", () => $2db775165b11adf7$export$bc9ec39841ba8fd3);
$parcel$export(module.exports, "RovoSettingsConfigProvider", () => $2db775165b11adf7$export$e6e0575f100c37ab);
$parcel$export(module.exports, "RovoSettingsModalMountedProvider", () => $2db775165b11adf7$export$c32765f1b1c62608);
$parcel$export(module.exports, "useRovoSettingsConfig", () => $2db775165b11adf7$export$db68c798d50f727e);
$parcel$export(module.exports, "useIsRovoSettingsModalProviderMounted", () => $2db775165b11adf7$export$ddb548fa2ffa23a3);

var $fsvuC = parcelRequire("fsvuC");
const $2db775165b11adf7$export$bc9ec39841ba8fd3 = {
    CHAT: 'chat',
    SEARCH_QF_PILL: 'search-qf-connect-apps-pill',
    SEARCH_FPS_CONNECT_APPS_BUTTON: 'search-fps-connect-apps-button'
};
const $2db775165b11adf7$var$initialState = {
    product: '',
    siteId: '',
    experienceId: 'ai-mate',
    assistanceServiceConfig: undefined,
    surface: undefined
};
const $2db775165b11adf7$var$rovoSettingsConfig = /*#__PURE__*/ (0, $fsvuC.createContext)($2db775165b11adf7$var$initialState);
const $2db775165b11adf7$var$rovoSettingsModalMountedContext = /*#__PURE__*/ (0, $fsvuC.createContext)(false);
const $2db775165b11adf7$export$e6e0575f100c37ab = $2db775165b11adf7$var$rovoSettingsConfig.Provider;
const $2db775165b11adf7$export$c32765f1b1c62608 = $2db775165b11adf7$var$rovoSettingsModalMountedContext.Provider;
const $2db775165b11adf7$export$db68c798d50f727e = ()=>(0, $fsvuC.useContext)($2db775165b11adf7$var$rovoSettingsConfig);
const $2db775165b11adf7$export$ddb548fa2ffa23a3 = ()=>(0, $fsvuC.useContext)($2db775165b11adf7$var$rovoSettingsModalMountedContext);

});

parcelRegister("8QG0u", function(module, exports) {
$parcel$export(module.exports, "ProductKeys1P", () => $a3d65eec5bb6d08f$export$a0110d095394669e);
$parcel$export(module.exports, "ARI_EXTRACTED_1P_KEYS", () => $a3d65eec5bb6d08f$export$deaa7a6e1403419a);
$parcel$export(module.exports, "NounKeys", () => $a3d65eec5bb6d08f$export$a93cddd79e3ea530);
/* eslint-disable @atlaskit/volt-strict-mode/no-re-exports -- Use direct imports. */ 

const $a3d65eec5bb6d08f$export$a0110d095394669e = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    CustomerServiceManagement: 'jira-customer-service',
    Trello: 'trello',
    Focus: 'mercury',
    Assets: 'cmdb',
    Talent: 'radar'
};
const $a3d65eec5bb6d08f$export$deaa7a6e1403419a = Object.values($a3d65eec5bb6d08f$export$a0110d095394669e);
const $a3d65eec5bb6d08f$export$a93cddd79e3ea530 = {
    project: 'project',
    goal: 'goal',
    AtlassianWebCrawler: 'atlassian-web-crawler'
};
const $a3d65eec5bb6d08f$export$cc6a3ce6b37346b2 = (key)=>{
    return Object.values($a3d65eec5bb6d08f$export$a93cddd79e3ea530).includes(key);
};

});

parcelRegister("29fps", function(module, exports) {
$parcel$export(module.exports, "PrimaryProductKeys", () => $90fb2daba1f9ae22$export$15d12effc8830544);
/**
 * Primary product keys represent products that can mount Search Page.
 */ const $90fb2daba1f9ae22$export$15d12effc8830544 = {
    Atlas: 'townsquare',
    Confluence: 'confluence',
    Assets: 'cmdb',
    Focus: 'mercury',
    Jira: 'jira',
    Elevate: 'elevate',
    Talent: 'radar',
    RovoExtension: 'rovo-extension',
    Studio: 'studio',
    Loom: 'loom'
};

});

parcelRegister("aHDyh", function(module, exports) {
$parcel$export(module.exports, "ProductKeys3P", () => $e1382daddc224d91$export$93aa518ca2694c2d);
$parcel$export(module.exports, "ProductResourceTypes3P", () => $e1382daddc224d91$export$5378b945bea99ba3);
/**
 * Product keys for third-party connectors.
 * Each key maps to a unique identifier used throughout the search system.
 */ // oxlint-disable-next-line eslint/no-redeclare
const $e1382daddc224d91$export$93aa518ca2694c2d = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3',
    Databricks: 'databricks',
    JsmDC: 'jsm-dc',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Gong: 'gong',
    Zoom: 'zoom'
};
const $e1382daddc224d91$export$5378b945bea99ba3 = {
    AtlassianWebCrawler: 'webcrawler-connector',
    Figma: 'figma-connector',
    Github: 'github-connector',
    GoogleDrive: 'google-drive-connector',
    OneDrive: 'onedrive-connector',
    Dropbox: 'dropbox-connector',
    Slack: 'slack-connector',
    Sharepoint: 'sharepoint-connector',
    Teams: 'microsoft-teams-connector',
    GoogleCalendar: 'google-calendar-connector',
    OutlookCalendar: 'outlook-calendar-connector',
    OutlookMail: 'outlook-mail-connector',
    Gmail: 'gmail-connector',
    AdobeSign: 'adobe-sign-connector',
    Asana: 'asana-connector',
    Zendesk: 'zendesk-connector',
    Airtable: 'airtable-connector',
    Smartsheet: 'smartsheet-connector',
    Notion: 'notion-connector',
    Miro: 'miro-connector',
    Docusign: 'docusign-connector',
    Lucid: 'lucid-connector',
    Monday: 'monday-connector',
    AzureDevops: 'azure-devops-connector',
    Gitlab: 'gitlab-connector',
    ConfluenceDC: 'confluence-dc-connector',
    JiraDC: 'jira-dc-connector',
    JsmDC: 'jsm-dc-connector',
    Canva: 'canva-connector',
    Box: 'box-connector',
    Zeplin: 'smartlinks-connector-zeplin',
    ServiceNow: 'servicenow-connector',
    Freshservice: 'freshservice-connector',
    PowerBI: 'smartlinks-connector-power-bi',
    ClickUp: 'smartlinks-connector-clickup',
    Amplitude: 'smartlinks-connector-amplitude',
    Stripe: 'smartlinks-connector-stripe',
    AdobeXD: 'smartlinks-connector-adobexd',
    Aha: 'aha-connector',
    Mural: 'smartlinks-connector-mural',
    Webex: 'smartlinks-connector-webex',
    Todoist: 'smartlinks-connector-todoist',
    PagerDuty: 'smartlinks-connector-pagerduty',
    Pipedrive: 'smartlinks-connector-pipedrive',
    Hubspot: 'hubspot-connector',
    Dovetail: 'smartlinks-connector-dovetail',
    LaunchDarkly: 'smartlinks-connector-launchdarkly',
    Salesforce: 'salesforce-connector',
    Sentry: 'smartlinks-connector-sentry',
    Gitbook: 'gitbook-connector',
    AWSS3: 'aws-s3-connector',
    Databricks: 'databricks-connector',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Gong: 'gong-connector',
    Zoom: 'zoom-connector'
};

});

parcelRegister("c92YF", function(module, exports) {
$parcel$export(module.exports, "setLocalStorageItem", () => $cd1ec7dbf111386c$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $cd1ec7dbf111386c$export$93d719890ad66653);
$parcel$export(module.exports, "getLocalStorageItemAsString", () => $cd1ec7dbf111386c$export$5df15f289f441790);
$parcel$export(module.exports, "removeLocalStorageItem", () => $cd1ec7dbf111386c$export$baf306891f1b93bd);

var $llCao = parcelRequire("llCao");

var $7keNf = parcelRequire("7keNf");
// `localStorage` is a browser-only Web API and does not exist during server-side
// rendering (SSR). Accessing the bare `localStorage` identifier on the server
// throws a `ReferenceError`, which crashes the render.
const $cd1ec7dbf111386c$var$isLocalStorageAvailable = ()=>{
    return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
};
const $cd1ec7dbf111386c$export$5aa524d86254b4f = (key, value)=>{
    if (!$cd1ec7dbf111386c$var$isLocalStorageAvailable()) return;
    if ((0, $llCao.fg)('search_page_use_browser_storage_controls')) (0, $7keNf.AtlBrowserStorageLocal).setItem(key, value);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(key, value);
};
const $cd1ec7dbf111386c$export$93d719890ad66653 = (key)=>{
    if (!$cd1ec7dbf111386c$var$isLocalStorageAvailable()) return null;
    const item = (0, $llCao.fg)('search_page_use_browser_storage_controls') ? (0, $7keNf.AtlBrowserStorageLocal).getItem(key) : localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
const $cd1ec7dbf111386c$export$5df15f289f441790 = (key)=>{
    if (!$cd1ec7dbf111386c$var$isLocalStorageAvailable()) return null;
    const item = (0, $llCao.fg)('search_page_use_browser_storage_controls') ? (0, $7keNf.AtlBrowserStorageLocal).getItem(key) : localStorage.getItem(key);
    return item ? item : null;
};
const $cd1ec7dbf111386c$export$baf306891f1b93bd = (key)=>{
    if (!$cd1ec7dbf111386c$var$isLocalStorageAvailable()) return;
    if ((0, $llCao.fg)('search_page_use_browser_storage_controls')) (0, $7keNf.AtlBrowserStorageLocal).removeItem(key);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(key);
};

});

parcelRegister("02ntx", function(module, exports) {
$parcel$export(module.exports, "allProductKeys", () => $886ea9eb9706e058$export$73be91b73ebbdb05);

var $8QG0u = parcelRequire("8QG0u");

var $aHDyh = parcelRequire("aHDyh");
const $886ea9eb9706e058$export$73be91b73ebbdb05 = [
    ...Object.values((0, $8QG0u.ProductKeys1P)),
    ...Object.values((0, $aHDyh.ProductKeys3P))
];

});

parcelRegister("hgzYa", function(module, exports) {
$parcel$export(module.exports, "clearQueryCache", () => $58d4a9940c4f5cfd$export$467f2e03eb04239a);
$parcel$export(module.exports, "prefetchQuery", () => $58d4a9940c4f5cfd$export$96097db97bddd5cd);
$parcel$export(module.exports, "useQuery", () => $58d4a9940c4f5cfd$export$dd0a697e1782aedd);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $3h1FP = parcelRequire("3h1FP");
var $3K7NP = parcelRequire("3K7NP");
var $5QDqc = parcelRequire("5QDqc");
var $ciIbx = parcelRequire("ciIbx");

var $d1B6S = parcelRequire("d1B6S");
const $58d4a9940c4f5cfd$var$store = (0, $5QDqc.createStore)({
    initialState: {
        cache: {},
        epoch: 0
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            },
        deleteCacheEntry: (key)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const cache = {
                    ...state.cache
                };
                delete cache[key];
                setState({
                    cache: cache
                });
            },
        clearCache: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    cache: {},
                    epoch: getState().epoch + 1
                });
            }
    }
});
const $58d4a9940c4f5cfd$var$getCacheEpoch = ()=>(0, $ciIbx.defaultRegistry).getStore($58d4a9940c4f5cfd$var$store).storeState.getState().epoch;
const $58d4a9940c4f5cfd$export$467f2e03eb04239a = ()=>{
    const storeApi = (0, $ciIbx.defaultRegistry).getStore($58d4a9940c4f5cfd$var$store);
    storeApi.actions.clearCache();
};
const $58d4a9940c4f5cfd$var$selector = (0, $3K7NP.createSelector)((state)=>state.cache, (state)=>state.epoch, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
	 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
	 * and it will determine whether to rerender the component
	 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
	 *
	 * e.g. for `enabled` true condition:
	 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
	 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
	 *
	 * To test this, run the unit test, and then force this function to return new stuff on every call
	 * e.g. `return { ...result, random: Math.random() };`
	 * it will result in increase renderCount in the unit test
	 */ (cache, epoch, key, initialQueryEnabled)=>({
        ...cache[key] ?? {
            data: null,
            error: null,
            isFetching: initialQueryEnabled
        },
        epoch: epoch
    }));
const $58d4a9940c4f5cfd$var$useCacheEntry = (0, $3h1FP.createHook)($58d4a9940c4f5cfd$var$store, {
    selector: $58d4a9940c4f5cfd$var$selector
});
const $58d4a9940c4f5cfd$export$96097db97bddd5cd = ({ queryKey: queryKeyParts, queryFn: queryFn, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const storeApi = (0, $ciIbx.defaultRegistry).getStore($58d4a9940c4f5cfd$var$store);
    const actions = storeApi.actions;
    if (actions.getCacheEntry(queryKey) !== undefined) return;
    onStart?.();
    const epochAtRequestStart = $58d4a9940c4f5cfd$var$getCacheEpoch();
    actions.updateCacheEntry(queryKey, {
        isFetching: true,
        data: null,
        error: null
    });
    queryFn().then((response)=>{
        if ($58d4a9940c4f5cfd$var$getCacheEpoch() !== epochAtRequestStart) return;
        actions.updateCacheEntry(queryKey, {
            data: response,
            error: null,
            isFetching: false
        });
        onSuccess?.(response);
    }).catch((error)=>{
        // Cache-side errors are intentionally swallowed: a downstream `useQuery`
        // observer (if any) must refetch and surface the error via its normal
        // path. Remove the warm entry so the failed prefetch does not poison the
        // shared cache for the cold path — unless the key has since been cleared
        // and refilled, in which case the entry is another request's to remove.
        if ($58d4a9940c4f5cfd$var$getCacheEpoch() === epochAtRequestStart) actions.deleteCacheEntry(queryKey);
        onError?.(error);
    });
};
const $58d4a9940c4f5cfd$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $fsvuC.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $fsvuC.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $fsvuC.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $58d4a9940c4f5cfd$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $fsvuC.useCallback)(async ()=>{
        const epochAtRequestStart = $58d4a9940c4f5cfd$var$getCacheEpoch();
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            // The clear already dropped this request's entry, and whatever is under the key now
            // belongs to a later request — so write nothing at all, including `isFetching: false`.
            if ($58d4a9940c4f5cfd$var$getCacheEpoch() !== epochAtRequestStart) return null;
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $d1B6S.mapErrorToApiError)(error);
            if ($58d4a9940c4f5cfd$var$getCacheEpoch() !== epochAtRequestStart) return null;
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            if ($58d4a9940c4f5cfd$var$getCacheEpoch() === epochAtRequestStart) updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    const updateCache = (0, $fsvuC.useCallback)((data)=>{
        updateCacheEntry(queryKey, {
            data: data
        });
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $dqdTY.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry,
        cache.epoch
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData,
        updateCache: updateCache
    };
};

});

parcelRegister("jJrcr", function(module, exports) {
$parcel$export(module.exports, "fetchProfileAaid", () => $549b871032497193$export$2d8258e5f5afe915);
$parcel$export(module.exports, "ProfileContext", () => $549b871032497193$export$3c814b55c7cbb1fb);
$parcel$export(module.exports, "useProfileController", () => $549b871032497193$export$68afc71177137005);

var $fsvuC = parcelRequire("fsvuC");

var $kZVJU = parcelRequire("kZVJU");

var $llCao = parcelRequire("llCao");

var $i6LPn = parcelRequire("i6LPn");
const $549b871032497193$var$fetchProfileData = (0, $kZVJU.default)(async ()=>{
    const data = await (0, $i6LPn.me)();
    return {
        aaid: data.account_id,
        name: data.name || '',
        displayName: data.nickname,
        avatarUrl: data.picture,
        email: data.email
    };
});
const $549b871032497193$export$2d8258e5f5afe915 = async ()=>(await $549b871032497193$var$fetchProfileData()).aaid;
const $549b871032497193$export$3c814b55c7cbb1fb = (0, $fsvuC.createContext)(null);
const $549b871032497193$var$emptyProfileData = {
    name: '',
    displayName: '',
    avatarUrl: ''
};
const $549b871032497193$var$toProfileControllerData = (profileData, profileStatus, isProfileStatusEnabled)=>isProfileStatusEnabled ? {
        ...profileData,
        profileStatus: profileStatus
    } : profileData;
const $549b871032497193$export$68afc71177137005 = (preFetchedProfileData)=>{
    const profileContextData = (0, $fsvuC.useContext)($549b871032497193$export$3c814b55c7cbb1fb);
    const isProfileStatusEnabled = (0, $llCao.fg)('rovo-chat-ai-inbox');
    const [profileData, setProfileData] = (0, $fsvuC.useState)(()=>$549b871032497193$var$toProfileControllerData($549b871032497193$var$emptyProfileData, 'loading', isProfileStatusEnabled));
    (0, $fsvuC.useEffect)(()=>{
        if (preFetchedProfileData) setProfileData($549b871032497193$var$toProfileControllerData(preFetchedProfileData, preFetchedProfileData.aaid ? 'ready' : 'unavailable', isProfileStatusEnabled));
        else if (profileContextData) setProfileData($549b871032497193$var$toProfileControllerData(profileContextData, profileContextData.aaid ? 'ready' : 'unavailable', isProfileStatusEnabled));
        else $549b871032497193$var$fetchProfileData().then((data)=>setProfileData($549b871032497193$var$toProfileControllerData(data, data.aaid ? 'ready' : 'unavailable', isProfileStatusEnabled))).catch(()=>setProfileData($549b871032497193$var$toProfileControllerData($549b871032497193$var$emptyProfileData, 'unavailable', isProfileStatusEnabled)));
    }, [
        setProfileData,
        isProfileStatusEnabled,
        profileContextData,
        preFetchedProfileData
    ]);
    return profileData;
};

});
parcelRegister("i6LPn", function(module, exports) {
$parcel$export(module.exports, "me", () => $32519cd6ae848deb$export$3e32638432616b6);

var $13Mqn = parcelRequire("13Mqn");
const $32519cd6ae848deb$export$3e32638432616b6 = async ()=>{
    const response = await (0, $13Mqn.performHttpFetch)({
        path: '/gateway/api/me',
        options: {
            method: 'GET'
        }
    });
    return response;
};

});


parcelRegister("fTlni", function(module, exports) {
$parcel$export(module.exports, "getOrgIdFromLocation", () => $18c27d0bf4f7bb5d$export$1f2105e47e4394d6);
$parcel$export(module.exports, "getDefaultShareBaseUrl", () => $18c27d0bf4f7bb5d$export$e8ce839529963220);
$parcel$export(module.exports, "buildShareConversationUrl", () => $18c27d0bf4f7bb5d$export$c3e9175d403671f7);
$parcel$export(module.exports, "buildShareConversationPreviewUrl", () => $18c27d0bf4f7bb5d$export$9fba46c1fd475aa6);
/**
 * Canonical production Home host that recipients are sent to when opening a shared chat.
 *
 * A share link is consumed by a recipient who has no relationship to the
 * tenant/origin where the chat was created (e.g. a chat shared from
 * `hello.atlassian.net` should still open on Home, not on `hello`). Production
 * tenants use this as the default for generated links.
 */ const $18c27d0bf4f7bb5d$export$8955dfdae8a2a221 = 'https://home.atlassian.com';
const $18c27d0bf4f7bb5d$export$f7619140282e6f7a = 'https://home.stg.atlassian.com';
/**
 * Path segment placed between the base URL and the opaque share token.
 */ const $18c27d0bf4f7bb5d$var$SHARE_PATH = '/chat/share';
const $18c27d0bf4f7bb5d$var$SHARE_PREVIEW_PATH = `${$18c27d0bf4f7bb5d$var$SHARE_PATH}/preview`;
const $18c27d0bf4f7bb5d$var$getCurrentOrigin = ()=>{
    if (typeof window === 'undefined') return undefined;
    return window.location.origin;
};
const $18c27d0bf4f7bb5d$export$1f2105e47e4394d6 = ()=>{
    if (typeof window === 'undefined') return undefined;
    const match = window.location.pathname.match(/^\/o\/([^/]+)/);
    return match?.[1];
};
const $18c27d0bf4f7bb5d$export$e8ce839529963220 = (origin = $18c27d0bf4f7bb5d$var$getCurrentOrigin())=>{
    if (origin?.includes('jira-dev.com') || origin?.includes('home.stg.atlassian.com')) return $18c27d0bf4f7bb5d$export$f7619140282e6f7a;
    return $18c27d0bf4f7bb5d$export$8955dfdae8a2a221;
};
const $18c27d0bf4f7bb5d$var$getShareURLSearchParams = (siteId)=>{
    // The shared-chat flow consumes siteId, while Home bootstraps its tenant context from cloudId.
    // They identify the same site here, so include both to keep every consumer consistently scoped.
    return siteId ? new URLSearchParams({
        siteId: siteId,
        cloudId: siteId
    }) : undefined;
};
const $18c27d0bf4f7bb5d$export$c3e9175d403671f7 = (shareToken, baseUrl = $18c27d0bf4f7bb5d$export$e8ce839529963220(), orgId, siteId)=>{
    // Normalise away any trailing slash on the base URL so we never emit a
    // double slash before the share path.
    const normalisedBase = baseUrl.replace(/\/+$/, '');
    const orgPath = orgId ? `/o/${encodeURIComponent(orgId)}` : '';
    const params = $18c27d0bf4f7bb5d$var$getShareURLSearchParams(siteId);
    return `${normalisedBase}${orgPath}${$18c27d0bf4f7bb5d$var$SHARE_PATH}/${shareToken}${params ? `?${params.toString()}` : ''}`;
};
const $18c27d0bf4f7bb5d$export$9fba46c1fd475aa6 = ({ conversationId: conversationId, messageId: messageId, baseUrl: baseUrl = $18c27d0bf4f7bb5d$export$e8ce839529963220(), orgId: orgId, siteId: siteId })=>{
    const normalisedBase = baseUrl.replace(/\/+$/, '');
    const orgPath = orgId ? `/o/${encodeURIComponent(orgId)}` : '';
    const params = new URLSearchParams({
        conversationId: conversationId,
        messageId: messageId,
        ...siteId ? {
            siteId: siteId
        } : {}
    });
    return `${normalisedBase}${orgPath}${$18c27d0bf4f7bb5d$var$SHARE_PREVIEW_PATH}?${params.toString()}`;
};

});

parcelRegister("lGPOe", function(module, exports) {
$parcel$export(module.exports, "EMPTY_CONVERSATION_ID", () => $d6bdb6c168f52093$export$a08ae3ac6db36809);
$parcel$export(module.exports, "createInitialChatState", () => $d6bdb6c168f52093$export$43475135ab77130a);
$parcel$export(module.exports, "createChatStore", () => $d6bdb6c168f52093$export$8572e013e9dc20c3);

var $5QDqc = parcelRequire("5QDqc");

var $c1CKk = parcelRequire("c1CKk");
const $d6bdb6c168f52093$export$a08ae3ac6db36809 = 'EMPTY_CONVERSATION_ID';
const $d6bdb6c168f52093$export$43475135ab77130a = ()=>({
        conversations: {
            EMPTY_CONVERSATION_ID: {
                id: $d6bdb6c168f52093$export$a08ae3ac6db36809,
                messages: [],
                name: '',
                status: (0, $c1CKk.CHAT_STORE_STATUS).idle,
                traces: [],
                timeCreated: new Date().toISOString()
            }
        },
        currentConversationId: $d6bdb6c168f52093$export$a08ae3ac6db36809,
        isConversationsInitialized: false,
        conversationPagination: {
            ...(0, $c1CKk.DEFAULT_CONVERSATION_PAGINATION)
        },
        promptHistory: undefined
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $d6bdb6c168f52093$var$store;
const $d6bdb6c168f52093$export$8572e013e9dc20c3 = (actions)=>{
    if (!$d6bdb6c168f52093$var$store) $d6bdb6c168f52093$var$store = (0, $5QDqc.createStore)({
        name: 'ConversationAssistantStore',
        initialState: $d6bdb6c168f52093$export$43475135ab77130a(),
        actions: actions
    });
    // The module-level `store` is typed as `any` because its action type T is
    // not known at declaration time. The cast here is safe: `createChatStore` is
    // always called with the same concrete actions object.
    return $d6bdb6c168f52093$var$store;
};

});
parcelRegister("c1CKk", function(module, exports) {
$parcel$export(module.exports, "StoreActionLoggableName", () => $552cd9b3df46f6f0$export$69799355b7de2229);
$parcel$export(module.exports, "DEFAULT_CONVERSATION_PAGINATION", () => $552cd9b3df46f6f0$export$61e8a5ac076d12b3);
$parcel$export(module.exports, "isAnswerNowAvailable", () => $552cd9b3df46f6f0$export$8ec4190061b584d5);
$parcel$export(module.exports, "AnswerNowStatusType", () => $552cd9b3df46f6f0$export$fe950e85847f6d5d);
$parcel$export(module.exports, "CHAT_STORE_STATUS", () => $552cd9b3df46f6f0$export$817d6b1b984afeb7);
$parcel$export(module.exports, "isTerminalTaskState", () => $552cd9b3df46f6f0$export$e87901ebf76c08a1);
$parcel$export(module.exports, "isStoreHuman", () => $552cd9b3df46f6f0$export$75e97486ff2b4c62);
$parcel$export(module.exports, "isStoreAssistant", () => $552cd9b3df46f6f0$export$d99f52ae2a325014);
$parcel$export(module.exports, "isStoreError", () => $552cd9b3df46f6f0$export$9e2d714e96946d26);
$parcel$export(module.exports, "isStoreMessage", () => $552cd9b3df46f6f0$export$f2b8d80523e7041);
$parcel$export(module.exports, "isStoreFollowUp", () => $552cd9b3df46f6f0$export$7c65a4fb7b6131a1);
$parcel$export(module.exports, "isStoreUsageHint", () => $552cd9b3df46f6f0$export$155f16100a67670d);
$parcel$export(module.exports, "getActionInvocationStatus", () => $552cd9b3df46f6f0$export$3070678f252266e3);
var $552cd9b3df46f6f0$export$69799355b7de2229 = /*#__PURE__*/ function(StoreActionLoggableName) {
    StoreActionLoggableName["addStoreChatItem"] = "addStoreChatItem";
    StoreActionLoggableName["addHumanMessage"] = "addHumanMessage";
    StoreActionLoggableName["addAssistantMessage"] = "addAssistantMessage";
    StoreActionLoggableName["clearFollowUpMessages"] = "clearFollowUpMessages";
    StoreActionLoggableName["sendMessage"] = "sendMessage";
    StoreActionLoggableName["sendMessageConfirmedTools"] = "sendMessageConfirmedTools";
    StoreActionLoggableName["sendA2UIAction"] = "sendA2UIAction";
    StoreActionLoggableName["removeMessage"] = "removeMessage";
    StoreActionLoggableName["truncateFromLastHumanMessage"] = "truncateFromLastHumanMessage";
    StoreActionLoggableName["fetchConversation"] = "fetchConversation";
    StoreActionLoggableName["prefetchConversationMessages"] = "prefetchConversationMessages";
    StoreActionLoggableName["reconnectToInProgressStream"] = "reconnectToInProgressStream";
    StoreActionLoggableName["abortRequests"] = "abortRequests";
    StoreActionLoggableName["answerNow"] = "answerNow";
    StoreActionLoggableName["addErrorMessage"] = "addErrorMessage";
    StoreActionLoggableName["fetchConversationChannelsData"] = "fetchConversationChannelsData";
    StoreActionLoggableName["loadMoreConversationChannelsData"] = "loadMoreConversationChannelsData";
    StoreActionLoggableName["hydrateConversation"] = "hydrateConversation";
    StoreActionLoggableName["addAgentMessage"] = "addAgentMessage";
    StoreActionLoggableName["handleChatOpenPubsubAction"] = "handleChatOpenPubsubAction";
    StoreActionLoggableName["createConversationOptimistically"] = "createConversationOptimistically";
    StoreActionLoggableName["createSeededConversation"] = "createSeededConversation";
    StoreActionLoggableName["updateActionInvocationStatus"] = "updateActionInvocationStatus";
    StoreActionLoggableName["updateActionData"] = "updateActionData";
    StoreActionLoggableName["updateActionExecutedData"] = "updateActionExecutedData";
    StoreActionLoggableName["resolveConversationAction"] = "resolveConversationAction";
    StoreActionLoggableName["bulkResolveConversationActions"] = "bulkResolveConversationActions";
    StoreActionLoggableName["bulkResolveConversationUIActions"] = "bulkResolveConversationUIActions";
    StoreActionLoggableName["setSelectedConversation"] = "setSelectedConversation";
    StoreActionLoggableName["warmConversationCache"] = "warmConversationCache";
    StoreActionLoggableName["hasConversationMessages"] = "hasConversationMessages";
    StoreActionLoggableName["stopTask"] = "stopTask";
    return StoreActionLoggableName;
}({});
const $552cd9b3df46f6f0$export$61e8a5ac076d12b3 = {
    nextCursor: null,
    hasMore: false,
    isLoadingMore: false,
    loadMoreError: null,
    isConversationListMounted: false
};
const $552cd9b3df46f6f0$export$8ec4190061b584d5 = (status)=>status?.type === 'AVAILABLE';
const $552cd9b3df46f6f0$export$fe950e85847f6d5d = {
    AVAILABLE: 'AVAILABLE',
    SWITCHING: 'SWITCHING',
    SWITCHING_REQUESTED: 'SWITCHING_REQUESTED',
    SWITCHED: 'SWITCHED',
    ERRORED: 'ERRORED'
};
var $552cd9b3df46f6f0$export$817d6b1b984afeb7 = /*#__PURE__*/ function(CHAT_STORE_STATUS) {
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["idle"] = 0] = "idle";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["loadingChat"] = 1] = "loadingChat";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["awaitingResponse"] = 2] = "awaitingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["typingResponse"] = 3] = "typingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["deactivatedAgentError"] = 4] = "deactivatedAgentError";
    return CHAT_STORE_STATUS;
}({});
const $552cd9b3df46f6f0$var$TERMINAL_TASK_STATES = [
    'Completed',
    'Failed',
    'Cancelled'
];
const $552cd9b3df46f6f0$export$e87901ebf76c08a1 = (state)=>$552cd9b3df46f6f0$var$TERMINAL_TASK_STATES.includes(state);
const $552cd9b3df46f6f0$export$75e97486ff2b4c62 = (message)=>'type' in message && message.type === 'HUMAN';
const $552cd9b3df46f6f0$export$d99f52ae2a325014 = (message)=>'type' in message && message.type === 'ASSISTANT';
const $552cd9b3df46f6f0$export$9e2d714e96946d26 = (message)=>'type' in message && message.type === 'ERROR';
const $552cd9b3df46f6f0$export$f2b8d80523e7041 = (message)=>$552cd9b3df46f6f0$export$75e97486ff2b4c62(message) || $552cd9b3df46f6f0$export$d99f52ae2a325014(message);
const $552cd9b3df46f6f0$export$61c7dbb423a56ae7 = (message)=>'type' in message && message.type === 'MEMORY_UPDATE';
const $552cd9b3df46f6f0$export$7c65a4fb7b6131a1 = (message)=>'type' in message && message.type === 'FOLLOW_UP';
const $552cd9b3df46f6f0$export$2e85f4812cb59241 = (message)=>'type' in message && message.type === 'LIVE_CHAT';
const $552cd9b3df46f6f0$export$20f0f8aded5b11e5 = (message)=>'type' in message && message.type === 'TWILIO_LIVE_CHAT_AGENT';
const $552cd9b3df46f6f0$export$908578fde1b22b55 = (message)=>$552cd9b3df46f6f0$export$75e97486ff2b4c62(message) && message.source === 'TWILIO_LIVE_CHAT';
const $552cd9b3df46f6f0$export$3db8a80b25c44828 = (message)=>$552cd9b3df46f6f0$export$20f0f8aded5b11e5(message) || $552cd9b3df46f6f0$export$908578fde1b22b55(message);
const $552cd9b3df46f6f0$export$d15e7fe0f58ee5d0 = (message)=>message.type === 'ACTION_PREPARE';
const $552cd9b3df46f6f0$export$533a80cec0f4f28f = (message)=>message.type === 'GUARD_BLOCK';
const $552cd9b3df46f6f0$export$155f16100a67670d = (message)=>'type' in message && message.type === 'USAGE_HINT';
const $552cd9b3df46f6f0$export$3070678f252266e3 = (invocationId, invokedActions)=>invokedActions && invokedActions[invocationId] || 'idle';

});


parcelRegister("5vRZY", function(module, exports) {
$parcel$export(module.exports, "store", () => $e6c74dde806f7ab8$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useChatContextStoreActions", () => $e6c74dde806f7ab8$export$53bf948a400e8426);
$parcel$export(module.exports, "useChatContextEditorContext", () => $e6c74dde806f7ab8$export$9465f65715425f1b);
$parcel$export(module.exports, "useChatContextDatabaseContext", () => $e6c74dde806f7ab8$export$debe3dc2612d2a8e);
$parcel$export(module.exports, "useChatContextBrowserContext", () => $e6c74dde806f7ab8$export$376b2a7bf70dad8);
$parcel$export(module.exports, "useChatContextPageSmartLinks", () => $e6c74dde806f7ab8$export$6280f21050465fe4);
$parcel$export(module.exports, "useChatContextAIFeatureContext", () => $e6c74dde806f7ab8$export$3794ec8d9f571031);
$parcel$export(module.exports, "useChatContextArtifactContext", () => $e6c74dde806f7ab8$export$3d0a0ac192a7df7e);
$parcel$export(module.exports, "useSmartCreationModalSurface", () => $e6c74dde806f7ab8$export$c6b34f9422255776);
$parcel$export(module.exports, "useChatContextProvider", () => $e6c74dde806f7ab8$export$904052abb7b98535);

var $fsvuC = parcelRequire("fsvuC");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $5Y9N2 = parcelRequire("5Y9N2");

var $dJhjg = parcelRequire("dJhjg");

var $fgXcj = parcelRequire("fgXcj");

var $llCao = parcelRequire("llCao");

var $1BcIJ = parcelRequire("1BcIJ");
/**
 * Whether the extension context bridge is relaying. Same experiment the bridge's own halves read,
 * without exposure: this runs on every send in every host, and the extension owns the exposure call.
 */ const $e6c74dde806f7ab8$var$isBridgeRelayedEditorContextEnabled = ()=>(0, $fgXcj.UNSAFE_expValNoExposure)('rovo-ext_context_bridge_exp', 'isEnabled', false) === true;
const $e6c74dde806f7ab8$export$6f57813fe9f31bf9 = (0, $5QDqc.createStore)({
    initialState: {
        editorContext: undefined,
        whiteboardContext: undefined,
        slidesContext: undefined,
        databaseContext: undefined,
        browserContext: undefined,
        dashboardContext: undefined,
        jiraWorkflowContext: undefined,
        artifactContext: undefined,
        aiFeatureContext: {},
        isAIFeatureContextDismissed: false,
        contentTargets: {},
        currentTargetId: undefined,
        pageSmartLinks: undefined,
        smartCreationModalSurface: undefined
    },
    actions: {
        getAllContext: ()=>({ getState: getState })=>getState(),
        getAIFeatureContext: ()=>({ getState: getState })=>{
                const currentState = getState().aiFeatureContext;
                // Delete all properties that are undefined
                Object.keys(currentState).forEach((key)=>currentState[key] === undefined && delete currentState[key]);
                // Avoid sending an empty object
                return Object.keys(currentState).length ? currentState : undefined;
            },
        setAIFeatureContext: (chatContextData)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                // Honour the user's explicit "Remove context" action
                if (state.isAIFeatureContextDismissed) return;
                const currentAIFeatureContextState = state.aiFeatureContext;
                const { contextKey: contextKey, setContext: setContext } = chatContextData;
                if (contextKey) {
                    const contextUpdated = setContext(currentAIFeatureContextState[contextKey]);
                    setState({
                        aiFeatureContext: {
                            ...currentAIFeatureContextState,
                            [contextKey]: contextUpdated
                        }
                    });
                }
            },
        setAIFeatureContextDismissed: (isDismissed)=>({ setState: setState })=>{
                setState(isDismissed ? {
                    aiFeatureContext: {},
                    isAIFeatureContextDismissed: true
                } : {
                    isAIFeatureContextDismissed: false
                });
            },
        getDashboardContext: ()=>({ getState: getState })=>getState().dashboardContext,
        setDashboardContext: (dashboardContext)=>({ setState: setState })=>{
                setState({
                    dashboardContext: dashboardContext
                });
            },
        getJiraWorkflowContext: ()=>({ getState: getState })=>getState().jiraWorkflowContext,
        setJiraWorkflowContext: (jiraWorkflowContext)=>({ setState: setState })=>{
                setState({
                    jiraWorkflowContext: jiraWorkflowContext
                });
            },
        getJiraCreateContext: ()=>({ getState: getState })=>getState().jiraCreateContext,
        setJiraCreateContext: (jiraCreateContext)=>({ setState: setState })=>{
                setState({
                    jiraCreateContext: jiraCreateContext
                });
            },
        getArtifactContext: ()=>({ getState: getState })=>getState().artifactContext,
        setArtifactContext: (artifactContext)=>({ setState: setState })=>{
                setState({
                    artifactContext: artifactContext
                });
            },
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        updateEditorContextIsViewMode: (isViewMode)=>({ setState: setState, getState: getState })=>{
                const { editorContext: editorContext } = getState();
                if (editorContext) setState({
                    editorContext: {
                        ...editorContext,
                        isViewMode: isViewMode
                    }
                });
            },
        getWhiteboardContext: ()=>({ getState: getState })=>getState().whiteboardContext,
        setWhiteboardContext: (whiteboardContext)=>({ setState: setState })=>{
                setState({
                    whiteboardContext: whiteboardContext
                });
            },
        getSlidesContext: ()=>({ getState: getState })=>getState().slidesContext,
        setSlidesContext: (slidesContext)=>({ setState: setState })=>{
                setState({
                    slidesContext: slidesContext
                });
            },
        getDatabaseContext: ()=>({ getState: getState })=>getState().databaseContext,
        setDatabaseContext: (databaseContext)=>({ setState: setState })=>{
                setState({
                    databaseContext: databaseContext
                });
            },
        mergeDatabaseContext: (partial)=>({ getState: getState, setState: setState })=>{
                // If no selected elements published, clean up the database context
                if (!partial?.selectedElementIds) {
                    setState({
                        databaseContext: undefined
                    });
                    return;
                }
                const current = getState().databaseContext;
                setState({
                    databaseContext: current ? {
                        ...current,
                        ...partial
                    } : partial
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            },
        setPageSmartLinks: (pageSmartLinks, status, contextKey)=>({ setState: setState })=>{
                setState({
                    pageSmartLinks: pageSmartLinks,
                    ...status ? {
                        pageSmartLinksStatus: status
                    } : {},
                    ...contextKey !== undefined ? {
                        pageSmartLinksContextKey: contextKey
                    } : {}
                });
            },
        getTarget: (contentContext, activeTargetId)=>({ getState: getState })=>{
                const targets = getState().contentTargets[contentContext];
                if (!targets) return undefined;
                // targets is always an array
                const targetList = targets;
                // If activeTargetId provided, find it; otherwise return first target
                if (activeTargetId) return targetList.find((t)=>t.id === activeTargetId);
                return targetList[0];
            },
        getContentContext: (contentId)=>({ getState: getState })=>{
                const entries = Object.entries(getState().contentTargets);
                for (const [context, targets] of entries){
                    const targetList = targets;
                    if (targetList.some((t)=>t.id === contentId)) return context;
                }
                return undefined;
            },
        getActiveContext: ()=>({ getState: getState })=>{
                const state = getState();
                // The rules here determine the 'rank' in which Rovo layers are resolved into "which layer is currently active".
                // They map to intended UX - in AIFC, the staging area is a modal-powered experience, on top of global experiences.
                // Consider the scenario of sending a message - the user will be interacting with the topmost layer.
                // `smartCreationModalSurface` covers the window before any staging-area content target
                // exists yet (e.g. a clarifying question asked before content generation starts) —
                // without it, this would incorrectly resolve to 'global' for that window.
                if (state.contentTargets['staging-area'] || state.smartCreationModalSurface === 'staging') return 'staging-area';
                if (state.contentTargets['agent-builder'] && (0, $dJhjg.isExperimentEnabled)('sltns-1425-add-ask-question-design-solution')) return 'agent-builder';
                return 'global';
            },
        hasTarget: (contentContext)=>({ getState: getState })=>!!getState().contentTargets[contentContext],
        setTarget: (toAdd, target)=>({ getState: getState, setState: setState })=>{
                const currentTargets = getState().contentTargets;
                // Store as array, append if not already present
                const existing = currentTargets[toAdd];
                const targetList = existing ?? [];
                // Avoid duplicates by checking if target with same id exists
                // & filter out any targets with empty IDs to avoid stale targets
                const filtered = targetList.filter((t)=>t.id !== '' && t.id !== target.id);
                filtered.push(target);
                setState({
                    contentTargets: {
                        ...currentTargets,
                        [toAdd]: filtered
                    }
                });
            },
        clearTarget: (toRemove, targetId)=>({ getState: getState, setState: setState })=>{
                const currentState = getState().contentTargets;
                const nextState = {};
                for (const key of Object.keys(currentState)){
                    const k = key;
                    if (k !== toRemove) nextState[k] = currentState[k];
                    else if (targetId) {
                        // If a specific targetId is provided, filter out that target
                        const targetList = currentState[k];
                        const filtered = targetList.filter((t)=>t.id !== targetId);
                        if (filtered.length > 0) nextState[k] = filtered;
                    }
                }
                setState({
                    contentTargets: nextState
                });
            },
        setCurrentTargetId: (targetId)=>({ setState: setState })=>{
                setState({
                    currentTargetId: targetId
                });
            },
        getCurrentTargetId: ()=>({ getState: getState })=>getState().currentTargetId,
        setSmartCreationModalSurface: (surface)=>({ setState: setState })=>{
                setState({
                    smartCreationModalSurface: surface
                });
            },
        getSmartCreationModalSurface: ()=>({ getState: getState })=>getState().smartCreationModalSurface
    }
});
const $e6c74dde806f7ab8$export$53bf948a400e8426 = (0, $3h1FP.createActionsHook)($e6c74dde806f7ab8$export$6f57813fe9f31bf9);
const $e6c74dde806f7ab8$export$9465f65715425f1b = (0, $3h1FP.createHook)($e6c74dde806f7ab8$export$6f57813fe9f31bf9, {
    selector: (state)=>state.editorContext
});
const $e6c74dde806f7ab8$export$eea520981851a092 = (0, $3h1FP.createHook)($e6c74dde806f7ab8$export$6f57813fe9f31bf9, {
    selector: (state)=>state.whiteboardContext
});
const $e6c74dde806f7ab8$export$c517e9a5e436c401 = (0, $3h1FP.createHook)($e6c74dde806f7ab8$export$6f57813fe9f31bf9, {
    selector: (state)=>state.slidesContext
});
const $e6c74dde806f7ab8$export$debe3dc2612d2a8e = (0, $3h1FP.createHook)($e6c74dde806f7ab8$export$6f57813fe9f31bf9, {
    selector: (state)=>state.databaseContext
});
const $e6c74dde806f7ab8$export$376b2a7bf70dad8 = (0, $3h1FP.createHook)($e6c74dde806f7ab8$export$6f57813fe9f31bf9, {
    selector: (state)=>state.browserContext
});
const $e6c74dde806f7ab8$export$6280f21050465fe4 = (0, $3h1FP.createHook)($e6c74dde806f7ab8$export$6f57813fe9f31bf9, {
    selector: (state)=>state.pageSmartLinks
});
const $e6c74dde806f7ab8$export$3794ec8d9f571031 = (0, $3h1FP.createHook)($e6c74dde806f7ab8$export$6f57813fe9f31bf9, {
    selector: (state)=>state.aiFeatureContext
});
const $e6c74dde806f7ab8$export$3d0a0ac192a7df7e = (0, $3h1FP.createHook)($e6c74dde806f7ab8$export$6f57813fe9f31bf9, {
    selector: (state)=>state.artifactContext
});
const $e6c74dde806f7ab8$export$c6b34f9422255776 = (0, $3h1FP.createHook)($e6c74dde806f7ab8$export$6f57813fe9f31bf9, {
    selector: (state)=>state.smartCreationModalSurface
});
const $e6c74dde806f7ab8$export$904052abb7b98535 = ({ requestBrowserContent: requestBrowserContent, getContentBody: getContentBody, getAdditionalContext: getAdditionalContext = async ()=>undefined, getStagingSpace: getStagingSpace, useCurrentNonEditingPageAsContext: useCurrentNonEditingPageAsContext, requestJiraContext: requestJiraContext, useCurrentPageContext: useCurrentPageContext, useCurrentBrowsingContext: configuredUseCurrentBrowsingContext })=>{
    const { getStagingAreaEntryPoint: getStagingAreaEntryPoint } = (0, $1BcIJ.useStagingAreaActions)();
    const actions = $e6c74dde806f7ab8$export$53bf948a400e8426();
    const { getTarget: getTarget, getCurrentTargetId: getCurrentTargetId } = actions;
    const fetchContent = (0, $fsvuC.useCallback)(async ({ type: type, contentContext: contentContext, activeTargetId: activeTargetId, source: source, prompt: prompt })=>{
        const currentTargetId = getCurrentTargetId();
        const contentTarget = getTarget(contentContext, activeTargetId);
        if (!contentTarget) {
            /*
				 * No target normally means there is genuinely no content to read.
				 *
				 * The browser extension is the exception. A target is only registered from
				 * `ContentReadyCommand`, and the Confluence page hosts its own chat, so `rovo-chat` is a
				 * local client there and the command is invoked in-process instead of crossing the
				 * extension transport. The bus context the bridge relays is all the extension ever gets,
				 * so use it rather than sending the backend no document and silently dropping the edit.
				 *
				 * Narrow, because the relayed context is always the whole global page and carries no id
				 * to check it against: pages only, global context only, never while a staging area exists
				 * (same reason as `shouldUseCurrentTargetId` below - do not touch content behind the
				 * modal), and never as a substitute for an explicit target that was not found.
				 * The bridge's own experiment gates it, but the experiment is on for the product half of
				 * the bridge too, so it does not scope this to the extension by itself.
				 */ if (type === 'page' && contentContext === 'global' && activeTargetId === undefined && !getTarget('staging-area') && $e6c74dde806f7ab8$var$isBridgeRelayedEditorContextEnabled()) {
                const relayedEditorContext = actions.getEditorContext();
                if (relayedEditorContext?.document?.content) return relayedEditorContext;
            }
            return undefined;
        }
        // Only use currentTargetId when staging-area doesn't exist
        // to avoid changing any content open behind the staging
        // area modal
        const shouldUseCurrentTargetId = type === 'page' && !getTarget('staging-area');
        // A bridge torn down during SPA navigation may leave currentTargetId pointing at
        // content that no longer exists. A follow-up can also explicitly select a different
        // registered target. In the experiment, use the selected contentTarget in either case.
        const shouldIgnoreCurrentTargetId = shouldUseCurrentTargetId && !!currentTargetId && (!getTarget(contentContext, currentTargetId) || activeTargetId !== undefined && currentTargetId !== activeTargetId) && (0, $dJhjg.isExperimentEnabled)('aifc_creation_context_stale_target_fix');
        const selectedTargetId = shouldUseCurrentTargetId && !shouldIgnoreCurrentTargetId ? currentTargetId || contentTarget.id : contentTarget.id;
        const contentBody = await getContentBody({
            type: type,
            id: selectedTargetId,
            source: source,
            prompt: prompt
        });
        if (!contentBody || contentBody.contentType !== type) return undefined;
        switch(contentBody.contentType){
            case 'page':
                if (!contentBody.pageBody) return undefined;
                return {
                    contentId: contentBody.contentId,
                    editorStreamingContractVersion: contentBody.editorStreamingContractVersion,
                    hasRealTimeCollab: contentBody.hasRealTimeCollab,
                    useFastPath: contentBody.useFastPath,
                    document: {
                        type: 'text/adf',
                        content: contentBody.pageBody
                    },
                    selection: {
                        type: 'text/markdown',
                        content: contentBody.selectionMarkdown || ''
                    },
                    selectionFragment: contentBody.selectionFragment,
                    selectionLocalIds: contentBody.selectionLocalIds,
                    contentMauiId: contentBody.contentMauiId,
                    dynamicUiSource: contentBody.dynamicUiSource,
                    dynamicUiType: contentBody.dynamicUiType,
                    dynamicUiSubtype: contentBody.dynamicUiSubtype,
                    mediaFileId: contentBody.mediaFileId,
                    mediaCollection: contentBody.mediaCollection,
                    isViewMode: contentBody.isViewMode,
                    isDraftLockedForEditing: contentBody.isDraftLockedForEditing,
                    useGenericEditorSkill: contentBody.useGenericEditorSkill,
                    additionalContext: contentBody.additionalContext
                };
            case 'whiteboard':
                if (!contentBody.svg || !contentBody.wdf) return undefined;
                return {
                    contentId: contentBody.contentId,
                    type: 'image/svg+xml',
                    svg: contentBody.svg,
                    title: contentBody.title ?? null,
                    url: contentBody.url ?? null,
                    wdf: contentBody.wdf,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'slide':
                if (!contentBody.xml) return undefined;
                return {
                    contentId: contentBody.contentId,
                    xml: contentBody.xml,
                    title: contentBody.title,
                    url: contentBody.url,
                    selectedSlideIndex: contentBody.selectedSlideIndex,
                    selectedElementIds: contentBody.selectedElementIds,
                    selectedTargets: contentBody.selectedTargets,
                    isViewMode: contentBody.isViewMode
                };
            case 'database':
                if (!contentBody.csv) return undefined;
                return {
                    contentId: contentBody.contentId,
                    csv: contentBody.csv,
                    title: contentBody.title,
                    url: contentBody.url,
                    isViewMode: contentBody.isViewMode
                };
            case 'dashboard':
                if (!contentBody.content) return undefined;
                return {
                    content: contentBody.content,
                    dashboardAri: contentBody.dashboardAri,
                    isEditing: contentBody.isEditing,
                    chartResponseData: contentBody.chartResponseData,
                    location: contentBody.location,
                    products: contentBody.products,
                    subProducts: contentBody.subProducts
                };
            default:
                return undefined;
        }
    }, [
        actions,
        getContentBody,
        getTarget,
        getCurrentTargetId
    ]);
    /**
	 * Fetches the context of a currently live page with Rovo chat open.
	 *
	 * @description see full list of cases to consider in {@link getContextRequirements}
	 */ const getEditorContext = (0, $fsvuC.useCallback)(async ({ source: source, prompt: prompt, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const shouldProvideContext = $e6c74dde806f7ab8$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: true,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return await fetchContent({
            type: 'page',
            contentContext: contentContext,
            activeTargetId: activeTargetId,
            source: source,
            prompt: prompt
        });
    }, [
        fetchContent
    ]);
    /**
	 * Fetches the context of a currently live page with Rovo chat open.
	 *
	 * @description see full list of cases to consider in {@link getContextRequirements}
	 */ const getWhiteboardContext = (0, $fsvuC.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const shouldProvideContext = $e6c74dde806f7ab8$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: true,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return await fetchContent({
            type: 'whiteboard',
            contentContext: contentContext,
            activeTargetId: activeTargetId
        });
    }, [
        fetchContent
    ]);
    const getSlidesContext = (0, $fsvuC.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = !(0, $llCao.fg)('cc-mui-slides-opted-out') && (0, $5Y9N2.default).getExperimentValue('cc-mui-slides-experiment', 'isEnabled', false);
        const shouldProvideContext = $e6c74dde806f7ab8$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent({
            type: 'slide',
            contentContext: contentContext,
            activeTargetId: activeTargetId
        }) : actions.getSlidesContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDatabaseContext = (0, $fsvuC.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const shouldProvideContext = $e6c74dde806f7ab8$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: true,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return await fetchContent({
            type: 'database',
            contentContext: contentContext,
            activeTargetId: activeTargetId
        });
    }, [
        fetchContent
    ]);
    const getDashboardEditorContext = (0, $fsvuC.useCallback)(async ({ contentContext: contentContext, activeTargetId: activeTargetId })=>{
        return await fetchContent({
            type: 'dashboard',
            contentContext: contentContext,
            activeTargetId: activeTargetId
        });
    }, [
        fetchContent
    ]);
    const getSpaceCreateContext = (0, $fsvuC.useCallback)(({ contentContext: contentContext, isFirstPrompt: isFirstPrompt })=>{
        if (contentContext === 'staging-area' && !isFirstPrompt && (0, $llCao.fg)('aifc_space_creation_enabled')) return getStagingSpace(String(getTarget(contentContext)?.id));
    }, [
        getStagingSpace,
        getTarget
    ]);
    const getIsStagingArea = (0, $fsvuC.useCallback)(()=>actions.getActiveContext() === 'staging-area', [
        actions
    ]);
    /**
	 * Whether the chat was launched about one specific linked thing, rather than about the page the
	 * user is on. Pinned items use `context_resource`; existing linked-entity flows such as the
	 * Smart Link toolbar and onboarding use `projectContext`.
	 *
	 * Rovo Spaces launches populate `projectContext` too, but with `projectUrl: ''`, because a space
	 * has no canonical URL. Those should still offer the current page, hence the non-empty check.
	 */ const hasEntityContext = (0, $fsvuC.useCallback)(()=>{
        const aiFeatureContext = actions.getAIFeatureContext();
        const contextResourceAri = aiFeatureContext?.context_resource?.ari;
        const hasContextResource = (0, $dJhjg.isExperimentEnabled)('rovo_your_work_tab_pin_objects') && typeof contextResourceAri === 'string' && contextResourceAri !== '';
        const projectUrl = aiFeatureContext?.projectContext?.projectUrl;
        const hasProjectContext = typeof projectUrl === 'string' && projectUrl !== '';
        return hasContextResource || hasProjectContext;
    }, [
        actions
    ]);
    const useCurrentBrowsingContext = (0, $fsvuC.useCallback)((addCurrentPageAsContextUserPreference)=>{
        if (configuredUseCurrentBrowsingContext !== undefined) return configuredUseCurrentBrowsingContext;
        // Drive useCurrentBrowsingContext directly from the chat mode store's
        // `useCurrentPageContext` toggle: when the user has current-page context
        // enabled we treat the current page as usable context, and off otherwise.
        if ((0, $llCao.fg)('rovo_browsing_context_from_banner')) {
            // The CwR modal shows no current page context in the UI, so never send it.
            if (getIsStagingArea() && (0, $llCao.fg)('cwr_isolate_smart_create_agent_selection')) return false;
            // A `true` here tells the backend to use `browser_url`, so a chat launched about a
            // link would answer about the host page instead of the link. `useCurrentPageContext`
            // cannot be used to spot that case: such launches force it on, because the context
            // banner only renders while it is true.
            if (hasEntityContext()) return false;
            return useCurrentPageContext;
        }
        // If the user has explicitly turned off "use current page as context" (e.g.
        // by dismissing the context banner), send false rather than undefined so the
        // backend is explicitly told not to use the browserUrl as context. This is
        // required in edit mode, where useCurrentNonEditingPageAsContext is undefined
        // but the user preference is set to false on dismiss. the value is sent as true
        // when the context is enabled in the chat banner.
        if (addCurrentPageAsContextUserPreference) return addCurrentPageAsContextUserPreference;
        // undefined means don't send useCurrentBrowsingContext at all. false tells backend to explicitly not use the browserUrl as context.
        if (useCurrentNonEditingPageAsContext === undefined) return undefined;
        const stagingAreaEnabled = getIsStagingArea();
        return !stagingAreaEnabled && addCurrentPageAsContextUserPreference && useCurrentNonEditingPageAsContext;
    }, [
        configuredUseCurrentBrowsingContext,
        useCurrentNonEditingPageAsContext,
        getIsStagingArea,
        useCurrentPageContext,
        hasEntityContext
    ]);
    const getBrowserContext = (0, $fsvuC.useCallback)(async ({ addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, enabled: enabled })=>{
        // if the feature is not enabled, we return the original context resolution.
        if (!enabled && !(0, $5Y9N2.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) return actions.getBrowserContext();
        if (!addCurrentPageAsContextUserPreference) return undefined;
        const storedBrowserContext = actions.getBrowserContext();
        // Request browser content from the extension
        const browserContextResult = await requestBrowserContent();
        if (!browserContextResult) return storedBrowserContext;
        if (browserContextResult.selection) return {
            context: browserContextResult
        };
        const storedSelection = storedBrowserContext?.context?.selection;
        return {
            context: storedSelection ? {
                ...browserContextResult,
                selection: storedSelection
            } : browserContextResult
        };
    }, [
        requestBrowserContent,
        actions
    ]);
    const getJiraContext = (0, $fsvuC.useCallback)(async ()=>{
        const isStagingArea = getIsStagingArea();
        if (!isStagingArea) {
            const jiraCreateContext = actions.getJiraCreateContext();
            if (jiraCreateContext?.draftWorkItems) return jiraCreateContext;
        }
        // Fallback to bridge API if available (staging area doesn't have the state in sync with the chat store)
        if (!requestJiraContext) return undefined;
        try {
            const result = await requestJiraContext();
            return result?.success ? result.context : undefined;
        // eslint-disable-next-line no-unused-vars
        } catch (error) {
            return undefined;
        }
    }, [
        requestJiraContext,
        actions,
        getIsStagingArea
    ]);
    return {
        ...actions,
        getAdditionalContext: getAdditionalContext,
        getEditorContext: getEditorContext,
        getWhiteboardContext: getWhiteboardContext,
        getSlidesContext: getSlidesContext,
        getSpaceCreateContext: getSpaceCreateContext,
        getIsStagingArea: getIsStagingArea,
        getStagingAreaEntryPoint: getStagingAreaEntryPoint,
        useCurrentBrowsingContext: useCurrentBrowsingContext,
        getDatabaseContext: getDatabaseContext,
        getDashboardEditorContext: getDashboardEditorContext,
        getBrowserContext: getBrowserContext,
        getJiraContext: getJiraContext
    };
};
function $e6c74dde806f7ab8$export$86d7678a1db25436({ contentContext: contentContext, source: source, isFirstPrompt: isFirstPrompt, isAifcEnabled: isAifcEnabled, userPreference: userPreference }) {
    /**
	 * If AIFC is not enabled, we default to the user's preference.
	 */ if (!isAifcEnabled) return userPreference;
    /**
	 * In the staging area, we always want to provide context if the source is the
	 * inline editor, from the blank object experience, or if the prompt is not the
	 * first in a new conversation.
	 */ const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_MAUI_INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP' || source === 'CONFLUENCE_CWR_TEMPLATE' || source === 'CONFLUENCE_CWR_BLANK_OBJECT';
    if (contentContext === 'staging-area') return sourceEligible || !isFirstPrompt;
    else /**
		 * On real content when AIFC is enabled, we only want to default to true
		 * if the source of the content is the inline editing experience. Otherwise,
		 * we want to respect the preference chosen by the user.
		 */ return sourceEligible || userPreference;
}

});
parcelRegister("1BcIJ", function(module, exports) {
$parcel$export(module.exports, "useMessageIdSelectedForPreview", () => $bd088bfcf826caab$export$a2795b51ce92008f);
$parcel$export(module.exports, "usePreviewSelection", () => $bd088bfcf826caab$export$a5e7db37858cd8ed);
$parcel$export(module.exports, "useStagingArea", () => $bd088bfcf826caab$export$916334da9df8d04);
$parcel$export(module.exports, "useStagingAreaActions", () => $bd088bfcf826caab$export$8f9a13b17bec42d5);
$parcel$export(module.exports, "useStagingAreaState", () => $bd088bfcf826caab$export$5a57f796673aabea);

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $bd088bfcf826caab$var$initialState = {
    messageIdSelectedForPreview: null,
    invocationIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: '',
    promptAppConnectorSources: [],
    isThirdPartyPromptStaged: false,
    dynamicUiType: undefined,
    dynamicUiSubtype: undefined,
    userSelectedDynamicUiSubtype: undefined,
    userSelectedDynamicUiSubtypeConversationId: undefined,
    dynamicUiSource: undefined,
    interactionSource: undefined,
    isRemixUpdating: false,
    forceSkipAutoConversationSelection: false,
    currentDisplayMessageId: undefined,
    closeModalCallback: null,
    previewSelection: undefined
};
const $bd088bfcf826caab$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    openStagingAreaPreview: ({ entryPoint: entryPoint, invocationId: invocationId, messageId: messageId, mode: mode })=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId,
                messageIdSelectedForPreview: messageId,
                stagingAreaEntryPoint: entryPoint,
                stagingAreaMode: mode
            });
        },
    closeStagingAreaPreview: (entryPoint)=>({ getState: getState, setState: setState })=>{
            if (getState().stagingAreaEntryPoint !== entryPoint) return;
            setState({
                invocationIdSelectedForPreview: null,
                messageIdSelectedForPreview: null,
                stagingAreaEntryPoint: '',
                stagingAreaMode: undefined
            });
        },
    getStagingAreaEntryPoint: ()=>({ getState: getState })=>getState().stagingAreaEntryPoint,
    setStagingAreaEntryPoint: (entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        },
    /**
	 * Writes `isThirdPartyPromptStaged` in the same update, so the flag cannot drift from the
	 * source list. Omitting `isThirdPartyPrompt` derives it from the list, which is what the
	 * one-argument call has always meant: before this experiment a non-empty list was the only way
	 * to stage a 3P prompt. Pass it for a 3P tile that carried no connectors — an empty list the
	 * reader must still attribute to the experiment (CCINT-8714).
	 */ setPromptAppConnectorSources: (promptAppConnectorSources, options)=>({ setState: setState })=>{
            setState({
                promptAppConnectorSources: promptAppConnectorSources,
                isThirdPartyPromptStaged: options?.isThirdPartyPrompt ?? promptAppConnectorSources.length > 0
            });
        },
    setInvocationIdSelectedForPreview: (invocationId)=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId
            });
        },
    getInvocationIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().invocationIdSelectedForPreview;
        },
    setIsRemixUpdating: (isUpdating)=>({ setState: setState })=>{
            setState({
                isRemixUpdating: isUpdating
            });
        },
    setDynamicUiContext: (dynamicUiType, dynamicUiSubtype, dynamicUiSource)=>({ setState: setState })=>{
            setState({
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource
            });
        },
    setUserSelectedDynamicUiSubtype: (userSelectedDynamicUiSubtype, conversationId)=>({ setState: setState })=>{
            setState({
                userSelectedDynamicUiSubtype: userSelectedDynamicUiSubtype,
                userSelectedDynamicUiSubtypeConversationId: userSelectedDynamicUiSubtype ? conversationId : undefined
            });
        },
    setInteractionSource: (interactionSource)=>({ setState: setState })=>{
            setState({
                interactionSource: interactionSource
            });
        },
    resetStagingArea: (options)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            // A Remix can seed its pick before opening Rovo for disambiguation. Reset the old
            // preview on that switch, but retain the pick only when it belongs to the destination.
            const preserveRequestedSubtype = options?.preserveRequestedSubtypeForConversationId !== undefined && options.preserveRequestedSubtypeForConversationId === state.userSelectedDynamicUiSubtypeConversationId;
            setState({
                messageIdSelectedForPreview: null,
                invocationIdSelectedForPreview: null,
                isRemixUpdating: false,
                stagingAreaMode: undefined,
                stagingAreaEntryPoint: '',
                promptAppConnectorSources: [],
                isThirdPartyPromptStaged: false,
                dynamicUiType: undefined,
                dynamicUiSubtype: undefined,
                userSelectedDynamicUiSubtype: preserveRequestedSubtype ? state.userSelectedDynamicUiSubtype : undefined,
                userSelectedDynamicUiSubtypeConversationId: preserveRequestedSubtype ? state.userSelectedDynamicUiSubtypeConversationId : undefined,
                dynamicUiSource: undefined,
                interactionSource: undefined,
                forceSkipAutoConversationSelection: false,
                currentDisplayMessageId: undefined,
                previewSelection: undefined
            });
        },
    setForceSkipAutoConversationSelection: (forceSkip)=>({ setState: setState })=>{
            setState({
                forceSkipAutoConversationSelection: forceSkip
            });
        },
    setCurrentDisplayMessageId: (messageId)=>({ setState: setState })=>{
            setState({
                currentDisplayMessageId: messageId
            });
        },
    setCloseModalCallback: (closeModalCallback)=>({ setState: setState })=>{
            setState({
                closeModalCallback: closeModalCallback
            });
        },
    closeStagingAreaModal: ()=>({ getState: getState })=>{
            getState().closeModalCallback?.();
        },
    setPreviewSelection: (previewSelection)=>({ setState: setState })=>{
            setState({
                previewSelection: previewSelection
            });
        }
};
const $bd088bfcf826caab$var$store = (0, $5QDqc.createStore)({
    initialState: $bd088bfcf826caab$var$initialState,
    actions: $bd088bfcf826caab$var$actions
});
const $bd088bfcf826caab$export$a2795b51ce92008f = (0, $3h1FP.createHook)($bd088bfcf826caab$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $bd088bfcf826caab$export$a5e7db37858cd8ed = (0, $3h1FP.createStateHook)($bd088bfcf826caab$var$store, {
    selector: (state)=>state.previewSelection
});
const $bd088bfcf826caab$export$916334da9df8d04 = (0, $3h1FP.createHook)($bd088bfcf826caab$var$store);
const $bd088bfcf826caab$export$8f9a13b17bec42d5 = (0, $3h1FP.createActionsHook)($bd088bfcf826caab$var$store);
const $bd088bfcf826caab$export$5a57f796673aabea = (0, $3h1FP.createStateHook)($bd088bfcf826caab$var$store);

});


parcelRegister("ig4Ak", function(module, exports) {
$parcel$export(module.exports, "getRovoParams", () => $cf37e9145656f2bb$export$6405071f390601f7);
$parcel$export(module.exports, "updatePageRovoParams", () => $cf37e9145656f2bb$export$4a302fc7d977f7b3);
$parcel$export(module.exports, "addRovoParamsToUrl", () => $cf37e9145656f2bb$export$ef04687636c850fe);
$parcel$export(module.exports, "encodeRovoParams", () => $cf37e9145656f2bb$export$eddc20a009406015);
$parcel$export(module.exports, "assertOnlySpecificFieldsDefined", () => $cf37e9145656f2bb$export$ad5179fba4239081);
$parcel$export(module.exports, "getListOfRovoParams", () => $cf37e9145656f2bb$export$9c55b0deb4e0c7df);

var $9LIv3 = parcelRequire("9LIv3");
const $cf37e9145656f2bb$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $cf37e9145656f2bb$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $cf37e9145656f2bb$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $cf37e9145656f2bb$export$9748efee331ec573 = (param)=>`${0, $9LIv3.ROVO_PARAM_PREFIX}${$cf37e9145656f2bb$export$fda91e425d265029(param)}`;
const $cf37e9145656f2bb$export$f2888183a34644d4 = (param)=>{
    return $cf37e9145656f2bb$export$858653b7ee3cbb17(param.replace((0, $9LIv3.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $cf37e9145656f2bb$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $cf37e9145656f2bb$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $9LIv3.ROVO_PARAM_PREFIX))) return;
        const paramKey = $cf37e9145656f2bb$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $cf37e9145656f2bb$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $cf37e9145656f2bb$var$processParams(q).rovoParams;
    } catch  {
        return {};
    }
};
const $cf37e9145656f2bb$export$4a302fc7d977f7b3 = (params, { historyMode: historyMode = 'push' } = {})=>{
    const updatedUrl = $cf37e9145656f2bb$export$ef04687636c850fe(window.location.pathname, params);
    if (historyMode === 'replace') {
        window.history.replaceState({}, '', updatedUrl);
        return;
    }
    window.history.pushState({}, '', updatedUrl);
};
const $cf37e9145656f2bb$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $cf37e9145656f2bb$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $cf37e9145656f2bb$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $cf37e9145656f2bb$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$cf37e9145656f2bb$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).filter(([_, value])=>value !== undefined).map(([key, value])=>{
        return `${$cf37e9145656f2bb$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $cf37e9145656f2bb$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $cf37e9145656f2bb$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $9LIv3.ROVO_VALID_PARAMS).map((param)=>`${$cf37e9145656f2bb$export$9748efee331ec573(param)}${suffix}`);
};

});
parcelRegister("9LIv3", function(module, exports) {
$parcel$export(module.exports, "ROVO_PARAM_PREFIX", () => $79f5623650753d46$export$5a550907ffbc9119);
$parcel$export(module.exports, "ROVO_VALID_PARAMS", () => $79f5623650753d46$export$3cd6b610e7ede579);
const $79f5623650753d46$export$5a550907ffbc9119 = 'rovoChat';
const $79f5623650753d46$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt',
    'stagingAreaOpen',
    'messageIdSelectedForPreview',
    'invocationIdSelectedForPreview',
    'promptLibraryOpen',
    'rovoJourneyId',
    'searchQuery'
];

});


parcelRegister("e9KYl", function(module, exports) {
$parcel$export(module.exports, "useRovoEntitlement", () => $482ff09d95927263$export$66d5dd4be64dea43);
$parcel$export(module.exports, "useRovoEntitlementActions", () => $482ff09d95927263$export$8004893135276275);
$parcel$export(module.exports, "RovoEntitlementSetter", () => $482ff09d95927263$export$d03a05ad8547472c);

var $fsvuC = parcelRequire("fsvuC");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $482ff09d95927263$var$rovoEntitlementStore = (0, $5QDqc.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $482ff09d95927263$var$useStateHook = (0, $3h1FP.createStateHook)($482ff09d95927263$var$rovoEntitlementStore);
const $482ff09d95927263$export$66d5dd4be64dea43 = ()=>{
    const result = $482ff09d95927263$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $482ff09d95927263$export$8004893135276275 = (0, $3h1FP.createActionsHook)($482ff09d95927263$var$rovoEntitlementStore);
const $482ff09d95927263$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $482ff09d95927263$export$8004893135276275();
    (0, $fsvuC.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
$482ff09d95927263$export$d03a05ad8547472c.displayName = "RovoEntitlementSetter";

});

parcelRegister("77POg", function(module, exports) {
$parcel$export(module.exports, "EmptyChatLaunchFeatureType", () => $d71bf6da65f5c05e$export$2c3ef866fb23a07f);
$parcel$export(module.exports, "useEmptyChatLaunchSelector", () => $d71bf6da65f5c05e$export$13a6c73a57f1d6a6);
$parcel$export(module.exports, "useActiveTabSelector", () => $d71bf6da65f5c05e$export$81a40d215ef1c1de);
$parcel$export(module.exports, "useSelectedSpaceSelector", () => $d71bf6da65f5c05e$export$5f449dc44751be0a);
$parcel$export(module.exports, "useSelectedPinnedItemSelector", () => $d71bf6da65f5c05e$export$5c79552389bcd8c6);
$parcel$export(module.exports, "useChatHeaderUISelector", () => $d71bf6da65f5c05e$export$78ce19c6cc1eeb16);
$parcel$export(module.exports, "useActiveMenuSelector", () => $d71bf6da65f5c05e$export$1bd034c20714e002);
$parcel$export(module.exports, "useMountedSelector", () => $d71bf6da65f5c05e$export$762e860bb8461339);
$parcel$export(module.exports, "useShouldFocusChatSearchSelector", () => $d71bf6da65f5c05e$export$b5d8051ebd0ce9b2);
$parcel$export(module.exports, "useDeferredSeededConversationSelector", () => $d71bf6da65f5c05e$export$b0635a9e5f8e69a9);
$parcel$export(module.exports, "useConversationHeaderSelector", () => $d71bf6da65f5c05e$export$f4c4584d8302c703);
$parcel$export(module.exports, "useChatInputUISelector", () => $d71bf6da65f5c05e$export$357ffd05205e0c5d);
$parcel$export(module.exports, "useSideNavUISelector", () => $d71bf6da65f5c05e$export$9e369d8095358b77);
$parcel$export(module.exports, "useRootUISelector", () => $d71bf6da65f5c05e$export$8f5523dfac6ff4fa);
$parcel$export(module.exports, "useUIStore", () => $d71bf6da65f5c05e$export$5b2ba9b8ea3b0771);
$parcel$export(module.exports, "useUIStoreActions", () => $d71bf6da65f5c05e$export$cd2fc25ddd3752d4);

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $lGPOe = parcelRequire("lGPOe");
const $d71bf6da65f5c05e$export$2c3ef866fb23a07f = {
    PROACTIVE_ACTION_ITEM: 'proactive-action-item'
};
const $d71bf6da65f5c05e$export$6fdb848aa0eff3d1 = {
    isActive: false
};
const $d71bf6da65f5c05e$var$initialState = {
    activeMenu: 'none',
    mounted: false,
    isAgentSelectorMenuOpen: false,
    streaming: false,
    isChatOnboardingMiniModalOpen: false,
    emptyChatLaunchGreeting: undefined,
    emptyChatLaunchInitialPrompt: undefined,
    emptyChatLaunchProjectContext: undefined,
    emptyChatLaunchInteractionSource: undefined,
    emptyChatLaunchInvokedFrom: undefined,
    emptyChatLaunchConversationActions: undefined,
    emptyChatLaunchReplaceProviderActions: false,
    emptyChatLaunchSkillRegistryTags: undefined,
    emptyChatLaunchId: 0,
    emptyChatLaunchActive: false,
    selectedSpace: undefined,
    selectedPinnedItem: undefined,
    activeTabId: 'suggestions',
    previousTabId: 'suggestions',
    lastTabConversationId: '',
    lastLifecycleConversationId: (0, $lGPOe.EMPTY_CONVERSATION_ID),
    lastLifecycleLaunchId: undefined,
    smartLink3PPostAuth: $d71bf6da65f5c05e$export$6fdb848aa0eff3d1,
    shouldFocusChatSearch: false,
    deferredSeededConversationSource: undefined
};
const $d71bf6da65f5c05e$var$store = (0, $5QDqc.createStore)({
    name: 'uiStore',
    initialState: $d71bf6da65f5c05e$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState({
                    ...$d71bf6da65f5c05e$var$initialState,
                    conversationHeader: null,
                    selectedSpace: undefined
                });
            },
        setActiveMenu: (menu)=>({ setState: setState })=>{
                setState({
                    activeMenu: menu
                });
            },
        setMounted: (mounted)=>({ setState: setState })=>{
                setState({
                    mounted: mounted
                });
            },
        setIsAgentSelectorMenuOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isAgentSelectorMenuOpen: isOpen
                });
            },
        setStreamingStatus: (status)=>({ setState: setState })=>{
                setState({
                    streaming: status
                });
            },
        setIsChatOnboardingMiniModalOpen: (status)=>({ setState: setState })=>{
                setState({
                    isChatOnboardingMiniModalOpen: status
                });
            },
        setSmartLink3PPostAuth: (payload)=>({ setState: setState })=>{
                setState({
                    smartLink3PPostAuth: payload
                });
            },
        clearSmartLink3PPostAuth: ()=>({ setState: setState })=>{
                setState({
                    smartLink3PPostAuth: $d71bf6da65f5c05e$export$6fdb848aa0eff3d1
                });
            },
        setConversationHeader: (header)=>({ setState: setState })=>{
                setState({
                    conversationHeader: header
                });
            },
        clearConversationHeader: ()=>({ setState: setState })=>{
                setState({
                    conversationHeader: null
                });
            },
        getIsMounted: ()=>({ getState: getState })=>{
                return getState().mounted;
            },
        setEmptyChatLaunch: (payload)=>({ setState: setState, getState: getState })=>{
                setState({
                    emptyChatLaunchGreeting: payload.customGreeting,
                    emptyChatLaunchInitialPrompt: payload.initialPrompt,
                    emptyChatLaunchConversationActions: payload.customConversationActions,
                    emptyChatLaunchProjectContext: payload.projectContext,
                    emptyChatLaunchInteractionSource: payload.interactionSource,
                    emptyChatLaunchInvokedFrom: payload.invokedFrom,
                    emptyChatLaunchReplaceProviderActions: payload.replaceProviderActions ?? false,
                    emptyChatLaunchSkillRegistryTags: payload.skillRegistryTags,
                    emptyChatLaunchId: getState().emptyChatLaunchId + 1,
                    emptyChatLaunchActive: true
                });
            },
        clearEmptyChatLaunchGreeting: ({ preserveInteractionSource: preserveInteractionSource = false, expectedLaunchId: expectedLaunchId } = {})=>({ setState: setState, getState: getState })=>{
                if (expectedLaunchId !== undefined && getState().emptyChatLaunchId !== expectedLaunchId) return;
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchInitialPrompt: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    ...preserveInteractionSource ? {} : {
                        emptyChatLaunchInteractionSource: undefined
                    },
                    emptyChatLaunchInvokedFrom: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined
                });
            },
        clearEmptyChatLaunchAll: ({ expectedLaunchId: expectedLaunchId } = {})=>({ setState: setState, getState: getState })=>{
                if (expectedLaunchId !== undefined && getState().emptyChatLaunchId !== expectedLaunchId) return;
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchInitialPrompt: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchProjectContext: undefined,
                    emptyChatLaunchInteractionSource: undefined,
                    emptyChatLaunchInvokedFrom: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined,
                    emptyChatLaunchActive: false
                });
            },
        setShouldFocusChatSearch: (shouldFocus)=>({ setState: setState })=>{
                setState({
                    shouldFocusChatSearch: shouldFocus
                });
            },
        setDeferredSeededConversationPending: (source)=>({ setState: setState })=>{
                setState({
                    deferredSeededConversationSource: source
                });
            },
        clearDeferredSeededConversationPending: (source)=>({ getState: getState, setState: setState })=>{
                if (getState().deferredSeededConversationSource === source) setState({
                    deferredSeededConversationSource: undefined
                });
            },
        setSelectedSpace: (space)=>({ setState: setState })=>{
                setState({
                    selectedSpace: space
                });
            },
        clearSelectedSpace: ()=>({ setState: setState })=>{
                setState({
                    selectedSpace: undefined
                });
            },
        setSelectedPinnedItem: (item)=>({ setState: setState })=>{
                setState({
                    selectedPinnedItem: item
                });
            },
        clearSelectedPinnedItem: ()=>({ setState: setState })=>{
                setState({
                    selectedPinnedItem: undefined
                });
            },
        setActiveTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    activeTabId: tabId
                });
            },
        setPreviousTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    previousTabId: tabId
                });
            },
        setLastTabConversationId: (id)=>({ setState: setState })=>{
                setState({
                    lastTabConversationId: id
                });
            },
        checkAndUpdateLifecycleGuard: (conversationId, launchId)=>({ getState: getState, setState: setState })=>{
                const { lastLifecycleConversationId: lastLifecycleConversationId, lastLifecycleLaunchId: lastLifecycleLaunchId } = getState();
                if (lastLifecycleConversationId === conversationId && lastLifecycleLaunchId === launchId) return false;
                setState({
                    lastLifecycleConversationId: conversationId,
                    lastLifecycleLaunchId: launchId
                });
                return true;
            }
    }
});
const $d71bf6da65f5c05e$var$useStore = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store);
const $d71bf6da65f5c05e$export$13a6c73a57f1d6a6 = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store, {
    selector: (state)=>({
            customGreeting: state.emptyChatLaunchGreeting,
            initialPrompt: state.emptyChatLaunchInitialPrompt,
            projectContext: state.emptyChatLaunchProjectContext,
            interactionSource: state.emptyChatLaunchInteractionSource,
            invokedFrom: state.emptyChatLaunchInvokedFrom,
            customConversationActions: state.emptyChatLaunchConversationActions,
            replaceProviderActions: state.emptyChatLaunchReplaceProviderActions,
            skillRegistryTags: state.emptyChatLaunchSkillRegistryTags,
            launchId: state.emptyChatLaunchId,
            isEmptyChatLaunchActive: state.emptyChatLaunchActive
        })
});
const $d71bf6da65f5c05e$export$81a40d215ef1c1de = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store, {
    selector: (state)=>({
            activeTabId: state.activeTabId,
            previousTabId: state.previousTabId,
            lastTabConversationId: state.lastTabConversationId
        })
});
const $d71bf6da65f5c05e$export$5f449dc44751be0a = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store, {
    selector: (state)=>({
            selectedSpace: state.selectedSpace
        })
});
const $d71bf6da65f5c05e$export$5c79552389bcd8c6 = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store, {
    selector: (state)=>({
            selectedPinnedItem: state.selectedPinnedItem
        })
});
const $d71bf6da65f5c05e$export$78ce19c6cc1eeb16 = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            isAgentSelectorMenuOpen: state.isAgentSelectorMenuOpen,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            selectedSpace: state.selectedSpace
        })
});
const $d71bf6da65f5c05e$export$1bd034c20714e002 = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu
        })
});
const $d71bf6da65f5c05e$export$762e860bb8461339 = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store, {
    selector: (state)=>({
            mounted: state.mounted
        })
});
const $d71bf6da65f5c05e$export$b5d8051ebd0ce9b2 = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store, {
    selector: (state)=>({
            shouldFocusChatSearch: state.shouldFocusChatSearch
        })
});
const $d71bf6da65f5c05e$export$b0635a9e5f8e69a9 = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store, {
    selector: (state)=>({
            isDeferredSeededConversationPending: state.deferredSeededConversationSource !== undefined
        })
});
const $d71bf6da65f5c05e$export$d3b1853c9cb98102 = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store, {
    selector: (state)=>({
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen
        })
});
const $d71bf6da65f5c05e$export$f4c4584d8302c703 = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store, {
    selector: (state)=>({
            conversationHeader: state.conversationHeader
        })
});
const $d71bf6da65f5c05e$export$1e3791eaae70097a = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store, {
    selector: (state)=>({
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $d71bf6da65f5c05e$export$357ffd05205e0c5d = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store, {
    selector: (state)=>({
            selectedSpace: state.selectedSpace,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $d71bf6da65f5c05e$export$9e369d8095358b77 = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            selectedSpace: state.selectedSpace
        })
});
const $d71bf6da65f5c05e$export$8f5523dfac6ff4fa = (0, $3h1FP.createHook)($d71bf6da65f5c05e$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            selectedSpace: state.selectedSpace,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $d71bf6da65f5c05e$export$5b2ba9b8ea3b0771 = ()=>{
    const [{ activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader, selectedSpace: selectedSpace, selectedPinnedItem: selectedPinnedItem, activeTabId: activeTabId, previousTabId: previousTabId, lastTabConversationId: lastTabConversationId, smartLink3PPostAuth: smartLink3PPostAuth }, { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader, clearConversationHeader: clearConversationHeader, setSelectedSpace: setSelectedSpace, clearSelectedSpace: clearSelectedSpace, setSelectedPinnedItem: setSelectedPinnedItem, clearSelectedPinnedItem: clearSelectedPinnedItem, setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId, setSmartLink3PPostAuth: setSmartLink3PPostAuth, clearSmartLink3PPostAuth: clearSmartLink3PPostAuth }] = $d71bf6da65f5c05e$var$useStore();
    return {
        activeMenu: activeMenu,
        mounted: mounted,
        streaming: streaming,
        isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
        conversationHeader: conversationHeader ?? null,
        selectedSpace: selectedSpace,
        selectedPinnedItem: selectedPinnedItem,
        reset: reset,
        setActiveMenu: setActiveMenu,
        setMounted: setMounted,
        setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
        setStreamingStatus: setStreamingStatus,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
        setConversationHeader: setConversationHeader,
        clearConversationHeader: clearConversationHeader,
        setSelectedSpace: setSelectedSpace,
        clearSelectedSpace: clearSelectedSpace,
        setSelectedPinnedItem: setSelectedPinnedItem,
        clearSelectedPinnedItem: clearSelectedPinnedItem,
        activeTabId: activeTabId,
        previousTabId: previousTabId,
        lastTabConversationId: lastTabConversationId,
        smartLink3PPostAuth: smartLink3PPostAuth,
        setSmartLink3PPostAuth: setSmartLink3PPostAuth,
        clearSmartLink3PPostAuth: clearSmartLink3PPostAuth,
        setActiveTabId: setActiveTabId,
        setPreviousTabId: setPreviousTabId,
        setLastTabConversationId: setLastTabConversationId
    };
};
const $d71bf6da65f5c05e$export$cd2fc25ddd3752d4 = (0, $3h1FP.createActionsHook)($d71bf6da65f5c05e$var$store);

});

parcelRegister("c58fg", function(module, exports) {
$parcel$export(module.exports, "RovoInsightsService", () => $e3704dcb0c755279$export$2687a6d505a87cc5);

var $FpT2g = parcelRequire("FpT2g");
const $e3704dcb0c755279$var$CHANNEL_ID_HEADER = 'X-Channel-Id';
const $e3704dcb0c755279$var$PRODUCT_HEADER = 'x-product';
const $e3704dcb0c755279$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
class $e3704dcb0c755279$export$2687a6d505a87cc5 extends (0, $FpT2g.AssistanceServiceBase) {
    constructor(config){
        super(config);
    }
    /**
	 * Check whether Rovo Insights is available for the current user.
	 */ async getInsightsStatus() {
        return this.fetchJson({
            path: '/rovo/v1/insights/status',
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'Content-Type': 'application/json;charset=UTF-8',
                    [$e3704dcb0c755279$var$CHANNEL_ID_HEADER]: 'rovo-chat',
                    [$e3704dcb0c755279$var$PRODUCT_HEADER]: 'rovo',
                    [$e3704dcb0c755279$var$EXPERIENCE_ID_HEADER]: 'rovo-insights'
                }),
                body: JSON.stringify({})
            },
            holdName: 'rovo-v1-insights-status'
        });
    }
    /**
	 * Fetch the Rovo Insights feed for the current user.
	 * @param options.debugInfo — When true, include debug_info in the response.
	 */ async getInsightsFeed(options) {
        const overrides = {};
        if (options?.debugInfo) overrides.debug_info = true;
        if (typeof localStorage !== 'undefined') {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const promptVariation = localStorage.getItem('DEBUG_rovo_insights_prompt_variation');
            if (promptVariation) overrides.prompt_variation = promptVariation;
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const generate = localStorage.getItem('DEBUG_rovo_insights_generate');
            if (generate) overrides.generate = generate === 'true';
        }
        return this.fetchJson({
            path: '/rovo/v1/insights/fetch',
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'Content-Type': 'application/json;charset=UTF-8',
                    [$e3704dcb0c755279$var$CHANNEL_ID_HEADER]: 'rovo-chat',
                    [$e3704dcb0c755279$var$PRODUCT_HEADER]: 'rovo',
                    [$e3704dcb0c755279$var$EXPERIENCE_ID_HEADER]: 'rovo-insights'
                }),
                body: JSON.stringify(overrides)
            },
            holdName: 'rovo-v1-insights-fetch'
        });
    }
    /**
	 * `this.fetch`, not `fetchJson`: nothing consumes the response body, and a non-2xx
	 * already rejects with an `ApiError`.
	 */ async sendInsightFeedback(request) {
        await this.fetch({
            path: '/rovo/v1/insights/feedback',
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'Content-Type': 'application/json;charset=UTF-8',
                    [$e3704dcb0c755279$var$CHANNEL_ID_HEADER]: 'rovo-chat',
                    [$e3704dcb0c755279$var$PRODUCT_HEADER]: 'rovo',
                    [$e3704dcb0c755279$var$EXPERIENCE_ID_HEADER]: 'rovo-insights'
                }),
                body: JSON.stringify(request)
            },
            holdName: 'rovo-v1-insights-feedback'
        });
    }
}

});

parcelRegister("gmGWU", function(module, exports) {
$parcel$export(module.exports, "CONVERSATION_ASSISTANT_CONTAINER_ID", () => $8edc0d3ecd38c960$export$dffb4ed44e20ea9a);
$parcel$export(module.exports, "CONVERSATION_ASSISTANT_CONTAINER_WIDTH", () => $8edc0d3ecd38c960$export$64aee74ba59709e5);
$parcel$export(module.exports, "CONVERSATION_ASSISTANT_MINIMUM_HEIGHT", () => $8edc0d3ecd38c960$export$aa3478deee7adbeb);
$parcel$export(module.exports, "DEFAULT_PAGE_TITLE", () => $8edc0d3ecd38c960$export$e942bf04e23ff966);
$parcel$export(module.exports, "isConfluenceAgentCreationEntryPoint", () => $8edc0d3ecd38c960$export$f834c05603f390d3);
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $8edc0d3ecd38c960$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $8edc0d3ecd38c960$export$64aee74ba59709e5 = 439; // px
const $8edc0d3ecd38c960$export$1c07393c5bb1bc27 = 439; // px
const $8edc0d3ecd38c960$export$aa3478deee7adbeb = 350; // px
const $8edc0d3ecd38c960$export$21e515a86cd1733b = 'Chat';
const $8edc0d3ecd38c960$export$e942bf04e23ff966 = 'Rovo';
const $8edc0d3ecd38c960$var$CONFLUENCE_AGENT_CREATION_ENTRY_POINTS = new Set([
    'globalCreateDropdown-inlineCreateAgent',
    'pageTreeItemContextualCreate-inlineCreateAgent',
    'spaceLevelContextualCreate-inlineCreateAgent',
    'endOfContentTreeContextualCreate-inlineCreateAgent',
    'globalCreateDropdown-smartCreate',
    'pageTreeItemContextualCreate-smartCreate',
    'spaceLevelContextualCreate-smartCreate',
    'endOfContentTreeContextualCreate-smartCreate',
    'confluence-rovo-agent-menu-create-agent'
]);
const $8edc0d3ecd38c960$export$f834c05603f390d3 = (source)=>$8edc0d3ecd38c960$var$CONFLUENCE_AGENT_CREATION_ENTRY_POINTS.has(source);

});

parcelRegister("59yy1", function(module, exports) {
$parcel$export(module.exports, "isJiraDeferredSeededChatOpenEnabled", () => $d48c52163f0a1ca8$export$2421a154022bfa50);

var $fgXcj = parcelRequire("fgXcj");
const $d48c52163f0a1ca8$var$JIRA_DEFER_VIEW_CHAT_OPEN_UNTIL_SEEDED_EXPERIMENT = 'jira_rovo_defer_view_chat_open_until_seeded';
const $d48c52163f0a1ca8$export$2421a154022bfa50 = ()=>(0, $fgXcj.UNSAFE_expValNoExposure)($d48c52163f0a1ca8$var$JIRA_DEFER_VIEW_CHAT_OPEN_UNTIL_SEEDED_EXPERIMENT, 'isEnabled', false);

});

parcelRegister("8vp0P", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistantUIModes", () => $9993a78374533cf9$export$bc36ebf73899a71d);
const $9993a78374533cf9$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};

});

parcelRegister("kGOem", function(module, exports) {
$parcel$export(module.exports, "usePreviewPanelsActions", () => $cb062057f465e26f$export$5f5debba1692bf40);

var $g41Yv = parcelRequire("g41Yv");
const $cb062057f465e26f$var$noop = (props)=>{};
const $cb062057f465e26f$export$5f5debba1692bf40 = ()=>{
    const context = (0, $g41Yv.usePreviewPanelsContext)();
    if (!context) return {
        open: $cb062057f465e26f$var$noop,
        close: $cb062057f465e26f$var$noop,
        setPanelWidth: $cb062057f465e26f$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};

});
parcelRegister("g41Yv", function(module, exports) {
$parcel$export(module.exports, "PreviewPanelsProvider", () => $4af1f0653cb8e458$export$65ae37e9c61321f9);
$parcel$export(module.exports, "usePreviewPanelsContext", () => $4af1f0653cb8e458$export$609db4be92d0fad8);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $cYhnF = parcelRequire("cYhnF");

var $bAVVG = parcelRequire("bAVVG");

var $axOKT = parcelRequire("axOKT");
const $4af1f0653cb8e458$var$noop = ()=>{};
const $4af1f0653cb8e458$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $4af1f0653cb8e458$var$noop,
    onClose: $4af1f0653cb8e458$var$noop
};
const $4af1f0653cb8e458$export$f473d225913e225d = /*#__PURE__*/ (0, $fsvuC.createContext)(undefined);
const $4af1f0653cb8e458$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $4af1f0653cb8e458$var$noop,
                onClose: $4af1f0653cb8e458$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
				When opening a new preview panel, if the current panel is of the same type we don't
				want to close the panel, but rather swap out the content. If the panel types don't match
				we close the current panel and open the new one.
				ex: A Goals panel is already open, and user tries to open a different Goals panel.
				Parent Products must pass their preview panel close functions to the Preview Panel provider
				via the `onPreviewPanelClose` prop.
			*/ if (state.panel && !(0, $axOKT.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $4af1f0653cb8e458$var$initialState.onOpen,
                onClose: params.onClose || $4af1f0653cb8e458$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $4af1f0653cb8e458$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $bAVVG.usePanelWidth)((0, $cYhnF.expVal)('nin_glance_panel', 'isEnabled', false) ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $fsvuC.useReducer)($4af1f0653cb8e458$var$previewPanelsReducer, {
        ...$4af1f0653cb8e458$var$initialState,
        ...initialPanel ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $fsvuC.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $fsvuC.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $fsvuC.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $fsvuC.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)($4af1f0653cb8e458$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
$4af1f0653cb8e458$export$65ae37e9c61321f9.displayName = "PreviewPanelsProvider";
const $4af1f0653cb8e458$export$609db4be92d0fad8 = ()=>{
    return (0, $fsvuC.useContext)($4af1f0653cb8e458$export$f473d225913e225d);
};

});
parcelRegister("bAVVG", function(module, exports) {
$parcel$export(module.exports, "usePanelWidth", () => $9fd45f81de6f2860$export$82b270f291af5a5);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $8TKkC = parcelRequire("8TKkC");

var $mhEfz = parcelRequire("mhEfz");

var $hSv8I = parcelRequire("hSv8I");
const $9fd45f81de6f2860$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $fsvuC.useState)((0, $hSv8I.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $fsvuC.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $fsvuC.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $fsvuC.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $fsvuC.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $fsvuC.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $fsvuC.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $fsvuC.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($8TKkC)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $hSv8I.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $fsvuC.useEffect)(()=>{
        const unbind = (0, $dqdTY.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};

});
parcelRegister("hSv8I", function(module, exports) {
$parcel$export(module.exports, "getDefaultPanelWidth", () => $3a00f5d829cc4301$export$29ceecbfeef33bfc);
const $3a00f5d829cc4301$var$PANEL_DEFAULT_WIDTH = 400;
const $3a00f5d829cc4301$var$PANEL_MAX_WIDTH = 1000;
const $3a00f5d829cc4301$var$MINIMUM_WIDTH = 1800;
const $3a00f5d829cc4301$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $3a00f5d829cc4301$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $3a00f5d829cc4301$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $3a00f5d829cc4301$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $3a00f5d829cc4301$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $3a00f5d829cc4301$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $3a00f5d829cc4301$var$PANEL_MAX_WIDTH;
    }
    return width;
};

});


parcelRegister("axOKT", function(module, exports) {
$parcel$export(module.exports, "doPreviewPanelTypesMatch", () => $36b130ceac1a8a69$export$eb89e687f2b278d7);

var $97UhQ = parcelRequire("97UhQ");
const $36b130ceac1a8a69$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $97UhQ.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $97UhQ.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};

});



parcelRegister("9vcXb", function(module, exports) {
$parcel$export(module.exports, "usePostOfficePlacement", () => $70291431db2103e6$export$b9e056b3d42aef4);

var $fsvuC = parcelRequire("fsvuC");

const $70291431db2103e6$export$b9e056b3d42aef4 = ()=>{
    const [PostOfficePlacement, setPostOfficePlacement] = (0, $fsvuC.useState)(null);
    const [isMounted, setIsMounted] = (0, $fsvuC.useState)(false);
    (0, $fsvuC.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            let isComponentMounted = true;
            // Check for mock in test environments (set by VR test)
            const mockModule = window.__mockPostOfficePlacement__;
            if (mockModule) {
                setPostOfficePlacement(()=>mockModule);
                setIsMounted(true);
                return;
            }
            // eslint-disable-next-line @atlassian/post-office-headless-api/no-placement-remote -- Post Office RML placement not recommended in platform. Disabled lint rule for existing usage.
            (parcelRequire("hw24J")).then((module)=>{
                if (isComponentMounted) {
                    setPostOfficePlacement(()=>module.default);
                    setIsMounted(true);
                }
            }).catch(()=>{
                if (isComponentMounted) setIsMounted(true);
            });
            return ()=>{
                isComponentMounted = false;
            };
        }
    }, []);
    return {
        PostOfficePlacement: PostOfficePlacement,
        isMounted: isMounted
    };
};

});
parcelRegister("hw24J", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = Promise.all([
    $dk4lR("uEM26"),
    $dk4lR("l3i9Q"),
    $dk4lR("eu9CW")
]).then(()=>parcelRequire('6gzlk'));

});


parcelRegister("gF7cG", function(module, exports) {
$parcel$export(module.exports, "useInsightsStatus", () => $0a9379210af3f36e$export$d191a72e03ff3705);
/**
 * Hook to check whether the Rovo Insights feature is available for the current user.
 *
 * Uses RovoInsightsService (extends AssistanceServiceBase) so that Rovo Insights
 * concerns stay out of the general-purpose AssistanceService.
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $kKZTv = parcelRequire("kKZTv");

var $hgzYa = parcelRequire("hgzYa");

var $FpT2g = parcelRequire("FpT2g");

var $c58fg = parcelRequire("c58fg");
const $0a9379210af3f36e$var$FRESHNESS_WINDOW_MS = 172800000;
const $0a9379210af3f36e$var$isGeneratedAtFresh = (generatedAt)=>{
    if (!generatedAt) return false;
    const generatedAtTime = new Date(generatedAt).getTime();
    if (Number.isNaN(generatedAtTime)) return false;
    return Date.now() - generatedAtTime < $0a9379210af3f36e$var$FRESHNESS_WINDOW_MS;
};
const $0a9379210af3f36e$export$d191a72e03ff3705 = (0, $FpT2g.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, enabled: enabled })=>{
    const insightsService = (0, $fsvuC.useMemo)(()=>{
        const config = assistanceService.getConfig();
        return new (0, $c58fg.RovoInsightsService)(config);
    }, [
        assistanceService
    ]);
    const { data: data, isFetching: isFetching, error: error } = (0, $hgzYa.useQuery)({
        queryKey: [
            'insightsStatus'
        ],
        enabled: enabled,
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $kKZTv.ExperienceName).FETCH_INSIGHTS_STATUS,
                name: (0, $kKZTv.ExperienceName).FETCH_INSIGHTS_STATUS
            });
            try {
                const response = await insightsService.getInsightsStatus();
                experienceTracker.succeed({
                    name: (0, $kKZTv.ExperienceName).FETCH_INSIGHTS_STATUS
                });
                return response;
            } catch (error) {
                experienceTracker.fail({
                    teamName: 'Rovo Expansion',
                    name: (0, $kKZTv.ExperienceName).FETCH_INSIGHTS_STATUS,
                    error: error instanceof Error ? error : new Error(String(error))
                });
                throw error;
            }
        }
    });
    // `success` means the fetch settled with data; a null `data` (no error) is still
    // pending, regardless of the transient `isFetching` flag — otherwise a no-data
    // window could mislabel as `success` and lock in a wrong reason via the fire-once ref.
    const statusFetchState = !enabled ? 'disabled' : error ? 'error' : data === null ? 'loading' : 'success';
    return {
        isInsightsAvailable: Boolean(data?.insights_available),
        isLoading: isFetching && data === null,
        generatedAt: data?.generated_at,
        isFresh: $0a9379210af3f36e$var$isGeneratedAtFresh(data?.generated_at),
        statusFetchState: statusFetchState
    };
});

});

parcelRegister("1xn83", function(module, exports) {
$parcel$export(module.exports, "isRecord", () => $e75816a08dfe3003$export$6ba840931da50680);
const $e75816a08dfe3003$export$6ba840931da50680 = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);

});

parcelRegister("leRMl", function(module, exports) {
$parcel$export(module.exports, "getGeneratedCacheKey", () => $1cf7c1dd2460bce3$export$2b81a9244368ace9);
/**
 * Registered in `atlassian-cookies` as a STARTS_WITH pattern under `Products.ALL`, covering
 * everything after it. Keys losing this prefix are blocked in every product.
 */ const $1cf7c1dd2460bce3$var$CACHE_KEY_PREFIX = 'rovo-potd:';
/** Bump when the shape stored under a key changes incompatibly. */ const $1cf7c1dd2460bce3$var$CACHE_KEY_VERSION = 'v1';
/** Key order is not part of the request, so it must not change the entry a caller lands on. */ const $1cf7c1dd2460bce3$var$stableStringify = (value)=>{
    if (Array.isArray(value)) return `[${value.map($1cf7c1dd2460bce3$var$stableStringify).join(',')}]`;
    if (typeof value === 'object' && value !== null) {
        const entries = Object.entries(value).filter(([, entryValue])=>entryValue !== undefined).sort(([left], [right])=>left < right ? -1 : 1).map(([key, entryValue])=>`${JSON.stringify(key)}:${$1cf7c1dd2460bce3$var$stableStringify(entryValue)}`);
        return `{${entries.join(',')}}`;
    }
    return JSON.stringify(value) ?? 'null';
};
const $1cf7c1dd2460bce3$var$getArgsFingerprint = (args)=>{
    const fingerprint = args === undefined ? '{}' : $1cf7c1dd2460bce3$var$stableStringify(args);
    return fingerprint === '{}' ? 'default' : fingerprint;
};
const $1cf7c1dd2460bce3$export$2b81a9244368ace9 = ({ slug: slug, accountId: accountId, args: args })=>`${$1cf7c1dd2460bce3$var$CACHE_KEY_PREFIX}${$1cf7c1dd2460bce3$var$CACHE_KEY_VERSION}:${slug}:${accountId}:${$1cf7c1dd2460bce3$var$getArgsFingerprint(args)}`;

});

parcelRegister("ecFQl", function(module, exports) {
$parcel$export(module.exports, "getGenerateEndpoint", () => $6be3edfdcdd7b32d$export$844dcb22a9dfd40a);
$parcel$export(module.exports, "fetchGenerated", () => $6be3edfdcdd7b32d$export$35e92f217ceb9ac9);
$parcel$export(module.exports, "refreshGenerated", () => $6be3edfdcdd7b32d$export$c356c98ff4cbe122);
$parcel$export(module.exports, "replaceGeneratedOutput", () => $6be3edfdcdd7b32d$export$448d1ea4f6afdf87);

var $7keNf = parcelRequire("7keNf");

var $ehsNQ = parcelRequire("ehsNQ");

var $1xn83 = parcelRequire("1xn83");

var $leRMl = parcelRequire("leRMl");
const $6be3edfdcdd7b32d$export$844dcb22a9dfd40a = (slug)=>`/gateway/api/potd/${slug}/generate`;
/**
 * Outlives every mount, so remounting does not re-ask and two surfaces mounted together share one
 * answer. It is also what keeps a consent-blocked storage write from costing a request per mount.
 */ const $6be3edfdcdd7b32d$var$memoryCache = new Map();
/** One entry per key while a request is open, so concurrent callers share a single POST. */ const $6be3edfdcdd7b32d$var$inFlightRequests = new Map();
const $6be3edfdcdd7b32d$var$requestOutput = async ({ slug: slug, args: args }, fetchFn)=>{
    const performFetch = fetchFn ?? globalThis.fetch;
    if (typeof performFetch !== 'function') return null;
    const response = await performFetch($6be3edfdcdd7b32d$export$844dcb22a9dfd40a(slug), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            args: args ?? {}
        })
    });
    const body = response.ok ? await response.json() : null;
    return (0, $1xn83.isRecord)(body) && body.status === 'ok' ? body.output : null;
};
/**
 * Issues the network request and writes whatever comes back into both caches, whatever the
 * outcome, so a repeated read (or a repeated refresh) at most asks once for as long as the request
 * is open. Shared by `fetchGenerated` and `refreshGenerated` — the only difference between the two
 * is whether a cache hit is allowed to short-circuit this.
 */ const $6be3edfdcdd7b32d$var$requestAndCache = (request, cacheKey, { parse: parse, getExpiresAt: getExpiresAt, fetchFn: fetchFn })=>{
    const pendingRequest = $6be3edfdcdd7b32d$var$requestOutput(request, fetchFn).catch(()=>null).then((output)=>{
        const data = parse(output);
        const generatedAt = Date.now();
        const expiresAt = getExpiresAt(generatedAt);
        // Recorded whatever the outcome, `null` included, so one page load asks at most once.
        $6be3edfdcdd7b32d$var$memoryCache.set(cacheKey, {
            expiresAt: expiresAt,
            data: data
        });
        if (data !== null) // The served `output`, not `data`, so reading another of its fields later needs no new
        // cache version.
        (0, $ehsNQ.writeBrowserStorageCache)((0, $7keNf.AtlBrowserStorageLocal), cacheKey, {
            expiresAt: expiresAt,
            generatedAt: generatedAt,
            value: output
        });
        return data;
    }).finally(()=>{
        $6be3edfdcdd7b32d$var$inFlightRequests.delete(cacheKey);
    });
    $6be3edfdcdd7b32d$var$inFlightRequests.set(cacheKey, pendingRequest);
    return pendingRequest;
};
const $6be3edfdcdd7b32d$export$35e92f217ceb9ac9 = async (request, options)=>{
    const cacheKey = (0, $leRMl.getGeneratedCacheKey)(request);
    const now = Date.now();
    const memoryEntry = $6be3edfdcdd7b32d$var$memoryCache.get(cacheKey);
    if (memoryEntry !== undefined && memoryEntry.expiresAt > now) return memoryEntry.data;
    const storedEntry = (0, $ehsNQ.readBrowserStorageCache)((0, $7keNf.AtlBrowserStorageLocal), cacheKey, options.parse, now);
    if (storedEntry !== null) {
        $6be3edfdcdd7b32d$var$memoryCache.set(cacheKey, {
            expiresAt: storedEntry.expiresAt,
            data: storedEntry.value
        });
        return storedEntry.value;
    }
    const openRequest = $6be3edfdcdd7b32d$var$inFlightRequests.get(cacheKey);
    if (openRequest !== undefined) return openRequest;
    return $6be3edfdcdd7b32d$var$requestAndCache(request, cacheKey, options);
};
const $6be3edfdcdd7b32d$export$c356c98ff4cbe122 = async (request, options)=>{
    const cacheKey = (0, $leRMl.getGeneratedCacheKey)(request);
    const openRequest = $6be3edfdcdd7b32d$var$inFlightRequests.get(cacheKey);
    if (openRequest !== undefined) return openRequest;
    return $6be3edfdcdd7b32d$var$requestAndCache(request, cacheKey, options);
};
const $6be3edfdcdd7b32d$export$448d1ea4f6afdf87 = (request, parse, output, timestamps)=>{
    const cacheKey = (0, $leRMl.getGeneratedCacheKey)(request);
    // An expired entry stays out of memory, so it cannot overwrite the record of a request that failed.
    if (timestamps.expiresAt > Date.now()) $6be3edfdcdd7b32d$var$memoryCache.set(cacheKey, {
        expiresAt: timestamps.expiresAt,
        data: parse(output)
    });
    (0, $ehsNQ.writeBrowserStorageCache)((0, $7keNf.AtlBrowserStorageLocal), cacheKey, {
        ...timestamps,
        value: output
    });
};
const $6be3edfdcdd7b32d$export$3038deefa7da4758 = ()=>{
    $6be3edfdcdd7b32d$var$memoryCache.clear();
    $6be3edfdcdd7b32d$var$inFlightRequests.clear();
};

});
parcelRegister("ehsNQ", function(module, exports) {
$parcel$export(module.exports, "readBrowserStorageCache", () => $796060b9ff623de6$export$5b34ec7f39633cbe);
$parcel$export(module.exports, "writeBrowserStorageCache", () => $796060b9ff623de6$export$b9416c674486703b);

var $1xn83 = parcelRequire("1xn83");
const $796060b9ff623de6$export$5b34ec7f39633cbe = (storage, key, parseValue, now)=>{
    try {
        const cached = JSON.parse(storage.getItem(key) ?? 'null');
        if (!(0, $1xn83.isRecord)(cached) || typeof cached.expiresAt !== 'number' || cached.expiresAt <= now) return null;
        const value = parseValue(cached.value);
        return value === null ? null : {
            expiresAt: cached.expiresAt,
            value: value
        };
    } catch  {
        return null;
    }
};
const $796060b9ff623de6$export$b9416c674486703b = (storage, key, entry)=>{
    try {
        storage.setItem(key, JSON.stringify(entry)).catch(()=>undefined);
    } catch  {
    // Caching is optional and must not affect the caller's behavior. A write blocked by consent
    // needs no handling here: the caller has already kept the value in memory for this page load.
    }
};

});


parcelRegister("9qqAa", function(module, exports) {
$parcel$export(module.exports, "PROMPT_OF_THE_DAY_SLUG", () => $5f69c947e769ce9a$export$b464e5802454e37c);
$parcel$export(module.exports, "PROMPT_OF_THE_DAY_OPTIONS", () => $5f69c947e769ce9a$export$ff610c3b7744ac4d);
$parcel$export(module.exports, "fetchPromptOfTheDay", () => $5f69c947e769ce9a$export$86033784e77d9857);
$parcel$export(module.exports, "refreshPromptOfTheDay", () => $5f69c947e769ce9a$export$787c58013bf4410c);

var $ecFQl = parcelRequire("ecFQl");

var $7L2Jv = parcelRequire("7L2Jv");
const $5f69c947e769ce9a$export$b464e5802454e37c = 'prompt-of-the-day';
const $5f69c947e769ce9a$export$c9da951bc690df99 = (0, $ecFQl.getGenerateEndpoint)($5f69c947e769ce9a$export$b464e5802454e37c);
/**
 * A suggestion is stale once the day it belongs to is over. A rolling 24h window would instead keep
 * yesterday's prompt until the same hour tomorrow for anyone who loaded the page late in the day.
 */ const $5f69c947e769ce9a$var$getNextLocalMidnight = (now)=>{
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    return midnight.getTime();
};
const $5f69c947e769ce9a$export$ff610c3b7744ac4d = {
    parse: (0, $7L2Jv.parsePromptsFromOutput),
    getExpiresAt: $5f69c947e769ce9a$var$getNextLocalMidnight
};
const $5f69c947e769ce9a$export$86033784e77d9857 = ({ accountId: accountId, args: args }, { fetchFn: fetchFn } = {})=>(0, $ecFQl.fetchGenerated)({
        slug: $5f69c947e769ce9a$export$b464e5802454e37c,
        accountId: accountId,
        args: args
    }, {
        ...$5f69c947e769ce9a$export$ff610c3b7744ac4d,
        fetchFn: fetchFn
    });
const $5f69c947e769ce9a$export$787c58013bf4410c = ({ accountId: accountId, args: args }, { fetchFn: fetchFn } = {})=>(0, $ecFQl.refreshGenerated)({
        slug: $5f69c947e769ce9a$export$b464e5802454e37c,
        accountId: accountId,
        args: args
    }, {
        ...$5f69c947e769ce9a$export$ff610c3b7744ac4d,
        fetchFn: fetchFn
    });

});
parcelRegister("7L2Jv", function(module, exports) {
$parcel$export(module.exports, "parsePromptsFromOutput", () => $3bf6b18afa49b1df$export$c994a8fcec78361);

var $1xn83 = parcelRequire("1xn83");
const $3bf6b18afa49b1df$var$parseNonEmptyString = (value)=>{
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    return trimmed === '' ? null : trimmed;
};
const $3bf6b18afa49b1df$var$parseNonEmptyStrings = (value)=>{
    if (!Array.isArray(value)) return undefined;
    const strings = value.map($3bf6b18afa49b1df$var$parseNonEmptyString).filter((item)=>item !== null);
    return strings.length > 0 ? strings : undefined;
};
// Optional and best-effort: anything malformed is dropped, never the prompt it belongs to.
const $3bf6b18afa49b1df$var$parseMetadata = (value)=>{
    if (!(0, $1xn83.isRecord)(value) || !(0, $1xn83.isRecord)(value.highlights)) return undefined;
    const shortPrompt = $3bf6b18afa49b1df$var$parseNonEmptyStrings(value.highlights.shortPrompt);
    return shortPrompt !== undefined ? {
        highlights: {
            shortPrompt: shortPrompt
        }
    } : undefined;
};
const $3bf6b18afa49b1df$var$parsePrompt = (value)=>{
    if (!(0, $1xn83.isRecord)(value)) return null;
    const shortPrompt = $3bf6b18afa49b1df$var$parseNonEmptyString(value.shortPrompt);
    if (shortPrompt === null) return null;
    const title = $3bf6b18afa49b1df$var$parseNonEmptyString(value.title);
    const expandedPrompt = $3bf6b18afa49b1df$var$parseNonEmptyString(value.expandedPrompt);
    const sources = $3bf6b18afa49b1df$var$parseNonEmptyStrings(value.sources);
    const metadata = $3bf6b18afa49b1df$var$parseMetadata(value.metadata);
    return {
        shortPrompt: shortPrompt,
        ...title !== null && {
            title: title
        },
        ...expandedPrompt !== null && {
            expandedPrompt: expandedPrompt
        },
        ...sources !== undefined && {
            sources: sources
        },
        ...metadata !== undefined && {
            metadata: metadata
        }
    };
};
const $3bf6b18afa49b1df$export$c994a8fcec78361 = (output)=>{
    if (!(0, $1xn83.isRecord)(output) || !Array.isArray(output.prompts)) return null;
    const prompts = output.prompts.map($3bf6b18afa49b1df$var$parsePrompt);
    return prompts.length > 0 && prompts.every((prompt)=>prompt !== null) ? prompts : null;
};

});


parcelRegister("1OBBP", function(module, exports) {

var $2bMLU = parcelRequire("2bMLU");

var $jflHl = parcelRequire("jflHl");

var $lIJFm = parcelRequire("lIJFm");

var $62y3O = parcelRequire("62y3O");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $1527a25f55ac18b3$var$difference = $lIJFm(function(array, values) {
    return $62y3O(array) ? $2bMLU(array, $jflHl(values, 1, $62y3O, true)) : [];
});
module.exports = $1527a25f55ac18b3$var$difference;

});
parcelRegister("2bMLU", function(module, exports) {

var $hvlEG = parcelRequire("hvlEG");

var $fJpgd = parcelRequire("fJpgd");

var $ctDCo = parcelRequire("ctDCo");

var $3I8Od = parcelRequire("3I8Od");

var $dN01R = parcelRequire("dN01R");

var $7xKkD = parcelRequire("7xKkD");
/** Used as the size to enable large array optimizations. */ var $198270e7d8ca8d54$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $198270e7d8ca8d54$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $fJpgd, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $3I8Od(values, $dN01R(iteratee));
    if (comparator) {
        includes = $ctDCo;
        isCommon = false;
    } else if (values.length >= $198270e7d8ca8d54$var$LARGE_ARRAY_SIZE) {
        includes = $7xKkD;
        isCommon = false;
        values = new $hvlEG(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $198270e7d8ca8d54$var$baseDifference;

});


parcelRegister("3t1NJ", function(module, exports) {
$parcel$export(module.exports, "SpotlightManager", () => $fc87c7a279fe9254$export$e040768d915476be);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $TLRFC = parcelRequire("TLRFC");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $fc87c7a279fe9254$export$e040768d915476be = ({ children: children })=>{
    if ((0, $llCao.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $TLRFC.PopoverProvider), {
        children: children
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment, {
        children: children
    });
};
$fc87c7a279fe9254$export$e040768d915476be.displayName = "SpotlightManager";
$fc87c7a279fe9254$export$e040768d915476be.displayName = 'SpotlightManager';

});

parcelRegister("8XqMW", function(module, exports) {
$parcel$export(module.exports, "SpotlightTarget", () => $5129a2e388e08b3b$export$e29577842f211e22);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $a5Zx6 = parcelRequire("a5Zx6");

var $llCao = parcelRequire("llCao");

var $35rMO = parcelRequire("35rMO");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $5129a2e388e08b3b$export$e29577842f211e22 = ({ children: children, name: name })=>{
    if ((0, $llCao.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $35rMO.PopoverTarget), {
        children: children
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $a5Zx6.default), {
        name: name,
        children: children
    });
};
$5129a2e388e08b3b$export$e29577842f211e22.displayName = "SpotlightTarget";
$5129a2e388e08b3b$export$e29577842f211e22.displayName = 'SpotlightTarget';

});

parcelRegister("iYzB5", function(module, exports) {
$parcel$export(module.exports, "EngagementSpotlight", () => $4b00a16175b5eedd$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $1HhHB = parcelRequire("1HhHB");

var $jLhh4 = parcelRequire("jLhh4");

var $1BvTi = parcelRequire("1BvTi");

var $aa42x = parcelRequire("aa42x");

var $lKgDi = parcelRequire("lKgDi");
const $4b00a16175b5eedd$var$SpotlightWithVariables = (0, $jLhh4.default)((0, $lKgDi.default));
const $4b00a16175b5eedd$export$f57123e11f24bec9 = (0, $1BvTi.default)($4b00a16175b5eedd$var$SpotlightWithVariables);
const $4b00a16175b5eedd$var$SpotlightWithMessage = (0, $aa42x.default)($4b00a16175b5eedd$export$f57123e11f24bec9, 'spotlight');
function $4b00a16175b5eedd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $1HhHB.default), {
        children: /*#__PURE__*/ (0, $5chsV.jsx)($4b00a16175b5eedd$var$SpotlightWithMessage, {
            ...props
        })
    });
}
$4b00a16175b5eedd$export$2e2bcd8739ae039.displayName = "EngagementSpotlight";

});
parcelRegister("jLhh4", function(module, exports) {
$parcel$export(module.exports, "default", () => $77841bbff3265859$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $3USiL = parcelRequire("3USiL");
function $77841bbff3265859$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $fsvuC.Component) {
        static{
            this.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
        }
        render() {
            const props = $77841bbff3265859$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, $5chsV.jsx)(TargetComponent, {
                ...props
            });
        }
    }
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $77841bbff3265859$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $3USiL.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $3USiL.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $3USiL.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});
parcelRegister("3USiL", function(module, exports) {
$parcel$export(module.exports, "rebuildButtonAction", () => $454cafced5152ff9$export$5d0ec4f796aceeb1);
$parcel$export(module.exports, "runTemplateOnInputs", () => $454cafced5152ff9$export$d808999430a3f186);

var $7dT0s = parcelRequire("7dT0s");
function $454cafced5152ff9$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $454cafced5152ff9$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $7dT0s.runTemplateForUrl)(input, variables) : (0, $7dT0s.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $110b74e2943f9928$export$edb46161045fece7)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}

});
const $110b74e2943f9928$export$e26f00bd90899835 = 'success';
const $110b74e2943f9928$export$edb46161045fece7 = 'error';

parcelRegister("7dT0s", function(module, exports) {
$parcel$export(module.exports, "runTemplateForUrl", () => $2a5bd095f2cbc533$export$416b2ef51d91ea20);
$parcel$export(module.exports, "runTemplateForHtml", () => $2a5bd095f2cbc533$export$5681b97796b74884);

var $aZGng = parcelRequire("aZGng");

var $aaG04 = parcelRequire("aaG04");


var $hHPjB = parcelRequire("hHPjB");
function $2a5bd095f2cbc533$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $aZGng.default)(template);
    return (0, $hHPjB.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $2a5bd095f2cbc533$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $aZGng.default)(template);
    return (0, $aaG04.replaceForUrl)(epTemplate, variables);
}
function $2a5bd095f2cbc533$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $aZGng.default)(template);
    return (0, $aaG04.replaceForHtml)(epTemplate, variables);
}

});
parcelRegister("aZGng", function(module, exports) {
$parcel$export(module.exports, "default", () => $96d1cf7466182d13$export$2e2bcd8739ae039);

var $2D8E3 = parcelRequire("2D8E3");
/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $96d1cf7466182d13$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $96d1cf7466182d13$var$UNESCAPED_MATCH = 1;
const $96d1cf7466182d13$var$UNESCAPED_GROUP_CONTENTS = 2;
const $96d1cf7466182d13$var$ESCAPED_GROUP_CONTENTS = 5;
function $96d1cf7466182d13$export$2e2bcd8739ae039(template) {
    const parts = (0, $2D8E3.regexpParts)(template, $96d1cf7466182d13$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$96d1cf7466182d13$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$96d1cf7466182d13$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$96d1cf7466182d13$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});
parcelRegister("2D8E3", function(module, exports) {
$parcel$export(module.exports, "regexpParts", () => $c54e6d4217134f47$export$b16d411b3b6d6dff);
function $c54e6d4217134f47$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $c54e6d4217134f47$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $c54e6d4217134f47$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $c54e6d4217134f47$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $c54e6d4217134f47$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}

});


parcelRegister("aaG04", function(module, exports) {
$parcel$export(module.exports, "replaceForUrl", () => $fbf738fa39266609$export$d10ae881b12b8ef2);
$parcel$export(module.exports, "replaceForHtml", () => $fbf738fa39266609$export$ca536300dbd6350);

var $hHPjB = parcelRequire("hHPjB");

var $ijpoi = parcelRequire("ijpoi");
/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $fbf738fa39266609$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $hHPjB.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $fbf738fa39266609$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $fbf738fa39266609$var$rawReplaceVariablesForUrl(template, variables) {
    return $fbf738fa39266609$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $fbf738fa39266609$var$rawReplaceVariablesForHtml(template, variables) {
    return $fbf738fa39266609$var$rawReplaceVariables(template, variables, (0, $ijpoi.default));
}
function $fbf738fa39266609$export$d10ae881b12b8ef2(template, variables) {
    return $fbf738fa39266609$var$withVariableValidation(template, variables, $fbf738fa39266609$var$rawReplaceVariablesForUrl);
}
function $fbf738fa39266609$export$ca536300dbd6350(template, variables) {
    return $fbf738fa39266609$var$withVariableValidation(template, variables, $fbf738fa39266609$var$rawReplaceVariablesForHtml);
}

});
parcelRegister("hHPjB", function(module, exports) {
$parcel$export(module.exports, "getRequiredVariablesFromTemplate", () => $6ff2c3354ebafd5f$export$4a33186abb06007b);

var $db6du = parcelRequire("db6du");
function $6ff2c3354ebafd5f$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $6ff2c3354ebafd5f$export$4a33186abb06007b(template) {
    const variableParts = $6ff2c3354ebafd5f$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $db6du.uniqStrings)(variableNames);
}

});
parcelRegister("db6du", function(module, exports) {
$parcel$export(module.exports, "uniqStrings", () => $d37693b5536f07d4$export$c150c7c1a29f33d8);
/**
 * Removes duplicate strings from an array.
 */ function $d37693b5536f07d4$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}

});


parcelRegister("ijpoi", function(module, exports) {
$parcel$export(module.exports, "default", () => $8171f77d45f74d31$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $8171f77d45f74d31$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});





parcelRegister("lKgDi", function(module, exports) {
$parcel$export(module.exports, "default", () => $c065b2602a27df38$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $wNZ8F = parcelRequire("wNZ8F");

var $gOANe = parcelRequire("gOANe");

var $72dzD = parcelRequire("72dzD");

var $llCao = parcelRequire("llCao");

var $daZXj = parcelRequire("daZXj");

var $eygIb = parcelRequire("eygIb");

var $3Ru3M = parcelRequire("3Ru3M");

var $9Cyj3 = parcelRequire("9Cyj3");

var $3NMdW = parcelRequire("3NMdW");

var $e9bDS = parcelRequire("e9bDS");

var $6k44y = parcelRequire("6k44y");

var $jZ2NQ = parcelRequire("jZ2NQ");

var $4iMK3 = parcelRequire("4iMK3");

var $kpS32 = parcelRequire("kpS32");

var $8xjQm = parcelRequire("8xjQm");

var $sAY9X = parcelRequire("sAY9X");

var $kKMaM = parcelRequire("kKMaM");

var $1rHDk = parcelRequire("1rHDk");

var $daQNA = parcelRequire("daQNA");

var $7LnGU = parcelRequire("7LnGU");

var $3TzTk = parcelRequire("3TzTk");

var $aiQwF = parcelRequire("aiQwF");
const $c065b2602a27df38$var$styles = {
    image: "_39xV02N91d"
};
const $c065b2602a27df38$export$f14689466e4eca7a = ({ isMigrated: isMigrated = false, ...rest })=>{
    if (isMigrated && (0, $llCao.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, $5chsV.jsx)($c065b2602a27df38$var$MigratedAkSpotlight, {
        ...rest
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)($c065b2602a27df38$var$DeprecatedAkSpotlight, {
        ...rest
    });
};
$c065b2602a27df38$export$f14689466e4eca7a.displayName = "EngagementSpotlight";
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c065b2602a27df38$var$DeprecatedAkSpotlight extends (0, $fsvuC.Component) {
    static{
        this.defaultProps = {
            fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($wNZ8F)))
        };
    }
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $7LnGU.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $72dzD.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius,
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $aiQwF.default), {
                html: body
            })
        });
    }
}
$c065b2602a27df38$var$DeprecatedAkSpotlight.displayName = "DeprecatedAkSpotlight";
const $c065b2602a27df38$var$MigratedAkSpotlight = (props)=>{
    const placement = (0, $3TzTk.translations).dialogPlacement(props.dialogPlacement);
    const [isVisible, setIsVisible] = (0, $fsvuC.useState)(true);
    const dismiss = (0, $fsvuC.useCallback)(()=>{
        setIsVisible(false);
    }, [
        setIsVisible
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $8xjQm.PopoverContent), {
        offset: props.offset,
        dismiss: dismiss,
        placement: placement,
        isVisible: isVisible,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $9Cyj3.SpotlightCard), {
            children: [
                /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jZ2NQ.SpotlightHeader), {
                    children: [
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $4iMK3.SpotlightHeadline), {
                            children: props.title
                        }),
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $3NMdW.SpotlightControls), {
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $e9bDS.SpotlightDismissControl), {})
                        })
                    ]
                }),
                props.image && /*#__PURE__*/ (0, $5chsV.jsx)((0, $kpS32.SpotlightMedia), {
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $gOANe.default), {
                        src: props.image,
                        alt: "",
                        className: (0, $gJ6nT.default)([
                            $c065b2602a27df38$var$styles.image
                        ])
                    })
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $3Ru3M.SpotlightBody), {
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $daZXj.Text), {
                        children: props.body
                    })
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $6k44y.SpotlightFooter), {
                    children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $eygIb.SpotlightActions), {
                        children: [
                            props.secondaryAction && (props.secondaryAction?.type === 'link' ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $daQNA.SpotlightSecondaryLink), {
                                onClick: dismiss,
                                ...props.secondaryAction.data,
                                href: props.secondaryAction.data?.url || '',
                                target: props.secondaryAction.data?.target,
                                children: props.secondaryText
                            }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $1rHDk.SpotlightSecondaryAction), {
                                onClick: dismiss,
                                ...props.secondaryAction.data,
                                children: props.secondaryText
                            })),
                            props.primaryAction && (props.primaryAction?.type === 'link' ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $kKMaM.SpotlightPrimaryLink), {
                                onClick: dismiss,
                                ...props.primaryAction.data,
                                href: props.primaryAction.data?.url || '',
                                target: props.primaryAction.data?.target,
                                children: props.primaryText
                            }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $sAY9X.SpotlightPrimaryAction), {
                                onClick: dismiss,
                                ...props.primaryAction.data,
                                children: props.primaryText
                            }))
                        ]
                    })
                })
            ]
        })
    });
};
$c065b2602a27df38$var$MigratedAkSpotlight.displayName = "MigratedAkSpotlight";
var $c065b2602a27df38$export$2e2bcd8739ae039 = $c065b2602a27df38$export$f14689466e4eca7a;

});
parcelRegister("3TzTk", function(module, exports) {
$parcel$export(module.exports, "translations", () => $ba8268ab2fe65eff$export$150b732325d14d04);
const $ba8268ab2fe65eff$export$44271b4f0c6a3563 = (value)=>{
    if (!value || value.length === 0) return '';
    /**
	 * All of the following are actually invalid in CSS selectors.
	 * It's unlikely that a lot of these are actually used as `Spotlight` `name` prop values.
	 * If it turns out other characters are used, add them as needed.
	 *
	 * (space) — descendant combinator
	 * > — child combinator
	 * + — adjacent sibling combinator
	 * ~ — general sibling combinator
	 * . — class selector
	 * # — ID selector
	 * : — pseudo-class/element
	 * [ ] — attribute selectors
	 * ( ) — functional notation
	 * , — selector list separator
	 * * — universal selector
	 * | — namespace separator
	 * " ' — string delimiters
	 * \ — escape character
	 * Characters not allowed in unescaped identifiers:
	 * Digits 0-9 cannot be the first character
	 * !, @, $, %, ^, &, =, {, }, ;, /, and most other punctuation
	 */ return value.split(' ').join('-').split('/').join('-');
};
const $ba8268ab2fe65eff$var$placementMap = {
    'top right': 'top-start',
    'top center': 'top-center',
    'top left': 'top-end',
    'right bottom': 'right-start',
    'right middle': 'right-start',
    'right top': 'right-end',
    'bottom left': 'bottom-end',
    'bottom center': 'bottom-center',
    'bottom right': 'bottom-start',
    'left top': 'left-end',
    'left middle': 'left-start',
    'left bottom': 'left-start'
};
const $ba8268ab2fe65eff$export$608d2c28a2f3926e = (value)=>{
    // `bottom left` is the default placement when `undefined` is passed.
    return $ba8268ab2fe65eff$var$placementMap[value || 'bottom left'];
};
const $ba8268ab2fe65eff$export$150b732325d14d04 = {
    target: $ba8268ab2fe65eff$export$44271b4f0c6a3563,
    dialogPlacement: $ba8268ab2fe65eff$export$608d2c28a2f3926e
};

});



parcelRegister("aqNhn", function(module, exports) {
$parcel$export(module.exports, "useCurrentPreviewPanel", () => $35d6e6f7e9c6f446$export$5351114e92b31bc6);

var $g41Yv = parcelRequire("g41Yv");
const $35d6e6f7e9c6f446$export$5351114e92b31bc6 = ()=>{
    const context = (0, $g41Yv.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    return {
        ...context.state.panel,
        width: context.width,
        setWidth: context.setPanelWidth
    };
};

});

parcelRegister("cIDM9", function(module, exports) {
module.exports = $942872b551f4bcde$var$defaultsPlugin;
function $942872b551f4bcde$var$defaultsPlugin() {
    var defaultValues = {};
    return {
        defaults: defaults,
        get: get
    };
    function defaults(_, values) {
        defaultValues = values;
    }
    function get(super_fn, key) {
        var val = super_fn();
        return val !== undefined ? val : defaultValues[key];
    }
}

});

parcelRegister("hK7W9", function(module, exports) {
var $ceace3a1707f4701$var$namespace = 'expire_mixin';
module.exports = $ceace3a1707f4701$var$expirePlugin;
function $ceace3a1707f4701$var$expirePlugin() {
    var expirations = this.createStore(this.storage, null, this._namespacePrefix + $ceace3a1707f4701$var$namespace);
    return {
        set: expire_set,
        get: expire_get,
        remove: expire_remove,
        getExpiration: getExpiration,
        removeExpiredKeys: removeExpiredKeys
    };
    function expire_set(super_fn, key, val, expiration) {
        if (!this.hasNamespace($ceace3a1707f4701$var$namespace)) expirations.set(key, expiration);
        return super_fn();
    }
    function expire_get(super_fn, key) {
        if (!this.hasNamespace($ceace3a1707f4701$var$namespace)) _checkExpiration.call(this, key);
        return super_fn();
    }
    function expire_remove(super_fn, key) {
        if (!this.hasNamespace($ceace3a1707f4701$var$namespace)) expirations.remove(key);
        return super_fn();
    }
    function getExpiration(_, key) {
        return expirations.get(key);
    }
    function removeExpiredKeys(_) {
        var keys = [];
        this.each(function(val, key) {
            keys.push(key);
        });
        for(var i = 0; i < keys.length; i++)_checkExpiration.call(this, keys[i]);
    }
    function _checkExpiration(key) {
        var expiration = expirations.get(key, Number.MAX_VALUE);
        if (expiration <= new Date().getTime()) {
            this.raw.remove(key);
            expirations.remove(key);
        }
    }
}

});

parcelRegister("gTA3a", function(module, exports) {

var $YGUg0 = parcelRequire("YGUg0");
var $c4cdbf36045a17e3$var$slice = $YGUg0.slice;
var $c4cdbf36045a17e3$var$pluck = $YGUg0.pluck;
var $c4cdbf36045a17e3$var$each = $YGUg0.each;
var $c4cdbf36045a17e3$var$bind = $YGUg0.bind;
var $c4cdbf36045a17e3$var$create = $YGUg0.create;
var $c4cdbf36045a17e3$var$isList = $YGUg0.isList;
var $c4cdbf36045a17e3$var$isFunction = $YGUg0.isFunction;
var $c4cdbf36045a17e3$var$isObject = $YGUg0.isObject;
module.exports = {
    createStore: $c4cdbf36045a17e3$var$createStore
};
var $c4cdbf36045a17e3$var$storeAPI = {
    version: '2.0.12',
    enabled: false,
    // get returns the value of the given key. If that value
    // is undefined, it returns optionalDefaultValue instead.
    get: function(key, optionalDefaultValue) {
        var data = this.storage.read(this._namespacePrefix + key);
        return this._deserialize(data, optionalDefaultValue);
    },
    // set will store the given value at key and returns value.
    // Calling set with value === undefined is equivalent to calling remove.
    set: function(key, value) {
        if (value === undefined) return this.remove(key);
        this.storage.write(this._namespacePrefix + key, this._serialize(value));
        return value;
    },
    // remove deletes the key and value stored at the given key.
    remove: function(key) {
        this.storage.remove(this._namespacePrefix + key);
    },
    // each will call the given callback once for each key-value pair
    // in this store.
    each: function(callback) {
        var self = this;
        this.storage.each(function(val, namespacedKey) {
            callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''));
        });
    },
    // clearAll will remove all the stored key-value pairs in this store.
    clearAll: function() {
        this.storage.clearAll();
    },
    // additional functionality that can't live in plugins
    // ---------------------------------------------------
    // hasNamespace returns true if this store instance has the given namespace.
    hasNamespace: function(namespace) {
        return this._namespacePrefix == '__storejs_' + namespace + '_';
    },
    // createStore creates a store.js instance with the first
    // functioning storage in the list of storage candidates,
    // and applies the the given mixins to the instance.
    createStore: function() {
        return $c4cdbf36045a17e3$var$createStore.apply(this, arguments);
    },
    addPlugin: function(plugin) {
        this._addPlugin(plugin);
    },
    namespace: function(namespace) {
        return $c4cdbf36045a17e3$var$createStore(this.storage, this.plugins, namespace);
    }
};
function $c4cdbf36045a17e3$var$_warn() {
    var _console = typeof console == 'undefined' ? null : console;
    if (!_console) return;
    var fn = _console.warn ? _console.warn : _console.log;
    fn.apply(_console, arguments);
}
function $c4cdbf36045a17e3$var$createStore(storages, plugins, namespace) {
    if (!namespace) namespace = '';
    if (storages && !$c4cdbf36045a17e3$var$isList(storages)) storages = [
        storages
    ];
    if (plugins && !$c4cdbf36045a17e3$var$isList(plugins)) plugins = [
        plugins
    ];
    var namespacePrefix = namespace ? '__storejs_' + namespace + '_' : '';
    var namespaceRegexp = namespace ? new RegExp('^' + namespacePrefix) : null;
    var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
    ;
    if (!legalNamespaces.test(namespace)) throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes');
    var _privateStoreProps = {
        _namespacePrefix: namespacePrefix,
        _namespaceRegexp: namespaceRegexp,
        _testStorage: function(storage) {
            try {
                var testStr = '__storejs__test__';
                storage.write(testStr, testStr);
                var ok = storage.read(testStr) === testStr;
                storage.remove(testStr);
                return ok;
            } catch (e) {
                return false;
            }
        },
        _assignPluginFnProp: function(pluginFnProp, propName) {
            var oldFn = this[propName];
            this[propName] = function pluginFn() {
                var args = $c4cdbf36045a17e3$var$slice(arguments, 0);
                var self = this;
                // super_fn calls the old function which was overwritten by
                // this mixin.
                function super_fn() {
                    if (!oldFn) return;
                    $c4cdbf36045a17e3$var$each(arguments, function(arg, i) {
                        args[i] = arg;
                    });
                    return oldFn.apply(self, args);
                }
                // Give mixing function access to super_fn by prefixing all mixin function
                // arguments with super_fn.
                var newFnArgs = [
                    super_fn
                ].concat(args);
                return pluginFnProp.apply(self, newFnArgs);
            };
        },
        _serialize: function(obj) {
            return JSON.stringify(obj);
        },
        _deserialize: function(strVal, defaultVal) {
            if (!strVal) return defaultVal;
            // It is possible that a raw string value has been previously stored
            // in a storage without using store.js, meaning it will be a raw
            // string value instead of a JSON serialized string. By defaulting
            // to the raw string value in case of a JSON parse error, we allow
            // for past stored values to be forwards-compatible with store.js
            var val = '';
            try {
                val = JSON.parse(strVal);
            } catch (e) {
                val = strVal;
            }
            return val !== undefined ? val : defaultVal;
        },
        _addStorage: function(storage) {
            if (this.enabled) return;
            if (this._testStorage(storage)) {
                this.storage = storage;
                this.enabled = true;
            }
        },
        _addPlugin: function(plugin) {
            var self = this;
            // If the plugin is an array, then add all plugins in the array.
            // This allows for a plugin to depend on other plugins.
            if ($c4cdbf36045a17e3$var$isList(plugin)) {
                $c4cdbf36045a17e3$var$each(plugin, function(plugin) {
                    self._addPlugin(plugin);
                });
                return;
            }
            // Keep track of all plugins we've seen so far, so that we
            // don't add any of them twice.
            var seenPlugin = $c4cdbf36045a17e3$var$pluck(this.plugins, function(seenPlugin) {
                return plugin === seenPlugin;
            });
            if (seenPlugin) return;
            this.plugins.push(plugin);
            // Check that the plugin is properly formed
            if (!$c4cdbf36045a17e3$var$isFunction(plugin)) throw new Error('Plugins must be function values that return objects');
            var pluginProperties = plugin.call(this);
            if (!$c4cdbf36045a17e3$var$isObject(pluginProperties)) throw new Error('Plugins must return an object of function properties');
            // Add the plugin function properties to this store instance.
            $c4cdbf36045a17e3$var$each(pluginProperties, function(pluginFnProp, propName) {
                if (!$c4cdbf36045a17e3$var$isFunction(pluginFnProp)) throw new Error('Bad plugin property: ' + propName + ' from plugin ' + plugin.name + '. Plugins should only return functions.');
                self._assignPluginFnProp(pluginFnProp, propName);
            });
        },
        // Put deprecated properties in the private API, so as to not expose it to accidential
        // discovery through inspection of the store object.
        // Deprecated: addStorage
        addStorage: function(storage) {
            $c4cdbf36045a17e3$var$_warn('store.addStorage(storage) is deprecated. Use createStore([storages])');
            this._addStorage(storage);
        }
    };
    var store = $c4cdbf36045a17e3$var$create(_privateStoreProps, $c4cdbf36045a17e3$var$storeAPI, {
        plugins: []
    });
    store.raw = {};
    $c4cdbf36045a17e3$var$each(store, function(prop, propName) {
        if ($c4cdbf36045a17e3$var$isFunction(prop)) store.raw[propName] = $c4cdbf36045a17e3$var$bind(store, prop);
    });
    $c4cdbf36045a17e3$var$each(storages, function(storage) {
        store._addStorage(storage);
    });
    $c4cdbf36045a17e3$var$each(plugins, function(plugin) {
        store._addPlugin(plugin);
    });
    return store;
}

});
parcelRegister("YGUg0", function(module, exports) {
var $0b66e3060116e966$var$assign = $0b66e3060116e966$var$make_assign();
var $0b66e3060116e966$var$create = $0b66e3060116e966$var$make_create();
var $0b66e3060116e966$var$trim = $0b66e3060116e966$var$make_trim();
var $0b66e3060116e966$var$Global = typeof window !== 'undefined' ? window : $parcel$global;
module.exports = {
    assign: $0b66e3060116e966$var$assign,
    create: $0b66e3060116e966$var$create,
    trim: $0b66e3060116e966$var$trim,
    bind: $0b66e3060116e966$var$bind,
    slice: $0b66e3060116e966$var$slice,
    each: $0b66e3060116e966$var$each,
    map: $0b66e3060116e966$var$map,
    pluck: $0b66e3060116e966$var$pluck,
    isList: $0b66e3060116e966$var$isList,
    isFunction: $0b66e3060116e966$var$isFunction,
    isObject: $0b66e3060116e966$var$isObject,
    Global: $0b66e3060116e966$var$Global
};
function $0b66e3060116e966$var$make_assign() {
    if (Object.assign) return Object.assign;
    else return function shimAssign(obj, props1, props2, etc) {
        for(var i = 1; i < arguments.length; i++)$0b66e3060116e966$var$each(Object(arguments[i]), function(val, key) {
            obj[key] = val;
        });
        return obj;
    };
}
function $0b66e3060116e966$var$make_create() {
    if (Object.create) return function create(obj, assignProps1, assignProps2, etc) {
        var assignArgsList = $0b66e3060116e966$var$slice(arguments, 1);
        return $0b66e3060116e966$var$assign.apply(this, [
            Object.create(obj)
        ].concat(assignArgsList));
    };
    else {
        function F() {} // eslint-disable-line no-inner-declarations
        return function create(obj, assignProps1, assignProps2, etc) {
            var assignArgsList = $0b66e3060116e966$var$slice(arguments, 1);
            F.prototype = obj;
            return $0b66e3060116e966$var$assign.apply(this, [
                new F()
            ].concat(assignArgsList));
        };
    }
}
function $0b66e3060116e966$var$make_trim() {
    if (String.prototype.trim) return function trim(str) {
        return String.prototype.trim.call(str);
    };
    else return function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}
function $0b66e3060116e966$var$bind(obj, fn) {
    return function() {
        return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
    };
}
function $0b66e3060116e966$var$slice(arr, index) {
    return Array.prototype.slice.call(arr, index || 0);
}
function $0b66e3060116e966$var$each(obj, fn) {
    $0b66e3060116e966$var$pluck(obj, function(val, key) {
        fn(val, key);
        return false;
    });
}
function $0b66e3060116e966$var$map(obj, fn) {
    var res = $0b66e3060116e966$var$isList(obj) ? [] : {};
    $0b66e3060116e966$var$pluck(obj, function(v, k) {
        res[k] = fn(v, k);
        return false;
    });
    return res;
}
function $0b66e3060116e966$var$pluck(obj, fn) {
    if ($0b66e3060116e966$var$isList(obj)) for(var i = 0; i < obj.length; i++){
        if (fn(obj[i], i)) return obj[i];
    }
    else {
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            if (fn(obj[key], key)) return obj[key];
        }
    }
}
function $0b66e3060116e966$var$isList(val) {
    return val != null && typeof val != 'function' && typeof val.length == 'number';
}
function $0b66e3060116e966$var$isFunction(val) {
    return val && ({}).toString.call(val) === '[object Function]';
}
function $0b66e3060116e966$var$isObject(val) {
    return val && ({}).toString.call(val) === '[object Object]';
}

});


parcelRegister("hUJAs", function(module, exports) {
// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.
module.exports = {
    name: 'memoryStorage',
    read: $d0ab073f4b5e02f8$var$read,
    write: $d0ab073f4b5e02f8$var$write,
    each: $d0ab073f4b5e02f8$var$each,
    remove: $d0ab073f4b5e02f8$var$remove,
    clearAll: $d0ab073f4b5e02f8$var$clearAll
};
var $d0ab073f4b5e02f8$var$memoryStorage = {};
function $d0ab073f4b5e02f8$var$read(key) {
    return $d0ab073f4b5e02f8$var$memoryStorage[key];
}
function $d0ab073f4b5e02f8$var$write(key, data) {
    $d0ab073f4b5e02f8$var$memoryStorage[key] = data;
}
function $d0ab073f4b5e02f8$var$each(callback) {
    for(var key in $d0ab073f4b5e02f8$var$memoryStorage)if ($d0ab073f4b5e02f8$var$memoryStorage.hasOwnProperty(key)) callback($d0ab073f4b5e02f8$var$memoryStorage[key], key);
}
function $d0ab073f4b5e02f8$var$remove(key) {
    delete $d0ab073f4b5e02f8$var$memoryStorage[key];
}
function $d0ab073f4b5e02f8$var$clearAll(key) {
    $d0ab073f4b5e02f8$var$memoryStorage = {};
}

});

parcelRegister("1J1da", function(module, exports) {

var $YGUg0 = parcelRequire("YGUg0");
var $141aeef1c21a157c$var$Global = $YGUg0.Global;
module.exports = {
    name: 'sessionStorage',
    read: $141aeef1c21a157c$var$read,
    write: $141aeef1c21a157c$var$write,
    each: $141aeef1c21a157c$var$each,
    remove: $141aeef1c21a157c$var$remove,
    clearAll: $141aeef1c21a157c$var$clearAll
};
function $141aeef1c21a157c$var$sessionStorage() {
    return $141aeef1c21a157c$var$Global.sessionStorage;
}
function $141aeef1c21a157c$var$read(key) {
    return $141aeef1c21a157c$var$sessionStorage().getItem(key);
}
function $141aeef1c21a157c$var$write(key, data) {
    return $141aeef1c21a157c$var$sessionStorage().setItem(key, data);
}
function $141aeef1c21a157c$var$each(fn) {
    for(var i = $141aeef1c21a157c$var$sessionStorage().length - 1; i >= 0; i--){
        var key = $141aeef1c21a157c$var$sessionStorage().key(i);
        fn($141aeef1c21a157c$var$read(key), key);
    }
}
function $141aeef1c21a157c$var$remove(key) {
    return $141aeef1c21a157c$var$sessionStorage().removeItem(key);
}
function $141aeef1c21a157c$var$clearAll() {
    return $141aeef1c21a157c$var$sessionStorage().clear();
}

});

parcelRegister("dO8UV", function(module, exports) {
$parcel$export(module.exports, "ChatContextSubscriber", () => $b91fbac888104837$export$29ff0802eb3bb217);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $6dtVG = parcelRequire("6dtVG");

var $5vRZY = parcelRequire("5vRZY");
const $b91fbac888104837$export$29ff0802eb3bb217 = ()=>{
    const { setEditorContext: setEditorContext, setBrowserContext: setBrowserContext, setDashboardContext: setDashboardContext, setAIFeatureContext: setAIFeatureContext, setJiraCreateContext: setJiraCreateContext, setArtifactContext: setArtifactContext, mergeDatabaseContext: mergeDatabaseContext, setPageSmartLinks: setPageSmartLinks } = (0, $5vRZY.useChatContextStoreActions)();
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6dtVG.Subscriber), {
        topic: "ai-mate",
        onEvent: async (payload)=>{
            // TODO https://product-fabric.atlassian.net/browse/AIM-1989 implement experience tracker
            try {
                switch(payload.type){
                    case 'editor-context-payload':
                        setEditorContext(payload.data);
                        break;
                    case 'browser-context-payload':
                        setBrowserContext(payload.data);
                        break;
                    case 'dashboard-insights-actions':
                        setDashboardContext(payload.data);
                        break;
                    case 'database-context-payload':
                        mergeDatabaseContext(payload.data);
                        break;
                    case 'set-message-context':
                        setAIFeatureContext(payload.data);
                        break;
                    case 'jira-create-context-payload':
                        setJiraCreateContext(payload.data);
                        break;
                    case 'artifact-context-payload':
                        if (!(0, $llCao.fg)('platform_forge_ui_artifact_rovo_chat_context')) break;
                        setArtifactContext(payload.data);
                        break;
                    case 'smartlinks-context-payload':
                        if (payload.status) setPageSmartLinks(payload.data, payload.status);
                        else setPageSmartLinks(payload.data);
                        break;
                    default:
                }
            } catch  {}
        }
    });
};
$b91fbac888104837$export$29ff0802eb3bb217.displayName = "ChatContextSubscriber";

});

parcelRegister("jj3dB", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistantButton", () => $0e981c09e8c975c0$export$7c328c0993982813);
$parcel$export(module.exports, "ConversationAssistantButtonNav4", () => $0e981c09e8c975c0$export$25e85d244cbf7845);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $oAzkD = parcelRequire("oAzkD");

var $jWJ9H = parcelRequire("jWJ9H");

var $3NfiF = parcelRequire("3NfiF");

var $bbyHr = parcelRequire("bbyHr");

var $5Y9N2 = parcelRequire("5Y9N2");

var $1ewxO = parcelRequire("1ewxO");

var $cIdnd = parcelRequire("cIdnd");

var $llCao = parcelRequire("llCao");

var $ig4Ak = parcelRequire("ig4Ak");

var $TLRFC = parcelRequire("TLRFC");

var $35rMO = parcelRequire("35rMO");

var $3Kmf8 = parcelRequire("3Kmf8");

var $jizTQ = parcelRequire("jizTQ");

var $biIKP = parcelRequire("biIKP");

var $dYg8A = parcelRequire("dYg8A");

var $gXkwQ = parcelRequire("gXkwQ");

var $dNV6N = parcelRequire("dNV6N");

var $4rFTp = parcelRequire("4rFTp");

var $jJrcr = parcelRequire("jJrcr");

var $9vcXb = parcelRequire("9vcXb");

var $gF7cG = parcelRequire("gF7cG");

var $kgcSG = parcelRequire("kgcSG");

var $l7jaf = parcelRequire("l7jaf");

var $fTlni = parcelRequire("fTlni");

var $2IS5k = parcelRequire("2IS5k");

var $4rfpn = parcelRequire("4rfpn");
const $0e981c09e8c975c0$var$defaultButtonStyles = {
    paddingInline: "var(--ds-space-100, 8px)"
};
const $0e981c09e8c975c0$var$inactiveButtonStyles = {
    background: "var(--ds-background-neutral, #0515240F)"
};
const $0e981c09e8c975c0$var$disabledButtonStyles = {
    background: "var(--ds-background-disabled, #0515240F)",
    color: "var(--ds-text-disabled, #080F214A)"
};
const $0e981c09e8c975c0$var$conversationAssistantButtonWrapperNoOverlayStyles = null;
const $0e981c09e8c975c0$var$topNavButtonFlareKeyframes = null;
const $0e981c09e8c975c0$var$topNavButtonFlareAnimationStyles = null;
const $0e981c09e8c975c0$var$baseShadow = `0 0 0 2px ${"var(--ds-border-discovery, #AF59E1)"}`;
const $0e981c09e8c975c0$var$pulseKeyframes = null;
const $0e981c09e8c975c0$var$pulseAnimationStyles = null;
const $0e981c09e8c975c0$var$reduceMotionStyles = null;
const $0e981c09e8c975c0$var$getAtlasChatUrl = (siteId, orgId)=>{
    const orgPath = orgId ? `/o/${encodeURIComponent(orgId)}` : '';
    return (0, $ig4Ak.addRovoParamsToUrl)(`${(0, $fTlni.getDefaultShareBaseUrl)()}${orgPath}/chat?cloudId=${encodeURIComponent(siteId)}`, {
        cloudId: siteId,
        pathway: 'chat'
    });
};
/**
 * Wraps button in a div that plays the top-nav flare animation.
 */ const $0e981c09e8c975c0$var$AnimatedFlareWrapper = ({ productKey: productKey, children: children })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jizTQ.useAnalytics)();
    (0, $fsvuC.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: 'animation',
            actionSubjectId: 'conversationAssistantButtonFlareAnimation',
            attributes: {
                productKey: productKey
            }
        });
    }, [
        sendAnalyticsEvent,
        productKey
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": "animated-flare-wrapper",
        className: (0, $gJ6nT.default)([
            "_0ubfYRlfZc _0RxVZVy7kJ _46PhP8f7mX _0rushMd1Zr _0jh4YZy7kJ",
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn _3iDTPbccYA _1uo2Zfx2jY _1mT5xdRAKS _4eDJc6NyaH _3fRV4C0oWv _1iAcE9M9iZ _0YTlbl7dHp _2ofBtgjkka _2Il32FxxUt _3Ku51Iogpp _4odxdyN91d _1cR5ZLLUVw _2jTvwtdnbC _2IjmTKdnbC _0UsFEzYbGa _3dCYwDWVPG _3qT6l0dnbC _0ubfYRyL8i _0rushMyL8i _4BbId5YbGa _4bHSExdnbC"
        ]),
        children: children
    });
};
$0e981c09e8c975c0$var$AnimatedFlareWrapper.displayName = "AnimatedFlareWrapper";
const $0e981c09e8c975c0$var$getConversationAssistantButton = (Button = (0, $bbyHr.PrimaryButton))=>/*#__PURE__*/ (0, $fsvuC.forwardRef)(({ testId: testId, isActive: isActive, isDisabled: isDisabled = false, onClick: onClickProp, onMouseEnter: onMouseEnterProp, label: label, tooltipContent: tooltipContent, shortcut: shortcut, orgId: orgId, siteId: siteId, productKey: productKey, analyticsAttributes: analyticsAttributes, enableOnboardingSpotlight: enableOnboardingSpotlight = false }, ref)=>{
        (0, $jWJ9H.di)((0, $5Y9N2.default), (0, $gF7cG.useInsightsStatus));
        const { formatMessage: formatMessage } = (0, $oAzkD.default)();
        const { start: start } = (0, $dYg8A.useConversationAssistantSpotlightActions)();
        const { PostOfficePlacement: PostOfficePlacement } = (0, $9vcXb.usePostOfficePlacement)();
        // Read from context only: this must not trigger a profile request just by mounting.
        const profileAaid = (0, $fsvuC.useContext)((0, $jJrcr.ProfileContext))?.aaid;
        // Prefetch insights status to warm the cache before the user opens chat.
        // This triggers the backend to generate insights asynchronously if not already cached.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isPulseExperimentEnabled = (0, $5Y9N2.default).getExperimentValue('rovo_growth_chat_pulse', 'isEnabled', false);
        (0, $gF7cG.useInsightsStatus)({
            enabled: isPulseExperimentEnabled,
            assistanceServiceParams: {
                touchpointSource: 'ask-rovo-button-prefetch',
                product: productKey,
                experienceId: 'ai-mate',
                siteId: siteId
            }
        });
        const [prefersReducedMotion] = (0, $fsvuC.useState)(()=>typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true);
        const [shouldShowMessage, setShouldShowMessage] = (0, $fsvuC.useState)(false);
        const messageId = productKey === 'confluence' ? 'confluence_rovo_chat_agents_spotlight_ga' : productKey === 'jira' ? 'jira_rovo_chat_agents_spotlight_ga' : '';
        const shouldUseCoordination = enableOnboardingSpotlight && !!messageId;
        const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jizTQ.useAnalytics)();
        // Capture initial prop values in a ref so the rendered event fires exactly once
        // on mount, even if reactive props like isActive/isDisabled change later.
        const renderedAttributesRef = (0, $fsvuC.useRef)({
            isActive: isActive,
            isDisabled: isDisabled,
            productKey: productKey
        });
        const sendAnalyticsEventRef = (0, $fsvuC.useRef)(sendAnalyticsEvent);
        sendAnalyticsEventRef.current = sendAnalyticsEvent;
        (0, $fsvuC.useEffect)(()=>{
            sendAnalyticsEventRef.current({
                eventType: 'operational',
                action: 'rendered',
                actionSubject: 'rovoChatButton',
                attributes: renderedAttributesRef.current
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        const openRovoChat = (event, analyticsEvent)=>{
            if (!isActive && onClick) onClick(event, analyticsEvent);
        };
        const onClick = (0, $fsvuC.useCallback)((...params)=>{
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'rovoChatButton',
                attributes: {
                    isActive: isActive,
                    isDisabled: isDisabled,
                    productKey: productKey,
                    ...analyticsAttributes
                }
            });
            return onClickProp?.(...params);
        }, [
            analyticsAttributes,
            isActive,
            isDisabled,
            onClickProp,
            productKey,
            sendAnalyticsEvent
        ]);
        const interactionName = isActive ? 'close-rovo-chat-nav-button' : 'open-rovo-chat-nav-button';
        const buttonLabel = label ?? formatMessage((0, $2IS5k.messages).rovoChatButtonLabel);
        const getChildren = ()=>{
            const button = /*#__PURE__*/ (0, $5chsV.jsx)(Button, {
                "data-spotlight-target": "rovo-chat-ask-rovo-button",
                onMouseEnter: (event)=>{
                    onMouseEnterProp?.(event);
                    // Fill the prompt-of-the-day cache before the panel opens, so it renders without a wait.
                    (0, $4rfpn.prefetchPromptOfTheDay)(profileAaid);
                    sendAnalyticsEvent({
                        eventType: 'ui',
                        action: 'hovered',
                        actionSubject: 'rovoChatButton',
                        attributes: {
                            isActive: isActive,
                            isDisabled: isDisabled,
                            productKey: productKey
                        }
                    });
                    if (shouldShowMessage) {
                        sendAnalyticsEvent({
                            eventType: 'ui',
                            action: 'hovered',
                            actionSubject: 'rovoChatButtonSpotlight'
                        });
                        start();
                    }
                },
                testId: testId,
                isSelected: isActive,
                onClick: onClick,
                isDisabled: isDisabled,
                tooltip: tooltipContent ?? /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Fragment), {
                    children: formatMessage((0, $2IS5k.messages).rovoChatButtonLabel)
                }),
                shortcut: shortcut,
                style: {
                    /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ ...$0e981c09e8c975c0$var$defaultButtonStyles,
                    ...!isActive && $0e981c09e8c975c0$var$inactiveButtonStyles,
                    ...isDisabled && $0e981c09e8c975c0$var$disabledButtonStyles
                },
                // The button's own visible/accessible label ("Ask Rovo") already conveys the
                // icon's meaning, so mark the icon as decorative to avoid a redundant
                // "Rovo Ask Rovo" screen reader announcement.
                iconBefore: /*#__PURE__*/ (0, $5chsV.jsx)((0, $1ewxO.RovoIcon), {
                    size: "xxsmall",
                    label: ""
                }),
                interactionName: interactionName,
                ref: ref,
                children: buttonLabel
            });
            if (Button === (0, $bbyHr.PrimaryButton)) return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                role: "list",
                children: button
            });
            if (!isActive && !isDisabled) {
                const shouldAnimateTopNavButton = !prefersReducedMotion && // Targets non-MAU Rovo Chat users — once a user becomes MAU, the gate
                // resolves to false on their next session (batch trait refreshes daily).
                (0, $llCao.fg)('rovo_chat_non_mau_rovo_button_animation_filter') && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
                (0, $5Y9N2.default).getExperimentValue('ask_rovo_top_nav_button_animation', 'isEnabled', false);
                if (shouldAnimateTopNavButton) return /*#__PURE__*/ (0, $5chsV.jsx)($0e981c09e8c975c0$var$AnimatedFlareWrapper, {
                    productKey: productKey,
                    children: button
                });
                return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    className: (0, $gJ6nT.default)([
                        "_0ubfYRlfZc _0RxVZVy7kJ _46PhP8f7mX _0rushMd1Zr _0jh4YZy7kJ"
                    ]),
                    children: button
                });
            }
            return button;
        };
        // The long-running-task PostOffice placement is anchored to the Ask Rovo
        // button (via data-spotlight-target) and must mount for every product
        // including Townsquare (productKey="atlas"), so it lives outside
        // SpotlightWrapper which only renders for products that opt into the
        // agents-onboarding coordination flow.
        // Uses <Fragment> (not <>) because this file has @jsx pragma without @jsxFrag.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isFullPageSpotlightEnabled = productKey === 'jira' && (0, $5Y9N2.default).getExperimentValue('rovo_chat_full_page_chat_spotlight', 'isEnabled', false);
        // FOMO spotlight for Atlas home (townsquare).
        //
        // This is a plain killswitch, NOT an experiment read. Randomization and
        // exposure for `rovo_chat_fomo_spotlight_in_home` happen in exactly one
        // place: inside the spotlight's own eligibility gate, after the non-MAU
        // and has-collaborators checks (see AtlasHomeFomoSpotlightConsumer).
        // Reading the experiment here as well would assign every Atlas user who
        // renders this button — including Rovo Chat MAU users and users with no
        // collaborators, who can never see the spotlight — blending the
        // value-proof and social-proof arms into one indistinguishable cell.
        //
        // `rovo_chat_fomo_spotlight_lifecycle` is the message template's own
        // lifecycle gate (see the Post Office template's config.ts and
        // filters/index.ts). Reusing it keeps one switch for "is this message
        // live": when it is off Post Office would not deliver anyway, so this
        // check just avoids mounting the placement and its fetch.
        const isFomoSpotlightEnabled = productKey === 'atlas' && (0, $llCao.fg)('rovo_chat_fomo_spotlight_lifecycle');
        return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
            children: [
                shouldUseCoordination || isFullPageSpotlightEnabled || isFomoSpotlightEnabled ? /*#__PURE__*/ (0, $5chsV.jsx)($0e981c09e8c975c0$export$de76c194bfb85689, {
                    setShouldShowMessage: setShouldShowMessage,
                    messageId: messageId,
                    orgId: orgId,
                    siteId: siteId,
                    children: getChildren(),
                    shouldShowMessage: shouldShowMessage,
                    openRovoChat: (event, analyticsEvent)=>openRovoChat(event, analyticsEvent),
                    isFullPageSpotlightEnabled: isFullPageSpotlightEnabled,
                    isFomoSpotlightEnabled: isFomoSpotlightEnabled
                }) : getChildren(),
                PostOfficePlacement && (0, $llCao.fg)('rovo_chat_max_mode_spotlight') && /*#__PURE__*/ (0, $5chsV.jsx)(PostOfficePlacement, {
                    placementId: "rovo-chat-long-running-task-spotlight",
                    // This placement fetches its own data. Disable the outer request to avoid duplicates
                    // when React replays renders during Suspense retries.
                    disableInitialData: true
                })
            ]
        });
    });
const $0e981c09e8c975c0$var$Nav4Button = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ tooltip: tooltip, shortcut: shortcut, ...props }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3Kmf8.default), {
        content: tooltip,
        shortcut: shortcut,
        // This button's visible text matches the tooltip
        // Announcing the tooltip means 'Chat' would be announced twice
        isScreenReaderAnnouncementDisabled: true,
        children: ({ ref: tooltipRef, ...triggerProps })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $cIdnd.Button), {
                interactionName: props?.interactionName,
                ref: (0, $3NfiF.mergeRefs)([
                    forwardedRef,
                    tooltipRef
                ]),
                ...triggerProps,
                ...props,
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps.onClick?.(event);
                },
                iconBefore: ()=>props.iconBefore || null
            })
    });
});
const $0e981c09e8c975c0$export$7c328c0993982813 = $0e981c09e8c975c0$var$getConversationAssistantButton((0, $bbyHr.PrimaryButton));
const $0e981c09e8c975c0$export$25e85d244cbf7845 = $0e981c09e8c975c0$var$getConversationAssistantButton($0e981c09e8c975c0$var$Nav4Button);
const $0e981c09e8c975c0$export$de76c194bfb85689 = ({ children: children, messageId: messageId, orgId: orgId, siteId: siteId, setShouldShowMessage: setShouldShowMessage, shouldShowMessage: shouldShowMessage, openRovoChat: openRovoChat, isFullPageSpotlightEnabled: isFullPageSpotlightEnabled = false, isFomoSpotlightEnabled: isFomoSpotlightEnabled = false })=>{
    (0, $jWJ9H.di)((0, $biIKP.usePostOfficeCoordination));
    const { activeSpotlight: activeSpotlight } = (0, $dYg8A.useConversationAssistantSpotlightState)();
    const [onboardingStarted, stopOnboarding] = (0, $biIKP.usePostOfficeCoordination)(messageId);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jizTQ.useAnalytics)();
    const onDismissMessage = ()=>{
        setShouldShowMessage(false);
        stopOnboarding();
    };
    const openFullPageRovoChat = (0, $fsvuC.useCallback)(()=>{
        window.location.assign($0e981c09e8c975c0$var$getAtlasChatUrl(siteId, orgId));
    }, [
        orgId,
        siteId
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (shouldShowMessage && activeSpotlight !== null) sendAnalyticsEvent({
            eventType: 'ui',
            action: 'shown',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    }, [
        shouldShowMessage,
        activeSpotlight,
        sendAnalyticsEvent
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (onboardingStarted) setShouldShowMessage(true);
    }, [
        onboardingStarted,
        setShouldShowMessage
    ]);
    // Mutually exclusive with the onboarding spotlight — don't show both at once
    const shouldShowFullPageSpotlight = isFullPageSpotlightEnabled && !shouldShowMessage;
    const shouldShowFomoSpotlight = isFomoSpotlightEnabled && !shouldShowMessage;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $l7jaf.ConditionalWrapper), {
        condition: shouldShowMessage || shouldShowFullPageSpotlight || shouldShowFomoSpotlight,
        wrapper: (children)=>/*#__PURE__*/ (0, $5chsV.jsxs)((0, $TLRFC.PopoverProvider), {
                children: [
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $35rMO.PopoverTarget), {
                        children: /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
                            className: (0, $gJ6nT.default)([
                                shouldShowMessage && activeSpotlight === null && "",
                                shouldShowMessage && activeSpotlight === null && "_0bjKvDKxmn _0nFVCGM9iZ _03m2nySHWH _1gBibyAup0 _43vdfTs3G2 _2OUyjtgbYL",
                                "_39Ohv4YbGa _1SdfoHYbGa"
                            ]),
                            children: [
                                children,
                                shouldShowFullPageSpotlight && /*#__PURE__*/ (0, $5chsV.jsx)((0, $kgcSG.ChunkErrorBoundary), {
                                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Suspense), {
                                        fallback: null,
                                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $dNV6N.AsyncRovoFullPageSpotlightPlacement), {
                                            openRovoChat: openFullPageRovoChat
                                        })
                                    })
                                }),
                                shouldShowFomoSpotlight && /*#__PURE__*/ (0, $5chsV.jsx)((0, $kgcSG.ChunkErrorBoundary), {
                                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Suspense), {
                                        fallback: null,
                                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $gXkwQ.AsyncAtlasHomeFomoSpotlightPlacement), {})
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $4rFTp.ConversationAssistantOnboardingSpotlight), {
                        onDismiss: onDismissMessage,
                        openRovoChat: openRovoChat
                    })
                ]
            }),
        children: children
    });
};
$0e981c09e8c975c0$export$de76c194bfb85689.displayName = "SpotlightWrapper";

});
parcelRegister("biIKP", function(module, exports) {
$parcel$export(module.exports, "usePostOfficeCoordination", () => $4a7671b1fe03da7a$export$a890021247f253fb);

var $fsvuC = parcelRequire("fsvuC");

var $k31PG = parcelRequire("k31PG");
const $4a7671b1fe03da7a$export$a890021247f253fb = (messageId)=>{
    const { isActive: poIsActive } = (0, $k31PG.useTrigger)(`${messageId}-started`);
    const { fireTrigger: poRequestMessageStart } = (0, $k31PG.useFirePostOfficeTrigger)({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: poFireDismissClick } = (0, $k31PG.useFirePostOfficeTrigger)({
        triggerId: `${messageId}-dismiss`
    });
    (0, $fsvuC.useEffect)(()=>{
        poRequestMessageStart({
            isActive: true
        });
    }, [
        messageId,
        poRequestMessageStart
    ]);
    const started = poIsActive;
    const stop = (force)=>{
        poFireDismissClick({
            isActive: true
        });
    };
    return [
        started,
        stop
    ];
};

});

parcelRegister("dYg8A", function(module, exports) {
$parcel$export(module.exports, "useConversationAssistantSpotlightActions", () => $e4221da9f915f21b$export$283f4929c8863814);
$parcel$export(module.exports, "useConversationAssistantSpotlightState", () => $e4221da9f915f21b$export$258c2a6b93cdef4a);

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $e4221da9f915f21b$var$initialState = {
    activeSpotlight: null
};
const $e4221da9f915f21b$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: 0
            });
        },
    next: ()=>({ setState: setState, getState: getState })=>{
            setState({
                activeSpotlight: (getState().activeSpotlight || 0) + 1
            });
        },
    end: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: null
            });
        }
};
const $e4221da9f915f21b$var$ConversationAssistantSpotlightStore = (0, $5QDqc.createStore)({
    initialState: $e4221da9f915f21b$var$initialState,
    actions: $e4221da9f915f21b$var$actions,
    name: 'ConversationAssistantSpotlightStore'
});
const $e4221da9f915f21b$export$283f4929c8863814 = (0, $3h1FP.createActionsHook)($e4221da9f915f21b$var$ConversationAssistantSpotlightStore);
const $e4221da9f915f21b$export$258c2a6b93cdef4a = (0, $3h1FP.createStateHook)($e4221da9f915f21b$var$ConversationAssistantSpotlightStore);

});

parcelRegister("gXkwQ", function(module, exports) {
$parcel$export(module.exports, "AsyncAtlasHomeFomoSpotlightPlacement", () => $95d69b270d182772$export$4fade188a259eed);

var $fsvuC = parcelRequire("fsvuC");

const $95d69b270d182772$export$4fade188a259eed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).lazy(()=>(parcelRequire("ggjhlW")).then(({ AtlasHomeFomoSpotlightPlacement: AtlasHomeFomoSpotlightPlacement })=>({
            default: AtlasHomeFomoSpotlightPlacement
        })));
$95d69b270d182772$export$4fade188a259eed.displayName = 'AsyncAtlasHomeFomoSpotlightPlacement';

});
parcelRegister("ggjhlW", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("j0ews").then(()=>parcelRequire('kpMAA'));

});


parcelRegister("dNV6N", function(module, exports) {
$parcel$export(module.exports, "AsyncRovoFullPageSpotlightPlacement", () => $2ea2327aee07b065$export$2a0e9ab75aa119a4);

var $fsvuC = parcelRequire("fsvuC");

const $2ea2327aee07b065$export$2a0e9ab75aa119a4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).lazy(()=>(parcelRequire("labNj")).then(({ RovoFullPageSpotlightPlacement: RovoFullPageSpotlightPlacement })=>({
            default: RovoFullPageSpotlightPlacement
        })));
$2ea2327aee07b065$export$2a0e9ab75aa119a4.displayName = 'AsyncRovoFullPageSpotlightPlacement';

});
parcelRegister("labNj", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("7BJru").then(()=>parcelRequire('5IaBn'));

});


parcelRegister("4rFTp", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistantOnboardingSpotlight", () => $ca4fa43174705108$export$e4abc8af2fc5e2ac);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $oAzkD = parcelRequire("oAzkD");

var $jWJ9H = parcelRequire("jWJ9H");

var $eygIb = parcelRequire("eygIb");

var $3Ru3M = parcelRequire("3Ru3M");

var $9Cyj3 = parcelRequire("9Cyj3");

var $3NMdW = parcelRequire("3NMdW");

var $e9bDS = parcelRequire("e9bDS");

var $6k44y = parcelRequire("6k44y");

var $jZ2NQ = parcelRequire("jZ2NQ");

var $4iMK3 = parcelRequire("4iMK3");

var $8xjQm = parcelRequire("8xjQm");

var $sAY9X = parcelRequire("sAY9X");

var $1rHDk = parcelRequire("1rHDk");

var $jizTQ = parcelRequire("jizTQ");

var $dYg8A = parcelRequire("dYg8A");

var $crRoe = parcelRequire("crRoe");
const $ca4fa43174705108$export$e4abc8af2fc5e2ac = ({ openRovoChat: openRovoChat, onDismiss: onDismiss })=>{
    (0, $jWJ9H.di)((0, $dYg8A.useConversationAssistantSpotlightState));
    const { formatMessage: formatMessage } = (0, $oAzkD.default)();
    const { end: end } = (0, $dYg8A.useConversationAssistantSpotlightActions)();
    const { activeSpotlight: activeSpotlight } = (0, $dYg8A.useConversationAssistantSpotlightState)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jizTQ.useAnalytics)();
    const handleTryChat = (event, analyticsEvent)=>{
        if (openRovoChat) openRovoChat(event, analyticsEvent);
        end();
        onDismiss();
        sendAnalyticsEvent({
            eventType: 'ui',
            // this is more of 'chatButtonClicked'
            action: 'dismissed',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    };
    const handleDismiss = ()=>{
        end();
        onDismiss();
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'dismissButtonClicked',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Fragment), {
        children: activeSpotlight !== null && /*#__PURE__*/ (0, $5chsV.jsx)((0, $8xjQm.PopoverContent), {
            dismiss: handleDismiss,
            isVisible: activeSpotlight !== null,
            placement: "bottom-start",
            children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $9Cyj3.SpotlightCard), {
                children: [
                    /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jZ2NQ.SpotlightHeader), {
                        children: [
                            /*#__PURE__*/ (0, $5chsV.jsx)((0, $4iMK3.SpotlightHeadline), {
                                children: formatMessage((0, $crRoe.default).onboardingHeading)
                            }),
                            /*#__PURE__*/ (0, $5chsV.jsx)((0, $3NMdW.SpotlightControls), {
                                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $e9bDS.SpotlightDismissControl), {
                                    onClick: handleDismiss
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $3Ru3M.SpotlightBody), {
                        children: formatMessage((0, $crRoe.default).onboardingDescription)
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $6k44y.SpotlightFooter), {
                        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $eygIb.SpotlightActions), {
                            children: [
                                /*#__PURE__*/ (0, $5chsV.jsx)((0, $1rHDk.SpotlightSecondaryAction), {
                                    onClick: handleDismiss,
                                    children: formatMessage((0, $crRoe.default).dismissOnboarding)
                                }),
                                /*#__PURE__*/ (0, $5chsV.jsx)((0, $sAY9X.SpotlightPrimaryAction), {
                                    onClick: handleTryChat,
                                    children: formatMessage((0, $crRoe.default).tryChat)
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
$ca4fa43174705108$export$e4abc8af2fc5e2ac.displayName = "ConversationAssistantOnboardingSpotlight";

});
parcelRegister("crRoe", function(module, exports) {
$parcel$export(module.exports, "default", () => $34e17fa1867ed937$export$2e2bcd8739ae039);

var $54F37 = parcelRequire("54F37");
const $34e17fa1867ed937$var$_default_1 = (0, $54F37.defineMessages)({
    tryChat: {
        id: 'rovo-onboarding-try-chat',
        defaultMessage: 'Try Max',
        description: "Button label displayed on the primary action button in the Rovo onboarding spotlight within the AI conversation interface. Shown as the text on a button in the spotlight. When clicked, it starts a new chat session and begins the user's first interaction with the AI assistant. The purpose is to provide a clear call-to-action for users to begin using the AI chat feature after viewing the onboarding information."
    },
    dismissOnboarding: {
        id: 'rovo-onboarding-dismiss',
        defaultMessage: 'Dismiss',
        description: 'Button label displayed on the dismiss button in the Rovo onboarding spotlight within the AI conversation interface. Shown as the text on a button in the spotlight. When clicked, it closes the onboarding spotlight without starting a chat. The purpose is to provide users with a way to skip the onboarding if they are already familiar with the feature or want to explore on their own.'
    },
    onboardingHeading: {
        id: 'rovo-onboarding-heading',
        defaultMessage: 'Say hi to Max',
        description: 'Heading text displayed at the top of the Rovo onboarding spotlight within the AI conversation interface. Shown as the main title or heading in the spotlight. The purpose is to immediately communicate to new users what the feature is about, which is chatting with an AI assistant to get help with work tasks.'
    },
    onboardingDescription: {
        id: 'rovo-onboarding-description',
        defaultMessage: 'Max takes on complex, multi-step work and comes back with a finished result.',
        description: 'Description text displayed in the body of the Rovo onboarding spotlight within the AI conversation interface. Shown as the body text below the heading. The purpose is to explain the key capabilities of Rovo Chat: exploring company knowledge, creating content, and collaborating on work, helping users understand the value and use cases for the AI assistant.'
    }
});
var $34e17fa1867ed937$export$2e2bcd8739ae039 = $34e17fa1867ed937$var$_default_1;

});


parcelRegister("kgcSG", function(module, exports) {
$parcel$export(module.exports, "ChunkErrorBoundary", () => $6f30765a4d5d9149$export$63986981e4af5143);

var $fsvuC = parcelRequire("fsvuC");
class $6f30765a4d5d9149$export$63986981e4af5143 extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        // Log chunk load failures so they are detectable in production
        // eslint-disable-next-line no-console
        console.error('[ChunkErrorBoundary] Failed to load async component chunk:', error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}
$6f30765a4d5d9149$export$63986981e4af5143.displayName = "ChunkErrorBoundary";

});

parcelRegister("l7jaf", function(module, exports) {
$parcel$export(module.exports, "ConditionalWrapper", () => $d821a3f350cb5109$export$39aecc95f0365819);
const $d821a3f350cb5109$export$39aecc95f0365819 = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children;

});

parcelRegister("2IS5k", function(module, exports) {
$parcel$export(module.exports, "messages", () => $88cd548d298c8575$export$defe85febe8b728c);

var $54F37 = parcelRequire("54F37");
const $88cd548d298c8575$export$defe85febe8b728c = (0, $54F37.defineMessages)({
    rovoChatButtonLabel: {
        id: 'conversation-assistant-button.ask-rovo-label',
        defaultMessage: 'Ask Rovo',
        description: 'Label for the button that opens the conversation assistant'
    }
});

});

parcelRegister("4rfpn", function(module, exports) {
$parcel$export(module.exports, "prefetchPromptOfTheDay", () => $e052875fe616470a$export$ccb9f2524bdf794f);

var $dJhjg = parcelRequire("dJhjg");

var $jJrcr = parcelRequire("jJrcr");

var $9qqAa = parcelRequire("9qqAa");
const $e052875fe616470a$export$ccb9f2524bdf794f = async (knownAaid)=>{
    if (!(0, $dJhjg.isExperimentEnabled)('rovo_generated_potd_in_dynamic_panel')) return;
    try {
        const accountId = knownAaid ?? await (0, $jJrcr.fetchProfileAaid)();
        if (accountId) await (0, $9qqAa.fetchPromptOfTheDay)({
            accountId: accountId
        });
    } catch  {
    // The profile request failed; the panel falls back to its own request.
    }
};

});


parcelRegister("hxmGv", function(module, exports) {
$parcel$export(module.exports, "ChatOpenerSubscriber", () => $f52dcd62ba437dce$export$6fa95a645837361b);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $fgXcj = parcelRequire("fgXcj");

var $6dtVG = parcelRequire("6dtVG");

var $ig4Ak = parcelRequire("ig4Ak");

var $hzhxT = parcelRequire("hzhxT");

var $e9KYl = parcelRequire("e9KYl");

var $jizTQ = parcelRequire("jizTQ");

var $5vRZY = parcelRequire("5vRZY");

var $77POg = parcelRequire("77POg");

var $59yy1 = parcelRequire("59yy1");
// TODO: Deprecated; teams integrating this event should opt-out of chat open using `openChat` on the core event payload
// Once all teams have opted out the ignoredEvents logic can be removed
const $f52dcd62ba437dce$var$ignoredEvents = new Set([
    'editor-context-payload',
    'browser-context-payload',
    'agent-changed'
]);

/**
 * Lazy-loaded so products that don't opt in never fetch this chunk — `ChatOpenerSubscriber` mounts
 * at the root of every product that embeds Rovo chat, so a static import would add it to every
 * page-load bundle regardless.
 */ const $f52dcd62ba437dce$var$LazyExtensionContextBridgeHost = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).lazy(()=>(parcelRequire("3zvdP")).then(({ ExtensionContextBridgeHost: ExtensionContextBridgeHost })=>({
            default: ExtensionContextBridgeHost
        })));
const $f52dcd62ba437dce$var$eventsToSkipAnalytics = new Set([
    // This event is fired way too often https://atlassian.slack.com/archives/C06PKQPN8BF/p1729569226011399
    'editor-context-payload',
    'agent-changed'
]);
const $f52dcd62ba437dce$export$6fa95a645837361b = ({ onTriggerOpeningChat: onTriggerOpeningChat, extensionContextBridgeEnabled: extensionContextBridgeEnabled = false })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jizTQ.useAnalytics)();
    const { setDeferredSeededConversationPending: setDeferredSeededConversationPending } = (0, $77POg.useUIStoreActions)();
    // Matches EXT_CONTEXT_BRIDGE_EXPERIMENT in
    // `@atlaskit/rovo-triggers/extension-context-bridge/constants`.
    //
    // The consumer opt-in stays the outer condition, so a product that has not opted in never reads
    // the experiment at all. The read itself is no-exposure because this component mounts at the root
    // of every page of an opted-in product: exposure here would count product page loads rather than
    // extension users. The extension logs the one exposure.
    const isExtensionContextBridgeEnabled = extensionContextBridgeEnabled && (0, $fgXcj.UNSAFE_expValNoExposure)('rovo-ext_context_bridge_exp', 'isEnabled', false) === true;
    // Mounted after hydration: a lazy Host rendered during hydration leaves a dehydrated Suspense
    // boundary that the next parent re-render breaks (React #421).
    const [isBridgeHostMountable, setIsBridgeHostMountable] = (0, $fsvuC.useState)(false);
    (0, $fsvuC.useEffect)(()=>{
        if (isExtensionContextBridgeEnabled) setIsBridgeHostMountable(true);
    }, [
        isExtensionContextBridgeEnabled
    ]);
    const { getTarget: getTarget } = (0, $5vRZY.useChatContextStoreActions)();
    /**
	 * Resolves the content id the bridge Host stamps onto outbound `editor-context-payload`. Resolved
	 * here rather than in the Host to avoid a `conversation-assistant-store` dependency cycle in
	 * `@atlaskit/rovo-triggers`.
	 */ const getBridgeContentId = (0, $fsvuC.useCallback)(()=>{
        const target = getTarget('global');
        return typeof target?.id === 'string' ? target.id : target?.id?.toString();
    }, [
        getTarget
    ]);
    /**
	 * Read here for the same reason as `getBridgeContentId`, and passed to the Host so a tenant with
	 * AI turned off relays nothing (SECASR-8597). Products set this via `RovoEntitlementSetter`
	 * alongside their nav button, so it is populated on every page the Host mounts on.
	 */ const { isRovoEnabled: isRovoEnabled } = (0, $e9KYl.useRovoEntitlement)();
    /**
	 * Reports what the bridge's relay policy decided for each payload this product published.
	 *
	 * Fired here rather than in `@atlaskit/rovo-triggers`, which has no analytics dependency, for the
	 * same reason as `getBridgeContentId`. Lands in the host product's own stream, which is right:
	 * these are the product's publishers. The bridge deduplicates to one call per distinct outcome
	 * per page.
	 *
	 * Data Portal registry: https://data-portal.internal.atlassian.com/analytics/registry/109870
	 */ const handleBridgeRelayDecision = (0, $fsvuC.useCallback)((decision)=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'evaluated',
            actionSubject: 'rovoExtensionBridgePayload',
            source: decision.publisherSource,
            attributes: {
                payloadType: decision.payloadType,
                contextKey: decision.contextKey,
                relayed: decision.relayed,
                relayDecision: decision.decision,
                publisherSource: decision.publisherSource,
                payloadProduct: decision.payloadProduct
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const [triggerOpen, setTriggerOpen] = (0, $fsvuC.useState)(!!(0, $ig4Ak.getRovoParams)()?.triggerOpen);
    // Trigger open rovo sidebar if not already open via URL param
    (0, $fsvuC.useEffect)(()=>{
        try {
            if (!triggerOpen) return;
            onTriggerOpeningChat();
            setTriggerOpen(false);
        } catch (error) {
        // Fail silently
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerOpen
    ]);
    (0, $6dtVG.useSubscribeAll)((payload)=>{
        const { type: type, source: source, openChat: openChat = true } = payload;
        const deferOpenUntilSeeded = type === 'chat-new' && payload.data.deferOpenUntilSeeded === true && !payload.data.skipCreatingSeededConversation && (0, $59yy1.isJiraDeferredSeededChatOpenEnabled)();
        if (deferOpenUntilSeeded && openChat) setDeferredSeededConversationPending(source);
        const preventOpen = !openChat || $f52dcd62ba437dce$var$ignoredEvents.has(type);
        if (!$f52dcd62ba437dce$var$eventsToSkipAnalytics.has(type)) sendAnalyticsEvent({
            action: 'eventReceived',
            actionSubject: 'aiMatePubSubEvent',
            source: source,
            attributes: {
                publisherSource: source,
                payloadType: type,
                eventTriggersChatOpen: !preventOpen
            }
        });
        if (preventOpen) return;
        // Extract conversation ID from chat-open events
        const conversationId = type === 'chat-open' && 'data' in payload ? payload.data.channelId : undefined;
        const openChatMode = 'openChatMode' in payload ? payload.openChatMode : undefined;
        const autoFocusInput = 'autoFocusInput' in payload ? payload.autoFocusInput : undefined;
        onTriggerOpeningChat(conversationId, openChatMode, source, autoFocusInput);
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5chsV.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $hzhxT.RovoPostMessagePubsubListener), {}),
            isExtensionContextBridgeEnabled && isBridgeHostMountable && /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Suspense, {
                fallback: null,
                children: /*#__PURE__*/ (0, $5chsV.jsx)($f52dcd62ba437dce$var$LazyExtensionContextBridgeHost, {
                    getContentId: getBridgeContentId,
                    isAiEnabled: isRovoEnabled,
                    onRelayDecision: handleBridgeRelayDecision
                })
            })
        ]
    });
};
$f52dcd62ba437dce$export$6fa95a645837361b.displayName = "ChatOpenerSubscriber";

});
parcelRegister("3zvdP", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("fxDEO").then(()=>parcelRequire('3tjl0'));

});


parcelRegister("dOZgZ", function(module, exports) {
$parcel$export(module.exports, "useRovoExperienceAPIStore", () => $92efbf9ec001fe95$export$37440b51449f7ac6);

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $9wsfn = parcelRequire("9wsfn");
const $92efbf9ec001fe95$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true,
    initialPrompt: undefined,
    openWithChatHistory: false,
    targetConversationId: null,
    targetConversationMetadata: null,
    autoFocusInput: true,
    wasAutoOpened: false,
    editorHadFocusBeforeChatOpen: false
};
const $92efbf9ec001fe95$var$store = (0, $5QDqc.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $92efbf9ec001fe95$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($92efbf9ec001fe95$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode,
                    wasAutoOpened: false
                });
            },
        clearInitialPrompt: ()=>({ setState: setState })=>{
                setState({
                    initialPrompt: undefined
                });
            },
        setOpenWithChatHistory: (openWithChatHistory)=>({ setState: setState })=>{
                setState({
                    openWithChatHistory: openWithChatHistory
                });
            },
        setTargetConversationId: (targetConversationId, metadata)=>({ setState: setState })=>{
                setState({
                    targetConversationId: targetConversationId,
                    targetConversationMetadata: metadata?.id === targetConversationId ? metadata : null
                });
            },
        setWasAutoOpened: (wasAutoOpened)=>({ setState: setState })=>{
                setState({
                    wasAutoOpened: wasAutoOpened
                });
            },
        setEditorHadFocusBeforeChatOpen: (editorHadFocusBeforeChatOpen)=>({ setState: setState })=>{
                setState({
                    editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt, autoFocusInput: autoFocusInput = true })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined,
                        autoFocusInput: true,
                        wasAutoOpened: false
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $9wsfn.ConversationAssistantUIModes).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
							which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined,
                            autoFocusInput: true,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $9wsfn.ConversationAssistantUIModes).MINI_MODAL:
                        setState({
                            mode: undefined,
                            autoFocusInput: true,
                            wasAutoOpened: false
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $9wsfn.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $9wsfn.ConversationAssistantUIModes).SIDEBAR,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $9wsfn.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $9wsfn.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                }
            },
        openConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt, autoFocusInput: autoFocusInput = true })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // Already in the desired mode — ensure the sidebar is actually
                // visible (it may have been displaced by another panel) but
                // otherwise treat this as a no-op.
                if (currentMode === targetMode) {
                    if (targetMode === (0, $9wsfn.ConversationAssistantUIModes).SIDEBAR && !sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                    return;
                }
                // Switch to the target mode
                switch(targetMode){
                    case (0, $9wsfn.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $9wsfn.ConversationAssistantUIModes).SIDEBAR,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $9wsfn.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        // wasAutoOpened is managed by the dedicated setWasAutoOpened action and reset on close/toggle/setMode.
                        setState({
                            mode: (0, $9wsfn.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            }
    }
});
const $92efbf9ec001fe95$var$useStore = (0, $3h1FP.createHook)($92efbf9ec001fe95$var$store);
const $92efbf9ec001fe95$export$37440b51449f7ac6 = ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, initialPrompt: initialPrompt, openWithChatHistory: openWithChatHistory, targetConversationId: targetConversationId, targetConversationMetadata: targetConversationMetadata, autoFocusInput: autoFocusInput, wasAutoOpened: wasAutoOpened, editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen }, { reset: reset, clearInitialPrompt: clearInitialPrompt, setOpenWithChatHistory: setOpenWithChatHistory, setTargetConversationId: setTargetConversationId, setWasAutoOpened: setWasAutoOpened, setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable }] = $92efbf9ec001fe95$var$useStore();
    return {
        mode: mode,
        initialPrompt: initialPrompt,
        openWithChatHistory: openWithChatHistory,
        targetConversationId: targetConversationId,
        targetConversationMetadata: targetConversationMetadata,
        autoFocusInput: autoFocusInput,
        wasAutoOpened: wasAutoOpened,
        editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen,
        reset: reset,
        clearInitialPrompt: clearInitialPrompt,
        setOpenWithChatHistory: setOpenWithChatHistory,
        setTargetConversationId: setTargetConversationId,
        setWasAutoOpened: setWasAutoOpened,
        setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        openConversationAssistantUIMode: openConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable
    };
};
const $92efbf9ec001fe95$export$66cf76b7e04da11f = (0, $3h1FP.createActionsHook)($92efbf9ec001fe95$var$store);

});
parcelRegister("9wsfn", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistantUIModes", () => $6471441b18203ba3$export$bc36ebf73899a71d);
/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ // oxlint-disable-next-line eslint/no-redeclare
const $6471441b18203ba3$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};

});


parcelRegister("bH64A", function(module, exports) {

var $iZ5K9 = parcelRequire("iZ5K9");

var $iEpZU = parcelRequire("iEpZU");

var $kN0DI = parcelRequire("kN0DI");

var $2MHNY = parcelRequire("2MHNY");

var $9uKnF = parcelRequire("9uKnF");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $88386bd6e9c5b140$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $88386bd6e9c5b140$var$includes(collection, value, fromIndex, guard) {
    collection = $iEpZU(collection) ? collection : $9uKnF(collection);
    fromIndex = fromIndex && !guard ? $2MHNY(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $88386bd6e9c5b140$var$nativeMax(length + fromIndex, 0);
    return $kN0DI(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $iZ5K9(collection, value, fromIndex) > -1;
}
module.exports = $88386bd6e9c5b140$var$includes;

});
parcelRegister("9uKnF", function(module, exports) {

var $DY9VK = parcelRequire("DY9VK");

var $fyIDO = parcelRequire("fyIDO");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $6e9ae4ab4ffb2130$var$values(object) {
    return object == null ? [] : $DY9VK(object, $fyIDO(object));
}
module.exports = $6e9ae4ab4ffb2130$var$values;

});
parcelRegister("DY9VK", function(module, exports) {

var $3I8Od = parcelRequire("3I8Od");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $07824efd93ee1e6a$var$baseValues(object, props) {
    return $3I8Od(props, function(key) {
        return object[key];
    });
}
module.exports = $07824efd93ee1e6a$var$baseValues;

});



parcelRegister("2TC6w", function(module, exports) {

var $YGUg0 = parcelRequire("YGUg0");
var $21be4682276271e5$var$Global = $YGUg0.Global;
module.exports = {
    name: 'localStorage',
    read: $21be4682276271e5$var$read,
    write: $21be4682276271e5$var$write,
    each: $21be4682276271e5$var$each,
    remove: $21be4682276271e5$var$remove,
    clearAll: $21be4682276271e5$var$clearAll
};
function $21be4682276271e5$var$localStorage() {
    return $21be4682276271e5$var$Global.localStorage;
}
function $21be4682276271e5$var$read(key) {
    return $21be4682276271e5$var$localStorage().getItem(key);
}
function $21be4682276271e5$var$write(key, data) {
    return $21be4682276271e5$var$localStorage().setItem(key, data);
}
function $21be4682276271e5$var$each(fn) {
    for(var i = $21be4682276271e5$var$localStorage().length - 1; i >= 0; i--){
        var key = $21be4682276271e5$var$localStorage().key(i);
        fn($21be4682276271e5$var$read(key), key);
    }
}
function $21be4682276271e5$var$remove(key) {
    return $21be4682276271e5$var$localStorage().removeItem(key);
}
function $21be4682276271e5$var$clearAll() {
    return $21be4682276271e5$var$localStorage().clear();
}

});

parcelRegister("aUzV5", function(module, exports) {
$parcel$export(module.exports, "ARTICLE_TYPE", () => $ac9acda779b22a4c$export$a72bfd9b1e5592c8);
var $ac9acda779b22a4c$export$a72bfd9b1e5592c8 = /*#__PURE__*/ function(ARTICLE_TYPE) {
    ARTICLE_TYPE["HELP_ARTICLE"] = "HELP_ARTICLE";
    ARTICLE_TYPE["WHATS_NEW"] = "WHATS_NEW";
    return ARTICLE_TYPE;
}({});

});

parcelRegister("j4OrM", function(module, exports) {
$parcel$export(module.exports, "AccountMenuIntlProvider", () => $5c86bdaa5874635c$export$6c1f1571e3dd1b34);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $hMTg4 = parcelRequire("hMTg4");
var $oAzkD = parcelRequire("oAzkD");

var $aMAEE = parcelRequire("aMAEE");
/**
 * Code path previously used optional chaining (process?.env?.NODE_ENV) which crashed the townsquare local dev loop
 * This approach removes the chaining, and will fallback if there's any other issues.
 */ function $5c86bdaa5874635c$var$isDev() {
    try {
        return false;
    } catch  {
        return false;
    }
}
const $5c86bdaa5874635c$export$6c1f1571e3dd1b34 = ({ children: children })=>{
    const { locale: locale } = (0, $oAzkD.default)();
    const messages = $5c86bdaa5874635c$var$useMessages(locale);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hMTg4.default), {
        locale: locale,
        messages: messages,
        onError: (err)=>{
            // Do not spam local devloop with missing translation errors
            //
            // See: https://github.com/formatjs/formatjs/issues/465#issuecomment-643887472
            // Note the default error handler: https://github.com/formatjs/formatjs/blob/d0b80fd9a814d1427b73577aebb7ccdb80b9ae94/packages/intl/src/utils.ts#L43
            if ($5c86bdaa5874635c$var$isDev() && err?.code !== 'MISSING_TRANSLATION') // eslint-disable-next-line no-console
            console.error(err);
        },
        children: children
    });
};
$5c86bdaa5874635c$export$6c1f1571e3dd1b34.displayName = "AccountMenuIntlProvider";
const $5c86bdaa5874635c$var$useMessages = (locale)=>{
    const [messages, setMessages] = (0, $fsvuC.useState)();
    (0, $fsvuC.useEffect)(()=>{
        if (/^en(-US)?$/i.exec(locale)) // Use fallback messages, which are already US English
        setMessages(undefined);
        else {
            let cancelled = false;
            $5c86bdaa5874635c$var$loadMessages(locale).catch((_error)=>undefined) // TODO: Log error somehow (analytics?)
            .then((messages)=>{
                if (!cancelled) setMessages(messages);
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        locale,
        setMessages
    ]);
    return messages;
};
const $5c86bdaa5874635c$var$loadMessages = async (locale)=>{
    let [language, region = ''] = locale.split('-', 2);
    language = language.toLowerCase();
    region = region.toUpperCase();
    return (await ((0, $aMAEE.default)[`${language}_${region}`] || (0, $aMAEE.default)[language])?.())?.default;
};

});
parcelRegister("aMAEE", function(module, exports) {
$parcel$export(module.exports, "default", () => $087c4db20da5d867$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by scripts/generate-i18n-index.ts.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index.
 */ 










































const $087c4db20da5d867$var$lazyMessages = {
    cs: ()=>(parcelRequire("hceHD")),
    cs_CZ: ()=>(parcelRequire("b0TyQ")),
    da: ()=>(parcelRequire("8sLCN")),
    da_DK: ()=>(parcelRequire("kPq1e")),
    de: ()=>(parcelRequire("29Tf0")),
    de_DE: ()=>(parcelRequire("eet58")),
    en_GB: ()=>(parcelRequire("eXNq8")),
    en_ZZ: ()=>(parcelRequire("2Uh89")),
    es: ()=>(parcelRequire("cMTda")),
    fi: ()=>(parcelRequire("gGS3I")),
    fi_FI: ()=>(parcelRequire("1EaIL")),
    fr: ()=>(parcelRequire("fl67D")),
    fr_FR: ()=>(parcelRequire("bdKnH")),
    hu: ()=>(parcelRequire("cTOCo")),
    hu_HU: ()=>(parcelRequire("ir4e9")),
    it: ()=>(parcelRequire("g6Qej")),
    it_IT: ()=>(parcelRequire("fqKUQ")),
    ja: ()=>(parcelRequire("Z0rzW")),
    ja_JP: ()=>(parcelRequire("4Zmgp")),
    ko: ()=>(parcelRequire("6nb5g")),
    ko_KR: ()=>(parcelRequire("boob3")),
    nb: ()=>(parcelRequire("f5E4I")),
    nb_NO: ()=>(parcelRequire("2NA9p")),
    nl: ()=>(parcelRequire("1NaNe")),
    nl_NL: ()=>(parcelRequire("ctkdi")),
    pl: ()=>(parcelRequire("6jwSJ")),
    pl_PL: ()=>(parcelRequire("d9djr")),
    pt_BR: ()=>(parcelRequire("jDlX4")),
    ru: ()=>(parcelRequire("gmixb")),
    ru_RU: ()=>(parcelRequire("axdjT")),
    sv: ()=>(parcelRequire("aS4Xy")),
    sv_SE: ()=>(parcelRequire("9GDI8")),
    th: ()=>(parcelRequire("hQWU7")),
    th_TH: ()=>(parcelRequire("jhBWe")),
    tr: ()=>(parcelRequire("4FCuM")),
    tr_TR: ()=>(parcelRequire("jfVKV")),
    uk: ()=>(parcelRequire("3JorC")),
    uk_UA: ()=>(parcelRequire("lpcd8")),
    vi: ()=>(parcelRequire("iWTC0")),
    vi_VN: ()=>(parcelRequire("16J4G")),
    zh: ()=>(parcelRequire("dZgBr")),
    zh_CN: ()=>(parcelRequire("kB3L7")),
    zh_TW: ()=>(parcelRequire("ycA6V"))
};
var $087c4db20da5d867$export$2e2bcd8739ae039 = $087c4db20da5d867$var$lazyMessages;

});
parcelRegister("hceHD", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("cUItF").then(()=>parcelRequire('18ifQ'));

});

parcelRegister("b0TyQ", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("bLJnR").then(()=>parcelRequire('4eKal'));

});

parcelRegister("8sLCN", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("873GS").then(()=>parcelRequire('bKRyu'));

});

parcelRegister("kPq1e", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("lIg9I").then(()=>parcelRequire('c6VLd'));

});

parcelRegister("29Tf0", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("giNO5").then(()=>parcelRequire('iEHR7'));

});

parcelRegister("eet58", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("f3J15").then(()=>parcelRequire('dvUac'));

});

parcelRegister("eXNq8", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("eiLnM").then(()=>parcelRequire('4BTyt'));

});

parcelRegister("2Uh89", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("foNZi").then(()=>parcelRequire('fsdO3'));

});

parcelRegister("cMTda", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("67XqR").then(()=>parcelRequire('fsJ91'));

});

parcelRegister("gGS3I", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("485uS").then(()=>parcelRequire('hl2qK'));

});

parcelRegister("1EaIL", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("14r4R").then(()=>parcelRequire('dwEHJ'));

});

parcelRegister("fl67D", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("iDbWz").then(()=>parcelRequire('ePgGK'));

});

parcelRegister("bdKnH", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("8TMoc").then(()=>parcelRequire('glP27'));

});

parcelRegister("cTOCo", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("3bF2Y").then(()=>parcelRequire('9JIE4'));

});

parcelRegister("ir4e9", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("8mIYt").then(()=>parcelRequire('7pChW'));

});

parcelRegister("g6Qej", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("4zdVi").then(()=>parcelRequire('2lC5P'));

});

parcelRegister("fqKUQ", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("5YzRQ").then(()=>parcelRequire('iIPKc'));

});

parcelRegister("Z0rzW", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("vxTnM").then(()=>parcelRequire('1xlU7'));

});

parcelRegister("4Zmgp", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("lnwA7").then(()=>parcelRequire('hz0kG'));

});

parcelRegister("6nb5g", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("mGRIi").then(()=>parcelRequire('beo8u'));

});

parcelRegister("boob3", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("aF1cE").then(()=>parcelRequire('SxZKB'));

});

parcelRegister("f5E4I", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("jh1Ce").then(()=>parcelRequire('4KdNa'));

});

parcelRegister("2NA9p", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("hGAUA").then(()=>parcelRequire('9Gj6z'));

});

parcelRegister("1NaNe", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("jfbuq").then(()=>parcelRequire('hspmz'));

});

parcelRegister("ctkdi", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("1DaCQ").then(()=>parcelRequire('9F7SW'));

});

parcelRegister("6jwSJ", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("gXFco").then(()=>parcelRequire('keWtr'));

});

parcelRegister("d9djr", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("6BJB7").then(()=>parcelRequire('lWFwF'));

});

parcelRegister("jDlX4", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("gYurZ").then(()=>parcelRequire('1zv0c'));

});

parcelRegister("gmixb", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("1DqJS").then(()=>parcelRequire('bnCqp'));

});

parcelRegister("axdjT", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("6LpuJ").then(()=>parcelRequire('dowM0'));

});

parcelRegister("aS4Xy", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("jFHpi").then(()=>parcelRequire('8Xovy'));

});

parcelRegister("9GDI8", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("2C9fc").then(()=>parcelRequire('eiwdG'));

});

parcelRegister("hQWU7", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("icWCf").then(()=>parcelRequire('7QvIC'));

});

parcelRegister("jhBWe", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("2ARPy").then(()=>parcelRequire('cyyfp'));

});

parcelRegister("4FCuM", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("bxtYF").then(()=>parcelRequire('aZcHS'));

});

parcelRegister("jfVKV", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("2c7ZG").then(()=>parcelRequire('2w3oN'));

});

parcelRegister("3JorC", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("220TK").then(()=>parcelRequire('lnNWq'));

});

parcelRegister("lpcd8", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("2MV9h").then(()=>parcelRequire('1NQG0'));

});

parcelRegister("iWTC0", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("1V0kT").then(()=>parcelRequire('90IrM'));

});

parcelRegister("16J4G", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("drbxS").then(()=>parcelRequire('3oxqI'));

});

parcelRegister("dZgBr", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("8KEW3").then(()=>parcelRequire('gmYk0'));

});

parcelRegister("kB3L7", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("jbSPH").then(()=>parcelRequire('6ua6Y'));

});

parcelRegister("ycA6V", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("iBLDY").then(()=>parcelRequire('7ZjtG'));

});



parcelRegister("9B11Q", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $54a970b4d0000cfa$export$515664faa1398f37);
$parcel$export(module.exports, "ANALYTICS_CONTEXT", () => $54a970b4d0000cfa$export$3cbe56a0cabcff38);
const $54a970b4d0000cfa$export$515664faa1398f37 = 'navigation';
const $54a970b4d0000cfa$export$3cbe56a0cabcff38 = {
    source: 'atlassianAccountMenu',
    componentName: 'atlassianAccountMenu',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};

});

parcelRegister("kM13M", function(module, exports) {
$parcel$export(module.exports, "AccountMenuLoggedOutStateNav4", () => $786bc14e3f69439e$export$f03eabcc4a75d4f3);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $jjliv = parcelRequire("jjliv");

var $9B11Q = parcelRequire("9B11Q");

var $2d7g7 = parcelRequire("2d7g7");
const $786bc14e3f69439e$export$f03eabcc4a75d4f3 = ({ testId: testId, logInLink: logInLink })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $jjliv.LogIn), {
        testId: testId,
        href: logInLink,
        onClick: (event, analytics)=>{
            analytics.update({
                actionSubjectId: 'logInLink'
            }).fire((0, $9B11Q.NAVIGATION_CHANNEL));
        },
        label: (0, $2d7g7.logInTooltip)
    });
$786bc14e3f69439e$export$f03eabcc4a75d4f3.displayName = "AccountMenuLoggedOutStateNav4";

});
parcelRegister("2d7g7", function(module, exports) {
$parcel$export(module.exports, "logInTooltip", () => $6574fe5f616ec8f3$export$b495e6c63a3a03c1);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $ECZQy = parcelRequire("ECZQy");
const $6574fe5f616ec8f3$export$b495e6c63a3a03c1 = /*#__PURE__*/ (0, $5chsV.jsx)((0, $ECZQy.default), {
    id: "identity.account-menu.account-menu-logged-out-state.log-in",
    defaultMessage: "Log in",
    description: "Tooltip for log in button when user is logged out"
});

});


parcelRegister("aoVRt", function(module, exports) {
$parcel$export(module.exports, "useAccountLinks", () => $996018487465cd9b$export$2afde6c526be23b9);

var $cnLDD = parcelRequire("cnLDD");
/**
 * Helper function to create a string of custom query parameters
 * Returns a string like "&orgId=blah&..." that can be appended to URLs
 */ const $996018487465cd9b$var$createCustomParametersString = (customParameters)=>{
    if (!customParameters || Object.keys(customParameters).length === 0) return '';
    return Object.entries(customParameters).map(([key, value])=>`&${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('');
};
const $996018487465cd9b$var$buildProfileLink = (baseUrl, path, applicationParam, email, logInLinkCustomParameters)=>{
    const profileUrl = `${baseUrl}${path}`;
    if (email) {
        const logInLinkCustomParamsString = $996018487465cd9b$var$createCustomParametersString(logInLinkCustomParameters);
        const loginUrl = `${baseUrl}/login?${applicationParam}&continue=${encodeURIComponent(profileUrl)}&prompt=none&login_hint=${encodeURIComponent(email)}${logInLinkCustomParamsString}`;
        return loginUrl;
    }
    return profileUrl;
};
function $996018487465cd9b$export$2afde6c526be23b9({ email: email, identityEnvironment: identityEnvironment, application: application, continueUrl: continueUrl, logOutContinueUrl: logOutContinueUrl, isLoggedOut: isLoggedOut, disableSwitchAccountLink: disableSwitchAccountLink, logInLinkCustomParameters: logInLinkCustomParameters }) {
    const { baseUrl: baseUrl } = (0, $cnLDD.resolveEnvironment)(identityEnvironment);
    const applicationParam = `application=${encodeURIComponent(application)}`;
    const continueParam = `continue=${encodeURIComponent(continueUrl)}`;
    const logOutContinueParam = logOutContinueUrl ? `continue=${encodeURIComponent(logOutContinueUrl)}` : continueParam;
    const manageProfileLink = $996018487465cd9b$var$buildProfileLink(baseUrl, '/manage-profile', applicationParam, email, logInLinkCustomParameters);
    return {
        manageProfileLink: manageProfileLink,
        switchAccountLink: disableSwitchAccountLink ? undefined : `${baseUrl}/login?${applicationParam}&${continueParam}&prompt=select_account${$996018487465cd9b$var$createCustomParametersString(logInLinkCustomParameters)}`,
        logOutLink: `${baseUrl}/logout?${applicationParam}&${logOutContinueParam}` + (disableSwitchAccountLink ? '' : '&prompt=none'),
        logInLink: isLoggedOut ? `${baseUrl}/login?${applicationParam}&${continueParam}${$996018487465cd9b$var$createCustomParametersString(logInLinkCustomParameters)}` : undefined
    };
}

});
parcelRegister("cnLDD", function(module, exports) {
$parcel$export(module.exports, "resolveEnvironment", () => $6259467ec9ae88c8$export$eabfcea451f48b90);
/**
 * An Identity environment to integrate with. Either a `"dev"`, `"fedex"`, `"staging"` or
 * `"prod"` for real Identity environments, or an `EnvironmentConfig` object for
 * using a fake environment (e.g. for local dev).
 */ const $6259467ec9ae88c8$var$environmentConfigs = {
    dev: {
        baseUrl: 'https://id.dev.internal.atlassian.com'
    },
    fedex: {
        baseUrl: 'https://id.atlassian-fex.com'
    },
    staging: {
        baseUrl: 'https://id.stg.internal.atlassian.com'
    },
    'staging-fedramp-moderate': {
        baseUrl: 'https://id.stg.atlassian-us-gov-mod.com'
    },
    prod: {
        baseUrl: 'https://id.atlassian.com'
    },
    'prod-fedramp-moderate': {
        baseUrl: 'https://id.atlassian-us-gov-mod.com'
    }
};
function $6259467ec9ae88c8$export$eabfcea451f48b90(identityEnvironment) {
    if (typeof identityEnvironment === 'string') return $6259467ec9ae88c8$var$environmentConfigs[identityEnvironment];
    else return identityEnvironment;
}

});


parcelRegister("29Wyv", function(module, exports) {
$parcel$export(module.exports, "AccountMenuTriggerNav4", () => $b4a7c3f27012a802$export$83537fb6d03c400d);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $oAzkD = parcelRequire("oAzkD");

var $h0GIl = parcelRequire("h0GIl");

var $ktNev = parcelRequire("ktNev");

var $a9abE = parcelRequire("a9abE");
const $b4a7c3f27012a802$export$83537fb6d03c400d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).forwardRef(({ picture: picture, email: email, trustPicture: trustPicture = false, 'aria-expanded': isExpanded, ...props }, ref)=>{
    const intl = (0, $oAzkD.default)();
    const state = (0, $ktNev.useImageState)(picture || '');
    const tooltip = intl.formatMessage((0, $a9abE.messages).triggerTooltip);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $h0GIl.Profile), {
        ...props,
        isSelected: isExpanded,
        ref: ref,
        label: email || tooltip,
        src: trustPicture || state === 'loaded' ? picture : undefined
    });
});

});
parcelRegister("ktNev", function(module, exports) {
$parcel$export(module.exports, "useImageState", () => $fa64a878fa9506b2$export$2c1df3428fc3264c);

var $fsvuC = parcelRequire("fsvuC");
const $fa64a878fa9506b2$export$2c1df3428fc3264c = (src)=>{
    const [state, setState] = (0, $fsvuC.useState)('pending');
    const imgRef = (0, $fsvuC.useRef)();
    (0, $fsvuC.useEffect)(()=>{
        if (!imgRef.current) {
            imgRef.current = new Image();
            imgRef.current.onload = ()=>setState('loaded');
            imgRef.current.onerror = ()=>setState('error');
        }
        setState('pending');
        imgRef.current.src = src;
    }, [
        src
    ]);
    return state;
};

});

parcelRegister("a9abE", function(module, exports) {
$parcel$export(module.exports, "messages", () => $40b68e6135e02eb4$export$defe85febe8b728c);

var $54F37 = parcelRequire("54F37");
const $40b68e6135e02eb4$export$defe85febe8b728c = (0, $54F37.defineMessages)({
    triggerTooltip: {
        id: 'identity.account-menu.account-menu-popup.skeleton.tooltip',
        defaultMessage: 'Account',
        description: 'Tooltip and alt-text for the account menu item'
    },
    popupLabel: {
        id: 'identity.account-menu.account-menu-popup.popup-label',
        defaultMessage: 'Account details',
        description: 'Accessible name for the non-modal dialog that opens from the account (profile) button in the top navigation'
    }
});

});


parcelRegister("4cjRY", function(module, exports) {
$parcel$export(module.exports, "QuickFindSkeleton", () => $207bbb14a016c79e$export$8f0d616c2469c6b6);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $oAzkD = parcelRequire("oAzkD");

var $cTXsj = parcelRequire("cTXsj");

var $3K8mq = parcelRequire("3K8mq");

var $9h9gi = parcelRequire("9h9gi");

var $2hfiJ = parcelRequire("2hfiJ");

var $2dZ7D = parcelRequire("2dZ7D");

var $c0fg4 = parcelRequire("c0fg4");

var $d8mEj = parcelRequire("d8mEj");

var $a2bib = parcelRequire("a2bib");
if (!window.inputSkeletonState) (0, $3K8mq.resetInputSkeletonState)();
const $207bbb14a016c79e$export$8f0d616c2469c6b6 = ({ onEnter: onEnter, isNav4Enabled: isNav4Enabled, injectValue: injectValue, customPlaceholder: customPlaceholder, inputRef: inputRef, primaryProduct: primaryProduct })=>{
    const dialogId = (0, $cTXsj.useId)();
    const { formatMessage: formatMessage } = (0, $oAzkD.default)();
    const initialSearchQuery = (0, $2dZ7D.getInitialQuery)();
    // Use the stored state as initial values for expansion and query
    const [isExpanded, setIsExpanded] = (0, $fsvuC.useState)((0, $3K8mq.getInputSkeletonFocus)());
    const [value, setValue] = (0, $fsvuC.useState)(()=>injectValue ?? initialSearchQuery);
    const ghostTextData = (0, $fsvuC.useMemo)(()=>(0, $d8mEj.parseGhostTextData)(customPlaceholder), [
        customPlaceholder
    ]);
    const { chatIntentDetectionEnabled: chatIntentDetectionEnabled } = (0, $c0fg4.serveChatConvergenceExperiment)(primaryProduct);
    const onFocus = (e)=>{
        setIsExpanded(true);
        (0, $3K8mq.setInputSkeletonIsFocus)(true);
        const target = e.currentTarget;
        (0, $3K8mq.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
    };
    const onBlur = ()=>{
        setIsExpanded(false);
        (0, $3K8mq.setInputSkeletonIsFocus)(false);
        (0, $3K8mq.setInputSkeletonSelection)(0, 0, 'none');
    };
    const onKeyDown = (e)=>{
        const target = e.currentTarget;
        if (e.key === 'Escape') {
            target.blur();
            onBlur();
        }
    };
    const onChange = (e)=>{
        const newValue = e.currentTarget.value;
        setValue(newValue);
        (0, $3K8mq.setInputSkeletonQuery)(newValue);
        const target = e.currentTarget;
        (0, $3K8mq.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
        (0, $9h9gi.setSessionItem)((0, $9h9gi.SEARCH_QUERY_KEY), newValue);
    };
    const onSelect = (e)=>{
        const target = e.currentTarget;
        (0, $3K8mq.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2hfiJ.Textfield), {
        value: value,
        placeholder: ghostTextData?.text ?? formatMessage((0, $a2bib.messages).placeholder),
        dialogId: dialogId,
        quickFindOpen: isExpanded,
        onEnter: onEnter,
        onClick: onFocus,
        onFocus: onFocus,
        onBlur: onBlur,
        onSelect: onSelect,
        onKeyDown: onKeyDown,
        onChange: onChange,
        isNav4Enabled: isNav4Enabled,
        chatIntentDetectionEnabled: chatIntentDetectionEnabled,
        inputRef: inputRef
    });
};
$207bbb14a016c79e$export$8f0d616c2469c6b6.displayName = "QuickFindSkeleton";

});
parcelRegister("3K8mq", function(module, exports) {
$parcel$export(module.exports, "getInputSkeletonQuery", () => $edb7871e0a1aca67$export$b8b6c2e7a0664212);
$parcel$export(module.exports, "setInputSkeletonQuery", () => $edb7871e0a1aca67$export$baa1c819dd4691f3);
$parcel$export(module.exports, "getInputSkeletonFocus", () => $edb7871e0a1aca67$export$38fcbc98be180790);
$parcel$export(module.exports, "setInputSkeletonIsFocus", () => $edb7871e0a1aca67$export$d3c6894b4e9af000);
$parcel$export(module.exports, "getInputSkeletonSelection", () => $edb7871e0a1aca67$export$a0c71b3bd9ec143c);
$parcel$export(module.exports, "setInputSkeletonSelection", () => $edb7871e0a1aca67$export$e0d745255b135363);
$parcel$export(module.exports, "resetInputSkeletonState", () => $edb7871e0a1aca67$export$c89dd2d5d4024c5e);
$parcel$export(module.exports, "removeInputSkeletonEventListeners", () => $edb7871e0a1aca67$export$166ce39761ad7743);
$parcel$export(module.exports, "removeInputSkeletonState", () => $edb7871e0a1aca67$export$c830bcf42e072a93);
const $edb7871e0a1aca67$var$getWindow = ()=>typeof window !== 'undefined' ? window : null;
const $edb7871e0a1aca67$export$b8b6c2e7a0664212 = ()=>{
    return $edb7871e0a1aca67$var$getWindow()?.inputSkeletonState?.query ?? '';
};
const $edb7871e0a1aca67$export$baa1c819dd4691f3 = (newQuery)=>{
    const { inputSkeletonState: inputSkeletonState } = $edb7871e0a1aca67$var$getWindow() ?? {};
    if (inputSkeletonState) inputSkeletonState.query = newQuery;
};
const $edb7871e0a1aca67$export$38fcbc98be180790 = ()=>{
    return $edb7871e0a1aca67$var$getWindow()?.inputSkeletonState?.isFocused || false;
};
const $edb7871e0a1aca67$export$d3c6894b4e9af000 = (newIsFocused)=>{
    const { inputSkeletonState: inputSkeletonState } = $edb7871e0a1aca67$var$getWindow() ?? {};
    if (inputSkeletonState) inputSkeletonState.isFocused = newIsFocused;
};
const $edb7871e0a1aca67$export$a0c71b3bd9ec143c = ()=>{
    const { inputSkeletonState: inputSkeletonState } = $edb7871e0a1aca67$var$getWindow() ?? {};
    return {
        selectionStart: inputSkeletonState?.selectionStart ?? 0,
        selectionEnd: inputSkeletonState?.selectionEnd ?? 0,
        selectionDirection: inputSkeletonState?.selectionDirection ?? 'none'
    };
};
const $edb7871e0a1aca67$export$e0d745255b135363 = (newSelectionStart, newSelectionEnd, newSelectionDirection)=>{
    const { inputSkeletonState: inputSkeletonState } = $edb7871e0a1aca67$var$getWindow() ?? {};
    if (inputSkeletonState) {
        inputSkeletonState.selectionStart = newSelectionStart;
        inputSkeletonState.selectionEnd = newSelectionEnd;
        inputSkeletonState.selectionDirection = newSelectionDirection;
    }
};
const $edb7871e0a1aca67$export$c89dd2d5d4024c5e = ()=>{
    const safeWindow = $edb7871e0a1aca67$var$getWindow();
    if (safeWindow) safeWindow.inputSkeletonState = {
        query: '',
        placeholder: '',
        isFocused: false,
        selectionStart: 0,
        selectionEnd: 0,
        selectionDirection: 'none',
        listeners: []
    };
};
const $edb7871e0a1aca67$export$166ce39761ad7743 = ()=>{
    const { inputSkeletonState: inputSkeletonState } = $edb7871e0a1aca67$var$getWindow() ?? {};
    if (inputSkeletonState) {
        inputSkeletonState.listeners.forEach(([target, event, handler])=>{
            target.removeEventListener(event, handler);
        });
        inputSkeletonState.listeners = [];
    }
};
const $edb7871e0a1aca67$export$c830bcf42e072a93 = ()=>{
    $edb7871e0a1aca67$export$166ce39761ad7743();
    delete $edb7871e0a1aca67$var$getWindow()?.inputSkeletonState;
};

});

parcelRegister("9h9gi", function(module, exports) {
$parcel$export(module.exports, "SEARCH_QUERY_KEY", () => $c8552b1bccec3262$export$240cb7dc75f6cac2);
$parcel$export(module.exports, "SEARCH_FILTERS_KEY", () => $c8552b1bccec3262$export$978fb20afa14aaa7);
$parcel$export(module.exports, "SEARCH_SHOW_AI_DIALOG_KEY", () => $c8552b1bccec3262$export$f4dca218ecb5824a);
$parcel$export(module.exports, "getSessionItem", () => $c8552b1bccec3262$export$fdf7104ff19cc288);
$parcel$export(module.exports, "setSessionItem", () => $c8552b1bccec3262$export$a5376dd4adeb0fbf);
$parcel$export(module.exports, "deleteSessionItem", () => $c8552b1bccec3262$export$5896963da935fdc4);

var $llCao = parcelRequire("llCao");

var $7keNf = parcelRequire("7keNf");
const $c8552b1bccec3262$export$9d075e4b938a80be = 'atlassian.search-dialog-sticky';
const $c8552b1bccec3262$export$240cb7dc75f6cac2 = 'atlassian.search-dialog-query';
const $c8552b1bccec3262$export$978fb20afa14aaa7 = 'atlassian.search-dialog-filters';
const $c8552b1bccec3262$export$f4dca218ecb5824a = 'atlassian.search-dialog.ai-dialog';
const $c8552b1bccec3262$var$getWindow = ()=>{
    if (typeof window === 'undefined') return null;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    if (typeof window.sessionStorage === 'undefined') return null;
    return window;
};
const $c8552b1bccec3262$export$fdf7104ff19cc288 = (key)=>{
    const windowReady = $c8552b1bccec3262$var$getWindow();
    if (!windowReady) return null;
    return (0, $llCao.fg)('search_page_use_bsc_session_storage') ? (0, $7keNf.AtlBrowserStorageSession).getItem(key) : $c8552b1bccec3262$var$getWindow()?.sessionStorage.getItem(key);
};
const $c8552b1bccec3262$export$a5376dd4adeb0fbf = (key, value)=>{
    const windowReady = $c8552b1bccec3262$var$getWindow();
    if (!windowReady) return;
    try {
        if ((0, $llCao.fg)('search_page_use_bsc_session_storage')) (0, $7keNf.AtlBrowserStorageSession).setItem(key, value);
        else $c8552b1bccec3262$var$getWindow()?.sessionStorage.setItem(key, value);
    } catch (error) {
        error.code, DOMException.QUOTA_EXCEEDED_ERR;
    }
};
const $c8552b1bccec3262$export$5896963da935fdc4 = (key)=>{
    const windowReady = $c8552b1bccec3262$var$getWindow();
    if (!windowReady) return;
    if ((0, $llCao.fg)('search_page_use_bsc_session_storage')) (0, $7keNf.AtlBrowserStorageSession).removeItem(key);
    else $c8552b1bccec3262$var$getWindow()?.sessionStorage.removeItem(key);
};

});

parcelRegister("2hfiJ", function(module, exports) {
$parcel$export(module.exports, "Textfield", () => $793dc1534f20b67c$export$d66ddc2063fc70a7);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $oAzkD = parcelRequire("oAzkD");

var $kfsyS = parcelRequire("kfsyS");

var $8HvJO = parcelRequire("8HvJO");

var $irYrv = parcelRequire("irYrv");

var $edN4B = parcelRequire("edN4B");

var $llCao = parcelRequire("llCao");

var $gP7u8 = parcelRequire("gP7u8");

var $9orrx = parcelRequire("9orrx");

var $8e1dR = parcelRequire("8e1dR");

var $e7Gbu = parcelRequire("e7Gbu");

var $c3eiw = parcelRequire("c3eiw");

var $bHxCN = parcelRequire("bHxCN");

var $8VFXm = parcelRequire("8VFXm");
const $793dc1534f20b67c$var$INTERACTIVE_SELECTOR = 'input, button, a[href], [role="button"]';
const $793dc1534f20b67c$var$textFieldBoxBaseStyles = (0, $9orrx.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: 'size.300',
    ':focus': {
        height: 'size.400'
    },
    width: '100%',
    paddingRight: 'space.200'
});
const $793dc1534f20b67c$var$textFieldBoxStyles = (0, $9orrx.xcss)({
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.medium'
});
const $793dc1534f20b67c$var$textFieldBoxFocusedStyles = (0, $9orrx.xcss)({
    height: 'size.400',
    border: 'none',
    paddingRight: '0'
});
const $793dc1534f20b67c$var$textFieldBoxFocusedElevationStyles = (0, $9orrx.xcss)({
    boxShadow: 'elevation.shadow.overlay'
});
const $793dc1534f20b67c$var$textFieldInDialogStyles = (0, $9orrx.xcss)({
    marginTop: 'space.075',
    position: 'relative',
    zIndex: 'layer'
});
const $793dc1534f20b67c$var$inputStyles = null;
const $793dc1534f20b67c$var$inputFocusedStyles = null;
const $793dc1534f20b67c$var$iconWrapperStyles = (0, $9orrx.xcss)({
    minWidth: 'size.300',
    minHeight: 'size.300',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'color.text.subtlest'
});
const $793dc1534f20b67c$var$iconWrapperFocusedStyles = (0, $9orrx.xcss)({
    marginInlineStart: 'space.200',
    marginInlineEnd: 'space.150',
    minWidth: 'size.200'
});
const $793dc1534f20b67c$var$clearIconFadeInAnimation = null;
const $793dc1534f20b67c$var$clearIconFadeInWrapperStyles = null;
// Styles for the trailing Connect Apps icon slot.
const $793dc1534f20b67c$var$connectAppsIconStyles = (0, $9orrx.xcss)({
    marginRight: 'space.050',
    display: 'flex',
    alignItems: 'center'
});
// When QuickFind is open, align the pill with where the close icon sits.
const $793dc1534f20b67c$var$connectAppsIconOpenStyles = (0, $9orrx.xcss)({
    marginRight: 'space.100'
});
const $793dc1534f20b67c$var$connectAppsIconWithFilterToggleStyles = (0, $9orrx.xcss)({
    marginInlineStart: 'space.100'
});
const $793dc1534f20b67c$var$textFieldBoxNoRightPaddingStyles = (0, $9orrx.xcss)({
    paddingRight: 'space.0'
});
// Nav3 style overrides
// Can be removed once all supported products use Nav4
const $793dc1534f20b67c$var$nav3StyleOverrides = {
    textFieldBoxStyles: (0, $9orrx.xcss)({
        borderColor: 'color.border.input',
        backgroundColor: 'color.background.input',
        borderRadius: 'radius.medium',
        width: '200px'
    }),
    textFieldBoxFocusedStyles: (0, $9orrx.xcss)({
        backgroundColor: 'elevation.surface.overlay',
        borderRadius: 'radius.large',
        width: '780px'
    }),
    iconWrapperStyles: (0, $9orrx.xcss)({
        minWidth: '30px'
    }),
    inputStyles: null
};
const $793dc1534f20b67c$export$d66ddc2063fc70a7 = ({ value: value, dialogId: dialogId, quickFindOpen: quickFindOpen, isNav4Enabled: isNav4Enabled, onEnter: onEnter, onFocus: onFocus, onBlur: onBlur, onSelect: onSelect, onKeyDown: onKeyDown, onChange: onChange, onClick: onClick, onClear: onClear, onAppsClick: onAppsClick, inputRef: inputRef, clearIconRef: clearIconRef, placeholder: placeholder, intentRouterEnabled: intentRouterEnabled, chatIntentDetectionEnabled: chatIntentDetectionEnabled, unifiedSurface: unifiedSurface, activeDescendantId: activeDescendantId, cloudId: cloudId, accountId: accountId, orgId: orgId, primaryProduct: primaryProduct, smartLinkUsage: smartLinkUsage, thirdPartyConfigs: thirdPartyConfigs, filterPresentation: filterPresentation })=>{
    const intl = (0, $oAzkD.default)();
    const showFilterToggle = quickFindOpen && filterPresentation !== undefined;
    const controlSpacing = chatIntentDetectionEnabled && quickFindOpen ? 'default' : 'compact';
    const instructionsId = `${dialogId}-instructions`;
    // Input drops its own border/shadow/radius and overlays onto the dialog (which
    // owns the single shadow). Driven by the caller, not read here — see prop doc.
    const unified = intentRouterEnabled || unifiedSurface || chatIntentDetectionEnabled;
    const handleKeyDown = (e)=>{
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
        if (typeof onKeyDown === 'function') onKeyDown(e);
    };
    const clearIconButton = /*#__PURE__*/ (0, $5chsV.jsx)((0, $kfsyS.default), {
        ref: clearIconRef,
        icon: (iconProps)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($irYrv))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)",
                label: ""
            }),
        spacing: controlSpacing,
        onClick: onClear,
        label: intl.formatMessage((0, $8VFXm.messages).clearIconLabel),
        appearance: "subtle",
        testId: "search-input-clear-button"
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $5chsV.jsxs)((0, $gP7u8.Box), {
        xcss: [
            $793dc1534f20b67c$var$textFieldBoxBaseStyles,
            (!unified || !quickFindOpen) && $793dc1534f20b67c$var$textFieldBoxStyles,
            unified && quickFindOpen && $793dc1534f20b67c$var$textFieldInDialogStyles,
            quickFindOpen ? $793dc1534f20b67c$var$textFieldBoxFocusedStyles : false,
            !unified && quickFindOpen && $793dc1534f20b67c$var$textFieldBoxFocusedElevationStyles,
            !isNav4Enabled && $793dc1534f20b67c$var$nav3StyleOverrides.textFieldBoxStyles,
            !isNav4Enabled && quickFindOpen && $793dc1534f20b67c$var$nav3StyleOverrides.textFieldBoxFocusedStyles,
            $793dc1534f20b67c$var$textFieldBoxNoRightPaddingStyles
        ],
        onClick: (e)=>{
            // React's synthetic events bubble through the JSX tree, not the DOM. The Rovo
            // Settings modal is a portal, so clicks inside it bubble to this onClick even
            // though they're outside this DOM subtree. Guard against that here, otherwise
            // closing the modal re-focuses the input and reopens Quick Find.
            if (!e.currentTarget.contains(e.target)) return;
            if ((0, $llCao.fg)('rovo_search_chat_convergence_instrumentation')) {
                const interactiveTarget = e.target.closest($793dc1534f20b67c$var$INTERACTIVE_SELECTOR);
                if (interactiveTarget && e.currentTarget.contains(interactiveTarget)) return;
            }
            inputRef?.current?.click();
            inputRef?.current?.focus();
        },
        testId: "search-input-container",
        role: "search",
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $gP7u8.Box), {
                xcss: [
                    $793dc1534f20b67c$var$iconWrapperStyles,
                    quickFindOpen && $793dc1534f20b67c$var$iconWrapperFocusedStyles,
                    !isNav4Enabled && $793dc1534f20b67c$var$nav3StyleOverrides.iconWrapperStyles
                ],
                children: isNav4Enabled || quickFindOpen ? chatIntentDetectionEnabled ? /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8HvJO))), {
                    color: "currentColor",
                    label: ""
                }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($edN4B))), {
                    color: "currentColor",
                    label: "",
                    "aria-hidden": "true"
                }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $bHxCN.LegacySearchIcon), {
                    isExpanded: !!quickFindOpen
                })
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("input", {
                ref: inputRef,
                onFocus: onFocus,
                onBlur: onBlur,
                onSelect: onSelect,
                onKeyDown: handleKeyDown,
                onClick: onClick,
                placeholder: placeholder || intl.formatMessage((0, $8VFXm.messages).inputPlaceholder),
                onChange: onChange,
                value: value,
                "data-testid": "search-input",
                autoComplete: "off",
                "aria-label": intl.formatMessage((0, $8VFXm.messages).inputPlaceholder),
                "aria-describedby": instructionsId,
                "aria-expanded": quickFindOpen,
                "aria-controls": dialogId,
                "aria-activedescendant": activeDescendantId ?? '',
                "aria-haspopup": "true",
                role: "combobox",
                className: (0, $gJ6nT.default)([
                    "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _2uo31fYbGa _2sNsIgmnOE _30huDKYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _4bt5LAnQyn _2WAcuGnQyn _1UtDYzKGUX _39xV02N91d _39HuIbz8Lp _1ANEUSLRg7 _3AxjleKGUX",
                    quickFindOpen && "_1UtDYzy7kJ",
                    !isNav4Enabled && "_2sNsIgmnOE"
                ])
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $8e1dR.default), {
                id: instructionsId,
                children: intl.formatMessage((0, $8VFXm.messages).inputInstructions)
            }),
            quickFindOpen && value && /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                className: (0, $gJ6nT.default)([
                    "_2fBhtei355 _0adFHs2ADO _3Y6bKpgRhm"
                ]),
                children: clearIconButton
            }),
            showFilterToggle && /*#__PURE__*/ (0, $5chsV.jsx)((0, $e7Gbu.FiltersToggle), {
                ...filterPresentation
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $gP7u8.Box), {
                xcss: [
                    $793dc1534f20b67c$var$connectAppsIconStyles,
                    quickFindOpen && $793dc1534f20b67c$var$connectAppsIconOpenStyles,
                    showFilterToggle && $793dc1534f20b67c$var$connectAppsIconWithFilterToggleStyles
                ],
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $c3eiw.ConnectAppsSearchIcon), {
                    spacing: controlSpacing,
                    start: quickFindOpen && !!thirdPartyConfigs,
                    cloudId: cloudId,
                    accountId: accountId,
                    orgId: orgId,
                    primaryProduct: primaryProduct,
                    smartLinkUsage: smartLinkUsage,
                    thirdPartyConfigs: thirdPartyConfigs,
                    onAppsClick: onAppsClick
                })
            })
        ]
    }));
};
$793dc1534f20b67c$export$d66ddc2063fc70a7.displayName = "Textfield";

});
parcelRegister("e7Gbu", function(module, exports) {
$parcel$export(module.exports, "FiltersToggle", () => $46713aa87974cd29$export$22e1d9624f6c8b05);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

// Keep store dependencies out of the navigation skeleton's initial bundle.
const $46713aa87974cd29$var$FiltersToggleLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).lazy(()=>(parcelRequire("jS0kw")).then(({ FiltersToggle: FiltersToggle })=>({
            default: FiltersToggle
        })));
const $46713aa87974cd29$export$22e1d9624f6c8b05 = (props)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $5chsV.jsx)($46713aa87974cd29$var$FiltersToggleLazy, {
            ...props
        })
    });
$46713aa87974cd29$export$22e1d9624f6c8b05.displayName = "FiltersToggle";

});
parcelRegister("jS0kw", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = Promise.all([
    $dk4lR("a1CVM"),
    $dk4lR("5h6rP"),
    $dk4lR("kwYrn")
]).then(()=>parcelRequire('hiH63'));

});


parcelRegister("c3eiw", function(module, exports) {
$parcel$export(module.exports, "ConnectAppsSearchIcon", () => $0257efeff74377fd$export$c3ce9d4249b1b4b1);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $oAzkD = parcelRequire("oAzkD");

var $fm5Zq = parcelRequire("fm5Zq");

var $llCao = parcelRequire("llCao");

var $daZXj = parcelRequire("daZXj");

var $ktnDV = parcelRequire("ktnDV");

var $jiRQy = parcelRequire("jiRQy");

var $2x9XD = parcelRequire("2x9XD");

var $a7Ic9 = parcelRequire("a7Ic9");

var $8zMBl = parcelRequire("8zMBl");

var $4azRP = parcelRequire("4azRP");

var $jZEH0 = parcelRequire("jZEH0");
// --- Icon sequence --------------------------------------------------------
const $0257efeff74377fd$var$MAX_APP_ICONS = 5;
const $0257efeff74377fd$var$STATIC_SEQUENCE = [
    {
        type: 'ads'
    },
    ...(0, $8zMBl.STATIC_FALLBACK_ORDER).map((slug)=>({
            type: 'img',
            slug: slug
        })),
    {
        type: 'ads'
    }
];
/**
 * Rank icons by smartlink usage from any 3P app that has a config (icon).
 * Backfill with the static fallback order, deduping.
 */ const $0257efeff74377fd$var$useIconSequence = (smartLinkUsage, thirdPartyConfigs)=>{
    return (0, $fsvuC.useMemo)(()=>{
        if (!smartLinkUsage || !thirdPartyConfigs) return $0257efeff74377fd$var$STATIC_SEQUENCE;
        const rankedByUsage = Object.entries(smartLinkUsage).filter(([key])=>(0, $2x9XD.is3pProductKey)(key) && thirdPartyConfigs[key]?.icon).sort((a, b)=>b[1] - a[1]).map(([key])=>key);
        const seen = new Set(rankedByUsage);
        const backfill = (0, $8zMBl.STATIC_FALLBACK_ORDER).filter((key)=>!seen.has(key) && thirdPartyConfigs[key]?.icon);
        const combined = [
            ...rankedByUsage,
            ...backfill
        ].slice(0, $0257efeff74377fd$var$MAX_APP_ICONS);
        return [
            {
                type: 'ads'
            },
            ...combined.map((slug)=>({
                    type: 'img',
                    slug: slug
                })),
            {
                type: 'ads'
            }
        ];
    }, [
        smartLinkUsage,
        thirdPartyConfigs
    ]);
};
// --- Layout / styling constants -------------------------------------------
const $0257efeff74377fd$var$PILL_GAP_PX = 6;
const $0257efeff74377fd$var$PILL_HORIZONTAL_PADDING_PX = 8;
const $0257efeff74377fd$var$LABEL_MAX_WIDTH_PX = 160;
// CSS strings cannot interpolate imported values (compiled `no-imported-style-values`),
// so we redeclare the durations here and assert they match `./timing` at compile time.
const $0257efeff74377fd$var$BG_DURATION_MS = 200;
const $0257efeff74377fd$var$SLIDE_DURATION_MS = 350;
const $0257efeff74377fd$var$FADE_DURATION_MS = 300;
const $0257efeff74377fd$var$EASE_PILL = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
const $0257efeff74377fd$var$EASE_ICON_CROSSFADE = 'cubic-bezier(0.45, 0, 0.55, 1)';
// Compile-time guard: drift between the timing module and the CSS values would
// silently desync animations and tests. This fails to typecheck if either side
// changes without the other.
const $0257efeff74377fd$var$_cssTimingMatchesTimingModule = [
    $0257efeff74377fd$var$BG_DURATION_MS,
    $0257efeff74377fd$var$SLIDE_DURATION_MS,
    $0257efeff74377fd$var$FADE_DURATION_MS
];
// --- Styles ---------------------------------------------------------------
const $0257efeff74377fd$var$pillButtonStyles = null;
const $0257efeff74377fd$var$pillButtonElevatedStyles = null;
const $0257efeff74377fd$var$labelWrapperStyles = null;
const $0257efeff74377fd$var$iconStackStyles = null;
const $0257efeff74377fd$var$iconStackSpacingStyles = {
    default: "_39xV02Z49V _0jFU0VZ49V"
};
const $0257efeff74377fd$var$iconLayerStyles = null;
const $0257efeff74377fd$var$appsIconLayerStyles = null;
const $0257efeff74377fd$var$appIconWrapperStyles = null;
const $0257efeff74377fd$var$appIconInnerStyles = null;
const $0257efeff74377fd$var$IconStack = ({ spacing: spacing, sequence: sequence, activeIndex: activeIndex, elevated: elevated, thirdPartyConfigs: thirdPartyConfigs })=>/*#__PURE__*/ (0, $5chsV.jsx)("span", {
        className: (0, $gJ6nT.default)([
            "_39xV02NHnM _0jFU0VNHnM _1mT5xdRAKS _3YEZNOdnbC _1pp6NdYbGa",
            spacing === 'default' && $0257efeff74377fd$var$iconStackSpacingStyles.default
        ]),
        children: sequence.map((entry, i)=>{
            const isActive = i === activeIndex;
            const key = entry.type === 'ads' ? `ads-${i}` : entry.slug;
            const Icon = entry.type === 'img' ? thirdPartyConfigs?.[entry.slug]?.icon : null;
            return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                style: {
                    opacity: isActive ? 1 : 0
                },
                className: (0, $gJ6nT.default)([
                    "_49OCfRdnbC _23rrnHZRqI _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
                ]),
                children: Icon ? /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                    className: (0, $gJ6nT.default)([
                        "_0bjKvDKTcp _4bt5LAnQyn _2WAcuGnQyn _30huDKba0w _39xV02oWWg _0jFU0VoWWg _24h04i2Njc _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC"
                    ]),
                    children: /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                        className: (0, $gJ6nT.default)([
                            "_3iDTPbccYA"
                        ]),
                        children: /*#__PURE__*/ (0, $5chsV.jsx)(Icon, {
                            size: "small"
                        })
                    })
                }) : /*#__PURE__*/ (0, $5chsV.jsx)($0257efeff74377fd$var$AdsIconCrossfade, {
                    elevated: elevated
                })
            }, key);
        })
    });
$0257efeff74377fd$var$IconStack.displayName = "IconStack";
/**
 * Crossfades between the inverse-color and subtle variants of the Apps icon
 * based on whether the pill is elevated. Both labels are empty because the
 * stack is decorative — accessibility comes from the button's `aria-label`.
 */ const $0257efeff74377fd$var$AdsIconCrossfade = ({ elevated: elevated })=>/*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                style: {
                    opacity: elevated ? 1 : 0
                },
                className: (0, $gJ6nT.default)([
                    "_49OCfRdnbC _23rrnHDC8A _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fm5Zq))), {
                    label: "",
                    color: "var(--ds-icon-inverse, #FFFFFF)"
                })
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                style: {
                    opacity: elevated ? 0 : 1
                },
                className: (0, $gJ6nT.default)([
                    "_49OCfRdnbC _23rrnHDC8A _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fm5Zq))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)"
                })
            })
        ]
    });
$0257efeff74377fd$var$AdsIconCrossfade.displayName = "AdsIconCrossfade";
/**
 * Rendered as a `<span role="button">` instead of a native `<button>` because
 * this component can be placed inside an element that is already a `<button>`
 * (e.g. Jira's `Pressable` skeleton wrapper).  Nesting `<button>` elements
 * produces invalid HTML that causes browsers to mis-parse the SSR payload,
 * breaking hydration and duplicating the entire page.
 *
 * See: https://jplat.atlassian.net/browse/JRB-1245
 */ const $0257efeff74377fd$var$PillButton = ({ spacing: spacing, spanRef: spanRef, ariaLabel: ariaLabel, label: label, sequence: sequence, activeIndex: activeIndex, elevated: elevated, textOut: textOut, onClick: onClick, thirdPartyConfigs: thirdPartyConfigs })=>/*#__PURE__*/ (0, $5chsV.jsxs)("span", {
        ref: spanRef,
        role: "button",
        tabIndex: 0,
        onClick: (e)=>{
            e.stopPropagation();
            onClick();
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                onClick();
            }
        },
        "aria-label": ariaLabel,
        "data-testid": "quick-find-connect-apps-pill",
        style: {
            gap: textOut ? $0257efeff74377fd$var$PILL_GAP_PX : 0,
            paddingLeft: elevated ? $0257efeff74377fd$var$PILL_HORIZONTAL_PADDING_PX : 0
        },
        className: (0, $gJ6nT.default)([
            "_0bjKvDKTcp _2sNsIgOLYo _23rrnHbDiT _3hxITiYbGa _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _46hvQmdnbC _0xmtkodnbC _03SyCPdnbC _0wOv4Q7zJH _0KLXruyL8i _4EiLyUujt8 _34b3D2FQfX _1eOmH6o126",
            elevated && "_0KLXrugozt _1eOmH6kTlo"
        ]),
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                "aria-hidden": "true",
                style: {
                    maxWidth: textOut ? $0257efeff74377fd$var$LABEL_MAX_WIDTH_PX : 0,
                    opacity: textOut ? 1 : 0
                },
                className: (0, $gJ6nT.default)([
                    "_4bt5LAnQyn _2WAcuGnQyn _23rrnHBJlW _3iDTPbccYA _0hPCNLDIqT _1ANEUSLRg7 _20VacPYbGa _1pp6NdYbGa"
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $daZXj.Text), {
                    size: "small",
                    weight: "medium",
                    color: "color.text.inverse",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)($0257efeff74377fd$var$IconStack, {
                spacing: spacing,
                sequence: sequence,
                activeIndex: activeIndex,
                elevated: elevated,
                thirdPartyConfigs: thirdPartyConfigs
            })
        ]
    });
$0257efeff74377fd$var$PillButton.displayName = "PillButton";
const $0257efeff74377fd$export$c3ce9d4249b1b4b1 = ({ spacing: spacing = 'compact', start: start = false, onAppsClick: onAppsClick, spanRef: spanRef, cloudId: cloudId, accountId: accountId, orgId: orgId, primaryProduct: primaryProduct, smartLinkUsage: smartLinkUsage, thirdPartyConfigs: thirdPartyConfigs })=>{
    const { formatMessage: formatMessage } = (0, $oAzkD.default)();
    const sequence = $0257efeff74377fd$var$useIconSequence(smartLinkUsage, thirdPartyConfigs);
    const disableAnimation = (0, $llCao.fg)('quick_find_hide_connect_apps_pill');
    const { canAnimate: canAnimate, recordAnimation: recordAnimation, dismissPermanently: dismissPermanently } = (0, $jZEH0.useConnectAppsCooldown)();
    const { phase: phase, activeIndex: activeIndex, exitEarly: exitEarly } = (0, $4azRP.useConnectAppsAnimation)({
        start: !disableAnimation && start,
        sequenceLength: sequence.length,
        canStart: canAnimate,
        onStart: recordAnimation
    });
    const elevated = (0, $4azRP.isElevated)(phase);
    const textOut = (0, $4azRP.isTextOut)(phase);
    const renderPill = (openModal)=>/*#__PURE__*/ (0, $5chsV.jsx)($0257efeff74377fd$var$PillButton, {
            spacing: spacing,
            spanRef: spanRef,
            ariaLabel: formatMessage((0, $a7Ic9.i18n).connectAppsButtonAriaLabel),
            label: formatMessage((0, $a7Ic9.i18n).connectAppsLabel),
            sequence: sequence,
            activeIndex: activeIndex,
            elevated: elevated,
            textOut: textOut,
            thirdPartyConfigs: thirdPartyConfigs,
            onClick: ()=>{
                onAppsClick?.();
                openModal?.();
                if (!disableAnimation) dismissPermanently();
                if (textOut) exitEarly();
            }
        });
    if (cloudId && primaryProduct) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jiRQy.RovoSettingsModal), {
        product: primaryProduct,
        cloudId: cloudId,
        accountId: accountId,
        orgId: orgId,
        surface: (0, $ktnDV.RovoSettingsModalSurface).SEARCH_QF_PILL,
        children: ({ open: open })=>renderPill(()=>open({
                    defaultTab: 'discovery'
                }))
    });
    return renderPill();
};
$0257efeff74377fd$export$c3ce9d4249b1b4b1.displayName = "ConnectAppsSearchIcon";

});
parcelRegister("2x9XD", function(module, exports) {
$parcel$export(module.exports, "ProductKeys1PForAnalytics", () => $e7da896a3096666f$export$252aae15ddb3591c);
$parcel$export(module.exports, "ProductKeys", () => $e7da896a3096666f$export$ef2c0ffddaaaf76c);
$parcel$export(module.exports, "all3pProductKeys", () => $e7da896a3096666f$export$57043b2770b3924d);
$parcel$export(module.exports, "all1pProductKeys", () => $e7da896a3096666f$export$225f36a2f261b1e7);
$parcel$export(module.exports, "getAllProductKeys", () => $e7da896a3096666f$export$297680dde4e8aef1);
$parcel$export(module.exports, "allProductKeys", () => $e7da896a3096666f$export$73be91b73ebbdb05);
$parcel$export(module.exports, "is1pProductKey", () => $e7da896a3096666f$export$65f9ab1ba49d5e68);
$parcel$export(module.exports, "is3pProductKey", () => $e7da896a3096666f$export$ae4856d6227d0649);
$parcel$export(module.exports, "isProductKey", () => $e7da896a3096666f$export$2a41a819c1db85b1);
$parcel$export(module.exports, "productsSupportingEmptyQuery", () => $e7da896a3096666f$export$ba4f56e768ae6f1e);
$parcel$export(module.exports, "PRODUCTS_ORDER", () => $e7da896a3096666f$export$64c23f2d9ef43822);
$parcel$export(module.exports, "GITHUB_PRODUCT_KEYS", () => $e7da896a3096666f$export$1d911f164123ed26);
$parcel$export(module.exports, "CODE_HOST_PRODUCT_KEYS", () => $e7da896a3096666f$export$29110d064e1087dd);
$parcel$export(module.exports, "PRODUCTS_ORDER_WITH_3P_BY_POPULARITY", () => $e7da896a3096666f$export$41ecd101a1ccdccc);
/**
 * Product key constants, types, and lightweight helpers.
 * No icons, no 3P configs, no React components.
 */ 
var $llCao = parcelRequire("llCao");

var $02ntx = parcelRequire("02ntx");

var $aHDyh = parcelRequire("aHDyh");

var $3ixCN = parcelRequire("3ixCN");

// oxlint-disable-next-line eslint/no-redeclare
const $e7da896a3096666f$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    CustomerServiceManagement: 'jira-customer-service',
    Trello: 'trello',
    Focus: 'mercury',
    Assets: 'cmdb',
    // Can't add these until they're ready as we use this type to enforce that product configs are available for all products
    Talent: 'radar'
};
const $e7da896a3096666f$export$252aae15ddb3591c = {
    ...$e7da896a3096666f$var$ProductKeys1P,
    Loom: 'loom',
    AtlasGoals: 'goals',
    AtlasProjects: 'projects',
    AtlasTeams: 'teams'
};
const $e7da896a3096666f$export$ef2c0ffddaaaf76c = {
    ...$e7da896a3096666f$var$ProductKeys1P,
    ...(0, $aHDyh.ProductKeys3P)
};
const $e7da896a3096666f$var$localAllProductKeys = Object.values($e7da896a3096666f$export$ef2c0ffddaaaf76c);
const $e7da896a3096666f$export$57043b2770b3924d = Object.values((0, $aHDyh.ProductKeys3P));
const $e7da896a3096666f$export$225f36a2f261b1e7 = Object.values($e7da896a3096666f$var$ProductKeys1P);
const $e7da896a3096666f$export$297680dde4e8aef1 = ()=>{
    if ((0, $llCao.fg)('rovo_fps_use_rovo_config')) return 0, $02ntx.allProductKeys;
    return $e7da896a3096666f$var$localAllProductKeys;
};
const $e7da896a3096666f$export$73be91b73ebbdb05 = $e7da896a3096666f$var$localAllProductKeys;
const $e7da896a3096666f$export$65f9ab1ba49d5e68 = (key)=>$e7da896a3096666f$export$225f36a2f261b1e7.includes(key);
const $e7da896a3096666f$export$ae4856d6227d0649 = (key)=>$e7da896a3096666f$export$57043b2770b3924d.includes(key);
const $e7da896a3096666f$export$2a41a819c1db85b1 = (key)=>{
    if (!key) return false;
    // Check hardcoded keys first
    if ($e7da896a3096666f$export$297680dde4e8aef1().includes(key)) return true;
    // Treat any "forge-connector-*" string as valid ProductKeys to support
    // dynamically provisioned Forge connectors without updating this constant list.
    // This means isProductKey is *looser* than "is configured in ProductKeys".
    return key.startsWith('forge-connector-');
};
const $e7da896a3096666f$export$ba4f56e768ae6f1e = [
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Confluence,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Jira
];
const $e7da896a3096666f$export$64c23f2d9ef43822 = [
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Confluence,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Jira,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.CustomerServiceManagement,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Atlas,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Trello,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Bitbucket,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Compass,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Focus,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Assets,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Talent,
    ...(0, $3ixCN.ProductsOrder3P)
];
const $e7da896a3096666f$export$1d911f164123ed26 = [
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Github
];
const $e7da896a3096666f$export$29110d064e1087dd = [
    ...$e7da896a3096666f$export$1d911f164123ed26,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Bitbucket
];
const $e7da896a3096666f$export$41ecd101a1ccdccc = [
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Confluence,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Jira,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.CustomerServiceManagement,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Atlas,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Trello,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Bitbucket,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Compass,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Focus,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Talent,
    $e7da896a3096666f$export$ef2c0ffddaaaf76c.Assets,
    ...(0, $3ixCN.NewProductsOrder3P)
];

});
parcelRegister("3ixCN", function(module, exports) {
$parcel$export(module.exports, "ProductsOrder3P", () => $d6b398c7f25db9c1$export$cc64d659abc3d135);
$parcel$export(module.exports, "NewProductsOrder3P", () => $d6b398c7f25db9c1$export$915acbd1d0c0550d);
$parcel$export(module.exports, "thirdPartyFilterProducts", () => $d6b398c7f25db9c1$export$c36c249aaac5cad0);
/**
 * Pure 3P product key constants extracted for SSR bundle isolation.
 * No icon or config imports - just string mappings.
 *
 * This is the SOURCE OF TRUTH for ProductKeys3P.
 * 3p-product-configs/index.tsx and products.tsx re-export from here.
 */ 
var $aHDyh = parcelRequire("aHDyh");
const $d6b398c7f25db9c1$export$cc64d659abc3d135 = [
    // Loom is actually a 1P so goes to the top
    (0, $aHDyh.ProductKeys3P).Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    (0, $aHDyh.ProductKeys3P).GoogleDrive,
    (0, $aHDyh.ProductKeys3P).Sharepoint,
    (0, $aHDyh.ProductKeys3P).OneDrive,
    (0, $aHDyh.ProductKeys3P).Dropbox,
    (0, $aHDyh.ProductKeys3P).Slack,
    (0, $aHDyh.ProductKeys3P).Teams,
    (0, $aHDyh.ProductKeys3P).Github,
    (0, $aHDyh.ProductKeys3P).Figma,
    (0, $aHDyh.ProductKeys3P).GoogleCalendar,
    (0, $aHDyh.ProductKeys3P).Gmail,
    (0, $aHDyh.ProductKeys3P).OutlookCalendar,
    (0, $aHDyh.ProductKeys3P).OutlookMail,
    (0, $aHDyh.ProductKeys3P).Airtable,
    (0, $aHDyh.ProductKeys3P).Smartsheet,
    (0, $aHDyh.ProductKeys3P).Asana,
    (0, $aHDyh.ProductKeys3P).Zendesk,
    (0, $aHDyh.ProductKeys3P).Miro,
    (0, $aHDyh.ProductKeys3P).Docusign,
    (0, $aHDyh.ProductKeys3P).Lucid,
    (0, $aHDyh.ProductKeys3P).Monday,
    (0, $aHDyh.ProductKeys3P).AzureDevops,
    (0, $aHDyh.ProductKeys3P).Gitlab,
    (0, $aHDyh.ProductKeys3P).ConfluenceDC,
    (0, $aHDyh.ProductKeys3P).Canva,
    (0, $aHDyh.ProductKeys3P).Box,
    (0, $aHDyh.ProductKeys3P).Zeplin,
    (0, $aHDyh.ProductKeys3P).ServiceNow,
    (0, $aHDyh.ProductKeys3P).Freshservice,
    (0, $aHDyh.ProductKeys3P).PowerBI,
    (0, $aHDyh.ProductKeys3P).ClickUp,
    (0, $aHDyh.ProductKeys3P).Amplitude,
    (0, $aHDyh.ProductKeys3P).Stripe,
    (0, $aHDyh.ProductKeys3P).AdobeXD,
    (0, $aHDyh.ProductKeys3P).Aha,
    (0, $aHDyh.ProductKeys3P).AdobeSign,
    (0, $aHDyh.ProductKeys3P).Mural,
    (0, $aHDyh.ProductKeys3P).Webex,
    (0, $aHDyh.ProductKeys3P).PagerDuty,
    (0, $aHDyh.ProductKeys3P).Pipedrive,
    (0, $aHDyh.ProductKeys3P).Dovetail,
    (0, $aHDyh.ProductKeys3P).LaunchDarkly,
    (0, $aHDyh.ProductKeys3P).Salesforce,
    (0, $aHDyh.ProductKeys3P).Sentry,
    (0, $aHDyh.ProductKeys3P).Gitbook,
    (0, $aHDyh.ProductKeys3P).AWSS3,
    (0, $aHDyh.ProductKeys3P).ForgeAdamVitareqDev,
    (0, $aHDyh.ProductKeys3P).ForgeAdamVitareqProd,
    (0, $aHDyh.ProductKeys3P).ForgeK15tScrollSitesDev,
    (0, $aHDyh.ProductKeys3P).ForgeK15tScrollSitesProd,
    (0, $aHDyh.ProductKeys3P).ForgePioAwsDev,
    (0, $aHDyh.ProductKeys3P).ForgePioAwsProd,
    (0, $aHDyh.ProductKeys3P).ForgePioClickupDev,
    (0, $aHDyh.ProductKeys3P).ForgePioClickupProd,
    (0, $aHDyh.ProductKeys3P).ForgePioGithubDev,
    (0, $aHDyh.ProductKeys3P).ForgePioGithubProd,
    (0, $aHDyh.ProductKeys3P).ForgePioGitbookDev,
    (0, $aHDyh.ProductKeys3P).ForgePioGitbookProd,
    (0, $aHDyh.ProductKeys3P).ForgePioGitlabDev,
    (0, $aHDyh.ProductKeys3P).ForgePioGitlabProd,
    (0, $aHDyh.ProductKeys3P).ForgePioGoogleDriveDev,
    (0, $aHDyh.ProductKeys3P).ForgePioGoogleDriveProd,
    (0, $aHDyh.ProductKeys3P).ForgePioGuruDev,
    (0, $aHDyh.ProductKeys3P).ForgePioGuruProd,
    (0, $aHDyh.ProductKeys3P).ForgePioHelpjuiceDev,
    (0, $aHDyh.ProductKeys3P).ForgePioHelpjuiceProd,
    (0, $aHDyh.ProductKeys3P).ForgePioHubspotDev,
    (0, $aHDyh.ProductKeys3P).ForgePioHubspotProd,
    (0, $aHDyh.ProductKeys3P).ForgePioSalesforceDev,
    (0, $aHDyh.ProductKeys3P).ForgePioSalesforceProd,
    (0, $aHDyh.ProductKeys3P).ForgePioSharepointDev,
    (0, $aHDyh.ProductKeys3P).ForgePioSharepointProd,
    (0, $aHDyh.ProductKeys3P).ForgePioStackOverflowDev,
    (0, $aHDyh.ProductKeys3P).ForgePioStackOverflowProd,
    (0, $aHDyh.ProductKeys3P).ForgeUtoolityGitbookDev,
    (0, $aHDyh.ProductKeys3P).ForgeUtoolityGitbookProd,
    (0, $aHDyh.ProductKeys3P).ForgeGdriveEugeneTestDev,
    (0, $aHDyh.ProductKeys3P).ForgeGdriveEugeneTestProd,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoSalesforceDev,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoSalesforceProd,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoServicenowDev,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoServicenowProd,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoWrikeDev,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoWrikeProd,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoAsanaDev,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoAsanaProd,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoBasecampDev,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoBasecampProd,
    // New 3P? Add it here
    (0, $aHDyh.ProductKeys3P).Databricks,
    (0, $aHDyh.ProductKeys3P).Notion,
    (0, $aHDyh.ProductKeys3P).Todoist,
    (0, $aHDyh.ProductKeys3P).Hubspot,
    (0, $aHDyh.ProductKeys3P).Gong,
    (0, $aHDyh.ProductKeys3P).Zoom,
    (0, $aHDyh.ProductKeys3P).JiraDC,
    (0, $aHDyh.ProductKeys3P).JsmDC,
    // Always last
    (0, $aHDyh.ProductKeys3P).AtlassianWebCrawler
];
// TODO: QS-8075 replace into PRODUCTS_ORDER when cleaning up the FG
const $d6b398c7f25db9c1$export$915acbd1d0c0550d = [
    // Loom is actually a 1P so goes to the top
    (0, $aHDyh.ProductKeys3P).Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    (0, $aHDyh.ProductKeys3P).GoogleDrive,
    (0, $aHDyh.ProductKeys3P).Sharepoint,
    (0, $aHDyh.ProductKeys3P).Slack,
    (0, $aHDyh.ProductKeys3P).Teams,
    (0, $aHDyh.ProductKeys3P).Figma,
    (0, $aHDyh.ProductKeys3P).Miro,
    (0, $aHDyh.ProductKeys3P).Salesforce,
    (0, $aHDyh.ProductKeys3P).Github,
    (0, $aHDyh.ProductKeys3P).Gmail,
    (0, $aHDyh.ProductKeys3P).Gitlab,
    (0, $aHDyh.ProductKeys3P).Lucid,
    (0, $aHDyh.ProductKeys3P).Asana,
    (0, $aHDyh.ProductKeys3P).AzureDevops,
    (0, $aHDyh.ProductKeys3P).GoogleCalendar,
    (0, $aHDyh.ProductKeys3P).OneDrive,
    (0, $aHDyh.ProductKeys3P).Dropbox,
    (0, $aHDyh.ProductKeys3P).OutlookCalendar,
    (0, $aHDyh.ProductKeys3P).OutlookMail,
    (0, $aHDyh.ProductKeys3P).Airtable,
    (0, $aHDyh.ProductKeys3P).Smartsheet,
    (0, $aHDyh.ProductKeys3P).Zendesk,
    (0, $aHDyh.ProductKeys3P).Docusign,
    (0, $aHDyh.ProductKeys3P).Databricks,
    (0, $aHDyh.ProductKeys3P).Monday,
    (0, $aHDyh.ProductKeys3P).ConfluenceDC,
    (0, $aHDyh.ProductKeys3P).Canva,
    (0, $aHDyh.ProductKeys3P).Box,
    (0, $aHDyh.ProductKeys3P).Zeplin,
    (0, $aHDyh.ProductKeys3P).ServiceNow,
    (0, $aHDyh.ProductKeys3P).Freshservice,
    (0, $aHDyh.ProductKeys3P).PowerBI,
    (0, $aHDyh.ProductKeys3P).ClickUp,
    (0, $aHDyh.ProductKeys3P).Amplitude,
    (0, $aHDyh.ProductKeys3P).Stripe,
    (0, $aHDyh.ProductKeys3P).AdobeXD,
    (0, $aHDyh.ProductKeys3P).Aha,
    (0, $aHDyh.ProductKeys3P).AdobeSign,
    (0, $aHDyh.ProductKeys3P).Mural,
    (0, $aHDyh.ProductKeys3P).Webex,
    (0, $aHDyh.ProductKeys3P).PagerDuty,
    (0, $aHDyh.ProductKeys3P).Pipedrive,
    (0, $aHDyh.ProductKeys3P).Dovetail,
    (0, $aHDyh.ProductKeys3P).LaunchDarkly,
    (0, $aHDyh.ProductKeys3P).Sentry,
    (0, $aHDyh.ProductKeys3P).Gitbook,
    (0, $aHDyh.ProductKeys3P).AWSS3,
    (0, $aHDyh.ProductKeys3P).Notion,
    (0, $aHDyh.ProductKeys3P).Todoist,
    (0, $aHDyh.ProductKeys3P).Hubspot,
    (0, $aHDyh.ProductKeys3P).JiraDC,
    (0, $aHDyh.ProductKeys3P).JsmDC,
    // New 3P? Add it here
    (0, $aHDyh.ProductKeys3P).ForgeAdamVitareqDev,
    (0, $aHDyh.ProductKeys3P).ForgeAdamVitareqProd,
    (0, $aHDyh.ProductKeys3P).ForgeK15tScrollSitesDev,
    (0, $aHDyh.ProductKeys3P).ForgeK15tScrollSitesProd,
    (0, $aHDyh.ProductKeys3P).ForgePioAwsDev,
    (0, $aHDyh.ProductKeys3P).ForgePioAwsProd,
    (0, $aHDyh.ProductKeys3P).ForgePioClickupDev,
    (0, $aHDyh.ProductKeys3P).ForgePioClickupProd,
    (0, $aHDyh.ProductKeys3P).ForgePioGithubDev,
    (0, $aHDyh.ProductKeys3P).ForgePioGithubProd,
    (0, $aHDyh.ProductKeys3P).ForgePioGitbookDev,
    (0, $aHDyh.ProductKeys3P).ForgePioGitbookProd,
    (0, $aHDyh.ProductKeys3P).ForgePioGitlabDev,
    (0, $aHDyh.ProductKeys3P).ForgePioGitlabProd,
    (0, $aHDyh.ProductKeys3P).ForgePioGoogleDriveDev,
    (0, $aHDyh.ProductKeys3P).ForgePioGoogleDriveProd,
    (0, $aHDyh.ProductKeys3P).ForgePioGuruDev,
    (0, $aHDyh.ProductKeys3P).ForgePioGuruProd,
    (0, $aHDyh.ProductKeys3P).ForgePioHelpjuiceDev,
    (0, $aHDyh.ProductKeys3P).ForgePioHelpjuiceProd,
    (0, $aHDyh.ProductKeys3P).ForgePioHubspotDev,
    (0, $aHDyh.ProductKeys3P).ForgePioHubspotProd,
    (0, $aHDyh.ProductKeys3P).ForgePioSalesforceDev,
    (0, $aHDyh.ProductKeys3P).ForgePioSalesforceProd,
    (0, $aHDyh.ProductKeys3P).ForgePioSharepointDev,
    (0, $aHDyh.ProductKeys3P).ForgePioSharepointProd,
    (0, $aHDyh.ProductKeys3P).ForgePioStackOverflowDev,
    (0, $aHDyh.ProductKeys3P).ForgePioStackOverflowProd,
    (0, $aHDyh.ProductKeys3P).ForgeUtoolityGitbookDev,
    (0, $aHDyh.ProductKeys3P).ForgeUtoolityGitbookProd,
    (0, $aHDyh.ProductKeys3P).ForgeGdriveEugeneTestDev,
    (0, $aHDyh.ProductKeys3P).ForgeGdriveEugeneTestProd,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoSalesforceDev,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoSalesforceProd,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoServicenowDev,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoServicenowProd,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoWrikeDev,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoWrikeProd,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoAsanaDev,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoAsanaProd,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoBasecampDev,
    (0, $aHDyh.ProductKeys3P).ForgeUnitoBasecampProd,
    (0, $aHDyh.ProductKeys3P).Gong,
    (0, $aHDyh.ProductKeys3P).Zoom,
    // Always last
    (0, $aHDyh.ProductKeys3P).AtlassianWebCrawler
];
const $d6b398c7f25db9c1$export$c36c249aaac5cad0 = {
    assignee: [
        (0, $aHDyh.ProductKeys3P).JiraDC,
        (0, $aHDyh.ProductKeys3P).JsmDC,
        (0, $aHDyh.ProductKeys3P).Github,
        (0, $aHDyh.ProductKeys3P).ForgePioGithubDev,
        (0, $aHDyh.ProductKeys3P).ForgePioGithubProd
    ],
    campaignStatus: [
        (0, $aHDyh.ProductKeys3P).Salesforce
    ],
    caseStatus: [
        (0, $aHDyh.ProductKeys3P).Salesforce
    ],
    closeDate: [
        (0, $aHDyh.ProductKeys3P).Salesforce
    ],
    content: [
        (0, $aHDyh.ProductKeys3P).ConfluenceDC,
        (0, $aHDyh.ProductKeys3P).GoogleDrive,
        (0, $aHDyh.ProductKeys3P).Sharepoint
    ],
    createdBy: [
        (0, $aHDyh.ProductKeys3P).ConfluenceDC,
        (0, $aHDyh.ProductKeys3P).ForgePioGithubDev,
        (0, $aHDyh.ProductKeys3P).ForgePioGithubProd,
        (0, $aHDyh.ProductKeys3P).Github,
        (0, $aHDyh.ProductKeys3P).Hubspot,
        (0, $aHDyh.ProductKeys3P).Salesforce
    ],
    label: [
        (0, $aHDyh.ProductKeys3P).ConfluenceDC
    ],
    lastUpdated: [
        (0, $aHDyh.ProductKeys3P).Airtable,
        (0, $aHDyh.ProductKeys3P).Asana,
        (0, $aHDyh.ProductKeys3P).AzureDevops,
        (0, $aHDyh.ProductKeys3P).Box,
        (0, $aHDyh.ProductKeys3P).ConfluenceDC,
        (0, $aHDyh.ProductKeys3P).Databricks,
        (0, $aHDyh.ProductKeys3P).Docusign,
        (0, $aHDyh.ProductKeys3P).Dropbox,
        (0, $aHDyh.ProductKeys3P).Figma,
        (0, $aHDyh.ProductKeys3P).ForgeAdamVitareqDev,
        (0, $aHDyh.ProductKeys3P).ForgeAdamVitareqProd,
        (0, $aHDyh.ProductKeys3P).ForgeGdriveEugeneTestDev,
        (0, $aHDyh.ProductKeys3P).ForgeGdriveEugeneTestProd,
        (0, $aHDyh.ProductKeys3P).ForgeK15tScrollSitesDev,
        (0, $aHDyh.ProductKeys3P).ForgeK15tScrollSitesProd,
        (0, $aHDyh.ProductKeys3P).ForgePioAwsDev,
        (0, $aHDyh.ProductKeys3P).ForgePioAwsProd,
        (0, $aHDyh.ProductKeys3P).ForgePioClickupDev,
        (0, $aHDyh.ProductKeys3P).ForgePioClickupProd,
        (0, $aHDyh.ProductKeys3P).ForgePioGitbookDev,
        (0, $aHDyh.ProductKeys3P).ForgePioGitbookProd,
        (0, $aHDyh.ProductKeys3P).ForgePioGithubDev,
        (0, $aHDyh.ProductKeys3P).ForgePioGithubProd,
        (0, $aHDyh.ProductKeys3P).ForgePioGitlabDev,
        (0, $aHDyh.ProductKeys3P).ForgePioGitlabProd,
        (0, $aHDyh.ProductKeys3P).ForgePioGoogleDriveDev,
        (0, $aHDyh.ProductKeys3P).ForgePioGoogleDriveProd,
        (0, $aHDyh.ProductKeys3P).ForgePioGuruDev,
        (0, $aHDyh.ProductKeys3P).ForgePioGuruProd,
        (0, $aHDyh.ProductKeys3P).ForgePioHelpjuiceDev,
        (0, $aHDyh.ProductKeys3P).ForgePioHelpjuiceProd,
        (0, $aHDyh.ProductKeys3P).ForgePioHubspotDev,
        (0, $aHDyh.ProductKeys3P).ForgePioHubspotProd,
        (0, $aHDyh.ProductKeys3P).ForgePioSalesforceDev,
        (0, $aHDyh.ProductKeys3P).ForgePioSalesforceProd,
        (0, $aHDyh.ProductKeys3P).ForgePioSharepointDev,
        (0, $aHDyh.ProductKeys3P).ForgePioSharepointProd,
        (0, $aHDyh.ProductKeys3P).ForgePioStackOverflowDev,
        (0, $aHDyh.ProductKeys3P).ForgePioStackOverflowProd,
        (0, $aHDyh.ProductKeys3P).ForgeUnitoAsanaDev,
        (0, $aHDyh.ProductKeys3P).ForgeUnitoAsanaProd,
        (0, $aHDyh.ProductKeys3P).ForgeUnitoBasecampDev,
        (0, $aHDyh.ProductKeys3P).ForgeUnitoBasecampProd,
        (0, $aHDyh.ProductKeys3P).ForgeUnitoSalesforceDev,
        (0, $aHDyh.ProductKeys3P).ForgeUnitoSalesforceProd,
        (0, $aHDyh.ProductKeys3P).ForgeUnitoServicenowDev,
        (0, $aHDyh.ProductKeys3P).ForgeUnitoServicenowProd,
        (0, $aHDyh.ProductKeys3P).ForgeUnitoWrikeDev,
        (0, $aHDyh.ProductKeys3P).ForgeUnitoWrikeProd,
        (0, $aHDyh.ProductKeys3P).ForgeUtoolityGitbookDev,
        (0, $aHDyh.ProductKeys3P).ForgeUtoolityGitbookProd,
        (0, $aHDyh.ProductKeys3P).Github,
        (0, $aHDyh.ProductKeys3P).Gmail,
        (0, $aHDyh.ProductKeys3P).GoogleDrive,
        (0, $aHDyh.ProductKeys3P).Hubspot,
        (0, $aHDyh.ProductKeys3P).JiraDC,
        (0, $aHDyh.ProductKeys3P).JsmDC,
        (0, $aHDyh.ProductKeys3P).Loom,
        (0, $aHDyh.ProductKeys3P).Lucid,
        (0, $aHDyh.ProductKeys3P).Miro,
        (0, $aHDyh.ProductKeys3P).Notion,
        (0, $aHDyh.ProductKeys3P).OneDrive,
        (0, $aHDyh.ProductKeys3P).OutlookMail,
        (0, $aHDyh.ProductKeys3P).Salesforce,
        (0, $aHDyh.ProductKeys3P).ServiceNow,
        (0, $aHDyh.ProductKeys3P).Sharepoint,
        (0, $aHDyh.ProductKeys3P).Slack,
        (0, $aHDyh.ProductKeys3P).Smartsheet,
        (0, $aHDyh.ProductKeys3P).Teams,
        (0, $aHDyh.ProductKeys3P).Zendesk,
        (0, $aHDyh.ProductKeys3P).Gong,
        (0, $aHDyh.ProductKeys3P).Zoom
    ],
    lastUpdatedBy: [
        (0, $aHDyh.ProductKeys3P).Hubspot,
        (0, $aHDyh.ProductKeys3P).Salesforce
    ],
    opportunityStatus: [
        (0, $aHDyh.ProductKeys3P).Salesforce
    ],
    onlyTitleMatch: [
        (0, $aHDyh.ProductKeys3P).Airtable,
        (0, $aHDyh.ProductKeys3P).Asana,
        (0, $aHDyh.ProductKeys3P).Box,
        (0, $aHDyh.ProductKeys3P).ConfluenceDC,
        (0, $aHDyh.ProductKeys3P).Databricks,
        (0, $aHDyh.ProductKeys3P).Docusign,
        (0, $aHDyh.ProductKeys3P).Dropbox,
        (0, $aHDyh.ProductKeys3P).Github,
        (0, $aHDyh.ProductKeys3P).GoogleDrive,
        (0, $aHDyh.ProductKeys3P).Hubspot,
        (0, $aHDyh.ProductKeys3P).Miro,
        (0, $aHDyh.ProductKeys3P).Notion,
        (0, $aHDyh.ProductKeys3P).OneDrive,
        (0, $aHDyh.ProductKeys3P).OutlookMail,
        (0, $aHDyh.ProductKeys3P).Salesforce,
        (0, $aHDyh.ProductKeys3P).ServiceNow,
        (0, $aHDyh.ProductKeys3P).Sharepoint,
        (0, $aHDyh.ProductKeys3P).Smartsheet,
        (0, $aHDyh.ProductKeys3P).Zendesk,
        (0, $aHDyh.ProductKeys3P).Gong,
        (0, $aHDyh.ProductKeys3P).Zoom
    ],
    owner: [
        (0, $aHDyh.ProductKeys3P).Salesforce
    ],
    project: [
        (0, $aHDyh.ProductKeys3P).JiraDC,
        (0, $aHDyh.ProductKeys3P).JsmDC
    ],
    pullRequestStatus: [
        (0, $aHDyh.ProductKeys3P).ForgePioGithubDev,
        (0, $aHDyh.ProductKeys3P).ForgePioGithubProd,
        (0, $aHDyh.ProductKeys3P).ForgePioGitlabDev,
        (0, $aHDyh.ProductKeys3P).ForgePioGitlabProd,
        (0, $aHDyh.ProductKeys3P).Github,
        (0, $aHDyh.ProductKeys3P).Gitlab
    ],
    repository: [
        (0, $aHDyh.ProductKeys3P).ForgePioGithubDev,
        (0, $aHDyh.ProductKeys3P).ForgePioGithubProd,
        (0, $aHDyh.ProductKeys3P).Github
    ],
    reviewer: [
        (0, $aHDyh.ProductKeys3P).ForgePioGithubDev,
        (0, $aHDyh.ProductKeys3P).ForgePioGithubProd,
        (0, $aHDyh.ProductKeys3P).Github
    ],
    slackChannel: [
        (0, $aHDyh.ProductKeys3P).Slack
    ],
    space: [
        (0, $aHDyh.ProductKeys3P).ConfluenceDC,
        (0, $aHDyh.ProductKeys3P).GoogleDrive,
        (0, $aHDyh.ProductKeys3P).Sharepoint
    ],
    hasAttachment: [
        (0, $aHDyh.ProductKeys3P).Teams
    ],
    // workspaceName is always in ThirdPartyConfigs.filters for Teams (gate controls filterIdOrdering only)
    workspaceName: [
        (0, $aHDyh.ProductKeys3P).Teams
    ]
};

});


parcelRegister("a7Ic9", function(module, exports) {
$parcel$export(module.exports, "i18n", () => $c3f327dec466a7f0$export$a7357cdd1f0b0168);

var $54F37 = parcelRequire("54F37");
const $c3f327dec466a7f0$export$a7357cdd1f0b0168 = (0, $54F37.defineMessages)({
    connectAppsLabel: {
        id: 'quick_find_connect_apps_label',
        defaultMessage: 'Connect apps',
        description: 'Label that slides in next to the apps icon when the search bar is opened, indicating the user can connect third-party apps.'
    },
    connectAppsButtonAriaLabel: {
        id: 'quick_find_connect_apps_button_aria_label',
        defaultMessage: 'Open app connections',
        description: 'Accessible label for the apps button shown at the trailing edge of the search bar.'
    }
});

});

parcelRegister("8zMBl", function(module, exports) {
$parcel$export(module.exports, "STATIC_FALLBACK_ORDER", () => $753547a2cd5babf5$export$cf5dbd29f0fc9bcc);

var $aHDyh = parcelRequire("aHDyh");
const $753547a2cd5babf5$export$cf5dbd29f0fc9bcc = [
    (0, $aHDyh.ProductKeys3P).GoogleDrive,
    (0, $aHDyh.ProductKeys3P).Salesforce,
    (0, $aHDyh.ProductKeys3P).Slack,
    (0, $aHDyh.ProductKeys3P).Github,
    (0, $aHDyh.ProductKeys3P).Figma
];

});

parcelRegister("4azRP", function(module, exports) {
$parcel$export(module.exports, "isElevated", () => $d2a0a72af0c498b8$export$58fbd07a68af8e16);
$parcel$export(module.exports, "isTextOut", () => $d2a0a72af0c498b8$export$918c1c59a77a7524);
$parcel$export(module.exports, "useConnectAppsAnimation", () => $d2a0a72af0c498b8$export$3fdaf24cc938081f);

var $fsvuC = parcelRequire("fsvuC");

var $fqiya = parcelRequire("fqiya");
const $d2a0a72af0c498b8$export$58fbd07a68af8e16 = (phase)=>phase === 'bg-fade-in' || phase === 'sliding-out' || phase === 'icon-cycling' || phase === 'sliding-back';
const $d2a0a72af0c498b8$export$918c1c59a77a7524 = (phase)=>phase === 'sliding-out' || phase === 'icon-cycling';
/** Maximum number of animation runs allowed per icon-component mount. */ const $d2a0a72af0c498b8$var$MAX_STARTS = 2;
const $d2a0a72af0c498b8$export$3fdaf24cc938081f = ({ start: start, sequenceLength: sequenceLength, canStart: canStart, onStart: onStart })=>{
    const [phase, setPhase] = (0, $fsvuC.useState)('idle');
    const [activeIndex, setActiveIndex] = (0, $fsvuC.useState)(0);
    const timersRef = (0, $fsvuC.useRef)([]);
    const rafRef = (0, $fsvuC.useRef)(null);
    const startCountRef = (0, $fsvuC.useRef)(0);
    // Mirror `sequenceLength` in a ref so the start-effect can read the latest
    // value without re-firing whenever the prop reference changes. This prevents
    // an in-flight animation from being torn down + restarted (visually a "rewind")
    // and from incrementing the cooldown counter twice for the same play.
    const sequenceLengthRef = (0, $fsvuC.useRef)(sequenceLength);
    sequenceLengthRef.current = sequenceLength;
    const cancelTimers = (0, $fsvuC.useCallback)(()=>{
        timersRef.current.forEach(clearTimeout);
        timersRef.current = [];
        if (rafRef.current !== null) {
            cancelAnimationFrame(rafRef.current);
            rafRef.current = null;
        }
    }, []);
    const scheduleAfter = (0, $fsvuC.useCallback)((delayMs, fn)=>{
        timersRef.current.push(setTimeout(fn, delayMs));
    }, []);
    const playReverseTail = (0, $fsvuC.useCallback)(()=>{
        setActiveIndex(0);
        setPhase('sliding-back');
        scheduleAfter((0, $fqiya.CONNECT_APPS_SLIDE_DURATION), ()=>{
            setPhase('bg-fade-out');
            scheduleAfter((0, $fqiya.CONNECT_APPS_BG_DURATION), ()=>setPhase('done'));
        });
    }, [
        scheduleAfter
    ]);
    const exitEarly = (0, $fsvuC.useCallback)(()=>{
        cancelTimers();
        playReverseTail();
    }, [
        cancelTimers,
        playReverseTail
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!start) {
            cancelTimers();
            setPhase('idle');
            setActiveIndex(0);
            return;
        }
        // Cap the per-mount play count and consult the per-week cooldown.
        // Visual overlap between consecutive runs is prevented separately —
        // the parent must transition `start` back to `false` (the branch
        // above cancels in-flight timers + resets to `idle`) before raising
        // `start` again for the next play.
        if (startCountRef.current >= $d2a0a72af0c498b8$var$MAX_STARTS || !canStart()) return;
        // We split the start over two animation frames so the DOM has enough
        // time to flush the idle styles before CSS transitions begin. Without
        // this, opening QuickFind during the initial render burst (e.g. mouse
        // already over QF on refresh) causes the pill to snap to bg-fade-in
        // and freeze because the transition has no painted "from" value.
        // Mirrors the canonical pattern in @atlaskit/motion (resizing, shrink-out).
        rafRef.current = requestAnimationFrame(()=>{
            rafRef.current = requestAnimationFrame(()=>{
                rafRef.current = null;
                // Consume the per-mount play slot and weekly cooldown only once
                // the animation actually begins. Done here (inside the inner rAF)
                // so a fast open-then-close in the ~16ms before paint cancels the
                // rAF without burning the user's budget.
                startCountRef.current += 1;
                onStart();
                // Snapshot the latest sequence length once per run so all
                // timeline math is internally consistent.
                const sequenceLength = sequenceLengthRef.current;
                // Build the full timeline up-front so forward & reverse share one schedule.
                const cycleStart = (0, $fqiya.CONNECT_APPS_BG_DURATION) + (0, $fqiya.CONNECT_APPS_SLIDE_DURATION);
                const cycleDuration = (sequenceLength - 1) * (0, $fqiya.CONNECT_APPS_ICON_STEP) + (0, $fqiya.HOLD_DURATION);
                const reverseStart = cycleStart + cycleDuration + (0, $fqiya.END_LINGER);
                const steps = [
                    {
                        atMs: 0,
                        apply: ()=>setPhase('bg-fade-in')
                    },
                    {
                        atMs: (0, $fqiya.CONNECT_APPS_BG_DURATION),
                        apply: ()=>setPhase('sliding-out')
                    },
                    {
                        atMs: cycleStart,
                        apply: ()=>setPhase('icon-cycling')
                    }
                ];
                // Icon i (1..N-1) becomes active HOLD ms after icon-cycling starts,
                // then every ICON_STEP ms thereafter.
                for(let i = 1; i < sequenceLength; i++)steps.push({
                    atMs: cycleStart + (0, $fqiya.HOLD_DURATION) + (i - 1) * (0, $fqiya.CONNECT_APPS_ICON_STEP),
                    apply: ()=>setActiveIndex(i)
                });
                steps.push({
                    atMs: reverseStart,
                    apply: ()=>{
                        setActiveIndex(0);
                        setPhase('sliding-back');
                    }
                }, {
                    atMs: reverseStart + (0, $fqiya.CONNECT_APPS_SLIDE_DURATION),
                    apply: ()=>setPhase('bg-fade-out')
                }, {
                    atMs: reverseStart + (0, $fqiya.CONNECT_APPS_SLIDE_DURATION) + (0, $fqiya.CONNECT_APPS_BG_DURATION),
                    apply: ()=>setPhase('done')
                });
                steps.forEach(({ atMs: atMs, apply: apply })=>scheduleAfter(atMs, apply));
            });
        });
        return cancelTimers;
    // `sequenceLength` is intentionally omitted from the deps; it's read from
    // `sequenceLengthRef` inside the rAF callback so a mid-flight prop change
    // doesn't tear down + restart the animation (see comment on the ref above).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        start,
        canStart,
        onStart,
        cancelTimers,
        scheduleAfter
    ]);
    return {
        phase: phase,
        activeIndex: activeIndex,
        exitEarly: exitEarly
    };
};

});
parcelRegister("fqiya", function(module, exports) {
$parcel$export(module.exports, "CONNECT_APPS_BG_DURATION", () => $24bfdb8b3a4dc58c$export$db0699d3bbb5c21);
$parcel$export(module.exports, "CONNECT_APPS_SLIDE_DURATION", () => $24bfdb8b3a4dc58c$export$7ed54f99843287d);
$parcel$export(module.exports, "HOLD_DURATION", () => $24bfdb8b3a4dc58c$export$fad50bf971d7fa0e);
$parcel$export(module.exports, "CONNECT_APPS_ICON_STEP", () => $24bfdb8b3a4dc58c$export$cb49a8c4d0e244f2);
$parcel$export(module.exports, "END_LINGER", () => $24bfdb8b3a4dc58c$export$f5cb186d9c55308b);
/**
 * Timing & easing constants for the Connect Apps animation.
 *
 * Single source of truth for both the JS phase machine
 * (`useConnectAppsAnimation`) and the CSS transitions in `index.tsx`.
 * Tests import these to derive total run time without hardcoding magic numbers.
 */ /** Duration of the pill background fade in/out at each end of the animation. */ const $24bfdb8b3a4dc58c$export$db0699d3bbb5c21 = 200;
const $24bfdb8b3a4dc58c$export$7ed54f99843287d = 350;
const $24bfdb8b3a4dc58c$export$fad50bf971d7fa0e = 420;
const $24bfdb8b3a4dc58c$export$9f0b035597bf40dd = 300;
const $24bfdb8b3a4dc58c$export$cb49a8c4d0e244f2 = $24bfdb8b3a4dc58c$export$fad50bf971d7fa0e + $24bfdb8b3a4dc58c$export$9f0b035597bf40dd;
const $24bfdb8b3a4dc58c$export$f5cb186d9c55308b = 1200;
const $24bfdb8b3a4dc58c$export$cf94430de8ea1fba = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
const $24bfdb8b3a4dc58c$export$3ded9395204bb852 = 'cubic-bezier(0.45, 0, 0.55, 1)';

});


parcelRegister("jZEH0", function(module, exports) {
$parcel$export(module.exports, "useConnectAppsCooldown", () => $703a24348ed2ba89$export$92cbac270a4be2e0);

var $fsvuC = parcelRequire("fsvuC");

var $3F9XK = parcelRequire("3F9XK");

var $58jbW = parcelRequire("58jbW");

var $c92YF = parcelRequire("c92YF");
const $703a24348ed2ba89$var$COOLDOWN_STORAGE_KEY = 'quick_find_connect_apps_cooldown';
const $703a24348ed2ba89$var$MAX_ANIMATIONS_PER_WEEK = 10;
const $703a24348ed2ba89$var$DISMISSED_VALUE = 'dismissed';
const $703a24348ed2ba89$var$getCurrentWeekKey = ()=>{
    const now = new Date();
    // ISO week-year + ISO week so we don't get an off-by-one across a year boundary
    // (e.g. Jan 1 can fall in the previous year's last ISO week).
    return `${(0, $58jbW.default)(now)}_w${(0, $3F9XK.default)(now)}`;
};
const $703a24348ed2ba89$var$readStore = ()=>{
    const raw = (0, $c92YF.getLocalStorageItemAsString)($703a24348ed2ba89$var$COOLDOWN_STORAGE_KEY);
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object' && 'count' in parsed && 'weekKey' in parsed && typeof parsed.count === 'number' && typeof parsed.weekKey === 'string') return parsed;
        return null;
    } catch  {
        // JSON parse error — degrade gracefully.
        return null;
    }
};
const $703a24348ed2ba89$var$isDismissed = ()=>{
    return (0, $c92YF.getLocalStorageItemAsString)($703a24348ed2ba89$var$COOLDOWN_STORAGE_KEY) === $703a24348ed2ba89$var$DISMISSED_VALUE;
};
const $703a24348ed2ba89$var$writeStore = (store)=>{
    try {
        (0, $c92YF.setLocalStorageItem)($703a24348ed2ba89$var$COOLDOWN_STORAGE_KEY, JSON.stringify(store));
    } catch  {
    // Private browsing / storage full / quota exceeded — degrade gracefully
    // (the animation plays anyway; we just lose the count for this attempt).
    }
};
const $703a24348ed2ba89$export$92cbac270a4be2e0 = (maxPerWeek = $703a24348ed2ba89$var$MAX_ANIMATIONS_PER_WEEK)=>{
    const canAnimate = (0, $fsvuC.useCallback)(()=>{
        if ($703a24348ed2ba89$var$isDismissed()) return false;
        const weekKey = $703a24348ed2ba89$var$getCurrentWeekKey();
        const stored = $703a24348ed2ba89$var$readStore();
        if (stored?.weekKey === weekKey && stored.count >= maxPerWeek) return false;
        return true;
    }, [
        maxPerWeek
    ]);
    const recordAnimation = (0, $fsvuC.useCallback)(()=>{
        const weekKey = $703a24348ed2ba89$var$getCurrentWeekKey();
        const stored = $703a24348ed2ba89$var$readStore();
        const count = stored?.weekKey === weekKey ? stored.count + 1 : 1;
        $703a24348ed2ba89$var$writeStore({
            weekKey: weekKey,
            count: count
        });
    }, []);
    const dismissPermanently = (0, $fsvuC.useCallback)(()=>{
        try {
            (0, $c92YF.setLocalStorageItem)($703a24348ed2ba89$var$COOLDOWN_STORAGE_KEY, $703a24348ed2ba89$var$DISMISSED_VALUE);
        } catch  {
        // degrade gracefully
        }
    }, []);
    return {
        canAnimate: canAnimate,
        recordAnimation: recordAnimation,
        dismissPermanently: dismissPermanently
    };
};

});


parcelRegister("bHxCN", function(module, exports) {
$parcel$export(module.exports, "LegacySearchIcon", () => $1e3e6b9794c9c5aa$export$c3bd67ecc5ebe519);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $edN4B = parcelRequire("edN4B");
const $1e3e6b9794c9c5aa$export$c3bd67ecc5ebe519 = ({ isExpanded: isExpanded, primaryColor: primaryColor = "var(--ds-text, #292A2E)", defaultColor: defaultColor = "var(--ds-text-subtlest, #6B6E76)", label: label = '' })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($edN4B))), {
        label: label,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : defaultColor
    });
$1e3e6b9794c9c5aa$export$c3bd67ecc5ebe519.displayName = "LegacySearchIcon";

});

parcelRegister("8VFXm", function(module, exports) {
$parcel$export(module.exports, "messages", () => $603cba3345c405d7$export$defe85febe8b728c);

var $54F37 = parcelRequire("54F37");
const $603cba3345c405d7$export$defe85febe8b728c = (0, $54F37.defineMessages)({
    clearIconLabel: {
        id: 'input_clear_icon_label',
        defaultMessage: 'Clear search',
        description: 'Label text for clear search button'
    },
    inputPlaceholder: {
        id: 'input_placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text in primary search input. Also used as the input accessible name, so keep it to a single word that voice-control users can say.'
    },
    inputInstructions: {
        id: 'input_aria_label',
        defaultMessage: 'Press enter to navigate to advanced search with your text query',
        description: 'Instruction for the primary search input, announced via aria-describedby, directs users to advanced search'
    },
    filterToggleLabel: {
        id: 'search-page.common.quick-find.textfield.filterToggleLabel',
        defaultMessage: 'Filters',
        description: 'Accessible label for the button that expands or collapses Quick Find filters'
    },
    filterToggleLabelWithCount: {
        id: 'search-page.common.quick-find.textfield.filterToggleLabelWithCount',
        defaultMessage: 'Filters, {count} applied',
        description: 'Accessible label for the button that expands or collapses Quick Find filters when filters are applied. {count} is the number of applied filters.'
    }
});

});


parcelRegister("2dZ7D", function(module, exports) {
$parcel$export(module.exports, "getInitialQuery", () => $f82a97b2a0b31328$export$ed7270bd966434af);
$parcel$export(module.exports, "useInputSkeleton", () => $f82a97b2a0b31328$export$67de3a75cbe82e14);

var $fsvuC = parcelRequire("fsvuC");

var $3K8mq = parcelRequire("3K8mq");
// The query is stored in module scope to persist across remounts
let $f82a97b2a0b31328$var$initialQueryValue;
const $f82a97b2a0b31328$export$ed7270bd966434af = (searchQueryParams)=>{
    const stickySearch = $f82a97b2a0b31328$var$initialQueryValue;
    return searchQueryParams || stickySearch || (0, $3K8mq.getInputSkeletonQuery)() || '';
};
const $f82a97b2a0b31328$export$67de3a75cbe82e14 = ({ localQuery: localQuery, inputRef: inputRef })=>{
    // Focus input if skeleton is focused
    (0, $fsvuC.useEffect)(()=>{
        const skeletonFocused = (0, $3K8mq.getInputSkeletonFocus)();
        if (skeletonFocused) {
            const input = inputRef?.current;
            if (input) {
                input.focus();
                input.click();
                const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $3K8mq.getInputSkeletonSelection)();
                input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
            }
        }
        (0, $3K8mq.removeInputSkeletonState)();
    }, [
        inputRef
    ]);
    // Push local query to session storage
    (0, $fsvuC.useEffect)(()=>{
        // Update the module-scoped variable to make it available for remounts
        $f82a97b2a0b31328$var$initialQueryValue = localQuery;
    }, [
        localQuery
    ]);
};

});

parcelRegister("c0fg4", function(module, exports) {
$parcel$export(module.exports, "serveChatConvergenceExperiment", () => $77408549df92d464$export$763430070b25bb55);

var $llCao = parcelRequire("llCao");

var $ageb5 = parcelRequire("ageb5");

var $6mUY0 = parcelRequire("6mUY0");

var $6SoBP = parcelRequire("6SoBP");
const $77408549df92d464$var$CHAT_CONVERGENCE_EXPERIMENT = 'rovo_search_chat_convergence_experiment';
const $77408549df92d464$export$763430070b25bb55 = (primaryProduct, { fireExposure: fireExposure = false } = {})=>{
    const isSearchChatConvergenceProduct = primaryProduct === (0, $6SoBP.PrimaryProductKeys).Confluence;
    if (!isSearchChatConvergenceProduct) return {
        chatIntentDetectionEnabled: false,
        chatSurface: undefined,
        intentDetectionModel: undefined
    };
    const sidebarChatEnabled = (0, $llCao.fg)('rovo_search_chat_convergence_sidebar');
    const floatyChatEnabled = (0, $llCao.fg)('rovo_search_chat_convergence_floaty');
    const floatyBigChatEnabled = (0, $llCao.fg)('rovo_search_chat_convergence_floaty_big');
    const intentModelBChatEnabled = (0, $llCao.fg)('rovo_search_chat_convergence_intent_model_b');
    const newTabChatEnabled = (0, $llCao.fg)('rovo_search_chat_convergence_tab');
    if (newTabChatEnabled) return {
        chatIntentDetectionEnabled: true,
        chatSurface: 'new-tab',
        intentDetectionModel: (0, $ageb5.KnowledgeDiscoverySearchChatIntentDetectionModelVersion).GEMMA3_1B_SCI_V1
    };
    if (sidebarChatEnabled) return {
        chatIntentDetectionEnabled: true,
        chatSurface: 'sidebar',
        intentDetectionModel: (0, $ageb5.KnowledgeDiscoverySearchChatIntentDetectionModelVersion).GEMMA3_1B_SCI_V1
    };
    if (floatyBigChatEnabled) return {
        chatIntentDetectionEnabled: true,
        chatSurface: 'floaty-big',
        intentDetectionModel: (0, $ageb5.KnowledgeDiscoverySearchChatIntentDetectionModelVersion).GEMMA3_1B_SCI_V1
    };
    if (floatyChatEnabled) return {
        chatIntentDetectionEnabled: true,
        chatSurface: 'floaty',
        intentDetectionModel: (0, $ageb5.KnowledgeDiscoverySearchChatIntentDetectionModelVersion).GEMMA3_1B_SCI_V1
    };
    if (intentModelBChatEnabled) return {
        chatIntentDetectionEnabled: true,
        chatSurface: 'floaty',
        intentDetectionModel: (0, $ageb5.KnowledgeDiscoverySearchChatIntentDetectionModelVersion).GEMMA4_E2B_SCI_V1
    };
    const { cohort: cohort } = (0, $6mUY0.getFrontendExperiment)({
        abTestId: $77408549df92d464$var$CHAT_CONVERGENCE_EXPERIMENT,
        fireExperimentExposure: fireExposure
    });
    let chatSurface;
    let intentDetectionModel;
    switch(cohort){
        case 'new-tab':
            chatSurface = 'new-tab';
            intentDetectionModel = (0, $ageb5.KnowledgeDiscoverySearchChatIntentDetectionModelVersion).GEMMA3_1B_SCI_V1;
            break;
        case 'sidebar':
            chatSurface = 'sidebar';
            intentDetectionModel = (0, $ageb5.KnowledgeDiscoverySearchChatIntentDetectionModelVersion).GEMMA3_1B_SCI_V1;
            break;
        case 'floaty-normal':
            chatSurface = 'floaty';
            intentDetectionModel = (0, $ageb5.KnowledgeDiscoverySearchChatIntentDetectionModelVersion).GEMMA3_1B_SCI_V1;
            break;
        case 'floaty-big':
            chatSurface = 'floaty-big';
            intentDetectionModel = (0, $ageb5.KnowledgeDiscoverySearchChatIntentDetectionModelVersion).GEMMA3_1B_SCI_V1;
            break;
        case 'intent-model-b':
            chatSurface = 'floaty';
            intentDetectionModel = (0, $ageb5.KnowledgeDiscoverySearchChatIntentDetectionModelVersion).GEMMA4_E2B_SCI_V1;
            break;
    }
    return {
        chatIntentDetectionEnabled: chatSurface !== undefined,
        chatSurface: chatSurface,
        intentDetectionModel: intentDetectionModel
    };
};

});
parcelRegister("ageb5", function(module, exports) {
$parcel$export(module.exports, "KnowledgeDiscoverySearchChatIntentDetectionModelVersion", () => $ceda089b0662d186$export$54a2bad2d2e20f86);
const $ceda089b0662d186$export$54a2bad2d2e20f86 = {
    GEMMA3_1B_SCI_V1: 'GEMMA3_1B_SCI_V1',
    GEMMA4_E2B_SCI_V1: 'GEMMA4_E2B_SCI_V1'
};

});

parcelRegister("6mUY0", function(module, exports) {
$parcel$export(module.exports, "getFrontendExperiment", () => $258c91d4399df5c9$export$a68238496eb1c8ce);
$parcel$export(module.exports, "createFeatureGateHandler", () => $258c91d4399df5c9$export$8774a01dc80b4a26);
$parcel$export(module.exports, "createFrontendExperimentHandler", () => $258c91d4399df5c9$export$841981a8a1feee8d);
$parcel$export(module.exports, "getMutuallyExclusiveUIExperiment", () => $258c91d4399df5c9$export$b8cc3cdd046fba93);

var $5Y9N2 = parcelRequire("5Y9N2");

var $5nthy = parcelRequire("5nthy");
const $258c91d4399df5c9$export$a68238496eb1c8ce = ({ abTestId: abTestId, onError: onError, fireExperimentExposure: fireExperimentExposure = true })=>{
    try {
        const cohort = (0, $5Y9N2.default).getExperiment(abTestId, {
            fireExperimentExposure: fireExperimentExposure
        }).get('cohort', (0, $5nthy.Cohort).Default);
        const serveExperiment = cohort === (0, $5nthy.Cohort).Test;
        return {
            serveExperiment: serveExperiment,
            abTestId: abTestId,
            cohort: cohort
        };
    } catch (error) {
        onError?.(error);
    }
    return {
        serveExperiment: false,
        abTestId: abTestId,
        cohort: (0, $5nthy.Cohort).Default
    };
};
const $258c91d4399df5c9$export$8774a01dc80b4a26 = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $5Y9N2.default).checkGate('search-experiment-overrides-killswitch')) return $258c91d4399df5c9$var$defaultCheckGate;
    if (!overrides) return $258c91d4399df5c9$var$defaultCheckGate;
    try {
        const gates = overrides.filter((overrides)=>overrides.type === 'gate');
        const getFeatureGate = (name)=>{
            const overrideFeatureGate = gates.find((override)=>'name' in override && override.name === name);
            if (!overrideFeatureGate) return $258c91d4399df5c9$var$defaultCheckGate(name);
            // Overrides always resolve to true as using an override is equivelant to turning FF on.
            return true;
        };
        return getFeatureGate;
    } catch (e) {
        console.error(e);
        return $258c91d4399df5c9$var$defaultCheckGate;
    }
};
const $258c91d4399df5c9$export$841981a8a1feee8d = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $5Y9N2.default).checkGate('search-experiment-overrides-killswitch')) return $258c91d4399df5c9$export$a68238496eb1c8ce;
    if (!overrides) return $258c91d4399df5c9$export$a68238496eb1c8ce;
    try {
        const experiments = overrides.filter((overrides)=>overrides.type === 'experiment');
        const customGetFrontendExperiment = ({ abTestId: abTestId, onError: onError, fireExperimentExposure: fireExperimentExposure })=>{
            const overrideFrontendExperiment = experiments.find((override)=>'name' in override && override.name === abTestId);
            if (!overrideFrontendExperiment) return $258c91d4399df5c9$export$a68238496eb1c8ce({
                abTestId: abTestId,
                onError: onError,
                fireExperimentExposure: fireExperimentExposure
            });
            return {
                abTestId: abTestId,
                serveExperiment: true,
                cohort: 'cohort' in overrideFrontendExperiment ? overrideFrontendExperiment.cohort : (0, $5nthy.Cohort).Test
            };
        };
        return customGetFrontendExperiment;
    } catch (e) {
        console.error(e);
        return $258c91d4399df5c9$export$a68238496eb1c8ce;
    }
};
// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
const $258c91d4399df5c9$var$defaultCheckGate = (name)=>(0, $5Y9N2.default).checkGate(name);
const $258c91d4399df5c9$export$b8cc3cdd046fba93 = (uiExperimentName, layerName, options = {
    fireLayerExposure: true
})=>{
    const layer = (0, $5Y9N2.default).getLayer(layerName, {
        fireLayerExposure: false
    });
    const frontendExperimentName = layer.get('frontendExperimentName', '');
    if (frontendExperimentName === uiExperimentName) return (0, $5Y9N2.default).getLayer(layerName, options);
    return undefined;
};

});
parcelRegister("5nthy", function(module, exports) {
$parcel$export(module.exports, "Cohort", () => $67c6fe4e5c99696b$export$b76685d1b5a37732);
var $67c6fe4e5c99696b$export$b76685d1b5a37732 = /*#__PURE__*/ function(Cohort) {
    Cohort["Default"] = "not-enrolled";
    Cohort["Control"] = "control";
    Cohort["Test"] = "test";
    return Cohort;
}({});

});


parcelRegister("6SoBP", function(module, exports) {
$parcel$export(module.exports, "PrimaryProductKeys", () => $eb8af19343be2f57$export$15d12effc8830544);
const $eb8af19343be2f57$export$15d12effc8830544 = {
    // Fully supported as GA
    Atlas: 'townsquare',
    Confluence: 'confluence',
    // In development
    Assets: 'cmdb',
    Focus: 'mercury',
    Jira: 'jira',
    Elevate: 'elevate',
    Talent: 'radar',
    RovoExtension: 'rovo-extension',
    Loom: 'loom'
};

});


parcelRegister("d8mEj", function(module, exports) {
$parcel$export(module.exports, "GhostTextExperimentCohort", () => $33305782b0434b1f$export$6891b88a23696d);
$parcel$export(module.exports, "ROTATION_THRESHOLD", () => $33305782b0434b1f$export$73fd7fc6fed7f9d9);
$parcel$export(module.exports, "parseGhostTextData", () => $33305782b0434b1f$export$bd8829925eef3cc2);

var $6c5Mm = parcelRequire("6c5Mm");
var $33305782b0434b1f$export$6891b88a23696d = /*#__PURE__*/ function(GhostTextExperimentCohort) {
    GhostTextExperimentCohort["CONTROL"] = "control";
    GhostTextExperimentCohort["THREE_P"] = "3p";
    return GhostTextExperimentCohort;
}({});
const $33305782b0434b1f$export$73fd7fc6fed7f9d9 = 3;
const $33305782b0434b1f$export$bd8829925eef3cc2 = (customPlaceholder)=>{
    if (!customPlaceholder) return undefined;
    try {
        const result = (0, $6c5Mm.GhostTextDataV2Schema).safeParse(JSON.parse(customPlaceholder));
        if (result.success) return result.data;
        return undefined;
    } catch  {
        return undefined;
    }
};

});
parcelRegister("6c5Mm", function(module, exports) {
$parcel$export(module.exports, "GhostTextDataV2Schema", () => $cfd7c9894cffc31f$export$9bcc9fe305679f00);
parcelRequire("czlIv");
var $g3khG = parcelRequire("g3khG");
const $cfd7c9894cffc31f$export$9bcc9fe305679f00 = (0, $g3khG).object({
    /** Unique key identifying the current ghost text set */ id: (0, $g3khG).string(),
    /** Locale of the ghost text */ locale: (0, $g3khG).string(),
    /** The placeholder text to display */ text: (0, $g3khG).string(),
    /** Number of times this text has been shown (0-2, resets after 3) */ occurrence: (0, $g3khG).number().optional().default(0)
});

});


parcelRegister("a2bib", function(module, exports) {
$parcel$export(module.exports, "messages", () => $5202036b926eb87b$export$defe85febe8b728c);

var $54F37 = parcelRequire("54F37");
const $5202036b926eb87b$export$defe85febe8b728c = (0, $54F37.defineMessages)({
    placeholder: {
        id: 'search_dialog_aria_label',
        defaultMessage: 'Search',
        description: 'Placeholder text in primary search input'
    }
});

});


parcelRegister("dhKSr", function(module, exports) {
$parcel$export(module.exports, "ProductSearchInputSkeletonInteractive", () => $b861d6ffbe2bc8e5$export$e3798ad624b9f761);
/*
 * An interactive version of the search input skeleton which allows users to
 * type into the skeleton's input.  The state of the skeleton input is saved in
 * the browser's storage (specifically within window.inputSkeletonState).
 * On the first render of this component, this stored state is used as initial
 * an initial state. This behaviour allows one instance of this component
 * to be replaced by another and appear to seamlessly act as a single component.
 *
 * This component is intended to be used for client side rendering only.
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $jpvVF = parcelRequire("jpvVF");

var $3osL0 = parcelRequire("3osL0");
const $b861d6ffbe2bc8e5$export$e3798ad624b9f761 = (props)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3osL0.ThemeProvider), {
        partialSearchCSS: props.theme,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $jpvVF.SearchInputSkeletonInteractive), {
            ...props
        })
    });
};
$b861d6ffbe2bc8e5$export$e3798ad624b9f761.displayName = "ProductSearchInputSkeletonInteractive";

});
parcelRegister("jpvVF", function(module, exports) {
$parcel$export(module.exports, "SearchInputSkeletonInteractive", () => $d1b8b21fadfa9f5d$export$fca483ab36e9fec9);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $8y1wd = parcelRequire("8y1wd");

var $3K8mq = parcelRequire("3K8mq");

var $1aZfF = parcelRequire("1aZfF");

var $9h9gi = parcelRequire("9h9gi");
const $d1b8b21fadfa9f5d$export$fca483ab36e9fec9 = ({ placeholder: placeholder, stickySearchEnabled: stickySearchEnabled, onEnter: onEnter, shouldFillContainer: shouldFillContainer })=>{
    // Initialise stored inputSkeletonState if necessary
    const checkedForInputSkeletonState = (0, $fsvuC.useRef)(false);
    if (!checkedForInputSkeletonState.current) {
        if (!window.inputSkeletonState) (0, $3K8mq.resetInputSkeletonState)();
        checkedForInputSkeletonState.current = true;
    }
    const searchInputRef = (0, $fsvuC.useRef)(null);
    // Use the stored state as initial values for expansion and query
    const [isExpanded, setIsExpanded] = (0, $fsvuC.useState)((0, $3K8mq.getInputSkeletonFocus)());
    const [value, setValue] = (0, $fsvuC.useState)(()=>{
        const stickySearchQuery = (0, $9h9gi.getSessionItem)((0, $9h9gi.SEARCH_QUERY_KEY));
        return stickySearchEnabled && stickySearchQuery ? stickySearchQuery : (0, $3K8mq.getInputSkeletonQuery)();
    });
    // Use the stored state to focus and set selection
    (0, $fsvuC.useLayoutEffect)(()=>{
        (0, $3K8mq.removeInputSkeletonEventListeners)();
        const isFoucsed = (0, $3K8mq.getInputSkeletonFocus)();
        const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $3K8mq.getInputSkeletonSelection)();
        if (isFoucsed) {
            searchInputRef?.current?.focus();
            searchInputRef?.current?.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
        }
    }, []);
    const onFocus = ()=>{
        setIsExpanded(true);
        (0, $3K8mq.setInputSkeletonIsFocus)(true);
        searchInputRef?.current?.focus();
    };
    const onBlur = ()=>{
        setIsExpanded(false);
        (0, $3K8mq.setInputSkeletonIsFocus)(false);
        if (!stickySearchEnabled) {
            setValue('');
            (0, $3K8mq.setInputSkeletonQuery)('');
            (0, $3K8mq.setInputSkeletonSelection)(0, 0, 'none');
        }
    };
    const onKeyDown = (e)=>{
        if (e.key === 'Escape') {
            searchInputRef?.current?.blur();
            onBlur();
        }
    };
    const onInput = (newValue)=>{
        setValue(newValue);
        (0, $3K8mq.setInputSkeletonQuery)(newValue);
        (0, $3K8mq.setInputSkeletonSelection)(searchInputRef?.current?.selectionStart || 0, searchInputRef?.current?.selectionEnd || 0, searchInputRef?.current?.selectionDirection || 'none');
        if (stickySearchEnabled) (0, $9h9gi.setSessionItem)((0, $9h9gi.SEARCH_QUERY_KEY), newValue);
    };
    const onSelect = ()=>{
        (0, $3K8mq.setInputSkeletonSelection)(searchInputRef?.current?.selectionStart || 0, searchInputRef?.current?.selectionEnd || 0, searchInputRef?.current?.selectionDirection || 'none');
    };
    // Fixes some instances where callbacks would not be called when the search
    // input is clicked as the component is being destroyed
    (0, $fsvuC.useEffect)(()=>{
        let storedSearchInputRef = null;
        if (searchInputRef.current) storedSearchInputRef = searchInputRef.current;
        return ()=>{
            if (storedSearchInputRef) {
                (0, $3K8mq.setInputSkeletonQuery)(storedSearchInputRef.value);
                (0, $3K8mq.setInputSkeletonIsFocus)(document.activeElement === storedSearchInputRef);
                (0, $3K8mq.setInputSkeletonSelection)(storedSearchInputRef.selectionStart || 0, storedSearchInputRef.selectionEnd || 0, storedSearchInputRef.selectionDirection || 'none');
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $8y1wd.SearchAnchor), {
        isExpanded: isExpanded,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $1aZfF.default), {
            "data-test-id": "search-dialog-input-skeleton-interactive",
            isExpanded: isExpanded,
            placeholder: placeholder,
            onInput: onInput,
            onSelect: onSelect,
            onEnter: onEnter,
            shouldFillContainer: shouldFillContainer,
            value: value,
            ref: searchInputRef
        })
    });
};
$d1b8b21fadfa9f5d$export$fca483ab36e9fec9.displayName = "SearchInputSkeletonInteractive";

});
parcelRegister("8y1wd", function(module, exports) {
$parcel$export(module.exports, "SearchAnchor", () => $7821eb43ca114b36$export$bc951697710bb35a);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $6XYj7 = parcelRequire("6XYj7");

var $feJ2F = parcelRequire("feJ2F");

var $23sWr = parcelRequire("23sWr");
const $7821eb43ca114b36$export$bc951697710bb35a = ({ children: children, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, isExpanded: isExpanded, shouldFillContainer: shouldFillContainer })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $feJ2F.SearchAnchorWrapper), {
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $6XYj7.AbsoluteContainer), {
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $23sWr.SearchDialogAnchor), {
                onBlur: onBlur,
                onFocus: onFocus,
                onKeyDown: onKeyDown,
                isExpanded: isExpanded,
                shouldFillContainer: shouldFillContainer,
                children: children
            })
        })
    });
$7821eb43ca114b36$export$bc951697710bb35a.displayName = "SearchAnchor";

});
parcelRegister("6XYj7", function(module, exports) {
$parcel$export(module.exports, "AbsoluteContainer", () => $6363cfc72e4084d6$export$36aa0f4a98890c96);

var $h2YWL = parcelRequire("h2YWL");

var $1f0Lc = parcelRequire("1f0Lc");

var $2CNTZ = parcelRequire("2CNTZ");
const $6363cfc72e4084d6$export$36aa0f4a98890c96 = /*#__PURE__*/ (0, $2CNTZ.default)('div', {
    target: "ed6gqfz0"
})("", (props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $h2YWL.css)({
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        ...props.shouldFillContainer && {
            left: 0
        },
        right: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $1f0Lc.zIndex).searchDialog
    });
    return {};
});

});
parcelRegister("1f0Lc", function(module, exports) {
$parcel$export(module.exports, "zIndex", () => $c05f0afd7df6a6d3$export$56446adcecbeec34);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-atlaskit-theme

var $QrsDO = parcelRequire("QrsDO");
const $c05f0afd7df6a6d3$export$56446adcecbeec34 = {
    searchDialog: (0, $QrsDO.layers).dialog()
};

});


parcelRegister("feJ2F", function(module, exports) {
$parcel$export(module.exports, "SearchAnchorWrapper", () => $299357278b161864$export$dfece74a62f1398d);

var $8RYVL = parcelRequire("8RYVL");

var $2CNTZ = parcelRequire("2CNTZ");
const $299357278b161864$export$dfece74a62f1398d = /*#__PURE__*/ (0, $2CNTZ.default)("div", {
    target: "e1g6liaa0"
})("position:relative;@media screen and (min-width: ", (0, $8RYVL.dialogPageTakeoverWidth) + 1, "px){", (props)=>props.shouldFillContainer ? 'width: 100%;' : 'min-width: 200px;', ";}", (props)=>props.shouldFillContainer ? 'max-width: 780px;' : '', " width:", (0, $8RYVL.inputFieldHeight).px, ";height:", (0, $8RYVL.inputFieldHeight).px, ";");

});
parcelRegister("8RYVL", function(module, exports) {
$parcel$export(module.exports, "grid", () => $f861f776fd6dbea4$export$85fc379452d91af0);
$parcel$export(module.exports, "atlassianNavigationHeight", () => $f861f776fd6dbea4$export$b9930dabfa4a3a3);
$parcel$export(module.exports, "collapsedSearchInputWidth", () => $f861f776fd6dbea4$export$f6af7620e8789c39);
$parcel$export(module.exports, "dialogWidth", () => $f861f776fd6dbea4$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogPageTakeoverWidth", () => $f861f776fd6dbea4$export$ce4512df260a325a);
$parcel$export(module.exports, "dialogPageCentreWidth", () => $f861f776fd6dbea4$export$a406031ed42c8e02);
$parcel$export(module.exports, "inputFieldHeight", () => $f861f776fd6dbea4$export$e00021bea368c518);
$parcel$export(module.exports, "enlargedInputFieldHeight", () => $f861f776fd6dbea4$export$30310ee354b45eb0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line no-barrel-files/no-barrel-files






const $f861f776fd6dbea4$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$f861f776fd6dbea4$var$AkGrid(multiplier * num),
        half: ()=>$f861f776fd6dbea4$var$AkGrid(0.5 * num),
        twice: ()=>$f861f776fd6dbea4$var$AkGrid(2 * num)
    });
const $f861f776fd6dbea4$export$85fc379452d91af0 = $f861f776fd6dbea4$var$AkGrid(1);
const $f861f776fd6dbea4$export$b9930dabfa4a3a3 = '56px';
const $f861f776fd6dbea4$export$f6af7620e8789c39 = '200px';
const $f861f776fd6dbea4$export$64d8573e83b64ff8 = '150px';
const $f861f776fd6dbea4$export$a3da89b899389ed8 = '780px';
const $f861f776fd6dbea4$export$ce4512df260a325a = 780;
const $f861f776fd6dbea4$export$a406031ed42c8e02 = '1130px';
const $f861f776fd6dbea4$export$e00021bea368c518 = $f861f776fd6dbea4$export$85fc379452d91af0.multiple(4);
const $f861f776fd6dbea4$export$30310ee354b45eb0 = $f861f776fd6dbea4$export$85fc379452d91af0.multiple(6);

});


parcelRegister("23sWr", function(module, exports) {
$parcel$export(module.exports, "SearchDialogAnchor", () => $f36b11ee66506966$export$f565ce1043dae7c9);
$parcel$export(module.exports, "EnlargedSearchAnchorWrapper", () => $f36b11ee66506966$export$5566658d36f6ca7b);

var $h2YWL = parcelRequire("h2YWL");

var $8RYVL = parcelRequire("8RYVL");

var $1f0Lc = parcelRequire("1f0Lc");

var $feJ2F = parcelRequire("feJ2F");

var $2CNTZ = parcelRequire("2CNTZ");

const $f36b11ee66506966$export$f565ce1043dae7c9 = /*#__PURE__*/ (0, $2CNTZ.default)('div', {
    target: "exl9bxq1"
})("position:relative;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $h2YWL.css)("@media screen and (max-width: ", (0, $8RYVL.dialogPageCentreWidth), "){ position:", props.shouldFillContainer ? 'static' : 'fixed', "; z-index:", (0, $1f0Lc.zIndex).searchDialog, ";left:calc((100% - ", (0, $8RYVL.dialogWidth), ") / 2);;}@media screen and (max-width: ", (0, $8RYVL.dialogPageTakeoverWidth), "px){ ", props.shouldFillContainer && 'position: fixed;', ";top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column;overflow:auto;}");
    return {};
});
const $f36b11ee66506966$export$5566658d36f6ca7b = /*#__PURE__*/ (0, $2CNTZ.default)((0, $feJ2F.SearchAnchorWrapper), {
    target: "exl9bxq0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        height: props.isExpanded ? (0, $8RYVL.enlargedInputFieldHeight).px : (0, $8RYVL.inputFieldHeight).px
    }));

});


parcelRegister("1aZfF", function(module, exports) {
$parcel$export(module.exports, "default", () => $875d139103245fef$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $kfsyS = parcelRequire("kfsyS");

var $3Zxrq = parcelRequire("3Zxrq");

var $llCao = parcelRequire("llCao");

var $3Kmf8 = parcelRequire("3Kmf8");

var $gDtLG = parcelRequire("gDtLG");

var $3osL0 = parcelRequire("3osL0");

var $6wKET = parcelRequire("6wKET");

var $cCnm6 = parcelRequire("cCnm6");

var $DUAKW = parcelRequire("DUAKW");

var $3pxxx = parcelRequire("3pxxx");
const $875d139103245fef$var$MAX_INPUT_LENGTH = 500;
const $875d139103245fef$export$55d7609a8f1eccd2 = ({ onInput: onInput, onClick: onClick, onEnter: onEnter, isExpanded: isExpanded, placeholder: placeholder, forwardRef: forwardRef, value: value, theme: theme, tooltipContent: tooltipContent, onBack: onBack, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, exitSearchLabel: exitSearchLabel, clearSearchLabel: clearSearchLabel, onSelect: onSelect, toggleAISearchButton: toggleAISearchButton, shouldFillContainer: shouldFillContainer, disableBoxShadow: disableBoxShadow, ariaLabelContent: ariaLabelContent })=>{
    const handleInput = (e)=>{
        if (onInput) onInput(e.currentTarget.value);
    };
    const handleClick = (e)=>{
        if (onClick) onClick(e);
    };
    const handleTabEnter = (e)=>{
        if (e.key === 'Enter' && onClick) onClick();
    };
    const handleKeyDown = (e)=>{
        if (e.nativeEvent?.isComposing || e.keyCode === 229) return;
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
    };
    const handleSelect = (e)=>{
        if (onSelect) onSelect(e);
    };
    const TooltipComponent = tooltipContent && !isExpanded ? undefined : (0, $cCnm6.HiddenTooltip);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3Kmf8.default), {
        // `HiddenTooltip` hides the popup but still renders it. The top-layer tooltip puts
        // role="tooltip" on its own host, which `HiddenTooltip` can't hide, so pass no content.
        content: TooltipComponent && (0, $llCao.fg)('platform-dst-top-layer-tooltip') ? undefined : tooltipContent,
        // NOTE: Types in React 18 have changed, `styled(TooltipPrimitive)` is no longer valid
        component: TooltipComponent,
        position: "bottom",
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $3pxxx.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $3pxxx.MobileSearchIconWrapper), {
                    isExpanded: isExpanded,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kfsyS.default), {
                        label: "Search",
                        onClick: handleClick,
                        icon: ()=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $gDtLG.SearchIcon), {
                                theme: theme,
                                isExpanded: isExpanded
                            })
                    })
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $3pxxx.DesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: isExpanded,
                    onKeyPress: handleTabEnter,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $gDtLG.SearchIcon), {
                        theme: theme,
                        isExpanded: isExpanded
                    })
                }),
                isExpanded && /*#__PURE__*/ (0, $5chsV.jsx)((0, $6wKET.ArrowIconWrapper), {
                    ...theme,
                    onClick: onBack,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Zxrq))), {
                        label: exitSearchLabel || 'Exit Search',
                        color: "currentColor"
                    })
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $3pxxx.SearchInputField), {
                    "data-test-id": "search-dialog-input",
                    onInput: handleInput,
                    onChange: handleInput,
                    onKeyDown: handleKeyDown,
                    onClick: handleClick,
                    onSelect: handleSelect,
                    isExpanded: isExpanded,
                    placeholder: placeholder,
                    ref: forwardRef || undefined,
                    value: value,
                    maxLength: $875d139103245fef$var$MAX_INPUT_LENGTH,
                    "aria-label": ariaLabelContent || placeholder,
                    ...disableBoxShadow && {
                        style: {
                            boxShadow: 'none'
                        }
                    },
                    ...theme
                }),
                (showClearButton || !!toggleAISearchButton) && /*#__PURE__*/ (0, $5chsV.jsx)((0, $DUAKW.SearchInputOverlay), {
                    theme: theme,
                    showClearButton: showClearButton,
                    onClear: onClear,
                    allowChangeExpand: allowChangeExpand,
                    clearSearchLabel: clearSearchLabel,
                    toggleAISearchButton: toggleAISearchButton
                })
            ]
        })
    });
};
$875d139103245fef$export$55d7609a8f1eccd2.displayName = "SearchInput";
const $875d139103245fef$var$SearchInputWithTheme = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).forwardRef((props, ref)=>{
    const theme = (0, $3osL0.useTheme)();
    return /*#__PURE__*/ (0, $5chsV.jsx)($875d139103245fef$export$55d7609a8f1eccd2, {
        ...props,
        theme: theme,
        forwardRef: ref
    });
});
$875d139103245fef$var$SearchInputWithTheme.displayName = 'SearchInput';
var $875d139103245fef$export$2e2bcd8739ae039 = $875d139103245fef$var$SearchInputWithTheme;

});
parcelRegister("gDtLG", function(module, exports) {
$parcel$export(module.exports, "SearchIcon", () => $5ad7508bdba20d2d$export$82eafebb825fc23f);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $edN4B = parcelRequire("edN4B");
const $5ad7508bdba20d2d$export$82eafebb825fc23f = ({ isExpanded: isExpanded, theme: theme, primaryColor: primaryColor = "var(--ds-text, #292A2E)", label: label = '' })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($edN4B))), {
        label: label,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : theme.default.color
    });
$5ad7508bdba20d2d$export$82eafebb825fc23f.displayName = "SearchIcon";

});

parcelRegister("3osL0", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $125b0a781025a2f0$export$d8964aec282183a3);
$parcel$export(module.exports, "useTheme", () => $125b0a781025a2f0$export$93d4e7f90805808f);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $jo5KC = parcelRequire("jo5KC");
/**
 * Pls see the function generateTheme inside - atlassian-frontend/packages/navigation/atlassian-navigation/src/theme/themeGenerator.ts
 * This default generator should overwrite the exact same properties which are being produced by the theme generator.
 */ const $125b0a781025a2f0$export$e6c62eb05a8288ed = {
    default: {
        default: {
            backgroundColor: "var(--ds-background-input, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)",
            borderColor: "var(--ds-border-input, #8C8F97)",
            borderWidth: "var(--ds-border-width, 1px)",
            iconColor: "var(--ds-icon-subtle, #505258)"
        },
        focus: {
            borderColor: "var(--ds-border-focused, #4688EC)",
            backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-input, #8C8F97)"}`
        },
        hover: {
            backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
        }
    }
};
const $125b0a781025a2f0$var$getTheme = (searchCSS)=>{
    if (!searchCSS) return $125b0a781025a2f0$export$e6c62eb05a8288ed.default;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))({}, $125b0a781025a2f0$export$e6c62eb05a8288ed.default, searchCSS);
};
const $125b0a781025a2f0$var$ctx = /*#__PURE__*/ (0, $fsvuC.createContext)($125b0a781025a2f0$export$e6c62eb05a8288ed.default);
const $125b0a781025a2f0$export$d8964aec282183a3 = ({ value: value, partialSearchCSS: partialSearchCSS, children: children })=>{
    const theme = $125b0a781025a2f0$var$getTheme(partialSearchCSS || value);
    return /*#__PURE__*/ (0, $5chsV.jsx)($125b0a781025a2f0$var$ctx.Provider, {
        value: theme,
        children: children
    });
};
$125b0a781025a2f0$export$d8964aec282183a3.displayName = "ThemeProvider";
const $125b0a781025a2f0$export$93d4e7f90805808f = ()=>{
    return (0, $fsvuC.useContext)($125b0a781025a2f0$var$ctx);
};
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $125b0a781025a2f0$export$f9bb738f552c610d = $125b0a781025a2f0$var$ctx;
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $125b0a781025a2f0$export$62640b580a501775 = (suppliedTheme)=>{
    return suppliedTheme;
};

});

parcelRegister("6wKET", function(module, exports) {
$parcel$export(module.exports, "ArrowIconWrapper", () => $772ff5696c582906$export$54c466678ae7c638);

var $8RYVL = parcelRequire("8RYVL");

var $2CNTZ = parcelRequire("2CNTZ");
const $772ff5696c582906$export$54c466678ae7c638 = /*#__PURE__*/ (0, $2CNTZ.default)('div', {
    target: "eseem520"
})("display:none;margin:0 ", (0, $8RYVL.grid).px, ";height:", (0, $8RYVL.grid).multiple(4).px, ";padding-bottom:", (0, $8RYVL.grid).multiple(0.25).px, ";color:", (props)=>props.default.color, ";@media screen and (max-width: ", (0, $8RYVL.dialogPageTakeoverWidth), "px){display:flex;align-items:center;}:hover{border-radius:var(--ds-radius-full, 9999px);background-color:", (props)=>props.hover.backgroundColor, ";color:", (props)=>props.hover.color, ";}");

});

parcelRegister("cCnm6", function(module, exports) {
$parcel$export(module.exports, "HiddenTooltip", () => $37db87fc8decfbbe$export$ca6fe3402791d08e);

var $i92dJ = parcelRequire("i92dJ");

var $2CNTZ = parcelRequire("2CNTZ");
function $37db87fc8decfbbe$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $37db87fc8decfbbe$export$ca6fe3402791d08e = /*#__PURE__*/ (0, $2CNTZ.default)((0, $i92dJ.default), {
    target: "e1rbdgxr0"
})({
    name: "eivff4",
    styles: "display:none"
});

});

parcelRegister("DUAKW", function(module, exports) {
$parcel$export(module.exports, "SearchInputOverlay", () => $e396242f4cfe66d7$export$bde709da22d710bb);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gUoEG = parcelRequire("gUoEG");

var $9msSe = parcelRequire("9msSe");

var $1097q = parcelRequire("1097q");
const $e396242f4cfe66d7$export$bde709da22d710bb = ({ theme: theme, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, clearSearchLabel: clearSearchLabel, toggleAISearchButton: toggleAISearchButton })=>{
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $1097q.InputBoxOverlayRight), {
        children: [
            showClearButton && /*#__PURE__*/ (0, $5chsV.jsx)((0, $9msSe.ClearIconWrapper), {
                ...theme,
                role: "button",
                onClick: onClear,
                onMouseEnter: ()=>{
                    allowChangeExpand?.(false);
                },
                onMouseLeave: ()=>{
                    allowChangeExpand?.(true);
                },
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gUoEG))), {
                    color: "currentColor",
                    label: clearSearchLabel || 'Clear search session'
                })
            }),
            toggleAISearchButton
        ]
    });
};
$e396242f4cfe66d7$export$bde709da22d710bb.displayName = "SearchInputOverlay";

});
parcelRegister("9msSe", function(module, exports) {
$parcel$export(module.exports, "ClearIconWrapper", () => $3a917351f01a3841$export$ff9b1a25d343474d);

var $8RYVL = parcelRequire("8RYVL");

var $2CNTZ = parcelRequire("2CNTZ");
const $3a917351f01a3841$export$ff9b1a25d343474d = /*#__PURE__*/ (0, $2CNTZ.default)('div', {
    target: "egczgaz0"
})("width:", (0, $8RYVL.grid).multiple(2).px, ";height:", (0, $8RYVL.grid).multiple(2).px, ";padding:5px var(--ds-space-075, 6px);color:var(--ds-text-subtlest, #6B6E76);background-color:transparent;@media screen and (max-width: ", (0, $8RYVL.dialogPageTakeoverWidth), "px){display:none;}:hover{cursor:pointer;color:var(--ds-icon, #292A2E);}&>span>svg{vertical-align:unset;}");

});

parcelRegister("1097q", function(module, exports) {
$parcel$export(module.exports, "InputBoxOverlayRight", () => $993aa088e929896e$export$1da38d078e896a10);

var $8RYVL = parcelRequire("8RYVL");

var $2CNTZ = parcelRequire("2CNTZ");
const $993aa088e929896e$export$1da38d078e896a10 = /*#__PURE__*/ (0, $2CNTZ.default)('div', {
    target: "eq5o9i0"
})("position:absolute;display:flex;top:0;right:0;height:100%;align-items:center;margin:auto 0;@media screen and (max-width: ", (0, $8RYVL.dialogPageTakeoverWidth), "px){right:24px;}");

});


parcelRegister("3pxxx", function(module, exports) {
$parcel$export(module.exports, "MobileSearchIconWrapper", () => $35f674ab21c9af00$export$63e083aca343a6ae);
$parcel$export(module.exports, "DesktopSearchIconWrapper", () => $35f674ab21c9af00$export$9673cb6b61244e6e);
$parcel$export(module.exports, "SearchInputContainer", () => $35f674ab21c9af00$export$c2b37b18a8b54130);
$parcel$export(module.exports, "SearchInputField", () => $35f674ab21c9af00$export$b6261a2c5ea449d);

var $h2YWL = parcelRequire("h2YWL");

var $hH7WA = parcelRequire("hH7WA");

var $8RYVL = parcelRequire("8RYVL");

var $2CNTZ = parcelRequire("2CNTZ");










function $35f674ab21c9af00$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $35f674ab21c9af00$var$expandedPlaceholderColor = "var(--ds-text-subtlest, #6B6E76)";
const $35f674ab21c9af00$export$63e083aca343a6ae = /*#__PURE__*/ (0, $2CNTZ.default)("span", {
    target: "eq4kchp3"
})("display:none;@media screen and (max-width: ", (0, $8RYVL.dialogPageTakeoverWidth), "px){display:", (props)=>props.isExpanded ? 'none' : 'block', ";}");
const $35f674ab21c9af00$export$9673cb6b61244e6e = /*#__PURE__*/ (0, $2CNTZ.default)('span', {
    target: "eq4kchp2"
})("width:", (0, $8RYVL.grid).multiple(2).px, ";height:", (0, $8RYVL.grid).multiple(2).px, ";position:absolute;top:", (0, $8RYVL.grid).px, ";left:", (0, $8RYVL.grid).px, ";color:", (props)=>props.isExpanded ? "var(--ds-text, #292A2E)" : props.default.color, ";display:inline-flex;align-items:baseline;:focus{box-shadow:0 0 0 2px var(--ds-border-focused, #4688EC);border-radius:var(--ds-radius-full, 9999px);outline:none;}&>span[role='img']{line-height:0;}@media screen and (max-width: ", (0, $8RYVL.dialogPageTakeoverWidth), "px){display:none;}");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $35f674ab21c9af00$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $35f674ab21c9af00$export$c2b37b18a8b54130 = /*#__PURE__*/ (0, $2CNTZ.default)('div', {
    target: "eq4kchp1"
})(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $h2YWL.css)("position:relative;max-width:100%; @media screen and (max-width: ", (0, $8RYVL.dialogPageTakeoverWidth), "px){ width:100%;}"), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const boundedStyles = /*#__PURE__*/ (0, $h2YWL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        width: props.isExpanded ? (0, $8RYVL.dialogWidth) : (0, $8RYVL.collapsedSearchInputWidth)
    });
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const fluidStyles = $35f674ab21c9af00$var$_ref;
    const styles = props.shouldFillContainer ? fluidStyles : boundedStyles;
    // todo - this should be another class
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $h2YWL.css)(styles, " @media screen and (max-width: ", (0, $8RYVL.dialogPageTakeoverWidth), "px){width:100%;height:", (0, $8RYVL.atlassianNavigationHeight), ";background-color:", props.default.backgroundColor, "; display:flex;align-items:center;max-width:initial;}");
    return styles;
});
const $35f674ab21c9af00$export$b6261a2c5ea449d = /*#__PURE__*/ (0, $2CNTZ.default)("input", {
    target: "eq4kchp0"
})("height:", (0, $8RYVL.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:var(--ds-radius-medium, 6px);/* Refer to @atlaskit/textfield for more details */font:var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);", (props)=>`
    border: ${"var(--ds-border-width, 1px)"} solid ${props.isExpanded ? props.focus.borderColor : props.default.borderColor};
    box-shadow: ${props.isExpanded ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${props.focus.borderColor}, -12px 0 24px 0 ${props.default.backgroundColor}` : 'none'};
    background-color: ${props.isExpanded ? props.focus.backgroundColor : props.default.backgroundColor};
    color: ${props.isExpanded ? props.focus.color : props.default.color};

    &::placeholder {
      color: ${props.isExpanded ? $35f674ab21c9af00$var$expandedPlaceholderColor : props.default.color};
    }
    :focus {
      border: ${"var(--ds-border-width, 1px)"} solid ${props.focus.borderColor};
    }
    @media screen and (max-width: ${0, $8RYVL.dialogPageTakeoverWidth}px) {
      ${props.isExpanded ? `
            padding: 0 ${(0, $8RYVL.grid).multiple(1.5).px} ${(0, $8RYVL.grid).multiple(0.25).px};
            margin: 0 ${(0, $8RYVL.grid).multiple(3).px} 0 0;` : `
            display: none;
          `}
    }
  `, " ", (0, $hH7WA.media).above.xs, "{font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);}");

});




parcelRegister("azfax", function(module, exports) {
$parcel$export(module.exports, "nowrapEllipsis", () => $e34475aa156daed4$export$b6b16ffe83ef4b56);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $e34475aa156daed4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e34475aa156daed4$export$b6b16ffe83ef4b56 = {
    name: "sqm42b",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};

});

parcelRegister("lmgoG", function(module, exports) {
$parcel$export(module.exports, "SSRsearchInputField", () => $d6a94682731e4c64$export$6d53dccb772ed720);

var $8RYVL = parcelRequire("8RYVL");

var $2CNTZ = parcelRequire("2CNTZ");
const $d6a94682731e4c64$export$6d53dccb772ed720 = /*#__PURE__*/ (0, $2CNTZ.default)('input', {
    target: "e1tlzr8c0"
})("height:", (0, $8RYVL.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:var(--ds-radius-medium, 6px);font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);border:", ()=>`${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-input, #8C8F97)"}`, ";background-color:var(--ds-background-input, #FFFFFF);color:var(--ds-text-subtlest, #6B6E76);:hover{background-color:var(--ds-background-input-hovered, #F8F8F8);}:focus{color:var(--ds-text, #292A2E);box-shadow:", ()=>`inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-input, #8C8F97)"}`, ";}@media screen and (max-width: ", (0, $8RYVL.dialogPageTakeoverWidth), "px){display:none;}");

});

parcelRegister("7okh0", function(module, exports) {
$parcel$export(module.exports, "SSRsearchInputWrapper", () => $65cfd2b41f9109bc$export$c47d4a3e1f1297f1);

var $2CNTZ = parcelRequire("2CNTZ");
const $65cfd2b41f9109bc$export$c47d4a3e1f1297f1 = /*#__PURE__*/ (0, $2CNTZ.default)('div', {
    target: "e4ak8mg0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
(props)=>({
        position: 'relative',
        height: '32px',
        '@media screen and (min-width: 781px)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            minWidth: props.shouldFillContainer ? '100%' : '200px'
        }
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
(props)=>props.shouldFillContainer ? 'width: 100%;' : '');

});

parcelRegister("lHAxP", function(module, exports) {
$parcel$export(module.exports, "SSRformContainer", () => $7e54cfa5d3328228$export$58ae19ee1fc7be8a);

var $2CNTZ = parcelRequire("2CNTZ");
function $7e54cfa5d3328228$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7e54cfa5d3328228$export$58ae19ee1fc7be8a = /*#__PURE__*/ (0, $2CNTZ.default)('div', {
    target: "ehrlot50"
})({
    name: "bjn8wh",
    styles: "position:relative"
});

});

parcelRegister("7jPIn", function(module, exports) {
$parcel$export(module.exports, "SSRsearchInputContainer", () => $8d1db2d4eb6319fe$export$b40f2abde293e8e4);

var $8RYVL = parcelRequire("8RYVL");

var $2CNTZ = parcelRequire("2CNTZ");
const $8d1db2d4eb6319fe$export$b40f2abde293e8e4 = /*#__PURE__*/ (0, $2CNTZ.default)('div', {
    target: "e1rxq6i70"
})("position:relative;max-width:100%;@media screen and (max-width: ", (0, $8RYVL.dialogPageTakeoverWidth), "px){width:100%;}width:", (props)=>{
    if (props.shouldFillContainer) return '100%';
    return 0, $8RYVL.collapsedSearchInputWidth;
}, ";");

});

parcelRegister("eDzIF", function(module, exports) {
$parcel$export(module.exports, "SSRdesktopSearchIconWrapper", () => $ee36433ac4ebf03a$export$eb4e9f55bbe045df);

var $8RYVL = parcelRequire("8RYVL");

var $2CNTZ = parcelRequire("2CNTZ");
const $ee36433ac4ebf03a$export$eb4e9f55bbe045df = /*#__PURE__*/ (0, $2CNTZ.default)('span', {
    target: "ex7lok0"
})("width:", (0, $8RYVL.grid).multiple(2).px, ";height:", (0, $8RYVL.grid).multiple(2).px, ";position:absolute;top:", (0, $8RYVL.grid).px, ";left:", (0, $8RYVL.grid).px, ";color:rgb(107, 119, 140);display:inline-flex;align-items:baseline;@media screen and (max-width: ", (0, $8RYVL.dialogPageTakeoverWidth), "px){display:none;}");

});

parcelRegister("gkkz9", function(module, exports) {
$parcel$export(module.exports, "SSRmobileSearchIconWrapper", () => $6301a413be14af85$export$3f33ed4b273b43d);

var $8RYVL = parcelRequire("8RYVL");

var $2CNTZ = parcelRequire("2CNTZ");
const $6301a413be14af85$export$3f33ed4b273b43d = /*#__PURE__*/ (0, $2CNTZ.default)('span', {
    target: "e12qszb40"
})("display:none;padding:", (0, $8RYVL.grid).multiple(0.5).px, ";padding-right:var(--ds-space-025, 2px);color:rgb(52, 69, 99);@media screen and (max-width: ", (0, $8RYVL.dialogPageTakeoverWidth), "px){display:flex;}");

});

/**
 * Set by `Popover` on its host element when it has an `onClose`. Only those
 * popovers can be asked to close, so only those are counted by
 * `hasOpenDialogOrPopover` and asked to close by `requestClosePopovers`.
 * Popovers without `onClose` (for example the flag group or a spotlight) are
 * not dismissible by outside code and are skipped.
 */ const $ba52e8a77c149a28$export$c6890d80f1a52941 = 'data-top-layer-closable';
const $ba52e8a77c149a28$export$17ed9502ee8e92da = 'top-layer-request-close';

const $e9181d8bc9d96b1b$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $e9181d8bc9d96b1b$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $e9181d8bc9d96b1b$export$13f57c02915787b3 = 'atlaskit-portal';

const $2842d286e8760d3e$export$ed5835cc67e87f72 = 'akPortalMount';
const $2842d286e8760d3e$export$80816bd900e5bd00 = 'akPortalUnmount';

// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $506751ca64a81ea5$export$a7801e29f563faad = 400;

/**
 * Character key codes which can be used in keyboard events.
 */ const $4096afce6d06a916$export$390330c10ff2b9a1 = 'ArrowUp';
const $4096afce6d06a916$export$a80636c6f41931fe = 'ArrowDown';
const $4096afce6d06a916$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $4096afce6d06a916$export$c40f9845adc73fb5 = 'ArrowRight';
const $4096afce6d06a916$export$4af703091671bc = 'Home';
const $4096afce6d06a916$export$e2bc30913faa5db7 = 'End';
const $4096afce6d06a916$export$10f6869ed0a7d75b = 'Tab';
const $4096afce6d06a916$export$8152f929a25a0ff4 = 'Enter';
const $4096afce6d06a916$export$e51a3576c045c8d5 = 'Space';
const $4096afce6d06a916$export$2bb790b9008907b4 = 'Escape';

const $8d44ad6280d93004$export$42f4885608027d0c = 'non_boolean';

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

/* eslint-disable jira/filename-case */ const $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $eb8cfa569eede1a9$export$e9c56aa3b027d98f = 'jira-customer-service';
const $eb8cfa569eede1a9$export$1346c9aa3cbb477d = 'jira-software';
const $eb8cfa569eede1a9$export$202f50ee62667e32 = 'jira-product-discovery';
const $eb8cfa569eede1a9$export$db515c8cec1e6f79 = 'jira-core';
const $eb8cfa569eede1a9$export$c811f21c9ad05dc2 = 'confluence';
const $eb8cfa569eede1a9$export$961148c98d198270 = 'opsgenie';
const $eb8cfa569eede1a9$export$a310f85340477585 = 'assets';
const $eb8cfa569eede1a9$export$d5e9b613bc4c47f = 'compass';

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // this is autogenerated file, see scripts/version-update.js
const $2604faf4ecb0fc27$export$a4ad2735b021c132 = '1.9.1';

const $f8a69c6d37cb4ab8$export$d6830277b06edd6 = 'normal';
const $f8a69c6d37cb4ab8$export$1eee5ddc4f6d41c5 = 400;

const $d06951238cc95036$export$cf090d5281b5ae06 = 10000;
const $d06951238cc95036$export$8575e30be0feb909 = 30000;

const $790d54a7af2f6d42$export$d8b468db8a225bc9 = 250;

const $9f5054f87e3e2d3a$export$5e28bf885ebebfa6 = '[browser-storage-controls]';
const $9f5054f87e3e2d3a$export$aeb1f5aa1188ce28 = 5000; // min gap between sends of the same action
const $9f5054f87e3e2d3a$export$ee3d07c2528881e2 = 10; // hard cap per action per page load

/* eslint-disable jira/filename-case */ const $d0b0f317b4f60123$export$881d135f98d8d7d0 = 100;
const $d0b0f317b4f60123$export$9ab5bdcb8a1d6c34 = false;
const $d0b0f317b4f60123$export$f267d0e9ab3eb265 = false;
const $d0b0f317b4f60123$export$12c1dc38ea1692da = 0;
const $d0b0f317b4f60123$export$34932e325e1234b3 = false;

const $ef43174c6184897f$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $ef43174c6184897f$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $ef43174c6184897f$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $ef43174c6184897f$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
const $ef43174c6184897f$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
const $ef43174c6184897f$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
const $ef43174c6184897f$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

const $531256d3fe3ee2a2$export$73e31d6dbeb74c41 = 'Something went wrong while loading the popup content.';

/* eslint-disable jira/filename-case */ const $8f860a533cc71fca$export$ff39ebd4bb12b718 = 201;
const $8f860a533cc71fca$export$3288b14b6745c572 = 204;
const $8f860a533cc71fca$export$9de493bcd9b1d977 = 400;
const $8f860a533cc71fca$export$67d19e9a991baa07 = 401;
const $8f860a533cc71fca$export$a3269a3914b007e3 = 403;
const $8f860a533cc71fca$export$8bca792d963eb0ef = 404;
const $8f860a533cc71fca$export$4a3cb39801694eee = 407;
const $8f860a533cc71fca$export$fa405bbf47d510e2 = 408;
const $8f860a533cc71fca$export$c09e7ea0fc79f34f = 409;
const $8f860a533cc71fca$export$5244030134e99 = 412;
const $8f860a533cc71fca$export$f90ac1df0b60853d = 413;
const $8f860a533cc71fca$export$a447d0a965e16776 = 422;
const $8f860a533cc71fca$export$3b48aba8957000cd = 426;
const $8f860a533cc71fca$export$6763168a631449a2 = 429;
const $8f860a533cc71fca$export$e813cd7045fcc98d = 500;
const $8f860a533cc71fca$export$2ce38d41a306034e = 502;
const $8f860a533cc71fca$export$974c37534b0191b1 = 503;
const $8f860a533cc71fca$export$5400e8dddac3fcf3 = 504;

const $132a6a261f02ebf7$export$52483b87432059f1 = 'jiraEditionAwarenessForStandardToPremium';

const $55bf78281c651395$export$83e119fb36bc846a = 'jira.user.theme.standard-to-premium-ea-pill.dismissed';

/* eslint-disable jira/filename-case */ const $f0e9a194674bc930$export$b5a308a17bc991f3 = 'projectKey';
const $f0e9a194674bc930$export$929d50f83189406c = 'boardId';
const $f0e9a194674bc930$export$da6f46390e1a426f = 'projectId';

/* eslint-disable jira/filename-case */ const $5f6e091542d432a9$export$b8b9d90f9e5bd72b = 'jiraAtlassianNavigationNav4';
const $5f6e091542d432a9$export$d57b6b390e78d90f = 'jira-cosmos';
const $5f6e091542d432a9$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $5f6e091542d432a9$export$b110169935468339 = 'AtlaskitAtlassianNavigationNav4';
const $5f6e091542d432a9$export$eed606b4351295d7 = 'login';
const $5f6e091542d432a9$export$35e541d26a145a7c = 'logout';

/* eslint-disable jira/filename-case */ const $3b258ee19859baa5$export$2bd315ece9f68967 = 'v4';

/* eslint-disable jira/filename-case */ const $192a2eeaa0a1dbf6$export$2ee9e5a3556c1e43 = 'sidebar';
const $192a2eeaa0a1dbf6$export$793ed84f5e13fedc = 'top';
const $192a2eeaa0a1dbf6$export$f1c9dd0f5207dd5e = 'tab';
const $192a2eeaa0a1dbf6$export$b83d0ee9325a2d0a = 'projectTitle';

/* eslint-disable jira/filename-case */ // TopNav or sidebar
const $fad9173ee481d7de$export$17ff3f7e02c6ac22 = 'global';
const $fad9173ee481d7de$export$33d8c916a600c5e9 = 'container';

/* eslint-disable jira/filename-case */ const $6b2913942bd90807$export$6dd9406e478a1fe2 = 'navigationItem';
const $6b2913942bd90807$export$b887e88d8d0739f6 = 'button';
const $6b2913942bd90807$export$64fed82162bd367 = 'dropdownItem';
const $6b2913942bd90807$export$b0a8b257f1f878a2 = 'searchInput';

const $5bdb53f12f87b5a8$export$cb2f616a76599e00 = 'APP_SWITCHER';

const $b435b412b2dfd147$export$b8b9d90f9e5bd72b = '@jira/navigation-apps__atlassian-navigation';
const $b435b412b2dfd147$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $b435b412b2dfd147$export$9934c8d98fd9e572 = 'atlassianSwitcher';

const $11c0f1bd3f72e082$export$c2c502a6524b22c7 = 'com.atlassian.jira.modules.servicemanagement.status-pages-entity:status-pages-entity-field-cftype';

/**
 * CSS variables that mirror the legacy `@atlaskit/page-layout` CSS custom properties.
 *
 * These are provided for consumers that previously relied on the `@atlaskit/page-layout`
 * CSS variables and need to reference them when using the navigation system.
 */ const $266ff4fb0e8e331a$export$f963aecf2d4465bd = 'var(--leftPanelWidth, 0px)';
const $266ff4fb0e8e331a$export$750459958906793 = 'var(--rightPanelWidth, 0px)';
const $266ff4fb0e8e331a$export$f897e1ed9f8ed251 = 'var(--leftSidebarWidth, 0px)';
const $266ff4fb0e8e331a$export$b44ab66843c05a69 = 'var(--rightSidebarWidth, 0px)';
const $266ff4fb0e8e331a$export$aeff86a16f13529 = 'var(--topNavigationHeight, 0px)';
const $266ff4fb0e8e331a$export$ed7cc0d417ee89e = 'var(--bannerHeight, 0px)';

const $eff8acf902328ef9$export$cf6877cd1fb9ba52 = 365;
const $eff8acf902328ef9$export$f1a3e4e33b782668 = 400;

const $f3039341ab1981e1$export$ad7805b1cbcab15e = 'JSMGROWTH-524';
const $f3039341ab1981e1$export$ac82a6f95aaaebf5 = 'grw-524_jsm_jpd_rovo_sidekick_killswitch';
const $f3039341ab1981e1$export$f562d49e335d7782 = 'jsm-contextual-suggestions';
const $f3039341ab1981e1$export$47ba9a433044383c = 'rovoQuickActions';
const $f3039341ab1981e1$export$8103addd67bbde0d = 60;

/* eslint-disable jira/filename-case */ const $1771eb0e641090af$export$53d41ff2666118e1 = 'agility-backlog';
const $1771eb0e641090af$export$7552fe2669628499 = 'bitbucket-issue';
const $1771eb0e641090af$export$41a718da0a8636f4 = 'connect-issue';
const $1771eb0e641090af$export$cebf0bc8b2ccaf57 = 'core-issue';
const $1771eb0e641090af$export$f154708d773ba5a0 = 'jira-board';
const $1771eb0e641090af$export$5e91e17726e54450 = 'jiraCalendar';
const $1771eb0e641090af$export$2dac1950892123f5 = 'jiraTimeline';
const $1771eb0e641090af$export$82540942fb014b0a = 'business-calendar';
const $1771eb0e641090af$export$7ca28938a07e0c33 = 'business-list';
const $1771eb0e641090af$export$f6cf06aaaeb58a54 = 'business-timeline';
const $1771eb0e641090af$export$b2c0462ff17aa26e = 'business-board';
const $1771eb0e641090af$export$a607850ebccd28ac = 'business-approvals';
const $1771eb0e641090af$export$1da6cede3561048f = 'business-files';
const $1771eb0e641090af$export$b19f949fb9713614 = 'full-issue';
const $1771eb0e641090af$export$c3899e01aa51a88e = 'jsm-full-issue';
const $1771eb0e641090af$export$a5132300c5214280 = 'embed-issue';
const $1771eb0e641090af$export$36d32bfbadaf29fb = 'work-item-view';
const $1771eb0e641090af$export$710114090a811b37 = 'global-issue-navigator-issue';
const $1771eb0e641090af$export$ce88447986394f2d = 'mobile-issue';
const $1771eb0e641090af$export$6a90d9196d330040 = 'project-issue-navigator';
const $1771eb0e641090af$export$2247c9059c171db1 = 'roadmap-issue';
const $1771eb0e641090af$export$cd16d39c55c569d0 = 'simple-software-board';
const $1771eb0e641090af$export$f72626bf0d75dfad = 'software-backlog-issue';
const $1771eb0e641090af$export$778b4609e784cb27 = 'software-deployments-issue';
const $1771eb0e641090af$export$5b73d694a6048002 = 'version-detail-issue';
const $1771eb0e641090af$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $1771eb0e641090af$export$21b5b7189add7861 = 'software-incidents-issue';
const $1771eb0e641090af$export$9c5d81b901471b27 = 'software-issue';
const $1771eb0e641090af$export$1735f6ad917dc411 = 'change-calendar';
const $1771eb0e641090af$export$7063ee6d0035a982 = 'queues-issue-view';
const $1771eb0e641090af$export$e3ab9da1dcf8e2ba = 'live-chat-issue-view';
const $1771eb0e641090af$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $1771eb0e641090af$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $1771eb0e641090af$export$14a8072f422804fd = 'issue-navigator-next';
const $1771eb0e641090af$export$cd2e8394c029507b = 'issue-navigator-detail-view';
const $1771eb0e641090af$export$9dac02c804d7acd8 = 'classic-software-board';
const $1771eb0e641090af$export$d6a617b7cd271a10 = 'jira-home-recommended';
const $1771eb0e641090af$export$49d57bef9ac2550b = 'global-issue-create';
const $1771eb0e641090af$export$9aea6bdc77a1b448 = 'csm-live-conversation-issue-view';
const $1771eb0e641090af$export$887083471231a492 = 'ham-work-items';
const $1771eb0e641090af$export$74b1da58ccd0577f = 'agents-watchtower';

/* eslint-disable jira/filename-case */ const $74cc6705a5fdb0de$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldIncludeBetaAiFeatures: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	jira_isBetaAiFeaturesEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldIncludeBetaAiFeatures)
	jira_rovoEnablementStatus(cloudId: $cloudId)@optIn(to: "JiraRovoEnablementStatus") {
		isRovoEntitlementEnabledForTenant
		isRovoAiFeaturesEnabledInAnyJiraProducts {
			isEnabled
			disabledReason
		}
		rovoAiFeaturesEnabledJiraProducts
	}
}
`;

const $1056e2b7e19aa4e0$export$f4208f01301e1342 = 'HELP';

/* eslint-disable jira/filename-case */ const $2b56b53c34bc2033$export$c43c7444da662fa1 = '1';
const $2b56b53c34bc2033$export$e99efa3985fa3c26 = 'helpPanel';
const $2b56b53c34bc2033$export$23aa6670f346c214 = 368;

/* eslint-disable jira/filename-case */ const $a250aea31dc76f65$export$53f45136e435c2fd = 'help_button_ui_state';

const $863aeee714b20c92$export$2ce650757fdac12a = 'NOTIFICATIONS';

/* eslint-disable jira/filename-case */ const $71a8d80581e45c48$export$e0226a83abddbd07 = 'check-notifications';

/* eslint-disable jira/filename-case */ const $8dfb0c8c68d6c8c9$export$14c62ba6f49b806f = 9;

/* eslint-disable jira/filename-case */ const $70e36d23224a09de$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $70e36d23224a09de$export$2ee9e5a3556c1e43 = 'SIDEBAR';

const $8ce4c0417f34b437$export$b98e411ae80c806f = '/';

const $eb044bb12d0b1d65$export$c1b33b1e65f8bd62 = 'SEARCH';

const $ba3615aabbc9caed$export$eeb0307e2964e28d = "var(--ds-text, #292A2E)";

const $73820dc7daa419bb$export$7168c0a11fb9ab29 = "var(--ds-text-subtlest, #6B6E76)";

const $bd344c6c2142b1d3$export$4ac85ff259fe4fce = "var(--ds-background-neutral-subtle-hovered, #0515240F)";

const $98d257b803724cde$export$271fb8b1437b1d62 = "var(--ds-link-visited, #803FA5)";

const $57a8d3ee2467d6bc$export$1b6b909295618bea = 'SETTINGS';


$parcel$global.rlb("bUWzb")
//# sourceMappingURL=shared~atlassian-navigation~vendor~ar.40ad1df7.js.map
